import { setSettingsVersions } from './chunk-ZJ2GAWXY.mjs';
import { setMasterSettings } from './chunk-TPWZ2NLW.mjs';
import { setRemoteLocationSettings } from './chunk-N6CFXMJJ.mjs';
import { setSelectedSettingsMode } from './chunk-DDECXZSP.mjs';
import { setLicenseSettings } from './chunk-6IECTPHB.mjs';
import { selectCustomizer, selectSpecialsCounterValue } from './chunk-PNEVEEYL.mjs';
import { selectAllMenuTypeDropdownList, selectCurrentHotButtons, selectCurrentItems, selectLocationCategoryBucket, selectLocationComboBucket, selectLocationItemBucket, selectLocationMenuTypeBucket, selectLocationModifierGroups, selectLocationModifierItems, selectLocationSubcategoryBucket, selectMenuTypeCombosSet, selectMenuTypeDropdownList, selectMenuTypeItemsSet, selectRegisterNavigationMenuType, selectSelectedMenu } from './chunk-DSFHCJ3V.mjs';
import { isPreviewMode, selectCurrentActiveItems, selectCurrentCategoryId, selectCurrentComboElementId, selectCurrentComboId, selectCurrentCourseNumberSelected, selectCurrentCustomTicketMode, selectCurrentItemGroupId, selectCurrentItemGroupInstance, selectCurrentItemId, selectCurrentMenuTypeId, selectCurrentModifierGroupId, selectCurrentModifierItemInstanceId, selectCurrentModifierTagId, selectCurrentModifyingSentTicketElement, selectCurrentNestedModifierGroupId, selectCurrentOrderIdNotInVAO, selectCurrentSeatId, selectCurrentSeatSelected, selectCurrentSeatSharedBarStatus, selectCurrentSeats, selectCurrentSubcategoryId, selectCurrentTicketElementId, selectDrawerSettlement, selectGlobalQuantity, selectHotButtonsModItemModGroupId, selectIsAllModsEnabled, selectIsComboElementActive, selectIsCurrentTicketElementModifying, selectIsMultiSeatEnabled, selectIsOmitExitOrderCallEnabled, selectIsPreviewEditEnabled, selectIsPreviewMode, selectIsSeatSelectorActive, selectIsSeatTagModeEnabled, selectIsTicketFilteredBySeat, selectIsVAOFocused, selectModifierItemHotButtonId, selectModifyingSentTicketElementId, selectOrderNumberPrinterId, selectOverlaySelected, selectRegisterBarCode, selectRegisterLastVisitedScreen, selectRegisterNavigation, selectRegisterNavigationPromptForPriceItemId, selectRegisterNavigationTableId, selectSelectedDrawer, selectSelectedDrawerAction, selectSelectedDrawerActionData, selectVAOFilter, selectVAOIsMultiselect, selectVAOSelectedCheckId, selectVAOSelectedOrders } from './chunk-BHZZAODT.mjs';
import { reducer_default as reducer_default$1 } from './chunk-WUUZF464.mjs';
import { endOfDayReducer } from './chunk-QCHORVBF.mjs';
import { actionCreators_exports, addSessionOrder, addSpecialObjectsToOrder, applySpecialToTicket, replaceSessionOrder, updateTicketElementField, selectRegisterItem, removeTicketElement, carryOverModifiersSelected, updateComboObjectPreview, updateOrderData, updateOrderSearchResultData, exitFromOrderAction, enterToOrderAction, leavingOrderActionWS, createCheck, updateCheckOrderDiscounts, voidAllChecks, dumpDefaultCheck, cleanDisplayCheckElements, createDisplayCheckElements, splitCheckElementEvenly, unSplitCheckElement, openCheck, closeCheck, mergeChecks, deleteEditableCheck, splitCheckBySeats, splitCheckIntoNNewChecks, moveCheckElements, deleteAllEditableChecks, ungroupCheckElements, splitCheckElementsWays, selectRegisterCombo, setOrders, rollUpOrderCheckElements, rollUpOrderSearchCheckElements, resetModifierGroupSelectedToConfigWhenSent, setCurrentTicketElementItemObj, toggleNestedModifierItemSelected, incrementNestedModifierItemSelected, deleteNestedModifierItemSelected, addCheckPayment, movePayments, setOrderSearchResult, resetTicketSpecials, rollUpTicketCombos, rollUpTicketElements, removeRegisterComboItem, selectRegisterComboItem, addModifierItemToModifierGroupItemObj, toggleModifierItemSelected, deleteTicketModifierItemSelected, incrementModifierItemSelected, resetModifierGroupSelected, decrementModifierItemSelected, selectNoneNestedModifierItemSelected, selectNoneModifierItems, decrementNestedModifierItemSelected, toggleNoneNestedModifierItemSelected, toggleItemIngredient, incrementItemIngredient, decrementItemIngredient } from './chunk-T2TEUPJX.mjs';
import { setCustomersVersions } from './chunk-MNVRN32N.mjs';
import { reducers_default } from './chunk-JOFTOWQI.mjs';
import { reducer_default, CUSTOMIZER_INITIAL_STATE } from './chunk-SP23AM7C.mjs';
import { setMasterCustomers } from './chunk-JESRHRAN.mjs';
import { SET_MASTER_CUSTOMERS_WS, SET_MASTER_CUSTOMERS } from './chunk-FXFSPFTU.mjs';
import { setRemoteLocationCustomers } from './chunk-ALMVEV2J.mjs';
import { SET_REMOTE_LOCATION_CUSTOMERS_WS, SET_REMOTE_LOCATION_CUSTOMERS } from './chunk-HXESVGDN.mjs';
import { setSelectedCustomersMode } from './chunk-5OXM3Z2M.mjs';
import { taxesSchema } from './chunk-YIDY7JBB.mjs';
import { usersMasterSchema, usersLocationSchema } from './chunk-533QTHPV.mjs';
import { setCustomersChangeDataValues, resetCustomersChangeData, setCustomersErrors, updateCustomersChangeDataValues, setCustomersChangeData, resetCustomersChanges, actions_exports } from './chunk-GBZMOJN6.mjs';
import { reducer_default as reducer_default$2 } from './chunk-35AGNM6Z.mjs';
import { setLocationCustomers } from './chunk-7RZBIADR.mjs';
import { SET_LOCATION_CUSTOMERS_WS, SET_LOCATION_CUSTOMERS } from './chunk-UHGOFDKM.mjs';
import { kitchenTicketSettingsSchema } from './chunk-J2RFF3VT.mjs';
import { licenseSettingsSchema } from './chunk-DTAZLOP3.mjs';
import { onlineOrderingSettingsSchema } from './chunk-OC5UXU6W.mjs';
import { prepStationsSchema } from './chunk-OJEW3YNV.mjs';
import { printerRulesSchema } from './chunk-UA4WF4R3.mjs';
import { rolesSchema } from './chunk-YMOD5FSG.mjs';
import { getReportsValidationSchema } from './chunk-MQCXMPPS.mjs';
import { generalSettingsSchema, validateEndOfBusinessDay } from './chunk-CM5UM2EZ.mjs';
import { modifierGroupSchema } from './chunk-VO3J2CE3.mjs';
import { modifierItemSchema } from './chunk-7FRVVTXZ.mjs';
import { reportingGroupSchema } from './chunk-ZFXLB76Q.mjs';
import { specialSchema } from './chunk-E7BQSEKW.mjs';
import { registerModeSchema } from './chunk-5ME43W57.mjs';
import { getCustomTenderId } from './chunk-GHIPCFZD.mjs';
import { subcategorySchema } from './chunk-TBS4VKUJ.mjs';
import { categorySchema } from './chunk-HAX6DWW2.mjs';
import { comboSchema } from './chunk-IRNMSTGM.mjs';
import { discountSchema } from './chunk-NMGSSMCX.mjs';
import { ingredientSchema } from './chunk-J626LWMG.mjs';
import { itemGroupSchema } from './chunk-YOHXBRDL.mjs';
import { getErrorMessages, itemSchema } from './chunk-ERICA5SD.mjs';
import { massUpdateItemSchema } from './chunk-5LFBQWRV.mjs';
import { menuTypeSchema } from './chunk-2ZVCUUUZ.mjs';
import { getTicketElementId, getEntityIdOrTabletGeneratedId, getEntityId, isTicketElementTriggered, notTicketElementTriggered, isTicketElementSent } from './chunk-3K5V3VM3.mjs';
import { shouldShowCustomersLocationsModalOnSaveCore } from './chunk-J5LO6SLU.mjs';
import { shouldShowSettingsLocationsModalOnSaveCore } from './chunk-FTPHMK43.mjs';
import { setSettingsChangeDataValues, setSettingsChangeData, updateSettingsChangeDataValues, resetSettingsChangeData, resetSettingsChanges, setSettingsErrors, actions_exports as actions_exports$1 } from './chunk-JMA3A6L2.mjs';
import { customerSchema } from './chunk-JH7JCWUE.mjs';
import { SET_SELECTED_CUSTOMERS_MODE_WS, SET_SELECTED_CUSTOMERS_MODE } from './chunk-FUTXKUZH.mjs';
import { clearOrderItemPrintingError, updateOrderWithPrintingErrors } from './chunk-HQUMZIBQ.mjs';
import { getEmployeesMainScreenRequestFormData, getEmployeeDetailsScreenRequestFormData } from './chunk-EDBSHJBY.mjs';
import { SET_DRAWERS, UPDATE_REGISTER_DRAWER } from './chunk-HIHJG2ZA.mjs';
import { isCustomizerSuperSet, hasCustomizerCollision, isCustomizerSubSet } from './chunk-L43PH4QX.mjs';
import { diffRegisterTicketFactory } from './chunk-3BLPG5KF.mjs';
import { diffRolesFactory } from './chunk-5CHX5XJU.mjs';
import { diffUserDetailsFactory } from './chunk-DLSQMQWX.mjs';
import { diffKitchenTicketFactory } from './chunk-BW5P7QSC.mjs';
import { diffLicenseSettingsFactory } from './chunk-YPGYMMH4.mjs';
import { diffLockScreenFactory } from './chunk-RHOS7MWF.mjs';
import { diffPaymentsFactory } from './chunk-3WBRYJND.mjs';
import { diffPrepStationsFactory } from './chunk-EYGV7Z2H.mjs';
import { diffPrinterRulesFactory } from './chunk-OJXURHPG.mjs';
import { diffReportingGroupFactory } from './chunk-PJNABAI5.mjs';
import { diffGeneralSettingsFactory } from './chunk-RHBJP3AY.mjs';
import { diffGuestReceiptFactory } from './chunk-EDLJXFRG.mjs';
import { diffGuestCheckFactory } from './chunk-O4DDRO5J.mjs';
import { diffFreshSheetFactory } from './chunk-Y64FVBAQ.mjs';
import { diffIngredientsFactory } from './chunk-K52H5R4F.mjs';
import { diffItemGroupsFactory } from './chunk-NQDVUBEH.mjs';
import { getCategoryAssociationsChanges, diffCategoriesFactory } from './chunk-7NUDKPDE.mjs';
import { getSubcategoryAssociationsChanges, diffSubcategoriesFactory } from './chunk-FA5ZJJCW.mjs';
import { getItemsCombosAndCategoriesChanges, diffMenuTypesFactory } from './chunk-GN4GMRI3.mjs';
import { freshSheetItemsFactoryCore } from './chunk-6H73KJ3D.mjs';
import { menuItemTableFactoryCore } from './chunk-OMVDHYS5.mjs';
import { GET_NO_MODIFIER_TAG_SELECTED, LITE_MODIFIER_TAG_POS_NAME, EXTRA_MODIFIER_TAG_POS_NAME, NO_MODIFIER_TAG, ON_SIDE_MODIFIER_TAG_POS_NAME, NO_MODIFIER_TAG_POS_NAME } from './chunk-N7WSOXSH.mjs';
import { SET_SETTINGS_BREADCRUMB_LOCATION, SET_SETTINGS_BREADCRUMB } from './chunk-Z36MVTLO.mjs';
import { SWITCH_PRICE_LIST, UPDATE_FIRE_TIMES_FIELD, APPLY_PAYMENT_TIP_ADJUSTMENT, ADD_REGISTER_OPEN_ITEM, VOID_CHECK, OPEN_CHECK, SPLIT_CHECK_INTO_N_NEW_CHECKS, SPLIT_CHECK_ELEMENT_BY_SEATS, SPLIT_CHECK_BY_SEATS, UNGROUP_CHECK_ELEMENTS, SPLIT_CHECK_ELEMENTS_WAYS, SPLIT_CHECK_ELEMENT_EVENLY, CREATE_DISPLAY_CHECK_ELEMENTS, CLEAN_DISPLAY_CHECK_ELEMENTS, DUMP_DEFAULT_CHECK, VOID_ALL_CHECKS, UPDATE_CHECK_ORDER_DISCOUNTS, ROLL_UP_CHECK_ELEMENTS, UN_SPLIT_CHECK_ELEMENT, MERGE_CHECKS, DELETE_ALL_EDITABLE_CHECKS, DELETE_EMPTY_CHECKS, DELETE_EDITABLE_CHECK, RENAME_CHECK, CLOSE_CHECK, MOVE_PAYMENTS, MOVE_CHECK_ELEMENTS, CREATE_CHECK, UPDATE_PAYMENT, TRANSFER_PAYMENT, VOID_PAYMENT, ADD_CHECK_PAYMENT, DECREMENT_ITEM_INGREDIENT, INCREMENT_ITEM_INGREDIENT, TOGGLE_ITEM_INGREDIENT, ROLL_UP_COMBO_ELEMENTS, ROLL_UP_TICKET_ELEMENTS, KITCHEN_ITEM_CLEAR_PRINTING_ERROR, RESET_MODIFIER_GROUP_SELECTED_TO_CONFIG_WHEN_SENT, COPY_SENT_TICKET_ELEMENT_CONFIG, CLEAR_UNSENT_ITEMS, REVERT_COMBO_ELEMENT_BASE_PRICE, REVERT_TICKET_ELEMENT_BASE_PRICE, UPDATE_COMBO_ELEMENT_BASE_PRICE, UPDATE_TICKET_ELEMENT_BASE_PRICE, TOGGLE_TICKET_ELEMENT_ON_HOLD, UNGROUP_COMBO_ELEMENT_BY_QTY, UNGROUP_TICKET_ELEMENT_BY_QTY, UNGROUP_COMBO_ELEMENT_BY_SINGLE_SEAT, UNGROUP_TICKET_ELEMENT_BY_SINGLE_SEAT, UNGROUP_COMBO_ELEMENT_BY_SEATS, UNGROUP_TICKET_ELEMENT_BY_SEATS, REMOVE_DISCOUNT_FROM_ORDER, UPDATE_ORDER_DISCOUNT, APPLY_DISCOUNT_TO_ORDER, REMOVE_DISCOUNT_FROM_COMBO, REMOVE_DISCOUNT_FROM_ITEM, UPDATE_TICKET_COMBO_DISCOUNT, UPDATE_TICKET_ELEMENT_DISCOUNT, ADD_SPECIAL_ORDER_OBJECT, RESET_TICKET_SPECIALS, APPLY_SPECIAL_TO_TICKET, APPLY_DISCOUNT_TO_ITEMS, UPDATE_COMPLETED_SECTIONS, UPDATE_MODIFIER_PRICE, TOGGLE_NONE_NESTED_MODIFIER_ITEM_SELECTED, TOGGLE_NESTED_MODIFIER_ITEM_SELECTED, INCREMENT_NESTED_MODIFIER_ITEM_SELECTED, DECREMENT_NESTED_MODIFIER_ITEM_SELECTED, DELETE_NESTED_MODIFIER_ITEM_SELECTED, SET_MODIFIER_PRICE, DELETE_NESTED_TICKET_MODIFIER_GROUP_ITEM, UPDATE_NESTED_TICKET_MODIFIER_GROUP_ITEM, CANCEL_COMBO_ELEMENT, REMOVE_COMBO_ELEMENT, REMOVE_TICKET_ELEMENT, DUPLICATE_COMBO_ELEMENT, DUPLICATE_TICKET_ELEMENT, MAKE_COMBO_FROM_TICKET_ITEM, UPDATE_COMBO_OBJECT_PREVIEW, SELECT_REGISTER_COMBO, REMOVE_REGISTER_COMBO_ITEM, SELECT_REGISTER_COMBO_ITEM, SELECT_REGISTER_ITEM, SELECT_SUBCATEGORY_CUSTOMIZER, DELETE_TICKET_MODIFIER_ITEM_SELECTED, DECREMENT_MODIFIER_ITEM_SELECTED, INCREMENT_MODIFIER_ITEM_SELECTED, TOGGLE_MODIFIER_ITEM_SELECTED, SELECT_NONE_MODIFIER_ITEMS_CUSTOMIZER, CARRY_OVER_MODIFIERS_SELECTED, RESET_MODIFIER_GROUP_SELECTED, UPDATE_TICKET_MODIFIER_GROUP_ITEM, SET_TICKET_MODIFIER_GROUPS_SELECTED, SELECT_NONE_MODIFIER_ITEMS, UPDATE_TICKET_ELEMENT_INSTRUCTIONS, UPDATE_TICKET_ELEMENT_COURSE, UPDATE_COMBO_ELEMENT_VOIDED, UPDATE_TICKET_ELEMENT_VOIDED, UPDATE_TICKET_ELEMENT_FIELD, SET_COMBO_ELEMENT_QUANTITY, SET_TICKET_ELEMENT_QUANTITY, SET_TICKET_ELEMENT_UN_SHARE, SET_COMBO_ELEMENT_SHARE, SET_TICKET_ELEMENT_SHARE, ADD_MODIFIER_ITEM_TO_MODIFIER_GROUP_ITEM_OBJ, SET_TICKET_ELEMENT_ITEM_OBJ, DECREMENT_COMBO_SEAT_QUANTITY, DECREMENT_SEAT_QUANTITY, INCREMENT_COMBO_SEAT_QUANTITY, INCREMENT_SEAT_QUANTITY, SET_COMBO_SEAT_QUANTITY, SET_SEAT_QUANTITY, TOGGLE_COMBO_SEAT_QUANTITY, TOGGLE_SEAT_QUANTITY, CLEAR_ALL_SEAT_TAGS, SET_SEAT_TAGS, TOGGLE_COMBO_ELEMENT_SEAT_SHARED, TOGGLE_TICKET_ELEMENT_SEAT_SHARED, INCREMENT_NUMBER_OF_SEATS, UPDATE_ORDER_WS, UPDATE_ORDER, REPLACE_ORDER_TABLET_GENERATED_ID_WS, ADD_SESSION_ORDER_WS, ADD_SESSION_ORDER, LEAVING_ORDER_WS, EXITING_FROM_ORDER, UPDATE_LICENSE_EDITING_ID_WS, UPDATE_LICENSE_EDITING_ID, UPDATE_LOCALLY_ORDER_FIELD, UPDATE_ORDER_FIELD, REMOVE_ORDER, SET_ORDER_LOCALLY_FOR_PAYMENT, SET_ORDER_LOCALLY_FOR_PAYMENT_BULK, SET_ORDERS, ROLL_UP_ORDER_SEARCH_CHECK_ELEMENTS, UPDATE_ORDER_SEARCH_RESULTS, RESET_ORDER_SEARCH_RESULTS_BAR_CODE_ORDER, SET_ORDER_SEARCH_RESULTS, MODIFY_ITEM_END, MODIFY_ITEM_START, SELECT_PREVIOUS_SEAT, SELECT_NEXT_SEAT, SELECT_CURRENT_SEAT } from './chunk-5J2PASRY.mjs';
import { UPDATE_TABLE_LAYOUT_AND_ORDERS, SET_TABLE_LAYOUT_DATA, SET_LAST_LAYOUT_CHANGE_TO_CURRENT_EDIT_DATA, SET_CURRENT_EDIT_DATA, RESET_CURRENT_EDIT_DATA, DISCARD_TABLE_LAYOUT_CHANGES, SET_TOOL_SETTINGS, SET_SELECTED_ELEMENT, SET_SELECTED_TABLES, INITIALIZE_TABLES_LAYOUT, INITIALIZE_LAYOUT, SET_SELECTED_LAYOUT, UPDATE_TABLE_LAYOUT_STORE, SET_LAST_UNDO_CHANGES, SET_LAST_REDO_CHANGES, SET_SERVICE_AREA, SET_NEW_SERVICE_AREA, UPDATE_SERVICE_AREA, UPDATE_SERVICE_AREAS, REMOVE_SERVICE_AREA, SET_LAST_SERVICE_AREAS_ORDER, SET_IS_BOTTOM_SHEET_OPEN, UPDATE_TABLES_WS, UPDATE_TABLES, UPDATE_SINGLE_TABLE_TABLE_LAYOUT_STATE, ignoredFieldsToSave } from './chunk-VZEH4VMY.mjs';
import { selectIsLoadingModal, selectConfirmationModal } from './chunk-TRN4ST4T.mjs';
import { selectReports, selectCreditBalancesReportById, selectInventoryOnHandReportById, selectVoidReasonsReportById, selectEmployeeSalesAndTipsReportById, selectCreditCardBatchReportById, selectEndOfShiftReportById, selectSalesOverviewReportById, selectItemComboSalesReportById, selectCustomReportById } from './chunk-BTYMBW3V.mjs';
import { SET_USERS, UPDATE_TIME_SUMMARY_WS, UPDATE_TIME_SUMMARY, UPDATE_RECENT_ORDERS_WS, UPDATE_RECENT_ORDERS, UPDATE_LOGGED_IN_RECENT_ORDERS_WS, UPDATE_LOGGED_IN_RECENT_ORDERS } from './chunk-V4FTVBZY.mjs';
import { SET_INITIAL_LOGGED_IN_USER, SET_LOGGED_IN_USER, CLEAR_LOGGED_IN_USER, SET_LOGGED_IN_ROLE_ON_STATE, SET_MENU_ACCESS_LOCATIONS, SET_SETTINGS_ACCESS_LOCATIONS } from './chunk-JGPMBBAW.mjs';
import { getStockZeroAction } from './chunk-ICXIWBPJ.mjs';
import { getUserRolesFromRolesIdsCore } from './chunk-FVDXHU74.mjs';
import { getReportDateTimesForPeriod } from './chunk-OZPRSAYH.mjs';
import { fixCustomReportsIds } from './chunk-SN5RDSTX.mjs';
import { reportHasChanges } from './chunk-X3JGGMD7.mjs';
import { reportBucketToEndpointType } from './chunk-LVN523NK.mjs';
import { CONFIRMATION_MODAL_INITIAL_STATE } from './chunk-PESWYEM7.mjs';
import { KITCHEN_PRINTING_ERROR_WS, KITCHEN_PRINTING_ERROR, SET_NETWORK_STATUS, SET_IS_WS_ACTIVE, RESET_GLOBAL_STATE, SET_TOKEN, SET_SHOW_TOAST, SET_LOCK_SCREEN_BANNER, SET_SHOW_REFRESH_TOAST, SET_SHOW_SETTINGS_REFRESH_TOAST, SET_HIDE_REFRESH_TOAST, SET_IS_LOADING_MODAL, REMOVE_TOAST_ELEMENT, SET_HIDE_TOAST, CLEAR_LOCK_SCREEN_BANNER, SET_SELECTED_NETWORK, SET_PULLING_DATA, SET_IS_LOADING, SET_IS_LOADING_MORE, SET_MESSAGE_ID, SET_SHOW_CONFORMATION_MODAL, UPDATE_KEYBOARD, SET_LATEST_PAYMENT_INFORMATION, UPDATE_POPOVER, SET_IS_CLOCK_IN_SUGGESTION_MODAL_OPEN, REMOVE_MASTER_DATA, INITIALIZE_APP_ON_LOCK_SCREEN } from './chunk-P7VATSOY.mjs';
import { getSettingsGenericError } from './chunk-TDNRUBPG.mjs';
import { diffTaxesFactory } from './chunk-22INMNZK.mjs';
import { unitsText } from './chunk-T4ZJPQ5Z.mjs';
import { pinAlreadyExistsCore } from './chunk-JVJ3UQ62.mjs';
import { formatParametersToGetPrintJob } from './chunk-EOWPU4IM.mjs';
import { getOrderOrSeatTagString } from './chunk-NPI7E63P.mjs';
import { getUserRegisterPermissionCore } from './chunk-77NPSY57.mjs';
import { getSettingsInitialState, LICENSE_INITIAL_STATE } from './chunk-KJO3PPWO.mjs';
import { LICENSE_SETTINGS_INITIAL_STATE } from './chunk-OQYBQD74.mjs';
import { getSimilarNameItemIds } from './chunk-D4X4RVF6.mjs';
import { getHasAllSubcategory, filterSubcategoriesWithItemAndComboIdSet, mapSubcategoryFromBucket } from './chunk-IW72S3WG.mjs';
import { sumAndSimplifyFractions, getDisplayedFraction } from './chunk-TQBSLTWN.mjs';
import { modifierGroupsFactoryCore } from './chunk-Q4YUBNKK.mjs';
import { SET_REPORTS_SELECTED_MODE, SET_SELECTED_REPORTS_TYPE, SET_REPORTS_ERRORS, SET_REPORTS_DIFF_OBJECT, SET_IS_REPORT_SAVING, SET_IS_REPORT_PDF_LOADING, SET_REPORT_URL, SET_REPORTS_CHANGE_DATA_VALUES, RESET_REPORTS_CHANGE_DATA, SET_REPORTS_CHANGE_DATA, SET_REPORTS, WS_SET_REPORTS } from './chunk-ER3UI63V.mjs';
import { selectedModifierItemObjFactory } from './chunk-S57ZADSR.mjs';
import { getArrayNumberChanges, filterDiffFunction, getTaxesDiffArrayCore, getMenuTypeDiffPath, changedElementSetFunction, isItemInMenuTypeCore, getArrayEditIndex, getDiffArray, getReportingGroupsDiffArrayCore, getMenuTypeArraysByAction, getObjectNextSortPriority, arrayElementSetFunction, addedObjectElementSetFunction, removedSetFunction, getObjectSorted } from './chunk-WTGT4IDV.mjs';
import { groupAndCountByIdFactory } from './chunk-E74SIN6H.mjs';
import { generatePrintJobId, generateTabletGeneratedId } from './chunk-UTN3NKH5.mjs';
import { filter } from './chunk-P33VLGUK.mjs';
import { simplifyFraction } from './chunk-2QIHMET6.mjs';
import { recursiveModifierMapperCore, modifierItemToTicketElementModifierItemCore } from './chunk-UWD7WNII.mjs';
import { getMergedData } from './chunk-GU4YSF57.mjs';
import { selectIsDualPricingEnabled, getNowUTCDate, getSettingsVersionCore, selectCurrentSettingsData, selectSettingsType, selectSettingsSelected, getNewSettingsVersionCore, selectIsSettingsRemoteLocationMode, selectSettingsChangeData, getCurrentSettingsCore, selectPrinterRulesForDetailsScreen, selectPrepStationsSettingsForDetailsScreen, selectCurrentTimeZone, areSettingsMasterModeSelector, selectShouldRenderLocationDropdown, selectActualSettingsType, selectLocationSettings, printersSelector, selectSpecials, addLeadingZero, selectSuppressSuggestiveOrdering, selectLocationMenuItemById, selectSeatingMode, selectAttachNoSeatToToGo, selectOverrideDefaultMenuTypeId, selectDefaultMenuTypeTimes, selectDefaultMenuTypeId, getDateISOBasedInEndOfBusinessDay, selectLocationListIds, selectGeneralSettings, selectIsCoursingEnabled, selectIsSeatingModeEnabled, selectLocationModifierTags, selectItemGroups, selectCurrentItem, selectMenuMode, selectIsMenuMasterMode, selectModifierGroups, selectBreadCrumbs, selectChangeData, selectChangeDataOrChangeMassUpdateData, selectOriginalMenuData, selectItems, selectCategories, selectSubcategories, selectMenuTypes, currentTaxesSettingsSelector, currentPrepStationsSelector, selectReportingGroups, selectMenuState, selectSelectedModeId, selectMenu, selectChangeDataId, selectIsMenuCreationMode, selectCombos, selectBreadCrumbsLength, selectMenuVersions, selectCurrentMenuType, selectIsMenuRemoteLocationMode, selectActualMenuType, getMenuVersionState, selectChangeDataDifferences, selectCurrentFreshSheet, selectOpenItemTypes, hotButtonsFactoryCore, selectPreviewElements, selectLastRearrangePreviewHotButtons, selectModifierItems, getHotButtonTitle, selectShowPopUpOnNavigateIfItemsOnTicketNotSentToKitchen, selectIsTicketSeatBarSettingEnabled, selectCoursingModeActive, selectLocationCourses, selectCustomTenders, selectCurrentMenuTypes, modifierTagsSelector, selectDefaultServiceAreaOption, selectIsCateringAvailable, selectIsDeliveryAvailable, selectIsToGoAvailable, selectRestaurantMode, makeSelectSettingsData, selectBucketSelected, getDayKey, getMilitaryHourRange, getMilitaryHourLuxon, getHourAndMinutesAndSecondsCore, selectIsMassUpdate, selectCurrentSettingsOriginalData, selectPaymentsServiceCharges, selectCurrentTaxesSettingsSelector, selectDashboardCardsList, selectDisplayMode, specialTagsSelector, settingsDifferencesSelector, selectCurrentSettingsFinalDiffObject, selectCurrentErrors, selectDataByBucketName, getCurrentMenuCore, selectCurrentSettings } from './chunk-67X7HZEW.mjs';
import { getMenuInitialState, getMenuInitialStateForSaving } from './chunk-TKRJWY2U.mjs';
import { SPECIAL_MENU_TYPE_VERSION_INITIAL_STATE } from './chunk-NXTTVEZZ.mjs';
import { DISCOUNT_INITIAL_STATE } from './chunk-SYWTGWBZ.mjs';
import { MENU_TYPE_VERSION_INITIAL_STATE, MASS_UPDATE_INITIAL_STATE, ITEM_INITIAL_STATE, MODIFIER_GROUP_ITEMS_INITIAL_STATE } from './chunk-IGSXE2BX.mjs';
import { INGREDIENT_INITIAL_STATE } from './chunk-VSPEQRDU.mjs';
import { MODIFIER_GROUP_PRICING_VERSION_INITIAL_STATE, MODIFIER_GROUPS_INITIAL_STATE } from './chunk-TOUCFDN5.mjs';
import { MODIFIER_ITEM_PRICING_VERSION_INITIAL_STATE, MODIFIER_ITEM_INITIAL_STATE } from './chunk-3A2KG5LI.mjs';
import { CATEGORIES_INITIAL_STATE } from './chunk-VRPWZYYT.mjs';
import { COMBO_ITEM_GROUP_INITIAL_STATE, COMBO_ITEM_OF_ITEM_GROUP_INITIAL_STATE, COMBO_MENU_TYPE_VERSION_INITIAL_STATE, COMBO_INITIAL_STATE } from './chunk-HQDB7QW6.mjs';
import { getNewHotButtonsCore, generatePositions } from './chunk-7MMV2ZSX.mjs';
import { EMPTY_HOT_BUTTON } from './chunk-EN7ENLN6.mjs';
import { selectLoggedInUserMenuAccessLocations, selectHasLoggedInUserAccessToMasterMenu, selectUsers } from './chunk-YLY6KHID.mjs';
import { USER_INITIAL_STATE, ROLE_INITIAL_STATE } from './chunk-OQ3OIKOT.mjs';
import { SUBCATEGORY_INITIAL_STATE } from './chunk-YTGMKKOP.mjs';
import { BUCKET_TEXT_DICTIONARY, SET_MASTER_MENU_ON_STATE_WS, SET_MASTER_MENU_ON_STATE, SET_LOCATION_MENU_ON_STATE, SET_SELECTED_MENU_MODE_WS, SET_SELECTED_MENU_MODE, SET_MENU_VERSIONS_WS, SET_MENU_VERSIONS, SET_REMOTE_LOCATION_MENU_ON_STATE_WS, SET_REMOTE_LOCATION_MENU_ON_STATE, SET_SELECTED_LOCATIONS, SET_MASS_UPDATE_SELECTED_LOCATIONS, SET_CHANGE_DATA, SET_CHANGE_MASS_UPDATE_DATA, SET_CHANGE_FRESH_SHEET_DATA, UPDATE_CHANGE_DATA_VALUES, UPDATE_CHANGE_FRESH_SHEET_DATA_VALUES, UPDATE_CHANGE_MASS_UPDATE_DATA_VALUES, RESET_CHANGE_DATA, RESET_CHANGE_MASS_UPDATE_DATA, RESET_CHANGE_FRESH_SHEET_DATA, RESET_MENU_CHANGES, RESET_MASS_UPDATE_MENU_CHANGES, SET_CHANGE_MASS_UPDATE_DATA_VALUES, SET_CHANGE_DATA_VALUES, SET_CHANGE_FRESH_SHEET_DATA_VALUES, SET_CHANGE_DATA_MODIFIER_GROUPS_VALUES, SET_DIFFERENCES, SET_DIFF_OBJECT, SET_BREADCRUMB_LOCATION, SET_BREADCRUMB, SET_ERRORS, SET_MASS_UPDATE_ERRORS, SET_LAST_PREVIEW_ARRANGEMENT, SET_PREVIEW_ELEMENTS, UPDATE_PREVIEW_ELEMENTS, SET_MENU_PREVIEW_ACTION, SET_LOCAL_ITEM_86, SET_LOCAL_MODIFIER_ITEM_86, SET_LOCAL_INGREDIENT_86, RESET_LOCAL_ITEM_STOCK, UPDATE_LOCAL_ITEM_STOCK, UPDATE_LOCAL_ITEM_SHOW_STOCK_ON_ITEM_CARD, UPDATE_INVENTORY_WS, UPDATE_INVENTORY, UPDATE_MODIFIER_ITEM_INVENTORY_WS, UPDATE_INGREDIENT_INVENTORY_WS, POST_REQUEST_MENU, SET_LOCATION_MENU_ON_STATE_WS } from './chunk-2Q5533PL.mjs';
import { getCategoryChildrenType } from './chunk-F6KAEMDT.mjs';
import { SET_REGISTER_SETTINGS, SET_REGISTER_TICKET_SETTINGS } from './chunk-DUMQLZJJ.mjs';
import { getHomeElementsByBucket } from './chunk-B5YSX73X.mjs';
import { INITIAL_STATE_BASE_INTERFACE_WITH_STRING_ID, NO_SEAT_ID, ALL_SEATS, SET_TOGGLE_HOT_BUTTONS, SET_SHOW_HOT_BUTTONS, UPDATE_PAYMENT_NAVIGATION, ENTER_PAYMENT_MODE, SET_PAYMENT_OPTION, SET_PAYMENT_METHOD, SET_STATION_COUNTER, SET_ACTIVE_TICKET_ELEMENT, TOGGLE_ORDER_MODAL, SET_TICKET_ELEMENTS_OPEN, CLEAN_NAVIGATION_AND_REMOVE_ACTIVE_ITEM, ADD_REMOVE_ACTIVE_ITEMS, SET_REGISTER_NAVIGATION, UPDATE_REGISTER_NAVIGATION_FIELD, DISABLE_EXIT_ORDER_CALL, ENABLE_EXIT_ORDER_CALL, bucketTypeMap, NULLISH_DATE, PAYMENT_OPTIONS, FOR_TABLE_SEAT_ID, TO_GO_SEAT_ID, SHARED_SEAT_ID, ABSOLUTE_CERO, METRIC_UNITS_OF_LIQUID_VOLUME, US_UNITS_OF_LIQUID_VOLUME, VAO_DATA_INITIAL_STATE, SET_SPECIALS_COUNTER } from './chunk-3YIOW4BW.mjs';
import { OrderStatus } from './chunk-ALU2SMPA.mjs';
import { SET_LOCATION_SETTINGS_WS, SET_LOCATION_SETTINGS, SET_PRINTER_STATUS_WS, SET_PRINTERS, REMOVED_PRINTER_WS, REMOVED_PRINTER, SET_SETTINGS_DASHBOARDS, SET_ROLE_DASHBOARDS } from './chunk-SKLRT3EJ.mjs';
import { trimArrayToMaxLength, getLeftJoin } from './chunk-VS6OCH75.mjs';
import { adjustShade } from './chunk-VW4PMEQJ.mjs';
import { and, not, formatMoney, getURLStringOrBase64 } from './chunk-G3WCWBRF.mjs';
import { reduceErrors } from './chunk-JYTWXDMI.mjs';
import { apiConfig_default } from './chunk-OEZ2BD32.mjs';
import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import { BASE_STORE_INITIAL_STATE } from './chunk-7PCIVIEC.mjs';
import { __export, __spreadProps, __spreadValues, __async, __objRest } from './chunk-T36PI2YV.mjs';
import cloneDeep16 from 'lodash/cloneDeep';
import deepDiff6, { diff } from 'deep-diff';
import { produce } from 'immer';
import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect';
import { isEmpty, assign, cloneDeep, find, isEqual, isUndefined, isNil, isNumber, zip, orderBy, takeRight, take, isNull, isInteger, get as get$1 } from 'lodash';
import { DateTime } from 'luxon';
export { DateTime } from 'luxon';
import isEmpty9 from 'lodash/isEmpty';
import axios from 'axios';
export { AxiosError } from 'axios';
import get from 'lodash/get';
import has from 'lodash/has';
import max3 from 'lodash/max';
import orderBy5 from 'lodash/orderBy';
import setWith from 'lodash/setWith';
import difference from 'lodash/difference';
import isEqual6 from 'lodash/isEqual';
import isNil3 from 'lodash/isNil';
import pick2 from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import unset from 'lodash/unset';
import without from 'lodash/without';
import { batch as batch$1, shallowEqual, useDispatch, useSelector } from 'react-redux';
import shajs3 from 'sha.js';
import mapValues3 from 'lodash/mapValues';
import sortBy from 'lodash/sortBy';
import * as yup from 'yup';
import { t } from 'i18next';
import { combineReducers, bindActionCreators } from 'redux';
import isEqual8 from 'lodash//isEqual';
import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

var ModifierGroupSectionStatus = /* @__PURE__ */ ((ModifierGroupSectionStatus2) => {
  ModifierGroupSectionStatus2["INACTIVE"] = "INACTIVE";
  ModifierGroupSectionStatus2["ACTIVE"] = "ACTIVE";
  ModifierGroupSectionStatus2["SELECTED"] = "SELECTED";
  ModifierGroupSectionStatus2["RED"] = "RED";
  ModifierGroupSectionStatus2["INCOMPLETE"] = "INCOMPLETE";
  return ModifierGroupSectionStatus2;
})(ModifierGroupSectionStatus || {});
var getMaxSize = (size1, size2) => {
  if (size1 === "extra" /* EXTRA */ || size2 === "extra" /* EXTRA */) {
    return "extra" /* EXTRA */;
  }
  if (size1 === "regular" /* REGULAR */ || size2 === "regular" /* REGULAR */) {
    return "regular" /* REGULAR */;
  }
  return "light" /* LIGHT */;
};
var getMinSize = (size1, size2) => {
  if (size1 === "light" /* LIGHT */ || size2 === "light" /* LIGHT */) {
    return "light" /* LIGHT */;
  }
  if (size1 === "regular" /* REGULAR */ || size2 === "regular" /* REGULAR */) {
    return "regular" /* REGULAR */;
  }
  return "extra" /* EXTRA */;
};
var getAdditionalAmountPrice = (modifierItem, amountSelected) => {
  const amount = amountSelected != null ? amountSelected : modifierItem.defaultAmountSelected;
  switch (amount) {
    case "light" /* LIGHT */:
      return modifierItem.additionalLightPrice;
    case "regular" /* REGULAR */:
      return modifierItem.additionalRegularPrice;
    case "extra" /* EXTRA */:
      return modifierItem.additionalExtraPrice;
    default:
      return modifierItem.additionalMasterPrice;
  }
};
var getIncludedAmountPrice = (modifierItem, amountSelected) => {
  const amount = amountSelected != null ? amountSelected : modifierItem.defaultAmountSelected;
  switch (amount) {
    case "light" /* LIGHT */:
      return modifierItem.includedLightPrice;
    case "regular" /* REGULAR */:
      return modifierItem.includedRegularPrice;
    case "extra" /* EXTRA */:
      return modifierItem.includedExtraPrice;
    default:
      return modifierItem.includedMasterPrice;
  }
};
var nextQuantityMap = {
  ["light" /* LIGHT */]: "regular" /* REGULAR */,
  ["regular" /* REGULAR */]: "extra" /* EXTRA */,
  ["extra" /* EXTRA */]: "extra" /* EXTRA */
};
var prevQuantityMap = {
  ["light" /* LIGHT */]: "light" /* LIGHT */,
  ["regular" /* REGULAR */]: "light" /* LIGHT */,
  ["extra" /* EXTRA */]: "regular" /* REGULAR */
};
var nextQuantityAmount = (current) => nextQuantityMap[current];
var prevQuantityAmount = (current) => prevQuantityMap[current];
var ReturnTypes = /* @__PURE__ */ ((ReturnTypes2) => {
  ReturnTypes2["modifierItemData"] = "MODIFIER_ITEM_DATA";
  ReturnTypes2["modifierGroupData"] = "MODIFIER_GROUP_DATA";
  return ReturnTypes2;
})(ReturnTypes || {});
function handleSetDefaultSelected(modifierItemId, isSelected, modifierGroupObject) {
  const { multiselect, quantityMode, modifierItems } = modifierGroupObject;
  try {
    if (multiselect) {
      switch (quantityMode) {
        case "x1,x2,x3" /* NUMBER */:
          return {
            type: "MODIFIER_ITEM_DATA" /* modifierItemData */,
            data: {
              isSelected,
              defaultQuantitySelected: isSelected ? 1 : 0
            }
          };
        case "Off" /* OFF */:
          return {
            type: "MODIFIER_ITEM_DATA" /* modifierItemData */,
            data: {
              isSelected
            }
          };
        default:
          return {
            type: "MODIFIER_ITEM_DATA" /* modifierItemData */,
            data: {
              isSelected,
              defaultAmountSelected: "regular" /* REGULAR */,
              defaultQuantitySelected: isSelected ? 1 : 0
            }
          };
      }
    }
    const currentSelectedModifierItem = Object.values(modifierItems).find(
      (modifierItem) => modifierItem.isSelected
    );
    if (!currentSelectedModifierItem)
      return {
        type: "MODIFIER_ITEM_DATA" /* modifierItemData */,
        data: {
          isSelected: true,
          defaultQuantitySelected: 1,
          defaultAmountSelected: "regular" /* REGULAR */
        }
      };
    else if (currentSelectedModifierItem && currentSelectedModifierItem.modifierItemId === modifierItemId) {
      return {
        type: "MODIFIER_ITEM_DATA" /* modifierItemData */,
        data: {
          isSelected: false,
          defaultQuantitySelected: 0,
          defaultAmountSelected: "regular" /* REGULAR */
        }
      };
    } else {
      const currentModifierGroup = cloneDeep16(modifierGroupObject);
      currentModifierGroup.modifierItems = __spreadProps(__spreadValues({}, currentModifierGroup.modifierItems), {
        [currentSelectedModifierItem.modifierItemId]: __spreadProps(__spreadValues({}, currentModifierGroup.modifierItems[currentSelectedModifierItem.modifierItemId]), {
          isSelected: false,
          defaultQuantitySelected: 0,
          defaultAmountSelected: "regular" /* REGULAR */
        }),
        [modifierItemId]: __spreadProps(__spreadValues({}, currentModifierGroup.modifierItems[modifierItemId]), {
          isSelected: true,
          defaultQuantitySelected: 1,
          defaultAmountSelected: "regular" /* REGULAR */
        })
      });
      return {
        type: "MODIFIER_GROUP_DATA" /* modifierGroupData */,
        data: currentModifierGroup
      };
    }
  } catch (error) {
    console.error("Error selecting default items", error);
  }
}
var handleDecrementModifierItem = (id, modifierGroupObject) => {
  const { quantityMode, modifierItems } = modifierGroupObject;
  const selectedModifierItem = modifierItems[Number(id)];
  const newValue = quantityMode === "x1,x2,x3" /* NUMBER */ ? {
    defaultQuantitySelected: selectedModifierItem.defaultQuantitySelected - 1
  } : {
    defaultAmountSelected: prevQuantityAmount(
      selectedModifierItem.defaultAmountSelected
    )
  };
  if (quantityMode === "x1,x2,x3" /* NUMBER */ && selectedModifierItem.defaultQuantitySelected < 1 || quantityMode === "Lt,Reg,Ext" /* SIZE */ && selectedModifierItem.defaultAmountSelected === newValue.defaultAmountSelected)
    return {
      type: "MODIFIER_ITEM_DATA" /* modifierItemData */,
      data: {}
    };
  return {
    type: "MODIFIER_ITEM_DATA" /* modifierItemData */,
    data: __spreadValues({
      isSelected: quantityMode === "x1,x2,x3" /* NUMBER */ ? Number(newValue.defaultQuantitySelected) > 0 : true
    }, newValue)
  };
};
var handleIncrementModifierItemQuantity = (id, modifierGroupObject) => {
  const { quantityMode, modifierItems } = modifierGroupObject;
  const selectedModifierItem = modifierItems[Number(id)];
  const newValue = quantityMode === "x1,x2,x3" /* NUMBER */ ? {
    defaultQuantitySelected: selectedModifierItem.defaultQuantitySelected + 1
  } : {
    defaultAmountSelected: nextQuantityAmount(
      selectedModifierItem.defaultAmountSelected
    )
  };
  if (quantityMode === "Lt,Reg,Ext" /* SIZE */ && newValue.defaultAmountSelected === selectedModifierItem.defaultAmountSelected)
    return {
      type: "MODIFIER_ITEM_DATA" /* modifierItemData */,
      data: {}
    };
  return {
    type: "MODIFIER_ITEM_DATA" /* modifierItemData */,
    data: __spreadValues({
      isSelected: true
    }, newValue)
  };
};
var getModifierItemButtonStatus = (modifierGroup, modifierItemSelected, ticketElementCustomizerType, customizerSectors) => getModifierItemButtonStatusByData(
  modifierGroup.activeCustomizerSectionSelector,
  modifierItemSelected,
  ticketElementCustomizerType,
  customizerSectors
);
var getModifierItemButtonStatusByData = (activeCustomizerSectionSelector, modifierItemSelected, ticketElementCustomizerType, customizerSectors) => {
  if (!modifierItemSelected) {
    return {
      status: "INACTIVE" /* INACTIVE */,
      amountSelected: void 0,
      quantitySelected: void 0
    };
  }
  const isSelected = !!modifierItemSelected;
  const returnObject = {
    status: isSelected ? "ACTIVE" /* ACTIVE */ : "INACTIVE" /* INACTIVE */,
    amountSelected: modifierItemSelected.amountSelected,
    quantitySelected: modifierItemSelected.quantitySelected,
    price: modifierItemSelected.totalPricePerItemUnit
  };
  if (hasNoModifierTag(modifierItemSelected.modifierTag)) {
    returnObject.status = "RED" /* RED */;
    return returnObject;
  }
  if (!modifierItemSelected.isComplete) {
    returnObject.status = "INCOMPLETE" /* INCOMPLETE */;
    return returnObject;
  }
  if (!activeCustomizerSectionSelector && ticketElementCustomizerType === "none" /* NONE */) {
    return returnObject;
  }
  let hasCollisions = false;
  for (const modifierItemInstance of Object.values(
    modifierItemSelected.modifierItemInstances
  )) {
    if (isCustomizerSuperSet(
      modifierItemInstance.customizerSectors,
      customizerSectors
    )) {
      returnObject.status = "ACTIVE" /* ACTIVE */;
      returnObject.amountSelected = modifierItemInstance.amountSelected;
      returnObject.quantitySelected = modifierItemInstance.quantitySelected;
      return returnObject;
    }
    if (!hasCollisions && hasCustomizerCollision(
      modifierItemInstance.customizerSectors,
      customizerSectors
    ))
      hasCollisions = true;
  }
  if (hasCollisions) {
    returnObject.status = "SELECTED" /* SELECTED */;
  } else
    returnObject.status = "INACTIVE" /* INACTIVE */;
  return returnObject;
};

// src/helpers/register/orderCreation/modifierItemsPriceAlgorithm.ts
function modifierItemsPriceAlgorithm(quantityMode, mode, included, totalModifierItemsSelected, _selectedModifierItems, modifierItems) {
  const selectedModifierItemWithPriceDiff = Object.values(
    _selectedModifierItems
  ).map((modifierItem) => {
    var _a;
    return __spreadProps(__spreadValues({}, modifierItem), {
      isDefault: (_a = modifierItem.isDefault) != null ? _a : false,
      defaultQuantity: modifierItems[modifierItem.id].defaultQuantitySelected,
      priceDifference: quantityMode !== "Lt,Reg,Ext" /* SIZE */ ? modifierItems[modifierItem.id].additionalMasterPrice - modifierItems[modifierItem.id].includedMasterPrice : getAdditionalAmountPrice(modifierItems[modifierItem.id]) - getIncludedAmountPrice(modifierItems[modifierItem.id])
    });
  });
  const expandedList = selectedModifierItemWithPriceDiff.map(
    (item) => {
      if (!item.isDefault) {
        return Array(item.count).fill(__spreadProps(__spreadValues({}, item), { isDefault: false }));
      }
      const defaultCount = item.defaultQuantity > item.count ? item.count : item.defaultQuantity;
      const defaultItems = Array(defaultCount).fill(__spreadProps(__spreadValues({}, item), {
        isDefault: true
      }));
      const additionalItems = item.defaultQuantity > item.count ? [] : Array(item.count - defaultCount).fill(__spreadProps(__spreadValues({}, item), {
        isDefault: false
      }));
      return [...defaultItems, ...additionalItems];
    }
  ).flat();
  expandedList.sort((a, b) => {
    if (a.isDefault && !b.isDefault) {
      return -1;
    }
    if (!a.isDefault && b.isDefault) {
      return 1;
    }
    if (mode === "max") {
      return a.priceDifference - b.priceDifference;
    } else {
      return b.priceDifference - a.priceDifference;
    }
  });
  let _includedModifierItems = [];
  let _additionalModifierItems = [];
  if (totalModifierItemsSelected >= included) {
    _includedModifierItems = expandedList.slice(0, included);
    _additionalModifierItems = expandedList.slice(included);
  } else {
    _includedModifierItems = expandedList;
  }
  const _includedModifierItemsCount = groupAndCountByIdFactory(_includedModifierItems);
  const _additionalModifierItemsCount = groupAndCountByIdFactory(_additionalModifierItems);
  return {
    includedModifierItems: _includedModifierItemsCount,
    additionalModifierItems: _additionalModifierItemsCount
  };
}
function calculateTotalPrice(quantityMode, includedModifierItemsCount, additionalModifierItemsCount, modifierItemsObj) {
  let total = 0;
  Object.values(includedModifierItemsCount).map(
    (_modifierItem) => {
      const includedPrice = quantityMode !== "Lt,Reg,Ext" /* SIZE */ ? modifierItemsObj[_modifierItem.id].includedMasterPrice : getIncludedAmountPrice(modifierItemsObj[_modifierItem.id]);
      if (modifierItemsObj[_modifierItem.id].inheritedActive) {
        total += _modifierItem.count * includedPrice;
      }
    }
  );
  Object.values(additionalModifierItemsCount).map(
    (_modifierItem) => {
      const aditionalPrice = quantityMode !== "Lt,Reg,Ext" /* SIZE */ ? modifierItemsObj[_modifierItem.id].additionalMasterPrice : getAdditionalAmountPrice(modifierItemsObj[_modifierItem.id]);
      if (modifierItemsObj[_modifierItem.id].inheritedActive) {
        total += _modifierItem.count * aditionalPrice;
      }
    }
  );
  return total;
}
function simulateAlgorithm(currentTotalPrice, selectedModifierItems, included, quantityMode, mode, modifierItems) {
  const totalDifferenceObj = {};
  Object.values(modifierItems).map((modifierItem) => {
    const { additionalModifierItems, includedModifierItems } = modifierItemsPriceAlgorithm(
      quantityMode,
      mode,
      included,
      selectedModifierItems.modifierItems[modifierItem.modifierItemId] && quantityMode === "Lt,Reg,Ext" /* SIZE */ ? selectedModifierItems.count : selectedModifierItems.count + 1,
      selectedModifierItems.modifierItems[modifierItem.modifierItemId] ? quantityMode === "Lt,Reg,Ext" /* SIZE */ ? selectedModifierItems.modifierItems : __spreadProps(__spreadValues({}, selectedModifierItems.modifierItems), {
        [modifierItem.modifierItemId]: __spreadProps(__spreadValues({}, selectedModifierItems.modifierItems[modifierItem.modifierItemId]), {
          count: selectedModifierItems.modifierItems[modifierItem.modifierItemId].count + 1
        })
      }) : __spreadProps(__spreadValues({}, selectedModifierItems.modifierItems), {
        [modifierItem.modifierItemId]: selectedModifierItemObjFactory(modifierItem)
      }),
      quantityMode === "Lt,Reg,Ext" /* SIZE */ && modifierItem.isSelected ? __spreadProps(__spreadValues({}, modifierItems), {
        [modifierItem.modifierItemId]: __spreadProps(__spreadValues({}, modifierItems[modifierItem.modifierItemId]), {
          defaultAmountSelected: nextQuantityAmount(
            modifierItems[modifierItem.modifierItemId].defaultAmountSelected
          )
        })
      }) : modifierItems
    );
    const nextTotal = calculateTotalPrice(
      quantityMode,
      includedModifierItems,
      additionalModifierItems,
      quantityMode === "Lt,Reg,Ext" /* SIZE */ && modifierItem.isSelected ? __spreadProps(__spreadValues({}, modifierItems), {
        [modifierItem.modifierItemId]: __spreadProps(__spreadValues({}, modifierItems[modifierItem.modifierItemId]), {
          defaultAmountSelected: nextQuantityAmount(
            modifierItems[modifierItem.modifierItemId].defaultAmountSelected
          )
        })
      }) : modifierItems
    );
    totalDifferenceObj[modifierItem.modifierItemId] = nextTotal - currentTotalPrice;
  });
  return totalDifferenceObj;
}
function getModifierItemsNextPrice(totalCount, selectedModifierItems, includedTotalCount, quantityMode, mode, modifierItems) {
  return simulateAlgorithm(
    totalCount,
    selectedModifierItems,
    includedTotalCount,
    quantityMode,
    mode,
    modifierItems
  );
}
var ITEM_MODIFIER_ITEMS_OVERRIDE_FIELDS = [
  "active",
  "isSelected",
  "includedMasterPrice",
  "additionalMasterPrice",
  "includedLightPrice",
  "includedRegularPrice",
  "includedExtraPrice",
  "additionalLightPrice",
  "additionalRegularPrice",
  "additionalExtraPrice",
  "defaultQuantitySelected",
  "defaultAmountSelected",
  "maximumQuantity"
];
var ITEM_MODIFIER_GROUPS_OVERRIDE_FIELDS = [
  "active",
  "advancedModifier",
  "defaultModifierGroupPricingVersionId",
  "includedModifierItems",
  "maximumModifierItems",
  "requiredModifierItems"
];
var propagateCategoriesToMenuTypes = (menuTypeVersions) => {
  const clonedMenuTypeVersions = cloneDeep16(menuTypeVersions);
  const clonedMenuTypeVersionsArray = Object.values(
    clonedMenuTypeVersions
  );
  const menuTypeVersionWithCategories = clonedMenuTypeVersionsArray.find(
    (menuTypeVersion) => Object.keys(menuTypeVersion.categoriesSubcategories || {}).length > 0
  );
  if (!menuTypeVersionWithCategories) {
    return clonedMenuTypeVersions;
  }
  clonedMenuTypeVersionsArray.forEach((menuTypeVersion) => {
    const { menuTypeId, categoriesSubcategories } = menuTypeVersion;
    if (Object.keys(categoriesSubcategories || {}).length === 0) {
      clonedMenuTypeVersions[menuTypeId].categoriesSubcategories = menuTypeVersionWithCategories.categoriesSubcategories;
    }
  });
  return clonedMenuTypeVersions;
};
var getModifierItemPriceObject = (modifierItems, quantityMode) => {
  const modifierItemsArray = Object.values(modifierItems);
  const mapFn = ({
    modifierItemId,
    defaultQuantitySelected,
    name
  }) => ({
    id: modifierItemId,
    count: quantityMode === "x1,x2,x3" /* NUMBER */ ? defaultQuantitySelected != null ? defaultQuantitySelected : 0 : 1,
    name
  });
  const filteredList = modifierItemsArray.filter(
    (modifierItem) => modifierItem.isSelected && modifierItem.inheritedActive
  ).map(mapFn);
  const filteredListWithHidden = modifierItemsArray.filter((modifierItem) => modifierItem.isSelected).map(mapFn);
  return {
    modifierItems: filteredList.reduce(
      (accObj, modifierItem) => __spreadProps(__spreadValues({}, accObj), {
        [modifierItem.id]: modifierItem
      }),
      {}
    ),
    modifierItemsWithHidden: filteredListWithHidden.reduce(
      (accObj, modifierItem) => __spreadProps(__spreadValues({}, accObj), {
        [modifierItem.id]: modifierItem
      }),
      {}
    ),
    count: filteredList.reduce(
      (totalCount, modifierItem) => totalCount + modifierItem.count,
      0
    )
  };
};
var getModifierItemPriceCalc = (modifierItems, includedModifierItems, quantityMode, priceCalcMode) => {
  const selectedModifierItemElements = getModifierItemPriceObject(
    modifierItems,
    quantityMode
  );
  const {
    includedModifierItems: _includedModifierItems,
    additionalModifierItems
  } = modifierItemsPriceAlgorithm(
    quantityMode,
    priceCalcMode,
    includedModifierItems,
    selectedModifierItemElements.count,
    selectedModifierItemElements.modifierItems,
    modifierItems
  );
  const totalPrice = calculateTotalPrice(
    quantityMode,
    _includedModifierItems,
    additionalModifierItems,
    modifierItems
  );
  const totalDifferenceObj = simulateAlgorithm(
    totalPrice,
    selectedModifierItemElements,
    includedModifierItems,
    quantityMode,
    priceCalcMode,
    modifierItems
  );
  return {
    selectedModifierItemElements,
    includedModifierItemsCount: _includedModifierItems,
    additionalModifierItemsCount: additionalModifierItems,
    totalPrice,
    totalDifferenceObj
  };
};
var getItemMassUpdateDataWithoutMasterProperties = (data) => {
  const dataWithoutMasterProperties = __spreadValues({}, data);
  dataWithoutMasterProperties == null ? true : delete dataWithoutMasterProperties.locationIds;
  delete dataWithoutMasterProperties.removeLocationIds;
  delete dataWithoutMasterProperties.categoryId;
  delete dataWithoutMasterProperties.subcategoryId;
  delete dataWithoutMasterProperties.inheritedTaxes;
  delete dataWithoutMasterProperties.linkedModifierItems;
  const obj = {
    id: 0,
    organizationId: 0,
    categoryId: data.categoryId,
    subcategoryId: data.subcategoryId,
    createdByLocationId: 0,
    name: "",
    customId: "",
    locationItemId: 0,
    itemId: 0,
    menuTypeVersions: {
      0: dataWithoutMasterProperties
    },
    locationIds: data.locationIds,
    removeLocationIds: data.removeLocationIds,
    inheritedTaxes: data.inheritedTaxes,
    linkedModifierItems: {},
    reportingGroupIds: []
  };
  return obj;
};
var getItemMassUpdateDifferences = (data) => {
  const obj = getItemMassUpdateDataWithoutMasterProperties(data);
  const initialState = __spreadValues({}, MASS_UPDATE_INITIAL_STATE);
  delete initialState.locationIds;
  delete initialState.removeLocationIds;
  delete initialState.categoryId;
  delete initialState.subcategoryId;
  delete initialState.inheritedTaxes;
  delete initialState.linkedModifierItems;
  const objInitialState = {
    id: 0,
    organizationId: 0,
    categoryId: MASS_UPDATE_INITIAL_STATE.categoryId,
    subcategoryId: MASS_UPDATE_INITIAL_STATE.subcategoryId,
    createdByLocationId: 0,
    name: "",
    locationItemId: 0,
    itemId: 0,
    menuTypeVersions: {
      0: initialState
    },
    locationIds: MASS_UPDATE_INITIAL_STATE.locationIds,
    removeLocationIds: MASS_UPDATE_INITIAL_STATE.locationIds,
    customId: "",
    inheritedTaxes: MASS_UPDATE_INITIAL_STATE.inheritedTaxes,
    linkedModifierItems: {},
    reportingGroupIds: []
  };
  let differences = diff(objInitialState, obj) || [];
  differences = differences.map((difference3) => {
    if (difference3.path[2] === "removeCategoriesSubcategories") {
      const newPath = [...difference3.path];
      newPath[2] = "categoriesSubcategories";
      return __spreadProps(__spreadValues({}, difference3), {
        path: newPath,
        kind: "D",
        lhs: difference3.rhs
      });
    }
    return difference3;
  });
  return differences;
};
var getDataForMenuReducer = (data, state, payloadBucketSelected) => {
  const coreState = { menu: state };
  const bucketSelected = payloadBucketSelected || selectBucketSelected(coreState);
  const isItem = bucketSelected === "items";
  return isItem ? preMakeItemWithModifierGroups(data, state) : data;
};
var preMakeItemWithModifierGroups = (item, state) => {
  const newItem = cloneDeep16(item);
  Object.entries(newItem.menuTypeVersions).forEach(
    ([menuTypeVersionId, menuTypeVersion]) => {
      newItem.menuTypeVersions[Number(menuTypeVersionId)] = preMakeMenuTypeVersionWithModifierGroups(
        item.itemId,
        menuTypeVersion,
        state,
        false
      );
    }
  );
  return newItem;
};
var preMakeMenuTypeVersionWithModifierGroups = (itemId, menuTypeVersion, state, clone = true) => {
  const coreState = { menu: state };
  const modifierGroups = selectModifierGroups(coreState);
  const modifierItems = selectModifierItems(coreState);
  const originalItem = selectItems(coreState)[itemId];
  const newMenuTypeVersion = clone ? cloneDeep16(menuTypeVersion) : __spreadValues({}, menuTypeVersion);
  Object.entries(newMenuTypeVersion.modifierGroups).forEach(
    ([modifierGroupId, modifierGroup]) => {
      const modifierGroupIdNumber = Number(modifierGroupId);
      const menuModifierGroup = modifierGroups[modifierGroupIdNumber];
      newMenuTypeVersion.modifierGroups[modifierGroupIdNumber] = __spreadProps(__spreadValues(__spreadValues({}, menuModifierGroup), modifierGroup), {
        inheritedActive: menuModifierGroup.active,
        override: {}
      });
      Object.keys(menuModifierGroup.modifierItems).forEach((key) => {
        const modifierItemId = Number(key);
        if (!newMenuTypeVersion.modifierGroups[modifierGroupIdNumber].modifierItems[modifierItemId]) {
          newMenuTypeVersion.modifierGroups[modifierGroupIdNumber].modifierItems[modifierItemId] = {};
        }
        newMenuTypeVersion.modifierGroups[modifierGroupIdNumber].modifierItems[modifierItemId].override = {};
      });
      ITEM_MODIFIER_GROUPS_OVERRIDE_FIELDS.forEach((field) => {
        var _a, _b, _c;
        if (field in (((_c = (_b = (_a = originalItem == null ? void 0 : originalItem.menuTypeVersions) == null ? void 0 : _a[newMenuTypeVersion.menuTypeId]) == null ? void 0 : _b.modifierGroups) == null ? void 0 : _c[modifierGroupIdNumber]) || {})) {
          newMenuTypeVersion.modifierGroups[modifierGroupIdNumber].override[field] = true;
        }
      });
      Object.entries(modifierGroup.modifierItems).forEach(
        ([modifierItemId, modifierItem]) => {
          const modifierItemIdNumber = Number(modifierItemId);
          ITEM_MODIFIER_ITEMS_OVERRIDE_FIELDS.forEach((field) => {
            var _a, _b, _c, _d, _e;
            if (field in (((_e = (_d = (_c = (_b = (_a = originalItem == null ? void 0 : originalItem.menuTypeVersions) == null ? void 0 : _a[newMenuTypeVersion.menuTypeId]) == null ? void 0 : _b.modifierGroups) == null ? void 0 : _c[modifierGroupIdNumber]) == null ? void 0 : _d.modifierItems) == null ? void 0 : _e[modifierItemIdNumber]) || {})) {
              newMenuTypeVersion.modifierGroups[modifierGroupIdNumber].modifierItems[modifierItemIdNumber].override[field] = true;
            }
          });
          const menuModifierItem = modifierGroups[modifierGroupIdNumber].modifierItems[modifierItemIdNumber];
          const modifierItemPricingVersionId = menuModifierGroup.modifierGroupPricingVersions[modifierGroup.defaultModifierGroupPricingVersionId || menuModifierGroup.defaultModifierGroupPricingVersionId].modItemPricingVersions[menuModifierItem.modifierItemId];
          const menuModifierItemPricingVersion = modifierItems[modifierItemIdNumber].modifierItemPricingVersions[modifierItemPricingVersionId] || {};
          newMenuTypeVersion.modifierGroups[modifierGroupIdNumber].modifierItems[modifierItemIdNumber] = __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, menuModifierItemPricingVersion), menuModifierItem), modifierItem), {
            inheritedActive: menuModifierItem.active && menuModifierItem.inheritedActive
          });
        }
      );
    }
  );
  return newMenuTypeVersion;
};
var updateMenuItemInventory = (item, update) => {
  Object.values(item.menuTypeVersions).forEach((menuTypeVersion) => {
    if (update.currentAmount !== void 0)
      item.menuTypeVersions[menuTypeVersion.menuTypeId].currentAmount = update.currentAmount;
    if (update.is86ed !== void 0)
      item.menuTypeVersions[menuTypeVersion.menuTypeId].is86ed = update.is86ed;
    if (update.showQuantityOnItemCard !== void 0)
      item.menuTypeVersions[menuTypeVersion.menuTypeId].showQuantityOnItemCard = update.showQuantityOnItemCard;
    if (update.trackInventory !== void 0)
      item.menuTypeVersions[menuTypeVersion.menuTypeId].trackInventory = update.trackInventory;
    if (update.showOnFreshSheet !== void 0)
      item.menuTypeVersions[menuTypeVersion.menuTypeId].showOnFreshSheet = update.showOnFreshSheet;
    if (update.resetStockDaily !== void 0)
      item.menuTypeVersions[menuTypeVersion.menuTypeId].resetStockDaily = update.resetStockDaily;
    if (update.actionWhenCurrentStockZero !== void 0)
      item.menuTypeVersions[menuTypeVersion.menuTypeId].actionWhenCurrentStockZero = update.actionWhenCurrentStockZero;
  });
};
var menuReducerHasChanges = (state, data) => {
  const { bucketSelected, id } = state.changeData;
  if (bucketSelected === null) {
    return false;
  }
  const hasChanges = id ? (deepDiff6(
    getDataForMenuReducer(
      state.selectedMode.currentMenu[bucketSelected][Number(id)],
      state
    ),
    getDataForMenuReducer(data, state)
  ) || []).length > 0 : true;
  return hasChanges;
};
var MENU_INITIAL_STATE = {
  menuTypes: {},
  categories: { 0: CATEGORIES_INITIAL_STATE },
  subcategories: { 0: SUBCATEGORY_INITIAL_STATE },
  items: { 0: ITEM_INITIAL_STATE },
  modifierGroups: { 0: MODIFIER_GROUPS_INITIAL_STATE },
  modifierItems: { 0: MODIFIER_ITEM_INITIAL_STATE },
  discounts: { 0: DISCOUNT_INITIAL_STATE },
  hotButtons: {},
  combos: { 0: COMBO_INITIAL_STATE },
  specials: {},
  ingredients: { 0: INGREDIENT_INITIAL_STATE },
  itemGroups: {},
  reportingGroups: {}
};
var MENU_VERSIONS_INITIAL_STATE = {
  master: 0,
  location: 0,
  remoteLocation: null
};
var MENU_MODULE_INITIAL_STATE = {
  versions: MENU_VERSIONS_INITIAL_STATE,
  masterMenu: MENU_INITIAL_STATE,
  locationMenu: MENU_INITIAL_STATE,
  remoteLocationMenu: MENU_INITIAL_STATE,
  selectedMode: {
    menuType: "masterMenu" /* MASTER_MENU */,
    id: 0,
    currentMenu: MENU_INITIAL_STATE,
    menuVersion: 0,
    name: "Enterprise",
    selectedBucket: "menuTypes"
  },
  changeData: {
    bucketSelected: null,
    id: 0,
    data: null,
    hasChanges: false,
    sectionId: "all",
    mode: "create" /* CREATE */,
    differences: [],
    finalDiffObject: null,
    errors: {},
    menuVersion: 0,
    selectedLocations: []
  },
  changeMassUpdateData: {
    bucketSelected: null,
    data: null,
    originalData: null,
    hasChanges: false,
    sectionId: "all",
    differences: [],
    finalDiffObject: null,
    errors: {},
    bucketIds: [],
    menuVersion: 0,
    selectionCriteria: null,
    selectedLocations: []
  },
  changeFreshSheetData: {
    data: null,
    originalData: null,
    hasChanges: false,
    finalDiffObject: null,
    sectionId: "all",
    differences: [],
    errors: {}
  },
  breadCrumb: [],
  lastRearrangePreview: {
    items: [],
    combos: [],
    categories: [],
    subcategories: [],
    modifierTags: [],
    hotButtons: [],
    modifierGroups: [],
    itemGroups: [],
    comboItems: [],
    menuTypes: [],
    modifierItems: [],
    general: []
  },
  previewElements: {
    items: {},
    combos: {},
    menuTypes: {},
    categories: {},
    subcategories: {},
    modifierItems: {},
    general: {}
  },
  menuPreviewAction: null
};
var menuReducer = (state = MENU_MODULE_INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_MASTER_MENU_ON_STATE_WS:
    case SET_MASTER_MENU_ON_STATE:
      return __spreadProps(__spreadValues({}, state), { masterMenu: action.payload });
    case SET_LOCATION_MENU_ON_STATE_WS:
    case SET_LOCATION_MENU_ON_STATE:
      return __spreadProps(__spreadValues({}, state), { locationMenu: action.payload });
    case SET_REMOTE_LOCATION_MENU_ON_STATE_WS:
    case SET_REMOTE_LOCATION_MENU_ON_STATE:
      return __spreadProps(__spreadValues({}, state), { remoteLocationMenu: action.payload });
    case SET_SELECTED_MENU_MODE_WS:
    case SET_SELECTED_MENU_MODE:
      return __spreadProps(__spreadValues({}, state), {
        selectedMode: __spreadValues(__spreadValues({}, state.selectedMode), action.payload)
      });
    case SET_MENU_VERSIONS_WS:
    case SET_MENU_VERSIONS:
      return __spreadProps(__spreadValues({}, state), { versions: action.payload });
    case SET_CHANGE_DATA:
      return __spreadProps(__spreadValues({}, state), {
        changeData: __spreadProps(__spreadValues({}, action.payload), {
          data: getDataForMenuReducer(
            action.payload.data,
            state,
            action.payload.bucketSelected
          )
        })
      });
    case SET_CHANGE_MASS_UPDATE_DATA:
      return __spreadProps(__spreadValues({}, state), { changeMassUpdateData: action.payload });
    case SET_CHANGE_FRESH_SHEET_DATA:
      return __spreadProps(__spreadValues({}, state), { changeFreshSheetData: action.payload });
    case SET_SELECTED_LOCATIONS:
      return __spreadProps(__spreadValues({}, state), {
        changeData: __spreadProps(__spreadValues({}, state.changeData), {
          selectedLocations: action.payload
        })
      });
    case SET_MASS_UPDATE_SELECTED_LOCATIONS:
      return __spreadProps(__spreadValues({}, state), {
        changeMassUpdateData: __spreadProps(__spreadValues({}, state.changeMassUpdateData), {
          selectedLocations: action.payload
        })
      });
    case RESET_CHANGE_DATA:
      return __spreadProps(__spreadValues({}, state), {
        changeData: {
          bucketSelected: null,
          id: 0,
          data: null,
          hasChanges: false,
          sectionId: "all",
          mode: "create" /* CREATE */,
          differences: [],
          finalDiffObject: null,
          menuVersion: 0,
          errors: {},
          selectedLocations: []
        }
      });
    case RESET_CHANGE_MASS_UPDATE_DATA:
      return __spreadProps(__spreadValues({}, state), {
        changeMassUpdateData: {
          bucketSelected: null,
          data: null,
          originalData: null,
          finalDiffObject: null,
          hasChanges: false,
          sectionId: "all",
          differences: [],
          menuVersion: 0,
          errors: {},
          bucketIds: [],
          selectionCriteria: null,
          selectedLocations: []
        }
      });
    case RESET_CHANGE_FRESH_SHEET_DATA:
      return __spreadProps(__spreadValues({}, state), {
        changeFreshSheetData: {
          data: null,
          originalData: null,
          finalDiffObject: null,
          hasChanges: false,
          sectionId: "all",
          differences: [],
          errors: {}
        }
      });
    case RESET_MENU_CHANGES:
      return __spreadProps(__spreadValues({}, state), {
        changeData: __spreadProps(__spreadValues({}, state.changeData), {
          errors: {},
          differences: [],
          hasChanges: false,
          data: getDataForMenuReducer(action.payload, state),
          sectionId: "all" /* ALL */
        })
      });
    case RESET_MASS_UPDATE_MENU_CHANGES:
      return __spreadProps(__spreadValues({}, state), {
        changeMassUpdateData: __spreadProps(__spreadValues({}, state.changeMassUpdateData), {
          errors: {},
          differences: [],
          hasChanges: false,
          data: action.payload,
          sectionId: "all" /* ALL */
        })
      });
    case SET_CHANGE_DATA_VALUES:
      return __spreadProps(__spreadValues({}, state), {
        changeData: __spreadProps(__spreadValues({}, state.changeData), {
          hasChanges: menuReducerHasChanges(state, action.payload.data),
          sectionId: action.payload.sectionId,
          data: action.payload.data
        })
      });
    case SET_CHANGE_MASS_UPDATE_DATA_VALUES:
      return __spreadProps(__spreadValues({}, state), {
        changeMassUpdateData: __spreadProps(__spreadValues({}, state.changeMassUpdateData), {
          hasChanges: true,
          sectionId: action.payload.sectionId,
          data: action.payload.data
        })
      });
    case SET_CHANGE_FRESH_SHEET_DATA_VALUES:
      return __spreadProps(__spreadValues({}, state), {
        changeFreshSheetData: __spreadProps(__spreadValues({}, state.changeFreshSheetData), {
          hasChanges: true,
          sectionId: action.payload.sectionId,
          data: action.payload.data
        })
      });
    case UPDATE_CHANGE_DATA_VALUES:
      return __spreadProps(__spreadValues({}, state), {
        changeData: __spreadValues(__spreadValues(__spreadValues({}, state.changeData), action.payload), action.payload.data ? {
          hasChanges: menuReducerHasChanges(state, action.payload.data),
          data: getDataForMenuReducer(action.payload.data, state)
        } : {})
      });
    case UPDATE_CHANGE_MASS_UPDATE_DATA_VALUES:
      return __spreadProps(__spreadValues({}, state), {
        changeMassUpdateData: __spreadValues(__spreadValues({}, state.changeMassUpdateData), action.payload)
      });
    case UPDATE_CHANGE_FRESH_SHEET_DATA_VALUES:
      return __spreadProps(__spreadValues({}, state), {
        changeFreshSheetData: __spreadValues(__spreadValues({}, state.changeFreshSheetData), action.payload)
      });
    case SET_DIFFERENCES:
      return __spreadProps(__spreadValues({}, state), {
        changeData: __spreadProps(__spreadValues({}, state.changeData), { differences: action.payload })
      });
    case SET_DIFF_OBJECT:
      return __spreadProps(__spreadValues({}, state), {
        changeData: __spreadProps(__spreadValues({}, state.changeData), { finalDiffObject: action.payload })
      });
    case SET_BREADCRUMB_LOCATION:
      return __spreadProps(__spreadValues({}, state), {
        breadCrumb: [...state.breadCrumb, action.payload]
      });
    case SET_BREADCRUMB:
      return __spreadProps(__spreadValues({}, state), {
        breadCrumb: action.payload
      });
    case SET_ERRORS:
      return __spreadProps(__spreadValues({}, state), {
        changeData: __spreadProps(__spreadValues({}, state.changeData), {
          errors: action.payload,
          sectionId: "errors"
        })
      });
    case SET_MASS_UPDATE_ERRORS:
      return __spreadProps(__spreadValues({}, state), {
        changeMassUpdateData: __spreadProps(__spreadValues({}, state.changeMassUpdateData), {
          errors: action.payload,
          sectionId: "errors"
        })
      });
    case SET_LAST_PREVIEW_ARRANGEMENT:
      return __spreadProps(__spreadValues({}, state), {
        lastRearrangePreview: __spreadValues(__spreadValues({}, state.lastRearrangePreview), action.payload)
      });
    case UPDATE_PREVIEW_ELEMENTS:
      return __spreadProps(__spreadValues({}, state), {
        previewElements: __spreadValues(__spreadValues({}, state.previewElements), action.payload)
      });
    case SET_PREVIEW_ELEMENTS:
      return __spreadProps(__spreadValues({}, state), {
        previewElements: action.payload
      });
    case SET_MENU_PREVIEW_ACTION:
      return __spreadProps(__spreadValues({}, state), {
        menuPreviewAction: action.payload
      });
    case SET_LOCAL_ITEM_86: {
      const { itemId, set86: is86ed } = action.payload;
      const locationMenu = state.locationMenu;
      const prevItem = locationMenu.items[itemId];
      const menuTypeVersions = Object.values(prevItem.menuTypeVersions);
      const newLocationMenu = produce(locationMenu, (draft) => {
        const itemDraft = draft.items[itemId];
        menuTypeVersions.forEach((menuTypeVersion) => {
          itemDraft.menuTypeVersions[menuTypeVersion.menuTypeId].is86ed = is86ed;
        });
      });
      return __spreadProps(__spreadValues({}, state), {
        locationMenu: newLocationMenu
      });
    }
    case SET_LOCAL_MODIFIER_ITEM_86: {
      const { modifierItemId, set86: is86ed } = action.payload;
      const locationMenu = state.locationMenu;
      const updatedModifierItems = produce(
        locationMenu.modifierItems,
        (draft) => {
          const modifierItemDraft = draft[modifierItemId];
          modifierItemDraft.is86ed = is86ed;
        }
      );
      return __spreadProps(__spreadValues({}, state), {
        locationMenu: __spreadProps(__spreadValues({}, state.locationMenu), {
          modifierItems: updatedModifierItems
        })
      });
    }
    case SET_LOCAL_INGREDIENT_86: {
      const { ingredientId, set86: is86ed } = action.payload;
      const locationMenu = state.locationMenu;
      const updatedIngredients = produce(locationMenu.ingredients, (draft) => {
        const ingredientDraft = draft[ingredientId];
        ingredientDraft.is86ed = is86ed;
      });
      return __spreadProps(__spreadValues({}, state), {
        locationMenu: __spreadProps(__spreadValues({}, state.locationMenu), {
          ingredients: updatedIngredients
        })
      });
    }
    case RESET_LOCAL_ITEM_STOCK: {
      const { itemId } = action.payload;
      const locationMenu = state.locationMenu;
      const prevItem = locationMenu.items[itemId];
      const menuTypeVersions = Object.values(prevItem.menuTypeVersions);
      const newLocationMenu = produce(locationMenu, (draft) => {
        const itemDraft = draft.items[itemId];
        menuTypeVersions.forEach((menuTypeVersion) => {
          itemDraft.menuTypeVersions[menuTypeVersion.menuTypeId].currentAmount = menuTypeVersion.initialAmount;
        });
      });
      return __spreadProps(__spreadValues({}, state), {
        locationMenu: newLocationMenu
      });
    }
    case UPDATE_LOCAL_ITEM_STOCK: {
      const { itemId, stock } = action.payload;
      const locationMenu = state.locationMenu;
      const newLocationMenu = produce(locationMenu, (draft) => {
        const prevItem = draft.items[itemId];
        const menuTypeVersions = Object.values(prevItem.menuTypeVersions);
        const itemDraft = draft.items[itemId];
        menuTypeVersions.forEach((menuTypeVersion) => {
          const prevStock = itemDraft.menuTypeVersions[menuTypeVersion.menuTypeId].currentAmount;
          itemDraft.menuTypeVersions[menuTypeVersion.menuTypeId].currentAmount = stock;
          if (getStockZeroAction(
            itemDraft.menuTypeVersions[menuTypeVersion.menuTypeId]
          ) !== "86" /* SET_86 */)
            return;
          if (stock <= 0) {
            itemDraft.menuTypeVersions[menuTypeVersion.menuTypeId].is86ed = true;
          } else if (prevStock <= 0) {
            itemDraft.menuTypeVersions[menuTypeVersion.menuTypeId].is86ed = false;
          }
        });
      });
      const newSelectedMode = produce(state.selectedMode, (draft) => {
        if (draft.menuType !== "locationMenu" /* LOCATION_MENU */)
          return;
        const currentMenuItem = draft.currentMenu.items[itemId];
        if (!currentMenuItem)
          return;
        const menuTypeVersions = Object.values(
          currentMenuItem.menuTypeVersions
        );
        menuTypeVersions.forEach((menuTypeVersion) => {
          const prevStock = menuTypeVersion.currentAmount;
          menuTypeVersion.currentAmount = stock;
          if (getStockZeroAction(menuTypeVersion) !== "86" /* SET_86 */)
            return;
          if (stock <= 0) {
            menuTypeVersion.is86ed = true;
          } else if (prevStock <= 0) {
            menuTypeVersion.is86ed = false;
          }
        });
        draft.currentMenu.items[itemId] = currentMenuItem;
      });
      return __spreadProps(__spreadValues({}, state), {
        locationMenu: newLocationMenu,
        selectedMode: newSelectedMode
      });
    }
    case UPDATE_LOCAL_ITEM_SHOW_STOCK_ON_ITEM_CARD: {
      const { itemId, showQuantityOnItemCard } = action.payload;
      const locationMenu = state.locationMenu;
      const newLocationMenu = produce(locationMenu, (draft) => {
        const item = draft.items[itemId];
        const menuTypeVersions = Object.values(item.menuTypeVersions);
        const itemDraft = draft.items[itemId];
        menuTypeVersions.forEach((menuTypeVersion) => {
          itemDraft.menuTypeVersions[menuTypeVersion.menuTypeId].showQuantityOnItemCard = showQuantityOnItemCard;
        });
      });
      const newSelectedMode = produce(state.selectedMode, (draft) => {
        if (draft.menuType !== "locationMenu" /* LOCATION_MENU */)
          return;
        const currentMenuItem = draft.currentMenu.items[itemId];
        if (!currentMenuItem)
          return;
        const menuTypeVersions = Object.values(
          currentMenuItem.menuTypeVersions
        );
        menuTypeVersions.forEach((menuTypeVersion) => {
          menuTypeVersion.showQuantityOnItemCard = showQuantityOnItemCard;
        });
        draft.currentMenu.items[itemId] = currentMenuItem;
      });
      return __spreadProps(__spreadValues({}, state), {
        locationMenu: newLocationMenu,
        selectedMode: newSelectedMode
      });
    }
    case UPDATE_INVENTORY:
    case UPDATE_INVENTORY_WS: {
      return produce(state, (draft) => {
        Object.entries(action.payload).forEach(
          ([itemStringId, update]) => {
            const locationItem = draft.locationMenu.items[Number(itemStringId)];
            if (!locationItem)
              return;
            updateMenuItemInventory(locationItem, update);
            const selectedMode = draft.selectedMode;
            const currentMenuItem = selectedMode.currentMenu.items[Number(itemStringId)];
            if (!currentMenuItem || selectActualMenuType({ menu: state }) !== "locationMenu" /* LOCATION_MENU */)
              return;
            updateMenuItemInventory(currentMenuItem, update);
          }
        );
      });
    }
    case UPDATE_MODIFIER_ITEM_INVENTORY_WS: {
      return produce(state, (draft) => {
        Object.entries(action.payload).forEach(
          ([itemStringId, update]) => {
            const modifierItem = draft.locationMenu.modifierItems[Number(itemStringId)];
            if (!modifierItem)
              return;
            if (update.is86ed !== void 0)
              modifierItem.is86ed = update.is86ed;
          }
        );
      });
    }
    case UPDATE_INGREDIENT_INVENTORY_WS: {
      return produce(state, (draft) => {
        Object.entries(action.payload).forEach(
          ([itemStringId, update]) => {
            const ingredient = draft.locationMenu.ingredients[Number(itemStringId)];
            if (!ingredient)
              return;
            if (update.is86ed !== void 0)
              ingredient.is86ed = update.is86ed;
          }
        );
      });
    }
    case REMOVE_MASTER_DATA:
      return __spreadProps(__spreadValues({}, state), {
        masterMenu: {}
      });
    default:
      return state;
  }
};
var reducer_default4 = menuReducer;

// src/state/selectors/customersSelectors.ts
var customersSelectors_exports = {};
__export(customersSelectors_exports, {
  areCustomersMasterModeSelector: () => areCustomersMasterModeSelector,
  createCustomersErrorSelector: () => createCustomersErrorSelector,
  createCustomersSectionSelector: () => createCustomersSectionSelector,
  makeSelectCustomersData: () => makeSelectCustomersData,
  selectActualCustomersVersion: () => selectActualCustomersVersion,
  selectCurrentCustomer: () => selectCurrentCustomer,
  selectCurrentCustomerOriginalData: () => selectCurrentCustomerOriginalData,
  selectCurrentCustomersSectionId: () => selectCurrentCustomersSectionId,
  selectCustomerChangeData: () => selectCustomerChangeData,
  selectCustomerDifferences: () => selectCustomerDifferences,
  selectCustomerFinalDiffObject: () => selectCustomerFinalDiffObject,
  selectCustomers: () => selectCustomers,
  selectCustomersDataAndSectionId: () => selectCustomersDataAndSectionId,
  selectCustomersErrors: () => selectCustomersErrors,
  selectCustomersLocationVersion: () => selectCustomersLocationVersion,
  selectCustomersMasterVersion: () => selectCustomersMasterVersion,
  selectCustomersRemoteLocationVersion: () => selectCustomersRemoteLocationVersion,
  selectCustomersSelectedMode: () => selectCustomersSelectedMode,
  selectCustomersType: () => selectCustomersType,
  selectCustomersVersions: () => selectCustomersVersions,
  selectIsCustomerSet: () => selectIsCustomerSet,
  selectLocationCustomers: () => selectLocationCustomers,
  selectMasterCustomers: () => selectMasterCustomers,
  selectRemoteLocationCustomers: () => selectRemoteLocationCustomers
});

// src/state/customers/selectedMode/initialStates.ts
var CUSTOMER_ORDER_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  orderId: 0,
  totalAmount: 0,
  status: "open-initiated" /* OPEN_INITIATED */,
  total: 0,
  locationId: 0
});
var CUSTOMER_INITIAL_STATE = {
  id: 0,
  customerId: 0,
  firstName: "",
  middleName: "",
  lastName: "",
  dateOfBirth: "",
  email: "",
  phoneNumber: "",
  customerNotes: "",
  addresses: {},
  cards: {},
  totalOfOrdersPlaced: 0,
  avgSpend: 0,
  lifetimeSpend: 0,
  avgTip: 0,
  avgTipAmount: 0,
  percentageBreakdownOfDineIn: 0,
  percentageBreakdownOfDelivery: 0,
  percentageBreakdownOfToGo: 0,
  percentageBreakdownOfCatering: 0,
  previousOrders: {}
};
var CUSTOMER_ADDRESS_INITIAL_STATE = __spreadProps(__spreadValues({}, INITIAL_STATE_BASE_INTERFACE_WITH_STRING_ID), {
  addressId: "0",
  isDefault: false,
  addressType: "house" /* HOUSE */,
  streetLine1: "",
  streetLine2: "",
  state: "",
  city: "",
  postalCode: "",
  hotelName: "",
  roomNumber: "",
  officeName: "",
  apartmentNumber: ""
});
var CUSTOMERS_INITIAL_STATE = {};
var CUSTOMER_SELECTED_MODE_INITIAL_STATE = {
  customersType: "location" /* LOCATION_CUSTOMERS */,
  id: 0,
  currentCustomers: CUSTOMERS_INITIAL_STATE,
  customersVersion: 0,
  name: "Location"
};

// src/helpers/factories/customers/addressInfoTableFactory.ts
var addressInfoRowMapping = (address) => ({
  id: address.addressId,
  isDefault: address.isDefault,
  addressType: address.addressType,
  addressName: "",
  unitNumber: "",
  streetLine1: address.streetLine1,
  streetLine2: address.streetLine2,
  state: address.state,
  city: address.city,
  postalCode: address.postalCode,
  actions: "actions"
});
var addressInfoTableFactory = (addresses) => Object.values(addresses || {}).map((address) => {
  return getCustomerAddressRowData(address);
});

// src/helpers/customers/customers.ts
var getCustomersVersionWithStateCore = (state) => {
  const customersType = selectCustomersType(state);
  switch (customersType) {
    case "master" /* MASTER_CUSTOMERS */:
      return selectCustomersMasterVersion(state);
    case "location" /* LOCATION_CUSTOMERS */:
      return selectCustomersLocationVersion(state);
    case "remoteLocation" /* REMOTE_LOCATION_CUSTOMERS */:
      return selectCustomersRemoteLocationVersion(state);
  }
};
var getCustomersVersionCore = (state) => {
  return getCustomersVersionWithStateCore(state);
};
var getNewCustomersVersionCore = (payload, state) => {
  const customersType = selectCustomersType(state);
  switch (customersType) {
    case "master" /* MASTER_CUSTOMERS */:
      return payload.versions.master;
    case "location" /* LOCATION_CUSTOMERS */:
      return payload.versions.location;
    case "remoteLocation" /* REMOTE_LOCATION_CUSTOMERS */:
      return payload.versions.remoteLocation;
  }
};
var getCurrentCustomersCore = (state, customersType) => {
  const { master, location, remoteLocation, versions } = state.customers;
  if (!customersType) {
    customersType = selectCustomersType(state);
  }
  switch (customersType) {
    case "master" /* MASTER_CUSTOMERS */:
      return { customers: master, version: versions.master };
    case "location" /* LOCATION_CUSTOMERS */:
      return { customers: location, version: versions.location };
    case "remoteLocation" /* REMOTE_LOCATION_CUSTOMERS */:
      return {
        customers: remoteLocation,
        version: versions.remoteLocation || 0
      };
  }
};
var getCustomerAddressRowData = (address) => {
  const addressRow = addressInfoRowMapping(address);
  switch (addressRow.addressType) {
    case "house" /* HOUSE */:
      addressRow.addressName = "-";
      addressRow.unitNumber = "-";
      break;
    case "apartment" /* APARTMENT */:
      addressRow.addressName = "-";
      addressRow.unitNumber = `${address.apartmentNumber}`;
      break;
    case "office" /* OFFICE */:
      addressRow.addressName = address.officeName || "-";
      addressRow.unitNumber = "-";
      break;
    case "hotel" /* HOTEL */:
      addressRow.addressName = address.hotelName || "-";
      addressRow.unitNumber = `${address.roomNumber}`;
      break;
  }
  return addressRow;
};
var getNewCustomerEmptyAddress = () => {
  const newAddressId = generateTabletGeneratedId();
  return __spreadProps(__spreadValues({}, CUSTOMER_ADDRESS_INITIAL_STATE), {
    addressType: "house" /* HOUSE */,
    addressId: newAddressId
  });
};
var createCustomersSectionSelector = (sectionId) => (_, next) => {
  return next.sectionId === sectionId ? false : next.sectionId !== "all" /* ALL */;
};
var selectCustomerChangeData = (state) => state.customers.changeData;
var selectCustomersSelectedMode = (state) => state.customers.selectedMode;
var selectMasterCustomers = (state) => state.customers.master;
var selectLocationCustomers = (state) => state.customers.location;
var selectRemoteLocationCustomers = (state) => state.customers.remoteLocation;
var selectCustomersType = (state) => selectCustomersSelectedMode(state).customersType;
var selectCustomersVersions = (state) => state.customers.versions;
var selectCustomers = (state) => selectCustomersSelectedMode(state).currentCustomers;
var selectCustomersMasterVersion = (state) => selectCustomersVersions(state).master;
var selectCustomersLocationVersion = (state) => selectCustomersVersions(state).location;
var selectCustomersRemoteLocationVersion = (state) => selectCustomersVersions(state).remoteLocation;
var selectActualCustomersVersion = (state) => getCustomersVersionWithStateCore(state);
var selectCurrentCustomer = (state) => selectCustomerChangeData(state).data;
var selectCurrentCustomerOriginalData = (state) => selectCustomerChangeData(state).originalData;
var selectCurrentCustomersSectionId = (state) => selectCustomerChangeData(state).sectionId;
var selectCustomersErrors = (state) => selectCustomerChangeData(state).errors;
var areCustomersMasterModeSelector = (state) => selectCustomersType(state) === "master" /* MASTER_CUSTOMERS */;
var selectCustomerDifferences = (state) => selectCustomerChangeData(state).differences;
var selectCustomerFinalDiffObject = (state) => selectCustomerChangeData(state).finalDiffObject;
var selectIsCustomerSet = (state) => selectCurrentCustomer(state) !== null;
var selectCustomersDataAndSectionId = createSelector(
  selectCurrentCustomer,
  selectCurrentCustomersSectionId,
  (data, sectionId) => ({
    data,
    sectionId
  })
);
var makeSelectCustomersData = (currentSectionId) => {
  const createSelectorCustom = createSelectorCreator(
    defaultMemoize,
    createCustomersSectionSelector(currentSectionId)
  );
  return createSelectorCustom(selectCustomersDataAndSectionId, ({ data }) => ({
    data
  }));
};
var createCustomersErrorSelector = (sectionId) => (state) => {
  var _a;
  for (const value of Object.values(
    selectCustomerChangeData(state).errors || {}
  )) {
    if (((_a = value.kind) == null ? void 0 : _a.section) === sectionId) {
      return true;
    }
  }
  return false;
};

// src/state/selectors/register/registerSelectors.ts
var registerSelectors_exports = {};
__export(registerSelectors_exports, {
  isCheckEditorActive: () => isCheckEditorActive,
  isPaymentScreenActive: () => isPaymentScreenActive,
  isPreviewMode: () => isPreviewMode,
  selectAllMenuTypeDropdownList: () => selectAllMenuTypeDropdownList,
  selectBarCodeOrderFromOrders: () => selectBarCodeOrderFromOrders,
  selectBarCodeOrderSearchResult: () => selectBarCodeOrderSearchResult,
  selectComboDisplayName: () => selectComboDisplayName,
  selectCurrentActiveBOGOSpecials: () => selectCurrentActiveBOGOSpecials,
  selectCurrentActiveItemSpecials: () => selectCurrentActiveItemSpecials,
  selectCurrentActiveItems: () => selectCurrentActiveItems,
  selectCurrentActiveSpecials: () => selectCurrentActiveSpecials,
  selectCurrentBOGOSpecialsBuyItemIds: () => selectCurrentBOGOSpecialsBuyItemIds,
  selectCurrentBOGOSpecialsGetItemIds: () => selectCurrentBOGOSpecialsGetItemIds,
  selectCurrentBaseCheck: () => selectCurrentBaseCheck,
  selectCurrentBaseCheckBalanceDue: () => selectCurrentBaseCheckBalanceDue,
  selectCurrentBaseCheckTip: () => selectCurrentBaseCheckTip,
  selectCurrentBaseCheckTotal: () => selectCurrentBaseCheckTotal,
  selectCurrentCategoryId: () => selectCurrentCategoryId,
  selectCurrentCheck: () => selectCurrentCheck,
  selectCurrentCheckBalanceDue: () => selectCurrentCheckBalanceDue,
  selectCurrentCheckElementEntries: () => selectCurrentCheckElementEntries,
  selectCurrentCheckId: () => selectCurrentCheckId,
  selectCurrentCheckName: () => selectCurrentCheckName,
  selectCurrentCheckNumber: () => selectCurrentCheckNumber,
  selectCurrentCheckPayments: () => selectCurrentCheckPayments,
  selectCurrentCheckTotal: () => selectCurrentCheckTotal,
  selectCurrentComboElement: () => selectCurrentComboElement,
  selectCurrentComboElementId: () => selectCurrentComboElementId,
  selectCurrentComboElementIsInClosedCheck: () => selectCurrentComboElementIsInClosedCheck,
  selectCurrentComboHasSeatSelected: () => selectCurrentComboHasSeatSelected,
  selectCurrentComboId: () => selectCurrentComboId,
  selectCurrentComboItemsNotTriggeredQty: () => selectCurrentComboItemsNotTriggeredQty,
  selectCurrentComboItemsReadyToSend: () => selectCurrentComboItemsReadyToSend,
  selectCurrentComboName: () => selectCurrentComboName,
  selectCurrentCombos: () => selectCurrentCombos,
  selectCurrentCombosBySeat: () => selectCurrentCombosBySeat,
  selectCurrentCourseNumber: () => selectCurrentCourseNumber,
  selectCurrentCourseNumberSelected: () => selectCurrentCourseNumberSelected,
  selectCurrentCustomTicketMode: () => selectCurrentCustomTicketMode,
  selectCurrentElementConfigWhenSent: () => selectCurrentElementConfigWhenSent,
  selectCurrentElementCreatedById: () => selectCurrentElementCreatedById,
  selectCurrentElementCustomizerType: () => selectCurrentElementCustomizerType,
  selectCurrentElementInstructions: () => selectCurrentElementInstructions,
  selectCurrentElementIsOnHold: () => selectCurrentElementIsOnHold,
  selectCurrentElementItemObj: () => selectCurrentElementItemObj,
  selectCurrentElementMenuTypeVersion: () => selectCurrentElementMenuTypeVersion,
  selectCurrentElementTimeSentToKitchen: () => selectCurrentElementTimeSentToKitchen,
  selectCurrentElementTimeTriggered: () => selectCurrentElementTimeTriggered,
  selectCurrentHotButtonModifierItemPosName: () => selectCurrentHotButtonModifierItemPosName,
  selectCurrentHotButtons: () => selectCurrentHotButtons,
  selectCurrentItemAllModIds: () => selectCurrentItemAllModIds,
  selectCurrentItemGroupId: () => selectCurrentItemGroupId,
  selectCurrentItemGroupInstance: () => selectCurrentItemGroupInstance,
  selectCurrentItemId: () => selectCurrentItemId,
  selectCurrentItemShowAllModsAlphabetizeButtonsEnabled: () => selectCurrentItemShowAllModsAlphabetizeButtonsEnabled,
  selectCurrentItemShowAllModsBehavior: () => selectCurrentItemShowAllModsBehavior,
  selectCurrentItemShowAllModsEnabled: () => selectCurrentItemShowAllModsEnabled,
  selectCurrentItemShowAllModsHalfSizeButtonsEnabled: () => selectCurrentItemShowAllModsHalfSizeButtonsEnabled,
  selectCurrentItemShowIngredients: () => selectCurrentItemShowIngredients,
  selectCurrentItems: () => selectCurrentItems,
  selectCurrentLicenseEditing: () => selectCurrentLicenseEditing,
  selectCurrentMenuTypeId: () => selectCurrentMenuTypeId,
  selectCurrentMenuTypeRegister: () => selectCurrentMenuTypeRegister,
  selectCurrentModifierGroup: () => selectCurrentModifierGroup,
  selectCurrentModifierGroupId: () => selectCurrentModifierGroupId,
  selectCurrentModifierItemInstanceId: () => selectCurrentModifierItemInstanceId,
  selectCurrentModifierTagId: () => selectCurrentModifierTagId,
  selectCurrentModifyingSentTicketElement: () => selectCurrentModifyingSentTicketElement,
  selectCurrentNavCheckIds: () => selectCurrentNavCheckIds,
  selectCurrentNestedModifierGroupId: () => selectCurrentNestedModifierGroupId,
  selectCurrentOrder: () => selectCurrentOrder,
  selectCurrentOrderActiveChecks: () => selectCurrentOrderActiveChecks,
  selectCurrentOrderBOGOSpecials: () => selectCurrentOrderBOGOSpecials,
  selectCurrentOrderBalanceDue: () => selectCurrentOrderBalanceDue,
  selectCurrentOrderCheckCount: () => selectCurrentOrderCheckCount,
  selectCurrentOrderCheckPaymentsCount: () => selectCurrentOrderCheckPaymentsCount,
  selectCurrentOrderChecks: () => selectCurrentOrderChecks,
  selectCurrentOrderChecksCount: () => selectCurrentOrderChecksCount,
  selectCurrentOrderClosedCheckIds: () => selectCurrentOrderClosedCheckIds,
  selectCurrentOrderComboIdsNoOnHold: () => selectCurrentOrderComboIdsNoOnHold,
  selectCurrentOrderCourseTimes: () => selectCurrentOrderCourseTimes,
  selectCurrentOrderCourseTimesObject: () => selectCurrentOrderCourseTimesObject,
  selectCurrentOrderCreatedDate: () => selectCurrentOrderCreatedDate,
  selectCurrentOrderDefaultCheckId: () => selectCurrentOrderDefaultCheckId,
  selectCurrentOrderDiscounts: () => selectCurrentOrderDiscounts,
  selectCurrentOrderHasAvailableChecks: () => selectCurrentOrderHasAvailableChecks,
  selectCurrentOrderHasDineInAndTakeOut: () => selectCurrentOrderHasDineInAndTakeOut,
  selectCurrentOrderId: () => selectCurrentOrderId,
  selectCurrentOrderIdNotInVAO: () => selectCurrentOrderIdNotInVAO,
  selectCurrentOrderIsNotBeenEdited: () => selectCurrentOrderIsNotBeenEdited,
  selectCurrentOrderNumber: () => selectCurrentOrderNumber,
  selectCurrentOrderNumberOfChecks: () => selectCurrentOrderNumberOfChecks,
  selectCurrentOrderObj: () => selectCurrentOrderObj,
  selectCurrentOrderOwnerId: () => selectCurrentOrderOwnerId,
  selectCurrentOrderPayments: () => selectCurrentOrderPayments,
  selectCurrentOrderServiceChargeSelection: () => selectCurrentOrderServiceChargeSelection,
  selectCurrentOrderServiceCharges: () => selectCurrentOrderServiceCharges,
  selectCurrentOrderSpecials: () => selectCurrentOrderSpecials,
  selectCurrentOrderSpecialsSource: () => selectCurrentOrderSpecialsSource,
  selectCurrentOrderSplitMode: () => selectCurrentOrderSplitMode,
  selectCurrentOrderStatus: () => selectCurrentOrderStatus,
  selectCurrentOrderSubtotal: () => selectCurrentOrderSubtotal,
  selectCurrentOrderTableId: () => selectCurrentOrderTableId,
  selectCurrentOrderTicketElementToCheckElements: () => selectCurrentOrderTicketElementToCheckElements,
  selectCurrentOrderTicketIdsNoOnHold: () => selectCurrentOrderTicketIdsNoOnHold,
  selectCurrentOrderTotalDiscountAmount: () => selectCurrentOrderTotalDiscountAmount,
  selectCurrentOrderTotalServiceChargeAmount: () => selectCurrentOrderTotalServiceChargeAmount,
  selectCurrentOrderType: () => selectCurrentOrderType,
  selectCurrentSeatId: () => selectCurrentSeatId,
  selectCurrentSeatSelected: () => selectCurrentSeatSelected,
  selectCurrentSeatSharedBarStatus: () => selectCurrentSeatSharedBarStatus,
  selectCurrentSeatTotalAmount: () => selectCurrentSeatTotalAmount,
  selectCurrentSeats: () => selectCurrentSeats,
  selectCurrentSpecialsRewardedElementIds: () => selectCurrentSpecialsRewardedElementIds,
  selectCurrentSpecialsRewardedElementInstances: () => selectCurrentSpecialsRewardedElementInstances,
  selectCurrentSpecialsTriggerElementIds: () => selectCurrentSpecialsTriggerElementIds,
  selectCurrentSpecialsTriggerElementInstances: () => selectCurrentSpecialsTriggerElementInstances,
  selectCurrentSubcategoryId: () => selectCurrentSubcategoryId,
  selectCurrentTicket: () => selectCurrentTicket,
  selectCurrentTicketBySeat: () => selectCurrentTicketBySeat,
  selectCurrentTicketComboIds: () => selectCurrentTicketComboIds,
  selectCurrentTicketElement: () => selectCurrentTicketElement,
  selectCurrentTicketElementAllowShare: () => selectCurrentTicketElementAllowShare,
  selectCurrentTicketElementComboId: () => selectCurrentTicketElementComboId,
  selectCurrentTicketElementCourseId: () => selectCurrentTicketElementCourseId,
  selectCurrentTicketElementCustomizerShape: () => selectCurrentTicketElementCustomizerShape,
  selectCurrentTicketElementCustomizerType: () => selectCurrentTicketElementCustomizerType,
  selectCurrentTicketElementExitDetailsOnReqModsCompletion: () => selectCurrentTicketElementExitDetailsOnReqModsCompletion,
  selectCurrentTicketElementHasItem: () => selectCurrentTicketElementHasItem,
  selectCurrentTicketElementHasMods: () => selectCurrentTicketElementHasMods,
  selectCurrentTicketElementHasNormalMods: () => selectCurrentTicketElementHasNormalMods,
  selectCurrentTicketElementHasOpenModAdded: () => selectCurrentTicketElementHasOpenModAdded,
  selectCurrentTicketElementId: () => selectCurrentTicketElementId,
  selectCurrentTicketElementIsClosedCheck: () => selectCurrentTicketElementIsClosedCheck,
  selectCurrentTicketElementIsFromDisabledCoursingMenu: () => selectCurrentTicketElementIsFromDisabledCoursingMenu,
  selectCurrentTicketElementIsNotNull: () => selectCurrentTicketElementIsNotNull,
  selectCurrentTicketElementIsShared: () => selectCurrentTicketElementIsShared,
  selectCurrentTicketElementIsTakeout: () => selectCurrentTicketElementIsTakeout,
  selectCurrentTicketElementItemObject: () => selectCurrentTicketElementItemObject,
  selectCurrentTicketElementMenuTypeId: () => selectCurrentTicketElementMenuTypeId,
  selectCurrentTicketElementModifierGroups: () => selectCurrentTicketElementModifierGroups,
  selectCurrentTicketElementNormalMods: () => selectCurrentTicketElementNormalMods,
  selectCurrentTicketElementOnTheFlyCourseNumber: () => selectCurrentTicketElementOnTheFlyCourseNumber,
  selectCurrentTicketElementPrepStations: () => selectCurrentTicketElementPrepStations,
  selectCurrentTicketElementQuantity: () => selectCurrentTicketElementQuantity,
  selectCurrentTicketElementSeating: () => selectCurrentTicketElementSeating,
  selectCurrentTicketElementsNotTriggeredQty: () => selectCurrentTicketElementsNotTriggeredQty,
  selectCurrentTicketElementsReadyToSend: () => selectCurrentTicketElementsReadyToSend,
  selectCurrentTicketIsEmpty: () => selectCurrentTicketIsEmpty,
  selectCurrentTicketItemIds: () => selectCurrentTicketItemIds,
  selectCurrentTicketItemIngredients: () => selectCurrentTicketItemIngredients,
  selectCurrentTicketNormalModsSelectedAreComplete: () => selectCurrentTicketNormalModsSelectedAreComplete,
  selectCurrentTicketSize: () => selectCurrentTicketSize,
  selectDefaultCheckElementsIds: () => selectDefaultCheckElementsIds,
  selectDefaultServiceAreaOptionAndMode: () => selectDefaultServiceAreaOptionAndMode,
  selectDrawerSettlement: () => selectDrawerSettlement,
  selectDrawers: () => selectDrawers,
  selectFilteredCurrentTicketElementModifierGroups: () => selectFilteredCurrentTicketElementModifierGroups,
  selectGlobalQuantity: () => selectGlobalQuantity,
  selectHotButtonsModItemModGroupId: () => selectHotButtonsModItemModGroupId,
  selectIsAllModsEnabled: () => selectIsAllModsEnabled,
  selectIsComboElementActive: () => selectIsComboElementActive,
  selectIsCurrentCheckDefault: () => selectIsCurrentCheckDefault,
  selectIsCurrentComboElementComplete: () => selectIsCurrentComboElementComplete,
  selectIsCurrentElementComplete: () => selectIsCurrentElementComplete,
  selectIsCurrentElementQtyWhenSentComplete: () => selectIsCurrentElementQtyWhenSentComplete,
  selectIsCurrentMenuTypeCoursingEnabled: () => selectIsCurrentMenuTypeCoursingEnabled,
  selectIsCurrentMenuTypeSelectedActive: () => selectIsCurrentMenuTypeSelectedActive,
  selectIsCurrentOrderSeatingMode: () => selectIsCurrentOrderSeatingMode,
  selectIsCurrentTicketElementComplete: () => selectIsCurrentTicketElementComplete,
  selectIsCurrentTicketElementCurrentMenuType: () => selectIsCurrentTicketElementCurrentMenuType,
  selectIsCurrentTicketElementItemCustomizer: () => selectIsCurrentTicketElementItemCustomizer,
  selectIsCurrentTicketElementModifying: () => selectIsCurrentTicketElementModifying,
  selectIsCurrentTicketElementShowIngredients: () => selectIsCurrentTicketElementShowIngredients,
  selectIsCurrentTicketElementSubcategoryCustomizer: () => selectIsCurrentTicketElementSubcategoryCustomizer,
  selectIsCurrentTicketElementToGo: () => selectIsCurrentTicketElementToGo,
  selectIsCurrentTicketElementVoid: () => selectIsCurrentTicketElementVoid,
  selectIsCustomizerScreenByTicketElement: () => selectIsCustomizerScreenByTicketElement,
  selectIsItemsToggled: () => selectIsItemsToggled,
  selectIsMultiSeatEnabled: () => selectIsMultiSeatEnabled,
  selectIsNOModifierTagSelected: () => selectIsNOModifierTagSelected,
  selectIsOmitExitOrderCallEnabled: () => selectIsOmitExitOrderCallEnabled,
  selectIsOrderClosed: () => selectIsOrderClosed,
  selectIsOrderTypeToGo: () => selectIsOrderTypeToGo,
  selectIsPayThroughTablet: () => selectIsPayThroughTablet,
  selectIsPaymentModeActive: () => selectIsPaymentModeActive,
  selectIsPreviewEditEnabled: () => selectIsPreviewEditEnabled,
  selectIsPreviewMode: () => selectIsPreviewMode,
  selectIsSeatSelectorActive: () => selectIsSeatSelectorActive,
  selectIsSeatTagModeEnabled: () => selectIsSeatTagModeEnabled,
  selectIsSimpleModeEnabled: () => selectIsSimpleModeEnabled,
  selectIsTicketFilteredBySeat: () => selectIsTicketFilteredBySeat,
  selectIsVAOFocused: () => selectIsVAOFocused,
  selectLocationCategoryBucket: () => selectLocationCategoryBucket,
  selectLocationComboBucket: () => selectLocationComboBucket,
  selectLocationItemBucket: () => selectLocationItemBucket,
  selectLocationMenuTypeBucket: () => selectLocationMenuTypeBucket,
  selectLocationModifierGroups: () => selectLocationModifierGroups,
  selectLocationModifierItems: () => selectLocationModifierItems,
  selectLocationSubcategoryBucket: () => selectLocationSubcategoryBucket,
  selectLowestPriceInActiveItems: () => selectLowestPriceInActiveItems,
  selectMaxSortPriorityInAllModsSelected: () => selectMaxSortPriorityInAllModsSelected,
  selectMenuTypeCombosSet: () => selectMenuTypeCombosSet,
  selectMenuTypeDropdownList: () => selectMenuTypeDropdownList,
  selectMenuTypeItemsSet: () => selectMenuTypeItemsSet,
  selectModifierItemHotButtonId: () => selectModifierItemHotButtonId,
  selectModifyingSentTicketElementId: () => selectModifyingSentTicketElementId,
  selectOmitCheckAndPaymentChecksToCloseOrder: () => selectOmitCheckAndPaymentChecksToCloseOrder,
  selectOrderComboElementSeats: () => selectOrderComboElementSeats,
  selectOrderNumberOfSeatsServed: () => selectOrderNumberOfSeatsServed,
  selectOrderNumberPrinterId: () => selectOrderNumberPrinterId,
  selectOrderOrCurrentCheck: () => selectOrderOrCurrentCheck,
  selectOrderSearchResults: () => selectOrderSearchResults,
  selectOrderSearchResultsOrders: () => selectOrderSearchResultsOrders,
  selectOrderSeatOnePosition: () => selectOrderSeatOnePosition,
  selectOrderSeatTags: () => selectOrderSeatTags,
  selectOrderTicketElementSeats: () => selectOrderTicketElementSeats,
  selectOrders: () => selectOrders,
  selectOverlaySelected: () => selectOverlaySelected,
  selectPaymentMethod: () => selectPaymentMethod,
  selectPaymentMethodList: () => selectPaymentMethodList,
  selectPaymentNavigationCheckId: () => selectPaymentNavigationCheckId,
  selectPaymentNavigationRefundAction: () => selectPaymentNavigationRefundAction,
  selectPaymentOption: () => selectPaymentOption,
  selectPromptForItemPriceName: () => selectPromptForItemPriceName,
  selectRegisterBarCode: () => selectRegisterBarCode,
  selectRegisterLastVisitedScreen: () => selectRegisterLastVisitedScreen,
  selectRegisterNavigation: () => selectRegisterNavigation,
  selectRegisterNavigationMenuType: () => selectRegisterNavigationMenuType,
  selectRegisterNavigationPromptForPriceItemId: () => selectRegisterNavigationPromptForPriceItemId,
  selectRegisterNavigationTableId: () => selectRegisterNavigationTableId,
  selectSectionsCompletedSet: () => selectSectionsCompletedSet,
  selectSelectedDrawer: () => selectSelectedDrawer,
  selectSelectedDrawerAction: () => selectSelectedDrawerAction,
  selectSelectedDrawerActionData: () => selectSelectedDrawerActionData,
  selectSelectedIngredients: () => selectSelectedIngredients,
  selectSelectedMenu: () => selectSelectedMenu,
  selectSelectedModifierGroups: () => selectSelectedModifierGroups,
  selectSelectedOrderSearchResult: () => selectSelectedOrderSearchResult,
  selectShowTicketElementModifierGroupSearchBar: () => selectShowTicketElementModifierGroupSearchBar,
  selectSpecialModTagsMetaData: () => selectSpecialModTagsMetaData,
  selectTagList: () => selectTagList,
  selectTicketElementById: () => selectTicketElementById,
  selectTicketElementsReadyForKitchen: () => selectTicketElementsReadyForKitchen,
  selectTicketItemMenuTypeId: () => selectTicketItemMenuTypeId,
  selectTriggeringManuallyDisabled: () => selectTriggeringManuallyDisabled,
  selectUnassignedCheckHasValidPayments: () => selectUnassignedCheckHasValidPayments,
  selectVAOData: () => selectVAOData,
  selectVAOFilter: () => selectVAOFilter,
  selectVAOIsMultiselect: () => selectVAOIsMultiselect,
  selectVAOSelectedCheckId: () => selectVAOSelectedCheckId,
  selectVAOSelectedOrders: () => selectVAOSelectedOrders
});

// src/helpers/register/reducerHelpers/seating.ts
var TOGGLE_SEATS_CASES = /* @__PURE__ */ ((TOGGLE_SEATS_CASES2) => {
  TOGGLE_SEATS_CASES2[TOGGLE_SEATS_CASES2["SELECT"] = 0] = "SELECT";
  TOGGLE_SEATS_CASES2[TOGGLE_SEATS_CASES2["DESELECT_SEAT"] = 1] = "DESELECT_SEAT";
  TOGGLE_SEATS_CASES2[TOGGLE_SEATS_CASES2["UPDATE_QUANTITY"] = 2] = "UPDATE_QUANTITY";
  TOGGLE_SEATS_CASES2[TOGGLE_SEATS_CASES2["REPLACE_SEAT"] = 3] = "REPLACE_SEAT";
  return TOGGLE_SEATS_CASES2;
})(TOGGLE_SEATS_CASES || {});
var deleteNoSeatKey = (element) => {
  if (element.seating[NO_SEAT_ID])
    delete element.seating[NO_SEAT_ID];
};
var shareTicketElement = (ticketElement, splitType) => {
  ticketElement.isShared = splitType;
};
var unShareTicketElement = (ticketElement, isSeatingModeEnabled) => {
  ticketElement.isShared = null;
  if (isSeatingModeEnabled)
    return;
  const newQty = Object.values(ticketElement.seating).reduce(
    (acc, curr) => acc + (curr ? 1 : 0),
    0
  );
  ticketElement.quantity = newQty;
  ticketElement.seating = { [NO_SEAT_ID]: newQty };
};
var toggleSeat = (ticketElement, seatId) => {
  const seats = ticketElement.seating;
  if (seats[seatId]) {
    delete seats[seatId];
  } else {
    seats[seatId] = 1;
  }
};
var setSeatValuesOnShareToggle = (ticketElement, isShared = false, isSeatingModeEnabled = false) => {
  if (!isShared) {
    ticketElement.seating = {};
    if (isSeatingModeEnabled)
      ticketElement.quantity = 0;
    return;
  }
  if (!isSeatingModeEnabled)
    return;
  if (ticketElement.seating[FOR_TABLE_SEAT_ID]) {
    delete ticketElement.seating[FOR_TABLE_SEAT_ID];
  }
  const seatIds = Object.entries(ticketElement.seating).filter(([, seat]) => seat).map(([id]) => Number(id));
  const seatCount = seatIds.length;
  const seatValue = (ticketElement.quantity || 1) / seatCount;
  seatIds.forEach((_seatId) => {
    ticketElement.seating[_seatId] = seatValue;
  });
};
var deleteSeatQuantity = (ticketElement, seatId) => {
  const seats = ticketElement.seating;
  if (seats[seatId]) {
    ticketElement.quantity && (ticketElement.quantity -= seats[seatId]);
    delete seats[seatId];
  }
};
var incrementSeatQuantity = (ticketElement, seatId, by = 1) => {
  const seating = ticketElement.seating;
  if (!seating) {
    ticketElement.seating = { [seatId]: by };
  } else {
    seating[seatId] = (seating[seatId] || 0) + by;
  }
  ticketElement.quantity = Math.round(
    Object.values(seating).reduce((acc, curr) => acc + (curr || 0), 0)
  );
};
var setSeatQuantity = (ticketElement, seatId, quantity) => {
  const seating = ticketElement.seating;
  if (!seating) {
    ticketElement.seating = { [seatId]: quantity };
  } else {
    seating[seatId] = quantity;
  }
  ticketElement.quantity = Math.round(
    Object.values(seating).reduce((acc, curr) => acc + (curr || 0), 0)
  );
};
var setSingleSeatQuantity = (ticketElement, seatId, quantity) => {
  ticketElement.seating = { [seatId]: quantity };
  ticketElement.quantity = quantity;
};
var decrementSeatQuantity = (ticketElement, seatId, by = 1) => {
  const seating = ticketElement.seating;
  if (!seating)
    return;
  if (seating[seatId] - by <= 0) {
    deleteSeatQuantity(ticketElement, seatId);
    return;
  }
  seating[seatId] = (seating[seatId] || 0) - by;
  ticketElement.quantity = Math.round(
    Object.values(seating).reduce((acc, curr) => acc + (curr || 0), 0)
  );
};
var toggleSeatQuantity = (ticketElement, seatId, quantity, isMultiSeatEnabled) => {
  const seatsSelected = Object.keys(ticketElement.seating).length;
  if (isMultiSeatEnabled) {
    if (ticketElement.seating[seatId] && !quantity) {
      deleteSeatQuantity(ticketElement, seatId);
      return 1 /* DESELECT_SEAT */;
    }
    const increment = (quantity || 1) - (ticketElement.seating[seatId] || 0);
    incrementSeatQuantity(ticketElement, seatId, increment);
    return 2 /* UPDATE_QUANTITY */;
  }
  if (seatsSelected > 1) {
    if (ticketElement.seating[seatId] && !quantity) {
      deleteSeatQuantity(ticketElement, seatId);
      return 1 /* DESELECT_SEAT */;
    } else {
      const increment = (quantity || 1) - (ticketElement.seating[seatId] || 0);
      incrementSeatQuantity(ticketElement, seatId, increment);
      return 2 /* UPDATE_QUANTITY */;
    }
  } else if (seatsSelected === 1) {
    const newQuantity = quantity || ticketElement.quantity || 1;
    if (!ticketElement.seating[seatId]) {
      setSingleSeatQuantity(ticketElement, seatId, newQuantity);
      return 3 /* REPLACE_SEAT */;
    } else if (!quantity) {
      deleteSeatQuantity(ticketElement, seatId);
      return 1 /* DESELECT_SEAT */;
    } else if (quantity) {
      setSingleSeatQuantity(ticketElement, seatId, newQuantity);
      return 2 /* UPDATE_QUANTITY */;
    }
  } else {
    setSingleSeatQuantity(
      ticketElement,
      seatId,
      quantity || ticketElement.quantity || 1
    );
    return 2 /* UPDATE_QUANTITY */;
  }
};

// src/helpers/register/seating.ts
var getSeatName = (t2, seatId) => {
  switch (seatId) {
    case NO_SEAT_ID:
      return t2("register.item.modifierGroups.seats.noSeat");
    case FOR_TABLE_SEAT_ID:
      return t2("register.item.modifierGroups.seats.forTable");
    case TO_GO_SEAT_ID:
      return t2("register.item.modifierGroups.seats.toGo");
    default:
      return t2("register.seating.seatLabel", { seatId });
  }
};
var filterTicketElementsBySeat = (ticket, currentSeat) => filterTicketBySeatSelected(
  Object.values(ticket).filter(isTicketElementNotAssociatedWithCombo),
  currentSeat
);
var zipCombosWithItems = (ticket, combos) => {
  if (!combos)
    return [];
  const mergeComboWithItemsFn = mergeComboWithItemsFunctionGenerator(ticket);
  return Object.values(combos).map(mergeComboWithItemsFn);
};
var mergeComboWithItemsFunctionGenerator = (ticket) => (comboElement) => {
  const itemGroupsSelectedWithTicketItem = Object.values(
    comboElement.itemGroupsSelected
  ).map((itemGroupSelected) => __spreadProps(__spreadValues({}, itemGroupSelected), {
    item: itemGroupSelected.ticketElementId ? ticket[itemGroupSelected.ticketElementId] : null
  })).reduce(
    (acc, itemGroupSelected) => __spreadProps(__spreadValues({}, acc), {
      [`${itemGroupSelected.itemGroupId}-${itemGroupSelected.instanceId}`]: itemGroupSelected
    }),
    {}
  );
  return __spreadProps(__spreadValues({}, comboElement), {
    itemGroupsSelected: itemGroupsSelectedWithTicketItem
  });
};
var filterCombosBySeatSelected = (combos, currentSeat) => {
  return filterTicketBySeatSelected(Object.values(combos), currentSeat);
};
var filterTicketBySeatSelected = (ticket, currentSeat) => {
  if (currentSeat === ALL_SEATS)
    return ticket;
  return ticket.filter(
    (ticketElement) => Object.keys(ticketElement.seating).map((seatKey) => Number(seatKey)).includes(currentSeat)
  );
};
var isTicketElementIdInSeatPage = (ticket, ticketElementId, currentSeat, activeItems) => {
  if (currentSeat === ALL_SEATS)
    return { ticketElementId, activeItems };
  const seatKeys = currentSeat === FOR_TABLE_SEAT_ID ? 0 : currentSeat;
  return ticketElementId === null ? { ticketElementId: null, activeItems: [] } : Object.values(ticket).filter(
    (ticketElement) => Object.keys(ticketElement.seating).map((seatKey) => Number(seatKey)).includes(seatKeys)
  ).some(
    (ticketElement) => ticketElementId === getTicketElementId(ticketElement)
  ) ? { ticketElementId, activeItems: [ticketElementId] } : { ticketElementId: null, activeItems: [] };
};
var calcTotalAmountPerSeat = (ticketElements) => ticketElements.map(calTotalItemPricePerSeat).reduce((total, item) => total + item, 0);
var calTotalItemPricePerSeat = (ticketElement) => {
  if (ticketElement.isVoided)
    return 0;
  return ticketElement.totalPriceWithDiscountsSpecialsNotTaxes;
};

// src/helpers/register/checks/checks_old.ts
var roundToCentesimal = (num) => Math.round((num + Number.EPSILON) * 100) / 100;
var updateCheckBalanceDue = (check) => {
  check.balanceDue = roundToCentesimal(check.total - check.balancePaid);
};
var updateCheckElementPrice = (priceDelta, check, checkElement) => {
  if (!priceDelta)
    return;
  check.subtotal = roundToCentesimal(check.subtotal + priceDelta);
  check.total = roundToCentesimal(check.total + priceDelta);
  updateCheckBalanceDue(check);
  checkElement.price = roundToCentesimal(checkElement.price + priceDelta);
};
var updateCheckElementEachPrice = (eachPriceDelta, _, checkElement) => {
  if (!eachPriceDelta)
    return;
  checkElement.eachPrice = roundToCentesimal(
    checkElement.eachPrice + eachPriceDelta
  );
};
var updateCheckElementDiscount = (discountDelta, check, checkElement) => {
  if (!discountDelta)
    return;
  check.totalDiscounts = roundToCentesimal(
    check.totalDiscounts + discountDelta
  );
  check.totalItemDiscounts = roundToCentesimal(
    check.totalItemDiscounts + discountDelta
  );
  checkElement.discount = roundToCentesimal(
    checkElement.discount + discountDelta
  );
  check.total = roundToCentesimal(check.total - discountDelta);
  updateCheckBalanceDue(check);
};
var updateCheckElementSpecial = (scpecialDelta, check, checkElement) => {
  if (!scpecialDelta)
    return;
  check.totalDiscounts = roundToCentesimal(
    check.totalDiscounts + scpecialDelta
  );
  check.totalSpecialDiscounts = roundToCentesimal(
    check.totalSpecialDiscounts + scpecialDelta
  );
  checkElement.specialAmount = roundToCentesimal(
    checkElement.specialAmount + scpecialDelta
  );
  check.total = roundToCentesimal(check.total - scpecialDelta);
  updateCheckBalanceDue(check);
};
var updateCheckElementTax = (taxDelta, check, checkElement) => {
  if (!taxDelta)
    return;
  check.tax = roundToCentesimal(check.tax + taxDelta);
  check.total = roundToCentesimal(check.total + taxDelta);
  updateCheckBalanceDue(check);
  checkElement.tax = roundToCentesimal(checkElement.tax + taxDelta);
};
var updateCheckElementSeats = (newSeats, _, checkElement) => {
  if (!newSeats)
    return;
  checkElement.seats = newSeats;
};
var updateCheckElementIsShared = (isShared, _, checkElement) => {
  checkElement.isShared = isShared;
};
var updateCheckElementItemCount = (countDelta, check, checkElement) => {
  if (!countDelta)
    return;
  checkElement.itemCount = roundToCentesimal(
    checkElement.itemCount + countDelta
  );
  check.itemCount = roundToCentesimal(
    Object.values(check.checkElements).reduce((acc, element) => {
      return acc + element.itemCount;
    }, 0)
  );
};
var updateCheckElementName = (newName, _, checkElement) => {
  if (checkElement.name === newName)
    return;
  checkElement.name = newName;
};
var updateCheckElementItemId = (checkElement, itemId) => {
  if (!itemId)
    return;
  checkElement.itemId = itemId;
};
var updateCheckElementDisplayFraction = (checkElement) => {
  checkElement.displayFraction = simplifyFraction(
    checkElement.quantity * checkElement.splitGrouped,
    checkElement.splitWays
  );
};
var updateDisplayCheckElementDisplayFraction = (displayCheckElement) => {
  displayCheckElement.displayFraction = simplifyFraction(
    displayCheckElement.splitGrouped,
    displayCheckElement.splitWays
  );
};
var updateDisplayCheckElementTotalQty = (displayCheckElement) => {
  displayCheckElement.totalQty = 0;
};
var updateCheckElementOld = (order, check, checkElement, deltas) => {
  updateCheckElementItemCount(deltas.itemCount, check, checkElement);
  updateCheckElementName(deltas.name, check, checkElement);
  updateCheckElementSeats(deltas.seats, check, checkElement);
  updateCheckElementEachPrice(deltas.eachPrice, check, checkElement);
  updateCheckElementPrice(deltas.price, check, checkElement);
  updateCheckElementDiscount(deltas.discount, check, checkElement);
  updateCheckElementSpecial(deltas.specialAmount, check, checkElement);
  updateCheckElementTax(deltas.tax, check, checkElement);
  updateCheckElementIsShared(deltas.isShared, check, checkElement);
  updateCheckElementDisplayFraction(checkElement);
  updateCheckElementItemId(checkElement, deltas.itemId);
};
var updateCheckOrderDiscounts2 = (check, orderDiscountsDelta) => {
  if (!orderDiscountsDelta)
    return;
  check.totalOrderDiscounts += orderDiscountsDelta;
  check.totalDiscounts += orderDiscountsDelta;
  check.total -= orderDiscountsDelta;
  updateCheckBalanceDue(check);
};
var getCheckElement = (order, checkId, checkElementId) => {
  var _a, _b;
  return (_b = (_a = order.checks[checkId]) == null ? void 0 : _a.checkElements) == null ? void 0 : _b[checkElementId];
};
var generateCheckElements = (order, elementId, isCombo) => {
  var _a, _b, _c, _d;
  const element = isCombo ? (_a = order.combos) == null ? void 0 : _a[elementId] : (_b = order.ticketElements) == null ? void 0 : _b[elementId];
  const checkId = order.defaultCheckId;
  if (!element)
    return;
  let elementToCheckElementsId = generateTabletGeneratedId();
  let itemId = TICKET_OPEN_ITEM_TYPE_ID;
  if (isCombo) {
    elementToCheckElementsId = element.tabletGeneratedId || elementToCheckElementsId;
    element.comboElementToCheckElementsId = elementToCheckElementsId;
    itemId = ((_c = element.comboObj) == null ? void 0 : _c.comboId) || -1;
  } else {
    elementToCheckElementsId = element.tabletGeneratedId || elementToCheckElementsId;
    element.ticketElementToCheckElementsId = elementToCheckElementsId;
    itemId = ((_d = element.itemObj) == null ? void 0 : _d.itemId) || TICKET_OPEN_ITEM_TYPE_ID;
  }
  const check = order.checks[checkId];
  if (!check)
    return;
  const newTicketToCheckElements = [];
  element.instanceIds.forEach((instanceId) => {
    var _a2, _b2, _c2, _d2;
    const itemCount = 1;
    const newCheckElement = createCheckElement({
      splitGrouped: 1,
      splitWays: 1,
      [isCombo ? "comboElementId" : "ticketElementId"]: elementId,
      ticketElementToCheckElementsId: elementToCheckElementsId,
      instanceId,
      checkId,
      quantity: 1,
      itemCount,
      itemId,
      name: isCombo ? (_b2 = (_a2 = element.comboObj) == null ? void 0 : _a2.name) != null ? _b2 : "" : (_d2 = (_c2 = element.itemObj) == null ? void 0 : _c2.name) != null ? _d2 : ""
    });
    const checkElementId = newCheckElement.tabletGeneratedId;
    check.checkElements[checkElementId] = newCheckElement;
    check.itemCount += itemCount;
    newTicketToCheckElements.push(
      createTicketElementToCheckElementObject({
        checkId,
        checkElementId,
        instanceId
      })
    );
  });
  order.ticketElementToCheckElements[elementToCheckElementsId] = newTicketToCheckElements;
};
var addElementToChecks = (order, elementId, isCombo, instanceId, seats) => {
  var _a, _b, _c, _d;
  const element = isCombo ? (_a = order.combos) == null ? void 0 : _a[elementId] : (_b = order.ticketElements) == null ? void 0 : _b[elementId];
  const checkId = order.defaultCheckId;
  if (!element)
    return;
  let elementToCheckElementsId = generateTabletGeneratedId();
  let itemId = TICKET_OPEN_ITEM_TYPE_ID;
  if (isCombo) {
    elementToCheckElementsId = element.comboElementToCheckElementsId || elementToCheckElementsId;
    element.comboElementToCheckElementsId = elementToCheckElementsId;
    itemId = ((_c = element.comboObj) == null ? void 0 : _c.comboId) || -1;
  } else {
    elementToCheckElementsId = element.ticketElementToCheckElementsId || elementToCheckElementsId;
    element.ticketElementToCheckElementsId = elementToCheckElementsId;
    itemId = ((_d = element.itemObj) == null ? void 0 : _d.itemId) || TICKET_OPEN_ITEM_TYPE_ID;
  }
  const check = order.checks[checkId];
  if (!check)
    return;
  const itemCount = 1;
  const newCheckElement = createCheckElement({
    splitGrouped: 1,
    splitWays: 1,
    [isCombo ? "comboElementId" : "ticketElementId"]: elementId,
    ticketElementToCheckElementsId: elementToCheckElementsId,
    checkId,
    instanceId,
    itemCount,
    quantity: 1,
    itemId,
    seats: seats || {}
  });
  const checkElementId = newCheckElement.tabletGeneratedId;
  check.checkElements[checkElementId] = newCheckElement;
  check.itemCount += itemCount;
  const newTicketElementToCheckElement = createTicketElementToCheckElementObject({
    checkId,
    checkElementId,
    instanceId
  });
  if (order.ticketElementToCheckElements[elementToCheckElementsId]) {
    order.ticketElementToCheckElements[elementToCheckElementsId].push(
      newTicketElementToCheckElement
    );
  } else {
    order.ticketElementToCheckElements[elementToCheckElementsId] = [
      newTicketElementToCheckElement
    ];
  }
  return newCheckElement;
};
var deleteCheckElementAndUpdateCheckOld = (order, check, checkElement) => {
  if (!checkElement)
    return;
  updateCheckElementOld(order, check, checkElement, {
    name: "",
    itemCount: -checkElement.itemCount,
    discount: -checkElement.discount,
    specialAmount: -checkElement.specialAmount,
    eachPrice: -checkElement.eachPrice,
    price: -checkElement.price,
    quantity: -checkElement.quantity,
    tax: -checkElement.tax,
    seats: {},
    isShared: false
  });
  check.checkElements = deleteCheckElementsFromCheck(check, [
    getCheckElementId(checkElement)
  ]);
};
var voidCheckElement = (order, check, checkElement) => {
  if (!check || !checkElement || checkElement.isVoided)
    return;
  check.itemCount -= checkElement.quantity;
  check.totalDiscounts -= checkElement.discount;
  check.totalItemDiscounts -= checkElement.discount;
  check.tax -= checkElement.tax;
  check.subtotal -= checkElement.price;
  check.total += checkElement.discount - checkElement.tax - checkElement.price;
  updateCheckBalanceDue(check);
  checkElement.isVoided = true;
};
var unVoidCheckElement = (order, check, checkElement) => {
  if (!check || !checkElement || !checkElement.isVoided)
    return;
  check.itemCount += checkElement.quantity;
  check.totalDiscounts += checkElement.discount;
  check.totalItemDiscounts += checkElement.discount;
  check.tax += checkElement.tax;
  check.subtotal += checkElement.price;
  check.total -= checkElement.discount - checkElement.tax - checkElement.price;
  updateCheckBalanceDue(check);
  checkElement.isVoided = false;
};
var removeComboItemFromCheckElement = (checkElement, ticketElementId) => {
  delete checkElement.comboItemNames[ticketElementId];
};
var addComboItemToCheckElement = (order, checkElement, ticketElementId) => {
  var _a, _b, _c;
  let ticketElementCheckName = "";
  if (order.ticketElements) {
    const ticketElement = order.ticketElements[ticketElementId];
    const menuTypeId = !ticketElement.isOpenItem ? ticketElement.menuTypeId : 0;
    ticketElementCheckName = (_c = (_b = (_a = ticketElement == null ? void 0 : ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[menuTypeId != null ? menuTypeId : -1]) == null ? void 0 : _b.checkName) != null ? _c : "";
  }
  checkElement.comboItemNames[ticketElementId] = ticketElementCheckName;
};
var distributeCurrencyByCheckPriceForPrice = (elements, totalCurrency, checksCurrentTotal) => {
  var _a, _b;
  if (totalCurrency === 0)
    return elements;
  const sortElementsByCheck = (_elements) => {
    const elementsByCheck = {};
    _elements.forEach((element) => {
      const { checkId } = element;
      if (!elementsByCheck[checkId])
        elementsByCheck[checkId] = [];
      elementsByCheck[checkId].push(element);
    });
    Object.values(elementsByCheck).forEach((checkElements) => {
      checkElements.sort((a, b) => a.price - b.price);
    });
    const sortedElements = [];
    const checkIds = Object.values(elementsByCheck).sort((a, b) => {
      let checkASum = a.reduce((acc, element) => acc + element.price, 0);
      let checkBSum = b.reduce((acc, element) => acc + element.price, 0);
      if (checksCurrentTotal && Object.keys(checksCurrentTotal).length > 0) {
        const checkAId = a[0].checkId;
        const checkBId = b[0].checkId;
        checkASum += checksCurrentTotal[checkAId] || 0;
        checkBSum += checksCurrentTotal[checkBId] || 0;
      }
      checkASum = roundToCentesimal(checkASum);
      checkBSum = roundToCentesimal(checkBSum);
      return checkASum - checkBSum;
    }).map((checkElements) => checkElements[0].checkId);
    let checkIndex = 0;
    while (sortedElements.length < _elements.length) {
      const checkId = checkIds[checkIndex];
      checkIndex = (checkIndex + 1) % checkIds.length;
      const checkElements = elementsByCheck[checkId];
      const element = checkElements.shift();
      if (!element)
        continue;
      sortedElements.push(element);
    }
    return sortedElements;
  };
  const valueMap = sortElementsByCheck(elements).map((element) => {
    const { fraction } = element;
    const factor = 100 * fraction.numerator / fraction.denominator;
    const newValueCents = Math.floor(factor * totalCurrency);
    const assignedValue = newValueCents / 100;
    if (checksCurrentTotal && checksCurrentTotal[element.checkId]) {
      checksCurrentTotal[element.checkId] += assignedValue;
    }
    return __spreadProps(__spreadValues({}, element), {
      assignedValue
    });
  });
  const remainder = roundToCentesimal(
    (totalCurrency - roundToCentesimal(
      valueMap.reduce((acc, element) => acc + element.assignedValue, 0)
    )) * 100
  );
  if (checksCurrentTotal) {
    Object.keys(checksCurrentTotal).forEach((checkId) => {
      checksCurrentTotal[checkId] = roundToCentesimal(
        checksCurrentTotal[checkId]
      );
    });
  }
  let newElementIndex = 0;
  for (let i = 0; i < remainder; i += 1) {
    if (((_a = valueMap[newElementIndex]) == null ? void 0 : _a.assignedValue) >= ((_b = valueMap[newElementIndex]) == null ? void 0 : _b.eachPrice)) {
      newElementIndex += 1;
      newElementIndex %= valueMap == null ? void 0 : valueMap.length;
    }
    if (valueMap[newElementIndex])
      valueMap[newElementIndex].assignedValue += 0.01;
    newElementIndex += 1;
    newElementIndex %= valueMap.length;
  }
  return valueMap;
};
var distributeCurrencyByCheckPrice = (elements, totalCurrency, special) => {
  if (totalCurrency === 0)
    return elements;
  const sortElementsByCheck = (_elements) => {
    const elementsByCheck = {};
    _elements.forEach((element) => {
      const { checkId } = element;
      if (!elementsByCheck[checkId])
        elementsByCheck[checkId] = [];
      elementsByCheck[checkId].push(element);
    });
    const sortedElements = [];
    const checkIds = Object.values(elementsByCheck).sort((a, b) => {
      let checkASum = a.reduce((acc, element) => acc + element.price, 0);
      let checkBSum = b.reduce((acc, element) => acc + element.price, 0);
      checkASum = roundToCentesimal(checkASum);
      checkBSum = roundToCentesimal(checkBSum);
      return special ? checkBSum - checkASum : checkASum - checkBSum;
    }).map((checkElements) => checkElements[0].checkId);
    Object.values(elementsByCheck).forEach((checkElements) => {
      checkElements.sort(
        (a, b) => special ? b.price - a.price : a.price - b.price
      );
    });
    let checkIndex = 0;
    while (sortedElements.length < _elements.length) {
      const checkId = checkIds[checkIndex];
      checkIndex = (checkIndex + 1) % checkIds.length;
      const checkElements = elementsByCheck[checkId];
      const element = checkElements.shift();
      if (!element)
        continue;
      sortedElements.push(element);
    }
    return sortedElements;
  };
  const valueMap = sortElementsByCheck(elements).map((element) => {
    const { fraction } = element;
    const factor = 100 * fraction.numerator / fraction.denominator;
    const newValueCents = Math.floor(factor * totalCurrency);
    const assignedValue = newValueCents / 100;
    return __spreadProps(__spreadValues({}, element), {
      assignedValue
    });
  });
  const remainder = roundToCentesimal(
    (totalCurrency - roundToCentesimal(
      valueMap.reduce((acc, element) => acc + element.assignedValue, 0)
    )) * 100
  );
  let newElementIndex = 0;
  for (let i = 0; i < remainder; i += 1) {
    if (!valueMap[newElementIndex])
      continue;
    valueMap[newElementIndex].assignedValue += 0.01;
    newElementIndex += 1;
    newElementIndex %= valueMap.length;
  }
  return valueMap;
};
var distributeCurrencyProportionally = (elements, totalCurrency, reverse) => {
  const totalCurrentValue = elements.reduce((acc, element) => acc + element.currentValue, 0) || 1;
  const sortFunction = reverse ? (a, b) => b.currentValue - a.currentValue : (a, b) => a.currentValue - b.currentValue;
  const valueMap = elements.sort(sortFunction).map((element) => {
    const { currentValue } = element;
    const factor = 100 * currentValue / totalCurrentValue;
    const newValueCents = Math.floor(factor * totalCurrency);
    const assignedValue = newValueCents / 100;
    return __spreadProps(__spreadValues({}, element), { assignedValue });
  });
  const remainder = roundToCentesimal(
    (totalCurrency - roundToCentesimal(
      valueMap.reduce((acc, element) => acc + element.assignedValue, 0)
    )) * 100
  );
  let newElementIndex = 0;
  for (let i = 0; i < remainder; i += 1) {
    valueMap[newElementIndex].assignedValue += 0.01;
    newElementIndex += 1;
    newElementIndex %= valueMap.length;
  }
  return valueMap;
};
var isCheckElementSplitBySeat = (order, checkElementMap) => {
  if (checkElementMap.length < 2)
    return false;
  const { checkId: firstCheckId, checkElementId: firstCheckElementId } = checkElementMap[0];
  const firstCheckElement = getCheckElement(
    order,
    firstCheckId,
    firstCheckElementId
  );
  if (!firstCheckElement)
    return false;
  const firstCheckElementSeats = firstCheckElement.seats;
  return checkElementMap.some(({ checkId, checkElementId }) => {
    const checkElement = getCheckElement(order, checkId, checkElementId);
    if (!checkElement)
      return false;
    return !isEqual(checkElement.seats, firstCheckElementSeats);
  });
};
var addComboToChecks = (order, comboElementId, instanceId, seats) => addElementToChecks(order, comboElementId, true, instanceId, seats);
var generateCheckElementsForElement = (order, ticketElementId, isCombo) => generateCheckElements(order, ticketElementId, isCombo);
var addTicketElementToChecks = (order, ticketElementId, instanceId, seats) => addElementToChecks(order, ticketElementId, false, instanceId, seats);
var voidCheckItemElement = (setVoid, order, ticketElementId) => {
  var _a, _b;
  const checkElementsId = (_b = (_a = order.ticketElements) == null ? void 0 : _a[ticketElementId]) == null ? void 0 : _b.ticketElementToCheckElementsId;
  const checkElements = order.ticketElementToCheckElements[checkElementsId || -1];
  Object.values(checkElements || {}).forEach(({ checkId, checkElementId }) => {
    const check = order.checks[checkId];
    const checkElement = getCheckElement(order, checkId, checkElementId);
    if (!check || !checkElement)
      return;
    if (setVoid) {
      voidCheckElement(order, check, checkElement);
    } else {
      unVoidCheckElement(order, check, checkElement);
    }
  });
};
var mapCheckElementToQuantity = (order, element, elementToCheckElementsMap) => {
  const elementSeats = element.seating || {};
  const elementIsShared = element.isShared || false;
  if (!isCheckElementSplitBySeat(order, elementToCheckElementsMap)) {
    return {
      isSplitBySeat: false,
      elements: elementToCheckElementsMap.map(
        ({ checkId, checkElementId, instanceId }) => {
          return {
            checkId,
            checkElementId,
            quantity: 1,
            seats: elementSeats,
            isShared: elementIsShared,
            isNew: false,
            instanceId
          };
        }
      )
    };
  }
  const oldSeatIds = new Set(
    elementToCheckElementsMap.reduce(
      (acc, { checkId, checkElementId }) => {
        const checkElement = getCheckElement(order, checkId, checkElementId);
        if (!checkElement)
          return acc;
        return [...acc, ...Object.keys(checkElement.seats)];
      },
      []
    )
  );
  const newSeatIds = new Set(
    Object.entries(elementSeats).filter(([, quantity]) => quantity).map(([seatId]) => seatId)
  );
  const addedSeatIds = /* @__PURE__ */ new Set();
  newSeatIds.forEach((newSeatId) => {
    if (!oldSeatIds.has(newSeatId))
      addedSeatIds.add(newSeatId);
  });
  const updatedElements = elementToCheckElementsMap.map(({ checkId, checkElementId, instanceId }) => {
    const checkElement = getCheckElement(order, checkId, checkElementId);
    if (!checkElement)
      return;
    const checkElementSeats = Object.keys(checkElement.seats || {});
    const newCheckElementSeats = checkElementSeats.map(Number).reduce((acc, seatId) => {
      const elementSeatQuantity = element.seating[seatId] || 0;
      acc[seatId] = elementSeatQuantity;
      return acc;
    }, {});
    const newCheckElementQuantity = isEmpty(newCheckElementSeats) ? element.quantity : Object.values(newCheckElementSeats).reduce(
      (acc, seatQuantity) => acc + seatQuantity,
      0
    );
    return {
      checkId,
      checkElementId,
      quantity: newCheckElementQuantity,
      seats: newCheckElementSeats,
      isShared: elementIsShared,
      isNew: false,
      instanceId
    };
  }).filter(Boolean);
  const addedElements = [...addedSeatIds].map((seatId) => {
    const checkElementId = generateTabletGeneratedId();
    const checkId = order.defaultCheckId;
    const seatQuantity = elementSeats[Number(seatId)] || 0;
    return {
      checkId,
      checkElementId,
      quantity: seatQuantity,
      seats: { [seatId]: seatQuantity },
      isShared: elementIsShared,
      isNew: true
    };
  });
  return {
    isSplitBySeat: true,
    elements: [...updatedElements, ...addedElements]
  };
};
var findDisplayCheckElementId = (displayCheckElements, checkElement) => {
  let displayElementId = null;
  const checkElementId = getCheckElementId(checkElement);
  for (const displayCheckElement of displayCheckElements) {
    if (displayCheckElement.rolledUpCheckElements[checkElementId]) {
      return displayCheckElement.tabletGeneratedId;
    } else if (displayCheckElement.itemId === checkElement.itemId && (displayCheckElement.ticketElementId === checkElement.ticketElementId || displayCheckElement.comboElementId === checkElement.comboElementId)) {
      displayElementId = displayCheckElement.tabletGeneratedId;
    }
  }
  return displayElementId;
};
var removeCheckElementFromDisplayCheckElement = (order, displayCheckElementId, checkElement) => {
  const checkElementId = getCheckElementId(checkElement);
  const checkId = getCheckIdByCheckElementId(order, checkElementId);
  if (!checkId)
    return;
  if (!order.checks[checkId].displayCheckElements[displayCheckElementId])
    return;
  delete order.checks[checkId].displayCheckElements[displayCheckElementId].rolledUpCheckElements[checkElementId];
  updateDisplayCheckElementTotals(
    order.checks[checkId].displayCheckElements[displayCheckElementId],
    {
      price: -checkElement.price,
      discount: -checkElement.discount,
      specialAmount: -checkElement.specialAmount,
      splitGrouped: -checkElement.splitGrouped,
      splitWays: checkElement.splitWays,
      quantity: -1
    }
  );
  if (isEmpty(
    order.checks[checkId].displayCheckElements[displayCheckElementId].rolledUpCheckElements
  )) {
    order.checks[checkId].displayCheckElements = deleteDisplayCheckElementFromCheck(
      order.checks[checkId],
      displayCheckElementId
    );
  }
};
var updateDisplayCheckElementTotals = (displayCheckElement, deltas) => {
  displayCheckElement.totalPrice += deltas.price;
  displayCheckElement.totalDiscount += deltas.discount;
  displayCheckElement.totalSpecialAmount += deltas.specialAmount;
  displayCheckElement.rolledUpCheckElementsQty += deltas.quantity;
  if (displayCheckElement.splitWays === 0 && displayCheckElement.splitGrouped === 0) {
    displayCheckElement.splitWays = deltas.splitWays;
    displayCheckElement.splitGrouped = deltas.splitGrouped;
  } else if (deltas.splitWays === displayCheckElement.splitWays) {
    displayCheckElement.splitGrouped += deltas.splitGrouped;
  } else {
    const displayDenominator = displayCheckElement.splitWays;
    displayCheckElement.splitGrouped *= deltas.splitWays;
    displayCheckElement.splitWays *= deltas.splitWays;
    displayCheckElement.splitGrouped += deltas.splitGrouped * displayDenominator;
  }
  const gcdValue = gcd(
    displayCheckElement.splitGrouped,
    displayCheckElement.splitWays
  );
  if (displayCheckElement.splitWays > 1 && gcdValue > 1) {
    displayCheckElement.splitGrouped /= gcdValue;
    displayCheckElement.splitWays /= gcdValue;
  }
  updateDisplayCheckElementDisplayFraction(displayCheckElement);
  updateDisplayCheckElementTotalQty(displayCheckElement);
};
function gcd(x, y) {
  x = Math.abs(x);
  y = Math.abs(y);
  while (y) {
    const t2 = y;
    y = x % y;
    x = t2;
  }
  return x;
}
var calculateCheckTotals = (checks, checkElementMap, checkElementNewValues) => {
  const checksCurrentTotal = {};
  const excludedCheckElements = {};
  checkElementMap.forEach(
    ({ checkElementId }) => excludedCheckElements[checkElementId] = true
  );
  Object.keys(checks).forEach((checkId) => {
    checksCurrentTotal[checkId] = 0;
    Object.values(checks[checkId].checkElements).forEach((checkElement) => {
      if (excludedCheckElements[getCheckElementId(checkElement)])
        return;
      checksCurrentTotal[checkId] += checkElement.price - checkElement.specialAmount - checkElement.discount + checkElement.tax;
    });
  });
  checkElementMap.forEach(({ checkId, checkElementId }) => {
    checksCurrentTotal[checkId] += checkElementNewValues[checkElementId].price - checkElementNewValues[checkElementId].specialAmount - checkElementNewValues[checkElementId].discount + checkElementNewValues[checkElementId].tax;
  });
  Object.keys(checksCurrentTotal).forEach((checkId) => {
    checksCurrentTotal[checkId] = roundToCentesimal(
      checksCurrentTotal[checkId]
    );
  });
  return checksCurrentTotal;
};
var updateItemCheckElements = (order, ticketElementId) => {
  var _a;
  const ticketElement = (_a = order.ticketElements) == null ? void 0 : _a[ticketElementId];
  if (!ticketElement || !ticketElement.isOpenItem && !!ticketElement.comboElementId)
    return;
  const checkElementMap = order.ticketElementToCheckElements[ticketElement.ticketElementToCheckElementsId || -1];
  const { isSplitBySeat, elements } = mapCheckElementToQuantity(
    order,
    ticketElement,
    checkElementMap || []
  );
  const menuTypeId = !ticketElement.isOpenItem ? ticketElement.menuTypeId : 0;
  if (isSplitBySeat) {
    elements.forEach(({ checkId, checkElementId, isNew, quantity, seats }) => {
      const checkElement = getCheckElement(order, checkId, checkElementId);
      if (!checkElement)
        return;
      if (!isNew && quantity === 0) {
        deleteCheckElementAndUpdateCheckOld(
          order,
          order.checks[checkId],
          checkElement
        );
        return;
      }
      const check = order.checks[checkId];
      if (!check)
        return;
      updateCheckElementSeats(seats, check, checkElement);
    });
  }
  const checkElementNewValues = Object.values(checkElementMap || {}).reduce(
    (acc, { checkElementId }) => (acc[checkElementId] = {
      price: 0,
      tax: 0,
      discount: 0,
      specialAmount: 0
    }) && acc,
    {}
  );
  const checksCurrentTotalPrice = calculateCheckTotals(
    order.checks,
    checkElementMap,
    checkElementNewValues
  );
  distributeCurrencyByCheckPriceForPrice(
    Object.values(checkElementMap || {}).map(
      ({ checkId, checkElementId, instanceId }) => {
        const checkElement = getCheckElement(order, checkId, checkElementId);
        return {
          id: checkElementId,
          fraction: {
            numerator: ((checkElement == null ? void 0 : checkElement.splitGrouped) || 0) * ((checkElement == null ? void 0 : checkElement.quantity) || 1),
            denominator: ((checkElement == null ? void 0 : checkElement.splitWays) || 1) * ((ticketElement == null ? void 0 : ticketElement.quantity) || 1)
          },
          price: 0,
          checkId,
          instanceId,
          assignedValue: 0,
          eachPrice: ticketElement.totalPricePerItemUnit
        };
      }
    ),
    ticketElement.totalPricePerItemUnit * (ticketElement.quantity || 0),
    checksCurrentTotalPrice
  ).forEach(
    ({ id, assignedValue }) => checkElementNewValues[id].price += roundToCentesimal(assignedValue)
  );
  const itemElementIdsToApplyBogo = {};
  if (!ticketElement.isOpenItem) {
    Object.values(ticketElement.specials).forEach((special) => {
      switch (special.specialApplyTo) {
        case "bogo" /* BOGO */:
          special.instances.forEach((instanceId) => {
            itemElementIdsToApplyBogo[instanceId] = 0;
          });
          break;
        case "item" /* ITEM */: {
          distributeCurrencyByCheckPrice(
            Object.values(checkElementMap || {}).map(
              ({ checkId, checkElementId, instanceId }) => {
                const checkElement = getCheckElement(
                  order,
                  checkId,
                  checkElementId
                );
                return {
                  id: checkElementId,
                  fraction: {
                    numerator: ((checkElement == null ? void 0 : checkElement.splitGrouped) || 0) * ((checkElement == null ? void 0 : checkElement.quantity) || 1),
                    denominator: ((checkElement == null ? void 0 : checkElement.splitWays) || 1) * ((ticketElement == null ? void 0 : ticketElement.quantity) || 1)
                  },
                  price: checkElementNewValues[checkElementId].price,
                  instanceId,
                  checkId,
                  assignedValue: 0
                };
              }
            ),
            special.appliedSpecialAmount,
            true
          ).forEach(({ id, assignedValue }) => {
            checkElementNewValues[id].specialAmount += roundToCentesimal(assignedValue);
          });
        }
      }
    });
    if (ticketElement.quantity > 1 && Object.keys(itemElementIdsToApplyBogo).length > 0) {
      const newCheckElements = checkElementMap.filter(
        ({ instanceId: _itemElementId }) => Object.keys(itemElementIdsToApplyBogo).includes(_itemElementId)
      );
      distributeCurrencyByCheckPrice(
        Object.values(newCheckElements || {}).map(
          ({ checkId, checkElementId, instanceId }) => {
            const checkElement = getCheckElement(
              order,
              checkId,
              checkElementId
            );
            return {
              id: checkElementId,
              fraction: {
                numerator: (checkElement == null ? void 0 : checkElement.splitGrouped) || 0,
                denominator: ((checkElement == null ? void 0 : checkElement.splitWays) || 1) * Object.keys(itemElementIdsToApplyBogo).length
              },
              price: checkElementNewValues[checkElementId].price,
              instanceId,
              checkId,
              assignedValue: 0
            };
          }
        ),
        !ticketElement.isOpenItem ? ticketElement.totalSpecialsBOGOAmount : 0,
        true
      ).forEach(({ id, assignedValue }) => {
        checkElementNewValues[id].specialAmount += roundToCentesimal(assignedValue);
      });
    } else {
      distributeCurrencyByCheckPrice(
        Object.values(checkElementMap || {}).map(
          ({ checkId, checkElementId, instanceId }) => {
            const checkElement = getCheckElement(
              order,
              checkId,
              checkElementId
            );
            return {
              id: checkElementId,
              fraction: {
                numerator: (checkElement == null ? void 0 : checkElement.splitGrouped) || 0,
                denominator: ((checkElement == null ? void 0 : checkElement.splitWays) || 1) * Object.keys(itemElementIdsToApplyBogo).length
              },
              price: checkElementNewValues[checkElementId].price,
              instanceId,
              checkId,
              assignedValue: 0
            };
          }
        ),
        !ticketElement.isOpenItem ? ticketElement.totalSpecialsBOGOAmount : 0,
        true
      ).forEach(({ id, assignedValue }) => {
        checkElementNewValues[id].specialAmount += roundToCentesimal(assignedValue);
      });
    }
  }
  distributeCurrencyProportionally(
    Object.values(checkElementMap || {}).map(({ checkElementId }) => {
      return {
        id: checkElementId,
        currentValue: checkElementNewValues[checkElementId].price - checkElementNewValues[checkElementId].specialAmount
      };
    }),
    ticketElement.totalDiscountAmount,
    true
  ).forEach(({ id, assignedValue }) => {
    checkElementNewValues[id].discount += roundToCentesimal(assignedValue);
  });
  distributeCurrencyByCheckPrice(
    Object.values(checkElementMap || {}).map(
      ({ checkId, checkElementId, instanceId }) => {
        const checkElement = getCheckElement(order, checkId, checkElementId);
        return {
          id: checkElementId,
          fraction: {
            numerator: ((checkElement == null ? void 0 : checkElement.splitGrouped) || 0) * ((checkElement == null ? void 0 : checkElement.quantity) || 1),
            denominator: ((checkElement == null ? void 0 : checkElement.splitWays) || 1) * ((ticketElement == null ? void 0 : ticketElement.quantity) || 1)
          },
          checkId,
          instanceId,
          price: checkElementNewValues[checkElementId].price - checkElementNewValues[checkElementId].discount - checkElementNewValues[checkElementId].specialAmount,
          assignedValue: 0
        };
      }
    ),
    ticketElement.totalTax
  ).forEach(({ id, assignedValue }) => {
    checkElementNewValues[id].tax += roundToCentesimal(assignedValue);
  });
  const tryUnsplit = [];
  elements.forEach(({ checkId, checkElementId, seats }) => {
    var _a2, _b, _c, _d, _e, _f, _g;
    const check = order.checks[checkId];
    const checkElement = getCheckElement(order, checkId, checkElementId);
    if (!check || !checkElement)
      return;
    const ticketElementCheckName = isOpenItemFn(ticketElement) ? (_c = (_b = (_a2 = ticketElement.itemObj) == null ? void 0 : _a2.menuTypeVersions[menuTypeId != null ? menuTypeId : -1]) == null ? void 0 : _b.posName) != null ? _c : "" : (_f = (_e = (_d = ticketElement.itemObj) == null ? void 0 : _d.menuTypeVersions[menuTypeId != null ? menuTypeId : -1]) == null ? void 0 : _e.checkName) != null ? _f : "";
    updateCheckElementOld(order, check, checkElement, {
      name: ticketElementCheckName,
      itemId: (_g = ticketElement.itemId) != null ? _g : void 0,
      quantity: 0,
      itemCount: 0,
      eachPrice: (ticketElement.totalPricePerItemUnit || 0) - checkElement.eachPrice,
      price: checkElementNewValues[checkElementId].price - checkElement.price,
      discount: checkElementNewValues[checkElementId].discount - checkElement.discount,
      tax: checkElementNewValues[checkElementId].tax - checkElement.tax,
      seats,
      isShared: !!ticketElement.isShared,
      specialAmount: checkElementNewValues[checkElementId].specialAmount - checkElement.specialAmount
    });
    checkElement.ticketElementId = ticketElementId;
  });
  return tryUnsplit;
};
var updateComboCheckElements = (order, comboId) => {
  var _a;
  const combo = (_a = order.combos) == null ? void 0 : _a[comboId];
  if (!combo)
    return;
  const checkElements = order.ticketElementToCheckElements[combo.comboElementToCheckElementsId || -1];
  const { isSplitBySeat, elements } = mapCheckElementToQuantity(
    order,
    combo,
    checkElements || []
  );
  if (isSplitBySeat) {
    elements.forEach(({ checkId, checkElementId, isNew, quantity, seats }) => {
      if (!isNew && quantity === 0) {
        const checkElement2 = getCheckElement(order, checkId, checkElementId);
        if (!checkElement2)
          return;
        deleteCheckElementAndUpdateCheckOld(
          order,
          order.checks[checkId],
          checkElement2
        );
        return;
      }
      const check = order.checks[checkId];
      const checkElement = getCheckElement(order, checkId, checkElementId);
      if (!check || !checkElement)
        return;
      updateCheckElementSeats(seats, check, checkElement);
      updateCheckElementItemCount(
        quantity - checkElement.quantity,
        check,
        checkElement
      );
    });
  }
  const checkElementNewValues = Object.values(checkElements || {}).reduce(
    (acc, { checkElementId }) => (acc[checkElementId] = {
      price: 0,
      tax: 0,
      discount: 0,
      specialAmount: 0
    }) && acc,
    {}
  );
  const checksCurrentTotalPrice = calculateCheckTotals(
    order.checks,
    checkElements,
    checkElementNewValues
  );
  distributeCurrencyByCheckPriceForPrice(
    Object.values(checkElements || {}).map(
      ({ checkId, checkElementId, instanceId }) => {
        const checkElement = getCheckElement(order, checkId, checkElementId);
        return {
          id: checkElementId,
          fraction: {
            numerator: ((checkElement == null ? void 0 : checkElement.splitGrouped) || 0) * ((checkElement == null ? void 0 : checkElement.quantity) || 1),
            denominator: ((checkElement == null ? void 0 : checkElement.splitWays) || 1) * ((combo == null ? void 0 : combo.quantity) || 1)
          },
          price: 0,
          checkId,
          instanceId,
          assignedValue: 0,
          eachPrice: combo.totalPricePerItemUnit
        };
      }
    ),
    combo.totalPricePerItemUnit * (combo.quantity || 0),
    checksCurrentTotalPrice
  ).forEach(
    ({ id, assignedValue }) => checkElementNewValues[id].price += roundToCentesimal(assignedValue)
  );
  const itemElementIdsToApplyBogo = {};
  Object.values(combo.specials).forEach((special) => {
    switch (special.specialApplyTo) {
      case "bogo" /* BOGO */:
        special.instances.forEach((instanceId) => {
          itemElementIdsToApplyBogo[instanceId] = 0;
        });
        break;
      case "item" /* ITEM */: {
        distributeCurrencyByCheckPrice(
          Object.values(checkElements || {}).map(
            ({ checkId, checkElementId, instanceId }) => {
              const checkElement = getCheckElement(
                order,
                checkId,
                checkElementId
              );
              return {
                id: checkElementId,
                fraction: {
                  numerator: ((checkElement == null ? void 0 : checkElement.splitGrouped) || 0) * ((checkElement == null ? void 0 : checkElement.quantity) || 1),
                  denominator: ((checkElement == null ? void 0 : checkElement.splitWays) || 1) * ((combo == null ? void 0 : combo.quantity) || 1)
                },
                price: checkElementNewValues[checkElementId].price,
                instanceId,
                checkId,
                assignedValue: 0
              };
            }
          ),
          special.appliedSpecialAmount,
          true
        ).forEach(({ id, assignedValue }) => {
          checkElementNewValues[id].specialAmount += roundToCentesimal(assignedValue);
        });
      }
    }
  });
  if (combo.quantity > 1 && Object.keys(itemElementIdsToApplyBogo).length > 0) {
    const newCheckElements = checkElements.filter(
      ({ instanceId: _itemElementId }) => Object.keys(itemElementIdsToApplyBogo).includes(_itemElementId)
    );
    distributeCurrencyByCheckPrice(
      Object.values(newCheckElements || {}).map(
        ({ checkId, checkElementId, instanceId }) => {
          const checkElement = getCheckElement(order, checkId, checkElementId);
          return {
            id: checkElementId,
            fraction: {
              numerator: (checkElement == null ? void 0 : checkElement.splitGrouped) || 0,
              denominator: ((checkElement == null ? void 0 : checkElement.splitWays) || 1) * Object.keys(itemElementIdsToApplyBogo).length
            },
            price: checkElementNewValues[checkElementId].price,
            instanceId,
            checkId,
            assignedValue: 0
          };
        }
      ),
      combo.totalSpecialsBOGOAmount,
      true
    ).forEach(({ id, assignedValue }) => {
      checkElementNewValues[id].specialAmount += roundToCentesimal(assignedValue);
    });
  } else {
    distributeCurrencyByCheckPrice(
      Object.values(checkElements || {}).map(
        ({ checkId, checkElementId, instanceId }) => {
          const checkElement = getCheckElement(order, checkId, checkElementId);
          return {
            id: checkElementId,
            fraction: {
              numerator: (checkElement == null ? void 0 : checkElement.splitGrouped) || 0,
              denominator: ((checkElement == null ? void 0 : checkElement.splitWays) || 1) * Object.keys(itemElementIdsToApplyBogo).length
            },
            price: checkElementNewValues[checkElementId].price,
            instanceId,
            checkId,
            assignedValue: 0
          };
        }
      ),
      combo.totalSpecialsBOGOAmount,
      true
    ).forEach(({ id, assignedValue }) => {
      checkElementNewValues[id].specialAmount += roundToCentesimal(assignedValue);
    });
  }
  distributeCurrencyProportionally(
    Object.values(checkElements || {}).map(({ checkElementId }) => {
      return {
        id: checkElementId,
        currentValue: checkElementNewValues[checkElementId].price - checkElementNewValues[checkElementId].specialAmount
      };
    }),
    combo.totalDiscountAmount,
    true
  ).forEach(({ id, assignedValue }) => {
    checkElementNewValues[id].discount += roundToCentesimal(assignedValue);
  });
  distributeCurrencyByCheckPrice(
    Object.values(checkElements || {}).map(
      ({ checkId, checkElementId, instanceId }) => {
        const checkElement = getCheckElement(order, checkId, checkElementId);
        return {
          id: checkElementId,
          fraction: {
            numerator: ((checkElement == null ? void 0 : checkElement.splitGrouped) || 0) * ((checkElement == null ? void 0 : checkElement.quantity) || 1),
            denominator: ((checkElement == null ? void 0 : checkElement.splitWays) || 1) * ((combo == null ? void 0 : combo.quantity) || 1)
          },
          checkId,
          instanceId,
          price: checkElementNewValues[checkElementId].price - checkElementNewValues[checkElementId].discount - checkElementNewValues[checkElementId].specialAmount,
          assignedValue: 0
        };
      }
    ),
    combo.totalTax
  ).forEach(({ id, assignedValue }) => {
    checkElementNewValues[id].tax += roundToCentesimal(assignedValue);
  });
  const tryUnsplit = [];
  const visitedElementIds = [];
  elements.forEach(
    ({ checkId, checkElementId, quantity, isShared, seats, instanceId }) => {
      var _a2, _b, _c, _d;
      const check = order.checks[checkId];
      const checkElement = getCheckElement(order, checkId, checkElementId);
      if (!check || !checkElement)
        return;
      const comboCheckName = (_d = (_c = (_b = combo.comboObj) == null ? void 0 : _b.menuTypeVersions[(_a2 = combo.menuTypeId) != null ? _a2 : -1]) == null ? void 0 : _c.checkName) != null ? _d : "";
      const oldSeatId = Object.keys(checkElement.seats || {})[0];
      const newSeatId = Object.keys(seats || {})[0];
      updateCheckElementOld(order, check, checkElement, {
        name: comboCheckName,
        quantity: 0,
        itemCount: Object.values(combo.itemGroupsSelected || {}).filter(
          (itemGroupSelected) => {
            var _a3, _b2, _c2;
            return (_c2 = (_b2 = order.ticketElements) == null ? void 0 : _b2[(_a3 = itemGroupSelected == null ? void 0 : itemGroupSelected.ticketElementId) != null ? _a3 : -1]) == null ? void 0 : _c2.quantity;
          }
        ).length * quantity - checkElement.itemCount,
        eachPrice: (combo.totalPricePerItemUnit || 0) - checkElement.eachPrice,
        price: checkElementNewValues[checkElementId].price - checkElement.price,
        discount: checkElementNewValues[checkElementId].discount - checkElement.discount,
        specialAmount: checkElementNewValues[checkElementId].specialAmount - checkElement.specialAmount,
        tax: checkElementNewValues[checkElementId].tax - checkElement.tax,
        seats,
        isShared
      });
      checkElement.comboElementId = comboId;
      const itemGroupSelectedTicketElementIds = new Set(
        Object.values(combo.itemGroupsSelected || {}).map(
          (itemGroupSelected) => itemGroupSelected.ticketElementId
        )
      );
      const checkComboTicketElementIds = new Set(
        Object.keys(checkElement.comboItemNames || {}).map((itemId) => {
          const num = Number(itemId);
          if (!isNaN(num))
            return num;
          if (itemId === "null")
            return null;
          return itemId;
        })
      );
      const comboItemIds = [
        ...itemGroupSelectedTicketElementIds,
        ...checkComboTicketElementIds
      ];
      comboItemIds.forEach((ticketElementId) => {
        if (!ticketElementId)
          return;
        if (itemGroupSelectedTicketElementIds.has(ticketElementId) && checkComboTicketElementIds.has(ticketElementId)) {
          return;
        }
        if (itemGroupSelectedTicketElementIds.has(ticketElementId)) {
          addComboItemToCheckElement(order, checkElement, ticketElementId);
        } else {
          removeComboItemFromCheckElement(checkElement, ticketElementId);
        }
      });
      if (oldSeatId !== newSeatId) {
        checkElement.disableAutoAssign = false;
      }
      if (!(checkElement.seats[-1] && checkElement.splitWays > 1) && !checkElement.disableAutoAssign) {
        autoAssignCheckElements(order, [checkElementId]);
        if (checkElement.splitWays > 1 && !visitedElementIds.includes(checkElement.instanceId)) {
          const checkIdByElementId = getCheckIdByCheckElementId(
            order,
            checkElementId
          );
          if (!checkIdByElementId)
            return;
          tryUnsplit.push({
            checkElementId,
            checkId: checkIdByElementId,
            instanceId
          });
          visitedElementIds.push(checkElement.instanceId);
        }
      }
    }
  );
  return tryUnsplit;
};
var updateMasterCheckOrderDiscounts = (order) => {
  let checks;
  if (Object.keys(order.checks).length > 1) {
    checks = Object.values(order.checks).filter(
      (check) => check.id !== order.defaultCheckId
    );
  } else {
    checks = [order.checks[order.defaultCheckId]];
  }
  if (checks.length === 0)
    return;
  const totalDiscounts = Object.values(order.orderDiscounts || {}).reduce(
    (acc, discount) => {
      var _a;
      return acc + ((_a = discount.appliedDiscountAmount) != null ? _a : 0);
    },
    0
  ) + Object.values(order.orderSpecials || {}).reduce(
    (acc, special) => {
      var _a;
      return acc + ((_a = special.appliedSpecialAmount) != null ? _a : 0);
    },
    0
  );
  const orderDiscounts = totalDiscounts;
  if (orderDiscounts < 0)
    return;
  const checkSubtotalMapList = checks.map((childCheck) => {
    const currentValue = childCheck.subtotal;
    return {
      id: getCheckId(childCheck),
      currentValue
    };
  });
  const checkValueMap = distributeCurrencyProportionally(
    checkSubtotalMapList,
    orderDiscounts,
    true
  );
  checkValueMap.forEach(
    ({ id: childCheckId, assignedValue: checkOrderDiscount }) => {
      const check = order.checks[childCheckId];
      if (!check)
        return;
      const delta = checkOrderDiscount - check.totalOrderDiscounts;
      updateCheckOrderDiscounts2(check, delta);
    }
  );
};
var voidCheck = (order, checkId) => {
  const check = order.checks[checkId];
  if (!check)
    return;
  const checkCopy = cloneDeep(check);
  checkCopy.status = "voided" /* VOIDED */;
  Object.values(check.checkElements).forEach((checkElement) => {
    const checkElementId = getCheckElementId(checkElement);
    moveCheckElements2(order, [checkElementId], checkId);
  });
  order.checks[checkId] = checkCopy;
};
var generateSingleCheck = (order) => {
  const ticketElements = Object.values(order.ticketElements || {}).filter(
    (ticketElement) => ticketElement.isOpenItem ? false : !ticketElement.comboElementId
  );
  const comboElements = Object.values(order.combos || {});
  order.checks = {};
  const newCheck = createCheck2(order);
  const newCheckId = getCheckId(newCheck);
  order.defaultCheckId = newCheckId;
  order.ticketElementToCheckElements = {};
  ticketElements.forEach((ticketElement) => {
    const ticketElementId = getTicketElementId(ticketElement);
    ticketElement.instanceIds.forEach((itemId) => {
      addTicketElementToChecks(order, ticketElementId, itemId);
      updateItemCheckElements(order, ticketElementId);
      if (ticketElement.isVoided) {
        voidCheckItemElement(true, order, ticketElementId);
      }
    });
  });
  comboElements.forEach((comboElement) => {
    const comboElementId = getTicketElementId(comboElement);
    comboElement.instanceIds.forEach((itemId) => {
      addComboToChecks(order, comboElementId, itemId);
      updateComboCheckElements(order, comboElementId);
    });
  });
  updateMasterCheckOrderDiscounts(order);
  return newCheckId;
};
var voidAllChecks2 = (order) => {
  const previousChecks = cloneDeep(order.checks);
  delete previousChecks[order.defaultCheckId];
  const newCheckId = generateSingleCheck(order);
  Object.values(previousChecks).forEach((check) => {
    var _a;
    check.status = "voided" /* VOIDED */;
    order.checks[getCheckId(check)] = check;
    Object.values((_a = check == null ? void 0 : check.payments) != null ? _a : {}).forEach((payment) => {
      payment.checkId = newCheckId;
      order = addCheckPayment2(order, newCheckId, payment);
    });
  });
};
var dumpDefaultCheck2 = (order) => {
  const defaultCheckId = order.defaultCheckId;
  const defaultCheck = order.checks[defaultCheckId];
  const newCheck = createCheck2(order, {
    number: generateNewCheckNumber(order.checks),
    status: "open" /* OPEN */
  });
  const newCheckId = getCheckId(newCheck);
  if (!defaultCheck || !newCheck)
    return;
  Object.values(defaultCheck.checkElements).map(getCheckElementId).forEach((checkElementId) => {
    moveCheckElements2(order, [checkElementId], newCheckId);
  });
};
var splitCheckElementIntoChecksEvenly = (order, checkElementId, checkFromId, checksToIds) => {
  const checkElement = getCheckElement(order, checkFromId, checkElementId);
  if (!checkElement || !checksToIds.length)
    return;
  const splitWays = checksToIds.length;
  const newTicketElementToCheckElementList = checksToIds.map((checkId) => {
    const check = order.checks[checkId];
    const itemCount = checkElement.itemCount;
    const newCheckElement = createCheckElement({
      splitWays: splitWays * checkElement.splitWays,
      splitGrouped: checkElement.splitGrouped,
      ticketElementToCheckElementsId: checkElement.ticketElementToCheckElementsId,
      comboElementId: checkElement.comboElementId,
      ticketElementId: checkElement.ticketElementId,
      checkId,
      instanceId: checkElement.instanceId,
      quantity: 1,
      itemCount,
      itemId: checkElement.itemId,
      isShared: checkElement.isShared,
      seats: checkElement.seats
    });
    const newCheckElementId = newCheckElement.tabletGeneratedId;
    check.checkElements[newCheckElementId] = newCheckElement;
    check.itemCount += itemCount;
    return createTicketElementToCheckElementObject({
      checkId,
      checkElementId: newCheckElementId,
      instanceId: checkElement.instanceId
    });
  });
  order.ticketElementToCheckElements[checkElement.ticketElementToCheckElementsId] = [
    ...order.ticketElementToCheckElements[checkElement.ticketElementToCheckElementsId].filter(
      ({ checkId, checkElementId: _checkElementId }) => !(checkId === checkFromId && checkElementId === _checkElementId)
    ),
    ...newTicketElementToCheckElementList
  ];
  newTicketElementToCheckElementList.forEach(
    ({ checkId, checkElementId: newCheckElementId }) => {
      const newCheck = order.checks[checkId];
      const newCheckElement = newCheck.checkElements[newCheckElementId];
      if (!newCheck || !newCheckElement)
        return;
      updateCheckElementDisplayFraction(newCheckElement);
    }
  );
  if (checkElement.isVoided) {
    voidCheckElement(order, order.checks[checkFromId], checkElement);
  }
  deleteCheckElementAndUpdateCheckOld(
    order,
    order.checks[checkFromId],
    checkElement
  );
  return newTicketElementToCheckElementList;
};
var autoAssignCheckElements = (order, checkElementIds) => {
  switch (order.splitMode) {
    case "SEATS" /* SEATS */:
      splitCheckElementBySeat(order, checkElementIds);
      break;
    case "EVENLY" /* EVENLY */: {
      const openChecksIds = [];
      Object.values(order.checks).forEach((check) => {
        if (checkStatusAllowsEditing(check.status) && getCheckId(check) !== order.defaultCheckId) {
          openChecksIds.push(getCheckId(check));
        }
      });
      checkElementIds.forEach((checkElementId) => {
        const checkId = getCheckIdByCheckElementId(order, checkElementId);
        if (!checkId)
          return;
        const checkElement = getCheckElement(order, checkId, checkElementId);
        if (!checkElement || checkElement.splitWays !== 1)
          return;
        splitCheckElementIntoChecksEvenly(
          order,
          checkElementId,
          checkId,
          openChecksIds
        );
      });
      break;
    }
  }
};
var splitCheckElementBySeat = (order, checkElementIds) => {
  if (!checkElementIds.length)
    return;
  const checkElementIdMap = [];
  checkElementIds.forEach((checkElementId) => {
    const checkId = getCheckIdByCheckElementId(order, checkElementId);
    if (!checkId)
      return;
    const checkElement = getCheckElement(order, checkId, checkElementId);
    if (!checkElement)
      return;
    if (!checkElement.isShared) {
      Object.keys(checkElement.seats).forEach((seatId) => {
        checkElementIdMap.push({
          seatId: Number(seatId),
          checkId,
          checkElementId
        });
      });
    } else {
      checkElementIdMap.push({
        seatId: SHARED_SEAT_ID,
        checkId,
        checkElementId,
        shared: Object.keys(checkElement.seats).map(Number)
      });
    }
  });
  checkElementIdMap.forEach(({ seatId, checkId, checkElementId, shared }) => {
    if (seatId >= 1) {
      let moved = false;
      Object.values(order.checks).forEach((check) => {
        if (!check.seats || !check.seats.includes(seatId))
          return;
        const checkToId = getCheckId(check);
        moved = true;
        if (!checkStatusAllowsEditing(order.checks[checkId].status))
          return;
        if (checkId === checkToId)
          return;
        moveCheckElements2(order, [checkElementId], checkToId);
      });
      if (moved)
        return;
      const name = getSeatName(i18n_config_default.t, seatId);
      const newCheck = createCheck2(order, {
        seats: [seatId],
        name
      });
      const newCheckId = getCheckId(newCheck);
      moveCheckElements2(order, [checkElementId], newCheckId);
    } else if (seatId === FOR_TABLE_SEAT_ID) {
      const seatsOccupied = order.numberOfSeatsOccupied || 0;
      const setOfSeats = /* @__PURE__ */ new Set();
      const checksToIds = [];
      Object.values(order.checks).forEach((check) => {
        if (!check.seats || check.seats.length === 0)
          return;
        if (getCheckId(check) !== order.defaultCheckId && checkStatusAllowsEditing(check.status))
          checksToIds.push(getCheckId(check));
        check.seats.forEach((seatIdCheck) => setOfSeats.add(seatIdCheck));
      });
      Array.from({ length: seatsOccupied }).forEach((_, index) => {
        if (setOfSeats.has(index + 1))
          return;
        const name = getSeatName(i18n_config_default.t, index + 1);
        const newCheck = createCheck2(order, {
          seats: [index + 1],
          name
        });
        const newCheckId = getCheckId(newCheck);
        checksToIds.push(newCheckId);
      });
      splitCheckElementIntoChecksEvenly(
        order,
        checkElementId,
        checkId,
        checksToIds
      );
    } else if (seatId === NO_SEAT_ID) {
      const checkElementCheckId = getCheckIdByCheckElementId(
        order,
        checkElementId
      );
      if (checkId !== order.defaultCheckId && checkStatusAllowsEditing(order.checks[checkId].status) && checkElementCheckId === order.defaultCheckId) {
        moveCheckElements2(order, [checkElementId], order.defaultCheckId);
      }
    } else if (seatId === SHARED_SEAT_ID) {
      if (!shared || shared.length === 0)
        return;
      const checksToIds = [];
      shared.forEach((sharedSeatId) => {
        let found = false;
        Object.values(order.checks).forEach((check) => {
          if (!check.seats || !check.seats.includes(sharedSeatId))
            return;
          if (getCheckId(check) !== order.defaultCheckId && checkStatusAllowsEditing(check.status)) {
            found = true;
            checksToIds.push(getCheckId(check));
          }
        });
        if (found)
          return;
        const name = getSeatName(i18n_config_default.t, sharedSeatId);
        const newCheck = createCheck2(order, {
          seats: [sharedSeatId],
          name
        });
        const newCheckId = getCheckId(newCheck);
        checksToIds.push(newCheckId);
      });
      splitCheckElementIntoChecksEvenly(
        order,
        checkElementId,
        checkId,
        checksToIds
      );
    }
  });
};
var handleElementUngroupBySeat = (order, originalElementId, ticketElementSeatMap, isCombo, ungroupingResult) => {
  var _a, _b, _c, _d;
  const originalTicketToCheckElementsId = isCombo ? (_b = (_a = order.combos) == null ? void 0 : _a[originalElementId]) == null ? void 0 : _b.comboElementToCheckElementsId : (_d = (_c = order.ticketElements) == null ? void 0 : _c[originalElementId]) == null ? void 0 : _d.ticketElementToCheckElementsId;
  const originalTicketToCheckElements = order.ticketElementToCheckElements[originalTicketToCheckElementsId || -1];
  if (!originalTicketToCheckElements)
    return;
  ungroupingResult.newTicketElementIds.forEach((newTicketId) => {
    var _a2, _b2, _c2, _d2;
    const newTicketSeatInfo = ticketElementSeatMap.find(
      ({ ticketElementId }) => ticketElementId === newTicketId
    );
    const newTicketToCheckElementsId = isCombo ? (_b2 = (_a2 = order.combos) == null ? void 0 : _a2[newTicketId]) == null ? void 0 : _b2.comboElementToCheckElementsId : (_d2 = (_c2 = order.ticketElements) == null ? void 0 : _c2[newTicketId]) == null ? void 0 : _d2.ticketElementToCheckElementsId;
    if (!newTicketSeatInfo || !newTicketToCheckElementsId)
      return;
    const ticketSeatSignatureQTY = newTicketSeatInfo.quantity;
    const matchingCheckIds = [];
    const itemElementIdsToTransfer = [];
    Object.values(order.checks).forEach((check) => {
      if (!check.seats || !checkStatusAllowsEditing(check.status))
        return;
      if (check.seats.includes(newTicketSeatInfo.seatId)) {
        const checkId = getCheckId(check);
        matchingCheckIds.push(checkId);
      }
    });
    matchingCheckIds.forEach((checkId) => {
      const check = order.checks[checkId];
      if (!check)
        return;
      Object.values(check.checkElements).forEach((checkElement) => {
        if (checkElement.seats[newTicketSeatInfo.seatId] && !itemElementIdsToTransfer.includes(checkElement.instanceId) && checkElement[isCombo ? "comboElementId" : "ticketElementId"] === originalElementId)
          itemElementIdsToTransfer.push(checkElement.instanceId);
      });
    });
    if (ticketSeatSignatureQTY !== itemElementIdsToTransfer.length) {
      Object.values(order.checks).forEach((check) => {
        if (itemElementIdsToTransfer.length === ticketSeatSignatureQTY)
          return;
        Object.values(check.checkElements).forEach((checkElement) => {
          if (itemElementIdsToTransfer.length === ticketSeatSignatureQTY)
            return;
          if (checkElement.seats[newTicketSeatInfo.seatId] && !itemElementIdsToTransfer.includes(checkElement.instanceId) && checkElement[isCombo ? "comboElementId" : "ticketElementId"] === originalElementId)
            itemElementIdsToTransfer.push(checkElement.instanceId);
        });
      });
    }
    const connections = originalTicketToCheckElements.filter((connection) => {
      return itemElementIdsToTransfer.includes(connection.instanceId);
    });
    order.ticketElementToCheckElements[newTicketToCheckElementsId] = connections;
    const deleteConnectionsFrom = isCombo ? order.combos : order.ticketElements;
    connections.forEach(({ checkId, checkElementId, instanceId }) => {
      if (!deleteConnectionsFrom[newTicketId].instanceIds.includes(instanceId)) {
        deleteConnectionsFrom[newTicketId].instanceIds.push(instanceId);
        deleteConnectionsFrom[originalElementId].instanceIds.splice(
          deleteConnectionsFrom[originalElementId].instanceIds.findIndex(
            (_itemElementId) => _itemElementId === instanceId
          ),
          1
        );
      }
      order.checks[checkId].checkElements[checkElementId][isCombo ? "comboElementId" : "ticketElementId"] = newTicketId;
      order.checks[checkId].checkElements[checkElementId].ticketElementToCheckElementsId = newTicketToCheckElementsId;
      originalTicketToCheckElements.splice(
        originalTicketToCheckElements.findIndex(
          ({
            checkId: _checkId,
            checkElementId: _checkElementId,
            instanceId: _itemElementId
          }) => _checkId === checkId && _checkElementId === checkElementId && _itemElementId === instanceId
        ),
        1
      );
    });
  });
};
var handleAutoSplitBySelectedSeat = (order, originalTicketElementId, remainingItemElementIds) => {
  const ticketElementToCheckElementsId = order.ticketElements[originalTicketElementId].ticketElementToCheckElementsId;
  if (!ticketElementToCheckElementsId)
    return;
  const checksToClear = order.ticketElementToCheckElements[ticketElementToCheckElementsId].filter(({ instanceId }) => remainingItemElementIds.includes(instanceId));
  order.ticketElementToCheckElements[ticketElementToCheckElementsId] = order.ticketElementToCheckElements[ticketElementToCheckElementsId].filter(
    ({ instanceId }) => !remainingItemElementIds.includes(instanceId)
  );
  checksToClear.forEach(({ checkId, checkElementId }) => {
    if (remainingItemElementIds.includes(
      order.checks[checkId].checkElements[checkElementId].instanceId
    )) {
      order.checks[checkId].checkElements = deleteCheckElementsFromCheck(
        order.checks[checkId],
        [checkElementId]
      );
      order.checks[checkId].itemCount -= 1;
    }
  });
};
var moveCheckElements2 = (order, checkElementIds, checkToId) => {
  var _a;
  let check = order.checks[checkToId];
  if (!check) {
    if (order.splitMode === "SEATS" /* SEATS */) {
      const seatsWithChecks = /* @__PURE__ */ new Set();
      let biggestSeatId = 0;
      Object.values(order.checks).forEach((_check) => {
        if (_check.seats)
          _check.seats.forEach((seat) => {
            seatsWithChecks.add(seat);
            if (seat > biggestSeatId)
              biggestSeatId = seat;
          });
      });
      const currentNumberOfSeats = order.numberOfSeatsOccupied || 0;
      let newSeatId = 0;
      let name = "";
      if (biggestSeatId + 1 <= currentNumberOfSeats && !seatsWithChecks.has(biggestSeatId + 1)) {
        newSeatId = biggestSeatId + 1;
        name = getSeatName(i18n_config_default.t, newSeatId);
      }
      if (newSeatId === 0) {
        order.numberOfSeatsOccupied = (order.numberOfSeatsOccupied || 0) + 1;
        newSeatId = order.numberOfSeatsOccupied;
        name = getSeatName(i18n_config_default.t, newSeatId);
      }
      createCheck2(
        order,
        {
          seats: [newSeatId],
          name
        },
        checkToId
      );
    } else {
      createCheck2(order, {}, checkToId);
    }
    check = order.checks[checkToId];
  }
  if (!checkStatusAllowsEditing(
    order.checks[checkToId].status || "open" /* OPEN */
  ))
    return;
  const checkTo = order.checks[checkToId];
  const checkElementToCheck = {};
  const checkElementIdSet = new Set(checkElementIds);
  Object.values(order.checks).forEach((_check) => {
    Object.keys(_check.checkElements).forEach((checkElementId) => {
      if (checkElementIdSet.has(checkElementId))
        checkElementToCheck[checkElementId] = getCheckId(_check);
    });
  });
  for (const checkElementId of checkElementIds) {
    const checkFromId = checkElementToCheck[checkElementId];
    if (checkFromId === checkToId)
      continue;
    const checkFrom = order.checks[checkFromId];
    const checkElement = getCheckElement(order, checkFromId, checkElementId);
    if (!checkElement || !checkFrom || !checkTo)
      return;
    const checkElementDeltas = {
      name: checkElement.name,
      quantity: 0,
      itemCount: 0,
      eachPrice: checkElement.eachPrice,
      price: checkElement.price,
      discount: checkElement.discount,
      specialAmount: checkElement.specialAmount,
      tax: checkElement.tax,
      seats: __spreadValues({}, checkElement.seats),
      isShared: checkElement.isShared
    };
    const prevItemCount = checkElement.itemCount;
    const prevQuantity = checkElement.quantity;
    const displayCheckElementId = findDisplayCheckElementId(
      Object.values((_a = order.checks[checkFromId].displayCheckElements) != null ? _a : {}),
      checkElement
    );
    if (displayCheckElementId) {
      removeCheckElementFromDisplayCheckElement(
        order,
        displayCheckElementId,
        checkElement
      );
    }
    updateCheckElementOld(order, checkFrom, checkElement, {
      name: "",
      quantity: -checkElement.quantity,
      itemCount: -checkElement.itemCount,
      eachPrice: -checkElement.eachPrice,
      price: -checkElement.price,
      discount: -checkElement.discount,
      specialAmount: -checkElement.specialAmount,
      tax: -checkElement.tax,
      seats: __spreadValues({}, checkElement.seats),
      isShared: checkElement.isShared
    });
    checkElement.itemCount = prevItemCount;
    checkElement.quantity = prevQuantity;
    checkTo.itemCount += prevItemCount;
    checkTo.checkElements[checkElementId] = checkElement;
    checkFrom.checkElements = deleteCheckElementsFromCheck(checkFrom, [
      checkElementId
    ]);
    updateCheckElementOld(order, checkTo, checkElement, checkElementDeltas);
    const ticketToCheckElementObject = order.ticketElementToCheckElements[checkElement.ticketElementToCheckElementsId].find(
      (ticketTOCheckElement) => checkElementId === ticketTOCheckElement.checkElementId && checkFromId === ticketTOCheckElement.checkId
    );
    if (ticketToCheckElementObject)
      ticketToCheckElementObject.checkId = checkToId;
  }
  for (const checkElementId of checkElementIds) {
    const checkFromId = checkElementToCheck[checkElementId];
    const checkFrom = order.checks[checkFromId];
    if (!checkFrom)
      continue;
  }
};
var getCheckPaymentsCount = (order) => Object.values(order.checks).map((check) => Object.values(check.payments)).flat().length;
var getCheckIdByCheckElementId = (order, checkElementId) => {
  const check = Object.values(order.checks).find(
    (_check) => _check.checkElements[checkElementId]
  );
  if (!check)
    return "";
  return getCheckId(check);
};
var getPaymentMethod = (payment) => payment.paymentMethod === "customTender" /* CUSTOM_TENDER */ ? Number(payment.id) : payment.paymentMethod;
var isPaymentValid = (paymentStatus) => {
  return paymentStatus !== "auth" /* AUTH */ && paymentStatus !== "auth-voided" /* AUTH_VOIDED */ && paymentStatus !== "voided" /* VOIDED */ && paymentStatus !== "refunded" /* REFUNDED */;
};
var transferPayments = (_order, paymentsToCheckIdsMap, destinationCheckId) => {
  Object.entries(paymentsToCheckIdsMap).forEach(([paymentId, checkId]) => {
    const payment = cloneDeep(_order.checks[checkId].payments[paymentId]);
    if (checkId === destinationCheckId)
      return;
    const destinationCheck = _order.checks[destinationCheckId];
    if (typeof destinationCheckId === "string") {
      payment.checkId = 0;
      payment.tabletGeneratedCheckId = destinationCheck.tabletGeneratedId;
    } else {
      payment.checkId = destinationCheckId;
      payment.tabletGeneratedCheckId = destinationCheck.tabletGeneratedId;
    }
    _order.checks[destinationCheckId].payments[paymentId] = payment;
    _order.checks[checkId].status = "open" /* OPEN */;
    delete _order.checks[checkId].payments[paymentId];
  });
};
var getPayButtonContent = (checkStatus, balanceDue, checkTotal, balancePaid, checkHasCheckElements) => {
  const payButtonContent = {
    text: "",
    showTotal: true,
    canClose: false,
    isDeleteCheck: false
  };
  if (checkStatus === "voided" /* VOIDED */)
    payButtonContent.showTotal = true;
  if (!checkHasCheckElements) {
    return {
      text: "register.paymentMode.checksEditor.checkPayButton.deleteCheck",
      showTotal: false,
      canClose: false,
      isDeleteCheck: true
    };
  }
  switch (checkStatus) {
    case "open" /* OPEN */:
      if (balanceDue <= 0) {
        payButtonContent.text = "register.paymentMode.checksEditor.checkPayButton.closeCheck";
        payButtonContent.showTotal = Number(balancePaid) > Number(checkTotal);
        payButtonContent.canClose = true;
      } else {
        payButtonContent.text = "commonButtons.pay";
      }
      break;
    case "partiallyPaid" /* PARTIALLY_PAID */:
      payButtonContent.text = "commonButtons.pay";
      break;
    case "paid" /* PAID */:
      payButtonContent.text = "register.paymentMode.checksEditor.checkPayButton.closeCheck";
      payButtonContent.showTotal = Number(balancePaid) > Number(checkTotal);
      payButtonContent.canClose = true;
      break;
    case "closed" /* CLOSED */:
      payButtonContent.text = "commonButtons.pay";
      payButtonContent.showTotal = Number(balancePaid) > Number(checkTotal);
      break;
    case "voided" /* VOIDED */:
      payButtonContent.text = "commonButtons.voided";
      break;
  }
  return payButtonContent;
};
var voidPayment = (order, payment) => {
  const check = order.checks[payment.checkId];
  check.payments[Number(payment.id)] = payment;
  if (isOrderClosed(order)) {
    return;
  }
  check.status = "open" /* OPEN */;
};
var transferPayment = (order, transferingOrder, transferedCheckId, payment) => {
  const unassignedCheck = transferingOrder.checks[transferedCheckId];
  const currCheck = order.checks[payment.checkId];
  delete currCheck.payments[Number(payment.id)];
  currCheck.status = "open" /* OPEN */;
  const updatedPayment = __spreadProps(__spreadValues({}, payment), {
    orderId: transferingOrder.id,
    checkId: transferedCheckId
  });
  const toChangeListPrice = payment.paymentMethod === "creditCard" /* CREDIT_CARD */ ? "card" /* CARD */ : "cash" /* CASH */;
  const dualPricingSettings = selectIsDualPricingEnabled.lastResult();
  if (dualPricingSettings.dualPricing && !transferingOrder.isLockedPrice && toChangeListPrice == "card" /* CARD */) {
    transferingOrder.isLockedPrice = true;
  }
  unassignedCheck.payments[Number(payment.id)] = updatedPayment;
  unassignedCheck.status = "open" /* OPEN */;
};
var updatePayment = (order, payment) => {
  order.checks[payment.checkId].payments[getEntityId(payment)] = payment;
};
var autoTransferPaymentsBasedOnCheckBalanceDue = (order) => {
  let unassignedCheckPayments = Object.values(
    order.checks[order.defaultCheckId].payments
  ).filter((payment) => {
    const paymentStatus = payment.status;
    return paymentStatus !== "auth-voided" /* AUTH_VOIDED */ && paymentStatus !== "voided" /* VOIDED */ && paymentStatus !== "refunded" /* REFUNDED */;
  });
  if (!unassignedCheckPayments.length)
    return;
  Object.values(order.checks).forEach((check) => {
    if (check.id === order.defaultCheckId || !unassignedCheckPayments.length)
      return;
    const checkBalanceDue = check.balanceDue;
    const sameAmountPayment = unassignedCheckPayments.find(
      (payment) => payment.baseAmount === checkBalanceDue
    );
    if (sameAmountPayment === void 0)
      return;
    unassignedCheckPayments = unassignedCheckPayments.filter(
      (payment) => payment.id !== sameAmountPayment.id
    );
    const paymentId = sameAmountPayment.id;
    transferPayments(
      order,
      { [paymentId]: order.defaultCheckId },
      getCheckId(check)
    );
  });
  updateChecksTotals(order);
};

// src/helpers/register/checks/checks.ts
var generateCheckId = generateTabletGeneratedId;
var getCheckId = (check) => (check == null ? void 0 : check.id) || (check == null ? void 0 : check.tabletGeneratedId);
var isCheckVoided = (check) => check.status === "voided" /* VOIDED */;
var renameCheck = (_order, checkId, newName) => {
  const check = _order.checks[checkId];
  if (!check)
    return _order;
  check.name = newName;
  return _order;
};
var generateNewCheckNumber = (checks) => {
  const existingChecksNumbers = Object.values(checks).map(
    (check) => check.number || 0
  );
  if (!existingChecksNumbers.length)
    return 0;
  let maxCheckNumberInOrder = Math.max(...existingChecksNumbers);
  if (isNaN(maxCheckNumberInOrder))
    maxCheckNumberInOrder = 0;
  return maxCheckNumberInOrder + 1;
};
var createCheck2 = (order, checkDefaults = {}, checkId) => {
  const newCheckNumber = generateNewCheckNumber(order.checks);
  const newCheckId = checkId ? checkId : generateCheckId();
  const newCheck = __spreadValues(__spreadProps(__spreadValues({}, cloneDeep(CHECK_INITIAL_STATE)), {
    number: newCheckNumber
  }), checkDefaults);
  if (typeof newCheckId === "string")
    newCheck.tabletGeneratedId = newCheckId;
  else
    newCheck.id = newCheckId;
  return newCheck;
};
var checkStatusAllowsEditing = (status, allowClosed = false) => status === "open" /* OPEN */ || status === "partiallyPaid" /* PARTIALLY_PAID */ || status === "paid" /* PAID */ || allowClosed && status === "closed" /* CLOSED */;
var checkCanBeDeleted = (check) => {
  if (!check.payments || Object.keys(check.payments).length === 0)
    return true;
  return false;
};
var deleteEditableCheck2 = (_order, checkId) => {
  const check = _order.checks[checkId];
  if (!check || !checkStatusAllowsEditing(check.status))
    return _order;
  const checkElementsIdsArray = Object.values(check.checkElements).map(
    (checkElement) => getCheckElementId(checkElement)
  );
  transferCheckElements(_order, checkElementsIdsArray, _order.defaultCheckId);
  const paymentsCheckIdsMap = {};
  Object.values(check.payments).forEach((payment) => {
    paymentsCheckIdsMap[getEntityId(payment)] = checkId;
  });
  transferPayments(_order, paymentsCheckIdsMap, _order.defaultCheckId);
  delete _order.checks[checkId];
  return _order;
};
var openCheck2 = (_order, checkId) => {
  const check = _order.checks[checkId];
  if (!check) {
    console.error("Fn openCheck: Check not found");
    return;
  }
  if (!Object.keys(check.payments).length) {
    check.status = "open" /* OPEN */;
  } else if (check.balanceDue <= 0) {
    check.status = "paid" /* PAID */;
  } else {
    check.status = "partiallyPaid" /* PARTIALLY_PAID */;
  }
  check.closedTime = null;
  return check;
};
var closeCheck2 = (state, _order, checkId) => {
  const check = _order.checks[checkId];
  if (!check) {
    console.error("Fn closeCheck: Check not found");
    return;
  }
  if (check.balanceDue > 0)
    return;
  if (checkStatusAllowsEditing(check.status)) {
    check.status = "closed" /* CLOSED */;
    check.closedTime = getNowUTCDate();
    Object.values(check.payments).forEach((payment) => {
      disableTicketElementsInClosedChecks(state, _order, payment);
    });
  }
  return _order;
};
var removeInvalidCheckElements = (_order) => {
  if (!_order)
    return;
  Object.values(_order.checks).forEach((check) => {
    Object.entries(check.checkElements).forEach(
      ([checkElementId, checkElement]) => {
        if (!(checkElement.ticketElementToCheckElementsId in _order.ticketElementToCheckElements)) {
          delete check.checkElements[checkElementId];
        }
      }
    );
  });
};
var updateChecksTotals = (_order, checksToUpdateIds, skipServiceCharges, shouldAdjustChecksStatus = true) => {
  if (!_order)
    return;
  removeInvalidCheckElements(_order);
  const toSkipCheckElementIds = getToSkipCheckElementIds(_order);
  const getFilteredChecks = () => {
    let _filteredChecks;
    if (checksToUpdateIds !== void 0 && (checksToUpdateIds == null ? void 0 : checksToUpdateIds.length) !== 0) {
      _filteredChecks = Object.entries(_order == null ? void 0 : _order.checks).filter(([checkId]) => checksToUpdateIds.includes(checkId)).map(([, check]) => check);
    } else {
      _filteredChecks = Object.values(_order == null ? void 0 : _order.checks).filter(
        (check) => checkStatusAllowsEditing(check.status, isOrderClosed(_order))
      );
    }
    return _filteredChecks;
  };
  let filteredChecks = getFilteredChecks();
  const paidSpecialsWithDetails = Object.values(_order.checks || {}).reduce(
    (acc, check) => {
      if (!check.specialsDetails)
        check.specialsDetails = {};
      if (check.status === "closed" /* CLOSED */ || check.status === "paid" /* PAID */)
        Object.values(check.specialsDetails).forEach((specialDetails) => {
          if (!acc[specialDetails.id])
            acc[specialDetails.id] = 0;
          acc[specialDetails.id] += specialDetails.appliedAmount;
        });
      return acc;
    },
    {}
  );
  const orderSpecialsToDistribute = Object.values(_order.orderSpecials || {}).map((special) => ({
    id: special.specialId,
    appliedAmount: special.appliedSpecialAmount,
    name: special.posName,
    checkName: special.checkName,
    type: special.type,
    discountOrSpecialValue: special.discountedAmount - (paidSpecialsWithDetails[special.id] || 0)
  })).filter((special) => special.appliedAmount > 0);
  const paidDiscountsWithDetails = Object.values(_order.checks || {}).reduce(
    (acc, check) => {
      if (!check.discountsDetails)
        check.discountsDetails = {};
      if (check.status === "closed" /* CLOSED */ || check.status === "paid" /* PAID */)
        Object.values(check.discountsDetails).forEach((discountDetails) => {
          if (!acc[discountDetails.id])
            acc[discountDetails.id] = 0;
          acc[discountDetails.id] += discountDetails.appliedAmount;
        });
      return acc;
    },
    {}
  );
  const paidDiscountsOnClosedChecks = Object.values(_order.checks || {}).reduce(
    (acc, check) => {
      if (!check.discountsDetails)
        check.discountsDetails = {};
      if (check.status === "closed" /* CLOSED */)
        Object.values(check.discountsDetails).forEach((discountDetails) => {
          if (!acc[discountDetails.id])
            acc[discountDetails.id] = 0;
          acc[discountDetails.id] += discountDetails.appliedAmount;
        });
      return acc;
    },
    {}
  );
  const orderDiscountsToDistribute = Object.values(_order.orderDiscounts || {}).map((discount) => {
    const value = {
      id: discount.id || discount.tabletGeneratedId,
      appliedAmount: discount.appliedDiscountAmount - (paidDiscountsOnClosedChecks[discount.id] || 0),
      name: discount.posName,
      checkName: discount.checkName,
      type: discount.type,
      discountOrSpecialValue: discount.value - (paidDiscountsWithDetails[discount.id] || 0)
    };
    return value;
  }).filter((discount) => discount.appliedAmount > 0);
  let openChecksSubTotal = 0;
  filteredChecks.forEach((check) => {
    const checkElements = Object.values(check.checkElements).filter(
      (checkElement) => checkElement.isVoided !== true
    );
    check.itemCount = checkElements.length;
    const newValues = checkElements.reduce(
      (acc, checkElement) => {
        if (toSkipCheckElementIds.has(checkElement.tabletGeneratedId)) {
          return acc;
        }
        acc.subtotal += checkElement.price;
        acc.totalItemDiscounts += checkElement.discount;
        acc.totalSpecialDiscounts += checkElement.specialAmount;
        acc.tax += checkElement.tax;
        return acc;
      },
      {
        subtotal: 0,
        totalItemDiscounts: 0,
        totalSpecialDiscounts: 0,
        tax: 0,
        paymentsTotal: 0,
        tipsTotal: 0
      }
    );
    Object.values(check.payments).filter((payment) => isPaymentValid(payment.status)).forEach((payment) => {
      newValues.paymentsTotal += payment.baseAmount;
      newValues.tipsTotal += payment.tip;
    });
    check = __spreadProps(__spreadValues({}, check), {
      subtotal: newValues.subtotal,
      totalItemDiscounts: newValues.totalItemDiscounts,
      totalSpecialDiscounts: newValues.totalSpecialDiscounts,
      tax: newValues.tax,
      specialsDetails: {},
      discountsDetails: {}
    });
    check.totalDiscounts = newValues.totalItemDiscounts + newValues.totalSpecialDiscounts;
    check.balancePaid = newValues.paymentsTotal;
    check.tip = newValues.tipsTotal;
    check.total = check.subtotal + check.tax - check.totalDiscounts;
    check.balanceDue = check.total - check.balancePaid;
    check.serviceChargeTotal = 0;
    check.serviceChargeTaxApplied = 0;
    if (checkStatusAllowsEditing(check.status)) {
      openChecksSubTotal += check.subtotal + check.tax;
    }
    _order.checks[getCheckId(check)] = check;
  });
  filteredChecks = getFilteredChecks();
  filteredChecks.forEach((check) => {
    if (!checkStatusAllowsEditing(check.status, isOrderClosed(_order)))
      return;
    if (check.status === "closed" /* CLOSED */) {
      const closedCheckDiscounts = check.appliedOrderSpecialAmount + check.totalOrderDiscounts;
      check.totalDiscounts += closedCheckDiscounts;
      check.total -= closedCheckDiscounts;
      check.balanceDue -= closedCheckDiscounts;
      _order.checks[getCheckId(check)] = check;
      return;
    }
    const checkRatio = (check.subtotal + check.tax) / openChecksSubTotal || 0;
    let orderSpecialsAmount = 0;
    orderSpecialsToDistribute.forEach((special) => {
      if (!check.specialsDetails)
        check.specialsDetails = {};
      check.specialsDetails[special.id] = __spreadProps(__spreadValues({}, special), {
        appliedAmount: special.appliedAmount * checkRatio
      });
      orderSpecialsAmount += special.appliedAmount * checkRatio;
    });
    let orderDiscountsAmount = 0;
    orderDiscountsToDistribute.forEach((discount) => {
      if (!check.discountsDetails)
        check.discountsDetails = {};
      check.discountsDetails[discount.id] = __spreadProps(__spreadValues({}, discount), {
        appliedAmount: discount.appliedAmount * checkRatio
      });
      orderDiscountsAmount += discount.appliedAmount * checkRatio;
    });
    check.appliedOrderSpecialAmount = orderSpecialsAmount;
    check.totalOrderDiscounts = orderDiscountsAmount;
    if (orderSpecialsAmount > 0 || orderDiscountsAmount > 0) {
      check.totalSpecialDiscounts += orderSpecialsAmount;
      const orderDiscountsAndSpecialsAmount = orderSpecialsAmount + orderDiscountsAmount;
      check.totalDiscounts += orderDiscountsAndSpecialsAmount;
      check.total -= orderDiscountsAndSpecialsAmount;
      check.balanceDue -= orderDiscountsAndSpecialsAmount;
      _order.checks[getCheckId(check)] = check;
    }
  });
  if (!skipServiceCharges) {
    updateChecksServiceChargeDistribution(_order);
  }
  if (shouldAdjustChecksStatus) {
    adjustChecksStatus(_order);
  }
};
var updateChecksServiceChargeDistribution = (_order) => {
  var _a;
  const editableChecks = Object.values(_order.checks).filter(
    (check) => checkStatusAllowsEditing(check.status, isOrderClosed(_order)) && getCheckId(check) !== _order.defaultCheckId
  );
  const unassignedCheckSubtotalAmount = ((_a = _order.checks[_order.defaultCheckId]) == null ? void 0 : _a.subtotal) || 0;
  const orderTotalDiscount = _order.totalDiscountsAndSpecials;
  const orderUsefulSubtotal = _order.subtotal - unassignedCheckSubtotalAmount;
  const customServiceChargeValues = Object.values(
    _order.serviceChargeDetails
  ).reduce(
    (acc, serviceChargeDetails) => {
      if (serviceChargeDetails.chargeType !== "custom_dollar" /* CUSTOM_DOLLAR */ && serviceChargeDetails.chargeType !== "custom_percent" /* CUSTOM_PERCENT */)
        return acc;
      acc.serviceChargeTotal += serviceChargeDetails.appliedServiceCharge;
      acc.taxTotal += serviceChargeDetails.taxAmount;
      return acc;
    },
    { serviceChargeTotal: 0, taxTotal: 0 }
  );
  const percentileServiceChargeValues = Object.values(
    _order.serviceChargeDetails
  ).reduce(
    (acc, serviceChargeDetails) => {
      if (serviceChargeDetails.chargeType !== "percent" /* PERCENT */)
        return acc;
      let orderSubTotal = orderUsefulSubtotal;
      if (serviceChargeDetails.discount === "post discount" /* POST_DISCOUNT */) {
        orderSubTotal -= orderTotalDiscount;
      }
      let serviceChargeAmount = 0;
      if (orderSubTotal === _order.subtotal) {
        serviceChargeAmount = serviceChargeDetails.appliedServiceCharge;
      } else {
        serviceChargeAmount = roundToCentesimal(
          orderSubTotal * (serviceChargeDetails.charge / 100)
        );
        if (serviceChargeAmount > serviceChargeDetails.appliedServiceCharge)
          serviceChargeAmount = serviceChargeDetails.appliedServiceCharge;
      }
      acc.serviceChargeTotal += serviceChargeAmount;
      let taxAmount = 0;
      serviceChargeDetails.taxIds.forEach((taxId) => {
        var _a2;
        const currentTaxSource = _order.serviceChargeTaxesSource[taxId];
        const currentTaxDetails = serviceChargeDetails.taxDetails[taxId];
        if (!currentTaxSource || !currentTaxDetails)
          return;
        if (currentTaxSource.taxType === "percent" /* PERCENT */ && orderSubTotal !== _order.subtotal) {
          taxAmount = roundToCentesimal(
            serviceChargeAmount * ((((_a2 = currentTaxSource.typeData) == null ? void 0 : _a2.rate) || 0) / 100)
          );
          if (taxAmount > currentTaxDetails.totalAmount)
            taxAmount = currentTaxDetails.totalAmount;
        } else {
          taxAmount = currentTaxDetails.totalAmount;
        }
        acc.taxTotal += taxAmount;
      });
      return acc;
    },
    { serviceChargeTotal: 0, taxTotal: 0 }
  );
  const fixServiceChargeValues = Object.values(
    _order.serviceChargeDetails
  ).reduce(
    (acc, serviceChargeDetails) => {
      if (serviceChargeDetails.chargeType !== "fixed" /* FIXED */)
        return acc;
      acc.serviceChargeTotal += serviceChargeDetails.charge;
      let taxAmount = 0;
      serviceChargeDetails.taxIds.forEach((taxId) => {
        const currentTaxDetails = serviceChargeDetails.taxDetails[taxId];
        taxAmount = currentTaxDetails.totalAmount;
        acc.taxTotal += taxAmount;
      });
      return acc;
    },
    { serviceChargeTotal: 0, taxTotal: 0 }
  );
  let totalAppliedServiceCharge = percentileServiceChargeValues.serviceChargeTotal + fixServiceChargeValues.serviceChargeTotal + customServiceChargeValues.serviceChargeTotal;
  let totalAppliedServiceChargeTax = percentileServiceChargeValues.taxTotal + fixServiceChargeValues.taxTotal + customServiceChargeValues.taxTotal;
  if (totalAppliedServiceCharge > _order.serviceChargeTotal) {
    totalAppliedServiceCharge = _order.serviceChargeTotal;
  }
  if (totalAppliedServiceChargeTax > _order.serviceChargeTaxTotal) {
    totalAppliedServiceChargeTax = _order.serviceChargeTaxTotal;
  }
  let paidServiceCharge = 0;
  let paidServiceChargeTax = 0;
  Object.values(_order.checks).forEach((check) => {
    if (check.status === "closed" /* CLOSED */ && getCheckId(check) !== _order.defaultCheckId) {
      paidServiceCharge += check.serviceChargeTotal;
      paidServiceChargeTax += check.serviceChargeTaxApplied;
    }
  });
  if (editableChecks.length === 0) {
    const check = _order.checks[_order.defaultCheckId];
    if (!checkStatusAllowsEditing(check.status, isOrderClosed(_order)))
      return;
    check.serviceChargeTotal = _order.serviceChargeTotal - paidServiceCharge;
    check.tax += _order.serviceChargeTaxTotal - paidServiceChargeTax;
    check.serviceChargeTaxApplied = _order.serviceChargeTaxTotal - paidServiceChargeTax;
    check.total += _order.serviceChargeTotal - paidServiceCharge + _order.serviceChargeTaxTotal - paidServiceChargeTax;
    check.balanceDue = check.total - check.balancePaid;
    return;
  }
  let editableCheckIdAndCheckTotalsMap = {};
  let serviceChargeAssigned = 0;
  let taxAssigned = 0;
  editableChecks.forEach((check) => {
    const serviceChargeRatio = roundToCentesimal(check.subtotal / orderUsefulSubtotal) || 0;
    const serviceChargeValue = serviceChargeRatio === 0 ? 0 : Math.floor(totalAppliedServiceCharge * 100 * serviceChargeRatio) / 100 || 0;
    const taxValue = serviceChargeRatio === 0 ? 0 : Math.floor(totalAppliedServiceChargeTax * 100 * serviceChargeRatio) / 100 || 0;
    serviceChargeAssigned += serviceChargeValue;
    taxAssigned += taxValue;
    editableCheckIdAndCheckTotalsMap[getCheckId(check)] = {
      checkId: getCheckId(check),
      serviceChargeRatio,
      serviceChargeValue,
      checkTotal: check.total + serviceChargeValue + taxValue,
      taxValue
    };
  });
  const diffServiceChargeToDistribute = totalAppliedServiceCharge - serviceChargeAssigned - paidServiceCharge;
  const centsToDistributeServiceCharge = Math.round(
    diffServiceChargeToDistribute * 100
  );
  const diffTaxToDistribute = totalAppliedServiceChargeTax - taxAssigned - paidServiceChargeTax;
  const centsToDistributeTax = Math.round(diffTaxToDistribute * 100);
  const amountsToDistribute = {
    serviceCharge: centsToDistributeServiceCharge,
    tax: centsToDistributeTax
  };
  if (centsToDistributeServiceCharge === 0 && centsToDistributeTax === 0) {
    _order.checks[_order.defaultCheckId].serviceChargeTotal = 0;
    _order.checks[_order.defaultCheckId].serviceChargeTaxApplied = 0;
    Object.values(editableCheckIdAndCheckTotalsMap).forEach(
      ({ checkId, serviceChargeValue, taxValue }) => {
        const check = _order.checks[checkId];
        check.serviceChargeTotal = serviceChargeValue;
        check.tax += taxValue;
        check.serviceChargeTaxApplied = taxValue;
        check.total += serviceChargeValue + taxValue;
        check.balanceDue = check.total - check.balancePaid;
        _order.checks[checkId] = check;
      }
    );
    return;
  }
  const filteredEditableCheckIdAndCheckTotalsMapArray = Object.values(
    editableCheckIdAndCheckTotalsMap
  ).filter((checkData) => checkData.serviceChargeRatio > 0);
  if (filteredEditableCheckIdAndCheckTotalsMapArray.length === 0) {
    _order.checks[_order.defaultCheckId].serviceChargeTotal += totalAppliedServiceCharge;
    _order.checks[_order.defaultCheckId].tax += totalAppliedServiceChargeTax;
    _order.checks[_order.defaultCheckId].serviceChargeTaxApplied += totalAppliedServiceChargeTax;
    _order.checks[_order.defaultCheckId].total += totalAppliedServiceCharge + totalAppliedServiceChargeTax;
    _order.checks[_order.defaultCheckId].balanceDue = _order.checks[_order.defaultCheckId].total - _order.checks[_order.defaultCheckId].balancePaid;
    return;
  }
  _order.checks[_order.defaultCheckId].serviceChargeTotal = 0;
  _order.checks[_order.defaultCheckId].serviceChargeTaxApplied = 0;
  const sortChecksByTotal = (a, b) => {
    return a.checkTotal - b.checkTotal;
  };
  const sortChecksByServiceCharge = (a, b) => {
    return a.serviceChargeValue - b.serviceChargeValue;
  };
  const sortChecksByTax = (a, b) => {
    return a.taxValue - b.taxValue;
  };
  Object.entries(amountsToDistribute).forEach(([key, amountToDistribute]) => {
    if (amountToDistribute === 0)
      return;
    const isTax = key === "tax";
    const sortValueFunction = isTax ? sortChecksByTax : sortChecksByServiceCharge;
    filteredEditableCheckIdAndCheckTotalsMapArray.sort(sortValueFunction).sort(sortChecksByTotal);
    for (let iteration = 0; iteration < amountToDistribute; iteration++) {
      const currentCheck = filteredEditableCheckIdAndCheckTotalsMapArray[0];
      currentCheck[isTax ? "taxValue" : "serviceChargeValue"] = (currentCheck[isTax ? "taxValue" : "serviceChargeValue"] * 100 + 1) / 100;
      currentCheck.checkTotal = (currentCheck.checkTotal * 100 + 1) / 100;
      filteredEditableCheckIdAndCheckTotalsMapArray.sort(sortValueFunction).sort(sortChecksByTotal);
    }
  });
  const filteredEditableCheckIdAndCheckTotalsMap = {};
  filteredEditableCheckIdAndCheckTotalsMapArray.forEach((checkData) => {
    filteredEditableCheckIdAndCheckTotalsMap[checkData.checkId] = checkData;
  });
  editableCheckIdAndCheckTotalsMap = __spreadValues(__spreadValues({}, editableCheckIdAndCheckTotalsMap), filteredEditableCheckIdAndCheckTotalsMap);
  Object.values(editableCheckIdAndCheckTotalsMap).forEach(
    ({ checkId, serviceChargeValue, taxValue }) => {
      const check = _order.checks[checkId];
      check.serviceChargeTotal = serviceChargeValue;
      check.tax += taxValue;
      check.serviceChargeTaxApplied = taxValue;
      check.total += serviceChargeValue + taxValue;
      check.balanceDue = check.total - check.balancePaid;
    }
  );
};
var getChecksIdsForTicketElement = (ticketElementToCheckElementsId, ticketElementToCheckElements) => {
  const checksIds = ticketElementToCheckElements[ticketElementToCheckElementsId].map((ticketElementChecksData) => ticketElementChecksData.checkId);
  return [...new Set(checksIds)];
};
var splitDefaultCheckBySeat = (_order) => {
  const defaultCheck = _order.checks[_order.defaultCheckId];
  if (!defaultCheck)
    return _order;
  splitCheckElementsBySeat(_order, Object.values(defaultCheck.checkElements), [
    _order.defaultCheckId
  ]);
  return _order;
};
var splitDefaultCheckInNWays = (_order, ways, checkElementIds) => {
  const defaultCheck = _order.checks[_order.defaultCheckId];
  let hasCheckElementsSelected = false;
  if (!defaultCheck)
    return _order;
  if (checkElementIds) {
    checkElementIds = checkElementIds.filter(
      (checkElementId) => !!defaultCheck.checkElements[checkElementId]
    );
    if (checkElementIds.length === 0)
      return _order;
    else
      hasCheckElementsSelected = true;
  }
  for (let iteration = 0; iteration < ways; iteration++) {
    const newCheck = createCheck2(_order);
    _order.checks[getCheckId(newCheck)] = newCheck;
    Object.values(defaultCheck.checkElements).forEach((checkElement) => {
      if (hasCheckElementsSelected && !(checkElementIds == null ? void 0 : checkElementIds.includes(getCheckElementId(checkElement))))
        return;
      if (!_order.ticketElementToCheckElements[checkElement.ticketElementToCheckElementsId]) {
        _order.ticketElementToCheckElements[checkElement.ticketElementToCheckElementsId] = [];
      }
      const newFraction = sumAndSimplifyFractions([
        {
          numerator: checkElement.splitGrouped,
          denominator: ways * (checkElement.splitWays || 1)
        }
      ]);
      const newCheckElement = createCheckElement(__spreadProps(__spreadValues({}, checkElement), {
        checkId: getCheckId(newCheck),
        splitWays: newFraction.denominator,
        splitGrouped: Number(newFraction.numerator || 0) + newFraction.unit * Number(newFraction.denominator || 1),
        displayFraction: getDisplayedFraction(newFraction),
        eachPrice: checkElement.price
      }));
      const newTicketElementToCheckElementObject = createTicketElementToCheckElements(newCheckElement);
      _order.ticketElementToCheckElements[checkElement.ticketElementToCheckElementsId] = [
        ..._order.ticketElementToCheckElements[checkElement.ticketElementToCheckElementsId].filter(
          ({ checkElementId }) => checkElementId !== getCheckElementId(checkElement)
        ),
        newTicketElementToCheckElementObject
      ];
      newCheck.checkElements[getCheckElementId(newCheckElement)] = newCheckElement;
    });
  }
  Object.entries(_order.ticketElementToCheckElements).forEach(
    ([ticketElementToCheckElementsId, ticketElementToCheckElements]) => {
      const baseCheckElement = Object.values(defaultCheck.checkElements).find(
        (checkElement) => checkElement.ticketElementToCheckElementsId === ticketElementToCheckElementsId
      );
      if (baseCheckElement === void 0 || hasCheckElementsSelected && !(checkElementIds == null ? void 0 : checkElementIds.includes(getCheckElementId(baseCheckElement))))
        return;
      const isCombo = !!baseCheckElement.comboElementId;
      const ticketElementId = String(
        isCombo ? baseCheckElement.comboElementId : baseCheckElement.ticketElementId
      );
      const ticketElement = isCombo ? _order.combos[ticketElementId] : _order.ticketElements[ticketElementId];
      const price = (ticketElement.isPriceOverride ? ticketElement.overridePricePerItemUnit : ticketElement.totalPricePerItemUnit) * ticketElement.quantity;
      const discountsDetails = Object.values(ticketElement.discounts).map((_discount) => ({
        id: _discount.discountId,
        appliedAmount: _discount.appliedDiscountAmount,
        name: _discount.posName,
        checkName: _discount.checkName,
        type: _discount.type,
        discountOrSpecialValue: _discount.value
      })).filter((_discount) => _discount.appliedAmount > 0).reduce(
        (acc, _discount) => {
          acc[_discount.id] = _discount;
          return acc;
        },
        {}
      );
      const specialsDetails = Object.values(ticketElement.specials).map((special) => ({
        id: special.specialId,
        appliedAmount: special.appliedSpecialAmount,
        name: special.posName,
        checkName: special.checkName,
        type: special.type,
        discountOrSpecialValue: special.discountedAmount
      })).filter((special) => special.appliedAmount > 0).reduce(
        (acc, _special) => {
          acc[_special.id] = _special;
          return acc;
        },
        {}
      );
      const tax = ticketElement.totalTax;
      overrideCheckElementFields(
        _order,
        ticketElementId,
        {
          tax: 0,
          price: 0,
          discount: 0,
          specialAmount: 0
        },
        isCombo
      );
      updateChecksTotals(_order, void 0, true);
      distributeValuesForTicketElementToCheckElements(
        _order,
        {
          tax,
          price,
          discountsDetails,
          specialsDetails
        },
        ticketElementToCheckElements,
        ticketElementToCheckElements.length,
        [_order.defaultCheckId],
        false,
        false
      );
    }
  );
  if (hasCheckElementsSelected) {
    checkElementIds == null ? void 0 : checkElementIds.forEach((checkElementId) => {
      delete _order.checks[_order.defaultCheckId].checkElements[checkElementId];
    });
  } else {
    _order.checks[_order.defaultCheckId].checkElements = {};
  }
  _order.checks[_order.defaultCheckId].status = "open" /* OPEN */;
  updateChecksTotals(_order);
  autoTransferPaymentsBasedOnCheckBalanceDue(_order);
  return _order;
};
var splitDefaultCheckToExistingChecks = (_order) => {
  const defaultCheck = _order.checks[_order.defaultCheckId];
  if (!defaultCheck)
    return _order;
  if (Object.keys(_order.checks).length === 1)
    return;
  Object.values(defaultCheck.checkElements).forEach((checkElement) => {
    splitCheckElementToAllNonDefaultAvailableChecks(
      _order,
      getCheckElementId(checkElement),
      _order.defaultCheckId
    );
  });
  return _order;
};
var autoSplitChecks = (_order) => {
  switch (_order.splitMode) {
    case "EVENLY" /* EVENLY */: {
      splitDefaultCheckToExistingChecks(_order);
      break;
    }
    case "SEATS" /* SEATS */:
      splitDefaultCheckBySeat(_order);
      updateChecksTotals(_order);
      break;
  }
  resetDisplayCheckElements(_order);
  return _order;
};
var deleteEmptyChecks = (_order) => {
  const checks = _order.checks;
  Object.values(checks).filter((check) => getCheckId(check) !== _order.defaultCheckId).forEach((check) => {
    if (!checkStatusAllowsEditing(check.status) || !checkCanBeDeleted(check))
      return;
    const checkElementIds = Object.values(check.checkElements);
    if (checkElementIds.length === 0) {
      deleteEditableCheck2(_order, getCheckId(check));
    }
  });
  return _order;
};
var resetChecksData = (_order) => {
  Object.values(_order.checks).forEach((check) => {
    if (getCheckId(check) !== _order.defaultCheckId)
      deleteEditableCheck2(_order, getCheckId(check));
  });
  return _order;
};
var adjustIsInClosedCheckForTicketElements = (_order, ticketElementIds) => {
  Object.values(ticketElementIds).forEach(({ elementId, isCombo }) => {
    var _a;
    let newIsInClosedCheck = false;
    const element = isCombo ? _order.combos[elementId] : _order.ticketElements[elementId];
    if (!element)
      return;
    const ticketElementToCheckElementsId = element.ticketElementToCheckElementsId;
    for (const { checkId } of ((_a = _order.ticketElementToCheckElements) == null ? void 0 : _a[String(ticketElementToCheckElementsId)]) || []) {
      const check = _order.checks[checkId];
      if (check.status === "closed" /* CLOSED */) {
        newIsInClosedCheck = true;
        break;
      }
    }
    element.isInClosedCheck = newIsInClosedCheck;
  });
  return _order;
};
var setChecksStatus = (_order, checkIds, status) => {
  checkIds.forEach((checkId) => {
    const check = _order.checks[checkId];
    if (!check)
      return;
    check.status = status;
    if (status === "closed" /* CLOSED */) {
      Object.values(check.checkElements).forEach((checkElement) => {
        const isCombo = !!checkElement.comboElementId;
        const elementId = String(
          isCombo ? checkElement.comboElementId : checkElement.ticketElementId
        );
        if (isCombo && elementId in _order.combos) {
          _order.combos[elementId].isInClosedCheck = true;
        } else if (elementId in _order.ticketElements) {
          _order.ticketElements[elementId].isInClosedCheck = true;
        }
      });
    } else if (status === "paid" /* PAID */) {
      const affectedTicketElementIds = {};
      Object.values(check.checkElements).forEach((checkElement) => {
        const isCombo = !!checkElement.comboElementId;
        const elementId = String(
          isCombo ? checkElement.comboElementId : checkElement.ticketElementId
        );
        affectedTicketElementIds[elementId] = {
          elementId,
          isCombo
        };
      });
      adjustIsInClosedCheckForTicketElements(_order, affectedTicketElementIds);
    }
  });
  return _order;
};
var adjustChecksStatus = (_order, checkIds) => {
  const _checkIds = checkIds || Object.keys(_order.checks);
  _checkIds.forEach((checkId) => {
    const check = _order.checks[checkId];
    if (!check || getCheckId(check) === _order.defaultCheckId)
      return;
    if (Object.values(check.payments).filter(
      (payment) => isPaymentValid(payment.status)
    ).length === 0) {
      setChecksStatus(_order, [checkId], "open" /* OPEN */);
    } else if (check.balanceDue > ABSOLUTE_CERO) {
      setChecksStatus(_order, [checkId], "partiallyPaid" /* PARTIALLY_PAID */);
    } else if (check.status !== "paid" /* PAID */) {
      setChecksStatus(_order, [checkId], "closed" /* CLOSED */);
    }
  });
  return _order;
};
var mergeChecks2 = (_order, checksToMergeIds) => {
  if (checksToMergeIds.length < 2)
    return _order;
  const newCheck = createCheck2(_order);
  const newCheckId = getCheckId(newCheck);
  if (!newCheck)
    return _order;
  _order.checks[newCheckId] = newCheck;
  const newCheckSeating = /* @__PURE__ */ new Set();
  checksToMergeIds.forEach((checkId) => {
    const check = _order.checks[checkId];
    if (!check)
      return;
    if (check.seats) {
      check.seats.forEach((seatId) => {
        newCheckSeating.add(seatId);
      });
    }
    const checkElementIds = Object.values(check.checkElements).map(
      (checkElement) => getCheckElementId(checkElement)
    );
    transferCheckElements(_order, checkElementIds, newCheckId);
    delete _order.checks[checkId];
  });
  if (newCheckSeating.size > 0)
    _order.checks[newCheckId].seats = orderBy(
      Array.from(newCheckSeating),
      (seat) => seat
    );
  return _order;
};
var addCheckPayment2 = (_order, checkId, payment, replaceCheckId = true) => {
  const check = _order.checks[checkId || -1];
  if (!check)
    return _order;
  if (!check.payments) {
    check.payments = {};
  }
  check.payments[getEntityId(payment)] = payment;
  payment.tabletGeneratedCheckId = check.tabletGeneratedId;
  if (replaceCheckId && check.id !== Number(payment.checkId)) {
    check.id = Number(payment.checkId);
    _order.checks[payment.checkId] = check;
    delete _order.checks[checkId];
    Object.values(_order.ticketElementToCheckElements).forEach(
      (ticketElementToCheckElementsArray) => {
        ticketElementToCheckElementsArray.forEach(
          (ticketElementToCheckElement) => {
            if (ticketElementToCheckElement.checkId === checkId) {
              ticketElementToCheckElement.checkId = payment.checkId;
            }
          }
        );
      }
    );
    if (_order.defaultCheckId === checkId)
      _order.defaultCheckId = payment.checkId;
  }
  updateChecksTotals(_order);
  return _order;
};
var splitPaymentForCheck = (ways, check) => {
  const paymentSplittingArray = [];
  const totalToSplit = check.balanceDue;
  const twoDecimalsValue = Math.floor(totalToSplit / ways * 100) / 100;
  for (let iteration = 0; iteration < ways; iteration++) {
    paymentSplittingArray.push({
      amountToPay: twoDecimalsValue,
      paymentId: null
    });
  }
  const sortSplittingPaymentsArray = () => {
    paymentSplittingArray.sort((a, b) => a.amountToPay - b.amountToPay);
  };
  const getPaymentSplittingObject = () => {
    const paymentSplittingObject = {};
    paymentSplittingArray.forEach((payment, index) => {
      paymentSplittingObject[index + 1] = __spreadProps(__spreadValues({}, payment), { id: index + 1 });
    });
    return paymentSplittingObject;
  };
  const diffToAmountToDistribute = totalToSplit - twoDecimalsValue * ways;
  const centsToDistribute = Math.round(diffToAmountToDistribute * 100);
  if (centsToDistribute === 0)
    return getPaymentSplittingObject();
  for (let iteration = 0; iteration < centsToDistribute; iteration++) {
    sortSplittingPaymentsArray();
    paymentSplittingArray[0].amountToPay = (paymentSplittingArray[0].amountToPay * 100 + 1) / 100;
  }
  return getPaymentSplittingObject();
};

// src/helpers/register/checks/checkElements.ts
var generateCheckElementId = generateTabletGeneratedId;
var generateInstanceId = generateTabletGeneratedId;
var generateDisplayCheckElementId = generateTabletGeneratedId;
var getCheckElementId = (checkElement) => checkElement.tabletGeneratedId;
var createTicketElementToCheckElementObject = (element) => element;
var generateCheckElementsForTicketElementInstances = (order, ticketElementId, isCombo) => {
  var _a, _b, _c, _d;
  const element = isCombo ? (_a = order.combos) == null ? void 0 : _a[ticketElementId] : (_b = order.ticketElements) == null ? void 0 : _b[ticketElementId];
  if (!element)
    return [];
  const defaultCheckId = order.defaultCheckId;
  let itemId = TICKET_OPEN_ITEM_TYPE_ID;
  if (isCombo) {
    element.ticketElementToCheckElementsId = element.tabletGeneratedId;
    itemId = ((_c = element.comboObj) == null ? void 0 : _c.comboId) || -1;
  } else {
    element.ticketElementToCheckElementsId = element.tabletGeneratedId;
    itemId = ((_d = element.itemObj) == null ? void 0 : _d.itemId) || TICKET_OPEN_ITEM_TYPE_ID;
  }
  const defaultCheck = order.checks[defaultCheckId];
  if (!defaultCheck)
    return [];
  const ticketElementSeats = Object.entries(cloneDeep(element.seating));
  return element.instanceIds.map((instanceId) => {
    var _a2, _b2, _c2, _d2;
    const newCheckElement = createCheckElement({
      splitGrouped: 1,
      splitWays: 1,
      [isCombo ? "comboElementId" : "ticketElementId"]: ticketElementId,
      ticketElementToCheckElementsId: element.tabletGeneratedId,
      instanceId,
      checkId: defaultCheckId,
      quantity: 1,
      itemCount: 1,
      itemId,
      name: isCombo ? (_b2 = (_a2 = element.comboObj) == null ? void 0 : _a2.name) != null ? _b2 : "" : (_d2 = (_c2 = element.itemObj) == null ? void 0 : _c2.name) != null ? _d2 : ""
    });
    if (ticketElementSeats.length) {
      const currentSeat = ticketElementSeats[0][0];
      newCheckElement.seats = { [currentSeat]: 1 };
      ticketElementSeats[0][1] = ticketElementSeats[0][1] - 1;
      if (ticketElementSeats[0][1] === 0) {
        ticketElementSeats.shift();
      }
    }
    return newCheckElement;
  });
};
var addCheckElementsInDefaultCheckToOrder = (order, ticketElementId, isCombo) => {
  if (!order.defaultCheckId)
    return;
  const defaultCheckId = order.defaultCheckId;
  const defaultCheck = order.checks[defaultCheckId];
  const newCheckElements = generateCheckElementsForTicketElementInstances(
    order,
    ticketElementId,
    isCombo
  );
  const newTicketElementToCheckElements = [];
  newCheckElements.forEach((checkElement) => {
    const checkElementId = checkElement.tabletGeneratedId;
    defaultCheck.checkElements[checkElementId] = checkElement;
    defaultCheck.itemCount += checkElement.itemCount;
    newTicketElementToCheckElements.push(
      createTicketElementToCheckElementObject({
        checkId: defaultCheckId,
        checkElementId,
        instanceId: checkElement.instanceId
      })
    );
  });
  order.ticketElementToCheckElements[ticketElementId] = newTicketElementToCheckElements;
};
var updateCheckElement = (_check, _checkElement, deltas) => {
  const check = cloneDeep(_check);
  const checkElement = cloneDeep(_checkElement);
  updateCheckElementItemCount(deltas.itemCount, check, checkElement);
  updateCheckElementName(deltas.name, check, checkElement);
  updateCheckElementSeats(deltas.seats, check, checkElement);
  updateCheckElementEachPrice(deltas.eachPrice, check, checkElement);
  updateCheckElementPrice(deltas.price, check, checkElement);
  updateCheckElementDiscount(deltas.discount, check, checkElement);
  updateCheckElementSpecial(deltas.specialAmount, check, checkElement);
  updateCheckElementTax(deltas.tax, check, checkElement);
  updateCheckElementIsShared(deltas.isShared, check, checkElement);
  updateCheckElementDisplayFraction(checkElement);
  updateCheckElementItemId(checkElement, deltas.itemId);
  return { check, checkElement };
};
var deleteCheckElementsFromCheck = (_check, checkElementIds) => {
  const check = cloneDeep(_check);
  checkElementIds.forEach((id) => {
    delete check.checkElements[id];
  });
  return check.checkElements;
};
var deleteDisplayCheckElementFromCheck = (_check, displayCheckElementId) => {
  const check = cloneDeep(_check);
  if (!(displayCheckElementId in check.displayCheckElements)) {
    return check.displayCheckElements;
  }
  delete check.displayCheckElements[displayCheckElementId];
  return check.displayCheckElements;
};
var deleteCheckElementAndUpdateCheck = (_check, checkElement) => {
  if (!checkElement)
    return cloneDeep(_check);
  const { check } = updateCheckElement(_check, checkElement, {
    name: "",
    itemCount: -checkElement.itemCount,
    discount: -checkElement.discount,
    specialAmount: -checkElement.specialAmount,
    eachPrice: -checkElement.eachPrice,
    price: -checkElement.price,
    quantity: -checkElement.quantity,
    tax: -checkElement.tax,
    seats: {},
    isShared: false
  });
  check.checkElements = deleteCheckElementsFromCheck(check, [
    getCheckElementId(checkElement)
  ]);
  return check;
};
var deleteTicketElementCheckElementsFromChecks = (order, ticketElementId) => {
  var _a;
  const ticketElementToCheckElementsId = (_a = order.ticketElements[ticketElementId]) == null ? void 0 : _a.ticketElementToCheckElementsId;
  if (!ticketElementToCheckElementsId)
    return;
  const ticketElementToCheckElements = order.ticketElementToCheckElements[ticketElementToCheckElementsId];
  if (!ticketElementToCheckElements)
    return;
  Object.values(ticketElementToCheckElements).forEach(
    ({ checkId, checkElementId }) => {
      const check = order.checks[checkId];
      if (!check)
        return;
      order.checks[checkId] = deleteCheckElementAndUpdateCheck(
        check,
        check.checkElements[checkElementId]
      );
    }
  );
};
var deleteTicketElementToCheckElements = (_order, ticketElementToCheckElementsId) => {
  ticketElementToCheckElementsId.forEach((id) => {
    delete _order.ticketElementToCheckElements[id];
  });
  return _order.ticketElementToCheckElements;
};
var deleteTicketElementFromChecksData = (order, ticketElementId) => {
  var _a, _b;
  deleteTicketElementCheckElementsFromChecks(order, ticketElementId);
  const ticketElementToCheckElementsId = (_b = (_a = order.ticketElements[ticketElementId]) == null ? void 0 : _a.ticketElementToCheckElementsId) != null ? _b : "";
  order.ticketElementToCheckElements = deleteTicketElementToCheckElements(
    order,
    [ticketElementToCheckElementsId]
  );
};
var deleteComboElementFromOrder = (order, comboElementId) => {
  var _a;
  deleteTicketElementCheckElementsFromChecks(order, comboElementId);
  const comboElement = order.combos[comboElementId];
  Object.values(comboElement.itemGroupsSelected).forEach((itemGroupSelected) => {
    var _a2;
    delete order.ticketElements[(_a2 = itemGroupSelected.ticketElementId) != null ? _a2 : ""];
  });
  delete order.ticketElementToCheckElements[(_a = comboElement.ticketElementToCheckElementsId) != null ? _a : ""];
  delete order.combos[comboElementId];
};
var createCheckElement = (checkElementDefaults = {}) => __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, CHECK_ELEMENT_INITIAL_STATE), {
  comboItemNames: {}
}), checkElementDefaults), {
  tabletGeneratedId: generateCheckElementId()
});
var createDisplayCheckElement = (checkElement, defaults) => {
  let newDisplayCheckElement = {};
  if (checkElement === void 0 || isEmpty(checkElement)) {
    newDisplayCheckElement = __spreadProps(__spreadValues(__spreadValues({}, DISPLAY_CHECK_ELEMENT_INITIAL_STATE), defaults), {
      tabletGeneratedId: generateDisplayCheckElementId()
    });
  } else {
    newDisplayCheckElement = __spreadProps(__spreadValues({}, DISPLAY_CHECK_ELEMENT_INITIAL_STATE), {
      tabletGeneratedId: generateDisplayCheckElementId(),
      itemId: checkElement.itemId,
      itemName: checkElement.name,
      eachPrice: checkElement.eachPrice,
      totalPrice: checkElement.price,
      totalDiscount: checkElement.discount,
      totalSpecialAmount: checkElement.specialAmount,
      displayFraction: checkElement.displayFraction,
      splitGrouped: checkElement.splitGrouped,
      splitWays: checkElement.splitWays,
      rolledUpCheckElementsQty: 1,
      totalQty: 1,
      comboItemNames: checkElement.comboItemNames,
      rolledUpCheckElements: {
        [getCheckElementId(checkElement)]: {
          checkElementId: getCheckElementId(checkElement),
          discount: checkElement.discount,
          specialAmount: checkElement.specialAmount,
          splitGrouped: checkElement.splitGrouped,
          splitWays: checkElement.splitWays,
          price: checkElement.price
        }
      },
      discountsDetails: checkElement.discountsDetails,
      specialsDetails: checkElement.specialsDetails
    });
    if (checkElement.ticketElementId) {
      newDisplayCheckElement.ticketElementId = checkElement.ticketElementId;
    } else if (checkElement.comboElementId) {
      newDisplayCheckElement.comboElementId = checkElement.comboElementId;
    }
  }
  return cloneDeep(newDisplayCheckElement);
};
var getToSkipCheckElementIds = (_order) => {
  const onHoldCheckElementIds = /* @__PURE__ */ new Set();
  if (!_order)
    return onHoldCheckElementIds;
  Object.values(_order.ticketElements).forEach((ticketElement) => {
    var _a;
    if (ticketElement.comboElementId)
      return;
    if (!ticketElement.isOnHold && !(ticketElement.totalPriceWithDiscountsSpecialsNotTaxes === 0 && ticketElement.totalTax === 0 && ((_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[ticketElement.isOpenItem ? 0 : ticketElement.menuTypeId].removeFromCheck)))
      return;
    const ticketElementToCheckElementsId = ticketElement.ticketElementToCheckElementsId;
    _order.ticketElementToCheckElements[ticketElementToCheckElementsId].forEach(
      (ticketElementToCheckElement) => {
        onHoldCheckElementIds.add(ticketElementToCheckElement.checkElementId);
      }
    );
  });
  return onHoldCheckElementIds;
};
var generateDisplayCheckElements = (_order, checkIds) => {
  if (!_order)
    return;
  const toSkipCheckElementIds = getToSkipCheckElementIds(_order);
  const checksToGenerateDisplayCheckElementsIds = checkIds || Object.keys(_order.checks);
  checksToGenerateDisplayCheckElementsIds.forEach((checkId) => {
    const check = _order.checks[checkId];
    if (!check)
      return;
    const displayCheckElements = {};
    Object.values(check.checkElements).forEach((checkElement) => {
      if (toSkipCheckElementIds.has(checkElement.tabletGeneratedId))
        return;
      const displayCheckElement = createDisplayCheckElement(checkElement);
      displayCheckElements[displayCheckElement.tabletGeneratedId] = displayCheckElement;
    });
    _order.checks[checkId].displayCheckElements = displayCheckElements;
  });
};
var createTicketElementToCheckElements = (checkElement) => ({
  checkId: checkElement.checkId,
  checkElementId: checkElement.tabletGeneratedId,
  instanceId: checkElement.instanceId
});
var getComboElementItemNames = (order, _element) => {
  const comboItemNames = {};
  Object.values(_element.itemGroupsSelected).forEach((itemGroupSelected) => {
    var _a;
    const selectedTicketElementId = itemGroupSelected.ticketElementId;
    if (!selectedTicketElementId)
      return;
    const selectedTicketElementName = Object.values(
      ((_a = order.ticketElements[String(selectedTicketElementId)].itemObj) == null ? void 0 : _a.menuTypeVersions) || {}
    )[0].posName;
    comboItemNames[selectedTicketElementId] = selectedTicketElementName;
  });
  return comboItemNames;
};
var createCheckDataForTicketElement = (_order, destinationCheckId, ticketElementId, isCombo, seatId, quantity, newCheckElementOverrideValues) => {
  var _a, _b, _c, _d, _e, _f, _g;
  if (!(destinationCheckId in _order.checks))
    return;
  const element = isCombo ? (_a = _order.combos) == null ? void 0 : _a[ticketElementId] : (_b = _order.ticketElements) == null ? void 0 : _b[ticketElementId];
  if (!element)
    return;
  let instanceIds = [];
  if (quantity) {
    instanceIds = Array.from(new Array(quantity), () => generateInstanceId());
    element.instanceIds = [...element.instanceIds || [], ...instanceIds];
  } else {
    instanceIds = element.instanceIds;
  }
  let itemId = TICKET_OPEN_ITEM_TYPE_ID;
  const newValues = {
    price: 0,
    tax: 0,
    discount: 0,
    specialAmount: 0,
    comboItemNames: {}
  };
  if (isCombo) {
    const _element = element;
    _element.ticketElementToCheckElementsId = element.tabletGeneratedId;
    itemId = ((_c = _element.comboObj) == null ? void 0 : _c.comboId) || -1;
    newValues.price = _element.totalPricePerItemUnit;
    newValues.tax = _element.totalTax;
    newValues.discount = _element.totalDiscountAmount;
    newValues.specialAmount = (_d = _element == null ? void 0 : _element.totalSpecialsAmount) != null ? _d : 0;
    newValues.comboItemNames = getComboElementItemNames(_order, _element);
  } else {
    const _element = element;
    _element.ticketElementToCheckElementsId = element.tabletGeneratedId;
    itemId = ((_e = _element.itemObj) == null ? void 0 : _e.itemId) || TICKET_OPEN_ITEM_TYPE_ID;
    newValues.price = _element.isPriceOverride ? _element.overridePricePerItemUnit : _element.totalPricePerItemUnit;
    newValues.tax = _element.totalTax;
    newValues.discount = _element.totalDiscountAmount;
    newValues.specialAmount = ((_f = _element.totalSpecialsAmount) != null ? _f : 0) + ((_g = _element.totalSpecialsBOGOAmount) != null ? _g : 0);
  }
  instanceIds.forEach((instanceId) => {
    var _a2, _b2, _c2, _d2;
    const checkElement = createCheckElement(__spreadValues(__spreadValues({
      displayFraction: "1",
      splitGrouped: 1,
      splitWays: 1,
      [isCombo ? "comboElementId" : "ticketElementId"]: ticketElementId,
      ticketElementToCheckElementsId: element.tabletGeneratedId,
      instanceId,
      checkId: destinationCheckId,
      quantity: 1,
      itemCount: 1,
      itemId,
      name: isCombo ? (_b2 = (_a2 = element.comboObj) == null ? void 0 : _a2.name) != null ? _b2 : "" : (_d2 = (_c2 = element.itemObj) == null ? void 0 : _c2.name) != null ? _d2 : "",
      eachPrice: newValues.price
    }, newValues), newCheckElementOverrideValues));
    if (isEmpty(checkElement.seats))
      checkElement.seats = seatId ? { [seatId]: 1 } : {};
    if (!seatId && !!element.isShared) {
      checkElement.isShared = !!element.isShared;
      checkElement.seats = element.seating;
    }
    _order.checks[destinationCheckId].checkElements[checkElement.tabletGeneratedId] = checkElement;
    if (!_order.ticketElementToCheckElements[element.ticketElementToCheckElementsId]) {
      _order.ticketElementToCheckElements[element.ticketElementToCheckElementsId] = [];
    }
    _order.ticketElementToCheckElements[element.ticketElementToCheckElementsId].push(createTicketElementToCheckElements(checkElement));
  });
};
var overrideCheckElementFields = (_order, ticketElementId, fieldsToUpdate, isCombo = false) => {
  var _a, _b, _c;
  const ticketElement = isCombo ? (_a = _order.combos) == null ? void 0 : _a[ticketElementId] : (_b = _order.ticketElements) == null ? void 0 : _b[ticketElementId];
  if (!ticketElement)
    return;
  const ticketElementToCheckElements = (_c = _order.ticketElementToCheckElements[ticketElement.ticketElementToCheckElementsId]) != null ? _c : [];
  ticketElementToCheckElements.forEach(({ checkId, checkElementId }) => {
    const check = _order.checks[checkId];
    if (!check)
      return;
    const checkElement = check.checkElements[checkElementId];
    if (!check.checkElements[checkElementId])
      return;
    check.checkElements[checkElementId] = __spreadValues(__spreadValues({}, checkElement), fieldsToUpdate);
  });
};
var removeCheckDataForTicketElement = (_order, ticketElementId, isCombo, seatId, quantity, keepInstances) => {
  var _a, _b, _c;
  const element = isCombo ? (_a = _order.combos) == null ? void 0 : _a[ticketElementId] : (_b = _order.ticketElements) == null ? void 0 : _b[ticketElementId];
  if (!element)
    return;
  const ticketElementToCheckElements = ((_c = _order.ticketElementToCheckElements) == null ? void 0 : _c[String(element.ticketElementToCheckElementsId)]) || [];
  const instanceIdsToRemove = /* @__PURE__ */ new Set();
  for (const { checkId } of ticketElementToCheckElements) {
    if (quantity && instanceIdsToRemove.size === quantity)
      break;
    const check = _order.checks[checkId];
    if (!check)
      continue;
    for (const checkElement of Object.values(check.checkElements)) {
      if (quantity && instanceIdsToRemove.size === quantity)
        break;
      if ((!seatId || checkElement.seats[seatId]) && (isCombo ? checkElement.comboElementId === ticketElementId : checkElement.ticketElementId === ticketElementId)) {
        instanceIdsToRemove.add(checkElement.instanceId);
      }
    }
  }
  Array.from(instanceIdsToRemove).forEach((instanceIdToRemove) => {
    const checksDataForInstanceId = ticketElementToCheckElements.filter(
      ({ instanceId }) => instanceId === instanceIdToRemove
    );
    checksDataForInstanceId.forEach(({ checkId, checkElementId }) => {
      const check = _order.checks[checkId];
      if (!check)
        return;
      delete check.checkElements[checkElementId];
    });
  });
  _order.ticketElementToCheckElements[String(element.ticketElementToCheckElementsId)] = ticketElementToCheckElements.filter(
    ({ instanceId }) => !instanceIdsToRemove.has(instanceId)
  );
  if (!keepInstances) {
    element.instanceIds = element.instanceIds.filter(
      (instanceId) => !instanceIdsToRemove.has(instanceId)
    );
  }
};
var cleanDisplayCheckElements2 = (_order, checkIds) => {
  if (!_order)
    return;
  const checksToCleanIds = checkIds || Object.keys(_order.checks);
  checksToCleanIds.forEach((checkId) => {
    const check = _order.checks[checkId];
    check.displayCheckElements = {};
  });
};
var resetDisplayCheckElements = (_order, checkIds) => {
  cleanDisplayCheckElements2(_order, checkIds);
  generateDisplayCheckElements(_order, checkIds);
};
var transferCheckElements = (_order, checkElementIds, destinationCheckId) => {
  let currentTicketElementToCheckElements;
  checkElementIds.forEach((checkElementId) => {
    for (const ticketElementToCheckElements of Object.values(
      _order.ticketElementToCheckElements
    )) {
      currentTicketElementToCheckElements = ticketElementToCheckElements.find(
        (ticketElementToCheckElement) => ticketElementToCheckElement.checkElementId === checkElementId
      );
      if (currentTicketElementToCheckElements)
        break;
    }
    if (!currentTicketElementToCheckElements)
      return;
    const { checkId } = currentTicketElementToCheckElements;
    const checkElement = _order.checks[checkId].checkElements[checkElementId];
    if (!checkElement || destinationCheckId === checkElement.checkId)
      return;
    checkElement.checkId = destinationCheckId;
    _order.checks[destinationCheckId].checkElements[checkElementId] = checkElement;
    _order.ticketElementToCheckElements[checkElement.ticketElementToCheckElementsId] = [
      ..._order.ticketElementToCheckElements[checkElement.ticketElementToCheckElementsId].filter(
        (ticketElementToCheckElement) => ticketElementToCheckElement.checkElementId !== checkElementId
      ),
      __spreadProps(__spreadValues({}, currentTicketElementToCheckElements), { checkId: destinationCheckId })
    ];
    const currentDisplayCheckElement = Object.values(
      _order.checks[checkId].displayCheckElements
    ).find(
      (displayCheckElement) => Object.keys(displayCheckElement.rolledUpCheckElements).includes(
        checkElementId.toString()
      )
    );
    delete _order.checks[checkId].displayCheckElements[(currentDisplayCheckElement == null ? void 0 : currentDisplayCheckElement.tabletGeneratedId.toString()) || ""];
    delete _order.checks[checkId].checkElements[checkElementId];
  });
};
var rollUpCheckElementsNew = (_order, checkIds, instancesIds) => {
  let filteredChecks;
  if (!_order)
    return;
  if (checkIds && checkIds.length > 0) {
    filteredChecks = checkIds.map((checkId) => _order.checks[checkId]);
  } else {
    filteredChecks = Object.values(_order.checks);
  }
  const checkElementsGroupedByCheckIdAndInstanceId = {};
  filteredChecks.forEach((check) => {
    Object.values(check.checkElements).forEach((checkElement) => {
      if (instancesIds !== void 0 && instancesIds.length > 0 && !(instancesIds == null ? void 0 : instancesIds.includes(checkElement.instanceId)))
        return;
      if (!checkElementsGroupedByCheckIdAndInstanceId[checkElement.checkId])
        checkElementsGroupedByCheckIdAndInstanceId[checkElement.checkId] = {};
      if (!checkElementsGroupedByCheckIdAndInstanceId[checkElement.checkId][checkElement.instanceId]) {
        checkElementsGroupedByCheckIdAndInstanceId[checkElement.checkId][checkElement.instanceId] = [];
      }
      checkElementsGroupedByCheckIdAndInstanceId[checkElement.checkId][checkElement.instanceId].push(checkElement);
    });
  });
  Object.entries(checkElementsGroupedByCheckIdAndInstanceId).forEach(
    ([_checkId, instanceCheckElements]) => {
      Object.entries(instanceCheckElements).forEach(
        ([instanceId, checkElements]) => {
          if (checkElements.length === 1) {
            delete checkElementsGroupedByCheckIdAndInstanceId[_checkId][instanceId];
          }
        }
      );
      if (Object.keys(checkElementsGroupedByCheckIdAndInstanceId[_checkId]).length === 0)
        delete checkElementsGroupedByCheckIdAndInstanceId[_checkId];
    }
  );
  if (Object.keys(checkElementsGroupedByCheckIdAndInstanceId).length === 0)
    return;
  Object.entries(checkElementsGroupedByCheckIdAndInstanceId).forEach(
    ([_checkId, instanceCheckElements]) => {
      Object.entries(instanceCheckElements).forEach(
        ([instanceId, checkElements]) => {
          const totals = {
            price: 0,
            tax: 0,
            discountsDetails: {},
            specialsDetails: {},
            displayFraction: "",
            splitGrouped: 0,
            splitWays: 0,
            discount: 0,
            specialAmount: 0
          };
          let checkElementCopy = {};
          let ticketElementToCheckElementsId = "";
          const fractionsArray = [];
          checkElements.forEach((checkElement, index) => {
            if (index === 0) {
              checkElementCopy = cloneDeep(checkElement);
              ticketElementToCheckElementsId = checkElement.ticketElementToCheckElementsId;
            }
            totals.price += checkElement.price;
            totals.tax += checkElement.tax;
            totals.discount += checkElement.discount;
            totals.specialAmount += checkElement.specialAmount;
            Object.values(checkElement.discountsDetails || {}).forEach(
              (discountDetails) => {
                if (!totals.discountsDetails)
                  totals.discountsDetails = {};
                if (!totals.discountsDetails[discountDetails.id])
                  totals.discountsDetails[discountDetails.id] = {};
                totals.discountsDetails[discountDetails.id] = __spreadProps(__spreadValues({}, totals.discountsDetails[discountDetails.id]), {
                  appliedAmount: (totals.discountsDetails[discountDetails.id].appliedAmount || 0) + discountDetails.appliedAmount
                });
              }
            );
            Object.values(checkElement.specialsDetails || {}).forEach(
              (specialDetails) => {
                if (!totals.specialsDetails)
                  totals.specialsDetails = {};
                if (!totals.specialsDetails[specialDetails.id])
                  totals.specialsDetails[specialDetails.id] = {};
                totals.specialsDetails[specialDetails.id] = __spreadProps(__spreadValues({}, totals.specialsDetails[specialDetails.id]), {
                  appliedAmount: (totals.specialsDetails[specialDetails.id].appliedAmount || 0) + specialDetails.appliedAmount
                });
              }
            );
            fractionsArray.push({
              numerator: checkElement.splitGrouped,
              denominator: checkElement.splitWays
            });
            const summedFraction = sumAndSimplifyFractions(fractionsArray);
            totals.displayFraction = getDisplayedFraction(summedFraction);
            totals.splitGrouped = summedFraction.numerator || 1;
            totals.splitWays = summedFraction.denominator || 1;
          });
          const newCheckElement = createCheckElement(__spreadValues(__spreadValues({}, checkElementCopy), totals));
          const newTicketElementToCheckElements = createTicketElementToCheckElements(newCheckElement);
          Object.values(_order.checks[_checkId].checkElements).forEach(
            (checkElement) => {
              if (checkElement.instanceId === instanceId) {
                delete _order.checks[_checkId].checkElements[getCheckElementId(checkElement)];
              }
            }
          );
          _order.checks[_checkId].checkElements[getCheckElementId(newCheckElement)] = newCheckElement;
          if (!_order.ticketElementToCheckElements[ticketElementToCheckElementsId]) {
            _order.ticketElementToCheckElements[ticketElementToCheckElementsId] = [];
          }
          _order.ticketElementToCheckElements[ticketElementToCheckElementsId] = [
            ..._order.ticketElementToCheckElements[ticketElementToCheckElementsId].filter(
              ({ instanceId: currentInstanceId, checkId }) => currentInstanceId !== instanceId || String(checkId) !== _checkId
            ),
            newTicketElementToCheckElements
          ];
        }
      );
    }
  );
};
var rollUpDisplayCheckElements = (_order, checkIds) => {
  if (!_order)
    return;
  let filteredChecks;
  if (checkIds && checkIds.length > 0) {
    filteredChecks = checkIds.map((checkId) => _order.checks[checkId]);
  } else {
    filteredChecks = Object.values(_order.checks);
  }
  const displayCheckElementsGroupedByCheckIdAndElementId = {};
  filteredChecks.forEach((check) => {
    const displayCheckElements = check.displayCheckElements;
    if (!displayCheckElements || Object.keys(displayCheckElements).length === 0)
      return;
    const _checkId = getCheckId(check);
    Object.values(displayCheckElements).forEach((displayCheckElement) => {
      var _a, _b;
      const elementId = displayCheckElement.comboElementId ? displayCheckElement.comboElementId : displayCheckElement.ticketElementId;
      if (elementId === TICKET_OPEN_ITEM_TYPE_ID)
        return;
      if (!displayCheckElementsGroupedByCheckIdAndElementId[_checkId])
        displayCheckElementsGroupedByCheckIdAndElementId[_checkId] = {};
      if (!displayCheckElementsGroupedByCheckIdAndElementId[_checkId][elementId]) {
        displayCheckElementsGroupedByCheckIdAndElementId[_checkId][elementId] = [];
      }
      const isCombo = !!displayCheckElement.comboElementId;
      let isCurrentElementVoided = false;
      if (_order.ticketElements[displayCheckElement.ticketElementId] || _order.combos[displayCheckElement.comboElementId]) {
        if (isCombo) {
          isCurrentElementVoided = (_a = _order.combos[displayCheckElement.comboElementId]) == null ? void 0 : _a.isVoided;
        } else {
          isCurrentElementVoided = (_b = _order.ticketElements[displayCheckElement.ticketElementId]) == null ? void 0 : _b.isVoided;
        }
      }
      if (!isCurrentElementVoided) {
        displayCheckElementsGroupedByCheckIdAndElementId[_checkId][elementId].push(displayCheckElement);
      }
    });
  });
  Object.entries(displayCheckElementsGroupedByCheckIdAndElementId).forEach(
    ([currentCheckId, elementDisplayCheckElements]) => {
      Object.entries(elementDisplayCheckElements).forEach(
        ([elementId, _displayCheckElements]) => {
          if (_displayCheckElements.length === 1) {
            delete displayCheckElementsGroupedByCheckIdAndElementId[currentCheckId][elementId];
          }
        }
      );
      if (Object.keys(
        displayCheckElementsGroupedByCheckIdAndElementId[currentCheckId]
      ).length === 0)
        delete displayCheckElementsGroupedByCheckIdAndElementId[currentCheckId];
    }
  );
  if (Object.keys(displayCheckElementsGroupedByCheckIdAndElementId).length === 0)
    return;
  Object.entries(displayCheckElementsGroupedByCheckIdAndElementId).forEach(
    ([_checkId, elementDisplayCheckElements]) => {
      Object.values(elementDisplayCheckElements).forEach(
        (_displayCheckElements) => {
          let totalRolledUpCheckElements = {};
          let baseDisplayCheckElement = {};
          const totals = {
            displayFraction: "",
            splitGrouped: 0,
            splitWays: 0,
            totalDiscount: 0,
            totalSpecialAmount: 0,
            totalPrice: 0,
            rolledUpCheckElementsQty: 0,
            discountsDetails: {},
            specialsDetails: {}
          };
          _displayCheckElements.forEach((displayCheckElement, index) => {
            if (index === 0) {
              baseDisplayCheckElement = displayCheckElement;
            }
            Object.values(displayCheckElement.discountsDetails || {}).forEach(
              (discountDetails) => {
                if (!totals.discountsDetails)
                  totals.discountsDetails = {};
                if (!totals.discountsDetails[discountDetails.id]) {
                  totals.discountsDetails[discountDetails.id] = discountDetails;
                } else {
                  totals.discountsDetails[discountDetails.id] = __spreadProps(__spreadValues({}, totals.discountsDetails[discountDetails.id]), {
                    appliedAmount: totals.discountsDetails[discountDetails.id].appliedAmount + discountDetails.appliedAmount
                  });
                }
              }
            );
            Object.values(displayCheckElement.specialsDetails || {}).forEach(
              (specialDetails) => {
                if (!totals.specialsDetails)
                  totals.specialsDetails = {};
                if (!totals.specialsDetails[specialDetails.id]) {
                  totals.specialsDetails[specialDetails.id] = specialDetails;
                } else {
                  totals.specialsDetails[specialDetails.id] = __spreadProps(__spreadValues({}, totals.specialsDetails[specialDetails.id]), {
                    appliedAmount: totals.specialsDetails[specialDetails.id].appliedAmount + specialDetails.appliedAmount
                  });
                }
              }
            );
            totalRolledUpCheckElements = __spreadValues(__spreadValues({}, totalRolledUpCheckElements), displayCheckElement.rolledUpCheckElements);
          });
          const fractionsArray = [];
          Object.values(totalRolledUpCheckElements).forEach(
            (displayCheckElement) => {
              totals.totalDiscount += displayCheckElement.discount;
              totals.totalSpecialAmount += displayCheckElement.specialAmount;
              totals.totalPrice += displayCheckElement.price;
              totals.rolledUpCheckElementsQty += 1;
              fractionsArray.push({
                numerator: displayCheckElement.splitGrouped,
                denominator: displayCheckElement.splitWays
              });
            }
          );
          const newDisplayCheckElement = createDisplayCheckElement(void 0, __spreadProps(__spreadValues(__spreadValues({}, baseDisplayCheckElement), totals), {
            rolledUpCheckElements: totalRolledUpCheckElements
          }));
          const summedFraction = sumAndSimplifyFractions(fractionsArray);
          const numerator = (summedFraction.numerator || 0) + summedFraction.unit * (summedFraction.denominator || 1);
          const denominator = summedFraction.denominator || 1;
          newDisplayCheckElement.displayFraction = getDisplayedFraction(summedFraction);
          newDisplayCheckElement.splitWays = denominator;
          newDisplayCheckElement.splitGrouped = numerator;
          _displayCheckElements.forEach((displayCheckElement) => {
            delete _order.checks[_checkId].displayCheckElements[displayCheckElement.tabletGeneratedId];
            _order.checks[_checkId].displayCheckElements[newDisplayCheckElement.tabletGeneratedId] = newDisplayCheckElement;
          });
        }
      );
    }
  );
};
var checkAndDisplayCheckElementsRollUp = (_order, checkId, instancesIds) => {
  if (!_order)
    return;
  rollUpCheckElementsNew(_order, checkId, instancesIds);
  resetDisplayCheckElements(_order, checkId);
  rollUpDisplayCheckElements(_order, checkId);
};
var splitCheckElementsNWays = (_order, checkElementAndCheckIds, ways) => {
  const checkIdToCheckElementData = {};
  const ticketElement = _order.ticketElements[_order.checks[checkElementAndCheckIds[0].checkId].checkElements[checkElementAndCheckIds[0].checkElementId].ticketElementId];
  const originalCheckElementsInstanceIds = new Set(
    checkElementAndCheckIds.map(
      ({ checkElementId, checkId }) => _order.checks[checkId].checkElements[checkElementId].instanceId
    )
  );
  checkElementAndCheckIds.forEach(({ checkElementId, checkId }) => {
    var _a, _b, _c, _d;
    const check = _order.checks[checkId];
    if (!check)
      return;
    const checkElement = __spreadValues({}, check.checkElements[checkElementId]);
    delete _order.checks[checkId].checkElements[checkElementId];
    if (!checkElement)
      return;
    _order.ticketElementToCheckElements[checkElement.ticketElementToCheckElementsId] = [
      ..._order.ticketElementToCheckElements[checkElement.ticketElementToCheckElementsId].filter(
        ({ checkElementId: _checkElementId }) => _checkElementId !== checkElementId
      )
    ];
    const newFraction = sumAndSimplifyFractions([
      {
        numerator: checkElement.splitGrouped,
        denominator: (checkElement.splitWays || 1) * ways
      }
    ]);
    const newTicketElementToCheckElements = [];
    for (let iteration = 0; iteration < ways; iteration++) {
      createCheckDataForTicketElement(
        _order,
        checkElement.checkId,
        String(checkElement.ticketElementId),
        !!checkElement.comboElementId,
        void 0,
        1,
        __spreadProps(__spreadValues({}, checkElement), {
          splitWays: newFraction.denominator,
          displayFraction: getDisplayedFraction(newFraction),
          splitGrouped: Number(newFraction.numerator || 0) + newFraction.unit * Number(newFraction.denominator || 0),
          eachPrice: checkElement.price
        })
      );
      newTicketElementToCheckElements.push(
        _order.ticketElementToCheckElements[checkElement.ticketElementToCheckElementsId][_order.ticketElementToCheckElements[checkElement.ticketElementToCheckElementsId].length - 1]
      );
    }
    distributeValuesForTicketElementToCheckElements(
      _order,
      {
        tax: checkElement == null ? void 0 : checkElement.tax,
        price: checkElement == null ? void 0 : checkElement.price,
        discountsDetails: checkElement == null ? void 0 : checkElement.discountsDetails,
        specialsDetails: checkElement == null ? void 0 : checkElement.specialsDetails
      },
      newTicketElementToCheckElements,
      ways
    );
    const isCombo = !!checkElement.comboElementId;
    const elementId = isCombo ? (_b = (_a = checkElement.comboElementId) == null ? void 0 : _a.toString()) != null ? _b : "" : (_d = (_c = checkElement.ticketElementId) == null ? void 0 : _c.toString()) != null ? _d : "";
    checkIdToCheckElementData[checkId] = {
      elementId,
      ticketElementToCheckElementsId: checkElement.ticketElementToCheckElementsId.toString(),
      isCombo
    };
  });
  if (ticketElement) {
    ticketElement.instanceIds = ticketElement.instanceIds.filter(
      (instanceId) => originalCheckElementsInstanceIds.has(instanceId)
    );
  }
  Object.entries(checkIdToCheckElementData).forEach(([checkId, data]) => {
    rollUpDisplayCheckElementOfDifferentInstances(
      _order,
      checkId,
      data.elementId,
      data.ticketElementToCheckElementsId,
      data.isCombo
    );
  });
};
var rollUpDisplayCheckElementOfDifferentInstances = (_order, checkId, ticketElementId, ticketElementToCheckElementsId, isCombo = false) => {
  const check = _order.checks[checkId];
  let baseDisplayCheckElement = {};
  Object.values(check.displayCheckElements).forEach((displayCheckElement) => {
    if (!isCombo && displayCheckElement.ticketElementId.toString() === ticketElementId) {
      baseDisplayCheckElement = cloneDeep(displayCheckElement);
      delete _order.checks[checkId].displayCheckElements[displayCheckElement.tabletGeneratedId];
    } else if (isCombo && displayCheckElement.comboElementId.toString() === ticketElementId) {
      baseDisplayCheckElement = cloneDeep(displayCheckElement);
      delete _order.checks[checkId].displayCheckElements[displayCheckElement.tabletGeneratedId];
    }
  });
  const instancesToCheckElementsIdsMap = {};
  _order.ticketElementToCheckElements[ticketElementToCheckElementsId].forEach(
    ({ checkId: _checkId, instanceId, checkElementId }) => {
      if (_checkId.toString() === checkId.toString()) {
        if (!instancesToCheckElementsIdsMap[instanceId])
          instancesToCheckElementsIdsMap[instanceId] = [];
        instancesToCheckElementsIdsMap[instanceId].push(checkElementId);
      }
    }
  );
  const checkElementsIdsWithDifferentInstance = [];
  const totalCheckElementsByInstance = Object.values(
    instancesToCheckElementsIdsMap
  )[0].length;
  for (let iteration = 0; iteration < totalCheckElementsByInstance; iteration++) {
    if (!checkElementsIdsWithDifferentInstance[iteration])
      checkElementsIdsWithDifferentInstance[iteration] = [];
    Object.values(instancesToCheckElementsIdsMap).forEach((instanceInfo) => {
      checkElementsIdsWithDifferentInstance[iteration].push(
        instanceInfo[iteration]
      );
    });
  }
  checkElementsIdsWithDifferentInstance.forEach((checkElementsIds) => {
    const totals = {
      displayFraction: "",
      splitGrouped: 0,
      splitWays: 0,
      totalDiscount: 0,
      totalSpecialAmount: 0,
      totalPrice: 0,
      rolledUpCheckElementsQty: 0,
      rolledUpCheckElements: {},
      discountsDetails: {},
      specialsDetails: {}
    };
    const fractionsArray = [];
    checkElementsIds.forEach((checkElementId) => {
      const checkElement = _order.checks[checkId].checkElements[checkElementId];
      Object.values(checkElement.discountsDetails || {}).forEach(
        (discountDetails) => {
          if (!totals.discountsDetails)
            totals.discountsDetails = {};
          if (!totals.discountsDetails[discountDetails.id]) {
            totals.discountsDetails[discountDetails.id] = discountDetails;
          } else {
            totals.discountsDetails[discountDetails.id] = __spreadProps(__spreadValues({}, discountDetails), {
              appliedAmount: totals.discountsDetails[discountDetails.id].appliedAmount + discountDetails.appliedAmount
            });
          }
        }
      );
      Object.values(checkElement.specialsDetails || {}).forEach(
        (specialDetails) => {
          if (!totals.specialsDetails)
            totals.specialsDetails = {};
          if (!totals.specialsDetails[specialDetails.id]) {
            totals.specialsDetails[specialDetails.id] = specialDetails;
          } else {
            totals.specialsDetails[specialDetails.id] = __spreadProps(__spreadValues({}, specialDetails), {
              appliedAmount: totals.specialsDetails[specialDetails.id].appliedAmount + specialDetails.appliedAmount
            });
          }
        }
      );
      totals.totalDiscount += checkElement.discount;
      totals.totalSpecialAmount += checkElement.specialAmount;
      totals.totalPrice += checkElement.price;
      totals.rolledUpCheckElementsQty += 1;
      totals.rolledUpCheckElements[checkElementId] = {
        checkElementId,
        discount: checkElement.discount,
        specialAmount: checkElement.specialAmount,
        splitGrouped: checkElement.splitGrouped,
        splitWays: checkElement.splitWays,
        price: checkElement.price
      };
      fractionsArray.push({
        numerator: checkElement.splitGrouped,
        denominator: checkElement.splitWays
      });
    });
    const summedFraction = sumAndSimplifyFractions(fractionsArray);
    const newDisplayCheckElement = createDisplayCheckElement(void 0, __spreadValues(__spreadValues({}, baseDisplayCheckElement), totals));
    newDisplayCheckElement.displayFraction = getDisplayedFraction(summedFraction);
    _order.checks[checkId].displayCheckElements[newDisplayCheckElement.tabletGeneratedId] = newDisplayCheckElement;
  });
};
var unGroupDisplayCheckElements = (_order, checkElementIdAndCheckIds) => {
  checkElementIdAndCheckIds.forEach(({ checkElementId, checkId }) => {
    const check = _order.checks[checkId];
    if (!check)
      return;
    const checkElement = check.checkElements[checkElementId];
    if (!checkElement)
      return;
    const displayCheckElement = Object.values(check.displayCheckElements).find(
      (_displayCheckElement) => Object.keys(_displayCheckElement.rolledUpCheckElements).includes(
        checkElementId
      )
    );
    Object.keys((displayCheckElement == null ? void 0 : displayCheckElement.rolledUpCheckElements) || {}).forEach(
      (rolledUpCheckElementId) => {
        const rolledUpCheckElement = check.checkElements[rolledUpCheckElementId];
        if (!rolledUpCheckElement)
          return;
        const newDisplayCheckElement = createDisplayCheckElement(rolledUpCheckElement);
        check.displayCheckElements[newDisplayCheckElement.tabletGeneratedId] = newDisplayCheckElement;
      }
    );
    delete check.displayCheckElements[(displayCheckElement == null ? void 0 : displayCheckElement.tabletGeneratedId) || ""];
    _order.checks[checkId] = check;
  });
};
var splitCheckElementToAllNonDefaultAvailableChecks = (_order, checkElementId, originCheckId) => {
  const originCheck = _order.checks[originCheckId];
  if (!originCheck)
    return;
  const originalCheckElement = cloneDeep(
    originCheck.checkElements[checkElementId]
  );
  if (!originalCheckElement)
    return;
  const availableChecks = Object.values(_order.checks).filter(
    (check) => getCheckId(check) !== _order.defaultCheckId && checkStatusAllowsEditing(check.status)
  );
  const ticketElementToCheckElementsId = originalCheckElement.ticketElementToCheckElementsId;
  _order.ticketElementToCheckElements[ticketElementToCheckElementsId] = _order.ticketElementToCheckElements[ticketElementToCheckElementsId].filter(
    (ticketElementToCheckElements) => ticketElementToCheckElements.checkElementId !== checkElementId
  );
  delete _order.checks[originCheckId].checkElements[checkElementId];
  const newFraction = sumAndSimplifyFractions([
    {
      numerator: originalCheckElement.splitGrouped,
      denominator: availableChecks.length * (originalCheckElement.splitWays || 1)
    }
  ]);
  const newTicketElementToCheckElementsArray = [];
  availableChecks.forEach((check) => {
    const newCheckElement = createCheckElement(__spreadProps(__spreadValues({}, originalCheckElement), {
      checkId: getCheckId(check),
      splitWays: newFraction.denominator,
      displayFraction: getDisplayedFraction(newFraction),
      splitGrouped: Number(newFraction.numerator || 0) + newFraction.unit * Number(newFraction.denominator || 1)
    }));
    const newTicketElementToCheckElements = createTicketElementToCheckElements(newCheckElement);
    newTicketElementToCheckElementsArray.push(newTicketElementToCheckElements);
    _order.checks[getCheckId(check)].checkElements[getCheckElementId(newCheckElement)] = newCheckElement;
    _order.ticketElementToCheckElements[ticketElementToCheckElementsId].push(
      newTicketElementToCheckElements
    );
  });
  const price = originalCheckElement.price;
  const discountsDetails = originalCheckElement.discountsDetails;
  const tax = originalCheckElement.tax;
  const specialsDetails = originalCheckElement.specialsDetails;
  const values = {
    tax,
    price,
    discountsDetails,
    specialsDetails
  };
  updateChecksTotals(_order, void 0, true);
  distributeValuesForTicketElementToCheckElements(
    _order,
    values,
    newTicketElementToCheckElementsArray,
    newTicketElementToCheckElementsArray.length,
    [_order.defaultCheckId]
  );
};
var updateCheckElementsSeats = (_order, ticketElementId) => {
  const ticketElement = _order.ticketElements[ticketElementId];
  if (!ticketElement)
    return;
  const ticketElementToCheckElementsId = String(
    ticketElement.ticketElementToCheckElementsId
  );
  const ticketElementToCheckElements = _order.ticketElementToCheckElements[ticketElementToCheckElementsId];
  if (!ticketElementToCheckElements)
    return;
  const ticketElementSeats = ticketElement.seating;
  ticketElementToCheckElements.forEach(({ checkElementId, checkId }) => {
    const check = _order.checks[checkId];
    if (!check)
      return;
    const checkElement = check.checkElements[checkElementId];
    if (!checkElement)
      return;
    checkElement.seats = ticketElementSeats;
  });
};
var splitCheckElementsBySeat = (_order, checkElements, omitCheckIdsInDistribution) => {
  const seatsWithElements = checkElements.reduce((acc, checkElement) => {
    const seats = Object.entries(checkElement.seats || {}).filter(([_, seatQty]) => seatQty).map(([seatNumber]) => Number(seatNumber));
    return /* @__PURE__ */ new Set([...acc, ...seats]);
  }, /* @__PURE__ */ new Set());
  const sortedSeatsWithElements = Array.from(seatsWithElements).filter((seat) => seat !== NO_SEAT_ID && seat !== FOR_TABLE_SEAT_ID).sort();
  const seatToCheckMap = {};
  const closedChecksSeatNumber = [];
  Object.values(_order.checks).forEach((check) => {
    if (!checkStatusAllowsEditing(check.status)) {
      if (check.seats && check.seats.length > 0)
        check.seats.forEach((seat) => {
          closedChecksSeatNumber.push(seat);
        });
      return;
    }
    if (check.seats && check.seats.length > 0 && check.id !== _order.defaultCheckId) {
      check.seats.forEach((seat) => {
        seatToCheckMap[seat] = getCheckId(check);
      });
    }
  });
  sortedSeatsWithElements.forEach((seatNumber) => {
    if (seatToCheckMap[seatNumber] || closedChecksSeatNumber.includes(seatNumber))
      return;
    const currentSeatCheck = createCheck2(_order, {
      seats: [seatNumber],
      name: "Seat " + seatNumber
    });
    seatToCheckMap[seatNumber] = getCheckId(currentSeatCheck);
    _order.checks[getCheckId(currentSeatCheck)] = currentSeatCheck;
  });
  const forTableAndSharedCheckElementsIdCheckIdMap = {};
  checkElements.forEach((checkElement) => {
    const currentCheckElementSeat = Object.keys(checkElement.seats || {})[0];
    const check = _order.checks[checkElement.checkId];
    if (!check)
      return;
    if (Number(currentCheckElementSeat) === NO_SEAT_ID)
      return;
    if (Number(currentCheckElementSeat) === FOR_TABLE_SEAT_ID || checkElement.isShared) {
      forTableAndSharedCheckElementsIdCheckIdMap[getCheckElementId(checkElement)] = checkElement.checkId;
      return;
    }
    const currentSeatCheckId = seatToCheckMap[Number(currentCheckElementSeat)];
    const currentSeatCheck = _order.checks[currentSeatCheckId];
    currentSeatCheck.checkElements[getCheckElementId(checkElement)] = __spreadProps(__spreadValues({}, checkElement), {
      checkId: getCheckId(currentSeatCheck)
    });
    delete check.checkElements[getCheckElementId(checkElement)];
    let currentTicketElementToCheckElement = _order.ticketElementToCheckElements[checkElement.ticketElementToCheckElementsId].find(
      ({ checkElementId }) => checkElementId === getCheckElementId(checkElement)
    );
    currentTicketElementToCheckElement = __spreadProps(__spreadValues({}, currentTicketElementToCheckElement), {
      checkId: getCheckId(currentSeatCheck)
    });
    _order.ticketElementToCheckElements = __spreadProps(__spreadValues({}, _order.ticketElementToCheckElements), {
      [checkElement.ticketElementToCheckElementsId]: [
        ..._order.ticketElementToCheckElements[checkElement.ticketElementToCheckElementsId].filter(
          ({ checkElementId }) => checkElementId !== getCheckElementId(checkElement)
        ),
        currentTicketElementToCheckElement
      ]
    });
  });
  if (!Object.keys(forTableAndSharedCheckElementsIdCheckIdMap).length) {
    deleteEmptyChecks(_order);
    return;
  }
  Object.entries(forTableAndSharedCheckElementsIdCheckIdMap).forEach(
    ([checkElementId, checkId]) => {
      const check = _order.checks[checkId];
      if (!check)
        return;
      const currentCheckElement = check.checkElements[checkElementId];
      const splitWays = currentCheckElement.isShared ? Object.keys(currentCheckElement.seats).length : Object.keys(seatToCheckMap).length;
      if (splitWays === 0 && !currentCheckElement.isShared)
        return;
      if (_order.ticketElementToCheckElements[currentCheckElement.ticketElementToCheckElementsId])
        _order.ticketElementToCheckElements[currentCheckElement.ticketElementToCheckElementsId] = _order.ticketElementToCheckElements[currentCheckElement.ticketElementToCheckElementsId].filter((ticketElementToCheckElement) => {
          return ticketElementToCheckElement.checkId !== _order.defaultCheckId || ticketElementToCheckElement.checkId === _order.defaultCheckId && Number(
            Object.keys(
              _order.checks[ticketElementToCheckElement.checkId].checkElements[ticketElementToCheckElement.checkElementId].seats
            )[0]
          ) === NO_SEAT_ID;
        });
      else
        _order.ticketElementToCheckElements[currentCheckElement.ticketElementToCheckElementsId] = [];
      const ticketElementToCheckElementsToDistribute = [];
      Object.entries(seatToCheckMap).forEach(([seatNumber, _checkId]) => {
        if (_checkId === _order.defaultCheckId)
          return;
        if (currentCheckElement.isShared && !Object.keys(currentCheckElement.seats).includes(seatNumber))
          return;
        const currentCheck = _order.checks[_checkId];
        const newCheckElement = createCheckElement(__spreadProps(__spreadValues({}, currentCheckElement), {
          checkId: _checkId,
          splitWays,
          displayFraction: `1/${splitWays}`,
          eachPrice: currentCheckElement.price,
          price: 0,
          discount: 0,
          tax: 0,
          specialAmount: 0
        }));
        const newTicketElementToCheckElementObject = createTicketElementToCheckElements(newCheckElement);
        ticketElementToCheckElementsToDistribute.push(
          newTicketElementToCheckElementObject
        );
        _order.ticketElementToCheckElements[currentCheckElement.ticketElementToCheckElementsId] = [
          ..._order.ticketElementToCheckElements[currentCheckElement.ticketElementToCheckElementsId],
          newTicketElementToCheckElementObject
        ];
        currentCheck.checkElements[getCheckElementId(newCheckElement)] = newCheckElement;
      });
      distributeValuesForTicketElementToCheckElements(
        _order,
        {
          tax: currentCheckElement == null ? void 0 : currentCheckElement.tax,
          price: currentCheckElement == null ? void 0 : currentCheckElement.price,
          discountsDetails: currentCheckElement == null ? void 0 : currentCheckElement.discountsDetails,
          specialsDetails: currentCheckElement == null ? void 0 : currentCheckElement.specialsDetails
        },
        ticketElementToCheckElementsToDistribute,
        splitWays,
        omitCheckIdsInDistribution,
        true
      );
      delete _order.checks[checkId].checkElements[checkElementId];
    }
  );
  deleteEmptyChecks(_order);
};
var clearCheckElementsForUnSentElements = (_order, comboIds, ignoredTicketElementIds) => {
  const ticketElementToCheckElementsIds = [];
  Object.values(_order.ticketElements).forEach((ticketElement) => {
    if (ignoredTicketElementIds.includes(getTicketElementId(ticketElement)) || ticketElement.comboElementId || isTicketElementSent(ticketElement))
      return;
    ticketElementToCheckElementsIds.push(
      String(ticketElement.ticketElementToCheckElementsId)
    );
  });
  comboIds.forEach((comboId) => {
    ticketElementToCheckElementsIds.push(
      String(_order.combos[comboId].ticketElementToCheckElementsId)
    );
  });
  ticketElementToCheckElementsIds.forEach((ticketElementToCheckElementsId) => {
    const ticketElementToCheckElements = _order.ticketElementToCheckElements[ticketElementToCheckElementsId];
    if (!ticketElementToCheckElements)
      return;
    ticketElementToCheckElements.forEach(({ checkElementId, checkId }) => {
      delete _order.checks[checkId].checkElements[checkElementId];
    });
    delete _order.ticketElementToCheckElements[ticketElementToCheckElementsId];
  });
};
var distributeValuesForTicketElementToCheckElements = (_order, values, ticketElementToCheckElements, ways, omitCheckIds, distributeBasedOnTicketElement = false, shouldUpdateCheckTotals = true) => {
  if (ticketElementToCheckElements.length === 0)
    return;
  const checkElementIdAndCheckInfoMapForTicketElement = {};
  let defaultValues = {};
  if (distributeBasedOnTicketElement) {
    const _checkId = ticketElementToCheckElements[0].checkId;
    const _checkElementId = ticketElementToCheckElements[0].checkElementId;
    const isCombo = !!_order.checks[_checkId].checkElements[_checkElementId].comboElementId;
    const ticketElementId = String(
      _order.checks[_checkId].checkElements[_checkElementId].ticketElementId || _order.checks[_checkId].checkElements[_checkElementId].comboElementId
    );
    const ticketElement = isCombo ? _order.combos[ticketElementId] : _order.ticketElements[ticketElementId];
    defaultValues = _order.ticketElementToCheckElements[String(ticketElement.ticketElementToCheckElementsId)].reduce(
      (acc, ticketElementToCheckElement) => {
        const checkId = ticketElementToCheckElement.checkId;
        const checkElementId = ticketElementToCheckElement.checkElementId;
        const checkElement = _order.checks[checkId].checkElements[checkElementId];
        if (omitCheckIds && (omitCheckIds == null ? void 0 : omitCheckIds.includes(checkId)))
          return acc;
        if (!acc[checkId]) {
          acc[checkId] = {
            tax: 0,
            price: 0,
            discount: 0,
            checkTotal: 0
          };
        }
        acc[checkId].tax += checkElement.tax;
        acc[checkId].price += checkElement.price;
        acc[checkId].discount += checkElement.discount + checkElement.specialAmount;
        acc[checkId].checkTotal += checkElement.price + checkElement.tax - (checkElement.discount + checkElement.specialAmount);
        return acc;
      },
      {}
    );
  }
  ticketElementToCheckElements.forEach((ticketElementToCheckElement) => {
    if (omitCheckIds == null ? void 0 : omitCheckIds.includes(ticketElementToCheckElement.checkId))
      return;
    const checkId = ticketElementToCheckElement.checkId;
    const checkElementId = ticketElementToCheckElement.checkElementId;
    checkElementIdAndCheckInfoMapForTicketElement[checkElementId] = {
      checkTotal: !distributeBasedOnTicketElement ? _order.checks[checkId].total : defaultValues[checkId].checkTotal,
      checkId,
      tax: !distributeBasedOnTicketElement ? _order.checks[checkId].tax : defaultValues[checkId].tax,
      discount: !distributeBasedOnTicketElement ? _order.checks[checkId].totalDiscounts : defaultValues[checkId].discount,
      price: !distributeBasedOnTicketElement ? _order.checks[checkId].subtotal : defaultValues[checkId].price,
      splitGrouped: _order.checks[checkId].checkElements[checkElementId].splitGrouped,
      splitWays: _order.checks[checkId].checkElements[checkElementId].splitWays
    };
  });
  if (Object.keys(checkElementIdAndCheckInfoMapForTicketElement).length === 0)
    return;
  Object.entries(values).forEach(([key, value]) => {
    if (!value)
      return;
    const amountToDistribute = Number(value);
    if (key === "discountsDetails" || key === "specialsDetails") {
      Object.values(
        value
      ).forEach(({ appliedAmount, id }) => {
        const result2 = distributeAmountToElementsBasedOnCheckTotals(
          checkElementIdAndCheckInfoMapForTicketElement,
          appliedAmount,
          ways,
          key
        );
        result2.forEach((res) => {
          const { checkElementId, value: _value, checkId, checkTotal } = res;
          const currentCheckElement = _order.checks[checkId].checkElements[checkElementId];
          currentCheckElement[key] = __spreadProps(__spreadValues({}, currentCheckElement[key] || {}), {
            [id]: __spreadProps(__spreadValues({}, value[id]), {
              appliedAmount: _value
            })
          });
          if (key === "discountsDetails") {
            currentCheckElement.discount = _value;
          } else if (key === "specialsDetails") {
            currentCheckElement.specialAmount = _value;
          }
          checkElementIdAndCheckInfoMapForTicketElement[checkElementId].checkTotal = checkTotal;
          const updatedCheckField = key === "specialsDetails" ? "discount" : key;
          checkElementIdAndCheckInfoMapForTicketElement[checkElementId][updatedCheckField] = res[updatedCheckField];
        });
      });
      return;
    }
    const result = distributeAmountToElementsBasedOnCheckTotals(
      checkElementIdAndCheckInfoMapForTicketElement,
      amountToDistribute,
      ways,
      key
    );
    result.forEach((res) => {
      const { checkElementId, value: _value, checkId, checkTotal } = res;
      _order.checks[checkId].checkElements[checkElementId][key] = _value;
      checkElementIdAndCheckInfoMapForTicketElement[checkElementId].checkTotal = checkTotal;
      const updatedCheckField = key === "specialAmount" ? "discount" : key;
      checkElementIdAndCheckInfoMapForTicketElement[checkElementId][updatedCheckField] = res[updatedCheckField];
    });
  });
  if (shouldUpdateCheckTotals)
    updateChecksTotals(_order);
};
var distributeAmountToElementsBasedOnCheckTotals = (checkElementAndCheckInfoMap, amountToDistribute, ways, key) => {
  const isDiscount = key === "discountsDetails" || key === "specialsDetails";
  const toUpdateKey = isDiscount ? "discount" : key;
  const sortDistributedAmounts = () => {
    distributedAmounts.sort((a, b) => {
      if (Number(a.checkTotal.toFixed(2)) > Number(b.checkTotal.toFixed(2)))
        return !isDiscount ? 1 : -1;
      if (Number(a.checkTotal.toFixed(2)) < Number(b.checkTotal.toFixed(2)))
        return !isDiscount ? -1 : 1;
      if (Number(a[toUpdateKey].toFixed(2)) > Number(b[toUpdateKey].toFixed(2)))
        return 1;
      if (Number(a[toUpdateKey].toFixed(2)) < Number(b[toUpdateKey].toFixed(2)))
        return -1;
      return 0;
    });
  };
  const twoDecimalsValue = Math.floor(amountToDistribute / ways * 100) / 100;
  const distributedAmounts = [];
  Object.entries(checkElementAndCheckInfoMap).forEach(
    ([checkElementId, checkInfo]) => {
      const addedValue = twoDecimalsValue * checkInfo.splitGrouped;
      const amountToAdd = {
        checkElementId,
        value: addedValue,
        checkTotal: isDiscount ? checkInfo.checkTotal - addedValue : checkInfo.checkTotal + addedValue,
        checkId: checkInfo.checkId,
        tax: checkInfo.tax,
        discount: checkInfo.discount,
        price: checkInfo.price
      };
      amountToAdd[toUpdateKey] += addedValue;
      distributedAmounts.push(amountToAdd);
    }
  );
  const diffToAmountToDistribute = amountToDistribute - twoDecimalsValue * ways;
  const centsToDistribute = Math.round(diffToAmountToDistribute * 100);
  for (let iteration = 0; iteration < centsToDistribute; iteration++) {
    sortDistributedAmounts();
    const currAmount = distributedAmounts[0];
    currAmount.value = (currAmount.value * 100 + 1) / 100;
    currAmount[toUpdateKey] = (currAmount[toUpdateKey] * 100 + 1) / 100;
    currAmount.checkTotal = isDiscount ? (currAmount.checkTotal * 100 - 1) / 100 : (currAmount.checkTotal * 100 + 1) / 100;
    distributedAmounts.forEach((distributedAmountInfo) => {
      if (distributedAmountInfo.checkId === currAmount.checkId && distributedAmountInfo.checkElementId !== currAmount.checkElementId) {
        distributedAmountInfo.checkTotal = currAmount.checkTotal;
        distributedAmountInfo[toUpdateKey] = currAmount[toUpdateKey];
      }
    });
  }
  return distributedAmounts;
};

// src/helpers/register/checks/checkReducerHelpers.ts
var updateTicketElementChecksTotals = (_order, ticketElementId, isCombo) => {
  var _a;
  const ticketElementToCheckElementsId = isCombo ? _order.combos[ticketElementId].ticketElementToCheckElementsId : _order.ticketElements[ticketElementId].ticketElementToCheckElementsId;
  const ticketElementChecksIds = ((_a = _order.ticketElementToCheckElements[ticketElementToCheckElementsId || ""]) != null ? _a : []).map(({ checkId }) => String(checkId));
  updateChecksTotals(_order, [...Array.from(new Set(ticketElementChecksIds))]);
};
var adjustCheckDataForToggleSeats = (toggleCase, _order, ticketElementId, isCombo, newTicketElementQuantity, prevTicketElementQuantity, seatId, prevSeatId) => {
  if (toggleCase === 1 /* DESELECT_SEAT */) {
    removeCheckDataForTicketElement(_order, ticketElementId, isCombo, seatId);
  } else if (toggleCase === 2 /* UPDATE_QUANTITY */) {
    if (prevTicketElementQuantity < newTicketElementQuantity) {
      createCheckDataForTicketElement(
        _order,
        _order.defaultCheckId,
        ticketElementId,
        isCombo,
        seatId,
        newTicketElementQuantity - prevTicketElementQuantity
      );
    } else if (prevTicketElementQuantity > newTicketElementQuantity) {
      removeCheckDataForTicketElement(
        _order,
        ticketElementId,
        isCombo,
        seatId,
        prevTicketElementQuantity - newTicketElementQuantity
      );
    }
  } else if (toggleCase === 3 /* REPLACE_SEAT */ && prevSeatId) {
    removeCheckDataForTicketElement(
      _order,
      ticketElementId,
      isCombo,
      prevSeatId
    );
    createCheckDataForTicketElement(
      _order,
      _order.defaultCheckId,
      ticketElementId,
      isCombo,
      seatId,
      newTicketElementQuantity
    );
  }
};
var distributeAndUpdatePriceDataToCheckElements = (_order, ticketElementId, isCombo = false, overrideValues) => {
  const ticketElement = isCombo ? _order.combos[ticketElementId] : _order.ticketElements[ticketElementId];
  const ticketElementToCheckElementsId = String(
    ticketElement.ticketElementToCheckElementsId
  );
  if (!ticketElementToCheckElementsId)
    return;
  const ticketElementToCheckElements = _order.ticketElementToCheckElements[String(ticketElement.ticketElementToCheckElementsId)] || [];
  const price = ((overrideValues == null ? void 0 : overrideValues.price) ? overrideValues == null ? void 0 : overrideValues.price : ticketElement.isPriceOverride ? ticketElement.overridePricePerItemUnit : ticketElement.totalPricePerItemUnit) * ticketElement.quantity;
  const discount = (overrideValues == null ? void 0 : overrideValues.discount) ? overrideValues == null ? void 0 : overrideValues.discount : ticketElement.totalDiscountAmount;
  const discountsDetails = Object.values(ticketElement.discounts).map((_discount) => ({
    id: _discount.id || _discount.tabletGeneratedId,
    appliedAmount: _discount.appliedDiscountAmount,
    name: _discount.posName,
    checkName: _discount.checkName,
    type: _discount.type,
    discountOrSpecialValue: _discount.value
  })).filter((_discount) => _discount.appliedAmount > 0).reduce(
    (acc, _discount) => {
      acc[_discount.id] = _discount;
      return acc;
    },
    {}
  );
  let specialAmount = (overrideValues == null ? void 0 : overrideValues.specialAmount) ? overrideValues == null ? void 0 : overrideValues.specialAmount : ticketElement.totalSpecialsAmount;
  if (!ticketElement.specials)
    ticketElement.specials = {};
  const specialsDetails = Object.values(ticketElement.specials).map((special) => ({
    id: special.specialId,
    appliedAmount: special.appliedSpecialAmount,
    name: special.posName,
    checkName: special.checkName,
    type: special.type,
    discountOrSpecialValue: special.discountedAmount
  })).filter((special) => special.appliedAmount > 0).reduce(
    (acc, _special) => {
      acc[_special.id] = _special;
      return acc;
    },
    {}
  );
  const tax = (overrideValues == null ? void 0 : overrideValues.tax) ? overrideValues == null ? void 0 : overrideValues.tax : ticketElement.totalTax;
  if (!isCombo) {
    specialAmount += ticketElement.totalSpecialsBOGOAmount;
  }
  overrideCheckElementFields(
    _order,
    ticketElementId,
    {
      tax: 0,
      price: 0,
      discount: 0,
      specialAmount: 0,
      discountsDetails: null,
      specialsDetails: null
    },
    isCombo
  );
  updateChecksTotals(_order, void 0, true);
  if (_order.splitMode === "SEATS" /* SEATS */) {
    const seatsTicketElementToCheckElements = {};
    ticketElementToCheckElements.forEach((ticketElementToCheckElement) => {
      const checkId = ticketElementToCheckElement.checkId;
      const checkElementId = ticketElementToCheckElement.checkElementId;
      const checkElement = _order.checks[checkId].checkElements[checkElementId];
      const currentCheckElementSeat = Object.keys(checkElement.seats || {})[0];
      if (!seatsTicketElementToCheckElements[currentCheckElementSeat]) {
        seatsTicketElementToCheckElements[currentCheckElementSeat] = [];
      }
      seatsTicketElementToCheckElements[currentCheckElementSeat].push(
        ticketElementToCheckElement
      );
    });
    const individualPrice = (overrideValues == null ? void 0 : overrideValues.price) ? overrideValues == null ? void 0 : overrideValues.price : ticketElement.isPriceOverride ? ticketElement.overridePricePerItemUnit : ticketElement.totalPricePerItemUnit;
    Object.entries(seatsTicketElementToCheckElements).forEach(
      ([seatId, seatTicketElementToCheckElements]) => {
        const seatsQuantity = ticketElement.seating[Number(seatId)];
        distributeValuesForTicketElementToCheckElements(
          _order,
          {
            price: individualPrice * seatsQuantity
          },
          seatTicketElementToCheckElements,
          seatTicketElementToCheckElements.length,
          [],
          Number(seatId) === FOR_TABLE_SEAT_ID
        );
      }
    );
    distributeValuesForTicketElementToCheckElements(
      _order,
      {
        discountsDetails,
        specialsDetails,
        tax
      },
      ticketElementToCheckElements,
      ticketElementToCheckElements.length
    );
    return;
  }
  distributeValuesForTicketElementToCheckElements(
    _order,
    {
      tax,
      price,
      discountsDetails,
      specialsDetails
    },
    ticketElementToCheckElements,
    ticketElementToCheckElements.length
  );
  const update = {
    eachPrice: (overrideValues == null ? void 0 : overrideValues.price) ? overrideValues == null ? void 0 : overrideValues.price : ticketElement.isPriceOverride ? ticketElement.overridePricePerItemUnit : ticketElement.totalPricePerItemUnit
  };
  if (tax === 0)
    update.tax = 0;
  if (discount === 0)
    update.discount = 0;
  if (price === 0)
    update.price = 0;
  if (specialAmount === 0)
    update.specialAmount = 0;
  overrideCheckElementFields(_order, ticketElementId, update, isCombo);
  updateChecksTotals(_order);
};
var createCheckDataAndUpdateCheckForTicketElement = (_order, ticketElementId, isCombo, seatId, quantity, onlyUpdateTicketElementChecksTotals = true) => {
  createCheckDataForTicketElement(
    _order,
    _order.defaultCheckId,
    ticketElementId,
    isCombo,
    seatId,
    quantity
  );
  adjustCheckDataForTicketElement(
    _order,
    ticketElementId,
    isCombo,
    onlyUpdateTicketElementChecksTotals
  );
};
var removeTicketElementAndCheckData = (_order, ticketElementId, isCombo) => {
  var _a, _b;
  removeCheckDataForTicketElement(_order, ticketElementId, isCombo);
  if (isCombo) {
    Object.values(
      ((_b = (_a = _order.combos) == null ? void 0 : _a[ticketElementId]) == null ? void 0 : _b.itemGroupsSelected) || {}
    ).forEach((itemGroup) => {
      delete _order.ticketElements[itemGroup.ticketElementId || ""];
    });
  }
  const ticketElementToCheckElementsId = isCombo ? _order.combos[ticketElementId].ticketElementToCheckElementsId : _order.ticketElements[ticketElementId].ticketElementToCheckElementsId;
  isCombo ? delete _order.combos[ticketElementId] : delete _order.ticketElements[ticketElementId];
  delete _order.ticketElementToCheckElements[ticketElementToCheckElementsId || ""];
};
var splitCheckElementBySeatReducerHelper = (_order, checkElementIds) => {
  const checkElementsArray = checkElementIds.map((checkElementId) => {
    let checkElement = {};
    for (const ticketElementToCheckElementsArray of Object.values(
      _order.ticketElementToCheckElements
    )) {
      const checkElementData = ticketElementToCheckElementsArray.find(
        ({ checkElementId: checkElementIdInArray }) => checkElementIdInArray === checkElementId
      );
      if (!checkElementData)
        continue;
      checkElement = _order.checks[checkElementData.checkId].checkElements[checkElementId];
      if (checkElement)
        break;
    }
    return checkElement;
  });
  splitCheckElementsBySeat(_order, checkElementsArray);
};
var unSplitCheckElementHelper = (_order, checkId, checkElementId) => {
  const checkElement = _order.checks[checkId].checkElements[checkElementId];
  if (!checkElement)
    return;
  const ticketElementToCheckElementsId = checkElement.ticketElementToCheckElementsId;
  const ticketElementToCheckElements = _order.ticketElementToCheckElements[ticketElementToCheckElementsId];
  const currentTicketElementToCheckElements = ticketElementToCheckElements.find(
    ({ checkId: _checkId, checkElementId: _checkElementId }) => _checkId === checkId && _checkElementId === checkElementId
  );
  if (!currentTicketElementToCheckElements)
    return;
  const currentInstanceChecksData = ticketElementToCheckElements.filter(
    ({ instanceId }) => instanceId === currentTicketElementToCheckElements.instanceId
  );
  currentInstanceChecksData.forEach(
    ({ checkId: _checkId, checkElementId: _checkElementId }) => {
      const check = _order.checks[_checkId];
      if (!check || !checkStatusAllowsEditing(check.status))
        return;
      const _checkElement = check.checkElements[_checkElementId];
      if (!_checkElement)
        return;
      transferCheckElements(
        _order,
        [getCheckElementId(_checkElement)],
        checkId
      );
    }
  );
  checkAndDisplayCheckElementsRollUp(_order, void 0, [
    currentTicketElementToCheckElements.instanceId
  ]);
  updateChecksTotals(_order);
};
var updateCheckElementForTicketElement = (_order, ticketElementId, doDistribute = true) => {
  const ticketElement = _order.ticketElements[ticketElementId];
  if (!ticketElement)
    return;
  const itemObject = ticketElement.itemObj;
  const menuTypeVersion = Object.values((itemObject == null ? void 0 : itemObject.menuTypeVersions) || {})[0];
  const newCheckElementValues = {
    name: menuTypeVersion == null ? void 0 : menuTypeVersion.posName,
    isShared: !!ticketElement.isShared,
    ticketElementId: getTicketElementId(ticketElement),
    itemId: ticketElement.itemId || TICKET_OPEN_ITEM_TYPE_ID
  };
  if (doDistribute) {
    distributeAndUpdatePriceDataToCheckElements(_order, ticketElementId, false);
  }
  overrideCheckElementFields(_order, ticketElementId, __spreadValues({}, newCheckElementValues));
};
var updateCheckElementForComboElement = (_order, comboElementId, doDistribute = true) => {
  const comboElement = _order.combos[comboElementId];
  if (!comboElement)
    return;
  const comboObject = comboElement.comboObj;
  const menuTypeVersion = Object.values((comboObject == null ? void 0 : comboObject.menuTypeVersions) || {})[0];
  const newCheckElementValues = {
    name: menuTypeVersion.posName,
    isShared: !!comboElement.isShared,
    comboElementId,
    itemId: comboObject == null ? void 0 : comboObject.comboId,
    comboItemNames: getComboElementItemNames(_order, comboElement)
  };
  if (doDistribute) {
    distributeAndUpdatePriceDataToCheckElements(_order, comboElementId, true);
  }
  overrideCheckElementFields(
    _order,
    comboElementId,
    __spreadValues({}, newCheckElementValues),
    true
  );
};
var adjustCheckDataForTicketElement = (_order, ticketElementId, isCombo, onlyUpdateTicketElementChecksTotals) => {
  const willDoAutoSplit = _order.splitMode;
  const doDistribution = _order.splitMode !== "EVENLY" /* EVENLY */ || Object.keys(_order.checks[_order.defaultCheckId].checkElements).length === 0;
  isCombo ? updateCheckElementForComboElement(_order, ticketElementId, doDistribution) : updateCheckElementForTicketElement(
    _order,
    ticketElementId,
    doDistribution
  );
  autoSplitChecks(_order);
  if (!willDoAutoSplit)
    onlyUpdateTicketElementChecksTotals ? updateTicketElementChecksTotals(_order, ticketElementId, isCombo) : updateChecksTotals(_order);
};
var getClosedChecksForSeatId = (order, seatId) => {
  const checkIds = Object.values(order.checks).filter(
    (check) => check.seats && check.seats.includes(seatId) && !checkStatusAllowsEditing(check.status)
  ).map(getCheckId);
  return checkIds;
};
var adjustRedundantCheckElementsAndTicketElementToCheckElements = (order, rollUpIds, isCombo = false) => {
  const elementsKey = isCombo ? "combos" : "ticketElements";
  rollUpIds.forEach(({ uniqueId, redundantIds }) => {
    const mainTicketElement = order[elementsKey][uniqueId];
    redundantIds.forEach((redundantId) => {
      overrideCheckElementFields(
        order,
        redundantId,
        {
          [isCombo ? "comboElementId" : "ticketElementId"]: uniqueId,
          ticketElementToCheckElementsId: String(
            mainTicketElement.ticketElementToCheckElementsId
          )
        },
        isCombo
      );
      const redudantTicketElement = order[elementsKey][redundantId];
      order.ticketElementToCheckElements[String(mainTicketElement.ticketElementToCheckElementsId)].push(
        ...order.ticketElementToCheckElements[String(redudantTicketElement.ticketElementToCheckElementsId)]
      );
      delete order.ticketElementToCheckElements[String(redudantTicketElement.ticketElementToCheckElementsId)];
    });
  });
};
var setDiscountToOrder = (discount, order, removeExclusive) => {
  var _a, _b;
  if (!order.orderDiscounts)
    order.orderDiscounts = {};
  const tabletGeneratedId = generateTabletGeneratedId();
  const existInDiscounts = discount.discountId === 0 ? false : Object.values(order.orderDiscounts).find(
    (_discount) => _discount.discountId === discount.discountId
  );
  if (existInDiscounts)
    delete order.orderDiscounts[existInDiscounts.id > 0 ? existInDiscounts.id : existInDiscounts.tabletGeneratedId];
  const newDiscount = __spreadProps(__spreadValues(__spreadValues({}, ITEM_DISCOUNT_INITIAL_STATE), discount), {
    tabletGeneratedId
  });
  if (discount.type === "override" /* OVERRIDE */ || discount.isExclusive) {
    discount.type === "override" /* OVERRIDE */ && removeAllItemDiscounts(
      order.ticketElements,
      order.type,
      order.isLockedPrice,
      order.taxExempt,
      order.noTaxInclusive
    );
    order.orderDiscounts = {
      [tabletGeneratedId]: __spreadProps(__spreadValues({}, newDiscount), {
        appliedDiscountAmount: roundToMoneyDecimals(
          getAppliedDiscountAmount(
            discount.type,
            discount.value,
            calcOrderMainSubtotal(order),
            1
          )
        )
      })
    };
  } else {
    order.orderDiscounts[tabletGeneratedId] = newDiscount;
    const applyDiscountsReducer = getDiscountCalculatorReducer(1);
    const separatedDiscounts = Object.values((_a = order.orderDiscounts) != null ? _a : {}).filter(
      removeExclusive ? (orderDiscount) => !orderDiscount.isExclusive : () => true
    ).reduce(separateDiscountsByTaxesType, { before: [], after: [] });
    const beforeTaxesDiscounts = separatedDiscounts.before.sort(sortDiscountsFunction).reduce(applyDiscountsReducer, {
      appliedDiscounts: [],
      itemPrice: calcOrderMainSubtotal(order) + order.serviceChargeTotal - getTotalSpecialAmount((_b = order.orderSpecials) != null ? _b : {})
    });
    const afterTaxesDiscounts = separatedDiscounts.after.sort(sortDiscountsFunction).reduce(applyDiscountsReducer, {
      appliedDiscounts: [],
      itemPrice: beforeTaxesDiscounts.itemPrice + order.tax
    });
    order.orderDiscounts = [
      ...beforeTaxesDiscounts.appliedDiscounts,
      ...afterTaxesDiscounts.appliedDiscounts
    ].reduce(reduceToDiscountsObject, {});
  }
};
var applyDiscountToItems = (discount, itemIds, order, removeExclusive, currentSeat, checkForSplit) => {
  itemIds.filter((itemId) => {
    var _a;
    const ticketElement = order.ticketElements[itemId];
    return isOpenItemFn(ticketElement) || !((_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[ticketElement.menuTypeId].excludeFromDiscounts);
  }).forEach((itemId) => {
    let requireSplit = checkForSplit;
    if (checkForSplit) {
      const isUniqueSeatElement = Object.keys(order.ticketElements[itemId].seating).length === 1 && order.ticketElements[itemId].seating[currentSeat];
      requireSplit = !isUniqueSeatElement;
    }
    const ticketElement = getAndSplitTicketElement(
      order,
      itemId,
      requireSplit,
      currentSeat
    );
    if (!ticketElement.discounts)
      ticketElement.discounts = {};
    const isItemTaxInclusive = isTicketElementTaxInclusive(ticketElement);
    const discountIsTaxInclusive = discount.taxes === "applyAfterTaxes" /* APPLY_AFTER */;
    const existInDiscounts = discount.discountId === 0 ? false : Object.values(ticketElement.discounts).find(
      (_discount) => _discount.discountId === discount.discountId
    );
    if (existInDiscounts)
      delete ticketElement.discounts[existInDiscounts.id > 0 ? existInDiscounts.id : existInDiscounts.tabletGeneratedId];
    const tabletGeneratedId = getNextTabletGeneratedId();
    const newDiscount = __spreadProps(__spreadValues(__spreadValues({}, ITEM_DISCOUNT_INITIAL_STATE), discount), {
      tabletGeneratedId
    });
    if (discount.type === "override" /* OVERRIDE */ || discount.isExclusive)
      ticketElement.discounts = {
        [tabletGeneratedId]: __spreadProps(__spreadValues({}, newDiscount), {
          appliedDiscountAmount: roundToMoneyDecimals(
            getAppliedDiscountAmount(
              discount.type,
              discount.value,
              (ticketElement.isPriceOverride ? ticketElement.overridePricePerItemUnit : ticketElement.baseItemPrice + (isItemTaxInclusive ? ticketElement.taxInclusiveSelectedModifiersPricePerItemUnit : ticketElement.selectedModifiersPricePerItemUnit) + (discountIsTaxInclusive ? ticketElement.totalTax : 0)) * ticketElement.quantity - (isNotOpenItemFn(ticketElement) ? ticketElement.totalSpecialsBOGOAmount + ticketElement.totalSpecialsAmount : 0),
              ticketElement.totalTax,
              ticketElement.quantity
            )
          )
        })
      };
    else {
      ticketElement.discounts[tabletGeneratedId] = newDiscount;
      const applyDiscountsReducer = getDiscountCalculatorReducer(
        ticketElement.quantity
      );
      const itemPrice = (ticketElement.isPriceOverride ? ticketElement.overridePricePerItemUnit : ticketElement.baseItemPrice + (isItemTaxInclusive ? ticketElement.taxInclusiveSelectedModifiersPricePerItemUnit : ticketElement.selectedModifiersPricePerItemUnit) + (discountIsTaxInclusive ? ticketElement.totalTax : 0)) * ticketElement.quantity - (isNotOpenItemFn(ticketElement) ? ticketElement.totalSpecialsAmount + ticketElement.totalSpecialsBOGOAmount : 0);
      ticketElement.discounts = Object.values(ticketElement.discounts).filter(
        removeExclusive ? (itemDiscount) => !itemDiscount.isExclusive : () => true
      ).sort(sortDiscountsFunction).reduce(applyDiscountsReducer, {
        appliedDiscounts: [],
        itemPrice
      }).appliedDiscounts.reduce(reduceToDiscountsObject, {});
    }
    calcTotalItemWithAlternativePrice(ticketElement, {
      calcSpecial: false,
      calcDiscount: false,
      orderType: order.type,
      orderIsLockedPrice: order.isLockedPrice,
      taxExempt: order.taxExempt,
      noTaxInclusive: order.noTaxInclusive
    });
  });
};
var applyDiscountToCombos = (discount, comboIds, order, removeExclusive) => {
  const tabletGeneratedCode = generateTabletGeneratedId();
  comboIds.forEach((comboId, index) => {
    const comboElement = order.combos[comboId];
    if (!comboElement.discounts)
      comboElement.discounts = {};
    const isTaxInclusive = isComboElementTaxInclusive(comboElement);
    const existInDiscounts = discount.discountId === 0 ? false : Object.values(comboElement.discounts).find(
      (_discount) => _discount.discountId === discount.discountId
    );
    if (existInDiscounts)
      delete comboElement.discounts[existInDiscounts.id > 0 ? existInDiscounts.id : existInDiscounts.tabletGeneratedId];
    const tabletGeneratedId = `${tabletGeneratedCode}-${index + 1}`;
    const newDiscount = __spreadProps(__spreadValues(__spreadValues({}, ITEM_DISCOUNT_INITIAL_STATE), discount), {
      tabletGeneratedId
    });
    if (discount.type === "override" /* OVERRIDE */ || discount.isExclusive)
      comboElement.discounts = {
        [tabletGeneratedId]: __spreadProps(__spreadValues({}, newDiscount), {
          appliedDiscountAmount: roundToMoneyDecimals(
            getAppliedDiscountAmount(
              discount.type,
              discount.value,
              (comboElement.isPriceOverride ? comboElement.overridePricePerItemUnit : comboElement.comboBasePrice + (isTaxInclusive ? comboElement.taxInclusiveAdditionalPrice : comboElement.totalAdditionalPriceAmount)) * comboElement.quantity - comboElement.totalSpecialsBOGOAmount - comboElement.totalSpecialsAmount,
              comboElement.quantity
            )
          )
        })
      };
    else {
      comboElement.discounts[tabletGeneratedId] = newDiscount;
      const applyDiscountsReducer = getDiscountCalculatorReducer(
        comboElement.quantity
      );
      comboElement.discounts = Object.values(comboElement.discounts).filter(
        removeExclusive ? (itemDiscount) => !itemDiscount.isExclusive : () => true
      ).sort(sortDiscountsFunction).reduce(applyDiscountsReducer, {
        appliedDiscounts: [],
        itemPrice: (comboElement.isPriceOverride ? comboElement.overridePricePerItemUnit : comboElement.comboBasePrice + (isTaxInclusive ? comboElement.taxInclusiveAdditionalPrice : comboElement.totalAdditionalPriceAmount)) * comboElement.quantity - comboElement.totalSpecialsAmount - comboElement.totalSpecialsBOGOAmount
      }).appliedDiscounts.reduce(reduceToDiscountsObject, {});
    }
    calcTotalComboPrice(comboElement, {
      calcDiscount: false,
      taxExempt: order.taxExempt
    });
  });
};
var removeItemDiscountByIdOrTabletGeneratedId = (ticketElement, id, tabletGeneratedId) => {
  if (id > 0)
    delete ticketElement.discounts[id];
  else
    delete ticketElement.discounts[tabletGeneratedId];
  const applyDiscountsReducer = getDiscountCalculatorReducer(
    ticketElement.quantity
  );
  const isTaxInclusive = isTicketElementTaxInclusive(ticketElement);
  ticketElement.discounts = Object.values(ticketElement.discounts).sort(sortDiscountsFunction).reduce(applyDiscountsReducer, {
    appliedDiscounts: [],
    itemPrice: ticketElement.isPriceOverride ? ticketElement.overridePricePerItemUnit : ticketElement.baseItemPrice + (isTaxInclusive ? ticketElement.taxInclusiveSelectedModifiersPricePerItemUnit : ticketElement.selectedModifiersPricePerItemUnit) - (isOpenItemFn(ticketElement) ? 0 : ticketElement.totalSpecialsAmount)
  }).appliedDiscounts.reduce(reduceToDiscountsObject, {});
};
var removeComboDiscountByIdOrTabletGeneratedId = (comboElement, id, tabletGeneratedId) => {
  if (id > 0)
    delete comboElement.discounts[id];
  else
    delete comboElement.discounts[tabletGeneratedId];
  const isTaxInclusive = isComboElementTaxInclusive(comboElement);
  const applyDiscountsReducer = getDiscountCalculatorReducer(
    comboElement.quantity
  );
  comboElement.discounts = Object.values(comboElement.discounts).sort(sortDiscountsFunction).reduce(applyDiscountsReducer, {
    appliedDiscounts: [],
    itemPrice: comboElement.isPriceOverride ? comboElement.overridePricePerItemUnit : comboElement.comboBasePrice + (isTaxInclusive ? comboElement.taxInclusiveAdditionalPrice : comboElement.totalAdditionalPriceAmount) - comboElement.totalSpecialsAmount
  }).appliedDiscounts.reduce(reduceToDiscountsObject, {});
};
var removeOrderDiscountByIdOrTabletGeneratedId = (order, id, tabletGeneratedId) => {
  if (id > 0)
    delete order.orderDiscounts[id];
  else
    delete order.orderDiscounts[tabletGeneratedId];
  const applyDiscountsReducer = getDiscountCalculatorReducer(1);
  order.orderDiscounts = Object.values(order.orderDiscounts).sort(sortDiscountsFunction).reduce(applyDiscountsReducer, {
    appliedDiscounts: [],
    itemPrice: calcOrderMainSubtotal(order)
  }).appliedDiscounts.reduce(reduceToDiscountsObject, {});
};
var removeAllItemDiscounts = (ticket, orderType, orderIsLockedPrice, taxExempt, noTaxInclusive) => {
  Object.values(ticket).forEach((ticketElement) => {
    ticketElement.discounts = {};
    ticketElement.totalDiscountAmount = 0;
    calcTotalItemWithAlternativePrice(ticketElement, {
      calcDiscount: false,
      orderType,
      orderIsLockedPrice,
      taxExempt,
      noTaxInclusive
    });
  });
};
var calcDiscountAmountAppliedToItem = (discounts, quantity, itemPrice) => {
  const applyDiscountsReducer = getDiscountCalculatorReducer(quantity);
  return Object.values(discounts).sort(sortDiscountsFunction).reduce(applyDiscountsReducer, {
    appliedDiscounts: [],
    itemPrice
  }).appliedDiscounts.reduce(reduceToDiscountsObject, {});
};
var getAppliedDiscountAmount = (type, value, baseItemPrice, quantity, thresholdAmount) => {
  const basePriceWithTaxes = baseItemPrice;
  switch (type) {
    case "percent" /* PERCENT */:
      return isNumber(thresholdAmount) && thresholdAmount > 0 ? Math.min(
        basePriceWithTaxes * value / 100,
        thresholdAmount * quantity
      ) : basePriceWithTaxes * value / 100;
    case "fixed" /* FIXED */:
      return value * quantity >= basePriceWithTaxes ? basePriceWithTaxes : value * quantity;
    case "override" /* OVERRIDE */:
      return value * quantity < basePriceWithTaxes ? basePriceWithTaxes - value * quantity : 0;
    default:
      return 0;
  }
};
var getTotalDiscountAmountReducer = (totalItemDiscountAmount, discount) => totalItemDiscountAmount + discount.appliedDiscountAmount;
var getTotalDiscountAmount = (discounts) => Object.values(discounts != null ? discounts : {}).reduce(getTotalDiscountAmountReducer, 0);
var checkAndUpdateOrderDiscounts = (order, getOrderDiscountsFunction, getOrderSpecialsFunction, getSubtotalFunction) => {
  var _a, _b;
  const applyDiscountsReducer = getDiscountCalculatorReducer(1);
  const separatedDiscounts = Object.values(
    (_a = getOrderDiscountsFunction(order)) != null ? _a : {}
  ).reduce(separateDiscountsByTaxesType, { before: [], after: [] });
  const orderSubtotal = getSubtotalFunction(order);
  const totalSpecialAmount = getTotalSpecialAmount(
    (_b = getOrderSpecialsFunction(order)) != null ? _b : {}
  );
  const itemPrice = orderSubtotal + order.serviceChargeTotal - totalSpecialAmount;
  const beforeTaxesDiscounts = separatedDiscounts.before.sort(sortDiscountsFunction).reduce(applyDiscountsReducer, {
    appliedDiscounts: [],
    itemPrice
  });
  const afterTaxesDiscounts = separatedDiscounts.after.sort(sortDiscountsFunction).reduce(applyDiscountsReducer, {
    appliedDiscounts: [],
    itemPrice: beforeTaxesDiscounts.itemPrice + order.tax
  });
  return [
    ...beforeTaxesDiscounts.appliedDiscounts,
    ...afterTaxesDiscounts.appliedDiscounts
  ].reduce(reduceToDiscountsObject, {});
};
var DISCOUNT_SORT_VALUES = {
  ["override" /* OVERRIDE */]: 1,
  ["fixed" /* FIXED */]: 2,
  ["percent" /* PERCENT */]: 3
};
var DISCOUNT_TAXES_SORT_VALUES = {
  ["applyBeforeTaxes" /* APPLY_BEFORE */]: 1,
  ["applyAfterTaxes" /* APPLY_AFTER */]: 2
};
var sortDiscountsFunction = (dA, dB) => dA.type === dB.type ? (dA.taxes || "applyBeforeTaxes" /* APPLY_BEFORE */) === (dB.taxes || "applyBeforeTaxes" /* APPLY_BEFORE */) ? (dA.value - dB.value) * -1 : DISCOUNT_TAXES_SORT_VALUES[dA.taxes] - DISCOUNT_TAXES_SORT_VALUES[dB.taxes] : DISCOUNT_SORT_VALUES[dA.type] - DISCOUNT_SORT_VALUES[dB.type];
var separateDiscountsByTaxesType = (acc, discount) => {
  if (discount.taxes === "applyAfterTaxes" /* APPLY_AFTER */)
    return __spreadProps(__spreadValues({}, acc), { after: [...acc.after, discount] });
  return __spreadProps(__spreadValues({}, acc), { before: [...acc.before, discount] });
};
var reduceToDiscountsObject = (discountObj, _discount) => __spreadProps(__spreadValues({}, discountObj), {
  [_discount.id > 0 ? _discount.id : _discount.tabletGeneratedId]: _discount
});
var updateItemDiscountObjectByIdOrTabletGeneratedId = (ticketElement, discount, discountId, tabletGeneratedId, isCustom) => {
  addDiscountToObject(
    ticketElement.discounts,
    discount,
    discountId,
    tabletGeneratedId
  );
  if (isCustom) {
    const applyDiscountsReducer = getDiscountCalculatorReducer(
      ticketElement.quantity
    );
    const isTaxInclusive = isTicketElementTaxInclusive(ticketElement);
    ticketElement.discounts = Object.values(ticketElement.discounts).sort(sortDiscountsFunction).reduce(applyDiscountsReducer, {
      appliedDiscounts: [],
      itemPrice: ticketElement.isPriceOverride ? ticketElement.overridePricePerItemUnit : ticketElement.baseItemPrice + (isTaxInclusive ? ticketElement.taxInclusiveSelectedModifiersPricePerItemUnit : ticketElement.selectedModifiersPricePerItemUnit) - (isOpenItemFn(ticketElement) ? 0 : ticketElement.totalSpecialsAmount)
    }).appliedDiscounts.reduce(reduceToDiscountsObject, {});
  }
};
var updateComboDiscountObjectByIdOrTabletGeneratedId = (comboElement, discount, discountId, tabletGeneratedId, isCustom) => {
  addDiscountToObject(
    comboElement.discounts,
    discount,
    discountId,
    tabletGeneratedId
  );
  if (isCustom) {
    const applyDiscountsReducer = getDiscountCalculatorReducer(
      comboElement.quantity
    );
    const isTaxInclusive = isComboElementTaxInclusive(comboElement);
    comboElement.discounts = Object.values(comboElement.discounts).sort(sortDiscountsFunction).reduce(applyDiscountsReducer, {
      appliedDiscounts: [],
      itemPrice: comboElement.isPriceOverride ? comboElement.overridePricePerItemUnit : comboElement.comboBasePrice + (isTaxInclusive ? comboElement.taxInclusiveAdditionalPrice : comboElement.totalAdditionalPriceAmount) - comboElement.totalSpecialsAmount
    }).appliedDiscounts.reduce(reduceToDiscountsObject, {});
  }
};
var updateOrderDiscountObjectByIdOrTabletGeneratedId = (order, discount, discountId, tabletGeneratedId, isCustom) => {
  addDiscountToObject(
    order.orderDiscounts,
    discount,
    discountId,
    tabletGeneratedId
  );
  if (isCustom) {
    const applyDiscountsReducer = getDiscountCalculatorReducer(1);
    order.orderDiscounts = Object.values(order.orderDiscounts).sort(sortDiscountsFunction).reduce(applyDiscountsReducer, {
      appliedDiscounts: [],
      itemPrice: calcOrderMainSubtotal(order)
    }).appliedDiscounts.reduce(reduceToDiscountsObject, {});
  }
};
var getDiscountCalculatorReducer = (quantity) => ({ appliedDiscounts, itemPrice }, itemDiscount) => {
  const appliedDiscountAmount = roundToMoneyDecimals(
    getAppliedDiscountAmount(
      itemDiscount.type,
      itemDiscount.value,
      itemPrice,
      quantity
    )
  );
  return {
    appliedDiscounts: [
      ...appliedDiscounts,
      __spreadProps(__spreadValues({}, itemDiscount), { appliedDiscountAmount })
    ],
    itemPrice: itemPrice - appliedDiscountAmount
  };
};
var addDiscountToObject = (discountObject, discount, discountId, tabletGeneratedId) => {
  const id = discountId > 0 ? discountId : tabletGeneratedId;
  discountObject[id] = __spreadValues(__spreadValues({}, discountObject[id]), discount);
};
var getItemNameOrNames = (itemList) => {
  return Object.values(itemList).map(
    (item) => {
      var _a;
      return (_a = item.itemObj) == null ? void 0 : _a.menuTypeVersions[item.isOpenItem ? 0 : item.menuTypeId].posName;
    }
  );
};
var getComboNames = (itemList) => {
  return Object.values(itemList).map(
    (combo) => {
      var _a;
      return (_a = combo.comboObj) == null ? void 0 : _a.menuTypeVersions[combo.menuTypeId].posName;
    }
  );
};
var getDiscountCount = (acc, element) => {
  const hasDiscounts = Object.values(element.discounts).length > 0;
  if (hasDiscounts)
    return {
      count: acc.count + 1,
      items: [...acc.items, getTicketElementId(element)]
    };
  return acc;
};
var getExclusiveDiscountsCount = (acc, item) => {
  const hasExclusiveDiscount = Object.values(item.discounts).some(
    (itemDiscount) => itemDiscount.isExclusive
  );
  if (hasExclusiveDiscount)
    return {
      count: acc.count + 1,
      items: [...acc.items, getTicketElementId(item)]
    };
  return acc;
};

// src/helpers/register/reducerHelpers/specials.ts
var EMPTY_SPECIALS_OBJECT = {};
var createValidationObject = (buyQuantity, getQuantity, buyItemElements, getItemElements, buyComboElements, getComboElements) => {
  return {
    isComplete: buyQuantity === buyItemElements.length + buyComboElements.length && getQuantity === getItemElements.length + getComboElements.length,
    isPartiallyComplete: buyQuantity === buyItemElements.length + buyComboElements.length && getItemElements.length + getComboElements.length > 0,
    buy: {
      isComplete: buyQuantity === buyItemElements.length + buyComboElements.length,
      elements: [...buyItemElements, ...buyComboElements]
    },
    get: {
      isComplete: getQuantity === getItemElements.length + getComboElements.length,
      elements: [...getItemElements, ...getComboElements]
    },
    hasItems: buyItemElements.length > 0 || getItemElements.length > 0 || buyComboElements.length > 0 || getComboElements.length > 0
  };
};
var getSpecialsActiveNow = (specials, timeZone, menuTypeId) => {
  const dayKey = getDayKey(timeZone);
  const todaySpecials = specials.filter(
    (special) => special.menuTypeVersions[menuTypeId].availableTimes[dayKey]
  );
  if (todaySpecials.length === 0)
    return {};
  const specialsWithTodayTimes = todaySpecials.map(
    ({ specialId, menuTypeVersions }) => ({
      specialId,
      posName: menuTypeVersions[menuTypeId].posName,
      discountType: menuTypeVersions[menuTypeId].discountType,
      thresholdAmount: menuTypeVersions[menuTypeId].thresholdAmount,
      discountAmount: menuTypeVersions[menuTypeId].discountAmount,
      specialApplyTo: menuTypeVersions[menuTypeId].specialApplyTo,
      times: menuTypeVersions[menuTypeId].availableTimes[dayKey].map(
        ({ startTime, endTime }) => __spreadValues({
          day: dayKey
        }, getMilitaryHourRange(startTime, endTime, timeZone))
      )
    })
  );
  const todayUTC = DateTime.now().setZone(timeZone);
  const nowMilitaryFormat = getMilitaryHourLuxon(todayUTC);
  const specialsWithTodayTimesFiltered = specialsWithTodayTimes.map((special) => __spreadProps(__spreadValues({}, special), {
    times: special.times.filter(
      (specialTime) => nowMilitaryFormat >= specialTime.startTimeMilitary && nowMilitaryFormat <= specialTime.endTimeMilitary
    )
  })).filter((special) => special.times.length > 0);
  if (specialsWithTodayTimesFiltered.length === 0)
    return {};
  return specialsWithTodayTimesFiltered.reduce(
    (acc, special) => __spreadProps(__spreadValues({}, acc), { [special.specialId]: special }),
    {}
  );
};
var getSpecialsFromMenuType = (menuTypeId, specials, timeZone) => {
  if (!menuTypeId)
    return {};
  const activeSpecials = Object.values(specials).filter(
    (special) => special.menuTypeVersions[menuTypeId] && special.menuTypeVersions[menuTypeId].active
  );
  return getSpecialsActiveNow(activeSpecials, timeZone, menuTypeId);
};
var getBogoSpecialsFromActiveSpecialsObject = (activeSpecials) => {
  return Object.values(activeSpecials).filter((special) => special.specialApplyTo === "bogo" /* BOGO */).reduce((acc, special) => {
    return __spreadProps(__spreadValues({}, acc), { [special.specialId]: special });
  }, {});
};
var getItemSpecialsFromActiveSpecialsObject = (activeSpecials) => {
  return Object.values(activeSpecials).filter((special) => special.specialApplyTo === "item" /* ITEM */).reduce((acc, special) => {
    return __spreadProps(__spreadValues({}, acc), { [special.specialId]: special });
  }, {});
};
var SPECIAL_TYPES_SORT_VALUES = {
  item: 1,
  bogo: 2,
  order: 3
};
var sortSpecialsFunction = (specialA, specialB) => SPECIAL_TYPES_SORT_VALUES[specialA.specialApplyTo] - SPECIAL_TYPES_SORT_VALUES[specialB.specialApplyTo];
var sortAppliedSpecialsFunction = (specialA, specialB) => SPECIAL_TYPES_SORT_VALUES[specialA.specialApplyTo] - SPECIAL_TYPES_SORT_VALUES[specialB.specialApplyTo];
var getSpecialAppliedValue = (activeSpecial) => {
  return {
    id: 0,
    tabletGeneratedId: "",
    appliedSpecialAmount: 0,
    specialId: activeSpecial.specialId,
    discountedAmount: activeSpecial.discountAmount,
    posName: activeSpecial.posName,
    checkName: activeSpecial.checkName,
    specialApplyTo: activeSpecial.specialApplyTo,
    type: activeSpecial.discountType,
    thresholdAmount: activeSpecial.thresholdAmount,
    instances: []
  };
};
var getSpecialsCalculatorReducer = (quantity) => ({ appliedSpecials, itemPrice }, special) => {
  let appliedSpecialAmount = roundToMoneyDecimals(
    getAppliedDiscountAmount(
      special.type,
      special.discountedAmount,
      itemPrice,
      quantity,
      special.thresholdAmount
    )
  );
  if (appliedSpecialAmount < 0) {
    appliedSpecialAmount = 0;
  }
  return {
    appliedSpecials: [
      ...appliedSpecials,
      __spreadProps(__spreadValues({}, special), { appliedSpecialAmount })
    ],
    itemPrice: itemPrice - appliedSpecialAmount
  };
};
var getBogoSpecialCalculatorReducer = () => ({ appliedSpecials, itemPrice }, itemDiscount) => {
  var _a;
  const appliedSpecialAmount = roundToMoneyDecimals(
    getAppliedDiscountAmount(
      itemDiscount.type,
      itemDiscount.discountedAmount,
      itemPrice * itemDiscount.instances.length,
      (_a = itemDiscount.instances.length) != null ? _a : 0,
      itemDiscount.thresholdAmount
    )
  );
  return {
    appliedSpecials: [
      ...appliedSpecials,
      __spreadProps(__spreadValues({}, itemDiscount), { appliedSpecialAmount })
    ],
    itemPrice: itemPrice - appliedSpecialAmount
  };
};
var checkAndUpdateOrderSpecials = (order, getSubtotalFunction) => {
  var _a;
  const applyDiscountsReducer = getSpecialsCalculatorReducer(1);
  const subtotal = getSubtotalFunction(order);
  const itemPrice = subtotal;
  order.orderSpecials = Object.values((_a = order.orderSpecials) != null ? _a : {}).reduce(applyDiscountsReducer, {
    appliedSpecials: [],
    itemPrice
  }).appliedSpecials.reduce(reduceToSpecialsObject, {});
};
var calcOrderSpecials = (order) => {
  var _a;
  const applyDiscountsReducer = getSpecialsCalculatorReducer(1);
  const subtotal = calcOrderMainSubtotal(order);
  const itemPrice = subtotal;
  order.alternativePriceData.orderSpecials = Object.values(
    (_a = order.alternativePriceData.orderSpecials) != null ? _a : {}
  ).reduce(applyDiscountsReducer, {
    appliedSpecials: [],
    itemPrice
  }).appliedSpecials.reduce(reduceToSpecialsObject, {});
};
var getTotalSpecialAmount = (specials) => {
  return Object.values(specials != null ? specials : {}).filter((special) => special.specialApplyTo !== "bogo" /* BOGO */).reduce((totalItemDiscountAmount, discount) => {
    const value = totalItemDiscountAmount + discount.appliedSpecialAmount;
    return value;
  }, 0);
};
var getItemPriceForSpecialsFlow = (element) => {
  return element.isPriceOverride ? element.overridePricePerItemUnit : isComboElement(element) ? element.comboBasePrice : element.baseItemPrice;
};
var getAlternativePriceForSpecialsFlow = (element) => {
  return element.isPriceOverride ? element.overridePricePerItemUnit : isComboElement(element) ? element.alternativePriceData.comboBasePrice : element.alternativePriceData.baseItemPrice;
};
var calcSpecialAmountApplied = (specials, quantity, elementPrice) => {
  const applyDiscountReducer = getSpecialsCalculatorReducer(quantity);
  const applyBogoSpecialReducer = getBogoSpecialCalculatorReducer();
  const bogoSpecials = Object.values(specials).filter((special) => special.specialApplyTo === "bogo" /* BOGO */).sort(sortAppliedSpecialsFunction).reduce(applyBogoSpecialReducer, {
    appliedSpecials: [],
    itemPrice: elementPrice
  }).appliedSpecials;
  const normalSpecials = Object.values(specials).filter((special) => special.specialApplyTo !== "bogo" /* BOGO */).sort(sortAppliedSpecialsFunction).reduce(applyDiscountReducer, {
    appliedSpecials: [],
    itemPrice: elementPrice * quantity
  }).appliedSpecials;
  return [...normalSpecials, ...bogoSpecials].reduce(
    reduceToSpecialsObject,
    EMPTY_SPECIALS_OBJECT
  );
};
var getTotalBogoSpecialAmount = (specials) => {
  return Object.values(specials != null ? specials : {}).filter((special) => special.specialApplyTo === "bogo" /* BOGO */).reduce(
    (totalItemDiscountAmount, discount) => totalItemDiscountAmount + discount.appliedSpecialAmount,
    0
  );
};
var reduceToSpecialsObject = (specialsObj, special) => __spreadProps(__spreadValues({}, specialsObj), {
  [special.id > 0 ? special.id : special.tabletGeneratedId]: special
});
var setUpBogoSpecial = (ticketElementId, comboElementId, buyQuantity, selectedQuantity) => {
  const isComplete = selectedQuantity >= buyQuantity;
  let numberOfInstances = selectedQuantity;
  if (isComplete)
    numberOfInstances = buyQuantity;
  const elements = new Array(numberOfInstances).fill(null).map((_, index) => ({
    elementInstance: index + 1,
    ticketElementId,
    comboElementId
  }));
  return {
    isComplete,
    elements
  };
};
var transformResultToSpecialValidation = (elements) => {
  return elements.map(
    (element) => element.isCombo ? {
      ticketElementId: null,
      comboElementId: getEntityIdOrTabletGeneratedId(element),
      instanceId: element.itemElementId
    } : {
      ticketElementId: getEntityIdOrTabletGeneratedId(element),
      comboElementId: null,
      instanceId: element.itemElementId
    }
  );
};
var mergeElementInstances = (elements, elementsWithChanges) => {
  const items = elements.filter((element) => !element.isCombo).map((element) => getEntityIdOrTabletGeneratedId(element)).concat(elementsWithChanges[0].map((element) => element.ticketElementId));
  const uniqueItems = [...new Set(items).values()].map((element) => ({
    ticketElementId: element,
    isCombo: false
  }));
  const combos = elements.filter((element) => element.isCombo).map((element) => getEntityIdOrTabletGeneratedId(element)).concat(elementsWithChanges[1].map((element) => element.comboElementId));
  const uniqueCombos = [...new Set(combos).values()].map((element) => ({
    comboElementId: element,
    isCombo: true
  }));
  return [...uniqueItems, ...uniqueCombos];
};
var getInstances = (quantity) => {
  return new Array(quantity).fill(null).map((_, index) => index + 1);
};
var mapElementIdToInstanceKey = (elementId) => (instance) => `${elementId}-${instance}`;
var mapElementIdToInstanceObject = (elementId) => (instance) => ({
  elementId,
  instance
});
var clearItemSpecial = (order, ticket, ticketElementId, specialId, currentSpecials) => {
  const ticketElement = ticket[ticketElementId];
  if (!ticketElement)
    return;
  if (isOpenItemFn(ticketElement))
    return;
  const specialExist = Object.values(ticketElement.specials).find(
    (special) => special.specialId === specialId
  );
  if (specialExist) {
    const { instances, count } = countItemInstances(
      currentSpecials,
      specialId,
      ticketElementId
    );
    if (count === 0)
      delete ticketElement.specials[specialExist.id || specialExist.tabletGeneratedId];
    else {
      ticketElement.specials[specialExist.id || specialExist.tabletGeneratedId].instances = instances;
    }
  }
  const applyDiscountsReducer = getSpecialsCalculatorReducer(
    ticketElement.quantity
  );
  ticketElement.specials = Object.values(ticketElement.specials).sort(sortAppliedSpecialsFunction).reduce(applyDiscountsReducer, {
    appliedSpecials: [],
    itemPrice: ticket[ticketElementId].isPriceOverride ? ticketElement.overridePricePerItemUnit : ticketElement.baseItemPrice + ticketElement.selectedModifiersPricePerItemUnit
  }).appliedSpecials.reduce(reduceToSpecialsObject, {});
  ticketElement.totalSpecialsAmount = getTotalSpecialAmount(
    ticketElement.specials
  );
  calcTotalItemWithAlternativePrice(ticketElement, {
    orderType: order.type,
    taxExempt: order.taxExempt,
    noTaxInclusive: order.noTaxInclusive,
    orderIsLockedPrice: order.isLockedPrice
  });
  updateCheckElementForTicketElement(order, ticketElementId);
};
var clearComboSpecial = (order, combos, comboElementId, specialId, currentSpecials) => {
  if (!combos[comboElementId])
    return;
  const specialExist = Object.values(combos[comboElementId].specials).find(
    (special) => special.specialId === specialId
  );
  if (specialExist) {
    const { instances, count } = countComboInstances(
      currentSpecials,
      specialId,
      comboElementId
    );
    if (count === 0)
      delete combos[comboElementId].specials[specialExist.id || specialExist.tabletGeneratedId];
    else {
      combos[comboElementId].specials[specialExist.id || specialExist.tabletGeneratedId].instances = instances;
    }
  }
  const applyDiscountsReducer = getSpecialsCalculatorReducer(
    combos[comboElementId].quantity
  );
  combos[comboElementId].specials = Object.values(
    combos[comboElementId].specials
  ).sort(sortAppliedSpecialsFunction).reduce(applyDiscountsReducer, {
    appliedSpecials: [],
    itemPrice: combos[comboElementId].isPriceOverride ? combos[comboElementId].overridePricePerItemUnit : combos[comboElementId].comboBasePrice + combos[comboElementId].totalAdditionalPriceAmount
  }).appliedSpecials.reduce(reduceToSpecialsObject, {});
  combos[comboElementId].totalSpecialsAmount = getTotalSpecialAmount(
    combos[comboElementId].specials
  );
  calcTotalComboWithAlternativePrice(combos[comboElementId], {
    orderType: order.type,
    taxExempt: order.taxExempt,
    noTaxInclusive: order.noTaxInclusive,
    orderIsLockedPrice: order.isLockedPrice
  });
  updateCheckElementForComboElement(order, comboElementId);
};
var findElementByIdAndType = (type, elementId) => (element) => type === "item" ? element.ticketElementId === elementId : element.comboElementId === elementId;
var replaceKeyWithInstanceDictionary = (dictionary) => (element) => {
  if (element.ticketElementId) {
    const baseKey = element.instanceId;
    if (dictionary[baseKey]) {
      element.ticketElementId = dictionary[baseKey].elementId;
      element.instanceId = dictionary[baseKey].instanceId;
    }
  } else if (element.comboElementId) {
    const baseKey = element.instanceId;
    if (dictionary[baseKey]) {
      element.comboElementId = dictionary[baseKey].elementId;
      element.instanceId = dictionary[baseKey].instanceId;
    }
  }
};
var updateCurrentOrderSpecialObjectWithDictionary = (dictionary, currentOrderSpecialsObject) => {
  const replaceKeyFunction = replaceKeyWithInstanceDictionary(dictionary);
  currentOrderSpecialsObject.forEach((specialObject) => {
    specialObject.validation.buy.elements.forEach(replaceKeyFunction);
    specialObject.validation.get.elements.forEach(replaceKeyFunction);
  });
};
var updateCurrentOrderSpecialsWithItems = (originalObject, updatedObjectArray, currentOrderSpecialsObject) => {
  const originalInstances = [...originalObject.instanceIds].map((itemElementId) => itemElementId).sort();
  const updatedInstances = updatedObjectArray.map((updatedObject) => {
    return updatedObject.instanceIds.map((instanceId, index) => ({
      elementId: updatedObject.id,
      instance: index + 1,
      instanceId
    }));
  }).flat().sort((a, b) => a.instanceId.localeCompare(b.instanceId));
  const dictionaryEntries = zip(originalInstances, updatedInstances);
  const dictionaryKeys = {};
  dictionaryEntries.forEach(([oldKeyInstance, newKeyInstance]) => {
    if (oldKeyInstance && newKeyInstance)
      dictionaryKeys[oldKeyInstance] = newKeyInstance;
  });
  updateCurrentOrderSpecialObjectWithDictionary(
    dictionaryKeys,
    currentOrderSpecialsObject
  );
};
var updateTicketElementWithInstancesCount = (ticketElement, ticketElementId, special, currentOrderSpecialsObject, orderType, taxExempt, orderIsLockedPrice, noTaxInclusive) => {
  const { count, instances } = countItemInstances(
    currentOrderSpecialsObject,
    special.specialId,
    ticketElementId
  );
  if (count)
    ticketElement.specials[special.id || special.tabletGeneratedId].instances = instances;
  else
    delete ticketElement.specials[special.id || special.tabletGeneratedId];
  calcTotalItemWithAlternativePrice(ticketElement, {
    orderType,
    taxExempt,
    orderIsLockedPrice,
    noTaxInclusive
  });
};
var getSpecialBoundToItem = (currentOrderSpecialsObject, ticketElementId, comboElementId) => {
  return currentOrderSpecialsObject.find((special) => {
    return special.validation.get.elements.find((element) => {
      if (ticketElementId && `${element.ticketElementId}` === `${ticketElementId}`)
        return element;
      if (comboElementId && `${element.comboElementId}` === `${comboElementId}`)
        return element;
      return void 0;
    });
  });
};
var getItemBOGOAppliedAmount = (specialObject, ticketElement) => {
  return getAppliedDiscountAmount(
    specialObject.discountType,
    specialObject.discountAmount,
    ticketElement.isPriceOverride ? ticketElement.overridePricePerItemUnit : ticketElement.baseItemPrice,
    1,
    specialObject.thresholdAmount
  );
};
var getComboBOGOAppliedAmount = (specialObject, comboElement) => {
  return getAppliedDiscountAmount(
    specialObject.discountType,
    specialObject.discountAmount,
    comboElement.isPriceOverride ? comboElement.overridePricePerItemUnit : comboElement.comboBasePrice,
    1,
    specialObject.thresholdAmount
  );
};
var filterSpecialsBySpecialIdAndTicketElementId = (currentSpecials, specialId, ticketElementId) => {
  return currentSpecials.filter((specialObject) => specialObject.specialId === specialId).map(
    (special) => special.validation.get.elements.filter(
      (element) => `${element.ticketElementId}` === `${ticketElementId}`
    )
  );
};
var filterSpecialsBySpecialIdAndComboElementId = (currentSpecials, specialId, comboElementId) => currentSpecials.filter((specialObject) => specialObject.specialId === specialId).map(
  (special) => special.validation.get.elements.filter(
    (element) => `${element.comboElementId}` === `${comboElementId}`
  )
);
var mapInstancesArrayToCounters = (instancesArray) => ({
  count: instancesArray.length,
  instances: instancesArray.map((element) => element.instanceId)
});
var reduceInstancesArrayToCounters = (total, countBySpecial) => ({
  count: total.count + countBySpecial.count,
  instances: [...total.instances, ...countBySpecial.instances]
});
var countItemInstances = (currentSpecials, specialId, ticketElementId) => {
  return filterSpecialsBySpecialIdAndTicketElementId(
    currentSpecials,
    specialId,
    ticketElementId
  ).map(mapInstancesArrayToCounters).reduce(reduceInstancesArrayToCounters, {
    count: 0,
    instances: []
  });
};
var countComboInstances = (currentSpecials, specialId, comboElementId) => {
  return filterSpecialsBySpecialIdAndComboElementId(
    currentSpecials,
    specialId,
    comboElementId
  ).map(mapInstancesArrayToCounters).reduce(reduceInstancesArrayToCounters, {
    count: 0,
    instances: []
  });
};
var getElementsAffectedBySpecial = (currentSpecials, specialObject) => {
  const elementsArrays = currentSpecials.filter((special) => special.specialId === specialObject.specialId).filter((special) => !special.isComplete).map((special) => special.validation.get.elements).flat();
  const result = elementsArrays.reduce(
    ([itemAcc, comboAcc], elementInstance) => {
      if (elementInstance.ticketElementId)
        return [[...itemAcc, elementInstance.ticketElementId], comboAcc];
      if (elementInstance.comboElementId)
        return [itemAcc, [...comboAcc, elementInstance.comboElementId]];
      return [itemAcc, comboAcc];
    },
    [[], []]
  );
  return [
    [...new Set(result[0]).values()].map((itemInstance) => ({
      ticketElementId: itemInstance,
      isCombo: false
    })),
    [...new Set(result[1]).values()].map((comboInstance) => ({
      comboElementId: comboInstance,
      isCombo: true
    }))
  ];
};
var getSpecialsToApply = (ticketElements, combos, orderSpecialsSource, specialsBuyIds, specialsGetIds, triggerElements, rewardedElements) => {
  const [buyItemIdsSet, buyComboIdsSet] = specialsBuyIds;
  const [getItemIdsSet, getComboIdsSet] = specialsGetIds;
  const [triggerItems, triggerCombos] = triggerElements;
  const [rewardedItems, rewardedCombos] = rewardedElements;
  const specialsToApply = {};
  const ticketElementsFiltered = Object.values(ticketElements).filter(isNotOpenItemFn).filter(
    and(isTicketElementNotAssociatedWithCombo, not(isTicketElementVoided))
  );
  const comboElements = Object.values(combos).filter(
    (comboElement) => !comboElement.isVoided
  );
  const itemsToCheck = ticketElementsFiltered.filter(
    (ticketElement) => !ticketElement.comboElementId && ticketElement.quantity && (buyItemIdsSet.has(ticketElement.itemId) || getItemIdsSet.has(ticketElement.itemId))
  ).map((ticketElement) => {
    return ticketElement.instanceIds.map((instance, index) => ({
      instance: index + 1,
      itemElementId: instance,
      id: ticketElement.id,
      tabletGeneratedId: ticketElement.tabletGeneratedId,
      itemId: ticketElement.itemId,
      isCombo: false
    }));
  }).flat().filter((ticketElement) => {
    return !triggerItems.has(ticketElement.itemElementId) && !rewardedItems.has(ticketElement.itemElementId);
  });
  const combosToCheck = comboElements.filter(
    (comboElement) => comboElement.quantity && (buyComboIdsSet.has(comboElement.comboId) || getComboIdsSet.has(comboElement.comboId))
  ).map((comboElement) => {
    return comboElement.instanceIds.map((instance, index) => ({
      instance: index + 1,
      itemElementId: instance,
      id: comboElement.id,
      tabletGeneratedId: comboElement.tabletGeneratedId,
      comboId: comboElement.comboId,
      isCombo: true
    }));
  }).flat().filter((comboElement) => {
    return !triggerCombos.has(comboElement.itemElementId) && !rewardedCombos.has(comboElement.itemElementId);
  });
  let itemsBucket = [...itemsToCheck];
  let combosBucket = [...combosToCheck];
  const orderSpecialSourceList = Object.values(orderSpecialsSource).map(
    (specialObject) => __spreadProps(__spreadValues({}, specialObject), {
      getItemIds: specialObject.mimicItems ? specialObject.buyItemIds : specialObject.getItemIds,
      getComboIds: specialObject.mimicItems ? specialObject.buyComboIds : specialObject.getComboIds
    })
  );
  orderSpecialSourceList.forEach((special) => {
    const buyLimit = special.buyQuantity;
    const getLimit = special.getQuantity;
    let hasFinishedChecking = false;
    while (!hasFinishedChecking) {
      const buyItems = [];
      const buyCombos = [];
      const validBuyItems = itemsBucket.filter(
        (itemInstance) => special.buyItemIds.includes(itemInstance.itemId)
      );
      const validBuyCombos = combosBucket.filter(
        (comboInstance) => special.buyComboIds.includes(comboInstance.comboId)
      );
      if (special.mimicItems && validBuyItems.length > buyLimit + getLimit) {
        const itemsBuffer = [];
        const itemList = [...validBuyItems];
        let counter = itemList.length;
        while (counter >= buyLimit + getLimit) {
          const buyAndGetItemSet = itemList.slice(0, buyLimit + getLimit);
          const itemsTaken = buyAndGetItemSet.length;
          const validation = createValidationObject(
            buyLimit,
            getLimit,
            take(buyAndGetItemSet, buyLimit),
            takeRight(buyAndGetItemSet, getLimit),
            [],
            []
          );
          if (validation.isComplete) {
            itemsBuffer.push(...buyAndGetItemSet);
            itemList.splice(0, itemsTaken);
            specialsToApply[special.specialId] ? specialsToApply[special.specialId].push({
              validation,
              specialObject: special.discountSpecialObj
            }) : specialsToApply[special.specialId] = [
              {
                validation,
                specialObject: special.discountSpecialObj
              }
            ];
          }
          counter -= itemsTaken;
        }
        itemsBucket = itemsBucket.filter(
          (itemInstance) => !itemsBuffer.map((itemBufferItem) => itemBufferItem.itemElementId).includes(itemInstance.itemElementId)
        );
        if (itemsBucket.length === 0)
          hasFinishedChecking = true;
      } else if (special.mimicItems && validBuyCombos.length > buyLimit + getLimit) {
        const combosBuffer = [];
        const comboList = [...validBuyCombos];
        let counter = comboList.length;
        while (counter >= buyLimit + getLimit) {
          const buyAndGetComboSet = comboList.slice(0, buyLimit + getLimit);
          const combosTaken = buyAndGetComboSet.length;
          const validation = createValidationObject(
            buyLimit,
            getLimit,
            [],
            [],
            take(buyAndGetComboSet, buyLimit),
            takeRight(buyAndGetComboSet, getLimit)
          );
          if (validation.isComplete) {
            combosBuffer.push(...buyAndGetComboSet);
            comboList.splice(0, combosTaken);
            specialsToApply[special.specialId] ? specialsToApply[special.specialId].push({
              validation,
              specialObject: special.discountSpecialObj
            }) : specialsToApply[special.specialId] = [
              {
                validation,
                specialObject: special.discountSpecialObj
              }
            ];
          }
          counter -= combosTaken;
        }
        combosBucket = combosBucket.filter(
          (comboInstance) => !combosBuffer.map((comboBufferItem) => comboBufferItem.itemElementId).includes(comboInstance.itemElementId)
        );
        if (combosBucket.length === 0)
          hasFinishedChecking = true;
      } else {
        buyItems.push(...take(validBuyItems, buyLimit));
        if (buyItems.length < buyLimit) {
          buyCombos.push(...take(validBuyCombos, buyLimit - buyItems.length));
        }
        if (buyItems.length + buyCombos.length === buyLimit) {
          const getItems = [];
          const getCombos = [];
          const remainingItems = itemsBucket.filter(
            (itemInstance) => !buyItems.includes(itemInstance)
          );
          const remainingCombos = combosBucket.filter(
            (comboInstance) => !buyCombos.includes(comboInstance)
          );
          const validGetItems = remainingItems.filter(
            (itemInstance) => special.getItemIds.includes(itemInstance.itemId)
          );
          getItems.push(...take(validGetItems, getLimit));
          if (getItems.length < getLimit) {
            const validGetCombos = remainingCombos.filter(
              (comboInstance) => special.getComboIds.includes(comboInstance.comboId)
            );
            getCombos.push(...take(validGetCombos, getLimit - getItems.length));
          }
          const validation = createValidationObject(
            buyLimit,
            getLimit,
            buyItems,
            getItems,
            buyCombos,
            getCombos
          );
          if (validation.isComplete || validation.isPartiallyComplete) {
            itemsBucket = remainingItems.filter(
              (itemInstance) => !getItems.includes(itemInstance)
            );
            combosBucket = remainingCombos.filter(
              (comboInstance) => !getCombos.includes(comboInstance)
            );
            specialsToApply[special.specialId] ? specialsToApply[special.specialId].push({
              validation,
              specialObject: special.discountSpecialObj
            }) : specialsToApply[special.specialId] = [
              {
                validation,
                specialObject: special.discountSpecialObj
              }
            ];
          } else if (!validation.hasItems) {
            hasFinishedChecking = true;
          } else {
            hasFinishedChecking = true;
          }
        } else {
          hasFinishedChecking = true;
        }
      }
    }
  });
  return specialsToApply;
};
var getCurrentBOGOSpecialsBuyItemIds = (activeSpecials) => {
  return Object.values(activeSpecials).reduce(
    ([itemIdsSet, comboIdsSet], currentSpecial) => {
      return [
        /* @__PURE__ */ new Set([...itemIdsSet.values(), ...currentSpecial.buyItemIds]),
        /* @__PURE__ */ new Set([...comboIdsSet.values(), ...currentSpecial.buyComboIds])
      ];
    },
    [/* @__PURE__ */ new Set(), /* @__PURE__ */ new Set()]
  );
};
var getCurrentBOGOSpecialsGetItemIds = (activeSpecials) => {
  return Object.values(activeSpecials).reduce(
    ([itemIdsSet, comboIdsSet], currentSpecial) => {
      return [
        /* @__PURE__ */ new Set([
          ...itemIdsSet.values(),
          ...currentSpecial.mimicItems ? currentSpecial.buyItemIds : currentSpecial.getItemIds
        ]),
        /* @__PURE__ */ new Set([
          ...comboIdsSet.values(),
          ...currentSpecial.mimicItems ? currentSpecial.buyComboIds : currentSpecial.getComboIds
        ])
      ];
    },
    [/* @__PURE__ */ new Set(), /* @__PURE__ */ new Set()]
  );
};
var getCurrentSpecialsTriggerElementInstances = (currentSpecials) => {
  const triggerElements = currentSpecials.filter((special) => special.isComplete).map((currentSpecial) => currentSpecial.validation.buy.elements).flat();
  return [
    new Set(triggerElements.map((element) => element.instanceId)),
    new Set(triggerElements.map((element) => element.instanceId))
  ];
};
var getCurrentSpecialsRewardedElementInstances = (currentSpecials) => {
  const triggerElements = currentSpecials.filter((special) => special.isComplete).map((currentSpecial) => currentSpecial.validation.get.elements).flat();
  return [
    new Set(triggerElements.map((element) => element.instanceId)),
    new Set(triggerElements.map((element) => element.instanceId))
  ];
};
var getCurrentSpecialsTriggerElementIds = (currentSpecials) => {
  const triggerElements = currentSpecials.map((currentSpecial) => currentSpecial.validation.buy.elements).flat();
  return [
    new Set(triggerElements.map((element) => element.ticketElementId)),
    new Set(triggerElements.map((element) => element.comboElementId))
  ];
};
var getCurrentSpecialsRewardedElementIds = (currentSpecials) => {
  const triggerElements = currentSpecials.map((currentSpecial) => currentSpecial.validation.get.elements).flat();
  return [
    new Set(triggerElements.map((element) => element.ticketElementId)),
    new Set(triggerElements.map((element) => element.comboElementId))
  ];
};
var applySpecialsToTicketAndCombos = (specialObjects, order, ticketElements, combos, orderType, ticketElementCallback, comboElementCallback) => {
  let ticketElementsToUpdate = [
    [],
    []
  ];
  Object.values(specialObjects).forEach((specialObjectArray) => {
    let specialGeneratedId = generateTabletGeneratedId();
    ticketElementsToUpdate = getElementsAffectedBySpecial(
      order.bogoSpecialsSelected,
      specialObjectArray[0].specialObject
    );
    const unmodifiedSpecial = order.bogoSpecialsSelected.filter(
      (specialObj) => specialObjectArray[0].specialObject.specialId !== specialObj.specialId || specialObj.isComplete
    );
    const newSpecialsObjects = specialObjectArray.reduce((acc, current) => {
      return [
        ...acc,
        {
          specialId: current.specialObject.specialId,
          isComplete: current.validation.isComplete,
          validation: {
            buy: {
              isComplete: current.validation.buy.isComplete,
              elements: transformResultToSpecialValidation(
                current.validation.buy.elements
              )
            },
            get: {
              isComplete: current.validation.get.isComplete,
              elements: transformResultToSpecialValidation(
                current.validation.get.elements
              )
            }
          }
        }
      ];
    }, []);
    order.bogoSpecialsSelected = [...unmodifiedSpecial, ...newSpecialsObjects];
    const mergedElements = mergeElementInstances(
      specialObjectArray.map(
        (specialObjectArrayItem2) => specialObjectArrayItem2.validation.get.elements
      ).flat(),
      ticketElementsToUpdate
    );
    const specialObjectArrayItem = specialObjectArray[0];
    mergedElements.forEach((element) => {
      if (element.isCombo) {
        const comboElement = combos[element.comboElementId];
        const appliedSpecialAmount = getComboBOGOAppliedAmount(
          specialObjectArrayItem.specialObject,
          comboElement
        );
        const exist = Object.values(
          combos[element.comboElementId].specials
        ).find(
          (specialItem) => specialItem.specialId === specialObjectArrayItem.specialObject.specialId
        );
        if (!exist) {
          const { instances, count } = countComboInstances(
            order.bogoSpecialsSelected,
            specialObjectArrayItem.specialObject.specialId,
            getTicketElementId(comboElement)
          );
          comboElement.specials[specialGeneratedId] = __spreadProps(__spreadValues({}, getSpecialAppliedValue(specialObjectArrayItem.specialObject)), {
            tabletGeneratedId: specialGeneratedId,
            appliedSpecialAmount: appliedSpecialAmount * count,
            instances
          });
        } else {
          const { instances, count } = countComboInstances(
            order.bogoSpecialsSelected,
            exist.specialId,
            getTicketElementId(comboElement)
          );
          combos[element.comboElementId].specials[getEntityId(exist)].appliedSpecialAmount = appliedSpecialAmount * count;
          combos[element.comboElementId].specials[getEntityId(exist)].instances = instances;
        }
        calcTotalComboWithAlternativePrice(combos[element.comboElementId], {
          orderType,
          taxExempt: order.taxExempt,
          noTaxInclusive: order.noTaxInclusive,
          orderIsLockedPrice: order.isLockedPrice
        });
        comboElementCallback(order, element.comboElementId);
      } else {
        const ticketElement = ticketElements[element.ticketElementId];
        const appliedSpecialAmount = getItemBOGOAppliedAmount(
          specialObjectArrayItem.specialObject,
          ticketElement
        );
        const exist = Object.values(ticketElement.specials).find(
          (specialItem) => specialItem.specialId === specialObjectArrayItem.specialObject.specialId
        );
        if (!exist) {
          const { instances, count } = countItemInstances(
            order.bogoSpecialsSelected,
            specialObjectArrayItem.specialObject.specialId,
            getTicketElementId(ticketElement)
          );
          ticketElement.specials[specialGeneratedId] = __spreadProps(__spreadValues({}, getSpecialAppliedValue(specialObjectArrayItem.specialObject)), {
            tabletGeneratedId: specialGeneratedId,
            appliedSpecialAmount: appliedSpecialAmount * count,
            instances
          });
        } else {
          const { instances, count } = countItemInstances(
            order.bogoSpecialsSelected,
            exist.specialId,
            getTicketElementId(ticketElement)
          );
          ticketElement.specials[getEntityId(exist)].instances = instances;
          ticketElement.specials[getEntityId(exist)].appliedSpecialAmount = appliedSpecialAmount * count;
        }
        calcTotalItemWithAlternativePrice(ticketElement, {
          orderType,
          taxExempt: order.taxExempt,
          noTaxInclusive: order.noTaxInclusive,
          orderIsLockedPrice: order.isLockedPrice
        });
        ticketElementCallback(order, element.ticketElementId);
      }
      specialGeneratedId = getNextTabletGeneratedId();
    });
  });
};
var getSpecialsToReset = (order, elementId, type) => {
  const findFunction = findElementByIdAndType(type, elementId);
  let specialsToReset = order.bogoSpecialsSelected.map((specialObject, index) => ({ specialObject, index })).filter(
    ({ specialObject }) => specialObject.validation.buy.elements.find(findFunction)
  );
  specialsToReset = [
    ...specialsToReset,
    ...order.bogoSpecialsSelected.map((specialObject, index) => ({ specialObject, index })).filter(
      ({ specialObject }) => specialObject.validation.get.elements.find(findFunction)
    )
  ];
  const itemOrComboElement = type === "item" ? order.ticketElements[elementId] : order.combos[elementId];
  const elementItemInstances = itemOrComboElement ? new Set(itemOrComboElement.instanceIds) : /* @__PURE__ */ new Set();
  specialsToReset = specialsToReset.filter(
    (currentSpecial) => currentSpecial.specialObject.validation.get.elements.some(
      (elementItem) => !elementItemInstances.has(elementItem.instanceId)
    ) || currentSpecial.specialObject.validation.buy.elements.some(
      (elementItem) => !elementItemInstances.has(elementItem.instanceId)
    )
  );
  return specialsToReset;
};
var resetSpecialsOnRemovedInstances = (order, specialsIndexesToReset) => {
  const itemsToUpdate = {};
  const combosToUpdate = {};
  order.bogoSpecialsSelected.filter((_currentSpecial, index) => specialsIndexesToReset.includes(index)).forEach((currentSpecial) => {
    currentSpecial.isComplete = false;
    currentSpecial.validation.get.elements.forEach((element) => {
      if (element.ticketElementId) {
        if (itemsToUpdate[currentSpecial.specialId])
          itemsToUpdate[currentSpecial.specialId].add(
            element.ticketElementId
          );
        else
          itemsToUpdate[currentSpecial.specialId] = /* @__PURE__ */ new Set([
            element.ticketElementId
          ]);
      } else if (element.comboElementId) {
        if (combosToUpdate[currentSpecial.specialId])
          combosToUpdate[currentSpecial.specialId].add(
            element.comboElementId
          );
        else
          combosToUpdate[currentSpecial.specialId] = /* @__PURE__ */ new Set([
            element.comboElementId
          ]);
      }
      currentSpecial.validation = SPECIAL_VALIDATION_OBJECT_INITIAL_STATE;
    });
  });
  Object.entries(itemsToUpdate).forEach(([specialId, ticketElementIds]) => {
    ticketElementIds.forEach((ticketElementId) => {
      clearItemSpecial(
        order,
        order.ticketElements,
        ticketElementId,
        Number(specialId),
        order.bogoSpecialsSelected
      );
    });
  });
  Object.entries(combosToUpdate).forEach(([specialId, comboElementIds]) => {
    comboElementIds.forEach((comboElementId) => {
      clearComboSpecial(
        order,
        order.combos,
        comboElementId,
        Number(specialId),
        order.bogoSpecialsSelected
      );
    });
  });
};
var getTotalSpecialAmountReducer = (totalItemDiscountAmount, discount) => totalItemDiscountAmount + discount.appliedSpecialAmount;

// src/state/register/orders/initialState.ts
var CHECK_INITIAL_STATE = {
  tabletGeneratedId: "",
  name: "",
  number: 0,
  status: "open" /* OPEN */,
  checkElements: {},
  displayCheckElements: {},
  itemCount: 0,
  subtotal: 0,
  totalItemDiscounts: 0,
  totalOrderDiscounts: 0,
  totalDiscounts: 0,
  serviceChargeTotal: 0,
  tax: 0,
  total: 0,
  balanceDue: 0,
  balancePaid: 0,
  tip: 0,
  payments: {},
  seats: null,
  totalSpecialDiscounts: 0,
  serviceChargeTaxApplied: 0,
  closedTime: null,
  appliedOrderSpecialAmount: 0,
  specialsDetails: {},
  discountsDetails: {}
};
var GET_ORDER_INITIAL_STATE = () => ({
  orderVersion: 0,
  organizationId: 0,
  locationId: 0,
  ownerId: 0,
  ownerRoleId: 0,
  createdById: 0,
  lastUpdatedById: 0,
  type: "dine in" /* DINE_IN */,
  status: "open-initiated" /* OPEN_INITIATED */,
  splitMode: "" /* NONE */,
  itemCount: 0,
  tax: 0,
  tip: 0,
  subtotal: 0,
  total: 0,
  balanceDue: 0,
  seatOnePosition: "",
  numberOfSeatsOccupied: 0,
  seatTags: {},
  orderTagIds: [],
  ticketElements: {},
  orderNumber: "0",
  tableId: 0,
  courseTimes: {},
  id: 0,
  tabletGeneratedId: "",
  serviceAreaId: 0,
  revenueCenterId: 0,
  licenseEditingId: 0,
  description: "",
  orderDiscounts: {},
  totalDiscountsAndSpecials: 0,
  name: "",
  combos: {},
  orderSpecials: {},
  ticketElementToCheckElements: {},
  checks: {
    0: CHECK_INITIAL_STATE
  },
  defaultCheckId: "",
  bogoSpecialsSelected: [],
  printerError: false,
  bogoSpecialsObj: {},
  serviceChargeTotal: 0,
  serviceChargeDetails: {},
  serviceChargeTaxTotal: 0,
  serviceChargeTaxesSource: {},
  serviceChargeSelection: null,
  hasUnsentItems: false,
  rating: 0,
  voidedReasonId: null,
  customerId: null,
  customer: null,
  fireTimes: [],
  assignedToMergedTablesInsideOrder: false,
  temporaryTableId: null,
  backupTableName: "",
  alternativePriceData: {
    balanceDue: 0,
    subtotal: 0,
    tax: 0,
    tip: 0,
    total: 0,
    serviceChargeTotal: 0,
    serviceChargeTaxTotal: 0,
    totalDiscountsAndSpecials: 0,
    orderDiscounts: {},
    orderSpecials: {}
  },
  firePrintingError: false,
  listPrice: null,
  isLockedPrice: false,
  taxExempt: false,
  noTaxInclusive: false,
  reopened: false
});
var ORDER_INITIAL_STATE = GET_ORDER_INITIAL_STATE();
var DEFAULT_ALTERNATIVE_PRICE_DATA = {
  balanceDue: 0,
  subtotal: 0,
  tax: 0,
  tip: 0,
  total: 0,
  serviceChargeTotal: 0,
  serviceChargeTaxTotal: 0,
  totalDiscountsAndSpecials: 0,
  orderDiscounts: {},
  orderSpecials: {}
};
var TICKET_ELEMENT_INITIAL_STATE = {
  instructions: "",
  timeAdded: "",
  versionId: 0,
  quantity: 0,
  seating: {},
  itemObj: null,
  selectedModifiersPricePerItemUnit: 0,
  modifierGroupsSelected: {},
  isComplete: false,
  isModifiersSelectionComplete: false,
  isVoided: false,
  isModifiedAfterSent: false,
  isInClosedCheck: false,
  isShared: null,
  customizerType: "none" /* NONE */,
  prepStationOverrideId: null,
  prepStationOverride: null,
  orderId: 0,
  itemId: 0,
  instanceIds: [],
  locationMenuTypeItemId: 0,
  locationMenuTypeItemVersionId: 0,
  baseItemPrice: 0,
  discounts: {},
  specials: {},
  totalTax: 0,
  taxDetails: {},
  totalDiscountAmount: 0,
  totalPricePerItemUnit: 0,
  totalPriceWithDiscountsSpecialsNotTaxes: 0,
  courseId: 0,
  timeTriggered: "",
  timeSentToKitchen: "",
  createdById: null,
  lastUpdatedById: null,
  id: 0,
  menuTypeId: 0,
  isTriggeringManuallyDisabled: false,
  tabletGeneratedId: "",
  isTakeout: false,
  isOnHold: false,
  hasBeenHeld: null,
  isPriceOverride: false,
  comboElementId: null,
  configWhenSent: null,
  comboItemGroupId: null,
  comboItemGroupInstance: null,
  printErrorMessage: {},
  totalSpecialsAmount: 0,
  overridePricePerItemUnit: 0,
  onTheFlyCourseNumber: null,
  totalSpecialsBOGOAmount: 0,
  ticketElementToCheckElementsId: "",
  prepStations: [],
  ingredientsSelected: {},
  isOpenItem: false,
  openItemTypeId: null,
  sentToPrepStationHistory: [],
  isCurrentMenuTypeCourseDisabled: false,
  noPrinterLocation: false,
  taxInclusiveSelectedModifiersPricePerItemUnit: 0,
  menuTypeInfo: null,
  voidedReasonId: null,
  isTaxInclusive: false,
  alternativePriceData: null,
  taxExempt: false
};
var GET_MODIFIER_ITEM_INSTANCE_INITIAL_STATE = () => ({
  modifierItemInstanceId: 0,
  price: 0,
  taxInclusivePrice: 0,
  isComplete: false,
  isVoided: false,
  isModifiedAfterSent: false,
  pricingMode: "included" /* INCLUDED */,
  amountSelected: "regular" /* REGULAR */,
  quantitySelected: 1,
  customizerSectors: __spreadValues({}, CUSTOMIZER_INITIAL_STATE),
  nestedModifierGroupsSelected: {}
});
var GET_MODIFIER_ITEM_SELECTED_INITIAL_STATE = () => ({
  isComplete: false,
  isDefaultModifier: false,
  isVoided: false,
  isModifiedAfterSent: false,
  quantitySelected: 1,
  modifierItemId: 0,
  amountSelected: "regular" /* REGULAR */,
  totalPricePerItemUnit: 0,
  taxInclusiveTotalPricePerItemUnit: 0,
  modifierItemInstances: {
    1: GET_MODIFIER_ITEM_INSTANCE_INITIAL_STATE()
  },
  locationModifierItemId: 0,
  locationModifierItemVersionId: 0,
  modifierTag: [],
  modifierSizeTag: null,
  onSidePrice: 0,
  isOverrideType: false,
  sortPriority: 0
});
var GET_MODIFIER_NO_MOD_TAG_APPLIED_STATE = () => __spreadProps(__spreadValues({}, GET_MODIFIER_ITEM_SELECTED_INITIAL_STATE()), {
  quantitySelected: 0,
  isComplete: true,
  modifierItemInstances: {
    0: {
      modifierItemInstanceId: 0,
      isComplete: true,
      isVoided: false,
      isModifiedAfterSent: false,
      pricingMode: "included" /* INCLUDED */,
      price: 0,
      taxInclusivePrice: 0,
      nestedModifierGroupsSelected: {},
      quantitySelected: 0,
      amountSelected: "regular" /* REGULAR */,
      customizerSectors: __spreadValues({}, CUSTOMIZER_INITIAL_STATE)
    }
  }
});
var ITEM_DISCOUNT_INITIAL_STATE = {
  id: 0,
  discountId: 0,
  type: "percent" /* PERCENT */,
  value: 0,
  appliedDiscountAmount: 0,
  posName: "",
  checkName: "",
  discountReasonId: null,
  isExclusive: false,
  taxes: "applyBeforeTaxes" /* APPLY_BEFORE */,
  additionalInfo: null,
  tabletGeneratedId: "",
  isReasonRequired: false
};
var COMBO_ELEMENT_INITIAL_STATE = {
  id: void 0,
  orderId: null,
  versionId: 0,
  quantity: 0,
  isComplete: false,
  isShared: null,
  comboId: 0,
  isInClosedCheck: false,
  tabletGeneratedId: "",
  comboObj: null,
  menuTypeId: 0,
  instanceIds: [],
  seating: {},
  discounts: {},
  specials: {},
  timeAdded: "",
  createdById: 0,
  lastUpdatedById: 0,
  totalDiscountAmount: 0,
  comboBasePrice: 0,
  totalTax: 0,
  taxDetails: {},
  totalPricePerItemUnit: 0,
  totalPriceWithDiscountsSpecialsNotTaxes: 0,
  itemGroupsSelected: {},
  isPriceOverride: false,
  totalAdditionalPriceAmount: 0,
  totalSpecialsAmount: 0,
  overridePricePerItemUnit: 0,
  isVoided: false,
  comboElementToCheckElementsId: "",
  totalSpecialsBOGOAmount: 0,
  isTakeout: false,
  isCurrentMenuTypeCourseDisabled: false,
  ticketElementToCheckElementsId: "",
  taxInclusiveAdditionalPrice: 0,
  locationMenuTypeComboId: 0,
  locationMenuTypeComboVersionId: 0,
  menuTypeInfo: null,
  voidedReasonId: null,
  alternativePriceData: null,
  isTaxInclusive: false
};
var COMBO_ITEM_GROUP_SELECTED_INITIAL_STATE = {
  itemGroupId: 0,
  itemId: null,
  isComplete: false,
  ticketElementId: null,
  isRequired: true,
  additionalPrice: 0,
  additionalModifiersPrice: 0,
  instanceId: 0
};
var CHECK_ELEMENT_INITIAL_STATE = {
  tabletGeneratedId: "",
  checkId: "",
  name: "",
  comboItemNames: {},
  itemCount: 0,
  quantity: 0,
  seats: {},
  isShared: false,
  eachPrice: 0,
  price: 0,
  tax: 0,
  discount: 0,
  isVoided: false,
  splitGrouped: 1,
  splitWays: 1,
  displayFraction: "",
  ticketElementId: null,
  comboElementId: null,
  ticketElementToCheckElementsId: "",
  instanceId: "",
  specialAmount: 0,
  itemId: -1,
  disableAutoAssign: false,
  specialsDetails: {},
  discountsDetails: {}
};
var DISPLAY_CHECK_ELEMENT_INITIAL_STATE = {
  tabletGeneratedId: "",
  // key is checkElementId
  rolledUpCheckElements: {},
  rolledUpCheckElementsQty: 0,
  itemName: "",
  itemId: 0,
  eachPrice: 0,
  displayFraction: "",
  totalQty: 0,
  totalPrice: 0,
  totalDiscount: 0,
  totalSpecialAmount: 0,
  splitGrouped: 0,
  splitWays: 0,
  ticketElementId: "",
  comboElementId: "",
  specialsDetails: {},
  discountsDetails: {}
};
var SPECIAL_VALIDATION_OBJECT_INITIAL_STATE = {
  buy: { isComplete: false, elements: [] },
  get: { isComplete: false, elements: [] }
};
var ALL_MODIFIERS_MODIFIER_GROUP = () => __spreadProps(__spreadValues({}, MODIFIER_GROUP_ITEMS_INITIAL_STATE()), {
  activeCustomizerSectionSelector: false,
  customizerSlicing: "quarters" /* QUARTERS */,
  locationModifierGroupId: ALL_MODS_ID,
  locationModifierGroupVersionId: ALL_MODS_ID,
  showSearchBar: true,
  searchAllModifierItems: false,
  global: true,
  multiselect: true,
  modifierGroupId: ALL_MODS_ID,
  quantityMode: "x1,x2,x3" /* NUMBER */,
  showModGroupTitleOnRegisterTicket: true,
  modifierItems: {},
  posName: "Custom",
  checkName: "Custom",
  kdsName: "Custom",
  backgroundColor: null,
  textColor: null,
  enableModTags: false,
  enableQuantityBar: false
});

// src/helpers/factories/register/specialModifierTagsFactory.ts
var LITE_MODIFIER_TAG = {
  name: LITE_MODIFIER_TAG_POS_NAME,
  modifierTagId: 0,
  checkName: LITE_MODIFIER_TAG_POS_NAME,
  isSpecial: true,
  tagPosition: "before" /* BEFORE */
};
var EXTRA_MODIFIER_TAG = {
  name: EXTRA_MODIFIER_TAG_POS_NAME,
  modifierTagId: 0,
  checkName: EXTRA_MODIFIER_TAG_POS_NAME,
  isSpecial: true,
  tagPosition: "before" /* BEFORE */
};
function specialModifierTagsFactory(modifierTags) {
  const specialModifierTags = Object.values(modifierTags).filter(
    (tag) => tag.isSpecial
  );
  const liteModifierTag = specialModifierTags.find(
    (tag) => tag.name === LITE_MODIFIER_TAG_POS_NAME
  );
  const extraModifierTag = specialModifierTags.find(
    (tag) => tag.name === EXTRA_MODIFIER_TAG_POS_NAME
  );
  return {
    ["regular" /* REGULAR */]: null,
    ["light" /* LIGHT */]: liteModifierTag ? getSelectedModifierTag(liteModifierTag) : LITE_MODIFIER_TAG,
    ["extra" /* EXTRA */]: extraModifierTag ? getSelectedModifierTag(extraModifierTag) : EXTRA_MODIFIER_TAG
  };
}

// src/helpers/register/reducerHelpers/nestedModifierItems.ts
var toggleNoneNestedModifierItemsSelected = (ticketElement, parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId) => {
  const modifierGroupSelected = ticketElement.modifierGroupsSelected[parentModifierGroupId].modifierItemsSelected[parentModifierItemId].modifierItemInstances[parentModifierInstanceId].nestedModifierGroupsSelected[nestedModifierGroupId];
  if (!modifierGroupSelected)
    return;
  const defaultModifiersItems = getDefaultModifierGroupsSelectedForNestedMod(
    ticketElement.itemObj,
    parentModifierGroupId,
    parentModifierItemId,
    nestedModifierGroupId
  );
  const wasNoneSelected = !!modifierGroupSelected.isNoneSelected;
  modifierGroupSelected.isNoneSelected = !wasNoneSelected;
  Object.keys(modifierGroupSelected.modifierItemsSelected).map(Number).forEach((modifierItemId) => {
    if (defaultModifiersItems.includes(modifierItemId)) {
      selectNoNestedModifierItem(
        ticketElement,
        parentModifierGroupId,
        parentModifierItemId,
        parentModifierInstanceId,
        nestedModifierGroupId,
        modifierItemId
      );
      applyModifierTag(
        ticketElement.modifierGroupsSelected[parentModifierGroupId].modifierItemsSelected[parentModifierItemId].modifierItemInstances[parentModifierInstanceId].nestedModifierGroupsSelected[nestedModifierGroupId].modifierItemsSelected[modifierItemId],
        GET_NO_MODIFIER_TAG_SELECTED(),
        "SELECT_NO" /* SELECT_NO */
      );
    } else
      delete modifierGroupSelected.modifierItemsSelected[modifierItemId];
  });
};
var decrementNestedModifierItemSelected2 = (ticketElement, parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId, nestedModifierItemId, modifierTagSizes) => {
  var _a, _b;
  const currentNestedModifierGroup = (_b = ticketElement.itemObj) == null ? void 0 : _b.menuTypeVersions[Object.keys(
    ((_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions) || {}
  )[0]].modifierGroups[parentModifierGroupId].modifierItems[parentModifierItemId].modifierGroups[nestedModifierGroupId];
  const newNestedModifierItem = ticketElement.modifierGroupsSelected[parentModifierGroupId].modifierItemsSelected[parentModifierItemId].modifierItemInstances[parentModifierInstanceId].nestedModifierGroupsSelected[nestedModifierGroupId].modifierItemsSelected[nestedModifierItemId];
  if (!newNestedModifierItem)
    return;
  if (currentNestedModifierGroup.quantityMode === "Lt,Reg,Ext" /* SIZE */) {
    if (newNestedModifierItem.amountSelected === "light" /* LIGHT */) {
      return deleteNestedModifierItemSelected2(
        ticketElement,
        parentModifierGroupId,
        parentModifierItemId,
        parentModifierInstanceId,
        nestedModifierGroupId,
        nestedModifierItemId
      );
    } else {
      newNestedModifierItem.amountSelected = prevQuantityAmount(
        newNestedModifierItem.amountSelected
      );
      newNestedModifierItem.modifierSizeTag = currentNestedModifierGroup.quantityMode === "Lt,Reg,Ext" /* SIZE */ ? modifierTagSizes[newNestedModifierItem.amountSelected] : null;
      newNestedModifierItem.modifierItemInstances[1].amountSelected = newNestedModifierItem.amountSelected;
    }
  } else if (newNestedModifierItem && newNestedModifierItem.isOverrideType) {
    newNestedModifierItem.amountSelected = prevQuantityAmount(
      newNestedModifierItem.amountSelected
    );
    newNestedModifierItem.modifierSizeTag = modifierTagSizes[newNestedModifierItem.amountSelected];
    newNestedModifierItem.modifierItemInstances[1].amountSelected = newNestedModifierItem.amountSelected;
  } else {
    delete newNestedModifierItem.modifierItemInstances[newNestedModifierItem.quantitySelected];
    newNestedModifierItem.quantitySelected -= 1;
    if (newNestedModifierItem.quantitySelected === 0) {
      return deleteNestedModifierItemSelected2(
        ticketElement,
        parentModifierGroupId,
        parentModifierItemId,
        parentModifierInstanceId,
        nestedModifierGroupId,
        nestedModifierItemId
      );
    }
  }
};
var deleteNestedModifierItemSelected2 = (ticketElement, parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId, nestedModifierItemId) => {
  const modifierGroupSelected = ticketElement.modifierGroupsSelected[parentModifierGroupId];
  delete modifierGroupSelected.modifierItemsSelected[parentModifierItemId].modifierItemInstances[parentModifierInstanceId].nestedModifierGroupsSelected[nestedModifierGroupId].modifierItemsSelected[nestedModifierItemId];
};
var incrementNestedModifierItemSelected2 = (ticketElement, parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId, nestedModifierItemId, modifierTagSizes) => {
  const itemObj = ticketElement.itemObj || {};
  const menuTypeId = !ticketElement.isOpenItem ? ticketElement.menuTypeId : 0;
  const nestedModifierGroup = itemObj == null ? void 0 : itemObj.menuTypeVersions[menuTypeId].modifierGroups[parentModifierGroupId].modifierItems[parentModifierItemId].modifierGroups[nestedModifierGroupId];
  const nestedModifierItem = nestedModifierGroup.modifierItems[nestedModifierItemId];
  const nestedModifierGroupSelected = ticketElement.modifierGroupsSelected[parentModifierGroupId].modifierItemsSelected[parentModifierItemId].modifierItemInstances[parentModifierInstanceId].nestedModifierGroupsSelected[nestedModifierGroupId];
  const nestedModifierItemSelected = nestedModifierGroupSelected.modifierItemsSelected[nestedModifierItemId];
  if (nestedModifierGroup.quantityMode === "Lt,Reg,Ext" /* SIZE */) {
    if (!nestedModifierItemSelected) {
      ticketElement.modifierGroupsSelected[parentModifierGroupId].modifierItemsSelected[parentModifierItemId].modifierItemInstances[parentModifierInstanceId].nestedModifierGroupsSelected[nestedModifierGroupId].modifierItemsSelected[nestedModifierItemId] = __spreadProps(__spreadValues({}, GET_MODIFIER_ITEM_SELECTED_INITIAL_STATE()), {
        modifierItemId: nestedModifierItemId,
        quantitySelected: 1,
        isComplete: true,
        amountSelected: nestedModifierItem.defaultAmountSelected,
        modifierSizeTag: nestedModifierGroup.quantityMode === "Lt,Reg,Ext" /* SIZE */ ? modifierTagSizes[nestedModifierItem.defaultAmountSelected] : null,
        modifierItemInstances: {
          1: __spreadProps(__spreadValues({}, GET_MODIFIER_ITEM_INSTANCE_INITIAL_STATE()), {
            amountSelected: nestedModifierItem.defaultAmountSelected,
            isComplete: true
          })
        }
      });
    } else {
      nestedModifierItemSelected.amountSelected = nextQuantityAmount(
        nestedModifierItemSelected.amountSelected
      );
      nestedModifierItemSelected.modifierSizeTag = nestedModifierGroup.quantityMode === "Lt,Reg,Ext" /* SIZE */ ? modifierTagSizes[nestedModifierItemSelected.amountSelected] : null;
      nestedModifierItemSelected.modifierItemInstances[1].amountSelected = nestedModifierItemSelected.amountSelected;
    }
  } else if (nestedModifierItemSelected && nestedModifierItemSelected.isOverrideType) {
    nestedModifierItemSelected.amountSelected = nextQuantityAmount(
      nestedModifierItemSelected.amountSelected
    );
    nestedModifierItemSelected.modifierSizeTag = modifierTagSizes[nestedModifierItemSelected.amountSelected];
    nestedModifierItemSelected.modifierItemInstances[1].amountSelected = nestedModifierItemSelected.amountSelected;
  } else {
    if (!nestedModifierItemSelected) {
      ticketElement.modifierGroupsSelected[parentModifierGroupId].modifierItemsSelected[parentModifierItemId].modifierItemInstances[parentModifierInstanceId].nestedModifierGroupsSelected[nestedModifierGroupId].modifierItemsSelected[nestedModifierItemId] = __spreadProps(__spreadValues({}, GET_MODIFIER_ITEM_SELECTED_INITIAL_STATE()), {
        amountSelected: nestedModifierItem.defaultAmountSelected,
        isComplete: true,
        modifierItemId: nestedModifierItemId,
        modifierItemInstances: {
          1: __spreadProps(__spreadValues({}, GET_MODIFIER_ITEM_INSTANCE_INITIAL_STATE()), {
            isComplete: true
          })
        }
      });
    } else {
      nestedModifierItemSelected.quantitySelected += 1;
      nestedModifierItemSelected.modifierItemInstances = __spreadProps(__spreadValues({}, nestedModifierItemSelected.modifierItemInstances), {
        [nestedModifierItemSelected.quantitySelected]: __spreadValues({}, GET_MODIFIER_ITEM_INSTANCE_INITIAL_STATE())
      });
    }
  }
  nestedModifierGroupSelected.isNoneSelected = false;
};
var singleSelectDeleteOtherNestedModifiers = (ticketElement, parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId, nestedModifierItemId) => {
  var _a, _b;
  const menuTypeId = !ticketElement.isOpenItem ? ticketElement.menuTypeId : 0;
  const modifierGroupSelected = ticketElement.modifierGroupsSelected[parentModifierGroupId].modifierItemsSelected[parentModifierItemId].modifierItemInstances[parentModifierInstanceId].nestedModifierGroupsSelected[nestedModifierGroupId];
  const modifierGroup = (_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[menuTypeId].modifierGroups[parentModifierGroupId].modifierItems[parentModifierItemId].modifierGroups[nestedModifierGroupId];
  const modifierItem = modifierGroup == null ? void 0 : modifierGroup.modifierItems[nestedModifierItemId];
  if ((modifierGroup == null ? void 0 : modifierGroup.multiselect) || !modifierItem || !modifierGroupSelected || !modifierGroup)
    return;
  const selectedModifierItemToDeleteId = (_b = Object.entries(
    modifierGroupSelected.modifierItemsSelected || {}
  ).find(
    ([_modifierItemId, _modifierItem]) => Number(_modifierItemId) !== nestedModifierItemId && _modifierItem.quantitySelected > 0
  )) == null ? void 0 : _b[0];
  if (selectedModifierItemToDeleteId) {
    deleteNestedModifierItemSelected2(
      ticketElement,
      parentModifierGroupId,
      parentModifierItemId,
      parentModifierInstanceId,
      nestedModifierGroupId,
      Number(selectedModifierItemToDeleteId)
    );
  }
};
var toggleNestedModifierItemSelected2 = (ticketElement, parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId, nestedModifierItemId, modTag, globalState, operation, modifierTagSizes) => {
  switch (operation) {
    case "DELETE" /* DELETE */:
      deleteNestedModifierItemSelected2(
        ticketElement,
        parentModifierGroupId,
        parentModifierItemId,
        parentModifierInstanceId,
        nestedModifierGroupId,
        nestedModifierItemId
      );
      break;
    case "INCREMENT" /* INCREMENT */:
      incrementNestedModifierItemSelected2(
        ticketElement,
        parentModifierGroupId,
        parentModifierItemId,
        parentModifierInstanceId,
        nestedModifierGroupId,
        nestedModifierItemId,
        modifierTagSizes
      );
      singleSelectDeleteOtherNestedModifiers(
        ticketElement,
        parentModifierGroupId,
        parentModifierItemId,
        parentModifierInstanceId,
        nestedModifierGroupId,
        nestedModifierItemId
      );
      break;
    case "DESELECT_NO" /* DESELECT_NO */:
      deleteNestedModifierItemSelected2(
        ticketElement,
        parentModifierGroupId,
        parentModifierItemId,
        parentModifierInstanceId,
        nestedModifierGroupId,
        nestedModifierItemId
      );
      incrementNestedModifierItemSelected2(
        ticketElement,
        parentModifierGroupId,
        parentModifierItemId,
        parentModifierInstanceId,
        nestedModifierGroupId,
        nestedModifierItemId,
        modifierTagSizes
      );
      singleSelectDeleteOtherNestedModifiers(
        ticketElement,
        parentModifierGroupId,
        parentModifierItemId,
        parentModifierInstanceId,
        nestedModifierGroupId,
        nestedModifierItemId
      );
      break;
    case "SELECT_NO" /* SELECT_NO */:
      selectNoNestedModifierItem(
        ticketElement,
        parentModifierGroupId,
        parentModifierItemId,
        parentModifierInstanceId,
        nestedModifierGroupId,
        nestedModifierItemId
      );
      break;
    case "SELECT_ON_SIDE" /* SELECT_ON_SIDE */:
      toggleOnSideNestedModTag(
        ticketElement,
        parentModifierGroupId,
        parentModifierItemId,
        parentModifierInstanceId,
        nestedModifierGroupId,
        nestedModifierItemId,
        modifierTagSizes,
        globalState
      );
      break;
    case "SELECT_EXTRA" /* SELECT_EXTRA */:
    case "SELECT_LITE" /* SELECT_LITE */:
      applySpecialModTagNested(
        ticketElement,
        parentModifierGroupId,
        parentModifierItemId,
        parentModifierInstanceId,
        nestedModifierGroupId,
        nestedModifierItemId,
        modTag,
        modifierTagSizes
      );
      break;
  }
  return operation;
};
var selectNoNestedModifierItem = (ticketElement, parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId, nestedModifierItemId) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const menuTypeId = !ticketElement.isOpenItem ? ticketElement.menuTypeId : 0;
  const modifierItem = (_e = (_d = (_c = (_b = (_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[menuTypeId]) == null ? void 0 : _b.modifierGroups[parentModifierGroupId]) == null ? void 0 : _c.modifierItems[parentModifierItemId]) == null ? void 0 : _d.modifierGroups[nestedModifierGroupId]) == null ? void 0 : _e.modifierItems[nestedModifierItemId];
  const modifierItemsSelected = (_i = (_h = (_g = (_f = ticketElement.modifierGroupsSelected[parentModifierGroupId]) == null ? void 0 : _f.modifierItemsSelected[parentModifierItemId]) == null ? void 0 : _g.modifierItemInstances[parentModifierInstanceId]) == null ? void 0 : _h.nestedModifierGroupsSelected[nestedModifierGroupId]) == null ? void 0 : _i.modifierItemsSelected;
  if (!modifierItem || !modifierItemsSelected)
    return;
  const noModifierItemSelected = __spreadProps(__spreadValues({}, GET_MODIFIER_ITEM_SELECTED_INITIAL_STATE()), {
    isComplete: true,
    quantitySelected: 0,
    modifierItemInstances: {},
    modifierItemId: nestedModifierItemId,
    locationModifierItemId: modifierItem.locationModifierItemId,
    locationModifierItemVersionId: modifierItem.locationModifierItemVersionId
  });
  ticketElement.modifierGroupsSelected[parentModifierGroupId].modifierItemsSelected[parentModifierItemId].modifierItemInstances[parentModifierInstanceId].nestedModifierGroupsSelected[nestedModifierGroupId].modifierItemsSelected[nestedModifierItemId] = noModifierItemSelected;
};
var applySpecialModTagNested = (ticketElement, parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId, nestedModifierItemId, specialModTag, modifierTagSizes) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  if (!specialModTag)
    return;
  const menuTypeId = !ticketElement.isOpenItem ? ticketElement.menuTypeId : 0;
  const modifierItem = (_e = (_d = (_c = (_b = (_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[menuTypeId]) == null ? void 0 : _b.modifierGroups[parentModifierGroupId]) == null ? void 0 : _c.modifierItems[parentModifierItemId]) == null ? void 0 : _d.modifierGroups[nestedModifierGroupId]) == null ? void 0 : _e.modifierItems[nestedModifierItemId];
  const modifierItemsSelected = (_i = (_h = (_g = (_f = ticketElement.modifierGroupsSelected[parentModifierGroupId]) == null ? void 0 : _f.modifierItemsSelected[parentModifierItemId]) == null ? void 0 : _g.modifierItemInstances[parentModifierInstanceId]) == null ? void 0 : _h.nestedModifierGroupsSelected[nestedModifierGroupId]) == null ? void 0 : _i.modifierItemsSelected;
  if (!modifierItem || !modifierItemsSelected)
    return;
  let modifierItemSelected = modifierItemsSelected[nestedModifierItemId];
  const modifierGroup = (_j = ticketElement.itemObj) == null ? void 0 : _j.menuTypeVersions[menuTypeId].modifierGroups[parentModifierGroupId].modifierItems[parentModifierItemId].modifierGroups[nestedModifierGroupId];
  if (!modifierGroup)
    return;
  if (modifierItemSelected) {
    if (modifierGroup.quantityMode === "Lt,Reg,Ext" /* SIZE */) {
      const currentAmountSelected = modifierItemSelected.amountSelected;
      if (currentAmountSelected === SPECIAL_TAG_NAME_TO_QUANTITY_SIZE[specialModTag.name])
        applyAmountSelected(
          modifierItemSelected,
          "regular" /* REGULAR */,
          modifierTagSizes
        );
      else
        applyAmountSelected(
          modifierItemSelected,
          SPECIAL_TAG_NAME_TO_QUANTITY_SIZE[specialModTag.name],
          modifierTagSizes
        );
    } else {
      const isOverrideType = modifierItemSelected.isOverrideType;
      const currentAmountSelected = modifierItemSelected.amountSelected;
      if (isOverrideType && currentAmountSelected === SPECIAL_TAG_NAME_TO_QUANTITY_SIZE[specialModTag.name]) {
        removeCurrentModifierItemAndAddNew(
          ticketElement,
          parentModifierGroupId,
          parentModifierItemId,
          parentModifierInstanceId,
          nestedModifierGroupId,
          nestedModifierItemId,
          modifierTagSizes
        );
      } else if (isOverrideType) {
        applyAmountSelected(
          modifierItemSelected,
          SPECIAL_TAG_NAME_TO_QUANTITY_SIZE[specialModTag.name],
          modifierTagSizes
        );
      } else {
        removeCurrentModifierItemAndAddNew(
          ticketElement,
          parentModifierGroupId,
          parentModifierItemId,
          parentModifierInstanceId,
          nestedModifierGroupId,
          nestedModifierItemId,
          modifierTagSizes
        );
        modifierItemSelected = modifierItemsSelected[nestedModifierItemId];
        overrideModifierItemQuantityMode(
          modifierItemSelected,
          SPECIAL_TAG_NAME_TO_QUANTITY_SIZE[specialModTag.name],
          modifierTagSizes
        );
      }
    }
    return;
  }
  incrementNestedModifierItemSelected2(
    ticketElement,
    parentModifierGroupId,
    parentModifierItemId,
    parentModifierInstanceId,
    nestedModifierGroupId,
    nestedModifierItemId,
    modifierTagSizes
  );
  singleSelectDeleteOtherNestedModifiers(
    ticketElement,
    parentModifierGroupId,
    parentModifierItemId,
    parentModifierInstanceId,
    nestedModifierGroupId,
    nestedModifierItemId
  );
  modifierItemSelected = modifierItemsSelected[nestedModifierItemId];
  if (modifierGroup.quantityMode === "Lt,Reg,Ext" /* SIZE */) {
    applyAmountSelected(
      modifierItemSelected,
      SPECIAL_TAG_NAME_TO_QUANTITY_SIZE[specialModTag.name],
      modifierTagSizes
    );
  } else {
    overrideModifierItemQuantityMode(
      modifierItemSelected,
      SPECIAL_TAG_NAME_TO_QUANTITY_SIZE[specialModTag.name],
      modifierTagSizes
    );
  }
};
var overrideModifierItemQuantityMode = (modifierItemSelected, amountSelected, modifierTagSizes) => {
  modifierItemSelected.isOverrideType = true;
  modifierItemSelected.amountSelected = amountSelected;
  modifierItemSelected.quantitySelected = 1;
  modifierItemSelected.modifierSizeTag = modifierTagSizes[amountSelected];
  const [key, ...rest] = Object.keys(
    modifierItemSelected.modifierItemInstances
  ).map(Number);
  modifierItemSelected.modifierItemInstances[key].amountSelected = amountSelected;
  rest.forEach((instanceKey) => {
    delete modifierItemSelected.modifierItemInstances[instanceKey];
  });
};
var removeCurrentModifierItemAndAddNew = (ticketElement, parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId, nestedModifierItemId, modifierTagSizes) => {
  deleteNestedModifierItemSelected2(
    ticketElement,
    parentModifierGroupId,
    parentModifierItemId,
    parentModifierInstanceId,
    nestedModifierGroupId,
    nestedModifierItemId
  );
  incrementNestedModifierItemSelected2(
    ticketElement,
    parentModifierGroupId,
    parentModifierItemId,
    parentModifierInstanceId,
    nestedModifierGroupId,
    nestedModifierItemId,
    modifierTagSizes
  );
  singleSelectDeleteOtherNestedModifiers(
    ticketElement,
    parentModifierGroupId,
    parentModifierItemId,
    parentModifierInstanceId,
    nestedModifierGroupId,
    nestedModifierItemId
  );
};
var applyAmountSelected = (modifierItemSelected, amountSelected, modifierTagSizes) => {
  modifierItemSelected.amountSelected = amountSelected;
  modifierItemSelected.modifierSizeTag = modifierTagSizes[amountSelected];
  Object.keys(modifierItemSelected.modifierItemInstances).map(Number).forEach((instanceKey) => {
    modifierItemSelected.modifierItemInstances[instanceKey].amountSelected = amountSelected;
  });
};
var toggleOnSideNestedModTag = (ticketElement, parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId, nestedModifierItemId, modifierTagSizes, globalState) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const menuTypeId = !ticketElement.isOpenItem ? ticketElement.menuTypeId : 0;
  const modifierItem = (_e = (_d = (_c = (_b = (_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[menuTypeId]) == null ? void 0 : _b.modifierGroups[parentModifierGroupId]) == null ? void 0 : _c.modifierItems[parentModifierItemId]) == null ? void 0 : _d.modifierGroups[nestedModifierGroupId]) == null ? void 0 : _e.modifierItems[nestedModifierItemId];
  const modifierItemsSelected = (_i = (_h = (_g = (_f = ticketElement.modifierGroupsSelected[parentModifierGroupId]) == null ? void 0 : _f.modifierItemsSelected[parentModifierItemId]) == null ? void 0 : _g.modifierItemInstances[parentModifierInstanceId]) == null ? void 0 : _h.nestedModifierGroupsSelected[nestedModifierGroupId]) == null ? void 0 : _i.modifierItemsSelected;
  if (!modifierItem || !modifierItemsSelected)
    return;
  let modifierItemSelected = modifierItemsSelected[nestedModifierItemId];
  if (modifierItemSelected) {
    if (hasOnSideApplied(modifierItemSelected.modifierTag)) {
      modifierItemSelected.onSidePrice = 0;
    } else {
      applyOnSidePriceNestedItem(
        nestedModifierGroupId,
        nestedModifierItemId,
        modifierItemSelected,
        globalState
      );
    }
    return;
  }
  incrementNestedModifierItemSelected2(
    ticketElement,
    parentModifierGroupId,
    parentModifierItemId,
    parentModifierInstanceId,
    nestedModifierGroupId,
    nestedModifierItemId,
    modifierTagSizes
  );
  singleSelectDeleteOtherNestedModifiers(
    ticketElement,
    parentModifierGroupId,
    parentModifierItemId,
    parentModifierInstanceId,
    nestedModifierGroupId,
    nestedModifierItemId
  );
  modifierItemSelected = modifierItemsSelected[nestedModifierItemId];
  applyOnSidePriceNestedItem(
    nestedModifierGroupId,
    nestedModifierItemId,
    modifierItemSelected,
    globalState
  );
};
var applyOnSidePriceNestedItem = (nestedModifierGroupId, nestedModifierItemId, modifierItemSelected, globalState) => {
  const nestedModifierGroupPricingVersionId = globalState.menu.locationMenu.modifierGroups[nestedModifierGroupId].modifierItems[nestedModifierItemId].defaultModifierItemPricingVersionId;
  const onSidePrice = globalState.menu.locationMenu.modifierItems[nestedModifierItemId].modifierItemPricingVersions[nestedModifierGroupPricingVersionId || 0].onSidePrice;
  modifierItemSelected.onSidePrice = onSidePrice;
};
var getDefaultModifierGroupsSelectedForNestedMod = (itemObj, parentModifierGroupId, parentModifierItemId, modifierGroupId) => {
  if (!itemObj)
    return [];
  const parentModifierItem = itemObj.menuTypeVersions[Object.keys(itemObj.menuTypeVersions)[0]].modifierGroups[parentModifierGroupId].modifierItems[parentModifierItemId];
  if (!parentModifierItem)
    return [];
  const nestedModifierItemWithMods = parentModifierItem.modifierGroups[modifierGroupId];
  if (!nestedModifierItemWithMods)
    return [];
  return getDefaultModsByModifierGroup(nestedModifierItemWithMods);
};
var getDefaultModsByModifierGroup = (modifierGroup) => Object.values(modifierGroup.modifierItems).filter((modifierItem) => modifierItem.isSelected).map((modifierItem) => modifierItem.modifierItemId);
var fixModifierTagForNestedMod = (modifierTag, defaultModifiersSelected, nestedModifierItemId, operation) => {
  if (modifierTag)
    return modifierTag;
  if (!defaultModifiersSelected)
    return null;
  if (defaultModifiersSelected.includes(nestedModifierItemId) && operation === "SELECT_NO" /* SELECT_NO */)
    return GET_NO_MODIFIER_TAG_SELECTED();
  return null;
};
var getNestedModifierItemHasChangesFunction = (sourceModifierGroup) => (modifierItemSelected) => {
  if ((modifierItemSelected == null ? void 0 : modifierItemSelected.modifierTag) !== null)
    return true;
  if (modifierItemSelected == null ? void 0 : modifierItemSelected.isOverrideType)
    return true;
  const modifierItemHasDiff = sourceModifierGroup.quantityMode !== "Lt,Reg,Ext" /* SIZE */ ? (sourceModifierGroup.modifierItems[modifierItemSelected.modifierItemId].defaultQuantitySelected || 1) !== modifierItemSelected.quantitySelected : (sourceModifierGroup.modifierItems[modifierItemSelected.modifierItemId].defaultAmountSelected || 1) !== modifierItemSelected.amountSelected;
  return modifierItemHasDiff;
};
var simplifyNestedModifierOperationToQuantityEffect = (operation) => {
  switch (operation) {
    case "INCREMENT" /* INCREMENT */:
      return "INCREMENT" /* INCREMENT */;
    case "DESELECT_NO" /* DESELECT_NO */:
      return "INCREMENT" /* INCREMENT */;
    case "SELECT_EXTRA" /* SELECT_EXTRA */:
    case "SELECT_LITE" /* SELECT_LITE */:
    case "SELECT_ON_SIDE" /* SELECT_ON_SIDE */:
    default:
      return operation;
  }
};
var validateMaximumNestedModifierItemQuantity = (ticketElement, parentModifierGroup, modifierItemId, modifierItemInstance, nestedModifierGroupId, nestedModifierItemId, operation) => {
  let errorCode = null;
  const modifierGroup = parentModifierGroup.modifierItems[modifierItemId].modifierGroups[nestedModifierGroupId];
  const modifierGroupId = parentModifierGroup.modifierGroupId;
  if (!modifierGroup.maximumModifierItems)
    return true;
  const currentModsCount = getModifierItemsSelectedQty(
    ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId].modifierItemInstances[modifierItemInstance].nestedModifierGroupsSelected[nestedModifierGroupId]
  );
  let isNextChangeAllowed = true;
  switch (operation) {
    case "INCREMENT" /* INCREMENT */: {
      isNextChangeAllowed = currentModsCount < modifierGroup.maximumModifierItems;
      errorCode = "maximumReached";
      break;
    }
    case "SELECT_ON_SIDE" /* SELECT_ON_SIDE */: {
      const currentModIsSelected = ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId].modifierItemInstances[modifierItemInstance].nestedModifierGroupsSelected[nestedModifierGroupId].modifierItemsSelected[nestedModifierItemId] && ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId].modifierItemInstances[modifierItemInstance].nestedModifierGroupsSelected[nestedModifierGroupId].modifierItemsSelected[nestedModifierItemId].quantitySelected;
      if (!currentModIsSelected) {
        isNextChangeAllowed = currentModsCount < modifierGroup.maximumModifierItems;
        errorCode = "maximumReached";
      }
      break;
    }
    case "INCREMENT_SIZE" /* INCREMENT_SIZE */:
    case "SELECT_EXTRA" /* SELECT_EXTRA */:
    case "SELECT_LITE" /* SELECT_LITE */: {
      const currentModIsSelected = ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId].modifierItemInstances[modifierItemInstance].nestedModifierGroupsSelected[nestedModifierGroupId].modifierItemsSelected[nestedModifierItemId] && ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId].modifierItemInstances[modifierItemInstance].nestedModifierGroupsSelected[nestedModifierGroupId].modifierItemsSelected[nestedModifierItemId].quantitySelected;
      if (!currentModIsSelected) {
        const currentModItemQty = ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId].modifierItemInstances[modifierItemInstance].nestedModifierGroupsSelected[nestedModifierGroupId].modifierItemsSelected[nestedModifierItemId] ? ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId].modifierItemInstances[modifierItemInstance].nestedModifierGroupsSelected[nestedModifierGroupId].modifierItemsSelected[nestedModifierItemId].quantitySelected : 0;
        const nextQuantity = currentModsCount - currentModItemQty + 1;
        isNextChangeAllowed = nextQuantity <= modifierGroup.maximumModifierItems;
        errorCode = "maximumReached";
      }
      break;
    }
  }
  if (!isNextChangeAllowed)
    throw new Error(errorCode != null ? errorCode : "unknown");
  return true;
};

// src/helpers/register/reducerHelpers/modifierItems.ts
var getDefaultModifiersSelectedFromItem = (ticketElement) => {
  if (ticketElement.isOpenItem || !ticketElement.itemObj)
    return {};
  const itemObj = ticketElement.itemObj;
  const menuTypeKey = ticketElement.menuTypeId;
  const menuTypeVersion = itemObj.menuTypeVersions[menuTypeKey];
  const defaultModifiersSelected = Object.values(
    menuTypeVersion.modifierGroups
  ).reduce(
    (acc, modifierGroup) => {
      const defaultModifierItems = Object.values(
        modifierGroup.modifierItems
      ).filter((modifierItem) => modifierItem.isSelected);
      if (!defaultModifierItems.length)
        return acc;
      acc[modifierGroup.modifierGroupId] = defaultModifierItems.map(
        (modifierItem) => modifierItem.modifierItemId
      );
      return acc;
    },
    {}
  );
  return defaultModifiersSelected;
};
var applyModifierTag = (modifierItemSelected, modifierTag, operation) => {
  if (!modifierItemSelected)
    return;
  if (!modifierTag)
    return;
  if (SPECIAL_TAGS_WITHOUT_STRING.includes(modifierTag.name)) {
    if (hasNoModifierTag([modifierTag]))
      modifierItemSelected.modifierTag = [];
    return;
  }
  if (operation === "NONE" /* NONE */ && modifierTag.name === NO_MODIFIER_TAG.name)
    return;
  if (hasModifierTag(modifierItemSelected.modifierTag, modifierTag)) {
    modifierItemSelected.modifierTag = removeModifierTag(
      modifierItemSelected.modifierTag,
      modifierTag
    );
    return;
  } else
    modifierItemSelected.modifierTag.push(modifierTag);
};
var fixModifierTag = (modifierTag, defaultModifiersSelected, modifierGroupId, modifierItemId, operation) => {
  if (modifierTag)
    return modifierTag;
  if (!defaultModifiersSelected)
    return null;
  if (!defaultModifiersSelected[modifierGroupId])
    return null;
  if (defaultModifiersSelected[modifierGroupId].includes(modifierItemId) && operation === "SELECT_NO" /* SELECT_NO */)
    return GET_NO_MODIFIER_TAG_SELECTED();
  return null;
};
var updateModifierPrice = (ticketElement, parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId) => {
  const ticketElementModifiersPrevPrice = ticketElement.selectedModifiersPricePerItemUnit || 0;
  const parentModifierGroupSelected = ticketElement.modifierGroupsSelected[parentModifierGroupId];
  const parentModifierGroupSelectedPrevPrice = (parentModifierGroupSelected == null ? void 0 : parentModifierGroupSelected.totalPricePerItemUnit) || 0;
  const itemObj = ticketElement.itemObj;
  const itemMenuTypeVersion = itemObj == null ? void 0 : itemObj.menuTypeVersions[isOpenItemFn(ticketElement) ? 0 : ticketElement.menuTypeId];
  const parentModifierGroup = itemMenuTypeVersion == null ? void 0 : itemMenuTypeVersion.modifierGroups[parentModifierGroupId];
  if (isNil(parentModifierGroup) || isNil(parentModifierGroupSelected))
    return;
  const isNested = !!(parentModifierItemId && parentModifierInstanceId && nestedModifierGroupId);
  if (isNested) {
    const nestedModifierGroupSelected = parentModifierGroupSelected.modifierItemsSelected[parentModifierItemId].modifierItemInstances[parentModifierInstanceId].nestedModifierGroupsSelected[nestedModifierGroupId];
    const nestedModifierGroup = parentModifierGroup.modifierItems[parentModifierItemId].modifierGroups[nestedModifierGroupId];
    if (isNil(nestedModifierGroup) || isNil(nestedModifierGroupSelected))
      return;
    const nestedModifierGroupSelectedPriceDifference = updateModifierGroupSelectedPrices(
      nestedModifierGroupSelected,
      nestedModifierGroup,
      isNested
    );
    const parentModifierItem = parentModifierGroupSelected.modifierItemsSelected[parentModifierItemId];
    parentModifierItem.totalPricePerItemUnit += nestedModifierGroupSelectedPriceDifference;
    parentModifierGroupSelected.totalPricePerItemUnit += nestedModifierGroupSelectedPriceDifference;
    const parentModifierGroupSelectedPriceDifference = parentModifierGroupSelected.totalPricePerItemUnit - parentModifierGroupSelectedPrevPrice;
    ticketElement.selectedModifiersPricePerItemUnit = ticketElementModifiersPrevPrice + parentModifierGroupSelectedPriceDifference;
  } else {
    const parentModifierGroupSelectedPriceDifference = updateModifierGroupSelectedPrices(
      parentModifierGroupSelected,
      parentModifierGroup,
      isNested
    );
    ticketElement.selectedModifiersPricePerItemUnit = ticketElementModifiersPrevPrice + parentModifierGroupSelectedPriceDifference;
  }
};
var updateAllModifiersPrices = (ticketElement) => Object.keys(ticketElement.modifierGroupsSelected).forEach(
  (modifierGroupKey) => updateModifierPrice(ticketElement, Number(modifierGroupKey))
);
var updateModifierGroupSelectedPrices = (modifierGroupSelected, modifierGroup, isNested) => {
  var _a, _b, _c, _d, _e, _f;
  const prevModGroupPrice = modifierGroupSelected.totalPricePerItemUnit;
  const { includedModifierItemsCount, additionalModifierItemsCount } = calculateModifierItemPricesRegister(
    modifierGroup.modifierItems,
    modifierGroupSelected.modifierItemsSelected,
    modifierGroup.includedModifierItems,
    modifierGroup.quantityMode,
    modifierGroup.priceCalcMode
  );
  let newModGroupPrice = 0;
  for (const modifierItemId in modifierGroupSelected.modifierItemsSelected) {
    const modifierItemSelected = modifierGroupSelected.modifierItemsSelected[modifierItemId];
    const modifierItem = modifierGroup.modifierItems[modifierItemId];
    if (!isNested) {
      modifierItemSelected.totalPricePerItemUnit = 0;
      let includedInstancesCount = 0;
      for (const modifierInstanceId in modifierItemSelected.modifierItemInstances) {
        const instance = modifierItemSelected.modifierItemInstances[Number(modifierInstanceId)];
        const isNoSelected = instance.quantitySelected === 0;
        const isIncluded = ((_a = includedModifierItemsCount[modifierItemId]) == null ? void 0 : _a.count) && includedInstancesCount < includedModifierItemsCount[modifierItemId].count;
        const price = isNoSelected ? 0 : isIncluded ? modifierGroup.quantityMode !== "Lt,Reg,Ext" /* SIZE */ && !modifierItemSelected.isOverrideType ? modifierItem.includedMasterPrice : getIncludedAmountPrice(
          modifierItem,
          modifierItemSelected.amountSelected
        ) : modifierGroup.quantityMode !== "Lt,Reg,Ext" /* SIZE */ && !modifierItemSelected.isOverrideType ? modifierItem.additionalMasterPrice : getAdditionalAmountPrice(
          modifierItem,
          modifierItemSelected.amountSelected
        );
        instance.pricingMode = isIncluded ? "included" /* INCLUDED */ : "additional" /* ADDITIONAL */;
        includedInstancesCount++;
        const nestedTotals = Object.values(
          instance.nestedModifierGroupsSelected
        ).reduce((acc, nestedModifierGroupSelected) => {
          return acc + nestedModifierGroupSelected.totalPricePerItemUnit;
        }, 0);
        const customizerSectionsCount = Object.values(
          instance.customizerSectors
        ).reduce((acc, cur) => acc + (cur ? 1 : 0), 0);
        const halfCount = Math.floor(customizerSectionsCount / 2);
        const quarterCount = customizerSectionsCount % 2;
        const pricePercentage = customizerSectionsCount === 4 ? 1 : (halfCount * modifierItem.halfPricePercent + quarterCount * modifierItem.quarterPricePercent) / 100;
        instance.price = price * pricePercentage;
        modifierItemSelected.totalPricePerItemUnit += instance.price + nestedTotals;
      }
      modifierItemSelected.totalPricePerItemUnit += (_b = modifierItemSelected.onSidePrice) != null ? _b : 0;
      newModGroupPrice += modifierItemSelected.totalPricePerItemUnit;
    } else {
      const _includedModifierItemsCount = ((_c = includedModifierItemsCount[modifierItemId]) == null ? void 0 : _c.count) || 0;
      const _additionalModifierItemsCount = ((_d = additionalModifierItemsCount[modifierItemId]) == null ? void 0 : _d.count) || 0;
      const _includedModifierItemsPrice = _includedModifierItemsCount * (modifierGroup.quantityMode !== "Lt,Reg,Ext" /* SIZE */ ? modifierItem.includedMasterPrice : getIncludedAmountPrice(
        modifierItem,
        modifierItemSelected.amountSelected
      ));
      const _additionalModifierItemsPrice = _additionalModifierItemsCount * (modifierGroup.quantityMode !== "Lt,Reg,Ext" /* SIZE */ ? modifierItem.additionalMasterPrice : getAdditionalAmountPrice(
        modifierItem,
        modifierItemSelected.amountSelected
      ));
      let includedInstancesCount = 0;
      const isNoSelected = modifierItemSelected.quantitySelected === 0;
      for (const nestedModifierInstanceId in modifierItemSelected.modifierItemInstances) {
        const nestedInstance = modifierItemSelected.modifierItemInstances[Number(nestedModifierInstanceId)];
        includedInstancesCount++;
        const isIncluded = ((_e = includedModifierItemsCount[modifierItemId]) == null ? void 0 : _e.count) && includedInstancesCount <= includedModifierItemsCount[modifierItemId].count;
        const price = isNoSelected ? 0 : isIncluded ? modifierGroup.quantityMode !== "Lt,Reg,Ext" /* SIZE */ && !modifierItemSelected.isOverrideType ? modifierItem.includedMasterPrice : getIncludedAmountPrice(
          modifierItem,
          modifierItemSelected.amountSelected
        ) : modifierGroup.quantityMode !== "Lt,Reg,Ext" /* SIZE */ && !modifierItemSelected.isOverrideType ? modifierItem.additionalMasterPrice : getAdditionalAmountPrice(
          modifierItem,
          modifierItemSelected.amountSelected
        );
        nestedInstance.price = price;
      }
      modifierItemSelected.totalPricePerItemUnit = _includedModifierItemsPrice + _additionalModifierItemsPrice;
      modifierItemSelected.totalPricePerItemUnit += (_f = modifierItemSelected.onSidePrice) != null ? _f : 0;
      newModGroupPrice += modifierItemSelected.totalPricePerItemUnit;
    }
  }
  modifierGroupSelected.totalPricePerItemUnit = newModGroupPrice;
  return newModGroupPrice - prevModGroupPrice;
};
var selectNoModifierItem = (ticketElement, modifierGroupId, modifierItemId, isDefaultModifier, globalState, sortPriority) => {
  var _a, _b, _c;
  let modifierItem = (_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[isOpenItemFn(ticketElement) ? 0 : ticketElement.menuTypeId].modifierGroups[modifierGroupId].modifierItems[modifierItemId];
  const modifierGroup = (_b = ticketElement.itemObj) == null ? void 0 : _b.menuTypeVersions[isOpenItemFn(ticketElement) ? 0 : ticketElement.menuTypeId].modifierGroups[modifierGroupId];
  if (ticketElement.itemObj && !modifierItem && ((_c = modifierGroupId === ALL_MODS_ID || (modifierGroup == null ? void 0 : modifierGroup.isAllMod)) != null ? _c : false) && globalState) {
    const globalModifierItem = globalState.menu.locationMenu.modifierItems[modifierItemId];
    if (!globalModifierItem)
      return;
    ticketElement.itemObj = modifierItemToTicketModifierItemIntoItemObj(
      ticketElement.itemObj,
      globalModifierItem,
      {
        modifierGroupId,
        modifierItemId,
        menuTypeId: isOpenItemFn(ticketElement) ? 0 : ticketElement.menuTypeId
      },
      true,
      globalState.menu.locationMenu.modifierGroups,
      globalState.menu.locationMenu.modifierItems,
      sortPriority
    );
    modifierItem = ticketElement.itemObj.menuTypeVersions[isOpenItemFn(ticketElement) ? 0 : ticketElement.menuTypeId].modifierGroups[modifierGroupId].modifierItems[modifierItemId];
  }
  if (!modifierItem)
    return;
  const noModifierItemSelected = __spreadProps(__spreadValues({}, GET_MODIFIER_NO_MOD_TAG_APPLIED_STATE()), {
    modifierItemId,
    isDefaultModifier,
    locationModifierItemId: modifierItem.locationModifierItemId,
    locationModifierItemVersionId: modifierItem.locationModifierItemVersionId,
    sortPriority: sortPriority != null ? sortPriority : modifierItem.sortPriority
  });
  ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId] = noModifierItemSelected;
};
var singleSelectDeleteOtherModifiers = (ticketElement, modifierGroupId, modifierItemId, customizer) => {
  var _a;
  const defaultModifiersSelected = getDefaultModifiersSelectedFromItem(ticketElement);
  const modifierGroupSelected = ticketElement.modifierGroupsSelected[modifierGroupId];
  const modifierGroup = (_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[isOpenItemFn(ticketElement) ? 0 : ticketElement.menuTypeId].modifierGroups[modifierGroupId];
  const modifierItem = modifierGroup == null ? void 0 : modifierGroup.modifierItems[modifierItemId];
  if ((modifierGroup == null ? void 0 : modifierGroup.multiselect) || !modifierItem || !modifierGroupSelected || !modifierGroup)
    return;
  const noSelectedModifierItems = Object.entries(
    modifierGroupSelected.modifierItemsSelected || {}
  ).filter(
    ([_modifierItemId, _modifierItem]) => Number(_modifierItemId) !== modifierItemId && (_modifierItem.quantitySelected > 0 || hasNoModifierTag(_modifierItem.modifierTag))
  );
  noSelectedModifierItems.forEach(([selectedModifierItemToDeleteId]) => {
    var _a2;
    if ((_a2 = defaultModifiersSelected[modifierGroupId]) == null ? void 0 : _a2.includes(
      Number(selectedModifierItemToDeleteId)
    )) {
      if (hasNoModifierTag(
        ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[Number(selectedModifierItemToDeleteId)].modifierTag
      ))
        return;
      const defaultModifierItemToDelete = ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[Number(selectedModifierItemToDeleteId)];
      const noModifierItemSelected = __spreadProps(__spreadValues({}, GET_MODIFIER_NO_MOD_TAG_APPLIED_STATE()), {
        modifierItemId: defaultModifierItemToDelete.modifierItemId,
        isDefaultModifier: defaultModifierItemToDelete.isDefaultModifier,
        locationModifierItemId: defaultModifierItemToDelete.locationModifierItemId,
        locationModifierItemVersionId: defaultModifierItemToDelete.locationModifierItemVersionId
      });
      ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[Number(selectedModifierItemToDeleteId)] = noModifierItemSelected;
      applyModifierTag(
        ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[Number(selectedModifierItemToDeleteId)],
        GET_NO_MODIFIER_TAG_SELECTED(),
        "SELECT_NO" /* SELECT_NO */
      );
    } else
      deleteModifierItemSelected(
        ticketElement,
        modifierGroupId,
        Number(selectedModifierItemToDeleteId),
        customizer
      );
  });
};
var removeCurrentModifierItemAndAddNew2 = (ticketElement, modifierGroupId, modifierItemId, modifierTagSizes, customizer, globalState, sortPriority) => {
  const isDefaultModifier = ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId].isDefaultModifier;
  if (isDefaultModifier)
    delete ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId];
  else
    deleteModifierItemSelected(
      ticketElement,
      modifierGroupId,
      modifierItemId,
      customizer
    );
  incrementModifierItemSelected2(
    ticketElement,
    modifierGroupId,
    modifierItemId,
    modifierTagSizes,
    customizer,
    globalState,
    sortPriority
  );
  singleSelectDeleteOtherModifiers(
    ticketElement,
    modifierGroupId,
    modifierItemId,
    customizer
  );
  ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId].isDefaultModifier = isDefaultModifier;
};
var carryOverModifiersSelected2 = (ticketElement, preExistingModifierGroupsSelected, modifierTagSizes) => {
  Object.values(preExistingModifierGroupsSelected).forEach(
    (modifierGroupSelected) => {
      const modifierGroupId = modifierGroupSelected == null ? void 0 : modifierGroupSelected.modifierGroupId;
      if (!modifierGroupId)
        return;
      Object.values((modifierGroupSelected == null ? void 0 : modifierGroupSelected.modifierItemsSelected) || {}).forEach(
        (modifierItemSelected) => {
          setModifierItemSelected(
            ticketElement,
            modifierGroupId,
            {
              modifierItemId: modifierItemSelected.modifierItemId,
              amountSelected: modifierItemSelected.amountSelected,
              quantitySelected: modifierItemSelected.quantitySelected,
              isOverrideType: modifierItemSelected.isOverrideType,
              modifierTag: modifierItemSelected.modifierTag,
              modifierSizeTag: modifierItemSelected.modifierSizeTag,
              modifierItemInstances: modifierItemSelected.modifierItemInstances
            },
            modifierTagSizes
          );
          updateModifierPrice(
            ticketElement,
            modifierGroupId,
            modifierItemSelected.modifierItemId
          );
          updateCompletedSections(
            ticketElement,
            false,
            modifierGroupId,
            modifierItemSelected.modifierItemId
          );
        }
      );
    }
  );
};
var selectNoneModifierItems2 = (ticketElement, modifierGroupId, globalState) => {
  const defaultModifierItems = getDefaultModifiersSelectedFromItem(ticketElement);
  const modifierGroupSelected = ticketElement.modifierGroupsSelected[modifierGroupId];
  const wasNoneSelected = modifierGroupSelected.isNoneSelected;
  modifierGroupSelected.isNoneSelected = !wasNoneSelected;
  const modifierItemsSelected = modifierGroupSelected.modifierItemsSelected;
  Object.keys(modifierItemsSelected).map(Number).forEach((modifierItemId) => {
    if (defaultModifierItems[modifierGroupId] && defaultModifierItems[modifierGroupId].includes(modifierItemId)) {
      selectNoModifierItem(
        ticketElement,
        modifierGroupId,
        modifierItemId,
        true,
        globalState,
        void 0
      );
      applyModifierTag(
        ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId],
        GET_NO_MODIFIER_TAG_SELECTED(),
        "SELECT_NO" /* SELECT_NO */
      );
    } else {
      delete modifierItemsSelected[modifierItemId];
      if (modifierGroupSelected.modifierItemsWithNested.includes(modifierItemId))
        modifierGroupSelected.modifierItemsWithNested = modifierGroupSelected.modifierItemsWithNested.filter(
          (id) => id !== modifierItemId
        );
    }
  });
};
var selectNoneModifierItemsCustomizer = (ticketElement, modifierGroupId, customizer, globalState) => {
  var _a;
  const modifierGroupSelected = ticketElement.modifierGroupsSelected[modifierGroupId];
  const modifierGroup = (_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[ticketElement.menuTypeId].modifierGroups[modifierGroupId];
  const defaultModifierItems = getDefaultModifiersSelectedFromItem(ticketElement);
  Object.values(modifierGroupSelected.modifierItemsSelected).forEach(
    (modifierItemSelected) => {
      const modifierItemId = modifierItemSelected.modifierItemId;
      const modifierItem = modifierGroup == null ? void 0 : modifierGroup.modifierItems[modifierItemId];
      if (!modifierItem || !modifierGroupSelected || !modifierGroup)
        return;
      if (defaultModifierItems[modifierGroupId] && defaultModifierItems[modifierGroupId].includes(modifierItemId)) {
        selectNoModifierItem(
          ticketElement,
          modifierGroupId,
          modifierItemId,
          true,
          globalState,
          void 0
        );
        applyModifierTag(
          ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId],
          GET_NO_MODIFIER_TAG_SELECTED(),
          "SELECT_NO" /* SELECT_NO */
        );
      } else if (modifierItemSelected.quantitySelected > 0 && !hasNoModifierTag(modifierItemSelected.modifierTag) && !modifierGroupSelected.modifierItemsWithNested.includes(
        modifierItemSelected.modifierItemId
      )) {
        deleteModifierItemSelected(
          ticketElement,
          modifierGroupId,
          modifierItemSelected.modifierItemId,
          customizer
        );
      }
    }
  );
};
var toggleModifierItemSelected2 = (ticketElement, modifierGroupId, modifierItemId, customizer, modifierTag, globalQuantity, globalState, operation, modifierTagSizes, isDefaultModifier, sortPriority) => {
  switch (operation) {
    case "SET_QUANTITY" /* SET_QUANTITY */:
      setModifierItemSelectedQuantity(
        ticketElement,
        modifierGroupId,
        modifierItemId,
        globalQuantity,
        modifierTagSizes,
        globalState,
        sortPriority
      );
      break;
    case "DELETE" /* DELETE */:
      deleteModifierItemSelected(
        ticketElement,
        modifierGroupId,
        modifierItemId,
        customizer
      );
      break;
    case "INCREMENT" /* INCREMENT */:
      incrementModifierItemSelected2(
        ticketElement,
        modifierGroupId,
        modifierItemId,
        modifierTagSizes,
        customizer,
        globalState,
        sortPriority
      );
      singleSelectDeleteOtherModifiers(
        ticketElement,
        modifierGroupId,
        modifierItemId,
        customizer
      );
      break;
    case "DESELECT_NO" /* DESELECT_NO */:
      removeCurrentModifierItemAndAddNew2(
        ticketElement,
        modifierGroupId,
        modifierItemId,
        modifierTagSizes,
        customizer,
        globalState,
        sortPriority
      );
      break;
    case "SELECT_NO" /* SELECT_NO */:
      selectNoModifierItem(
        ticketElement,
        modifierGroupId,
        modifierItemId,
        isDefaultModifier,
        globalState,
        sortPriority
      );
      break;
    case "SELECT_ON_SIDE" /* SELECT_ON_SIDE */:
      toggleOnSideModTag(
        ticketElement,
        modifierGroupId,
        modifierItemId,
        modifierTagSizes,
        customizer,
        globalState,
        sortPriority
      );
      break;
    case "SELECT_EXTRA" /* SELECT_EXTRA */:
    case "SELECT_LITE" /* SELECT_LITE */:
      applySpecialModTag(
        ticketElement,
        modifierGroupId,
        modifierItemId,
        customizer,
        modifierTag,
        modifierTagSizes,
        globalState,
        sortPriority
      );
      break;
    default:
    case "NONE" /* NONE */:
      if (modifierTag) {
        if (sortPriority) {
          ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId].sortPriority = sortPriority;
        }
      }
      break;
  }
  return operation;
};
function getOperationByModifierTagAndModifierItem(modifierItemSelected, modifierTag, quantityMode = "Off" /* OFF */, globalQuantity = null, isCustomizer = false, customizer = CUSTOMIZER_INITIAL_STATE, defaultModifierItems = []) {
  let operation = "NONE" /* NONE */;
  if (modifierItemSelected && hasNoModifierTag(modifierItemSelected.modifierTag)) {
    if ((modifierTag == null ? void 0 : modifierTag.name) === NO_MODIFIER_TAG.name) {
      operation = "NONE" /* NONE */;
    } else if (isNull(modifierTag) || (modifierTag == null ? void 0 : modifierTag.name) !== NO_MODIFIER_TAG.name) {
      if (modifierTag && modifierTag.isSpecial) {
        operation = MODIFIER_TAG_NAME_TO_OPERATION[modifierTag.name];
      } else if (modifierTag) {
        operation = "DESELECT_NO" /* DESELECT_NO */;
      } else
        operation = "DESELECT_NO" /* DESELECT_NO */;
    }
  } else if (modifierTag && modifierTag.isSpecial) {
    operation = MODIFIER_TAG_NAME_TO_OPERATION[modifierTag.name];
  } else if (modifierTag && modifierItemSelected && (modifierItemSelected == null ? void 0 : modifierItemSelected.quantitySelected)) {
    return operation;
  } else if (isCustomizer) {
    const collidesWithCustomizer = Object.entries(
      (modifierItemSelected == null ? void 0 : modifierItemSelected.modifierItemInstances) || {}
    ).some(([, instance]) => {
      return hasCustomizerCollision(customizer, instance.customizerSectors);
    });
    if (collidesWithCustomizer) {
      if (modifierItemSelected && defaultModifierItems.includes(modifierItemSelected.modifierItemId))
        operation = "SELECT_NO" /* SELECT_NO */;
      else
        operation = "DELETE" /* DELETE */;
    } else {
      operation = "INCREMENT" /* INCREMENT */;
    }
  } else if (quantityMode === "x1,x2,x3" /* NUMBER */ && globalQuantity) {
    const prevQuantity = (modifierItemSelected == null ? void 0 : modifierItemSelected.quantitySelected) || 0;
    if (prevQuantity === 0 && globalQuantity === 1) {
      return "INCREMENT" /* INCREMENT */;
    }
    if (prevQuantity !== globalQuantity) {
      return "SET_QUANTITY" /* SET_QUANTITY */;
    }
  } else {
    operation = modifierItemSelected ? defaultModifierItems.includes(modifierItemSelected.modifierItemId) ? "SELECT_NO" /* SELECT_NO */ : "DELETE" /* DELETE */ : "INCREMENT" /* INCREMENT */;
  }
  return operation;
}
function getOperationByModifierTagOnly(modifierTag, globalQuantity = null) {
  let operation = "INCREMENT" /* INCREMENT */;
  if (modifierTag && modifierTag.isSpecial) {
    operation = MODIFIER_TAG_NAME_TO_OPERATION[modifierTag.name];
  } else if (globalQuantity && globalQuantity > 1) {
    return "SET_QUANTITY" /* SET_QUANTITY */;
  }
  return operation;
}
function getOperationByQuantityModeAndModifierItem(quantityMode, modifierItemSelected) {
  if (!modifierItemSelected)
    return "INCREMENT" /* INCREMENT */;
  if (quantityMode === "Lt,Reg,Ext" /* SIZE */)
    return "INCREMENT_SIZE" /* INCREMENT_SIZE */;
  return "INCREMENT" /* INCREMENT */;
}
var getModifierItemsSelectedQty = (modifierGroupSelected) => Object.values(modifierGroupSelected.modifierItemsSelected).reduce(
  (acc, modifierItemSelected) => acc + modifierItemSelected.quantitySelected,
  0
);
var applySpecialModTag = (ticketElement, modifierGroupId, modifierItemId, customizer, specialModTag, modifierTagSizes, globalState, sortPriority) => {
  if (!specialModTag)
    return;
  let modifierItemSelected = ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId];
  const modifierGroup = ticketElement.modifierGroupsSelected[modifierGroupId];
  if (modifierGroup.modifierItemsWithNested.includes(modifierItemId))
    return;
  if (modifierItemSelected) {
    if (modifierGroup.quantityMode === "Lt,Reg,Ext" /* SIZE */) {
      const currentAmountSelected = modifierItemSelected.amountSelected;
      if (currentAmountSelected === SPECIAL_TAG_NAME_TO_QUANTITY_SIZE[specialModTag.name])
        applyAmountSelected2(modifierItemSelected, "regular" /* REGULAR */);
      else
        applyAmountSelected2(
          modifierItemSelected,
          SPECIAL_TAG_NAME_TO_QUANTITY_SIZE[specialModTag.name]
        );
    } else {
      const isOverrideType = modifierItemSelected.isOverrideType;
      const currentAmountSelected = modifierItemSelected.amountSelected;
      if (isOverrideType && currentAmountSelected === SPECIAL_TAG_NAME_TO_QUANTITY_SIZE[specialModTag.name]) {
        const hasOnSide = hasOnSideApplied(modifierItemSelected.modifierTag);
        const currentModTag = modifierItemSelected.modifierTag;
        removeCurrentModifierItemAndAddNew2(
          ticketElement,
          modifierGroupId,
          modifierItemId,
          modifierTagSizes,
          customizer,
          globalState,
          sortPriority
        );
        if (hasOnSide) {
          toggleOnSideModTag(
            ticketElement,
            modifierGroupId,
            modifierItemId,
            modifierTagSizes,
            customizer,
            globalState,
            sortPriority
          );
          ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId].modifierTag = currentModTag;
        }
      } else if (isOverrideType) {
        applyAmountSelected2(
          modifierItemSelected,
          SPECIAL_TAG_NAME_TO_QUANTITY_SIZE[specialModTag.name]
        );
      } else {
        removeCurrentModifierItemAndAddNew2(
          ticketElement,
          modifierGroupId,
          modifierItemId,
          modifierTagSizes,
          customizer,
          globalState,
          sortPriority
        );
        const hasOnSide = hasOnSideApplied(modifierItemSelected.modifierTag);
        const currentModTag = modifierItemSelected.modifierTag;
        overrideModifierItemQuantityMode2(
          ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId],
          SPECIAL_TAG_NAME_TO_QUANTITY_SIZE[specialModTag.name]
        );
        if (hasOnSide) {
          toggleOnSideModTag(
            ticketElement,
            modifierGroupId,
            modifierItemId,
            modifierTagSizes,
            customizer,
            globalState,
            sortPriority
          );
          ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId].modifierTag = currentModTag;
        }
      }
    }
    if (sortPriority)
      modifierItemSelected.sortPriority = sortPriority;
    return;
  }
  incrementModifierItemSelected2(
    ticketElement,
    modifierGroupId,
    modifierItemId,
    modifierTagSizes,
    customizer,
    globalState,
    sortPriority
  );
  singleSelectDeleteOtherModifiers(
    ticketElement,
    modifierGroupId,
    modifierItemId,
    customizer
  );
  modifierItemSelected = ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId];
  if (modifierGroup.modifierItemsWithNested.includes(modifierItemId))
    return;
  if (modifierGroup.quantityMode === "Lt,Reg,Ext" /* SIZE */) {
    modifierItemSelected.onSidePrice = 0;
    applyAmountSelected2(
      modifierItemSelected,
      SPECIAL_TAG_NAME_TO_QUANTITY_SIZE[specialModTag.name]
    );
  } else {
    overrideModifierItemQuantityMode2(
      modifierItemSelected,
      SPECIAL_TAG_NAME_TO_QUANTITY_SIZE[specialModTag.name]
    );
  }
};
var toggleOnSideModTag = (ticketElement, modifierGroupId, modifierItemId, modifierTagSizes, customizer, globalState, sortPriority) => {
  let modifierItemSelected = ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId];
  if (modifierItemSelected) {
    if (hasOnSideApplied(modifierItemSelected.modifierTag)) {
      modifierItemSelected.onSidePrice = 0;
    } else {
      if (!modifierItemSelected.quantitySelected) {
        removeCurrentModifierItemAndAddNew2(
          ticketElement,
          modifierGroupId,
          modifierItemId,
          modifierTagSizes,
          customizer,
          globalState,
          sortPriority
        );
        modifierItemSelected = ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId];
      }
      applyOnSidePrice(
        ticketElement,
        modifierGroupId,
        modifierItemId,
        globalState,
        modifierItemSelected
      );
    }
    if (sortPriority)
      modifierItemSelected.sortPriority = sortPriority;
    return;
  }
  incrementModifierItemSelected2(
    ticketElement,
    modifierGroupId,
    modifierItemId,
    modifierTagSizes,
    customizer,
    globalState,
    sortPriority
  );
  singleSelectDeleteOtherModifiers(
    ticketElement,
    modifierGroupId,
    modifierItemId,
    customizer
  );
  modifierItemSelected = ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId];
  applyOnSidePrice(
    ticketElement,
    modifierGroupId,
    modifierItemId,
    globalState,
    modifierItemSelected
  );
};
var applyAmountSelected2 = (modifierItemSelected, amountSelected) => {
  modifierItemSelected.amountSelected = amountSelected;
  modifierItemSelected.modifierSizeTag = selectSpecialModTagsMetaData.lastResult()[amountSelected];
  Object.keys(modifierItemSelected.modifierItemInstances).map(Number).forEach((instanceKey) => {
    modifierItemSelected.modifierItemInstances[instanceKey].amountSelected = amountSelected;
  });
};
var applyOnSidePrice = (ticketElement, modifierGroupId, modifierItemId, globalState, modifierItemSelected) => {
  let pricingVersionId = null;
  if (ticketElement.itemObj) {
    const menuTypeKey = isOpenItemFn(ticketElement) ? 0 : ticketElement.menuTypeId;
    pricingVersionId = ticketElement.itemObj.menuTypeVersions[menuTypeKey].modifierGroups[modifierGroupId].modifierItems[modifierItemId].modifierItemPricingVersionId || ticketElement.itemObj.menuTypeVersions[menuTypeKey].modifierGroups[modifierGroupId].modifierItems[modifierItemId].defaultModifierItemPricingVersionId;
  }
  const onSidePrice = pricingVersionId ? globalState.menu.locationMenu.modifierItems[modifierItemId].modifierItemPricingVersions[pricingVersionId].onSidePrice : 0;
  modifierItemSelected.onSidePrice = onSidePrice;
};
var overrideModifierItemQuantityMode2 = (modifierItemSelected, amountSelected) => {
  modifierItemSelected.isOverrideType = true;
  modifierItemSelected.amountSelected = amountSelected;
  modifierItemSelected.modifierSizeTag = selectSpecialModTagsMetaData.lastResult()[amountSelected];
  modifierItemSelected.quantitySelected = 1;
  const [key, ...rest] = Object.keys(
    modifierItemSelected.modifierItemInstances
  ).map(Number);
  modifierItemSelected.modifierItemInstances[key].amountSelected = amountSelected;
  rest.forEach((instanceKey) => {
    delete modifierItemSelected.modifierItemInstances[instanceKey];
  });
};
var decrementModifierItemSelected2 = (ticketElement, modifierGroupId, modifierItemId, modifierTagSizes, customizer, sortPriority) => {
  var _a, _b;
  const isCustomizerItem = ticketElement.customizerType !== "none" /* NONE */;
  const modifierGroupSelected = ticketElement.modifierGroupsSelected;
  const currentModifierGroupSelected = modifierGroupSelected[modifierGroupId];
  const modifierGroup = (_b = (_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[isOpenItemFn(ticketElement) ? 0 : ticketElement.menuTypeId]) == null ? void 0 : _b.modifierGroups[modifierGroupId];
  if (!modifierGroup || !currentModifierGroupSelected)
    return;
  const modifierItemSelected = currentModifierGroupSelected.modifierItemsSelected[modifierItemId];
  if (sortPriority)
    modifierItemSelected.sortPriority = sortPriority;
  if (isCustomizerItem && modifierGroup.activeCustomizerSectionSelector) {
    if (modifierGroup.quantityMode === "Lt,Reg,Ext" /* SIZE */ || modifierItemSelected.isOverrideType) {
      return decrementCustomizerSizeModifierItemSelected(
        ticketElement,
        modifierGroupId,
        modifierItemId,
        customizer
      );
    }
    return decrementCustomizerQuantityModifierItemSelected(
      ticketElement,
      modifierGroupId,
      modifierItemId,
      customizer
    );
  }
  if (modifierGroup.quantityMode === "Lt,Reg,Ext" /* SIZE */ || modifierItemSelected.isOverrideType) {
    return decrementSizeModifierItemSelected(
      ticketElement,
      modifierGroupId,
      modifierItemId,
      modifierTagSizes,
      customizer
    );
  }
  if (currentModifierGroupSelected.modifierItemsSelected[modifierItemId]) {
    return decrementQuantityModifierItemSelected(
      ticketElement,
      modifierGroupId,
      modifierItemId,
      customizer
    );
  }
};
var decrementSizeModifierItemSelected = (ticketElement, modifierGroupId, modifierItemId, modifierTagSizes, customizer) => {
  const currentModifierGroupSelected = ticketElement.modifierGroupsSelected[modifierGroupId];
  let newModifierItemSelected = null;
  if (currentModifierGroupSelected.modifierItemsSelected[modifierItemId].amountSelected !== "light" /* LIGHT */) {
    newModifierItemSelected = currentModifierGroupSelected.modifierItemsSelected[modifierItemId];
    newModifierItemSelected.amountSelected = prevQuantityAmount(
      newModifierItemSelected.amountSelected
    );
    newModifierItemSelected.modifierSizeTag = modifierTagSizes[newModifierItemSelected.amountSelected];
    const prevInstance = newModifierItemSelected.modifierItemInstances[Number(
      Object.keys(newModifierItemSelected.modifierItemInstances).pop() || "0"
    )];
    if (prevInstance) {
      prevInstance.amountSelected = prevQuantityAmount(
        prevInstance.amountSelected
      );
    }
  } else {
    deleteModifierItemSelected(
      ticketElement,
      modifierGroupId,
      modifierItemId,
      customizer
    );
  }
};
var decrementQuantityModifierItemSelected = (ticketElement, modifierGroupId, modifierItemId, customizer) => {
  var _a;
  const currentModifierGroupSelected = ticketElement.modifierGroupsSelected[modifierGroupId];
  const newModifierItemSelected = currentModifierGroupSelected.modifierItemsSelected[modifierItemId];
  if (!newModifierItemSelected)
    return;
  if (newModifierItemSelected.quantitySelected - 1 === 0 && ((_a = getDefaultModifiersSelectedFromItem(ticketElement)[modifierGroupId]) == null ? void 0 : _a.includes(modifierItemId))) {
    const modifierItem = currentModifierGroupSelected.modifierItemsSelected[modifierItemId];
    const noModifierItemSelected = __spreadProps(__spreadValues({}, GET_MODIFIER_ITEM_SELECTED_INITIAL_STATE()), {
      quantitySelected: 0,
      isComplete: true,
      isDefaultModifier: true,
      modifierItemInstances: {
        0: {
          modifierItemInstanceId: 0,
          isComplete: true,
          isVoided: false,
          isModifiedAfterSent: false,
          pricingMode: "included" /* INCLUDED */,
          price: 0,
          taxInclusivePrice: 0,
          nestedModifierGroupsSelected: {},
          quantitySelected: 0,
          amountSelected: "regular" /* REGULAR */,
          customizerSectors: __spreadValues({}, CUSTOMIZER_INITIAL_STATE)
        }
      },
      modifierItemId,
      locationModifierItemId: modifierItem.locationModifierItemId,
      locationModifierItemVersionId: modifierItem.locationModifierItemVersionId
    });
    currentModifierGroupSelected.modifierItemsSelected[modifierItemId] = noModifierItemSelected;
    return applyModifierTag(
      ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId],
      GET_NO_MODIFIER_TAG_SELECTED(),
      "SELECT_NO" /* SELECT_NO */
    );
  }
  delete newModifierItemSelected.modifierItemInstances[Object.keys(newModifierItemSelected.modifierItemInstances).length];
  newModifierItemSelected.quantitySelected -= 1;
  if (newModifierItemSelected.quantitySelected === 0) {
    deleteModifierItemSelected(
      ticketElement,
      modifierGroupId,
      modifierItemId,
      customizer
    );
  }
};
var decrementCustomizerSizeModifierItemSelected = (ticketElement, modifierGroupId, modifierItemId, customizer) => {
  const currentModifierGroupSelected = ticketElement.modifierGroupsSelected[modifierGroupId];
  const modifierItemsWithNested = currentModifierGroupSelected.modifierItemsWithNested || [];
  const newModifierItemSelected = currentModifierGroupSelected.modifierItemsSelected[modifierItemId];
  if (!newModifierItemSelected)
    return;
  let newInstanceId = null;
  let newInstance = null;
  const matchingInstanceEntry = Object.entries(
    newModifierItemSelected.modifierItemInstances
  ).find(([, instance]) => isEqual(instance.customizerSectors, customizer));
  if (matchingInstanceEntry) {
    const matchingInstance = matchingInstanceEntry[1];
    matchingInstance.amountSelected = prevQuantityAmount(
      matchingInstance.amountSelected
    );
    newInstance = matchingInstance;
    newInstanceId = Number(matchingInstanceEntry[0]);
  } else {
    const instanceWithSubsetCustomizer = Object.values(
      newModifierItemSelected.modifierItemInstances
    ).find(
      (instance) => isCustomizerSubSet(customizer, instance.customizerSectors)
    );
    if (!instanceWithSubsetCustomizer || instanceWithSubsetCustomizer.amountSelected === "light" /* LIGHT */) {
      return;
    }
    instanceWithSubsetCustomizer.customizerSectors = Object.entries(
      customizer
    ).reduce(
      (acc, [key, value]) => {
        if (value) {
          acc[key] = false;
        }
        return acc;
      },
      __spreadValues({}, instanceWithSubsetCustomizer.customizerSectors)
    );
    newInstanceId = Object.keys(newModifierItemSelected.modifierItemInstances).reduce(
      (acc, id) => Math.max(acc, Number(id)),
      0
    ) + 1;
    newInstance = __spreadProps(__spreadValues({}, GET_MODIFIER_ITEM_INSTANCE_INITIAL_STATE()), {
      isComplete: true,
      customizerSectors: __spreadValues({}, customizer),
      amountSelected: prevQuantityAmount(
        instanceWithSubsetCustomizer.amountSelected
      )
    });
    newModifierItemSelected.modifierItemInstances[newInstanceId] = newInstance;
  }
  if (!newInstance)
    return;
  const instanceToMergeWithEntry = Object.entries(
    newModifierItemSelected.modifierItemInstances
  ).find(
    ([instanceId, instance]) => instanceId !== `${newInstanceId}` && instance.amountSelected === (newInstance == null ? void 0 : newInstance.amountSelected)
  );
  if (instanceToMergeWithEntry) {
    const instanceToMergeWith = instanceToMergeWithEntry[1];
    instanceToMergeWith.customizerSectors = Object.entries(
      instanceToMergeWith.customizerSectors
    ).reduce(
      (acc, [key, value]) => {
        if (value) {
          acc[key] = true;
        }
        return acc;
      },
      __spreadValues({}, newInstance.customizerSectors)
    );
    delete newModifierItemSelected.modifierItemInstances[newInstanceId];
  }
  const newParentSize = Object.values(
    newModifierItemSelected.modifierItemInstances
  ).reduce(
    (acc, instance) => getMaxSize(acc, instance.amountSelected),
    "light" /* LIGHT */
  );
  if (newParentSize !== newModifierItemSelected.amountSelected) {
    newModifierItemSelected.amountSelected = newParentSize;
  }
  return {
    modifierItemsWithNested,
    newModifierItemSelected,
    newInstanceId,
    newInstance
  };
};
var decrementCustomizerQuantityModifierItemSelected = (ticketElement, modifierGroupId, modifierItemId, customizer) => {
  const currentModifierGroupSelected = ticketElement.modifierGroupsSelected[modifierGroupId];
  const modifierItemsWithNested = currentModifierGroupSelected.modifierItemsWithNested || [];
  const newModifierItemSelected = currentModifierGroupSelected.modifierItemsSelected[modifierItemId];
  if (!newModifierItemSelected)
    return;
  const matchingInstanceEntry = Object.entries(
    newModifierItemSelected.modifierItemInstances
  ).find(([, instance]) => isEqual(instance.customizerSectors, customizer));
  if (matchingInstanceEntry) {
    delete newModifierItemSelected.modifierItemInstances[Number(matchingInstanceEntry[0])];
    newModifierItemSelected.quantitySelected -= 1;
  } else {
    const instanceWithSubsetCustomizer = Object.values(
      newModifierItemSelected.modifierItemInstances
    ).find(
      (instance) => isCustomizerSubSet(customizer, instance.customizerSectors)
    );
    if (instanceWithSubsetCustomizer) {
      instanceWithSubsetCustomizer.customizerSectors = Object.entries(
        customizer
      ).reduce(
        (acc, [key, value]) => {
          if (value) {
            acc[key] = false;
          }
          return acc;
        },
        __spreadValues({}, instanceWithSubsetCustomizer.customizerSectors)
      );
    }
  }
  return {
    ticketElement,
    modifierGroupId,
    newModifierItemSelected,
    modifierItemsWithNested
  };
};
var modifierItemToTicketModifierItem = (currentModifierItem, modifierGroupId, isAllMod, menuModifierGroups, menuModifierItems, sortPriority) => {
  const pricingVersion = currentModifierItem.modifierItemPricingVersions[currentModifierItem.defaultModifierItemPricingVersionId];
  const modifierGroups = recursiveModifierMapperCore(
    currentModifierItem.modifierGroups,
    menuModifierGroups,
    menuModifierItems,
    true,
    1
  );
  const ticketMI = {
    locationModifierItemId: currentModifierItem.locationModifierItemId,
    locationModifierItemVersionId: currentModifierItem.locationModifierItemVersionId,
    name: currentModifierItem.name,
    posName: currentModifierItem.posName,
    checkName: currentModifierItem.checkName,
    kdsName: currentModifierItem.kdsName,
    modifierGroups,
    modifierItemPricingVersionId: currentModifierItem.defaultModifierItemPricingVersionId,
    defaultModifierItemPricingVersionId: currentModifierItem.defaultModifierItemPricingVersionId,
    modifierItemId: currentModifierItem.modifierItemId,
    locationId: currentModifierItem.locationId,
    includedMasterPrice: pricingVersion.includedMasterPrice,
    additionalMasterPrice: pricingVersion.additionalMasterPrice,
    applyPiecePricing: true,
    quarterPricePercent: pricingVersion.quarterPricePercent,
    halfPricePercent: pricingVersion.halfPricePercent,
    customIncludedQuantityPricing: true,
    includedLightPrice: pricingVersion.includedLightPrice,
    includedRegularPrice: pricingVersion.includedRegularPrice,
    includedExtraPrice: pricingVersion.includedExtraPrice,
    customAdditionalQuantityPricing: true,
    additionalLightPrice: pricingVersion.additionalLightPrice,
    additionalRegularPrice: pricingVersion.additionalRegularPrice,
    additionalExtraPrice: pricingVersion.additionalExtraPrice,
    defaultQuantitySelected: currentModifierItem.defaultQuantitySelected,
    isSelected: false,
    active: currentModifierItem.active,
    locationModifierItemPricingVersionId: 0,
    locationModifierGroupPricingVersionId: 0,
    sortPriority: sortPriority ? sortPriority : 0,
    defaultAmountSelected: "regular" /* REGULAR */,
    is86ed: false,
    locationMgpvLocationMipvVersionId: 0,
    override: {},
    id: 0,
    spacesBefore: 0,
    linesBefore: 0,
    maximumQuantity: 0,
    inheritedActive: true
  };
  return ticketMI;
};
var modifierItemToTicketModifierItemIntoItemObj = (itemObj, selectedModifierItem, ids, isAllMod, menuModifierGroups, menuModifierItems, sortPriority) => {
  const ticketMI = modifierItemToTicketModifierItem(
    selectedModifierItem,
    ids.modifierGroupId,
    isAllMod,
    menuModifierGroups,
    menuModifierItems,
    sortPriority
  );
  return produce(itemObj, (draft) => {
    draft.menuTypeVersions[ids.menuTypeId].modifierGroups[ids.modifierGroupId].modifierItems[ids.modifierItemId] = ticketMI;
  });
};
var getModifierItemHasChangesFunction = (sourceModifierGroup) => (modifierItemSelected) => {
  if (modifierItemSelected && modifierItemSelected.modifierTag && !isEmpty9(modifierItemSelected.modifierTag))
    return true;
  if (modifierItemSelected == null ? void 0 : modifierItemSelected.isOverrideType)
    return true;
  const hasNestedMods = !isEmpty9(
    sourceModifierGroup.modifierItems[modifierItemSelected.modifierItemId].modifierGroups
  );
  const modifierItemHasDiff = sourceModifierGroup.quantityMode !== "Lt,Reg,Ext" /* SIZE */ ? (sourceModifierGroup.modifierItems[modifierItemSelected.modifierItemId].defaultQuantitySelected || 1) !== modifierItemSelected.quantitySelected : (sourceModifierGroup.modifierItems[modifierItemSelected.modifierItemId].defaultAmountSelected || 1) !== modifierItemSelected.amountSelected;
  if (!hasNestedMods)
    return modifierItemHasDiff;
  if (modifierItemHasDiff)
    return true;
  return Object.values(modifierItemSelected.modifierItemInstances).some(
    (instance) => {
      return Object.values(instance.nestedModifierGroupsSelected).some(
        (nestedModGroup) => {
          const nestedModGroupDiffFunction = getModifierItemHasChangesFunction(
            sourceModifierGroup.modifierItems[modifierItemSelected.modifierItemId].modifierGroups[nestedModGroup.modifierGroupId]
          );
          const defaultNestedModGroupModItems = getDefaultModsByModifierGroup(
            sourceModifierGroup.modifierItems[modifierItemSelected.modifierItemId].modifierGroups[nestedModGroup.modifierGroupId]
          );
          return Object.values(nestedModGroup.modifierItemsSelected).some(
            (nestedModItem) => !defaultNestedModGroupModItems.includes(
              nestedModItem.modifierItemId
            ) || nestedModGroupDiffFunction(nestedModItem)
          );
        }
      );
    }
  );
};
var simplifyModifierOperationToQuantityEffect = (operation) => {
  switch (operation) {
    case "INCREMENT" /* INCREMENT */:
      return "INCREMENT" /* INCREMENT */;
    case "DESELECT_NO" /* DESELECT_NO */:
    case "SELECT_EXTRA" /* SELECT_EXTRA */:
    case "SELECT_LITE" /* SELECT_LITE */:
    case "SET_QUANTITY" /* SET_QUANTITY */:
      return "SET_QUANTITY" /* SET_QUANTITY */;
    case "SELECT_ON_SIDE" /* SELECT_ON_SIDE */:
    default:
      return operation;
  }
};
var validateMaximumModifierGroupItemsQuantity = (modifierGroup, ticketElement, modifierItemId, operation, quantity) => {
  let errorCode = null;
  const modifierGroupId = modifierGroup.modifierGroupId;
  if (!modifierGroup.maximumModifierItems)
    return true;
  const skipValidation = modifierGroup.maximumModifierItems === 1 && !modifierGroup.multiselect;
  const currentModsCount = getModifierItemsSelectedQty(
    ticketElement.modifierGroupsSelected[modifierGroupId]
  );
  let isNextChangeAllowed = true;
  switch (operation) {
    case "INCREMENT" /* INCREMENT */: {
      isNextChangeAllowed = skipValidation || currentModsCount < modifierGroup.maximumModifierItems;
      errorCode = "maximumReached";
      break;
    }
    case "SET_QUANTITY" /* SET_QUANTITY */: {
      const currentModItemQty = ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId] ? ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId].quantitySelected : 0;
      const nextQuantity = currentModsCount - currentModItemQty + (quantity != null ? quantity : 1);
      isNextChangeAllowed = skipValidation || nextQuantity <= modifierGroup.maximumModifierItems;
      errorCode = quantity === null ? "maximumReached" : "wrongQuantity";
      break;
    }
    case "INCREMENT_SIZE" /* INCREMENT_SIZE */:
    case "SELECT_ON_SIDE" /* SELECT_ON_SIDE */: {
      const currentModIsSelected = ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId] && ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId].quantitySelected;
      if (!currentModIsSelected) {
        const currentModItemQty = ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId] ? ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId].quantitySelected : 0;
        const nextQuantity = currentModsCount - currentModItemQty + (quantity != null ? quantity : 1);
        isNextChangeAllowed = skipValidation || nextQuantity <= modifierGroup.maximumModifierItems;
        errorCode = quantity === null ? "maximumReached" : "wrongQuantity";
      }
      break;
    }
  }
  if (!isNextChangeAllowed)
    throw new Error(errorCode != null ? errorCode : "unknown");
  return true;
};
var checkIfTicketElementIsTaxExempt = (ticketElement, globalState) => {
  if (ticketElement.isOpenItem || isComboElement(ticketElement)) {
    return;
  }
  const itemObj = ticketElement.itemObj;
  const menuTypeVersion = itemObj.menuTypeVersions[ticketElement.menuTypeId];
  const isItemTaxExempt = menuTypeVersion.taxExempt || false;
  const modifierItems = selectLocationModifierItems(globalState);
  const removeItemTaxExempt = Object.values(
    ticketElement.modifierGroupsSelected
  ).some((modifierGroup) => {
    return modifierGroup.modifierItemsSelected && Object.values(modifierGroup.modifierItemsSelected).some((modifierItem) => {
      var _a;
      return ((_a = modifierItems[modifierItem.modifierItemId]) == null ? void 0 : _a.removeItemTaxExempt) || false;
    });
  });
  ticketElement.taxExempt = isItemTaxExempt && !removeItemTaxExempt;
};
var initializeModifierGroupsSelected = (newTicketItem, modifierTagSizes, defaultCustomizerSectorsForCustomizerSection) => {
  const modifierGroupsSelected = {};
  if (!newTicketItem) {
    return {
      modifierGroupsSelected
    };
  }
  const allModIds = Object.values((newTicketItem == null ? void 0 : newTicketItem.menuTypeVersions) || {})[0].allModIds;
  const menuTypeVersion = Object.values(newTicketItem.menuTypeVersions)[0];
  Object.values(menuTypeVersion.modifierGroups).forEach((modifierGroup) => {
    const calculatedModifierPricesCount = calculateModifierItemPricesMenu(
      modifierGroup.modifierItems,
      modifierGroup.includedModifierItems,
      modifierGroup.quantityMode,
      modifierGroup.priceCalcMode
    );
    if (modifierGroup.defaultSelectionPrice !== calculatedModifierPricesCount.totalPrice) {
      menuTypeVersion.defaultModifiersPrice += -modifierGroup.defaultSelectionPrice + calculatedModifierPricesCount.totalPrice;
      modifierGroup.defaultSelectionPrice = calculatedModifierPricesCount.totalPrice;
    }
    const preModifierGroupSelected = {
      isComplete: false,
      isNoneSelected: false,
      quantityRequired: modifierGroup.requiredModifierItems,
      modifierGroupId: modifierGroup.modifierGroupId,
      quantityMode: modifierGroup.quantityMode,
      totalPricePerItemUnit: calculatedModifierPricesCount.totalPrice,
      taxInclusiveTotalPricePerItemUnit: 0,
      modifierItemsSelected: {},
      modifierItemsWithNested: [],
      customizerEnabled: modifierGroup.activeCustomizerSectionSelector,
      locationModifierGroupId: modifierGroup.locationModifierGroupId,
      locationModifierGroupVersionId: modifierGroup.locationModifierGroupVersionId,
      showSearchBar: modifierGroup.showSearchBar,
      global: modifierGroup.isAllMod
    };
    Object.values(modifierGroup.modifierItems).forEach((modifierItem) => {
      var _a;
      if (modifierItem.isSelected) {
        let includedCount = 0;
        const preModifierItemSelected = __spreadProps(__spreadValues({}, GET_MODIFIER_ITEM_SELECTED_INITIAL_STATE()), {
          modifierItemId: modifierItem.modifierItemId,
          isDefaultModifier: true,
          quantitySelected: modifierItem.defaultQuantitySelected || 1,
          amountSelected: modifierItem.defaultAmountSelected,
          modifierSizeTag: modifierGroup.quantityMode === "Lt,Reg,Ext" /* SIZE */ ? modifierTagSizes[modifierItem.defaultAmountSelected] : null,
          locationModifierItemId: modifierItem.locationModifierItemId,
          locationModifierItemVersionId: modifierItem.locationModifierItemVersionId,
          modifierItemInstances: {},
          isComplete: true
        });
        for (let i = 0; i < (modifierItem.defaultQuantitySelected || 1); i++) {
          let nestedModifierGroups = {};
          let nestedModsPrice = 0;
          if (!isEmpty(modifierItem.modifierGroups)) {
            nestedModifierGroups = mapNestedModGroups(
              modifierItem.modifierGroups,
              modifierTagSizes
            );
            nestedModsPrice = Object.values(nestedModifierGroups).reduce(
              (acc, modGroup) => acc + modGroup.totalPricePerItemUnit,
              0
            );
          }
          const isIncluded = ((_a = calculatedModifierPricesCount.includedModifierItemsCount[modifierItem.modifierItemId]) == null ? void 0 : _a.count) && includedCount < calculatedModifierPricesCount.includedModifierItemsCount[modifierItem.modifierItemId].count;
          const price = isIncluded ? modifierGroup.quantityMode !== "Lt,Reg,Ext" /* SIZE */ ? modifierItem.includedMasterPrice : getIncludedAmountPrice(
            modifierItem,
            modifierItem.defaultAmountSelected
          ) : modifierGroup.quantityMode !== "Lt,Reg,Ext" /* SIZE */ ? modifierItem.additionalMasterPrice : getAdditionalAmountPrice(
            modifierItem,
            modifierItem.defaultAmountSelected
          );
          preModifierItemSelected.totalPricePerItemUnit += price + nestedModsPrice;
          if (isIncluded)
            includedCount++;
          const newInstance = __spreadProps(__spreadValues({}, GET_MODIFIER_ITEM_INSTANCE_INITIAL_STATE()), {
            amountSelected: modifierItem.defaultAmountSelected,
            quantitySelected: modifierItem.defaultQuantitySelected || 1,
            customizerSectors: __spreadValues({}, modifierGroup.activeCustomizerSectionSelector ? defaultCustomizerSectorsForCustomizerSection || CUSTOMIZER_INITIAL_STATE : CUSTOMIZER_INITIAL_STATE),
            modifierItemInstanceId: i + 1,
            price,
            isComplete: initializeIsInstanceComplete(nestedModifierGroups),
            nestedModifierGroupsSelected: nestedModifierGroups,
            pricingMode: isIncluded ? "included" /* INCLUDED */ : "additional" /* ADDITIONAL */
          });
          preModifierItemSelected.modifierItemInstances[i + 1] = newInstance;
        }
        preModifierItemSelected.isComplete = Object.values(
          preModifierItemSelected.modifierItemInstances
        ).every((instance) => instance.isComplete);
        preModifierGroupSelected.modifierItemsSelected[modifierItem.modifierItemId] = preModifierItemSelected;
        if (!isEmpty(modifierItem.modifierGroups) && !preModifierGroupSelected.modifierItemsWithNested.includes(
          modifierItem.modifierItemId
        )) {
          preModifierGroupSelected.modifierItemsWithNested.push(
            modifierItem.modifierItemId
          );
        }
      }
    });
    preModifierGroupSelected.isComplete = getModifierItemsSelectedQty(preModifierGroupSelected) >= modifierGroup.requiredModifierItems && Object.values(preModifierGroupSelected.modifierItemsSelected).every(
      (modI) => modI.isComplete
    );
    modifierGroupsSelected[modifierGroup.modifierGroupId] = preModifierGroupSelected;
  });
  Object.values(modifierGroupsSelected).forEach((modifierGroup) => {
    if (allModIds.includes(modifierGroup.modifierGroupId)) {
      modifierGroup.isComplete = true;
    }
  });
  return {
    modifierGroupsSelected
  };
};
var toggleHotButtonModifierItemInModifierGroup = (itemCopy, menuTypeId, hotButtonsModifierItemId, modifierItemFields) => {
  const modifierGroupWithHotButtonModItem = Object.values(
    itemCopy.menuTypeVersions[menuTypeId].modifierGroups
  ).sort((a, b) => {
    if (a.isAllMod && !b.isAllMod)
      return 1;
    if (!a.isAllMod && b.isAllMod)
      return -1;
    return a.sortPriority - b.sortPriority;
  }).find(
    (_modifierGroup) => Object.keys(_modifierGroup.modifierItems).includes(
      String(hotButtonsModifierItemId)
    )
  );
  if (modifierGroupWithHotButtonModItem) {
    Object.assign(
      itemCopy.menuTypeVersions[menuTypeId].modifierGroups[modifierGroupWithHotButtonModItem.modifierGroupId].modifierItems[hotButtonsModifierItemId],
      modifierItemFields
    );
  }
};
var mapNestedModGroups = (modifierGroups, modifierTagSizes) => {
  const modifierGroupsSelected = {};
  Object.values(modifierGroups).forEach((modifierGroup) => {
    const calculatedModifierPricesCount = calculateModifierItemPricesMenu(
      modifierGroup.modifierItems,
      modifierGroup.includedModifierItems,
      modifierGroup.quantityMode,
      modifierGroup.priceCalcMode
    );
    const preModifierGroupSelected = {
      isComplete: false,
      isNoneSelected: false,
      quantityRequired: modifierGroup.requiredModifierItems,
      modifierGroupId: modifierGroup.modifierGroupId,
      quantityMode: modifierGroup.quantityMode,
      totalPricePerItemUnit: calculatedModifierPricesCount.totalPrice,
      taxInclusiveTotalPricePerItemUnit: 0,
      modifierItemsSelected: {},
      modifierItemsWithNested: [],
      customizerEnabled: modifierGroup.activeCustomizerSectionSelector,
      locationModifierGroupId: modifierGroup.locationModifierGroupId,
      locationModifierGroupVersionId: modifierGroup.locationModifierGroupVersionId,
      showSearchBar: modifierGroup.showSearchBar,
      global: modifierGroup.global
    };
    let includedCount = 0;
    const includedTotal = Object.values(
      calculatedModifierPricesCount.includedModifierItemsCount
    ).reduce(
      (total, miC) => total + miC.count,
      0
    );
    Object.values(modifierGroup.modifierItems).forEach((modifierItem) => {
      if (modifierItem.isSelected) {
        const preModifierItemSelected = __spreadProps(__spreadValues({}, GET_MODIFIER_ITEM_SELECTED_INITIAL_STATE()), {
          modifierItemId: modifierItem.modifierItemId,
          quantitySelected: modifierItem.defaultQuantitySelected || 1,
          amountSelected: modifierItem.defaultAmountSelected,
          modifierSizeTag: modifierGroup.quantityMode === "Lt,Reg,Ext" /* SIZE */ ? modifierTagSizes[modifierItem.defaultAmountSelected] : null,
          locationModifierItemId: modifierItem.locationModifierItemId,
          locationModifierItemVersionId: modifierItem.locationModifierItemVersionId,
          modifierItemInstances: {},
          isComplete: true
        });
        for (let i = 0; i < (modifierItem.defaultQuantitySelected || 1); i++) {
          const price = includedCount < includedTotal ? modifierGroup.quantityMode !== "Lt,Reg,Ext" /* SIZE */ ? modifierItem.includedMasterPrice : getIncludedAmountPrice(
            modifierItem,
            modifierItem.defaultAmountSelected
          ) : modifierGroup.quantityMode !== "Lt,Reg,Ext" /* SIZE */ ? modifierItem.additionalMasterPrice : getAdditionalAmountPrice(
            modifierItem,
            modifierItem.defaultAmountSelected
          );
          preModifierItemSelected.totalPricePerItemUnit += price;
          includedCount++;
          const newInstance = __spreadProps(__spreadValues({}, GET_MODIFIER_ITEM_INSTANCE_INITIAL_STATE()), {
            amountSelected: modifierItem.defaultAmountSelected,
            quantitySelected: modifierItem.defaultQuantitySelected || 1,
            customizerSectors: __spreadValues({}, CUSTOMIZER_INITIAL_STATE),
            modifierItemInstanceId: i + 1,
            price,
            isComplete: initializeIsInstanceComplete({})
          });
          preModifierItemSelected.modifierItemInstances[i + 1] = newInstance;
        }
        preModifierGroupSelected.modifierItemsSelected[modifierItem.modifierItemId] = preModifierItemSelected;
      }
    });
    preModifierGroupSelected.isComplete = getModifierItemsSelectedQty(preModifierGroupSelected) >= modifierGroup.requiredModifierItems;
    modifierGroupsSelected[modifierGroup.modifierGroupId] = preModifierGroupSelected;
  });
  return modifierGroupsSelected;
};
var initializeModifierGroupsSelected_default = initializeModifierGroupsSelected;

// src/helpers/register/reducerHelpers/taxesVolumetric.ts
var getVolumetricTaxApplied = (data, itemVolumeData, quantity) => {
  const { volume, unit: itemUnit } = itemVolumeData;
  const { interval, rate, unit: taxUnit } = data;
  let taxAmount = 0;
  let currentInterval = interval;
  let volumeRemaining = volume * quantity;
  let currentItemUnit = itemUnit;
  let currentTaxUnit = taxUnit;
  while (volumeRemaining > 0) {
    if (currentItemUnit === currentTaxUnit) {
      if (volumeRemaining > currentInterval) {
        const proportion = Math.trunc(volumeRemaining / currentInterval);
        taxAmount = rate * proportion;
        volumeRemaining -= currentInterval * proportion;
      } else {
        taxAmount += volumeRemaining / currentInterval * rate;
        volumeRemaining -= currentInterval;
      }
    } else {
      const bestFitUnit = getBestFitUnitType(currentItemUnit, currentTaxUnit);
      currentInterval = convertVolumeUnits(
        interval,
        currentTaxUnit,
        bestFitUnit
      );
      volumeRemaining = convertVolumeUnits(
        volumeRemaining,
        currentItemUnit,
        bestFitUnit
      );
      currentItemUnit = bestFitUnit;
      currentTaxUnit = bestFitUnit;
    }
  }
  return taxAmount;
};
var convertVolumeUnits = (volume, fromUnit, toUnit) => {
  if (fromUnit === toUnit)
    return volume;
  switch (fromUnit) {
    case "ml" /* ML */:
      return volume;
    case "l" /* L */:
      switch (toUnit) {
        case "ml" /* ML */:
          return volume * 1e3;
        default:
          return volume;
      }
    case "gal" /* GAL */:
      switch (toUnit) {
        case "ml" /* ML */:
          return volume * 3785.41;
        case "qt" /* QT */:
          return volume * 4;
        case "pnt" /* PNT */:
          return volume * 8;
        default:
          return volume;
      }
    case "qt" /* QT */:
      switch (toUnit) {
        case "ml" /* ML */:
          return volume * 946.353;
        case "pnt" /* PNT */:
          return volume * 2;
        default:
          return volume;
      }
    case "pnt" /* PNT */:
      switch (toUnit) {
        case "ml" /* ML */:
          return volume * 473.176;
        default:
          return volume;
      }
    default:
      return volume;
  }
};
var getBestFitUnitType = (typeA, typeB) => {
  if (typeA === typeB)
    return typeA;
  const category = getUnitCategory(typeA);
  if (category === getUnitCategory(typeB)) {
    if (category === "metric") {
      const metricIndexA = METRIC_UNITS_OF_LIQUID_VOLUME.indexOf(typeA);
      const metricIndexB = METRIC_UNITS_OF_LIQUID_VOLUME.indexOf(typeB);
      return metricIndexA < metricIndexB ? typeA : typeB;
    } else {
      const usIndexA = US_UNITS_OF_LIQUID_VOLUME.indexOf(typeA);
      const usIndexB = US_UNITS_OF_LIQUID_VOLUME.indexOf(typeB);
      return usIndexA < usIndexB ? typeA : typeB;
    }
  } else {
    return "ml" /* ML */;
  }
};
var getUnitCategory = (unit) => METRIC_UNITS_OF_LIQUID_VOLUME.includes(unit) ? "metric" : "us";

// src/state/register/actionHelpers.ts
var actionHelpers_exports = {};
__export(actionHelpers_exports, {
  checkAndSetTicketElementActiveCore: () => checkAndSetTicketElementActiveCore,
  checkElementExist: () => checkElementExist,
  checkForCoursesUpdate: () => checkForCoursesUpdate,
  checkOrderPermissions: () => checkOrderPermissions,
  generateCourseTimesObject: () => generateCourseTimesObject,
  getOrderAdditionalData: () => getOrderAdditionalData,
  getValidationForCurrentOrder: () => getValidationForCurrentOrder,
  validateElementIsAppliedToSpecial: () => validateElementIsAppliedToSpecial,
  validateGeneralSeatingMode: () => validateGeneralSeatingMode,
  validateSeatingMode: () => validateSeatingMode,
  validateTicketElementIsEnabled: () => validateTicketElementIsEnabled
});

// src/helpers/register/orders.ts
var isOrderClosedOrPaid = (orderStatus) => {
  return isOrderStatusClosed(orderStatus) || orderStatus === "other-voided" /* OTHER_VOIDED */ || orderStatus === "tip-pending" /* TIP_PENDING */;
};
var isOrderClosedOrVoided = (orderStatus) => {
  return isOrderStatusClosed(orderStatus) || orderStatus === "other-voided" /* OTHER_VOIDED */;
};
var ORDER_CLOSED_STATUS = [
  "closed-complete" /* CLOSED_COMPLETE */,
  "closed-batch pending" /* CLOSED_BATCH_PENDING */
];
var isOrderStatusClosed = (orderStatus) => {
  return ORDER_CLOSED_STATUS.includes(orderStatus);
};
var ORDER_NOT_AVAILABLE_TO_ENTER = [
  ...ORDER_CLOSED_STATUS,
  "other-voided" /* OTHER_VOIDED */,
  "failed" /* FAILED */
];
var isOrderNotAvailableToEnter = (orderStatus) => ORDER_NOT_AVAILABLE_TO_ENTER.includes(orderStatus);
var ORDER_OPEN_STATUS = [
  "open-initiated" /* OPEN_INITIATED */,
  "open-ordered" /* OPEN_ORDERED */
];
var getIsOrderOpen = (status) => {
  return ORDER_OPEN_STATUS.includes(status);
};
var calcNextMenuType = ({
  defaultMenuTypeTimes,
  timeZone
}) => {
  const dayKey = getDayKey(timeZone);
  if (!defaultMenuTypeTimes[dayKey])
    throw new Error("No menu for today");
  const defaultMenuTypeTimeList = [...defaultMenuTypeTimes[dayKey]];
  const formattedMenuTypeTimeList = defaultMenuTypeTimeList.map(
    (menuTypeTime) => {
      return __spreadValues({
        menuTypeId: menuTypeTime.menuTypeId,
        day: dayKey,
        startTime: menuTypeTime.startTime,
        endTime: menuTypeTime.endTime
      }, getMilitaryHourRange(
        menuTypeTime.startTime,
        menuTypeTime.endTime,
        timeZone
      ));
    }
  );
  if (formattedMenuTypeTimeList.length === 0)
    throw new Error("No menu times for today");
  const sortedList = formattedMenuTypeTimeList.sort(
    (a, b) => a.startTimeMilitary - b.startTimeMilitary
  );
  const todayUTC = DateTime.now().setZone(timeZone);
  const nowMilitaryFormat = getMilitaryHourLuxon(todayUTC);
  const nextMenuList = sortedList.filter(
    (menuTypeTime) => nowMilitaryFormat < menuTypeTime.endTimeMilitary
  );
  if (nextMenuList.length === 0)
    throw new Error("No menu times left");
  const [currentMenuTypeTime, nextMenuTypeTime] = nextMenuList;
  let diff11 = null;
  if (nextMenuTypeTime) {
    const current = DateTime.fromObject(todayUTC.toObject()).setZone(timeZone);
    const temporalDate = current.set(
      getHourAndMinutesAndSecondsCore(
        nextMenuTypeTime.startTime,
        timeZone,
        true
      )
    );
    diff11 = temporalDate.diff(todayUTC);
  } else {
    const current = DateTime.fromObject(todayUTC.toObject()).setZone(timeZone);
    const temporalDate = current.set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0
    });
    const midnight = temporalDate.plus({ day: 1 });
    diff11 = midnight.diff(todayUTC);
  }
  if (diff11.milliseconds < 0)
    throw new Error("Error in range time");
  return {
    menuTypeId: currentMenuTypeTime.menuTypeId,
    nextCheckInMilliseconds: diff11.milliseconds
  };
};
var getOverrideMenuType = (getState) => {
  const overrideDefaultMenuTypeId = selectOverrideDefaultMenuTypeId(getState());
  const menuTypeOptionList = selectMenuTypeDropdownList(getState());
  const menuIsAvailable = menuTypeOptionList.find(
    ({ value }) => value === overrideDefaultMenuTypeId
  );
  if (!menuIsAvailable)
    throw new Error("MenuTypeId not found in current list");
  return overrideDefaultMenuTypeId;
};
var getReducedOrderObject = (order) => {
  return {
    id: order.id,
    orderNumber: order.orderNumber,
    status: order.status,
    type: order.type,
    createdAt: order.createdAt,
    updatedAt: order.updatedAt,
    ownerId: order.ownerId,
    description: order.description,
    hasUnsentItems: order.hasUnsentItems,
    name: order.name,
    tableId: order.tableId,
    serviceAreaId: order.serviceAreaId,
    printerError: order.printerError,
    tabletGeneratedId: order.tabletGeneratedId,
    total: order.total,
    searchStrength: order.searchStrength
  };
};

// src/state/app/actions.ts
var actions_exports14 = {};
__export(actions_exports14, {
  addPrintingErrorsToOrder: () => addPrintingErrorsToOrder,
  clearLockScreenBanner: () => clearLockScreenBanner,
  handleConnectivityChange: () => handleConnectivityChange,
  hideRefreshToast: () => hideRefreshToast,
  hideToast: () => hideToast,
  removeMasterData: () => removeMasterData,
  removeToastElement: () => removeToastElement,
  resetGlobalState: () => resetGlobalState,
  sendCustomErrorToBackendLog: () => sendCustomErrorToBackendLog,
  setInitializeAppOnLockScreen: () => setInitializeAppOnLockScreen,
  setIsClockInSuggestionModalOpen: () => setIsClockInSuggestionModalOpen,
  setIsLoading: () => setIsLoading,
  setIsLoadingModal: () => setIsLoadingModal,
  setIsLoadingMore: () => setIsLoadingMore,
  setIsWSActive: () => setIsWSActive,
  setLatestPaymentInformation: () => setLatestPaymentInformation,
  setLockScreenBanner: () => setLockScreenBanner,
  setMasterLocation: () => setMasterLocation,
  setMessageId: () => setMessageId,
  setNetworkStatus: () => setNetworkStatus,
  setPullingData: () => setPullingData,
  setSelectedNetwork: () => setSelectedNetwork,
  setShowConfirmationModal: () => setShowConfirmationModal,
  setShowRefreshToast: () => setShowRefreshToast,
  setShowSettingsRefreshToast: () => setShowSettingsRefreshToast,
  setShowToast: () => setShowToast,
  setToken: () => setToken,
  showLockScreenBanner: () => showLockScreenBanner,
  showToast: () => showToast,
  updateKeyboard: () => updateKeyboard,
  updateLicensesAndDevices: () => updateLicensesAndDevices,
  updatePopover: () => updatePopover
});

// src/state/menu/actions.ts
var actions_exports16 = {};
__export(actions_exports16, {
  activatePreviewEditing: () => activatePreviewEditing,
  addBreadCrumbLocation: () => addBreadCrumbLocation,
  addHotButtonsPage: () => addHotButtonsPage,
  addNewItemGroup: () => addNewItemGroup,
  addNewMenuTypesToItem: () => addNewMenuTypesToItem,
  addNewMenuTypesToSpecial: () => addNewMenuTypesToSpecial,
  addPricingVersionForModifierGroup: () => addPricingVersionForModifierGroup,
  addPricingVersionForModifierItem: () => addPricingVersionForModifierItem,
  assignItemsToLocation: () => assignItemsToLocation,
  associateHotButton: () => associateHotButton,
  associateItemToItemGroup: () => associateItemToItemGroup,
  associateModifierItemToModifierGroup: () => associateModifierItemToModifierGroup,
  breadCrumbPopNavigation: () => breadCrumbPopNavigation,
  cancelChangesOnCancelPress: () => cancelChangesOnCancelPress,
  cancelFreshSheetChangesOnCancelPress: () => cancelFreshSheetChangesOnCancelPress,
  changePricingVersion: () => changePricingVersion,
  changeSelectedMode: () => changeSelectedMode,
  checkBreadCrumbLocation: () => checkBreadCrumbLocation,
  checkBucketValidation: () => checkBucketValidation,
  checkCategoryFormValidation: () => checkCategoryFormValidation,
  checkComboFormValidation: () => checkComboFormValidation,
  checkDiscountFormValidation: () => checkDiscountFormValidation,
  checkForChangesAndNavigate: () => checkForChangesAndNavigate,
  checkForForbiddenBucket: () => checkForForbiddenBucket,
  checkForFreshSheetChangesAndNavigate: () => checkForFreshSheetChangesAndNavigate,
  checkForItemInLocationAndContinue: () => checkForItemInLocationAndContinue,
  checkForMassUpdateChangesAndNavigate: () => checkForMassUpdateChangesAndNavigate,
  checkForPreviewChanges: () => checkForPreviewChanges,
  checkIngredientFormValidation: () => checkIngredientFormValidation,
  checkItemFormValidation: () => checkItemFormValidation,
  checkItemGroupFormValidation: () => checkItemGroupFormValidation,
  checkMassUpdateFormValidation: () => checkMassUpdateFormValidation,
  checkMenuTypeFormValidation: () => checkMenuTypeFormValidation,
  checkModifierGroupFormValidation: () => checkModifierGroupFormValidation,
  checkModifierItemFormValidation: () => checkModifierItemFormValidation,
  checkReportingGroupFormValidation: () => checkReportingGroupFormValidation,
  checkSpecialFormValidation: () => checkSpecialFormValidation,
  checkSubcategoryFormValidation: () => checkSubcategoryFormValidation,
  clearError: () => clearError,
  createBucketElement: () => createBucketElement,
  deleteBucketElement: () => deleteBucketElement,
  deleteBucketItems: () => deleteBucketItems,
  deleteItemGroupFromCombo: () => deleteItemGroupFromCombo,
  deleteModifierGroupFromItem: () => deleteModifierGroupFromItem,
  deleteModifierGroupFromModifierItem: () => deleteModifierGroupFromModifierItem,
  getCurrentEditingElement: () => getCurrentEditingElement,
  getCurrentModifierGroup: () => getCurrentModifierGroup,
  getDataFromChangeData: () => getDataFromChangeData,
  getItemPriceListByIdAndMenuTypeId: () => getItemPriceListByIdAndMenuTypeId,
  getLocationsToApply: () => getLocationsToApply,
  getMasterMenu: () => getMasterMenu,
  getMenuVersion: () => getMenuVersion,
  getModifierItemsCurrentItem: () => getModifierItemsCurrentItem,
  getRemoteLocationMenu: () => getRemoteLocationMenu,
  handleDeleteModifierGroup: () => handleDeleteModifierGroup,
  handleDeleteModifierGroupFromModifierItem: () => handleDeleteModifierGroupFromModifierItem,
  handleHideModifierGroup: () => handleHideModifierGroup,
  handleHideModifierGroupFromModifierItem: () => handleHideModifierGroupFromModifierItem,
  hideModifierGroup: () => hideModifierGroup,
  hideModifierGroupFromModifierItem: () => hideModifierGroupFromModifierItem,
  itemMassUpdateConfirmation: () => itemMassUpdateConfirmation,
  itemMassUpdateEndpoint: () => itemMassUpdateEndpoint,
  massPriceUpdate: () => massPriceUpdate,
  menuBucketValidationThunks: () => menuBucketValidationThunks,
  rearrangeItemGroups: () => rearrangeItemGroups,
  rearrangeItemGroupsToLastOrFirst: () => rearrangeItemGroupsToLastOrFirst,
  rearrangeModifierGroups: () => rearrangeModifierGroups,
  rearrangeModifierGroupsToLastOrFirst: () => rearrangeModifierGroupsToLastOrFirst,
  removeHotButton: () => removeHotButton,
  removeItemFromItemGroup: () => removeItemFromItemGroup,
  removeMenuTypeFromItem: () => removeMenuTypeFromItem,
  removeModifierItemFromModifierGroup: () => removeModifierItemFromModifierGroup,
  removePricingVersionFromModifierGroup: () => removePricingVersionFromModifierGroup,
  removePricingVersionFromModifierItem: () => removePricingVersionFromModifierItem,
  resetChangeData: () => resetChangeData,
  resetChangeFreshSheetData: () => resetChangeFreshSheetData,
  resetChangeMassUpdateData: () => resetChangeMassUpdateData,
  resetFreshSheetToOriginal: () => resetFreshSheetToOriginal,
  resetLastPreviewOrder: () => resetLastPreviewOrder,
  resetLocalItemStock: () => resetLocalItemStock,
  resetMassUpdateMenuChanges: () => resetMassUpdateMenuChanges,
  resetMenuChanges: () => resetMenuChanges,
  saveChangesOnSavePress: () => saveChangesOnSavePress,
  setBreadCrumb: () => setBreadCrumb,
  setBreadCrumbIndexData: () => setBreadCrumbIndexData,
  setBreadCrumbLocation: () => setBreadCrumbLocation,
  setBreadCrumbStatusPath: () => setBreadCrumbStatusPath,
  setChangeData: () => setChangeData,
  setChangeDataModifierGroupsValues: () => setChangeDataModifierGroupsValues,
  setChangeDataValues: () => setChangeDataValues,
  setChangeFreshSheetData: () => setChangeFreshSheetData,
  setChangeFreshSheetDataValues: () => setChangeFreshSheetDataValues,
  setChangeMassUpdateData: () => setChangeMassUpdateData,
  setDefaultData: () => setDefaultData,
  setDefaultFreshSheetData: () => setDefaultFreshSheetData,
  setDiffObject: () => setDiffObject,
  setDifferences: () => setDifferences,
  setErrors: () => setErrors,
  setFreshSheetDataFromMenu: () => setFreshSheetDataFromMenu,
  setItem68Thunk: () => setItem68Thunk,
  setLastPreviewArrangement: () => setLastPreviewArrangement,
  setLastPreviewOrder: () => setLastPreviewOrder,
  setLocalIngredient86: () => setLocalIngredient86,
  setLocalItem86: () => setLocalItem86,
  setLocalModifierItem86: () => setLocalModifierItem86,
  setLocationMenu: () => setLocationMenu,
  setMassUpdateErrors: () => setMassUpdateErrors,
  setMassUpdateSelectedLocations: () => setMassUpdateSelectedLocations,
  setMasterMenu: () => setMasterMenu,
  setMenuPreviewAction: () => setMenuPreviewAction,
  setMenuVersions: () => setMenuVersions,
  setPreviewElements: () => setPreviewElements,
  setRemoteLocationMenu: () => setRemoteLocationMenu,
  setSelectedLocations: () => setSelectedLocations,
  setSelectedMenuMode: () => setSelectedMenuMode,
  show86ModifierItemOrIngredientModal: () => show86ModifierItemOrIngredientModal,
  showForbiddenChangeLocationToast: () => showForbiddenChangeLocationToast,
  showModifierItem86ConfirmationModal: () => showModifierItem86ConfirmationModal,
  sortHotButtonsPage: () => sortHotButtonsPage,
  updateCategory: () => updateCategory,
  updateChangeDataValues: () => updateChangeDataValues,
  updateChangeFreshSheetDataValues: () => updateChangeFreshSheetDataValues,
  updateChangeMassUpdateDataValues: () => updateChangeMassUpdateDataValues,
  updateCombo: () => updateCombo,
  updateCurrentMenu: () => updateCurrentMenu,
  updateEntityInventoryWS: () => updateEntityInventoryWS,
  updateFinalDiffObject: () => updateFinalDiffObject,
  updateFreshSheet: () => updateFreshSheet,
  updateFreshSheetEndpoint: () => updateFreshSheetEndpoint,
  updateInventory: () => updateInventory,
  updateItem: () => updateItem,
  updateItemGroup: () => updateItemGroup,
  updateItemInventory: () => updateItemInventory,
  updateLastItemsOfItemGroupOrder: () => updateLastItemsOfItemGroupOrder,
  updateLastModifierItemsOrder: () => updateLastModifierItemsOrder,
  updateLastPreviewOrder: () => updateLastPreviewOrder,
  updateLocalItemShowStockOnItemCard: () => updateLocalItemShowStockOnItemCard,
  updateLocalItemStock: () => updateLocalItemStock,
  updateMassUpdateFinalDiffObject: () => updateMassUpdateFinalDiffObject,
  updateMenuBucket: () => updateMenuBucket,
  updateMenuChangeData: () => updateMenuChangeData,
  updateMenuOnSocket: () => updateMenuOnSocket,
  updateMenuType: () => updateMenuType,
  updateModPrice: () => updateModPrice,
  updateModifierGroup: () => updateModifierGroup,
  updateModifierItem: () => updateModifierItem,
  updateModifierItemModifierGroups: () => updateModifierItemModifierGroups,
  updatePreviewElements: () => updatePreviewElements,
  updateSelectionPriceForModifierItemsOfModifierGroup: () => updateSelectionPriceForModifierItemsOfModifierGroup,
  updateSpecial: () => updateSpecial,
  updateSubcategory: () => updateSubcategory
});
var baseUrl = "https://api-prod.tableturnapp.com/api";
var apiCall = (_0, _1, _2, ..._3) => __async(void 0, [_0, _1, _2, ..._3], function* (method, endpoint, withAuth, data = {}, licenseId, errorCodesDispatcher, dispatch, state, extraHeaders, reportError = () => true, abortController, responseType = "json") {
  var _a, _b, _c, _d, _e, _f, _g;
  const authToken = state.app.token;
  const preconfig = {
    method,
    url: withAuth ? `${baseUrl}/s${endpoint}` : `${baseUrl}${endpoint}`,
    data,
    signal: abortController == null ? void 0 : abortController.signal,
    responseType,
    params: method === "get" /* Get */ ? data : void 0
  };
  let config = {};
  if (withAuth) {
    config = __spreadProps(__spreadValues({}, preconfig), {
      headers: __spreadValues(__spreadValues({
        Authorization: `Bearer ${authToken}`
      }, licenseId ? { licenseId } : {}), extraHeaders)
    });
  } else {
    config = preconfig;
  }
  try {
    const response = yield axios(config);
    if (responseType === "blob" || responseType === "arraybuffer")
      return response;
    return response.data;
  } catch (e) {
    const error = e;
    const typedDispatch = dispatch;
    errorCodesDispatcher(error);
    if (axios.isCancel(e))
      return;
    reportError(error) && typedDispatch(
      showToast({
        type: "error",
        title: `Error${typeof ((_a = error.response) == null ? void 0 : _a.data) === "string" ? " : " + ((_b = error.response) == null ? void 0 : _b.data) : ""}`,
        description: typeof ((_c = error.response) == null ? void 0 : _c.data) === "string" ? (_d = error.response) == null ? void 0 : _d.data : ((_g = (_f = (_e = error.response) == null ? void 0 : _e.data) == null ? void 0 : _f.error) == null ? void 0 : _g.message) || ""
      })
    );
    throw e;
  }
});
var SORT_PRIORITY_FIELD = "sortPriority";
var IS_ALL_MOD_FIELD = "isAllMod";
var IGNORED_MASTER_FIELDS = [
  "locationIds",
  "linkedModifierItems",
  "reportingGroupIds"
];
var MasterFieldLabels = /* @__PURE__ */ ((MasterFieldLabels2) => {
  MasterFieldLabels2["name"] = "Name";
  MasterFieldLabels2["customId"] = "Custom ID";
  MasterFieldLabels2["locationIds"] = "Locations";
  MasterFieldLabels2["linkedModifierItems"] = "Linked Modifier Items";
  MasterFieldLabels2["reportingGroupIds"] = "Reporting Groups";
  return MasterFieldLabels2;
})(MasterFieldLabels || {});
var ItemAssociationsSectionFieldLabels = /* @__PURE__ */ ((ItemAssociationsSectionFieldLabels2) => {
  ItemAssociationsSectionFieldLabels2[ItemAssociationsSectionFieldLabels2["categoryId"] = 0] = "categoryId";
  ItemAssociationsSectionFieldLabels2[ItemAssociationsSectionFieldLabels2["subcategoryId"] = 1] = "subcategoryId";
  return ItemAssociationsSectionFieldLabels2;
})(ItemAssociationsSectionFieldLabels || {});
var ItemBasicSectionFieldLabels = /* @__PURE__ */ ((ItemBasicSectionFieldLabels2) => {
  ItemBasicSectionFieldLabels2[ItemBasicSectionFieldLabels2["posName"] = 0] = "posName";
  ItemBasicSectionFieldLabels2[ItemBasicSectionFieldLabels2["kdsName"] = 1] = "kdsName";
  ItemBasicSectionFieldLabels2[ItemBasicSectionFieldLabels2["checkName"] = 2] = "checkName";
  ItemBasicSectionFieldLabels2[ItemBasicSectionFieldLabels2["onlineName"] = 3] = "onlineName";
  ItemBasicSectionFieldLabels2[ItemBasicSectionFieldLabels2["courseId"] = 4] = "courseId";
  ItemBasicSectionFieldLabels2[ItemBasicSectionFieldLabels2["allowSharing"] = 5] = "allowSharing";
  ItemBasicSectionFieldLabels2[ItemBasicSectionFieldLabels2["active"] = 6] = "active";
  ItemBasicSectionFieldLabels2[ItemBasicSectionFieldLabels2["activeOnline"] = 7] = "activeOnline";
  ItemBasicSectionFieldLabels2[ItemBasicSectionFieldLabels2["calories"] = 8] = "calories";
  ItemBasicSectionFieldLabels2[ItemBasicSectionFieldLabels2["prepTime"] = 9] = "prepTime";
  ItemBasicSectionFieldLabels2[ItemBasicSectionFieldLabels2["ageRestricted"] = 10] = "ageRestricted";
  ItemBasicSectionFieldLabels2[ItemBasicSectionFieldLabels2["ageThreshold"] = 11] = "ageThreshold";
  ItemBasicSectionFieldLabels2[ItemBasicSectionFieldLabels2["delivery"] = 12] = "delivery";
  ItemBasicSectionFieldLabels2[ItemBasicSectionFieldLabels2["imageUrl"] = 13] = "imageUrl";
  ItemBasicSectionFieldLabels2[ItemBasicSectionFieldLabels2["secondaryImageUrl"] = 14] = "secondaryImageUrl";
  ItemBasicSectionFieldLabels2[ItemBasicSectionFieldLabels2["defaultNoSeat"] = 15] = "defaultNoSeat";
  return ItemBasicSectionFieldLabels2;
})(ItemBasicSectionFieldLabels || {});
var ItemRegisterSectionFieldLabels = /* @__PURE__ */ ((ItemRegisterSectionFieldLabels2) => {
  ItemRegisterSectionFieldLabels2[ItemRegisterSectionFieldLabels2["customizer"] = 0] = "customizer";
  ItemRegisterSectionFieldLabels2[ItemRegisterSectionFieldLabels2["customizerShape"] = 1] = "customizerShape";
  ItemRegisterSectionFieldLabels2[ItemRegisterSectionFieldLabels2["backgroundColor"] = 2] = "backgroundColor";
  ItemRegisterSectionFieldLabels2[ItemRegisterSectionFieldLabels2["textColor"] = 3] = "textColor";
  ItemRegisterSectionFieldLabels2[ItemRegisterSectionFieldLabels2["kdsColor"] = 4] = "kdsColor";
  ItemRegisterSectionFieldLabels2[ItemRegisterSectionFieldLabels2["specialTagId"] = 5] = "specialTagId";
  ItemRegisterSectionFieldLabels2[ItemRegisterSectionFieldLabels2["displayPictureOnCard"] = 6] = "displayPictureOnCard";
  ItemRegisterSectionFieldLabels2[ItemRegisterSectionFieldLabels2["enterItemDetails"] = 7] = "enterItemDetails";
  ItemRegisterSectionFieldLabels2[ItemRegisterSectionFieldLabels2["exitItemDetailsOnRequiredModCompletion"] = 8] = "exitItemDetailsOnRequiredModCompletion";
  ItemRegisterSectionFieldLabels2[ItemRegisterSectionFieldLabels2["displayItemPriceOnRegister"] = 9] = "displayItemPriceOnRegister";
  ItemRegisterSectionFieldLabels2[ItemRegisterSectionFieldLabels2["transparentBackground"] = 10] = "transparentBackground";
  ItemRegisterSectionFieldLabels2[ItemRegisterSectionFieldLabels2["hideItemName"] = 11] = "hideItemName";
  ItemRegisterSectionFieldLabels2[ItemRegisterSectionFieldLabels2["doneIsForTable"] = 12] = "doneIsForTable";
  return ItemRegisterSectionFieldLabels2;
})(ItemRegisterSectionFieldLabels || {});
var ItemMoreInformationFieldLabels = /* @__PURE__ */ ((ItemMoreInformationFieldLabels2) => {
  ItemMoreInformationFieldLabels2[ItemMoreInformationFieldLabels2["description"] = 0] = "description";
  ItemMoreInformationFieldLabels2[ItemMoreInformationFieldLabels2["onlineDescription"] = 1] = "onlineDescription";
  ItemMoreInformationFieldLabels2[ItemMoreInformationFieldLabels2["recipe"] = 2] = "recipe";
  return ItemMoreInformationFieldLabels2;
})(ItemMoreInformationFieldLabels || {});
var ItemPricingFieldLabels = /* @__PURE__ */ ((ItemPricingFieldLabels2) => {
  ItemPricingFieldLabels2[ItemPricingFieldLabels2["itemPrice"] = 0] = "itemPrice";
  ItemPricingFieldLabels2[ItemPricingFieldLabels2["taxInclusive"] = 1] = "taxInclusive";
  ItemPricingFieldLabels2[ItemPricingFieldLabels2["onlinePrice"] = 2] = "onlinePrice";
  ItemPricingFieldLabels2[ItemPricingFieldLabels2["deliveryPrice"] = 3] = "deliveryPrice";
  ItemPricingFieldLabels2[ItemPricingFieldLabels2["toGoPrice"] = 4] = "toGoPrice";
  ItemPricingFieldLabels2[ItemPricingFieldLabels2["excludeFromSuggestedTip"] = 5] = "excludeFromSuggestedTip";
  ItemPricingFieldLabels2[ItemPricingFieldLabels2["defaultModifiersPrice"] = 6] = "defaultModifiersPrice";
  ItemPricingFieldLabels2[ItemPricingFieldLabels2["excludeFromDiscounts"] = 7] = "excludeFromDiscounts";
  ItemPricingFieldLabels2[ItemPricingFieldLabels2["removeFromCheck"] = 8] = "removeFromCheck";
  ItemPricingFieldLabels2[ItemPricingFieldLabels2["promptForPrice"] = 9] = "promptForPrice";
  ItemPricingFieldLabels2[ItemPricingFieldLabels2["taxExempt"] = 10] = "taxExempt";
  return ItemPricingFieldLabels2;
})(ItemPricingFieldLabels || {});
var ItemDimensionsFieldLabels = /* @__PURE__ */ ((ItemDimensionsFieldLabels2) => {
  ItemDimensionsFieldLabels2[ItemDimensionsFieldLabels2["dimensionsSellBy"] = 0] = "dimensionsSellBy";
  ItemDimensionsFieldLabels2[ItemDimensionsFieldLabels2["dimensionsVolumePerUnit"] = 1] = "dimensionsVolumePerUnit";
  ItemDimensionsFieldLabels2[ItemDimensionsFieldLabels2["dimensionsWeightPerUnit"] = 2] = "dimensionsWeightPerUnit";
  ItemDimensionsFieldLabels2[ItemDimensionsFieldLabels2["dimensionsVolumeUnit"] = 3] = "dimensionsVolumeUnit";
  ItemDimensionsFieldLabels2[ItemDimensionsFieldLabels2["dimensionsWeightUnit"] = 4] = "dimensionsWeightUnit";
  return ItemDimensionsFieldLabels2;
})(ItemDimensionsFieldLabels || {});
var ItemSuggestiveOrderingLabels = /* @__PURE__ */ ((ItemSuggestiveOrderingLabels2) => {
  ItemSuggestiveOrderingLabels2[ItemSuggestiveOrderingLabels2["suggestiveOrdering"] = 0] = "suggestiveOrdering";
  ItemSuggestiveOrderingLabels2[ItemSuggestiveOrderingLabels2["suggestiveOrderingItemPrice"] = 1] = "suggestiveOrderingItemPrice";
  ItemSuggestiveOrderingLabels2[ItemSuggestiveOrderingLabels2["suggestiveOrderingPrompt"] = 2] = "suggestiveOrderingPrompt";
  ItemSuggestiveOrderingLabels2[ItemSuggestiveOrderingLabels2["suggestiveOrderingItemId"] = 3] = "suggestiveOrderingItemId";
  return ItemSuggestiveOrderingLabels2;
})(ItemSuggestiveOrderingLabels || {});
var ItemModifierGroupsExtraLabels = /* @__PURE__ */ ((ItemModifierGroupsExtraLabels2) => {
  ItemModifierGroupsExtraLabels2[ItemModifierGroupsExtraLabels2["showAllMods"] = 0] = "showAllMods";
  ItemModifierGroupsExtraLabels2[ItemModifierGroupsExtraLabels2["allModsBehavior"] = 1] = "allModsBehavior";
  ItemModifierGroupsExtraLabels2[ItemModifierGroupsExtraLabels2["showAllModsAlphabetizeButtons"] = 2] = "showAllModsAlphabetizeButtons";
  ItemModifierGroupsExtraLabels2[ItemModifierGroupsExtraLabels2["showAllModsHalfSizeButtons"] = 3] = "showAllModsHalfSizeButtons";
  return ItemModifierGroupsExtraLabels2;
})(ItemModifierGroupsExtraLabels || {});
var ItemIngredientsExtraLabels = /* @__PURE__ */ ((ItemIngredientsExtraLabels2) => {
  ItemIngredientsExtraLabels2[ItemIngredientsExtraLabels2["showIngredients"] = 0] = "showIngredients";
  return ItemIngredientsExtraLabels2;
})(ItemIngredientsExtraLabels || {});
var ItemModifierGroupLabels = /* @__PURE__ */ ((ItemModifierGroupLabels2) => {
  ItemModifierGroupLabels2[ItemModifierGroupLabels2["active"] = 0] = "active";
  ItemModifierGroupLabels2[ItemModifierGroupLabels2["requiredModifierItems"] = 1] = "requiredModifierItems";
  ItemModifierGroupLabels2[ItemModifierGroupLabels2["includedModifierItems"] = 2] = "includedModifierItems";
  ItemModifierGroupLabels2[ItemModifierGroupLabels2["maximumModifierItems"] = 3] = "maximumModifierItems";
  ItemModifierGroupLabels2[ItemModifierGroupLabels2["defaultModifierGroupPricingVersionId"] = 4] = "defaultModifierGroupPricingVersionId";
  ItemModifierGroupLabels2[ItemModifierGroupLabels2["sortPriority"] = 5] = "sortPriority";
  ItemModifierGroupLabels2[ItemModifierGroupLabels2["isAllMod"] = 6] = "isAllMod";
  return ItemModifierGroupLabels2;
})(ItemModifierGroupLabels || {});
var ItemTaxLabels = /* @__PURE__ */ ((ItemTaxLabels2) => {
  ItemTaxLabels2[ItemTaxLabels2["isActive"] = 0] = "isActive";
  return ItemTaxLabels2;
})(ItemTaxLabels || {});
var ItemModifierItemLabels = /* @__PURE__ */ ((ItemModifierItemLabels2) => {
  ItemModifierItemLabels2[ItemModifierItemLabels2["defaultQuantitySelected"] = 0] = "defaultQuantitySelected";
  ItemModifierItemLabels2[ItemModifierItemLabels2["defaultAmountSelected"] = 1] = "defaultAmountSelected";
  ItemModifierItemLabels2[ItemModifierItemLabels2["isSelected"] = 2] = "isSelected";
  ItemModifierItemLabels2[ItemModifierItemLabels2["active"] = 3] = "active";
  ItemModifierItemLabels2[ItemModifierItemLabels2["includedMasterPrice"] = 4] = "includedMasterPrice";
  ItemModifierItemLabels2[ItemModifierItemLabels2["additionalMasterPrice"] = 5] = "additionalMasterPrice";
  ItemModifierItemLabels2[ItemModifierItemLabels2["includedLightPrice"] = 6] = "includedLightPrice";
  ItemModifierItemLabels2[ItemModifierItemLabels2["includedRegularPrice"] = 7] = "includedRegularPrice";
  ItemModifierItemLabels2[ItemModifierItemLabels2["includedExtraPrice"] = 8] = "includedExtraPrice";
  ItemModifierItemLabels2[ItemModifierItemLabels2["additionalLightPrice"] = 9] = "additionalLightPrice";
  ItemModifierItemLabels2[ItemModifierItemLabels2["additionalRegularPrice"] = 10] = "additionalRegularPrice";
  ItemModifierItemLabels2[ItemModifierItemLabels2["additionalExtraPrice"] = 11] = "additionalExtraPrice";
  ItemModifierItemLabels2[ItemModifierItemLabels2["maximumQuantity"] = 12] = "maximumQuantity";
  return ItemModifierItemLabels2;
})(ItemModifierItemLabels || {});
var ItemInventoryLabels = /* @__PURE__ */ ((ItemInventoryLabels2) => {
  ItemInventoryLabels2[ItemInventoryLabels2["initialAmount"] = 0] = "initialAmount";
  ItemInventoryLabels2[ItemInventoryLabels2["currentAmount"] = 1] = "currentAmount";
  ItemInventoryLabels2[ItemInventoryLabels2["resetStockDaily"] = 2] = "resetStockDaily";
  ItemInventoryLabels2[ItemInventoryLabels2["showOnFreshSheet"] = 3] = "showOnFreshSheet";
  ItemInventoryLabels2[ItemInventoryLabels2["noCurrentStock86Item"] = 4] = "noCurrentStock86Item";
  ItemInventoryLabels2[ItemInventoryLabels2["resetStockToInitialAtZero"] = 5] = "resetStockToInitialAtZero";
  ItemInventoryLabels2[ItemInventoryLabels2["is86ed"] = 6] = "is86ed";
  ItemInventoryLabels2[ItemInventoryLabels2["actionWhenCurrentStockZero"] = 7] = "actionWhenCurrentStockZero";
  ItemInventoryLabels2[ItemInventoryLabels2["trackInventory"] = 8] = "trackInventory";
  ItemInventoryLabels2[ItemInventoryLabels2["showQuantityOnItemCard"] = 9] = "showQuantityOnItemCard";
  ItemInventoryLabels2[ItemInventoryLabels2["volume"] = 10] = "volume";
  ItemInventoryLabels2[ItemInventoryLabels2["unit"] = 11] = "unit";
  ItemInventoryLabels2[ItemInventoryLabels2["universalProductCode"] = 12] = "universalProductCode";
  return ItemInventoryLabels2;
})(ItemInventoryLabels || {});
var ItemIngredientsFields = /* @__PURE__ */ ((ItemIngredientsFields2) => {
  ItemIngredientsFields2[ItemIngredientsFields2["sortPriority"] = 0] = "sortPriority";
  ItemIngredientsFields2[ItemIngredientsFields2["active"] = 1] = "active";
  ItemIngredientsFields2[ItemIngredientsFields2["name"] = 2] = "name";
  ItemIngredientsFields2[ItemIngredientsFields2["posName"] = 3] = "posName";
  ItemIngredientsFields2[ItemIngredientsFields2["isSelected"] = 4] = "isSelected";
  return ItemIngredientsFields2;
})(ItemIngredientsFields || {});
var ItemTaxFields = /* @__PURE__ */ ((ItemTaxFields2) => {
  ItemTaxFields2[ItemTaxFields2["isActive"] = 0] = "isActive";
  return ItemTaxFields2;
})(ItemTaxFields || {});
var ItemPrepStationsChangesLabels = /* @__PURE__ */ ((ItemPrepStationsChangesLabels2) => {
  ItemPrepStationsChangesLabels2[ItemPrepStationsChangesLabels2["showPrepStationSelectionModal"] = 0] = "showPrepStationSelectionModal";
  return ItemPrepStationsChangesLabels2;
})(ItemPrepStationsChangesLabels || {});
var ItemGuestCheckDisplayLabels = /* @__PURE__ */ ((ItemGuestCheckDisplayLabels2) => {
  ItemGuestCheckDisplayLabels2[ItemGuestCheckDisplayLabels2["showModifiers"] = 0] = "showModifiers";
  ItemGuestCheckDisplayLabels2[ItemGuestCheckDisplayLabels2["showModItemPrice"] = 1] = "showModItemPrice";
  return ItemGuestCheckDisplayLabels2;
})(ItemGuestCheckDisplayLabels || {});
var ItemLinkedModifierItemsFields = /* @__PURE__ */ ((ItemLinkedModifierItemsFields2) => {
  ItemLinkedModifierItemsFields2[ItemLinkedModifierItemsFields2["shareNames"] = 0] = "shareNames";
  ItemLinkedModifierItemsFields2[ItemLinkedModifierItemsFields2["sharePrice"] = 1] = "sharePrice";
  ItemLinkedModifierItemsFields2[ItemLinkedModifierItemsFields2["shareMods"] = 2] = "shareMods";
  return ItemLinkedModifierItemsFields2;
})(ItemLinkedModifierItemsFields || {});
var itemIgnoredFields = [
  "menuTypeItemId",
  "modifierGroupMenuTypeItemId",
  "modifierGroupPricingVersions",
  "modifierItemPricingVersionId",
  "id",
  "createdAt",
  "updatedAt",
  "deletedAt",
  "locationId",
  "modifierGroupId",
  "locationMenuTypeItemId",
  "menuTypeId",
  "ageThreshold",
  "locationModifierItemPricingVersionId",
  "locationModifierGroupPricingVersionId",
  "locationModifierGroupMenuTypeItemVersionId",
  "locationMgpvLocationMipvVersionId",
  "menuTypeItemId",
  "locationMenuTypeItemVersionId",
  "multiselect",
  "quantityMode",
  "override",
  "allowNoneSelection",
  "overrideId",
  "overrideVersionId",
  "locationModifierGroupMenuTypeItemId",
  "isDisabled"
];
var itemIgnoredModifierItemsFields = [
  "id",
  "createdAt",
  "updatedAt",
  "deletedAt",
  "locationId",
  "modifierItemId",
  "modifierItemPricingVersionId",
  "customIncludedQuantityPricing",
  "customAdditionalQuantityPricing",
  "sortPriority",
  "applyPiecePricing",
  "quarterPricePercent",
  "halfPricePercent",
  "locationModifierItemPricingVersionId",
  "locationModifierGroupPricingVersionId",
  "locationMgpvLocationMipvVersionId",
  "overrideId",
  "overrideVersionId",
  "locationModifierGroupMenuTypeItemId",
  "isDisabled",
  "override",
  "inheritedActive"
];
var itemIgnoredQuantityOffFields = [
  "includedLightPrice",
  "includedRegularPrice",
  "includedExtraPrice",
  "additionalLightPrice",
  "additionalRegularPrice",
  "additionalExtraPrice",
  "defaultQuantitySelected"
];
var itemIgnoredQuantityNumberFields = [
  "includedLightPrice",
  "includedRegularPrice",
  "includedExtraPrice",
  "additionalLightPrice",
  "additionalRegularPrice",
  "additionalExtraPrice"
];
var itemIgnoredQuantitySizeFields = [
  "includedMasterPrice",
  "additionalMasterPrice"
];
var MODIFIER_GROUPS = "modifierGroups";
var INGREDIENTS = "ingredients";
var CATEGORY_INHERITED_TAXES = "categoryInheritedTaxes";
var SUBCATEGORY_INHERITED_TAXES = "subcategoryInheritedTaxes";
var CATEGORIES_SUBCATEGORIES = "categoriesSubcategories";
var DEFAULT_SELECTION_PRICE = "defaultSelectionPrice";
var DEFAULT_MODIFIERS_PRICE = "defaultModifiersPrice";
var IS_SELECTED = "isSelected";
var ACTIVE = "active";
var DEFAULT_QUANTITY_SELECTED = "defaultQuantitySelected";
var DEFAULT_AMOUNT_SELECTED = "defaultAmountSelected";
var itemIgnoredItemPrices = [
  "itemPrice",
  "deliveryPrice",
  "onlinePrice",
  "toGoPrice"
];
var itemIgnoredPremadeModifierGroupFields = [
  "requiredModifierItems",
  "includedModifierItems"
];
var returnLabel = (field, depth) => {
  if (depth === 1) {
    if (field in MasterFieldLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.master.${field}`
      );
    }
  } else if (depth === 3) {
    if (field in ItemAssociationsSectionFieldLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.master.${field}`
      );
    } else if (field in ItemBasicSectionFieldLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.basic.${field}`
      );
    } else if (field in ItemRegisterSectionFieldLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.registerInfo.${field}`
      );
    } else if (field in ItemMoreInformationFieldLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.moreInfo.${field}`
      );
    } else if (field in ItemPricingFieldLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.pricing.${field}`
      );
    } else if (field in ItemDimensionsFieldLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.dimensions.${field}`
      );
    } else if (field in ItemSuggestiveOrderingLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.suggestiveOrdering.${field}`
      );
    } else if (field in ItemInventoryLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.inventory.${field}`
      );
    } else if (field in ItemModifierGroupsExtraLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.modifierGroupsExtra.${field}`
      );
    } else if (field in ItemIngredientsExtraLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.ingredientsExtra.${field}`
      );
    } else if (field in ItemPrepStationsChangesLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.prepStationsChanges.${field}`
      );
    } else if (field in ItemGuestCheckDisplayLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.guestCheckDisplay.${field}`
      );
    } else if (field in ItemLinkedModifierItemsFields) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.linkedModifierItems.${field}`
      );
    }
  } else if (depth === 5) {
    if (field in ItemModifierGroupLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.modifierGroup.${field}`
      );
    }
    if (field in ItemTaxLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.taxes.${field}`
      );
    }
  } else if (depth === 7) {
    if (field in ItemModifierItemLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.modifierItem.${field}`
      );
    }
  }
};
var getChangeWithTextValue = (state, itemData, value, field, menuTypeVersionId, isMassUpdate) => {
  const specialTags = specialTagsSelector(state);
  const courses = selectLocationCourses(state);
  const items = selectItems(state);
  let label;
  if (field === "ageRestricted") {
    const ageThreshold = itemData.menuTypeVersions[menuTypeVersionId].ageThreshold;
    return {
      field,
      label: i18n_config_default.t("app.modals.itemsDiff.basic.restrictions"),
      value: value || isMassUpdate ? isMassUpdate ? value : ageThreshold : 0,
      textValue: `${i18n_config_default.t(
        "app.modals.itemsDiff.basic.ageRestricted"
      )}: ${value ? isMassUpdate ? "Yes" : ageThreshold : "No"}`,
      menuTypeVersionId
    };
  } else if (field === "courseId") {
    const course = courses[Number(value)];
    return {
      field,
      label: returnLabel(field, 3),
      value: value ? Number(value) : null,
      textValue: value && Object.keys(courses).length > 0 ? [
        course.name,
        course.active ? "" : ` (${i18n_config_default.t("commonTexts.inactive")})`
      ].join("") : i18n_config_default.t("settingsModule.coursing.noCourse"),
      menuTypeVersionId
    };
  } else if (field === "customizerShape") {
    const textValue = value ? value === "square" ? i18n_config_default.t(
      "menuScreen.itemDetails.registerDisplay.registerDisplayOptions.customizerShape.options.square"
    ) : i18n_config_default.t(
      "menuScreen.itemDetails.registerDisplay.registerDisplayOptions.customizerShape.options.round"
    ) : "";
    return {
      field,
      label: returnLabel(field, 3),
      value: value != null ? value : "",
      textValue,
      menuTypeVersionId
    };
  } else if (field === "specialTagId") {
    const specialTag = specialTags[Number(value)];
    const textValue = value ? specialTag.abbreviation : "No Special Tag";
    return {
      field,
      label: returnLabel(field, 3),
      value,
      textValue,
      menuTypeVersionId
    };
  } else if (field === "actionWhenCurrentStockZero") {
    const textValue = i18n_config_default.t(
      `menuScreen.itemDetails.inventorySection.actionWhenCurrentStockZero.options.${!value ? "null" : value}`
    );
    return {
      field,
      label: returnLabel(field, 3),
      value,
      textValue,
      menuTypeVersionId
    };
  } else if (field === "suggestiveOrderingItemId") {
    const itemName = value ? items[Number(value)].name : i18n_config_default.t("commonTexts.none");
    return {
      field,
      label: returnLabel(field, 3),
      value,
      textValue: itemName,
      menuTypeVersionId
    };
  } else if (field === "suggestiveOrderingItemPrice") {
    return {
      field,
      label: value === null ? i18n_config_default.t(
        "menuScreen.itemDetails.suggestiveOrdering.allowSpecialPrice"
      ) : returnLabel(field, 3),
      value,
      textValue: value === null ? i18n_config_default.t("commonTexts.no") : value,
      menuTypeVersionId
    };
  } else {
    label = returnLabel(field, 3);
  }
  return {
    field,
    label,
    value,
    menuTypeVersionId
  };
};
var diffItemsFactory = (itemId, diffArray, itemData, state, isMassUpdate) => {
  if (diffArray.length > 0) {
    const currentMenu = selectMenu(state);
    const categories = selectCategories(state);
    const subCategories = selectSubcategories(state);
    const menuTypes = selectMenuTypes(state);
    const items = selectItems(state);
    const reportingGroups = selectReportingGroups(state);
    const originalItemData = itemId ? items[itemId] : MASS_UPDATE_INITIAL_STATE;
    const menuTypeVersionIds = [];
    diffArray.filter(
      (diff11) => diff11.path.length >= 2 && !IGNORED_MASTER_FIELDS.includes(diff11.path[0])
    ).map((diff11) => {
      const menuTypeVersionId = Number(diff11.path[1]);
      if (!menuTypeVersionIds.includes(menuTypeVersionId))
        menuTypeVersionIds.push(menuTypeVersionId);
    });
    const formattedMasterFieldsArray = diffArray.filter((diff11) => diff11.path.length === 1).map((diff11) => {
      var _a, _b, _c;
      if (!diff11.path)
        return { field: null };
      const field = diff11.path[((_a = diff11.path) == null ? void 0 : _a.length) - 1];
      let result = {
        field,
        label: (_b = returnLabel(field, 1)) != null ? _b : "",
        value: (_c = diff11.rhs) != null ? _c : ""
      };
      if (field === "categoryId") {
        result = __spreadProps(__spreadValues({}, result), {
          id: categories[Number(diff11.rhs)].categoryId,
          value: categories[Number(diff11.rhs)].name
        });
      } else if (field === "subcategoryId" && diff11.rhs) {
        result = __spreadProps(__spreadValues({}, result), {
          id: subCategories[Number(diff11.rhs)].subcategoryId,
          value: subCategories[Number(diff11.rhs)].name
        });
      } else if (field === "subcategoryId") {
        result = __spreadProps(__spreadValues({}, result), {
          id: null,
          value: ""
        });
      }
      return result;
    });
    const formattedDiffArray = diffArray.filter((diff11) => diff11.path.length === 3).map((diff11) => {
      if (!diff11.path)
        return { field: null };
      const field = diff11.path[2];
      const menuTypeVersionId = Number(diff11.path[1]);
      if (diff11.kind === "A") {
        return {
          field,
          label: returnLabel(field, 3),
          value: diff11.item,
          menuTypeVersionId
        };
      } else {
        const value = diff11.rhs;
        return getChangeWithTextValue(
          state,
          itemData,
          value,
          field,
          menuTypeVersionId,
          isMassUpdate
        );
      }
    });
    const masterChanges = formattedMasterFieldsArray.filter(
      (diff11) => !IGNORED_MASTER_FIELDS.includes(diff11.field)
    );
    const linkedModifierItemsChanges = getLinkedModifierItemsChanges(
      diffArray,
      state
    );
    if (linkedModifierItemsChanges.length > 0) {
      masterChanges.push({
        field: "linkedModifierItems",
        label: returnLabel("linkedModifierItems", 1),
        value: linkedModifierItemsChanges
      });
    }
    const reportingGroupIdsChanges = getArrayNumberChanges(
      originalItemData.reportingGroupIds,
      itemData.reportingGroupIds
    ).map((change) => {
      var _a;
      return __spreadProps(__spreadValues({}, change), { value: (_a = reportingGroups[change.id]) == null ? void 0 : _a.name });
    });
    if (reportingGroupIdsChanges.length > 0) {
      masterChanges.push({
        field: "reportingGroupIds",
        label: returnLabel("reportingGroupIds", 1),
        value: reportingGroupIdsChanges
      });
    }
    const {
      basicChanges,
      registerChanges,
      moreInfoChanges,
      pricingChanges,
      suggestiveOrderingChanges,
      inventoryChanges,
      modifierGroupsExtraChanges,
      prepStationChanges,
      ingredientsExtraChanges,
      guestCheckDisplayChanges,
      associationsChanges,
      dimensionsChanges
    } = filterChangesBySection(formattedDiffArray, state);
    const formattedMenuTypeVersions = menuTypeVersionIds.map((menuTypeVersionId) => {
      var _a, _b, _c;
      const originalPrepStations = "menuTypeVersions" in originalItemData ? ((_a = originalItemData.menuTypeVersions[Number(menuTypeVersionId)]) == null ? void 0 : _a.prepStationIds) || [] : [];
      const newPrepStations = ((_b = itemData.menuTypeVersions[Number(menuTypeVersionId)]) == null ? void 0 : _b.prepStationIds) || [];
      const removedPrepStationIds = ((_c = itemData.menuTypeVersions[Number(menuTypeVersionId)]) == null ? void 0 : _c.removePrepStationIds) || [];
      const hasPrepStationsChanges = diffArray.some(
        (diff11) => diff11.path[2] === "prepStationIds" && diff11.path[1] === menuTypeVersionId.toString()
      );
      const wasDeleted = diffArray.find(
        (diff11) => diff11.path.length === 2 && diff11.kind === "D" && diff11.path[1] === menuTypeVersionId.toString()
      );
      const wasAdded = diffArray.find(
        (diff11) => diff11.path.length === 2 && diff11.kind === "N" && diff11.path[1] === menuTypeVersionId.toString()
      );
      const prepStationValues = getPrepStationChanges(
        wasAdded ? true : hasPrepStationsChanges || removedPrepStationIds.length > 0,
        originalPrepStations,
        newPrepStations,
        state,
        removedPrepStationIds
      );
      if (wasDeleted) {
        return {
          label: menuTypes[Number(menuTypeVersionId)].name,
          id: menuTypeVersionId,
          action: "remove",
          totalOfChanges: 0,
          sections: {
            basic: [],
            register: [],
            pricing: [],
            dimensions: [],
            inventory: [],
            moreInfo: [],
            suggestiveOrdering: [],
            modifierGroups: [],
            modifierGroupsExtra: [],
            ingredientsExtra: [],
            ingredients: [],
            prepStations: [],
            prepStationsChanges: [],
            guestCheckDisplay: [],
            taxes: {},
            categoriesSubcategories: [],
            associations: [],
            reportingGroups: []
          }
        };
      } else if (wasAdded) {
        const newMenuTypeVersion = wasAdded.rhs;
        const formattedNewFieldsArray = Object.entries(
          newMenuTypeVersion
        ).filter(
          ([field, value]) => !itemIgnoredFields.includes(field) && value !== ""
        ).map(([field, value]) => {
          return getChangeWithTextValue(
            state,
            itemData,
            value,
            field,
            menuTypeVersionId,
            isMassUpdate
          );
        });
        const newModifierGroups = Object.values(
          newMenuTypeVersion.modifierGroups
        ).map((modifierGroup) => {
          return formatNewModifierGroup(
            modifierGroup,
            menuTypeVersionId,
            state
          );
        });
        const newIngredients = Object.values(
          newMenuTypeVersion.ingredients
        ).map((ingredient) => {
          return formatNewIngredient(ingredient, menuTypeVersionId, state);
        });
        const {
          basicChanges: basic,
          registerChanges: register,
          moreInfoChanges: moreInfo,
          pricingChanges: pricing,
          dimensionsChanges: dimensions,
          suggestiveOrderingChanges: suggestiveOrdering,
          inventoryChanges: inventory,
          modifierGroupsExtraChanges: modifierGroupsExtra,
          ingredientsExtraChanges: ingredientsExtra,
          prepStationChanges: _prepStationChanges,
          guestCheckDisplayChanges: _guestCheckDisplayChanges,
          associationsChanges: _associationsChanges
        } = filterChangesBySection(formattedNewFieldsArray, state);
        const categoriesSubcategoriesChanges = generateCategoriesAndSubcategoriesChanges(
          diffArray,
          currentMenu,
          menuTypeVersionId.toString(),
          state
        );
        const hasDefaultModifiersPrice = pricing.filter(
          (pricingChange) => pricingChange.menuTypeVersionId === menuTypeVersionId
        ).find(
          (pricingChange) => pricingChange.field === DEFAULT_MODIFIERS_PRICE
        );
        let totalPrices = [];
        if (pricing.length > 0) {
          if (hasDefaultModifiersPrice) {
            totalPrices = getTotalPrices(
              Number(hasDefaultModifiersPrice.value),
              true,
              itemData.menuTypeVersions[menuTypeVersionId]
            );
          } else {
            const hasPriceFields = pricing.filter(
              (change) => itemIgnoredItemPrices.includes(change.field)
            ).length > 0;
            totalPrices = hasPriceFields ? getTotalPrices(
              0,
              false,
              itemData.menuTypeVersions[menuTypeVersionId]
            ) : [];
          }
        }
        return {
          label: menuTypes[Number(menuTypeVersionId)].name,
          id: menuTypeVersionId,
          action: "add",
          totalOfChanges: 0,
          sections: {
            basic,
            register,
            inventory,
            pricing: [...pricing, ...totalPrices],
            dimensions,
            moreInfo,
            suggestiveOrdering,
            modifierGroups: newModifierGroups,
            ingredients: newIngredients,
            modifierGroupsExtra,
            ingredientsExtra,
            prepStations: prepStationValues,
            prepStationsChanges: _prepStationChanges,
            guestCheckDisplay: _guestCheckDisplayChanges,
            associations: _associationsChanges,
            taxes: formatItemNewTaxes(
              newMenuTypeVersion.inheritedTaxes,
              newMenuTypeVersion.taxIds,
              state
            ),
            categoriesSubcategories: categoriesSubcategoriesChanges,
            reportingGroups: []
          }
        };
      } else {
        const totalOfChanges = (
          //TODO: CHECK THIS LOGIC
          diffArray.filter((change) => {
            const isIngredient = change.path.length >= 2 && change.path.length <= 5 && change.path[2] === "ingredients";
            return change.path[1] === menuTypeVersionId.toString() && change.path[2] !== DEFAULT_MODIFIERS_PRICE && change.path[2] !== "prepStationIds" && !isIngredient || isIngredient && change.path.length === 4 && ["N", "D"].includes(change.kind) || isIngredient && change.path.length === 5 && change.path[4] in ItemIngredientsFields;
          }).length + prepStationValues.length
        );
        const modifierGroupsChanges = generateModifierGroupsChanges(
          diffArray,
          currentMenu,
          menuTypeVersionId.toString(),
          state
        );
        const taxesChanges = generateTaxesChanges(
          diffArray,
          menuTypeVersionId.toString(),
          state
        );
        const reportingGroupsChanges = generateMassUpdateReportingGroupsChanges(
          diffArray,
          menuTypeVersionId.toString(),
          state
        );
        const ingredientsChanges = generateIngredientsChanges(
          diffArray,
          currentMenu,
          menuTypeVersionId.toString(),
          state
        );
        const categoriesSubcategoriesChanges = generateCategoriesAndSubcategoriesChanges(
          diffArray,
          currentMenu,
          menuTypeVersionId.toString(),
          state
        );
        const pricing = pricingChanges.filter(
          (pricingChange) => pricingChange.menuTypeVersionId === menuTypeVersionId
        );
        const hasDefaultModifiersPrice = pricing.find(
          (pricingChange) => pricingChange.field === DEFAULT_MODIFIERS_PRICE
        );
        let totalPrices = [];
        if (pricingChanges.length > 0) {
          if (hasDefaultModifiersPrice) {
            totalPrices = getTotalPrices(
              Number(hasDefaultModifiersPrice.value),
              true,
              itemData.menuTypeVersions[menuTypeVersionId]
            );
          } else {
            const hasPriceFields = pricing.filter(
              (change) => itemIgnoredItemPrices.includes(change.field)
            ).length > 0;
            totalPrices = hasPriceFields ? getTotalPrices(
              0,
              true,
              itemData.menuTypeVersions[menuTypeVersionId]
            ) : [];
          }
        }
        return {
          label: menuTypes[Number(menuTypeVersionId)] ? menuTypes[Number(menuTypeVersionId)].name : i18n_config_default.t("menuScreen.itemsMain.massUpdate.button"),
          id: menuTypeVersionId,
          action: "update",
          totalOfChanges,
          sections: {
            basic: basicChanges.filter(
              (basicChange) => basicChange.menuTypeVersionId === menuTypeVersionId
            ),
            dimensions: dimensionsChanges.filter(
              (dimensionsChange) => dimensionsChange.menuTypeVersionId === menuTypeVersionId
            ),
            associations: associationsChanges.filter(
              (associationChange) => associationChange.menuTypeVersionId === menuTypeVersionId
            ),
            register: registerChanges.filter(
              (registerChange) => registerChange.menuTypeVersionId === menuTypeVersionId
            ),
            moreInfo: moreInfoChanges.filter(
              (moreInfoChange) => moreInfoChange.menuTypeVersionId === menuTypeVersionId
            ),
            pricing: [...pricing, ...totalPrices],
            inventory: inventoryChanges.filter(
              (inventoryChange) => inventoryChange.menuTypeVersionId === menuTypeVersionId
            ),
            suggestiveOrdering: suggestiveOrderingChanges.filter(
              (suggestiveOrderingChange) => suggestiveOrderingChange.menuTypeVersionId === menuTypeVersionId
            ),
            modifierGroupsExtra: modifierGroupsExtraChanges.filter(
              (modifierGroupsChange) => modifierGroupsChange.menuTypeVersionId === menuTypeVersionId
            ),
            ingredientsExtra: ingredientsExtraChanges.filter(
              (ingredientsChange) => ingredientsChange.menuTypeVersionId === menuTypeVersionId
            ),
            modifierGroups: modifierGroupsChanges.map((modGroup) => __spreadProps(__spreadValues({}, modGroup), {
              changes: modGroup.changes.filter(
                (change) => change.field !== DEFAULT_SELECTION_PRICE
              )
            })),
            ingredients: ingredientsChanges,
            categoriesSubcategories: categoriesSubcategoriesChanges,
            prepStations: prepStationValues,
            prepStationsChanges: prepStationChanges.filter(
              (prepStationsChange) => prepStationsChange.menuTypeVersionId === menuTypeVersionId
            ),
            guestCheckDisplay: guestCheckDisplayChanges.filter(
              (prepStationsChange) => prepStationsChange.menuTypeVersionId === menuTypeVersionId
            ),
            taxes: taxesChanges,
            reportingGroups: reportingGroupsChanges
          }
        };
      }
    });
    return {
      itemId,
      masterChanges,
      menuTypeVersions: formattedMenuTypeVersions
    };
  }
  return null;
};
var getLinkedModifierItemsChanges = (diffArray, state) => {
  const linkedModifierItems = [];
  const modifierItems = selectModifierItems(state);
  const changeData = selectCurrentItem(state);
  const itemName = changeData == null ? void 0 : changeData.name;
  const LINKED_MODIFIER_ITEMS_FIELD = "linkedModifierItems";
  diffArray.forEach(
    (diff11) => filterDiffFunction(
      diff11,
      ({ field, diffLength }) => {
        var _a, _b, _c;
        const customField = diff11.path[0];
        if (diffLength === 1 || customField !== LINKED_MODIFIER_ITEMS_FIELD) {
          return;
        }
        const modifierItemId = Number(diff11.path[1]);
        if (diff11.kind === "N") {
          let changes = Object.entries(
            diff11.rhs
          ).map(([linkedModifierItemField, linkedModifierItemValue]) => ({
            field: linkedModifierItemField,
            label: returnLabel(linkedModifierItemField, 3),
            value: linkedModifierItemValue
          }));
          changes = changes.filter(
            (change) => change.field in ItemLinkedModifierItemsFields
          );
          linkedModifierItems.push({
            id: modifierItemId,
            value: modifierItemId ? (_a = modifierItems[modifierItemId]) == null ? void 0 : _a.name : itemName,
            action: "add",
            changes
          });
        } else if (diff11.kind === "D") {
          if (customField === LINKED_MODIFIER_ITEMS_FIELD) {
            linkedModifierItems.push({
              id: modifierItemId,
              value: (_b = modifierItems[modifierItemId]) == null ? void 0 : _b.name,
              action: "remove",
              changes: []
            });
          }
        } else if (diff11.kind === "E") {
          const customNewDiff = {
            field: diff11.path[2],
            label: returnLabel(field, 3) || "",
            value: diff11.rhs
          };
          if (customField === LINKED_MODIFIER_ITEMS_FIELD) {
            if (!linkedModifierItems.find(
              (linkedModifierItem) => linkedModifierItem.id === modifierItemId && linkedModifierItem.action === "update"
            )) {
              linkedModifierItems.push({
                id: modifierItemId,
                value: (_c = modifierItems[modifierItemId]) == null ? void 0 : _c.name,
                action: "update",
                changes: [customNewDiff]
              });
            } else {
              for (const [
                i,
                linkedModifierItem
              ] of linkedModifierItems.entries()) {
                if (linkedModifierItem.id === modifierItemId) {
                  linkedModifierItems[i].changes = [
                    ...linkedModifierItem.changes,
                    customNewDiff
                  ];
                  break;
                }
              }
            }
          }
        }
      },
      returnLabel
    )
  );
  return linkedModifierItems;
};
var generateModifierGroupsChanges = (diffArray, currentMenu, menuTypeVersionId, state) => {
  const menuModifierGroups = currentMenu.modifierGroups;
  const menuModifierItems = currentMenu.modifierItems;
  const modifierGroupsIds = [];
  const formattedModifierGroups = diffArray.filter(
    (diff11) => diff11.path.length >= 4 && diff11.path.length < 6 && diff11.path[2] !== "prepStationIds" && diff11.path[2] !== "ingredients" && diff11.path[2] !== "taxIds" && diff11.path[2] !== "inheritedTaxes" && diff11.path[2] !== "categoriesSubcategories" && diff11.path[1] === menuTypeVersionId || diff11.path.length === 3 && diff11.path[2] === "removeModifierGroups"
  ).map((diff11) => {
    var _a, _b;
    const field = diff11.path[((_a = diff11.path) == null ? void 0 : _a.length) - 1];
    if (!diff11.path)
      return { field: null };
    if (diff11.path.length === 3 && diff11.path[2] === "removeModifierGroups") {
      const modifierGroupId2 = Number((_b = diff11.item) == null ? void 0 : _b.rhs);
      if (!modifierGroupsIds.includes(modifierGroupId2))
        modifierGroupsIds.push(modifierGroupId2);
      return {
        field: modifierGroupId2,
        modifierGroupId: modifierGroupId2,
        label: returnLabel(field, 5),
        value: diff11.rhs,
        menuTypeVersionId: Number(menuTypeVersionId)
      };
    }
    const modifierGroupId = Number(diff11.path[3]);
    if (!modifierGroupsIds.includes(modifierGroupId))
      modifierGroupsIds.push(modifierGroupId);
    return {
      field,
      modifierGroupId,
      label: returnLabel(field, 5),
      value: diff11.rhs,
      menuTypeVersionId: Number(menuTypeVersionId)
    };
  });
  const formattedModifierGroupItems = diffArray.filter(
    (diff11) => diff11.path.length === 7 && diff11.path[1] === menuTypeVersionId.toString()
  ).map((diff11) => {
    var _a;
    if (!diff11.path)
      return { field: null };
    const field = diff11.path[((_a = diff11.path) == null ? void 0 : _a.length) - 1];
    const modifierGroupId = Number(diff11.path[3]);
    if (!modifierGroupsIds.includes(modifierGroupId))
      modifierGroupsIds.push(modifierGroupId);
    const modifierItemId = diff11.path[5];
    return {
      field,
      menuTypeVersionId: Number(menuTypeVersionId),
      modifierGroupId,
      modifierItemId: Number(modifierItemId),
      label: returnLabel(field, 7),
      value: diff11.rhs
    };
  });
  const modifierGroupsChanges = modifierGroupsIds.map(
    (modifierGroupId) => {
      var _a;
      const modifierGroupName = (_a = menuModifierGroups[modifierGroupId]) == null ? void 0 : _a.posName;
      const wasDeleted = diffArray.find(
        (diff11) => {
          var _a2;
          return diff11.path.length === 4 && diff11.path[1] === menuTypeVersionId && diff11.path[3] === modifierGroupId.toString() && diff11.kind === "D" || diff11.path.length === 3 && diff11.path[2] === "removeModifierGroups" && Number((_a2 = diff11.item) == null ? void 0 : _a2.rhs) === modifierGroupId;
        }
      );
      const wasAdded = diffArray.find(
        (diff11) => diff11.path.length === 4 && diff11.path[1] === menuTypeVersionId && diff11.path[3] === modifierGroupId.toString() && diff11.kind === "N"
      );
      if (wasDeleted) {
        return {
          label: modifierGroupName,
          id: modifierGroupId,
          action: "remove",
          changes: [],
          itemsChanged: []
        };
      } else if (wasAdded) {
        const newModifierGroup = wasAdded.rhs;
        return formatNewModifierGroup(
          newModifierGroup,
          Number(menuTypeVersionId),
          state
        );
      } else {
        const modifierGroupsById = formattedModifierGroups.filter((change) => {
          const changeData = state.menu.changeData.data;
          const modifierGroup = changeData.menuTypeVersions[Number(menuTypeVersionId)].modifierGroups[modifierGroupId];
          if ((modifierGroup == null ? void 0 : modifierGroup.isAllMod) && itemIgnoredPremadeModifierGroupFields.includes(change.field)) {
            return false;
          }
          return change.modifierGroupId === modifierGroupId;
        });
        if (formattedModifierGroupItems.filter(
          (change) => change.modifierGroupId === modifierGroupId
        ).length > 0) {
          const itemsIds = [];
          const itemsById = formattedModifierGroupItems.filter((change) => {
            if (change.modifierGroupId === modifierGroupId) {
              const item = change.modifierItemId;
              if (!itemsIds.includes(item))
                itemsIds.push(item);
              return true;
            }
            return false;
          });
          const quantityMode = menuModifierGroups[modifierGroupId].quantityMode;
          let itemsChanged = itemsIds.map((modifierItemId) => {
            let changesForItems = itemsById.filter(
              (item) => item.modifierItemId === modifierItemId
            );
            if (quantityMode === "Off" /* OFF */) {
              changesForItems = changesForItems.filter(
                (modifierItem) => !itemIgnoredQuantityOffFields.includes(modifierItem.field)
              );
            } else if (quantityMode === "x1,x2,x3" /* NUMBER */) {
              changesForItems = changesForItems.filter(
                (modifierItem) => !itemIgnoredQuantityNumberFields.includes(modifierItem.field)
              );
            } else {
              changesForItems = changesForItems.filter(
                (modifierItem) => !itemIgnoredQuantitySizeFields.includes(modifierItem.field)
              );
            }
            return {
              label: menuModifierItems[Number(modifierItemId)].name,
              id: modifierItemId,
              changes: changesForItems
            };
          });
          itemsChanged = itemsChanged.filter(
            (itemChanged) => itemChanged.changes.length > 0
          );
          const defaultModifierGroupPricingVersionId = modifierGroupsById.find(
            (modifierGroup) => modifierGroup.field === "defaultModifierGroupPricingVersionId"
          );
          if (defaultModifierGroupPricingVersionId) {
            const pricingVersionName = menuModifierGroups[modifierGroupId].modifierGroupPricingVersions[Number(defaultModifierGroupPricingVersionId.value)].name;
            const changes = modifierGroupsById.filter(
              (modifierGroup) => modifierGroup.field !== "defaultModifierGroupPricingVersionId"
            );
            return {
              label: modifierGroupName,
              id: modifierGroupId,
              action: "update",
              changes: [
                ...changes,
                __spreadProps(__spreadValues({}, defaultModifierGroupPricingVersionId), {
                  textValue: pricingVersionName
                })
              ],
              itemsChanged
            };
          } else {
            return {
              label: modifierGroupName,
              id: modifierGroupId,
              action: "update",
              changes: [...modifierGroupsById],
              itemsChanged
            };
          }
        } else {
          return {
            label: modifierGroupName,
            id: modifierGroupId,
            action: "update",
            changes: modifierGroupsById,
            itemsChanged: []
          };
        }
      }
    }
  );
  return modifierGroupsChanges;
};
var BASE_CATEGORY_SUBCATEGORY_DIFF = {
  label: "Categories and Subcategories",
  field: "categoriesSubcategories"
};
var formatCategorySubcategoryDiffValue = (value, currentMenu) => {
  var _a, _b, _c, _d;
  const categoryId = (value == null ? void 0 : value.categoryId) || null;
  const subcategoryId = (value == null ? void 0 : value.subcategoryId) || null;
  const categoryName = categoryId ? (_b = (_a = currentMenu.categories) == null ? void 0 : _a[categoryId]) == null ? void 0 : _b.posName : "No Category";
  const subcategoryName = subcategoryId ? (_d = (_c = currentMenu.subcategories) == null ? void 0 : _c[subcategoryId]) == null ? void 0 : _d.posName : "No Subcategory";
  return {
    categoryId,
    subcategoryId,
    categoryName,
    subcategoryName
  };
};
var createCategorySubcategoryMultiAddDiff = (categoriesSubcategories, currentMenu) => {
  const addInstances = [];
  Object.values(categoriesSubcategories != null ? categoriesSubcategories : {}).forEach((catSubcat) => {
    addInstances.push(__spreadProps(__spreadValues({}, BASE_CATEGORY_SUBCATEGORY_DIFF), {
      id: null,
      action: "add",
      value: formatCategorySubcategoryDiffValue(catSubcat, currentMenu)
    }));
  });
  return addInstances;
};
var generateCategoriesAndSubcategoriesChanges = (diffArray, currentMenu, menuTypeVersionId, state, createNewMenuTypes = true) => {
  var _a, _b;
  if (createNewMenuTypes && diffArray.some(
    (diff11) => diff11.kind === "N" && isEqual6(diff11.path, ["menuTypeVersions", menuTypeVersionId])
  )) {
    const categoriesSubcategories = (_b = (_a = state.menu.changeData.data.menuTypeVersions) == null ? void 0 : _a[Number(menuTypeVersionId)]) == null ? void 0 : _b.categoriesSubcategories;
    if (!categoriesSubcategories) {
      return [];
    }
    return createCategorySubcategoryMultiAddDiff(
      categoriesSubcategories,
      currentMenu
    );
  }
  const filteredDiffArray = diffArray.filter(
    (diff11) => diff11.path.length >= 3 && diff11.path[1] === menuTypeVersionId && diff11.path[2] === "categoriesSubcategories"
  );
  return filteredDiffArray.map(
    (diff11) => {
      if (diff11.kind === "N" && diff11.path.length === 3) {
        return createCategorySubcategoryMultiAddDiff(
          diff11.rhs,
          currentMenu
        );
      }
      if (diff11.kind === "N" && diff11.path.length === 4) {
        return __spreadProps(__spreadValues({}, BASE_CATEGORY_SUBCATEGORY_DIFF), {
          id: null,
          action: "add",
          value: formatCategorySubcategoryDiffValue(
            diff11.rhs,
            currentMenu
          )
        });
      }
      if (diff11.kind === "D" && diff11.path.length === 4) {
        return __spreadProps(__spreadValues({}, BASE_CATEGORY_SUBCATEGORY_DIFF), {
          id: isNaN(Number(diff11.path[3])) ? null : Number(diff11.path[3]),
          action: "remove",
          value: formatCategorySubcategoryDiffValue(
            diff11.lhs,
            currentMenu
          )
        });
      }
      if (diff11.kind === "E" && diff11.path.length === 5) {
        const newCategoiresAndSubcategoriesValue = get(
          state.menu.changeData.data,
          [...diff11.path].slice(0, 4)
        );
        return __spreadProps(__spreadValues({}, BASE_CATEGORY_SUBCATEGORY_DIFF), {
          id: Number(diff11.path[3]),
          action: "update",
          value: formatCategorySubcategoryDiffValue(
            newCategoiresAndSubcategoriesValue,
            currentMenu
          )
        });
      }
      return [];
    }
  ).flat();
};
var generateIngredientsChanges = (diffArray, currentMenu, menuTypeVersionId, state) => {
  const menuIngredients = currentMenu.ingredients;
  const ingredientsIds = [];
  const formattedIngredients = diffArray.filter(
    (diff11) => diff11.path.length >= 4 && diff11.path.length < 6 && diff11.path[2] === "ingredients" && diff11.path[1] === menuTypeVersionId
  ).map((diff11) => {
    var _a;
    const field = diff11.path[((_a = diff11.path) == null ? void 0 : _a.length) - 1];
    if (!diff11.path)
      return { field: null };
    const ingredientId = isNaN(Number(diff11.path[3])) ? diff11.path[3] : Number(diff11.path[3]);
    if (!ingredientsIds.includes(ingredientId))
      ingredientsIds.push(ingredientId);
    return {
      field,
      ingredientId,
      label: returnLabel(field, 5),
      value: diff11.rhs,
      menuTypeVersionId: Number(menuTypeVersionId)
    };
  });
  const ingredientsChanges = ingredientsIds.map(
    (ingredientId) => {
      var _a;
      const ingredientName = !isNaN(Number(ingredientId)) ? (_a = menuIngredients[Number(ingredientId)]) == null ? void 0 : _a.posName : "";
      const wasDeleted = diffArray.find(
        (diff11) => diff11.path.length === 4 && diff11.path[1] === menuTypeVersionId && diff11.path[3] === ingredientId.toString() && diff11.kind === "D"
      );
      const wasAdded = diffArray.find(
        (diff11) => diff11.path.length === 4 && diff11.path[1] === menuTypeVersionId && diff11.path[3] === ingredientId.toString() && diff11.kind === "N"
      );
      if (wasDeleted) {
        return {
          label: ingredientName,
          id: Number(ingredientId),
          tabletGeneratedId: Number(ingredientId),
          action: "remove",
          changes: []
        };
      } else if (wasAdded) {
        const newIngredient = wasAdded.rhs;
        return formatNewIngredient(
          newIngredient,
          Number(menuTypeVersionId),
          state
        );
      } else {
        const ingredientsById = formattedIngredients.filter((change) => {
          if (!(change.field in ItemIngredientsFields)) {
            return false;
          }
          return change.ingredientId === ingredientId;
        });
        return {
          label: ingredientName,
          id: Number(ingredientId),
          tabletGeneratedId: Number(ingredientId),
          action: "update",
          changes: ingredientsById
        };
      }
    }
  );
  return ingredientsChanges;
};
var generateTaxesChanges = (diffArray, menuTypeVersionId, state, isCombo = false) => {
  var _a;
  const isMassUpdate = selectIsMassUpdate(state);
  const formattedInheritedTaxesDiff = {};
  const bucketSelected = selectBucketSelected(state);
  const taxes = state.settings.selectedMode.currentSettings.taxes;
  const changeData = selectCurrentItem(state);
  const originalItem = (isCombo ? state.menu.selectedMode.currentMenu.combos[state.menu.changeData.id] : state.menu.selectedMode.currentMenu.items[state.menu.changeData.id]) || getMenuInitialStateForSaving(bucketSelected || "items");
  const customTaxes = diffArray.filter(
    (diff11) => diff11.path[2] === "taxIds" && diff11.path[1] === menuTypeVersionId
  );
  const customRemovedTaxes = diffArray.filter(
    (diff11) => diff11.path[2] === "removeTaxIds" && diff11.path[1] === menuTypeVersionId
  );
  if (customTaxes.length > 0) {
    formattedInheritedTaxesDiff.taxIds = getTaxesDiffArrayCore(
      isMassUpdate ? [] : originalItem.menuTypeVersions[Number(menuTypeVersionId)].taxIds,
      isMassUpdate ? changeData == null ? void 0 : changeData.taxIds : changeData.menuTypeVersions[Number(menuTypeVersionId)].taxIds,
      state
    );
  }
  if (isMassUpdate && customRemovedTaxes.length > 0) {
    formattedInheritedTaxesDiff.taxIds = [
      ...formattedInheritedTaxesDiff.taxIds || [],
      ...getTaxesDiffArrayCore(
        changeData == null ? void 0 : changeData.removeTaxIds,
        [],
        state
      )
    ];
  }
  if (isMassUpdate) {
    return formattedInheritedTaxesDiff;
  }
  const inheritedTaxesDiff = diffArray.filter(
    (diff11) => diff11.path.length >= 4 && diff11.path[2] === "inheritedTaxes" && diff11.path[1] === menuTypeVersionId
  );
  for (const diff11 of inheritedTaxesDiff) {
    const taxId = isNaN(Number(diff11.path[4])) ? diff11.path[4] : Number(diff11.path[4]);
    const taxInheritedBucket = diff11.path[3];
    if (!(taxInheritedBucket in formattedInheritedTaxesDiff)) {
      formattedInheritedTaxesDiff[taxInheritedBucket] = [];
    }
    const isActive = diff11.kind === "N" ? (_a = diff11.rhs) == null ? void 0 : _a.isActive : diff11.rhs;
    formattedInheritedTaxesDiff[taxInheritedBucket].push({
      id: Number(taxId),
      value: taxes[taxId].name,
      action: isActive ? "add" : "remove"
    });
  }
  return formattedInheritedTaxesDiff;
};
var generateMassUpdateReportingGroupsChanges = (diffArray, menuTypeVersionId, state) => {
  const isMassUpdate = selectIsMassUpdate(state);
  let reportingGroupsDiff = [];
  const changeData = selectCurrentItem(state);
  const reportingGroupsBucket = selectReportingGroups(state);
  if (!isMassUpdate) {
    return [];
  }
  const addedReportingGroups = diffArray.filter(
    (diff11) => diff11.path[2] === "reportingGroupIds" && diff11.path[1] === menuTypeVersionId
  );
  const removedReportingGroups = diffArray.filter(
    (diff11) => diff11.path[2] === "removeReportingGroupIds" && diff11.path[1] === menuTypeVersionId
  );
  if (addedReportingGroups.length > 0) {
    reportingGroupsDiff = getArrayNumberChanges(
      [],
      changeData == null ? void 0 : changeData.reportingGroupIds
    );
  }
  if (removedReportingGroups.length > 0) {
    reportingGroupsDiff = [
      ...reportingGroupsDiff || [],
      ...getArrayNumberChanges(
        changeData == null ? void 0 : changeData.removeReportingGroupIds,
        []
      )
    ];
  }
  reportingGroupsDiff = reportingGroupsDiff.map((diff11) => __spreadProps(__spreadValues({}, diff11), {
    value: reportingGroupsBucket[diff11.id].name
  }));
  return reportingGroupsDiff;
};
var getLocationsChanges = (hasSomeLocationIds, itemLocationIds, locationIds, state, extraRemovedLocationsIds = []) => {
  const locationsGroups = state.locations;
  const locationValues = [];
  if (hasSomeLocationIds) {
    const removedLocationIds = [
      ...difference(itemLocationIds, locationIds),
      ...extraRemovedLocationsIds
    ];
    const addedLocationIds = difference(
      locationIds,
      itemLocationIds
    );
    if (removedLocationIds.length > 0) {
      removedLocationIds.map((removedLocationId) => {
        var _a;
        const locationData = Object.values(locationsGroups).filter(
          (locationGroup) => locationGroup.locations.find(
            (location) => location.id === Number(removedLocationId)
          )
        );
        if (locationData.length === 1) {
          const locationName = (_a = locationData[0].locations.find(
            (location) => location.id === Number(removedLocationId)
          )) == null ? void 0 : _a.streetLine1;
          locationValues.push({
            action: "remove",
            id: removedLocationId,
            value: locationName != null ? locationName : ""
          });
        } else {
          locationValues.push({
            action: "",
            id: 0,
            value: ""
          });
        }
      });
    }
    if (addedLocationIds.length > 0) {
      addedLocationIds.map((addedLocationId) => {
        var _a;
        const locationData = Object.values(locationsGroups).filter(
          (locationGroup) => locationGroup.locations.find(
            (location) => location.id === Number(addedLocationId)
          )
        );
        if (locationData.length === 1) {
          const locationName = (_a = locationData[0].locations.find(
            (location) => location.id === Number(addedLocationId)
          )) == null ? void 0 : _a.streetLine1;
          locationValues.push({
            action: "add",
            id: addedLocationId,
            value: locationName != null ? locationName : ""
          });
        } else {
          locationValues.push({
            action: "",
            id: 0,
            value: ""
          });
        }
      });
    }
  }
  return locationValues;
};
var getPrepStationChanges = (hasPrepStationChanges, originalPrepStationIds, prepStationIds, state, extraRemovedPrepStationsIds = []) => {
  const prepStations = currentPrepStationsSelector(state);
  const prepStationValues = [];
  if (hasPrepStationChanges) {
    const removedPrepStationIds = [
      ...difference(originalPrepStationIds, prepStationIds),
      ...extraRemovedPrepStationsIds
    ];
    const addedPrepStationIds = difference(
      prepStationIds,
      originalPrepStationIds
    );
    if (removedPrepStationIds.length > 0) {
      removedPrepStationIds.map((removedPrepStationId) => {
        const prepStationData = prepStations[removedPrepStationId];
        if (prepStationData) {
          const prepStationName = prepStationData.name;
          prepStationValues.push({
            action: "remove",
            id: removedPrepStationId,
            value: prepStationName != null ? prepStationName : ""
          });
        } else {
          prepStationValues.push({
            action: "remove",
            id: 0,
            value: ""
          });
        }
      });
    }
    if (addedPrepStationIds.length > 0) {
      addedPrepStationIds.map((addedPrepStationId) => {
        const prepStationData = prepStations[addedPrepStationId];
        if (prepStationData) {
          const prepStationName = prepStationData.name;
          prepStationValues.push({
            action: "add",
            id: addedPrepStationId,
            value: prepStationName != null ? prepStationName : ""
          });
        } else {
          prepStationValues.push({
            action: "add",
            id: 0,
            value: ""
          });
        }
      });
    }
  }
  return prepStationValues;
};
var formatNewModifierGroup = (modifierGroup, menuTypeVersionId, state) => {
  var _a;
  const menu = state.menu;
  const currentMenu = menu.selectedMode.currentMenu;
  const menuModifierGroups = currentMenu.modifierGroups;
  const menuModifierItems = currentMenu.modifierItems;
  const modifierGroupName = (_a = menuModifierGroups[modifierGroup.modifierGroupId]) == null ? void 0 : _a.posName;
  const newModifierItems = modifierGroup.modifierItems;
  const quantityMode = menuModifierGroups[modifierGroup.modifierGroupId].quantityMode;
  const changes = Object.entries(modifierGroup).filter(([key]) => {
    if ((modifierGroup == null ? void 0 : modifierGroup.isAllMod) && itemIgnoredPremadeModifierGroupFields.includes(key)) {
      return false;
    }
    if (!returnLabel(key, 5)) {
      return;
    }
    return !itemIgnoredFields.includes(key) && key !== "modifierItems";
  }).map(([keyModifierGroup, modifierGroupValue]) => {
    if (keyModifierGroup === "defaultModifierGroupPricingVersionId") {
      return {
        field: keyModifierGroup,
        modifierGroupId: modifierGroup.modifierGroupId,
        label: returnLabel(keyModifierGroup, 5),
        value: modifierGroupValue,
        textValue: menuModifierGroups[modifierGroup.modifierGroupId].modifierGroupPricingVersions[Number(modifierGroupValue)].name,
        menuTypeVersionId
      };
    } else {
      return {
        field: keyModifierGroup,
        modifierGroupId: modifierGroup.modifierGroupId,
        label: returnLabel(keyModifierGroup, 5),
        value: modifierGroupValue,
        menuTypeVersionId
      };
    }
  });
  const itemsChanged = Object.entries(newModifierItems).filter(([field]) => !itemIgnoredModifierItemsFields.includes(field)).map(([field, value]) => {
    let changesForItems = Object.entries(value).filter(([key1]) => {
      if (!returnLabel(key1, 7)) {
        return false;
      }
      return !itemIgnoredModifierItemsFields.includes(key1);
    }).map(([keyModifierItem, modifierItemValue]) => {
      return {
        field: keyModifierItem,
        label: returnLabel(keyModifierItem, 7),
        value: modifierItemValue,
        modifierGroupId: modifierGroup.modifierGroupId,
        modifierItemId: value.modifierItemId,
        menuTypeVersionId: Number(menuTypeVersionId)
      };
    });
    if (quantityMode === "Off" /* OFF */) {
      changesForItems = changesForItems.filter(
        (modifierItem) => !itemIgnoredQuantityOffFields.includes(modifierItem.field)
      );
    } else if (quantityMode === "x1,x2,x3" /* NUMBER */) {
      changesForItems = changesForItems.filter(
        (modifierItem) => !itemIgnoredQuantityNumberFields.includes(modifierItem.field)
      );
    } else {
      changesForItems = changesForItems.filter(
        (modifierItem) => !itemIgnoredQuantitySizeFields.includes(modifierItem.field)
      );
    }
    return {
      label: menuModifierItems[Number(field)].name,
      id: value.modifierItemId,
      changes: changesForItems
    };
  });
  return {
    label: modifierGroupName,
    id: modifierGroup.modifierGroupId,
    action: "add",
    changes: [...changes],
    itemsChanged
  };
};
var formatItemNewTaxes = (inheritedTaxes, taxIds, state) => {
  const taxes = currentTaxesSettingsSelector(state);
  const taxIdsDiff = getTaxesDiffArrayCore([], taxIds, state);
  const taxesDiff = {};
  const subcategoryTaxesDiff = [];
  const categoryTaxesDiff = [];
  const menuTypesTaxesDiff = [];
  if (taxIdsDiff.length > 0) {
    taxesDiff.taxIds = taxIdsDiff;
  }
  const forEachTaxFn = (tax, taxesDiffArray) => {
    taxesDiffArray.push({
      id: tax.id,
      value: taxes[tax.id].name,
      action: tax.isActive ? "add" : "remove"
    });
  };
  Object.values(inheritedTaxes.subcategoryInheritedTaxes || {}).forEach(
    (tax) => forEachTaxFn(tax, subcategoryTaxesDiff)
  );
  Object.values(inheritedTaxes.categoryInheritedTaxes || {}).forEach(
    (tax) => forEachTaxFn(tax, categoryTaxesDiff)
  );
  Object.values(inheritedTaxes.menuTypeInheritedTaxes || {}).forEach(
    (tax) => forEachTaxFn(tax, menuTypesTaxesDiff)
  );
  if (categoryTaxesDiff.length > 0) {
    taxesDiff.categoryInheritedTaxes = categoryTaxesDiff;
  }
  if (subcategoryTaxesDiff.length > 0) {
    taxesDiff.subcategoryInheritedTaxes = subcategoryTaxesDiff;
  }
  if (menuTypesTaxesDiff.length > 0) {
    taxesDiff.menuTypeInheritedTaxes = menuTypesTaxesDiff;
  }
  return taxesDiff;
};
var formatNewIngredient = (ingredient, menuTypeVersionId, state) => {
  var _a;
  const menu = state.menu;
  const currentMenu = menu.selectedMode.currentMenu;
  const menuIngredients = currentMenu.ingredients;
  const ingredientName = typeof ingredient.ingredientId === "number" ? (_a = menuIngredients[ingredient.ingredientId]) == null ? void 0 : _a.posName : "";
  const changes = Object.entries(ingredient).filter(([key]) => key in ItemIngredientsFields).map(([keyIngredient, ingredientValue]) => ({
    field: keyIngredient,
    ingredientId: ingredient.ingredientId,
    label: returnLabel(keyIngredient, 5),
    value: ingredientValue,
    menuTypeVersionId
  }));
  return {
    label: ingredientName,
    id: typeof ingredient.ingredientId === "string" ? 0 : ingredient.ingredientId,
    tabletGeneratedId: ingredient.ingredientId,
    action: "add",
    changes: [...changes]
  };
};
var getArraysByAction = (diffArray, menuTypeId) => {
  const {
    addedMenuTypesDiff,
    removedMenuTypesDiff,
    changedMenuTypeFieldsDiff,
    arraysDiff
  } = getMenuTypeArraysByAction(diffArray, menuTypeId);
  const addedModifierGroups = diffArray.filter(
    (diff11) => diff11.path.length === 4 && diff11.path[2] === MODIFIER_GROUPS && diff11.kind === "N" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const removedModifierGroups = diffArray.filter(
    (diff11) => diff11.path.length === 4 && diff11.path[2] === MODIFIER_GROUPS && diff11.kind === "D" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const changedModifierGroupFields = diffArray.filter(
    (diff11) => diff11.path.length === 5 && diff11.path[2] === MODIFIER_GROUPS && diff11.kind === "E" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const addedIngredients = diffArray.filter(
    (diff11) => diff11.path.length === 4 && diff11.path[2] === INGREDIENTS && diff11.kind === "N" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const removedIngredients = diffArray.filter(
    (diff11) => diff11.path.length === 4 && diff11.path[2] === INGREDIENTS && diff11.kind === "D" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const changedIngredientFields = diffArray.filter(
    (diff11) => diff11.path.length === 5 && diff11.path[2] === INGREDIENTS && diff11.kind === "E" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const addedCategories = diffArray.filter(
    (diff11) => diff11.path.length === 4 && diff11.path[2] === CATEGORIES_SUBCATEGORIES && diff11.kind === "N" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const removedCategories = diffArray.filter(
    (diff11) => diff11.path.length === 4 && diff11.path[2] === CATEGORIES_SUBCATEGORIES && diff11.kind === "D" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const changedCategoriesFields = diffArray.filter(
    (diff11) => diff11.path.length === 5 && diff11.path[2] === CATEGORIES_SUBCATEGORIES && diff11.kind === "E" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const addedCategoryTaxes = diffArray.filter(
    (diff11) => diff11.path.length === 5 && diff11.path[3] === CATEGORY_INHERITED_TAXES && diff11.kind === "N" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const removedCategoryTaxes = diffArray.filter(
    (diff11) => diff11.path.length === 5 && diff11.path[3] === CATEGORY_INHERITED_TAXES && diff11.kind === "D" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const changedCategoryTaxesFields = diffArray.filter(
    (diff11) => diff11.path.length === 6 && diff11.path[3] === CATEGORY_INHERITED_TAXES && diff11.kind === "E" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const addedSubcategoryTaxes = diffArray.filter(
    (diff11) => diff11.path.length === 5 && diff11.path[3] === SUBCATEGORY_INHERITED_TAXES && diff11.kind === "N" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const removedSubcategoryTaxes = diffArray.filter(
    (diff11) => diff11.path.length === 5 && diff11.path[3] === SUBCATEGORY_INHERITED_TAXES && diff11.kind === "D" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const changedSubcategoryTaxesFields = diffArray.filter(
    (diff11) => diff11.path.length === 6 && diff11.path[3] === SUBCATEGORY_INHERITED_TAXES && diff11.kind === "E" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const changedModifierGroupModifierItemFields = diffArray.filter(
    (diff11) => diff11.path.length === 7 && diff11.path[2] === MODIFIER_GROUPS && diff11.kind === "E" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  return {
    arraysDiff,
    addedMenuTypesDiff,
    removedMenuTypesDiff,
    addedModifierGroups,
    removedModifierGroups,
    changedMenuTypeFieldsDiff: changedMenuTypeFieldsDiff.filter(
      (change) => change.path[2] !== "locationIds" && change.path[2] !== "categoriesSubcategories"
    ),
    changedModifierGroupFields,
    changedModifierGroupModifierItemFields,
    addedCategories,
    removedCategories,
    changedCategoriesFields,
    addedCategoryTaxes,
    removedCategoryTaxes,
    changedCategoryTaxesFields,
    addedSubcategoryTaxes,
    removedSubcategoryTaxes,
    changedSubcategoryTaxesFields,
    addedIngredients,
    removedIngredients,
    changedIngredientFields
  };
};
var applyChangesToMenuTypes = (formattedMenuTypeVersions, hasMenuTypesToApplyChanges, state, dispatch) => {
  let renderErrorToast = false;
  const changeData = selectChangeData(state);
  const itemId = selectChangeDataId(state);
  const originalData = preMakeItemWithModifierGroups(
    selectOriginalMenuData(state),
    state.menu
  );
  const clonedItemData = cloneDeep16(
    preMakeItemWithModifierGroups(changeData.data, state.menu)
  );
  const isCreation = selectIsMenuCreationMode(state);
  const clonedChanges = cloneDeep16(changeData.differences);
  const {
    addedMenuTypesDiff,
    addedModifierGroups,
    removedModifierGroups,
    changedMenuTypeFieldsDiff,
    changedModifierGroupFields,
    changedModifierGroupModifierItemFields,
    addedCategories,
    removedCategories,
    changedCategoriesFields,
    addedCategoryTaxes,
    removedCategoryTaxes,
    changedCategoryTaxesFields,
    addedSubcategoryTaxes,
    removedSubcategoryTaxes,
    changedSubcategoryTaxesFields,
    addedIngredients,
    removedIngredients,
    changedIngredientFields,
    arraysDiff
  } = getArraysByAction(
    clonedChanges,
    hasMenuTypesToApplyChanges == null ? void 0 : hasMenuTypesToApplyChanges.currentMenuType
  );
  const getModifierGroupsSorted = (diff11, menuTypeIdToApply, sortPriority) => {
    const diffPath = getMenuTypeDiffPath(diff11.path, menuTypeIdToApply);
    const targetMenuTypeModifierGroupsPath = diffPath.slice(0, 3).join(".");
    const { hasChanges, elements } = getObjectSorted(
      clonedItemData.menuTypeVersions[menuTypeIdToApply].modifierGroups,
      diff11.path[3],
      sortPriority
    );
    if (!hasChanges) {
      renderErrorToast = true;
    }
    return {
      hasChanges,
      modifierGroups: elements,
      path: targetMenuTypeModifierGroupsPath
    };
  };
  const addedModifierGroupSetFunction = (diff11, menuTypeIdToApply) => {
    var _a;
    const diffPathToApplyArray = getMenuTypeDiffPath(
      diff11.path,
      menuTypeIdToApply
    );
    const diffPathToApply = diffPathToApplyArray.join(".");
    const newData = diff11.rhs;
    const originalSortPriority = newData.sortPriority;
    newData.sortPriority = getObjectNextSortPriority(
      (_a = clonedItemData.menuTypeVersions[menuTypeIdToApply]) == null ? void 0 : _a.modifierGroups
    );
    setWith(clonedItemData, diffPathToApply, newData, Object);
    const {
      path: targetMenuTypeItemGroupsPath,
      modifierGroups: targetMenuTypeItemGroups
    } = getModifierGroupsSorted(diff11, menuTypeIdToApply, originalSortPriority);
    if (newData[IS_ALL_MOD_FIELD]) {
      clonedItemData.menuTypeVersions[menuTypeIdToApply].allModsBehavior = clonedItemData.menuTypeVersions[(hasMenuTypesToApplyChanges == null ? void 0 : hasMenuTypesToApplyChanges.currentMenuType) || 0].allModsBehavior;
    }
    setWith(
      clonedItemData,
      targetMenuTypeItemGroupsPath,
      targetMenuTypeItemGroups,
      Object
    );
  };
  const getCategoryTarget = (diff11, menuTypeIdToApply) => {
    const diffPathToApplyArray = getMenuTypeDiffPath(
      diff11.path,
      menuTypeIdToApply
    );
    const categoryOriginPath = diff11.path.slice(0, 4).join(".");
    const categoryOrigin = get(clonedItemData, categoryOriginPath);
    const targetMenuTypeCategories = clonedItemData.menuTypeVersions[menuTypeIdToApply].categoriesSubcategories;
    const targetCategory = Object.entries(targetMenuTypeCategories || {}).find(
      (category) => category[1].categoryId === categoryOrigin.categoryId
    );
    const targetPathArray = diffPathToApplyArray.slice(0, 3);
    if (targetCategory) {
      targetPathArray.push(targetCategory[0]);
    }
    if (diff11.path.length >= 5) {
      targetPathArray.push(
        diffPathToApplyArray[diffPathToApplyArray.length - 1]
      );
    }
    const targetPath = targetPathArray.join(".");
    return {
      target: targetCategory,
      originPath: categoryOriginPath,
      targetPath
    };
  };
  const itemArrayElementSetFunction = (diff11, menuTypeIdToApply) => {
    arrayElementSetFunction(
      diff11,
      menuTypeIdToApply,
      originalData,
      clonedItemData
    );
  };
  const changedCategorySetFunction = (diff11, menuTypeIdToApply) => {
    const { target: targetCategory, targetPath } = getCategoryTarget(
      diff11,
      menuTypeIdToApply
    );
    if (!targetCategory) {
      renderErrorToast = true;
      return;
    }
    setWith(clonedItemData, targetPath, diff11.rhs, Object);
  };
  const itemChangedElementSetFunction = (diff11, menuTypeIdToApply) => {
    const hasChanged = changedElementSetFunction(
      diff11,
      menuTypeIdToApply,
      clonedItemData
    );
    if (!hasChanged) {
      renderErrorToast = true;
    }
  };
  const addedCategorySetFunction = (diff11, menuTypeIdToApply) => {
    const { target: targetCategory, targetPath } = getCategoryTarget(
      diff11,
      menuTypeIdToApply
    );
    if (targetCategory) {
      changedSetFunction(
        __spreadProps(__spreadValues({}, diff11), { path: targetPath.split(".") }),
        menuTypeIdToApply
      );
    } else {
      addedObjectElementSetFunction(diff11, menuTypeIdToApply, clonedItemData);
    }
  };
  const itemAddedObjectElementSetFunction = (diff11, menuTypeIdToApply) => {
    addedObjectElementSetFunction(diff11, menuTypeIdToApply, clonedItemData);
  };
  const addedMenuTypeSetFunction = (diff11, menuTypeIdToApply) => {
    const diffPath = getMenuTypeDiffPath(diff11.path, menuTypeIdToApply);
    const path = diffPath.join(".");
    if (has(clonedItemData, path)) {
      setWith(
        clonedItemData,
        path,
        __spreadProps(__spreadValues({}, diff11.rhs), {
          menuTypeId: menuTypeIdToApply
        }),
        Object
      );
    }
  };
  const itemRemovedSetFunction = (diff11, menuTypeIdToApply) => {
    const hasRemoved = removedSetFunction(
      diff11,
      menuTypeIdToApply,
      clonedItemData
    );
    if (!hasRemoved) {
      renderErrorToast = true;
    }
  };
  const changedSetFunction = (diff11, menuTypeIdToApply) => {
    const diffPath = getMenuTypeDiffPath(diff11.path, menuTypeIdToApply);
    const path = diffPath.join(".");
    if (has(clonedItemData, path)) {
      setWith(clonedItemData, path, diff11.rhs, Object);
    }
  };
  const changedModifierGroupSetFunction = (diff11, menuTypeIdToApply) => {
    const field = diff11.path[diff11.path.length - 1];
    const diffPathArray = getMenuTypeDiffPath(diff11.path, menuTypeIdToApply);
    const diffPath = diffPathArray.join(".");
    const elementPath = diffPathArray.slice(0, -1).join(".");
    const isSortPriority = field === SORT_PRIORITY_FIELD;
    const elementTarget = get(clonedItemData, elementPath);
    if (!elementTarget) {
      renderErrorToast = true;
      return;
    }
    if (isSortPriority) {
      const {
        path: targetMenuTypeModifierGroupsPath,
        modifierGroups: targetMenuTypeModifierGroups
      } = getModifierGroupsSorted(
        diff11,
        menuTypeIdToApply,
        diff11.rhs
      );
      setWith(
        clonedItemData,
        targetMenuTypeModifierGroupsPath,
        targetMenuTypeModifierGroups,
        Object
      );
      return;
    }
    if (field === IS_ALL_MOD_FIELD && diff11.rhs === true) {
      clonedItemData.menuTypeVersions[menuTypeIdToApply].allModsBehavior = clonedItemData.menuTypeVersions[(hasMenuTypesToApplyChanges == null ? void 0 : hasMenuTypesToApplyChanges.currentMenuType) || 0].allModsBehavior;
    }
    if (has(clonedItemData, diffPath) && !isSortPriority) {
      setWith(clonedItemData, diffPath, diff11.rhs, Object);
    }
  };
  if (hasMenuTypesToApplyChanges) {
    hasMenuTypesToApplyChanges.menuTypesToApplyChanges.forEach((menuType) => {
      const menuTypeIdToApply = menuType.menuTypeId;
      changedMenuTypeFieldsDiff.forEach((diff11) => {
        changedSetFunction(diff11, menuTypeIdToApply);
      });
      addedMenuTypesDiff.forEach(
        (diff11) => addedMenuTypeSetFunction(diff11, menuTypeIdToApply)
      );
      orderBy5(changedModifierGroupFields, (change) => {
        const field = change.path[change.path.length - 1];
        return field === SORT_PRIORITY_FIELD ? change.rhs : 0;
      }).forEach(
        (diff11) => changedModifierGroupSetFunction(diff11, menuTypeIdToApply)
      );
      orderBy5(changedModifierGroupModifierItemFields, (change) => {
        const field = change.path[change.path.length - 1];
        return field === SORT_PRIORITY_FIELD ? change.rhs : 0;
      }).forEach(
        (diff11) => changedModifierGroupSetFunction(diff11, menuTypeIdToApply)
      );
      addedModifierGroups.forEach(
        (diff11) => addedModifierGroupSetFunction(diff11, menuTypeIdToApply)
      );
      removedModifierGroups.forEach(
        (diff11) => itemRemovedSetFunction(diff11, menuTypeIdToApply)
      );
      removedCategories.forEach(
        (diff11) => itemRemovedSetFunction(diff11, menuTypeIdToApply)
      );
      removedCategoryTaxes.forEach(
        (diff11) => itemRemovedSetFunction(diff11, menuTypeIdToApply)
      );
      removedSubcategoryTaxes.forEach(
        (diff11) => itemRemovedSetFunction(diff11, menuTypeIdToApply)
      );
      removedIngredients.forEach(
        (diff11) => itemRemovedSetFunction(diff11, menuTypeIdToApply)
      );
      addedCategories.forEach(
        (diff11) => addedCategorySetFunction(diff11, menuTypeIdToApply)
      );
      addedCategoryTaxes.forEach(
        (diff11) => itemAddedObjectElementSetFunction(diff11, menuTypeIdToApply)
      );
      addedSubcategoryTaxes.forEach(
        (diff11) => itemAddedObjectElementSetFunction(diff11, menuTypeIdToApply)
      );
      addedIngredients.forEach(
        (diff11) => addedModifierGroupSetFunction(diff11, menuTypeIdToApply)
      );
      changedCategoryTaxesFields.forEach(
        (diff11) => itemChangedElementSetFunction(diff11, menuTypeIdToApply)
      );
      changedSubcategoryTaxesFields.forEach(
        (diff11) => itemChangedElementSetFunction(diff11, menuTypeIdToApply)
      );
      changedIngredientFields.forEach(
        (diff11) => itemChangedElementSetFunction(diff11, menuTypeIdToApply)
      );
      changedCategoriesFields.forEach(
        (diff11) => changedCategorySetFunction(diff11, menuTypeIdToApply)
      );
      arraysDiff.forEach(
        (diff11) => itemArrayElementSetFunction(diff11, menuTypeIdToApply)
      );
      changedModifierGroupModifierItemFields.forEach((diff11) => {
        const field = diff11.path[diff11.path.length - 1];
        const value = diff11.rhs;
        const diffPathToApplyArray = getMenuTypeDiffPath(
          diff11.path,
          menuTypeIdToApply
        );
        const diffPathToApplyModifierItemArray = diffPathToApplyArray.slice(
          0,
          -1
        );
        const diffPathToApplyModifierItem = diffPathToApplyModifierItemArray.join(".");
        const hasIsSelected = field === IS_SELECTED && value === true;
        const hasIsActive = field === ACTIVE && value === false;
        const targetModifierItem = get(
          clonedItemData,
          diffPathToApplyModifierItem
        );
        if (hasIsSelected && !(targetModifierItem == null ? void 0 : targetModifierItem.active)) {
          changedElementSetFunction(
            __spreadProps(__spreadValues({}, diff11), {
              path: [...diffPathToApplyModifierItemArray, ACTIVE],
              rhs: true
            }),
            menuTypeIdToApply,
            clonedItemData
          );
        }
        if (hasIsActive) {
          if (targetModifierItem == null ? void 0 : targetModifierItem.isSelected) {
            changedElementSetFunction(
              __spreadProps(__spreadValues({}, diff11), {
                path: [...diffPathToApplyModifierItemArray, IS_SELECTED],
                rhs: false
              }),
              menuTypeIdToApply,
              clonedItemData
            );
          }
          if (targetModifierItem == null ? void 0 : targetModifierItem.defaultQuantitySelected) {
            changedElementSetFunction(
              __spreadProps(__spreadValues({}, diff11), {
                path: [
                  ...diffPathToApplyModifierItemArray,
                  DEFAULT_QUANTITY_SELECTED
                ],
                rhs: 0
              }),
              menuTypeIdToApply,
              clonedItemData
            );
          }
          if ((targetModifierItem == null ? void 0 : targetModifierItem.defaultAmountSelected) !== "regular" /* REGULAR */) {
            changedElementSetFunction(
              __spreadProps(__spreadValues({}, diff11), {
                path: [
                  ...diffPathToApplyModifierItemArray,
                  DEFAULT_AMOUNT_SELECTED
                ],
                rhs: "regular" /* REGULAR */
              }),
              menuTypeIdToApply,
              clonedItemData
            );
          }
        }
      });
      let totalModifiersPrice = 0;
      Object.values(
        clonedItemData.menuTypeVersions[menuTypeIdToApply].modifierGroups
      ).forEach((modifierGroup) => {
        if (!modifierGroup.active || !modifierGroup.inheritedActive) {
          return;
        }
        const formattedModifierGroup = modifierGroupsFactoryCore(
          { [modifierGroup.modifierGroupId]: modifierGroup },
          state
        );
        const { totalPrice } = getModifierItemPriceCalc(
          formattedModifierGroup[0].modifierItems,
          formattedModifierGroup[0].includedModifierItems,
          formattedModifierGroup[0].quantityMode,
          formattedModifierGroup[0].priceCalcMode
        );
        modifierGroup.defaultSelectionPrice = totalPrice;
        clonedItemData.menuTypeVersions[menuTypeIdToApply].defaultModifiersPrice = totalModifiersPrice += totalPrice;
      });
    });
    const differences = deepDiff6(originalData, clonedItemData);
    const newState = __spreadProps(__spreadValues({}, state), {
      menu: __spreadProps(__spreadValues({}, state.menu), {
        changeData: __spreadProps(__spreadValues({}, state.menu.changeData), {
          data: clonedItemData,
          differences
        })
      })
    });
    const newDiffObject = diffItemsFactory(
      itemId,
      differences,
      clonedItemData,
      newState
    );
    if (isCreation) {
      dispatch(
        updateChangeDataValues({
          data: clonedItemData,
          sectionId: "all" /* ALL */
        })
      );
    }
    if (renderErrorToast) {
      dispatch(
        showToast({
          type: "warning",
          title: i18n_config_default.t(
            "menuScreen.comboDetails.applyChangesToMenuType.error.title"
          ),
          description: i18n_config_default.t(
            "menuScreen.comboDetails.applyChangesToMenuType.error.description"
          ),
          timeout: 5e3
        })
      );
    }
    return newDiffObject == null ? void 0 : newDiffObject.menuTypeVersions;
  }
  return formattedMenuTypeVersions;
};
function addPropertiesAndOverWriteIfExist(sourceArray, targetArray) {
  const existingFieldsArray = [];
  const nonExistingFields = sourceArray.reduce(
    (sourceAcc, sourceValue) => {
      const elementExist = targetArray.find(
        (element) => element.field === sourceValue.field
      );
      if (!elementExist)
        return [...sourceAcc, sourceValue];
      return sourceAcc;
    },
    []
  );
  const existingFields = sourceArray.reduce(
    (sourceAcc, sourceValue) => {
      const elementExist = targetArray.find(
        (element) => element.field === sourceValue.field
      );
      existingFieldsArray.push(sourceValue.field);
      if (elementExist)
        return [...sourceAcc, sourceValue];
      return sourceAcc;
    },
    []
  );
  const currentFields = targetArray.filter(
    (element) => !existingFieldsArray.includes(element.field)
  );
  return [...currentFields, ...existingFields, ...nonExistingFields];
}
function addTaxesPropertiesAndOverWriteIfExist(sourceArray, targetMenuTypeId, targetArray, taxType, state) {
  const changeData = state.menu.changeData.data;
  let newChanges = cloneDeep16(sourceArray);
  newChanges = newChanges.reduce((result, currentChange) => {
    const targetChange = targetArray.find(
      (element) => element.id === currentChange.id
    );
    let targetTax;
    if (taxType === "taxIds") {
      targetTax = changeData.menuTypeVersions[targetMenuTypeId].taxIds.includes(
        currentChange.id
      );
    } else {
      targetTax = currentChange.id in changeData.menuTypeVersions[targetMenuTypeId].inheritedTaxes[taxType];
    }
    if (!targetChange && !targetTax) {
      return currentChange.action === "add" ? [...result, currentChange] : result;
    }
    if (!targetChange && targetTax) {
      return currentChange.action === "remove" ? [...result, currentChange] : result;
    }
    if (targetChange && !targetTax) {
      return currentChange.action === "remove" ? [...result, currentChange] : result;
    }
    if (targetChange && targetTax) {
      return currentChange.action === "add" ? [...result, currentChange] : result;
    }
    return result;
  }, []);
  const newChangesIds = newChanges.map((change) => change.id);
  return [
    ...newChanges,
    ...targetArray.filter(
      (targetElement) => !newChangesIds.includes(targetElement.id)
    )
  ];
}
function addCategoriesSubcategoriesPropertiesAndOverWriteIfExist(sourceArray, targetMenuTypeId, targetArray, state) {
  const changeData = state.menu.changeData.data;
  let newChanges = cloneDeep16(sourceArray);
  newChanges = newChanges.reduce(
    (result, currentChange) => {
      const targetCategory = Object.entries(
        changeData.menuTypeVersions[targetMenuTypeId].categoriesSubcategories || {}
      ).find(
        (categorySubcategory) => categorySubcategory[1].categoryId === currentChange.value.categoryId
      );
      switch (currentChange.action) {
        case "update":
        case "remove":
          if (targetCategory) {
            return [
              ...result,
              __spreadProps(__spreadValues({}, currentChange), { id: Number(targetCategory[0]) })
            ];
          }
          break;
        case "add":
          if (targetCategory) {
            return targetCategory[1].subcategoryId === currentChange.value.subcategoryId ? result : [
              ...result,
              __spreadProps(__spreadValues({}, currentChange), {
                id: Number(targetCategory[0]),
                action: "update"
              })
            ];
          }
          return [
            ...result,
            __spreadProps(__spreadValues({}, currentChange), {
              id: null
            })
          ];
      }
      return result;
    },
    []
  );
  const newChangesIds = newChanges.map((change) => change.id);
  return [
    ...newChanges,
    ...targetArray.filter(
      (targetElement) => !newChangesIds.includes(targetElement.id)
    )
  ];
}
function addInheritedTaxesPropertiesAndOverWriteIfExist(sourceArray, targetMenuTypeId, targetArray, taxType, state) {
  if (taxType === "taxIds")
    return [];
  const changeData = state.menu.changeData.data;
  let newChanges = cloneDeep16(sourceArray);
  newChanges = newChanges.reduce((result, currentChange) => {
    const targetTax = currentChange.id in changeData.menuTypeVersions[targetMenuTypeId].inheritedTaxes[taxType];
    if (targetTax) {
      return [...result, currentChange];
    }
    return result;
  }, []);
  const newChangesIds = newChanges.map((change) => change.id);
  return [
    ...newChanges,
    ...targetArray.filter(
      (targetElement) => !newChangesIds.includes(targetElement.id)
    )
  ];
}
var getTotalPrices = (totalPrice, hasDefaultModifiersPrice, menuTypeVersion) => {
  if (!hasDefaultModifiersPrice) {
    totalPrice = menuTypeVersion.defaultModifiersPrice;
  }
  let itemPrice = totalPrice;
  let onlinePrice = totalPrice;
  let deliveryPrice = totalPrice;
  let toGoPrice = totalPrice;
  itemPrice = totalPrice + menuTypeVersion.itemPrice;
  onlinePrice = totalPrice + menuTypeVersion.onlinePrice;
  deliveryPrice = totalPrice + menuTypeVersion.deliveryPrice;
  toGoPrice = totalPrice + menuTypeVersion.toGoPrice;
  return [
    {
      field: "totalItemPrice",
      label: "",
      value: itemPrice,
      menuTypeVersionId: menuTypeVersion.menuTypeId,
      fo: true
    },
    {
      field: "totalOnlinePrice",
      label: "Online Price",
      value: onlinePrice,
      menuTypeVersionId: menuTypeVersion.menuTypeId,
      fo: true
    },
    {
      field: "totalDeliveryPrice",
      label: "Delivery Price",
      value: deliveryPrice,
      menuTypeVersionId: menuTypeVersion.menuTypeId,
      fo: true
    },
    {
      field: "totalToGoPrice",
      label: "To Go Price",
      value: toGoPrice,
      menuTypeVersionId: menuTypeVersion.menuTypeId,
      fo: true
    }
  ];
};
var filterChangesBySection = (formattedDiffArray, state) => {
  const categories = selectCategories(state);
  const subcategories = selectSubcategories(state);
  const basicChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(ItemBasicSectionFieldLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  );
  const associationsChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(ItemAssociationsSectionFieldLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  ).map((change) => {
    var _a, _b;
    if (change.field === "categoryId") {
      const categoryId = change.value;
      return __spreadProps(__spreadValues({}, change), {
        value: !categoryId ? null : categoryId,
        textValue: !categoryId ? i18n_config_default.t("commonTexts.none") : (_a = categories[categoryId]) == null ? void 0 : _a.name
      });
    } else if (change.field === "subcategoryId") {
      const subcategoryId = change.value;
      return __spreadProps(__spreadValues({}, change), {
        textValue: subcategoryId ? (_b = subcategories[subcategoryId]) == null ? void 0 : _b.name : i18n_config_default.t("commonTexts.none")
      });
    }
    return change;
  });
  const registerChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(ItemRegisterSectionFieldLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  );
  const moreInfoChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(ItemMoreInformationFieldLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  );
  const pricingChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(ItemPricingFieldLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  );
  const dimensionsChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(ItemDimensionsFieldLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  ).map((change) => {
    if (change.field === "dimensionsVolumeUnit") {
      return __spreadProps(__spreadValues({}, change), {
        textValue: i18n_config_default.t(
          `settingsModule.taxesSettings.taxesTable.unitTypes.${change.value}`
        )
      });
    } else if (change.field === "dimensionsWeightUnit") {
      return __spreadProps(__spreadValues({}, change), {
        textValue: i18n_config_default.t(
          `app.weightTypes.${change.value}`
        )
      });
    } else if (change.field === "dimensionsSellBy") {
      return __spreadProps(__spreadValues({}, change), {
        textValue: i18n_config_default.t(
          `menuScreen.itemDetails.dimensions.dimensionsSellBy.options.${change.value}`
        )
      });
    }
    return change;
  });
  const suggestiveOrderingChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(ItemSuggestiveOrderingLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  );
  const inventoryChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(ItemInventoryLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  ).map((change) => {
    if (change.field === "unit") {
      return __spreadProps(__spreadValues({}, change), {
        textValue: unitsText[change.value]
      });
    }
    return change;
  });
  const ingredientsExtraChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(ItemIngredientsExtraLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  );
  const modifierGroupsExtraChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(ItemModifierGroupsExtraLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  ).map((change) => {
    if (change.field === "allModsBehavior") {
      return __spreadProps(__spreadValues({}, change), {
        textValue: i18n_config_default.t(
          `menuScreen.itemDetails.modifierGroupsSection.allMods.allModsBehavior.options.${change.value}`
        )
      });
    }
    return change;
  });
  const prepStationChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(ItemPrepStationsChangesLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  );
  const guestCheckDisplayChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(ItemGuestCheckDisplayLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  );
  return {
    basicChanges,
    registerChanges,
    moreInfoChanges,
    pricingChanges,
    suggestiveOrderingChanges,
    inventoryChanges,
    modifierGroupsExtraChanges,
    prepStationChanges,
    ingredientsExtraChanges,
    guestCheckDisplayChanges,
    associationsChanges,
    dimensionsChanges
  };
};

// src/helpers/factories/menuDifferences/diffCombosFactory.ts
var ComboMasterFieldLabels = /* @__PURE__ */ ((ComboMasterFieldLabels2) => {
  ComboMasterFieldLabels2[ComboMasterFieldLabels2["name"] = 0] = "name";
  return ComboMasterFieldLabels2;
})(ComboMasterFieldLabels || {});
var ComboBasicSectionFieldLabels = /* @__PURE__ */ ((ComboBasicSectionFieldLabels2) => {
  ComboBasicSectionFieldLabels2[ComboBasicSectionFieldLabels2["posName"] = 0] = "posName";
  ComboBasicSectionFieldLabels2[ComboBasicSectionFieldLabels2["kdsName"] = 1] = "kdsName";
  ComboBasicSectionFieldLabels2[ComboBasicSectionFieldLabels2["checkName"] = 2] = "checkName";
  ComboBasicSectionFieldLabels2[ComboBasicSectionFieldLabels2["onlineName"] = 3] = "onlineName";
  ComboBasicSectionFieldLabels2[ComboBasicSectionFieldLabels2["allowSharing"] = 4] = "allowSharing";
  ComboBasicSectionFieldLabels2[ComboBasicSectionFieldLabels2["active"] = 5] = "active";
  ComboBasicSectionFieldLabels2[ComboBasicSectionFieldLabels2["activeOnline"] = 6] = "activeOnline";
  ComboBasicSectionFieldLabels2[ComboBasicSectionFieldLabels2["delivery"] = 7] = "delivery";
  ComboBasicSectionFieldLabels2[ComboBasicSectionFieldLabels2["imageUrl"] = 8] = "imageUrl";
  ComboBasicSectionFieldLabels2[ComboBasicSectionFieldLabels2["secondaryImageUrl"] = 9] = "secondaryImageUrl";
  ComboBasicSectionFieldLabels2[ComboBasicSectionFieldLabels2["defaultNoSeat"] = 10] = "defaultNoSeat";
  return ComboBasicSectionFieldLabels2;
})(ComboBasicSectionFieldLabels || {});
var ComboInventorySectionFieldLabels = /* @__PURE__ */ ((ComboInventorySectionFieldLabels2) => {
  ComboInventorySectionFieldLabels2[ComboInventorySectionFieldLabels2["volume"] = 0] = "volume";
  ComboInventorySectionFieldLabels2[ComboInventorySectionFieldLabels2["unit"] = 1] = "unit";
  return ComboInventorySectionFieldLabels2;
})(ComboInventorySectionFieldLabels || {});
var ComboRegisterSectionFieldLabels = /* @__PURE__ */ ((ComboRegisterSectionFieldLabels2) => {
  ComboRegisterSectionFieldLabels2[ComboRegisterSectionFieldLabels2["backgroundColor"] = 0] = "backgroundColor";
  ComboRegisterSectionFieldLabels2[ComboRegisterSectionFieldLabels2["textColor"] = 1] = "textColor";
  ComboRegisterSectionFieldLabels2[ComboRegisterSectionFieldLabels2["kdsColor"] = 2] = "kdsColor";
  ComboRegisterSectionFieldLabels2[ComboRegisterSectionFieldLabels2["specialTagId"] = 3] = "specialTagId";
  ComboRegisterSectionFieldLabels2[ComboRegisterSectionFieldLabels2["displayPictureOnCard"] = 4] = "displayPictureOnCard";
  ComboRegisterSectionFieldLabels2[ComboRegisterSectionFieldLabels2["displayComboPriceOnRegister"] = 5] = "displayComboPriceOnRegister";
  ComboRegisterSectionFieldLabels2[ComboRegisterSectionFieldLabels2["hideComboName"] = 6] = "hideComboName";
  ComboRegisterSectionFieldLabels2[ComboRegisterSectionFieldLabels2["transparentBackground"] = 7] = "transparentBackground";
  ComboRegisterSectionFieldLabels2[ComboRegisterSectionFieldLabels2["doneIsForTable"] = 8] = "doneIsForTable";
  return ComboRegisterSectionFieldLabels2;
})(ComboRegisterSectionFieldLabels || {});
var ComboPricingFieldLabels = /* @__PURE__ */ ((ComboPricingFieldLabels2) => {
  ComboPricingFieldLabels2[ComboPricingFieldLabels2["comboBasePrice"] = 0] = "comboBasePrice";
  ComboPricingFieldLabels2[ComboPricingFieldLabels2["taxInclusive"] = 1] = "taxInclusive";
  ComboPricingFieldLabels2[ComboPricingFieldLabels2["onlinePrice"] = 2] = "onlinePrice";
  ComboPricingFieldLabels2[ComboPricingFieldLabels2["deliveryPrice"] = 3] = "deliveryPrice";
  ComboPricingFieldLabels2[ComboPricingFieldLabels2["excludeFromSuggestedTip"] = 4] = "excludeFromSuggestedTip";
  ComboPricingFieldLabels2[ComboPricingFieldLabels2["excludeFromDiscounts"] = 5] = "excludeFromDiscounts";
  ComboPricingFieldLabels2[ComboPricingFieldLabels2["removeFromCheck"] = 6] = "removeFromCheck";
  ComboPricingFieldLabels2[ComboPricingFieldLabels2["toGoPrice"] = 7] = "toGoPrice";
  return ComboPricingFieldLabels2;
})(ComboPricingFieldLabels || {});
var ComboMoreInformationFieldLabels = /* @__PURE__ */ ((ComboMoreInformationFieldLabels2) => {
  ComboMoreInformationFieldLabels2[ComboMoreInformationFieldLabels2["description"] = 0] = "description";
  ComboMoreInformationFieldLabels2[ComboMoreInformationFieldLabels2["onlineDescription"] = 1] = "onlineDescription";
  return ComboMoreInformationFieldLabels2;
})(ComboMoreInformationFieldLabels || {});
var ComboItemGroupsFieldLabels = /* @__PURE__ */ ((ComboItemGroupsFieldLabels2) => {
  ComboItemGroupsFieldLabels2[ComboItemGroupsFieldLabels2["posName"] = 0] = "posName";
  ComboItemGroupsFieldLabels2[ComboItemGroupsFieldLabels2["required"] = 1] = "required";
  ComboItemGroupsFieldLabels2[ComboItemGroupsFieldLabels2["sortPriority"] = 2] = "sortPriority";
  ComboItemGroupsFieldLabels2[ComboItemGroupsFieldLabels2["quantity"] = 3] = "quantity";
  ComboItemGroupsFieldLabels2[ComboItemGroupsFieldLabels2["active"] = 4] = "active";
  return ComboItemGroupsFieldLabels2;
})(ComboItemGroupsFieldLabels || {});
var ComboItemsOfItemGroupFieldLabels = /* @__PURE__ */ ((ComboItemsOfItemGroupFieldLabels2) => {
  ComboItemsOfItemGroupFieldLabels2[ComboItemsOfItemGroupFieldLabels2["active"] = 0] = "active";
  ComboItemsOfItemGroupFieldLabels2[ComboItemsOfItemGroupFieldLabels2["additionalPrice"] = 1] = "additionalPrice";
  ComboItemsOfItemGroupFieldLabels2[ComboItemsOfItemGroupFieldLabels2["sortPriority"] = 2] = "sortPriority";
  return ComboItemsOfItemGroupFieldLabels2;
})(ComboItemsOfItemGroupFieldLabels || {});
var ComboAssociationsSectionFieldLabels = /* @__PURE__ */ ((ComboAssociationsSectionFieldLabels2) => {
  ComboAssociationsSectionFieldLabels2[ComboAssociationsSectionFieldLabels2["categoryId"] = 0] = "categoryId";
  ComboAssociationsSectionFieldLabels2[ComboAssociationsSectionFieldLabels2["subcategoryId"] = 1] = "subcategoryId";
  return ComboAssociationsSectionFieldLabels2;
})(ComboAssociationsSectionFieldLabels || {});
var SORT_PRIORITY_FIELD2 = "sortPriority";
var returnLabel2 = (field, depth) => {
  if (depth === 1) {
    if (field in ComboMasterFieldLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.master.${field}`
      );
    }
  } else if (depth === 3) {
    if (field in ComboAssociationsSectionFieldLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.master.${field}`
      );
    } else if (field in ComboBasicSectionFieldLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.basic.${field}`
      );
    } else if (field in ComboRegisterSectionFieldLabels) {
      return i18n_config_default.t(
        field === "displayPictureOnCard" ? "app.modals.combosDiff.registerInfo.displayPictureOnCard" : `app.modals.itemsDiff.registerInfo.${field}`
      );
    } else if (field in ComboMoreInformationFieldLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.moreInfo.${field}`
      );
    } else if (field in ComboPricingFieldLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.pricing.${field}`
      );
    } else if (field in ComboInventorySectionFieldLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.inventory.${field}`
      );
    }
  } else if (depth === 5) {
    if (field in ComboItemGroupsFieldLabels) {
      return i18n_config_default.t(
        `app.modals.combosDiff.itemGroup.${field}`
      );
    }
  } else if (depth === 7) {
    if (field in ComboItemsOfItemGroupFieldLabels) {
      return i18n_config_default.t(
        `app.modals.combosDiff.itemOfItemGroup.${field}`
      );
    }
  }
};
var MENU_TYPE_VERSION_DIFF_INITIAL = {
  label: "",
  id: 0,
  action: "remove",
  totalOfChanges: 0,
  sections: {
    basic: [],
    register: [],
    pricing: [],
    inventory: [],
    moreInfo: [],
    itemGroups: [],
    taxes: {},
    associations: [],
    // TODO: add categories logic
    categoriesSubcategories: []
  }
};
var diffCombosFactory = (diffArray, state) => {
  if (diffArray.length > 0) {
    const comboId = state.menu.changeData.id;
    const menuTypeVersions = generateMenuTypeVersionsArray(diffArray, state);
    addTotalChanges(menuTypeVersions);
    const diffObject = {
      comboId,
      masterChanges: generateMasterChangesArray(diffArray, state),
      menuTypeVersions
    };
    return diffObject;
  }
  return null;
};
var generateMasterChangesArray = (diffArray, state) => {
  const currentMenu = state.menu.selectedMode.currentMenu;
  const originalData = selectOriginalMenuData(state);
  const { data } = state.menu.changeData;
  const masterChanges = [];
  const itemLocationIds = originalData.locationIds;
  const locationIds = data.locationIds;
  const hasSomeLocationIds = diffArray.filter((diff11) => diff11.path[0] === "locationIds").length > 0 ? true : false;
  const locationValues = getLocationsChanges(
    hasSomeLocationIds,
    itemLocationIds,
    locationIds,
    state
  );
  const locationsChanges = {
    field: "locationIds",
    label: i18n_config_default.t("app.modals.itemsDiff.master.locationIds"),
    value: locationValues,
    menuTypeVersionId: 0
  };
  diffArray.forEach(
    (diff11) => filterDiffFunction(
      diff11,
      ({ field, diffLength, newDiff }) => {
        if (diffLength !== 1) {
          return;
        }
        if (field in ComboMasterFieldLabels) {
          if (field === "subcategoryId" && Number(newDiff.value) === 0) {
            return;
          }
          if (field === "categoryId") {
            const categoryName = currentMenu.categories[Number(newDiff.value)].name;
            masterChanges.push(__spreadProps(__spreadValues({}, newDiff), { textValue: categoryName }));
          } else if (field === "subcategoryId") {
            const subcategoryName = currentMenu.subcategories[Number(newDiff.value)].name;
            masterChanges.push(__spreadProps(__spreadValues({}, newDiff), { textValue: subcategoryName }));
          } else {
            masterChanges.push(newDiff);
          }
        }
      },
      returnLabel2
    )
  );
  if (locationValues.length > 0) {
    masterChanges.push(locationsChanges);
  }
  return masterChanges;
};
var getArraysByAction2 = (diffArray, menuTypeId) => {
  const {
    addedMenuTypesDiff,
    removedMenuTypesDiff,
    changedMenuTypeFieldsDiff
  } = getMenuTypeArraysByAction(diffArray, menuTypeId);
  const addedItemGroups = diffArray.filter(
    (diff11) => diff11.path.length === 4 && diff11.path[2] === "itemGroups" && diff11.kind === "N" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const removedItemGroups = diffArray.filter(
    (diff11) => diff11.path.length === 4 && diff11.path[2] === "itemGroups" && diff11.kind === "D" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const changedItemGroupFields = diffArray.filter(
    (diff11) => diff11.path.length === 5 && diff11.path[2] === "itemGroups" && diff11.kind === "E" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const removedItemGroupItems = diffArray.filter(
    (diff11) => diff11.path.length === 6 && diff11.path[2] === "itemGroups" && diff11.kind === "D" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const addedItemGroupItems = diffArray.filter(
    (diff11) => diff11.path.length === 6 && diff11.path[2] === "itemGroups" && diff11.kind === "N" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const changedItemGroupItemFields = diffArray.filter(
    (diff11) => diff11.path.length === 7 && diff11.path[2] === "itemGroups" && diff11.kind === "E" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  return {
    addedMenuTypesDiff,
    removedMenuTypesDiff,
    addedItemGroups,
    removedItemGroups,
    changedMenuTypeFieldsDiff: changedMenuTypeFieldsDiff.filter(
      (change) => change.path[2] !== "locationIds" && change.path[2] !== "categoriesSubcategories"
    ),
    changedItemGroupFields,
    removedItemGroupItems,
    addedItemGroupItems,
    changedItemGroupItemFields
  };
};
var generateMenuTypeVersionsArray = (diffArray, state) => {
  const changeData = state.menu.changeData.data;
  const currentMenu = selectMenu(state);
  const { menuTypes, items } = currentMenu;
  const menuTypeVersions = [];
  const {
    addedMenuTypesDiff,
    removedMenuTypesDiff,
    addedItemGroups,
    removedItemGroups,
    changedMenuTypeFieldsDiff,
    changedItemGroupFields,
    removedItemGroupItems,
    addedItemGroupItems,
    changedItemGroupItemFields
  } = getArraysByAction2(diffArray);
  addedMenuTypesDiff.forEach((diff11) => {
    menuTypeVersions.push(
      menuTypeObjToDiff(diff11.rhs, state)
    );
  });
  removedMenuTypesDiff.forEach((diff11) => {
    const menuTypeVersionId = Number(diff11.path[1]);
    menuTypeVersions.push(__spreadProps(__spreadValues({}, cloneDeep16(MENU_TYPE_VERSION_DIFF_INITIAL)), {
      label: menuTypes[menuTypeVersionId].name,
      id: menuTypeVersionId,
      action: "remove"
    }));
  });
  const getMenuTypeVersionEditIndex = (menuTypeVersionId) => {
    return menuTypeVersions.findIndex(
      (menuTypeVersion) => menuTypeVersion.action === "update" && menuTypeVersion.id === menuTypeVersionId
    );
  };
  const getItemGroupEditIndex = (menuTypeVersionId, itemGroupId) => {
    const menuTypeVersionIndex = getMenuTypeVersionEditIndex(menuTypeVersionId);
    if (menuTypeVersionIndex < 0) {
      return menuTypeVersionIndex;
    }
    return menuTypeVersions[menuTypeVersionIndex].sections.itemGroups.findIndex(
      (itemGroup) => itemGroup.action === "update" && itemGroup.id === itemGroupId
    );
  };
  const getItemOfItemGroupEditIndex = (menuTypeVersionId, itemGroupId, itemId) => {
    const menuTypeVersionIndex = getMenuTypeVersionEditIndex(menuTypeVersionId);
    if (menuTypeVersionIndex < 0) {
      return menuTypeVersionIndex;
    }
    const itemGroupIndex = getItemGroupEditIndex(
      menuTypeVersionId,
      itemGroupId
    );
    if (itemGroupIndex < 0) {
      return itemGroupIndex;
    }
    return menuTypeVersions[menuTypeVersionIndex].sections.itemGroups[itemGroupIndex].itemsChanged.findIndex(
      (itemOfItemGroup) => itemOfItemGroup.action === "update" && itemOfItemGroup.id === itemId
    );
  };
  const addItemGroupChange = (change, menuTypeVersionId) => {
    const clonedInitialMenuTypeVersion = cloneDeep16(
      MENU_TYPE_VERSION_DIFF_INITIAL
    );
    const menuTypeVersionIndex = getMenuTypeVersionEditIndex(menuTypeVersionId);
    const hasMenuTypeVersionEdit = menuTypeVersionIndex >= 0;
    if (hasMenuTypeVersionEdit) {
      menuTypeVersions[menuTypeVersionIndex].sections.itemGroups.push(change);
    } else {
      menuTypeVersions.push(__spreadProps(__spreadValues({}, clonedInitialMenuTypeVersion), {
        label: menuTypes[menuTypeVersionId].name,
        id: menuTypeVersionId,
        action: "update",
        sections: __spreadProps(__spreadValues({}, clonedInitialMenuTypeVersion.sections), {
          itemGroups: [change]
        })
      }));
    }
  };
  const addItemOfItemGroupChange = (change, menuTypeVersionId, itemGroupId) => {
    const clonedInitialMenuTypeVersion = cloneDeep16(
      MENU_TYPE_VERSION_DIFF_INITIAL
    );
    const itemGroupName = changeData.menuTypeVersions[menuTypeVersionId].itemGroups[itemGroupId].posName;
    const menuTypeVersionIndex = getMenuTypeVersionEditIndex(menuTypeVersionId);
    const itemGroupIndex = getItemGroupEditIndex(
      menuTypeVersionId,
      itemGroupId
    );
    const hasMenuTypeVersionEdit = menuTypeVersionIndex >= 0;
    const hasItemGroupEdit = itemGroupIndex >= 0;
    const itemGroupChange = {
      label: itemGroupName,
      id: itemGroupId,
      action: "update",
      changes: [],
      itemsChanged: [change]
    };
    if (hasMenuTypeVersionEdit && hasItemGroupEdit) {
      menuTypeVersions[menuTypeVersionIndex].sections.itemGroups[itemGroupIndex].itemsChanged.push(change);
    } else if (hasMenuTypeVersionEdit && !hasItemGroupEdit) {
      menuTypeVersions[menuTypeVersionIndex].sections.itemGroups.push(
        itemGroupChange
      );
    } else {
      menuTypeVersions.push(__spreadProps(__spreadValues({}, clonedInitialMenuTypeVersion), {
        label: menuTypes[menuTypeVersionId].name,
        id: menuTypeVersionId,
        action: "update",
        sections: __spreadProps(__spreadValues({}, clonedInitialMenuTypeVersion.sections), {
          itemGroups: [itemGroupChange]
        })
      }));
    }
  };
  addedItemGroups.forEach((diff11) => {
    const menuTypeVersionId = Number(diff11.path[1]);
    const itemGroupObj = diff11.rhs;
    const itemGroupDiff = itemGroupObjToDiff(
      itemGroupObj,
      menuTypeVersionId,
      state
    );
    addItemGroupChange(itemGroupDiff, menuTypeVersionId);
  });
  removedItemGroups.forEach((diff11) => {
    const menuTypeVersionId = Number(diff11.path[1]);
    const itemGroupId = Number(diff11.path[3]);
    const itemGroupObj = diff11.lhs;
    addItemGroupChange(
      {
        label: itemGroupObj.posName,
        id: itemGroupId,
        action: "remove",
        changes: [],
        itemsChanged: []
      },
      menuTypeVersionId
    );
  });
  addedItemGroupItems.forEach((diff11) => {
    const menuTypeVersionId = Number(diff11.path[1]);
    const itemGroupId = Number(diff11.path[3]);
    const itemOfItemGroupObj = diff11.rhs;
    const itemGroupDiff = itemOfItemGroupObjToDiff(
      itemOfItemGroupObj,
      menuTypeVersionId,
      state
    );
    addItemOfItemGroupChange(itemGroupDiff, menuTypeVersionId, itemGroupId);
  });
  removedItemGroupItems.forEach((diff11) => {
    const menuTypeVersionId = Number(diff11.path[1]);
    const itemGroupId = Number(diff11.path[3]);
    const itemOfItemGroupObj = diff11.lhs;
    const item = items[itemOfItemGroupObj.itemId];
    addItemOfItemGroupChange(
      {
        label: item.name,
        id: itemOfItemGroupObj.itemId,
        action: "remove",
        changes: []
      },
      menuTypeVersionId,
      itemGroupId
    );
  });
  const reduceChangesFunction = (prevDiff, currentDiff, additionalData) => {
    return filterDiffFunction(
      currentDiff,
      ({ field, newDiff }) => {
        const menuTypeVersionId = Number(currentDiff.path[1]);
        if (prevDiff[menuTypeVersionId]) {
          return __spreadProps(__spreadValues({}, prevDiff), {
            [menuTypeVersionId]: __spreadProps(__spreadValues({}, prevDiff[menuTypeVersionId]), {
              [field]: newDiff.value
            })
          });
        } else {
          return __spreadProps(__spreadValues({}, prevDiff), {
            [menuTypeVersionId]: __spreadProps(__spreadValues({}, additionalData), {
              [field]: newDiff.value
            })
          });
        }
      },
      returnLabel2
    );
  };
  const reduceItemGroupChangesFunction = (prevDiff, currentDiff, itemGroupId) => {
    return filterDiffFunction(
      currentDiff,
      ({ field, newDiff }) => {
        const menuTypeVersionId = Number(currentDiff.path[1]);
        const hasMenuTypeVersion = prevDiff[menuTypeVersionId];
        const hasItemGroup = hasMenuTypeVersion && prevDiff[menuTypeVersionId][itemGroupId];
        if (hasMenuTypeVersion && hasItemGroup) {
          return __spreadProps(__spreadValues({}, prevDiff), {
            [menuTypeVersionId]: __spreadProps(__spreadValues({}, prevDiff[menuTypeVersionId]), {
              [itemGroupId]: __spreadProps(__spreadValues({}, prevDiff[menuTypeVersionId][itemGroupId]), {
                [field]: newDiff.value,
                itemGroupId
              })
            })
          });
        } else if (hasMenuTypeVersion && !hasItemGroup) {
          return __spreadProps(__spreadValues({}, prevDiff), {
            [menuTypeVersionId]: __spreadProps(__spreadValues({}, prevDiff[menuTypeVersionId]), {
              [itemGroupId]: {
                [field]: newDiff.value,
                itemGroupId
              }
            })
          });
        } else {
          return __spreadProps(__spreadValues({}, prevDiff), {
            [menuTypeVersionId]: {
              [itemGroupId]: {
                itemGroupId,
                [field]: newDiff.value
              }
            }
          });
        }
      },
      returnLabel2
    );
  };
  const reduceItemsChangesFunction = (prevDiff, currentDiff) => {
    return filterDiffFunction(
      currentDiff,
      ({ field, newDiff }) => {
        const menuTypeVersionId = Number(currentDiff.path[1]);
        const itemGroupId = Number(currentDiff.path[3]);
        const itemId = Number(currentDiff.path[5]);
        const clonedPrev = cloneDeep16(prevDiff);
        if (!get(
          clonedPrev,
          `${menuTypeVersionId}.${itemGroupId}.${itemId}.itemId`
        )) {
          setWith(
            clonedPrev,
            `${menuTypeVersionId}.${itemGroupId}.${itemId}.itemId`,
            itemId,
            Object
          );
        }
        setWith(
          clonedPrev,
          `${menuTypeVersionId}.${itemGroupId}.${itemId}.${field}`,
          newDiff.value,
          Object
        );
        return clonedPrev;
      },
      returnLabel2
    );
  };
  const changedMenuTypeReduced = changedMenuTypeFieldsDiff.reduce(
    (prevValue, currentValue) => {
      const menuTypeVersionId = Number(currentValue.path[1]);
      return reduceChangesFunction(prevValue, currentValue, {
        menuTypeId: menuTypeVersionId
      });
    },
    {}
  );
  Object.entries(changedMenuTypeReduced).forEach(
    ([menuTypeVersionId, menuTypeVersionObj]) => {
      const menuTypeVersionIndex = getMenuTypeVersionEditIndex(
        Number(menuTypeVersionId)
      );
      const hasMenuTypeVersionEdit = menuTypeVersionIndex >= 0;
      const menuTypeVersionDiff = menuTypeObjToDiff(
        menuTypeVersionObj,
        state
      );
      if (hasMenuTypeVersionEdit) {
        menuTypeVersions[menuTypeVersionIndex] = __spreadProps(__spreadValues({}, menuTypeVersions[menuTypeVersionIndex]), {
          sections: {
            basic: [
              ...menuTypeVersions[menuTypeVersionIndex].sections.basic,
              ...menuTypeVersionDiff.sections.basic
            ],
            associations: [
              ...menuTypeVersions[menuTypeVersionIndex].sections.associations,
              ...menuTypeVersionDiff.sections.associations
            ],
            register: [
              ...menuTypeVersions[menuTypeVersionIndex].sections.register,
              ...menuTypeVersionDiff.sections.register
            ],
            pricing: [
              ...menuTypeVersions[menuTypeVersionIndex].sections.pricing,
              ...menuTypeVersionDiff.sections.pricing
            ],
            inventory: [
              ...menuTypeVersions[menuTypeVersionIndex].sections.inventory,
              ...menuTypeVersionDiff.sections.inventory
            ],
            taxes: {},
            moreInfo: [
              ...menuTypeVersions[menuTypeVersionIndex].sections.moreInfo,
              ...menuTypeVersionDiff.sections.moreInfo
            ],
            itemGroups: [
              ...menuTypeVersions[menuTypeVersionIndex].sections.itemGroups,
              ...menuTypeVersionDiff.sections.itemGroups
            ],
            categoriesSubcategories: []
            // categoriesSubcategories: generateCategoriesAndSubcategoriesChanges(
            //   diffArray,
            //   currentMenu,
            //   menuTypeVersionId,
            //   state,
            // ),
          }
        });
      } else {
        menuTypeVersions.push(__spreadProps(__spreadValues({}, menuTypeVersionDiff), {
          action: "update",
          totalOfChanges: 0
        }));
      }
    }
  );
  const changedItemGroupsReduced = changedItemGroupFields.reduce(
    (prevValue, currentValue) => {
      const itemGroupId = Number(currentValue.path[3]);
      return reduceItemGroupChangesFunction(
        prevValue,
        currentValue,
        itemGroupId
      );
    },
    {}
  );
  Object.entries(changedItemGroupsReduced).forEach(
    ([menuTypeVersionId, itemGroups]) => {
      Object.entries(itemGroups).forEach(
        ([itemGroupId, itemGroupObj]) => {
          const clonedInitialMenuTypeVersion = cloneDeep16(
            MENU_TYPE_VERSION_DIFF_INITIAL
          );
          const itemGroupObjTyped = itemGroupObj;
          const itemGroupIdNumber = Number(itemGroupId);
          const menuTypeVersionIdNumber = Number(menuTypeVersionId);
          const menuTypeVersionIndex = getMenuTypeVersionEditIndex(
            menuTypeVersionIdNumber
          );
          const itemGroupIndex = getItemGroupEditIndex(
            menuTypeVersionIdNumber,
            itemGroupIdNumber
          );
          const hasMenuTypeVersionEdit = menuTypeVersionIndex >= 0;
          const hasItemGroupEdit = itemGroupIndex >= 0;
          const itemGroupDiff = __spreadProps(__spreadValues({}, itemGroupObjToDiff(
            itemGroupObjTyped,
            menuTypeVersionIdNumber,
            state
          )), {
            action: "update",
            label: changeData.menuTypeVersions[menuTypeVersionIdNumber].itemGroups[itemGroupIdNumber].posName
          });
          if (hasMenuTypeVersionEdit && hasItemGroupEdit) {
            menuTypeVersions[menuTypeVersionIndex].sections.itemGroups[itemGroupIndex].changes.push(...itemGroupDiff.changes);
          } else if (hasMenuTypeVersionEdit && !hasItemGroupEdit) {
            menuTypeVersions[menuTypeVersionIndex].sections.itemGroups.push(
              itemGroupDiff
            );
          } else {
            menuTypeVersions.push(__spreadProps(__spreadValues({}, clonedInitialMenuTypeVersion), {
              label: menuTypes[menuTypeVersionIdNumber].name,
              id: menuTypeVersionIdNumber,
              action: "update",
              sections: __spreadProps(__spreadValues({}, clonedInitialMenuTypeVersion.sections), {
                itemGroups: [itemGroupDiff]
              })
            }));
          }
        }
      );
    }
  );
  const changedItemGroupsItemReduced = changedItemGroupItemFields.reduce(
    reduceItemsChangesFunction,
    {}
  );
  Object.entries(changedItemGroupsItemReduced).forEach(
    ([menuTypeVersionId, menuTypeVersionObj]) => {
      Object.entries(menuTypeVersionObj).forEach(
        ([itemGroupId, itemGroupObj]) => {
          Object.entries(itemGroupObj).forEach(([, itemOfItemGroupObj]) => {
            const clonedInitialMenuTypeVersion = cloneDeep16(
              MENU_TYPE_VERSION_DIFF_INITIAL
            );
            const itemOfItemGroupObjTyped = itemOfItemGroupObj;
            const itemGroupIdNumber = Number(itemGroupId);
            const menuTypeVersionIdNumber = Number(menuTypeVersionId);
            const menuTypeVersionIndex = getMenuTypeVersionEditIndex(
              menuTypeVersionIdNumber
            );
            const itemGroupIndex = getItemGroupEditIndex(
              menuTypeVersionIdNumber,
              itemGroupIdNumber
            );
            const itemOfItemGroupIndex = getItemOfItemGroupEditIndex(
              menuTypeVersionIdNumber,
              itemGroupIdNumber,
              itemOfItemGroupObjTyped.itemId
            );
            const hasMenuTypeVersionEdit = menuTypeVersionIndex >= 0;
            const hasItemGroupEdit = itemGroupIndex >= 0;
            const hasItemOfItemGroupEdit = itemOfItemGroupIndex >= 0;
            const itemOfItemGroupDiff = __spreadProps(__spreadValues({}, itemOfItemGroupObjToDiff(
              itemOfItemGroupObjTyped,
              menuTypeVersionIdNumber,
              state
            )), {
              action: "update"
            });
            const itemGroupDiff = __spreadProps(__spreadValues({}, itemGroupObjToDiff(
              {
                posName: changeData.menuTypeVersions[menuTypeVersionIdNumber].itemGroups[itemGroupIdNumber].posName,
                itemGroupId: itemGroupIdNumber,
                items: {
                  [itemOfItemGroupObjTyped.itemId]: itemOfItemGroupObjTyped
                }
              },
              menuTypeVersionIdNumber,
              state
            )), {
              action: "update",
              changes: []
            });
            itemGroupDiff.itemsChanged[0].action = "update";
            if (hasMenuTypeVersionEdit && hasItemGroupEdit && hasItemOfItemGroupEdit) {
              menuTypeVersions[menuTypeVersionIndex].sections.itemGroups[itemGroupIndex].itemsChanged[itemOfItemGroupIndex].changes.push(
                ...itemOfItemGroupDiff.changes
              );
            } else if (hasMenuTypeVersionEdit && hasItemGroupEdit && !hasItemOfItemGroupEdit) {
              menuTypeVersions[menuTypeVersionIndex].sections.itemGroups[itemGroupIndex].itemsChanged.push(__spreadProps(__spreadValues({}, itemOfItemGroupDiff), {
                action: "update"
              }));
            } else if (hasMenuTypeVersionEdit && !hasItemGroupEdit && !hasItemOfItemGroupEdit) {
              menuTypeVersions[menuTypeVersionIndex].sections.itemGroups.push(
                itemGroupDiff
              );
            } else {
              menuTypeVersions.push(__spreadProps(__spreadValues({}, clonedInitialMenuTypeVersion), {
                label: menuTypes[menuTypeVersionIdNumber].name,
                id: menuTypeVersionIdNumber,
                action: "update",
                sections: __spreadProps(__spreadValues({}, clonedInitialMenuTypeVersion.sections), {
                  itemGroups: [itemGroupDiff]
                })
              }));
            }
          });
        }
      );
    }
  );
  const menuTypeVersionIds = [];
  diffArray.filter((diff11) => diff11.path.length >= 2 && diff11.path[0] !== "locationIds").forEach((diff11) => {
    const menuTypeVersionId = Number(diff11.path[1]);
    if (!menuTypeVersionIds.includes(menuTypeVersionId))
      menuTypeVersionIds.push(menuTypeVersionId);
  });
  menuTypeVersionIds.forEach((menuTypeVersionId) => {
    const taxesChanges = generateTaxesChanges(
      diffArray,
      menuTypeVersionId.toString(),
      state,
      true
    );
    if (Object.keys(taxesChanges).length > 0) {
      const menuTypeVersionIndex = getMenuTypeVersionEditIndex(
        Number(menuTypeVersionId)
      );
      if (menuTypeVersionIndex >= 0) {
        menuTypeVersions[menuTypeVersionIndex].sections.taxes = taxesChanges;
      } else {
        const menuTypeVersionDiff = menuTypeObjToDiff(
          {
            menuTypeId: menuTypeVersionId
          },
          state
        );
        menuTypeVersions.push(__spreadProps(__spreadValues({}, __spreadProps(__spreadValues({}, menuTypeVersionDiff), {
          sections: __spreadProps(__spreadValues({}, menuTypeVersionDiff.sections), { taxes: taxesChanges })
        })), {
          action: "update",
          totalOfChanges: 0
        }));
      }
    }
  });
  menuTypeVersionIds.forEach((menuTypeVersionId) => {
    var _a;
    const categoriesSubcategories = generateCategoriesAndSubcategoriesChanges(
      diffArray,
      currentMenu,
      (_a = menuTypeVersionId != null ? menuTypeVersionId : 0) == null ? void 0 : _a.toString(),
      state,
      false
    );
    if (!categoriesSubcategories.length)
      return;
    const menuTypeVersionIndex = getMenuTypeVersionEditIndex(menuTypeVersionId);
    if (menuTypeVersionIndex < 0) {
      const menuTypeVersionDiff = menuTypeObjToDiff(
        {
          menuTypeId: menuTypeVersionId
        },
        state
      );
      menuTypeVersions.push(__spreadProps(__spreadValues({}, __spreadProps(__spreadValues({}, menuTypeVersionDiff), {
        sections: __spreadProps(__spreadValues({}, menuTypeVersionDiff.sections), {
          categoriesSubcategories
        })
      })), {
        action: "update",
        totalOfChanges: 0
      }));
    } else {
      menuTypeVersions[menuTypeVersionIndex].sections.categoriesSubcategories = categoriesSubcategories;
    }
  });
  return menuTypeVersions;
};
var menuTypeObjToDiff = (menuTypeVersion, state) => {
  const menuTypes = selectMenuTypes(state);
  const subcategories = selectSubcategories(state);
  const categories = selectCategories(state);
  const ITEM_GROUPS_FIELD = "itemGroups";
  const menuTypeVersionId = menuTypeVersion.menuTypeId;
  const menuTypeVersionDiff = __spreadProps(__spreadValues({}, cloneDeep16(MENU_TYPE_VERSION_DIFF_INITIAL)), {
    label: menuTypes[menuTypeVersionId].name,
    id: menuTypeVersionId,
    action: "add"
  });
  Object.entries(menuTypeVersion).forEach(([key, value]) => {
    var _a, _b;
    const diff11 = {
      field: key,
      label: returnLabel2(key, 3) || "",
      value,
      menuTypeVersionId
    };
    if (key in ComboBasicSectionFieldLabels) {
      menuTypeVersionDiff.sections.basic.push(diff11);
    } else if (key in ComboAssociationsSectionFieldLabels) {
      if (diff11.field === "categoryId") {
        const categoryId = diff11.value;
        return menuTypeVersionDiff.sections.associations.push(__spreadProps(__spreadValues({}, diff11), {
          value: !categoryId ? null : categoryId,
          textValue: !categoryId ? i18n_config_default.t("commonTexts.none") : (_a = categories[categoryId]) == null ? void 0 : _a.name
        }));
      } else if (diff11.field === "subcategoryId") {
        return menuTypeVersionDiff.sections.associations.push(__spreadProps(__spreadValues({}, diff11), {
          textValue: diff11.value ? (_b = subcategories[diff11.value]) == null ? void 0 : _b.name : i18n_config_default.t("commonTexts.none")
        }));
      }
      menuTypeVersionDiff.sections.associations.push(diff11);
    } else if (key in ComboRegisterSectionFieldLabels) {
      menuTypeVersionDiff.sections.register.push(diff11);
    } else if (key in ComboMoreInformationFieldLabels) {
      menuTypeVersionDiff.sections.moreInfo.push(diff11);
    } else if (key in ComboPricingFieldLabels) {
      menuTypeVersionDiff.sections.pricing.push(diff11);
    } else if (key in ComboInventorySectionFieldLabels) {
      if (diff11.field === "unit") {
        return menuTypeVersionDiff.sections.inventory.push(__spreadProps(__spreadValues({}, diff11), {
          textValue: unitsText[diff11.value]
        }));
      }
      menuTypeVersionDiff.sections.inventory.push(diff11);
    } else if (key === ITEM_GROUPS_FIELD) {
      Object.values(value).forEach((itemGroup) => {
        menuTypeVersionDiff.sections.itemGroups.push(
          itemGroupObjToDiff(
            itemGroup,
            menuTypeVersionId,
            state
          )
        );
      });
    } else if (key === "categoriesSubcategories") {
      menuTypeVersionDiff.sections.categoriesSubcategories = createCategorySubcategoryMultiAddDiff(
        value,
        state.menu.selectedMode.currentMenu
      );
    }
  });
  menuTypeVersionDiff.sections.taxes = formatItemNewTaxes(
    menuTypeVersion.inheritedTaxes || {},
    menuTypeVersion.taxIds || [],
    state
  );
  return menuTypeVersionDiff;
};
var itemGroupObjToDiff = (itemGroup, menuTypeVersionId, state) => {
  const ITEMS_FIELD = "items";
  const itemGroupDiff = {
    label: itemGroup.posName || "",
    id: itemGroup.itemGroupId || 0,
    action: "add",
    changes: [],
    itemsChanged: []
  };
  Object.entries(itemGroup).forEach(([key, value]) => {
    const diff11 = {
      field: key,
      label: returnLabel2(key, 5) || "",
      value: typeof value === "object" ? "" : value,
      menuTypeVersionId
    };
    if (key in ComboItemGroupsFieldLabels) {
      itemGroupDiff.changes.push(diff11);
    } else if (key === ITEMS_FIELD) {
      Object.values(value || {}).forEach((item) => {
        itemGroupDiff.itemsChanged.push(
          itemOfItemGroupObjToDiff(
            item,
            menuTypeVersionId,
            state
          )
        );
      });
    }
  });
  return itemGroupDiff;
};
var itemOfItemGroupObjToDiff = (item, menuTypeVersionId, state) => {
  const items = state.menu.selectedMode.currentMenu.items;
  const menuItem = items[item.itemId];
  const itemGroupDiff = {
    label: menuItem.name,
    id: item.itemId,
    changes: [],
    action: "add"
  };
  Object.entries(item).forEach(([key, value]) => {
    const diff11 = {
      field: key,
      label: returnLabel2(key, 7) || "",
      value,
      menuTypeVersionId
    };
    if (key in ComboItemsOfItemGroupFieldLabels) {
      itemGroupDiff.changes.push(diff11);
    }
  });
  return itemGroupDiff;
};
var addTotalChanges = (menuTypeVersions) => {
  const immediateAdditionActions = ["add", "remove"];
  menuTypeVersions.forEach((menuTypeVersionDiff) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    menuTypeVersionDiff.totalOfChanges = menuTypeVersionDiff.totalOfChanges + menuTypeVersionDiff.sections.basic.length + menuTypeVersionDiff.sections.associations.length + menuTypeVersionDiff.sections.categoriesSubcategories.length + menuTypeVersionDiff.sections.register.length + menuTypeVersionDiff.sections.pricing.length + menuTypeVersionDiff.sections.inventory.length + menuTypeVersionDiff.sections.moreInfo.length + (((_a = menuTypeVersionDiff.sections.taxes) == null ? void 0 : _a.taxIds) ? (_b = menuTypeVersionDiff.sections.taxes) == null ? void 0 : _b.taxIds.length : 0) + (((_c = menuTypeVersionDiff.sections.taxes) == null ? void 0 : _c.menuTypeInheritedTaxes) ? (_d = menuTypeVersionDiff.sections.taxes) == null ? void 0 : _d.menuTypeInheritedTaxes.length : 0) + (((_e = menuTypeVersionDiff.sections.taxes) == null ? void 0 : _e.categoryInheritedTaxes) ? (_f = menuTypeVersionDiff.sections.taxes) == null ? void 0 : _f.categoryInheritedTaxes.length : 0) + (((_g = menuTypeVersionDiff.sections.taxes) == null ? void 0 : _g.subcategoryInheritedTaxes) ? (_h = menuTypeVersionDiff.sections.taxes) == null ? void 0 : _h.subcategoryInheritedTaxes.length : 0);
    menuTypeVersionDiff.sections.itemGroups.forEach((itemGroup) => {
      if (immediateAdditionActions.includes(itemGroup.action)) {
        menuTypeVersionDiff.totalOfChanges++;
      } else {
        menuTypeVersionDiff.totalOfChanges += itemGroup.changes.length;
        itemGroup.itemsChanged.forEach((item) => {
          if (immediateAdditionActions.includes(item.action)) {
            menuTypeVersionDiff.totalOfChanges++;
          } else {
            menuTypeVersionDiff.totalOfChanges += item.changes.length;
          }
        });
      }
    });
  });
};
var getNewFilteredItemsOfItemGroup = (items, menuTypeVersionId, state) => {
  const clonedItems = cloneDeep16(items);
  const newItems = Object.entries(clonedItems);
  const filteredItems = orderBy5(
    newItems.filter(
      ([itemId]) => isItemInMenuTypeCore(Number(itemId), menuTypeVersionId, state),
      state
    ),
    (item) => item[1].sortPriority
  );
  return filteredItems.reduce((prev, current, currentIndex) => {
    return __spreadProps(__spreadValues({}, prev), {
      [Number(current[0])]: __spreadProps(__spreadValues({}, clonedItems[Number(current[0])]), {
        sortPriority: currentIndex + 1
      })
    });
  }, {});
};
var getNextItemGroupId = (itemGroups) => {
  return (max3(Object.keys(itemGroups || {}).map((id) => Number(id)) || []) || 0) + 1;
};
var applyComboChangesToMenuTypes = (formattedMenuTypeVersions, hasMenuTypesToApplyChanges, state, dispatch) => {
  let renderErrorToast = false;
  const changeData = state.menu.changeData;
  const menuTypes = state.menu.selectedMode.currentMenu.menuTypes;
  const originalData = selectOriginalMenuData(state);
  const clonedComboData = cloneDeep16(changeData.data);
  const isCreation = selectIsMenuCreationMode(state);
  const clonedChanges = cloneDeep16(changeData.differences);
  const {
    addedItemGroups,
    removedItemGroups,
    changedMenuTypeFieldsDiff,
    changedItemGroupFields,
    changedItemGroupItemFields,
    addedMenuTypesDiff
  } = getArraysByAction2(
    clonedChanges,
    hasMenuTypesToApplyChanges == null ? void 0 : hasMenuTypesToApplyChanges.currentMenuType
  );
  const getItemGroupNextSortPriority = (menuTypeVersionId) => {
    var _a;
    return getObjectNextSortPriority(
      ((_a = clonedComboData.menuTypeVersions[menuTypeVersionId]) == null ? void 0 : _a.itemGroups) || {}
    );
  };
  const getItemGroupsSorted = (diff11, menuTypeIdToApply, sortPriority) => {
    const diffPath = getMenuTypeDiffPath(diff11.path, menuTypeIdToApply);
    const targetMenuTypeItemGroupsPath = diffPath.slice(0, 3).join(".");
    const { hasChanges, elements } = getObjectSorted(
      clonedComboData.menuTypeVersions[menuTypeIdToApply].itemGroups,
      diff11.path[2],
      sortPriority
    );
    if (!hasChanges) {
      renderErrorToast = true;
    }
    return {
      hasChanges,
      itemGroups: elements,
      path: targetMenuTypeItemGroupsPath
    };
  };
  const addedItemGroupSetFunction = (diff11, menuTypeIdToApply) => {
    const diffPathToApplyArray = getMenuTypeDiffPath(
      diff11.path,
      menuTypeIdToApply
    );
    const diffPathToApply = diffPathToApplyArray.join(".");
    const newData = diff11.rhs;
    const originalSortPriority = newData.sortPriority;
    newData.sortPriority = getItemGroupNextSortPriority(menuTypeIdToApply);
    setWith(clonedComboData, diffPathToApply, newData, Object);
    const {
      path: targetMenuTypeItemGroupsPath,
      itemGroups: targetMenuTypeItemGroups
    } = getItemGroupsSorted(diff11, menuTypeIdToApply, originalSortPriority);
    setWith(
      clonedComboData,
      targetMenuTypeItemGroupsPath,
      targetMenuTypeItemGroups,
      Object
    );
  };
  const addedMenuTypeSetFunction = (diff11, menuTypeIdToApply) => {
    const diffPath = getMenuTypeDiffPath(diff11.path, menuTypeIdToApply);
    const path = diffPath.join(".");
    if (has(clonedComboData, path)) {
      setWith(
        clonedComboData,
        path,
        __spreadProps(__spreadValues({}, diff11.rhs), {
          menuTypeId: menuTypeIdToApply
        }),
        Object
      );
    }
  };
  const getItemGroupTarget = (diff11, menuTypeIdToApply, validateOrigin) => {
    const diffPath = getMenuTypeDiffPath(diff11.path, menuTypeIdToApply);
    const itemGroupsPath = diffPath.slice(0, 3).join(".");
    const itemGroupOriginPath = diff11.path.slice(0, 4).join(".");
    const itemGroupOrigin = get(
      validateOrigin ? originalData : clonedComboData,
      itemGroupOriginPath
    );
    const itemGroupsData = get(clonedComboData, itemGroupsPath);
    const hasItemGroup = Object.entries(itemGroupsData).find(
      ([, itemGroup]) => itemGroup.itemGroupId === itemGroupOrigin.itemGroupId
    );
    return {
      itemGroupTarget: hasItemGroup,
      itemGroupsPath,
      itemGroupOriginPath
    };
  };
  const comboRemovedSetFunction = (diff11, menuTypeIdToApply) => {
    const hasRemoved = removedSetFunction(
      diff11,
      menuTypeIdToApply,
      clonedComboData
    );
    if (!hasRemoved) {
      renderErrorToast = true;
    }
  };
  const changedSetFunction = (diff11, menuTypeIdToApply) => {
    changedElementSetFunction(diff11, menuTypeIdToApply, clonedComboData);
  };
  const changedItemGroupSetFunction = (diff11, menuTypeIdToApply) => {
    const field = diff11.path[diff11.path.length - 1];
    const diffPath = getMenuTypeDiffPath(diff11.path, menuTypeIdToApply);
    const isSortPriority = field === SORT_PRIORITY_FIELD2;
    const { itemGroupTarget } = getItemGroupTarget(
      diff11,
      menuTypeIdToApply,
      false
    );
    if (!itemGroupTarget) {
      renderErrorToast = true;
      return;
    }
    if (isSortPriority) {
      const {
        path: targetMenuTypeItemGroupsPath,
        itemGroups: targetMenuTypeItemGroups
      } = getItemGroupsSorted(
        diff11,
        menuTypeIdToApply,
        diff11.rhs
      );
      setWith(
        clonedComboData,
        targetMenuTypeItemGroupsPath,
        targetMenuTypeItemGroups,
        Object
      );
      return;
    }
    diffPath[3] = itemGroupTarget[0];
    const path = diffPath.join(".");
    if (has(clonedComboData, path) && !isSortPriority) {
      setWith(clonedComboData, path, diff11.rhs, Object);
    }
  };
  const menuTypesTaxesSections = {};
  if (hasMenuTypesToApplyChanges) {
    const currentSections = formattedMenuTypeVersions.find(
      (el) => el.id === (hasMenuTypesToApplyChanges == null ? void 0 : hasMenuTypesToApplyChanges.currentMenuType)
    ).sections;
    hasMenuTypesToApplyChanges.menuTypesToApplyChanges.forEach((menuType) => {
      const menuTypeIdToApply = menuType.menuTypeId;
      changedMenuTypeFieldsDiff.forEach(
        (diff11) => changedSetFunction(diff11, menuTypeIdToApply)
      );
      addedMenuTypesDiff.forEach(
        (diff11) => addedMenuTypeSetFunction(diff11, menuTypeIdToApply)
      );
      orderBy5(changedItemGroupFields, (change) => {
        const field = change.path[change.path.length - 1];
        return field === SORT_PRIORITY_FIELD2 ? change.rhs : 0;
      }).forEach((diff11) => changedItemGroupSetFunction(diff11, menuTypeIdToApply));
      orderBy5(changedItemGroupItemFields, (change) => {
        const field = change.path[change.path.length - 1];
        return field === SORT_PRIORITY_FIELD2 ? change.rhs : 0;
      }).forEach((diff11) => changedItemGroupSetFunction(diff11, menuTypeIdToApply));
      addedItemGroups.forEach(
        (diff11) => addedItemGroupSetFunction(diff11, menuTypeIdToApply)
      );
      removedItemGroups.forEach(
        (diff11) => comboRemovedSetFunction(diff11, menuTypeIdToApply)
      );
      const taxIdsSection = addTaxesPropertiesAndOverWriteIfExist(
        currentSections.taxes.taxIds || [],
        menuType.menuTypeId,
        [],
        "taxIds",
        state
      );
      const menuTypeInheritedTaxesSection = addInheritedTaxesPropertiesAndOverWriteIfExist(
        currentSections.taxes.menuTypeInheritedTaxes || [],
        menuType.menuTypeId,
        [],
        "menuTypeInheritedTaxes",
        state
      );
      const categoryInheritedTaxesSection = addInheritedTaxesPropertiesAndOverWriteIfExist(
        currentSections.taxes.categoryInheritedTaxes || [],
        menuType.menuTypeId,
        [],
        "categoryInheritedTaxes",
        state
      );
      const subcategoryInheritedTaxesSection = addInheritedTaxesPropertiesAndOverWriteIfExist(
        currentSections.taxes.subcategoryInheritedTaxes || [],
        menuType.menuTypeId,
        [],
        "subcategoryInheritedTaxes",
        state
      );
      if (taxIdsSection.length || menuTypeInheritedTaxesSection.length || categoryInheritedTaxesSection.length || subcategoryInheritedTaxesSection.length) {
        menuTypesTaxesSections[menuType.menuTypeId] = {
          taxIds: taxIdsSection,
          menuTypeInheritedTaxes: menuTypeInheritedTaxesSection,
          categoryInheritedTaxes: categoryInheritedTaxesSection,
          subcategoryInheritedTaxes: subcategoryInheritedTaxesSection
        };
      }
    });
    const differences = deepDiff6(originalData, clonedComboData);
    const newState = __spreadProps(__spreadValues({}, state), {
      menu: __spreadProps(__spreadValues({}, state.menu), {
        changeData: __spreadProps(__spreadValues({}, state.menu.changeData), {
          data: clonedComboData,
          differences
        })
      })
    });
    const newDiffObject = diffCombosFactory(differences, newState);
    newDiffObject == null ? void 0 : newDiffObject.menuTypeVersions.forEach((menuTypeVersion) => {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      if (menuTypesTaxesSections[menuTypeVersion.id]) {
        if (menuTypeVersion.action !== "add") {
          menuTypeVersion.sections.taxes = menuTypesTaxesSections[menuTypeVersion.id];
          menuTypeVersion.totalOfChanges += (((_b = (_a = menuTypeVersion.sections.taxes) == null ? void 0 : _a.taxIds) == null ? void 0 : _b.length) || 0) + (((_d = (_c = menuTypeVersion.sections.taxes) == null ? void 0 : _c.subcategoryInheritedTaxes) == null ? void 0 : _d.length) || 0) + (((_f = (_e = menuTypeVersion.sections.taxes) == null ? void 0 : _e.menuTypeInheritedTaxes) == null ? void 0 : _f.length) || 0) + (((_h = (_g = menuTypeVersion.sections.taxes) == null ? void 0 : _g.categoryInheritedTaxes) == null ? void 0 : _h.length) || 0);
        }
        delete menuTypesTaxesSections[menuTypeVersion.id];
      }
    });
    Object.entries(menuTypesTaxesSections).forEach(([menuTypeId, taxes]) => {
      var _a, _b, _c, _d;
      newDiffObject == null ? void 0 : newDiffObject.menuTypeVersions.push({
        label: menuTypes[Number(menuTypeId)].name,
        id: Number(menuTypeId),
        action: "update",
        totalOfChanges: (((_a = taxes == null ? void 0 : taxes.taxIds) == null ? void 0 : _a.length) || 0) + (((_b = taxes == null ? void 0 : taxes.menuTypeInheritedTaxes) == null ? void 0 : _b.length) || 0) + (((_c = taxes == null ? void 0 : taxes.categoryInheritedTaxes) == null ? void 0 : _c.length) || 0) + (((_d = taxes == null ? void 0 : taxes.subcategoryInheritedTaxes) == null ? void 0 : _d.length) || 0),
        sections: {
          basic: [],
          register: [],
          pricing: [],
          moreInfo: [],
          inventory: [],
          associations: [],
          itemGroups: [],
          taxes,
          // TODO: add categories logic
          categoriesSubcategories: []
        }
      });
    });
    if (isCreation) {
      dispatch(
        updateChangeDataValues({
          data: clonedComboData,
          sectionId: "all" /* ALL */
        })
      );
    }
    if (renderErrorToast) {
      dispatch(
        showToast({
          type: "warning",
          title: i18n_config_default.t(
            "menuScreen.comboDetails.applyChangesToMenuType.error.title"
          ),
          description: i18n_config_default.t(
            "menuScreen.comboDetails.applyChangesToMenuType.error.description"
          ),
          timeout: 5e3
        })
      );
    }
    return newDiffObject == null ? void 0 : newDiffObject.menuTypeVersions;
  }
  return formattedMenuTypeVersions;
};

// src/helpers/factories/menuDifferences/diffDiscountsFactory.ts
var DiscountMasterFieldLabels = /* @__PURE__ */ ((DiscountMasterFieldLabels2) => {
  DiscountMasterFieldLabels2[DiscountMasterFieldLabels2["name"] = 0] = "name";
  DiscountMasterFieldLabels2[DiscountMasterFieldLabels2["locationIds"] = 1] = "locationIds";
  return DiscountMasterFieldLabels2;
})(DiscountMasterFieldLabels || {});
var DiscountBasicSectionFieldLabels = /* @__PURE__ */ ((DiscountBasicSectionFieldLabels2) => {
  DiscountBasicSectionFieldLabels2[DiscountBasicSectionFieldLabels2["active"] = 0] = "active";
  DiscountBasicSectionFieldLabels2[DiscountBasicSectionFieldLabels2["posName"] = 1] = "posName";
  DiscountBasicSectionFieldLabels2[DiscountBasicSectionFieldLabels2["checkName"] = 2] = "checkName";
  DiscountBasicSectionFieldLabels2[DiscountBasicSectionFieldLabels2["requireReason"] = 3] = "requireReason";
  return DiscountBasicSectionFieldLabels2;
})(DiscountBasicSectionFieldLabels || {});
var DiscountMoreInformationFieldLabels = /* @__PURE__ */ ((DiscountMoreInformationFieldLabels2) => {
  DiscountMoreInformationFieldLabels2[DiscountMoreInformationFieldLabels2["description"] = 0] = "description";
  return DiscountMoreInformationFieldLabels2;
})(DiscountMoreInformationFieldLabels || {});
var DiscountDiscountScheme = /* @__PURE__ */ ((DiscountDiscountScheme2) => {
  DiscountDiscountScheme2[DiscountDiscountScheme2["applyTo"] = 0] = "applyTo";
  DiscountDiscountScheme2[DiscountDiscountScheme2["type"] = 1] = "type";
  DiscountDiscountScheme2[DiscountDiscountScheme2["value"] = 2] = "value";
  DiscountDiscountScheme2[DiscountDiscountScheme2["taxes"] = 3] = "taxes";
  DiscountDiscountScheme2[DiscountDiscountScheme2["exclusive"] = 4] = "exclusive";
  return DiscountDiscountScheme2;
})(DiscountDiscountScheme || {});
var ignoredQuantitySizeFields = ["defaultQuantitySelected"];
var returnLabel3 = (field) => {
  if (field in DiscountMasterFieldLabels) {
    return i18n_config_default.t(
      `app.modals.discountsDiffModal.master.${field}`
    );
  }
  if (field in DiscountBasicSectionFieldLabels) {
    return i18n_config_default.t(
      `app.modals.discountsDiffModal.basic.${field}`
    );
  }
  if (field in DiscountMoreInformationFieldLabels) {
    return i18n_config_default.t(
      `app.modals.discountsDiffModal.moreInfo.${field}`
    );
  }
  if (field in DiscountDiscountScheme) {
    return i18n_config_default.t(
      `app.modals.discountsDiffModal.discountScheme.${field}`
    );
  }
};
var returnValueLabel = (type) => {
  return type === "percent" /* PERCENT */ ? i18n_config_default.t("app.modals.discountsDiffModal.discountScheme.value.percentage") : i18n_config_default.t("app.modals.discountsDiffModal.discountScheme.value.amount");
};
var diffDiscountFactory = (discountId, diffArray, discountData, state) => {
  if (diffArray.length > 0) {
    const originalData = selectOriginalMenuData(state);
    const discountLocationIds = originalData.locationIds;
    const locationIds = discountData.locationIds;
    const formattedDiffArray = diffArray.map((diff11) => {
      var _a, _b, _c;
      if (!diff11.path)
        return { field: null };
      const field = diff11.path[((_a = diff11.path) == null ? void 0 : _a.length) - 1];
      const value = diff11.rhs;
      let textValue;
      if (field === "applyTo") {
        if (value === "item" /* ITEM */) {
          textValue = i18n_config_default.t(
            "menuScreen.discountDetails.discountScheme.inputs.applyTo.options.item"
          );
        } else if (value === "order" /* ORDER */) {
          textValue = i18n_config_default.t(
            "menuScreen.discountDetails.discountScheme.inputs.applyTo.options.order"
          );
        }
      } else if (field === "type") {
        if (value === "fixed" /* FIXED */) {
          textValue = i18n_config_default.t(
            "menuScreen.discountDetails.discountScheme.inputs.discountType.options.fixed"
          );
        } else if (value === "override" /* OVERRIDE */) {
          textValue = i18n_config_default.t(
            "menuScreen.discountDetails.discountScheme.inputs.discountType.options.override"
          );
        } else if (value === "percent" /* PERCENT */) {
          textValue = i18n_config_default.t(
            "menuScreen.discountDetails.discountScheme.inputs.discountType.options.percent"
          );
        }
      } else if (field === "taxes") {
        if (value === "applyBeforeTaxes" /* APPLY_BEFORE */) {
          textValue = i18n_config_default.t(
            "menuScreen.discountDetails.discountScheme.inputs.taxes.options.applyBefore"
          );
        } else if (value === "applyAfterTaxes" /* APPLY_AFTER */) {
          textValue = i18n_config_default.t(
            "menuScreen.discountDetails.discountScheme.inputs.taxes.options.applyAfter"
          );
        }
      }
      return {
        field,
        textValue,
        label: field === "value" ? returnValueLabel(discountData.type) : (_b = returnLabel3(field)) != null ? _b : "",
        value: (_c = diff11.rhs) != null ? _c : ""
      };
    });
    const hasSomeLocationIds = diffArray.filter((diff11) => diff11.path[0] === "locationIds").length > 0 ? true : false;
    const locationValues = getLocationsChanges(
      hasSomeLocationIds,
      discountLocationIds,
      locationIds,
      state
    );
    const locationsChanges = {
      field: "locationIds",
      label: returnLabel3("locationIds"),
      value: locationValues,
      menuTypeVersionId: 0
    };
    const {
      masterChanges: formattedMasterFieldsArray,
      basicChanges,
      moreInformationChanges,
      discountSchemeChanges
    } = filterChangesBySection2(formattedDiffArray);
    const masterChanges = formattedMasterFieldsArray.filter(
      (diff11) => diff11.field !== "locationIds"
    );
    if (locationValues.length > 0) {
      masterChanges.push(locationsChanges);
    }
    return {
      discountId,
      masterChanges,
      basic: basicChanges,
      moreInfo: moreInformationChanges,
      discountScheme: discountSchemeChanges
    };
  }
  return null;
};
var filterChangesBySection2 = (formattedDiffArray) => {
  const masterChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(DiscountMasterFieldLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  );
  const basicChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(DiscountBasicSectionFieldLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  );
  const moreInformationChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(DiscountMoreInformationFieldLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  );
  const discountSchemeChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(DiscountDiscountScheme).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  );
  return {
    masterChanges,
    basicChanges,
    moreInformationChanges,
    discountSchemeChanges
  };
};

// src/helpers/factories/menuDifferences/diffModifierItemsFactory.ts
var ModifierItemMasterFieldLabels = /* @__PURE__ */ ((ModifierItemMasterFieldLabels2) => {
  ModifierItemMasterFieldLabels2[ModifierItemMasterFieldLabels2["name"] = 0] = "name";
  return ModifierItemMasterFieldLabels2;
})(ModifierItemMasterFieldLabels || {});
var ModifierItemBasicSectionFieldLabels = /* @__PURE__ */ ((ModifierItemBasicSectionFieldLabels2) => {
  ModifierItemBasicSectionFieldLabels2[ModifierItemBasicSectionFieldLabels2["posName"] = 0] = "posName";
  ModifierItemBasicSectionFieldLabels2[ModifierItemBasicSectionFieldLabels2["kdsName"] = 1] = "kdsName";
  ModifierItemBasicSectionFieldLabels2[ModifierItemBasicSectionFieldLabels2["checkName"] = 2] = "checkName";
  ModifierItemBasicSectionFieldLabels2[ModifierItemBasicSectionFieldLabels2["onlineName"] = 3] = "onlineName";
  ModifierItemBasicSectionFieldLabels2[ModifierItemBasicSectionFieldLabels2["active"] = 4] = "active";
  ModifierItemBasicSectionFieldLabels2[ModifierItemBasicSectionFieldLabels2["removeItemTaxExempt"] = 5] = "removeItemTaxExempt";
  return ModifierItemBasicSectionFieldLabels2;
})(ModifierItemBasicSectionFieldLabels || {});
var ModifierItemInventorySectionFieldLabels = /* @__PURE__ */ ((ModifierItemInventorySectionFieldLabels2) => {
  ModifierItemInventorySectionFieldLabels2[ModifierItemInventorySectionFieldLabels2["is86ed"] = 0] = "is86ed";
  return ModifierItemInventorySectionFieldLabels2;
})(ModifierItemInventorySectionFieldLabels || {});
var ModifierItemPricingVersionFields = /* @__PURE__ */ ((ModifierItemPricingVersionFields2) => {
  ModifierItemPricingVersionFields2[ModifierItemPricingVersionFields2["name"] = 0] = "name";
  ModifierItemPricingVersionFields2[ModifierItemPricingVersionFields2["includedMasterPrice"] = 1] = "includedMasterPrice";
  ModifierItemPricingVersionFields2[ModifierItemPricingVersionFields2["additionalMasterPrice"] = 2] = "additionalMasterPrice";
  ModifierItemPricingVersionFields2[ModifierItemPricingVersionFields2["quarterPricePercent"] = 3] = "quarterPricePercent";
  ModifierItemPricingVersionFields2[ModifierItemPricingVersionFields2["halfPricePercent"] = 4] = "halfPricePercent";
  ModifierItemPricingVersionFields2[ModifierItemPricingVersionFields2["includedLightPrice"] = 5] = "includedLightPrice";
  ModifierItemPricingVersionFields2[ModifierItemPricingVersionFields2["includedRegularPrice"] = 6] = "includedRegularPrice";
  ModifierItemPricingVersionFields2[ModifierItemPricingVersionFields2["includedExtraPrice"] = 7] = "includedExtraPrice";
  ModifierItemPricingVersionFields2[ModifierItemPricingVersionFields2["additionalLightPrice"] = 8] = "additionalLightPrice";
  ModifierItemPricingVersionFields2[ModifierItemPricingVersionFields2["additionalRegularPrice"] = 9] = "additionalRegularPrice";
  ModifierItemPricingVersionFields2[ModifierItemPricingVersionFields2["additionalExtraPrice"] = 10] = "additionalExtraPrice";
  ModifierItemPricingVersionFields2[ModifierItemPricingVersionFields2["onSidePrice"] = 11] = "onSidePrice";
  return ModifierItemPricingVersionFields2;
})(ModifierItemPricingVersionFields || {});
var ModifierItemModifierGroupLabels = /* @__PURE__ */ ((ModifierItemModifierGroupLabels2) => {
  ModifierItemModifierGroupLabels2[ModifierItemModifierGroupLabels2["active"] = 0] = "active";
  ModifierItemModifierGroupLabels2[ModifierItemModifierGroupLabels2["requiredModifierItems"] = 1] = "requiredModifierItems";
  ModifierItemModifierGroupLabels2[ModifierItemModifierGroupLabels2["includedModifierItems"] = 2] = "includedModifierItems";
  ModifierItemModifierGroupLabels2[ModifierItemModifierGroupLabels2["defaultModifierGroupPricingVersionId"] = 3] = "defaultModifierGroupPricingVersionId";
  ModifierItemModifierGroupLabels2[ModifierItemModifierGroupLabels2["sortPriority"] = 4] = "sortPriority";
  ModifierItemModifierGroupLabels2[ModifierItemModifierGroupLabels2["defaultSelectionPrice"] = 5] = "defaultSelectionPrice";
  return ModifierItemModifierGroupLabels2;
})(ModifierItemModifierGroupLabels || {});
var ModifierItemModifierItemLabels = /* @__PURE__ */ ((ModifierItemModifierItemLabels2) => {
  ModifierItemModifierItemLabels2[ModifierItemModifierItemLabels2["defaultQuantitySelected"] = 0] = "defaultQuantitySelected";
  ModifierItemModifierItemLabels2[ModifierItemModifierItemLabels2["defaultAmountSelected"] = 1] = "defaultAmountSelected";
  ModifierItemModifierItemLabels2[ModifierItemModifierItemLabels2["isSelected"] = 2] = "isSelected";
  ModifierItemModifierItemLabels2[ModifierItemModifierItemLabels2["active"] = 3] = "active";
  ModifierItemModifierItemLabels2[ModifierItemModifierItemLabels2["includedMasterPrice"] = 4] = "includedMasterPrice";
  ModifierItemModifierItemLabels2[ModifierItemModifierItemLabels2["additionalMasterPrice"] = 5] = "additionalMasterPrice";
  ModifierItemModifierItemLabels2[ModifierItemModifierItemLabels2["includedLightPrice"] = 6] = "includedLightPrice";
  ModifierItemModifierItemLabels2[ModifierItemModifierItemLabels2["includedRegularPrice"] = 7] = "includedRegularPrice";
  ModifierItemModifierItemLabels2[ModifierItemModifierItemLabels2["includedExtraPrice"] = 8] = "includedExtraPrice";
  ModifierItemModifierItemLabels2[ModifierItemModifierItemLabels2["additionalLightPrice"] = 9] = "additionalLightPrice";
  ModifierItemModifierItemLabels2[ModifierItemModifierItemLabels2["additionalRegularPrice"] = 10] = "additionalRegularPrice";
  ModifierItemModifierItemLabels2[ModifierItemModifierItemLabels2["additionalExtraPrice"] = 11] = "additionalExtraPrice";
  return ModifierItemModifierItemLabels2;
})(ModifierItemModifierItemLabels || {});
var modifierItemIgnoredFields = [
  "id",
  "createdAt",
  "deletedAt",
  "createdByLocationId",
  "locationId",
  "locationModifierItemPricingVersionId",
  "locationModifierItemPricingVersionVersionId",
  "modifierItemId",
  "modifierItemPricingVersionId",
  "organizationId",
  "updatedAt",
  "modifierGroupMenuTypeItemId",
  "modifierGroupId",
  "modifierGroupModifierItemId",
  "isSelected",
  "defaultQuantitySelected",
  "defaultAmountSelected",
  "parent"
];
var modifierItemIgnoredModifierItemsFields = [
  "id",
  "createdAt",
  "updatedAt",
  "deletedAt",
  "locationId",
  "createdByLocationId",
  "modifierItemId",
  "modifierItemPricingVersionId",
  "modifierGroupModifierItemId",
  "sortPriority",
  "parent",
  "defaultSelectionPrice",
  "requiredModifierItems",
  "includedModifierItems",
  "modifierGroupId",
  "defaultModifierGroupPricingVersionId"
];
var modifierItemIgnoredModifierItemPricingVersion = [
  "id",
  "createdAt",
  "updatedAt",
  "deletedAt",
  "locationId",
  "createdByLocationId",
  "organizationId",
  "modifierItemId",
  "name",
  "halfPricePercent",
  "quarterPricePercent",
  "modifierItemPricingVersionId",
  "locationModifierItemPricingVersionId",
  "locationModifierItemPricingVersionVersionId"
];
var modifierItemIgnoredModifierGroupOfModifierItemFields = [
  // Ignored general fields
  "id",
  "createdAt",
  "updatedAt",
  "deletedAt",
  "createdByLocationId",
  "modifierItemId",
  "defaultSelectionPrice",
  // Ignored ModifierGroup Of ModifierItem fields
  "modifierGroupModifierItemId",
  "locationModifierGroupModifierItemId",
  "locationModifierGroupModifierItemVersionId",
  "modifierGroupMenuTypeItemId",
  "modifierGroupId"
];
var returnLabel4 = (field, depth) => {
  if (depth === 1) {
    if (field in ModifierItemMasterFieldLabels) {
      return i18n_config_default.t(
        `app.modals.modifierItemsDiffModal.master.${field}`
      );
    }
    if (field in ModifierItemBasicSectionFieldLabels) {
      return i18n_config_default.t(
        `app.modals.modifierItemsDiffModal.basic.${field}`
      );
    }
    if (field in ModifierItemInventorySectionFieldLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.inventory.${field}`
      );
    }
  }
  if (depth === 3) {
    if (field in ModifierItemPricingVersionFields) {
      return i18n_config_default.t(
        `app.modals.modifierItemsDiffModal.pricing.${field}`
      );
    }
    if (field in ModifierItemModifierGroupLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.modifierGroup.${field}`
      );
    }
  }
  if (depth === 5 && field in ModifierItemModifierItemLabels) {
    return i18n_config_default.t(
      `app.modals.itemsDiff.modifierItem.${field}`
    );
  }
};
var diffModifierItemsFactory = (modifierItemId, diffArray, modifierItemData, state) => {
  const pricingVersionIds = [];
  const originalData = selectOriginalMenuData(state);
  const modifierItemPricingVersions = originalData.modifierItemPricingVersions;
  const modifierGroups = selectModifierGroups(state);
  if (diffArray.length > 0) {
    const formattedDiffArray = diffArray.filter((diff11) => diff11.path.length === 1).map((diff11) => {
      var _a, _b;
      if (!diff11.path)
        return { field: null };
      const field = diff11.path[0];
      const value = (_a = diff11.rhs) != null ? _a : "";
      return {
        field,
        label: (_b = returnLabel4(field, 1)) != null ? _b : "",
        value
      };
    });
    const formattedPricingDiffArray = diffArray.filter(
      (diff11) => diff11.path.length === 3 && diff11.path[0] !== "modifierGroups" && diff11.path[0] !== "prepStationIds"
    ).map((diff11) => {
      var _a, _b;
      if (!diff11.path)
        return { field: null };
      const field = diff11.path[2];
      const value = (_a = diff11.rhs) != null ? _a : "";
      const pricingVersionId = Number(diff11.path[1]);
      return {
        field,
        label: (_b = returnLabel4(field, 3)) != null ? _b : "",
        value,
        pricingVersionId
      };
    });
    diffArray.filter(
      (diff11) => diff11.path.length >= 2 && diff11.path[0] !== "locationIds" && diff11.path[0] !== "modifierGroups" && diff11.path[0] !== "prepStationIds"
    ).map((diff11) => {
      const pricingVersionId = Number(diff11.path[1]);
      if (!pricingVersionIds.includes(pricingVersionId))
        pricingVersionIds.push(pricingVersionId);
    });
    const { masterChanges, basicChanges, inventoryChanges } = filterChangesBySection3(formattedDiffArray);
    const formattedPricingVersions = (
      // Iterate over pricingVersionIds
      pricingVersionIds.map((pricingVersionId) => {
        const wasDeleted = diffArray.find(
          (diff11) => diff11.path.length === 2 && diff11.kind === "D" && diff11.path[1] === pricingVersionId.toString()
        );
        const wasAdded = diffArray.find(
          (diff11) => diff11.path.length === 2 && diff11.kind === "N" && diff11.path[1] === pricingVersionId.toString()
        );
        if (wasDeleted) {
          return {
            label: modifierItemPricingVersions[Number(pricingVersionId)].name,
            id: pricingVersionId,
            action: "remove",
            totalOfChanges: 0,
            changes: []
          };
        } else if (wasAdded) {
          const newPricingVersion = wasAdded.rhs;
          const formattedNewFieldsArray = Object.entries(newPricingVersion).filter(([field]) => !modifierItemIgnoredFields.includes(field)).map(([field, value]) => {
            return {
              field,
              label: returnLabel4(field, 3),
              value
            };
          });
          return {
            label: modifierItemData.modifierItemPricingVersions[Number(pricingVersionId)].name,
            id: pricingVersionId,
            action: "add",
            totalOfChanges: 0,
            changes: formattedNewFieldsArray
          };
        } else {
          const totalOfChanges = diffArray.filter(
            (change) => change.path[1] === pricingVersionId.toString()
          ).length;
          return {
            label: modifierItemPricingVersions[Number(pricingVersionId)].name,
            id: pricingVersionId,
            action: "update",
            totalOfChanges,
            changes: formattedPricingDiffArray.filter(
              (pricingChange) => pricingChange.pricingVersionId === pricingVersionId
            )
          };
        }
      })
    );
    const modifierGroupsChanges = generateModifierGroupsChanges2(
      diffArray,
      modifierItemData,
      state
    );
    const modifierGroupChanges = getArrayNumberChanges(
      originalData.parentModifierGroupIds,
      modifierItemData.parentModifierGroupIds
    ).map((change) => {
      var _a;
      return __spreadProps(__spreadValues({}, change), { value: (_a = modifierGroups[change.id]) == null ? void 0 : _a.name });
    });
    const originalPrepStations = (originalData == null ? void 0 : originalData.prepStationIds) || [];
    const newPrepStations = (modifierItemData == null ? void 0 : modifierItemData.prepStationIds) || [];
    const hasPrepStationsChanges = diffArray.some(
      (diff11) => diff11.path[0] === "prepStationIds"
    );
    const prepStationValues = getPrepStationChanges(
      hasPrepStationsChanges,
      originalPrepStations,
      newPrepStations,
      state,
      []
    );
    return {
      modifierItemId,
      masterChanges,
      basic: basicChanges,
      inventory: inventoryChanges,
      pricingVersions: formattedPricingVersions,
      modifiers: modifierGroupsChanges,
      modifierGroups: modifierGroupChanges,
      prepStations: prepStationValues
    };
  }
  return null;
};
var filterChangesBySection3 = (formattedDiffArray) => {
  const masterChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(ModifierItemMasterFieldLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  );
  const basicChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(ModifierItemBasicSectionFieldLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  );
  const inventoryChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(ModifierItemInventorySectionFieldLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  );
  return {
    masterChanges,
    basicChanges,
    inventoryChanges
  };
};
var generateModifierGroupsChanges2 = (diffArray, modifierItemData, state) => {
  const currentMenu = state.menu.selectedMode.currentMenu;
  const {
    modifierGroups: menuModifierGroups,
    modifierItems: menuModifierItems
  } = currentMenu;
  const originalData = selectOriginalMenuData(state);
  const currentModifierGroups = originalData.modifierGroups;
  const modifierGroupsIds = [];
  const formattedModifierGroups = diffArray.filter(
    (diff11) => diff11.path.length >= 2 && diff11.path.length < 5 && diff11.path[0] === "modifierGroups"
  ).map((diff11) => {
    var _a;
    if (!diff11.path)
      return { field: null };
    const field = diff11.path[((_a = diff11.path) == null ? void 0 : _a.length) - 1];
    const modifierGroupId = Number(diff11.path[1]);
    if (!modifierGroupsIds.includes(modifierGroupId))
      modifierGroupsIds.push(modifierGroupId);
    return {
      field,
      modifierGroupId,
      label: returnLabel4(field, 3),
      value: diff11.rhs
    };
  });
  const formattedModifierGroupItems = diffArray.filter((diff11) => diff11.path.length === 5 && diff11.path[0] === "modifierGroups").map((diff11) => {
    var _a;
    if (!diff11.path)
      return { field: null };
    const field = diff11.path[((_a = diff11.path) == null ? void 0 : _a.length) - 1];
    const modifierGroupId = Number(diff11.path[1]);
    if (!modifierGroupsIds.includes(modifierGroupId))
      modifierGroupsIds.push(modifierGroupId);
    const modifierItemId = diff11.path[3];
    const currentModifierItem = currentModifierGroups[modifierGroupId].modifierItems[Number(modifierItemId)].modifierItemId;
    return {
      field,
      modifierGroupId,
      modifierItemId: Number(currentModifierItem),
      label: returnLabel4(field, 5),
      value: diff11.rhs
    };
  });
  const modifierGroupsChanges = modifierGroupsIds.map((modifierGroupId) => {
    const modifierGroupName = menuModifierGroups[modifierGroupId].posName;
    const currentModifierGroup = currentModifierGroups[modifierGroupId];
    const wasDeleted = diffArray.find(
      (diff11) => diff11.path.length === 2 && diff11.path[1] === modifierGroupId.toString() && diff11.kind === "D" && diff11.path[0] === "modifierGroups"
    );
    const wasAdded = diffArray.find(
      (diff11) => diff11.path.length === 2 && diff11.path[1] === modifierGroupId.toString() && diff11.kind === "N" && diff11.path[0] === "modifierGroups"
    );
    if (wasDeleted) {
      return {
        label: modifierGroupName,
        id: modifierGroupId,
        action: "remove",
        changes: [],
        itemsChanged: []
      };
    } else if (wasAdded) {
      const newModifierGroup = wasAdded.rhs;
      return formatNewModifierGroup2(newModifierGroup, currentMenu);
    } else {
      const modifierGroupsById = formattedModifierGroups.filter(
        (change) => change.modifierGroupId === modifierGroupId
      );
      const isDefaultModifierGroupPricingVersionId = modifierGroupsById.find(
        (modifierGroup) => modifierGroup.field === "defaultModifierGroupPricingVersionId"
      );
      let pricingVersionName = "";
      let pricingVersionChangesArray = [];
      if (isDefaultModifierGroupPricingVersionId) {
        pricingVersionName = menuModifierGroups[modifierGroupId].modifierGroupPricingVersions[Number(isDefaultModifierGroupPricingVersionId.value)].name;
        pricingVersionChangesArray = Object.entries(
          modifierItemData.modifierGroups[modifierGroupId].modifierItems
        ).map(([, value]) => {
          return {
            id: value.modifierItemId,
            label: menuModifierItems[Number(value.modifierItemId)].name,
            changes: getPricingVersionChanges(
              menuModifierGroups,
              menuModifierItems,
              currentModifierGroup,
              value.modifierItemId,
              isDefaultModifierGroupPricingVersionId.value
            )
          };
        }, {});
      }
      if (formattedModifierGroupItems.filter(
        (change) => change.modifierGroupId === modifierGroupId
      ).length > 0) {
        const itemsIds = [];
        const itemsById = formattedModifierGroupItems.filter(
          (change) => !modifierItemIgnoredModifierItemsFields.includes(change.field)
        ).filter((change) => {
          if (change.modifierGroupId === modifierGroupId) {
            const item = change.modifierItemId;
            if (!itemsIds.includes(item))
              itemsIds.push(item);
            return true;
          }
          return false;
        });
        const itemsChanged = itemsIds.map((modifierItemId) => {
          const pricingVersionChanges = pricingVersionChangesArray.find(
            (change) => change.id === modifierItemId
          );
          if (pricingVersionChanges) {
            return {
              label: menuModifierItems[Number(modifierItemId)].name,
              id: modifierItemId,
              changes: [
                ...itemsById.filter(
                  (item) => item.modifierItemId === modifierItemId
                ),
                ...pricingVersionChanges.changes
              ]
            };
          } else {
            return {
              label: menuModifierItems[Number(modifierItemId)].name,
              id: modifierItemId,
              changes: itemsById.filter(
                (item) => item.modifierItemId === modifierItemId
              )
            };
          }
        });
        const selectedDefaultCount = Object.values(
          modifierItemData.modifierGroups[modifierGroupId].modifierItems
        ).filter((modifierItem) => modifierItem.isSelected).length;
        if (isDefaultModifierGroupPricingVersionId) {
          const changes = modifierGroupsById.filter(
            (modifierGroup) => modifierGroup.field !== "defaultModifierGroupPricingVersionId"
          );
          return {
            label: modifierGroupName,
            id: modifierGroupId,
            action: "update",
            changes: [
              {
                field: "selectedDefault",
                label: i18n_config_default.t(
                  "app.modals.itemsDiff.modifierGroup.selectedDefault"
                ),
                value: selectedDefaultCount
              },
              ...changes,
              __spreadProps(__spreadValues({}, isDefaultModifierGroupPricingVersionId), {
                textValue: pricingVersionName
              })
            ],
            itemsChanged: [
              ...itemsChanged,
              ...pricingVersionChangesArray.filter(
                (change) => !itemsIds.includes(change.id)
              )
            ]
          };
        } else {
          return {
            label: modifierGroupName,
            id: modifierGroupId,
            action: "update",
            changes: [
              {
                field: "selectedDefault",
                label: i18n_config_default.t(
                  "app.modals.itemsDiff.modifierGroup.selectedDefault"
                ),
                value: selectedDefaultCount
              },
              ...modifierGroupsById
            ],
            itemsChanged
          };
        }
      } else {
        if (isDefaultModifierGroupPricingVersionId) {
          const changes = modifierGroupsById.filter(
            (modifierGroup) => modifierGroup.field !== "defaultModifierGroupPricingVersionId"
          );
          return {
            label: modifierGroupName,
            id: modifierGroupId,
            action: "update",
            changes: [
              ...changes,
              __spreadProps(__spreadValues({}, isDefaultModifierGroupPricingVersionId), {
                textValue: pricingVersionName
              })
            ],
            itemsChanged: pricingVersionChangesArray
          };
        } else {
          return {
            label: modifierGroupName,
            id: modifierGroupId,
            action: "update",
            changes: modifierGroupsById,
            itemsChanged: []
          };
        }
      }
    }
  });
  return modifierGroupsChanges;
};
var formatNewModifierGroup2 = (modifierGroup, currentMenu) => {
  const {
    modifierGroups: menuModifierGroups,
    modifierItems: menuModifierItems
  } = currentMenu;
  const modifierGroupName = menuModifierGroups[modifierGroup.modifierGroupId].posName;
  const newModifierItems = modifierGroup.modifierItems;
  const changes = Object.entries(modifierGroup).filter(
    ([key]) => !modifierItemIgnoredFields.includes(key) && key !== "modifierItems"
  ).map(([keyModifierGroup, modifierGroupValue]) => {
    if (keyModifierGroup === "defaultModifierGroupPricingVersionId") {
      return {
        field: keyModifierGroup,
        modifierGroupId: modifierGroup.modifierGroupId,
        label: returnLabel4(keyModifierGroup, 3),
        value: modifierGroupValue,
        textValue: menuModifierGroups[modifierGroup.modifierGroupId].modifierGroupPricingVersions[Number(modifierGroupValue)].name
      };
    } else {
      return {
        field: keyModifierGroup,
        modifierGroupId: modifierGroup.modifierGroupId,
        label: returnLabel4(keyModifierGroup, 3),
        value: modifierGroupValue
      };
    }
  });
  const isDefaultModifierGroupPricingVersionId = changes.find(
    (change) => change.field === "defaultModifierGroupPricingVersionId"
  );
  const itemsChanged = Object.entries(newModifierItems).filter(
    ([field]) => !modifierItemIgnoredModifierItemsFields.includes(field)
  ).map(([field, value]) => {
    const changesForItems = Object.entries(value).filter(
      ([key1]) => !modifierItemIgnoredModifierItemsFields.includes(key1)
    ).map(([keyModifierItem, modifierItemValue]) => {
      return {
        field: keyModifierItem,
        label: returnLabel4(keyModifierItem, 5),
        value: modifierItemValue,
        modifierGroupId: modifierGroup.modifierGroupId,
        modifierItemId: value.modifierItemId
      };
    });
    if (isDefaultModifierGroupPricingVersionId) {
      const pricingVersionChanges = getPricingVersionChanges(
        menuModifierGroups,
        menuModifierItems,
        modifierGroup,
        value.modifierItemId,
        isDefaultModifierGroupPricingVersionId.value
      );
      return {
        label: menuModifierItems[Number(field)].name,
        id: value.modifierItemId,
        changes: [...changesForItems, ...pricingVersionChanges]
      };
    } else {
      return {
        label: menuModifierItems[Number(field)].name,
        id: value.modifierItemId,
        changes: changesForItems
      };
    }
  });
  return {
    label: modifierGroupName,
    id: modifierGroup.modifierGroupId,
    action: "add",
    changes,
    itemsChanged
  };
};
var getPricingVersionChanges = (menuModifierGroups, menuModifierItems, modifierGroup, modifierItemId, isDefaultModifierGroupPricingVersionId) => {
  const pricingVersionId = menuModifierGroups[modifierGroup.modifierGroupId].modifierGroupPricingVersions[isDefaultModifierGroupPricingVersionId].modItemPricingVersions[modifierItemId];
  const pricingVersion = menuModifierItems[modifierItemId].modifierItemPricingVersions[pricingVersionId];
  let pricingVersionChanges = Object.entries(
    pricingVersion
  ).filter(
    ([fieldPricingVersion]) => !modifierItemIgnoredModifierItemPricingVersion.includes(
      fieldPricingVersion
    )
  ).map(([fieldPricingVersion, valuePricingVersion]) => {
    return {
      field: fieldPricingVersion,
      label: returnLabel4(fieldPricingVersion, 5),
      modifierGroupId: modifierGroup.modifierGroupId,
      modifierItemId,
      value: valuePricingVersion
    };
  });
  const quantityMode = menuModifierGroups[modifierGroup.modifierGroupId].quantityMode;
  if (quantityMode === "Off" /* OFF */) {
    pricingVersionChanges = pricingVersionChanges.filter(
      (modifierItem) => !itemIgnoredQuantityOffFields.includes(modifierItem.field)
    );
  } else if (quantityMode === "x1,x2,x3" /* NUMBER */) {
    pricingVersionChanges = pricingVersionChanges.filter(
      (modifierItem) => !itemIgnoredQuantityNumberFields.includes(modifierItem.field)
    );
  } else {
    pricingVersionChanges = pricingVersionChanges.filter(
      (modifierItem) => !itemIgnoredQuantitySizeFields.includes(modifierItem.field)
    );
  }
  return pricingVersionChanges;
};

// src/helpers/factories/menuDifferences/diffModifierGroupsFactory.ts
var ModifierGroupMasterFieldLabels = /* @__PURE__ */ ((ModifierGroupMasterFieldLabels2) => {
  ModifierGroupMasterFieldLabels2[ModifierGroupMasterFieldLabels2["name"] = 0] = "name";
  return ModifierGroupMasterFieldLabels2;
})(ModifierGroupMasterFieldLabels || {});
var ModifierGroupBasicSectionFieldLabels = /* @__PURE__ */ ((ModifierGroupBasicSectionFieldLabels2) => {
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["posName"] = 0] = "posName";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["kdsName"] = 1] = "kdsName";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["checkName"] = 2] = "checkName";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["onlineName"] = 3] = "onlineName";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["active"] = 4] = "active";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["multiselect"] = 5] = "multiselect";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["allowNoneSelection"] = 6] = "allowNoneSelection";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["requiredModifierItems"] = 7] = "requiredModifierItems";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["includedModifierItems"] = 8] = "includedModifierItems";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["maximumModifierItems"] = 9] = "maximumModifierItems";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["quantityMode"] = 10] = "quantityMode";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["priceCalcMode"] = 11] = "priceCalcMode";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["activeCustomizerSectionSelector"] = 12] = "activeCustomizerSectionSelector";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["hidePriceIfFree"] = 13] = "hidePriceIfFree";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["showModGroupTitleOnRegisterTicket"] = 14] = "showModGroupTitleOnRegisterTicket";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["showModGroupTitleOnKitchenTicket"] = 15] = "showModGroupTitleOnKitchenTicket";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["guestCheck"] = 16] = "guestCheck";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["advancedModifier"] = 17] = "advancedModifier";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["showSearchBar"] = 18] = "showSearchBar";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["searchAllModifierItems"] = 19] = "searchAllModifierItems";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["global"] = 20] = "global";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["enableModTags"] = 21] = "enableModTags";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["enableQuantityBar"] = 22] = "enableQuantityBar";
  ModifierGroupBasicSectionFieldLabels2[ModifierGroupBasicSectionFieldLabels2["customizerSlicing"] = 23] = "customizerSlicing";
  return ModifierGroupBasicSectionFieldLabels2;
})(ModifierGroupBasicSectionFieldLabels || {});
var ModifierGroupRegisterDisplayFieldLabels = /* @__PURE__ */ ((ModifierGroupRegisterDisplayFieldLabels2) => {
  ModifierGroupRegisterDisplayFieldLabels2[ModifierGroupRegisterDisplayFieldLabels2["backgroundColor"] = 0] = "backgroundColor";
  ModifierGroupRegisterDisplayFieldLabels2[ModifierGroupRegisterDisplayFieldLabels2["textColor"] = 1] = "textColor";
  return ModifierGroupRegisterDisplayFieldLabels2;
})(ModifierGroupRegisterDisplayFieldLabels || {});
var ModifierGroupPricingVersionFieldsLabels = /* @__PURE__ */ ((ModifierGroupPricingVersionFieldsLabels2) => {
  ModifierGroupPricingVersionFieldsLabels2[ModifierGroupPricingVersionFieldsLabels2["name"] = 0] = "name";
  ModifierGroupPricingVersionFieldsLabels2[ModifierGroupPricingVersionFieldsLabels2["includedMasterPrice"] = 1] = "includedMasterPrice";
  ModifierGroupPricingVersionFieldsLabels2[ModifierGroupPricingVersionFieldsLabels2["additionalMasterPrice"] = 2] = "additionalMasterPrice";
  ModifierGroupPricingVersionFieldsLabels2[ModifierGroupPricingVersionFieldsLabels2["quarterPricePercent"] = 3] = "quarterPricePercent";
  ModifierGroupPricingVersionFieldsLabels2[ModifierGroupPricingVersionFieldsLabels2["halfPricePercent"] = 4] = "halfPricePercent";
  ModifierGroupPricingVersionFieldsLabels2[ModifierGroupPricingVersionFieldsLabels2["includedLightPrice"] = 5] = "includedLightPrice";
  ModifierGroupPricingVersionFieldsLabels2[ModifierGroupPricingVersionFieldsLabels2["includedRegularPrice"] = 6] = "includedRegularPrice";
  ModifierGroupPricingVersionFieldsLabels2[ModifierGroupPricingVersionFieldsLabels2["includedExtraPrice"] = 7] = "includedExtraPrice";
  ModifierGroupPricingVersionFieldsLabels2[ModifierGroupPricingVersionFieldsLabels2["additionalLightPrice"] = 8] = "additionalLightPrice";
  ModifierGroupPricingVersionFieldsLabels2[ModifierGroupPricingVersionFieldsLabels2["additionalRegularPrice"] = 9] = "additionalRegularPrice";
  ModifierGroupPricingVersionFieldsLabels2[ModifierGroupPricingVersionFieldsLabels2["additionalExtraPrice"] = 10] = "additionalExtraPrice";
  return ModifierGroupPricingVersionFieldsLabels2;
})(ModifierGroupPricingVersionFieldsLabels || {});
var ModifierGroupModifierItemsFieldsLabels = /* @__PURE__ */ ((ModifierGroupModifierItemsFieldsLabels2) => {
  ModifierGroupModifierItemsFieldsLabels2[ModifierGroupModifierItemsFieldsLabels2["active"] = 0] = "active";
  ModifierGroupModifierItemsFieldsLabels2[ModifierGroupModifierItemsFieldsLabels2["isSelected"] = 1] = "isSelected";
  ModifierGroupModifierItemsFieldsLabels2[ModifierGroupModifierItemsFieldsLabels2["defaultAmountSelected"] = 2] = "defaultAmountSelected";
  ModifierGroupModifierItemsFieldsLabels2[ModifierGroupModifierItemsFieldsLabels2["defaultQuantitySelected"] = 3] = "defaultQuantitySelected";
  ModifierGroupModifierItemsFieldsLabels2[ModifierGroupModifierItemsFieldsLabels2["includedMasterPrice"] = 4] = "includedMasterPrice";
  ModifierGroupModifierItemsFieldsLabels2[ModifierGroupModifierItemsFieldsLabels2["additionalMasterPrice"] = 5] = "additionalMasterPrice";
  ModifierGroupModifierItemsFieldsLabels2[ModifierGroupModifierItemsFieldsLabels2["includedLightPrice"] = 6] = "includedLightPrice";
  ModifierGroupModifierItemsFieldsLabels2[ModifierGroupModifierItemsFieldsLabels2["includedRegularPrice"] = 7] = "includedRegularPrice";
  ModifierGroupModifierItemsFieldsLabels2[ModifierGroupModifierItemsFieldsLabels2["includedExtraPrice"] = 8] = "includedExtraPrice";
  ModifierGroupModifierItemsFieldsLabels2[ModifierGroupModifierItemsFieldsLabels2["additionalLightPrice"] = 9] = "additionalLightPrice";
  ModifierGroupModifierItemsFieldsLabels2[ModifierGroupModifierItemsFieldsLabels2["additionalRegularPrice"] = 10] = "additionalRegularPrice";
  ModifierGroupModifierItemsFieldsLabels2[ModifierGroupModifierItemsFieldsLabels2["additionalExtraPrice"] = 11] = "additionalExtraPrice";
  ModifierGroupModifierItemsFieldsLabels2[ModifierGroupModifierItemsFieldsLabels2["sortPriority"] = 12] = "sortPriority";
  ModifierGroupModifierItemsFieldsLabels2[ModifierGroupModifierItemsFieldsLabels2["defaultSelectionPrice"] = 13] = "defaultSelectionPrice";
  ModifierGroupModifierItemsFieldsLabels2[ModifierGroupModifierItemsFieldsLabels2["linesBefore"] = 14] = "linesBefore";
  ModifierGroupModifierItemsFieldsLabels2[ModifierGroupModifierItemsFieldsLabels2["spacesBefore"] = 15] = "spacesBefore";
  ModifierGroupModifierItemsFieldsLabels2[ModifierGroupModifierItemsFieldsLabels2["maximumQuantity"] = 16] = "maximumQuantity";
  return ModifierGroupModifierItemsFieldsLabels2;
})(ModifierGroupModifierItemsFieldsLabels || {});
var ModifierGroupModifierGroupPricingVersionsLabels = /* @__PURE__ */ ((ModifierGroupModifierGroupPricingVersionsLabels2) => {
  ModifierGroupModifierGroupPricingVersionsLabels2[ModifierGroupModifierGroupPricingVersionsLabels2["name"] = 0] = "name";
  ModifierGroupModifierGroupPricingVersionsLabels2[ModifierGroupModifierGroupPricingVersionsLabels2["modItemPricingVersions"] = 1] = "modItemPricingVersions";
  return ModifierGroupModifierGroupPricingVersionsLabels2;
})(ModifierGroupModifierGroupPricingVersionsLabels || {});
var modifierGroupIgnoredModifierItemsOfModifierGroupFields = [
  "id",
  "createdAt",
  "deletedAt",
  "createdByLocationId",
  "locationId",
  "organizationId",
  "updatedAt",
  "locationModifierGroupModifierItemId",
  "locationModifierGroupModifierItemVersionId",
  "modifierItemId",
  "modifierItemPricingVersionId",
  "modifierGroupPricingVersionId",
  "modifierGroupModifierItemId",
  "defaultModifierGroupPricingVersionId"
];
var modifierGroupIgnoredModifierGroupPricingVersionFields = [
  "id",
  "createdAt",
  "deletedAt",
  "createdByLocationId",
  "locationId",
  "organizationId",
  "updatedAt",
  "locationModifierGroupPricingVersionId",
  "locationModifierGroupPricingVersionVersionId",
  "modifierGroupPricingVersionId",
  "modItemPricingVersions"
];
var modifierGroupIgnoredModifierGroupModifierItemFields = [
  "id",
  "updatedAt",
  "createdAt",
  "deletedAt",
  "defaultModifierItemPricingVersionId",
  "locationModifierGroupModifierItemId",
  "modifierGroupModifierItemId",
  "modifierItemId",
  "description",
  "checkName",
  "kdsName",
  "posName",
  "onlineName",
  "includedModifierItems",
  "requiredModifierItems",
  "isDisabled",
  "defaultModifiersPrice"
];
var returnLabel5 = (field, depth) => {
  if (depth === 1) {
    if (field in ModifierGroupMasterFieldLabels) {
      return i18n_config_default.t(
        `app.modals.modifierGroupsDiffModal.master.${field}`
      );
    }
    if (field in ModifierGroupBasicSectionFieldLabels) {
      return i18n_config_default.t(
        `app.modals.modifierGroupsDiffModal.basic.${field}`
      );
    }
    if (field in ModifierGroupRegisterDisplayFieldLabels) {
      return i18n_config_default.t(
        `app.modals.modifierGroupsDiffModal.register.${field}`
      );
    }
  }
  if (depth === 3) {
    if (field in ModifierGroupModifierItemsFieldsLabels) {
      return i18n_config_default.t(
        `app.modals.modifierGroupsDiffModal.modifierItem.${field}`
      );
    }
    if (field in ModifierGroupModifierGroupPricingVersionsLabels) {
      return i18n_config_default.t(
        `app.modals.modifierGroupsDiffModal.modifierGroupPricingVersions.${field}`
      );
    }
  }
  if (depth === 4 && field in ModifierGroupModifierGroupPricingVersionsLabels) {
    return i18n_config_default.t(
      `app.modals.modifierGroupsDiffModal.modifierGroupPricingVersions.${field}`
    );
  }
};
var diffModifierGroupsFactory = (modifierGroupId, diffArray, modifierGroupData, state) => {
  const modifierItemsIds = [];
  const pricingVersionIds = [];
  const { modifierItems: menuModifierItems } = state.menu.selectedMode.currentMenu;
  const originalData = selectOriginalMenuData(state);
  const modifierGroupPricingVersions = originalData.modifierGroupPricingVersions;
  if (diffArray.length > 0) {
    const formattedDiffArray = diffArray.filter((diff11) => diff11.path.length === 1).map((diff11) => {
      var _a, _b, _c;
      if (!diff11.path)
        return { field: null };
      const field = diff11.path[0];
      const value = field in ModifierGroupRegisterDisplayFieldLabels ? diff11.rhs : (_a = diff11.rhs) != null ? _a : "";
      if (field === "customizerSlicing") {
        return {
          field,
          label: (_b = returnLabel5(field, 1)) != null ? _b : "",
          value,
          textValue: i18n_config_default.t(
            `menuScreen.modifierGroupDetails.basic.customizerSlicing.${value}`
          )
        };
      }
      return {
        field,
        label: (_c = returnLabel5(field, 1)) != null ? _c : "",
        value
      };
    });
    diffArray.filter((diff11) => diff11.path[0] === "modifierGroupPricingVersions").map((diff11) => {
      if (diff11.path) {
        const pricingVersionId = Number(diff11.path[1]);
        if (!pricingVersionIds.includes(pricingVersionId))
          pricingVersionIds.push(pricingVersionId);
      }
    });
    const formattedPricingDiffArray = diffArray.filter(
      (diff11) => diff11.path.length === 3 && diff11.path[0] === "modifierGroupPricingVersions"
    ).map((diff11) => {
      var _a;
      if (!diff11.path)
        return { field: null };
      const field = diff11.path[2];
      const value = (_a = diff11.rhs) != null ? _a : "";
      const pricingVersionId = Number(diff11.path[1]);
      return {
        field,
        label: returnLabel5(field, 3),
        value,
        pricingVersionId
      };
    });
    let formattedModItemPricingVersionsDiffArray = diffArray.filter(
      (diff11) => diff11.path.length === 4 && diff11.path[0] === "modifierGroupPricingVersions" && diff11.kind !== "D"
    ).map((diff11) => {
      var _a, _b;
      if (!diff11.path)
        return { field: null };
      const field = diff11.path[2];
      const value = (_a = diff11.rhs) != null ? _a : "";
      const previousValue = (_b = diff11.lhs) != null ? _b : value;
      const pricingVersionId = Number(diff11.path[1]);
      const modifierItemId = Number(diff11.path[3]);
      if (!modifierItemsIds.includes(modifierItemId))
        modifierItemsIds.push(modifierItemId);
      if (field === "modItemPricingVersions") {
        return {
          field,
          label: returnLabel5(field, 4),
          previousValue,
          value,
          textValue: menuModifierItems[modifierItemId].modifierItemPricingVersions[Number(value)].name,
          pricingVersionId,
          modifierItemId
        };
      } else {
        return {
          field,
          label: returnLabel5(field, 4),
          value,
          pricingVersionId,
          modifierItemId
        };
      }
    });
    const formattedModifierItemsDiffArray = diffArray.filter(
      (diff11) => diff11.path.length === 3 && diff11.path[0] === "modifierItems"
    ).map((diff11) => {
      var _a, _b;
      if (!diff11.path)
        return { field: null };
      const field = diff11.path[2];
      const value = (_a = diff11.rhs) != null ? _a : "";
      const modifierItemId = Number(diff11.path[1]);
      if (!modifierItemsIds.includes(modifierItemId))
        modifierItemsIds.push(modifierItemId);
      return {
        field,
        label: (_b = returnLabel5(field, 3)) != null ? _b : "",
        value,
        modifierItemId
      };
    });
    diffArray.filter(
      (diff11) => diff11.path.length === 2 && (diff11.kind === "D" || diff11.kind === "N") && diff11.path[0] === "modifierItems"
    ).map((diff11) => {
      if (diff11.path) {
        const modifierItemId = diff11.path[1];
        if (!modifierItemsIds.includes(Number(modifierItemId)))
          modifierItemsIds.push(Number(modifierItemId));
      }
    });
    let totalModifierItemsChanges = formattedModifierItemsDiffArray.length;
    diffArray.filter(
      (diff11) => diff11.path.length === 2 && diff11.path[0] === "modifierGroupPricingVersions" && diff11.kind === "N"
    ).map((diff11) => {
      if (!diff11.path)
        return { field: null };
      const newPricingVersionModifierItems = diff11.rhs;
      if (newPricingVersionModifierItems) {
        const modItemGroupPricingVersions = newPricingVersionModifierItems.modItemPricingVersions;
        const modifierItemChanges = Object.entries(
          modItemGroupPricingVersions
        ).map(([modifierItemId, pricingVersionId]) => {
          if (!modifierItemsIds.includes(Number(modifierItemId)))
            modifierItemsIds.push(Number(modifierItemId));
          const value = menuModifierItems[Number(modifierItemId)].modifierItemPricingVersions[pricingVersionId].modifierItemPricingVersionId;
          return {
            field: "modItemPricingVersions",
            label: returnLabel5("modItemPricingVersions", 4),
            previousValue: value,
            value,
            textValue: menuModifierItems[Number(modifierItemId)].modifierItemPricingVersions[pricingVersionId].name,
            pricingVersionId: newPricingVersionModifierItems.modifierGroupPricingVersionId,
            modifierItemId: Number(modifierItemId)
          };
        });
        formattedModItemPricingVersionsDiffArray = [
          ...formattedModItemPricingVersionsDiffArray,
          ...modifierItemChanges
        ];
      }
      return { field: null };
    });
    const modifierItemsChanged = modifierItemsIds.map((modifierItemId) => {
      const modItemPricingVersionChanges = Object.values(
        formattedModItemPricingVersionsDiffArray
      ).filter((change) => change.modifierItemId === modifierItemId);
      const areModItemPricingVersions = modItemPricingVersionChanges.filter(
        (change) => change.field === "modItemPricingVersions"
      );
      const wasAdded = diffArray.find(
        (diff11) => diff11.path.length === 2 && diff11.kind === "N" && diff11.path[0] === "modifierItems" && diff11.path[1] === modifierItemId.toString()
      );
      const wasDeleted = diffArray.find(
        (diff11) => diff11.path.length === 2 && diff11.kind === "D" && diff11.path[0] === "modifierItems" && diff11.path[1] === modifierItemId.toString()
      );
      if (wasDeleted) {
        totalModifierItemsChanges += 1;
        return {
          label: menuModifierItems[Number(modifierItemId)].name,
          id: modifierItemId,
          action: "remove",
          changes: []
        };
      } else if (wasAdded) {
        totalModifierItemsChanges += 1;
        const newModifierItem = wasAdded.rhs;
        let formattedNewFieldsArray = Object.entries(
          newModifierItem
        ).filter(
          ([field]) => !modifierGroupIgnoredModifierGroupModifierItemFields.includes(
            field
          )
        ).map(([field, value]) => {
          return {
            field,
            label: returnLabel5(field, 3),
            value
          };
        });
        if (areModItemPricingVersions.length > 0) {
          const pricingVersionChanges = formattedPricingVersionsChanges(
            areModItemPricingVersions,
            menuModifierItems,
            modifierGroupData,
            modifierItemId
          );
          const quantityMode = modifierGroupData.quantityMode;
          if (quantityMode === "Off" /* OFF */) {
            formattedNewFieldsArray = formattedNewFieldsArray.filter(
              (modifierItem) => !itemIgnoredQuantityOffFields.includes(modifierItem.field)
            );
          } else if (quantityMode === "x1,x2,x3" /* NUMBER */) {
            formattedNewFieldsArray = formattedNewFieldsArray.filter(
              (modifierItem) => !itemIgnoredQuantityNumberFields.includes(modifierItem.field)
            );
          } else {
            formattedNewFieldsArray = formattedNewFieldsArray.filter(
              (modifierItem) => !itemIgnoredQuantitySizeFields.includes(modifierItem.field)
            );
          }
          totalModifierItemsChanges += formattedNewFieldsArray.length;
          return {
            label: menuModifierItems[Number(modifierItemId)].name,
            id: modifierItemId,
            action: "add",
            changes: [
              ...formattedNewFieldsArray,
              ...modItemPricingVersionChanges.filter(
                (change) => change.modifierItemId === modifierItemId
              ),
              ...pricingVersionChanges
            ]
          };
        } else {
          totalModifierItemsChanges += formattedNewFieldsArray.length;
          return {
            label: menuModifierItems[Number(modifierItemId)].name,
            id: modifierItemId,
            action: "add",
            changes: formattedNewFieldsArray
          };
        }
      } else {
        if (areModItemPricingVersions.length > 0) {
          const pricingVersionChanges = formattedPricingVersionsChanges(
            areModItemPricingVersions,
            menuModifierItems,
            modifierGroupData,
            modifierItemId
          );
          return {
            label: menuModifierItems[Number(modifierItemId)].name,
            id: modifierItemId,
            action: "update",
            changes: [
              ...formattedModifierItemsDiffArray.filter(
                (item) => item.modifierItemId === modifierItemId
              ),
              ...modItemPricingVersionChanges.filter(
                (change) => change.modifierItemId === modifierItemId
              ),
              ...pricingVersionChanges
            ]
          };
        } else {
          return {
            label: menuModifierItems[Number(modifierItemId)].name,
            id: modifierItemId,
            action: "update",
            changes: formattedModifierItemsDiffArray.filter(
              (item) => item.modifierItemId === modifierItemId
            )
          };
        }
      }
    });
    const selectedModifierItems = modifierItemsChanged.filter(
      (item) => item.changes.filter((change) => change.field === "isSelected").length > 0
    ).length;
    const { masterChanges, basicChanges, registerChanges } = filterChangesBySection4(formattedDiffArray);
    const formattedPricingVersions = pricingVersionIds.map((pricingVersionId) => {
      const wasDeleted = diffArray.find(
        (diff11) => diff11.path.length === 2 && diff11.kind === "D" && diff11.path[1] === pricingVersionId.toString()
      );
      const wasAdded = diffArray.find(
        (diff11) => diff11.path.length === 2 && diff11.kind === "N" && diff11.path[1] === pricingVersionId.toString()
      );
      if (wasDeleted) {
        return {
          label: modifierGroupPricingVersions[Number(pricingVersionId)].name,
          id: pricingVersionId,
          action: "remove",
          totalOfChanges: 0,
          changes: []
        };
      } else if (wasAdded) {
        const newPricingVersion = wasAdded.rhs;
        return formatNewPricingVersion(
          newPricingVersion,
          modifierGroupData,
          pricingVersionId
        );
      } else {
        const pricingVersionChanges = formattedPricingDiffArray.filter(
          (pricingChange) => pricingChange.pricingVersionId === pricingVersionId
        );
        const totalOfChanges = modifierItemsChanged.reduce((acc, modifierItem) => {
          return acc + modifierItem.changes.filter((change) => {
            if (!change.pricingVersionId)
              return false;
            if (change.pricingVersionId === pricingVersionId)
              return true;
            return false;
          }).length;
        }, 0) + pricingVersionChanges.length;
        return {
          label: modifierGroupPricingVersions[Number(pricingVersionId)].name,
          id: pricingVersionId,
          action: "update",
          totalOfChanges,
          changes: pricingVersionChanges
        };
      }
    });
    return {
      modifierGroupId,
      masterChanges,
      basic: basicChanges,
      register: registerChanges,
      pricingVersions: formattedPricingVersions,
      modifierItems: modifierItemsChanged,
      totalModifierItemsChanges,
      selectedModifierItems
    };
  }
  return null;
};
var formatNewPricingVersion = (newPricingVersion, modifierGroupData, pricingVersionId) => {
  const formattedNewFieldsArray = Object.entries(
    newPricingVersion
  ).filter(
    ([field]) => !modifierGroupIgnoredModifierGroupPricingVersionFields.includes(field)
  ).map(([field, value]) => {
    return {
      field,
      label: returnLabel5(field, 3),
      value
    };
  });
  return {
    label: modifierGroupData.modifierGroupPricingVersions[Number(pricingVersionId)].name,
    id: pricingVersionId,
    action: "add",
    totalOfChanges: 0,
    changes: formattedNewFieldsArray
  };
};
var formattedPricingVersionsChanges = (areModItemPricingVersions, menuModifierItems, modifierGroupData, modifierItemId) => {
  let pricingVersionChanges = areModItemPricingVersions.reduce(
    (acc, modItemPricingVersion) => {
      const pricingVersion = menuModifierItems[modifierItemId].modifierItemPricingVersions[Number(modItemPricingVersion.value)];
      const pricingVersionChangesByElement = Object.entries(pricingVersion).filter(
        ([fieldPricingVersion]) => !modifierItemIgnoredModifierItemPricingVersion.includes(
          fieldPricingVersion
        )
      ).map(([fieldPricingVersion, valuePricingVersion]) => {
        return {
          field: fieldPricingVersion,
          label: returnLabel5(fieldPricingVersion, 3),
          pricingVersionId: modItemPricingVersion.pricingVersionId,
          modifierItemId,
          value: valuePricingVersion
        };
      });
      return [...acc, ...pricingVersionChangesByElement];
    },
    []
  );
  const quantityMode = modifierGroupData.quantityMode;
  if (quantityMode === "Off" /* OFF */) {
    pricingVersionChanges = pricingVersionChanges.filter(
      (modifierItem) => !itemIgnoredQuantityOffFields.includes(modifierItem.field)
    );
  } else if (quantityMode === "x1,x2,x3" /* NUMBER */) {
    pricingVersionChanges = pricingVersionChanges.filter(
      (modifierItem) => !itemIgnoredQuantityNumberFields.includes(modifierItem.field)
    );
  } else {
    pricingVersionChanges = pricingVersionChanges.filter(
      (modifierItem) => !itemIgnoredQuantitySizeFields.includes(modifierItem.field)
    );
  }
  return pricingVersionChanges;
};
var filterChangesBySection4 = (formattedDiffArray) => {
  const masterChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(ModifierGroupMasterFieldLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  );
  const basicChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(ModifierGroupBasicSectionFieldLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  );
  const registerChanges = formattedDiffArray.filter(
    (diff11) => diff11.field ? Object.keys(ModifierGroupRegisterDisplayFieldLabels).filter((value) => isNaN(Number(value))).includes(diff11.field) : false
  );
  return {
    masterChanges,
    basicChanges,
    registerChanges
  };
};
var SpecialMasterFieldLabels = /* @__PURE__ */ ((SpecialMasterFieldLabels2) => {
  SpecialMasterFieldLabels2[SpecialMasterFieldLabels2["name"] = 0] = "name";
  return SpecialMasterFieldLabels2;
})(SpecialMasterFieldLabels || {});
var SpecialBasicSectionFieldLabels = /* @__PURE__ */ ((SpecialBasicSectionFieldLabels2) => {
  SpecialBasicSectionFieldLabels2[SpecialBasicSectionFieldLabels2["active"] = 0] = "active";
  SpecialBasicSectionFieldLabels2[SpecialBasicSectionFieldLabels2["posName"] = 1] = "posName";
  SpecialBasicSectionFieldLabels2[SpecialBasicSectionFieldLabels2["checkName"] = 2] = "checkName";
  return SpecialBasicSectionFieldLabels2;
})(SpecialBasicSectionFieldLabels || {});
var SpecialMoreInformationFieldLabels = /* @__PURE__ */ ((SpecialMoreInformationFieldLabels2) => {
  SpecialMoreInformationFieldLabels2[SpecialMoreInformationFieldLabels2["description"] = 0] = "description";
  return SpecialMoreInformationFieldLabels2;
})(SpecialMoreInformationFieldLabels || {});
var SpecialsSchemeFieldLabels = /* @__PURE__ */ ((SpecialsSchemeFieldLabels2) => {
  SpecialsSchemeFieldLabels2[SpecialsSchemeFieldLabels2["specialApplyTo"] = 0] = "specialApplyTo";
  SpecialsSchemeFieldLabels2[SpecialsSchemeFieldLabels2["discountType"] = 1] = "discountType";
  SpecialsSchemeFieldLabels2[SpecialsSchemeFieldLabels2["discountAmount"] = 2] = "discountAmount";
  SpecialsSchemeFieldLabels2[SpecialsSchemeFieldLabels2["thresholdAmount"] = 3] = "thresholdAmount";
  SpecialsSchemeFieldLabels2[SpecialsSchemeFieldLabels2["buyQuantity"] = 4] = "buyQuantity";
  SpecialsSchemeFieldLabels2[SpecialsSchemeFieldLabels2["getQuantity"] = 5] = "getQuantity";
  return SpecialsSchemeFieldLabels2;
})(SpecialsSchemeFieldLabels || {});
var SpecialGetItemsFieldLabels = /* @__PURE__ */ ((SpecialGetItemsFieldLabels2) => {
  SpecialGetItemsFieldLabels2[SpecialGetItemsFieldLabels2["mimicItems"] = 0] = "mimicItems";
  return SpecialGetItemsFieldLabels2;
})(SpecialGetItemsFieldLabels || {});
var SpecialAvailabilityFields = /* @__PURE__ */ ((SpecialAvailabilityFields2) => {
  SpecialAvailabilityFields2[SpecialAvailabilityFields2["day"] = 0] = "day";
  SpecialAvailabilityFields2[SpecialAvailabilityFields2["startTime"] = 1] = "startTime";
  SpecialAvailabilityFields2[SpecialAvailabilityFields2["endTime"] = 2] = "endTime";
  return SpecialAvailabilityFields2;
})(SpecialAvailabilityFields || {});
var AVAILABILITY_FIELD = "availableTimes";
var BUY_ITEMS_FIELD = "buyItemIds";
var GET_ITEMS_FIELD = "getItemIds";
var BUY_COMBOS_FIELD = "buyComboIds";
var GET_COMBOS_FIELD = "getComboIds";
var returnLabel6 = (field, depth) => {
  if (depth === 1) {
    if (field in SpecialMasterFieldLabels) {
      return i18n_config_default.t(
        `app.modals.specialsDiff.master.${field}`
      );
    }
  } else if (depth === 3) {
    if (field in SpecialBasicSectionFieldLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.basic.${field}`
      );
    } else if (field in SpecialsSchemeFieldLabels) {
      return i18n_config_default.t(
        `app.modals.specialsDiff.specialsScheme.${field}`
      );
    } else if (field in SpecialMoreInformationFieldLabels) {
      return i18n_config_default.t(
        `app.modals.itemsDiff.moreInfo.${field}`
      );
    } else if (field in SpecialGetItemsFieldLabels) {
      return i18n_config_default.t(
        `app.modals.specialsDiff.getItemsFields.${field}`
      );
    }
  } else if (depth === 6) {
    if (field in SpecialAvailabilityFields) {
      return i18n_config_default.t(
        `app.modals.registerModeDiffModal.general.timeBasedMenuType.${field}`
      );
    }
  }
};
var MENU_TYPE_VERSION_DIFF_INITIAL2 = {
  label: "",
  id: 0,
  action: "remove",
  totalOfChanges: 0,
  sections: {
    basic: [],
    moreInfo: [],
    availability: {
      monday: [],
      tuesday: [],
      wednesday: [],
      thursday: [],
      friday: [],
      saturday: [],
      sunday: []
    },
    specialsScheme: [],
    associations: {
      buyItems: [],
      getItems: [],
      buyCombos: [],
      getCombos: [],
      getItemsChanges: []
    }
  }
};
var diffSpecialsFactory = (diffArray, state, originData, finalData) => {
  if (diffArray.length > 0) {
    const specialId = state.menu.changeData.id;
    const menuTypeVersions = generateMenuTypeVersionsArray2(
      diffArray,
      state,
      originData,
      finalData
    );
    addTotalChanges2(menuTypeVersions);
    const diffObject = {
      specialId,
      masterChanges: generateMasterChangesArray2(diffArray, state),
      menuTypeVersions
    };
    return diffObject;
  }
  return null;
};
var generateMasterChangesArray2 = (diffArray, state) => {
  const originalData = selectOriginalMenuData(state);
  const { data } = state.menu.changeData;
  const masterChanges = [];
  const specialLocationIds = originalData.locationIds;
  const locationIds = data.locationIds;
  const hasSomeLocationIds = diffArray.filter((diff11) => diff11.path[0] === "locationIds").length > 0 ? true : false;
  const locationValues = getLocationsChanges(
    hasSomeLocationIds,
    specialLocationIds,
    locationIds,
    state
  );
  const locationsChanges = {
    field: "locationIds",
    label: i18n_config_default.t("app.modals.itemsDiff.master.locationIds"),
    value: locationValues,
    menuTypeVersionId: 0
  };
  diffArray.forEach(
    (diff11) => filterDiffFunction(
      diff11,
      ({ field, diffLength, newDiff }) => {
        if (diffLength !== 1) {
          return;
        }
        if (field in SpecialMasterFieldLabels) {
          masterChanges.push(newDiff);
        }
      },
      returnLabel6
    )
  );
  if (locationValues.length > 0) {
    masterChanges.push(locationsChanges);
  }
  return masterChanges;
};
var getArraysByAction3 = (diffArray, menuTypeId) => {
  const {
    addedMenuTypesDiff,
    removedMenuTypesDiff,
    changedMenuTypeFieldsDiff
  } = getMenuTypeArraysByAction(diffArray, menuTypeId);
  const changedAvailabilityDiff = diffArray.filter(
    (diff11) => diff11.path.length === 6 && diff11.path[2] === AVAILABILITY_FIELD && diff11.kind === "E" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const removedOrAddedAvailabilityDiff = diffArray.filter(
    (diff11) => diff11.path.length === 4 && diff11.path[2] === AVAILABILITY_FIELD && diff11.kind === "A" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const removedOrAddedGetItemsDiff = diffArray.filter(
    (diff11) => diff11.path.length === 3 && diff11.path[2] === GET_ITEMS_FIELD && diff11.kind === "A" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const removedOrAddedBuyItemsDiff = diffArray.filter(
    (diff11) => diff11.path.length === 3 && diff11.path[2] === BUY_ITEMS_FIELD && diff11.kind === "A" && (menuTypeId ? Number(diff11.path[1]) === menuTypeId : true)
  );
  const getItemsChangesDiff = changedMenuTypeFieldsDiff.filter(
    (diff11) => diff11.path[diff11.path.length - 1] in SpecialGetItemsFieldLabels
  );
  return {
    addedMenuTypesDiff,
    removedMenuTypesDiff,
    changedMenuTypeFieldsDiff,
    changedAvailabilityDiff,
    removedOrAddedAvailabilityDiff,
    removedOrAddedBuyItemsDiff,
    removedOrAddedGetItemsDiff,
    getItemsChangesDiff
  };
};
var generateMenuTypeVersionsArray2 = (diffArray, state, originData, finalData) => {
  const changeData = finalData || state.menu.changeData.data;
  const { menuTypes, items, combos } = state.menu.selectedMode.currentMenu;
  const originalData = originData || selectOriginalMenuData(state);
  const menuTypeVersions = [];
  const {
    addedMenuTypesDiff,
    removedMenuTypesDiff,
    changedMenuTypeFieldsDiff,
    changedAvailabilityDiff,
    removedOrAddedAvailabilityDiff
  } = getArraysByAction3(diffArray);
  addedMenuTypesDiff.forEach((diff11) => {
    menuTypeVersions.push(
      menuTypeObjToDiff2(
        diff11.rhs,
        state,
        finalData
      )
    );
  });
  removedMenuTypesDiff.forEach((diff11) => {
    const menuTypeVersionId = Number(diff11.path[1]);
    menuTypeVersions.push(__spreadProps(__spreadValues({}, cloneDeep16(MENU_TYPE_VERSION_DIFF_INITIAL2)), {
      label: menuTypes[menuTypeVersionId].name,
      id: menuTypeVersionId,
      action: "remove"
    }));
  });
  const getMenuTypeVersionEditIndex = (menuTypeVersionId) => {
    return getArrayEditIndex(menuTypeVersionId, menuTypeVersions);
  };
  changedAvailabilityDiff.forEach((diff11) => {
    filterDiffFunction(
      diff11,
      ({ newDiff }) => {
        var _a, _b, _c;
        if (!(newDiff.field in SpecialAvailabilityFields)) {
          return;
        }
        const menuTypeVersionId = Number(diff11.path[1]);
        const menuTypeVersionIndex = getMenuTypeVersionEditIndex(menuTypeVersionId);
        const hasMenuTypeVersionEdit = menuTypeVersionIndex >= 0;
        const day = diff11.path[3];
        const index = Number(diff11.path[4]);
        const timeId = (_c = (_b = (_a = originalData.menuTypeVersions[menuTypeVersionId].availableTimes) == null ? void 0 : _a[day]) == null ? void 0 : _b[index]) == null ? void 0 : _c.id;
        const newTimeDiff = {
          label: day,
          action: "update",
          id: timeId,
          tabletGeneratedId: timeId,
          changes: [newDiff],
          index
        };
        if (hasMenuTypeVersionEdit) {
          const menuTypeVersion = menuTypeVersions[menuTypeVersionIndex];
          const availabilityIndex = getArrayEditIndex(
            timeId,
            menuTypeVersion.sections.availability[day]
          );
          const hasAvailabilityIndex = availabilityIndex >= 0;
          if (hasAvailabilityIndex) {
            menuTypeVersion.sections.availability[day][availabilityIndex].changes.push(newDiff);
          } else {
            menuTypeVersion.sections.availability[day].push(newTimeDiff);
          }
        } else {
          const clonedMenuTypeVersionDiffInitial = cloneDeep16(
            MENU_TYPE_VERSION_DIFF_INITIAL2
          );
          menuTypeVersions.push({
            action: "update",
            id: menuTypeVersionId,
            label: menuTypes[menuTypeVersionId].name,
            totalOfChanges: 0,
            sections: __spreadProps(__spreadValues({}, clonedMenuTypeVersionDiffInitial.sections), {
              availability: __spreadProps(__spreadValues({}, clonedMenuTypeVersionDiffInitial.sections.availability), {
                [day]: [newTimeDiff]
              })
            })
          });
        }
      },
      returnLabel6
    );
  });
  removedOrAddedAvailabilityDiff.forEach((diff11) => {
    var _a, _b, _c, _d, _e;
    const wasRemoved = ((_a = diff11.item) == null ? void 0 : _a.kind) === "D";
    const menuTypeVersionId = Number(diff11.path[1]);
    const menuTypeVersionIndex = getMenuTypeVersionEditIndex(menuTypeVersionId);
    const hasMenuTypeVersionEdit = menuTypeVersionIndex >= 0;
    const day = diff11.path[3];
    const index = Number(diff11.index);
    const newTimeDiff = {
      label: day,
      index,
      action: wasRemoved ? "remove" : "add",
      tabletGeneratedId: wasRemoved ? ((_b = diff11.item) == null ? void 0 : _b.lhs).id : ((_c = diff11.item) == null ? void 0 : _c.rhs).id,
      id: wasRemoved ? ((_d = diff11.item) == null ? void 0 : _d.lhs).id : 0,
      changes: wasRemoved ? [] : timeToDiff(
        (_e = diff11.item) == null ? void 0 : _e.rhs,
        menuTypeVersionId,
        index
      ).changes
    };
    if (hasMenuTypeVersionEdit) {
      const menuTypeVersion = menuTypeVersions[menuTypeVersionIndex];
      menuTypeVersion.sections.availability[day].push(newTimeDiff);
    } else {
      const clonedMenuTypeVersionDiffInitial = cloneDeep16(
        MENU_TYPE_VERSION_DIFF_INITIAL2
      );
      menuTypeVersions.push({
        action: "update",
        id: menuTypeVersionId,
        label: menuTypes[menuTypeVersionId].name,
        totalOfChanges: 0,
        sections: __spreadProps(__spreadValues({}, clonedMenuTypeVersionDiffInitial.sections), {
          availability: __spreadProps(__spreadValues({}, clonedMenuTypeVersionDiffInitial.sections.availability), {
            [day]: [newTimeDiff]
          })
        })
      });
    }
  });
  Object.entries(originalData.menuTypeVersions).forEach(
    ([menuTypeVersionId, menuTypeVersion]) => {
      const menuTypeVersionIdNumber = Number(menuTypeVersionId);
      const changedMenuTypeVersion = changeData.menuTypeVersions[menuTypeVersionIdNumber];
      if (!changedMenuTypeVersion) {
        return;
      }
      let menuTypeVersionIndex = getMenuTypeVersionEditIndex(
        menuTypeVersionIdNumber
      );
      const hasMenuTypeVersionEdit = menuTypeVersionIndex >= 0;
      const mapIntoItemChange = (locationChange, isCombo) => {
        var _a, _b;
        return {
          value: isCombo ? (_a = combos[locationChange.id]) == null ? void 0 : _a.name : (_b = items[locationChange.id]) == null ? void 0 : _b.name,
          id: locationChange.id,
          action: locationChange.action,
          label: changeData.menuTypeVersions[menuTypeVersionIdNumber].specialApplyTo === "bogo" /* BOGO */ ? i18n_config_default.t(
            `app.modals.specialsDiff.getItemsFields.buyItemIds.title.bogo.${isCombo ? "combos" : "items"}`
          ) : i18n_config_default.t(
            `app.modals.specialsDiff.getItemsFields.buyItemIds.title.item.${isCombo ? "combos" : "items"}`
          )
        };
      };
      const buyItemValues = getArrayNumberChanges(
        menuTypeVersion.buyItemIds,
        changedMenuTypeVersion.buyItemIds
      ).map((value) => mapIntoItemChange(value, false));
      const getItemValues = getArrayNumberChanges(
        menuTypeVersion.getItemIds,
        changedMenuTypeVersion.getItemIds
      ).map((value) => mapIntoItemChange(value, false));
      const buyComboValues = getArrayNumberChanges(
        menuTypeVersion.buyComboIds,
        changedMenuTypeVersion.buyComboIds
      ).map((value) => mapIntoItemChange(value, true));
      const getComboValues = getArrayNumberChanges(
        menuTypeVersion.getComboIds,
        changedMenuTypeVersion.getComboIds
      ).map((value) => mapIntoItemChange(value, true));
      if (!hasMenuTypeVersionEdit && (buyItemValues.length > 0 || getItemValues.length > 0 || getComboValues.length > 0 || buyComboValues.length > 0)) {
        menuTypeVersions.push(__spreadProps(__spreadValues({}, cloneDeep16(MENU_TYPE_VERSION_DIFF_INITIAL2)), {
          action: "update",
          id: menuTypeVersionIdNumber,
          label: menuTypes[menuTypeVersionIdNumber].name,
          totalOfChanges: 0
        }));
      }
      menuTypeVersionIndex = getMenuTypeVersionEditIndex(
        menuTypeVersionIdNumber
      );
      if (menuTypeVersionIndex < 0) {
        return;
      }
      menuTypeVersions[menuTypeVersionIndex].sections.associations.buyItems = buyItemValues;
      menuTypeVersions[menuTypeVersionIndex].sections.associations.getItems = getItemValues;
      menuTypeVersions[menuTypeVersionIndex].sections.associations.buyCombos = buyComboValues;
      menuTypeVersions[menuTypeVersionIndex].sections.associations.getCombos = getComboValues;
    }
  );
  const reduceChangesFunction = (prevDiff, currentDiff, additionalData) => {
    return filterDiffFunction(
      currentDiff,
      ({ field, newDiff }) => {
        const menuTypeVersionId = Number(currentDiff.path[1]);
        if (prevDiff[menuTypeVersionId]) {
          return __spreadProps(__spreadValues({}, prevDiff), {
            [menuTypeVersionId]: __spreadProps(__spreadValues({}, prevDiff[menuTypeVersionId]), {
              [field]: newDiff.value
            })
          });
        } else {
          return __spreadProps(__spreadValues({}, prevDiff), {
            [menuTypeVersionId]: __spreadProps(__spreadValues({}, additionalData), {
              [field]: newDiff.value
            })
          });
        }
      },
      returnLabel6
    );
  };
  const changedMenuTypeReduced = changedMenuTypeFieldsDiff.reduce(
    (prevValue, currentValue) => {
      const menuTypeVersionId = Number(currentValue.path[1]);
      return reduceChangesFunction(prevValue, currentValue, {
        menuTypeId: menuTypeVersionId
      });
    },
    {}
  );
  Object.entries(changedMenuTypeReduced).forEach(
    ([menuTypeVersionId, menuTypeVersionObj]) => {
      const menuTypeVersionIndex = getMenuTypeVersionEditIndex(
        Number(menuTypeVersionId)
      );
      const hasMenuTypeVersionEdit = menuTypeVersionIndex >= 0;
      const menuTypeVersionDiff = menuTypeObjToDiff2(
        menuTypeVersionObj,
        state,
        finalData
      );
      if (hasMenuTypeVersionEdit) {
        menuTypeVersions[menuTypeVersionIndex] = __spreadProps(__spreadValues({}, menuTypeVersions[menuTypeVersionIndex]), {
          sections: __spreadProps(__spreadValues({}, menuTypeVersions[menuTypeVersionIndex].sections), {
            basic: [
              ...menuTypeVersions[menuTypeVersionIndex].sections.basic,
              ...menuTypeVersionDiff.sections.basic
            ],
            moreInfo: [
              ...menuTypeVersions[menuTypeVersionIndex].sections.moreInfo,
              ...menuTypeVersionDiff.sections.moreInfo
            ],
            specialsScheme: [
              ...menuTypeVersions[menuTypeVersionIndex].sections.specialsScheme,
              ...menuTypeVersionDiff.sections.specialsScheme
            ],
            associations: {
              buyItems: [
                ...menuTypeVersions[menuTypeVersionIndex].sections.associations.buyItems,
                ...menuTypeVersionDiff.sections.associations.buyItems
              ],
              getItems: [
                ...menuTypeVersions[menuTypeVersionIndex].sections.associations.getItems,
                ...menuTypeVersionDiff.sections.associations.getItems
              ],
              buyCombos: [
                ...menuTypeVersions[menuTypeVersionIndex].sections.associations.buyCombos,
                ...menuTypeVersionDiff.sections.associations.buyCombos
              ],
              getCombos: [
                ...menuTypeVersions[menuTypeVersionIndex].sections.associations.getCombos,
                ...menuTypeVersionDiff.sections.associations.getCombos
              ],
              getItemsChanges: [
                ...menuTypeVersions[menuTypeVersionIndex].sections.associations.getItemsChanges,
                ...menuTypeVersionDiff.sections.associations.getItemsChanges
              ]
            }
          })
        });
      } else {
        menuTypeVersions.push(__spreadProps(__spreadValues({}, menuTypeVersionDiff), {
          action: "update",
          totalOfChanges: 0
        }));
      }
    }
  );
  return menuTypeVersions;
};
var arrayNumberToAddArrayChange = (array, labelGetter, fieldLabelGetter) => {
  return array.map((id) => ({
    value: labelGetter(id),
    id,
    action: "add",
    label: fieldLabelGetter(id)
  }));
};
var menuTypeObjToDiff2 = (menuTypeVersion, state, finalData) => {
  const currentMenu = state.menu.selectedMode.currentMenu;
  const changeData = finalData || state.menu.changeData.data;
  const menuTypes = currentMenu.menuTypes;
  const items = currentMenu.items;
  const combos = currentMenu.combos;
  const menuTypeVersionId = menuTypeVersion.menuTypeId;
  const clonedMenuTypeVersionDiffInitial = cloneDeep16(
    MENU_TYPE_VERSION_DIFF_INITIAL2
  );
  const menuTypeVersionDiff = __spreadProps(__spreadValues({}, clonedMenuTypeVersionDiffInitial), {
    label: menuTypes[menuTypeVersionId].name,
    id: menuTypeVersionId,
    action: "add"
  });
  Object.entries(menuTypeVersion).forEach(([key, value]) => {
    const diff11 = {
      field: key,
      label: returnLabel6(key, 3) || "",
      value,
      menuTypeVersionId
    };
    if (key in SpecialBasicSectionFieldLabels) {
      menuTypeVersionDiff.sections.basic.push(diff11);
    } else if (key in SpecialsSchemeFieldLabels) {
      if (diff11.field === "discountAmount") {
        return menuTypeVersionDiff.sections.specialsScheme.push(__spreadProps(__spreadValues({}, diff11), {
          label: i18n_config_default.t(
            `app.modals.specialsDiff.specialsScheme.discountAmount${changeData.menuTypeVersions[menuTypeVersionId].discountType === "percent" /* PERCENT */ ? "Percentage" : ""}`
          ),
          textValue: changeData.menuTypeVersions[menuTypeVersionId].discountType === "percent" /* PERCENT */ ? `${diff11.value}%` : formatMoney("", diff11.value)
        }));
      }
      if (diff11.field === "specialApplyTo") {
        return menuTypeVersionDiff.sections.specialsScheme.push(__spreadProps(__spreadValues({}, diff11), {
          textValue: i18n_config_default.t(
            `menuScreen.specialDetails.scheme.applyTo.options.${diff11.value}`
          )
        }));
      }
      if (diff11.field === "discountType") {
        return menuTypeVersionDiff.sections.specialsScheme.push(__spreadProps(__spreadValues({}, diff11), {
          textValue: i18n_config_default.t(
            `menuScreen.discountDetails.discountScheme.inputs.discountType.options.${diff11.value}`
          )
        }));
      }
      menuTypeVersionDiff.sections.specialsScheme.push(diff11);
    } else if (key in SpecialMoreInformationFieldLabels) {
      menuTypeVersionDiff.sections.moreInfo.push(diff11);
    } else if (key in SpecialGetItemsFieldLabels) {
      menuTypeVersionDiff.sections.associations.getItemsChanges.push(diff11);
    } else if (key === AVAILABILITY_FIELD) {
      menuTypeVersionDiff.sections.availability = availabilityTimeObjToDiff(
        value,
        menuTypeVersionId
      );
    } else if (key === BUY_ITEMS_FIELD) {
      menuTypeVersionDiff.sections.associations.buyItems = arrayNumberToAddArrayChange(
        value,
        (itemId) => {
          var _a;
          return (_a = items[itemId]) == null ? void 0 : _a.name;
        },
        () => changeData.menuTypeVersions[menuTypeVersionId].specialApplyTo === "bogo" /* BOGO */ ? i18n_config_default.t(
          "menuScreen.specialDetails.associations.buyItemIds.title.bogo"
        ) : i18n_config_default.t(
          "menuScreen.specialDetails.associations.buyItemIds.title.item"
        )
      );
    } else if (key === GET_ITEMS_FIELD) {
      menuTypeVersionDiff.sections.associations.getItems = arrayNumberToAddArrayChange(
        value,
        (itemId) => {
          var _a;
          return (_a = items[itemId]) == null ? void 0 : _a.name;
        },
        () => changeData.menuTypeVersions[menuTypeVersionId].specialApplyTo === "bogo" /* BOGO */ ? i18n_config_default.t(
          "app.modals.specialsDiff.getItemsFields.buyItemIds.title.bogo.items"
        ) : i18n_config_default.t(
          "app.modals.specialsDiff.getItemsFields.buyItemIds.title.item.items"
        )
      );
    } else if (key === BUY_COMBOS_FIELD) {
      menuTypeVersionDiff.sections.associations.buyCombos = arrayNumberToAddArrayChange(
        value,
        (comboId) => {
          var _a;
          return (_a = combos[comboId]) == null ? void 0 : _a.name;
        },
        () => changeData.menuTypeVersions[menuTypeVersionId].specialApplyTo === "bogo" /* BOGO */ ? i18n_config_default.t(
          "app.modals.specialsDiff.getItemsFields.buyItemIds.title.bogo.combos"
        ) : i18n_config_default.t(
          "app.modals.specialsDiff.getItemsFields.buyItemIds.title.item.combos"
        )
      );
    } else if (key === GET_COMBOS_FIELD) {
      menuTypeVersionDiff.sections.associations.getCombos = arrayNumberToAddArrayChange(
        value,
        (comboId) => {
          var _a;
          return (_a = combos[comboId]) == null ? void 0 : _a.name;
        },
        () => changeData.menuTypeVersions[menuTypeVersionId].specialApplyTo === "bogo" /* BOGO */ ? i18n_config_default.t(
          "app.modals.specialsDiff.getItemsFields.buyItemIds.title.bogo.combos"
        ) : i18n_config_default.t(
          "app.modals.specialsDiff.getItemsFields.buyItemIds.title.item.combos"
        )
      );
    }
  });
  return menuTypeVersionDiff;
};
var timeToDiff = (time, menuTypeVersionId, index) => {
  const timeDiff = {
    id: time.id,
    index,
    tabletGeneratedId: time.id,
    action: "add",
    label: "",
    changes: []
  };
  Object.entries(time).forEach(([timeKey, timeValue]) => {
    const diff11 = {
      field: timeKey,
      label: returnLabel6(timeKey, 6) || "",
      value: timeValue,
      menuTypeVersionId
    };
    if (timeKey in SpecialAvailabilityFields) {
      timeDiff.changes.push(diff11);
    }
  });
  return timeDiff;
};
var availabilityTimeObjToDiff = (availability, menuTypeVersionId) => {
  const availabilityDiff = {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: []
  };
  Object.entries(availability).forEach(([key, value]) => {
    value.forEach((time, index) => {
      const timeDiff = timeToDiff(
        time,
        menuTypeVersionId,
        index
      );
      availabilityDiff[key].push(timeDiff);
    });
  });
  return availabilityDiff;
};
var addTotalChanges2 = (menuTypeVersions) => {
  menuTypeVersions.forEach((menuTypeVersionDiff) => {
    menuTypeVersionDiff.totalOfChanges = menuTypeVersionDiff.totalOfChanges + menuTypeVersionDiff.sections.basic.length + menuTypeVersionDiff.sections.moreInfo.length + menuTypeVersionDiff.sections.availability.monday.length + menuTypeVersionDiff.sections.availability.tuesday.length + menuTypeVersionDiff.sections.availability.wednesday.length + menuTypeVersionDiff.sections.availability.thursday.length + menuTypeVersionDiff.sections.availability.friday.length + menuTypeVersionDiff.sections.availability.saturday.length + menuTypeVersionDiff.sections.availability.sunday.length + menuTypeVersionDiff.sections.specialsScheme.length + menuTypeVersionDiff.sections.associations.buyItems.length + menuTypeVersionDiff.sections.associations.getItems.length + menuTypeVersionDiff.sections.associations.getCombos.length + menuTypeVersionDiff.sections.associations.buyCombos.length + menuTypeVersionDiff.sections.associations.getItemsChanges.length;
  });
};
var getNewSpecialFilteredItemsOfItemGroup = (items, menuTypeVersionId, state) => {
  const clonedItems = cloneDeep16(items);
  const newItems = Object.entries(clonedItems);
  const filteredItems = orderBy5(
    newItems.filter(
      ([itemId]) => isItemInMenuTypeCore(Number(itemId), menuTypeVersionId, state)
    ),
    (item) => item[1].sortPriority
  );
  return filteredItems.reduce((prev, current, currentIndex) => {
    return __spreadProps(__spreadValues({}, prev), {
      [Number(current[0])]: __spreadProps(__spreadValues({}, clonedItems[Number(current[0])]), {
        sortPriority: currentIndex + 1
      })
    });
  }, {});
};
var getSpecialNextItemGroupId = (itemGroups) => {
  return (max3(Object.keys(itemGroups || {}).map((id) => Number(id)) || []) || 0) + 1;
};
var applySpecialChangesToMenuTypes = (formattedMenuTypeVersions, hasMenuTypesToApplyChanges, state, dispatch) => {
  let renderErrorToast = false;
  const changeData = state.menu.changeData;
  const currentMenu = state.menu.selectedMode.currentMenu;
  const originData = cloneDeep16(selectOriginalMenuData(state));
  const clonedSpecialData = cloneDeep16(changeData.data);
  const items = currentMenu.items;
  const combos = currentMenu.combos;
  if (hasMenuTypesToApplyChanges) {
    const originMenuTypeVersionId = hasMenuTypesToApplyChanges == null ? void 0 : hasMenuTypesToApplyChanges.currentMenuType;
    const originMenuTypeChanges = cloneDeep16(
      formattedMenuTypeVersions.find(
        (formattedMenuTypeVersion) => formattedMenuTypeVersion.id === originMenuTypeVersionId
      )
    );
    hasMenuTypesToApplyChanges.menuTypesToApplyChanges.forEach((menuType) => {
      const menuTypeIdToApply = menuType.menuTypeId;
      const menuTypeFieldsForEach = (diff11) => {
        setWith(
          clonedSpecialData,
          `menuTypeVersions.${menuTypeIdToApply}.${diff11.field}`,
          diff11.value,
          Object
        );
      };
      originMenuTypeChanges == null ? void 0 : originMenuTypeChanges.sections.basic.forEach(menuTypeFieldsForEach);
      originMenuTypeChanges == null ? void 0 : originMenuTypeChanges.sections.moreInfo.forEach(menuTypeFieldsForEach);
      originMenuTypeChanges == null ? void 0 : originMenuTypeChanges.sections.specialsScheme.forEach(
        menuTypeFieldsForEach
      );
      originMenuTypeChanges == null ? void 0 : originMenuTypeChanges.sections.associations.getItemsChanges.forEach(
        menuTypeFieldsForEach
      );
      const itemIdsForEach = (diff11, field) => {
        var _a;
        const targetItemsArray = (_a = clonedSpecialData.menuTypeVersions[menuTypeIdToApply]) == null ? void 0 : _a[field];
        const selectedElement = ["buyComboIds", "getComboIds"].includes(field) ? combos[diff11.id] : items[diff11.id];
        if (!selectedElement.menuTypeVersions[menuTypeIdToApply]) {
          renderErrorToast = true;
          return;
        }
        const filteredArray = targetItemsArray.filter((id) => id !== diff11.id);
        const newTargetItemsArray = diff11.action === "add" ? [...filteredArray, diff11.id] : filteredArray;
        setWith(
          clonedSpecialData,
          `menuTypeVersions.${menuTypeIdToApply}.${field}`,
          newTargetItemsArray,
          Object
        );
      };
      originMenuTypeChanges == null ? void 0 : originMenuTypeChanges.sections.associations.buyItems.forEach(
        (diff11) => itemIdsForEach(diff11, "buyItemIds")
      );
      originMenuTypeChanges == null ? void 0 : originMenuTypeChanges.sections.associations.getItems.forEach(
        (diff11) => itemIdsForEach(diff11, "getItemIds")
      );
      originMenuTypeChanges == null ? void 0 : originMenuTypeChanges.sections.associations.buyCombos.forEach(
        (diff11) => itemIdsForEach(diff11, "buyComboIds")
      );
      originMenuTypeChanges == null ? void 0 : originMenuTypeChanges.sections.associations.getCombos.forEach(
        (diff11) => itemIdsForEach(diff11, "getComboIds")
      );
      const hasMimicActive = clonedSpecialData.menuTypeVersions[menuTypeIdToApply].mimicItems;
      if (hasMimicActive) {
        clonedSpecialData.menuTypeVersions[menuTypeIdToApply].getItemIds = [
          ...clonedSpecialData.menuTypeVersions[menuTypeIdToApply].buyItemIds
        ];
        clonedSpecialData.menuTypeVersions[menuTypeIdToApply].getComboIds = [
          ...clonedSpecialData.menuTypeVersions[menuTypeIdToApply].buyComboIds
        ];
      }
      const clonedTargetTimes = cloneDeep16(
        clonedSpecialData.menuTypeVersions[menuTypeIdToApply].availableTimes
      );
      const originTimes = cloneDeep16(
        clonedSpecialData.menuTypeVersions[originMenuTypeVersionId].availableTimes
      );
      Object.entries(
        (originMenuTypeChanges == null ? void 0 : originMenuTypeChanges.sections.availability) || {}
      ).forEach(([day, timeChanges]) => {
        const newTargetTimes = [];
        const typedDay = day;
        if (timeChanges.length === 0) {
          return;
        }
        originTimes[typedDay].forEach((originTime, timeIndex) => {
          newTargetTimes.push(__spreadProps(__spreadValues({}, originTime), {
            id: clonedTargetTimes[typedDay].length > timeIndex ? clonedTargetTimes[typedDay][timeIndex].id : originTime.id
          }));
        });
        clonedTargetTimes[typedDay] = newTargetTimes;
      });
      clonedSpecialData.menuTypeVersions[menuTypeIdToApply].availableTimes = clonedTargetTimes;
    });
    const differences = deepDiff6(originData, clonedSpecialData);
    const newDiffObject = diffSpecialsFactory(
      differences,
      state,
      originData,
      clonedSpecialData
    );
    if (renderErrorToast) {
      dispatch(
        showToast({
          type: "warning",
          title: i18n_config_default.t(
            "menuScreen.specialDetails.applyChangesToMenuType.error.title"
          ),
          description: i18n_config_default.t(
            "menuScreen.specialDetails.applyChangesToMenuType.error.description"
          ),
          timeout: 5e3
        })
      );
    }
    return {
      newMenuTypeVersions: newDiffObject == null ? void 0 : newDiffObject.menuTypeVersions,
      newData: clonedSpecialData
    };
  }
  return {
    newMenuTypeVersions: formattedMenuTypeVersions,
    newData: changeData.data
  };
};

// src/helpers/menu/modals/selectLocationModal.ts
var shouldShowLocationsModalOnSaveCore = (differences, state, dispatch) => {
  const isMasterMode = selectIsMenuMasterMode(state);
  const { changeData, changeMassUpdateData } = selectMenuState(state);
  const shouldRenderModal = selectShouldRenderLocationDropdown(state);
  const isMassUpdate = !!changeMassUpdateData.data;
  const bucketSelected = isMassUpdate ? changeMassUpdateData.bucketSelected : changeData.bucketSelected;
  const userLocations = selectLoggedInUserMenuAccessLocations(state);
  const hasAccessToMasterMenu = selectHasLoggedInUserAccessToMasterMenu(state);
  dispatch(setSelectedLocations([]));
  dispatch(setMassUpdateSelectedLocations([]));
  if (!bucketSelected)
    return false;
  if (!isMasterMode && userLocations.length === 1 && !hasAccessToMasterMenu) {
    if (isMassUpdate) {
      dispatch(setMassUpdateSelectedLocations(userLocations));
      return false;
    }
    dispatch(setSelectedLocations(userLocations));
    return false;
  }
  if (isMasterMode && bucketSelected === "items" && differences.length === 1 && differences.some((diff11) => diff11.path[0] === "customId")) {
    return false;
  }
  if (!shouldRenderModal && isMasterMode) {
    dispatch(setSelectedLocations([0, ...userLocations]));
    return false;
  }
  return userLocations.length > 1 || hasAccessToMasterMenu;
};

// src/state/register/actions.ts
var actions_exports17 = {};
__export(actions_exports17, {
  actionCreatorsOrders: () => actionCreators_exports,
  actionHelpers: () => actionHelpers_exports,
  actionThunksModifierItemsAndIngredients: () => modifierItemsAndIngredients_exports,
  actionThunksOrders: () => thunks_exports,
  actionThunksRegisterChecks: () => checks_exports,
  actionThunksRegisterCombos: () => combos_exports,
  actionThunksRegisterDiscounts: () => discountsAndSpecials_exports,
  actionThunksRegisterNavigation: () => navigation_exports,
  actionThunksRegisterPayments: () => payments_exports,
  actionThunksRegisterTableLayout: () => tablelayout_exports,
  cleanNavigationAndRemoveActiveItem: () => cleanNavigationAndRemoveActiveItem,
  enterPaymentMode: () => enterPaymentMode,
  setActiveTicketElement: () => setActiveTicketElement,
  setCurrentStationCounter: () => setCurrentStationCounter,
  setDrawers: () => setDrawers,
  setOrderModal: () => setOrderModal,
  setPaymentMethod: () => setPaymentMethod,
  setPaymentOption: () => setPaymentOption,
  setRegisterNavigation: () => setRegisterNavigation,
  setShowHotButtons: () => setShowHotButtons,
  setTicketElementsOpen: () => setTicketElementsOpen,
  setToggleHotButtons: () => setToggleHotButtons,
  toggleActiveItem: () => toggleActiveItem,
  updateDrawer: () => updateDrawer,
  updateExitOrderCallStatus: () => updateExitOrderCallStatus,
  updatePaymentNavigation: () => updatePaymentNavigation,
  updateRegisterNavigationField: () => updateRegisterNavigationField
});

// src/state/register/orders/thunks/index.ts
var thunks_exports = {};
__export(thunks_exports, {
  createOrderCore: () => createOrderCore,
  editOrder: () => editOrder,
  exitFromOrderCore: () => exitFromOrderCore,
  getCurrentOrderInData: () => getCurrentOrderInData,
  getMenuTypeFromOrder: () => getMenuTypeFromOrder,
  replaceSessionOrderThunk: () => replaceSessionOrderThunk,
  rollUpTicketInCurrentOrder: () => rollUpTicketInCurrentOrder,
  selectRegisterItemThunk: () => selectRegisterItemThunk,
  suggestOrdering: () => suggestOrdering,
  updateComboObjectPreviewThunk: () => updateComboObjectPreviewThunk,
  updateEnterOrderAndRecentOrders: () => updateEnterOrderAndRecentOrders,
  updateExitOrderLicenseId: () => updateExitOrderLicenseId,
  updateOrderField: () => updateOrderField,
  validateCurrentOrderTabletGeneratedId: () => validateCurrentOrderTabletGeneratedId
});

// src/state/settings/users/actions.ts
var actions_exports7 = {};
__export(actions_exports7, {
  breakInBreakOut: () => breakInBreakOut,
  clockInClockOut: () => clockInClockOut,
  createEmployeeAction: () => createEmployeeAction,
  getMenuAccessLocations: () => getMenuAccessLocations,
  getSettingsAccessLocations: () => getSettingsAccessLocations,
  removeRecentOrderClosed: () => removeRecentOrderClosed,
  replaceUserRecentOrderStation: () => replaceUserRecentOrderStation,
  setUsers: () => setUsers,
  updateLoggedInUserRecentOrders: () => updateLoggedInUserRecentOrders,
  updateRecentOrders: () => updateRecentOrders,
  updateUserRecentOrders: () => updateUserRecentOrders,
  updateUserRecentOrdersStation: () => updateUserRecentOrdersStation,
  updateUsersTimeSummary: () => updateUsersTimeSummary
});

// src/state/settings/breadCrumb/actions.ts
var actions_exports6 = {};
__export(actions_exports6, {
  addSettingsBreadCrumbLocation: () => addSettingsBreadCrumbLocation,
  checkSettingsBreadCrumbLocation: () => checkSettingsBreadCrumbLocation,
  setSettingsBreadCrumb: () => setSettingsBreadCrumb,
  setSettingsBreadCrumbLocation: () => setSettingsBreadCrumbLocation,
  setSettingsBreadCrumbStatusPath: () => setSettingsBreadCrumbStatusPath
});

// src/state/settings/actions.ts
var actions_exports5 = {};
__export(actions_exports5, {
  associateLicenseLocation: () => associateLicenseLocation,
  cancelSettingsChangesOnCancelPress: () => cancelSettingsChangesOnCancelPress,
  changeSelectedSettingsMode: () => changeSelectedSettingsMode,
  checkForSettingsChangesAndNavigate: () => checkForSettingsChangesAndNavigate,
  checkForValueInLocationAndContinue: () => checkForValueInLocationAndContinue,
  checkGeneralSettingsFormValidation: () => checkGeneralSettingsFormValidation,
  checkKitchenTicketSettingsFormValidation: () => checkKitchenTicketSettingsFormValidation,
  checkLicenseSettingsFormValidation: () => checkLicenseSettingsFormValidation,
  checkOnlineSettingsFormValidation: () => checkOnlineSettingsFormValidation,
  checkPaymentsValidation: () => checkPaymentsValidation,
  checkPrepStationsFormValidation: () => checkPrepStationsFormValidation,
  checkPrinterRulesValidation: () => checkPrinterRulesValidation,
  checkRegisterModeFormValidation: () => checkRegisterModeFormValidation,
  checkRolesFormValidation: () => checkRolesFormValidation,
  checkSettingsValidation: () => checkSettingsValidation,
  checkTaxesValidation: () => checkTaxesValidation,
  checkUsersFormValidation: () => checkUsersFormValidation,
  createRegisterTicketPreviewData: () => createRegisterTicketPreviewData,
  deactivateLicense: () => deactivateLicense,
  deactivateLicenseFromDevice: () => deactivateLicenseFromDevice,
  deletePrepStation: () => deletePrepStation,
  deleteSettingsElement: () => deleteSettingsElement,
  editSettingsElement: () => editSettingsElement,
  getMasterSettings: () => getMasterSettings,
  getRemoteLocationSettings: () => getRemoteLocationSettings,
  getSettingsLocationsToApply: () => getSettingsLocationsToApply,
  printTestKitchenTicket: () => printTestKitchenTicket,
  pullKitchenTicketPrepStationSettings: () => pullKitchenTicketPrepStationSettings,
  pushKitchenTicketPrepStationsSettings: () => pushKitchenTicketPrepStationsSettings,
  removePrinters: () => removePrinters,
  resendUserInvite: () => resendUserInvite,
  resetRegisterTicketSettingsData: () => resetRegisterTicketSettingsData,
  saveSettingsChangesOnSavePress: () => saveSettingsChangesOnSavePress,
  setDefaultSettingsData: () => setDefaultSettingsData,
  setLocationSelectedSettingsMode: () => setLocationSelectedSettingsMode,
  setRegisterSettings: () => setRegisterSettings,
  setRegisterTicketSettings: () => setRegisterTicketSettings,
  setSettingsOnState: () => setSettingsOnState,
  settingsValidationThunks: () => settingsValidationThunks,
  showElementNotFoundInLocationToast: () => showElementNotFoundInLocationToast,
  updateCurrentSettings: () => updateCurrentSettings,
  updateGenericSettings: () => updateGenericSettings,
  updateKitchenTicketSettings: () => updateKitchenTicketSettings,
  updateRegisterTicketSettings: () => updateRegisterTicketSettings,
  updateSettingsChangeData: () => updateSettingsChangeData,
  updateSettingsFinalDiffObject: () => updateSettingsFinalDiffObject,
  updateSettingsOnSocket: () => updateSettingsOnSocket,
  validateKitchenSettingsData: () => validateKitchenSettingsData
});

// src/helpers/factories/settingsDifferences/diffOnlineSettingsFactory.ts
var basicFieldLabels = /* @__PURE__ */ ((basicFieldLabels2) => {
  basicFieldLabels2[basicFieldLabels2["acceptingOrders"] = 0] = "acceptingOrders";
  basicFieldLabels2[basicFieldLabels2["defaultMenuTypeId"] = 1] = "defaultMenuTypeId";
  basicFieldLabels2[basicFieldLabels2["onlineMenuTimes"] = 2] = "onlineMenuTimes";
  basicFieldLabels2[basicFieldLabels2["scheduleOutOrder"] = 3] = "scheduleOutOrder";
  return basicFieldLabels2;
})(basicFieldLabels || {});
var pickupFieldLabels = /* @__PURE__ */ ((pickupFieldLabels2) => {
  pickupFieldLabels2[pickupFieldLabels2["pickupIsActive"] = 0] = "pickupIsActive";
  pickupFieldLabels2[pickupFieldLabels2["pickupBufferTime"] = 1] = "pickupBufferTime";
  pickupFieldLabels2[pickupFieldLabels2["pickupAvailability"] = 2] = "pickupAvailability";
  return pickupFieldLabels2;
})(pickupFieldLabels || {});
var deliveryFieldLabels = /* @__PURE__ */ ((deliveryFieldLabels2) => {
  deliveryFieldLabels2[deliveryFieldLabels2["deliveryIsActive"] = 0] = "deliveryIsActive";
  deliveryFieldLabels2[deliveryFieldLabels2["deliveryBufferTime"] = 1] = "deliveryBufferTime";
  deliveryFieldLabels2[deliveryFieldLabels2["deliveryAvailability"] = 2] = "deliveryAvailability";
  deliveryFieldLabels2[deliveryFieldLabels2["copyPickupTimes"] = 3] = "copyPickupTimes";
  deliveryFieldLabels2[deliveryFieldLabels2["deliveryRadius"] = 4] = "deliveryRadius";
  return deliveryFieldLabels2;
})(deliveryFieldLabels || {});
var pageDesignFieldLabels = /* @__PURE__ */ ((pageDesignFieldLabels2) => {
  pageDesignFieldLabels2[pageDesignFieldLabels2["primaryColor"] = 0] = "primaryColor";
  pageDesignFieldLabels2[pageDesignFieldLabels2["secondaryColor"] = 1] = "secondaryColor";
  pageDesignFieldLabels2[pageDesignFieldLabels2["tertiaryColor"] = 2] = "tertiaryColor";
  pageDesignFieldLabels2[pageDesignFieldLabels2["backgroundColor"] = 3] = "backgroundColor";
  pageDesignFieldLabels2[pageDesignFieldLabels2["showBanner"] = 4] = "showBanner";
  pageDesignFieldLabels2[pageDesignFieldLabels2["bannerDescription"] = 5] = "bannerDescription";
  pageDesignFieldLabels2[pageDesignFieldLabels2["showItemImage"] = 6] = "showItemImage";
  pageDesignFieldLabels2[pageDesignFieldLabels2["allowSpecialInstructionsOnItems"] = 7] = "allowSpecialInstructionsOnItems";
  pageDesignFieldLabels2[pageDesignFieldLabels2["showCalories"] = 8] = "showCalories";
  return pageDesignFieldLabels2;
})(pageDesignFieldLabels || {});
var tipsFieldLabels = /* @__PURE__ */ ((tipsFieldLabels2) => {
  tipsFieldLabels2[tipsFieldLabels2["showTippingAtCheckout"] = 0] = "showTippingAtCheckout";
  tipsFieldLabels2[tipsFieldLabels2["pickupTipDefault"] = 1] = "pickupTipDefault";
  tipsFieldLabels2[tipsFieldLabels2["pickupTip1"] = 2] = "pickupTip1";
  tipsFieldLabels2[tipsFieldLabels2["pickupTip2"] = 3] = "pickupTip2";
  tipsFieldLabels2[tipsFieldLabels2["pickupTip3"] = 4] = "pickupTip3";
  tipsFieldLabels2[tipsFieldLabels2["deliveryTipDefault"] = 5] = "deliveryTipDefault";
  tipsFieldLabels2[tipsFieldLabels2["deliveryTip1"] = 6] = "deliveryTip1";
  tipsFieldLabels2[tipsFieldLabels2["deliveryTip2"] = 7] = "deliveryTip2";
  tipsFieldLabels2[tipsFieldLabels2["deliveryTip3"] = 8] = "deliveryTip3";
  return tipsFieldLabels2;
})(tipsFieldLabels || {});
var tipsPickupFieldLabels = /* @__PURE__ */ ((tipsPickupFieldLabels2) => {
  tipsPickupFieldLabels2[tipsPickupFieldLabels2["pickupTipDefault"] = 0] = "pickupTipDefault";
  tipsPickupFieldLabels2[tipsPickupFieldLabels2["pickupTip1"] = 1] = "pickupTip1";
  tipsPickupFieldLabels2[tipsPickupFieldLabels2["pickupTip2"] = 2] = "pickupTip2";
  tipsPickupFieldLabels2[tipsPickupFieldLabels2["pickupTip3"] = 3] = "pickupTip3";
  return tipsPickupFieldLabels2;
})(tipsPickupFieldLabels || {});
var tipsDeliveryFieldLabels = /* @__PURE__ */ ((tipsDeliveryFieldLabels2) => {
  tipsDeliveryFieldLabels2[tipsDeliveryFieldLabels2["deliveryTipDefault"] = 0] = "deliveryTipDefault";
  tipsDeliveryFieldLabels2[tipsDeliveryFieldLabels2["deliveryTip1"] = 1] = "deliveryTip1";
  tipsDeliveryFieldLabels2[tipsDeliveryFieldLabels2["deliveryTip2"] = 2] = "deliveryTip2";
  tipsDeliveryFieldLabels2[tipsDeliveryFieldLabels2["deliveryTip3"] = 3] = "deliveryTip3";
  return tipsDeliveryFieldLabels2;
})(tipsDeliveryFieldLabels || {});
var tipsDefaultFieldLabels = /* @__PURE__ */ ((tipsDefaultFieldLabels2) => {
  tipsDefaultFieldLabels2[tipsDefaultFieldLabels2["pickupTipDefault"] = 0] = "pickupTipDefault";
  tipsDefaultFieldLabels2[tipsDefaultFieldLabels2["deliveryTipDefault"] = 1] = "deliveryTipDefault";
  return tipsDefaultFieldLabels2;
})(tipsDefaultFieldLabels || {});
var tipsSuggestionsFieldLabels = /* @__PURE__ */ ((tipsSuggestionsFieldLabels2) => {
  tipsSuggestionsFieldLabels2[tipsSuggestionsFieldLabels2["pickupTip1"] = 0] = "pickupTip1";
  tipsSuggestionsFieldLabels2[tipsSuggestionsFieldLabels2["pickupTip2"] = 1] = "pickupTip2";
  tipsSuggestionsFieldLabels2[tipsSuggestionsFieldLabels2["pickupTip3"] = 2] = "pickupTip3";
  tipsSuggestionsFieldLabels2[tipsSuggestionsFieldLabels2["deliveryTip1"] = 3] = "deliveryTip1";
  tipsSuggestionsFieldLabels2[tipsSuggestionsFieldLabels2["deliveryTip2"] = 4] = "deliveryTip2";
  tipsSuggestionsFieldLabels2[tipsSuggestionsFieldLabels2["deliveryTip3"] = 5] = "deliveryTip3";
  return tipsSuggestionsFieldLabels2;
})(tipsSuggestionsFieldLabels || {});
var onlineMenuTypeTimesFields = /* @__PURE__ */ ((onlineMenuTypeTimesFields2) => {
  onlineMenuTypeTimesFields2[onlineMenuTypeTimesFields2["menuTypeId"] = 0] = "menuTypeId";
  onlineMenuTypeTimesFields2[onlineMenuTypeTimesFields2["startTime"] = 1] = "startTime";
  onlineMenuTypeTimesFields2[onlineMenuTypeTimesFields2["endTime"] = 2] = "endTime";
  return onlineMenuTypeTimesFields2;
})(onlineMenuTypeTimesFields || {});
var timesFields = /* @__PURE__ */ ((timesFields2) => {
  timesFields2[timesFields2["startTime"] = 0] = "startTime";
  timesFields2[timesFields2["endTime"] = 1] = "endTime";
  return timesFields2;
})(timesFields || {});
var MENU_TYPE_RULES_FIELD = "onlineMenuTimes";
var PICKUP_AVAILABILITY_FIELD = "pickupAvailability";
var DELIVERY_AVAILABILITY_FIELD = "deliveryAvailability";
var returnLabel7 = (field) => {
  if (field in basicFieldLabels) {
    return i18n_config_default.t(
      `settingsModule.onlineSettings.basic.${field}`
    );
  }
  if (field in pickupFieldLabels) {
    return i18n_config_default.t(
      `settingsModule.onlineSettings.pickup.${field}`
    );
  }
  if (field in deliveryFieldLabels) {
    return i18n_config_default.t(
      `settingsModule.onlineSettings.delivery.${field}`
    );
  }
  if (field in pageDesignFieldLabels) {
    return i18n_config_default.t(
      `settingsModule.onlineSettings.pageDesign.${field}`
    );
  }
  if (field === "showTippingAtCheckout") {
    return i18n_config_default.t("settingsModule.onlineSettings.tips.showTippingAtCheckout");
  }
  if (field in tipsDefaultFieldLabels) {
    return i18n_config_default.t("settingsModule.onlineSettings.tips.suggestedTipDefault");
  }
  if (field in tipsSuggestionsFieldLabels) {
    return i18n_config_default.t(
      `settingsModule.onlineSettings.tips.suggestedTip${field.slice(-1)}`
    );
  }
};
var diffOnlineSettingsFactory = (diffArray, state) => {
  if (diffArray.length > 0) {
    const basic = generateBasicDiff(diffArray, state);
    const pageDesign = generatePageDesignDiff(diffArray);
    const tips = generateTipsDiff(diffArray);
    const pickup = generateDiff(diffArray, state, PICKUP_AVAILABILITY_FIELD);
    const delivery = generateDiff(
      diffArray,
      state,
      DELIVERY_AVAILABILITY_FIELD
    );
    return {
      basic,
      pickup: {
        changes: pickup.changes,
        pickupAvailability: pickup.availability
      },
      delivery: {
        changes: delivery.changes,
        deliveryAvailability: delivery.availability
      },
      pageDesign,
      tips
    };
  }
  return null;
};
var generateBasicDiff = (diffArray, state) => {
  const changes = [];
  const originalData = state.settings.changeData.originalData;
  const menuTypes = state.menu.selectedMode.currentMenu.menuTypes;
  const changeData = selectCurrentSettingsData(state);
  const onlineMenuTimes = {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: []
  };
  diffArray.forEach(
    (diff11) => filterDiffFunction(
      diff11,
      ({ field, diffLength, newDiff }) => {
        if (diffLength !== 1) {
          return;
        }
        if (!(field in basicFieldLabels)) {
          return;
        }
        if (field === "defaultMenuTypeId") {
          return changes.push(__spreadProps(__spreadValues({}, newDiff), {
            textValue: state.menu.selectedMode.currentMenu.menuTypes[Number(newDiff.value)].name
          }));
        }
        changes.push(newDiff);
      },
      returnLabel7
    )
  );
  const { changedOnlineMenuTimesDiff, removedOrAddedOnlineMenuTimesDiff } = getArraysByAction4(diffArray, "onlineMenuTimes");
  changedOnlineMenuTimesDiff.forEach((diff11) => {
    filterDiffFunction(
      diff11,
      ({ newDiff }) => {
        var _a, _b, _c;
        if (!(newDiff.field in timesFields)) {
          return;
        }
        const day = diff11.path[1];
        const index = Number(diff11.path[2]);
        const timeId = (_c = (_b = (_a = originalData["onlineMenuTimes"]) == null ? void 0 : _a[day]) == null ? void 0 : _b[index]) == null ? void 0 : _c.id;
        const newTimeDiff = {
          label: day,
          action: "update",
          id: timeId,
          tabletGeneratedId: timeId,
          changes: [newDiff],
          index
        };
        const hoursOfOperationIndex = getArrayEditIndex(
          timeId,
          onlineMenuTimes[day]
        );
        const hasHoursOfOperationIndex = hoursOfOperationIndex >= 0;
        if (hasHoursOfOperationIndex) {
          onlineMenuTimes[day][hoursOfOperationIndex].changes.push(newDiff);
        } else {
          onlineMenuTimes[day].push(newTimeDiff);
        }
      },
      returnLabel7
    );
  });
  removedOrAddedOnlineMenuTimesDiff.forEach((diff11) => {
    var _a, _b, _c, _d, _e, _f;
    const wasRemoved = ((_a = diff11.item) == null ? void 0 : _a.kind) === "D";
    const day = diff11.path[1];
    const index = Number(diff11.index);
    const newTimeDiff = {
      label: day,
      index,
      action: wasRemoved ? "remove" : "add",
      tabletGeneratedId: wasRemoved ? ((_b = diff11.item) == null ? void 0 : _b.lhs).id : ((_c = diff11.item) == null ? void 0 : _c.rhs).id,
      id: wasRemoved ? ((_d = diff11.item) == null ? void 0 : _d.lhs).id : 0,
      changes: wasRemoved ? [] : [
        ...timeToDiff2((_e = diff11.item) == null ? void 0 : _e.rhs, index).changes,
        {
          field: "menuTypeId",
          label: "",
          value: ((_f = diff11.item) == null ? void 0 : _f.rhs).menuTypeId
        }
      ]
    };
    onlineMenuTimes[day].push(newTimeDiff);
  });
  diffArray.forEach(
    (diff11) => filterDiffFunction(
      diff11,
      ({ field, diffLength }) => {
        const customField = diff11.path[0];
        if (diffLength < 2)
          return;
        if (diff11.kind === "E" && customField === MENU_TYPE_RULES_FIELD) {
          const customNewDiff = {
            field: customField === MENU_TYPE_RULES_FIELD ? diff11.path[3] : diff11.path[2],
            label: returnLabel7(diff11.path[2]) || "",
            value: diff11.rhs
          };
          const day = diff11.path[1];
          const timeBasedIndex = Number(diff11.path[2]);
          const timeBasedId = state.settings.selectedMode.currentSettings.online.onlineMenuTimes[day][timeBasedIndex].id;
          if (day in onlineMenuTimes && field in onlineMenuTypeTimesFields) {
            if (!onlineMenuTimes[day].find(
              (menuType) => menuType.id === timeBasedId && menuType.action === "update"
            )) {
              onlineMenuTimes[day].push({
                id: timeBasedId,
                tabletGeneratedId: timeBasedId,
                label: menuTypes[changeData.onlineMenuTimes[day][timeBasedIndex].menuTypeId].name,
                action: "update",
                changes: [customNewDiff],
                index: timeBasedIndex
              });
            } else {
              for (const [i, menuType] of onlineMenuTimes[day].entries()) {
                if (menuType.id === timeBasedId) {
                  onlineMenuTimes[day][i].changes = [
                    ...menuType.changes,
                    customNewDiff
                  ];
                  break;
                }
              }
            }
          }
        }
      },
      returnLabel7
    )
  );
  return {
    changes,
    onlineMenuTimes
  };
};
var generateDiff = (diffArray, state, availabilityField) => {
  const changes = [];
  const originalData = state.settings.changeData.originalData;
  const availability = {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: []
  };
  diffArray.forEach(
    (diff11) => filterDiffFunction(
      diff11,
      ({ field, diffLength, newDiff }) => {
        if (diffLength !== 1) {
          return;
        }
        if (!(field in (availabilityField === "pickupAvailability" ? pickupFieldLabels : deliveryFieldLabels))) {
          return;
        }
        if (field === "pickupBufferTime" || field === "deliveryBufferTime") {
          changes.push(__spreadProps(__spreadValues({}, newDiff), {
            textValue: `${newDiff.value} min`
          }));
          return;
        }
        if (field === "deliveryRadius") {
          changes.push(__spreadProps(__spreadValues({}, newDiff), {
            textValue: `${newDiff.value} mi`
          }));
          return;
        }
        changes.push(newDiff);
      },
      returnLabel7
    )
  );
  const { changedOnlineMenuTimesDiff, removedOrAddedOnlineMenuTimesDiff } = getArraysByAction4(diffArray, availabilityField);
  changedOnlineMenuTimesDiff.forEach((diff11) => {
    filterDiffFunction(
      diff11,
      ({ newDiff }) => {
        var _a, _b, _c;
        if (!(newDiff.field in timesFields)) {
          return;
        }
        const day = diff11.path[1];
        const index = Number(diff11.path[2]);
        const timeId = (_c = (_b = (_a = originalData[availabilityField]) == null ? void 0 : _a[day]) == null ? void 0 : _b[index]) == null ? void 0 : _c.id;
        const newTimeDiff = {
          label: day,
          action: "update",
          id: timeId,
          tabletGeneratedId: timeId,
          changes: [newDiff],
          index
        };
        const hoursOfOperationIndex = getArrayEditIndex(
          timeId,
          availability[day]
        );
        const hasHoursOfOperationIndex = hoursOfOperationIndex >= 0;
        if (hasHoursOfOperationIndex) {
          availability[day][hoursOfOperationIndex].changes.push(newDiff);
        } else {
          availability[day].push(newTimeDiff);
        }
      },
      returnLabel7
    );
  });
  removedOrAddedOnlineMenuTimesDiff.forEach((diff11) => {
    var _a, _b, _c, _d;
    const wasRemoved = ((_a = diff11.item) == null ? void 0 : _a.kind) === "D";
    const day = diff11.path[1];
    const index = Number(diff11.index);
    const id = wasRemoved ? ((_b = diff11.item) == null ? void 0 : _b.lhs).id : ((_c = diff11.item) == null ? void 0 : _c.rhs).id;
    const newTimeDiff = {
      label: day,
      index,
      action: wasRemoved ? "remove" : "add",
      tabletGeneratedId: id,
      id,
      changes: wasRemoved ? [] : deliveryTimeToDiff(
        (_d = diff11.item) == null ? void 0 : _d.rhs,
        index
      ).changes
    };
    availability[day].push(newTimeDiff);
  });
  return {
    changes,
    availability
  };
};
var getArraysByAction4 = (diffArray, field) => {
  const changedOnlineMenuTimesDiff = diffArray.filter(
    (diff11) => diff11.path.length === 4 && diff11.path[0] === field && diff11.kind === "E"
  );
  const removedOrAddedOnlineMenuTimesDiff = diffArray.filter(
    (diff11) => diff11.path.length === 2 && diff11.path[0] === field && diff11.kind === "A"
  );
  return {
    changedOnlineMenuTimesDiff,
    removedOrAddedOnlineMenuTimesDiff
  };
};
var generatePageDesignDiff = (diffArray) => {
  const changes = [];
  diffArray.forEach(
    (diff11) => filterDiffFunction(
      diff11,
      ({ field, diffLength, newDiff }) => {
        if (diffLength !== 1) {
          return;
        }
        if (!(field in pageDesignFieldLabels)) {
          return;
        }
        changes.push(newDiff);
      },
      returnLabel7
    )
  );
  return changes;
};
var generateTipsDiff = (diffArray) => {
  const changes = [];
  diffArray.forEach(
    (diff11) => filterDiffFunction(
      diff11,
      ({ field, diffLength, newDiff }) => {
        if (diffLength !== 1) {
          return;
        }
        if (!(field in tipsFieldLabels)) {
          return;
        }
        if (field === "pickupTipDefault" || field === "deliveryTipDefault") {
          changes.push(__spreadProps(__spreadValues({}, newDiff), {
            textValue: `${newDiff.value ? i18n_config_default.t(
              `settingsModule.onlineSettings.tips.suggestedTip${newDiff.value}`
            ) : i18n_config_default.t(
              "settingsModule.onlineSettings.tips.noDefaultTip"
            )}`
          }));
          return;
        }
        if (field === "pickupTip1" || field === "pickupTip2" || field === "pickupTip3" || field === "deliveryTip1" || field === "deliveryTip2" || field === "deliveryTip3") {
          changes.push(__spreadProps(__spreadValues({}, newDiff), {
            textValue: `${newDiff.value} %`
          }));
          return;
        }
        changes.push(newDiff);
      },
      returnLabel7
    )
  );
  return changes;
};
var timeToDiff2 = (time, index) => {
  const timeDiff = {
    id: time.id,
    index,
    tabletGeneratedId: time.id,
    action: "add",
    label: "",
    changes: []
  };
  Object.entries(time).forEach(([timeKey, timeValue]) => {
    const diff11 = {
      field: timeKey,
      label: returnLabel7(timeKey) || "",
      value: timeValue
    };
    if (timeKey in timesFields) {
      timeDiff.changes.push(diff11);
    }
  });
  return timeDiff;
};
var deliveryTimeToDiff = (time, index) => {
  const timeDiff = {
    id: time.id,
    index,
    tabletGeneratedId: time.id,
    action: "add",
    label: "",
    changes: []
  };
  Object.entries(time).forEach(([timeKey, timeValue]) => {
    const diff11 = {
      field: timeKey,
      label: returnLabel7(timeKey) || "",
      value: timeValue
    };
    if (timeKey in timesFields) {
      timeDiff.changes.push(diff11);
    }
  });
  return timeDiff;
};
var GeneralRegisterDisplayFieldLabels = /* @__PURE__ */ ((GeneralRegisterDisplayFieldLabels2) => {
  GeneralRegisterDisplayFieldLabels2[GeneralRegisterDisplayFieldLabels2["showModTagBar"] = 0] = "showModTagBar";
  GeneralRegisterDisplayFieldLabels2[GeneralRegisterDisplayFieldLabels2["showConfirmPopupToRemoveItem"] = 1] = "showConfirmPopupToRemoveItem";
  GeneralRegisterDisplayFieldLabels2[GeneralRegisterDisplayFieldLabels2["showConfirmPopUpOnClearUnsentWithinAnItem"] = 2] = "showConfirmPopUpOnClearUnsentWithinAnItem";
  GeneralRegisterDisplayFieldLabels2[GeneralRegisterDisplayFieldLabels2["showSentItemModificationsOnRegisterTicket"] = 3] = "showSentItemModificationsOnRegisterTicket";
  GeneralRegisterDisplayFieldLabels2[GeneralRegisterDisplayFieldLabels2["showConfirmPopUpOnLeaveIncompleteItem"] = 4] = "showConfirmPopUpOnLeaveIncompleteItem";
  GeneralRegisterDisplayFieldLabels2[GeneralRegisterDisplayFieldLabels2["enforceItemGroupOrderForCombos"] = 5] = "enforceItemGroupOrderForCombos";
  GeneralRegisterDisplayFieldLabels2[GeneralRegisterDisplayFieldLabels2["defaultRestaurantMode"] = 6] = "defaultRestaurantMode";
  GeneralRegisterDisplayFieldLabels2[GeneralRegisterDisplayFieldLabels2["persistSelectedCategoryOnItemSelection"] = 7] = "persistSelectedCategoryOnItemSelection";
  GeneralRegisterDisplayFieldLabels2[GeneralRegisterDisplayFieldLabels2["showHotButtonToggle"] = 8] = "showHotButtonToggle";
  GeneralRegisterDisplayFieldLabels2[GeneralRegisterDisplayFieldLabels2["showNotificationMessageForPrinterErrors"] = 9] = "showNotificationMessageForPrinterErrors";
  GeneralRegisterDisplayFieldLabels2[GeneralRegisterDisplayFieldLabels2["showPrinterStatusNotifications"] = 10] = "showPrinterStatusNotifications";
  GeneralRegisterDisplayFieldLabels2[GeneralRegisterDisplayFieldLabels2["firePositionOnRegisterTicket"] = 11] = "firePositionOnRegisterTicket";
  GeneralRegisterDisplayFieldLabels2[GeneralRegisterDisplayFieldLabels2["showDoneButton"] = 12] = "showDoneButton";
  GeneralRegisterDisplayFieldLabels2[GeneralRegisterDisplayFieldLabels2["printHeldItems"] = 13] = "printHeldItems";
  return GeneralRegisterDisplayFieldLabels2;
})(GeneralRegisterDisplayFieldLabels || {});
var GeneralOrderTypesAvailableFieldLabels = /* @__PURE__ */ ((GeneralOrderTypesAvailableFieldLabels2) => {
  GeneralOrderTypesAvailableFieldLabels2[GeneralOrderTypesAvailableFieldLabels2["isCateringAvailable"] = 0] = "isCateringAvailable";
  GeneralOrderTypesAvailableFieldLabels2[GeneralOrderTypesAvailableFieldLabels2["isDeliveryAvailable"] = 1] = "isDeliveryAvailable";
  GeneralOrderTypesAvailableFieldLabels2[GeneralOrderTypesAvailableFieldLabels2["isDineInAvailable"] = 2] = "isDineInAvailable";
  GeneralOrderTypesAvailableFieldLabels2[GeneralOrderTypesAvailableFieldLabels2["isToGoAvailable"] = 3] = "isToGoAvailable";
  return GeneralOrderTypesAvailableFieldLabels2;
})(GeneralOrderTypesAvailableFieldLabels || {});
var TableServiceGeneralFieldLabels = /* @__PURE__ */ ((TableServiceGeneralFieldLabels2) => {
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["seating"] = 0] = "seating";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["allowForTableButton"] = 1] = "allowForTableButton";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["enableDragDropForSeatPopover"] = 2] = "enableDragDropForSeatPopover";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["ticketSeatBar"] = 3] = "ticketSeatBar";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["showConfirmPopUpWhenSendingItemsInSeatView"] = 4] = "showConfirmPopUpWhenSendingItemsInSeatView";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["showSeatOneDescription"] = 5] = "showSeatOneDescription";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["showSendItemsModal"] = 6] = "showSendItemsModal";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["seatingMode"] = 7] = "seatingMode";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["showOrderDetailsForDefaultNewOrder"] = 8] = "showOrderDetailsForDefaultNewOrder";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["showOrderDetailsForNewOrderTsr"] = 9] = "showOrderDetailsForNewOrderTsr";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["showGuestCount"] = 10] = "showGuestCount";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["defaultGuestCountOnNewOrder"] = 11] = "defaultGuestCountOnNewOrder";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["setGuestCountToZeroWhenNoTable"] = 12] = "setGuestCountToZeroWhenNoTable";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["setGuestCountToZeroOnToGoOrders"] = 13] = "setGuestCountToZeroOnToGoOrders";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["prepStationForFireTicketId"] = 14] = "prepStationForFireTicketId";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["attachNoSeatToToGo"] = 15] = "attachNoSeatToToGo";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["showPopUpOnNavigateIfItemsOnTicketNotSentToKitchen"] = 16] = "showPopUpOnNavigateIfItemsOnTicketNotSentToKitchen";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["showIndicatorWhenItemsOnTicketNotSentToKitchen"] = 17] = "showIndicatorWhenItemsOnTicketNotSentToKitchen";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["keepTipPendingOrdersAssociatedToTable"] = 18] = "keepTipPendingOrdersAssociatedToTable";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["enableMapLayoutDragAndDrop"] = 19] = "enableMapLayoutDragAndDrop";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["showTableBorderForLoggedInUsersOrders"] = 20] = "showTableBorderForLoggedInUsersOrders";
  TableServiceGeneralFieldLabels2[TableServiceGeneralFieldLabels2["seatManagementButtonFunction"] = 21] = "seatManagementButtonFunction";
  return TableServiceGeneralFieldLabels2;
})(TableServiceGeneralFieldLabels || {});
var TableServiceTableLayoutFieldLabels = /* @__PURE__ */ ((TableServiceTableLayoutFieldLabels2) => {
  TableServiceTableLayoutFieldLabels2[TableServiceTableLayoutFieldLabels2["showSeatsOnTableLayout"] = 0] = "showSeatsOnTableLayout";
  TableServiceTableLayoutFieldLabels2[TableServiceTableLayoutFieldLabels2["showTimerOnTableLayout"] = 1] = "showTimerOnTableLayout";
  TableServiceTableLayoutFieldLabels2[TableServiceTableLayoutFieldLabels2["useCleaningStatusOnTableLayout"] = 2] = "useCleaningStatusOnTableLayout";
  TableServiceTableLayoutFieldLabels2[TableServiceTableLayoutFieldLabels2["allowOpenTabsOnTableLayout"] = 3] = "allowOpenTabsOnTableLayout";
  return TableServiceTableLayoutFieldLabels2;
})(TableServiceTableLayoutFieldLabels || {});
var TableServiceCoursingFieldLabels = /* @__PURE__ */ ((TableServiceCoursingFieldLabels2) => {
  TableServiceCoursingFieldLabels2[TableServiceCoursingFieldLabels2["coursing"] = 0] = "coursing";
  TableServiceCoursingFieldLabels2[TableServiceCoursingFieldLabels2["autoTriggering"] = 1] = "autoTriggering";
  TableServiceCoursingFieldLabels2[TableServiceCoursingFieldLabels2["coursingMode"] = 2] = "coursingMode";
  TableServiceCoursingFieldLabels2[TableServiceCoursingFieldLabels2["groupRounds"] = 3] = "groupRounds";
  return TableServiceCoursingFieldLabels2;
})(TableServiceCoursingFieldLabels || {});
var CourseFields = /* @__PURE__ */ ((CourseFields2) => {
  CourseFields2[CourseFields2["active"] = 0] = "active";
  CourseFields2[CourseFields2["sortPriority"] = 1] = "sortPriority";
  CourseFields2[CourseFields2["name"] = 2] = "name";
  CourseFields2[CourseFields2["posName"] = 3] = "posName";
  CourseFields2[CourseFields2["kitchenName"] = 4] = "kitchenName";
  CourseFields2[CourseFields2["triggerTime"] = 5] = "triggerTime";
  return CourseFields2;
})(CourseFields || {});
var QuickServiceGeneralFieldLabels = /* @__PURE__ */ ((QuickServiceGeneralFieldLabels2) => {
  QuickServiceGeneralFieldLabels2[QuickServiceGeneralFieldLabels2["assignOrderTag"] = 0] = "assignOrderTag";
  QuickServiceGeneralFieldLabels2[QuickServiceGeneralFieldLabels2["sendOrderToKitchenTrigger"] = 1] = "sendOrderToKitchenTrigger";
  QuickServiceGeneralFieldLabels2[QuickServiceGeneralFieldLabels2["qsrSendAndPayActionButtons"] = 2] = "qsrSendAndPayActionButtons";
  QuickServiceGeneralFieldLabels2[QuickServiceGeneralFieldLabels2["showOrderDetailsForNewOrderQsr"] = 3] = "showOrderDetailsForNewOrderQsr";
  return QuickServiceGeneralFieldLabels2;
})(QuickServiceGeneralFieldLabels || {});
var CFDGeneralFieldLabels = /* @__PURE__ */ ((CFDGeneralFieldLabels2) => {
  CFDGeneralFieldLabels2[CFDGeneralFieldLabels2["receiptScreenTimeout"] = 0] = "receiptScreenTimeout";
  CFDGeneralFieldLabels2[CFDGeneralFieldLabels2["requireClientSignature"] = 1] = "requireClientSignature";
  CFDGeneralFieldLabels2[CFDGeneralFieldLabels2["payThroughCfdOnly"] = 2] = "payThroughCfdOnly";
  CFDGeneralFieldLabels2[CFDGeneralFieldLabels2["promptStarRatings"] = 3] = "promptStarRatings";
  CFDGeneralFieldLabels2[CFDGeneralFieldLabels2["darkMode"] = 4] = "darkMode";
  CFDGeneralFieldLabels2[CFDGeneralFieldLabels2["promptPrintReceipt"] = 5] = "promptPrintReceipt";
  return CFDGeneralFieldLabels2;
})(CFDGeneralFieldLabels || {});
var CFDAdsFieldLabels = /* @__PURE__ */ ((CFDAdsFieldLabels2) => {
  CFDAdsFieldLabels2[CFDAdsFieldLabels2["isFacebookActive"] = 0] = "isFacebookActive";
  CFDAdsFieldLabels2[CFDAdsFieldLabels2["isXActive"] = 1] = "isXActive";
  CFDAdsFieldLabels2[CFDAdsFieldLabels2["isInstagramActive"] = 2] = "isInstagramActive";
  CFDAdsFieldLabels2[CFDAdsFieldLabels2["facebookAccount"] = 3] = "facebookAccount";
  CFDAdsFieldLabels2[CFDAdsFieldLabels2["xAccount"] = 4] = "xAccount";
  CFDAdsFieldLabels2[CFDAdsFieldLabels2["instagramAccount"] = 5] = "instagramAccount";
  CFDAdsFieldLabels2[CFDAdsFieldLabels2["placeholderBackground"] = 6] = "placeholderBackground";
  CFDAdsFieldLabels2[CFDAdsFieldLabels2["adTextBackground"] = 7] = "adTextBackground";
  CFDAdsFieldLabels2[CFDAdsFieldLabels2["mediaLinksBackground"] = 8] = "mediaLinksBackground";
  return CFDAdsFieldLabels2;
})(CFDAdsFieldLabels || {});
var CFDTipsFieldLabels = /* @__PURE__ */ ((CFDTipsFieldLabels2) => {
  CFDTipsFieldLabels2[CFDTipsFieldLabels2["showTippingOptionsAtCheckout"] = 0] = "showTippingOptionsAtCheckout";
  CFDTipsFieldLabels2[CFDTipsFieldLabels2["showCfdTipSelectionOnRegister"] = 1] = "showCfdTipSelectionOnRegister";
  CFDTipsFieldLabels2[CFDTipsFieldLabels2["defaultSuggestedTip"] = 2] = "defaultSuggestedTip";
  CFDTipsFieldLabels2[CFDTipsFieldLabels2["suggestedTip1"] = 3] = "suggestedTip1";
  CFDTipsFieldLabels2[CFDTipsFieldLabels2["suggestedTip2"] = 4] = "suggestedTip2";
  CFDTipsFieldLabels2[CFDTipsFieldLabels2["suggestedTip3"] = 5] = "suggestedTip3";
  return CFDTipsFieldLabels2;
})(CFDTipsFieldLabels || {});
var AdsTableFieldLabels = /* @__PURE__ */ ((AdsTableFieldLabels2) => {
  AdsTableFieldLabels2[AdsTableFieldLabels2["sortPriority"] = 0] = "sortPriority";
  AdsTableFieldLabels2[AdsTableFieldLabels2["active"] = 1] = "active";
  AdsTableFieldLabels2[AdsTableFieldLabels2["imageUrl"] = 2] = "imageUrl";
  AdsTableFieldLabels2[AdsTableFieldLabels2["title"] = 3] = "title";
  AdsTableFieldLabels2[AdsTableFieldLabels2["text"] = 4] = "text";
  AdsTableFieldLabels2[AdsTableFieldLabels2["price"] = 5] = "price";
  return AdsTableFieldLabels2;
})(AdsTableFieldLabels || {});
var SpecialTagFields = /* @__PURE__ */ ((SpecialTagFields2) => {
  SpecialTagFields2[SpecialTagFields2["active"] = 0] = "active";
  SpecialTagFields2[SpecialTagFields2["name"] = 1] = "name";
  SpecialTagFields2[SpecialTagFields2["posName"] = 2] = "posName";
  SpecialTagFields2[SpecialTagFields2["abbreviation"] = 3] = "abbreviation";
  SpecialTagFields2[SpecialTagFields2["color"] = 4] = "color";
  SpecialTagFields2[SpecialTagFields2["textColor"] = 5] = "textColor";
  return SpecialTagFields2;
})(SpecialTagFields || {});
var ModifierTagFields = /* @__PURE__ */ ((ModifierTagFields2) => {
  ModifierTagFields2[ModifierTagFields2["active"] = 0] = "active";
  ModifierTagFields2[ModifierTagFields2["name"] = 1] = "name";
  ModifierTagFields2[ModifierTagFields2["posName"] = 2] = "posName";
  ModifierTagFields2[ModifierTagFields2["checkName"] = 3] = "checkName";
  ModifierTagFields2[ModifierTagFields2["sortPriority"] = 4] = "sortPriority";
  ModifierTagFields2[ModifierTagFields2["tagPosition"] = 5] = "tagPosition";
  ModifierTagFields2[ModifierTagFields2["menuTypeIds"] = 6] = "menuTypeIds";
  return ModifierTagFields2;
})(ModifierTagFields || {});
var DiscountReasonFields = /* @__PURE__ */ ((DiscountReasonFields2) => {
  DiscountReasonFields2[DiscountReasonFields2["active"] = 0] = "active";
  DiscountReasonFields2[DiscountReasonFields2["name"] = 1] = "name";
  DiscountReasonFields2[DiscountReasonFields2["posName"] = 2] = "posName";
  DiscountReasonFields2[DiscountReasonFields2["sortPriority"] = 3] = "sortPriority";
  DiscountReasonFields2[DiscountReasonFields2["isDiscount"] = 4] = "isDiscount";
  DiscountReasonFields2[DiscountReasonFields2["isVoid"] = 5] = "isVoid";
  return DiscountReasonFields2;
})(DiscountReasonFields || {});
var OrderSeatTagsFields = /* @__PURE__ */ ((OrderSeatTagsFields2) => {
  OrderSeatTagsFields2[OrderSeatTagsFields2["sortPriority"] = 0] = "sortPriority";
  OrderSeatTagsFields2[OrderSeatTagsFields2["active"] = 1] = "active";
  OrderSeatTagsFields2[OrderSeatTagsFields2["isOrderTag"] = 2] = "isOrderTag";
  OrderSeatTagsFields2[OrderSeatTagsFields2["isSeatTag"] = 3] = "isSeatTag";
  OrderSeatTagsFields2[OrderSeatTagsFields2["type"] = 4] = "type";
  OrderSeatTagsFields2[OrderSeatTagsFields2["name"] = 5] = "name";
  OrderSeatTagsFields2[OrderSeatTagsFields2["posName"] = 6] = "posName";
  OrderSeatTagsFields2[OrderSeatTagsFields2["backgroundColor"] = 7] = "backgroundColor";
  OrderSeatTagsFields2[OrderSeatTagsFields2["orderTagFavorite"] = 8] = "orderTagFavorite";
  OrderSeatTagsFields2[OrderSeatTagsFields2["seatTagFavorite"] = 9] = "seatTagFavorite";
  OrderSeatTagsFields2[OrderSeatTagsFields2["textColor"] = 10] = "textColor";
  return OrderSeatTagsFields2;
})(OrderSeatTagsFields || {});
var TimeBasedMenuTypeFields = /* @__PURE__ */ ((TimeBasedMenuTypeFields2) => {
  TimeBasedMenuTypeFields2[TimeBasedMenuTypeFields2["menuTypeId"] = 0] = "menuTypeId";
  TimeBasedMenuTypeFields2[TimeBasedMenuTypeFields2["day"] = 1] = "day";
  TimeBasedMenuTypeFields2[TimeBasedMenuTypeFields2["startTime"] = 2] = "startTime";
  TimeBasedMenuTypeFields2[TimeBasedMenuTypeFields2["endTime"] = 3] = "endTime";
  return TimeBasedMenuTypeFields2;
})(TimeBasedMenuTypeFields || {});
var DefaultMenuTypeFields = /* @__PURE__ */ ((DefaultMenuTypeFields2) => {
  DefaultMenuTypeFields2[DefaultMenuTypeFields2["defaultMenuTypeId"] = 0] = "defaultMenuTypeId";
  return DefaultMenuTypeFields2;
})(DefaultMenuTypeFields || {});
var OpenItemTypeFields = /* @__PURE__ */ ((OpenItemTypeFields2) => {
  OpenItemTypeFields2[OpenItemTypeFields2["active"] = 0] = "active";
  OpenItemTypeFields2[OpenItemTypeFields2["name"] = 1] = "name";
  OpenItemTypeFields2[OpenItemTypeFields2["posName"] = 2] = "posName";
  OpenItemTypeFields2[OpenItemTypeFields2["dontPromptOpenItemName"] = 3] = "dontPromptOpenItemName";
  OpenItemTypeFields2[OpenItemTypeFields2["sortPriority"] = 4] = "sortPriority";
  OpenItemTypeFields2[OpenItemTypeFields2["prepStationId"] = 5] = "prepStationId";
  OpenItemTypeFields2[OpenItemTypeFields2["taxIds"] = 6] = "taxIds";
  OpenItemTypeFields2[OpenItemTypeFields2["reportingGroupsIds"] = 7] = "reportingGroupsIds";
  return OpenItemTypeFields2;
})(OpenItemTypeFields || {});
var EndOfDayClockOutFieldLabels = /* @__PURE__ */ ((EndOfDayClockOutFieldLabels2) => {
  EndOfDayClockOutFieldLabels2[EndOfDayClockOutFieldLabels2["requireNoOpenOrders"] = 0] = "requireNoOpenOrders";
  EndOfDayClockOutFieldLabels2[EndOfDayClockOutFieldLabels2["requireNonCashTips"] = 1] = "requireNonCashTips";
  EndOfDayClockOutFieldLabels2[EndOfDayClockOutFieldLabels2["requireServerBankSettlement"] = 2] = "requireServerBankSettlement";
  EndOfDayClockOutFieldLabels2[EndOfDayClockOutFieldLabels2["netNonCashTipsOnSettlement"] = 3] = "netNonCashTipsOnSettlement";
  EndOfDayClockOutFieldLabels2[EndOfDayClockOutFieldLabels2["requireCashtipReporting"] = 4] = "requireCashtipReporting";
  EndOfDayClockOutFieldLabels2[EndOfDayClockOutFieldLabels2["requireDrawerSettlement"] = 5] = "requireDrawerSettlement";
  EndOfDayClockOutFieldLabels2[EndOfDayClockOutFieldLabels2["displayTipsDueInHeader"] = 6] = "displayTipsDueInHeader";
  EndOfDayClockOutFieldLabels2[EndOfDayClockOutFieldLabels2["zeroTipsDueOnClockOut"] = 7] = "zeroTipsDueOnClockOut";
  EndOfDayClockOutFieldLabels2[EndOfDayClockOutFieldLabels2["autoSettleDrawerId"] = 8] = "autoSettleDrawerId";
  return EndOfDayClockOutFieldLabels2;
})(EndOfDayClockOutFieldLabels || {});
var returnLabel8 = (field) => {
  if (field in GeneralRegisterDisplayFieldLabels) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.general.registerDisplay.${field}`
    );
  }
  if (field in GeneralOrderTypesAvailableFieldLabels) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.general.orderTypesAvailable.${field}`
    );
  }
  if (field in DefaultMenuTypeFields) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.general.timeBasedMenuType.${field}`
    );
  }
  if (field in TimeBasedMenuTypeFields) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.general.timeBasedMenuType.${field}`
    );
  }
  if (field in SpecialTagFields) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.general.specialTags.${field}`
    );
  }
  if (field in ModifierTagFields) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.general.modifierTags.${field}`
    );
  }
  if (field in DiscountReasonFields) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.general.discountReasons.${field}`
    );
  }
  if (field in OrderSeatTagsFields) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.tags.orderSeatTags.${field}`
    );
  }
  if (field in TableServiceGeneralFieldLabels) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.tableService.general.${field}`
    );
  }
  if (field in TableServiceTableLayoutFieldLabels) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.tableService.tableLayout.${field}`
    );
  }
  if (field in TableServiceCoursingFieldLabels) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.tableService.coursing.${field}`
    );
  }
  if (field in CourseFields) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.tableService.coursing.${field}`
    );
  }
  if (field in QuickServiceGeneralFieldLabels) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.quickService.general.${field}`
    );
  }
  if (field in OpenItemTypeFields) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.tags.openItemTypes.${field}`
    );
  }
  if (field in CFDGeneralFieldLabels) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.customerFacingDisplay.general.${field}`
    );
  }
  if (field in CFDAdsFieldLabels) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.customerFacingDisplay.ads.${field}`
    );
  }
  if (field in CFDTipsFieldLabels) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.customerFacingDisplay.tips.${field}`
    );
  }
  if (field in AdsTableFieldLabels) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.customerFacingDisplay.adsTable.${field}`
    );
  }
  if (field in EndOfDayClockOutFieldLabels) {
    return i18n_config_default.t(
      `app.modals.registerModeDiffModal.endOfDay.clockOut.${field}`
    );
  }
};
var diffRegisterModeFactory = (diffArray, state) => {
  if (diffArray.length > 0) {
    const _a = generateGeneralObj(diffArray, state), {
      specialTags,
      modTags,
      discountReasons,
      orderSeatTags,
      openItemTypes
    } = _a, general = __objRest(_a, [
      "specialTags",
      "modTags",
      "discountReasons",
      "orderSeatTags",
      "openItemTypes"
    ]);
    const tableService = generateTableServiceObj(diffArray, state);
    const quickService = generateQuickServiceObj(diffArray);
    return {
      general,
      tags: {
        specialTags,
        modTags,
        discountReasons,
        orderSeatTags,
        openItemTypes
      },
      tableService,
      quickService,
      customerFacingDisplay: {
        general: getDiffArray(diffArray, returnLabel8, CFDGeneralFieldLabels, 1),
        ads: getDiffArray(diffArray, returnLabel8, CFDAdsFieldLabels, 1),
        adsTable: generateAdsTableDiff(diffArray, state),
        tips: getDiffArray(diffArray, returnLabel8, CFDTipsFieldLabels, 1)
      },
      endOfDay: {
        clockOut: generateEndOfDayObj(diffArray, 1, state)
      }
    };
  }
  return null;
};
var generateEndOfDayObj = (diffArray, depth = 1, state) => {
  const changes = [];
  const enums = EndOfDayClockOutFieldLabels;
  const drawers = selectDrawers(state);
  const users = selectUsers(state);
  diffArray.forEach(
    (diff11) => filterDiffFunction(
      diff11,
      ({ field, diffLength, newDiff }) => {
        var _a;
        if (Array.isArray(enums) && Array.isArray(depth)) {
          enums.forEach((enumObj, index) => {
            if (diffLength !== depth[index]) {
              return;
            }
            if (!(field in enumObj)) {
              return;
            }
            changes.push(newDiff);
          });
        } else {
          if (diffLength !== depth) {
            return;
          }
          if (!(field in enums)) {
            return;
          }
          if (field === "autoSettleDrawerId") {
            const drawer = drawers[Number(newDiff.value)];
            changes.push(__spreadProps(__spreadValues({}, newDiff), {
              textValue: newDiff.value ? drawer.type === "server" /* SERVER */ ? ((_a = users[drawer.ownerOrganizationUserId]) == null ? void 0 : _a.posName) || drawer.name : drawer.name : i18n_config_default.t("commonTexts.bank")
            }));
            return;
          }
          changes.push(newDiff);
        }
      },
      returnLabel8
    )
  );
  return changes;
};
var generateGeneralObj = (diffArray, state) => {
  const changeData = selectCurrentSettingsData(state);
  const originalData = selectCurrentSettingsOriginalData(
    state
  );
  const menuTypes = state.menu.selectedMode.currentMenu.menuTypes;
  const registerDisplay = [];
  const orderTypesAvailable = [];
  const specialTags = [];
  const modTags = [];
  const discountReasons = [];
  const orderSeatTags = [];
  const openItemTypes = [];
  const timeBasedMenuType = [];
  const defaultMenuTypeTimes = {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: []
  };
  const MODIFIER_TAGS_FIELD = "modifierTags";
  const SPECIAL_TAGS_FIELD = "specialTags";
  const DISCOUNT_REASONS_FIELD = "discountReasons";
  const MENU_TYPE_RULES_FIELD2 = "defaultMenuTypeTimes";
  const ORDER_SEAT_TAGS_FIELD = "orderSeatTags";
  const OPEN_ITEM_TYPES_FIELD = "openItemTypes";
  const MODIFIER_TAGS_MENU_TYPE_IDS_FIELD = "menuTypeIds";
  diffArray.forEach(
    (diff11) => filterDiffFunction(
      diff11,
      ({ field, diffLength, newDiff }) => {
        var _a, _b, _c;
        if (diffLength === 1) {
          if (field in GeneralRegisterDisplayFieldLabels) {
            if (field !== "defaultRestaurantMode" && field !== "firePositionOnRegisterTicket") {
              return registerDisplay.push(newDiff);
            }
            switch (newDiff.value) {
              case "qsr" /* QSR */:
                return registerDisplay.push(__spreadProps(__spreadValues({}, newDiff), {
                  textValue: i18n_config_default.t(
                    "settingsModule.registerModeSettings.general.defaultRestaurantMode.options.qsr"
                  )
                }));
              case "tsr" /* TSR */:
                return registerDisplay.push(__spreadProps(__spreadValues({}, newDiff), {
                  textValue: i18n_config_default.t(
                    "settingsModule.registerModeSettings.general.defaultRestaurantMode.options.tsr"
                  )
                }));
              case "top" /* TOP */:
                return registerDisplay.push(__spreadProps(__spreadValues({}, newDiff), {
                  textValue: i18n_config_default.t(
                    "settingsModule.registerModeSettings.general.firePositionOnRegisterTicket.options.top"
                  )
                }));
              case "bottom" /* BOTTOM */:
                return registerDisplay.push(__spreadProps(__spreadValues({}, newDiff), {
                  textValue: i18n_config_default.t(
                    "settingsModule.registerModeSettings.general.firePositionOnRegisterTicket.options.bottom"
                  )
                }));
              case "topCommaSeparated" /* TOP_COMMA_SEPARATED */:
                return registerDisplay.push(__spreadProps(__spreadValues({}, newDiff), {
                  textValue: i18n_config_default.t(
                    "settingsModule.registerModeSettings.general.firePositionOnRegisterTicket.options.topCommaSeparated"
                  )
                }));
              case "bottomCommaSeparated" /* BOTTOM_COMMA_SEPARATED */:
                return registerDisplay.push(__spreadProps(__spreadValues({}, newDiff), {
                  textValue: i18n_config_default.t(
                    "settingsModule.registerModeSettings.general.firePositionOnRegisterTicket.options.bottomCommaSeparated"
                  )
                }));
            }
          } else if (field in GeneralOrderTypesAvailableFieldLabels) {
            orderTypesAvailable.push(newDiff);
          } else if (field in DefaultMenuTypeFields) {
            if (field === "defaultMenuTypeId") {
              timeBasedMenuType.push(__spreadProps(__spreadValues({}, newDiff), {
                textValue: state.menu.selectedMode.currentMenu.menuTypes[Number(newDiff.value)].name
              }));
            }
          }
        } else if (diffLength >= 2) {
          const customField = diff11.path[0];
          if (diff11.kind === "A" && customField === MENU_TYPE_RULES_FIELD2) {
            const change = diff11.item;
            const day = diff11.path[1];
            const index = Number(diff11.index);
            const changes = Object.entries(
              (change == null ? void 0 : change.rhs) || {}
            ).map(([timeBasedMenuTypeField, timeBasedMenuTypeValue]) => ({
              field: timeBasedMenuTypeField,
              label: returnLabel8(timeBasedMenuTypeField),
              value: timeBasedMenuTypeValue
            })).filter((_change) => _change.field in TimeBasedMenuTypeFields);
            if (day in defaultMenuTypeTimes) {
              if ((change == null ? void 0 : change.kind) === "N") {
                defaultMenuTypeTimes[day].push({
                  id: 0,
                  tabletGeneratedId: change.rhs.id,
                  label: menuTypes[change.rhs.menuTypeId].name,
                  action: "add",
                  changes,
                  index
                });
              } else if ((change == null ? void 0 : change.kind) === "D") {
                defaultMenuTypeTimes[day].push({
                  id: change.lhs.id,
                  tabletGeneratedId: change.lhs.id,
                  label: menuTypes[change.lhs.menuTypeId].name,
                  action: "remove",
                  changes: [],
                  index
                });
              }
            }
          } else if (diff11.kind === "N") {
            let changes = Object.entries(
              diff11.rhs
            ).map(([specialTagField, specialTagValue]) => {
              let newFields = {};
              if (customField === ORDER_SEAT_TAGS_FIELD) {
                let typeString = "";
                if (specialTagField === "type") {
                  switch (specialTagValue) {
                    case "allergy" /* ALLERGY */:
                      typeString = i18n_config_default.t(
                        "settingsModule.registerModeSettings.tags.seatOrderTags.type.options.allergy"
                      );
                      break;
                    case "attribute" /* ATTRIBUTE */:
                      typeString = i18n_config_default.t(
                        "settingsModule.registerModeSettings.tags.seatOrderTags.type.options.attribute"
                      );
                      break;
                    case "milestone" /* MILESTONE */:
                      typeString = i18n_config_default.t(
                        "settingsModule.registerModeSettings.tags.seatOrderTags.type.options.milestone"
                      );
                      break;
                  }
                  newFields = { textValue: typeString };
                } else if (specialTagField === "isOrderTag") {
                  const orderOrSeatTagString = getOrderOrSeatTagString({
                    isOrderTag: diff11.rhs.isOrderTag,
                    isSeatTag: diff11.rhs.isSeatTag
                  });
                  switch (orderOrSeatTagString) {
                    case "orderOnly" /* ORDER_ONLY */:
                      typeString = i18n_config_default.t(
                        "settingsModule.registerModeSettings.tags.seatOrderTags.orderOrSeatTag.options.orderOnly"
                      );
                      break;
                    case "seatOnly" /* SEAT_ONLY */:
                      typeString = i18n_config_default.t(
                        "settingsModule.registerModeSettings.tags.seatOrderTags.orderOrSeatTag.options.seatOnly"
                      );
                      break;
                    case "both" /* BOTH */:
                      typeString = i18n_config_default.t(
                        "settingsModule.registerModeSettings.tags.seatOrderTags.orderOrSeatTag.options.both"
                      );
                      break;
                  }
                  newFields = { textValue: typeString };
                }
              }
              return __spreadValues({
                field: specialTagField,
                label: returnLabel8(specialTagField),
                value: specialTagValue
              }, newFields);
            });
            if (customField === SPECIAL_TAGS_FIELD) {
              changes = changes.filter(
                (change) => change.field in SpecialTagFields
              );
              specialTags.push({
                id: diff11.rhs.specialTagId,
                label: diff11.rhs.name,
                action: "add",
                changes
              });
            } else if (customField === MODIFIER_TAGS_FIELD) {
              changes = changes.filter(
                (change) => change.field in ModifierTagFields
              );
              modTags.push({
                id: diff11.rhs.modifierTagId,
                label: diff11.rhs.name,
                action: "add",
                changes
              });
            } else if (customField === DISCOUNT_REASONS_FIELD) {
              changes = changes.filter(
                (change) => change.field in DiscountReasonFields
              );
              discountReasons.push({
                id: diff11.rhs.discountReasonId,
                label: diff11.rhs.name,
                action: "add",
                changes
              });
            } else if (customField === ORDER_SEAT_TAGS_FIELD) {
              changes = changes.filter(
                (change) => change.field in OrderSeatTagsFields
              );
              orderSeatTags.push({
                id: 0,
                tabletGeneratedId: diff11.rhs.orderSeatTagId,
                label: diff11.rhs.name,
                action: "add",
                changes
              });
            } else if (customField === OPEN_ITEM_TYPES_FIELD) {
              changes = changes.filter(
                (change) => change.field in OpenItemTypeFields
              );
              openItemTypes.push({
                id: diff11.rhs.openItemTypeId,
                label: diff11.rhs.name,
                action: "add",
                changes,
                taxesDiff: [],
                reportingGroupsDiff: []
              });
            }
          } else if (diff11.kind === "D") {
            if (customField === SPECIAL_TAGS_FIELD) {
              specialTags.push({
                id: diff11.lhs.specialTagId,
                label: diff11.lhs.name,
                action: "remove",
                changes: []
              });
            } else if (customField === MODIFIER_TAGS_FIELD) {
              modTags.push({
                id: diff11.lhs.modifierTagId,
                label: diff11.lhs.name,
                action: "remove",
                changes: []
              });
            } else if (customField === DISCOUNT_REASONS_FIELD) {
              discountReasons.push({
                id: diff11.lhs.discountReasonId,
                label: diff11.lhs.name,
                action: "remove",
                changes: []
              });
            } else if (customField === ORDER_SEAT_TAGS_FIELD) {
              orderSeatTags.push({
                id: Number(
                  diff11.lhs.orderSeatTagId
                ),
                tabletGeneratedId: diff11.lhs.orderSeatTagId,
                label: diff11.lhs.name,
                action: "remove",
                changes: []
              });
            } else if (customField === OPEN_ITEM_TYPES_FIELD) {
              openItemTypes.push({
                id: Number(
                  diff11.lhs.openItemTypeId
                ),
                label: diff11.lhs.name,
                action: "remove",
                changes: [],
                taxesDiff: [],
                reportingGroupsDiff: []
              });
            }
          } else if (diff11.kind === "E" || diff11.kind === "A" && customField === OPEN_ITEM_TYPES_FIELD || diff11.kind === "A" && customField === MODIFIER_TAGS_FIELD && field === MODIFIER_TAGS_MENU_TYPE_IDS_FIELD) {
            const id = Number(diff11.path[1]);
            let newFields = {};
            if (customField === ORDER_SEAT_TAGS_FIELD) {
              let typeString = "";
              if (field === "type") {
                switch (diff11.rhs) {
                  case "allergy" /* ALLERGY */:
                    typeString = i18n_config_default.t(
                      "settingsModule.registerModeSettings.tags.seatOrderTags.type.options.allergy"
                    );
                    break;
                  case "attribute" /* ATTRIBUTE */:
                    typeString = i18n_config_default.t(
                      "settingsModule.registerModeSettings.tags.seatOrderTags.type.options.attribute"
                    );
                    break;
                  case "milestone" /* MILESTONE */:
                    typeString = i18n_config_default.t(
                      "settingsModule.registerModeSettings.tags.seatOrderTags.type.options.milestone"
                    );
                    break;
                }
                newFields = { textValue: typeString };
              } else if (field === "isOrderTag") {
                const orderOrSeatTagString = getOrderOrSeatTagString({
                  isOrderTag: changeData.orderSeatTags[id].isOrderTag,
                  isSeatTag: changeData.orderSeatTags[id].isSeatTag
                });
                switch (orderOrSeatTagString) {
                  case "orderOnly" /* ORDER_ONLY */:
                    typeString = i18n_config_default.t(
                      "settingsModule.registerModeSettings.tags.seatOrderTags.orderOrSeatTag.options.orderOnly"
                    );
                    break;
                  case "seatOnly" /* SEAT_ONLY */:
                    typeString = i18n_config_default.t(
                      "settingsModule.registerModeSettings.tags.seatOrderTags.orderOrSeatTag.options.seatOnly"
                    );
                    break;
                  case "both" /* BOTH */:
                    typeString = i18n_config_default.t(
                      "settingsModule.registerModeSettings.tags.seatOrderTags.orderOrSeatTag.options.both"
                    );
                    break;
                }
                newFields = { textValue: typeString };
              }
            }
            const customNewDiff = __spreadValues({
              field: customField === MENU_TYPE_RULES_FIELD2 ? diff11.path[3] : diff11.path[2],
              label: returnLabel8(diff11.path[2]) || "",
              value: diff11.rhs
            }, newFields);
            if (customNewDiff.field === MODIFIER_TAGS_MENU_TYPE_IDS_FIELD) {
              const menuTypeIds = (_a = changeData.modifierTags[id]) == null ? void 0 : _a.menuTypeIds;
              customNewDiff.value = (menuTypeIds == null ? void 0 : menuTypeIds.length) === 0 ? null : menuTypeIds;
            }
            if (customField === SPECIAL_TAGS_FIELD) {
              if (!specialTags.find(
                (specialTag) => specialTag.id === id && specialTag.action === "update"
              )) {
                specialTags.push({
                  id,
                  label: changeData.specialTags[id].name,
                  action: "update",
                  changes: [customNewDiff]
                });
              } else {
                for (const [i, specialTag] of specialTags.entries()) {
                  if (specialTag.id === id) {
                    specialTags[i].changes = [
                      ...specialTag.changes,
                      customNewDiff
                    ];
                    break;
                  }
                }
              }
            } else if (customField === MODIFIER_TAGS_FIELD) {
              if (customNewDiff.field === MODIFIER_TAGS_MENU_TYPE_IDS_FIELD && customNewDiff.value) {
                const menuTypeIdsChanges = getArrayNumberChanges(
                  (_b = originalData.modifierTags[id]) == null ? void 0 : _b.menuTypeIds,
                  (_c = changeData.modifierTags[id]) == null ? void 0 : _c.menuTypeIds
                );
                if (!menuTypeIdsChanges.length) {
                  return;
                }
              }
              if (!modTags.find(
                (modifierTag) => modifierTag.id === id && modifierTag.action === "update"
              )) {
                modTags.push({
                  id,
                  label: changeData.modifierTags[id].name,
                  action: "update",
                  changes: [customNewDiff]
                });
              } else {
                for (const [i, modifierTag] of modTags.entries()) {
                  if (modifierTag.id === id) {
                    if (modTags[i].changes.some(
                      (change) => change.field === MODIFIER_TAGS_MENU_TYPE_IDS_FIELD
                    )) {
                      return;
                    }
                    modTags[i].changes = [
                      ...modifierTag.changes,
                      customNewDiff
                    ];
                    break;
                  }
                }
              }
            } else if (customField === DISCOUNT_REASONS_FIELD) {
              if (!discountReasons.find(
                (discountReason) => discountReason.id === id && discountReason.action === "update"
              )) {
                discountReasons.push({
                  id,
                  label: changeData.discountReasons[id].name,
                  action: "update",
                  changes: [customNewDiff]
                });
              } else {
                for (const [i, discountReason] of discountReasons.entries()) {
                  if (discountReason.id === id) {
                    discountReasons[i].changes = [
                      ...discountReason.changes,
                      customNewDiff
                    ];
                    break;
                  }
                }
              }
            } else if (customField === ORDER_SEAT_TAGS_FIELD) {
              if (!orderSeatTags.find(
                (orderSeatTag) => orderSeatTag.id === id && orderSeatTag.action === "update"
              )) {
                orderSeatTags.push({
                  id,
                  tabletGeneratedId: id,
                  label: changeData.orderSeatTags[id].name,
                  action: "update",
                  changes: [customNewDiff]
                });
              } else {
                for (const [i, orderSeatTag] of orderSeatTags.entries()) {
                  if (orderSeatTag.id === id) {
                    orderSeatTags[i].changes = [
                      ...orderSeatTag.changes,
                      customNewDiff
                    ];
                    break;
                  }
                }
              }
            } else if (customField === MENU_TYPE_RULES_FIELD2) {
              const day = diff11.path[1];
              const timeBasedIndex = Number(diff11.path[2]);
              const timeBasedId = state.settings.selectedMode.currentSettings.register.defaultMenuTypeTimes[day][timeBasedIndex].id;
              if (day in defaultMenuTypeTimes && field in TimeBasedMenuTypeFields) {
                if (!defaultMenuTypeTimes[day].find(
                  (menuType) => menuType.id === timeBasedId && menuType.action === "update"
                )) {
                  defaultMenuTypeTimes[day].push({
                    id: timeBasedId,
                    tabletGeneratedId: timeBasedId,
                    label: menuTypes[changeData.defaultMenuTypeTimes[day][timeBasedIndex].menuTypeId].name,
                    action: "update",
                    changes: [customNewDiff],
                    index: timeBasedIndex
                  });
                } else {
                  for (const [i, menuType] of defaultMenuTypeTimes[day].entries()) {
                    if (menuType.id === timeBasedId) {
                      defaultMenuTypeTimes[day][i].changes = [
                        ...menuType.changes,
                        customNewDiff
                      ];
                      break;
                    }
                  }
                }
              }
            } else if (customField === OPEN_ITEM_TYPES_FIELD) {
              const isTaxIds = field === "taxIds";
              const isreportingGroupsIds = field === "reportingGroupsIds";
              if (!openItemTypes.find(
                (openItemType) => openItemType.id === id && openItemType.action === "update"
              )) {
                openItemTypes.push({
                  id,
                  label: changeData.openItemTypes[id].name,
                  action: "update",
                  changes: isTaxIds || isreportingGroupsIds ? [] : [customNewDiff],
                  taxesDiff: getOpenItemTypeTaxesDiff(id, state),
                  reportingGroupsDiff: getOpenItemTypeReportingGroupsDiff(
                    id,
                    state
                  )
                });
              } else {
                if (isTaxIds || isreportingGroupsIds) {
                  return;
                }
                for (const [i, openItemType] of openItemTypes.entries()) {
                  if (openItemType.id === id) {
                    openItemTypes[i].changes = [
                      ...openItemType.changes,
                      customNewDiff
                    ];
                    break;
                  }
                }
              }
            }
          }
        }
      },
      returnLabel8
    )
  );
  return {
    registerDisplay,
    orderTypesAvailable,
    specialTags,
    orderSeatTags,
    modTags,
    discountReasons,
    openItemTypes,
    defaultMenuTypeTimes: mapValues3(
      defaultMenuTypeTimes,
      (rules) => sortBy(rules, (rule) => {
        const rank = {
          update: 1,
          add: 2,
          remove: 3
        };
        return rank[rule.action];
      })
    ),
    timeBasedMenuType
  };
};
var generateAdsTableDiff = (diffArray, state) => {
  const changeData = selectCurrentSettingsData(state);
  const ads = [];
  const ADS_FIELD = "ads";
  diffArray.forEach(
    (diff11) => filterDiffFunction(
      diff11,
      ({ diffLength, newDiff }) => {
        if (diffLength === 1) {
          return;
        } else if (diffLength >= 2) {
          const customField = diff11.path[0];
          if (diff11.kind === "N") {
            let changes = Object.entries(diff11.rhs).map(
              ([adField, adValue]) => ({
                field: adField,
                label: returnLabel8(adField),
                value: adValue
              })
            );
            if (customField === ADS_FIELD) {
              changes = changes.filter(
                (change) => change.field in AdsTableFieldLabels
              );
              ads.push({
                id: diff11.rhs.id,
                label: diff11.rhs.title,
                action: "add",
                changes
              });
            }
          } else if (diff11.kind === "D") {
            if (customField === ADS_FIELD) {
              ads.push({
                id: diff11.lhs.id,
                label: diff11.lhs.title,
                action: "remove",
                changes: []
              });
            }
          } else if (diff11.kind === "E") {
            const id = diff11.path[1];
            if (customField === ADS_FIELD) {
              if (!ads.find((ad) => ad.id === id && ad.action === "update")) {
                ads.push({
                  id,
                  label: changeData.ads[id].title,
                  action: "update",
                  changes: [newDiff]
                });
              } else {
                for (const [i, ad] of ads.entries()) {
                  if (ad.id === id) {
                    ads[i].changes = [...ad.changes, newDiff];
                    break;
                  }
                }
              }
            }
          }
        }
      },
      returnLabel8
    )
  );
  return ads;
};
var getOpenItemTypeTaxesDiff = (openItemTypeId, state) => {
  const originalData = selectCurrentSettingsOriginalData(state);
  const changeData = selectCurrentSettingsData(state);
  const originalOpenItemType = originalData.openItemTypes[openItemTypeId];
  const changedOpenItemType = changeData.openItemTypes[openItemTypeId];
  if (!originalOpenItemType || !changedOpenItemType) {
    return [];
  }
  return getTaxesDiffArrayCore(
    originalOpenItemType.taxIds,
    changedOpenItemType.taxIds,
    state
  ).map((taxDiff) => ({
    label: taxDiff.value,
    id: taxDiff.id,
    action: taxDiff.action
  }));
};
var getOpenItemTypeReportingGroupsDiff = (openItemTypeId, state) => {
  const originalData = selectCurrentSettingsOriginalData(state);
  const changeData = selectCurrentSettingsData(state);
  const originalOpenItemType = originalData.openItemTypes[openItemTypeId];
  const changedOpenItemType = changeData.openItemTypes[openItemTypeId];
  if (!originalOpenItemType || !changedOpenItemType) {
    return [];
  }
  return getReportingGroupsDiffArrayCore(
    originalOpenItemType.reportingGroupsIds,
    changedOpenItemType.reportingGroupsIds,
    state
  ).map((reportingGroupDiff) => ({
    label: reportingGroupDiff.value,
    id: reportingGroupDiff.id,
    action: reportingGroupDiff.action
  }));
};
var generateTableServiceObj = (diffArray, state) => {
  const data = state.settings.changeData.data;
  const prepStations = currentPrepStationsSelector(state);
  const general = [];
  const coursing = [];
  const coursingTable = [];
  const tableLayout = [];
  const COURSING_FIELD = "courses";
  diffArray.forEach(
    (diff11) => filterDiffFunction(
      diff11,
      ({ field, diffLength, newDiff }) => {
        var _a, _b;
        if (diffLength === 1) {
          if (field in TableServiceGeneralFieldLabels) {
            if (field === "seatingMode") {
              general.push(__spreadProps(__spreadValues({}, newDiff), {
                textValue: i18n_config_default.t(
                  `settingsModule.registerModeSettings.tableService.general.seating.seatingMode.options.${newDiff.value}`
                )
              }));
              return;
            } else if (field === "ticketSeatBar") {
              general.push(__spreadProps(__spreadValues({}, newDiff), {
                textValue: i18n_config_default.t(
                  `settingsModule.registerModeSettings.tableService.general.seating.ticketSeatBar.options.${newDiff.value}`
                )
              }));
              return;
            } else if (field === "prepStationForFireTicketId") {
              general.push(__spreadProps(__spreadValues({}, newDiff), {
                textValue: ((_a = prepStations[newDiff.value]) == null ? void 0 : _a.name) || i18n_config_default.t("app.modals.prepStation.noPrepStation")
              }));
              return;
            } else if (field === "seatManagementButtonFunction") {
              general.push(__spreadProps(__spreadValues({}, newDiff), {
                textValue: i18n_config_default.t(
                  `settingsModule.registerModeSettings.tableService.general.seating.seatManagementButtonFunction.options.${newDiff.value}`
                )
              }));
              return;
            }
            general.push(newDiff);
          } else if (field in TableServiceTableLayoutFieldLabels) {
            tableLayout.push(newDiff);
          } else if (field in TableServiceCoursingFieldLabels) {
            if (field === "coursingMode") {
              switch (newDiff.value) {
                case "on_the_fly" /* ON_THE_FLY */:
                  return coursing.push(__spreadProps(__spreadValues({}, newDiff), {
                    textValue: i18n_config_default.t(
                      "settingsModule.registerModeSettings.tableService.coursing.coursingMode.options.onTheFly"
                    )
                  }));
                case "predefined" /* PREDEFINED */:
                  return coursing.push(__spreadProps(__spreadValues({}, newDiff), {
                    textValue: i18n_config_default.t(
                      "settingsModule.registerModeSettings.tableService.coursing.coursingMode.options.predefined"
                    )
                  }));
              }
            }
            coursing.push(newDiff);
          }
        } else if (diffLength >= 2) {
          const customField = diff11.path[0];
          if (diff11.kind === "N") {
            let changes = Object.entries(
              diff11.rhs
            ).map(([specialTagField, specialTagValue]) => ({
              field: specialTagField,
              label: returnLabel8(specialTagField),
              value: specialTagValue
            }));
            if (customField === COURSING_FIELD) {
              changes = changes.filter((change) => change.field in CourseFields);
              coursingTable.push({
                id: diff11.rhs.courseId,
                label: diff11.rhs.name,
                action: "add",
                changes
              });
            }
          } else if (diff11.kind === "D") {
            if (customField === COURSING_FIELD) {
              coursingTable.push({
                id: diff11.lhs.courseId,
                label: diff11.lhs.name,
                action: "remove",
                changes: []
              });
            }
          } else if (diff11.kind === "E") {
            const id = Number(diff11.path[1]);
            const customNewDiff = {
              field: diff11.path[2],
              label: returnLabel8(diff11.path[2]) || "",
              value: diff11.rhs
            };
            if (customField === COURSING_FIELD) {
              if (!coursingTable.find(
                (course) => course.id === id && course.action === "update"
              )) {
                coursingTable.push({
                  id,
                  label: (_b = data.courses[id]) == null ? void 0 : _b.name,
                  action: "update",
                  changes: [customNewDiff]
                });
              } else {
                for (const [i, course] of coursingTable.entries()) {
                  if (course.id === id) {
                    coursingTable[i].changes = [
                      ...course.changes,
                      customNewDiff
                    ];
                    break;
                  }
                }
              }
            }
          }
        }
      },
      returnLabel8
    )
  );
  return {
    general,
    coursing,
    coursingTable,
    tableLayout
  };
};
var generateQuickServiceObj = (diffArray) => {
  const general = [];
  diffArray.forEach(
    (diff11) => filterDiffFunction(
      diff11,
      ({ field, diffLength, newDiff }) => {
        if (diffLength === 1) {
          if (field in QuickServiceGeneralFieldLabels) {
            if (field !== "qsrSendAndPayActionButtons") {
              return general.push(newDiff);
            }
            switch (newDiff.value) {
              case "pay_only" /* PAY_ONLY */:
                return general.push(__spreadProps(__spreadValues({}, newDiff), {
                  textValue: i18n_config_default.t(
                    "settingsModule.registerModeSettings.quickService.general.qsrSendAndPayActionButtons.options.payOnly"
                  )
                }));
              case "send_only" /* SEND_ONLY */:
                return general.push(__spreadProps(__spreadValues({}, newDiff), {
                  textValue: i18n_config_default.t(
                    "settingsModule.registerModeSettings.quickService.general.qsrSendAndPayActionButtons.options.sendOnly"
                  )
                }));
              case "both" /* BOTH */:
                return general.push(__spreadProps(__spreadValues({}, newDiff), {
                  textValue: i18n_config_default.t(
                    "settingsModule.registerModeSettings.quickService.general.qsrSendAndPayActionButtons.options.both"
                  )
                }));
            }
          }
        }
      },
      returnLabel8
    )
  );
  return {
    general
  };
};
var getGenericError = ({
  message,
  id,
  section
}) => ({
  id: "genericError" /* GENERIC_ERROR */,
  data: {
    message
  },
  kind: {
    id,
    data: {
      message
    },
    type: "genericError" /* GENERIC_ERROR */,
    section
  }
});
var getPaymentsId = (key, field) => {
  return `payments-${key}-${field}`;
};
var getPaymentsError = (field) => {
  return getGenericError({
    id: field,
    message: i18n_config_default.t(`settingsModule.paymentsSettings.errors.${field}`),
    section: "payments" /* PAYMENTS */
  });
};
var getCustomTenderError = (key, field) => {
  const objectKey = getCustomTenderId(key, field);
  return getSettingsGenericError({
    key: objectKey,
    id: "paymentsCustomTenders",
    message: i18n_config_default.t(
      "settingsModule.paymentsSettings.errors.customTenders.name"
    ),
    section: "customTenders" /* CUSTOM_TENDERS */
  });
};
var paymentsCustomTendersSchema = yup.lazy(
  (obj) => yup.object(
    mapValues3(
      obj,
      (_, key) => yup.object({
        name: yup.string().trim().required(JSON.stringify(getCustomTenderError(key, "name")))
      })
    )
  )
);
var validatePayments = (data) => __async(void 0, null, function* () {
  let errors = {};
  const { success, reason } = validateEndOfBusinessDay(
    data.batchTime,
    "batchTime"
  );
  if (!success) {
    errors["batchTime"] = getSettingsGenericError({
      key: "batchTime",
      id: "batchTime",
      message: i18n_config_default.t(
        `settingsModule.paymentsSettings.errors.batchTime.${reason === "empty" ? "empty" : "invalid"}`
      ),
      section: "general" /* GENERAL */
    }).batchTime;
  }
  if (data.enableEGiftIntegration ? !data.eGiftCardLocationId || data.eGiftCardLocationId.length !== 4 : data.eGiftCardLocationId && data.eGiftCardLocationId.length !== 4) {
    errors["eGiftCardLocationId"] = getSettingsGenericError({
      key: "eGiftCardLocationId",
      id: "eGiftCardLocationId",
      message: i18n_config_default.t(
        "settingsModule.paymentsSettings.errors.eGiftCardLocationId"
      ),
      section: "payments" /* PAYMENTS */
    }).eGiftCardLocationId;
  }
  if (data.enableEGiftIntegration ? !data.eGiftCardMerchantId || data.eGiftCardMerchantId.length !== 7 : data.eGiftCardMerchantId && data.eGiftCardMerchantId.length !== 7) {
    errors["eGiftCardMerchantId"] = getSettingsGenericError({
      key: "eGiftCardMerchantId",
      id: "eGiftCardMerchantId",
      message: i18n_config_default.t(
        "settingsModule.paymentsSettings.errors.eGiftCardMerchantId"
      ),
      section: "payments" /* PAYMENTS */
    }).eGiftCardMerchantId;
  }
  Object.values(data.serviceCharges).forEach((charge) => {
    if (charge.name.length === 0) {
      errors[`payments-${charge.id}-name`] = getPaymentsError("name");
    }
    if (charge.posName.length === 0) {
      errors[`payments-${charge.id}-posName`] = getPaymentsError("posName");
    }
    if (charge.orderTypes.length === 0) {
      errors[`payments-${charge.id}-orderTypes`] = getPaymentsError("orderTypes");
    }
    if (charge.charge <= 0 && charge.chargeType !== "custom_dollar" /* CUSTOM_DOLLAR */ && charge.chargeType !== "custom_percent" /* CUSTOM_PERCENT */)
      errors[`payments-${charge.id}-charge`] = getGenericError({
        id: "charge",
        message: i18n_config_default.t("settingsModule.paymentsSettings.errors.charge"),
        section: "payments" /* PAYMENTS */
      });
  });
  try {
    yield paymentsCustomTendersSchema.validate(data.customTenders || {}, {
      abortEarly: false
    });
  } catch (error) {
    errors = __spreadValues(__spreadValues({}, errors), reduceErrors(error.errors));
  }
  if (Object.keys(errors).length > 0) {
    throw errors;
  }
});

// src/dummy/settings/registerTicketSettings.dummy.json
var registerTicketSettings_dummy_default = {
  id: 15175,
  createdAt: "2025-02-05T21:01:06.86Z",
  updatedAt: "2025-02-05T21:03:01.690473Z",
  deletedAt: null,
  organizationId: 574,
  locationId: 853,
  ownerId: 2082,
  ownerRoleId: 200,
  createdById: 2082,
  lastUpdatedById: 2082,
  organizationCustomerId: null,
  description: "",
  name: "",
  status: "open-initiated",
  type: "to_go",
  subtotal: 55.29,
  itemCount: 4,
  serviceChargePercent: 0,
  tax: 7.93,
  tip: 0,
  total: 68.22,
  balanceDue: 68.22,
  seatOnePosition: "",
  numberOfSeatsOccupied: 5,
  orderNumber: "00-0001",
  revenueCenterId: 3,
  serviceAreaId: 5,
  tabletGeneratedId: "fc6ec9ca-8bc0-4d50-ad0c-dfd02c8754cc",
  newOrder: false,
  licenseEditingId: 577,
  ticketElements: {
    "69033": {
      id: 69033,
      itemId: 2292,
      itemObj: {
        id: 2292,
        name: "Big Bacon BBQ Burger",
        itemId: 2292,
        customId: "",
        createdAt: "2023-04-27T17:34:55.159707Z",
        deletedAt: null,
        updatedAt: "2024-09-06T18:40:47.255333Z",
        locationIds: null,
        taxesSource: {
          "33": {
            id: 33,
            name: "FL 10% Tax",
            taxType: "percent",
            typeData: {
              rate: 10,
              unit: null,
              interval: null
            },
            orderTypes: "catering,delivery,dine in,to_go",
            tableTypeData: null,
            organizationId: 574
          },
          "34": {
            id: 34,
            name: "Alc",
            taxType: "volume",
            typeData: {
              rate: 0.06,
              unit: "ml",
              interval: 10
            },
            orderTypes: "catering,dine in,delivery,to_go",
            tableTypeData: null,
            organizationId: 574
          },
          "35": {
            id: 35,
            name: "Dining",
            taxType: "fixed",
            typeData: {
              rate: 0.25,
              unit: null,
              interval: null
            },
            orderTypes: "catering,dine in,delivery,to_go",
            tableTypeData: null,
            organizationId: 574
          }
        },
        menuTypeItemId: 6203,
        organizationId: 574,
        menuTypeVersions: {
          "278": {
            id: 18772,
            unit: "ml",
            active: true,
            combos: {},
            is86ed: true,
            recipe: "This is a top secret formula",
            taxIds: [],
            volume: 0,
            kdsName: "Bacon BBQ Burger",
            posName: "Big Bacon BBQ Bjf",
            calories: 0,
            courseId: 67,
            delivery: false,
            imageUrl: "https://olo-images-live.imgix.net/e6/e63a08b7d22846469554e2722fb581d4.jpg?auto=format%2Ccompress&q=60&cs=tinysrgb&w=1200&h=800&fit=fill&fm=png32&bg=transparent&s=d45dc71bcb50b10c16bac74f775d0b4b",
            kdsColor: null,
            prepTime: 0,
            specials: {
              "58": {
                name: "newtst",
                active: true,
                posName: "newtst",
                specialId: 58,
                availableTimes: {
                  friday: [
                    {
                      id: 603,
                      day: "friday",
                      endTime: "2024-08-22T16:00:00Z",
                      createdAt: "2024-08-22T15:49:52.097657Z",
                      deletedAt: null,
                      startTime: "2024-08-22T12:00:00Z",
                      updatedAt: "2024-08-22T15:49:52.097657Z",
                      locationMenuTypeSpecialId: 178
                    }
                  ],
                  monday: [
                    {
                      id: 597,
                      day: "monday",
                      endTime: "2024-08-22T19:00:00Z",
                      createdAt: "2024-08-22T15:10:42.90859Z",
                      deletedAt: null,
                      startTime: "2024-08-22T12:00:00Z",
                      updatedAt: "2024-08-22T15:49:52.091353Z",
                      locationMenuTypeSpecialId: 178
                    }
                  ],
                  sunday: [
                    {
                      id: 599,
                      day: "sunday",
                      endTime: "2024-08-22T16:00:00Z",
                      createdAt: "2024-08-22T15:49:52.094611Z",
                      deletedAt: null,
                      startTime: "2024-08-22T12:00:00Z",
                      updatedAt: "2024-08-22T15:49:52.094611Z",
                      locationMenuTypeSpecialId: 178
                    }
                  ],
                  tuesday: [
                    {
                      id: 600,
                      day: "tuesday",
                      endTime: "2025-01-15T04:45:00Z",
                      createdAt: "2024-08-22T15:49:52.095403Z",
                      deletedAt: null,
                      startTime: "2025-01-14T05:00:00Z",
                      updatedAt: "2025-01-14T22:19:28.507669Z",
                      locationMenuTypeSpecialId: 178
                    }
                  ],
                  saturday: [
                    {
                      id: 598,
                      day: "saturday",
                      endTime: "2024-08-22T19:00:00Z",
                      createdAt: "2024-08-22T15:49:52.092955Z",
                      deletedAt: null,
                      startTime: "2024-08-22T12:00:00Z",
                      updatedAt: "2024-08-22T15:49:52.092955Z",
                      locationMenuTypeSpecialId: 178
                    }
                  ],
                  thursday: [
                    {
                      id: 602,
                      day: "thursday",
                      endTime: "2024-08-22T16:00:00Z",
                      createdAt: "2024-08-22T15:49:52.096895Z",
                      deletedAt: null,
                      startTime: "2024-08-22T12:00:00Z",
                      updatedAt: "2024-08-22T15:49:52.096895Z",
                      locationMenuTypeSpecialId: 178
                    }
                  ],
                  wednesday: [
                    {
                      id: 601,
                      day: "wednesday",
                      endTime: "2024-08-22T16:00:00Z",
                      createdAt: "2024-08-22T15:49:52.096153Z",
                      deletedAt: null,
                      startTime: "2024-08-22T12:00:00Z",
                      updatedAt: "2024-08-22T15:49:52.096153Z",
                      locationMenuTypeSpecialId: 178
                    }
                  ]
                }
              }
            },
            allModIds: [],
            checkName: "Bacon BBQ Burger",
            createdAt: "2023-04-27T17:34:55.976007Z",
            deletedAt: null,
            itemPrice: 17.19,
            textColor: null,
            toGoPrice: 17.19,
            updatedAt: "2025-01-30T16:58:11.189238Z",
            customizer: false,
            locationId: 853,
            menuTypeId: 278,
            onlineName: "Big Bacon BBQ Burger",
            description: "Two beef patties, six slices of bacon, house BBQ, cheddar, red onion, pickles.",
            ingredients: {
              "4": {
                id: 199,
                name: "Beef",
                active: true,
                posName: "Beef",
                isDisabled: false,
                isSelected: true,
                ingredientId: 4,
                sortPriority: 1
              }
            },
            onlinePrice: 17.19,
            showAllMods: true,
            activeOnline: true,
            ageThreshold: 21,
            allowSharing: false,
            hideItemName: false,
            reset86Daily: false,
            sortPriority: 2,
            spacesBefore: 0,
            specialTagId: null,
            taxInclusive: false,
            ageRestricted: false,
            currentAmount: -102,
            defaultNoSeat: false,
            deliveryPrice: 17.19,
            initialAmount: 10,
            showModifiers: false,
            doneIsForTable: false,
            inheritedTaxes: {
              categoryInheritedTaxes: {},
              menuTypeInheritedTaxes: {
                "33": {
                  id: 33,
                  isActive: true
                },
                "34": {
                  id: 34,
                  isActive: true
                },
                "35": {
                  id: 35,
                  isActive: true
                }
              },
              subcategoryInheritedTaxes: {}
            },
            menuTypeItemId: 6201,
            modifierGroups: {
              "0": {
                id: 0,
                active: true,
                global: true,
                kdsName: "Custom",
                posName: "Custom",
                isAllMod: false,
                override: {
                  active: false,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "Custom",
                createdAt: null,
                deletedAt: null,
                textColor: null,
                updatedAt: null,
                locationId: 0,
                multiselect: true,
                quantityMode: "x1,x2,x3",
                sortPriority: null,
                enableModTags: false,
                modifierItems: {},
                priceCalcMode: "max",
                showSearchBar: true,
                backgroundColor: null,
                hidePriceIfFree: false,
                inheritedActive: true,
                isPremadeHeader: false,
                modifierGroupId: 0,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: false,
                maximumModifierItems: 0,
                modifierGroupItemsId: 0,
                defaultSelectionPrice: 0,
                includedModifierItems: 0,
                requiredModifierItems: 0,
                searchAllModifierItems: false,
                locationModifierGroupId: 0,
                modifierGroupMenuTypeItemId: 0,
                locationModifierGroupItemsId: 0,
                locationModifierGroupVersionId: 0,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: true,
                defaultModifierGroupPricingVersionId: 0,
                locationModifierGroupMenuTypeItemVersionId: 0
              },
              "298": {
                id: 14700,
                active: true,
                posName: "Toppings",
                isAllMod: false,
                override: {
                  advancedModifier: true,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "Toppings_Test",
                createdAt: "2023-04-27T17:34:58.364449Z",
                deletedAt: null,
                textColor: null,
                updatedAt: "2025-01-30T16:58:11.168592Z",
                locationId: 853,
                multiselect: true,
                quantityMode: "Lt,Reg,Ext",
                sortPriority: 3,
                enableModTags: false,
                modifierItems: {
                  "1337": {
                    id: 1337,
                    name: "Pepper",
                    active: true,
                    is86ed: false,
                    kdsName: "Pepper",
                    posName: "Pepper",
                    override: {
                      isSelected: true,
                      includedExtraPrice: true,
                      includedLightPrice: true,
                      additionalExtraPrice: true,
                      additionalLightPrice: true,
                      includedRegularPrice: true,
                      additionalRegularPrice: true,
                      defaultQuantitySelected: true
                    },
                    checkName: "Pepper",
                    createdAt: "2023-04-27T17:34:58.684437Z",
                    deletedAt: null,
                    updatedAt: "2024-06-03T21:27:19.97053Z",
                    isDisabled: false,
                    isSelected: true,
                    onlineName: "Pepper",
                    description: "",
                    linesBefore: 0,
                    onSidePrice: 0,
                    sortPriority: 5,
                    spacesBefore: 0,
                    modifierGroups: {},
                    modifierItemId: 1337,
                    inheritedActive: true,
                    maximumQuantity: null,
                    halfPricePercent: 50,
                    includedExtraPrice: 5,
                    includedLightPrice: 5,
                    includedMasterPrice: 1,
                    quarterPricePercent: 25,
                    additionalExtraPrice: 5,
                    additionalLightPrice: 5,
                    includedRegularPrice: 5,
                    additionalMasterPrice: 2,
                    defaultAmountSelected: "regular",
                    defaultModifiersPrice: 0,
                    defaultSelectionPrice: 0,
                    includedModifierItems: 3,
                    requiredModifierItems: 0,
                    additionalRegularPrice: 5,
                    locationModifierItemId: 1495,
                    defaultQuantitySelected: 1,
                    modifierGroupModifierItemId: 1319,
                    modifierItemPricingVersionId: 1891,
                    locationModifierItemVersionId: 1959,
                    locationMgpvLocationMipvVersionId: 733,
                    defaultModifierItemPricingVersionId: 1891,
                    locationModifierGroupMenuTypeItemId: 0,
                    locationModifierGroupModifierItemId: 2666,
                    defaultModifierGroupPricingVersionId: 319,
                    locationModifierItemPricingVersionId: 0,
                    locationModifierGroupPricingVersionId: 0,
                    locationModifierGroupModifierItemVersionId: 3837
                  }
                },
                priceCalcMode: "min",
                showSearchBar: false,
                backgroundColor: null,
                hidePriceIfFree: false,
                inheritedActive: true,
                modifierGroupId: 298,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: false,
                maximumModifierItems: 3,
                defaultSelectionPrice: 5,
                includedModifierItems: 3,
                requiredModifierItems: 0,
                searchAllModifierItems: true,
                locationModifierGroupId: 314,
                modifierGroupMenuTypeItemId: 12690,
                locationModifierGroupVersionId: 4405,
                activeCustomizerSectionSelector: true,
                showModGroupTitleOnRegisterTicket: true,
                defaultModifierGroupPricingVersionId: 319,
                locationModifierGroupMenuTypeItemVersionId: 165603
              },
              "299": {
                id: 14699,
                active: true,
                posName: "Sides",
                isAllMod: false,
                override: {
                  advancedModifier: true,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: true,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "SidesCn",
                createdAt: "2023-04-27T17:34:58.364449Z",
                deletedAt: null,
                textColor: null,
                updatedAt: "2025-01-30T16:58:11.172292Z",
                locationId: 853,
                multiselect: true,
                quantityMode: "x1,x2,x3",
                sortPriority: 1,
                enableModTags: true,
                modifierItems: {
                  "1345": {
                    id: 1345,
                    name: "Rice",
                    active: true,
                    is86ed: false,
                    kdsName: "Rice",
                    posName: "Rice",
                    override: {},
                    checkName: "Rice",
                    createdAt: "2023-04-27T17:34:58.684437Z",
                    deletedAt: null,
                    updatedAt: "2024-10-23T20:52:37.038457Z",
                    isDisabled: false,
                    isSelected: true,
                    onlineName: "Rice",
                    description: "",
                    linesBefore: 0,
                    onSidePrice: 0,
                    sortPriority: 3,
                    spacesBefore: 0,
                    modifierGroups: {},
                    modifierItemId: 1345,
                    inheritedActive: true,
                    maximumQuantity: null,
                    halfPricePercent: 50,
                    includedExtraPrice: 1,
                    includedLightPrice: 0,
                    includedMasterPrice: 0,
                    quarterPricePercent: 25,
                    additionalExtraPrice: 2.5,
                    additionalLightPrice: 1,
                    includedRegularPrice: 0,
                    additionalMasterPrice: 1,
                    defaultAmountSelected: "regular",
                    defaultModifiersPrice: 0,
                    defaultSelectionPrice: 1,
                    includedModifierItems: 1,
                    requiredModifierItems: 1,
                    additionalRegularPrice: 1.5,
                    locationModifierItemId: 1320,
                    defaultQuantitySelected: 1,
                    modifierGroupModifierItemId: 1327,
                    modifierItemPricingVersionId: 1907,
                    locationModifierItemVersionId: 487,
                    locationMgpvLocationMipvVersionId: 752,
                    defaultModifierItemPricingVersionId: 1907,
                    locationModifierGroupMenuTypeItemId: 0,
                    locationModifierGroupModifierItemId: 1349,
                    defaultModifierGroupPricingVersionId: 321,
                    locationModifierItemPricingVersionId: 0,
                    locationModifierGroupPricingVersionId: 0,
                    locationModifierGroupModifierItemVersionId: 6184
                  },
                  "1348": {
                    id: 1348,
                    name: "Sweet Potato Fries",
                    active: true,
                    is86ed: false,
                    kdsName: "Sweet Potato Fries",
                    posName: "Sweet Potato Fries",
                    override: {
                      isSelected: true,
                      defaultQuantitySelected: true
                    },
                    checkName: "Sweet Potato Fries",
                    createdAt: "2023-04-27T17:34:58.684437Z",
                    deletedAt: null,
                    updatedAt: "2024-10-17T19:53:11.400372Z",
                    isDisabled: false,
                    isSelected: true,
                    onlineName: "Sweet Potato Fries",
                    description: "",
                    linesBefore: 0,
                    onSidePrice: 0,
                    sortPriority: 6,
                    spacesBefore: 0,
                    modifierGroups: {},
                    modifierItemId: 1348,
                    inheritedActive: true,
                    maximumQuantity: null,
                    halfPricePercent: 50,
                    includedExtraPrice: 1,
                    includedLightPrice: 1.22,
                    includedMasterPrice: 1.22,
                    quarterPricePercent: 25,
                    additionalExtraPrice: 2.5,
                    additionalLightPrice: 1.5,
                    includedRegularPrice: 1.22,
                    additionalMasterPrice: 1.5,
                    defaultAmountSelected: "regular",
                    defaultModifiersPrice: 0,
                    defaultSelectionPrice: 0,
                    includedModifierItems: 1,
                    requiredModifierItems: 1,
                    additionalRegularPrice: 1.5,
                    locationModifierItemId: 1704,
                    defaultQuantitySelected: 1,
                    modifierGroupModifierItemId: 1330,
                    modifierItemPricingVersionId: 1913,
                    locationModifierItemVersionId: 964,
                    locationMgpvLocationMipvVersionId: 3312,
                    defaultModifierItemPricingVersionId: 1913,
                    locationModifierGroupMenuTypeItemId: 0,
                    locationModifierGroupModifierItemId: 3711,
                    defaultModifierGroupPricingVersionId: 321,
                    locationModifierItemPricingVersionId: 0,
                    locationModifierGroupPricingVersionId: 0,
                    locationModifierGroupModifierItemVersionId: 6132
                  },
                  "1349": {
                    id: 1349,
                    name: "Salad",
                    active: true,
                    is86ed: false,
                    kdsName: "Salad",
                    posName: "Salad",
                    override: {},
                    checkName: "Salad",
                    createdAt: "2023-09-06T21:50:06.407541Z",
                    deletedAt: null,
                    updatedAt: "2024-05-28T19:52:41.828247Z",
                    isDisabled: false,
                    isSelected: false,
                    onlineName: "Salad",
                    description: "",
                    linesBefore: 0,
                    onSidePrice: 0,
                    sortPriority: 0,
                    spacesBefore: 0,
                    modifierGroups: {
                      "302": {
                        id: 1332,
                        active: true,
                        parent: "modifierItem",
                        posName: "Dressing",
                        checkName: "Dressing",
                        createdAt: "2023-04-27T17:34:58.609105Z",
                        deletedAt: null,
                        textColor: null,
                        updatedAt: "2023-04-27T17:34:58.609105Z",
                        isSelected: false,
                        locationId: null,
                        linesBefore: 0,
                        multiselect: false,
                        quantityMode: "Off",
                        sortPriority: 1,
                        spacesBefore: 0,
                        enableModTags: true,
                        modifierItems: {
                          "1361": {
                            id: 1345,
                            name: "Cesar",
                            active: true,
                            parent: "modifierGroup",
                            kdsName: "Cesar",
                            posName: "Cesar",
                            checkName: "Cesar",
                            createdAt: "2023-04-27T17:34:58.609105Z",
                            deletedAt: null,
                            updatedAt: "2023-04-27T17:34:58.609105Z",
                            isSelected: false,
                            locationId: 853,
                            linesBefore: 0,
                            sortPriority: 1,
                            spacesBefore: 0,
                            modifierGroups: {},
                            modifierItemId: 1361,
                            inheritedActive: true,
                            maximumQuantity: 0,
                            modifierGroupId: 302,
                            includedExtraPrice: 3,
                            includedLightPrice: 0,
                            createdByLocationId: null,
                            includedMasterPrice: 0,
                            additionalExtraPrice: 3.5,
                            additionalLightPrice: 0,
                            includedRegularPrice: 0,
                            additionalMasterPrice: 0,
                            defaultAmountSelected: "regular",
                            defaultSelectionPrice: 0,
                            includedModifierItems: 1,
                            requiredModifierItems: 1,
                            additionalRegularPrice: 1.5,
                            locationModifierItemId: 1461,
                            defaultQuantitySelected: 0,
                            modifierGroupModifierItemId: 1345,
                            locationModifierItemVersionId: 644,
                            locationModifierGroupModifierItemId: 2877,
                            defaultModifierGroupPricingVersionId: 325,
                            locationModifierGroupModifierItemVersionId: 2802
                          },
                          "1362": {
                            id: 1346,
                            name: "Ranch",
                            active: true,
                            parent: "modifierGroup",
                            kdsName: "Ranch",
                            posName: "Ranch",
                            checkName: "Ranch",
                            createdAt: "2023-04-27T17:34:58.609105Z",
                            deletedAt: null,
                            updatedAt: "2023-04-27T17:34:58.609105Z",
                            isSelected: false,
                            locationId: 853,
                            linesBefore: 0,
                            sortPriority: 2,
                            spacesBefore: 0,
                            modifierGroups: {},
                            modifierItemId: 1362,
                            inheritedActive: true,
                            maximumQuantity: 0,
                            modifierGroupId: 302,
                            includedExtraPrice: 3,
                            includedLightPrice: 0,
                            createdByLocationId: null,
                            includedMasterPrice: 0,
                            additionalExtraPrice: 3.5,
                            additionalLightPrice: 1,
                            includedRegularPrice: 1,
                            additionalMasterPrice: 1,
                            defaultAmountSelected: "regular",
                            defaultSelectionPrice: 0,
                            includedModifierItems: 1,
                            requiredModifierItems: 1,
                            additionalRegularPrice: 1.5,
                            locationModifierItemId: 1490,
                            defaultQuantitySelected: 0,
                            modifierGroupModifierItemId: 1346,
                            locationModifierItemVersionId: 916,
                            locationModifierGroupModifierItemId: 2878,
                            defaultModifierGroupPricingVersionId: 325,
                            locationModifierGroupModifierItemVersionId: 2804
                          },
                          "1363": {
                            id: 1347,
                            name: "Italian",
                            active: true,
                            parent: "modifierGroup",
                            kdsName: "Italian",
                            posName: "Italian",
                            checkName: "Italian",
                            createdAt: "2023-04-27T17:34:58.609105Z",
                            deletedAt: null,
                            updatedAt: "2023-04-27T17:34:58.609105Z",
                            isSelected: false,
                            locationId: 853,
                            linesBefore: 0,
                            sortPriority: 3,
                            spacesBefore: 0,
                            modifierGroups: {},
                            modifierItemId: 1363,
                            inheritedActive: true,
                            maximumQuantity: 0,
                            modifierGroupId: 302,
                            includedExtraPrice: 3,
                            includedLightPrice: 0,
                            createdByLocationId: null,
                            includedMasterPrice: 0,
                            additionalExtraPrice: 3.5,
                            additionalLightPrice: 1,
                            includedRegularPrice: 1,
                            additionalMasterPrice: 1,
                            defaultAmountSelected: "regular",
                            defaultSelectionPrice: 0,
                            includedModifierItems: 1,
                            requiredModifierItems: 1,
                            additionalRegularPrice: 1.5,
                            locationModifierItemId: 1413,
                            defaultQuantitySelected: 0,
                            modifierGroupModifierItemId: 1347,
                            locationModifierItemVersionId: 1497,
                            locationModifierGroupModifierItemId: 2879,
                            defaultModifierGroupPricingVersionId: 325,
                            locationModifierGroupModifierItemVersionId: 2806
                          }
                        },
                        priceCalcMode: "max",
                        showSearchBar: false,
                        modifierItemId: 1349,
                        backgroundColor: null,
                        hidePriceIfFree: true,
                        inheritedActive: true,
                        maximumQuantity: 0,
                        modifierGroupId: 302,
                        customizerSlicing: "quarters",
                        enableQuantityBar: false,
                        allowNoneSelection: false,
                        createdByLocationId: null,
                        maximumModifierItems: 0,
                        defaultAmountSelected: "regular",
                        defaultSelectionPrice: 0,
                        includedModifierItems: 1,
                        requiredModifierItems: 1,
                        searchAllModifierItems: false,
                        defaultQuantitySelected: 0,
                        locationModifierGroupId: 1477,
                        modifierGroupModifierItemId: 1332,
                        locationModifierGroupVersionId: 3636,
                        activeCustomizerSectionSelector: false,
                        showModGroupTitleOnRegisterTicket: true,
                        locationModifierGroupModifierItemId: 1327,
                        defaultModifierGroupPricingVersionId: 325,
                        locationModifierGroupModifierItemVersionId: 518
                      },
                      "303": {
                        id: 1333,
                        active: true,
                        parent: "modifierItem",
                        posName: "Protein",
                        checkName: "Protein",
                        createdAt: "2023-04-27T17:34:58.609105Z",
                        deletedAt: null,
                        textColor: null,
                        updatedAt: "2023-04-27T17:34:58.609105Z",
                        isSelected: false,
                        locationId: null,
                        linesBefore: 0,
                        multiselect: true,
                        quantityMode: "x1,x2,x3",
                        sortPriority: 2,
                        spacesBefore: 0,
                        enableModTags: true,
                        modifierItems: {
                          "1364": {
                            id: 1348,
                            name: "Turkey",
                            active: true,
                            parent: "modifierGroup",
                            kdsName: "Turkey",
                            posName: "Turkey",
                            checkName: "Turkey",
                            createdAt: "2023-04-27T17:34:58.609105Z",
                            deletedAt: null,
                            updatedAt: "2023-04-27T17:34:58.609105Z",
                            isSelected: false,
                            locationId: null,
                            linesBefore: 0,
                            sortPriority: 1,
                            spacesBefore: 0,
                            modifierGroups: {},
                            modifierItemId: 1364,
                            inheritedActive: true,
                            maximumQuantity: 0,
                            modifierGroupId: 303,
                            includedExtraPrice: 4.1,
                            includedLightPrice: 0,
                            createdByLocationId: null,
                            includedMasterPrice: 2.55,
                            additionalExtraPrice: 5,
                            additionalLightPrice: 1,
                            includedRegularPrice: 2.6,
                            additionalMasterPrice: 3.99,
                            defaultAmountSelected: "regular",
                            defaultSelectionPrice: 0,
                            includedModifierItems: 1,
                            requiredModifierItems: 1,
                            additionalRegularPrice: 3,
                            locationModifierItemId: 1462,
                            defaultQuantitySelected: 0,
                            modifierGroupModifierItemId: 1348,
                            locationModifierItemVersionId: 645,
                            locationModifierGroupModifierItemId: 1343,
                            defaultModifierGroupPricingVersionId: 326,
                            locationModifierGroupModifierItemVersionId: 534
                          },
                          "1365": {
                            id: 1349,
                            name: "Chicken",
                            active: true,
                            parent: "modifierGroup",
                            kdsName: "Chicken",
                            posName: "Chicken",
                            checkName: "Chicken",
                            createdAt: "2023-04-27T17:34:58.609105Z",
                            deletedAt: null,
                            updatedAt: "2023-04-27T17:34:58.609105Z",
                            isSelected: true,
                            locationId: 853,
                            linesBefore: 0,
                            sortPriority: 2,
                            spacesBefore: 0,
                            modifierGroups: {},
                            modifierItemId: 1365,
                            inheritedActive: true,
                            maximumQuantity: 0,
                            modifierGroupId: 303,
                            includedExtraPrice: 4.1,
                            includedLightPrice: 0,
                            createdByLocationId: null,
                            includedMasterPrice: 2.55,
                            additionalExtraPrice: 5,
                            additionalLightPrice: 1,
                            includedRegularPrice: 2.6,
                            additionalMasterPrice: 3.99,
                            defaultAmountSelected: "regular",
                            defaultSelectionPrice: 6.54,
                            includedModifierItems: 1,
                            requiredModifierItems: 1,
                            additionalRegularPrice: 3,
                            locationModifierItemId: 1340,
                            defaultQuantitySelected: 2,
                            modifierGroupModifierItemId: 1349,
                            locationModifierItemVersionId: 507,
                            locationModifierGroupModifierItemId: 4478,
                            defaultModifierGroupPricingVersionId: 326,
                            locationModifierGroupModifierItemVersionId: 6090
                          }
                        },
                        priceCalcMode: "",
                        showSearchBar: false,
                        modifierItemId: 1349,
                        backgroundColor: null,
                        hidePriceIfFree: true,
                        inheritedActive: true,
                        maximumQuantity: 0,
                        modifierGroupId: 303,
                        customizerSlicing: "quarters",
                        enableQuantityBar: false,
                        allowNoneSelection: true,
                        createdByLocationId: null,
                        maximumModifierItems: 3,
                        defaultAmountSelected: "regular",
                        defaultSelectionPrice: 0,
                        includedModifierItems: 1,
                        requiredModifierItems: 1,
                        searchAllModifierItems: false,
                        defaultQuantitySelected: 0,
                        locationModifierGroupId: 351,
                        modifierGroupModifierItemId: 1333,
                        locationModifierGroupVersionId: 4048,
                        activeCustomizerSectionSelector: false,
                        showModGroupTitleOnRegisterTicket: true,
                        locationModifierGroupModifierItemId: 1328,
                        defaultModifierGroupPricingVersionId: 326,
                        locationModifierGroupModifierItemVersionId: 519
                      }
                    },
                    modifierItemId: 1349,
                    inheritedActive: true,
                    maximumQuantity: null,
                    halfPricePercent: 50,
                    includedExtraPrice: 1,
                    includedLightPrice: 0,
                    includedMasterPrice: 0,
                    quarterPricePercent: 25,
                    additionalExtraPrice: 2.5,
                    additionalLightPrice: 1,
                    includedRegularPrice: 0,
                    additionalMasterPrice: 1,
                    defaultAmountSelected: "",
                    defaultModifiersPrice: 0,
                    defaultSelectionPrice: 0,
                    includedModifierItems: 0,
                    requiredModifierItems: 0,
                    additionalRegularPrice: 1.5,
                    locationModifierItemId: 1341,
                    defaultQuantitySelected: 0,
                    modifierGroupModifierItemId: 1588,
                    modifierItemPricingVersionId: 1915,
                    locationModifierItemVersionId: 702,
                    locationMgpvLocationMipvVersionId: 3144,
                    defaultModifierItemPricingVersionId: 1915,
                    locationModifierGroupMenuTypeItemId: 0,
                    locationModifierGroupModifierItemId: 2397,
                    defaultModifierGroupPricingVersionId: 321,
                    locationModifierItemPricingVersionId: 0,
                    locationModifierGroupPricingVersionId: 0,
                    locationModifierGroupModifierItemVersionId: 3722
                  }
                },
                priceCalcMode: "max",
                showSearchBar: false,
                backgroundColor: null,
                hidePriceIfFree: true,
                inheritedActive: true,
                modifierGroupId: 299,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: true,
                maximumModifierItems: 5,
                defaultSelectionPrice: 2.2199999999999998,
                includedModifierItems: 1,
                requiredModifierItems: 3,
                searchAllModifierItems: false,
                locationModifierGroupId: 313,
                modifierGroupMenuTypeItemId: 12685,
                locationModifierGroupVersionId: 4073,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: true,
                defaultModifierGroupPricingVersionId: 321,
                locationModifierGroupMenuTypeItemVersionId: 165604
              },
              "301": {
                id: 45035,
                active: true,
                posName: "Cook Temp",
                isAllMod: false,
                override: {
                  advancedModifier: true,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "Cook Temp",
                createdAt: "2023-11-14T22:54:01.397986Z",
                deletedAt: null,
                textColor: null,
                updatedAt: "2025-01-30T16:58:11.174887Z",
                locationId: 853,
                multiselect: false,
                quantityMode: "Off",
                sortPriority: 2,
                enableModTags: false,
                modifierItems: {
                  "1359": {
                    id: 1359,
                    name: "Medium Well",
                    active: true,
                    is86ed: false,
                    kdsName: "Medium Well",
                    posName: "Medium Well",
                    override: {},
                    checkName: "Medium Well",
                    createdAt: "2023-04-27T17:34:58.684437Z",
                    deletedAt: null,
                    updatedAt: "2023-05-17T18:40:49.39148Z",
                    isDisabled: false,
                    isSelected: false,
                    onlineName: "Medium Well",
                    description: "",
                    linesBefore: 0,
                    onSidePrice: 0,
                    sortPriority: 5,
                    spacesBefore: 0,
                    modifierGroups: {},
                    modifierItemId: 1359,
                    inheritedActive: true,
                    maximumQuantity: null,
                    halfPricePercent: 0,
                    includedExtraPrice: 0,
                    includedLightPrice: 0,
                    includedMasterPrice: 0,
                    quarterPricePercent: 0,
                    additionalExtraPrice: 0,
                    additionalLightPrice: 0,
                    includedRegularPrice: 0,
                    additionalMasterPrice: 0,
                    defaultAmountSelected: "regular",
                    defaultModifiersPrice: 0,
                    defaultSelectionPrice: 0,
                    includedModifierItems: 1,
                    requiredModifierItems: 1,
                    additionalRegularPrice: 0,
                    locationModifierItemId: 1334,
                    defaultQuantitySelected: 0,
                    modifierGroupModifierItemId: 1343,
                    modifierItemPricingVersionId: 1926,
                    locationModifierItemVersionId: 501,
                    locationMgpvLocationMipvVersionId: 773,
                    defaultModifierItemPricingVersionId: 1926,
                    locationModifierGroupMenuTypeItemId: 0,
                    locationModifierGroupModifierItemId: 1365,
                    defaultModifierGroupPricingVersionId: 324,
                    locationModifierItemPricingVersionId: 0,
                    locationModifierGroupPricingVersionId: 0,
                    locationModifierGroupModifierItemVersionId: 567
                  }
                },
                priceCalcMode: "max",
                showSearchBar: false,
                backgroundColor: null,
                hidePriceIfFree: true,
                inheritedActive: true,
                modifierGroupId: 301,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: false,
                maximumModifierItems: 1,
                defaultSelectionPrice: 0,
                includedModifierItems: 1,
                requiredModifierItems: 1,
                searchAllModifierItems: false,
                locationModifierGroupId: 320,
                modifierGroupMenuTypeItemId: 13711,
                locationModifierGroupVersionId: 4215,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: true,
                defaultModifierGroupPricingVersionId: 324,
                locationModifierGroupMenuTypeItemVersionId: 165605
              },
              "304": {
                id: 14674,
                active: true,
                posName: "Burger Global",
                isAllMod: false,
                override: {
                  advancedModifier: true,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "Burger Global",
                createdAt: "2023-05-04T19:09:48.112358Z",
                deletedAt: null,
                textColor: null,
                updatedAt: "2025-01-30T16:58:11.177463Z",
                locationId: 853,
                multiselect: true,
                quantityMode: "x1,x2,x3",
                sortPriority: 4,
                enableModTags: true,
                modifierItems: {},
                priceCalcMode: "max",
                showSearchBar: true,
                backgroundColor: null,
                hidePriceIfFree: true,
                inheritedActive: true,
                modifierGroupId: 304,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: false,
                maximumModifierItems: 0,
                defaultSelectionPrice: 0,
                includedModifierItems: 0,
                requiredModifierItems: 0,
                searchAllModifierItems: true,
                locationModifierGroupId: 904,
                modifierGroupMenuTypeItemId: 12945,
                locationModifierGroupVersionId: 2534,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: true,
                defaultModifierGroupPricingVersionId: 328,
                locationModifierGroupMenuTypeItemVersionId: 165606
              },
              "312": {
                id: 51609,
                active: true,
                posName: "Bread",
                isAllMod: false,
                override: {
                  advancedModifier: true,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "Bread",
                createdAt: "2024-09-13T22:29:37.598763Z",
                deletedAt: null,
                textColor: null,
                updatedAt: "2025-01-30T16:58:11.179958Z",
                locationId: 853,
                multiselect: false,
                quantityMode: "Off",
                sortPriority: 1,
                enableModTags: true,
                modifierItems: {},
                priceCalcMode: "max",
                showSearchBar: false,
                backgroundColor: null,
                hidePriceIfFree: true,
                inheritedActive: true,
                modifierGroupId: 312,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: false,
                maximumModifierItems: 1,
                defaultSelectionPrice: 0,
                includedModifierItems: 0,
                requiredModifierItems: 0,
                searchAllModifierItems: false,
                locationModifierGroupId: 901,
                modifierGroupMenuTypeItemId: 17285,
                locationModifierGroupVersionId: 4217,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: true,
                defaultModifierGroupPricingVersionId: 337,
                locationModifierGroupMenuTypeItemVersionId: 165607
              }
            },
            prepStationIds: [],
            trackInventory: true,
            allModsBehavior: "all",
            backgroundColor: null,
            customizerShape: "",
            resetStockDaily: false,
            showIngredients: true,
            enterItemDetails: false,
            homeSortPriority: null,
            homeSpacesBefore: 0,
            showModItemPrice: false,
            showOnFreshSheet: false,
            onlineDescription: "Two beef patties, six slices of bacon, house BBQ, cheddar, red onion, pickles.",
            secondaryImageUrl: "",
            showLinkingOptions: false,
            suggestiveOrdering: false,
            linkedModifierItems: {
              "1970": {
                modifierItemId: 1970
              }
            },
            displayPictureOnCard: false,
            excludeFromDiscounts: false,
            universalProductCode: "",
            defaultModifiersPrice: 7.22,
            transparentBackground: false,
            freshSheetSortPriority: 0,
            locationMenuTypeItemId: 18772,
            showQuantityOnItemCard: true,
            categoriesSubcategories: {
              "529": {
                categoryId: 526,
                subcategoryId: null
              },
              "23997": {
                categoryId: 525,
                subcategoryId: 302
              }
            },
            excludeFromSuggestedTip: false,
            suggestiveOrderingItemId: 0,
            suggestiveOrderingPrompt: "This is the prompt",
            actionWhenCurrentStockZero: "86",
            displayItemPriceOnRegister: true,
            showAllModsHalfSizeButtons: true,
            suggestiveOrderingItemPrice: null,
            locationMenuTypeItemVersionId: 846395,
            showAllModsAlphabetizeButtons: true,
            showPrepStationSelectionModal: false,
            exitItemDetailsOnRequiredModCompletion: false
          }
        },
        reportingGroupIds: [32],
        createdByLocationId: null,
        linkedModifierItems: {
          "1970": {
            modifierItemId: 1970
          }
        }
      },
      orderId: 15175,
      seating: {
        "-2": 1
      },
      courseId: null,
      isOnHold: false,
      isShared: null,
      isVoided: false,
      quantity: 1,
      specials: {},
      totalTax: 3.45,
      discounts: {},
      isTakeout: true,
      timeAdded: "2025-02-05T21:01:22.893Z",
      versionId: 1,
      isComplete: true,
      isOpenItem: false,
      menuTypeId: 278,
      taxDetails: {
        "33": {
          taxId: 33,
          percentage: 10,
          totalAmount: 3.2
        },
        "34": {
          taxId: 34,
          percentage: 0,
          totalAmount: 0
        },
        "35": {
          taxId: 35,
          percentage: 0,
          totalAmount: 0.25
        }
      },
      createdById: 2082,
      instanceIds: ["cb1a8d7e-0ac7-40c4-a8ee-4cfc7bbdfa17"],
      instructions: "",
      menuTypeInfo: {
        id: 278,
        name: "Breakfast",
        posName: "Breakfast",
        disableCoursing: false
      },
      prepStations: [],
      baseItemPrice: 17.19,
      timeTriggered: "0001-01-01T00:00:00Z",
      comboElementId: null,
      configWhenSent: null,
      customizerType: "none",
      openItemTypeId: null,
      voidedReasonId: null,
      isInClosedCheck: false,
      isPriceOverride: false,
      lastUpdatedById: 2082,
      ticketElementId: 69033,
      comboItemGroupId: null,
      noPrinterLocation: false,
      printErrorMessage: {},
      tabletGeneratedId: "544c66b8-6ec4-4a10-b264-c5a2f1a5536b",
      timeSentToKitchen: "0001-01-01T00:00:00Z",
      ingredientsSelected: {
        "4": {
          name: "Beef",
          posName: "Beef",
          isVoided: false,
          isSelected: true,
          modifierTag: [],
          ingredientId: 4,
          selectedAmount: "regular",
          modifierSizeTag: null,
          isModifiedAfterSent: false
        }
      },
      isModifiedAfterSent: false,
      prepStationOverride: null,
      totalDiscountAmount: 0,
      totalSpecialsAmount: 0,
      onTheFlyCourseNumber: null,
      prepStationOverrideId: null,
      totalPricePerItemUnit: 31.95,
      comboItemGroupInstance: null,
      locationMenuTypeItemId: 18772,
      modifierGroupsSelected: {
        "0": {
          global: false,
          isComplete: true,
          quantityMode: "x1,x2,x3",
          showSearchBar: true,
          isNoneSelected: false,
          modifierGroupId: 0,
          quantityRequired: 0,
          customizerEnabled: false,
          modifierItemsSelected: {},
          totalPricePerItemUnit: 0,
          locationModifierGroupId: 0,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 0,
          taxInclusiveTotalPricePerItemUnit: 0
        },
        "298": {
          global: false,
          isComplete: true,
          quantityMode: "Lt,Reg,Ext",
          showSearchBar: false,
          isNoneSelected: false,
          modifierGroupId: 298,
          quantityRequired: 0,
          customizerEnabled: true,
          modifierItemsSelected: {
            "1337": {
              isVoided: false,
              isComplete: true,
              modifierTag: [],
              onSidePrice: 0,
              sortPriority: 0,
              amountSelected: "regular",
              isOverrideType: false,
              modifierItemId: 1337,
              modifierSizeTag: null,
              quantitySelected: 1,
              isDefaultModifier: true,
              isModifiedAfterSent: false,
              modifierItemInstances: {
                "1": {
                  price: 5,
                  isVoided: false,
                  isComplete: true,
                  pricingMode: "included",
                  amountSelected: "regular",
                  quantitySelected: 1,
                  customizerSectors: {
                    topLeft: true,
                    topRight: true,
                    bottomLeft: true,
                    bottomRight: true
                  },
                  taxInclusivePrice: 0,
                  isModifiedAfterSent: false,
                  modifierItemInstanceId: 1,
                  nestedModifierGroupsSelected: {}
                }
              },
              totalPricePerItemUnit: 5,
              locationModifierItemId: 1495,
              locationModifierItemVersionId: 1959,
              taxInclusiveTotalPricePerItemUnit: 0
            }
          },
          totalPricePerItemUnit: 5,
          locationModifierGroupId: 314,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 4405,
          taxInclusiveTotalPricePerItemUnit: 0
        },
        "299": {
          global: false,
          isComplete: true,
          quantityMode: "x1,x2,x3",
          showSearchBar: false,
          isNoneSelected: false,
          modifierGroupId: 299,
          quantityRequired: 3,
          customizerEnabled: false,
          modifierItemsSelected: {
            "1345": {
              isVoided: false,
              isComplete: true,
              modifierTag: [],
              onSidePrice: 0,
              sortPriority: 0,
              amountSelected: "regular",
              isOverrideType: false,
              modifierItemId: 1345,
              modifierSizeTag: null,
              quantitySelected: 1,
              isDefaultModifier: true,
              isModifiedAfterSent: false,
              modifierItemInstances: {
                "1": {
                  price: 1,
                  isVoided: false,
                  isComplete: true,
                  pricingMode: "additional",
                  amountSelected: "regular",
                  quantitySelected: 1,
                  customizerSectors: {
                    topLeft: true,
                    topRight: true,
                    bottomLeft: true,
                    bottomRight: true
                  },
                  taxInclusivePrice: 0,
                  isModifiedAfterSent: false,
                  modifierItemInstanceId: 1,
                  nestedModifierGroupsSelected: {}
                }
              },
              totalPricePerItemUnit: 1,
              locationModifierItemId: 1320,
              locationModifierItemVersionId: 487,
              taxInclusiveTotalPricePerItemUnit: 0
            },
            "1348": {
              isVoided: false,
              isComplete: true,
              modifierTag: [],
              onSidePrice: 0,
              sortPriority: 0,
              amountSelected: "regular",
              isOverrideType: false,
              modifierItemId: 1348,
              modifierSizeTag: null,
              quantitySelected: 1,
              isDefaultModifier: true,
              isModifiedAfterSent: false,
              modifierItemInstances: {
                "1": {
                  price: 1.22,
                  isVoided: false,
                  isComplete: true,
                  pricingMode: "included",
                  amountSelected: "regular",
                  quantitySelected: 1,
                  customizerSectors: {
                    topLeft: true,
                    topRight: true,
                    bottomLeft: true,
                    bottomRight: true
                  },
                  taxInclusivePrice: 0,
                  isModifiedAfterSent: false,
                  modifierItemInstanceId: 1,
                  nestedModifierGroupsSelected: {}
                }
              },
              totalPricePerItemUnit: 1.22,
              locationModifierItemId: 1704,
              locationModifierItemVersionId: 964,
              taxInclusiveTotalPricePerItemUnit: 0
            },
            "1349": {
              isVoided: false,
              isComplete: true,
              modifierTag: [],
              onSidePrice: 0,
              sortPriority: 1,
              amountSelected: "regular",
              isOverrideType: false,
              modifierItemId: 1349,
              modifierSizeTag: null,
              quantitySelected: 1,
              isDefaultModifier: false,
              isModifiedAfterSent: false,
              modifierItemInstances: {
                "1": {
                  price: 1,
                  isVoided: false,
                  isComplete: true,
                  pricingMode: "additional",
                  amountSelected: "regular",
                  quantitySelected: 1,
                  customizerSectors: {
                    topLeft: true,
                    topRight: true,
                    bottomLeft: true,
                    bottomRight: true
                  },
                  taxInclusivePrice: 0,
                  isModifiedAfterSent: false,
                  modifierItemInstanceId: 1,
                  nestedModifierGroupsSelected: {
                    "302": {
                      isComplete: true,
                      quantityMode: "Off",
                      showSearchBar: false,
                      isNoneSelected: false,
                      modifierGroupId: 302,
                      quantityRequired: 1,
                      customizerEnabled: false,
                      modifierItemsSelected: {
                        "1361": {
                          isVoided: false,
                          isComplete: true,
                          modifierTag: [],
                          onSidePrice: 0,
                          sortPriority: 0,
                          amountSelected: "regular",
                          isOverrideType: false,
                          modifierItemId: 1361,
                          modifierSizeTag: null,
                          quantitySelected: 1,
                          isDefaultModifier: false,
                          isModifiedAfterSent: false,
                          modifierItemInstances: {
                            "1": {
                              price: 0,
                              isVoided: false,
                              isComplete: true,
                              pricingMode: "included",
                              amountSelected: "regular",
                              quantitySelected: 1,
                              customizerSectors: {
                                topLeft: true,
                                topRight: true,
                                bottomLeft: true,
                                bottomRight: true
                              },
                              taxInclusivePrice: 0,
                              isModifiedAfterSent: false,
                              modifierItemInstanceId: 0,
                              nestedModifierGroupsSelected: {}
                            }
                          },
                          totalPricePerItemUnit: 0,
                          locationModifierItemId: 0,
                          locationModifierItemVersionId: 0,
                          taxInclusiveTotalPricePerItemUnit: 0
                        }
                      },
                      totalPricePerItemUnit: 0,
                      locationModifierGroupId: 1477,
                      modifierItemsWithNested: [],
                      locationModifierGroupVersionId: 3636,
                      taxInclusiveTotalPricePerItemUnit: 0
                    },
                    "303": {
                      isComplete: true,
                      quantityMode: "x1,x2,x3",
                      showSearchBar: false,
                      isNoneSelected: false,
                      modifierGroupId: 303,
                      quantityRequired: 1,
                      customizerEnabled: false,
                      modifierItemsSelected: {
                        "1365": {
                          isVoided: false,
                          isComplete: true,
                          modifierTag: [],
                          onSidePrice: 0,
                          sortPriority: 0,
                          amountSelected: "regular",
                          isOverrideType: false,
                          modifierItemId: 1365,
                          modifierSizeTag: null,
                          quantitySelected: 2,
                          isDefaultModifier: false,
                          isModifiedAfterSent: false,
                          modifierItemInstances: {
                            "1": {
                              price: 2.55,
                              isVoided: false,
                              isComplete: true,
                              pricingMode: "included",
                              amountSelected: "regular",
                              quantitySelected: 2,
                              customizerSectors: {
                                topLeft: true,
                                topRight: true,
                                bottomLeft: true,
                                bottomRight: true
                              },
                              taxInclusivePrice: 0,
                              isModifiedAfterSent: false,
                              modifierItemInstanceId: 1,
                              nestedModifierGroupsSelected: {}
                            },
                            "2": {
                              price: 3.99,
                              isVoided: false,
                              isComplete: true,
                              pricingMode: "included",
                              amountSelected: "regular",
                              quantitySelected: 2,
                              customizerSectors: {
                                topLeft: true,
                                topRight: true,
                                bottomLeft: true,
                                bottomRight: true
                              },
                              taxInclusivePrice: 0,
                              isModifiedAfterSent: false,
                              modifierItemInstanceId: 2,
                              nestedModifierGroupsSelected: {}
                            }
                          },
                          totalPricePerItemUnit: 6.54,
                          locationModifierItemId: 1340,
                          locationModifierItemVersionId: 507,
                          taxInclusiveTotalPricePerItemUnit: 0
                        }
                      },
                      totalPricePerItemUnit: 6.54,
                      locationModifierGroupId: 351,
                      modifierItemsWithNested: [],
                      locationModifierGroupVersionId: 4048,
                      taxInclusiveTotalPricePerItemUnit: 0
                    }
                  }
                }
              },
              totalPricePerItemUnit: 7.54,
              locationModifierItemId: 1341,
              locationModifierItemVersionId: 702,
              taxInclusiveTotalPricePerItemUnit: 0
            }
          },
          totalPricePerItemUnit: 9.76,
          locationModifierGroupId: 313,
          modifierItemsWithNested: [1349],
          locationModifierGroupVersionId: 4073,
          taxInclusiveTotalPricePerItemUnit: 0
        },
        "301": {
          global: false,
          isComplete: true,
          quantityMode: "Off",
          showSearchBar: false,
          isNoneSelected: false,
          modifierGroupId: 301,
          quantityRequired: 1,
          customizerEnabled: false,
          modifierItemsSelected: {
            "1359": {
              isVoided: false,
              isComplete: true,
              modifierTag: [],
              onSidePrice: 0,
              sortPriority: 1,
              amountSelected: "regular",
              isOverrideType: false,
              modifierItemId: 1359,
              modifierSizeTag: null,
              quantitySelected: 1,
              isDefaultModifier: false,
              isModifiedAfterSent: false,
              modifierItemInstances: {
                "1": {
                  price: 0,
                  isVoided: false,
                  isComplete: true,
                  pricingMode: "included",
                  amountSelected: "regular",
                  quantitySelected: 1,
                  customizerSectors: {
                    topLeft: true,
                    topRight: true,
                    bottomLeft: true,
                    bottomRight: true
                  },
                  taxInclusivePrice: 0,
                  isModifiedAfterSent: false,
                  modifierItemInstanceId: 1,
                  nestedModifierGroupsSelected: {}
                }
              },
              totalPricePerItemUnit: 0,
              locationModifierItemId: 1334,
              locationModifierItemVersionId: 501,
              taxInclusiveTotalPricePerItemUnit: 0
            }
          },
          totalPricePerItemUnit: 0,
          locationModifierGroupId: 320,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 4215,
          taxInclusiveTotalPricePerItemUnit: 0
        },
        "304": {
          global: false,
          isComplete: true,
          quantityMode: "x1,x2,x3",
          showSearchBar: true,
          isNoneSelected: false,
          modifierGroupId: 304,
          quantityRequired: 0,
          customizerEnabled: false,
          modifierItemsSelected: {},
          totalPricePerItemUnit: 0,
          locationModifierGroupId: 904,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 2534,
          taxInclusiveTotalPricePerItemUnit: 0
        },
        "312": {
          global: false,
          isComplete: true,
          quantityMode: "Off",
          showSearchBar: false,
          isNoneSelected: false,
          modifierGroupId: 312,
          quantityRequired: 0,
          customizerEnabled: false,
          modifierItemsSelected: {},
          totalPricePerItemUnit: 0,
          locationModifierGroupId: 901,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 4217,
          taxInclusiveTotalPricePerItemUnit: 0
        }
      },
      totalSpecialsBOGOAmount: 0,
      overridePricePerItemUnit: 0,
      sentToPrepStationHistory: [],
      isModifiersSelectionComplete: true,
      isTriggeringManuallyDisabled: false,
      locationMenuTypeItemVersionId: 846395,
      ticketElementToCheckElementsId: "544c66b8-6ec4-4a10-b264-c5a2f1a5536b",
      isCurrentMenuTypeCourseDisabled: false,
      selectedModifiersPricePerItemUnit: 14.76,
      totalPriceWithDiscountsSpecialsNotTaxes: 31.95,
      taxInclusiveSelectedModifiersPricePerItemUnit: 0
    },
    "69034": {
      id: 69034,
      itemId: 2271,
      itemObj: {
        id: 2271,
        name: "Sprite",
        itemId: 2271,
        customId: "sprite-idjk",
        createdAt: "2023-04-27T17:34:55.159707Z",
        deletedAt: null,
        updatedAt: "2024-11-08T14:58:13.368693Z",
        locationIds: null,
        taxesSource: {
          "33": {
            id: 33,
            name: "FL 10% Tax",
            taxType: "percent",
            typeData: {
              rate: 10,
              unit: null,
              interval: null
            },
            orderTypes: "catering,delivery,dine in,to_go",
            tableTypeData: null,
            organizationId: 574
          },
          "34": {
            id: 34,
            name: "Alc",
            taxType: "volume",
            typeData: {
              rate: 0.06,
              unit: "ml",
              interval: 10
            },
            orderTypes: "catering,dine in,delivery,to_go",
            tableTypeData: null,
            organizationId: 574
          },
          "35": {
            id: 35,
            name: "Dining",
            taxType: "fixed",
            typeData: {
              rate: 0.25,
              unit: null,
              interval: null
            },
            orderTypes: "catering,dine in,delivery,to_go",
            tableTypeData: null,
            organizationId: 574
          },
          "56": {
            id: 56,
            name: "Alcohol Tax Test Mod",
            taxType: "volume",
            typeData: {
              rate: 0.5,
              unit: "ml",
              interval: 10
            },
            orderTypes: "catering,dine in,delivery,to_go",
            tableTypeData: null,
            organizationId: 574
          }
        },
        menuTypeItemId: 6107,
        organizationId: 574,
        menuTypeVersions: {
          "278": {
            id: 18582,
            unit: "ml",
            active: true,
            combos: {
              "38": {
                name: "Test",
                comboId: 38,
                posName: "Testr",
                comboBasePrice: 3213.32
              }
            },
            is86ed: false,
            recipe: "This is a top secret formula",
            taxIds: [33],
            volume: 0,
            kdsName: "Sprite 2",
            posName: "Sprite",
            calories: 120,
            courseId: 66,
            delivery: false,
            imageUrl: "https://images.heb.com/is/image/HEBGrocery/001397083",
            kdsColor: null,
            prepTime: 0,
            specials: {
              "58": {
                name: "newtst",
                active: true,
                posName: "newtst",
                specialId: 58,
                availableTimes: {
                  friday: [
                    {
                      id: 603,
                      day: "friday",
                      endTime: "2024-08-22T16:00:00Z",
                      createdAt: "2024-08-22T15:49:52.097657Z",
                      deletedAt: null,
                      startTime: "2024-08-22T12:00:00Z",
                      updatedAt: "2024-08-22T15:49:52.097657Z",
                      locationMenuTypeSpecialId: 178
                    }
                  ],
                  monday: [
                    {
                      id: 597,
                      day: "monday",
                      endTime: "2024-08-22T19:00:00Z",
                      createdAt: "2024-08-22T15:10:42.90859Z",
                      deletedAt: null,
                      startTime: "2024-08-22T12:00:00Z",
                      updatedAt: "2024-08-22T15:49:52.091353Z",
                      locationMenuTypeSpecialId: 178
                    }
                  ],
                  sunday: [
                    {
                      id: 599,
                      day: "sunday",
                      endTime: "2024-08-22T16:00:00Z",
                      createdAt: "2024-08-22T15:49:52.094611Z",
                      deletedAt: null,
                      startTime: "2024-08-22T12:00:00Z",
                      updatedAt: "2024-08-22T15:49:52.094611Z",
                      locationMenuTypeSpecialId: 178
                    }
                  ],
                  tuesday: [
                    {
                      id: 600,
                      day: "tuesday",
                      endTime: "2025-01-15T04:45:00Z",
                      createdAt: "2024-08-22T15:49:52.095403Z",
                      deletedAt: null,
                      startTime: "2025-01-14T05:00:00Z",
                      updatedAt: "2025-01-14T22:19:28.507669Z",
                      locationMenuTypeSpecialId: 178
                    }
                  ],
                  saturday: [
                    {
                      id: 598,
                      day: "saturday",
                      endTime: "2024-08-22T19:00:00Z",
                      createdAt: "2024-08-22T15:49:52.092955Z",
                      deletedAt: null,
                      startTime: "2024-08-22T12:00:00Z",
                      updatedAt: "2024-08-22T15:49:52.092955Z",
                      locationMenuTypeSpecialId: 178
                    }
                  ],
                  thursday: [
                    {
                      id: 602,
                      day: "thursday",
                      endTime: "2024-08-22T16:00:00Z",
                      createdAt: "2024-08-22T15:49:52.096895Z",
                      deletedAt: null,
                      startTime: "2024-08-22T12:00:00Z",
                      updatedAt: "2024-08-22T15:49:52.096895Z",
                      locationMenuTypeSpecialId: 178
                    }
                  ],
                  wednesday: [
                    {
                      id: 601,
                      day: "wednesday",
                      endTime: "2024-08-22T16:00:00Z",
                      createdAt: "2024-08-22T15:49:52.096153Z",
                      deletedAt: null,
                      startTime: "2024-08-22T12:00:00Z",
                      updatedAt: "2024-08-22T15:49:52.096153Z",
                      locationMenuTypeSpecialId: 178
                    }
                  ]
                }
              }
            },
            allModIds: [536],
            checkName: "Sprite",
            createdAt: "2023-04-27T17:34:55.471282Z",
            deletedAt: null,
            itemPrice: 1.05,
            textColor: "#",
            toGoPrice: 2,
            updatedAt: "2025-02-05T14:57:27.058043Z",
            customizer: false,
            locationId: 853,
            menuTypeId: 278,
            onlineName: "Sprite Online 3",
            description: "Soft drink",
            ingredients: {},
            onlinePrice: 1.05,
            showAllMods: true,
            activeOnline: true,
            ageThreshold: 21,
            allowSharing: true,
            hideItemName: true,
            reset86Daily: false,
            sortPriority: 2,
            spacesBefore: 0,
            specialTagId: 4,
            taxInclusive: true,
            ageRestricted: false,
            currentAmount: 10,
            defaultNoSeat: false,
            deliveryPrice: 1,
            initialAmount: 10,
            showModifiers: true,
            doneIsForTable: true,
            inheritedTaxes: {
              categoryInheritedTaxes: {
                "34": {
                  id: 34,
                  isActive: true
                }
              },
              menuTypeInheritedTaxes: {
                "33": {
                  id: 33,
                  isActive: true
                },
                "34": {
                  id: 34,
                  isActive: true
                },
                "35": {
                  id: 35,
                  isActive: true
                }
              },
              subcategoryInheritedTaxes: {
                "56": {
                  id: 56,
                  isActive: true
                }
              }
            },
            menuTypeItemId: 6106,
            modifierGroups: {
              "0": {
                id: 0,
                active: true,
                global: true,
                kdsName: "Custom",
                posName: "Custom",
                isAllMod: false,
                override: {
                  active: false,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "Custom",
                createdAt: null,
                deletedAt: null,
                textColor: null,
                updatedAt: null,
                locationId: 0,
                multiselect: true,
                quantityMode: "x1,x2,x3",
                sortPriority: null,
                enableModTags: false,
                modifierItems: {},
                priceCalcMode: "max",
                showSearchBar: true,
                backgroundColor: null,
                hidePriceIfFree: false,
                inheritedActive: true,
                isPremadeHeader: false,
                modifierGroupId: 0,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: false,
                maximumModifierItems: 0,
                modifierGroupItemsId: 0,
                defaultSelectionPrice: 0,
                includedModifierItems: 0,
                requiredModifierItems: 0,
                searchAllModifierItems: false,
                locationModifierGroupId: 0,
                modifierGroupMenuTypeItemId: 0,
                locationModifierGroupItemsId: 0,
                locationModifierGroupVersionId: 0,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: true,
                defaultModifierGroupPricingVersionId: 0,
                locationModifierGroupMenuTypeItemVersionId: 0
              },
              "536": {
                id: 51753,
                active: true,
                posName: "All Mods (Food)",
                isAllMod: true,
                override: {
                  advancedModifier: true,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "All Mods (Food)",
                createdAt: "2024-09-23T18:35:46.506592Z",
                deletedAt: null,
                textColor: null,
                updatedAt: "2025-02-04T21:28:36.454523Z",
                locationId: 853,
                multiselect: true,
                quantityMode: "x1,x2,x3",
                sortPriority: 1,
                enableModTags: true,
                modifierItems: {},
                priceCalcMode: "max",
                showSearchBar: false,
                backgroundColor: null,
                hidePriceIfFree: false,
                inheritedActive: true,
                modifierGroupId: 536,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: false,
                maximumModifierItems: 0,
                defaultSelectionPrice: 0,
                includedModifierItems: 0,
                requiredModifierItems: 0,
                searchAllModifierItems: false,
                locationModifierGroupId: 2044,
                modifierGroupMenuTypeItemId: 17357,
                locationModifierGroupVersionId: 4131,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: false,
                defaultModifierGroupPricingVersionId: 607,
                locationModifierGroupMenuTypeItemVersionId: 165871
              }
            },
            prepStationIds: [],
            trackInventory: true,
            allModsBehavior: "premade",
            backgroundColor: "#ae62d4",
            customizerShape: "",
            resetStockDaily: false,
            showIngredients: true,
            enterItemDetails: false,
            homeSortPriority: 0,
            homeSpacesBefore: 0,
            showModItemPrice: true,
            showOnFreshSheet: true,
            onlineDescription: "Soft drink",
            secondaryImageUrl: "",
            showLinkingOptions: false,
            suggestiveOrdering: false,
            linkedModifierItems: {},
            displayPictureOnCard: true,
            excludeFromDiscounts: true,
            universalProductCode: "",
            defaultModifiersPrice: 0,
            transparentBackground: true,
            freshSheetSortPriority: 8,
            locationMenuTypeItemId: 18582,
            showQuantityOnItemCard: true,
            categoriesSubcategories: {
              "8826": {
                categoryId: null,
                subcategoryId: 201
              },
              "12566": {
                categoryId: 525,
                subcategoryId: null
              },
              "12942": {
                categoryId: 561,
                subcategoryId: 237
              },
              "12960": {
                categoryId: 534,
                subcategoryId: null
              },
              "23985": {
                categoryId: 525,
                subcategoryId: 302
              }
            },
            excludeFromSuggestedTip: false,
            suggestiveOrderingItemId: 0,
            suggestiveOrderingPrompt: "This is the prompt",
            actionWhenCurrentStockZero: "",
            displayItemPriceOnRegister: true,
            showAllModsHalfSizeButtons: true,
            suggestiveOrderingItemPrice: null,
            locationMenuTypeItemVersionId: 848070,
            showAllModsAlphabetizeButtons: true,
            showPrepStationSelectionModal: false,
            exitItemDetailsOnRequiredModCompletion: false
          }
        },
        reportingGroupIds: [2, 3, 4, 7, 8, 9, 16, 32],
        createdByLocationId: null,
        linkedModifierItems: {}
      },
      orderId: 15175,
      seating: {
        "-2": 1
      },
      courseId: null,
      isOnHold: false,
      isShared: null,
      isVoided: false,
      quantity: 1,
      specials: {},
      totalTax: 0.55,
      discounts: {},
      isTakeout: true,
      timeAdded: "2025-02-05T21:01:59.300Z",
      versionId: 1,
      isComplete: true,
      isOpenItem: false,
      menuTypeId: 278,
      taxDetails: {
        "33": {
          taxId: 33,
          percentage: 10,
          totalAmount: 0.3
        },
        "34": {
          taxId: 34,
          percentage: 0,
          totalAmount: 0
        },
        "35": {
          taxId: 35,
          percentage: 0,
          totalAmount: 0.25
        },
        "56": {
          taxId: 56,
          percentage: 0,
          totalAmount: 0
        }
      },
      createdById: 2082,
      instanceIds: ["ccf4a4ba-9cf6-4f78-ac91-bd1c1c7d4f47"],
      instructions: "",
      menuTypeInfo: {
        id: 278,
        name: "Breakfast",
        posName: "Breakfast",
        disableCoursing: false
      },
      prepStations: [],
      baseItemPrice: 1.45,
      timeTriggered: "0001-01-01T00:00:00Z",
      comboElementId: null,
      configWhenSent: null,
      customizerType: "none",
      openItemTypeId: null,
      voidedReasonId: null,
      isInClosedCheck: false,
      isPriceOverride: false,
      lastUpdatedById: 2082,
      ticketElementId: 69034,
      comboItemGroupId: null,
      noPrinterLocation: false,
      printErrorMessage: {},
      tabletGeneratedId: "bed26150-5063-478f-9665-567574fcb302",
      timeSentToKitchen: "0001-01-01T00:00:00Z",
      ingredientsSelected: {},
      isModifiedAfterSent: false,
      prepStationOverride: null,
      totalDiscountAmount: 0,
      totalSpecialsAmount: 0,
      onTheFlyCourseNumber: null,
      prepStationOverrideId: null,
      totalPricePerItemUnit: 1.45,
      comboItemGroupInstance: null,
      locationMenuTypeItemId: 18582,
      modifierGroupsSelected: {
        "0": {
          global: false,
          isComplete: true,
          quantityMode: "x1,x2,x3",
          showSearchBar: true,
          isNoneSelected: false,
          modifierGroupId: 0,
          quantityRequired: 0,
          customizerEnabled: false,
          modifierItemsSelected: {},
          totalPricePerItemUnit: 0,
          locationModifierGroupId: 0,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 0,
          taxInclusiveTotalPricePerItemUnit: 0
        },
        "536": {
          global: true,
          isComplete: true,
          quantityMode: "x1,x2,x3",
          showSearchBar: false,
          isNoneSelected: false,
          modifierGroupId: 536,
          quantityRequired: 0,
          customizerEnabled: false,
          modifierItemsSelected: {},
          totalPricePerItemUnit: 0,
          locationModifierGroupId: 2044,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 4131,
          taxInclusiveTotalPricePerItemUnit: 0
        }
      },
      totalSpecialsBOGOAmount: 0,
      overridePricePerItemUnit: 0,
      sentToPrepStationHistory: [],
      isModifiersSelectionComplete: true,
      isTriggeringManuallyDisabled: false,
      locationMenuTypeItemVersionId: 848070,
      ticketElementToCheckElementsId: "bed26150-5063-478f-9665-567574fcb302",
      isCurrentMenuTypeCourseDisabled: false,
      selectedModifiersPricePerItemUnit: 0,
      totalPriceWithDiscountsSpecialsNotTaxes: 1.45,
      taxInclusiveSelectedModifiersPricePerItemUnit: 0
    },
    "69035": {
      id: 69035,
      itemId: 2297,
      itemObj: {
        id: 2297,
        name: "Santa Fe Burger",
        itemId: 2297,
        customId: "",
        createdAt: "2023-04-27T17:34:55.159707Z",
        deletedAt: null,
        updatedAt: "2024-04-23T00:45:36.924881Z",
        locationIds: null,
        taxesSource: {
          "33": {
            id: 33,
            name: "FL 10% Tax",
            taxType: "percent",
            typeData: {
              rate: 10,
              unit: null,
              interval: null
            },
            orderTypes: "catering,delivery,dine in,to_go",
            tableTypeData: null,
            organizationId: 574
          },
          "34": {
            id: 34,
            name: "Alc",
            taxType: "volume",
            typeData: {
              rate: 0.06,
              unit: "ml",
              interval: 10
            },
            orderTypes: "catering,dine in,delivery,to_go",
            tableTypeData: null,
            organizationId: 574
          },
          "35": {
            id: 35,
            name: "Dining",
            taxType: "fixed",
            typeData: {
              rate: 0.25,
              unit: null,
              interval: null
            },
            orderTypes: "catering,dine in,delivery,to_go",
            tableTypeData: null,
            organizationId: 574
          }
        },
        menuTypeItemId: 6224,
        organizationId: 574,
        menuTypeVersions: {
          "278": {
            id: 18814,
            unit: "ml",
            active: true,
            combos: {},
            is86ed: false,
            recipe: "This is a top secret formula",
            taxIds: [33],
            volume: 0,
            kdsName: "Santa Fe Burger",
            posName: "Santa Fe Burger",
            calories: 300,
            courseId: 67,
            delivery: false,
            imageUrl: "https://olo-images-live.imgix.net/67/673a22f540f747dab86aeaf32c279cdf.jpg?auto=format%2Ccompress&q=60&cs=tinysrgb&w=1200&h=800&fit=fill&fm=png32&bg=transparent&s=9a4d0e683aa80f6130c67f9ae6b522b3",
            kdsColor: null,
            prepTime: 0,
            specials: {
              "57": {
                name: "Tstxyz",
                active: true,
                posName: "Tstxyz",
                specialId: 57,
                availableTimes: {}
              }
            },
            allModIds: [298, 300],
            checkName: "Santa Fe Burger",
            createdAt: "2023-04-27T17:34:56.085293Z",
            deletedAt: null,
            itemPrice: 12.89,
            textColor: null,
            toGoPrice: 12.89,
            updatedAt: "2025-01-09T21:51:40.474669Z",
            customizer: false,
            locationId: 853,
            menuTypeId: 278,
            onlineName: "Santa Fe Burger",
            description: "Avocado, pepper Jack, red onion, jalape\xF1os, tomato, pickles, cilantro, spicy Santa Fe sauce.",
            ingredients: {},
            onlinePrice: 12.89,
            showAllMods: true,
            activeOnline: true,
            ageThreshold: 21,
            allowSharing: true,
            hideItemName: false,
            reset86Daily: false,
            sortPriority: 6,
            spacesBefore: 0,
            specialTagId: null,
            taxInclusive: false,
            ageRestricted: false,
            currentAmount: 10,
            defaultNoSeat: false,
            deliveryPrice: 12.89,
            initialAmount: 0,
            showModifiers: true,
            doneIsForTable: false,
            inheritedTaxes: {
              categoryInheritedTaxes: {},
              menuTypeInheritedTaxes: {
                "33": {
                  id: 33,
                  isActive: true
                },
                "34": {
                  id: 34,
                  isActive: true
                },
                "35": {
                  id: 35,
                  isActive: true
                }
              },
              subcategoryInheritedTaxes: {}
            },
            menuTypeItemId: 6222,
            modifierGroups: {
              "0": {
                id: 0,
                active: true,
                global: true,
                kdsName: "Custom",
                posName: "Custom",
                isAllMod: false,
                override: {
                  active: false,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "Custom",
                createdAt: null,
                deletedAt: null,
                textColor: null,
                updatedAt: null,
                locationId: 0,
                multiselect: true,
                quantityMode: "x1,x2,x3",
                sortPriority: null,
                enableModTags: false,
                modifierItems: {},
                priceCalcMode: "max",
                showSearchBar: true,
                backgroundColor: null,
                hidePriceIfFree: false,
                inheritedActive: true,
                isPremadeHeader: false,
                modifierGroupId: 0,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: false,
                maximumModifierItems: 0,
                modifierGroupItemsId: 0,
                defaultSelectionPrice: 0,
                includedModifierItems: 0,
                requiredModifierItems: 0,
                searchAllModifierItems: false,
                locationModifierGroupId: 0,
                modifierGroupMenuTypeItemId: 0,
                locationModifierGroupItemsId: 0,
                locationModifierGroupVersionId: 0,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: true,
                defaultModifierGroupPricingVersionId: 0,
                locationModifierGroupMenuTypeItemVersionId: 0
              },
              "298": {
                id: 49162,
                active: true,
                posName: "Toppings",
                isAllMod: true,
                override: {
                  advancedModifier: true,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "Toppings_Test",
                createdAt: "2023-04-27T17:34:58.364449Z",
                deletedAt: null,
                textColor: null,
                updatedAt: "2025-01-09T21:51:40.457438Z",
                locationId: 853,
                multiselect: true,
                quantityMode: "Lt,Reg,Ext",
                sortPriority: 2,
                enableModTags: false,
                modifierItems: {},
                priceCalcMode: "min",
                showSearchBar: false,
                backgroundColor: null,
                hidePriceIfFree: false,
                inheritedActive: true,
                modifierGroupId: 298,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: false,
                maximumModifierItems: 3,
                defaultSelectionPrice: 0,
                includedModifierItems: 3,
                requiredModifierItems: 0,
                searchAllModifierItems: true,
                locationModifierGroupId: 314,
                modifierGroupMenuTypeItemId: 12752,
                locationModifierGroupVersionId: 4405,
                activeCustomizerSectionSelector: true,
                showModGroupTitleOnRegisterTicket: true,
                defaultModifierGroupPricingVersionId: 319,
                locationModifierGroupMenuTypeItemVersionId: 157057
              },
              "299": {
                id: 49621,
                active: true,
                posName: "Sides",
                isAllMod: false,
                override: {
                  advancedModifier: true,
                  maximumModifierItems: true,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "SidesCn",
                createdAt: "2023-04-27T17:34:58.364449Z",
                deletedAt: null,
                textColor: null,
                updatedAt: "2025-01-09T21:51:40.463393Z",
                locationId: 853,
                multiselect: true,
                quantityMode: "x1,x2,x3",
                sortPriority: 1,
                enableModTags: true,
                modifierItems: {
                  "1345": {
                    id: 1345,
                    name: "Rice",
                    active: true,
                    is86ed: false,
                    kdsName: "Rice",
                    posName: "Rice",
                    override: {},
                    checkName: "Rice",
                    createdAt: "2023-04-27T17:34:58.684437Z",
                    deletedAt: null,
                    updatedAt: "2024-10-23T20:52:37.038457Z",
                    isDisabled: false,
                    isSelected: true,
                    onlineName: "Rice",
                    description: "",
                    linesBefore: 0,
                    onSidePrice: 0,
                    sortPriority: 3,
                    spacesBefore: 0,
                    modifierGroups: {},
                    modifierItemId: 1345,
                    inheritedActive: true,
                    maximumQuantity: null,
                    halfPricePercent: 50,
                    includedExtraPrice: 1,
                    includedLightPrice: 0,
                    includedMasterPrice: 0,
                    quarterPricePercent: 25,
                    additionalExtraPrice: 2.5,
                    additionalLightPrice: 1,
                    includedRegularPrice: 0,
                    additionalMasterPrice: 1,
                    defaultAmountSelected: "regular",
                    defaultModifiersPrice: 0,
                    defaultSelectionPrice: 1,
                    includedModifierItems: 1,
                    requiredModifierItems: 1,
                    additionalRegularPrice: 1.5,
                    locationModifierItemId: 1320,
                    defaultQuantitySelected: 1,
                    modifierGroupModifierItemId: 1327,
                    modifierItemPricingVersionId: 1907,
                    locationModifierItemVersionId: 487,
                    locationMgpvLocationMipvVersionId: 752,
                    defaultModifierItemPricingVersionId: 1907,
                    locationModifierGroupMenuTypeItemId: 0,
                    locationModifierGroupModifierItemId: 1349,
                    defaultModifierGroupPricingVersionId: 321,
                    locationModifierItemPricingVersionId: 0,
                    locationModifierGroupPricingVersionId: 0,
                    locationModifierGroupModifierItemVersionId: 6184
                  },
                  "1347": {
                    id: 1347,
                    name: "Broccoli",
                    active: true,
                    is86ed: false,
                    kdsName: "Broccoli",
                    posName: "Broccoli",
                    override: {},
                    checkName: "Broccoli",
                    createdAt: "2023-04-27T17:34:58.684437Z",
                    deletedAt: null,
                    updatedAt: "2024-10-23T20:52:37.03552Z",
                    isDisabled: false,
                    isSelected: true,
                    onlineName: "Broccoli",
                    description: "",
                    linesBefore: 0,
                    onSidePrice: 0,
                    sortPriority: 5,
                    spacesBefore: 0,
                    modifierGroups: {},
                    modifierItemId: 1347,
                    inheritedActive: true,
                    maximumQuantity: null,
                    halfPricePercent: 50,
                    includedExtraPrice: 1,
                    includedLightPrice: 1,
                    includedMasterPrice: 1,
                    quarterPricePercent: 25,
                    additionalExtraPrice: 2.5,
                    additionalLightPrice: 1.25,
                    includedRegularPrice: 1,
                    additionalMasterPrice: 1.25,
                    defaultAmountSelected: "regular",
                    defaultModifiersPrice: 0,
                    defaultSelectionPrice: 1,
                    includedModifierItems: 1,
                    requiredModifierItems: 1,
                    additionalRegularPrice: 1.5,
                    locationModifierItemId: 1703,
                    defaultQuantitySelected: 1,
                    modifierGroupModifierItemId: 1329,
                    modifierItemPricingVersionId: 1911,
                    locationModifierItemVersionId: 963,
                    locationMgpvLocationMipvVersionId: 3309,
                    defaultModifierItemPricingVersionId: 1911,
                    locationModifierGroupMenuTypeItemId: 0,
                    locationModifierGroupModifierItemId: 3710,
                    defaultModifierGroupPricingVersionId: 321,
                    locationModifierItemPricingVersionId: 0,
                    locationModifierGroupPricingVersionId: 0,
                    locationModifierGroupModifierItemVersionId: 6183
                  }
                },
                priceCalcMode: "max",
                showSearchBar: false,
                backgroundColor: null,
                hidePriceIfFree: true,
                inheritedActive: true,
                modifierGroupId: 299,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: true,
                maximumModifierItems: 2,
                defaultSelectionPrice: 2,
                includedModifierItems: 1,
                requiredModifierItems: 1,
                searchAllModifierItems: false,
                locationModifierGroupId: 313,
                modifierGroupMenuTypeItemId: 12748,
                locationModifierGroupVersionId: 4073,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: true,
                defaultModifierGroupPricingVersionId: 321,
                locationModifierGroupMenuTypeItemVersionId: 157058
              },
              "300": {
                id: 49163,
                active: true,
                posName: "Sauce",
                isAllMod: true,
                override: {
                  advancedModifier: true,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "Sauce",
                createdAt: "2023-04-27T17:34:58.364449Z",
                deletedAt: null,
                textColor: null,
                updatedAt: "2025-01-09T21:51:40.466366Z",
                locationId: 853,
                multiselect: true,
                quantityMode: "x1,x2,x3",
                sortPriority: 1,
                enableModTags: false,
                modifierItems: {},
                priceCalcMode: "max",
                showSearchBar: true,
                backgroundColor: null,
                hidePriceIfFree: true,
                inheritedActive: true,
                modifierGroupId: 300,
                customizerSlicing: "quarters",
                enableQuantityBar: true,
                allowNoneSelection: true,
                maximumModifierItems: 0,
                defaultSelectionPrice: 0,
                includedModifierItems: 3,
                requiredModifierItems: 1,
                searchAllModifierItems: false,
                locationModifierGroupId: 1245,
                modifierGroupMenuTypeItemId: 12756,
                locationModifierGroupVersionId: 4133,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: true,
                defaultModifierGroupPricingVersionId: 323,
                locationModifierGroupMenuTypeItemVersionId: 157059
              }
            },
            prepStationIds: [],
            trackInventory: false,
            allModsBehavior: "premade",
            backgroundColor: null,
            customizerShape: "",
            resetStockDaily: false,
            showIngredients: false,
            enterItemDetails: false,
            homeSortPriority: null,
            homeSpacesBefore: 0,
            showModItemPrice: false,
            showOnFreshSheet: false,
            onlineDescription: "Avocado, pepper Jack, red onion, jalape\xF1os, tomato, pickles, cilantro, spicy Santa Fe sauce.",
            secondaryImageUrl: "",
            showLinkingOptions: false,
            suggestiveOrdering: false,
            linkedModifierItems: {
              "1553": {
                modifierItemId: 1553
              }
            },
            displayPictureOnCard: false,
            excludeFromDiscounts: false,
            universalProductCode: "",
            defaultModifiersPrice: 2,
            transparentBackground: false,
            freshSheetSortPriority: 0,
            locationMenuTypeItemId: 18814,
            showQuantityOnItemCard: false,
            categoriesSubcategories: {
              "653": {
                categoryId: 526,
                subcategoryId: null
              },
              "24001": {
                categoryId: 525,
                subcategoryId: 302
              }
            },
            excludeFromSuggestedTip: false,
            suggestiveOrderingItemId: 0,
            suggestiveOrderingPrompt: "This is the prompt",
            actionWhenCurrentStockZero: "",
            displayItemPriceOnRegister: true,
            showAllModsHalfSizeButtons: false,
            suggestiveOrderingItemPrice: null,
            locationMenuTypeItemVersionId: 837841,
            showAllModsAlphabetizeButtons: false,
            showPrepStationSelectionModal: false,
            exitItemDetailsOnRequiredModCompletion: false
          }
        },
        reportingGroupIds: [32],
        createdByLocationId: null,
        linkedModifierItems: {
          "1553": {
            modifierItemId: 1553
          }
        }
      },
      orderId: 15175,
      seating: {
        "-2": 1
      },
      courseId: null,
      isOnHold: false,
      isShared: null,
      isVoided: false,
      quantity: 1,
      specials: {},
      totalTax: 3.23,
      discounts: {},
      isTakeout: true,
      timeAdded: "2025-02-05T21:02:06.287Z",
      versionId: 1,
      isComplete: true,
      isOpenItem: false,
      menuTypeId: 278,
      taxDetails: {
        "33": {
          taxId: 33,
          percentage: 10,
          totalAmount: 2.98
        },
        "34": {
          taxId: 34,
          percentage: 0,
          totalAmount: 0
        },
        "35": {
          taxId: 35,
          percentage: 0,
          totalAmount: 0.25
        }
      },
      createdById: 2082,
      instanceIds: ["010f13f8-cd20-4199-b942-db0ef37a7f99"],
      instructions: "",
      menuTypeInfo: {
        id: 278,
        name: "Breakfast",
        posName: "Breakfast",
        disableCoursing: false
      },
      prepStations: [],
      baseItemPrice: 12.89,
      timeTriggered: "0001-01-01T00:00:00Z",
      comboElementId: null,
      configWhenSent: null,
      customizerType: "none",
      openItemTypeId: null,
      voidedReasonId: null,
      isInClosedCheck: false,
      isPriceOverride: false,
      lastUpdatedById: 2082,
      ticketElementId: 69035,
      comboItemGroupId: null,
      noPrinterLocation: false,
      printErrorMessage: {},
      tabletGeneratedId: "56e36983-f299-4be3-9f00-d91c76d5f553",
      timeSentToKitchen: "0001-01-01T00:00:00Z",
      ingredientsSelected: {},
      isModifiedAfterSent: false,
      prepStationOverride: null,
      totalDiscountAmount: 0,
      totalSpecialsAmount: 0,
      onTheFlyCourseNumber: null,
      prepStationOverrideId: null,
      totalPricePerItemUnit: 14.89,
      comboItemGroupInstance: null,
      locationMenuTypeItemId: 18814,
      modifierGroupsSelected: {
        "0": {
          global: false,
          isComplete: true,
          quantityMode: "x1,x2,x3",
          showSearchBar: true,
          isNoneSelected: false,
          modifierGroupId: 0,
          quantityRequired: 0,
          customizerEnabled: false,
          modifierItemsSelected: {},
          totalPricePerItemUnit: 0,
          locationModifierGroupId: 0,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 0,
          taxInclusiveTotalPricePerItemUnit: 0
        },
        "298": {
          global: true,
          isComplete: true,
          quantityMode: "Lt,Reg,Ext",
          showSearchBar: false,
          isNoneSelected: false,
          modifierGroupId: 298,
          quantityRequired: 0,
          customizerEnabled: true,
          modifierItemsSelected: {},
          totalPricePerItemUnit: 0,
          locationModifierGroupId: 314,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 4405,
          taxInclusiveTotalPricePerItemUnit: 0
        },
        "299": {
          global: false,
          isComplete: true,
          quantityMode: "x1,x2,x3",
          showSearchBar: false,
          isNoneSelected: false,
          modifierGroupId: 299,
          quantityRequired: 1,
          customizerEnabled: false,
          modifierItemsSelected: {
            "1345": {
              isVoided: false,
              isComplete: true,
              modifierTag: [],
              onSidePrice: 0,
              sortPriority: 0,
              amountSelected: "regular",
              isOverrideType: false,
              modifierItemId: 1345,
              modifierSizeTag: null,
              quantitySelected: 1,
              isDefaultModifier: true,
              isModifiedAfterSent: false,
              modifierItemInstances: {
                "1": {
                  price: 0,
                  isVoided: false,
                  isComplete: true,
                  pricingMode: "included",
                  amountSelected: "regular",
                  quantitySelected: 1,
                  customizerSectors: {
                    topLeft: true,
                    topRight: true,
                    bottomLeft: true,
                    bottomRight: true
                  },
                  taxInclusivePrice: 0,
                  isModifiedAfterSent: false,
                  modifierItemInstanceId: 1,
                  nestedModifierGroupsSelected: {}
                }
              },
              totalPricePerItemUnit: 0,
              locationModifierItemId: 1320,
              locationModifierItemVersionId: 487,
              taxInclusiveTotalPricePerItemUnit: 0
            },
            "1347": {
              isVoided: false,
              isComplete: true,
              modifierTag: [],
              onSidePrice: 0,
              sortPriority: 0,
              amountSelected: "regular",
              isOverrideType: false,
              modifierItemId: 1347,
              modifierSizeTag: null,
              quantitySelected: 1,
              isDefaultModifier: true,
              isModifiedAfterSent: false,
              modifierItemInstances: {
                "1": {
                  price: 1.25,
                  isVoided: false,
                  isComplete: true,
                  pricingMode: "included",
                  amountSelected: "regular",
                  quantitySelected: 1,
                  customizerSectors: {
                    topLeft: true,
                    topRight: true,
                    bottomLeft: true,
                    bottomRight: true
                  },
                  taxInclusivePrice: 0,
                  isModifiedAfterSent: false,
                  modifierItemInstanceId: 1,
                  nestedModifierGroupsSelected: {}
                }
              },
              totalPricePerItemUnit: 1.25,
              locationModifierItemId: 1703,
              locationModifierItemVersionId: 963,
              taxInclusiveTotalPricePerItemUnit: 0
            }
          },
          totalPricePerItemUnit: 2,
          locationModifierGroupId: 313,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 4073,
          taxInclusiveTotalPricePerItemUnit: 0
        },
        "300": {
          global: true,
          isComplete: true,
          quantityMode: "x1,x2,x3",
          showSearchBar: true,
          isNoneSelected: false,
          modifierGroupId: 300,
          quantityRequired: 1,
          customizerEnabled: false,
          modifierItemsSelected: {},
          totalPricePerItemUnit: 0,
          locationModifierGroupId: 1245,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 4133,
          taxInclusiveTotalPricePerItemUnit: 0
        }
      },
      totalSpecialsBOGOAmount: 0,
      overridePricePerItemUnit: 0,
      sentToPrepStationHistory: [],
      isModifiersSelectionComplete: true,
      isTriggeringManuallyDisabled: false,
      locationMenuTypeItemVersionId: 837841,
      ticketElementToCheckElementsId: "56e36983-f299-4be3-9f00-d91c76d5f553",
      isCurrentMenuTypeCourseDisabled: false,
      selectedModifiersPricePerItemUnit: 2,
      totalPriceWithDiscountsSpecialsNotTaxes: 14.89,
      taxInclusiveSelectedModifiersPricePerItemUnit: 0
    },
    "69038": {
      id: 69038,
      itemId: 2766,
      itemObj: {
        id: 2766,
        name: "Demo Burger",
        itemId: 2766,
        customId: "",
        createdAt: "2023-06-22T18:53:29.603773Z",
        deletedAt: null,
        updatedAt: "2023-06-22T18:53:29.603773Z",
        locationIds: null,
        taxesSource: {
          "33": {
            id: 33,
            name: "FL 10% Tax",
            taxType: "percent",
            typeData: {
              rate: 10,
              unit: null,
              interval: null
            },
            orderTypes: "catering,delivery,dine in,to_go",
            tableTypeData: null,
            organizationId: 574
          }
        },
        menuTypeItemId: 6608,
        organizationId: 574,
        menuTypeVersions: {
          "286": {
            id: 166768,
            unit: "ml",
            active: true,
            combos: {},
            is86ed: false,
            recipe: "",
            taxIds: [],
            volume: 0,
            kdsName: "Demo Burger",
            posName: "Demo Burger",
            calories: 0,
            courseId: null,
            delivery: false,
            imageUrl: "",
            kdsColor: null,
            prepTime: 0,
            specials: {},
            allModIds: [310, 312, 314, 322, 331, 335],
            checkName: "Demo Burger",
            createdAt: "2023-10-17T15:32:25.675842Z",
            deletedAt: null,
            itemPrice: 0,
            textColor: null,
            toGoPrice: 0,
            updatedAt: "2024-12-17T23:57:59.128483Z",
            customizer: false,
            locationId: 853,
            menuTypeId: 286,
            onlineName: "Demo Burger",
            description: "",
            ingredients: {
              "4": {
                id: 120,
                name: "Beef",
                active: true,
                posName: "Beef",
                isDisabled: false,
                isSelected: true,
                ingredientId: 4,
                sortPriority: 1
              }
            },
            onlinePrice: 0,
            showAllMods: true,
            activeOnline: true,
            ageThreshold: 0,
            allowSharing: false,
            hideItemName: false,
            reset86Daily: false,
            sortPriority: 0,
            spacesBefore: 0,
            specialTagId: null,
            taxInclusive: false,
            ageRestricted: false,
            currentAmount: 10,
            defaultNoSeat: false,
            deliveryPrice: 0,
            initialAmount: 0,
            showModifiers: true,
            doneIsForTable: false,
            inheritedTaxes: {
              categoryInheritedTaxes: {},
              menuTypeInheritedTaxes: {
                "33": {
                  id: 33,
                  isActive: true
                }
              },
              subcategoryInheritedTaxes: {}
            },
            menuTypeItemId: 6878,
            modifierGroups: {
              "0": {
                id: 0,
                active: true,
                global: true,
                kdsName: "Custom",
                posName: "Custom",
                isAllMod: false,
                override: {
                  active: false,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "Custom",
                createdAt: null,
                deletedAt: null,
                textColor: null,
                updatedAt: null,
                locationId: 0,
                multiselect: true,
                quantityMode: "x1,x2,x3",
                sortPriority: null,
                enableModTags: false,
                modifierItems: {},
                priceCalcMode: "max",
                showSearchBar: true,
                backgroundColor: null,
                hidePriceIfFree: false,
                inheritedActive: true,
                isPremadeHeader: false,
                modifierGroupId: 0,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: false,
                maximumModifierItems: 0,
                modifierGroupItemsId: 0,
                defaultSelectionPrice: 0,
                includedModifierItems: 0,
                requiredModifierItems: 0,
                searchAllModifierItems: false,
                locationModifierGroupId: 0,
                modifierGroupMenuTypeItemId: 0,
                locationModifierGroupItemsId: 0,
                locationModifierGroupVersionId: 0,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: true,
                defaultModifierGroupPricingVersionId: 0,
                locationModifierGroupMenuTypeItemVersionId: 0
              },
              "298": {
                id: 44911,
                active: true,
                posName: "Toppings",
                isAllMod: false,
                override: {
                  advancedModifier: true,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "Toppings_Test",
                createdAt: "2023-10-17T15:32:25.689967Z",
                deletedAt: null,
                textColor: null,
                updatedAt: "2024-12-17T23:57:58.964664Z",
                locationId: 853,
                multiselect: true,
                quantityMode: "Lt,Reg,Ext",
                sortPriority: 3,
                enableModTags: false,
                modifierItems: {},
                priceCalcMode: "min",
                showSearchBar: false,
                backgroundColor: null,
                hidePriceIfFree: false,
                inheritedActive: true,
                modifierGroupId: 298,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: false,
                maximumModifierItems: 3,
                defaultSelectionPrice: 0,
                includedModifierItems: 3,
                requiredModifierItems: 0,
                searchAllModifierItems: true,
                locationModifierGroupId: 314,
                modifierGroupMenuTypeItemId: 13658,
                locationModifierGroupVersionId: 4405,
                activeCustomizerSectionSelector: true,
                showModGroupTitleOnRegisterTicket: true,
                defaultModifierGroupPricingVersionId: 319,
                locationModifierGroupMenuTypeItemVersionId: 139014
              },
              "301": {
                id: 44913,
                active: true,
                posName: "Cook Temp",
                isAllMod: false,
                override: {
                  advancedModifier: true,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "Cook Temp",
                createdAt: "2023-10-17T15:32:25.729109Z",
                deletedAt: null,
                textColor: null,
                updatedAt: "2024-12-09T16:03:43.265959Z",
                locationId: 853,
                multiselect: false,
                quantityMode: "Off",
                sortPriority: 1,
                enableModTags: false,
                modifierItems: {
                  "1359": {
                    id: 1359,
                    name: "Medium Well",
                    active: true,
                    is86ed: false,
                    kdsName: "Medium Well",
                    posName: "Medium Well",
                    override: {},
                    checkName: "Medium Well",
                    createdAt: "2023-04-27T17:34:58.684437Z",
                    deletedAt: null,
                    updatedAt: "2023-05-17T18:40:49.39148Z",
                    isDisabled: false,
                    isSelected: false,
                    onlineName: "Medium Well",
                    description: "",
                    linesBefore: 0,
                    onSidePrice: 0,
                    sortPriority: 5,
                    spacesBefore: 0,
                    modifierGroups: {},
                    modifierItemId: 1359,
                    inheritedActive: true,
                    maximumQuantity: null,
                    halfPricePercent: 0,
                    includedExtraPrice: 0,
                    includedLightPrice: 0,
                    includedMasterPrice: 0,
                    quarterPricePercent: 0,
                    additionalExtraPrice: 0,
                    additionalLightPrice: 0,
                    includedRegularPrice: 0,
                    additionalMasterPrice: 0,
                    defaultAmountSelected: "regular",
                    defaultModifiersPrice: 0,
                    defaultSelectionPrice: 0,
                    includedModifierItems: 1,
                    requiredModifierItems: 1,
                    additionalRegularPrice: 0,
                    locationModifierItemId: 1334,
                    defaultQuantitySelected: 0,
                    modifierGroupModifierItemId: 1343,
                    modifierItemPricingVersionId: 1926,
                    locationModifierItemVersionId: 501,
                    locationMgpvLocationMipvVersionId: 773,
                    defaultModifierItemPricingVersionId: 1926,
                    locationModifierGroupMenuTypeItemId: 0,
                    locationModifierGroupModifierItemId: 1365,
                    defaultModifierGroupPricingVersionId: 324,
                    locationModifierItemPricingVersionId: 0,
                    locationModifierGroupPricingVersionId: 0,
                    locationModifierGroupModifierItemVersionId: 567
                  }
                },
                priceCalcMode: "max",
                showSearchBar: false,
                backgroundColor: null,
                hidePriceIfFree: true,
                inheritedActive: true,
                modifierGroupId: 301,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: false,
                maximumModifierItems: 1,
                defaultSelectionPrice: 0,
                includedModifierItems: 1,
                requiredModifierItems: 1,
                searchAllModifierItems: false,
                locationModifierGroupId: 320,
                modifierGroupMenuTypeItemId: 13659,
                locationModifierGroupVersionId: 4215,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: true,
                defaultModifierGroupPricingVersionId: 324,
                locationModifierGroupMenuTypeItemVersionId: 131318
              },
              "309": {
                id: 44915,
                active: true,
                posName: "LTOP",
                isAllMod: false,
                override: {
                  advancedModifier: true,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "LTOP",
                createdAt: "2023-10-17T15:32:25.74707Z",
                deletedAt: null,
                textColor: null,
                updatedAt: "2024-12-09T16:03:43.273119Z",
                locationId: 853,
                multiselect: true,
                quantityMode: "x1,x2,x3",
                sortPriority: 2,
                enableModTags: true,
                modifierItems: {
                  "1371": {
                    id: 1371,
                    name: "Pickles",
                    active: true,
                    is86ed: false,
                    kdsName: "Pickles",
                    posName: "Pickles",
                    override: {},
                    checkName: "Pickles",
                    createdAt: "2023-06-23T18:29:19.282629Z",
                    deletedAt: null,
                    updatedAt: "2023-06-23T18:29:19.282629Z",
                    isDisabled: false,
                    isSelected: false,
                    onlineName: "Pickles",
                    description: "",
                    linesBefore: 0,
                    onSidePrice: 0,
                    sortPriority: 0,
                    spacesBefore: 0,
                    modifierGroups: {},
                    modifierItemId: 1371,
                    inheritedActive: true,
                    maximumQuantity: null,
                    halfPricePercent: 100,
                    includedExtraPrice: 0,
                    includedLightPrice: 0,
                    includedMasterPrice: 0,
                    quarterPricePercent: 100,
                    additionalExtraPrice: 0,
                    additionalLightPrice: 0,
                    includedRegularPrice: 0,
                    additionalMasterPrice: 0,
                    defaultAmountSelected: "",
                    defaultModifiersPrice: 0,
                    defaultSelectionPrice: 0,
                    includedModifierItems: 0,
                    requiredModifierItems: 0,
                    additionalRegularPrice: 0,
                    locationModifierItemId: 1489,
                    defaultQuantitySelected: 0,
                    modifierGroupModifierItemId: 1392,
                    modifierItemPricingVersionId: 1940,
                    locationModifierItemVersionId: 895,
                    locationMgpvLocationMipvVersionId: 836,
                    defaultModifierItemPricingVersionId: 1940,
                    locationModifierGroupMenuTypeItemId: 0,
                    locationModifierGroupModifierItemId: 1397,
                    defaultModifierGroupPricingVersionId: 334,
                    locationModifierItemPricingVersionId: 0,
                    locationModifierGroupPricingVersionId: 0,
                    locationModifierGroupModifierItemVersionId: 602
                  }
                },
                priceCalcMode: "max",
                showSearchBar: false,
                backgroundColor: null,
                hidePriceIfFree: true,
                inheritedActive: true,
                modifierGroupId: 309,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: false,
                maximumModifierItems: 0,
                defaultSelectionPrice: 0,
                includedModifierItems: 0,
                requiredModifierItems: 0,
                searchAllModifierItems: false,
                locationModifierGroupId: 897,
                modifierGroupMenuTypeItemId: 13660,
                locationModifierGroupVersionId: 1775,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: true,
                defaultModifierGroupPricingVersionId: 334,
                locationModifierGroupMenuTypeItemVersionId: 131321
              },
              "310": {
                id: 49148,
                active: true,
                posName: "Burger Mods",
                isAllMod: true,
                override: {
                  advancedModifier: true,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "Burger Mods",
                createdAt: "2024-05-30T12:12:54.230156Z",
                deletedAt: null,
                textColor: null,
                updatedAt: "2024-12-09T16:03:43.275449Z",
                locationId: 853,
                multiselect: true,
                quantityMode: "x1,x2,x3",
                sortPriority: 1,
                enableModTags: true,
                modifierItems: {},
                priceCalcMode: "max",
                showSearchBar: true,
                backgroundColor: null,
                hidePriceIfFree: true,
                inheritedActive: true,
                modifierGroupId: 310,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: true,
                maximumModifierItems: 0,
                defaultSelectionPrice: 0,
                includedModifierItems: 0,
                requiredModifierItems: 0,
                searchAllModifierItems: true,
                locationModifierGroupId: 1489,
                modifierGroupMenuTypeItemId: 16124,
                locationModifierGroupVersionId: 3910,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: true,
                defaultModifierGroupPricingVersionId: 335,
                locationModifierGroupMenuTypeItemVersionId: 131322
              },
              "312": {
                id: 49150,
                active: true,
                posName: "Bread",
                isAllMod: true,
                override: {
                  advancedModifier: true,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "Bread",
                createdAt: "2024-05-30T12:12:54.295583Z",
                deletedAt: null,
                textColor: null,
                updatedAt: "2024-12-09T16:03:43.278159Z",
                locationId: 853,
                multiselect: false,
                quantityMode: "Off",
                sortPriority: 7,
                enableModTags: true,
                modifierItems: {},
                priceCalcMode: "max",
                showSearchBar: false,
                backgroundColor: null,
                hidePriceIfFree: true,
                inheritedActive: true,
                modifierGroupId: 312,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: false,
                maximumModifierItems: 1,
                defaultSelectionPrice: 0,
                includedModifierItems: 0,
                requiredModifierItems: 0,
                searchAllModifierItems: false,
                locationModifierGroupId: 901,
                modifierGroupMenuTypeItemId: 16125,
                locationModifierGroupVersionId: 4217,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: true,
                defaultModifierGroupPricingVersionId: 337,
                locationModifierGroupMenuTypeItemVersionId: 131323
              },
              "314": {
                id: 49154,
                active: true,
                posName: "Burger Toppings",
                isAllMod: true,
                override: {
                  advancedModifier: true,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "Burger Toppings",
                createdAt: "2024-05-30T12:12:54.33726Z",
                deletedAt: null,
                textColor: null,
                updatedAt: "2024-12-09T16:03:43.2833Z",
                locationId: 853,
                multiselect: true,
                quantityMode: "x1,x2,x3",
                sortPriority: 5,
                enableModTags: true,
                modifierItems: {
                  "1342": {
                    id: 1342,
                    name: "Mushrooms",
                    active: true,
                    is86ed: false,
                    kdsName: "Mushrooms",
                    posName: "Mushrooms",
                    override: {},
                    checkName: "Mushrooms",
                    createdAt: "2023-04-27T17:34:58.409588Z",
                    deletedAt: null,
                    updatedAt: "2024-08-29T13:20:09.039635Z",
                    isDisabled: false,
                    isSelected: true,
                    onlineName: "Mushrooms",
                    description: "",
                    linesBefore: 0,
                    onSidePrice: 0,
                    sortPriority: 6,
                    spacesBefore: 0,
                    modifierGroups: {},
                    modifierItemId: 1342,
                    inheritedActive: true,
                    maximumQuantity: 0,
                    halfPricePercent: 50,
                    includedExtraPrice: 2.22,
                    includedLightPrice: 0,
                    includedMasterPrice: 1,
                    quarterPricePercent: 25,
                    additionalExtraPrice: 3.22,
                    additionalLightPrice: 1,
                    includedRegularPrice: 1.22,
                    additionalMasterPrice: 2,
                    defaultAmountSelected: "regular",
                    defaultModifiersPrice: 0,
                    defaultSelectionPrice: 6,
                    includedModifierItems: 0,
                    requiredModifierItems: 0,
                    additionalRegularPrice: 1.6,
                    locationModifierItemId: 1317,
                    defaultQuantitySelected: 3,
                    modifierGroupModifierItemId: 1405,
                    modifierItemPricingVersionId: 1901,
                    locationModifierItemVersionId: 484,
                    locationMgpvLocationMipvVersionId: 851,
                    defaultModifierItemPricingVersionId: 1901,
                    locationModifierGroupMenuTypeItemId: 0,
                    locationModifierGroupModifierItemId: 4734,
                    defaultModifierGroupPricingVersionId: 339,
                    locationModifierItemPricingVersionId: 0,
                    locationModifierGroupPricingVersionId: 0,
                    locationModifierGroupModifierItemVersionId: 5423
                  },
                  "1354": {
                    id: 1354,
                    name: "BBQ Sauce",
                    active: true,
                    is86ed: false,
                    kdsName: "BBQ Sauce",
                    posName: "BBQ Sauce",
                    override: {},
                    checkName: "BBQ Sauce",
                    createdAt: "2023-04-27T17:34:58.409588Z",
                    deletedAt: null,
                    updatedAt: "2024-08-29T13:20:09.042671Z",
                    isDisabled: false,
                    isSelected: true,
                    onlineName: "BBQ Sauce",
                    description: "",
                    linesBefore: 0,
                    onSidePrice: 0,
                    sortPriority: 8,
                    spacesBefore: 0,
                    modifierGroups: {},
                    modifierItemId: 1354,
                    inheritedActive: true,
                    maximumQuantity: 0,
                    halfPricePercent: 60,
                    includedExtraPrice: 3,
                    includedLightPrice: 0,
                    includedMasterPrice: 0,
                    quarterPricePercent: 25,
                    additionalExtraPrice: 3.5,
                    additionalLightPrice: 1,
                    includedRegularPrice: 1,
                    additionalMasterPrice: 1,
                    defaultAmountSelected: "regular",
                    defaultModifiersPrice: 0,
                    defaultSelectionPrice: 1,
                    includedModifierItems: 0,
                    requiredModifierItems: 0,
                    additionalRegularPrice: 1.5,
                    locationModifierItemId: 2662,
                    defaultQuantitySelected: 1,
                    modifierGroupModifierItemId: 1406,
                    modifierItemPricingVersionId: 1921,
                    locationModifierItemVersionId: 1962,
                    locationMgpvLocationMipvVersionId: 848,
                    defaultModifierItemPricingVersionId: 1921,
                    locationModifierGroupMenuTypeItemId: 0,
                    locationModifierGroupModifierItemId: 4736,
                    defaultModifierGroupPricingVersionId: 339,
                    locationModifierItemPricingVersionId: 0,
                    locationModifierGroupPricingVersionId: 0,
                    locationModifierGroupModifierItemVersionId: 5424
                  }
                },
                priceCalcMode: "max",
                showSearchBar: false,
                backgroundColor: null,
                hidePriceIfFree: false,
                inheritedActive: true,
                modifierGroupId: 314,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: false,
                maximumModifierItems: 0,
                defaultSelectionPrice: 7,
                includedModifierItems: 0,
                requiredModifierItems: 0,
                searchAllModifierItems: false,
                locationModifierGroupId: 1490,
                modifierGroupMenuTypeItemId: 16127,
                locationModifierGroupVersionId: 3906,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: false,
                defaultModifierGroupPricingVersionId: 339,
                locationModifierGroupMenuTypeItemVersionId: 131325
              },
              "322": {
                id: 49156,
                active: true,
                posName: "Wing Mods",
                isAllMod: true,
                override: {
                  advancedModifier: true,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "Wing Mods",
                createdAt: "2024-05-30T12:12:54.386504Z",
                deletedAt: null,
                textColor: null,
                updatedAt: "2024-12-09T16:03:43.285829Z",
                locationId: 853,
                multiselect: true,
                quantityMode: "x1,x2,x3",
                sortPriority: 4,
                enableModTags: true,
                modifierItems: {},
                priceCalcMode: "max",
                showSearchBar: false,
                backgroundColor: null,
                hidePriceIfFree: true,
                inheritedActive: true,
                modifierGroupId: 322,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: false,
                maximumModifierItems: 0,
                defaultSelectionPrice: 0,
                includedModifierItems: 0,
                requiredModifierItems: 0,
                searchAllModifierItems: false,
                locationModifierGroupId: 1553,
                modifierGroupMenuTypeItemId: 16128,
                locationModifierGroupVersionId: 2156,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: false,
                defaultModifierGroupPricingVersionId: 388,
                locationModifierGroupMenuTypeItemVersionId: 131326
              },
              "331": {
                id: 49158,
                active: true,
                posName: "Common Add Ons",
                isAllMod: true,
                override: {
                  advancedModifier: true,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "Common Add Ons",
                createdAt: "2024-05-30T12:12:54.401713Z",
                deletedAt: null,
                textColor: null,
                updatedAt: "2024-05-30T12:12:54.401713Z",
                locationId: 853,
                multiselect: true,
                quantityMode: "x1,x2,x3",
                sortPriority: 2,
                enableModTags: true,
                modifierItems: {},
                priceCalcMode: "max",
                showSearchBar: false,
                backgroundColor: null,
                hidePriceIfFree: false,
                inheritedActive: true,
                modifierGroupId: 331,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: false,
                maximumModifierItems: 0,
                defaultSelectionPrice: 0,
                includedModifierItems: 2,
                requiredModifierItems: 0,
                searchAllModifierItems: false,
                locationModifierGroupId: 1517,
                modifierGroupMenuTypeItemId: 16129,
                locationModifierGroupVersionId: 1781,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: false,
                defaultModifierGroupPricingVersionId: 362,
                locationModifierGroupMenuTypeItemVersionId: 99783
              },
              "335": {
                id: 49160,
                active: true,
                posName: "Sandwich Mods",
                isAllMod: true,
                override: {
                  advancedModifier: true,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "Sandwich Mods",
                createdAt: "2024-05-30T12:12:54.428418Z",
                deletedAt: null,
                textColor: null,
                updatedAt: "2024-12-09T16:03:43.288505Z",
                locationId: 853,
                multiselect: true,
                quantityMode: "x1,x2,x3",
                sortPriority: 3,
                enableModTags: true,
                modifierItems: {},
                priceCalcMode: "max",
                showSearchBar: true,
                backgroundColor: null,
                hidePriceIfFree: false,
                inheritedActive: true,
                modifierGroupId: 335,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: false,
                maximumModifierItems: 0,
                defaultSelectionPrice: 0,
                includedModifierItems: 0,
                requiredModifierItems: 0,
                searchAllModifierItems: true,
                locationModifierGroupId: 1690,
                modifierGroupMenuTypeItemId: 16130,
                locationModifierGroupVersionId: 3313,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: false,
                defaultModifierGroupPricingVersionId: 366,
                locationModifierGroupMenuTypeItemVersionId: 131327
              },
              "385": {
                id: 49164,
                active: true,
                posName: "Test no mods",
                isAllMod: false,
                override: {
                  advancedModifier: true,
                  maximumModifierItems: false,
                  includedModifierItems: false,
                  requiredModifierItems: false,
                  defaultModifierGroupPricingVersionId: false
                },
                checkName: "Test no mods",
                createdAt: "2024-05-30T16:43:18.443538Z",
                deletedAt: null,
                textColor: null,
                updatedAt: "2024-12-09T16:03:43.291098Z",
                locationId: 853,
                multiselect: true,
                quantityMode: "x1,x2,x3",
                sortPriority: 4,
                enableModTags: true,
                modifierItems: {},
                priceCalcMode: "max",
                showSearchBar: false,
                backgroundColor: null,
                hidePriceIfFree: false,
                inheritedActive: true,
                modifierGroupId: 385,
                customizerSlicing: "quarters",
                enableQuantityBar: false,
                allowNoneSelection: false,
                maximumModifierItems: 0,
                defaultSelectionPrice: 0,
                includedModifierItems: 0,
                requiredModifierItems: 0,
                searchAllModifierItems: false,
                locationModifierGroupId: 1691,
                modifierGroupMenuTypeItemId: 16131,
                locationModifierGroupVersionId: 2545,
                activeCustomizerSectionSelector: false,
                showModGroupTitleOnRegisterTicket: false,
                defaultModifierGroupPricingVersionId: 440,
                locationModifierGroupMenuTypeItemVersionId: 131328
              }
            },
            prepStationIds: [35],
            trackInventory: false,
            allModsBehavior: "premade",
            backgroundColor: null,
            customizerShape: "",
            resetStockDaily: false,
            showIngredients: true,
            enterItemDetails: false,
            homeSortPriority: null,
            homeSpacesBefore: 0,
            showModItemPrice: true,
            showOnFreshSheet: false,
            onlineDescription: "",
            secondaryImageUrl: "",
            showLinkingOptions: false,
            suggestiveOrdering: false,
            linkedModifierItems: {},
            displayPictureOnCard: false,
            excludeFromDiscounts: false,
            universalProductCode: "",
            defaultModifiersPrice: 7,
            transparentBackground: false,
            freshSheetSortPriority: 0,
            locationMenuTypeItemId: 166768,
            showQuantityOnItemCard: false,
            categoriesSubcategories: {
              "915": {
                categoryId: 526,
                subcategoryId: null
              }
            },
            excludeFromSuggestedTip: false,
            suggestiveOrderingItemId: 0,
            suggestiveOrderingPrompt: "",
            actionWhenCurrentStockZero: "",
            displayItemPriceOnRegister: true,
            showAllModsHalfSizeButtons: false,
            suggestiveOrderingItemPrice: null,
            locationMenuTypeItemVersionId: 803332,
            showAllModsAlphabetizeButtons: false,
            showPrepStationSelectionModal: false,
            exitItemDetailsOnRequiredModCompletion: false
          }
        },
        reportingGroupIds: [32],
        createdByLocationId: 853,
        linkedModifierItems: {}
      },
      orderId: 15175,
      seating: {
        "-2": 1
      },
      courseId: null,
      isOnHold: false,
      isShared: null,
      isVoided: false,
      quantity: 1,
      specials: {},
      totalTax: 0.7,
      discounts: {},
      isTakeout: true,
      timeAdded: "2025-02-05T21:02:55.360Z",
      versionId: 1,
      isComplete: true,
      isOpenItem: false,
      menuTypeId: 286,
      taxDetails: {
        "33": {
          taxId: 33,
          percentage: 10,
          totalAmount: 0.7
        }
      },
      createdById: 2082,
      instanceIds: ["923a8cc9-fc31-40c5-99fe-d8aceda17c24"],
      instructions: "",
      menuTypeInfo: {
        id: 286,
        name: "FOOD Menu",
        posName: "FOOD Menu",
        disableCoursing: true
      },
      prepStations: [],
      baseItemPrice: 0,
      timeTriggered: "0001-01-01T00:00:00Z",
      comboElementId: null,
      configWhenSent: null,
      customizerType: "none",
      openItemTypeId: null,
      voidedReasonId: null,
      isInClosedCheck: false,
      isPriceOverride: false,
      lastUpdatedById: 2082,
      ticketElementId: 69038,
      comboItemGroupId: null,
      noPrinterLocation: false,
      printErrorMessage: {},
      tabletGeneratedId: "4678a0bd-3cd9-41b3-8a1a-2dcab4720a8d",
      timeSentToKitchen: "0001-01-01T00:00:00Z",
      ingredientsSelected: {
        "4": {
          name: "Beef",
          posName: "Beef",
          isVoided: false,
          isSelected: true,
          modifierTag: [],
          ingredientId: 4,
          selectedAmount: "regular",
          modifierSizeTag: null,
          isModifiedAfterSent: false
        }
      },
      isModifiedAfterSent: false,
      prepStationOverride: null,
      totalDiscountAmount: 0,
      totalSpecialsAmount: 0,
      onTheFlyCourseNumber: null,
      prepStationOverrideId: null,
      totalPricePerItemUnit: 7,
      comboItemGroupInstance: null,
      locationMenuTypeItemId: 166768,
      modifierGroupsSelected: {
        "0": {
          global: false,
          isComplete: true,
          quantityMode: "x1,x2,x3",
          showSearchBar: true,
          isNoneSelected: false,
          modifierGroupId: 0,
          quantityRequired: 0,
          customizerEnabled: false,
          modifierItemsSelected: {},
          totalPricePerItemUnit: 0,
          locationModifierGroupId: 0,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 0,
          taxInclusiveTotalPricePerItemUnit: 0
        },
        "298": {
          global: false,
          isComplete: true,
          quantityMode: "Lt,Reg,Ext",
          showSearchBar: false,
          isNoneSelected: false,
          modifierGroupId: 298,
          quantityRequired: 0,
          customizerEnabled: true,
          modifierItemsSelected: {},
          totalPricePerItemUnit: 0,
          locationModifierGroupId: 314,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 4405,
          taxInclusiveTotalPricePerItemUnit: 0
        },
        "301": {
          global: false,
          isComplete: true,
          quantityMode: "Off",
          showSearchBar: false,
          isNoneSelected: false,
          modifierGroupId: 301,
          quantityRequired: 1,
          customizerEnabled: false,
          modifierItemsSelected: {
            "1359": {
              isVoided: false,
              isComplete: true,
              modifierTag: [],
              onSidePrice: 0,
              sortPriority: 1,
              amountSelected: "regular",
              isOverrideType: false,
              modifierItemId: 1359,
              modifierSizeTag: null,
              quantitySelected: 1,
              isDefaultModifier: false,
              isModifiedAfterSent: false,
              modifierItemInstances: {
                "1": {
                  price: 0,
                  isVoided: false,
                  isComplete: true,
                  pricingMode: "included",
                  amountSelected: "regular",
                  quantitySelected: 1,
                  customizerSectors: {
                    topLeft: true,
                    topRight: true,
                    bottomLeft: true,
                    bottomRight: true
                  },
                  taxInclusivePrice: 0,
                  isModifiedAfterSent: false,
                  modifierItemInstanceId: 1,
                  nestedModifierGroupsSelected: {}
                }
              },
              totalPricePerItemUnit: 0,
              locationModifierItemId: 1334,
              locationModifierItemVersionId: 501,
              taxInclusiveTotalPricePerItemUnit: 0
            }
          },
          totalPricePerItemUnit: 0,
          locationModifierGroupId: 320,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 4215,
          taxInclusiveTotalPricePerItemUnit: 0
        },
        "309": {
          global: false,
          isComplete: true,
          quantityMode: "x1,x2,x3",
          showSearchBar: false,
          isNoneSelected: false,
          modifierGroupId: 309,
          quantityRequired: 0,
          customizerEnabled: false,
          modifierItemsSelected: {
            "1371": {
              isVoided: false,
              isComplete: true,
              modifierTag: [],
              onSidePrice: 0,
              sortPriority: 1,
              amountSelected: "regular",
              isOverrideType: false,
              modifierItemId: 1371,
              modifierSizeTag: null,
              quantitySelected: 1,
              isDefaultModifier: false,
              isModifiedAfterSent: false,
              modifierItemInstances: {
                "1": {
                  price: 0,
                  isVoided: false,
                  isComplete: true,
                  pricingMode: "additional",
                  amountSelected: "regular",
                  quantitySelected: 1,
                  customizerSectors: {
                    topLeft: true,
                    topRight: true,
                    bottomLeft: true,
                    bottomRight: true
                  },
                  taxInclusivePrice: 0,
                  isModifiedAfterSent: false,
                  modifierItemInstanceId: 1,
                  nestedModifierGroupsSelected: {}
                }
              },
              totalPricePerItemUnit: 0,
              locationModifierItemId: 1489,
              locationModifierItemVersionId: 895,
              taxInclusiveTotalPricePerItemUnit: 0
            }
          },
          totalPricePerItemUnit: 0,
          locationModifierGroupId: 897,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 1775,
          taxInclusiveTotalPricePerItemUnit: 0
        },
        "310": {
          global: true,
          isComplete: true,
          quantityMode: "x1,x2,x3",
          showSearchBar: true,
          isNoneSelected: false,
          modifierGroupId: 310,
          quantityRequired: 0,
          customizerEnabled: false,
          modifierItemsSelected: {},
          totalPricePerItemUnit: 0,
          locationModifierGroupId: 1489,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 3910,
          taxInclusiveTotalPricePerItemUnit: 0
        },
        "312": {
          global: true,
          isComplete: true,
          quantityMode: "Off",
          showSearchBar: false,
          isNoneSelected: false,
          modifierGroupId: 312,
          quantityRequired: 0,
          customizerEnabled: false,
          modifierItemsSelected: {},
          totalPricePerItemUnit: 0,
          locationModifierGroupId: 901,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 4217,
          taxInclusiveTotalPricePerItemUnit: 0
        },
        "314": {
          global: true,
          isComplete: true,
          quantityMode: "x1,x2,x3",
          showSearchBar: false,
          isNoneSelected: false,
          modifierGroupId: 314,
          quantityRequired: 0,
          customizerEnabled: false,
          modifierItemsSelected: {
            "1342": {
              isVoided: false,
              isComplete: true,
              modifierTag: [],
              onSidePrice: 0,
              sortPriority: 0,
              amountSelected: "regular",
              isOverrideType: false,
              modifierItemId: 1342,
              modifierSizeTag: null,
              quantitySelected: 3,
              isDefaultModifier: true,
              isModifiedAfterSent: false,
              modifierItemInstances: {
                "1": {
                  price: 2,
                  isVoided: false,
                  isComplete: true,
                  pricingMode: "included",
                  amountSelected: "regular",
                  quantitySelected: 3,
                  customizerSectors: {
                    topLeft: true,
                    topRight: true,
                    bottomLeft: true,
                    bottomRight: true
                  },
                  taxInclusivePrice: 0,
                  isModifiedAfterSent: false,
                  modifierItemInstanceId: 1,
                  nestedModifierGroupsSelected: {}
                },
                "2": {
                  price: 2,
                  isVoided: false,
                  isComplete: true,
                  pricingMode: "included",
                  amountSelected: "regular",
                  quantitySelected: 3,
                  customizerSectors: {
                    topLeft: true,
                    topRight: true,
                    bottomLeft: true,
                    bottomRight: true
                  },
                  taxInclusivePrice: 0,
                  isModifiedAfterSent: false,
                  modifierItemInstanceId: 2,
                  nestedModifierGroupsSelected: {}
                },
                "3": {
                  price: 2,
                  isVoided: false,
                  isComplete: true,
                  pricingMode: "included",
                  amountSelected: "regular",
                  quantitySelected: 3,
                  customizerSectors: {
                    topLeft: true,
                    topRight: true,
                    bottomLeft: true,
                    bottomRight: true
                  },
                  taxInclusivePrice: 0,
                  isModifiedAfterSent: false,
                  modifierItemInstanceId: 3,
                  nestedModifierGroupsSelected: {}
                }
              },
              totalPricePerItemUnit: 6,
              locationModifierItemId: 1317,
              locationModifierItemVersionId: 484,
              taxInclusiveTotalPricePerItemUnit: 0
            },
            "1354": {
              isVoided: false,
              isComplete: true,
              modifierTag: [],
              onSidePrice: 0,
              sortPriority: 0,
              amountSelected: "regular",
              isOverrideType: false,
              modifierItemId: 1354,
              modifierSizeTag: null,
              quantitySelected: 1,
              isDefaultModifier: true,
              isModifiedAfterSent: false,
              modifierItemInstances: {
                "1": {
                  price: 1,
                  isVoided: false,
                  isComplete: true,
                  pricingMode: "included",
                  amountSelected: "regular",
                  quantitySelected: 1,
                  customizerSectors: {
                    topLeft: true,
                    topRight: true,
                    bottomLeft: true,
                    bottomRight: true
                  },
                  taxInclusivePrice: 0,
                  isModifiedAfterSent: false,
                  modifierItemInstanceId: 1,
                  nestedModifierGroupsSelected: {}
                }
              },
              totalPricePerItemUnit: 1,
              locationModifierItemId: 2662,
              locationModifierItemVersionId: 1962,
              taxInclusiveTotalPricePerItemUnit: 0
            }
          },
          totalPricePerItemUnit: 7,
          locationModifierGroupId: 1490,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 3906,
          taxInclusiveTotalPricePerItemUnit: 0
        },
        "322": {
          global: true,
          isComplete: true,
          quantityMode: "x1,x2,x3",
          showSearchBar: false,
          isNoneSelected: false,
          modifierGroupId: 322,
          quantityRequired: 0,
          customizerEnabled: false,
          modifierItemsSelected: {},
          totalPricePerItemUnit: 0,
          locationModifierGroupId: 1553,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 2156,
          taxInclusiveTotalPricePerItemUnit: 0
        },
        "331": {
          global: true,
          isComplete: true,
          quantityMode: "x1,x2,x3",
          showSearchBar: false,
          isNoneSelected: false,
          modifierGroupId: 331,
          quantityRequired: 0,
          customizerEnabled: false,
          modifierItemsSelected: {},
          totalPricePerItemUnit: 0,
          locationModifierGroupId: 1517,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 1781,
          taxInclusiveTotalPricePerItemUnit: 0
        },
        "335": {
          global: true,
          isComplete: true,
          quantityMode: "x1,x2,x3",
          showSearchBar: true,
          isNoneSelected: false,
          modifierGroupId: 335,
          quantityRequired: 0,
          customizerEnabled: false,
          modifierItemsSelected: {},
          totalPricePerItemUnit: 0,
          locationModifierGroupId: 1690,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 3313,
          taxInclusiveTotalPricePerItemUnit: 0
        },
        "385": {
          global: false,
          isComplete: true,
          quantityMode: "x1,x2,x3",
          showSearchBar: false,
          isNoneSelected: false,
          modifierGroupId: 385,
          quantityRequired: 0,
          customizerEnabled: false,
          modifierItemsSelected: {},
          totalPricePerItemUnit: 0,
          locationModifierGroupId: 1691,
          modifierItemsWithNested: [],
          locationModifierGroupVersionId: 2545,
          taxInclusiveTotalPricePerItemUnit: 0
        }
      },
      totalSpecialsBOGOAmount: 0,
      overridePricePerItemUnit: 0,
      sentToPrepStationHistory: [],
      isModifiersSelectionComplete: true,
      isTriggeringManuallyDisabled: false,
      locationMenuTypeItemVersionId: 803332,
      ticketElementToCheckElementsId: "4678a0bd-3cd9-41b3-8a1a-2dcab4720a8d",
      isCurrentMenuTypeCourseDisabled: true,
      selectedModifiersPricePerItemUnit: 7,
      totalPriceWithDiscountsSpecialsNotTaxes: 7,
      taxInclusiveSelectedModifiersPricePerItemUnit: 0
    }
  },
  combos: {},
  orderDiscounts: {},
  orderTagIds: [],
  seatTags: {},
  courseTimes: {
    "1": {
      type: "on_the_fly",
      courseId: 1,
      isActive: true,
      courseName: "1",
      triggerTime: 1,
      sortPriority: 1,
      timeTriggered: null,
      timeSentToKitchen: null
    }
  },
  printerError: false,
  orderSpecials: {},
  bogoSpecialsSelected: [],
  bogoSpecialsObj: {},
  checks: {
    "31847": {
      id: 31847,
      tabletGeneratedId: "fc6ec9ca-8bc0-4d50-ad0c-dfd02c8754cc",
      name: "Unassigned",
      checkElements: {
        "02a1b91a-d256-4b3f-9ba2-53bc0ee67bcc": {
          tabletGeneratedId: "02a1b91a-d256-4b3f-9ba2-53bc0ee67bcc",
          checkId: 31847,
          name: "Demo Burger",
          comboItemNames: {},
          itemCount: 1,
          quantity: 1,
          eachPrice: 7,
          price: 7,
          tax: 0.7,
          discount: 0,
          isVoided: false,
          splitGrouped: 1,
          splitWays: 1,
          ticketElementId: 69038,
          comboElementId: null,
          ticketElementToCheckElementsId: "4678a0bd-3cd9-41b3-8a1a-2dcab4720a8d",
          seats: {
            "-2": 1
          },
          isShared: false,
          instanceId: "923a8cc9-fc31-40c5-99fe-d8aceda17c24",
          displayFraction: "1",
          specialAmount: 0,
          itemId: 2766,
          disableAutoAssign: false,
          specialsDetails: {},
          discountsDetails: {}
        },
        "5cf67578-d324-4305-8576-8653bdd5b2dd": {
          tabletGeneratedId: "5cf67578-d324-4305-8576-8653bdd5b2dd",
          checkId: 31847,
          name: "Sprite",
          comboItemNames: {},
          itemCount: 1,
          quantity: 1,
          eachPrice: 1.45,
          price: 1.45,
          tax: 0.55,
          discount: 0,
          isVoided: false,
          splitGrouped: 1,
          splitWays: 1,
          ticketElementId: 69034,
          comboElementId: null,
          ticketElementToCheckElementsId: "bed26150-5063-478f-9665-567574fcb302",
          seats: {
            "-2": 1
          },
          isShared: false,
          instanceId: "ccf4a4ba-9cf6-4f78-ac91-bd1c1c7d4f47",
          displayFraction: "1",
          specialAmount: 0,
          itemId: 2271,
          disableAutoAssign: false,
          specialsDetails: {},
          discountsDetails: {}
        },
        "869227e9-d91c-4ae0-b569-e742a6a5647e": {
          tabletGeneratedId: "869227e9-d91c-4ae0-b569-e742a6a5647e",
          checkId: 31847,
          name: "Big Bacon BBQ Bjf",
          comboItemNames: {},
          itemCount: 1,
          quantity: 1,
          eachPrice: 31.95,
          price: 31.95,
          tax: 3.45,
          discount: 0,
          isVoided: false,
          splitGrouped: 1,
          splitWays: 1,
          ticketElementId: 69033,
          comboElementId: null,
          ticketElementToCheckElementsId: "544c66b8-6ec4-4a10-b264-c5a2f1a5536b",
          seats: {
            "-2": 1
          },
          isShared: false,
          instanceId: "cb1a8d7e-0ac7-40c4-a8ee-4cfc7bbdfa17",
          displayFraction: "1",
          specialAmount: 0,
          itemId: 2292,
          disableAutoAssign: false,
          specialsDetails: {},
          discountsDetails: {}
        },
        "b903f8ca-1e53-40fb-8186-253b93f2b45b": {
          tabletGeneratedId: "b903f8ca-1e53-40fb-8186-253b93f2b45b",
          checkId: 31847,
          name: "Santa Fe Burger",
          comboItemNames: {},
          itemCount: 1,
          quantity: 1,
          eachPrice: 14.89,
          price: 14.89,
          tax: 3.23,
          discount: 0,
          isVoided: false,
          splitGrouped: 1,
          splitWays: 1,
          ticketElementId: 69035,
          comboElementId: null,
          ticketElementToCheckElementsId: "56e36983-f299-4be3-9f00-d91c76d5f553",
          seats: {
            "-2": 1
          },
          isShared: false,
          instanceId: "010f13f8-cd20-4199-b942-db0ef37a7f99",
          displayFraction: "1",
          specialAmount: 0,
          itemId: 2297,
          disableAutoAssign: false,
          specialsDetails: {},
          discountsDetails: {}
        }
      },
      itemCount: 4,
      subtotal: 55.29,
      totalItemDiscounts: 0,
      totalOrderDiscounts: 0,
      totalSpecialDiscounts: 0,
      totalDiscounts: 0,
      serviceChargeTotal: 5,
      tax: 7.930000000000001,
      total: 68.22,
      balanceDue: 68.22,
      balancePaid: 0,
      tip: 0,
      paymentIds: null,
      seats: null,
      timePrinted: null,
      number: 0,
      isVoided: false,
      status: "open",
      payments: {},
      serviceChargeTaxApplied: 0,
      closedTime: null,
      appliedOrderSpecialAmount: 0,
      specialsDetails: null,
      discountsDetails: null
    }
  },
  ticketElementToCheckElements: {
    "4678a0bd-3cd9-41b3-8a1a-2dcab4720a8d": [
      {
        checkId: 31847,
        instanceId: "923a8cc9-fc31-40c5-99fe-d8aceda17c24",
        checkElementId: "02a1b91a-d256-4b3f-9ba2-53bc0ee67bcc"
      }
    ],
    "544c66b8-6ec4-4a10-b264-c5a2f1a5536b": [
      {
        checkId: 31847,
        instanceId: "cb1a8d7e-0ac7-40c4-a8ee-4cfc7bbdfa17",
        checkElementId: "869227e9-d91c-4ae0-b569-e742a6a5647e"
      }
    ],
    "56e36983-f299-4be3-9f00-d91c76d5f553": [
      {
        checkId: 31847,
        instanceId: "010f13f8-cd20-4199-b942-db0ef37a7f99",
        checkElementId: "b903f8ca-1e53-40fb-8186-253b93f2b45b"
      }
    ],
    "bed26150-5063-478f-9665-567574fcb302": [
      {
        checkId: 31847,
        instanceId: "ccf4a4ba-9cf6-4f78-ac91-bd1c1c7d4f47",
        checkElementId: "5cf67578-d324-4305-8576-8653bdd5b2dd"
      }
    ]
  },
  splitMode: "",
  totalDiscountsAndSpecials: 0,
  serviceChargeTaxesSource: {},
  serviceChargeDetails: {
    "48": {
      id: 48,
      name: "new",
      active: true,
      charge: 5,
      taxIds: [],
      posName: "5$ Serv",
      assignTo: "restaurant",
      discount: "post discount",
      autoApply: true,
      createdAt: "2024-06-05T15:02:06.553896Z",
      deletedAt: null,
      minGuests: 0,
      taxAmount: 0,
      updatedAt: "2025-01-23T22:36:01.689295Z",
      chargeType: "fixed",
      locationId: 853,
      orderTypes: ["dine in", "delivery", "catering", "to_go"],
      taxDetails: {},
      organizationId: 574,
      serviceChargeId: 48,
      appliedServiceCharge: 5
    }
  },
  serviceChargeTotal: 5,
  serviceChargeTaxTotal: 0,
  hasUnsentItems: true,
  rating: 0,
  voidedReasonId: null,
  customer: null,
  customerId: null,
  assignedToMergedTablesInsideOrder: false,
  serviceChargeSelection: null,
  fireTimes: [],
  searchStrength: null,
  defaultCheckId: 31847,
  tableId: 560
};

// src/state/loggedInUser/actions.ts
var actions_exports3 = {};
__export(actions_exports3, {
  clearUser: () => clearUser,
  setInitialLoggedInUser: () => setInitialLoggedInUser,
  setLoggedInRoleOnState: () => setLoggedInRoleOnState,
  setLoggedInUser: () => setLoggedInUser,
  setUsersAndUpdateLoggedInUser: () => setUsersAndUpdateLoggedInUser
});
var setInitialLoggedInUser = (payload) => ({
  type: SET_INITIAL_LOGGED_IN_USER,
  payload
});
var setLoggedInUser = (payload) => ({
  type: SET_LOGGED_IN_USER,
  payload
});
var clearUser = () => ({
  type: CLEAR_LOGGED_IN_USER,
  payload: void 0
});
var setLoggedInRoleOnState = (role) => ({
  type: SET_LOGGED_IN_ROLE_ON_STATE,
  payload: role
});
var batch = (fn) => fn();
var setUsersAndUpdateLoggedInUser = (users) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const loggedInUser = getState().loggedInUser;
    batch(() => {
      if (loggedInUser.organizationUserId) {
        dispatch(setLoggedInUser(users[loggedInUser.organizationUserId]));
      }
      dispatch(setUsers(users));
    });
  });
};
var getSelectedIngredientFromMenuIngredient = (params) => {
  const ingredient = {
    ingredientId: params.ingredientId,
    name: params.name,
    posName: params.posName,
    isSelected: params.isSelected
  };
  return __spreadProps(__spreadValues({}, ingredient), {
    selectedAmount: "regular" /* REGULAR */,
    modifierTag: [],
    modifierSizeTag: null,
    isModifiedAfterSent: false,
    isVoided: false
  });
};
var getDefaultIngredientsSelected = (ticketElement) => {
  if (ticketElement.isOpenItem || !ticketElement.itemObj)
    return [];
  const itemObject = ticketElement.itemObj;
  return Object.values(
    itemObject.menuTypeVersions[Number(Object.keys(itemObject.menuTypeVersions)[0])].ingredients
  ).filter((ingredient) => {
    return ingredient.active && ingredient.isSelected;
  }).map((menuIngredient) => menuIngredient.ingredientId);
};
var initializeIngredientsSelected = (itemObject) => {
  const ingredientsSelected = {};
  if (!itemObject) {
    return {
      ingredientsSelected
    };
  }
  Object.values(
    itemObject.menuTypeVersions[Number(Object.keys(itemObject.menuTypeVersions)[0])].ingredients
  ).filter((ingredient) => {
    return ingredient.active && ingredient.isSelected;
  }).forEach((menuIngredient) => {
    ingredientsSelected[menuIngredient.ingredientId] = getSelectedIngredientFromMenuIngredient(menuIngredient);
  });
  return {
    ingredientsSelected
  };
};
var toggleTicketElementIngredient = (ticketElement, ingredientId, modTag) => {
  var _a;
  if (!ticketElement.itemObj)
    return;
  if (!modTag) {
    const ingredientSelected = ticketElement.ingredientsSelected[ingredientId];
    if (ingredientSelected) {
      if (getDefaultIngredientsSelected(ticketElement).includes(ingredientId)) {
        applySpecialModTag2(ingredientSelected, GET_NO_MODIFIER_TAG_SELECTED());
      } else
        delete ticketElement.ingredientsSelected[ingredientId];
    } else {
      incrementTicketElementIngredientSize(ticketElement, ingredientId);
    }
  } else {
    const ingredientSelected = ticketElement.ingredientsSelected[ingredientId];
    if (ingredientSelected) {
      if (isEmpty(ingredientSelected.modifierTag)) {
        if (modTag.isSpecial && modTag.name !== ON_SIDE_MODIFIER_TAG_POS_NAME) {
          applySpecialModTag2(ingredientSelected, modTag);
        } else {
          ingredientSelected.modifierTag.push(modTag);
        }
      } else {
        if (modTag.isSpecial && modTag.name !== ON_SIDE_MODIFIER_TAG_POS_NAME) {
          applySpecialModTag2(ingredientSelected, modTag);
        } else {
          if (hasModifierTag(ingredientSelected.modifierTag, modTag)) {
            ingredientSelected.modifierTag = removeModifierTag(
              ingredientSelected.modifierTag,
              modTag
            );
          } else {
            ingredientSelected.modifierTag.push(modTag);
            ingredientSelected.isSelected = true;
          }
        }
      }
    } else {
      ticketElement.ingredientsSelected[ingredientId] = __spreadProps(__spreadValues({}, getSelectedIngredientFromMenuIngredient(
        (_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[ticketElement.menuTypeId].ingredients[ingredientId]
      )), {
        isSelected: true,
        selectedAmount: "regular" /* REGULAR */
      });
      if (modTag.isSpecial && modTag.name !== ON_SIDE_MODIFIER_TAG_POS_NAME) {
        applySpecialModTag2(
          ticketElement.ingredientsSelected[ingredientId],
          modTag
        );
      } else {
        ticketElement.ingredientsSelected[ingredientId].modifierTag.push(
          modTag
        );
      }
    }
  }
};
var applySpecialModTag2 = (ingredientSelected, modTag) => {
  switch (modTag.name) {
    case NO_MODIFIER_TAG_POS_NAME: {
      if (hasNoModifierTag(ingredientSelected.modifierTag)) {
        ingredientSelected.modifierTag = [];
        ingredientSelected.selectedAmount = "regular" /* REGULAR */;
        ingredientSelected.isSelected = true;
      } else {
        ingredientSelected.modifierTag = [modTag];
        ingredientSelected.selectedAmount = "regular" /* REGULAR */;
        ingredientSelected.isSelected = false;
      }
      break;
    }
    case EXTRA_MODIFIER_TAG_POS_NAME:
    case LITE_MODIFIER_TAG_POS_NAME: {
      if (hasNoModifierTag(ingredientSelected.modifierTag))
        ingredientSelected.modifierTag = [];
      if (SPECIAL_TAG_NAME_TO_QUANTITY_SIZE[modTag.name] === ingredientSelected.selectedAmount) {
        ingredientSelected.selectedAmount = "regular" /* REGULAR */;
        ingredientSelected.modifierSizeTag = null;
        ingredientSelected.isSelected = true;
      } else if (SPECIAL_TAGS_WITHOUT_STRING.includes(modTag.name)) {
        ingredientSelected.selectedAmount = "regular" /* REGULAR */;
        ingredientSelected.isSelected = true;
        ingredientSelected.selectedAmount = SPECIAL_TAG_NAME_TO_QUANTITY_SIZE[modTag.name];
        ingredientSelected.modifierSizeTag = selectSpecialModTagsMetaData.lastResult()[ingredientSelected.selectedAmount];
      }
      break;
    }
  }
};
var incrementTicketElementIngredientSize = (ticketElement, ingredientId) => {
  var _a;
  if (!ticketElement.itemObj)
    return;
  const currentStatus = ticketElement.ingredientsSelected[ingredientId];
  if (currentStatus) {
    currentStatus.selectedAmount = nextQuantityAmount(
      currentStatus.selectedAmount
    );
    currentStatus.modifierSizeTag = selectSpecialModTagsMetaData.lastResult()[currentStatus.selectedAmount];
  } else {
    ticketElement.ingredientsSelected[ingredientId] = __spreadProps(__spreadValues({}, getSelectedIngredientFromMenuIngredient(
      (_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[ticketElement.menuTypeId].ingredients[ingredientId]
    )), {
      isSelected: true,
      selectedAmount: "regular" /* REGULAR */
    });
  }
};
var decrementTicketElementIngredientSize = (ticketElement, ingredientId) => {
  var _a;
  if (!ticketElement.itemObj)
    return;
  const currentStatus = ticketElement.ingredientsSelected[ingredientId];
  if (currentStatus) {
    currentStatus.selectedAmount = prevQuantityAmount(
      currentStatus.selectedAmount
    );
    currentStatus.modifierSizeTag = selectSpecialModTagsMetaData.lastResult()[currentStatus.selectedAmount];
  } else {
    ticketElement.ingredientsSelected[ingredientId] = __spreadProps(__spreadValues({}, getSelectedIngredientFromMenuIngredient(
      (_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[ticketElement.menuTypeId].ingredients[ingredientId]
    )), {
      selectedAmount: "regular" /* REGULAR */
    });
  }
};
var reinitializeModifierGroupSelected = (ticketElement, modifierGroupId, modifierTagSizes) => {
  if (isNaN(modifierGroupId) || !ticketElement.itemObj) {
    return null;
  }
  const defaultModifierItems = getDefaultModifiersSelectedFromItem(ticketElement)[modifierGroupId];
  const itemObj = ticketElement.itemObj;
  const itemMenuTypeVersion = itemObj.menuTypeVersions[Number(Object.keys(itemObj.menuTypeVersions)[0])];
  const newModifierGroupSelected = {
    isComplete: itemMenuTypeVersion.modifierGroups[modifierGroupId].requiredModifierItems === 0,
    isNoneSelected: false,
    quantityRequired: itemMenuTypeVersion.modifierGroups[modifierGroupId].requiredModifierItems,
    modifierGroupId,
    quantityMode: itemMenuTypeVersion.modifierGroups[modifierGroupId].quantityMode,
    modifierItemsWithNested: [],
    modifierItemsSelected: {},
    totalPricePerItemUnit: 0,
    taxInclusiveTotalPricePerItemUnit: 0,
    customizerEnabled: itemMenuTypeVersion.modifierGroups[modifierGroupId].activeCustomizerSectionSelector,
    locationModifierGroupId: itemMenuTypeVersion.modifierGroups[modifierGroupId].locationModifierGroupId,
    locationModifierGroupVersionId: itemMenuTypeVersion.modifierGroups[modifierGroupId].locationModifierGroupVersionId,
    showSearchBar: itemMenuTypeVersion.modifierGroups[modifierGroupId].showSearchBar,
    global: itemMenuTypeVersion.modifierGroups[modifierGroupId].isAllMod
  };
  if (!defaultModifierItems) {
    return newModifierGroupSelected;
  }
  defaultModifierItems.forEach((modifierItemId) => {
    const modifierItem = itemMenuTypeVersion.modifierGroups[modifierGroupId].modifierItems[modifierItemId];
    newModifierGroupSelected.modifierItemsSelected[modifierItemId] = __spreadProps(__spreadValues({}, GET_MODIFIER_ITEM_SELECTED_INITIAL_STATE()), {
      isDefaultModifier: true,
      modifierItemId,
      amountSelected: modifierItem.defaultAmountSelected,
      quantitySelected: modifierItem.defaultQuantitySelected || 1,
      modifierSizeTag: newModifierGroupSelected.quantityMode === "Lt,Reg,Ext" /* SIZE */ ? modifierTagSizes[modifierItem.defaultAmountSelected] : null,
      locationModifierItemId: modifierItem.locationModifierItemId,
      locationModifierItemVersionId: modifierItem.locationModifierItemVersionId,
      isComplete: true
    });
    for (let i = 0; i < (modifierItem.defaultQuantitySelected || 1); i++) {
      let nestedModifierGroups = {};
      nestedModifierGroups = mapNestedModGroups(
        modifierItem.modifierGroups,
        modifierTagSizes
      );
      newModifierGroupSelected.modifierItemsSelected[modifierItemId].modifierItemInstances[i + 1] = __spreadProps(__spreadValues({}, GET_MODIFIER_ITEM_INSTANCE_INITIAL_STATE()), {
        amountSelected: modifierItem.defaultAmountSelected,
        quantitySelected: modifierItem.defaultQuantitySelected || 1,
        customizerSectors: __spreadValues({}, CUSTOMIZER_INITIAL_STATE),
        modifierItemInstanceId: i + 1,
        isComplete: initializeIsInstanceComplete(nestedModifierGroups),
        nestedModifierGroupsSelected: nestedModifierGroups
      });
    }
    newModifierGroupSelected.modifierItemsSelected[modifierItemId].isComplete = Object.values(
      newModifierGroupSelected.modifierItemsSelected[modifierItemId].modifierItemInstances
    ).every((instance) => instance.isComplete);
    if (!isEmpty(modifierItem.modifierGroups) && !newModifierGroupSelected.modifierItemsWithNested.includes(modifierItemId)) {
      newModifierGroupSelected.modifierItemsWithNested.push(modifierItemId);
    }
  });
  newModifierGroupSelected.isComplete = getModifierItemsSelectedQty(newModifierGroupSelected) >= newModifierGroupSelected.quantityRequired && Object.values(newModifierGroupSelected.modifierItemsSelected).every(
    (modI) => modI.isComplete
  );
  return newModifierGroupSelected;
};
var reinitializeModifierGroupSelected_default = reinitializeModifierGroupSelected;

// src/helpers/register/reducerHelpers/resetModifierGroupSelected.ts
var resetAllModsModifierGroupsSelected = (ticketElement) => {
  if (!ticketElement.itemObj)
    return;
  const allModsBehavior = ticketElement.itemObj.menuTypeVersions[ticketElement.isOpenItem ? 0 : ticketElement.menuTypeId].allModsBehavior;
  if (allModsBehavior === "all" /* ALL */)
    resetModifierGroupSelected2(ticketElement, ALL_MODS_ID);
  else {
    const allModGroupsList = Object.values(
      ticketElement.itemObj.menuTypeVersions[ticketElement.isOpenItem ? 0 : ticketElement.menuTypeId].modifierGroups
    ).filter((modifierGroup) => modifierGroup.isAllMod);
    allModGroupsList.forEach((modifierGroup) => {
      resetModifierGroupSelected2(ticketElement, modifierGroup.modifierGroupId);
    });
  }
};
var resetModifierGroupSelected2 = (ticketElement, modifierGroupId) => {
  if (!ticketElement.modifierGroupsSelected[modifierGroupId])
    return;
  const prevPrice = ticketElement.modifierGroupsSelected[modifierGroupId].totalPricePerItemUnit;
  const newModifierGroupSelected = reinitializeModifierGroupSelected_default(
    ticketElement,
    modifierGroupId,
    selectSpecialModTagsMetaData.lastResult()
  );
  if (!newModifierGroupSelected)
    return;
  ticketElement.modifierGroupsSelected[modifierGroupId] = newModifierGroupSelected;
  const priceDelta = newModifierGroupSelected.totalPricePerItemUnit - prevPrice;
  ticketElement.selectedModifiersPricePerItemUnit += priceDelta;
  ticketElement.totalPriceWithDiscountsSpecialsNotTaxes += priceDelta * ticketElement.quantity;
  ticketElement.totalPricePerItemUnit += priceDelta;
};
var resetIngredientsSelected = (ticketElement) => {
  if (!ticketElement.itemObj)
    return;
  if (ticketElement.isOpenItem)
    return;
  Object.assign(
    ticketElement,
    initializeIngredientsSelected(ticketElement.itemObj)
  );
};
var ordersReducer = produce(
  (state = {}, action) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    switch (action.type) {
      case SET_ORDERS:
        return action.payload;
      case SET_ORDER_LOCALLY_FOR_PAYMENT_BULK:
      case SET_ORDER_LOCALLY_FOR_PAYMENT:
        state[getEntityId(action.payload)] = action.payload;
        checkAndDisplayCheckElementsRollUp(state[getEntityId(action.payload)]);
        updateChecksTotals(state[getEntityId(action.payload)]);
        calcOrderTotalsWithAlternativePrice(state[getEntityId(action.payload)]);
        break;
      case REMOVE_ORDER:
        delete state[action.payload];
        break;
      case UPDATE_TABLE_LAYOUT_AND_ORDERS:
        return action.payload.orders;
      case UPDATE_ORDER_FIELD:
      case UPDATE_LOCALLY_ORDER_FIELD:
        if (!state[action.payload.orderId])
          return state;
        checkForOrderTypeChanges(
          action.payload.orderUpdate,
          state[action.payload.orderId]
        );
        assign(state[action.payload.orderId], action.payload.orderUpdate);
        if ("ticketElements" in action.payload.orderUpdate)
          state[action.payload.orderId].hasUnsentItems = getOrderHasUnsentItems(
            state[action.payload.orderId]
          );
        if ("taxExempt" in action.payload.orderUpdate || "noTaxInclusive" in action.payload.orderUpdate) {
          updateTicketElementsWithTaxExempt(state[action.payload.orderId]);
        }
        if ("serviceChargeTotal" in action.payload.orderUpdate || "ticketElements" in action.payload.orderUpdate) {
          calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        }
        updateChecksTotals(state[action.payload.orderId]);
        break;
      case UPDATE_LICENSE_EDITING_ID:
      case UPDATE_LICENSE_EDITING_ID_WS:
        state[action.payload.orderId].licenseEditingId = action.payload.licenseEditingId;
        break;
      case EXITING_FROM_ORDER:
      case LEAVING_ORDER_WS:
        state[action.orderId].licenseEditingId = null;
        break;
      case ADD_SESSION_ORDER:
      case ADD_SESSION_ORDER_WS:
        state[action.id] = action.payload;
        if (action.updateTotals) {
          calcOrderTotalsWithAlternativePrice(state[action.id], true);
          updateChecksTotals(state[action.id]);
        }
        break;
      case REPLACE_ORDER_TABLET_GENERATED_ID_WS:
        state[action.payload.orderId] = state[action.payload.tabletGeneratedId];
        state[action.payload.orderId].id = action.payload.orderId;
        delete state[action.payload.tabletGeneratedId];
        if (action.payload.defaultCheckId) {
          state[action.payload.orderId].checks[action.payload.defaultCheckId] = state[action.payload.orderId].checks[state[action.payload.orderId].defaultCheckId];
          state[action.payload.orderId].checks[action.payload.defaultCheckId].id = action.payload.defaultCheckId;
          delete state[action.payload.orderId].checks[state[action.payload.orderId].defaultCheckId];
          state[action.payload.orderId].defaultCheckId = action.payload.defaultCheckId;
          Object.values(
            state[action.payload.orderId].ticketElementToCheckElements
          ).forEach((ticketElementToCheckElementArrays) => {
            ticketElementToCheckElementArrays.forEach(
              (ticketElementToCheckElement) => {
                ticketElementToCheckElement.checkId = action.payload.defaultCheckId;
              }
            );
          });
        }
        break;
      case UPDATE_ORDER:
        state[action.payload.order.id] = action.payload.order;
        generateDisplayCheckElements(state[action.payload.order.id]);
        break;
      case UPDATE_ORDER_WS:
        state[action.payload.order.id] = action.payload.order;
        generateDisplayCheckElements(state[action.payload.order.id]);
        if (state[action.payload.order.id] === void 0)
          break;
        rollUpDisplayCheckElements(state[action.payload.order.id]);
        break;
      case INCREMENT_NUMBER_OF_SEATS:
        state[action.payload.orderId].numberOfSeatsOccupied = (state[action.payload.orderId].numberOfSeatsOccupied || 0) + 1;
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        break;
      case TOGGLE_TICKET_ELEMENT_SEAT_SHARED:
      case TOGGLE_COMBO_ELEMENT_SEAT_SHARED: {
        if (action.payload.isCombo) {
          toggleComboElementSeatShared(
            state[action.payload.orderId].combos[action.payload.ticketElementId],
            state[action.payload.orderId].ticketElements,
            action.payload.isSeatingModeEnabled,
            action.payload.seatId
          );
          updateTicketAndComboCompleteQuantity(
            state[action.payload.orderId].combos[action.payload.ticketElementId],
            state[action.payload.orderId].ticketElements,
            action.payload.isSeatingModeEnabled
          );
          setIsComboComplete(
            state[action.payload.orderId].combos[action.payload.ticketElementId],
            action.payload.isSeatingModeEnabled
          );
        } else {
          toggleSeat(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
            action.payload.seatId
          );
          setSeatValuesOnShareToggle(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
            true,
            action.payload.isSeatingModeEnabled
          );
          updateCompletedSections(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
            true
          );
        }
        removeCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.isCombo
        );
        createCheckDataAndUpdateCheckForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.isCombo,
          void 0,
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId].quantity
        );
        autoSplitChecks(state[action.payload.orderId]);
        checkAndDisplayCheckElementsRollUp(state[action.payload.orderId]);
        break;
      }
      case SET_SEAT_TAGS:
        if (!state[action.payload.orderId].seatTags) {
          state[action.payload.orderId].seatTags = {};
        }
        state[action.payload.orderId].seatTags[action.payload.seatId] = action.payload.seatTags;
        break;
      case CLEAR_ALL_SEAT_TAGS:
        state[action.payload].seatTags = {};
        break;
      case TOGGLE_SEAT_QUANTITY: {
        const ticketElement = state[action.payload.orderId].ticketElements[action.payload.ticketElementId];
        const prevTicketElementQuantity = ticketElement.quantity;
        const prevSeatId = Number(Object.keys(ticketElement.seating)[0]);
        const toggleCase = toggleSeatQuantity(
          ticketElement,
          action.payload.seatId,
          action.payload.quantity,
          action.payload.isMultiSeatEnabled
        );
        handleQuantityChange(ticketElement);
        calcTotalItemWithAlternativePrice(
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
          {
            orderType: state[action.payload.orderId].type,
            orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
            taxExempt: state[action.payload.orderId].taxExempt,
            noTaxInclusive: state[action.payload.orderId].noTaxInclusive
          }
        );
        updateCompletedSections(
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
          true
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        adjustCheckDataForToggleSeats(
          toggleCase,
          state[action.payload.orderId],
          action.payload.ticketElementId,
          false,
          ticketElement.quantity,
          prevTicketElementQuantity,
          action.payload.seatId,
          prevSeatId
        );
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        break;
      }
      case TOGGLE_COMBO_SEAT_QUANTITY: {
        const comboElement = state[action.payload.orderId].combos[action.payload.ticketElementId];
        const prevTicketElementQuantity = comboElement.quantity;
        const prevSeatId = Number(Object.keys(comboElement.seating)[0]);
        const toggleCase = toggleComboSeatQuantity(
          state[action.payload.orderId].combos[action.payload.ticketElementId],
          state[action.payload.orderId].ticketElements,
          action.payload.seatId,
          action.payload.quantity
        );
        updateTicketAndComboCompleteQuantity(
          state[action.payload.orderId].combos[action.payload.ticketElementId],
          state[action.payload.orderId].ticketElements,
          true
        );
        calcTotalComboWithAlternativePrice(
          state[action.payload.orderId].combos[action.payload.ticketElementId],
          {
            orderType: state[action.payload.orderId].type,
            taxExempt: state[action.payload.orderId].taxExempt,
            noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
            orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
          }
        );
        setIsComboComplete(
          state[action.payload.orderId].combos[action.payload.ticketElementId],
          action.payload.isSeatingModeEnabled
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        adjustCheckDataForToggleSeats(
          toggleCase,
          state[action.payload.orderId],
          action.payload.ticketElementId,
          true,
          comboElement.quantity,
          prevTicketElementQuantity,
          action.payload.seatId,
          prevSeatId
        );
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          true
        );
        break;
      }
      case SET_SEAT_QUANTITY:
      case SET_COMBO_SEAT_QUANTITY: {
        let ticketElement;
        let prevTicketElementQuantity;
        if (action.payload.isCombo) {
          ticketElement = state[action.payload.orderId].combos[action.payload.ticketElementId];
          prevTicketElementQuantity = ticketElement.quantity;
          setComboSeatQuantity(
            ticketElement,
            state[action.payload.orderId].ticketElements,
            action.payload.seatId,
            action.payload.quantity
          );
          updateTicketAndComboCompleteQuantity(
            ticketElement,
            state[action.payload.orderId].ticketElements,
            true
          );
          setIsComboComplete(
            ticketElement,
            action.payload.isSeatingModeEnabled
          );
          calcTotalComboWithAlternativePrice(ticketElement, {
            orderType: state[action.payload.orderId].type,
            taxExempt: state[action.payload.orderId].taxExempt,
            noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
            orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
          });
        } else {
          ticketElement = state[action.payload.orderId].ticketElements[action.payload.ticketElementId];
          prevTicketElementQuantity = ticketElement.quantity;
          setSeatQuantity(
            ticketElement,
            action.payload.seatId,
            action.payload.quantity
          );
          handleQuantityChange(ticketElement);
          calcTotalItemWithAlternativePrice(ticketElement, {
            orderType: state[action.payload.orderId].type,
            orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
            taxExempt: state[action.payload.orderId].taxExempt,
            noTaxInclusive: state[action.payload.orderId].noTaxInclusive
          });
          updateCompletedSections(ticketElement, true);
        }
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        adjustCheckDataForToggleSeats(
          2 /* UPDATE_QUANTITY */,
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.isCombo,
          ticketElement.quantity,
          prevTicketElementQuantity,
          action.payload.seatId
        );
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.isCombo
        );
        break;
      }
      case INCREMENT_SEAT_QUANTITY:
      case INCREMENT_COMBO_SEAT_QUANTITY: {
        if (action.payload.isCombo) {
          incrementComboSeatQuantity(
            state[action.payload.orderId].combos[action.payload.ticketElementId],
            state[action.payload.orderId].ticketElements,
            action.payload.seatId
          );
          updateTicketAndComboCompleteQuantity(
            state[action.payload.orderId].combos[action.payload.ticketElementId],
            state[action.payload.orderId].ticketElements,
            true
          );
          setIsComboComplete(
            state[action.payload.orderId].combos[action.payload.ticketElementId],
            action.payload.isSeatingModeEnabled
          );
          calcTotalComboWithAlternativePrice(
            state[action.payload.orderId].combos[action.payload.ticketElementId],
            {
              orderType: state[action.payload.orderId].type,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
            }
          );
        } else {
          incrementSeatQuantity(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
            action.payload.seatId
          );
          handleQuantityChange(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId]
          );
          calcTotalItemWithAlternativePrice(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
            {
              orderType: state[action.payload.orderId].type,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive
            }
          );
          updateCompletedSections(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
            true
          );
        }
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        createCheckDataAndUpdateCheckForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.isCombo,
          action.payload.seatId,
          1
        );
        break;
      }
      case DECREMENT_SEAT_QUANTITY:
      case DECREMENT_COMBO_SEAT_QUANTITY: {
        if (action.payload.isCombo) {
          decrementComboSeatQuantity(
            state[action.payload.orderId].combos[action.payload.ticketElementId],
            state[action.payload.orderId].ticketElements,
            action.payload.seatId
          );
          updateTicketAndComboCompleteQuantity(
            state[action.payload.orderId].combos[action.payload.ticketElementId],
            state[action.payload.orderId].ticketElements,
            true
          );
          setIsComboComplete(
            state[action.payload.orderId].combos[action.payload.ticketElementId],
            action.payload.isSeatingModeEnabled
          );
          calcTotalComboWithAlternativePrice(
            state[action.payload.orderId].combos[action.payload.ticketElementId],
            {
              orderType: state[action.payload.orderId].type,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
            }
          );
        } else {
          decrementSeatQuantity(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
            action.payload.seatId
          );
          handleQuantityChange(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId]
          );
          calcTotalItemWithAlternativePrice(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
            {
              orderType: state[action.payload.orderId].type,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive
            }
          );
          updateCompletedSections(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
            true
          );
        }
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        removeCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.isCombo,
          action.payload.seatId,
          1
        );
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.isCombo
        );
        break;
      }
      case SET_TICKET_ELEMENT_ITEM_OBJ:
        state[action.payload.orderId].ticketElements[action.payload.ticketElementId].itemObj = action.payload.itemObj;
        break;
      case ADD_MODIFIER_ITEM_TO_MODIFIER_GROUP_ITEM_OBJ: {
        const ticketElement = state[action.payload.orderId].ticketElements[action.payload.ticketElementId];
        if (ticketElement.itemObj)
          ticketElement.itemObj.menuTypeVersions[ticketElement.isOpenItem ? 0 : ticketElement.menuTypeId].modifierGroups[action.payload.modifierGroupId].modifierItems[action.payload.modifierItemId] = action.payload.modifierItemObj;
        break;
      }
      case SET_TICKET_ELEMENT_SHARE:
      case SET_COMBO_ELEMENT_SHARE: {
        const order = state[action.payload.orderId];
        if (action.payload.isCombo) {
          const comboElement = order.combos[action.payload.ticketElementId];
          shareComboElement(
            state[action.payload.orderId],
            state[action.payload.orderId].combos[action.payload.ticketElementId],
            state[action.payload.orderId].ticketElements,
            action.payload.isSeatingModeEnabled,
            action.payload.shareCase,
            action.payload.splitType
          );
          calcTotalComboWithAlternativePrice(comboElement, {
            orderType: state[action.payload.orderId].type,
            taxExempt: state[action.payload.orderId].taxExempt,
            noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
            orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
          });
          createCheckDataAndUpdateCheckForTicketElement(
            state[action.payload.orderId],
            action.payload.ticketElementId,
            true,
            void 0,
            comboElement.quantity
          );
        } else {
          const ticketElement = order.ticketElements[action.payload.ticketElementId];
          deleteNoSeatKey(ticketElement);
          if (action.payload.shareCase === "share" || ticketElement.quantity === 0) {
            ticketElement.quantity = action.payload.globalQuantity ? action.payload.globalQuantity : 1;
          }
          shareTicketElement(ticketElement, action.payload.splitType);
          setSeatValuesOnShareToggle(
            ticketElement,
            true,
            action.payload.isSeatingModeEnabled
          );
          calcTotalItemWithAlternativePrice(ticketElement, {
            orderType: state[action.payload.orderId].type,
            orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
            taxExempt: state[action.payload.orderId].taxExempt,
            noTaxInclusive: state[action.payload.orderId].noTaxInclusive
          });
          updateCompletedSections(
            ticketElement,
            action.payload.isSeatingModeEnabled
          );
          calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
          removeCheckDataForTicketElement(
            state[action.payload.orderId],
            action.payload.ticketElementId,
            false,
            void 0,
            ticketElement.quantity
          );
          createCheckDataAndUpdateCheckForTicketElement(
            state[action.payload.orderId],
            action.payload.ticketElementId,
            false,
            void 0,
            ticketElement.quantity
          );
        }
        break;
      }
      case SET_TICKET_ELEMENT_UN_SHARE:
        if (action.payload.isCombo) {
          unShareComboElement(
            state[action.payload.orderId].combos[action.payload.ticketElementId],
            state[action.payload.orderId].ticketElements,
            action.payload.isSeatingModeEnabled,
            action.payload.isForTableEnabled
          );
          calcTotalComboWithAlternativePrice(
            state[action.payload.orderId].combos[action.payload.ticketElementId],
            {
              orderType: state[action.payload.orderId].type,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
            }
          );
          removeCheckDataForTicketElement(
            state[action.payload.orderId],
            action.payload.ticketElementId,
            true
          );
        } else {
          setSeatValuesOnShareToggle(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
            false,
            action.payload.isSeatingModeEnabled
          );
          unShareTicketElement(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
            action.payload.isForTableEnabled
          );
          calcTotalItemWithAlternativePrice(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
            {
              orderType: state[action.payload.orderId].type,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive
            }
          );
          removeCheckDataForTicketElement(
            state[action.payload.orderId],
            action.payload.ticketElementId,
            false
          );
        }
        checkAndDisplayCheckElementsRollUp(state[action.payload.orderId]);
        updateChecksTotals(state[action.payload.orderId]);
        break;
      case SET_TICKET_ELEMENT_QUANTITY:
      case SET_COMBO_ELEMENT_QUANTITY: {
        let ticketElement;
        let prevTicketElementQuantity;
        if (action.payload.isCombo) {
          ticketElement = state[action.payload.orderId].combos[action.payload.ticketElementId];
          prevTicketElementQuantity = ticketElement.quantity;
          setComboElementQuantity(
            state[action.payload.orderId].combos[action.payload.ticketElementId],
            state[action.payload.orderId].ticketElements,
            action.payload.quantity,
            action.payload.isSeatingModeEnabled
          );
          calcTotalComboWithAlternativePrice(
            state[action.payload.orderId].combos[action.payload.ticketElementId],
            {
              orderType: state[action.payload.orderId].type,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
            }
          );
        } else {
          ticketElement = state[action.payload.orderId].ticketElements[action.payload.ticketElementId];
          prevTicketElementQuantity = ticketElement.quantity;
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId].quantity = action.payload.quantity;
          handleQuantityChange(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId]
          );
          if (!ticketElement.isShared)
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId].seating = { [NO_SEAT_ID]: action.payload.quantity };
          calcTotalItemWithAlternativePrice(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
            {
              orderType: state[action.payload.orderId].type,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive
            }
          );
          updateCompletedSections(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
            action.payload.isSeatingModeEnabled
          );
        }
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        adjustCheckDataForToggleSeats(
          2 /* UPDATE_QUANTITY */,
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.isCombo,
          ticketElement.quantity,
          prevTicketElementQuantity,
          void 0
        );
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.isCombo
        );
        break;
      }
      case UPDATE_TICKET_ELEMENT_FIELD: {
        state[action.payload.orderId].ticketElements[action.payload.ticketElementId] = __spreadValues(__spreadValues({}, state[action.payload.orderId].ticketElements[action.payload.ticketElementId]), action.payload.ticketElementUpdate);
        updateCompletedSections(
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
          action.payload.isSeatingModeEnabled
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        updateCheckElementForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        updateChecksTotals(state[action.payload.orderId]);
        break;
      }
      case UPDATE_TICKET_ELEMENT_VOIDED: {
        const isVoided = action.payload.isVoided;
        state[action.payload.orderId].ticketElements[action.payload.ticketElementId].isVoided = isVoided;
        if (isVoided) {
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId].voidedReasonId = action.payload.voidedReasonId;
        } else {
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId].voidedReasonId = null;
        }
        const sentTime = getNowUTCDate();
        const prepStations = action.payload.prepStationIds.map((prepStationId) => {
          var _a2;
          return {
            prepStationId,
            printJobId: action.payload.printJobIdsPerPrepStation ? (_a2 = action.payload.printJobIdsPerPrepStation[prepStationId]) != null ? _a2 : generatePrintJobId() : generatePrintJobId()
          };
        });
        prepStations.forEach(({ prepStationId, printJobId }) => {
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId].sentToPrepStationHistory.push({
            printJobId,
            prepStationId,
            sentTime,
            printJobErrorId: null,
            isVoided
          });
        });
        state[action.payload.orderId].ticketElements[action.payload.ticketElementId].prepStations = prepStations;
        if (state[action.payload.orderId].ticketElements[action.payload.ticketElementId].prepStationOverrideId) {
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId].prepStationOverride = prepStations[0];
        }
        overrideCheckElementFields(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          { isVoided: action.payload.isVoided },
          false
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        updateTicketElementChecksTotals(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          false
        );
        break;
      }
      case UPDATE_COMBO_ELEMENT_VOIDED:
        state[action.payload.orderId].combos[action.payload.comboElementId].isVoided = action.payload.isVoided;
        state[action.payload.orderId].combos[action.payload.comboElementId].voidedReasonId = action.payload.voidedReasonId;
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        overrideCheckElementFields(
          state[action.payload.orderId],
          action.payload.comboElementId,
          { isVoided: action.payload.isVoided },
          true
        );
        updateTicketElementChecksTotals(
          state[action.payload.orderId],
          action.payload.comboElementId,
          true
        );
        break;
      case UPDATE_TICKET_ELEMENT_COURSE: {
        const ticketElement = state[action.payload.orderId].ticketElements[action.payload.ticketElementId];
        ticketElement.courseId = action.payload.coursingMode === "predefined" /* PREDEFINED */ ? action.payload.data.courseId : null;
        ticketElement.onTheFlyCourseNumber = action.payload.coursingMode === "on_the_fly" /* ON_THE_FLY */ ? action.payload.data.courseId : null;
        ticketElement.isTakeout = action.payload.data.isTakeout;
        ticketElement.baseItemPrice = isOpenItemFn(ticketElement) ? ticketElement.baseItemPrice : ticketElement.itemObj ? getBasePrice(
          ticketElement.itemObj.menuTypeVersions[ticketElement.menuTypeId],
          action.payload.data.isTakeout
        ) : (_a = ticketElement.baseItemPrice) != null ? _a : 0;
        if (isTicketElementTaxInclusive(ticketElement)) {
          const taxIds = getTaxesToApplyFromItemObj(
            ticketElement.itemObj,
            ticketElement.menuTypeId
          );
          ticketElement.baseItemPrice = getBasePriceFromTaxInclusive(
            (_c = (_b = ticketElement.itemObj) == null ? void 0 : _b.taxesSource) != null ? _c : {},
            state[action.payload.orderId].type,
            ticketElement.baseItemPrice,
            taxIds,
            ticketElement.isTakeout,
            getTicketItemVolumeData(ticketElement),
            ticketElement.quantity
          );
        }
        calcTotalItemWithAlternativePrice(ticketElement, {
          orderType: state[action.payload.orderId].type,
          orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
          taxExempt: state[action.payload.orderId].taxExempt,
          noTaxInclusive: state[action.payload.orderId].noTaxInclusive
        });
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          !!ticketElement.comboElementId
        );
        if (isTicketElementAssociatedWithCombo(ticketElement)) {
          const comboElement = state[action.payload.orderId].combos[ticketElement.comboElementId];
          const previousStatus = comboElement.isTakeout;
          updateComboIsTakeoutStatus(
            comboElement,
            state[action.payload.orderId].ticketElements
          );
          comboElement.comboBasePrice = comboElement.comboObj ? getComboBasePrice(
            comboElement.comboObj.menuTypeVersions[comboElement.menuTypeId],
            comboElement.isTakeout
          ) : (_d = comboElement.comboBasePrice) != null ? _d : 0;
          if (previousStatus !== comboElement.isTakeout) {
            calcTotalComboWithAlternativePrice(comboElement, {
              orderType: state[action.payload.orderId].type,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
            });
          }
        }
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        break;
      }
      case UPDATE_TICKET_ELEMENT_INSTRUCTIONS: {
        const ticketElement = getAndSplitTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.seatSplitRequired,
          action.payload.currentSeat
        );
        ticketElement.instructions = action.payload.data.instructions;
        break;
      }
      case SELECT_NONE_MODIFIER_ITEMS: {
        const ticketElement = getAndSplitTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.seatSplitRequired,
          action.payload.currentSeat
        );
        selectNoneModifierItems2(
          ticketElement,
          action.payload.modifierGroupId,
          action.payload.globalState
        );
        updateModifierPrice(ticketElement, action.payload.modifierGroupId);
        updateCompletedSections(
          ticketElement,
          action.payload.isSeatingModeEnabled,
          action.payload.modifierGroupId
        );
        updateComboItemGroup(
          ticketElement,
          state[action.payload.orderId].combos,
          action.payload.isSeatingModeEnabled
        );
        calcTotalSelectedModifiersPrice(ticketElement);
        calcTotalItemWithAlternativePrice(ticketElement, {
          orderType: state[action.payload.orderId].type,
          orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
          taxExempt: state[action.payload.orderId].taxExempt,
          noTaxInclusive: state[action.payload.orderId].noTaxInclusive
        });
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        break;
      }
      case SET_TICKET_MODIFIER_GROUPS_SELECTED: {
        const ticketElement = getAndSplitTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.seatSplitRequired,
          action.payload.currentSeat
        );
        ticketElement.modifierGroupsSelected[action.payload.modifierGroupId] = action.payload;
        updateCompletedSections(
          ticketElement,
          action.payload.isSeatingModeEnabled,
          action.payload.modifierGroupId
        );
        updateComboItemGroup(
          ticketElement,
          state[action.payload.orderId].combos,
          action.payload.isSeatingModeEnabled
        );
        calcTotalSelectedModifiersPrice(ticketElement);
        calcTotalItemWithAlternativePrice(ticketElement, {
          orderType: state[action.payload.orderId].type,
          orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
          taxExempt: state[action.payload.orderId].taxExempt,
          noTaxInclusive: state[action.payload.orderId].noTaxInclusive
        });
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        break;
      }
      case UPDATE_TICKET_MODIFIER_GROUP_ITEM: {
        const { orderId, ticketElementId, modifierGroupId } = action.payload;
        state[orderId].ticketElements[ticketElementId].modifierGroupsSelected[modifierGroupId].modifierItemsWithNested = action.payload.modifierItemsWithNested;
        state[orderId].ticketElements[ticketElementId].modifierGroupsSelected[modifierGroupId].modifierItemsSelected[action.payload.modifierItemSelected.modifierItemId] = action.payload.modifierItemSelected;
        calcOrderTotalsWithAlternativePrice(state[orderId], true);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        break;
      }
      case RESET_MODIFIER_GROUP_SELECTED: {
        const ticketElement = state[action.payload.orderId].ticketElements[action.payload.ticketElementId];
        if (action.payload.modifierGroupId === ALL_MODS_ID) {
          if (action.payload.isIngredientsActive)
            resetIngredientsSelected(ticketElement);
          else
            resetAllModsModifierGroupsSelected(ticketElement);
        } else
          resetModifierGroupSelected2(
            ticketElement,
            action.payload.modifierGroupId
          );
        updateModifierPrice(ticketElement, action.payload.modifierGroupId);
        updateCompletedSections(
          ticketElement,
          action.payload.isSeatingModeEnabled,
          action.payload.modifierGroupId
        );
        updateComboItemGroup(
          ticketElement,
          state[action.payload.orderId].combos,
          action.payload.isSeatingModeEnabled
        );
        checkIfTicketElementIsTaxExempt(
          ticketElement,
          action.payload.globalState
        );
        calcTotalItemWithAlternativePrice(ticketElement, {
          orderType: state[action.payload.orderId].type,
          orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
          taxExempt: state[action.payload.orderId].taxExempt,
          noTaxInclusive: state[action.payload.orderId].noTaxInclusive
        });
        if (ticketElement.comboElementId && ticketElement.comboItemGroupId)
          updateItemGroupAdditionalPrice(
            ticketElement,
            state[action.payload.orderId].combos[ticketElement.comboElementId]
          );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          !!ticketElement.comboElementId
        );
        break;
      }
      case CARRY_OVER_MODIFIERS_SELECTED: {
        const ticketElement = getAndSplitTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.seatSplitRequired,
          action.payload.currentSeat
        );
        carryOverModifiersSelected2(
          ticketElement,
          action.payload.modifierGroupsSelected,
          selectSpecialModTagsMetaData.lastResult()
        );
        updateComboItemGroup(
          ticketElement,
          state[action.payload.orderId].combos,
          action.payload.isSeatingModeEnabled
        );
        calcTotalItemWithAlternativePrice(ticketElement, {
          orderType: state[action.payload.orderId].type,
          orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
          taxExempt: state[action.payload.orderId].taxExempt,
          noTaxInclusive: state[action.payload.orderId].noTaxInclusive
        });
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        break;
      }
      case SELECT_NONE_MODIFIER_ITEMS_CUSTOMIZER: {
        const ticketElement = getAndSplitTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.seatSplitRequired,
          action.payload.currentSeat
        );
        selectNoneModifierItemsCustomizer(
          ticketElement,
          action.payload.modifierGroupId,
          action.payload.customizer,
          action.payload.globalState
        );
        updateComboItemGroup(
          ticketElement,
          state[action.payload.orderId].combos,
          action.payload.isSeatingModeEnabled
        );
        calcTotalItemWithAlternativePrice(ticketElement, {
          orderType: state[action.payload.orderId].type,
          orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
          taxExempt: state[action.payload.orderId].taxExempt,
          noTaxInclusive: state[action.payload.orderId].noTaxInclusive
        });
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        break;
      }
      case TOGGLE_MODIFIER_ITEM_SELECTED: {
        const ticketElement = state[action.payload.orderId].ticketElements[action.payload.ticketElementId];
        const defaultModifiersSelected = getDefaultModifiersSelectedFromItem(ticketElement);
        toggleModifierItemSelected2(
          ticketElement,
          action.payload.modifierGroupId,
          action.payload.modifierItemId,
          action.payload.customizer,
          action.payload.modifierTag,
          action.payload.globalQuantity,
          action.payload.globalState,
          action.payload.operation,
          selectSpecialModTagsMetaData(action.payload.globalState),
          defaultModifiersSelected[action.payload.modifierGroupId] && defaultModifiersSelected[action.payload.modifierGroupId].includes(
            action.payload.modifierItemId
          ),
          action.payload.sortPriority
        );
        applyModifierTag(
          ticketElement.modifierGroupsSelected[action.payload.modifierGroupId].modifierItemsSelected[action.payload.modifierItemId],
          fixModifierTag(
            action.payload.modifierTag,
            defaultModifiersSelected,
            action.payload.modifierGroupId,
            action.payload.modifierItemId,
            action.payload.operation
          ),
          action.payload.operation
        );
        updateModifierPrice(
          ticketElement,
          action.payload.modifierGroupId,
          action.payload.modifierItemId
        );
        updateCompletedSections(
          ticketElement,
          action.payload.isSeatingModeEnabled,
          action.payload.modifierGroupId
        );
        updateComboItemGroup(
          ticketElement,
          state[action.payload.orderId].combos,
          action.payload.isSeatingModeEnabled
        );
        checkIfTicketElementIsTaxExempt(
          ticketElement,
          action.payload.globalState
        );
        calcTotalItemWithAlternativePrice(ticketElement, {
          orderType: state[action.payload.orderId].type,
          orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
          taxExempt: state[action.payload.orderId].taxExempt,
          noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
          calcDiscount: true
        });
        if (ticketElement.comboElementId && ticketElement.comboItemGroupId)
          updateItemGroupAdditionalPrice(
            ticketElement,
            state[action.payload.orderId].combos[ticketElement.comboElementId]
          );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          !!ticketElement.comboElementId
        );
        break;
      }
      case INCREMENT_MODIFIER_ITEM_SELECTED: {
        const ticketElement = state[action.payload.orderId].ticketElements[action.payload.ticketElementId];
        incrementModifierItemSelected2(
          ticketElement,
          action.payload.modifierGroupId,
          action.payload.modifierItemId,
          selectSpecialModTagsMetaData(action.payload.globalState),
          action.payload.customizer,
          action.payload.globalState,
          action.payload.sortPriority
        );
        singleSelectDeleteOtherModifiers(
          ticketElement,
          action.payload.modifierGroupId,
          action.payload.modifierItemId,
          action.payload.customizer
        );
        updateModifierPrice(ticketElement, action.payload.modifierGroupId);
        updateCompletedSections(
          ticketElement,
          action.payload.isSeatingModeEnabled,
          action.payload.modifierGroupId
        );
        calcTotalItemWithAlternativePrice(ticketElement, {
          orderType: state[action.payload.orderId].type,
          orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
          taxExempt: state[action.payload.orderId].taxExempt,
          noTaxInclusive: state[action.payload.orderId].noTaxInclusive
        });
        ticketElement.updatedAt = getNowUTCDate();
        if (ticketElement.comboElementId && ticketElement.comboItemGroupId)
          updateItemGroupAdditionalPrice(
            ticketElement,
            state[action.payload.orderId].combos[ticketElement.comboElementId]
          );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          !!ticketElement.comboElementId
        );
        break;
      }
      case DECREMENT_MODIFIER_ITEM_SELECTED: {
        const ticketElement = state[action.payload.orderId].ticketElements[action.payload.ticketElementId];
        decrementModifierItemSelected2(
          ticketElement,
          action.payload.modifierGroupId,
          action.payload.modifierItemId,
          selectSpecialModTagsMetaData(action.payload.globalState),
          action.payload.customizer,
          action.payload.sortPriority
        );
        updateModifierPrice(ticketElement, action.payload.modifierGroupId);
        updateCompletedSections(
          ticketElement,
          action.payload.isSeatingModeEnabled,
          action.payload.modifierGroupId,
          action.payload.modifierItemId
        );
        checkIfTicketElementIsTaxExempt(
          ticketElement,
          action.payload.globalState
        );
        calcTotalItemWithAlternativePrice(
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
          {
            orderType: state[action.payload.orderId].type,
            orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
            taxExempt: state[action.payload.orderId].taxExempt,
            noTaxInclusive: state[action.payload.orderId].noTaxInclusive
          }
        );
        ticketElement.updatedAt = getNowUTCDate();
        if (ticketElement.comboElementId && ticketElement.comboItemGroupId)
          updateItemGroupAdditionalPrice(
            ticketElement,
            state[action.payload.orderId].combos[ticketElement.comboElementId]
          );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          !!ticketElement.comboElementId
        );
        break;
      }
      case DELETE_TICKET_MODIFIER_ITEM_SELECTED: {
        const ticketElement = state[action.payload.orderId].ticketElements[action.payload.ticketElementId];
        const defaultModifiersSelected = getDefaultModifiersSelectedFromItem(ticketElement);
        if (defaultModifiersSelected[action.payload.modifierGroupId] && defaultModifiersSelected[action.payload.modifierGroupId].includes(
          action.payload.modifierItemId
        )) {
          selectNoModifierItem(
            ticketElement,
            action.payload.modifierGroupId,
            action.payload.modifierItemId,
            true,
            action.payload.globalState,
            void 0
          );
          applyModifierTag(
            ticketElement.modifierGroupsSelected[action.payload.modifierGroupId].modifierItemsSelected[action.payload.modifierItemId],
            GET_NO_MODIFIER_TAG_SELECTED(),
            "SELECT_NO" /* SELECT_NO */
          );
        } else
          deleteModifierItemSelected(
            ticketElement,
            action.payload.modifierGroupId,
            action.payload.modifierItemId,
            action.payload.customizer
          );
        updateModifierPrice(ticketElement, action.payload.modifierGroupId);
        updateCompletedSections(
          ticketElement,
          action.payload.isSeatingModeEnabled,
          action.payload.modifierGroupId
        );
        calcTotalItemWithAlternativePrice(ticketElement, {
          orderType: state[action.payload.orderId].type,
          orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
          taxExempt: state[action.payload.orderId].taxExempt,
          noTaxInclusive: state[action.payload.orderId].noTaxInclusive
        });
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          !!ticketElement.comboElementId
        );
        break;
      }
      case SELECT_SUBCATEGORY_CUSTOMIZER:
      case SELECT_REGISTER_ITEM: {
        selectRegisterItem2(
          state[action.payload.orderId].ticketElements,
          action.payload.ticketElementId,
          action.payload.itemId,
          action.payload.globalState,
          selectIsDualPricingEnabled.lastResult(),
          action.payload.overrides
        );
        if (state[action.payload.orderId].ticketElements[action.payload.ticketElementId].totalPriceWithDiscountsSpecialsNotTaxes > 0 && state[action.payload.orderId].isLockedPrice) {
          state[action.payload.orderId].isLockedPrice = false;
        }
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        const seating = action.payload.globalState.settings.selectedMode.currentSettings.register.seating;
        const globalQuantity = (_e = action.payload.globalState.register.registerNavigation.quantity) != null ? _e : 1;
        const ticketElementSeating = state[action.payload.orderId].ticketElements[action.payload.ticketElementId].seating;
        const isTicketElementSeatingEmpty = isEmpty(ticketElementSeating);
        if (!seating || state[action.payload.orderId].tableId === null || !isTicketElementSeatingEmpty) {
          createCheckDataAndUpdateCheckForTicketElement(
            state[action.payload.orderId],
            action.payload.ticketElementId,
            false,
            !isTicketElementSeatingEmpty ? Number(Object.keys(ticketElementSeating)[0]) : void 0,
            !isTicketElementSeatingEmpty ? Number(Object.values(ticketElementSeating)[0]) : globalQuantity
          );
        }
        break;
      }
      case SELECT_REGISTER_COMBO_ITEM: {
        const itemGroupKey = `${action.payload.itemGroupId}-${action.payload.itemGroupInstance}`;
        let comboItemGroupSelected = state[action.payload.orderId].combos[action.payload.comboElementId].itemGroupsSelected[itemGroupKey];
        if (comboItemGroupSelected == null ? void 0 : comboItemGroupSelected.ticketElementId)
          removePreviousElement(
            state[action.payload.orderId].ticketElements,
            comboItemGroupSelected
          );
        else {
          const comboElement = state[action.payload.orderId].combos[action.payload.comboElementId];
          state[action.payload.orderId].combos[action.payload.comboElementId].itemGroupsSelected[itemGroupKey] = __spreadProps(__spreadValues({}, COMBO_ITEM_GROUP_SELECTED_INITIAL_STATE), {
            isRequired: (_i = (_h = (_f = comboElement.comboObj) == null ? void 0 : _f.menuTypeVersions[comboElement.menuTypeId].itemGroups[action.payload.itemGroupId].override.required) != null ? _h : (_g = comboElement.comboObj) == null ? void 0 : _g.menuTypeVersions[comboElement.menuTypeId].itemGroups[action.payload.itemGroupId].required) != null ? _i : false
          });
          comboItemGroupSelected = state[action.payload.orderId].combos[action.payload.comboElementId].itemGroupsSelected[itemGroupKey];
        }
        selectRegisterItem2(
          state[action.payload.orderId].ticketElements,
          action.payload.ticketElementId,
          action.payload.itemId,
          action.payload.globalState,
          selectIsDualPricingEnabled.lastResult(),
          {
            menuTypeId: state[action.payload.orderId].combos[action.payload.comboElementId].menuTypeId,
            prepStationId: action.payload.prepStationId
          }
        );
        updateWithComboValues(
          state[action.payload.orderId].combos[action.payload.comboElementId],
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
          action.payload.itemGroupId,
          action.payload.itemGroupInstance
        );
        updateCompletedSections(
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
          action.payload.isSeatingModeEnabled
        );
        comboItemGroupSelected.itemGroupId = action.payload.itemGroupId;
        comboItemGroupSelected.itemId = action.payload.itemId;
        comboItemGroupSelected.ticketElementId = action.payload.ticketElementId;
        comboItemGroupSelected.instanceId = action.payload.itemGroupInstance;
        comboItemGroupSelected.isComplete = state[action.payload.orderId].ticketElements[action.payload.ticketElementId].isModifiersSelectionComplete;
        comboItemGroupSelected.additionalPrice = (_j = action.payload.additionalPrice) != null ? _j : 0;
        calcTotalAdditionalPrice(
          state[action.payload.orderId].combos[action.payload.comboElementId]
        );
        setIsComboComplete(
          state[action.payload.orderId].combos[action.payload.comboElementId],
          action.payload.isSeatingModeEnabled
        );
        state[action.payload.orderId].combos[action.payload.comboElementId].updatedAt = getNowUTCDate();
        calcTotalComboWithAlternativePrice(
          state[action.payload.orderId].combos[action.payload.comboElementId],
          {
            orderType: state[action.payload.orderId].type,
            taxExempt: state[action.payload.orderId].taxExempt,
            noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
            orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
          }
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.comboElementId,
          true
        );
        break;
      }
      case REMOVE_REGISTER_COMBO_ITEM: {
        const comboItemGroupSelected = state[action.payload.orderId].combos[action.payload.comboElementId].itemGroupsSelected[`${action.payload.itemGroupId}-${action.payload.itemGroupInstance}`];
        removePreviousElement(
          state[action.payload.orderId].ticketElements,
          comboItemGroupSelected
        );
        comboItemGroupSelected.isRequired = (_l = (_k = state[action.payload.orderId].combos[action.payload.comboElementId].comboObj) == null ? void 0 : _k.menuTypeVersions[state[action.payload.orderId].combos[action.payload.comboElementId].menuTypeId].itemGroups[action.payload.itemGroupId].required) != null ? _l : false;
        comboItemGroupSelected.isComplete = !comboItemGroupSelected.isRequired;
        calcTotalAdditionalPrice(
          state[action.payload.orderId].combos[action.payload.comboElementId]
        );
        setIsComboComplete(
          state[action.payload.orderId].combos[action.payload.comboElementId],
          action.payload.isSeatingModeEnabled
        );
        calcTotalComboWithAlternativePrice(
          state[action.payload.orderId].combos[action.payload.comboElementId],
          {
            orderType: state[action.payload.orderId].type,
            taxExempt: state[action.payload.orderId].taxExempt,
            noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
            orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
          }
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        updateCheckElementForComboElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        updateChecksTotals(state[action.payload.orderId]);
        break;
      }
      case SELECT_REGISTER_COMBO: {
        selectRegisterCombo2(
          state[action.payload.orderId],
          action.payload.comboElementId,
          action.payload.comboId,
          action.payload.globalState,
          selectIsDualPricingEnabled.lastResult(),
          action.payload.overrides
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        const seating = action.payload.globalState.settings.selectedMode.currentSettings.register.seating;
        const globalQuantity = (_m = action.payload.globalState.register.registerNavigation.quantity) != null ? _m : 1;
        const comboIsNoSeat = NO_SEAT_ID in state[action.payload.orderId].combos[action.payload.comboElementId].seating;
        if (!seating || state[action.payload.orderId].tableId === null || comboIsNoSeat) {
          createCheckDataAndUpdateCheckForTicketElement(
            state[action.payload.orderId],
            action.payload.comboElementId,
            true,
            comboIsNoSeat ? NO_SEAT_ID : void 0,
            comboIsNoSeat ? state[action.payload.orderId].combos[action.payload.comboElementId].seating[NO_SEAT_ID] : globalQuantity
          );
        }
        break;
      }
      case UPDATE_COMBO_OBJECT_PREVIEW:
        updateComboElement(
          state[action.payload.orderId],
          action.payload.comboElementId,
          action.payload.comboId,
          action.payload.globalState
        );
        break;
      case MAKE_COMBO_FROM_TICKET_ITEM: {
        const ticketElement = state[action.payload.orderId].ticketElements[action.payload.ticketElementId];
        selectRegisterCombo2(
          state[action.payload.orderId],
          action.payload.comboElementId,
          action.payload.comboId,
          action.payload.globalState,
          selectIsDualPricingEnabled.lastResult(),
          {
            menuTypeId: ticketElement.menuTypeId
          }
        );
        const comboElement = state[action.payload.orderId].combos[action.payload.comboElementId];
        ticketElement.comboElementId = getEntityIdOrTabletGeneratedId(comboElement);
        ticketElement.comboItemGroupId = action.payload.itemGroupId;
        updateItemGroupSelected(
          comboElement,
          action.payload.itemGroupId,
          action.payload.itemGroupInstance,
          {
            ticketElementId: getEntityIdOrTabletGeneratedId(ticketElement),
            itemGroupId: action.payload.itemGroupId,
            itemId: ticketElement.itemId,
            additionalPrice: action.payload.additionalPrice,
            isRequired: action.payload.isRequired,
            isComplete: ticketElement.isModifiersSelectionComplete,
            instanceId: 1,
            additionalModifiersPrice: 0
          }
        );
        comboElement.quantity = ticketElement.quantity || 1;
        comboElement.seating = __spreadValues({}, ticketElement.seating);
        calcTotalAdditionalPrice(
          state[action.payload.orderId].combos[action.payload.comboElementId]
        );
        setIsComboComplete(
          state[action.payload.orderId].combos[action.payload.comboElementId],
          action.payload.isSeatingModeEnabled
        );
        calcTotalComboWithAlternativePrice(
          state[action.payload.orderId].combos[action.payload.comboElementId],
          {
            orderType: state[action.payload.orderId].type,
            taxExempt: state[action.payload.orderId].taxExempt,
            noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
            orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
          }
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        removeCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          false
        );
        const comboSeat = Object.keys(comboElement.seating)[0];
        createCheckDataAndUpdateCheckForTicketElement(
          state[action.payload.orderId],
          action.payload.comboElementId,
          true,
          comboSeat ? Number(comboSeat) : void 0,
          comboElement.quantity,
          false
        );
        break;
      }
      case DUPLICATE_TICKET_ELEMENT: {
        duplicateRegisterItem(
          state[action.payload.orderId].ticketElements,
          action.payload.prevTicketElementId,
          action.payload.newTicketElementId,
          action.payload.seatSplitRequired,
          action.payload.currentSeat,
          action.payload.isSeatingEnabled,
          action.payload.nextCourseNumber,
          action.payload.isReorder
        );
        const newTicketElement = state[action.payload.orderId].ticketElements[action.payload.newTicketElementId];
        calcTotalItemWithAlternativePrice(newTicketElement, {
          orderType: state[action.payload.orderId].type,
          orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
          taxExempt: state[action.payload.orderId].taxExempt,
          noTaxInclusive: state[action.payload.orderId].noTaxInclusive
        });
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        const ticketElementSeating = newTicketElement.seating;
        const isTicketElementSeatingEmpty = isEmpty(ticketElementSeating);
        const isTicketElementShared = newTicketElement.isShared !== null;
        if (isTicketElementSeatingEmpty) {
          createCheckDataAndUpdateCheckForTicketElement(
            state[action.payload.orderId],
            action.payload.newTicketElementId,
            false,
            void 0,
            newTicketElement.quantity
          );
        } else if (isTicketElementShared) {
          for (let iterator = 0; iterator < newTicketElement.quantity; iterator++) {
            createCheckDataAndUpdateCheckForTicketElement(
              state[action.payload.orderId],
              action.payload.newTicketElementId,
              false,
              void 0,
              1
            );
          }
        } else {
          Object.entries(ticketElementSeating).forEach(([seat, quantity]) => {
            createCheckDataAndUpdateCheckForTicketElement(
              state[action.payload.orderId],
              action.payload.newTicketElementId,
              false,
              Number(seat),
              quantity
            );
          });
        }
        break;
      }
      case DUPLICATE_COMBO_ELEMENT: {
        duplicateRegisterCombo(
          state[action.payload.orderId].combos,
          state[action.payload.orderId].ticketElements,
          action.payload.prevTicketElementId,
          action.payload.newTicketElementId,
          action.payload.isSeatingEnabled,
          action.payload.isReorder,
          action.payload.nextCourseNumber
        );
        convertOldComboElementIntoTheNewest(
          state[action.payload.orderId].combos[action.payload.prevTicketElementId],
          state[action.payload.orderId].combos[action.payload.newTicketElementId],
          state[action.payload.orderId].ticketElements,
          action.payload.isSeatingEnabled,
          action.payload.isReorder
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        const newComboElement = state[action.payload.orderId].combos[action.payload.newTicketElementId];
        const ticketElementSeating = newComboElement.seating;
        const isTicketElementSeatingEmpty = isEmpty(ticketElementSeating);
        createCheckDataAndUpdateCheckForTicketElement(
          state[action.payload.orderId],
          action.payload.newTicketElementId,
          true,
          !isTicketElementSeatingEmpty ? Number(Object.keys(ticketElementSeating)[0]) : void 0,
          newComboElement.quantity
        );
        break;
      }
      case REMOVE_TICKET_ELEMENT: {
        removeTicketElementAndCheckData(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          false
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        updateChecksTotals(state[action.payload.orderId]);
        autoSplitChecks(state[action.payload.orderId]);
        break;
      }
      case REMOVE_COMBO_ELEMENT:
      case CANCEL_COMBO_ELEMENT: {
        removeTicketElementAndCheckData(
          state[action.payload.orderId],
          action.payload.comboElementId,
          true
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        updateChecksTotals(state[action.payload.orderId]);
        autoSplitChecks(state[action.payload.orderId]);
        break;
      }
      case UPDATE_NESTED_TICKET_MODIFIER_GROUP_ITEM: {
        const {
          orderId,
          ticketElementId,
          parentModifierGroupId,
          parentModifierInstanceId,
          childModifierGroupId,
          parentModifierItemId
        } = action.payload;
        state[orderId].ticketElements[ticketElementId].modifierGroupsSelected[parentModifierGroupId].modifierItemsSelected[parentModifierItemId].modifierItemInstances[parentModifierInstanceId].nestedModifierGroupsSelected[childModifierGroupId].modifierItemsSelected[action.payload.nestedModifierItemSelected.modifierItemId] = action.payload.nestedModifierItemSelected;
        calcOrderTotalsWithAlternativePrice(state[orderId]);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        break;
      }
      case DELETE_NESTED_TICKET_MODIFIER_GROUP_ITEM: {
        const {
          orderId,
          ticketElementId,
          parentModifierGroupId,
          parentModifierItemId,
          parentModifierInstanceId,
          childModifierGroupId
        } = action.payload;
        state[orderId].ticketElements[ticketElementId].modifierGroupsSelected[parentModifierGroupId].modifierItemsSelected[parentModifierItemId].modifierItemInstances[parentModifierInstanceId].nestedModifierGroupsSelected[childModifierGroupId].modifierItemsSelected = action.payload.nestedModifierItemsSelected;
        calcOrderTotalsWithAlternativePrice(state[orderId]);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        break;
      }
      case SET_MODIFIER_PRICE: {
        const { orderId, ticketElementId } = action.payload;
        state[orderId].ticketElements[ticketElementId].selectedModifiersPricePerItemUnit = (state[orderId].ticketElements[ticketElementId].selectedModifiersPricePerItemUnit || 0) + (action.payload.selectedModifiersPriceDifference || 0);
        state[orderId].ticketElements[ticketElementId].modifierGroupsSelected[action.payload.modifierGroupSelected.modifierGroupId] = action.payload.modifierGroupSelected;
        calcOrderTotalsWithAlternativePrice(state[orderId]);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        break;
      }
      case DELETE_NESTED_MODIFIER_ITEM_SELECTED:
        deleteNestedModifierItemSelected2(
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
          action.payload.parentModifierGroupId,
          action.payload.parentModifierItemId,
          action.payload.parentModifierInstanceId,
          action.payload.nestedModifierGroupId,
          action.payload.nestedModifierItemId
        );
        updateModifierPrice(
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
          action.payload.parentModifierGroupId,
          action.payload.parentModifierItemId,
          action.payload.parentModifierInstanceId,
          action.payload.nestedModifierGroupId
        );
        updateCompletedSections(
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
          action.payload.isSeatingModeEnabled,
          action.payload.parentModifierGroupId,
          action.payload.parentModifierItemId,
          true,
          action.payload.parentModifierInstanceId,
          action.payload.nestedModifierGroupId
        );
        break;
      case DECREMENT_NESTED_MODIFIER_ITEM_SELECTED: {
        const ticketElement = getAndSplitTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.seatSplitRequired,
          action.payload.currentSeat
        );
        decrementNestedModifierItemSelected2(
          ticketElement,
          action.payload.parentModifierGroupId,
          action.payload.parentModifierItemId,
          action.payload.parentModifierInstanceId,
          action.payload.nestedModifierGroupId,
          action.payload.nestedModifierItemId,
          selectSpecialModTagsMetaData.lastResult()
        );
        updateModifierPrice(
          ticketElement,
          action.payload.parentModifierGroupId,
          action.payload.parentModifierItemId,
          action.payload.parentModifierInstanceId,
          action.payload.nestedModifierGroupId
        );
        updateCompletedSections(
          ticketElement,
          action.payload.isSeatingModeEnabled,
          action.payload.parentModifierGroupId,
          action.payload.parentModifierItemId,
          true,
          action.payload.parentModifierInstanceId,
          action.payload.nestedModifierGroupId
        );
        calcTotalItemWithAlternativePrice(ticketElement, {
          orderType: state[action.payload.orderId].type,
          orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
          taxExempt: state[action.payload.orderId].taxExempt,
          noTaxInclusive: state[action.payload.orderId].noTaxInclusive
        });
        ticketElement.updatedAt = getNowUTCDate();
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        break;
      }
      case INCREMENT_NESTED_MODIFIER_ITEM_SELECTED: {
        const ticketElement = getAndSplitTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.seatSplitRequired,
          action.payload.currentSeat
        );
        incrementNestedModifierItemSelected2(
          ticketElement,
          action.payload.parentModifierGroupId,
          action.payload.parentModifierItemId,
          action.payload.parentModifierInstanceId,
          action.payload.nestedModifierGroupId,
          action.payload.nestedModifierItemId,
          selectSpecialModTagsMetaData.lastResult()
        );
        updateModifierPrice(
          ticketElement,
          action.payload.parentModifierGroupId,
          action.payload.parentModifierItemId,
          action.payload.parentModifierInstanceId,
          action.payload.nestedModifierGroupId
        );
        updateCompletedSections(
          ticketElement,
          action.payload.isSeatingModeEnabled,
          action.payload.parentModifierGroupId,
          action.payload.parentModifierItemId,
          true,
          action.payload.parentModifierInstanceId,
          action.payload.nestedModifierGroupId
        );
        calcTotalItemWithAlternativePrice(ticketElement, {
          orderType: state[action.payload.orderId].type,
          orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
          taxExempt: state[action.payload.orderId].taxExempt,
          noTaxInclusive: state[action.payload.orderId].noTaxInclusive
        });
        ticketElement.updatedAt = getNowUTCDate();
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        break;
      }
      case TOGGLE_NESTED_MODIFIER_ITEM_SELECTED: {
        const ticketElement = getAndSplitTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.seatSplitRequired,
          action.payload.currentSeat
        );
        toggleNestedModifierItemSelected2(
          ticketElement,
          action.payload.parentModifierGroupId,
          action.payload.parentModifierItemId,
          action.payload.parentModifierInstanceId,
          action.payload.nestedModifierGroupId,
          action.payload.nestedModifierItemId,
          action.payload.modifierTag,
          action.payload.globalState,
          action.payload.operation,
          selectSpecialModTagsMetaData.lastResult()
        );
        applyModifierTag(
          ticketElement.modifierGroupsSelected[action.payload.parentModifierGroupId].modifierItemsSelected[action.payload.parentModifierItemId].modifierItemInstances[action.payload.parentModifierInstanceId].nestedModifierGroupsSelected[action.payload.nestedModifierGroupId].modifierItemsSelected[action.payload.nestedModifierItemId],
          fixModifierTagForNestedMod(
            action.payload.modifierTag,
            getDefaultModifierGroupsSelectedForNestedMod(
              ticketElement.itemObj,
              action.payload.parentModifierGroupId,
              action.payload.parentModifierItemId,
              action.payload.nestedModifierGroupId
            ),
            action.payload.nestedModifierItemId,
            action.payload.operation
          ),
          action.payload.operation
        );
        updateModifierPrice(
          ticketElement,
          action.payload.parentModifierGroupId,
          action.payload.parentModifierItemId,
          action.payload.parentModifierInstanceId,
          action.payload.nestedModifierGroupId
        );
        updateCompletedSections(
          ticketElement,
          action.payload.isSeatingModeEnabled,
          action.payload.parentModifierGroupId,
          action.payload.parentModifierItemId,
          true,
          action.payload.parentModifierInstanceId,
          action.payload.nestedModifierGroupId
        );
        updateComboItemGroup(
          ticketElement,
          state[action.payload.orderId].combos,
          action.payload.isSeatingModeEnabled
        );
        calcTotalItemWithAlternativePrice(ticketElement, {
          orderType: state[action.payload.orderId].type,
          orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
          taxExempt: state[action.payload.orderId].taxExempt,
          noTaxInclusive: state[action.payload.orderId].noTaxInclusive
        });
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        break;
      }
      case TOGGLE_NONE_NESTED_MODIFIER_ITEM_SELECTED: {
        const ticketElement = getAndSplitTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.seatSplitRequired,
          action.payload.currentSeat
        );
        toggleNoneNestedModifierItemsSelected(
          ticketElement,
          action.payload.parentModifierGroupId,
          action.payload.parentModifierItemId,
          action.payload.parentModifierInstanceId,
          action.payload.nestedModifierGroupId
        );
        updateModifierPrice(
          ticketElement,
          action.payload.parentModifierGroupId,
          action.payload.parentModifierItemId,
          action.payload.parentModifierInstanceId,
          action.payload.nestedModifierGroupId
        );
        updateCompletedSections(
          ticketElement,
          action.payload.isSeatingModeEnabled,
          action.payload.parentModifierGroupId,
          action.payload.parentModifierItemId,
          true,
          action.payload.parentModifierInstanceId,
          action.payload.nestedModifierGroupId
        );
        calcTotalSelectedModifiersPrice(ticketElement);
        calcTotalItemWithAlternativePrice(ticketElement, {
          orderType: state[action.payload.orderId].type,
          orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
          taxExempt: state[action.payload.orderId].taxExempt,
          noTaxInclusive: state[action.payload.orderId].noTaxInclusive
        });
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        break;
      }
      case UPDATE_MODIFIER_PRICE:
        updateModifierPrice(
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
          action.payload.parentModifierGroupId,
          action.payload.parentModifierItemId,
          action.payload.parentModifierInstanceId,
          action.payload.nestedModifierGroupId
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        break;
      case UPDATE_COMPLETED_SECTIONS:
        updateCompletedSections(
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
          action.payload.isSeatingModeEnabled,
          action.payload.parentModifierGroupId,
          action.payload.parentModifierItemId,
          action.payload.isNested,
          action.payload.parentModifierInstanceId,
          action.payload.nestedModifierGroupId
        );
        break;
      case APPLY_DISCOUNT_TO_ITEMS: {
        applyDiscountToItems(
          action.payload.discount,
          action.payload.itemIds,
          state[action.payload.orderId],
          action.payload.removeExclusive,
          action.payload.currentSeat,
          action.payload.checkForSplit
        );
        applyDiscountToCombos(
          action.payload.discount,
          action.payload.comboIds,
          state[action.payload.orderId],
          action.payload.removeExclusive
        );
        action.payload.itemIds.forEach((ticketElementId) => {
          adjustCheckDataForTicketElement(
            state[action.payload.orderId],
            ticketElementId
          );
        });
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        updateChecksTotals(state[action.payload.orderId]);
        break;
      }
      case APPLY_SPECIAL_TO_TICKET: {
        applySpecialsToTicketAndCombos(
          action.payload.specialObjects,
          state[action.payload.orderId],
          state[action.payload.orderId].ticketElements,
          state[action.payload.orderId].combos,
          state[action.payload.orderId].type,
          updateCheckElementForTicketElement,
          updateCheckElementForComboElement
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        updateChecksTotals(state[action.payload.orderId]);
        break;
      }
      case RESET_TICKET_SPECIALS: {
        const order = state[action.payload.orderId];
        resetSpecialsOnRemovedInstances(
          order,
          action.payload.specialsIndexesToReset
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        break;
      }
      case ADD_SPECIAL_ORDER_OBJECT: {
        if (!state[action.payload.orderId].bogoSpecialsObj)
          state[action.payload.orderId].bogoSpecialsObj = {};
        Object.assign(
          state[action.payload.orderId].bogoSpecialsObj,
          action.payload.specialObjects
        );
        break;
      }
      case UPDATE_TICKET_ELEMENT_DISCOUNT: {
        const ticketElement = getAndSplitTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.seatSplitRequired,
          action.payload.currentSeat
        );
        updateItemDiscountObjectByIdOrTabletGeneratedId(
          ticketElement,
          action.payload.discount,
          action.payload.discountId,
          action.payload.tabletGeneratedId,
          action.payload.isCustom
        );
        action.payload.isCustom && calcTotalItemWithAlternativePrice(ticketElement, {
          orderType: state[action.payload.orderId].type,
          orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
          taxExempt: state[action.payload.orderId].taxExempt,
          noTaxInclusive: state[action.payload.orderId].noTaxInclusive
        });
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        if (action.payload.isCustom) {
          calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
          updateChecksTotals(state[action.payload.orderId]);
        }
        break;
      }
      case UPDATE_TICKET_COMBO_DISCOUNT: {
        updateComboDiscountObjectByIdOrTabletGeneratedId(
          state[action.payload.orderId].combos[action.payload.ticketElementId],
          action.payload.discount,
          action.payload.discountId,
          action.payload.tabletGeneratedId,
          action.payload.isCustom
        );
        action.payload.isCustom && calcTotalComboWithAlternativePrice(
          state[action.payload.orderId].combos[action.payload.ticketElementId],
          {
            orderType: state[action.payload.orderId].type,
            taxExempt: state[action.payload.orderId].taxExempt,
            noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
            orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
          }
        );
        updateCheckElementForComboElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        if (action.payload.isCustom) {
          calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
          updateChecksTotals(state[action.payload.orderId]);
        }
        break;
      }
      case REMOVE_DISCOUNT_FROM_ITEM: {
        const ticketElement = getAndSplitTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.seatSplitRequired,
          action.payload.currentSeat
        );
        removeItemDiscountByIdOrTabletGeneratedId(
          ticketElement,
          action.payload.id,
          action.payload.tabletGeneratedId
        );
        calcTotalItemWithAlternativePrice(ticketElement, {
          orderType: state[action.payload.orderId].type,
          orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
          taxExempt: state[action.payload.orderId].taxExempt,
          noTaxInclusive: state[action.payload.orderId].noTaxInclusive
        });
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        break;
      }
      case REMOVE_DISCOUNT_FROM_COMBO: {
        removeComboDiscountByIdOrTabletGeneratedId(
          state[action.payload.orderId].combos[action.payload.ticketElementId],
          action.payload.id,
          action.payload.tabletGeneratedId
        );
        calcTotalComboWithAlternativePrice(
          state[action.payload.orderId].combos[action.payload.ticketElementId],
          {
            orderType: state[action.payload.orderId].type,
            taxExempt: state[action.payload.orderId].taxExempt,
            noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
            orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
          }
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        updateCheckElementForComboElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        updateChecksTotals(state[action.payload.orderId]);
        break;
      }
      case APPLY_DISCOUNT_TO_ORDER:
        setDiscountToOrder(
          action.payload.discount,
          state[action.payload.orderId],
          action.payload.removeExclusive
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        updateChecksTotals(state[action.payload.orderId]);
        break;
      case UPDATE_ORDER_DISCOUNT:
        updateOrderDiscountObjectByIdOrTabletGeneratedId(
          state[action.payload.orderId],
          action.payload.discount,
          action.payload.discountId,
          action.payload.tabletGeneratedId,
          action.payload.isCustom
        );
        action.payload.isCustom && calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        updateChecksTotals(state[action.payload.orderId]);
        break;
      case REMOVE_DISCOUNT_FROM_ORDER:
        removeOrderDiscountByIdOrTabletGeneratedId(
          state[action.payload.orderId],
          action.payload.id,
          action.payload.tabletGeneratedId
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        updateChecksTotals(state[action.payload.orderId]);
        break;
      case UNGROUP_TICKET_ELEMENT_BY_SEATS:
      case UNGROUP_COMBO_ELEMENT_BY_SEATS: {
        let originalTicketElementId;
        let ungroupingResult;
        let originalItemElementIds = [];
        if (action.payload.isCombo) {
          ungroupingResult = ungroupComboElementBySeats(
            state[action.payload.orderId].combos,
            state[action.payload.orderId].ticketElements,
            action.payload.ticketElementSeatMap
          );
          originalItemElementIds = [
            ...state[action.payload.orderId].combos[action.payload.ticketElementSeatMap[0].ticketElementId].instanceIds
          ];
          originalTicketElementId = ungroupingResult.originalTicketElementId;
        } else {
          originalItemElementIds = [
            ...state[action.payload.orderId].ticketElements[action.payload.ticketElementSeatMap[0].ticketElementId].instanceIds
          ];
          ungroupingResult = ungroupTicketElementBySeatsReducer(
            state[action.payload.orderId].ticketElements,
            action.payload.ticketElementSeatMap
          );
          originalTicketElementId = ungroupingResult.originalTicketElementId;
        }
        handleElementUngroupBySeat(
          state[action.payload.orderId],
          originalTicketElementId,
          action.payload.ticketElementSeatMap,
          action.payload.isCombo,
          ungroupingResult
        );
        if (action.payload.isCombo) {
          ungroupingResult.newTicketElementIds.forEach((ticketElementId) => {
            calcTotalComboWithAlternativePrice(
              state[action.payload.orderId].combos[ticketElementId],
              {
                orderType: state[action.payload.orderId].type,
                taxExempt: state[action.payload.orderId].taxExempt,
                noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
                orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
              }
            );
          });
          calcTotalComboWithAlternativePrice(
            state[action.payload.orderId].combos[originalTicketElementId],
            {
              orderType: state[action.payload.orderId].type,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
            }
          );
        } else {
          updateElementAfterSplitBySeats(
            state[action.payload.orderId].ticketElements,
            action.payload.ticketElementSeatMap,
            originalItemElementIds,
            state[action.payload.orderId].bogoSpecialsSelected,
            state[action.payload.orderId].type,
            state[action.payload.orderId].taxExempt,
            state[action.payload.orderId].noTaxInclusive,
            state[action.payload.orderId].isLockedPrice
          );
          calcTotalItemWithAlternativePrice(
            state[action.payload.orderId].ticketElements[originalTicketElementId],
            {
              orderType: state[action.payload.orderId].type,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive
            }
          );
          ungroupingResult.newTicketElementIds.forEach((ticketElementId) => {
            calcTotalItemWithAlternativePrice(
              state[action.payload.orderId].ticketElements[ticketElementId],
              {
                orderType: state[action.payload.orderId].type,
                orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
                taxExempt: state[action.payload.orderId].taxExempt,
                noTaxInclusive: state[action.payload.orderId].noTaxInclusive
              }
            );
          });
        }
        action.payload.ticketElementSeatMap.forEach((seatMap) => {
          removeCheckDataForTicketElement(
            state[action.payload.orderId],
            seatMap.ticketElementId,
            action.payload.isCombo,
            seatMap.seatId,
            void 0,
            true
          );
          createCheckDataForTicketElement(
            state[action.payload.orderId],
            state[action.payload.orderId].defaultCheckId,
            seatMap.ticketElementId,
            action.payload.isCombo,
            seatMap.seatId
          );
          action.payload.isCombo ? updateCheckElementForComboElement(
            state[action.payload.orderId],
            seatMap.ticketElementId
          ) : updateCheckElementForTicketElement(
            state[action.payload.orderId],
            seatMap.ticketElementId
          );
        });
        autoSplitChecks(state[action.payload.orderId]);
        updateChecksTotals(state[action.payload.orderId]);
        break;
      }
      case UNGROUP_TICKET_ELEMENT_BY_SINGLE_SEAT:
      case UNGROUP_COMBO_ELEMENT_BY_SINGLE_SEAT: {
        if (action.payload.isCombo) {
          ungroupComboElementBySingleSeat(
            state[action.payload.orderId].combos,
            state[action.payload.orderId].ticketElements,
            action.payload.ticketElementId,
            action.payload.newTicketElementId,
            action.payload.seatId,
            action.payload.quantity
          );
          calcTotalComboWithAlternativePrice(
            state[action.payload.orderId].combos[action.payload.ticketElementId],
            {
              orderType: state[action.payload.orderId].type,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
            }
          );
          calcTotalComboWithAlternativePrice(
            state[action.payload.orderId].combos[action.payload.newTicketElementId],
            {
              orderType: state[action.payload.orderId].type,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
            }
          );
        } else {
          ungroupTicketElementBySingleSeatReducer(
            state[action.payload.orderId].ticketElements,
            action.payload.ticketElementId,
            action.payload.newTicketElementId,
            action.payload.seatId,
            action.payload.quantity,
            state[action.payload.orderId].bogoSpecialsSelected,
            state[action.payload.orderId].type,
            state[action.payload.orderId].taxExempt,
            state[action.payload.orderId].noTaxInclusive,
            state[action.payload.orderId].isLockedPrice
          );
          calcTotalItemWithAlternativePrice(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
            {
              orderType: state[action.payload.orderId].type,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive
            }
          );
          calcTotalItemWithAlternativePrice(
            state[action.payload.orderId].ticketElements[action.payload.newTicketElementId],
            {
              orderType: state[action.payload.orderId].type,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive
            }
          );
        }
        removeCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.isCombo,
          action.payload.seatId,
          void 0,
          true
        );
        createCheckDataForTicketElement(
          state[action.payload.orderId],
          state[action.payload.orderId].defaultCheckId,
          action.payload.ticketElementId,
          action.payload.isCombo,
          action.payload.seatId
        );
        createCheckDataForTicketElement(
          state[action.payload.orderId],
          state[action.payload.orderId].defaultCheckId,
          action.payload.newTicketElementId,
          action.payload.isCombo,
          action.payload.seatId
        );
        if (action.payload.isCombo) {
          updateCheckElementForComboElement(
            state[action.payload.orderId],
            action.payload.ticketElementId
          );
          updateCheckElementForComboElement(
            state[action.payload.orderId],
            action.payload.newTicketElementId
          );
        } else {
          updateCheckElementForTicketElement(
            state[action.payload.orderId],
            action.payload.ticketElementId
          );
          updateCheckElementForTicketElement(
            state[action.payload.orderId],
            action.payload.newTicketElementId
          );
        }
        autoSplitChecks(state[action.payload.orderId]);
        updateChecksTotals(state[action.payload.orderId]);
        break;
      }
      case UNGROUP_TICKET_ELEMENT_BY_QTY:
      case UNGROUP_COMBO_ELEMENT_BY_QTY: {
        if (action.payload.isCombo) {
          ungroupComboElementByQty(
            state[action.payload.orderId].combos,
            state[action.payload.orderId].ticketElements,
            action.payload.ticketElementId,
            action.payload.quantity,
            action.payload.newTicketElementId
          );
          calcTotalComboWithAlternativePrice(
            state[action.payload.orderId].combos[action.payload.ticketElementId],
            {
              orderType: state[action.payload.orderId].type,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
            }
          );
          calcTotalComboWithAlternativePrice(
            state[action.payload.orderId].combos[action.payload.newTicketElementId],
            {
              orderType: state[action.payload.orderId].type,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
            }
          );
        } else {
          ungroupTicketElementByQtyReducer(
            state[action.payload.orderId].ticketElements,
            action.payload.ticketElementId,
            action.payload.quantity,
            action.payload.newTicketElementId,
            state[action.payload.orderId].bogoSpecialsSelected,
            state[action.payload.orderId].type,
            state[action.payload.orderId].taxExempt,
            state[action.payload.orderId].noTaxInclusive,
            state[action.payload.orderId].isLockedPrice
          );
          calcTotalItemWithAlternativePrice(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
            {
              orderType: state[action.payload.orderId].type,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive
            }
          );
          calcTotalItemWithAlternativePrice(
            state[action.payload.orderId].ticketElements[action.payload.newTicketElementId],
            {
              orderType: state[action.payload.orderId].type,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive
            }
          );
        }
        removeCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.isCombo,
          void 0,
          void 0,
          true
        );
        createCheckDataForTicketElement(
          state[action.payload.orderId],
          state[action.payload.orderId].defaultCheckId,
          action.payload.ticketElementId,
          action.payload.isCombo,
          void 0
        );
        createCheckDataForTicketElement(
          state[action.payload.orderId],
          state[action.payload.orderId].defaultCheckId,
          action.payload.newTicketElementId,
          action.payload.isCombo,
          void 0
        );
        if (action.payload.isCombo) {
          updateCheckElementForComboElement(
            state[action.payload.orderId],
            action.payload.ticketElementId
          );
          updateCheckElementForComboElement(
            state[action.payload.orderId],
            action.payload.newTicketElementId
          );
        } else {
          updateCheckElementForTicketElement(
            state[action.payload.orderId],
            action.payload.ticketElementId
          );
          updateCheckElementForTicketElement(
            state[action.payload.orderId],
            action.payload.newTicketElementId
          );
        }
        autoSplitChecks(state[action.payload.orderId]);
        updateChecksTotals(state[action.payload.orderId]);
        break;
      }
      case TOGGLE_TICKET_ELEMENT_ON_HOLD: {
        const ticketElement = getAndSplitTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.seatSplitRequired,
          action.payload.currentSeat
        );
        ticketElement.isOnHold = !ticketElement.isOnHold;
        handleQuantityChange(ticketElement);
        updateChecksTotals(state[action.payload.orderId]);
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        break;
      }
      case UPDATE_TICKET_ELEMENT_BASE_PRICE:
      case UPDATE_COMBO_ELEMENT_BASE_PRICE: {
        if (action.payload.isCombo) {
          setComboBasePrice(
            state[action.payload.orderId].combos[action.payload.ticketElementId],
            action.payload.overridePrice
          );
        } else {
          const ticketElement = state[action.payload.orderId].ticketElements[action.payload.ticketElementId];
          ticketElement.overridePricePerItemUnit = action.payload.overridePrice;
          ticketElement.isPriceOverride = true;
          calcTotalItemWithAlternativePrice(ticketElement, {
            orderType: state[action.payload.orderId].type,
            orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
            taxExempt: state[action.payload.orderId].taxExempt,
            noTaxInclusive: state[action.payload.orderId].noTaxInclusive
          });
        }
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.isCombo
        );
        break;
      }
      case REVERT_TICKET_ELEMENT_BASE_PRICE:
      case REVERT_COMBO_ELEMENT_BASE_PRICE: {
        if (action.payload.isCombo) {
          revertComboPrice(
            state[action.payload.orderId].combos[action.payload.ticketElementId]
          );
        } else {
          const ticketElement = state[action.payload.orderId].ticketElements[action.payload.ticketElementId];
          ticketElement.isPriceOverride = false;
          ticketElement.overridePricePerItemUnit = 0;
          calcTotalItemWithAlternativePrice(ticketElement, {
            orderType: state[action.payload.orderId].type,
            orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
            taxExempt: state[action.payload.orderId].taxExempt,
            noTaxInclusive: state[action.payload.orderId].noTaxInclusive
          });
        }
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.isCombo
        );
        break;
      }
      case CLEAR_UNSENT_ITEMS: {
        if (action.payload.checkForSplit)
          clearUnsentTicketElementsAndSplit(
            state[action.payload.orderId],
            action.payload.ticketElementIds,
            action.payload.ignoredTicketElementIds,
            action.payload.currentSeat,
            action.payload.checkForSplit
          );
        else {
          clearCheckElementsForUnSentElements(
            state[action.payload.orderId],
            action.payload.clearableCombos,
            action.payload.ignoredTicketElementIds
          );
          clearUnsentTicketElements(
            state[action.payload.orderId].ticketElements,
            action.payload.clearableCombos,
            action.payload.ignoredTicketElementIds
          );
          clearCombos(
            state[action.payload.orderId],
            action.payload.clearableCombos
          );
        }
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        updateChecksTotals(state[action.payload.orderId]);
        break;
      }
      case COPY_SENT_TICKET_ELEMENT_CONFIG:
        copySentTicketElementConfig(
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId]
        );
        break;
      case RESET_MODIFIER_GROUP_SELECTED_TO_CONFIG_WHEN_SENT:
        if (action.payload.isIngredientsActive) {
          resetIngredientsSelectedToConfigWhenSent(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId]
          );
        } else
          resetModifierGroupSelectedToConfigWhenSent2(
            state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
            action.payload.modifierGroupId
          );
        updateCompletedSections(
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
          action.payload.isSeatingModeEnabled,
          action.payload.modifierGroupId
        );
        calcTotalSelectedModifiersPrice(
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId]
        );
        calcTotalItemWithAlternativePrice(
          state[action.payload.orderId].ticketElements[action.payload.ticketElementId],
          {
            orderType: state[action.payload.orderId].type,
            orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
            taxExempt: state[action.payload.orderId].taxExempt,
            noTaxInclusive: state[action.payload.orderId].noTaxInclusive
          }
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        adjustCheckDataForTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        break;
      case KITCHEN_PRINTING_ERROR:
      case KITCHEN_PRINTING_ERROR_WS:
        updateOrderWithPrintingErrors(
          state[action.payload.orderId],
          action.payload
        );
        state[action.payload.orderId].hasUnsentItems = getOrderHasUnsentItems(
          state[action.payload.orderId]
        );
        break;
      case KITCHEN_ITEM_CLEAR_PRINTING_ERROR:
        clearOrderItemPrintingError(
          state[action.payload.orderId],
          action.payload.ticketElementId
        );
        state[action.payload.orderId].hasUnsentItems = getOrderHasUnsentItems(
          state[action.payload.orderId]
        );
        break;
      case ROLL_UP_TICKET_ELEMENTS:
        adjustRedundantCheckElementsAndTicketElementToCheckElements(
          state[action.payload.orderId],
          action.payload.ticketElementIds
        );
        rollUpTicketElements2(
          state[action.payload.orderId].ticketElements,
          action.payload.ticketElementIds,
          state[action.payload.orderId].bogoSpecialsSelected,
          state[action.payload.orderId].bogoSpecialsObj,
          state[action.payload.orderId].type,
          state[action.payload.orderId].taxExempt,
          state[action.payload.orderId].isLockedPrice,
          state[action.payload.orderId].noTaxInclusive
        );
        action.payload.ticketElementIds.forEach(({ uniqueId }) => {
          calcTotalItemWithAlternativePrice(
            state[action.payload.orderId].ticketElements[uniqueId],
            {
              orderType: state[action.payload.orderId].type,
              orderIsLockedPrice: state[action.payload.orderId].isLockedPrice,
              taxExempt: state[action.payload.orderId].taxExempt,
              noTaxInclusive: state[action.payload.orderId].noTaxInclusive
            }
          );
          distributeAndUpdatePriceDataToCheckElements(
            state[action.payload.orderId],
            uniqueId
          );
        });
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        autoSplitChecks(state[action.payload.orderId]);
        checkAndDisplayCheckElementsRollUp(state[action.payload.orderId]);
        updateChecksTotals(state[action.payload.orderId]);
        break;
      case ROLL_UP_COMBO_ELEMENTS:
        adjustRedundantCheckElementsAndTicketElementToCheckElements(
          state[action.payload.orderId],
          action.payload.comboElementIds,
          true
        );
        rollUpComboElements(
          state[action.payload.orderId],
          action.payload.comboElementIds,
          state[action.payload.orderId].bogoSpecialsSelected,
          state[action.payload.orderId].bogoSpecialsObj
        );
        action.payload.comboElementIds.forEach(({ uniqueId }) => {
          calcTotalComboWithAlternativePrice(state[action.payload.orderId].combos[uniqueId], {
            orderType: state[action.payload.orderId].type,
            taxExempt: state[action.payload.orderId].taxExempt,
            noTaxInclusive: state[action.payload.orderId].noTaxInclusive,
            orderIsLockedPrice: state[action.payload.orderId].isLockedPrice
          });
          updateCheckElementForComboElement(
            state[action.payload.orderId],
            uniqueId
          );
        });
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        autoSplitChecks(state[action.payload.orderId]);
        checkAndDisplayCheckElementsRollUp(state[action.payload.orderId]);
        updateChecksTotals(state[action.payload.orderId]);
        break;
      case TOGGLE_ITEM_INGREDIENT:
        {
          const ticketElement = getAndSplitTicketElement(
            state[action.payload.orderId],
            action.payload.ticketElementId,
            action.payload.seatSplitRequired,
            action.payload.currentSeat
          );
          toggleTicketElementIngredient(
            ticketElement,
            action.payload.ingredientId,
            action.payload.modifierTagObject
          );
        }
        break;
      case INCREMENT_ITEM_INGREDIENT: {
        const ticketElement = getAndSplitTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.seatSplitRequired,
          action.payload.currentSeat
        );
        incrementTicketElementIngredientSize(
          ticketElement,
          action.payload.ingredientId
        );
        break;
      }
      case DECREMENT_ITEM_INGREDIENT: {
        const ticketElement = getAndSplitTicketElement(
          state[action.payload.orderId],
          action.payload.ticketElementId,
          action.payload.seatSplitRequired,
          action.payload.currentSeat
        );
        decrementTicketElementIngredientSize(
          ticketElement,
          action.payload.ingredientId
        );
        break;
      }
      case ADD_CHECK_PAYMENT:
        addCheckPayment2(
          state[action.payload.orderId],
          action.payload.checkId,
          action.payload.payment
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        checkAndDisplayCheckElementsRollUp(state[action.payload.orderId], [
          action.payload.checkId
        ]);
        updateChecksTotals(state[action.payload.orderId], [
          String(action.payload.checkId)
        ]);
        break;
      case VOID_PAYMENT:
        voidPayment(state[action.payload.orderId], action.payload.payment);
        updateChecksTotals(state[action.payload.orderId]);
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        break;
      case TRANSFER_PAYMENT:
        transferPayment(
          state[action.payload.orderId],
          state[action.payload.transferredOrderId],
          action.payload.transferredCheckId,
          action.payload.payment
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        calcOrderTotalsWithAlternativePrice(state[action.payload.transferredOrderId]);
        updateChecksTotals(state[action.payload.orderId]);
        updateChecksTotals(state[action.payload.transferredOrderId]);
        break;
      case UPDATE_PAYMENT:
        updatePayment(state[action.payload.orderId], action.payload.payment);
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId]);
        break;
      case CREATE_CHECK:
        createCheck2(
          state[action.payload.orderId],
          action.payload.checkDefaults
        );
        break;
      case MOVE_CHECK_ELEMENTS: {
        if (!state[action.payload.orderId].checks[action.payload.checkToId]) {
          state[action.payload.orderId].checks[action.payload.checkToId] = createCheck2(
            state[action.payload.orderId],
            {},
            action.payload.checkToId
          );
        }
        transferCheckElements(
          state[action.payload.orderId],
          action.payload.checkElementIds,
          action.payload.checkToId
        );
        rollUpCheckElementsNew(state[action.payload.orderId], [
          action.payload.checkToId
        ]);
        resetDisplayCheckElements(state[action.payload.orderId], [
          action.payload.checkToId
        ]);
        rollUpDisplayCheckElements(state[action.payload.orderId], [
          action.payload.checkToId
        ]);
        updateChecksTotals(state[action.payload.orderId]);
        break;
      }
      case MOVE_PAYMENTS:
        if (!state[action.payload.orderId].checks[action.payload.checkToId]) {
          state[action.payload.orderId].checks[action.payload.checkToId] = createCheck2(
            state[action.payload.orderId],
            {},
            action.payload.checkToId
          );
        }
        transferPayments(
          state[action.payload.orderId],
          action.payload.paymentsToCheckIdsMap,
          action.payload.checkToId
        );
        updateChecksTotals(state[action.payload.orderId]);
        break;
      case CLOSE_CHECK: {
        setChecksStatus(
          state[action.payload.orderId],
          [action.payload.checkId],
          "closed" /* CLOSED */
        );
        break;
      }
      case RENAME_CHECK:
        renameCheck(
          state[action.payload.orderId],
          action.payload.checkId,
          action.payload.newName
        );
        break;
      case DELETE_EDITABLE_CHECK: {
        deleteEditableCheck2(
          state[action.payload.orderId],
          action.payload.checkId
        );
        checkAndDisplayCheckElementsRollUp(state[action.payload.orderId]);
        updateChecksTotals(state[action.payload.orderId]);
        break;
      }
      case DELETE_EMPTY_CHECKS:
        deleteEmptyChecks(state[action.payload.orderId]);
        break;
      case DELETE_ALL_EDITABLE_CHECKS: {
        resetChecksData(state[action.payload.orderId]);
        checkAndDisplayCheckElementsRollUp(state[action.payload.orderId]);
        updateChecksTotals(state[action.payload.orderId]);
        break;
      }
      case MERGE_CHECKS: {
        mergeChecks2(state[action.payload.orderId], action.payload.checkIds);
        checkAndDisplayCheckElementsRollUp(state[action.payload.orderId]);
        updateChecksTotals(state[action.payload.orderId]);
        break;
      }
      case UN_SPLIT_CHECK_ELEMENT:
        unSplitCheckElementHelper(
          state[action.payload.orderId],
          action.payload.checkId,
          action.payload.checkElementId
        );
        break;
      case ROLL_UP_CHECK_ELEMENTS: {
        checkAndDisplayCheckElementsRollUp(state[action.payload.orderId]);
        break;
      }
      case UPDATE_CHECK_ORDER_DISCOUNTS:
        updateChecksTotals(state[action.payload.orderId]);
        break;
      case VOID_ALL_CHECKS:
        voidAllChecks2(state[action.payload.orderId]);
        break;
      case DUMP_DEFAULT_CHECK:
        dumpDefaultCheck2(state[action.payload.orderId]);
        break;
      case CLEAN_DISPLAY_CHECK_ELEMENTS: {
        cleanDisplayCheckElements2(state[action.payload.orderId], [
          String(action.payload.checkId)
        ]);
        break;
      }
      case CREATE_DISPLAY_CHECK_ELEMENTS: {
        generateDisplayCheckElements(state[action.payload.orderId], [
          String(action.payload.checkId)
        ]);
        break;
      }
      case SPLIT_CHECK_ELEMENT_EVENLY: {
        splitCheckElementToAllNonDefaultAvailableChecks(
          state[action.payload.orderId],
          action.payload.checkElementId,
          action.payload.checkFromId
        );
        checkAndDisplayCheckElementsRollUp(state[action.payload.orderId]);
        updateChecksTotals(state[action.payload.orderId]);
        break;
      }
      case SPLIT_CHECK_ELEMENTS_WAYS: {
        if (action.payload.ways === 1)
          break;
        splitCheckElementsNWays(
          state[action.payload.orderId],
          action.payload.checkElementIds,
          action.payload.ways
        );
        break;
      }
      case UNGROUP_CHECK_ELEMENTS:
        unGroupDisplayCheckElements(
          state[action.payload.orderId],
          action.payload.checkElementIds
        );
        break;
      case SPLIT_CHECK_BY_SEATS: {
        splitDefaultCheckBySeat(state[action.payload.orderId]);
        updateChecksTotals(state[action.payload.orderId]);
        autoTransferPaymentsBasedOnCheckBalanceDue(
          state[action.payload.orderId]
        );
        checkAndDisplayCheckElementsRollUp(state[action.payload.orderId]);
        break;
      }
      case SPLIT_CHECK_ELEMENT_BY_SEATS:
        splitCheckElementBySeatReducerHelper(
          state[action.payload.orderId],
          action.payload.checkElementIds
        );
        checkAndDisplayCheckElementsRollUp(state[action.payload.orderId]);
        updateChecksTotals(state[action.payload.orderId]);
        break;
      case SPLIT_CHECK_INTO_N_NEW_CHECKS:
        splitDefaultCheckInNWays(
          state[action.payload.orderId],
          action.payload.newCheckIds.length,
          action.payload.checkElementIds
        );
        checkAndDisplayCheckElementsRollUp(state[action.payload.orderId]);
        break;
      case OPEN_CHECK: {
        setChecksStatus(
          state[action.payload.orderId],
          [action.payload.checkId],
          "paid" /* PAID */
        );
        updateChecksTotals(state[action.payload.orderId]);
        break;
      }
      case VOID_CHECK:
        voidCheck(state[action.payload.orderId], action.payload.checkId);
        break;
      case ADD_REGISTER_OPEN_ITEM: {
        addNewOpenItem(
          state[action.payload.orderId].ticketElements,
          action.payload,
          selectIsDualPricingEnabled.lastResult()
        );
        calcOrderTotalsWithAlternativePrice(state[action.payload.orderId], true);
        const seating = action.payload.globalState.settings.selectedMode.currentSettings.register.seating;
        const globalQuantity = (_n = action.payload.globalState.register.registerNavigation.quantity) != null ? _n : 1;
        const ticketElementSeating = state[action.payload.orderId].ticketElements[action.payload.tabletGeneratedId].seating;
        const isTicketElementSeatingEmpty = isEmpty(ticketElementSeating);
        if (!seating || state[action.payload.orderId].tableId === null || !isTicketElementSeatingEmpty) {
          createCheckDataAndUpdateCheckForTicketElement(
            state[action.payload.orderId],
            action.payload.tabletGeneratedId,
            false,
            !isTicketElementSeatingEmpty ? Number(Object.keys(ticketElementSeating)[0]) : void 0,
            !isTicketElementSeatingEmpty ? Number(Object.values(ticketElementSeating)[0]) : globalQuantity
          );
        }
        break;
      }
      case APPLY_PAYMENT_TIP_ADJUSTMENT: {
        action.payload.tipList.forEach((paymentData) => {
          const order = state[paymentData.orderId];
          let check = order.checks[paymentData.checkId];
          if (!check) {
            const realCheck = Object.entries(order.checks).filter(
              ([, value]) => value.id === paymentData.checkId
            );
            if (realCheck.length > 0) {
              check = order.checks[realCheck[0][0]];
            }
          }
          const payment = check.payments[paymentData.paymentId];
          if (paymentData.tipError) {
            payment.tipError = paymentData.tipError;
            payment.userConfirmedTip = payment.userConfirmedTip || false;
          } else {
            payment.tip = paymentData.tip;
            payment.total = payment.baseAmount + payment.tip;
            payment.tipError = null;
            payment.userConfirmedTip = true;
          }
          check.tip = Object.values(check.payments).filter(
            (checkPayment) => !checkPayment.tipError && checkPayment.status !== "voided" /* VOIDED */ && checkPayment.status !== "refunded" /* REFUNDED */
          ).reduce((acc, current) => acc + current.tip, 0);
          calcOrderTotalsWithAlternativePrice(order);
        });
        break;
      }
      case UPDATE_FIRE_TIMES_FIELD: {
        if (state[action.payload.orderId])
          return __spreadProps(__spreadValues({}, state), {
            [action.payload.orderId]: __spreadProps(__spreadValues({}, state[action.payload.orderId]), {
              fireTimes: [
                action.payload.time,
                ...state[action.payload.orderId].fireTimes || []
              ]
            })
          });
        break;
      }
      case SWITCH_PRICE_LIST: {
        const order = state[action.payload.orderId];
        order.listPrice = action.payload.priceList;
        const mainOrderPrices = {
          balanceDue: order.balanceDue,
          orderDiscounts: order.orderDiscounts,
          orderSpecials: order.orderSpecials,
          serviceChargeTaxTotal: order.serviceChargeTaxTotal,
          serviceChargeTotal: order.serviceChargeTotal,
          subtotal: order.subtotal,
          tax: order.tax,
          tip: order.tip,
          total: order.total,
          totalDiscountsAndSpecials: order.totalDiscountsAndSpecials
        };
        Object.assign(order, order.alternativePriceData);
        order.alternativePriceData = mainOrderPrices;
        Object.values(order.ticketElements).forEach((ticketElement) => {
          let originalPriceData = {};
          if (ticketElement.isOpenItem) {
            originalPriceData = getOpenItemMainPriceDataObject(ticketElement);
          } else {
            originalPriceData = getItemMainPriceDataObject(ticketElement);
          }
          Object.assign(ticketElement, ticketElement.alternativePriceData);
          ticketElement.alternativePriceData = originalPriceData;
          updateCheckElementForTicketElement(
            order,
            getTicketElementId(ticketElement),
            true
          );
        });
        updateChecksTotals(order);
        checkAndDisplayCheckElementsRollUp(order);
        if (action.payload.lockPrice)
          order.isLockedPrice = true;
        break;
      }
      default:
        return state;
    }
  }
);
var getItemMainPriceDataObject = (itemOrOpenItem) => {
  return {
    baseItemPrice: itemOrOpenItem.baseItemPrice,
    discounts: itemOrOpenItem.discounts,
    selectedModifiersPricePerItemUnit: itemOrOpenItem.selectedModifiersPricePerItemUnit,
    taxDetails: itemOrOpenItem.taxDetails,
    taxInclusiveSelectedModifiersPricePerItemUnit: itemOrOpenItem.taxInclusiveSelectedModifiersPricePerItemUnit,
    totalDiscountAmount: itemOrOpenItem.totalDiscountAmount,
    totalPricePerItemUnit: itemOrOpenItem.totalPricePerItemUnit,
    totalTax: itemOrOpenItem.totalTax,
    totalPriceWithDiscountsSpecialsNotTaxes: itemOrOpenItem.totalPriceWithDiscountsSpecialsNotTaxes,
    specials: itemOrOpenItem.specials,
    totalSpecialsAmount: itemOrOpenItem.totalSpecialsAmount,
    totalSpecialsBOGOAmount: itemOrOpenItem.totalSpecialsBOGOAmount
  };
};
var getOpenItemMainPriceDataObject = (openItem) => {
  return {
    baseItemPrice: openItem.baseItemPrice,
    discounts: openItem.discounts,
    selectedModifiersPricePerItemUnit: openItem.selectedModifiersPricePerItemUnit,
    taxDetails: openItem.taxDetails,
    taxInclusiveSelectedModifiersPricePerItemUnit: openItem.taxInclusiveSelectedModifiersPricePerItemUnit,
    totalDiscountAmount: openItem.totalDiscountAmount,
    totalPricePerItemUnit: openItem.totalPricePerItemUnit,
    totalTax: openItem.totalTax,
    totalPriceWithDiscountsSpecialsNotTaxes: openItem.totalPriceWithDiscountsSpecialsNotTaxes,
    specials: null
  };
};

// src/state/register/reducers.ts
var DRAWER_MANAGEMENT_NAVIGATION_INITIAL_STATE = {
  selectedDrawer: null,
  selectedAction: null,
  actionData: null,
  settlement: false
};
var REGISTER_NAVIGATION_INITIAL_STATE = {
  menuTypeId: null,
  categoryId: null,
  subcategoryId: null,
  itemId: null,
  comboId: null,
  comboElementId: null,
  orderId: null,
  ticketElementId: null,
  skipInventoryCheck: false,
  modifyingSentTicketElementId: null,
  modifierGroupId: null,
  prevModGroupTypeModGroupId: null,
  modifierItemInstanceId: null,
  isAllModsEnabled: false,
  nestedModifierGroupId: null,
  activeItems: [],
  menuMode: null,
  isPreviewEditEnabled: false,
  isSeatSelectionActive: false,
  isPreviewMode: false,
  quantity: null,
  customQuantityInput: null,
  orderNumberPrinterId: null,
  seats: {},
  seatTags: {},
  modifierTag: null,
  isShared: null,
  ticketMultiselectMode: null,
  currentSeat: ALL_SEATS,
  disablePreviewDeleteEnabled: false,
  suggestiveOrderingModal: {
    active: false,
    itemId: null,
    menuTypeId: null,
    prompt: null,
    suggestivePrice: null,
    onContinue: null
  },
  itemGroupId: null,
  VAOData: VAO_DATA_INITIAL_STATE,
  drawerManagement: DRAWER_MANAGEMENT_NAVIGATION_INITIAL_STATE,
  courseNumber: null,
  tableId: null,
  detailsOverlay: false,
  modifierItemHotButtonSelectedId: null,
  hotButtonsModItemModGroupId: null,
  lastVisitedScreen: null,
  isMultiSeatEnabled: false,
  itemGroupInstance: null,
  omitChecksAndPaymentsCheckToCloseOrder: false,
  isSeatTagModeEnabled: false,
  activeTab: "ticket",
  promptForPriceItemId: null,
  barCode: null
};
var ORDER_SEARCH_RESULTS_INITIAL_STATE = {
  orders: [],
  currentPage: 0,
  totalPages: 0,
  total: 0,
  lastFilters: {},
  selectedMainOrder: null,
  barCodeOrder: null
};
var stationCounterReducer = (state = 0, { type, payload }) => type === SET_STATION_COUNTER ? payload : state;
var hotButtonsReducer = (state = { showHotButtons: false, useHotButtonsAnimation: false }, { type, payload }) => {
  switch (type) {
    case SET_TOGGLE_HOT_BUTTONS:
      return __spreadProps(__spreadValues({}, state), { showHotButtons: !state.showHotButtons });
    case SET_SHOW_HOT_BUTTONS:
      return {
        showHotButtons: typeof payload.showHotButtons === "boolean" ? payload.showHotButtons : state.showHotButtons,
        useHotButtonsAnimation: typeof payload.useHotButtonsAnimation === "boolean" ? payload.useHotButtonsAnimation : state.useHotButtonsAnimation
      };
    default:
      return state;
  }
};
var orderSearchResultsReducer = produce((state = ORDER_SEARCH_RESULTS_INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_ORDER_SEARCH_RESULTS:
      return action.payload;
    case RESET_ORDER_SEARCH_RESULTS_BAR_CODE_ORDER:
      return __spreadProps(__spreadValues({}, state), { barCodeOrder: null });
    case UPDATE_ORDER_SEARCH_RESULTS: {
      const newArray = state.orders.map((order) => {
        if (String(order.id) === String(action.payload.orderId)) {
          return __spreadValues(__spreadValues({}, order), action.payload.orderData);
        }
        return order;
      });
      state.orders = newArray;
      if (state.selectedMainOrder && String(state.selectedMainOrder.id) === String(action.payload.orderId)) {
        state.selectedMainOrder = __spreadValues(__spreadValues({}, state.selectedMainOrder), action.payload.orderData);
      }
      break;
    }
    case UPDATE_ORDER_FIELD:
    case UPDATE_LOCALLY_ORDER_FIELD:
      {
        if (state.selectedMainOrder && String(state.selectedMainOrder.id) === String(action.payload.orderId)) {
          const order = state.selectedMainOrder;
          checkForOrderTypeChanges(action.payload.orderUpdate, order);
          assign(order, action.payload.orderUpdate);
          order.hasUnsentItems = getOrderHasUnsentItems(order);
          updateChecksTotals(order);
        } else {
          const order = state.orders.find(
            (_order) => String(_order.id) === String(action.payload.orderId)
          );
          if (!order)
            return;
          assign(order, action.payload.orderUpdate);
        }
      }
      break;
    case ROLL_UP_ORDER_SEARCH_CHECK_ELEMENTS:
      {
        const currentOrder = state.selectedMainOrder;
        if (currentOrder)
          checkAndDisplayCheckElementsRollUp(currentOrder);
      }
      break;
    default:
      return state;
  }
});
var orderModalReducer = (state = { active: false, table: null, mode: "CREATE" /* CREATE */ }, { type, payload }) => {
  if (type === TOGGLE_ORDER_MODAL)
    return payload;
  return state;
};
var registerNavigationReducer = (state = REGISTER_NAVIGATION_INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case SET_REGISTER_NAVIGATION:
      return payload;
    case UPDATE_REGISTER_NAVIGATION_FIELD:
      return __spreadValues(__spreadValues({}, state), payload);
    case REPLACE_ORDER_TABLET_GENERATED_ID_WS:
      return __spreadProps(__spreadValues({}, state), {
        orderId: state.orderId === payload.tabletGeneratedId ? payload.orderId : null
      });
    case ADD_REMOVE_ACTIVE_ITEMS:
      if (state.activeItems.indexOf(payload) === -1)
        return __spreadProps(__spreadValues({}, state), { activeItems: [...state.activeItems, payload] });
      return __spreadProps(__spreadValues({}, state), {
        activeItems: [...state.activeItems.filter((id) => id !== payload)]
      });
    case CLEAN_NAVIGATION_AND_REMOVE_ACTIVE_ITEM:
      return __spreadProps(__spreadValues({}, state), {
        itemId: null,
        ticketElementId: null,
        skipInventoryCheck: false,
        isSeatSelectionActive: false,
        modifyingSentTicketElementId: null,
        modifierGroupId: null,
        prevModGroupTypeModGroupId: null,
        isAllModsEnabled: false,
        nestedModifierGroupId: null,
        modifierItemInstanceId: null,
        categoryId: null,
        subcategoryId: null,
        activeItems: [...state.activeItems.filter((item) => item !== payload)]
      });
    case SET_ACTIVE_TICKET_ELEMENT: {
      const _activeItems = [...state.activeItems];
      const filteredActiveItems = _activeItems.filter(
        (ticketElementId) => ticketElementId !== state.ticketElementId
      );
      return __spreadProps(__spreadValues(__spreadValues({}, state), payload.registerNavigation), {
        activeItems: [...filteredActiveItems, payload.elementId]
      });
    }
    case SELECT_CURRENT_SEAT:
      return __spreadValues(__spreadValues(__spreadProps(__spreadValues({}, state), {
        currentSeat: payload.selectedSeat,
        seats: payload.selectedSeat === ALL_SEATS ? payload.seatingPromptMode === "no_prompt" /* NO_PROMPT */ ? { 1: true } : {} : { [payload.selectedSeat]: true },
        isShared: null,
        newElementYPos: null,
        itemId: null
      }), isTicketElementIdInSeatPage(
        payload.order.ticketElements,
        state.ticketElementId,
        payload.selectedSeat,
        state.activeItems
      )), isComboElementIdInSeatPage(
        payload.order.combos,
        state.comboElementId,
        payload.selectedSeat,
        state.activeItems
      ));
    case SELECT_NEXT_SEAT: {
      const nextSeat = (state.currentSeat + 1) % (payload.seatsOccupied + 1);
      return __spreadValues(__spreadValues(__spreadProps(__spreadValues({}, state), {
        currentSeat: nextSeat,
        seats: nextSeat === ALL_SEATS ? payload.seatingPromptMode === "no_prompt" /* NO_PROMPT */ ? { 1: true } : {} : { [nextSeat]: true },
        isShared: null,
        newElementYPos: null,
        itemId: null
      }), isTicketElementIdInSeatPage(
        payload.order.ticketElements,
        state.ticketElementId,
        nextSeat,
        state.activeItems
      )), isComboElementIdInSeatPage(
        payload.order.combos,
        state.comboElementId,
        nextSeat,
        state.activeItems
      ));
    }
    case SELECT_PREVIOUS_SEAT: {
      const currentSeat = state.currentSeat === FOR_TABLE_SEAT_ID ? 0 : state.currentSeat;
      const previousSeat = (currentSeat + payload.seatsOccupied) % (payload.seatsOccupied + 1);
      return __spreadValues(__spreadValues(__spreadProps(__spreadValues({}, state), {
        currentSeat: previousSeat,
        seats: previousSeat === ALL_SEATS ? payload.seatingPromptMode === "no_prompt" /* NO_PROMPT */ ? { 1: true } : {} : { [previousSeat]: true },
        isShared: null,
        newElementYPos: null,
        itemId: null
      }), isTicketElementIdInSeatPage(
        payload.order.ticketElements,
        state.ticketElementId,
        previousSeat,
        state.activeItems
      )), isComboElementIdInSeatPage(
        payload.order.combos,
        state.comboElementId,
        previousSeat,
        state.activeItems
      ));
    }
    case MODIFY_ITEM_START:
      return __spreadProps(__spreadValues({}, state), {
        modifyingSentTicketElementId: payload.ticketElementId
      });
    case MODIFY_ITEM_END:
      return __spreadProps(__spreadValues({}, state), {
        modifyingSentTicketElementId: null
      });
    default:
      return state;
  }
};
var REFUND_ACTION_INITIAL_STATE = {
  checkId: null,
  paymentId: null,
  refundAmount: 0,
  refundBody: null,
  paymentMethod: null
};
var PAYMENT_NAVIGATION_INITIAL_STATE = {
  isPaymentModeActive: false,
  option: "" /* NULL */,
  method: "" /* NULL */,
  checkId: null,
  screen: "PAYMENT" /* PAYMENT */,
  payThroughTablet: false,
  defaultSplit: {
    type: "" /* NONE */
  },
  forceClearUnassignedCheck: false,
  isItemsToggled: true,
  isDiscountsToggled: false,
  refundAction: REFUND_ACTION_INITIAL_STATE
};
var paymentNavigationReducer = (state = PAYMENT_NAVIGATION_INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case UPDATE_PAYMENT_NAVIGATION:
      return __spreadValues(__spreadValues({}, state), payload);
    case SET_PAYMENT_OPTION:
      return __spreadProps(__spreadValues({}, state), { option: payload });
    case SET_PAYMENT_METHOD:
      return __spreadProps(__spreadValues({}, state), { method: payload });
    default:
      return state;
  }
};
var specialsCounterReducer = (state = 0, { type, payload }) => type === SET_SPECIALS_COUNTER ? payload : state;
var exitOrderReducer = (state = false, { type, payload }) => type === ENABLE_EXIT_ORDER_CALL || type === DISABLE_EXIT_ORDER_CALL ? payload : state;
var reducers_default2 = combineReducers({
  customizer: reducer_default,
  orderCounter: stationCounterReducer,
  hotButtons: hotButtonsReducer,
  registerNavigation: registerNavigationReducer,
  paymentNavigation: paymentNavigationReducer,
  orders: ordersReducer,
  drawers: reducer_default$1,
  orderSearchResults: orderSearchResultsReducer,
  isOrderModalActive: orderModalReducer,
  specialsCounter: specialsCounterReducer,
  endOfDay: endOfDayReducer,
  exitOrder: exitOrderReducer
});

// src/state/settings/location/actions.ts
var actions_exports4 = {};
__export(actions_exports4, {
  associateUsersToLocation: () => associateUsersToLocation,
  setDashboards: () => setDashboards,
  setLocationSettings: () => setLocationSettings,
  setPrinterStatusWs: () => setPrinterStatusWs,
  setPrinters: () => setPrinters,
  setRemovedPrinters: () => setRemovedPrinters,
  setRoleDashboards: () => setRoleDashboards
});
var setLocationSettings = (payload, isWebSocket = false) => ({
  type: isWebSocket ? SET_LOCATION_SETTINGS_WS : SET_LOCATION_SETTINGS,
  payload
});
var setPrinterStatusWs = (payload) => ({
  type: SET_PRINTER_STATUS_WS,
  payload
});
var setPrinters = (payload) => ({
  type: SET_PRINTERS,
  payload
});
var setRemovedPrinters = (payload, isWebSocket = false) => ({
  type: isWebSocket ? REMOVED_PRINTER_WS : REMOVED_PRINTER,
  payload
});
var setDashboards = (payload) => ({
  type: SET_SETTINGS_DASHBOARDS,
  payload
});
var setRoleDashboards = (payload) => ({
  type: SET_ROLE_DASHBOARDS,
  payload
});
var associateUsersToLocation = (users, organizationId, licenseId, licenseSettingsId, errorCodesDispatcher, extraHeaders) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    dispatch(setIsLoadingModal({ active: true, message: "Associating users" }));
    const state = getState();
    const locationId = state.settings.selectedMode.id;
    const userRoleIds = {};
    let user;
    for (user of users) {
      if (!user.roleIds)
        continue;
      userRoleIds[user.id] = user.roleIds;
    }
    const data = {
      locationId,
      userRoleIds,
      ids: []
    };
    const url = apiConfig_default.settings.associateEntityToLocation(
      organizationId,
      locationId,
      "users"
    );
    apiCall(
      "put" /* Put */,
      url,
      true,
      data,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders
    ).then((response) => {
      dispatch(setIsLoadingModal({ active: false }));
      dispatch(
        setSettingsOnState(
          response.menu,
          licenseSettingsId,
          false,
          { skipMaster: false },
          false,
          true
        )
      );
    }).catch((err) => {
      dispatch(setIsLoadingModal({ active: false }));
      console.error("endpoint", err);
    });
  });
};

// src/state/settings/actions.ts
var PRINTER_RULES_SETTINGS_SELECTED = [
  "printerRules",
  "licenseSpecificPrinterRules"
];
var setRegisterSettings = (payload) => ({
  type: SET_REGISTER_SETTINGS,
  payload
});
var setRegisterTicketSettings = (payload) => ({
  type: SET_REGISTER_TICKET_SETTINGS,
  payload
});
var updateRegisterTicketSettings = (payload, sectionId) => (dispatch, getState) => {
  const state = getState();
  const registerTicketSettings = state.settings.changeData.data;
  const newRegisterTicketSettings = __spreadValues(__spreadValues({}, registerTicketSettings), payload);
  batch$1(() => {
    dispatch(
      setSettingsChangeDataValues(newRegisterTicketSettings, sectionId)
    );
    dispatch(setRegisterTicketSettings(newRegisterTicketSettings));
  });
};
var setLocationSelectedSettingsMode = (organizationId, locationId, licenseId, errorCodesDispatcher, extraHeaders) => (dispatch, getState) => {
  const state = getState();
  const streetLine1 = state.settings.selectedMode.currentSettings.general.streetLine1;
  dispatch(
    changeSelectedSettingsMode(
      {
        settingsType: "location" /* LOCATION_SETTINGS */,
        id: locationId,
        name: streetLine1
      },
      organizationId,
      licenseId,
      errorCodesDispatcher,
      extraHeaders
    )
  );
};
var setDefaultSettingsData = () => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const { settingsSelected, id, mode } = state.settings.changeData;
    const currentSettings = state.settings.selectedMode.currentSettings;
    if (!settingsSelected) {
      return;
    }
    const settingsData = mode === "create" /* CREATE */ ? getSettingsInitialState(settingsSelected) : id ? currentSettings[settingsSelected][id] : currentSettings[settingsSelected];
    if (!settingsData) {
      return;
    }
    dispatch(
      setSettingsChangeData({
        id,
        settingsSelected,
        data: settingsData,
        originalData: settingsData,
        hasChanges: false,
        sectionId: "all" /* ALL */,
        differences: [],
        finalDiffObject: null,
        errors: {},
        settingsVersion: getSettingsVersionCore(state) || 0,
        selectedLocations: [],
        mode
      })
    );
  });
};
var changeSelectedSettingsMode = (preSelectedMode, organizationId, licenseId, errorCodesDispatcher, extraHeaders, onContinue, omitSetMenu) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const { location, master, versions } = getState().settings;
    const {
      locationMenu,
      masterMenu,
      versions: versionsMenu
    } = getState().menu;
    const settingsType = preSelectedMode.overrideSettingsType || preSelectedMode.settingsType;
    switch (settingsType) {
      case "master" /* MASTER_SETTINGS */:
        yield dispatch(
          checkForValueInLocationAndContinue(
            preSelectedMode.name,
            master,
            () => {
              dispatch(
                setSelectedSettingsMode(__spreadProps(__spreadValues({}, preSelectedMode), {
                  currentSettings: master,
                  settingsVersion: versions.master
                }))
              );
              !omitSetMenu && dispatch(
                setSelectedMenuMode({
                  currentMenu: masterMenu,
                  menuVersion: versionsMenu.master,
                  menuType: "masterMenu" /* MASTER_MENU */,
                  id: preSelectedMode.id,
                  name: preSelectedMode.name
                })
              );
            }
          )
        );
        break;
      case "location" /* LOCATION_SETTINGS */:
        yield dispatch(
          checkForValueInLocationAndContinue(
            preSelectedMode.name,
            location,
            () => {
              dispatch(
                setSelectedSettingsMode(__spreadProps(__spreadValues({}, preSelectedMode), {
                  currentSettings: location,
                  settingsVersion: versions.location
                }))
              );
              !omitSetMenu && dispatch(
                setSelectedMenuMode({
                  currentMenu: locationMenu,
                  menuVersion: versionsMenu.location,
                  menuType: "locationMenu" /* LOCATION_MENU */,
                  id: preSelectedMode.id,
                  name: preSelectedMode.name
                })
              );
            }
          )
        );
        break;
      case "remoteLocation" /* REMOTE_LOCATION_SETTINGS */:
        const hasUserAccess = yield dispatch(
          getRemoteLocationSettings(
            preSelectedMode,
            organizationId,
            licenseId,
            errorCodesDispatcher,
            extraHeaders
          )
        );
        if (!omitSetMenu && hasUserAccess) {
          yield dispatch(
            getRemoteLocationMenu(
              {
                menuType: "remoteLocationMenu" /* REMOTE_LOCATION_MENU */,
                name: preSelectedMode.name,
                loaderIcon: preSelectedMode.loaderIcon,
                id: preSelectedMode.id
              },
              preSelectedMode.name,
              organizationId,
              licenseId,
              errorCodesDispatcher,
              extraHeaders
            )
          );
        }
    }
    onContinue && onContinue();
  });
};
var ELEMENT_NOT_FOUND_MESSAGES = {
  users: "settingsModule.userDetailsSettings.noElementFoundMessage",
  online: "commonTexts.na",
  lockScreen: "commonTexts.na",
  general: "commonTexts.na",
  roles: "commonTexts.na",
  register: "commonTexts.na",
  registerTicket: "commonTexts.na",
  kitchenTicket: "commonTexts.na",
  prepStations: "commonTexts.na",
  printerRules: "commonTexts.na",
  licenseSpecificPrinterRules: "commonTexts.na",
  taxes: "settingsModule.taxesSettings.noElementFoundMessage",
  devices: "commonTexts.na",
  licenses: "commonTexts.na",
  licenseSettings: "commonTexts.na",
  guestCheck: "commonTexts.na",
  guestReceipt: "commonTexts.na",
  payments: "commonTexts.na",
  dashboards: "commonTexts.na"
};
var checkForValueInLocationAndContinue = (location, currentSettings, onContinue) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const { settingsSelected, id, mode } = getState().settings.changeData;
    if (settingsSelected && settingsSelected === "users" && mode === "update" /* UPDATE */ && id !== 0) {
      const valueExists = currentSettings[settingsSelected][id];
      if (valueExists) {
        onContinue();
      } else {
        dispatch(
          showElementNotFoundInLocationToast(
            location,
            settingsSelected
          )
        );
      }
    } else {
      onContinue();
    }
  });
};
var showElementNotFoundInLocationToast = (location, settingsSelected) => {
  return (dispatch) => __async(void 0, null, function* () {
    dispatch(
      showToast({
        type: "error",
        title: i18n_config_default.t("menuScreen.noElementToast.title"),
        description: i18n_config_default.t(ELEMENT_NOT_FOUND_MESSAGES[settingsSelected], {
          location
        })
      })
    );
  });
};
var getRemoteLocationSettings = (preSelectedMode, organizationId, licenseId, errorCodesDispatcher, extraHeaders, onContinue) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const url = apiConfig_default.settings.getLocationSettings(
      organizationId,
      preSelectedMode.id
    );
    try {
      const resp = yield apiCall(
        "get" /* Get */,
        url,
        true,
        void 0,
        licenseId,
        errorCodesDispatcher,
        dispatch,
        state,
        extraHeaders
      );
      const loggedInUserId = getState().loggedInUser.id;
      const userFromNewLocation = resp.location.users[loggedInUserId];
      if (!userFromNewLocation.active) {
        dispatch(
          showToast({
            type: "warning",
            title: t("toasts.cannotAccessLocation.title"),
            description: t("toasts.cannotAccessLocation.description")
          })
        );
        return false;
      }
      dispatch(
        checkForValueInLocationAndContinue(
          preSelectedMode.name,
          resp.location,
          () => {
            dispatch(setRemoteLocationSettings(resp.location));
            dispatch(
              setSettingsVersions(__spreadProps(__spreadValues({}, state.settings.versions), {
                remoteLocation: resp.version
              }))
            );
            dispatch(
              setSelectedSettingsMode(__spreadProps(__spreadValues({}, preSelectedMode), {
                currentSettings: resp.location,
                settingsVersion: resp.version
              }))
            );
            onContinue == null ? void 0 : onContinue();
          }
        )
      );
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  });
};
var getMasterSettings = (organizationId, licenseId, errorCodesDispatcher, extraHeaders, onContinue) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const url = apiConfig_default.settings.getLocationSettings(organizationId, 0);
  try {
    const resp = yield apiCall(
      "get" /* Get */,
      url,
      true,
      void 0,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders
    );
    dispatch(setMasterSettings(resp.location));
    dispatch(
      setSettingsVersions(__spreadProps(__spreadValues({}, state.settings.versions), {
        master: resp.version
      }))
    );
    onContinue == null ? void 0 : onContinue();
  } catch (err) {
    console.error(err);
  }
});
var updateGenericSettings = (values, sectionId, hardUpdate = false) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const data = getState().settings.changeData.data;
    const oldData = hardUpdate ? {} : data;
    dispatch(
      setSettingsChangeDataValues(
        __spreadValues(__spreadValues({}, oldData), values),
        sectionId
      )
    );
  });
};
var updateKitchenTicketSettings = (values, sectionId, prepStationVersionId) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const data = selectCurrentSettingsData(
      getState()
    );
    const prepStationVersionsCloned = cloneDeep16(data.prepStationVersions);
    dispatch(
      updateGenericSettings(
        {
          prepStationVersions: __spreadProps(__spreadValues({}, prepStationVersionsCloned), {
            [prepStationVersionId]: __spreadValues(__spreadValues({}, prepStationVersionsCloned[prepStationVersionId]), values)
          })
        },
        sectionId
      )
    );
  });
};
var deletePrepStation = (values, sectionId) => {
  return (dispatch) => __async(void 0, null, function* () {
    dispatch(setSettingsChangeDataValues(values, sectionId));
  });
};
var resetRegisterTicketSettingsData = () => {
  return (dispatch) => __async(void 0, null, function* () {
    batch$1(() => {
      dispatch(updateCurrentSettings());
      dispatch(
        updateRegisterNavigationField(REGISTER_NAVIGATION_INITIAL_STATE)
      );
    });
  });
};
var createRegisterTicketPreviewData = () => {
  return (dispatch) => __async(void 0, null, function* () {
    batch$1(() => {
      dispatch(addSessionOrder(registerTicketSettings_dummy_default, 0));
      dispatch(
        updateRegisterNavigationField({
          orderId: 0,
          isPreviewMode: true,
          disablePreviewDeleteEnabled: true
        })
      );
    });
  });
};
var updateSettingsOnSocket = (payload, licenseSettingsId, skipMaster = false) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const { active: isLoading, isMakingApiCall } = selectIsLoadingModal(state);
  const settingsType = selectSettingsType(state);
  const settingsSelected = selectSettingsSelected(state);
  const oldSettingsVersion = getSettingsVersionCore(state);
  const newSettingsVersion = getNewSettingsVersionCore(payload, state);
  const isRemoteLocationMode = selectIsSettingsRemoteLocationMode(state);
  if (isLoading && isMakingApiCall) {
    return;
  }
  dispatch(
    setSettingsOnState(
      payload,
      licenseSettingsId,
      true,
      {
        skipMaster
      },
      false,
      true
    )
  );
  if (oldSettingsVersion !== newSettingsVersion && !isRemoteLocationMode) {
    if (!settingsSelected && settingsType !== "remoteLocation" /* REMOTE_LOCATION_SETTINGS */) {
      dispatch(updateCurrentSettings(false));
    }
    dispatch(
      setShowSettingsRefreshToast({
        isActive: true,
        variant: "SETTINGS" /* SETTINGS */,
        title: i18n_config_default.t("menuScreen.refreshToast.title.settings")
      })
    );
  }
});
var updateSettingsFinalDiffObject = (differences) => {
  return (dispatch, getState) => {
    const state = getState();
    const { settingsSelected } = selectSettingsChangeData(state);
    if (settingsSelected === "kitchenTicket") {
      dispatch(
        updateSettingsChangeDataValues({
          differences,
          finalDiffObject: diffKitchenTicketFactory(differences, state)
        })
      );
    } else {
      dispatch(
        updateSettingsChangeDataValues({
          differences
        })
      );
    }
  };
};
var checkForSettingsChangesAndNavigate = (onContinue, onRefresh, postRequest2, organizationId, locationId, licenseId, licenseSettingsId, errorCodesDispatcher, extraHeaders, onContinueResetChangeData = true, isSavePressed = false, navigateOnSave = false, showDiscardChangesModal = true) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const currentSettings = state.settings.selectedMode.currentSettings;
    const { settingsSelected, data, originalData, mode, hasChanges } = state.settings.changeData;
    if (!data) {
      onContinue();
      return;
    }
    if (!settingsSelected) {
      return;
    }
    const fn = settingsValidationThunks(
      settingsSelected,
      data,
      true,
      onContinue
    );
    const isValid = yield dispatch(fn);
    if (!isValid) {
      return;
    }
    const showLocationSelectionModal = shouldShowSettingsLocationsModalOnSaveCore(dispatch, state);
    const handleSave = () => __async(void 0, null, function* () {
      const { success } = yield dispatch(
        editSettingsElement(
          onRefresh,
          navigateOnSave,
          postRequest2,
          organizationId,
          locationId,
          licenseId,
          licenseSettingsId,
          errorCodesDispatcher,
          extraHeaders,
          void 0,
          void 0,
          onContinue
        )
      );
      if (!success) {
        return;
      }
    });
    if (mode === "create" /* CREATE */ && hasChanges && isSavePressed) {
      return handleSave();
    }
    if (settingsSelected && mode === "update" /* UPDATE */) {
      const originData = originalData || currentSettings[settingsSelected];
      let differences;
      if (settingsSelected === "registerTicket") {
        const registerTicketOriginData = getCurrentSettingsCore(state).settings.registerTicket;
        differences = diff(registerTicketOriginData, data);
      } else {
        differences = diff(originData, data);
      }
      if (!differences) {
        const changeData = selectSettingsChangeData(state);
        dispatch(setSettingsChangeData(__spreadProps(__spreadValues({}, changeData), { hasChanges: false })));
        onContinue();
        onContinueResetChangeData && !isSavePressed && dispatch(resetSettingsChangeData());
        return;
      }
      if (differences.length === 0) {
        onContinueResetChangeData && dispatch(resetSettingsChangeData());
        onContinue();
        return;
      }
      batch$1(() => {
        dispatch(updateSettingsFinalDiffObject(differences));
        const skipDiffModal = /* @__PURE__ */ new Set([
          "licenseSettings"
        ]);
        const shouldShowSettingsDiffModal = !skipDiffModal.has(settingsSelected);
        const onSuccess = () => {
          if (showLocationSelectionModal) {
            dispatch(
              setShowConfirmationModal({
                title: "",
                type: "locationSettingsSelection",
                active: true,
                onSuccess: handleSave
              })
            );
          } else {
            handleSave();
          }
        };
        if (shouldShowSettingsDiffModal) {
          dispatch(
            setShowConfirmationModal({
              title: i18n_config_default.t("app.modals.diffModal.reviewChanges"),
              type: "settingsDiff",
              btnCancelText: isSavePressed ? "" : i18n_config_default.t("app.modals.discardChangesConfirmation.title"),
              btnSuccessText: showLocationSelectionModal ? "" : i18n_config_default.t("commonButtons.save"),
              description: showLocationSelectionModal ? `${i18n_config_default.t("app.modals.diffModal.youHaveUnsavedChanges", {
                bucket: i18n_config_default.t(
                  `menuScreen.common.settings.${settingsSelected}.singular`
                )
              })} ${i18n_config_default.t("app.modals.diffModal.descripTionForContinue")}` : `${i18n_config_default.t("app.modals.diffModal.youHaveUnsavedChanges", {
                bucket: i18n_config_default.t(
                  `menuScreen.common.settings.${settingsSelected}.singular`
                )
              })} ${i18n_config_default.t("app.modals.diffModal.descriptionForSave")}`,
              active: true,
              onSuccess,
              onCancel: () => {
                if (isSavePressed)
                  return;
                if (onContinueResetChangeData) {
                  if (settingsSelected === "registerTicket") {
                    batch$1(() => {
                      dispatch(
                        resetSettingsChanges(
                          getCurrentSettingsCore(state).settings.registerTicket
                        )
                      );
                      dispatch(resetRegisterTicketSettingsData());
                      dispatch(
                        addSessionOrder(
                          ORDER_INITIAL_STATE,
                          0
                        )
                      );
                    });
                  } else {
                    dispatch(resetSettingsChangeData());
                  }
                }
                onContinue();
              }
            })
          );
        } else {
          if (showLocationSelectionModal === false && showDiscardChangesModal) {
            dispatch(
              cancelSettingsChangesOnCancelPress(void 0, () => {
                dispatch(resetSettingsChangeData());
                onContinue();
              })
            );
          } else {
            onSuccess();
          }
        }
      });
    } else if (mode === "create" /* CREATE */ && hasChanges) {
      dispatch(
        setShowConfirmationModal({
          title: i18n_config_default.t(
            `menuScreen.common.settings.${settingsSelected}.creation.title`
          ),
          description: i18n_config_default.t(
            `menuScreen.common.settings.${settingsSelected}.creation.message`
          ),
          type: "warning",
          active: true,
          btnSuccessText: i18n_config_default.t("app.modals.creationConfirmation.exit"),
          btnCancelText: i18n_config_default.t("app.modals.creationConfirmation.continue"),
          onSuccess: () => {
            onContinueResetChangeData && dispatch(resetSettingsChangeData());
            onContinue();
          }
        })
      );
      return;
    } else {
      if (onContinueResetChangeData)
        dispatch(resetSettingsChangeData());
      onContinue();
    }
  });
};
var cancelSettingsChangesOnCancelPress = (onNavigation, customOnSuccess) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const { settingsSelected, id, mode, data } = state.settings.changeData;
    const printerRulesSettings = selectPrinterRulesForDetailsScreen(state);
    const prepStationsSettings = selectPrepStationsSettingsForDetailsScreen(state);
    if (!settingsSelected) {
      return;
    }
    const isPrinterRulesScreen = PRINTER_RULES_SETTINGS_SELECTED.includes(settingsSelected);
    const isPrepStationsScreen = settingsSelected === "prepStations";
    let currentEditingSettings;
    if (mode === "create" /* CREATE */) {
      currentEditingSettings = getSettingsInitialState(settingsSelected);
    } else if (id) {
      currentEditingSettings = state.settings.selectedMode.currentSettings[settingsSelected][id];
    } else if (isPrinterRulesScreen) {
      currentEditingSettings = printerRulesSettings;
    } else if (isPrepStationsScreen) {
      currentEditingSettings = prepStationsSettings;
    } else {
      currentEditingSettings = state.settings.selectedMode.currentSettings[settingsSelected];
    }
    if (!currentEditingSettings) {
      return;
    }
    batch$1(() => {
      const onSuccess = () => {
        if (settingsSelected === "registerTicket") {
          dispatch(
            resetSettingsChanges(
              getCurrentSettingsCore(state).settings.registerTicket
            )
          );
          dispatch(resetRegisterTicketSettingsData());
          dispatch(createRegisterTicketPreviewData());
        } else if (settingsSelected === "users") {
          dispatch(
            resetSettingsChanges(__spreadProps(__spreadValues({}, currentEditingSettings), {
              user: __spreadProps(__spreadValues({}, currentEditingSettings.user), {
                email: data.user.email
              })
            }))
          );
        } else if (settingsSelected) {
          if (currentEditingSettings)
            dispatch(resetSettingsChanges(currentEditingSettings));
        } else {
          if (onNavigation !== void 0)
            onNavigation();
          dispatch(resetSettingsChangeData());
        }
      };
      dispatch(
        setShowConfirmationModal({
          title: i18n_config_default.t(
            "app.modals.discardChangesConfirmation.title"
          ),
          description: i18n_config_default.t(
            "app.modals.discardChangesConfirmation.description"
          ),
          active: true,
          type: "warning",
          btnCancelText: i18n_config_default.t("commonTexts.no"),
          btnSuccessText: i18n_config_default.t("commonTexts.yes"),
          onSuccess: customOnSuccess ? customOnSuccess : onSuccess
        })
      );
    });
  });
};
var checkSettingsValidation = (canDiscard, onContinue) => (dispatch, getState) => {
  const errors = getState().settings.changeData.errors;
  if (Object.keys(errors).length > 0) {
    dispatch(
      setShowConfirmationModal({
        title: "",
        active: true,
        type: canDiscard ? "settingsValidationDiscard" : "settingsValidation",
        btnSuccessText: i18n_config_default.t("commonButtons.ok"),
        onSuccess: () => {
          dispatch(resetSettingsChangeData());
          onContinue && onContinue();
        }
      })
    );
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
};
var checkPrinterRulesValidation = (data, canDiscard, onContinue) => (dispatch) => __async(void 0, null, function* () {
  try {
    yield printerRulesSchema.validate(data, {
      abortEarly: false
    });
    dispatch(setSettingsErrors({}));
  } catch (error) {
    dispatch(
      setSettingsErrors(__spreadValues({}, reduceErrors(error.errors)))
    );
    dispatch(checkSettingsValidation(canDiscard, onContinue));
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var checkTaxesValidation = (data, canDiscard, onContinue, openValidationModal = true) => (dispatch) => __async(void 0, null, function* () {
  try {
    yield taxesSchema.validate(data, {
      abortEarly: false
    });
    dispatch(setSettingsErrors({}));
  } catch (error) {
    dispatch(
      setSettingsErrors(__spreadValues({}, reduceErrors(error.errors)))
    );
    openValidationModal && dispatch(checkSettingsValidation(canDiscard, onContinue));
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var checkPaymentsValidation = (data, canDiscard, onContinue, openValidationModal = true) => (dispatch) => __async(void 0, null, function* () {
  try {
    yield validatePayments(data);
    dispatch(setSettingsErrors({}));
  } catch (error) {
    dispatch(setSettingsErrors(error));
    openValidationModal && dispatch(checkSettingsValidation(canDiscard, onContinue));
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var checkRegisterModeFormValidation = (data, canDiscard, onContinue) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  try {
    yield registerModeSchema(selectCurrentTimeZone(state)).validate(data, {
      abortEarly: false
    });
    dispatch(setSettingsErrors({}));
  } catch (error) {
    dispatch(
      setSettingsErrors(__spreadValues({}, reduceErrors(error.errors)))
    );
    dispatch(checkSettingsValidation(canDiscard, onContinue));
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var checkKitchenTicketSettingsFormValidation = (data, canDiscard, onContinue, skipModal) => (dispatch) => __async(void 0, null, function* () {
  try {
    yield kitchenTicketSettingsSchema.validate(data, {
      abortEarly: false
    });
    dispatch(setSettingsErrors({}));
  } catch (error) {
    dispatch(
      setSettingsErrors(__spreadValues({}, reduceErrors(error.errors)))
    );
    !skipModal && dispatch(checkSettingsValidation(canDiscard, onContinue));
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var checkGeneralSettingsFormValidation = (data, canDiscard, onContinue) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  try {
    yield generalSettingsSchema(data, state);
    dispatch(setSettingsErrors({}));
  } catch (error) {
    dispatch(
      setSettingsErrors(__spreadValues({}, reduceErrors(error.errors)))
    );
    dispatch(checkSettingsValidation(canDiscard, onContinue));
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var checkOnlineSettingsFormValidation = (data, canDiscard, onContinue) => (dispatch) => __async(void 0, null, function* () {
  try {
    yield onlineOrderingSettingsSchema();
    dispatch(setSettingsErrors({}));
  } catch (error) {
    dispatch(
      setSettingsErrors(__spreadValues({}, reduceErrors(error.errors)))
    );
    dispatch(checkSettingsValidation(canDiscard, onContinue));
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var checkRolesFormValidation = (data, canDiscard, onContinue) => (dispatch) => __async(void 0, null, function* () {
  try {
    yield rolesSchema.validate(data, {
      abortEarly: false
    });
    dispatch(setSettingsErrors({}));
  } catch (error) {
    dispatch(
      setSettingsErrors(__spreadValues({}, reduceErrors(error.errors)))
    );
    dispatch(checkSettingsValidation(canDiscard, onContinue));
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var checkUsersFormValidation = (data, canDiscard, onContinue) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const isMasterMode = areSettingsMasterModeSelector(state);
  const hasMultipleLocations = selectShouldRenderLocationDropdown(state);
  try {
    isMasterMode ? hasMultipleLocations ? yield usersMasterSchema.validate(
      __spreadValues(__spreadValues({}, data), data.user),
      {
        abortEarly: false
      }
    ) : yield usersLocationSchema.validate(
      __spreadValues(__spreadValues({}, data), data.user),
      {
        abortEarly: false
      }
    ) : yield usersLocationSchema.validate(
      __spreadValues(__spreadValues({}, data), data.user),
      {
        abortEarly: false
      }
    );
    if (pinAlreadyExistsCore(
      data.pin,
      data.organizationUserId,
      state,
      data.user.email
    )) {
      const pinError = {
        pin: {
          id: "genericError",
          data: {
            message: i18n_config_default.t("validations.pinAlreadyInUse")
          },
          kind: {
            id: "pin",
            data: {
              message: i18n_config_default.t("validations.pinAlreadyInUse")
            },
            type: "genericError",
            section: "basic" /* BASIC */
          }
        }
      };
      dispatch(
        setSettingsErrors(__spreadValues({}, reduceErrors([JSON.stringify(pinError)])))
      );
      dispatch(checkSettingsValidation(canDiscard, onContinue));
      return Promise.resolve(false);
    }
    dispatch(setSettingsErrors({}));
  } catch (error) {
    dispatch(
      setSettingsErrors(__spreadValues({}, reduceErrors(error.errors)))
    );
    dispatch(checkSettingsValidation(canDiscard, onContinue));
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var checkPrepStationsFormValidation = (data, canDiscard, onContinue) => (dispatch) => __async(void 0, null, function* () {
  try {
    yield prepStationsSchema.validate(data, {
      abortEarly: false
    });
    dispatch(setSettingsErrors({}));
  } catch (error) {
    dispatch(
      setSettingsErrors(__spreadValues({}, reduceErrors(error.errors)))
    );
    dispatch(checkSettingsValidation(canDiscard, onContinue));
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var checkLicenseSettingsFormValidation = (data, canDiscard, onContinue) => (dispatch) => __async(void 0, null, function* () {
  try {
    yield licenseSettingsSchema.validate(data, {
      abortEarly: false
    });
    dispatch(setSettingsErrors({}));
  } catch (error) {
    dispatch(
      setSettingsErrors(__spreadValues({}, reduceErrors(error.errors)))
    );
    dispatch(checkSettingsValidation(canDiscard, onContinue));
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var settingsValidationThunks = (settingsName, data, canDiscard, onContinue) => {
  switch (settingsName) {
    case "register":
      return checkRegisterModeFormValidation(
        data,
        canDiscard,
        onContinue
      );
    case "general":
      return checkGeneralSettingsFormValidation(
        data,
        canDiscard,
        onContinue
      );
    case "online":
      return checkOnlineSettingsFormValidation(
        data,
        canDiscard,
        onContinue
      );
    case "prepStations":
      return checkPrepStationsFormValidation(
        data,
        canDiscard,
        onContinue
      );
    case "licenseSpecificPrinterRules":
    case "printerRules":
      return checkPrinterRulesValidation(
        data,
        canDiscard,
        onContinue
      );
    case "taxes":
      return checkTaxesValidation(
        data,
        canDiscard,
        onContinue
      );
    case "payments":
      return checkPaymentsValidation(
        data,
        canDiscard,
        onContinue
      );
    case "licenseSettings":
      return checkLicenseSettingsFormValidation(
        data,
        canDiscard,
        onContinue
      );
    case "roles":
      return checkRolesFormValidation(
        data,
        canDiscard,
        onContinue
      );
    case "users":
      return checkUsersFormValidation(
        data,
        canDiscard,
        onContinue
      );
    case "kitchenTicket":
      return checkKitchenTicketSettingsFormValidation(
        data,
        canDiscard,
        onContinue
      );
    default:
      return checkSettingsValidation(canDiscard, onContinue);
  }
};
var postCreateElement = (navigate = true, postRequest2, id, mode, customSettingsSelected, successMessage) => (dispatch, getState) => {
  const state = getState();
  const changeData = state.settings.changeData;
  const stateMode = changeData.mode;
  const settingsSelected = customSettingsSelected || changeData.settingsSelected;
  if (settingsSelected === null)
    return;
  const isCreating = (mode || stateMode) === "create" /* CREATE */;
  dispatch(postRequest2(navigate, customSettingsSelected, mode, id));
  dispatch(
    showToast({
      title: i18n_config_default.t("commonTexts.success"),
      description: successMessage ? successMessage : settingsSelected ? settingsSelected === "printers" || settingsSelected === "terminals" ? i18n_config_default.t("navBar.common.printerCenter.backupPrinterUpdated") : i18n_config_default.t(
        isCreating ? CREATE_SETTINGS_MESSAGES.success[settingsSelected] : UPDATE_SETTINGS_MESSAGES.success[settingsSelected]
      ) : "Successfully sent new Element",
      type: "success"
    })
  );
};
var setSettingsOnState = (payload, licenseSettingsId, isWebSocket = false, { skipMaster } = {}, skipRemote = false, shouldUpdateCurrentSettings = false) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const selectedMode = state.settings.selectedMode;
  const {
    master: masterVersion,
    location: locationVersion,
    remoteLocation: remoteVersion
  } = state.settings.versions;
  batch$1(() => {
    payload.master && !skipMaster && dispatch(setMasterSettings(payload.master, isWebSocket));
    payload.location && dispatch(setLocationSettings(payload.location, isWebSocket));
    if (payload.location) {
      licenseSettingsId && dispatch(
        setLicenseSettings(
          payload.location.licenseSettings[licenseSettingsId]
        )
      );
    }
    dispatch(
      setSettingsVersions(
        {
          master: skipMaster ? masterVersion : payload.versions.master || masterVersion,
          location: payload.versions.location || locationVersion,
          remoteLocation: payload.versions.remoteLocation || remoteVersion
        },
        isWebSocket
      )
    );
    if (payload.remote && skipRemote === false) {
      dispatch(setRemoteLocationSettings(payload.remote, isWebSocket));
      dispatch(
        setSelectedSettingsMode(
          __spreadProps(__spreadValues({}, selectedMode), {
            currentSettings: payload.remote
          }),
          isWebSocket
        )
      );
    }
    if (shouldUpdateCurrentSettings)
      dispatch(updateCurrentSettings());
  });
});
var updateCurrentSettings = (hideToast2 = true) => (dispatch, getState) => {
  const state = getState();
  const selectedMode = state.settings.selectedMode;
  const locationSettings = state.settings.location;
  const refreshToast = state.app.refreshToast;
  const { settings: currentSettings, version: settingsVersion } = getCurrentSettingsCore(state);
  const loggedInUser = state.loggedInUser;
  dispatch(
    setSelectedSettingsMode(__spreadProps(__spreadValues({}, selectedMode), {
      settingsVersion,
      currentSettings
    }))
  );
  if (loggedInUser.id) {
    const updatedRole = locationSettings.roles[loggedInUser.loggedInRole.roleId];
    dispatch(setLoggedInRoleOnState(updatedRole));
  }
  if (refreshToast.isActive && hideToast2) {
    dispatch(hideRefreshToast());
  }
};
var UPDATE_SETTINGS_MESSAGES = {
  success: {
    register: "settingsModule.registerModeSettings.editElement.success",
    lockScreen: "settingsModule.lockScreenSettings.editElement.success",
    general: "settingsModule.generalSettings.editElement.success",
    online: "settingsModule.onlineSettings.editElement.success",
    roles: "settingsModule.roleDetailsSettings.editElement.success",
    registerTicket: "settingsModule.registerTicketSettings.editElement.success",
    kitchenTicket: "settingsModule.kitchenTicketSettings.editElement.success",
    prepStations: "settingsModule.prepStationsSettings.editElement.success",
    printerRules: "settingsModule.printerRulesSettings.editElement.success",
    licenseSpecificPrinterRules: "settingsModule.licenseSpecificPrinterRules.editElement.success",
    licenseSettings: "settingsModule.licenseSettings.editElement.success",
    users: "settingsModule.usersSettings.editElement.success",
    licenses: "settingsModule.licenseSettings.editElement.success",
    devices: "settingsModule.devices_licenses.editElement.success",
    taxes: "settingsModule.taxesSettings.editElement.success",
    guestCheck: "settingsModule.guestCheckSettings.editElement.success",
    guestReceipt: "settingsModule.guestReceiptSettings.editElement.success",
    payments: "settingsModule.paymentsSettings.editElement.success",
    dashboards: "settingsModule.dashboardsSettings.editElement.success"
  },
  error: {
    register: "settingsModule.registerModeSettings.editElement.error",
    lockScreen: "settingsModule.lockScreenSettings.editElement.error",
    general: "settingsModule.generalSettings.editElement.error",
    online: "settingsModule.onlineSettings.editElement.error",
    roles: "settingsModule.roleDetailsSettings.editElement.error",
    registerTicket: "settingsModule.registerTicketSettings.editElement.error",
    kitchenTicket: "settingsModule.kitchenTicketSettings.editElement.error",
    prepStations: "settingsModule.prepStationsSettings.editElement.error",
    printerRules: "settingsModule.printerRulesSettings.editElement.error",
    licenseSpecificPrinterRules: "settingsModule.licenseSpecificPrinterRules.editElement.error",
    licenseSettings: "settingsModule.licenseSettings.editElement.error",
    users: "settingsModule.usersSettings.editElement.error",
    licenses: "settingsModule.licenseSettings.editElement.error",
    devices: "settingsModule.devices_licenses.editElement.error",
    taxes: "settingsModule.taxesSettings.editElement.error",
    guestCheck: "settingsModule.guestCheckSettings.editElement.error",
    guestReceipt: "settingsModule.guestReceiptSettings.editElement.error",
    payments: "settingsModule.paymentsSettings.editElement.error",
    dashboards: "settingsModule.dashboardsSettings.editElement.error"
  },
  loading: {
    register: "settingsModule.registerModeSettings.editElement.loading",
    lockScreen: "settingsModule.lockScreenSettings.editElement.loading",
    general: "settingsModule.generalSettings.editElement.loading",
    online: "settingsModule.onlineSettings.editElement.loading",
    roles: "settingsModule.roleDetailsSettings.editElement.loading",
    registerTicket: "settingsModule.registerTicketSettings.editElement.loading",
    kitchenTicket: "settingsModule.kitchenTicketSettings.editElement.loading",
    prepStations: "settingsModule.prepStationsSettings.editElement.loading",
    printerRules: "settingsModule.printerRulesSettings.editElement.loading",
    licenseSpecificPrinterRules: "settingsModule.licenseSpecificPrinterRules.editElement.loading",
    licenseSettings: "settingsModule.licenseSettings.editElement.loading",
    users: "settingsModule.usersSettings.editElement.loading",
    licenses: "settingsModule.licenseSettings.editElement.loading",
    devices: "settingsModule.devices_licenses.editElement.loading",
    taxes: "settingsModule.taxesSettings.editElement.loading",
    guestCheck: "settingsModule.guestCheckSettings.editElement.loading",
    guestReceipt: "settingsModule.guestReceiptSettings.editElement.loading",
    payments: "settingsModule.paymentsSettings.editElement.loading",
    dashboards: "settingsModule.dashboardsSettings.editElement.loading"
  }
};
var CREATE_SETTINGS_MESSAGES = {
  success: {
    register: "commonTexts.na",
    lockScreen: "commonTexts.na",
    general: "commonTexts.na",
    online: "commonTexts.na",
    roles: "settingsModule.roleDetailsSettings.createNewElement.success",
    registerTicket: "commonTexts.na",
    kitchenTicket: "commonTexts.na",
    prepStations: "commonTexts.na",
    printerRules: "commonTexts.na",
    licenseSpecificPrinterRules: "commonTexts.na",
    devices: "commonTexts.na",
    licenseSettings: "settingsModule.licenseSettings.createNewElement.success",
    users: "settingsModule.usersSettings.createNewElement.success",
    licenses: "commonTexts.na",
    taxes: "commonTexts.na",
    guestCheck: "commonTexts.na",
    guestReceipt: "commonTexts.na",
    payments: "commonTexts.na",
    dashboards: "commonTexts.na"
  },
  error: {
    register: "commonTexts.na",
    lockScreen: "commonTexts.na",
    general: "commonTexts.na",
    online: "commonTexts.na",
    roles: "settingsModule.roleDetailsSettings.createNewElement.error",
    registerTicket: "commonTexts.na",
    kitchenTicket: "commonTexts.na",
    prepStations: "commonTexts.na",
    printerRules: "commonTexts.na",
    licenseSpecificPrinterRules: "commonTexts.na",
    devices: "commonTexts.na",
    licenseSettings: "settingsModule.licenseSettings.createNewElement.error",
    users: "settingsModule.usersSettings.createNewElement.error",
    licenses: "commonTexts.na",
    taxes: "commonTexts.na",
    guestCheck: "commonTexts.na",
    guestReceipt: "commonTexts.na",
    payments: "commonTexts.na",
    dashboards: "commonTexts.na"
  },
  loading: {
    register: "commonTexts.na",
    lockScreen: "commonTexts.na",
    general: "commonTexts.na",
    online: "commonTexts.na",
    roles: "settingsModule.roleDetailsSettings.createNewElement.loading",
    registerTicket: "commonTexts.na",
    kitchenTicket: "commonTexts.na",
    prepStations: "commonTexts.na",
    printerRules: "commonTexts.na",
    licenseSpecificPrinterRules: "commonTexts.na",
    devices: "commonTexts.na",
    licenseSettings: "settingsModule.licenseSettings.createNewElement.loading",
    users: "settingsModule.usersSettings.createNewElement.loading",
    licenses: "commonTexts.na",
    taxes: "commonTexts.na",
    guestCheck: "commonTexts.na",
    guestReceipt: "commonTexts.na",
    payments: "commonTexts.na",
    dashboards: "commonTexts.na"
  }
};
var getRegisterDiffObject = (getState) => __async(void 0, null, function* () {
  const state = getState();
  const imageField = "imageUrl";
  const differences = settingsDifferencesSelector(state);
  const diffObject = diffRegisterModeFactory(
    differences,
    state
  );
  const imageChanges = (diffObject == null ? void 0 : diffObject.customerFacingDisplay.adsTable.filter(
    (ad) => ad.changes.some((change) => change.field === imageField)
  )) || [];
  yield Promise.all(
    imageChanges.map((imageChange) => __async(void 0, null, function* () {
      const basicImageChange = imageChange.changes.find(
        (change) => change.field === imageField
      );
      if (basicImageChange) {
        basicImageChange.value = yield getURLStringOrBase64(
          basicImageChange == null ? void 0 : basicImageChange.value
        );
      }
      return Promise.resolve(imageChange);
    }))
  );
  return diffObject;
});
var getGeneralSettingsDiffObject = (getState) => __async(void 0, null, function* () {
  const state = getState();
  const differences = cloneDeep16(settingsDifferencesSelector(state));
  const digitalLogoDiff = differences.find(
    (change) => change.path[change.path.length - 1] === "digitalLogoUrl"
  );
  const printLogoDiff = differences.find(
    (change) => change.path[change.path.length - 1] === "printLogoUrl"
  );
  if (digitalLogoDiff) {
    const digitalImageString = yield getURLStringOrBase64(
      digitalLogoDiff.rhs
    );
    digitalLogoDiff.rhs = digitalImageString;
  }
  if (printLogoDiff) {
    const printImageString = yield getURLStringOrBase64(
      printLogoDiff.rhs
    );
    printLogoDiff.rhs = printImageString;
  }
  return diffGeneralSettingsFactory(differences, state);
});
var getOnlineSettingsDiffObject = (getState) => {
  const state = getState();
  const differences = cloneDeep16(settingsDifferencesSelector(state));
  return diffOnlineSettingsFactory(differences, state);
};
var getRolesDiffObject = (getState) => {
  const state = getState();
  const differences = settingsDifferencesSelector(state);
  return diffRolesFactory(differences, state);
};
var getRegisterTicketDiffObject = (getState) => {
  const state = getState();
  const differences = settingsDifferencesSelector(state);
  return diffRegisterTicketFactory(differences);
};
var getLockScreenSettingsDiffObject = (getState) => {
  const state = getState();
  const differences = settingsDifferencesSelector(state);
  return diffLockScreenFactory(differences);
};
var getPaymentsDiffObject = (getState) => {
  const state = getState();
  const differences = settingsDifferencesSelector(state);
  return diffPaymentsFactory(differences, state);
};
var getPrepStationsDiffObject = (getState) => {
  const state = getState();
  const differences = settingsDifferencesSelector(state);
  return diffPrepStationsFactory(differences, state);
};
var getPrinterRulesDiffObject = (getState) => {
  const state = getState();
  const differences = settingsDifferencesSelector(state);
  return diffPrinterRulesFactory(differences);
};
var getTaxesDiffObject = (getState) => {
  const state = getState();
  const differences = settingsDifferencesSelector(state);
  return diffTaxesFactory(differences);
};
var getGuestCheckDiffObject = (getState) => {
  const state = getState();
  const differences = settingsDifferencesSelector(state);
  return diffGuestCheckFactory(differences, state);
};
var getGuestReceiptDiffObject = (getState) => {
  const state = getState();
  const differences = settingsDifferencesSelector(state);
  return diffGuestReceiptFactory(differences, state);
};
var getLicenseSettingsDiffObject = (getState) => {
  const state = getState();
  const differences = settingsDifferencesSelector(state);
  return diffLicenseSettingsFactory(differences);
};
var getUserDetailsDiffObject = (getState) => {
  const state = getState();
  const differences = settingsDifferencesSelector(state);
  return diffUserDetailsFactory(differences, state);
};
var getSettingsFinalDiffObject = (getState) => {
  return selectCurrentSettingsFinalDiffObject(getState());
};
var DIFF_OBJECT_GETTER = {
  register: getRegisterDiffObject,
  lockScreen: getLockScreenSettingsDiffObject,
  general: getGeneralSettingsDiffObject,
  online: getOnlineSettingsDiffObject,
  roles: getRolesDiffObject,
  registerTicket: getRegisterTicketDiffObject,
  kitchenTicket: getSettingsFinalDiffObject,
  users: getUserDetailsDiffObject,
  prepStations: getPrepStationsDiffObject,
  printerRules: getPrinterRulesDiffObject,
  licenseSpecificPrinterRules: getPrinterRulesDiffObject,
  licenseSettings: getLicenseSettingsDiffObject,
  devices: () => null,
  licenses: () => null,
  taxes: getTaxesDiffObject,
  guestCheck: getGuestCheckDiffObject,
  guestReceipt: getGuestReceiptDiffObject,
  payments: getPaymentsDiffObject,
  dashboards: () => null
};
var editSettingsElement = (onRefresh, navigate = true, postRequest2, organizationId, currentLocationId, licenseId, licenseSettingsId, errorCodesDispatcher, extraHeaders, request, mode, onContinue) => (dispatch, getState) => __async(void 0, null, function* () {
  var _a, _b, _c, _d, _e;
  const state = getState();
  const {
    settingsVersion,
    mode: stateMode,
    selectedLocations,
    data,
    id
  } = state.settings.changeData;
  let settingsSelected = (request == null ? void 0 : request.settingsSelected) || selectSettingsSelected(state);
  const loggedInUser = state.loggedInUser;
  const selectedMode = state.settings.selectedMode;
  const settingsType = selectActualSettingsType(state);
  const loggedInOrganizationUserId = loggedInUser.organizationUserId;
  const roleId = loggedInUser.loggedInRole.id;
  if (!settingsSelected || data === null && !(request == null ? void 0 : request.data) && !(request == null ? void 0 : request.diff))
    return { success: false, id: 0 };
  const isCreating = (mode || stateMode) === "create" /* CREATE */;
  dispatch(setShowConfirmationModal(CONFIRMATION_MODAL_INITIAL_STATE));
  dispatch(
    setIsLoadingModal({
      active: true,
      message: settingsSelected === "printers" || settingsSelected === "terminals" ? isCreating ? i18n_config_default.t("commonTexts.creating") : i18n_config_default.t("commonTexts.updating") : i18n_config_default.t(
        isCreating ? CREATE_SETTINGS_MESSAGES.loading[settingsSelected] : UPDATE_SETTINGS_MESSAGES.loading[settingsSelected]
      ),
      isMakingApiCall: true
    })
  );
  const url = apiConfig_default.settings.getLocationSettings(
    organizationId,
    currentLocationId
  );
  const time = (/* @__PURE__ */ new Date()).getTime();
  const hash = shajs3("sha256").update(`${time}-${settingsSelected}-${JSON.stringify(data)}`).digest("hex");
  const diffLocationIds = settingsSelected === "users" ? selectedLocations.filter((loc) => loc !== 0) : selectedLocations;
  const diffObject = settingsSelected === "printers" || settingsSelected === "terminals" ? {} : typeof DIFF_OBJECT_GETTER[settingsSelected] === "function" ? yield DIFF_OBJECT_GETTER[settingsSelected](getState) : {};
  if (settingsSelected === "licenseSpecificPrinterRules") {
    settingsSelected = "printerRules";
  }
  const isPrinterRulesScreen = PRINTER_RULES_SETTINGS_SELECTED.includes(
    settingsSelected
  );
  const isPrinterRulesInMaster = isPrinterRulesScreen && !selectedMode.id;
  const isPrepStationsScreen = settingsSelected === "prepStations";
  const isPrepStationsInMaster = isPrepStationsScreen && !selectedMode.id;
  const hasMultipleLocations = selectShouldRenderLocationDropdown(state);
  const locationId = (isPrinterRulesInMaster || isPrepStationsInMaster) && !hasMultipleLocations ? currentLocationId : selectedMode.id;
  const _settingsVersion = settingsVersion || getSettingsVersionCore(state);
  const dataRequest = request ? __spreadProps(__spreadValues({}, request), {
    hash,
    locationId,
    settingsVersion: _settingsVersion,
    diffLocationIds: request.diffLocationIds || diffLocationIds,
    roleId,
    organizationUserId: loggedInOrganizationUserId,
    diff: request.diff || diffObject
  }) : {
    settingsSelected,
    id,
    data,
    hash,
    locationId,
    settingsVersion: _settingsVersion,
    diffLocationIds,
    roleId,
    organizationUserId: loggedInOrganizationUserId,
    diff: diffObject
  };
  try {
    dispatch(setMessageId(hash));
    const response = yield apiCall(
      isCreating ? "post" /* Post */ : "put" /* Put */,
      url,
      true,
      dataRequest,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders,
      (errorResponse) => {
        var _a2, _b2, _c2;
        return ((_c2 = (_b2 = (_a2 = errorResponse.response) == null ? void 0 : _a2.data) == null ? void 0 : _b2.error) == null ? void 0 : _c2.code) !== 17 /* OUTDATED_SETTINGS */;
      }
    );
    batch$1(() => {
      dispatch(setSettingsOnState(response.settings, licenseSettingsId));
      if (settingsType !== "remoteLocation" /* REMOTE_LOCATION_SETTINGS */) {
        dispatch(updateCurrentSettings());
      }
      dispatch(
        postCreateElement(
          navigate,
          postRequest2,
          response.id,
          mode || stateMode,
          settingsSelected,
          request == null ? void 0 : request.successMessage
        )
      );
    });
    onContinue == null ? void 0 : onContinue();
    dispatch(setIsLoadingModal({ active: false, isMakingApiCall: false }));
    return { success: true, id: response.id };
  } catch (e) {
    console.error(e);
    const error = e;
    if (((_c = (_b = (_a = error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.error) == null ? void 0 : _c.code) === 17 /* OUTDATED_SETTINGS */) {
      dispatch(
        setIsLoadingModal({
          active: true,
          message: `${i18n_config_default.t("menuScreen.refreshModal.edit.settings.title")}. ${i18n_config_default.t("commonTexts.refreshingData")}...`,
          isMakingApiCall: true
        })
      );
      yield new Promise((resolve) => setTimeout(resolve, 1e3));
      dispatch(
        setSettingsOnState(
          (_e = (_d = error.response.data) == null ? void 0 : _d.error) == null ? void 0 : _e.data,
          licenseSettingsId
        )
      );
      onRefresh && onRefresh();
      yield new Promise((resolve) => setTimeout(resolve, 2e3));
      return yield dispatch(
        editSettingsElement(
          onRefresh,
          navigate,
          postRequest2,
          organizationId,
          currentLocationId,
          licenseId,
          licenseSettingsId,
          errorCodesDispatcher,
          extraHeaders,
          request,
          mode
        )
      );
    } else {
      dispatch(setIsLoadingModal({ active: false, isMakingApiCall: false }));
      return { success: false, id: 0 };
    }
  }
});
var DELETE_SETTINGS_MESSAGES = {
  success: {
    register: "commonTexts.na",
    lockScreen: "commonTexts.na",
    general: "commonTexts.na",
    online: "commonTexts.na",
    roles: "settingsModule.roleDetailsSettings.deleteElement.success",
    registerTicket: "commonTexts.na",
    kitchenTicket: "commonTexts.na",
    prepStations: "commonTexts.na",
    printerRules: "commonTexts.na",
    licenseSpecificPrinterRules: "commonTexts.na",
    devices: "commonTexts.na",
    users: "settingsModule.usersSettings.deleteElement.success",
    licenses: "commonTexts.na",
    licenseSettings: "commonTexts.na",
    taxes: "commonTexts.na",
    guestCheck: "commonTexts.na",
    guestReceipt: "commonTexts.na",
    payments: "commonTexts.na",
    dashboards: "commonTexts.na"
  },
  error: {
    register: "commonTexts.na",
    lockScreen: "commonTexts.na",
    general: "commonTexts.na",
    online: "commonTexts.na",
    roles: "settingsModule.roleDetailsSettings.deleteElement.error",
    registerTicket: "commonTexts.na",
    kitchenTicket: "commonTexts.na",
    prepStations: "commonTexts.na",
    printerRules: "commonTexts.na",
    licenseSpecificPrinterRules: "commonTexts.na",
    devices: "commonTexts.na",
    users: "settingsModule.usersSettings.deleteElement.error",
    licenses: "commonTexts.na",
    licenseSettings: "commonTexts.na",
    taxes: "commonTexts.na",
    guestCheck: "commonTexts.na",
    guestReceipt: "commonTexts.na",
    payments: "commonTexts.na",
    dashboards: "commonTexts.na"
  },
  loading: {
    register: "commonTexts.na",
    lockScreen: "commonTexts.na",
    general: "commonTexts.na",
    online: "commonTexts.na",
    roles: "settingsModule.roleDetailsSettings.deleteElement.loading",
    registerTicket: "commonTexts.na",
    kitchenTicket: "commonTexts.na",
    prepStations: "commonTexts.na",
    printerRules: "commonTexts.na",
    licenseSpecificPrinterRules: "commonTexts.na",
    devices: "commonTexts.na",
    users: "settingsModule.usersSettings.deleteElement.loading",
    licenses: "commonTexts.na",
    licenseSettings: "commonTexts.na",
    taxes: "commonTexts.na",
    guestCheck: "commonTexts.na",
    guestReceipt: "commonTexts.na",
    payments: "commonTexts.na",
    dashboards: "commonTexts.na"
  }
};
var UNASSOCIATE_SETTINGS_MESSAGES = {
  success: {
    register: "commonTexts.na",
    lockScreen: "commonTexts.na",
    general: "commonTexts.na",
    online: "commonTexts.na",
    roles: "commonTexts.na",
    registerTicket: "commonTexts.na",
    kitchenTicket: "commonTexts.na",
    prepStations: "commonTexts.na",
    printerRules: "commonTexts.na",
    licenseSpecificPrinterRules: "commonTexts.na",
    devices: "commonTexts.na",
    users: "settingsModule.usersSettings.unassociateElement.success",
    licenses: "commonTexts.na",
    licenseSettings: "commonTexts.na",
    taxes: "commonTexts.na",
    guestCheck: "commonTexts.na",
    guestReceipt: "commonTexts.na",
    payments: "commonTexts.na",
    dashboards: "commonTexts.na"
  },
  error: {
    register: "commonTexts.na",
    lockScreen: "commonTexts.na",
    general: "commonTexts.na",
    online: "commonTexts.na",
    roles: "commonTexts.na",
    registerTicket: "commonTexts.na",
    kitchenTicket: "commonTexts.na",
    prepStations: "commonTexts.na",
    printerRules: "commonTexts.na",
    licenseSpecificPrinterRules: "commonTexts.na",
    devices: "commonTexts.na",
    users: "settingsModule.usersSettings.unassociateElement.error",
    licenses: "commonTexts.na",
    licenseSettings: "commonTexts.na",
    taxes: "commonTexts.na",
    guestCheck: "commonTexts.na",
    guestReceipt: "commonTexts.na",
    payments: "commonTexts.na",
    dashboards: "commonTexts.na"
  },
  loading: {
    register: "commonTexts.na",
    lockScreen: "commonTexts.na",
    general: "commonTexts.na",
    online: "commonTexts.na",
    roles: "commonTexts.na",
    registerTicket: "commonTexts.na",
    kitchenTicket: "commonTexts.na",
    prepStations: "commonTexts.na",
    printerRules: "commonTexts.na",
    licenseSpecificPrinterRules: "commonTexts.na",
    devices: "commonTexts.na",
    licenseSettings: "commonTexts.na",
    users: "settingsModule.usersSettings.unassociateElement.loading",
    licenses: "commonTexts.na",
    taxes: "commonTexts.na",
    guestCheck: "commonTexts.na",
    guestReceipt: "commonTexts.na",
    payments: "commonTexts.na",
    dashboards: "commonTexts.na"
  }
};
var updateSettingsChangeData = () => (dispatch, getState) => {
  const state = getState();
  const { settingsSelected, id } = state.settings.changeData;
  const currentSettings = state.settings.selectedMode.currentSettings;
  const locationSettings = selectLocationSettings(state);
  const hasMultipleLocations = selectShouldRenderLocationDropdown(state);
  if (!settingsSelected) {
    return;
  }
  const isPrinterRulesScreen = PRINTER_RULES_SETTINGS_SELECTED.includes(settingsSelected);
  const isPrepStationsScreen = settingsSelected === "prepStations";
  const isLicenseSpecificPrinterRules = settingsSelected === "licenseSpecificPrinterRules";
  let newData;
  if (id) {
    newData = currentSettings[settingsSelected][id];
  } else if (isPrinterRulesScreen) {
    if (!hasMultipleLocations) {
      newData = locationSettings.printerRules;
    } else {
      newData = currentSettings[settingsSelected];
    }
  } else if (isPrepStationsScreen) {
    if (!hasMultipleLocations) {
      newData = locationSettings.prepStations;
    } else {
      newData = currentSettings[settingsSelected];
    }
  } else {
    newData = currentSettings[settingsSelected];
  }
  const settingsVersion = ((isPrinterRulesScreen || isPrepStationsScreen) && !hasMultipleLocations ? getCurrentSettingsCore(state, "location" /* LOCATION_SETTINGS */).version : getSettingsVersionCore(state)) || 0;
  if (!newData && isLicenseSpecificPrinterRules) {
    newData = {};
  }
  dispatch(
    updateSettingsChangeDataValues({
      data: newData,
      hasChanges: false,
      originalData: newData,
      sectionId: "all" /* ALL */,
      settingsVersion
    })
  );
};
var postDeleteSettingsElement = (postRequest2) => (dispatch, getState) => {
  const state = getState();
  const { settingsSelected, mode } = state.settings.changeData;
  const isMasterMode = selectSettingsType(state) === "master" /* MASTER_SETTINGS */;
  dispatch(postRequest2(true, settingsSelected || void 0, mode));
  dispatch(
    showToast({
      title: i18n_config_default.t("commonTexts.success"),
      description: settingsSelected ? i18n_config_default.t(
        isMasterMode ? DELETE_SETTINGS_MESSAGES.success[settingsSelected] : UNASSOCIATE_SETTINGS_MESSAGES.success[settingsSelected]
      ) : "Successfully deleted Element",
      type: "success"
    })
  );
};
var deleteSettingsElement = (postCreate, organizationId, currentLocationId, licenseId, licenseSettingsId, errorCodesDispatcher, extraHeaders) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const { settingsSelected, settingsVersion, id, data } = state.settings.changeData;
  const settingsType = selectActualSettingsType(state);
  const selectedMode = state.menu.selectedMode;
  if (settingsSelected === null || data === null)
    return false;
  const isMasterMode = settingsType === "master" /* MASTER_SETTINGS */;
  const loggedInUser = state.loggedInUser;
  const loggedInOrganizationUserId = loggedInUser.organizationUserId;
  const roleId = loggedInUser.loggedInRole.id;
  dispatch(
    setIsLoadingModal({
      active: true,
      message: i18n_config_default.t(
        isMasterMode ? DELETE_SETTINGS_MESSAGES.loading[settingsSelected] : UNASSOCIATE_SETTINGS_MESSAGES.loading[settingsSelected]
      ),
      isMakingApiCall: true
    })
  );
  const url = apiConfig_default.settings.getLocationSettings(
    organizationId,
    currentLocationId
  );
  const time = (/* @__PURE__ */ new Date()).getTime();
  const hash = shajs3("sha256").update(`${time}-${settingsSelected}`).digest("hex");
  const dataRequest = {
    settingsSelected,
    organizationUserId: loggedInOrganizationUserId,
    roleId,
    id,
    hash,
    data: {},
    locationId: selectedMode.id,
    settingsVersion,
    diffLocationIds: [],
    diff: {}
  };
  try {
    dispatch(setMessageId(hash));
    const response = yield apiCall(
      "delete" /* Delete */,
      url,
      true,
      dataRequest,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders
    );
    dispatch(setSettingsOnState(response.settings, licenseSettingsId));
    dispatch(postDeleteSettingsElement(postCreate));
    if (settingsType !== "remoteLocation" /* REMOTE_LOCATION_SETTINGS */) {
      dispatch(updateCurrentSettings());
    }
    return true;
  } catch (e) {
    console.error(e);
    dispatch(setIsLoadingModal({ active: false, isMakingApiCall: false }));
    return false;
  }
});
var saveSettingsChangesOnSavePress = (onRefresh, postRequest2, onIsValid) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const { settingsSelected, data } = getState().settings.changeData;
    if (settingsSelected === null || data === null)
      return;
    try {
      const fn = settingsValidationThunks(settingsSelected, data, false);
      const isValid = yield dispatch(fn);
      if (isValid) {
        onIsValid();
      }
    } catch (error) {
      console.error(error);
    }
  });
};
var associateLicenseLocation = (onRefresh, licenseIds, locationId, organizationId, currentLocationId, licenseId, licenseSettingsId, errorCodesDispatcher, extraHeaders) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const remoteLocationSettingsCopy = __spreadValues({}, state.settings.remoteLocation);
  const settingsType = selectActualSettingsType(state);
  if (licenseIds.length === 0)
    return { success: false, id: 0 };
  dispatch(setShowConfirmationModal(CONFIRMATION_MODAL_INITIAL_STATE));
  dispatch(
    setIsLoadingModal({
      active: true,
      message: i18n_config_default.t(
        "settingsModule.devices_licenses.associateLocation.loading"
      )
    })
  );
  const url = apiConfig_default.settings.associateEntityToLocation(
    organizationId,
    currentLocationId,
    "licenses"
  );
  const dataRequest = {
    ids: licenseIds,
    locationId
  };
  try {
    const response = yield apiCall(
      "put" /* Put */,
      url,
      true,
      dataRequest,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders,
      (errorResponse) => {
        var _a, _b, _c;
        return ((_c = (_b = (_a = errorResponse.response) == null ? void 0 : _a.data) == null ? void 0 : _b.error) == null ? void 0 : _c.code) !== 17 /* OUTDATED_SETTINGS */;
      }
    );
    batch$1(() => {
      dispatch(
        setSettingsOnState(
          response.menu,
          licenseSettingsId,
          false,
          { skipMaster: false },
          true
        )
      );
      if (settingsType === "remoteLocation" /* REMOTE_LOCATION_SETTINGS */ && licenseIds[0] in remoteLocationSettingsCopy.licenses) {
        const remoteLocationLicensesCopy = __spreadValues({}, remoteLocationSettingsCopy.licenses);
        delete remoteLocationLicensesCopy[licenseIds[0]];
        dispatch(
          setRemoteLocationSettings(
            __spreadProps(__spreadValues({}, remoteLocationSettingsCopy), {
              licenses: remoteLocationLicensesCopy
            }),
            true
          )
        );
      }
      dispatch(updateCurrentSettings());
      dispatch(setIsLoadingModal({ active: false }));
    });
    return { success: true, id: 0 };
  } catch (e) {
    console.error(e);
    const error = e;
    batch$1(() => {
      var _a, _b, _c, _d, _e;
      dispatch(setIsLoadingModal({ active: false }));
      if (((_c = (_b = (_a = error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.error) == null ? void 0 : _c.code) === 17 /* OUTDATED_SETTINGS */) {
        dispatch(
          setSettingsOnState(
            (_e = (_d = error.response.data) == null ? void 0 : _d.error) == null ? void 0 : _e.data,
            licenseSettingsId
          )
        );
        dispatch(
          setShowConfirmationModal({
            title: i18n_config_default.t(
              "menuScreen.refreshModal.edit.settings.title"
            ),
            description: i18n_config_default.t(
              "menuScreen.refreshModal.edit.settings.description"
            ),
            type: "refresh",
            btnSuccessText: i18n_config_default.t("menuScreen.refreshModal.successButton"),
            active: true,
            onSuccess: () => {
              onRefresh && onRefresh();
            },
            onCancel: () => {
              dispatch(
                setShowConfirmationModal(CONFIRMATION_MODAL_INITIAL_STATE)
              );
            }
          })
        );
      }
    });
    return { success: false, id: 0 };
  }
});
var getSettingsLocationsToApply = () => (_, getState) => {
  const state = getState();
  const settingsSelected = selectSettingsSelected(state);
  const currentLocationId = state.settings.selectedMode.id;
  const settingsAccessLocations = state.loggedInUser.settingsAccessLocations;
  if (!settingsSelected)
    return [];
  let locationsToApply = settingsAccessLocations.filter(
    (id) => id !== currentLocationId
  );
  if (settingsSelected === "users") {
    const updatedUser = state.settings.changeData.data;
    const userId = updatedUser.id;
    const masterUser = state.settings.master.users[userId || -1];
    if (!masterUser)
      return locationsToApply;
    const masterUserAccessLocationSet = new Set(
      (masterUser == null ? void 0 : masterUser.locationIds) || []
    );
    locationsToApply = locationsToApply.filter(
      (id) => masterUserAccessLocationSet.has(id)
    );
  }
  return locationsToApply;
};
var deactivateLicenseFromDevice = (onRefresh, deviceId, deactivateLicenseId, currentLicenseId, licenseSettingsId, organizationId, currentLocationId, errorCodesDispatcher, extraHeaders, onDeactivationSuccess) => (dispatch, getState) => __async(void 0, null, function* () {
  var _a, _b, _c, _d, _e;
  const state = getState();
  const settingsType = selectActualSettingsType(state);
  if (!deviceId || !deactivateLicenseId)
    return { success: false, id: 0 };
  dispatch(setShowConfirmationModal(CONFIRMATION_MODAL_INITIAL_STATE));
  dispatch(
    setIsLoadingModal({
      active: true,
      message: i18n_config_default.t("settingsModule.devices_licenses.deactivate.loading")
    })
  );
  const url = apiConfig_default.settings.deactivateLicense(
    organizationId,
    currentLocationId
  );
  const dataRequest = {
    licenseId: deactivateLicenseId,
    deviceId
  };
  try {
    const response = yield apiCall(
      "post" /* Post */,
      url,
      true,
      dataRequest,
      currentLicenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders,
      (errorResponse) => {
        var _a2, _b2, _c2;
        return ((_c2 = (_b2 = (_a2 = errorResponse.response) == null ? void 0 : _a2.data) == null ? void 0 : _b2.error) == null ? void 0 : _c2.code) !== 17 /* OUTDATED_SETTINGS */;
      }
    );
    batch$1(() => {
      dispatch(setSettingsOnState(response, licenseSettingsId));
      if (settingsType !== "remoteLocation" /* REMOTE_LOCATION_SETTINGS */) {
        dispatch(updateCurrentSettings());
      }
    });
    onDeactivationSuccess && onDeactivationSuccess();
    dispatch(setIsLoadingModal({ active: false }));
    return { success: true, id: 0 };
  } catch (e) {
    console.error(e);
    const error = e;
    dispatch(setIsLoadingModal({ active: false }));
    if (((_c = (_b = (_a = error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.error) == null ? void 0 : _c.code) === 17 /* OUTDATED_SETTINGS */) {
      dispatch(
        setSettingsOnState(
          (_e = (_d = error.response.data) == null ? void 0 : _d.error) == null ? void 0 : _e.data,
          licenseSettingsId
        )
      );
      dispatch(
        setShowConfirmationModal({
          title: i18n_config_default.t(
            "menuScreen.refreshModal.edit.settings.title"
          ),
          description: i18n_config_default.t(
            "menuScreen.refreshModal.edit.settings.description"
          ),
          type: "refresh",
          btnSuccessText: i18n_config_default.t("menuScreen.refreshModal.successButton"),
          active: true,
          onSuccess: () => {
            onRefresh && onRefresh();
          },
          onCancel: () => {
            dispatch(
              setShowConfirmationModal(CONFIRMATION_MODAL_INITIAL_STATE)
            );
          }
        })
      );
    }
    return { success: false, id: 0 };
  }
});
var deactivateLicense = (onRefresh, deviceId, deactivateLicenseId, currentLicenseId, licenseSettingsId, nickname, organizationId, currentLocationId, errorCodesDispatcher, extraHeaders, onDeactivationSuccess) => {
  return (dispatch) => __async(void 0, null, function* () {
    const onSuccess = () => {
      dispatch(
        deactivateLicenseFromDevice(
          onRefresh,
          deviceId,
          deactivateLicenseId,
          currentLicenseId,
          licenseSettingsId,
          organizationId,
          currentLocationId,
          errorCodesDispatcher,
          extraHeaders,
          onDeactivationSuccess
        )
      );
    };
    dispatch(
      setShowConfirmationModal({
        title: i18n_config_default.t("app.modals.deactivateLicenseFromDevice.title"),
        description: `${i18n_config_default.t(
          "app.modals.deactivateLicenseFromDevice.description"
        )} ${nickname}?`,
        active: true,
        type: "warning",
        btnCancelText: i18n_config_default.t("commonTexts.no"),
        btnSuccessText: i18n_config_default.t("commonTexts.yes"),
        showRed: true,
        onSuccess
      })
    );
  });
};
var printTestKitchenTicket = (printerId, prepStationId, organizationId, currentLocationId, licenseId, errorCodesDispatcher, extraHeaders) => (dispatch, getState) => __async(void 0, null, function* () {
  var _a;
  const state = getState();
  const settingsSelected = selectSettingsSelected(state);
  const changeData = prepStationId ? selectCurrentSettingsData(state).prepStationVersions[prepStationId] : selectCurrentSettingsData(state);
  const printers = printersSelector(state);
  const printerName = (_a = printers[printerId]) == null ? void 0 : _a.name;
  let url = "";
  let settingsField = "";
  const kitchenTicketExample = produce(
    __spreadProps(__spreadValues({}, registerTicketSettings_dummy_default), {
      locationId: currentLocationId,
      organizationId
    }),
    (draft) => {
      checkAndDisplayCheckElementsRollUp(draft);
    }
  );
  switch (settingsSelected) {
    case "guestCheck":
      settingsField = "guestCheckSettings";
      url = apiConfig_default.settings.printTestGuestCheckTicket(
        organizationId,
        currentLocationId
      );
      break;
    case "guestReceipt":
      settingsField = "guestReceiptSettings";
      url = apiConfig_default.settings.printTestGuestReceiptTicket(
        organizationId,
        currentLocationId
      );
      break;
    default:
      settingsField = "kitchenTicket";
      url = apiConfig_default.settings.printTestKitchenTicket(
        organizationId,
        currentLocationId
      );
  }
  const dataRequest = {
    isFire: false,
    isTest: true,
    printerId,
    [settingsField]: changeData,
    order: kitchenTicketExample
  };
  dispatch(
    setIsLoadingModal({ active: true, message: "Printing Test Ticket" })
  );
  try {
    yield apiCall(
      "post" /* Post */,
      url,
      true,
      dataRequest,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders
    );
    batch$1(() => {
      dispatch(setIsLoadingModal({ active: false }));
      dispatch(
        showToast({
          title: i18n_config_default.t("commonTexts.success"),
          description: i18n_config_default.t(
            "settingsModule.kitchenTicketSettings.printTest.success",
            { printerName }
          ),
          type: "info"
        })
      );
    });
    return { success: true, id: 0 };
  } catch (e) {
    dispatch(setIsLoadingModal({ active: false }));
    return { success: false, id: 0 };
  }
});
var validateKitchenSettingsData = () => (dispatch, getState) => {
  const state = getState();
  dispatch(
    checkKitchenTicketSettingsFormValidation(
      selectCurrentSettingsData(state),
      false,
      () => null,
      true
    )
  );
};
var pullKitchenTicketPrepStationSettings = (prepStationVersionId, prepStationToPullId) => (dispatch, getState) => {
  const state = getState();
  const currentPrepStationVersions = selectCurrentSettingsData(state).prepStationVersions;
  if (!prepStationToPullId)
    return;
  const prepStationToPull = currentPrepStationVersions[prepStationToPullId];
  if (!prepStationToPull)
    return;
  dispatch(
    updateGenericSettings(
      {
        prepStationVersions: __spreadProps(__spreadValues({}, currentPrepStationVersions), {
          [prepStationVersionId]: __spreadProps(__spreadValues({}, prepStationToPull), {
            prepStationId: prepStationVersionId
          })
        })
      },
      "all" /* ALL */
    )
  );
  dispatch(validateKitchenSettingsData());
};
var pushKitchenTicketPrepStationsSettings = (prepStationVersionId, prepStationToPushIds) => (dispatch, getState) => {
  const state = getState();
  const currentPrepStationVersions = selectCurrentSettingsData(state).prepStationVersions;
  const clonedPrepStationVersions = cloneDeep16(currentPrepStationVersions);
  prepStationToPushIds.forEach((prepStationToPushId) => {
    clonedPrepStationVersions[prepStationToPushId] = __spreadProps(__spreadValues({}, clonedPrepStationVersions[prepStationVersionId]), {
      prepStationId: prepStationToPushId
    });
  });
  dispatch(
    updateGenericSettings(
      {
        prepStationVersions: clonedPrepStationVersions
      },
      "all" /* ALL */
    )
  );
  dispatch(validateKitchenSettingsData());
};
var resendUserInvite = (type, organizationId, licenseId, errorCodesDispatcher, extraHeaders) => (dispatch, getState) => {
  const state = getState();
  const { settingsSelected, data } = state.settings.changeData;
  if (!settingsSelected || !data)
    return;
  const userId = data.userId;
  const urlGetter = type === "app" ? apiConfig_default.user.resendAppInvite : apiConfig_default.user.resendOrgInvite;
  const url = urlGetter(userId);
  const body = {
    userId,
    organizationId
  };
  dispatch(
    setIsLoadingModal({
      active: true,
      message: i18n_config_default.t(
        "settingsModule.userDetailsSettings.resendInviteRequest.loading"
      )
    })
  );
  apiCall(
    "post" /* Post */,
    url,
    true,
    body,
    licenseId,
    errorCodesDispatcher,
    dispatch,
    state,
    extraHeaders
  ).then(() => {
    dispatch(
      showToast({
        title: i18n_config_default.t("commonTexts.success"),
        description: i18n_config_default.t(
          "settingsModule.userDetailsSettings.resendInviteRequest.success"
        ),
        type: "success"
      })
    );
  }).catch(() => {
    dispatch(
      showToast({
        title: i18n_config_default.t("commonTexts.error"),
        description: i18n_config_default.t(
          "settingsModule.userDetailsSettings.resendInviteRequest.error"
        ),
        type: "error"
      })
    );
  }).finally(() => {
    dispatch(setIsLoadingModal({ active: false }));
  });
};
var removePrinters = (printerIds, isWebSocket = false) => (dispatch, getState) => {
  dispatch(setRemovedPrinters(printerIds, isWebSocket));
  const resultingState = getState();
  const isSettingsLocationMode = selectSettingsType(resultingState) === "location" /* LOCATION_SETTINGS */;
  if (!isSettingsLocationMode)
    return;
  dispatch(updateCurrentSettings());
};

// src/state/settings/breadCrumb/actions.ts
var setSettingsBreadCrumbLocation = (payload) => ({
  type: SET_SETTINGS_BREADCRUMB_LOCATION,
  payload
});
var setSettingsBreadCrumb = (payload) => ({
  type: SET_SETTINGS_BREADCRUMB,
  payload
});
var addSettingsBreadCrumbLocation = (location) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    if (location.action === "replace" /* REPLACE */) {
      const breadCrumb = cloneDeep16(getState().settings.breadCrumb);
      breadCrumb.pop();
      dispatch(setSettingsBreadCrumb([...breadCrumb, location]));
    } else if (location.action === "nav-main" /* NAV_MAIN */) {
      dispatch(setSettingsBreadCrumb([location]));
    } else if (location.action === "add" /* ADD */) {
      const newLocation = __spreadProps(__spreadValues({}, location), {
        text: `Adding ${location.text}`
      });
      dispatch(setSettingsBreadCrumbLocation(newLocation));
    } else if (location.action === "edit" /* EDIT */) {
      const newLocation = __spreadProps(__spreadValues({}, location), {
        text: `Editing ${location.text}`
      });
      dispatch(setSettingsBreadCrumbLocation(newLocation));
    } else {
      dispatch(setSettingsBreadCrumbLocation(location));
    }
    location.onPress();
  });
};
var checkSettingsBreadCrumbLocation = (index, onRefresh, postRequest2, organizationId, currentLocationId, licenseId, licenseSettingsId, errorCodesDispatcher, extraHeaders) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const breadCrumb = getState().settings.breadCrumb;
    const newBreadCrumb = breadCrumb.slice(0, index + 1);
    if (breadCrumb[index].action === "nav-main") {
      dispatch(
        checkForSettingsChangesAndNavigate(
          () => {
            dispatch(setSettingsBreadCrumb([breadCrumb[index]]));
            breadCrumb[index].onPress();
          },
          onRefresh,
          postRequest2,
          organizationId,
          currentLocationId,
          licenseId,
          licenseSettingsId,
          errorCodesDispatcher,
          extraHeaders
        )
      );
    } else {
      dispatch(
        checkForSettingsChangesAndNavigate(
          () => {
            dispatch(setSettingsBreadCrumb(newBreadCrumb));
            breadCrumb[index].onPress();
          },
          onRefresh,
          postRequest2,
          organizationId,
          currentLocationId,
          licenseId,
          licenseSettingsId,
          errorCodesDispatcher,
          extraHeaders
        )
      );
    }
  });
};
var setSettingsBreadCrumbStatusPath = (index, statusPath) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const breadCrumb = getState().settings.breadCrumb;
    if (breadCrumb.length >= index + 1) {
      const breadCrumbCopy = cloneDeep16(breadCrumb);
      const newBreadCrumb = breadCrumbCopy[index];
      newBreadCrumb.statusPath = statusPath;
      breadCrumbCopy[index] = newBreadCrumb;
      dispatch(setSettingsBreadCrumb(breadCrumbCopy));
    }
  });
};

// src/state/settings/users/actions.ts
var setUsers = (payload) => ({
  type: SET_USERS,
  payload
});
var updateUsersTimeSummary = (payload, ws) => ({
  type: ws ? UPDATE_TIME_SUMMARY_WS : UPDATE_TIME_SUMMARY,
  payload
});
var updateRecentOrders = (payload, ws) => ({
  type: ws ? UPDATE_RECENT_ORDERS_WS : UPDATE_RECENT_ORDERS,
  payload
});
var updateLoggedInUserRecentOrders = (payload, ws) => ({
  type: ws ? UPDATE_LOGGED_IN_RECENT_ORDERS_WS : UPDATE_LOGGED_IN_RECENT_ORDERS,
  payload
});
var clockInClockOut = (clockIn, organizationId, locationId, userData, errorCodesDispatcher, extraHeaders, setIsLoaderActive) => {
  return (dispatch, getState) => {
    setIsLoaderActive && setIsLoaderActive(true);
    return dispatch(
      createEmployeeAction(
        clockIn ? "clock in" /* ClockIn */ : "clock out" /* ClockOut */,
        "general" /* General */,
        organizationId,
        locationId,
        userData,
        errorCodesDispatcher,
        extraHeaders,
        void 0,
        (error) => {
          var _a;
          const customError = (_a = error.response) == null ? void 0 : _a.data.error;
          if (customError && customError.code === 127) {
            dispatch(
              showToast({
                type: "info",
                title: i18n_config_default.t(
                  "authentication.timeSummary.clockIn.alreadyClockedIn"
                )
              })
            );
            return false;
          }
          return true;
        }
      )
    ).then((response) => {
      const state = getState();
      const organizationUserId = state.loggedInUser.organizationUserId;
      dispatch(
        updateUserRecentOrders({ recentOrders: [], organizationUserId })
      );
      if (response.payload.drawers)
        dispatch(setDrawers(response.payload.drawers));
      dispatch(updateUsersTimeSummary(response.payload));
      setIsLoaderActive && setIsLoaderActive(false);
    }).catch((error) => {
      var _a;
      const axiosError = error;
      const body = (_a = axiosError.response) == null ? void 0 : _a.data.error;
      const state = getState();
      if (body && body.code === 127 && !!state.loggedInUser.id) {
        const organizationUserId = state.loggedInUser.organizationUserId;
        const currentTimeSummary = state.loggedInUser.shiftTimeSummary;
        const data = body.data;
        const loggedInRole = state.loggedInUser.loggedInRole;
        const validClockIn = data.validClockIn;
        let role = loggedInRole;
        if (loggedInRole.roleId !== validClockIn.roleId) {
          const [fixedRole] = getUserRolesFromRolesIdsCore(
            [validClockIn.roleId],
            state
          );
          dispatch(setLoggedInRoleOnState(fixedRole));
          role = fixedRole;
        }
        dispatch(
          updateUsersTimeSummary(__spreadProps(__spreadValues({}, currentTimeSummary), {
            status: "active",
            role,
            lastClockedInRole: role,
            action: validClockIn.action,
            organizationUserId,
            licenseId: userData.licenseId
          }))
        );
        setIsLoaderActive && setIsLoaderActive(false);
      }
    });
  };
};
var breakInBreakOut = (breakIn, organizationId, locationId, userData, errorCodesDispatcher, extraHeaders, setIsLoaderActive) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    setIsLoaderActive && setIsLoaderActive(true);
    const userStatus = getState().loggedInUser.shiftTimeSummary.status;
    if (userStatus === "inactive" /* INACTIVE */) {
      dispatch(
        showToast({
          type: "info",
          title: "You are not clocked in",
          description: "You must be clocked in to take a break"
        })
      );
      return;
    }
    const response = yield dispatch(
      createEmployeeAction(
        breakIn ? "break in" /* BreakIn */ : "break out" /* BreakOut */,
        "general" /* General */,
        organizationId,
        locationId,
        userData,
        errorCodesDispatcher,
        extraHeaders
      )
    );
    dispatch(updateUsersTimeSummary(response.payload));
    setIsLoaderActive && setIsLoaderActive(false);
  });
};
var createEmployeeAction = (action, module, organizationId, locationId, userData, errorCodesDispatcher, extraHeaders, extraData, reportError = () => true) => {
  return (dispatch, getState) => {
    const state = getState();
    const url = apiConfig_default.settings.createEmployeeAction(
      organizationId,
      locationId
    );
    const data = {
      roleId: userData.roleId,
      organizationUserId: userData.organizationUserId,
      action,
      data: __spreadValues({
        licenseId: userData.licenseId
      }, extraData),
      module
    };
    return apiCall(
      "post" /* Post */,
      url,
      true,
      data,
      userData.licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders,
      reportError
    );
  };
};
var getMenuAccessLocations = (showClockInSuggestModal, organizationId, licenseId, errorCodesDispatcher, onPress, onNavigate, extraHeaders) => {
  return (dispatch, getState) => {
    const state = getState();
    const organizationUserId = state.loggedInUser.organizationUserId;
    const getUserLocationsUrl = apiConfig_default.menu.getMenuAccessLocations(
      organizationId,
      organizationUserId
    );
    apiCall(
      "get" /* Get */,
      getUserLocationsUrl,
      true,
      void 0,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders
    ).then((userLocations) => {
      dispatch(resetChangeData());
      dispatch({
        type: SET_MENU_ACCESS_LOCATIONS,
        payload: userLocations.locationIds
      });
      dispatch(
        setBreadCrumb([
          {
            action: "nav-main" /* NAV_MAIN */,
            text: i18n_config_default.t(BUCKET_TEXT_DICTIONARY.menuTypes),
            onPress
          }
        ])
      );
      onNavigate();
      if (showClockInSuggestModal)
        dispatch(setIsClockInSuggestionModalOpen(true));
    }).catch((err) => console.error(err));
  };
};
var getSettingsAccessLocations = (showClockInSuggestModal, organizationId, licenseId, errorCodesDispatcher, onPress, onNavigate, extraHeaders) => {
  return (dispatch, getState) => {
    const state = getState();
    const organizationUserId = state.loggedInUser.organizationUserId;
    const getUserLocationsUrl = apiConfig_default.menu.getMenuAccessLocations(
      organizationId,
      organizationUserId
    );
    apiCall(
      "get" /* Get */,
      getUserLocationsUrl,
      true,
      void 0,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders
    ).then((userLocations) => {
      dispatch(resetSettingsChangeData());
      dispatch({
        type: SET_SETTINGS_ACCESS_LOCATIONS,
        payload: userLocations.locationIds
      });
      dispatch(
        setSettingsBreadCrumb([
          {
            action: "nav-main" /* NAV_MAIN */,
            text: "Settings Screen",
            onPress
          }
        ])
      );
      onNavigate();
      if (showClockInSuggestModal)
        dispatch(setIsClockInSuggestionModalOpen(true));
    }).catch((err) => console.error(err));
  };
};
var updateUserRecentOrders = (payload) => (dispatch, getState) => {
  const state = getState();
  const loggedInOrganizationUserId = state.loggedInUser.organizationUserId;
  const users = state.settings.selectedMode.currentSettings.users;
  if (!users[payload.organizationUserId])
    return;
  if (payload.organizationUserId === loggedInOrganizationUserId)
    dispatch(updateLoggedInUserRecentOrders(payload));
};
var removeRecentOrderClosed = (payload) => (dispatch, getState) => {
  const state = getState();
  const loggedInOrganizationUser = state.loggedInUser;
  const filteredRecentOrders = loggedInOrganizationUser.recentOrders.filter(
    (recentOrder) => recentOrder.orderId !== payload.orderId
  );
  dispatch(
    updateLoggedInUserRecentOrders({
      recentOrders: filteredRecentOrders,
      organizationUserId: loggedInOrganizationUser.organizationUserId
    })
  );
};
var updateUserRecentOrdersStation = (recentOrder) => (dispatch, getState) => {
  const state = getState();
  const organizationUserId = state.loggedInUser.organizationUserId;
  const recentOrders = state.loggedInUser.recentOrders;
  const currentRecentOrders = [...recentOrders];
  const differentOrders = currentRecentOrders.filter(
    (order) => typeof order.orderId === "string" ? order.orderId.toString() !== recentOrder.orderId.toString() : order.orderId !== recentOrder.orderId
  );
  let newRecentOrders = [];
  if (differentOrders.length === currentRecentOrders.length)
    newRecentOrders = [recentOrder, ...currentRecentOrders];
  else
    newRecentOrders = [recentOrder, ...differentOrders];
  dispatch(
    updateLoggedInUserRecentOrders({
      recentOrders: trimArrayToMaxLength(newRecentOrders, 2),
      organizationUserId
    })
  );
};
var replaceUserRecentOrderStation = (payload, oldId) => (dispatch, getState) => {
  const state = getState();
  const currentRecentOrders = state.loggedInUser.recentOrders.map(
    (order) => order.orderId !== oldId ? order : payload
  );
  const organizationUserId = state.loggedInUser.organizationUserId;
  dispatch(
    updateLoggedInUserRecentOrders(
      {
        recentOrders: currentRecentOrders,
        organizationUserId
      },
      true
    )
  );
};

// src/state/register/orders/thunks/discountsAndSpecials.ts
var discountsAndSpecials_exports = {};
__export(discountsAndSpecials_exports, {
  addDiscountToActiveItemsCore: () => addDiscountToActiveItemsCore,
  addDiscountToActiveOrder: () => addDiscountToActiveOrder,
  applySpecialsToNewItems: () => applySpecialsToNewItems,
  clearOrderSpecialObjects: () => clearOrderSpecialObjects,
  removeComboOrItemDiscountThunk: () => removeComboOrItemDiscountThunk,
  removeOrderDiscountThunk: () => removeOrderDiscountThunk,
  setUpCurrentOrderActiveSpecials: () => setUpCurrentOrderActiveSpecials,
  toggleMultiselectModeCore: () => toggleMultiselectModeCore,
  updateOrderDiscountThunk: () => updateOrderDiscountThunk,
  updateTicketElementDiscountThunk: () => updateTicketElementDiscountThunk
});
var addDiscountToActiveItemsCore = (discount) => (dispatch, getState) => {
  const state = getState();
  const itemList = selectCurrentActiveItems(state);
  const orderId = selectCurrentOrderId(state);
  const currentSeat = selectCurrentSeatSelected(state);
  if (orderId === null)
    return;
  const order = state.register.orders[orderId];
  const currentOrderClosedChecks = selectCurrentOrderClosedCheckIds(state);
  const applyDiscount = (removeExclusive) => {
    const itemElements = Object.values(order.ticketElements).filter(
      (ticketElement) => itemList.includes(getTicketElementId(ticketElement))
    ).filter(
      (ticketElement) => {
        var _a;
        return !((_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[ticketElement.isOpenItem ? 0 : ticketElement.menuTypeId].excludeFromDiscounts);
      }
    ).filter(
      (ticketElement) => ticketElement.totalPricePerItemUnit > 0 && ticketElement.totalPriceWithDiscountsSpecialsNotTaxes > 0 && !ticketElement.isVoided
    ).filter((ticketElement) => {
      if (!ticketElement.ticketElementToCheckElementsId)
        return true;
      const ticketElementToCheckElements = Object.values(
        order.ticketElementToCheckElements[ticketElement.ticketElementToCheckElementsId]
      );
      const isTicketElementInClosedChecks = ticketElementToCheckElements.some(
        ({ checkId }) => currentOrderClosedChecks.includes(checkId)
      );
      return !isTicketElementInClosedChecks;
    }).map(getTicketElementId);
    const comboElements = Object.values(order.combos).filter(
      (comboElement) => itemList.includes(getTicketElementId(comboElement))
    ).filter(
      (comboElement) => comboElement.totalPricePerItemUnit > 0 && comboElement.totalPriceWithDiscountsSpecialsNotTaxes > 0 && !comboElement.isVoided
    ).map(getTicketElementId);
    validateGeneralSeatingMode(
      getState,
      (checkForSplit) => dispatch(
        actionCreators_exports.applyDiscountToItem(
          discount,
          itemElements,
          comboElements,
          orderId,
          removeExclusive,
          currentSeat,
          checkForSplit
        )
      )
    );
    dispatch(updateRegisterNavigationField({ activeItems: [] }));
  };
  if (discount.type === "override" /* OVERRIDE */) {
    const itemsUnderTheOverrideValue = Object.values(order.ticketElements).filter(
      (ticketElement) => itemList.includes(getTicketElementId(ticketElement))
    ).filter(
      ({ baseItemPrice, selectedModifiersPricePerItemUnit }) => {
        var _a;
        return ((_a = discount.value) != null ? _a : 0) >= baseItemPrice + selectedModifiersPricePerItemUnit;
      }
    );
    const combosUnderOverrideValue = Object.values(order.combos).filter(
      (comboElement) => itemList.includes(getTicketElementId(comboElement))
    ).filter(
      ({ comboBasePrice, totalAdditionalPriceAmount }) => {
        var _a;
        return ((_a = discount.value) != null ? _a : 0) >= comboBasePrice + totalAdditionalPriceAmount;
      }
    );
    if (itemsUnderTheOverrideValue.length > 0 || combosUnderOverrideValue.length > 0)
      dispatch(
        setShowConfirmationModal({
          title: i18n_config_default.t(
            "register.modals.discounts.itemsUnderOverrideValueTitle"
          ),
          description: i18n_config_default.t(
            itemsUnderTheOverrideValue.length > 1 ? "register.modals.discounts.itemsUnderOverrideValueMultipleDescription" : "register.modals.discounts.itemsUnderOverrideValueSingleDescription",
            {
              overridePrice: discount.value,
              itemCount: itemsUnderTheOverrideValue.length + combosUnderOverrideValue.length,
              discountName: discount.posName,
              posName: [
                ...getItemNameOrNames(itemsUnderTheOverrideValue),
                ...getComboNames(combosUnderOverrideValue)
              ].join(", ")
            }
          ),
          active: true,
          type: "info",
          hideCancel: true,
          btnSuccessText: i18n_config_default.t("commonButtons.ok"),
          onSuccess: () => null
        })
      );
    else
      applyDiscount(false);
  } else if (discount.isExclusive) {
    let summary = Object.values(order.ticketElements).filter(
      (ticketElement) => itemList.includes(getTicketElementId(ticketElement))
    ).reduce(getDiscountCount, { count: 0, items: [] });
    summary = Object.values(order.combos).filter(
      (comboElement) => itemList.includes(getTicketElementId(comboElement))
    ).reduce(getDiscountCount, summary);
    if (summary.count > 0)
      dispatch(
        setShowConfirmationModal({
          title: i18n_config_default.t(
            "register.modals.discounts.exclusiveDiscount"
          ),
          description: i18n_config_default.t(
            "register.modals.discounts.exclusiveDiscountDescription"
          ),
          active: true,
          type: "warning",
          btnCancelText: i18n_config_default.t("commonButtons.cancel"),
          btnSuccessText: i18n_config_default.t("commonButtons.continue"),
          onSuccess: () => applyDiscount(true)
        })
      );
    else
      applyDiscount(false);
  } else {
    let summary = Object.values(order.ticketElements).filter((item) => itemList.includes(getTicketElementId(item))).reduce(getExclusiveDiscountsCount, { count: 0, items: [] });
    summary = Object.values(order.combos).filter(
      (comboElement) => itemList.includes(getTicketElementId(comboElement))
    ).reduce(getExclusiveDiscountsCount, summary);
    if (summary.count > 0)
      dispatch(
        setShowConfirmationModal({
          title: i18n_config_default.t(
            "register.modals.discounts.removingExclusiveDiscount"
          ),
          description: i18n_config_default.t(
            "register.modals.discounts.removingExclusiveDiscountDescription",
            { selectedDiscount: discount.posName }
          ),
          active: true,
          type: "warning",
          btnCancelText: i18n_config_default.t("commonButtons.stay"),
          btnSuccessText: i18n_config_default.t("commonButtons.continue"),
          onSuccess: () => applyDiscount(true)
        })
      );
    else
      applyDiscount(false);
  }
};
var addDiscountToActiveOrder = (discount) => (dispatch) => {
  dispatch(addDiscountToActiveOrderValid(discount));
};
var addDiscountToActiveOrderValid = (discount) => (dispatch, getState) => {
  var _a, _b;
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  if (orderId === null)
    return;
  if (discount.type === "override" /* OVERRIDE */) {
    const hasOrderDiscounts = Object.keys(state.register.orders[orderId].orderDiscounts).length > 0;
    const hasItemDiscounts = Object.values(
      state.register.orders[orderId].ticketElements
    ).map(({ discounts }) => discounts != null ? discounts : {}).some((discounts) => Object.keys(discounts).length > 0);
    if (hasOrderDiscounts || hasItemDiscounts) {
      const discountsList = `${hasItemDiscounts ? i18n_config_default.t("register.modals.discounts.itemDiscounts") : ""}${hasItemDiscounts && hasOrderDiscounts ? ` ${i18n_config_default.t("commonTexts.and")} ` : ""}${hasOrderDiscounts ? i18n_config_default.t("register.modals.discounts.orderDiscounts") : ""}`;
      dispatch(
        setShowConfirmationModal({
          title: i18n_config_default.t(
            "register.modals.discounts.overrideOrderDiscount"
          ),
          description: i18n_config_default.t(
            "register.modals.discounts.overrideOrderDiscountDescription",
            {
              discountsList
            }
          ),
          active: true,
          type: "info",
          btnCancelText: i18n_config_default.t("commonButtons.cancel"),
          btnSuccessText: i18n_config_default.t("commonButtons.ok"),
          onCancel: () => null,
          onSuccess: () => dispatch(
            actionCreators_exports.applyDiscountToOrder(
              discount,
              orderId,
              true
            )
          )
        })
      );
    } else
      dispatch(
        actionCreators_exports.applyDiscountToOrder(discount, orderId, true)
      );
  } else if (discount.isExclusive) {
    const hasDiscounts = Object.values((_a = state.register.orders[orderId].orderDiscounts) != null ? _a : {}).length > 0;
    if (hasDiscounts)
      dispatch(
        setShowConfirmationModal({
          title: i18n_config_default.t(
            "register.modals.discounts.exclusiveDiscount"
          ),
          description: i18n_config_default.t(
            "register.modals.discounts.exclusiveDiscountOrderDescription"
          ),
          active: true,
          type: "warning",
          btnCancelText: i18n_config_default.t("commonButtons.cancel"),
          btnSuccessText: i18n_config_default.t("commonButtons.continue"),
          onSuccess: () => dispatch(
            actionCreators_exports.applyDiscountToOrder(
              discount,
              orderId,
              true
            )
          )
        })
      );
    else
      dispatch(
        actionCreators_exports.applyDiscountToOrder(discount, orderId, false)
      );
  } else {
    const order = state.register.orders[orderId];
    const hasExclusiveDiscount = Object.values(
      (_b = order.orderDiscounts) != null ? _b : {}
    ).some((itemDiscount) => itemDiscount.isExclusive);
    if (hasExclusiveDiscount)
      dispatch(
        setShowConfirmationModal({
          title: i18n_config_default.t(
            "register.modals.discounts.removingExclusiveDiscount"
          ),
          description: i18n_config_default.t(
            "register.modals.discounts.removingExclusiveOrderDiscountDescription",
            { selectedDiscount: discount.checkName }
          ),
          active: true,
          type: "warning",
          btnCancelText: i18n_config_default.t("commonButtons.stay"),
          btnSuccessText: i18n_config_default.t("commonButtons.continue"),
          onSuccess: () => dispatch(
            actionCreators_exports.applyDiscountToOrder(
              discount,
              orderId,
              true
            )
          )
        })
      );
    else
      dispatch(
        actionCreators_exports.applyDiscountToOrder(discount, orderId, false)
      );
  }
};
var updateOrderDiscountThunk = (discount, discountId, tabletGeneratedId, isCustom) => (dispatch, getState) => {
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  if (orderId)
    dispatch(
      actionCreators_exports.updateOrderDiscount(
        orderId,
        discount,
        discountId,
        tabletGeneratedId,
        isCustom
      )
    );
};
var updateTicketElementDiscountThunk = (elementId, discount, discountId, tabletGeneratedId, isCustom, isCombo) => (dispatch, getState) => {
  const state = getState();
  const { orderId, currentSeat } = state.register.registerNavigation;
  if (orderId === null || !elementId)
    return;
  const ticketElement = state.register.orders[orderId].ticketElements[elementId];
  validateSeatingMode(
    getState,
    (seatSplitRequired = false) => dispatch(
      actionCreators_exports.updateTicketItemDiscount(
        orderId,
        elementId,
        discount,
        discountId,
        tabletGeneratedId,
        isCustom,
        {
          currentSeat,
          seatSplitRequired,
          isSeatingModeEnabled: selectIsCurrentOrderSeatingMode.lastResult()
        },
        isCombo
      )
    ),
    ticketElement
  );
};
var removeComboOrItemDiscountThunk = (ticketElementId, id, tabletGeneratedId) => (dispatch, getState) => {
  const state = getState();
  const { orderId, currentSeat } = state.register.registerNavigation;
  if (orderId === null)
    return;
  const ticketElement = state.register.orders[orderId].ticketElements[ticketElementId];
  const comboElement = state.register.orders[orderId].combos[ticketElementId];
  const isCombo = comboElement !== null && !ticketElement;
  validateSeatingMode(
    getState,
    (seatSplitRequired = false) => dispatch(
      actionCreators_exports.removeDiscountFromElement(
        orderId,
        ticketElementId,
        id,
        tabletGeneratedId,
        {
          currentSeat,
          seatSplitRequired,
          isSeatingModeEnabled: selectIsCurrentOrderSeatingMode.lastResult()
        },
        isCombo
      )
    ),
    ticketElement
  );
};
var removeOrderDiscountThunk = (id, tabletGeneratedId) => (dispatch, getState) => {
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  if (orderId === null)
    return;
  dispatch(
    actionCreators_exports.removeDiscountFromOrder(
      orderId,
      id,
      tabletGeneratedId
    )
  );
};
var toggleMultiselectModeCore = () => (dispatch, getState) => {
  var _a;
  const state = getState();
  const customTicketMode = state.register.registerNavigation.ticketMultiselectMode;
  const orderId = state.register.registerNavigation.orderId;
  const ticketElementId = state.register.registerNavigation.ticketElementId;
  const isPaymentModeActive = state.register.paymentNavigation.isPaymentModeActive;
  const isDiscountsToggled = state.register.paymentNavigation.isDiscountsToggled;
  let isDiscountDisabled = false;
  if (ticketElementId !== null && orderId !== null && !isPaymentModeActive) {
    const ticketElement = state.register.orders[orderId].ticketElements[ticketElementId];
    isDiscountDisabled = isOpenItemFn(ticketElement) ? ticketElement.baseItemPrice === 0 || ticketElement.isVoided : ((_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[ticketElement.menuTypeId].excludeFromDiscounts) || ticketElement.baseItemPrice === 0 || !!ticketElement.comboElementId || ticketElement.isVoided;
  }
  const activeItems = ticketElementId !== null && !isDiscountDisabled ? [ticketElementId] : [];
  dispatch(
    updateRegisterNavigationField({
      activeItems,
      ticketMultiselectMode: customTicketMode === null ? "discounts" : null,
      detailsOverlay: false
    })
  );
  if (isPaymentModeActive)
    dispatch(
      updatePaymentNavigation({
        isPaymentModeActive: false,
        isDiscountsToggled: true
      })
    );
  else if (isDiscountsToggled)
    dispatch(
      updatePaymentNavigation({
        isPaymentModeActive: true,
        isDiscountsToggled: false
      })
    );
};
var setUpCurrentOrderActiveSpecials = (menuTypeId, itemId, comboId) => (dispatch, getState) => {
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  if (orderId === null || menuTypeId === null)
    return;
  const specialsBucket = selectSpecials(state);
  const activeBogoSpecials = selectCurrentActiveBOGOSpecials(state);
  const specialObjects = Object.values(activeBogoSpecials).map((activeSpecial) => specialsBucket[activeSpecial.specialId]).filter((special) => special.menuTypeVersions[menuTypeId]).map((special) => __spreadProps(__spreadValues({}, special.menuTypeVersions[menuTypeId]), {
    specialId: special.specialId
  }));
  const currentOrderSpecials = selectCurrentOrderSpecialsSource(state);
  let specialsToAdd = [];
  if (itemId !== null) {
    specialsToAdd = specialObjects.filter(
      (special) => special.buyItemIds.includes(itemId) || special.getItemIds.includes(itemId)
    );
  } else if (comboId !== null) {
    specialsToAdd = specialObjects.filter(
      (special) => special.buyComboIds.includes(comboId) || special.getComboIds.includes(comboId)
    );
  }
  specialsToAdd = specialsToAdd.filter(
    (special) => !currentOrderSpecials[special.specialId]
  );
  if (specialsToAdd.length === 0)
    return;
  const specialSourceList = {};
  specialsToAdd.forEach((specialMenuType) => {
    const {
      getComboIds,
      getItemIds,
      buyComboIds,
      buyItemIds,
      buyQuantity,
      getQuantity,
      mimicItems
    } = specialMenuType;
    const discountSpecialObj = {
      specialId: specialMenuType.specialId,
      discountAmount: specialMenuType.discountAmount,
      discountType: specialMenuType.discountType,
      posName: specialMenuType.posName,
      checkName: specialMenuType.checkName,
      specialApplyTo: specialMenuType.specialApplyTo,
      thresholdAmount: specialMenuType.thresholdAmount
    };
    specialSourceList[specialMenuType.specialId] = {
      buyComboIds,
      buyItemIds,
      getComboIds: mimicItems ? [] : getComboIds,
      getItemIds: mimicItems ? [] : getItemIds,
      buyQuantity,
      getQuantity,
      mimicItems,
      discountSpecialObj,
      specialId: specialMenuType.specialId
    };
  });
  dispatch(addSpecialObjectsToOrder(orderId, specialSourceList));
};
var applySpecialsToNewItems = () => (dispatch, getState) => {
  const state = getState();
  const specialsBuyIds = selectCurrentBOGOSpecialsBuyItemIds(state);
  const specialsGetIds = selectCurrentBOGOSpecialsGetItemIds(state);
  const orderId = selectCurrentOrderId(state);
  const ticket = selectCurrentTicket(state);
  const combos = selectCurrentCombos(state);
  const isSeatingEnabled = selectIsCurrentOrderSeatingMode(state);
  const orderSpecialsSource = selectCurrentOrderSpecialsSource(state);
  const triggerElements = selectCurrentSpecialsTriggerElementInstances(state);
  const rewardedElements = selectCurrentSpecialsRewardedElementInstances(state);
  if (orderId === null)
    return;
  const specialsToApply = getSpecialsToApply(
    ticket,
    combos,
    orderSpecialsSource,
    specialsBuyIds,
    specialsGetIds,
    triggerElements,
    rewardedElements
  );
  if (!isEmpty(specialsToApply)) {
    dispatch(
      applySpecialToTicket({
        orderId,
        isSeatingEnabled,
        specialObjects: specialsToApply
      })
    );
  }
};
var clearOrderSpecialObjects = () => (dispatch, getState) => {
  const state = getState();
  const order = selectCurrentOrderObj(state);
  const orderId = selectCurrentOrderId(state);
  if (orderId === null)
    return;
  const { ticketElements, combos, bogoSpecialsSelected, bogoSpecialsObj } = order;
  const comboIds = selectCurrentTicketComboIds(state);
  const itemIds = selectCurrentTicketItemIds(state);
  const bogoSpecialsObjUpdated = produce(bogoSpecialsObj, (draft) => {
    Object.values(bogoSpecialsObj).forEach((special) => {
      const existInOrder = special.buyItemIds.some((itemId) => itemIds.includes(itemId)) || special.getItemIds.some((itemId) => itemIds.includes(itemId)) || special.buyComboIds.some((comboId) => comboIds.includes(comboId)) || special.getComboIds.some((comboId) => comboIds.includes(comboId));
      if (!existInOrder)
        delete draft[special.specialId];
    });
  });
  const bogoSpecialsSelectedUpdated = bogoSpecialsSelected.filter(
    (specialObject) => specialObject.specialId in bogoSpecialsObjUpdated && specialObject.validation.buy.elements.every(
      (element) => element.ticketElementId && ticketElements[element.ticketElementId] || element.comboElementId && combos[element.comboElementId]
    ) && specialObject.validation.get.elements.every(
      (element) => element.ticketElementId && ticketElements[element.ticketElementId] || element.comboElementId && combos[element.comboElementId]
    )
  );
  if (order.bogoSpecialsObj !== bogoSpecialsObjUpdated || !shallowEqual(order.bogoSpecialsSelected, bogoSpecialsSelectedUpdated))
    dispatch(
      updateOrderField(
        orderId,
        {
          bogoSpecialsSelected: bogoSpecialsSelectedUpdated,
          bogoSpecialsObj: bogoSpecialsObjUpdated
        },
        true
      )
    );
};

// src/state/register/orders/thunks/tablelayout.ts
var tablelayout_exports = {};
__export(tablelayout_exports, {
  getExtendedTableAndShowOrderModal: () => getExtendedTableAndShowOrderModal,
  getExtendedTableFactory: () => getExtendedTableFactory,
  getExtendedTableThunk: () => getExtendedTableThunk,
  updateTablesStatusAndOrderId: () => updateTablesStatusAndOrderId
});

// src/state/tableLayout/actions.ts
var actions_exports8 = {};
__export(actions_exports8, {
  addElement: () => addElement,
  addServiceArea: () => addServiceArea,
  cancelTableLayoutChanges: () => cancelTableLayoutChanges,
  changeServiceArea: () => changeServiceArea,
  checkForLayoutChanges: () => checkForLayoutChanges,
  deleteElementFromLayout: () => deleteElementFromLayout,
  discardTableLayoutChanges: () => discardTableLayoutChanges,
  duplicateElement: () => duplicateElement,
  initializeLayout: () => initializeLayout,
  initializeTablesLayout: () => initializeTablesLayout,
  redoLastElementChange: () => redoLastElementChange,
  removeServiceAreAndResetState: () => removeServiceAreAndResetState,
  removeServiceArea: () => removeServiceArea,
  resetCurrentEditData: () => resetCurrentEditData,
  saveAllChanges: () => saveAllChanges,
  selectElement: () => selectElement,
  setCurrentEditData: () => setCurrentEditData,
  setIsBottomSheetOpen: () => setIsBottomSheetOpen,
  setLastLayoutChangeToCurrentEditData: () => setLastLayoutChangeToCurrentEditData,
  setLastRedoChanges: () => setLastRedoChanges,
  setLastServiceAreasOrder: () => setLastServiceAreasOrder,
  setLastUndoChanges: () => setLastUndoChanges,
  setNewServiceArea: () => setNewServiceArea,
  setSelectedElement: () => setSelectedElement,
  setSelectedLayout: () => setSelectedLayout,
  setSelectedTables: () => setSelectedTables,
  setServiceArea: () => setServiceArea,
  setTableLayoutData: () => setTableLayoutData,
  setToolSettings: () => setToolSettings,
  undoLastElementChange: () => undoLastElementChange,
  updateElementAndSaveLastChange: () => updateElementAndSaveLastChange,
  updateServiceArea: () => updateServiceArea,
  updateServiceAreaDetails: () => updateServiceAreaDetails,
  updateServiceAreas: () => updateServiceAreas,
  updateSingleTableLayoutStatus: () => updateSingleTableLayoutStatus,
  updateTableLayoutOrders: () => updateTableLayoutOrders,
  updateTableLayoutStore: () => updateTableLayoutStore,
  updateTables: () => updateTables
});
var setTableLayoutData = (payload) => ({
  type: SET_TABLE_LAYOUT_DATA,
  payload
});
var setLastLayoutChangeToCurrentEditData = (payload) => ({
  type: SET_LAST_LAYOUT_CHANGE_TO_CURRENT_EDIT_DATA,
  payload
});
var updateTableLayoutOrders = (tableLayout, orders) => ({
  type: UPDATE_TABLE_LAYOUT_AND_ORDERS,
  payload: {
    tableLayout,
    orders
  }
});
var setCurrentEditData = () => ({
  type: SET_CURRENT_EDIT_DATA
});
var resetCurrentEditData = () => ({
  type: RESET_CURRENT_EDIT_DATA
});
var discardTableLayoutChanges = (resetToDefault) => ({
  type: DISCARD_TABLE_LAYOUT_CHANGES,
  payload: {
    resetToDefault
  }
});
var setToolSettings = (payload) => ({
  type: SET_TOOL_SETTINGS,
  payload
});
var setSelectedElement = (payload) => ({
  type: SET_SELECTED_ELEMENT,
  payload
});
var setSelectedTables = (payload) => ({
  type: SET_SELECTED_TABLES,
  payload
});
var initializeTablesLayout = () => ({
  type: INITIALIZE_TABLES_LAYOUT
});
var initializeLayout = () => ({
  type: INITIALIZE_LAYOUT
});
var setSelectedLayout = (payload) => ({
  type: SET_SELECTED_LAYOUT,
  payload
});
var updateTableLayoutStore = (payload) => ({
  type: UPDATE_TABLE_LAYOUT_STORE,
  payload
});
var setLastUndoChanges = (payload) => ({
  type: SET_LAST_UNDO_CHANGES,
  payload
});
var setLastRedoChanges = (payload) => ({
  type: SET_LAST_REDO_CHANGES,
  payload
});
var setServiceArea = (payload) => ({
  type: SET_SERVICE_AREA,
  payload
});
var setNewServiceArea = (payload) => ({
  type: SET_NEW_SERVICE_AREA,
  payload
});
var updateServiceArea = (payload) => ({
  type: UPDATE_SERVICE_AREA,
  payload
});
var updateServiceAreas = (payload) => ({
  type: UPDATE_SERVICE_AREAS,
  payload
});
var removeServiceArea = (payload) => ({
  type: REMOVE_SERVICE_AREA,
  payload
});
var setLastServiceAreasOrder = (payload) => ({
  type: SET_LAST_SERVICE_AREAS_ORDER,
  payload
});
var setIsBottomSheetOpen = (payload) => ({
  type: SET_IS_BOTTOM_SHEET_OPEN,
  payload
});
var updateTables = (payload, ws) => ({
  type: ws ? UPDATE_TABLES_WS : UPDATE_TABLES,
  payload
});
var updateSingleTableLayoutStatus = (tableId, table) => ({
  type: UPDATE_SINGLE_TABLE_TABLE_LAYOUT_STATE,
  payload: {
    tableId,
    table
  }
});
var checkForLayoutChanges = (organizationId, locationId, licenseId, errorCodesDispatcher, onContinue) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const { savedData, currentEditData } = getState().tableLayout;
    const { undoList, selectedServiceArea } = getState().tableLayout.currentEditLayout;
    let differences = diff(savedData, currentEditData);
    differences = differences ? differences.filter((difference3) => {
      return !ignoredFieldsToSave.includes(difference3.path[3]);
    }) : [];
    if (!selectedServiceArea || Object.keys(currentEditData.revenueCenters).length === 0 || differences.length === 0 && undoList.length === 0) {
      dispatch(resetCurrentEditData());
      onContinue && onContinue();
    } else {
      dispatch(
        setShowConfirmationModal({
          title: i18n_config_default.t(
            "app.modals.infoConfirmationModal.unsavedChanges"
          ),
          description: `
${i18n_config_default.t(
            "app.modals.infoConfirmationModal.unsavedChangesMessage"
          )}`,
          active: true,
          type: "info",
          btnTerciaryText: i18n_config_default.t("commonButtons.discard"),
          btnSuccessText: i18n_config_default.t("commonButtons.saveChanges"),
          onTerciaryButtonPress: () => {
            dispatch(resetCurrentEditData());
            onContinue && onContinue();
          },
          onSuccess: () => {
            dispatch(
              saveAllChanges(
                organizationId,
                locationId,
                licenseId,
                errorCodesDispatcher,
                () => {
                  dispatch(resetCurrentEditData());
                  onContinue && onContinue();
                }
              )
            );
          }
        })
      );
    }
  });
};
var saveAllChanges = (organizationId, locationId, licenseId, errorCodesDispatcher, onSuccess) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const { currentEditData, currentEditLayout, savedData } = getState().tableLayout;
    const { selectedServiceArea } = currentEditLayout;
    if (selectedServiceArea) {
      const organizationUserId = state.loggedInUser.organizationUserId;
      const roleId = state.loggedInUser.loggedInRole.id;
      const url = apiConfig_default.tableLayout.getLocationLayout(
        organizationId,
        locationId
      );
      const differences = diff(savedData, currentEditData);
      const filteredDifferences = differences.filter(
        (difference3) => {
          return !ignoredFieldsToSave.includes(difference3.path[3]);
        }
      );
      if (filteredDifferences.length > 0) {
        dispatch(
          setIsLoadingModal({
            active: true,
            message: i18n_config_default.t(
              "settingsModule.tableLayoutCreator.messages.updatingLayoutPleaseWait"
            )
          })
        );
        const tablesDeleted = [];
        filteredDifferences.filter((difference3) => {
          return difference3.kind === "D" && difference3.path[0] === "serviceAreaLayouts" && difference3.path.length === 3;
        }).map((value) => {
          const element = value.lhs ? value.lhs : null;
          if (element && element.type === "table" /* TABLE */) {
            tablesDeleted.push(element.tableId);
          }
        });
        filteredDifferences.filter((difference3) => {
          return difference3.kind === "D" && difference3.path[0] === "serviceAreaLayouts" && difference3.path.length === 2;
        }).map((value) => {
          const layout = value.lhs ? value.lhs : null;
          if (layout)
            Object.values(layout).map((element) => {
              if (element.type === "table" /* TABLE */ && !String(element.id).includes("-")) {
                tablesDeleted.push(element.tableId);
              }
            });
        });
        const filteredTables = __spreadValues({}, currentEditData.tables);
        tablesDeleted.map((tableKey) => {
          delete filteredTables[tableKey];
        });
        let formattedNewTables = {};
        let formattedNewLayouts = {};
        let formattedServiceAreas = {};
        const serviceAreaLayouts = currentEditData.serviceAreaLayouts;
        const serviceAreas = currentEditData.serviceAreas;
        if (serviceAreaLayouts) {
          formattedNewTables = Object.entries(serviceAreaLayouts).reduce(
            (acc, [_, layout]) => {
              if (Object.values(layout).length > 0) {
                const newTables = Object.entries(layout).filter(
                  ([elementKey, element]) => element.type === "table" && elementKey.includes("-")
                ).reduce((accElement, [elementKey, element]) => {
                  const isRelatedToNewServiceArea = String(
                    element.serviceAreaId
                  ).includes("-");
                  const newElement = {
                    status: "available",
                    seats: element.seats,
                    tableNumber: element.name,
                    serviceAreaId: element.serviceAreaId,
                    statusUpdateTime: null,
                    orderId: null,
                    organizationId,
                    locationId
                  };
                  if (isRelatedToNewServiceArea) {
                    newElement.temporaryServiceAreaId = String(
                      newElement.serviceAreaId
                    );
                    delete newElement.serviceAreaId;
                  }
                  return __spreadProps(__spreadValues({}, accElement), {
                    [elementKey]: newElement
                  });
                }, {});
                return __spreadValues(__spreadValues({}, acc), newTables);
              }
              return acc;
            },
            {}
          );
          formattedServiceAreas = Object.entries(serviceAreas).sort(([_, a], [, b]) => a.sortPriority - b.sortPriority).reduce((acc, [serviceAreaKey, serviceArea], index) => {
            const newServiceArea = __spreadValues({}, serviceArea);
            const isNewServiceArea = String(serviceAreaKey).includes("-");
            if (isNewServiceArea) {
              delete newServiceArea.id;
            }
            return __spreadProps(__spreadValues({}, acc), {
              [serviceAreaKey]: __spreadProps(__spreadValues({}, newServiceArea), {
                sortPriority: index
              })
            });
          }, {});
          formattedNewLayouts = Object.entries(serviceAreaLayouts).reduce(
            (accLayout, [layoutKey, layout]) => {
              const newElements = Object.entries(layout).reduce(
                (accElement, [elementKey, element]) => {
                  const isNewElement = String(elementKey).includes("-");
                  const isRelatedToNewServiceArea = String(
                    element.serviceAreaId
                  ).includes("-");
                  const newElement = __spreadValues({}, element);
                  if (isNewElement) {
                    delete newElement.id;
                  }
                  if (isRelatedToNewServiceArea) {
                    delete newElement.serviceAreaId;
                  }
                  delete newElement.seats;
                  delete newElement.name;
                  return __spreadProps(__spreadValues({}, accElement), {
                    [elementKey]: __spreadProps(__spreadValues({}, newElement), {
                      organizationId,
                      locationId
                    })
                  });
                },
                {}
              );
              return __spreadProps(__spreadValues({}, accLayout), {
                [layoutKey]: newElements
              });
            },
            {}
          );
        }
        const newData = {
          organizationUserId,
          roleId,
          tables: __spreadValues(__spreadValues({}, filteredTables), formattedNewTables),
          serviceAreas: formattedServiceAreas,
          serviceAreaLayouts: formattedNewLayouts
        };
        yield apiCall(
          "put" /* Put */,
          url,
          true,
          newData,
          licenseId,
          errorCodesDispatcher,
          dispatch,
          state
        ).then((res) => {
          onSuccess && onSuccess();
          dispatch(
            updateTableLayoutStore({
              currentEditData: res,
              savedData: res,
              currentEditLayout: __spreadProps(__spreadValues({}, currentEditLayout), {
                redoList: [],
                undoList: [],
                lastServiceAreasOrder: null
              })
            })
          );
          if (String(selectedServiceArea.id).includes("-")) {
            const newServiceArea = Object.values(res.serviceAreas).find(
              (serviceArea) => serviceArea.sortPriority === selectedServiceArea.sortPriority
            );
            if (newServiceArea)
              dispatch(changeServiceArea(newServiceArea.id));
          } else {
            dispatch(changeServiceArea(selectedServiceArea.id));
          }
          dispatch(
            setIsLoadingModal({
              active: false
            })
          );
          dispatch(
            showToast({
              type: "success",
              title: i18n_config_default.t("validations.allChangesSaved"),
              description: i18n_config_default.t(
                "settingsModule.tableLayoutCreator.messages.changesSaved"
              )
            })
          );
        }).catch(() => {
          dispatch(
            setIsLoadingModal({
              active: false
            })
          );
          dispatch(
            showToast({
              title: i18n_config_default.t(
                "settingsModule.tableLayoutCreator.messages.errorUpdatingLayout"
              ),
              description: i18n_config_default.t(
                "settingsModule.tableLayoutCreator.messages.errorSavingChanges"
              ),
              type: "error"
            })
          );
        });
      } else {
        dispatch(
          showToast({
            type: "success",
            title: i18n_config_default.t("validations.allChangesSaved"),
            description: i18n_config_default.t(
              "settingsModule.tableLayoutCreator.messages.changesSaved"
            )
          })
        );
      }
    }
  });
};
var cancelTableLayoutChanges = (onContinue) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const onSuccess = () => {
      const { currentEditLayout } = state.tableLayout;
      const selectedServiceArea = currentEditLayout.selectedServiceArea;
      if (!selectedServiceArea)
        return dispatch(discardTableLayoutChanges(true));
      if (String(selectedServiceArea.id).includes("-")) {
        dispatch(discardTableLayoutChanges(true));
      } else {
        dispatch(discardTableLayoutChanges(false));
        dispatch(changeServiceArea(selectedServiceArea.id));
      }
      onContinue && onContinue();
    };
    dispatch(
      setShowConfirmationModal({
        title: i18n_config_default.t("app.modals.discardChangesConfirmation.title"),
        description: i18n_config_default.t(
          "app.modals.discardChangesConfirmation.description"
        ),
        active: true,
        type: "warning",
        btnCancelText: i18n_config_default.t("commonTexts.no"),
        btnSuccessText: i18n_config_default.t("commonTexts.yes"),
        onSuccess
      })
    );
  });
};
var selectElement = (element) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const selectedElement = getState().tableLayout.currentEditLayout.selectedElement;
    if (selectedElement && selectedElement.id === (element == null ? void 0 : element.id)) {
      dispatch(setSelectedElement(null));
    } else {
      dispatch(setSelectedElement(element));
    }
  });
};
var addElement = (element, onSave) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const tableLayout = state.tableLayout;
    const { selectedServiceArea, undoList } = tableLayout.currentEditLayout;
    const { serviceAreaLayouts } = tableLayout.currentEditData;
    const licenseId = state.loggedInUser.userId;
    if (selectedServiceArea && serviceAreaLayouts) {
      const selectedLayout = serviceAreaLayouts[selectedServiceArea.id];
      const tablesOfCurrentLayoutKeys = Object.values(selectedLayout).filter(
        (cElement) => cElement.type === "table" /* TABLE */
      );
      let newTableName = element.name;
      const timeStampUNIX = Date.now();
      const newId = `${addLeadingZero(licenseId)}-${timeStampUNIX}`;
      if (element.type === "table" /* TABLE */) {
        newTableName = (tablesOfCurrentLayoutKeys.length + 1).toString();
      }
      const newElement = {
        [newId]: __spreadProps(__spreadValues({}, element), {
          id: newId,
          tableId: null,
          name: newTableName.toString(),
          customElementName: newTableName.toString(),
          serviceAreaId: selectedServiceArea.id
        })
      };
      const newUndoList = [
        ...undoList,
        {
          action: "add" /* ADD */,
          element: newElement[newId]
        }
      ];
      const nextState = produce(tableLayout, (draft) => {
        draft.currentEditLayout.undoList = newUndoList;
        draft.currentEditLayout.redoList = [];
        if (draft.currentEditData.serviceAreaLayouts)
          draft.currentEditData.serviceAreaLayouts[selectedServiceArea.id] = __spreadValues(__spreadValues({}, draft.currentEditData.serviceAreaLayouts[selectedServiceArea.id]), newElement);
      });
      batch$1(() => {
        dispatch(updateTableLayoutStore(nextState));
        dispatch(
          selectElement({
            id: newId,
            type: newElement[newId].type,
            showControls: element.type === "custom" /* CUSTOM */
          })
        );
        onSave && onSave(newId);
      });
    }
  });
};
var updateElementAndSaveLastChange = (currentElement, updatedElement) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const tableLayout = getState().tableLayout;
    const { undoList, selectedServiceArea } = tableLayout.currentEditLayout;
    if (updatedElement && selectedServiceArea) {
      const newUndoList = [
        ...undoList,
        { action: "edit" /* EDIT */, element: currentElement }
      ];
      const nextState = produce(tableLayout, (draft) => {
        draft.currentEditLayout.undoList = newUndoList;
        draft.currentEditLayout.redoList = [];
        if (draft.currentEditData.serviceAreaLayouts)
          draft.currentEditData.serviceAreaLayouts[selectedServiceArea.id] = __spreadProps(__spreadValues({}, draft.currentEditData.serviceAreaLayouts[selectedServiceArea.id]), {
            [currentElement.id]: __spreadValues(__spreadValues({}, updatedElement), (updatedElement.type === "custom" /* CUSTOM */ || updatedElement.type === "table" /* TABLE */) && {
              customElementName: updatedElement.name
            })
          });
        if (updatedElement.tableId) {
          draft.currentEditData.tables[updatedElement.tableId].seats = updatedElement.seats;
          draft.currentEditData.tables[updatedElement.tableId].tableNumber = updatedElement.name;
        }
      });
      dispatch(updateTableLayoutStore(nextState));
    }
  });
};
var deleteElementFromLayout = () => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const tableLayout = getState().tableLayout;
    const { serviceAreaLayouts, tables } = tableLayout.currentEditData;
    const { selectedElement, selectedServiceArea, undoList } = tableLayout.currentEditLayout;
    if (selectedElement && selectedServiceArea && serviceAreaLayouts) {
      const idToDelete = selectedElement ? selectedElement.id : 0;
      const currentLayout = cloneDeep16(
        serviceAreaLayouts[selectedServiceArea.id]
      );
      let canRemove = true;
      const selectedElementToDelete = currentLayout[idToDelete];
      const newTables = cloneDeep16(tables);
      if (selectedElementToDelete.type === "table" /* TABLE */) {
        const tableId = selectedElementToDelete.mergedTableId ? selectedElementToDelete.mergedTableId : selectedElementToDelete.tableId;
        if (tableId) {
          const currentTableStatus = tables[tableId].status;
          if (currentTableStatus !== "available" /* AVAILABLE */ && currentTableStatus !== "unavailable" /* UNAVAILABLE */) {
            canRemove = false;
            dispatch(
              showToast({
                title: i18n_config_default.t(
                  "settingsModule.tableLayoutCreator.messages.unableToDeleteTable.title"
                ),
                description: i18n_config_default.t(
                  "settingsModule.tableLayoutCreator.messages.unableToDeleteTable.message"
                ),
                type: "error"
              })
            );
          }
        }
      }
      if (canRemove) {
        const newUndoList = [
          ...undoList,
          {
            action: "remove" /* REMOVE */,
            element: currentLayout[idToDelete]
          }
        ];
        delete currentLayout[idToDelete];
        const nextState = produce(tableLayout, (draft) => {
          draft.currentEditLayout.undoList = newUndoList;
          draft.currentEditLayout.selectedElement = null;
          if (draft.currentEditData.serviceAreaLayouts)
            draft.currentEditData.serviceAreaLayouts[selectedServiceArea.id] = currentLayout;
          draft.currentEditData.tables = newTables;
        });
        dispatch(updateTableLayoutStore(nextState));
      }
    }
  });
};
var duplicateElement = () => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const tableLayout = getState().tableLayout;
    const { selectedElement, selectedServiceArea, undoList } = tableLayout.currentEditLayout;
    const { serviceAreaLayouts } = tableLayout.currentEditData;
    const gridWidth = tableLayout.toolSettings.gridWidth;
    const userId = state.loggedInUser.userId;
    if (selectedElement && selectedServiceArea && serviceAreaLayouts) {
      const timeStampUNIX = Date.now();
      const newId = `${addLeadingZero(userId)}-${timeStampUNIX}`;
      const currentElement = serviceAreaLayouts[selectedServiceArea.id][selectedElement.id];
      const xCoordinate = currentElement.xCoordinate + (currentElement.xCoordinate + currentElement.width >= gridWidth ? -currentElement.width : currentElement.width + 10);
      const newElement = {
        [newId]: __spreadProps(__spreadValues({}, currentElement), {
          id: newId,
          tableId: null,
          xCoordinate
        })
      };
      const newUndoList = [
        ...undoList,
        {
          action: "add" /* ADD */,
          element: newElement[newId]
        }
      ];
      const nextState = produce(tableLayout, (draft) => {
        draft.currentEditLayout.undoList = newUndoList;
        draft.currentEditLayout.redoList = [];
        if (draft.currentEditData.serviceAreaLayouts)
          draft.currentEditData.serviceAreaLayouts[selectedServiceArea.id] = __spreadValues(__spreadValues({}, draft.currentEditData.serviceAreaLayouts[selectedServiceArea.id]), newElement);
      });
      dispatch(updateTableLayoutStore(nextState));
    }
  });
};
var undoLastElementChange = () => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const tableLayout = getState().tableLayout;
    const { undoList, redoList, selectedServiceArea } = cloneDeep16(
      tableLayout.currentEditLayout
    );
    const { serviceAreaLayouts } = tableLayout.currentEditData;
    if (undoList.length > 0 && selectedServiceArea && serviceAreaLayouts) {
      const lastChange = undoList[undoList.length - 1];
      const elementId = lastChange.element.id;
      const serviceAreaId = lastChange.element.serviceAreaId;
      const currentChange = serviceAreaLayouts[serviceAreaId][elementId];
      let newLayout = cloneDeep16(serviceAreaLayouts[serviceAreaId]);
      if (lastChange.action === "edit" /* EDIT */) {
        newLayout = __spreadProps(__spreadValues({}, newLayout), {
          [elementId]: lastChange.element
        });
      } else if (lastChange.action === "add" /* ADD */) {
        delete newLayout[elementId];
      } else if (lastChange.action === "remove" /* REMOVE */) {
        newLayout = __spreadProps(__spreadValues({}, newLayout), {
          [elementId]: lastChange.element
        });
      }
      const newRedoList = [
        ...redoList,
        {
          action: lastChange.action,
          element: currentChange != null ? currentChange : lastChange.element
        }
      ];
      undoList.pop();
      const nextState = produce(tableLayout, (draft) => {
        draft.currentEditLayout.undoList = undoList;
        draft.currentEditLayout.redoList = newRedoList;
        if (draft.currentEditData.serviceAreaLayouts)
          draft.currentEditData.serviceAreaLayouts[serviceAreaId] = newLayout;
        if (lastChange.action === "edit" /* EDIT */ && lastChange.element.tableId) {
          draft.currentEditData.tables[lastChange.element.tableId].seats = lastChange.element.seats;
          draft.currentEditData.tables[lastChange.element.tableId].tableNumber = lastChange.element.name;
        }
      });
      dispatch(updateTableLayoutStore(nextState));
      if (lastChange.element.serviceAreaId !== selectedServiceArea.id)
        dispatch(changeServiceArea(lastChange.element.serviceAreaId));
    }
  });
};
var redoLastElementChange = () => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const tableLayout = getState().tableLayout;
    const { undoList, redoList, selectedServiceArea } = cloneDeep16(
      tableLayout.currentEditLayout
    );
    const { serviceAreaLayouts } = tableLayout.currentEditData;
    if (redoList.length > 0 && selectedServiceArea && serviceAreaLayouts) {
      const lastRedo = redoList[redoList.length - 1];
      const elementId = lastRedo.element.id;
      const serviceAreaId = lastRedo.element.serviceAreaId;
      const currentChange = serviceAreaLayouts[serviceAreaId][elementId];
      let newLayout = cloneDeep16(serviceAreaLayouts[serviceAreaId]);
      const newUndoList = [
        ...undoList,
        {
          action: lastRedo.action,
          element: currentChange != null ? currentChange : lastRedo.element
        }
      ];
      if (lastRedo.action === "edit" /* EDIT */) {
        newLayout = __spreadProps(__spreadValues({}, newLayout), {
          [elementId]: lastRedo.element
        });
      } else if (lastRedo.action === "add" /* ADD */) {
        newLayout = __spreadProps(__spreadValues({}, newLayout), {
          [elementId]: lastRedo.element
        });
      } else if (lastRedo.action === "remove" /* REMOVE */) {
        delete newLayout[elementId];
      }
      redoList.pop();
      dispatch(changeServiceArea(lastRedo.element.serviceAreaId));
      const nextState = produce(tableLayout, (draft) => {
        draft.currentEditLayout.undoList = newUndoList;
        draft.currentEditLayout.redoList = redoList;
        if (draft.currentEditData.serviceAreaLayouts)
          draft.currentEditData.serviceAreaLayouts[serviceAreaId] = newLayout;
        if (lastRedo.action === "edit" /* EDIT */ && lastRedo.element.tableId) {
          draft.currentEditData.tables[lastRedo.element.tableId].seats = lastRedo.element.seats;
          draft.currentEditData.tables[lastRedo.element.tableId].tableNumber = lastRedo.element.name;
        }
      });
      dispatch(updateTableLayoutStore(nextState));
      if (lastRedo.element.serviceAreaId !== selectedServiceArea.id)
        dispatch(changeServiceArea(lastRedo.element.serviceAreaId));
    }
  });
};
var changeServiceArea = (serviceAreaID) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const tableLayout = getState().tableLayout;
    const nextState = produce(tableLayout, (draft) => {
      draft.currentEditLayout.selectedServiceArea = draft.currentEditData.serviceAreas[serviceAreaID];
      draft.currentEditLayout.selectedElement = null;
      const serviceAreaLayouts = draft.currentEditData.serviceAreaLayouts;
      const tables = draft.currentEditData.tables;
      if (serviceAreaLayouts) {
        const selectedLayout = serviceAreaLayouts[serviceAreaID];
        const newLayout = Object.entries(selectedLayout).reduce(
          (accElement, [elementId, element]) => {
            if (element.tableId) {
              return __spreadProps(__spreadValues({}, accElement), {
                [elementId]: __spreadProps(__spreadValues({}, element), {
                  name: tables[element.tableId].tableNumber,
                  seats: tables[element.tableId].seats
                })
              });
            }
            return __spreadProps(__spreadValues({}, accElement), {
              [elementId]: __spreadProps(__spreadValues({}, element), {
                name: element.customElementName
              })
            });
          },
          {}
        );
        serviceAreaLayouts[serviceAreaID] = newLayout;
        draft.currentEditData.serviceAreaLayouts = serviceAreaLayouts;
      }
    });
    dispatch(updateTableLayoutStore(nextState));
  });
};
var addServiceArea = ({ name, revenueCenterId, isActive, forceNoTaxInclusive }, organizationId, locationId, onContinue) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const currentLocationId = locationId;
    const tableLayout = state.tableLayout;
    const serviceAreas = tableLayout.currentEditData.serviceAreas;
    const loggedInUserId = state.loggedInUser.userId;
    if (Object.keys(serviceAreas).length > 0) {
      const newSortPriority = Object.values(serviceAreas).sort((a, b) => a.sortPriority - b.sortPriority).reduce((acc, serviceArea) => {
        if (serviceArea.sortPriority > acc)
          return serviceArea.sortPriority;
        return acc;
      }, 0);
      const timeStampUNIX = Date.now();
      const newServiceAreaId = `${addLeadingZero(loggedInUserId)}-${timeStampUNIX}`;
      const newServiceArea = {
        [newServiceAreaId]: {
          id: newServiceAreaId,
          name,
          revenueCenterId,
          sortPriority: newSortPriority + 1,
          organizationId,
          locationId: currentLocationId,
          isActive,
          forceNoTaxInclusive
        }
      };
      const newServiceAreaOBJ = {
        [newServiceAreaId]: {}
      };
      const nextState = produce(tableLayout, (draft) => {
        draft.currentEditData.serviceAreas = __spreadValues(__spreadValues({}, draft.currentEditData.serviceAreas), newServiceArea);
        draft.currentEditData.serviceAreaLayouts = __spreadValues(__spreadValues({}, draft.currentEditData.serviceAreaLayouts), newServiceAreaOBJ);
        draft.isBottomSheetOpen = false;
      });
      dispatch(updateTableLayoutStore(nextState));
      dispatch(changeServiceArea(newServiceAreaId));
      onContinue();
    }
  });
};
var updateServiceAreaDetails = ({
  serviceAreaId,
  serviceAreaName,
  revenueCenterId,
  isActive,
  forceNoTaxInclusive
}, onContinue) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const serviceAreas = getState().tableLayout.currentEditData.serviceAreas;
    if (Object.keys(serviceAreas)) {
      const serviceArea = serviceAreas[serviceAreaId];
      const editedServiceAre = __spreadProps(__spreadValues({}, serviceArea), {
        name: serviceAreaName,
        revenueCenterId,
        isActive,
        forceNoTaxInclusive
      });
      dispatch(
        updateServiceArea({ serviceAreaId, serviceArea: editedServiceAre })
      );
      onContinue();
    }
  });
};
var removeServiceAreAndResetState = (serviceAreaId) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const tableLayout = state.tableLayout;
    const selectedServiceArea = state.tableLayout.currentEditLayout.selectedServiceArea;
    const {
      serviceAreas,
      serviceAreaLayouts: layouts,
      tables
    } = tableLayout.currentEditData;
    if (Object.keys(serviceAreas)) {
      const newServiceAreas = __spreadValues({}, serviceAreas);
      delete newServiceAreas[serviceAreaId];
      if (layouts) {
        const newLayouts = __spreadValues({}, layouts);
        const layoutToDelete = newLayouts[serviceAreaId];
        let canRemove = true;
        Object.values(layoutToDelete).some((element) => {
          if (element.type === "table" /* TABLE */) {
            const tableId = element.mergedTableId ? element.mergedTableId : element.tableId;
            if (tableId) {
              const currentTableStatus = tables[tableId].status;
              if (currentTableStatus !== "available" /* AVAILABLE */ && currentTableStatus !== "unavailable" /* UNAVAILABLE */) {
                canRemove = false;
                return false;
              }
            }
          }
        });
        if (!canRemove) {
          dispatch(
            showToast({
              title: i18n_config_default.t(
                "settingsModule.tableLayoutCreator.messages.unableToDeleteServiceArea.title"
              ),
              description: i18n_config_default.t(
                "settingsModule.tableLayoutCreator.messages.unableToDeleteServiceArea.message"
              ),
              type: "error"
            })
          );
          return;
        }
        delete newLayouts[serviceAreaId];
        const nextState = produce(tableLayout, (draft) => {
          draft.currentEditData.serviceAreas = newServiceAreas;
          draft.currentEditData.serviceAreaLayouts = newLayouts;
          draft.isBottomSheetOpen = false;
        });
        dispatch(updateTableLayoutStore(nextState));
        if (serviceAreaId === (selectedServiceArea == null ? void 0 : selectedServiceArea.id)) {
          dispatch(setServiceArea(null));
        }
      }
    }
  });
};
var getExtendedTableThunk = (currentTableId) => (_, getState) => {
  return getExtendedTableFactory(currentTableId, getState());
};
var getExtendedTableFactory = (currentTableId, state) => {
  const { serviceAreaLayouts, tables } = state.tableLayout.savedData;
  const table = tables[currentTableId];
  const DEFAULT_TABLE_VALUE = __spreadProps(__spreadValues({}, table), {
    mergedTableId: null,
    tableId: null,
    name: ""
  });
  if (!serviceAreaLayouts || !table)
    return DEFAULT_TABLE_VALUE;
  const currentElement = Object.values(
    serviceAreaLayouts[table.serviceAreaId]
  ).find(
    (element) => element.mergedTableId === table.id || element.tableId === table.id
  );
  if (!currentElement)
    return DEFAULT_TABLE_VALUE;
  const tableId = currentElement.mergedTableId ? currentElement.mergedTableId : currentElement.tableId;
  const tableNumber = tables[tableId].tableNumber;
  return __spreadProps(__spreadValues({}, table), {
    mergedTableId: currentElement.mergedTableId,
    tableId: currentElement.tableId,
    name: tableNumber
  });
};
var getExtendedTableAndShowOrderModal = (tableId, mode, defaultSeats = true, isAllOrderTypes = false) => (dispatch) => {
  dispatch(
    checkOrderPermissions(() => {
      let table = tableId ? dispatch(getExtendedTableThunk(tableId)) : null;
      if (!defaultSeats && table) {
        table = __spreadProps(__spreadValues({}, table), {
          seats: -1
        });
      }
      dispatch(
        setOrderModal({
          active: true,
          table,
          mode,
          isAllOrderTypes
        })
      );
    })
  );
};
var updateTablesStatusAndOrderId = (isWSR, table, orderId) => (dispatch, getState) => {
  const state = getState();
  const { tables } = state.tableLayout.savedData;
  const currentOrder = state.register.orders[orderId];
  if (isWSR && !orderId) {
    const tableId = table.id;
    const newTables = produce(tables, (draft) => {
      draft[tableId] = table;
    });
    dispatch(updateTables(newTables, true));
  } else {
    if (currentOrder && currentOrder.status === "other-voided" /* OTHER_VOIDED */) {
      const currentOrderTable = Object.values(tables).find(
        (_table) => _table.orderId === orderId
      );
      if (currentOrderTable)
        delete tables[currentOrderTable.id];
    }
    const tableId = table.tableId;
    const newTables = produce(tables, (draft) => {
      draft[tableId] = __spreadProps(__spreadValues({}, draft[tableId]), {
        status: "seated" /* SEATED */,
        orderId: orderId != null ? orderId : null,
        statusUpdateTime: getNowUTCDate()
      });
    });
    dispatch(updateTables(newTables));
  }
};

// src/state/register/orders/thunks/index.ts
var replaceSessionOrderThunk = (order, navigateToRegister, ws) => (dispatch, getState) => {
  const state = getState();
  const currentOrderId = selectCurrentOrderId(state);
  const isVAOFocused = selectIsVAOFocused(state);
  if (currentOrderId === order.id && isOrderClosedOrVoided(order.status) && !isVAOFocused) {
    navigateToRegister();
  }
  dispatch(
    replaceSessionOrder({ order, orderVersion: order.orderVersion }, ws)
  );
};
var rollUpTicketInCurrentOrder = () => (dispatch, getState) => {
  const state = getState();
  const { orderId } = state.register.registerNavigation;
  const ticket = selectCurrentTicket(state);
  const combos = selectCurrentCombos(state);
  if (orderId === null)
    return;
  checkForRollUp(
    ticket,
    combos,
    (ticketRollUpIds) => {
      ticketRollUpIds && dispatch(rollUpTicketElements(orderId, ticketRollUpIds));
    },
    (combosRollUpIds) => {
      combosRollUpIds && dispatch(rollUpTicketCombos(orderId, combosRollUpIds));
    }
  );
};
var suggestOrdering = (onContinue, licenseId, ticketElementIdOverride = null) => (dispatch, getState) => {
  var _a, _b;
  const state = getState();
  const currentOrderId = selectCurrentOrderId(state);
  const ticketElementId = ticketElementIdOverride || selectCurrentTicketElementId(state);
  const currentTicketElement = ticketElementId && selectTicketElementById(state, ticketElementId) || void 0;
  const isSuggestiveOrderingSuppressed = selectSuppressSuggestiveOrdering(state);
  const isSeatingModeEnabled = selectIsCurrentOrderSeatingMode.lastResult();
  const isOpenItem = currentTicketElement && isOpenItemFn(currentTicketElement);
  const currentTicketItemMenuTypeVersion = isOpenItem ? null : (_b = (_a = currentTicketElement == null ? void 0 : currentTicketElement.itemObj) == null ? void 0 : _a.menuTypeVersions) == null ? void 0 : _b[(currentTicketElement == null ? void 0 : currentTicketElement.menuTypeId) || 0];
  if (isSuggestiveOrderingSuppressed || !currentOrderId || !currentTicketElement || !currentTicketItemMenuTypeVersion || isOpenItem)
    return onContinue();
  const {
    suggestiveOrdering: so,
    suggestiveOrderingPrompt,
    suggestiveOrderingItemId,
    suggestiveOrderingItemPrice
  } = currentTicketItemMenuTypeVersion;
  if (!so || currentTicketElement.suggestedItemId === suggestiveOrderingItemId)
    return onContinue();
  dispatch(
    updateTicketElementField(
      { suggestedItemId: suggestiveOrderingItemId },
      currentOrderId,
      getTicketElementId(currentTicketElement),
      isSeatingModeEnabled
    )
  );
  dispatch(
    updateRegisterNavigationField({
      suggestiveOrderingModal: {
        active: true,
        itemId: suggestiveOrderingItemId,
        menuTypeId: currentTicketElement.menuTypeId,
        prompt: suggestiveOrderingPrompt,
        suggestivePrice: suggestiveOrderingItemPrice,
        onContinue
      }
    })
  );
};
var selectRegisterItemThunk = (itemId, licenseId, skipInventoryCheck = false, isSuggested = false, overrides = {}, noSeat = false, t2) => (dispatch, getState) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  let state = getState();
  const {
    orderId,
    ticketElementId,
    seats: selectedSeats,
    quantity: selectedQuantity,
    menuTypeId: _menuTypeId
  } = state.register.registerNavigation;
  const menuTypeId = overrides.menuTypeId || _menuTypeId;
  if (orderId === null)
    return;
  const seatsInNavigation = Object.keys(selectedSeats);
  const elementHasNoSeatsAssigned = seatsInNavigation.length === 0;
  const item = selectLocationMenuItemById(state, itemId);
  const isSeatingModeNoPrompt = selectSeatingMode(state) === "no_prompt" /* NO_PROMPT */;
  const itemMenuTypeVersion = (_a = item == null ? void 0 : item.menuTypeVersions) == null ? void 0 : _a[menuTypeId || -1];
  const isSeatingModeEnabled = selectIsCurrentOrderSeatingMode(state);
  const isSubcategoryCustomizer = selectIsCurrentTicketElementSubcategoryCustomizer(state);
  const currentOrderType = selectCurrentOrderType(state);
  const isToGoOrder = currentOrderType === "to_go" /* TO_GO */;
  const isAttachNoSeatToGoOrder = selectAttachNoSeatToToGo(state);
  let willSeatingBeEmpty = isSeatingModeEnabled && elementHasNoSeatsAssigned && !(itemMenuTypeVersion == null ? void 0 : itemMenuTypeVersion.defaultNoSeat) && !isSeatingModeNoPrompt && !isSubcategoryCustomizer;
  if (isToGoOrder && isAttachNoSeatToGoOrder) {
    willSeatingBeEmpty = false;
  }
  if (noSeat) {
    willSeatingBeEmpty = false;
    overrides.defaultNoSeat = true;
  }
  const _ticketElementId = ticketElementId && !isSuggested ? ticketElementId : generateTabletGeneratedId();
  const preExistingModifierGroupsSelected = cloneDeep(
    ((_b = state.register.orders[orderId].ticketElements[_ticketElementId]) == null ? void 0 : _b.modifierGroupsSelected) || {}
  );
  dispatch(
    selectRegisterItem({
      orderId,
      ticketElementId: _ticketElementId,
      itemId,
      globalState: state,
      skipInventoryCheck,
      willSeatingBeEmpty,
      overrides
    })
  );
  state = getState();
  const currentTicketElement = state.register.orders[orderId].ticketElements[_ticketElementId];
  if (!currentTicketElement)
    return;
  const modifierItemHotButtonId = state.register.registerNavigation.modifierItemHotButtonSelectedId;
  if (modifierItemHotButtonId) {
    const modGroups = Object.values(
      (currentTicketElement.itemObj || {}).menuTypeVersions || {}
    )[0].modifierGroups;
    const wasHotButtonModItemFound = Object.values(modGroups).some(
      (modifierGroup) => {
        return Object.keys(modifierGroup.modifierItems).includes(
          String(modifierItemHotButtonId)
        );
      }
    );
    if (!wasHotButtonModItemFound) {
      const hotButtonModifierItemPosName = selectCurrentHotButtonModifierItemPosName(state);
      if (currentTicketElement.customizerType !== "subcategory" /* SUBCATEGORY */) {
        dispatch(
          setShowConfirmationModal({
            active: true,
            type: "warning",
            title: `${hotButtonModifierItemPosName} ${t2 && t2("register.modals.hotButtonsModifierItemNotFoundModal.title")}`,
            description: `${hotButtonModifierItemPosName} ${t2 && t2("register.modals.hotButtonsModifierItemNotFoundModal.description")} ${Object.values(((_c = currentTicketElement.itemObj) == null ? void 0 : _c.menuTypeVersions) || {})[0].posName}`,
            hideCancel: true
          })
        );
        dispatch(removeTicketElement(orderId, _ticketElementId));
        dispatch(
          updateRegisterNavigationField({
            modifierItemHotButtonSelectedId: null
          })
        );
        return;
      } else {
        dispatch(
          updateRegisterNavigationField({
            modifierItemHotButtonSelectedId: null
          })
        );
        dispatch(
          showToast({
            type: "info",
            title: `${hotButtonModifierItemPosName} ${t2 && t2("register.modals.hotButtonsModifierItemNotFoundModal.title")}`,
            description: `${hotButtonModifierItemPosName} ${t2 && t2("register.modals.hotButtonsModifierItemNotFoundModal.description")} ${Object.values(((_d = currentTicketElement.itemObj) == null ? void 0 : _d.menuTypeVersions) || {})[0].posName}`
          })
        );
      }
    }
  }
  const seatingData = {
    seatSplitRequired: false,
    currentSeat: selectCurrentSeatSelected(state),
    licenseId,
    isSeatingModeEnabled: selectIsCurrentOrderSeatingMode.lastResult()
  };
  if (currentTicketElement.customizerType !== "none" /* NONE */)
    dispatch(
      carryOverModifiersSelected(
        {
          orderId,
          ticketElementId: _ticketElementId,
          modifierGroupsSelected: preExistingModifierGroupsSelected
        },
        seatingData
      )
    );
  const newRegisterNavigation = {
    itemId,
    orderId,
    ticketElementId: _ticketElementId,
    modifierGroupId: null,
    prevModGroupTypeModGroupId: null,
    nestedModifierGroupId: null,
    modifierItemInstanceId: null,
    isAllModsEnabled: false,
    quantity: null,
    isSeatSelectionActive: willSeatingBeEmpty
  };
  const isCurrentSubcategoryCustomizer = currentTicketElement.customizerType === "subcategory" /* SUBCATEGORY */;
  const currentMenuTypeItem = Object.values(
    ((_e = currentTicketElement == null ? void 0 : currentTicketElement.itemObj) == null ? void 0 : _e.menuTypeVersions) || {}
  )[0];
  const itemHasNormalModifierGroups = Object.values(
    currentMenuTypeItem.modifierGroups || {}
  ).some(
    (modifierGroup) => !modifierGroup.isAllMod && modifierGroup.modifierGroupId !== ALL_MODS_ID
  );
  const modifierGroupsIds = Object.keys(
    currentMenuTypeItem.modifierGroups || {}
  ).map(Number);
  if (!itemHasNormalModifierGroups || modifierGroupsIds.length === 1 && modifierGroupsIds[0] === ALL_MODS_ID) {
    newRegisterNavigation.modifierGroupId = ALL_MODS_ID;
    newRegisterNavigation.isAllModsEnabled = true;
  } else {
    const validModifierGroupId = getDefaultModifierGroupSelected(
      currentMenuTypeItem.modifierGroups
    );
    newRegisterNavigation.modifierGroupId = validModifierGroupId;
  }
  dispatch(setUpCurrentOrderActiveSpecials(menuTypeId, itemId, null));
  const selectedModifierGroupsIds = Object.keys(
    currentTicketElement.modifierGroupsSelected
  ).map(Number);
  const enterItemDetails = (_h = (_g = (_f = currentTicketElement.itemObj) == null ? void 0 : _f.menuTypeVersions) == null ? void 0 : _g[menuTypeId || -1]) == null ? void 0 : _h.enterItemDetails;
  if (!willSeatingBeEmpty && (!enterItemDetails && currentTicketElement.isComplete || selectedModifierGroupsIds.filter(
    (modifierGroupId) => modifierGroupId !== 0 && modifierGroupId
  ).length === 0)) {
    if (isCurrentSubcategoryCustomizer)
      newRegisterNavigation.subcategoryId = 0;
    const currentMenuType = state.menu.locationMenu.menuTypes[Number(menuTypeId)];
    const currentMenuTypeHasHomeScreenItemsAndCombos = currentMenuType.homeScreenElements.length > 0;
    if (currentMenuType.defaultToHomeScreen && currentMenuTypeHasHomeScreenItemsAndCombos) {
      newRegisterNavigation.categoryId = null;
      newRegisterNavigation.subcategoryId = null;
    }
    newRegisterNavigation.ticketElementId = null;
    newRegisterNavigation.itemId = null;
    newRegisterNavigation.modifierGroupId = null;
    dispatch(applySpecialsToNewItems());
    dispatch(rollUpTicketInCurrentOrder());
  } else {
    dispatch(applySpecialsToNewItems());
  }
  if (selectedModifierGroupsIds.length === 1 && selectedModifierGroupsIds[0] === ALL_MODS_ID) {
    newRegisterNavigation.isAllModsEnabled = true;
    newRegisterNavigation.modifierGroupId = ALL_MODS_ID;
  }
  if (isCurrentSubcategoryCustomizer) {
    newRegisterNavigation.isAllModsEnabled = false;
  }
  if (state.register.registerNavigation.modifierItemHotButtonSelectedId)
    newRegisterNavigation.modifierItemHotButtonSelectedId = null;
  dispatch(
    updateRegisterNavigationField(__spreadProps(__spreadValues({}, newRegisterNavigation), {
      quantity: willSeatingBeEmpty ? selectedQuantity : null,
      modifierTag: null
    }))
  );
  if (!newRegisterNavigation.ticketElementId) {
    dispatch(suggestOrdering(() => null, licenseId, _ticketElementId));
  }
};
var updateComboObjectPreviewThunk = () => (dispatch, getState) => {
  const state = getState();
  const { comboId, comboElementId } = state.register.registerNavigation;
  if (comboElementId && comboId) {
    dispatch(
      updateComboObjectPreview({
        orderId: 0,
        comboElementId,
        comboId,
        globalState: state
      })
    );
  }
};
var getMenuTypeFromOrder = (order) => (_, getState) => {
  if (!getIsOrderOpen(order.status)) {
    const hasFiredItems = Object.values(order.ticketElements).filter(
      isTicketElementTriggered
    );
    const keyAttribute = hasFiredItems ? "timeAdded" : "timeTriggered";
    const oldestElement = Object.values(order.ticketElements).filter(isNotOpenItemFn).reduce(
      (newestElement, ticketElement) => new Date(ticketElement[keyAttribute]) > new Date(newestElement[keyAttribute]) ? ticketElement : newestElement,
      {
        timeAdded: (/* @__PURE__ */ new Date(0)).toUTCString(),
        timeTriggered: (/* @__PURE__ */ new Date(0)).toUTCString()
      }
    );
    const menuTypeOptionList = selectMenuTypeDropdownList(getState());
    if (menuTypeOptionList.find(
      ({ value }) => value === oldestElement.menuTypeId
    ))
      return oldestElement.menuTypeId;
    else
      return 0;
  } else {
    const overrideDefaultMenuTypeId = selectOverrideDefaultMenuTypeId(getState());
    try {
      if (overrideDefaultMenuTypeId) {
        return getOverrideMenuType(getState);
      } else {
        const timeZone = selectCurrentTimeZone(getState());
        const defaultMenuTypeTimes = selectDefaultMenuTypeTimes(getState());
        const nextMenuTypeCheck = calcNextMenuType({
          defaultMenuTypeTimes,
          timeZone
        });
        const menuTypeOptionList = selectMenuTypeDropdownList(getState());
        const menuIsAvailable = menuTypeOptionList.find(
          ({ value }) => value === nextMenuTypeCheck.menuTypeId
        );
        if (!menuIsAvailable)
          throw new Error("MenuTypeId not found in available list");
        return nextMenuTypeCheck.menuTypeId;
      }
    } catch (error) {
      const defaultMenuTypeId = selectDefaultMenuTypeId(getState());
      const menuTypeOptionList = selectMenuTypeDropdownList(getState());
      if (menuTypeOptionList.length) {
        const menuIsAvailable = menuTypeOptionList.find(
          ({ value }) => value === defaultMenuTypeId
        );
        return menuIsAvailable ? defaultMenuTypeId : menuTypeOptionList[0].value;
      }
      return null;
    }
  }
};
var createOrderCore = (table, orderNumber, generateCoursing, formData, organizationId, locationId, licenseId) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const revenueCenters = state.tableLayout.savedData.revenueCenters;
  const selectedServiceArea = state.tableLayout.currentEditLayout.selectedServiceArea;
  const roleId = state.loggedInUser.loggedInRole.id;
  const generatedOrderId = generateTabletGeneratedId();
  const orderMetaData = getOrderAdditionalData(getState);
  let tableNumber = "0";
  let tableId = null;
  let serviceAreaId = null;
  let revenueCenterId = null;
  if (table) {
    tableId = table.mergedTableId ? table.mergedTableId : table.tableId;
    tableNumber = table.name;
    dispatch(
      updateTablesStatusAndOrderId(
        false,
        __spreadProps(__spreadValues({}, table), { tableId }),
        generatedOrderId
      )
    );
  }
  if (table && selectedServiceArea) {
    serviceAreaId = Number(selectedServiceArea.id);
    revenueCenterId = revenueCenters[selectedServiceArea.revenueCenterId].id;
  }
  const orderTagIds = formData.orderTags.reduce(
    (acc, orderTag) => [...acc, orderTag.value],
    []
  );
  const newOrder = __spreadProps(__spreadValues(__spreadValues({}, GET_ORDER_INITIAL_STATE()), orderMetaData), {
    organizationId,
    locationId,
    roleId,
    ownerRoleId: roleId,
    name: formData.name.trim(),
    description: formData.description.trim(),
    tabletGeneratedId: generatedOrderId,
    orderNumber,
    tableId,
    numberOfSeatsOccupied: formData.numberOfSeatsOccupied,
    type: formData.type,
    orderTagIds,
    courseTimes: generateCoursing ? generateCourseTimesObject(state) : {},
    serviceAreaId,
    revenueCenterId,
    licenseEditingId: licenseId,
    customer: formData.customer,
    customerId: formData.customerId,
    id: 0,
    noTaxInclusive: !table ? false : (selectedServiceArea == null ? void 0 : selectedServiceArea.forceNoTaxInclusive) || false
  });
  const masterCheckId = newOrder.tabletGeneratedId;
  const masterCheck = __spreadProps(__spreadValues({}, cloneDeep(CHECK_INITIAL_STATE)), {
    tabletGeneratedId: masterCheckId,
    name: i18n_config_default.t("register.check.masterCheckName")
  });
  newOrder.defaultCheckId = masterCheckId;
  newOrder.checks = {
    [masterCheckId]: masterCheck
  };
  const menuTypeId = state.register.registerNavigation.menuTypeId || dispatch(getMenuTypeFromOrder(newOrder));
  const specialsBucket = selectSpecials(state);
  const timeZone = selectCurrentTimeZone(state);
  const activeSpecials = getSpecialsFromMenuType(
    menuTypeId,
    specialsBucket,
    timeZone
  );
  const orderSpecialActive = Object.values(activeSpecials).find(
    (special) => special.specialApplyTo === "order" /* ORDER */
  );
  if (orderSpecialActive) {
    const specialApplied = getSpecialAppliedValue(orderSpecialActive);
    specialApplied.tabletGeneratedId = generatedOrderId;
    newOrder.orderSpecials = { [generatedOrderId]: specialApplied };
  }
  dispatch(addSessionOrder(newOrder, generatedOrderId));
  dispatch(
    updateUserRecentOrdersStation({
      orderId: generatedOrderId,
      orderNumber,
      tableNumber
    })
  );
  return Promise.resolve({
    order: newOrder,
    navigation: {
      menuTypeId,
      orderId: generatedOrderId,
      tableId
    }
  });
});
var editOrder = (orderId, formData, onSuccess) => (dispatch, getState) => {
  const state = getState();
  const _a = formData, { orderTags } = _a, orderUpdate = __objRest(_a, ["orderTags"]);
  const orderTagIds = orderTags.reduce(
    (acc, orderTag) => [...acc, orderTag.value],
    []
  );
  const orderData = __spreadProps(__spreadValues({}, __spreadProps(__spreadValues({}, orderUpdate), {
    name: orderUpdate.name.trim(),
    description: orderUpdate.description.trim()
  })), {
    orderTagIds
  });
  const currentOrder = selectCurrentOrderObj(state);
  const keysToCheck = Object.keys(orderData);
  const originalData = Object.fromEntries(
    Object.entries(currentOrder).filter(([key]) => keysToCheck.includes(key))
  );
  const diff11 = deepDiff6(originalData, orderData);
  if (!diff11)
    return;
  dispatch(updateOrderField(orderId, orderData));
  onSuccess && onSuccess();
};
var updateOrderField = (orderId, orderData, isLocally) => (dispatch, getState) => {
  const orderSearchResults = getState().register.orderSearchResults.orders;
  const remoteOrder = find(
    orderSearchResults,
    (order) => String(order.id) === String(orderId)
  );
  dispatch(updateOrderData(orderId, orderData, isLocally));
  if (orderSearchResults.length > 0 && remoteOrder) {
    dispatch(
      updateOrderSearchResultData(orderId, orderData)
    );
  }
};
var exitFromOrderCore = (orderId, skipCall) => (dispatch, getState) => {
  const state = getState();
  if (state.register.registerNavigation.orderId === null && state.register.registerNavigation.quantity !== null) {
    dispatch(
      updateRegisterNavigationField({
        quantity: null
      })
    );
  }
  if (!isEqual(
    state.register.paymentNavigation,
    PAYMENT_NAVIGATION_INITIAL_STATE
  )) {
    dispatch(
      updatePaymentNavigation(__spreadValues({}, PAYMENT_NAVIGATION_INITIAL_STATE))
    );
  }
  if (!skipCall)
    dispatch(exitFromOrderAction(null, orderId));
};
var updateEnterOrderAndRecentOrders = ({
  licenseEditingId,
  orderId,
  recentOrders,
  organizationUserId
}) => (dispatch, getState) => {
  const state = getState();
  const orders = state.register.orders;
  const loggedInOrganizationUserId = state.loggedInUser.organizationUserId;
  if (orders[orderId] && orders[orderId].licenseEditingId !== licenseEditingId)
    dispatch(enterToOrderAction({ licenseEditingId, orderId }, true));
  const payload = {
    recentOrders,
    organizationUserId
  };
  const actionCreator = organizationUserId === loggedInOrganizationUserId ? updateLoggedInUserRecentOrders : updateRecentOrders;
  dispatch(actionCreator(payload, true));
};
var updateExitOrderLicenseId = ({
  orderId
}) => (dispatch, getState) => {
  const state = getState();
  const orders = state.register.orders;
  if (!orders[orderId])
    return;
  if (orders[orderId].licenseEditingId === null)
    return;
  dispatch(leavingOrderActionWS(null, orderId));
};
var validateCurrentOrderTabletGeneratedId = (tabletGeneratedId, onContinue) => (_, getState) => {
  const state = getState();
  const currentOrder = selectCurrentOrderObj(state);
  if (!currentOrder)
    return;
  if (currentOrder.tabletGeneratedId === tabletGeneratedId)
    return onContinue(false);
  onContinue(true);
};
var getCurrentOrderInData = (orderId) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const { orders } = state.register;
  if (orderId in orders)
    return Promise.resolve(orders[orderId]);
  try {
    const loadedOrder = yield getOrderById(orderId);
    dispatch(addSessionOrder(loadedOrder, orderId));
    return Promise.resolve(loadedOrder);
  } catch (error) {
    return Promise.reject(error);
  }
});

// src/state/register/orders/thunks/checks.ts
var checks_exports = {};
__export(checks_exports, {
  addCheckPaymentCoreThunk: () => addCheckPaymentCoreThunk,
  cleanDisplayCheckElementsThunk: () => cleanDisplayCheckElementsThunk,
  closeCheckThunk: () => closeCheckThunk,
  createCheckCoreThunk: () => createCheckCoreThunk,
  createDisplayCheckElementsThunk: () => createDisplayCheckElementsThunk,
  deleteCheckCoreThunk: () => deleteCheckCoreThunk,
  dumpDefaultCheckThunk: () => dumpDefaultCheckThunk,
  mergeChecksCoreThunk: () => mergeChecksCoreThunk,
  openCheckThunk: () => openCheckThunk,
  resetAllEditableChecksCoreThunk: () => resetAllEditableChecksCoreThunk,
  splitCheckElementEvenlyIntoAllEditableChecks: () => splitCheckElementEvenlyIntoAllEditableChecks,
  splitCheckElementNWaysCoreThunk: () => splitCheckElementNWaysCoreThunk,
  splitDefaultCheckByCustomCoreThunk: () => splitDefaultCheckByCustomCoreThunk,
  splitDefaultCheckBySeatsCoreThunk: () => splitDefaultCheckBySeatsCoreThunk,
  splitDefaultCheckIntoExistingChecksThunk: () => splitDefaultCheckIntoExistingChecksThunk,
  splitDefaultCheckIntoNNewChecksCoreThunk: () => splitDefaultCheckIntoNNewChecksCoreThunk,
  ungroupCheckElementsThunk: () => ungroupCheckElementsThunk,
  unsplitCheckElementsCoreThunk: () => unsplitCheckElementsCoreThunk,
  updateCheckOrderDiscountsThunk: () => updateCheckOrderDiscountsThunk,
  updateCurrentOrderChecksData: () => updateCurrentOrderChecksData,
  voidAllChecksCoreThunk: () => voidAllChecksCoreThunk
});
var createCheckCoreThunk = (checkDefaults = {}) => (dispatch, getState) => {
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  const order = selectCurrentOrderObj(state);
  if (!orderId || !order)
    return;
  const checkId = generateTabletGeneratedId();
  const checkNumber = generateNewCheckNumber(order.checks);
  dispatch(
    createCheck(orderId, checkId, __spreadValues({
      number: checkNumber
    }, checkDefaults))
  );
};
var updateCheckOrderDiscountsThunk = () => (dispatch, getState) => {
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  if (!orderId)
    return;
  dispatch(updateCheckOrderDiscounts(orderId));
};
var voidAllChecksCoreThunk = () => (dispatch, getState) => {
  const orderId = selectCurrentOrderId(getState());
  if (!orderId)
    return;
  dispatch(voidAllChecks(orderId));
  const currentDefaultCheckId = selectCurrentOrderDefaultCheckId(getState());
  dispatch(
    updatePaymentNavigation({
      checkId: currentDefaultCheckId,
      forceClearUnassignedCheck: false
    })
  );
};
var addCheckPaymentCoreThunk = (checkId) => (dispatch) => {
  dispatch(
    updatePaymentNavigation({
      checkId,
      screen: "PAYMENT" /* PAYMENT */,
      method: "CREDIT_DEBIT" /* CREDIT_CARD */,
      option: "PAY" /* PAY */
    })
  );
};
var dumpDefaultCheckThunk = () => (dispatch) => {
  const orderId = selectCurrentOrderId.lastResult();
  if (!orderId)
    return;
  dispatch(dumpDefaultCheck(orderId));
};
var cleanDisplayCheckElementsThunk = (checkId) => (dispatch, getState) => {
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  if (!orderId)
    return;
  dispatch(cleanDisplayCheckElements(orderId, checkId));
};
var createDisplayCheckElementsThunk = (checkId) => (dispatch, getState) => {
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  if (!orderId)
    return;
  dispatch(createDisplayCheckElements(orderId, checkId));
};
var splitCheckElementEvenlyIntoAllEditableChecks = (checkFromId, checkElementId) => (dispatch, getState) => {
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  const order = selectCurrentOrderObj(state);
  if (!orderId || !order)
    return;
  const checksToIds = Object.values(order.checks).filter(
    (check) => getCheckId(check) !== order.defaultCheckId && checkStatusAllowsEditing(check.status)
  ).map(getCheckId);
  return dispatch(
    splitCheckElementEvenly({
      orderId,
      checkElementId,
      checkFromId,
      checksToIds
    })
  );
};
var unsplitCheckElementsCoreThunk = (activeItems) => (dispatch, getState) => {
  const state = getState();
  const currentOrderId = state.register.registerNavigation.orderId;
  if (!currentOrderId)
    return;
  Object.values(activeItems).forEach((item) => {
    dispatch(
      unSplitCheckElement(currentOrderId, item.checkId, item.checkElementId)
    );
  });
};
var openCheckThunk = (checkId) => (dispatch, getState) => {
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  const defaultCheckId = selectCurrentOrderDefaultCheckId(state);
  if (!orderId || !checkId || !defaultCheckId || checkId === defaultCheckId)
    return;
  dispatch(openCheck(orderId, checkId));
};
var closeCheckThunk = (orderId, checkId) => (dispatch, getState) => {
  const state = getState();
  dispatch(closeCheck(orderId, checkId, state));
};
var mergeChecksCoreThunk = (orderId, checkIds) => (dispatch) => {
  dispatch(mergeChecks(orderId, checkIds));
};
var deleteCheckCoreThunk = (orderId, checkId) => (dispatch) => {
  dispatch(deleteEditableCheck(orderId, checkId));
};
var splitDefaultCheckByCustomCoreThunk = () => (dispatch, getState) => {
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  dispatch(
    updatePaymentNavigation({
      screen: "CHECK_EDITOR" /* CHECK_EDITOR */,
      defaultSplit: {
        type: "" /* NONE */
      }
    })
  );
  dispatch(
    updateOrderField(orderId || 0, {
      splitMode: "CUSTOM" /* CUSTOM */
    })
  );
};
var splitDefaultCheckBySeatsCoreThunk = (checkElementIds = null) => (dispatch, getState) => {
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  const order = selectCurrentOrderObj(state);
  if (!orderId || !order)
    return;
  const checkId = order.defaultCheckId;
  checkElementIds = Object.values(order.checks[checkId].checkElements).map(
    getCheckElementId
  );
  if (!checkElementIds || checkElementIds.length === 0)
    return;
  dispatch(
    splitCheckBySeats({
      orderId,
      checkId,
      checkElementIds
    })
  );
  dispatch(
    updateOrderField(orderId, {
      splitMode: "SEATS" /* SEATS */
    })
  );
  dispatch(
    updatePaymentNavigation({
      screen: "CHECK_EDITOR" /* CHECK_EDITOR */,
      defaultSplit: {
        type: "SEATS" /* SEATS */
      }
    })
  );
};
var splitDefaultCheckIntoNNewChecksCoreThunk = (ways, checkElementIds = null, handlePrint) => (dispatch, getState) => {
  let state = getState();
  const orderId = selectCurrentOrderId(state);
  let order = selectCurrentOrderObj(state);
  if (!orderId || !order)
    return;
  const checkId = order.defaultCheckId;
  if (checkElementIds) {
    checkElementIds = checkElementIds.filter(
      (checkElementId) => !!order.checks[checkId].checkElements[checkElementId]
    );
    if (checkElementIds.length === 0)
      return;
  }
  const newCheckIds = Array.from({ length: ways }).map(
    () => generateTabletGeneratedId()
  );
  dispatch(
    splitCheckIntoNNewChecks({
      orderId,
      checkId,
      newCheckIds,
      checkElementIds
    })
  );
  state = getState();
  order = selectCurrentOrderObj(state);
  handlePrint && handlePrint(order);
  dispatch(
    updateOrderField(orderId, {
      splitMode: "EVENLY" /* EVENLY */
    })
  );
  if (state.register.paymentNavigation.screen === "PAYMENT" /* PAYMENT */) {
    dispatch(
      updatePaymentNavigation({
        screen: "CHECK_EDITOR" /* CHECK_EDITOR */,
        defaultSplit: {
          type: "EVENLY" /* EVENLY */,
          ways
        }
      })
    );
  }
};
var splitDefaultCheckIntoExistingChecksThunk = (checkElementIds = null) => (dispatch, getState) => {
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  const order = selectCurrentOrderObj(state);
  if (!orderId || !order)
    return;
  const existingChecks = Object.values(order.checks).filter(
    (check) => checkStatusAllowsEditing(check.status)
  );
  const checkId = order.defaultCheckId;
  if (checkElementIds) {
    checkElementIds = checkElementIds.filter(
      (checkElementId) => !!order.checks[checkId].checkElements[checkElementId]
    );
    if (checkElementIds.length === 0)
      checkElementIds = null;
  }
  if (!checkElementIds) {
    checkElementIds = Object.values(order.checks[checkId].checkElements).map(
      getCheckElementId
    );
  }
  checkElementIds.forEach((checkElementId) => {
    if (existingChecks.length === 1) {
      dispatch(
        moveCheckElements(
          orderId,
          checkElementIds,
          getCheckId(existingChecks[0])
        )
      );
    }
    dispatch(
      // TODO: single action instead of a loop
      splitCheckElementEvenlyIntoAllEditableChecks(checkId, checkElementId)
    );
  });
};
var resetAllEditableChecksCoreThunk = (orderId, onAllowed) => (dispatch) => {
  dispatch(deleteAllEditableChecks(orderId));
  onAllowed();
};
var ungroupCheckElementsThunk = (checkElementIds) => (dispatch, getState) => {
  if (!checkElementIds.length)
    return;
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  if (!orderId)
    return;
  return dispatch(
    ungroupCheckElements({
      orderId,
      checkElementIds
    })
  );
};
var splitCheckElementNWaysCoreThunk = (checkId, checkElementIds, ways) => (dispatch, getState) => {
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  if (!orderId)
    return;
  return dispatch(
    splitCheckElementsWays({
      orderId,
      checkElementIds,
      checkId,
      ways
    })
  );
};
var updateCurrentOrderChecksData = (orderUpdate) => (dispatch, getState) => {
  const state = getState();
  const currentOrderId = selectCurrentOrderId(state);
  if (!currentOrderId)
    return;
  dispatch(updateOrderField(currentOrderId, orderUpdate));
};

// src/state/register/orders/thunks/combos.ts
var combos_exports = {};
__export(combos_exports, {
  cancelComboElementThunk: () => cancelComboElementThunk,
  makeComboFromItemThunk: () => makeComboFromItemThunk,
  removeComboElementCoreThunk: () => removeComboElementCoreThunk,
  removeTicketComboItemThunk: () => removeTicketComboItemThunk,
  selectRegisterComboItemThunk: () => selectRegisterComboItemThunk,
  selectRegisterComboThunk: () => selectRegisterComboThunk
});
var selectRegisterComboThunk = (comboId, overrides = {}) => (dispatch, getState) => {
  var _a, _b, _c, _d;
  const state = getState();
  const { orderId, menuTypeId } = state.register.registerNavigation;
  const { seats: selectedSeats, quantity: selectedQuantity } = state.register.registerNavigation;
  const seatsInNavigation = Object.keys(selectedSeats);
  const elementHasNoSeatsAssigned = seatsInNavigation.length === 0;
  const isSeatingEnabled = selectIsCurrentOrderSeatingMode(state);
  const isSeatingModeNoPrompt = selectSeatingMode(state) === "no_prompt" /* NO_PROMPT */;
  const willSeatingBeEmpty = isSeatingEnabled && elementHasNoSeatsAssigned && !isSeatingModeNoPrompt && !((_d = (_c = (_b = (_a = selectLocationComboBucket(state)) == null ? void 0 : _a[comboId]) == null ? void 0 : _b.menuTypeVersions) == null ? void 0 : _c[selectCurrentMenuTypeId(state) || -1]) == null ? void 0 : _d.defaultNoSeat);
  if (orderId === null)
    return;
  const newTicketComboId = generateTabletGeneratedId();
  dispatch(
    selectRegisterCombo({
      orderId,
      comboElementId: newTicketComboId,
      comboId,
      overrides,
      globalState: state
    })
  );
  const newRegisterNavigation = {
    orderId,
    itemId: null,
    ticketElementId: null,
    skipInventoryCheck: false,
    modifierGroupId: null,
    prevModGroupTypeModGroupId: null,
    nestedModifierGroupId: null,
    modifierItemInstanceId: null,
    comboElementId: newTicketComboId,
    comboId,
    activeItems: [newTicketComboId],
    isSeatSelectionActive: willSeatingBeEmpty
  };
  if (!getState().register.orders[orderId].combos[newTicketComboId])
    return;
  dispatch(setUpCurrentOrderActiveSpecials(menuTypeId, null, comboId));
  dispatch(applySpecialsToNewItems());
  dispatch(
    updateRegisterNavigationField(__spreadProps(__spreadValues({}, newRegisterNavigation), {
      quantity: willSeatingBeEmpty ? selectedQuantity : null,
      modifierTag: null
    }))
  );
};
var removeComboElementCoreThunk = (comboElementId) => (dispatch, getState) => {
  const state = getState();
  const orderId = state.register.registerNavigation.orderId;
  if (orderId === null)
    return;
  dispatch(
    updateRegisterNavigationField({
      itemId: null,
      ticketElementId: null,
      skipInventoryCheck: false,
      isSeatSelectionActive: false,
      comboId: null,
      comboElementId: null,
      activeItems: [],
      quantity: null
    })
  );
  dispatch(actionCreators_exports.removeComboElement(orderId, comboElementId));
  dispatch(validateElementIsAppliedToSpecial(comboElementId, "combo"));
};
var selectRegisterComboItemThunk = (itemId, itemGroupId, instanceId, additionalPrice, comboElementId, triggerClose, triggerNext, overrides, skipInventoryCheck) => (dispatch, getState) => {
  var _a;
  let state = getState();
  const { orderId } = state.register.registerNavigation;
  if (orderId === null)
    return;
  const newTicketElementId = generateTabletGeneratedId();
  const itemGroupsSelected = state.register.orders[orderId].combos[comboElementId].itemGroupsSelected;
  const isCurrentItemSelected = itemGroupsSelected[`${itemGroupId}-${instanceId}`] && itemGroupsSelected[`${itemGroupId}-${instanceId}`].itemId === itemId;
  const menuTypeId = state.register.registerNavigation.menuTypeId;
  const selectedSeats = state.register.registerNavigation.seats;
  const seatsInNavigation = Object.keys(selectedSeats);
  const elementHasNoSeatsAssigned = seatsInNavigation.length === 0;
  const item = selectLocationMenuItemById(state, itemId);
  const isSeatingModeNoPrompt = selectSeatingMode(state) === "no_prompt" /* NO_PROMPT */;
  const itemMenuTypeVersion = (_a = item == null ? void 0 : item.menuTypeVersions) == null ? void 0 : _a[menuTypeId || -1];
  const isSeatingModeEnabled = selectIsCurrentOrderSeatingMode(state);
  const isSubcategoryCustomizer = selectIsCurrentTicketElementSubcategoryCustomizer(state);
  const willSeatingBeEmpty = isSeatingModeEnabled && elementHasNoSeatsAssigned && !(itemMenuTypeVersion == null ? void 0 : itemMenuTypeVersion.defaultNoSeat) && !isSeatingModeNoPrompt && !isSubcategoryCustomizer;
  if (isCurrentItemSelected) {
    dispatch(
      validateTicketElementIsEnabled(comboElementId, orderId, () => {
        dispatch(
          removeRegisterComboItem({
            orderId,
            ticketElementId: itemGroupsSelected[`${itemGroupId}-${instanceId}`].ticketElementId,
            itemId,
            itemGroupId,
            itemGroupInstance: instanceId,
            comboElementId,
            globalState: state,
            isCombo: true,
            isSeatingModeEnabled: selectIsCurrentOrderSeatingMode.lastResult()
          })
        );
        dispatch(
          updateRegisterNavigationField({
            itemId: null,
            ticketElementId: null,
            skipInventoryCheck: false,
            isSeatSelectionActive: false,
            modifierGroupId: null,
            prevModGroupTypeModGroupId: null,
            nestedModifierGroupId: null,
            modifierItemInstanceId: null,
            isAllModsEnabled: false
          })
        );
      })
    );
    return;
  }
  dispatch(
    validateTicketElementIsEnabled(comboElementId, orderId, () => {
      var _a2, _b, _c;
      dispatch(
        selectRegisterComboItem({
          orderId,
          ticketElementId: newTicketElementId,
          itemId,
          additionalPrice,
          itemGroupId,
          itemGroupInstance: instanceId,
          comboElementId,
          globalState: state,
          isCombo: true,
          prepStationId: overrides ? overrides.prepStationId : void 0,
          skipInventoryCheck,
          willSeatingBeEmpty,
          isSeatingModeEnabled
        })
      );
      state = getState();
      const ticketElement = state.register.orders[orderId].ticketElements[newTicketElementId];
      if (!ticketElement)
        return;
      const enterItemDetailsWithNoMods = (_c = (_b = (_a2 = ticketElement.itemObj) == null ? void 0 : _a2.menuTypeVersions) == null ? void 0 : _b[menuTypeId || -1]) == null ? void 0 : _c.enterItemDetails;
      if (!enterItemDetailsWithNoMods && Object.values(
        state.register.orders[orderId].ticketElements[newTicketElementId].modifierGroupsSelected
      ).every(
        (modifierGroup) => !modifierGroup.quantityRequired || modifierGroup.quantityRequired <= Object.values(modifierGroup.modifierItemsSelected).reduce(
          (acc, curr) => acc + (curr.quantitySelected || 0),
          0
        )
      ))
        triggerNext(
          state.register.orders[orderId].combos[comboElementId].itemGroupsSelected
        );
      else
        triggerClose();
      dispatch(
        checkAndSetTicketElementActiveCore({
          registerNavigation: {
            itemId,
            orderId,
            ticketElementId: newTicketElementId,
            modifierGroupId: null,
            prevModGroupTypeModGroupId: null,
            nestedModifierGroupId: null,
            modifierItemInstanceId: null,
            isAllModsEnabled: false
          },
          elementId: newTicketElementId
        })
      );
    })
  );
};
var removeTicketComboItemThunk = (ticketElement) => (dispatch, getState) => {
  const state = getState();
  const orderId = state.register.registerNavigation.orderId;
  if (orderId === null)
    return Promise.reject({ error: "noOrderId" });
  if (!ticketElement.comboElementId)
    return Promise.reject({ error: "noComboElementId" });
  const orders = state.register.orders;
  const order = orders[orderId];
  const comboElement = order.combos[ticketElement.comboElementId];
  let isItemRequired = false;
  let itemGroupId = 0;
  dispatch(
    validateTicketElementIsEnabled(
      ticketElement.comboElementId,
      orderId,
      () => {
        var _a, _b, _c;
        if (ticketElement.comboItemGroupId) {
          isItemRequired = (_b = (_a = comboElement.comboObj) == null ? void 0 : _a.menuTypeVersions[comboElement.menuTypeId].itemGroups[ticketElement.comboItemGroupId].required) != null ? _b : false;
          itemGroupId = ticketElement.comboItemGroupId;
        } else {
          const comboObject = comboElement.comboObj;
          if (!comboObject)
            return Promise.reject({ error: "noComboObject" });
          const itemGroups = comboObject.menuTypeVersions[comboElement.menuTypeId].itemGroups;
          const itemGroupMatched = Object.values(itemGroups).find(
            (itemGroup) => {
              const itemIsInGroup = Object.values(itemGroup.items).find(
                (items) => items.itemId === ticketElement.itemId
              );
              return itemIsInGroup;
            }
          );
          if (!itemGroupMatched)
            return Promise.reject({ error: "noItemGroup" });
          itemGroupId = itemGroupMatched.itemGroupId;
          isItemRequired = itemGroupMatched.required;
        }
        if (isItemRequired)
          return Promise.reject({ error: "itemRequired", itemGroupId });
        const ticketElementId = state.register.registerNavigation.ticketElementId;
        dispatch(
          removeRegisterComboItem({
            orderId,
            ticketElementId: getTicketElementId(ticketElement),
            itemId: ticketElement.itemId,
            itemGroupId,
            itemGroupInstance: (_c = ticketElement.comboItemGroupInstance) != null ? _c : 1,
            comboElementId: ticketElement.comboElementId,
            globalState: state,
            isCombo: true,
            isSeatingModeEnabled: selectIsCurrentOrderSeatingMode.lastResult()
          })
        );
        if (ticketElementId === getTicketElementId(ticketElement))
          dispatch(
            updateRegisterNavigationField({
              itemId: null,
              ticketElementId: null,
              skipInventoryCheck: false,
              isSeatSelectionActive: false,
              modifierGroupId: null,
              prevModGroupTypeModGroupId: null,
              nestedModifierGroupId: null,
              modifierItemInstanceId: null
            })
          );
      }
    )
  );
  return Promise.resolve();
};
var makeComboFromItemThunk = (comboId) => (dispatch, getState) => {
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  const ticketElement = selectCurrentTicketElement(state);
  if (orderId === null || !ticketElement || isOpenItemFn(ticketElement))
    return;
  const newTicketComboId = generateTabletGeneratedId();
  const menuTypeId = ticketElement.menuTypeId;
  const comboBucket = selectLocationComboBucket(state);
  const comboElement = comboBucket[comboId];
  const itemGroups = comboElement.menuTypeVersions[menuTypeId].itemGroups;
  const itemGroupMatched = Object.values(itemGroups).find((itemGroup) => {
    const itemIsInGroup = Object.values(itemGroup.items).find(
      (items) => items.itemId === ticketElement.itemId
    );
    return itemIsInGroup;
  });
  if (!itemGroupMatched)
    return;
  dispatch(
    actionCreators_exports.makeComboFromTicketElement({
      comboId,
      orderId,
      ticketElementId: getTicketElementId(ticketElement),
      comboElementId: newTicketComboId,
      itemGroupId: itemGroupMatched.itemGroupId,
      itemGroupInstance: 1,
      additionalPrice: itemGroupMatched.items[ticketElement.itemId].additionalPrice,
      isRequired: itemGroupMatched.required,
      globalState: state,
      isSeatingModeEnabled: selectIsCurrentOrderSeatingMode.lastResult()
    })
  );
  const newRegisterNavigation = {
    orderId,
    itemId: ticketElement.itemId,
    ticketElementId: getTicketElementId(ticketElement),
    modifierGroupId: null,
    prevModGroupTypeModGroupId: null,
    nestedModifierGroupId: null,
    modifierItemInstanceId: null,
    comboElementId: newTicketComboId,
    comboId,
    activeItems: [newTicketComboId, getTicketElementId(ticketElement)]
  };
  if (!getState().register.orders[orderId].combos[newTicketComboId])
    return;
  dispatch(
    updateRegisterNavigationField(__spreadProps(__spreadValues({}, newRegisterNavigation), {
      quantity: null,
      modifierTag: null
    }))
  );
};
var cancelComboElementThunk = (comboElementId) => (dispatch, getState) => {
  const state = getState();
  const orderId = state.register.registerNavigation.orderId;
  if (orderId === null)
    return;
  dispatch(
    updateRegisterNavigationField({
      itemId: null,
      ticketElementId: null,
      skipInventoryCheck: false,
      isSeatSelectionActive: false,
      comboId: null,
      comboElementId: null,
      activeItems: [],
      quantity: null
    })
  );
  dispatch(actionCreators_exports.cancelComboElement(orderId, comboElementId));
};

// src/state/register/orders/thunks/modifierItemsAndIngredients.ts
var modifierItemsAndIngredients_exports = {};
__export(modifierItemsAndIngredients_exports, {
  addOpenModAndToggleItThunk: () => addOpenModAndToggleItThunk,
  clearOpenModThunk: () => clearOpenModThunk,
  decrementItemIngredientThunk: () => decrementItemIngredientThunk,
  decrementModifierItemSelectedThunk: () => decrementModifierItemSelectedThunk,
  decrementNestedModifierItemSelectedThunk: () => decrementNestedModifierItemSelectedThunk,
  deleteModifierGroupItemSelected: () => deleteModifierGroupItemSelected,
  deleteNestedModifierGroupItemSelected: () => deleteNestedModifierGroupItemSelected,
  getMaxSortPriorityByModifierGroupId: () => getMaxSortPriorityByModifierGroupId,
  getMaxSortPriorityInAllMods: () => getMaxSortPriorityInAllMods,
  handleModifierGroupMaximumQuantityError: () => handleModifierGroupMaximumQuantityError,
  incrementItemIngredientSizeThunk: () => incrementItemIngredientSizeThunk,
  incrementModifierItemSelectedThunk: () => incrementModifierItemSelectedThunk,
  incrementNestedModifierItemSelectedThunk: () => incrementNestedModifierItemSelectedThunk,
  resetModifierGroupSelectedCoreThunk: () => resetModifierGroupSelectedCoreThunk,
  resetModifierGroupToConfigWhenSentCore: () => resetModifierGroupToConfigWhenSentCore,
  toggleItemIngredientThunk: () => toggleItemIngredientThunk,
  toggleModifierItemSelectedThunk: () => toggleModifierItemSelectedThunk,
  toggleNestedModifierItemSelectedThunk: () => toggleNestedModifierItemSelectedThunk,
  toggleNoneModifierItemsSelected: () => toggleNoneModifierItemsSelected,
  toggleNoneNestedModifierItemSelectedThunk: () => toggleNoneNestedModifierItemSelectedThunk,
  validateMaximumModifierItemQuantityCurrent: () => validateMaximumModifierItemQuantityCurrent
});

// src/state/register/orders/thunks/navigation.ts
var navigation_exports = {};
__export(navigation_exports, {
  changeRegisterNavigationCategory: () => changeRegisterNavigationCategory,
  checkPaymentScreenAndNavigate: () => checkPaymentScreenAndNavigate,
  clearModifierTag: () => clearModifierTag,
  closeMultiselectMode: () => closeMultiselectMode,
  closeOrderDetailsOverlay: () => closeOrderDetailsOverlay,
  getAndResetGlobalQuantity: () => getAndResetGlobalQuantity,
  getClearedNavigationObject: () => getClearedNavigationObject,
  navigateToOrderCore: () => navigateToOrderCore,
  openOrderDetailsOverlayCore: () => openOrderDetailsOverlayCore,
  setIsPaymentModeActiveCoreThunk: () => setIsPaymentModeActiveCoreThunk,
  updateRegisterNavigationFieldWithCheck: () => updateRegisterNavigationFieldWithCheck,
  updateRegisterNavigationFieldWithCheckAndState: () => updateRegisterNavigationFieldWithCheckAndState
});

// src/state/customers/actions.ts
var actions_exports9 = {};
__export(actions_exports9, {
  cancelCustomerChangesOnCancelPress: () => cancelCustomerChangesOnCancelPress,
  checkCustomerValidation: () => checkCustomerValidation,
  checkForCustomerChangesAndNavigate: () => checkForCustomerChangesAndNavigate,
  customerValidationThunk: () => customerValidationThunk,
  editCustomer: () => editCustomer,
  fetchCustomers: () => fetchCustomers,
  fetchSingleCustomer: () => fetchSingleCustomer,
  saveCustomerChangesOnSavePress: () => saveCustomerChangesOnSavePress,
  setCustomersOnState: () => setCustomersOnState,
  updateCurrentCustomers: () => updateCurrentCustomers,
  updateCustomer: () => updateCustomer,
  updateCustomerChangeData: () => updateCustomerChangeData,
  updateCustomerFinalDiffObject: () => updateCustomerFinalDiffObject,
  validateCustomerChangesOnSavePress: () => validateCustomerChangesOnSavePress
});

// src/helpers/factories/customersDifferences/diffCustomerFactory.ts
var CustomerBasicSectionFieldLabels = /* @__PURE__ */ ((CustomerBasicSectionFieldLabels2) => {
  CustomerBasicSectionFieldLabels2[CustomerBasicSectionFieldLabels2["firstName"] = 0] = "firstName";
  CustomerBasicSectionFieldLabels2[CustomerBasicSectionFieldLabels2["middleName"] = 1] = "middleName";
  CustomerBasicSectionFieldLabels2[CustomerBasicSectionFieldLabels2["lastName"] = 2] = "lastName";
  CustomerBasicSectionFieldLabels2[CustomerBasicSectionFieldLabels2["dateOfBirth"] = 3] = "dateOfBirth";
  CustomerBasicSectionFieldLabels2[CustomerBasicSectionFieldLabels2["email"] = 4] = "email";
  CustomerBasicSectionFieldLabels2[CustomerBasicSectionFieldLabels2["phoneNumber"] = 5] = "phoneNumber";
  CustomerBasicSectionFieldLabels2[CustomerBasicSectionFieldLabels2["customerNotes"] = 6] = "customerNotes";
  return CustomerBasicSectionFieldLabels2;
})(CustomerBasicSectionFieldLabels || {});
var CustomerAddressInfoSectionFieldLabels = /* @__PURE__ */ ((CustomerAddressInfoSectionFieldLabels2) => {
  CustomerAddressInfoSectionFieldLabels2[CustomerAddressInfoSectionFieldLabels2["isDefault"] = 0] = "isDefault";
  CustomerAddressInfoSectionFieldLabels2[CustomerAddressInfoSectionFieldLabels2["addressType"] = 1] = "addressType";
  CustomerAddressInfoSectionFieldLabels2[CustomerAddressInfoSectionFieldLabels2["streetLine1"] = 2] = "streetLine1";
  CustomerAddressInfoSectionFieldLabels2[CustomerAddressInfoSectionFieldLabels2["streetLine2"] = 3] = "streetLine2";
  CustomerAddressInfoSectionFieldLabels2[CustomerAddressInfoSectionFieldLabels2["state"] = 4] = "state";
  CustomerAddressInfoSectionFieldLabels2[CustomerAddressInfoSectionFieldLabels2["city"] = 5] = "city";
  CustomerAddressInfoSectionFieldLabels2[CustomerAddressInfoSectionFieldLabels2["postalCode"] = 6] = "postalCode";
  CustomerAddressInfoSectionFieldLabels2[CustomerAddressInfoSectionFieldLabels2["hotelName"] = 7] = "hotelName";
  CustomerAddressInfoSectionFieldLabels2[CustomerAddressInfoSectionFieldLabels2["roomNumber"] = 8] = "roomNumber";
  CustomerAddressInfoSectionFieldLabels2[CustomerAddressInfoSectionFieldLabels2["officeName"] = 9] = "officeName";
  CustomerAddressInfoSectionFieldLabels2[CustomerAddressInfoSectionFieldLabels2["apartmentNumber"] = 10] = "apartmentNumber";
  return CustomerAddressInfoSectionFieldLabels2;
})(CustomerAddressInfoSectionFieldLabels || {});
var CustomerCardsInfoSectionFieldLabels = /* @__PURE__ */ ((CustomerCardsInfoSectionFieldLabels2) => {
  CustomerCardsInfoSectionFieldLabels2[CustomerCardsInfoSectionFieldLabels2["isDefault"] = 0] = "isDefault";
  return CustomerCardsInfoSectionFieldLabels2;
})(CustomerCardsInfoSectionFieldLabels || {});
var returnLabel9 = (field) => {
  if (field in CustomerBasicSectionFieldLabels) {
    return i18n_config_default.t(
      `app.modals.customersDiffModal.basic.${field}`
    );
  }
  if (field in CustomerAddressInfoSectionFieldLabels) {
    return i18n_config_default.t(
      `app.modals.customersDiffModal.addressInfo.${field}`
    );
  }
  if (field in CustomerCardsInfoSectionFieldLabels) {
    return i18n_config_default.t(
      `app.modals.customersDiffModal.addressInfo.${field}`
    );
  }
};
var diffCustomerFactory = (diffArray, state) => {
  if (diffArray.length > 0) {
    const { addressInfo, cardsInfo } = generateTablesObj(diffArray, state);
    return {
      basic: getDiffArray(
        diffArray,
        returnLabel9,
        CustomerBasicSectionFieldLabels,
        1
      ),
      addressInfo,
      cardsInfo
    };
  }
  return null;
};
var generateTablesObj = (diffArray, state) => {
  const changeData = selectCurrentCustomer(state);
  const addressInfo = [];
  const cardsInfo = [];
  const ADDRESSES_FIELD = "addresses";
  const CARDS_FIELD = "cards";
  diffArray.forEach(
    (diff11) => filterDiffFunction(
      diff11,
      ({ diffLength }) => {
        if (diffLength >= 2) {
          const customField = diff11.path[0];
          if (diff11.kind === "N") {
            let changes = Object.entries(
              diff11.rhs
            ).map(([specialTagField, specialTagValue]) => {
              return {
                field: specialTagField,
                label: returnLabel9(specialTagField),
                value: specialTagValue
              };
            });
            if (customField === ADDRESSES_FIELD) {
              changes = changes.filter(
                (change) => change.field in CustomerAddressInfoSectionFieldLabels
              );
              addressInfo.push({
                id: diff11.rhs.addressId,
                label: "",
                action: "add",
                changes
              });
            }
          } else if (diff11.kind === "D") {
            if (customField === ADDRESSES_FIELD) {
              addressInfo.push({
                id: diff11.lhs.addressId,
                label: "",
                action: "remove",
                changes: []
              });
            }
          } else if (diff11.kind === "E") {
            const id = Number(diff11.path[1]);
            const idAsString = diff11.path[1];
            const customNewDiff = {
              field: diff11.path[2],
              label: returnLabel9(diff11.path[2]) || "",
              value: diff11.rhs
            };
            if (customField === ADDRESSES_FIELD) {
              if (!addressInfo.find(
                (address) => address.id === idAsString && address.action === "update"
              )) {
                addressInfo.push({
                  id: idAsString,
                  label: "",
                  action: "update",
                  changes: [customNewDiff]
                });
              } else {
                for (const [i, address] of addressInfo.entries()) {
                  if (address.id === idAsString) {
                    addressInfo[i].changes = [
                      ...address.changes,
                      customNewDiff
                    ];
                    break;
                  }
                }
              }
            } else if (customField === CARDS_FIELD) {
              if (!cardsInfo.find(
                (card) => card.id === id && card.action === "update"
              )) {
                cardsInfo.push({
                  id,
                  label: changeData.cards[id].lastFourDigits || "",
                  action: "update",
                  changes: [customNewDiff]
                });
              } else {
                for (const [i, card] of cardsInfo.entries()) {
                  if (card.id === id) {
                    cardsInfo[i].changes = [...card.changes, customNewDiff];
                    break;
                  }
                }
              }
            }
          }
        }
      },
      returnLabel9
    )
  );
  return {
    addressInfo,
    cardsInfo
  };
};
var updateCustomer = (values, sectionId, hardUpdate = false) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const data = selectCurrentCustomer(getState());
    const oldData = hardUpdate ? {} : data;
    if (oldData === null) {
      return;
    }
    dispatch(
      setCustomersChangeDataValues(
        __spreadValues(__spreadValues({}, oldData), values),
        sectionId
      )
    );
  });
};
var updateCurrentCustomers = (hideRefresh = true) => (dispatch, getState) => {
  const state = getState();
  const selectedMode = selectCustomersSelectedMode(state);
  const { master, location, remoteLocation, versions } = state.customers;
  const refreshToast = state.app.refreshToast;
  let currentCustomers;
  let customersVersion;
  switch (selectedMode.customersType) {
    case "master" /* MASTER_CUSTOMERS */:
      currentCustomers = master;
      customersVersion = versions.master;
      break;
    case "location" /* LOCATION_CUSTOMERS */:
      currentCustomers = location;
      customersVersion = versions.location;
      break;
    case "remoteLocation" /* REMOTE_LOCATION_CUSTOMERS */:
      currentCustomers = remoteLocation;
      customersVersion = versions.remoteLocation || 0;
      break;
  }
  dispatch(
    setSelectedCustomersMode(__spreadProps(__spreadValues({}, selectedMode), {
      customersVersion,
      currentCustomers
    }))
  );
  if (refreshToast.isActive && hideRefresh) {
    dispatch(hideRefreshToast());
  }
};
var fetchCustomers = (organizationId, locationId, currentLocationId, licenseId, page, append = true, search) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const masterCustomers = selectMasterCustomers(state);
  const locationCustomers = selectLocationCustomers(state);
  const remoteLocationCustomers = selectRemoteLocationCustomers(state);
  const {
    master: masterVersion,
    location: locationVersion,
    remoteLocation: remoteVersion
  } = selectCustomersVersions(state);
  const isRemoteLocation = locationId !== currentLocationId && currentLocationId !== 0;
  if (!search) {
    dispatch(
      setIsLoadingModal({
        active: true,
        message: i18n_config_default.t("customersScreen.mainScreen.loadingMessage"),
        isMakingApiCall: true
      })
    );
  }
  const url = apiConfig_default.customers.getLocationCustomers(
    organizationId,
    currentLocationId,
    page,
    search
  );
  try {
    const response = yield apiCall(
      "get" /* Get */,
      url,
      true,
      void 0,
      licenseId,
      () => null,
      dispatch,
      state
    );
    const newMasterCustomers = append ? __spreadValues(__spreadValues({}, masterCustomers), response.master.customers) : response.master.customers;
    const newLocationCustomers = append ? __spreadValues(__spreadValues({}, locationCustomers), response.location.customers) : response.location.customers;
    const newRemoteLocationCustomers = append ? __spreadValues(__spreadValues({}, remoteLocationCustomers), response.location.customers) : response.location.customers;
    dispatch(setMasterCustomers(newMasterCustomers));
    if (isRemoteLocation) {
      dispatch(setRemoteLocationCustomers(newRemoteLocationCustomers));
    } else {
      dispatch(setLocationCustomers(newLocationCustomers));
    }
    dispatch(updateCurrentCustomers());
    dispatch(
      setCustomersVersions(
        {
          master: response.version || masterVersion,
          location: response.version || locationVersion,
          remoteLocation: response.version || remoteVersion
        },
        false
      )
    );
    return {
      success: true,
      totalPages: response.location.totalPages,
      totalCustomers: response.location.totalCustomers,
      currentPage: response.location.currentPage
    };
  } catch (e) {
    return {
      success: false,
      totalPages: 0,
      totalCustomers: 0,
      currentPage: 0
    };
  } finally {
    dispatch(setIsLoadingModal({ active: false, isMakingApiCall: false }));
  }
});
var fetchSingleCustomer = (organizationId, locationId, currentLocationId, licenseId, customerId) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const isRemoteLocation = locationId !== currentLocationId && currentLocationId !== 0;
  const url = apiConfig_default.customers.getSingleCustomer(
    organizationId,
    currentLocationId,
    customerId
  );
  try {
    const response = yield apiCall(
      "get" /* Get */,
      url,
      true,
      void 0,
      licenseId,
      () => null,
      dispatch,
      state
    );
    const newMasterCustomers = { [customerId]: response.master };
    const newLocationCustomers = { [customerId]: response.location };
    const newRemoteLocationCustomers = { [customerId]: response.location };
    dispatch(setMasterCustomers(newMasterCustomers));
    if (isRemoteLocation) {
      dispatch(setRemoteLocationCustomers(newRemoteLocationCustomers));
    } else {
      dispatch(setLocationCustomers(newLocationCustomers));
    }
    dispatch(updateCurrentCustomers());
    return {
      success: true
    };
  } catch (e) {
    return {
      success: false
    };
  }
});
var checkCustomerValidation = (canDiscard, onContinue, showErrorsModal = true) => (dispatch, getState) => {
  const state = getState();
  const errors = selectCustomersErrors(state);
  if (Object.keys(errors).length > 0 && showErrorsModal) {
    dispatch(
      setShowConfirmationModal({
        title: "",
        active: true,
        type: canDiscard ? "customerValidationDiscard" : "customerValidation",
        btnSuccessText: i18n_config_default.t("commonButtons.ok"),
        onSuccess: () => {
          onContinue && onContinue();
          dispatch(resetCustomersChangeData());
        }
      })
    );
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
};
var customerValidationThunk = (data, canDiscard, onContinue, showErrorsModal = true) => (dispatch) => __async(void 0, null, function* () {
  try {
    yield customerSchema.validate(data, {
      abortEarly: false
    });
    dispatch(setCustomersErrors({}));
  } catch (error) {
    dispatch(
      setCustomersErrors(__spreadValues({}, reduceErrors(error.errors)))
    );
    dispatch(
      checkCustomerValidation(canDiscard, onContinue, showErrorsModal)
    );
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var setCustomersOnState = (payload, isWebSocket = false, shouldUpdateCurrentCustomers = false) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const masterCustomers = selectMasterCustomers(state);
  const locationCustomers = selectLocationCustomers(state);
  const {
    master: masterVersion,
    location: locationVersion,
    remoteLocation: remoteVersion
  } = selectCustomersVersions(state);
  batch$1(() => {
    payload.master && dispatch(
      setMasterCustomers(__spreadProps(__spreadValues({}, masterCustomers), {
        [payload.id]: payload.master
      }))
    );
    payload.location && dispatch(
      setLocationCustomers(__spreadProps(__spreadValues({}, locationCustomers), {
        [payload.id]: payload.location
      }))
    );
    dispatch(
      setCustomersVersions(
        {
          master: payload.version || masterVersion,
          location: payload.version || locationVersion,
          remoteLocation: payload.version || remoteVersion
        },
        isWebSocket
      )
    );
    if (shouldUpdateCurrentCustomers)
      dispatch(updateCurrentCustomers());
  });
});
var postEditCustomer = (navigate = true, postRequest2, id, mode, successMessage) => (dispatch, getState) => {
  const state = getState();
  const changeData = selectCustomerChangeData(state);
  const stateMode = changeData.mode;
  const isCreating = (mode || stateMode) === "create" /* CREATE */;
  dispatch(postRequest2(navigate, mode, id));
  dispatch(
    showToast({
      // title: i18n.t('commonTexts.success'),
      title: successMessage ? successMessage : i18n_config_default.t(
        isCreating ? "customersScreen.createNewElement.success" : "customersScreen.editElement.success"
      ),
      type: "success"
    })
  );
};
var editCustomer = (onRefresh, navigate = true, postRequest2, organizationId, currentLocationId, licenseId, licenseSettingsId, errorCodesDispatcher, extraHeaders, request, mode) => (dispatch, getState) => __async(void 0, null, function* () {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const state = getState();
  const {
    customersVersion,
    mode: stateMode,
    selectedLocations,
    data,
    id,
    finalDiffObject
  } = selectCustomerChangeData(state);
  const loggedInUser = state.loggedInUser;
  const selectedMode = state.settings.selectedMode;
  const loggedInOrganizationUserId = loggedInUser.organizationUserId;
  const roleId = loggedInUser.loggedInRole.id;
  if (data === null && !(request == null ? void 0 : request.data) && !(request == null ? void 0 : request.diff))
    return { success: false, id: 0 };
  const isCreating = (mode || stateMode) === "create" /* CREATE */;
  dispatch(setShowConfirmationModal(CONFIRMATION_MODAL_INITIAL_STATE));
  dispatch(
    setIsLoadingModal({
      active: true,
      message: isCreating ? i18n_config_default.t("commonTexts.creating") : i18n_config_default.t("commonTexts.updating"),
      isMakingApiCall: true
    })
  );
  const url = apiConfig_default.customers.editCustomers(
    organizationId,
    currentLocationId
  );
  const diffLocationIds = selectedLocations;
  const hasMultipleLocations = selectShouldRenderLocationDropdown(state);
  const locationId = !hasMultipleLocations ? currentLocationId : selectedMode.id;
  const _customersVersion = customersVersion || getCustomersVersionCore(state);
  const dataRequest = request ? __spreadProps(__spreadValues({}, request), {
    locationId,
    customersVersion: _customersVersion,
    diffLocationIds: request.diffLocationIds || diffLocationIds,
    roleId,
    organizationUserId: loggedInOrganizationUserId,
    diff: request.diff || finalDiffObject
  }) : {
    id,
    data,
    locationId,
    customersVersion: _customersVersion,
    diffLocationIds,
    roleId,
    organizationUserId: loggedInOrganizationUserId,
    diff: finalDiffObject
  };
  try {
    const response = yield apiCall(
      isCreating ? "post" /* Post */ : "put" /* Put */,
      url,
      true,
      dataRequest,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders,
      (errorResponse) => {
        var _a2, _b2, _c2;
        return ((_c2 = (_b2 = (_a2 = errorResponse.response) == null ? void 0 : _a2.data) == null ? void 0 : _b2.error) == null ? void 0 : _c2.code) !== 112 /* OUTDATED_CUSTOMER */;
      }
    );
    batch$1(() => {
      dispatch(setCustomersOnState(response));
      dispatch(updateCurrentCustomers());
      isCreating && dispatch(
        updateCustomersChangeDataValues({
          id: response.id,
          mode: "update" /* UPDATE */
        })
      );
      dispatch(
        postEditCustomer(
          navigate,
          postRequest2,
          response.id,
          mode || stateMode,
          request == null ? void 0 : request.successMessage
        )
      );
    });
    dispatch(setIsLoadingModal({ active: false, isMakingApiCall: false }));
    return { success: true, id: response.id };
  } catch (e) {
    console.error(e);
    const error = e;
    if (((_c = (_b = (_a = error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.error) == null ? void 0 : _c.code) === 112 /* OUTDATED_CUSTOMER */) {
      dispatch(
        setIsLoadingModal({
          active: true,
          message: `${i18n_config_default.t("menuScreen.refreshModal.edit.customers.title")}. ${i18n_config_default.t("commonTexts.refreshingData")}...`,
          isMakingApiCall: true
        })
      );
      yield new Promise((resolve) => setTimeout(resolve, 1e3));
      dispatch(setCustomersOnState((_e = (_d = error.response.data) == null ? void 0 : _d.error) == null ? void 0 : _e.data));
      onRefresh && onRefresh();
      yield new Promise((resolve) => setTimeout(resolve, 2e3));
      return yield dispatch(
        editCustomer(
          onRefresh,
          navigate,
          postRequest2,
          organizationId,
          currentLocationId,
          licenseId,
          licenseSettingsId,
          errorCodesDispatcher,
          extraHeaders,
          request,
          mode
        )
      );
    } else if (((_h = (_g = (_f = error.response) == null ? void 0 : _f.data) == null ? void 0 : _g.error) == null ? void 0 : _h.code) === 111 /* CUSTOMER_PHONE_DUPLICATED */) {
      dispatch(
        setCustomersErrors(
          getSettingsGenericError({
            key: "phoneNumber",
            id: "phoneNumber",
            message: i18n_config_default.t("customersScreen.errors.phoneNumber.duplicated"),
            section: "basic" /* BASIC */
          })
        )
      );
      dispatch(setIsLoadingModal({ active: false, isMakingApiCall: false }));
      return { success: false, id: 0 };
    } else {
      dispatch(setIsLoadingModal({ active: false, isMakingApiCall: false }));
      return { success: false, id: 0 };
    }
  }
});
var updateCustomerFinalDiffObject = (differences) => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(
      updateCustomersChangeDataValues({
        differences,
        finalDiffObject: diffCustomerFactory(differences, state)
      })
    );
  };
};
var cancelCustomerChangesOnCancelPress = (onNavigation, customOnSuccess) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const { originalData, data, mode } = selectCustomerChangeData(state);
    const isCreation = mode === "create" /* CREATE */;
    if (!data) {
      return;
    }
    batch$1(() => {
      const onSuccess = () => {
        if (isCreation) {
          onNavigation == null ? void 0 : onNavigation();
          dispatch(resetCustomersChangeData());
        } else {
          dispatch(resetCustomersChanges(originalData));
        }
      };
      dispatch(
        setShowConfirmationModal({
          title: i18n_config_default.t(
            "app.modals.discardChangesConfirmation.title"
          ),
          description: i18n_config_default.t(
            "app.modals.discardChangesConfirmation.description"
          ),
          active: true,
          type: "warning",
          btnCancelText: i18n_config_default.t("commonTexts.no"),
          btnSuccessText: i18n_config_default.t("commonTexts.yes"),
          onSuccess: customOnSuccess ? customOnSuccess : onSuccess
        })
      );
    });
  });
};
var checkForCustomerChangesAndNavigate = (onContinue, onRefresh, postRequest2, organizationId, locationId, licenseId, licenseSettingsId, errorCodesDispatcher, extraHeaders, onContinueResetChangeData = true, isSavePressed = false, navigateOnSave = false, options) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const currentCustomers = selectCustomers(state);
    const { data, originalData, mode, hasChanges, id } = selectCustomerChangeData(state);
    if (!data) {
      onContinue();
      return { success: false, id: 0 };
    }
    const fn = customerValidationThunk(
      data,
      true,
      onContinue,
      !(options == null ? void 0 : options.hideErrorsModal)
    );
    const isValid = yield dispatch(fn);
    if (!isValid) {
      return { success: false, id: 0 };
    }
    const showLocationSelectionModal = shouldShowCustomersLocationsModalOnSaveCore(dispatch);
    const handleSave = () => __async(void 0, null, function* () {
      const { success, id: fetchId } = yield dispatch(
        editCustomer(
          onRefresh,
          navigateOnSave,
          postRequest2,
          organizationId,
          locationId,
          licenseId,
          licenseSettingsId,
          errorCodesDispatcher,
          extraHeaders,
          void 0,
          void 0
        )
      );
      if (!success) {
        return { success, id: fetchId };
      }
      onContinue();
      return { success, id: fetchId };
    });
    if (mode === "create" /* CREATE */ && hasChanges && isSavePressed) {
      return handleSave();
    }
    if (mode === "update" /* UPDATE */) {
      const originData = originalData || currentCustomers[id];
      const differences = diff(originData, data);
      if (!differences) {
        const changeData = selectCustomerChangeData(state);
        dispatch(setCustomersChangeData(__spreadProps(__spreadValues({}, changeData), { hasChanges: false })));
        onContinue();
        onContinueResetChangeData && !isSavePressed && dispatch(resetCustomersChangeData());
        return { success: true, id };
      }
      if (differences.length === 0) {
        onContinue();
        onContinueResetChangeData && dispatch(resetCustomersChangeData());
        return { success: true, id };
      }
      dispatch(updateCustomerFinalDiffObject(differences));
      const onSuccess = () => {
        if (showLocationSelectionModal) {
          dispatch(
            setShowConfirmationModal({
              title: "",
              type: "locationSettingsSelection",
              active: true,
              onSuccess: handleSave
            })
          );
        } else {
          return handleSave();
        }
      };
      if (options == null ? void 0 : options.hideErrorsModal) {
        return handleSave();
      } else {
        dispatch(
          setShowConfirmationModal({
            title: i18n_config_default.t("app.modals.diffModal.reviewChanges"),
            type: "customersDiff",
            btnCancelText: isSavePressed ? "" : i18n_config_default.t("app.modals.discardChangesConfirmation.title"),
            btnSuccessText: showLocationSelectionModal ? "" : i18n_config_default.t("commonButtons.save"),
            description: showLocationSelectionModal ? `${i18n_config_default.t("app.modals.diffModal.youHaveUnsavedChanges", {
              bucket: i18n_config_default.t("customersScreen.singular")
            })} ${i18n_config_default.t("app.modals.diffModal.descripTionForContinue")}` : `${i18n_config_default.t("app.modals.diffModal.youHaveUnsavedChanges", {
              bucket: i18n_config_default.t("customersScreen.singular")
            })} ${i18n_config_default.t("app.modals.diffModal.descriptionForSave")}`,
            active: true,
            onSuccess,
            onCancel: () => {
              if (isSavePressed)
                return;
              onContinue();
              if (onContinueResetChangeData) {
                dispatch(resetCustomersChangeData());
              }
            }
          })
        );
      }
    } else if (mode === "create" /* CREATE */ && hasChanges) {
      const onSuccess = () => {
        onContinue();
        onContinueResetChangeData && dispatch(resetCustomersChangeData());
      };
      if (options == null ? void 0 : options.hideErrorsModal) {
        onSuccess();
      } else {
        dispatch(
          setShowConfirmationModal({
            title: i18n_config_default.t("customersScreen.creation.title"),
            description: i18n_config_default.t("customersScreen.creation.message"),
            type: "warning",
            active: true,
            btnSuccessText: i18n_config_default.t("app.modals.creationConfirmation.exit"),
            btnCancelText: i18n_config_default.t("app.modals.creationConfirmation.continue"),
            onSuccess
          })
        );
      }
      return { success: true, id };
    } else {
      onContinue();
      if (onContinueResetChangeData)
        dispatch(resetCustomersChangeData());
    }
    return { success: true, id };
  });
};
var validateCustomerChangesOnSavePress = (showErrorsModal = true) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const { data } = selectCustomerChangeData(state);
    if (data === null)
      return { success: false };
    try {
      const fn = customerValidationThunk(
        data,
        false,
        void 0,
        showErrorsModal
      );
      const isValid = yield dispatch(fn);
      return { success: isValid };
    } catch (error) {
      console.error(error);
      return { success: false };
    }
  });
};
var saveCustomerChangesOnSavePress = (onIsValid, showErrorsModal = true) => {
  return (dispatch) => __async(void 0, null, function* () {
    const { success } = yield dispatch(
      validateCustomerChangesOnSavePress(showErrorsModal)
    );
    if (success) {
      yield onIsValid();
    }
    return { success };
  });
};
var updateCustomerChangeData = () => (dispatch, getState) => {
  const state = getState();
  const { data, id } = selectCustomerChangeData(state);
  const currentCustomers = selectCustomers(state);
  const hasMultipleLocations = selectShouldRenderLocationDropdown(state);
  if (!data) {
    return;
  }
  const newData = currentCustomers[id];
  const customersVersion = (!hasMultipleLocations ? getCurrentCustomersCore(state, "location" /* LOCATION_CUSTOMERS */).version : getCustomersVersionCore(state)) || 0;
  dispatch(
    updateCustomersChangeDataValues({
      data: newData,
      hasChanges: false,
      originalData: newData,
      sectionId: "all" /* ALL */,
      customersVersion
    })
  );
};

// src/state/management/employees/actions.ts
var actions_exports10 = {};
__export(actions_exports10, {
  addEmployeeShiftCore: () => addEmployeeShiftCore,
  deleteEmployeeShiftCore: () => deleteEmployeeShiftCore,
  editEmployeeShiftCore: () => editEmployeeShiftCore,
  fetchEmployeeDetailsShiftsCore: () => fetchEmployeeDetailsShiftsCore,
  fetchEmployeeDetailsSummaryCore: () => fetchEmployeeDetailsSummaryCore,
  fetchEmployeesCore: () => fetchEmployeesCore,
  genericEmployeeShiftCore: () => genericEmployeeShiftCore
});
var fetchEmployeesCore = (organizationId, locationId, licenseId, filters, sorting, page, currentEmployees, append = true, omitLoading = false) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const errorObject = {
    success: false,
    totalPages: 0,
    total: 0,
    currentPage: 0,
    employees: []
  };
  if (!filters.startDate || !filters.endDate) {
    return errorObject;
  }
  !append && !omitLoading && dispatch(
    setIsLoadingModal({
      active: true,
      isMakingApiCall: true
    })
  );
  const request = __spreadProps(__spreadValues({}, filters), {
    startDate: getDateISOBasedInEndOfBusinessDay(
      filters.startDate || "",
      state
    ),
    endDate: getDateISOBasedInEndOfBusinessDay(filters.endDate || "", state),
    page
  });
  const url = apiConfig_default.management.getEmployees(
    organizationId,
    locationId,
    getEmployeesMainScreenRequestFormData(request, sorting)
  );
  try {
    const response = yield apiCall(
      "get" /* Get */,
      url,
      true,
      void 0,
      licenseId,
      () => null,
      dispatch,
      state
    );
    const newEmployees = append ? [...currentEmployees, ...response.employees] : response.employees;
    return {
      success: true,
      totalPages: response.totalPages,
      total: response.total,
      currentPage: response.currentPage,
      employees: newEmployees
    };
  } catch (e) {
    return errorObject;
  } finally {
    !append && !omitLoading && dispatch(setIsLoadingModal({ active: false, isMakingApiCall: false }));
  }
});
var fetchEmployeeDetailsShiftsCore = (organizationId, locationId, licenseId, filters, sorting, page, userId, currentShifts, append = true, omitLoading = false) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const errorObject = {
    success: false,
    totalPages: 0,
    total: 0,
    currentPage: 0,
    shifts: []
  };
  if (!filters.startDate || !filters.endDate) {
    return errorObject;
  }
  !append && !omitLoading && dispatch(
    setIsLoadingModal({
      active: true,
      isMakingApiCall: true
    })
  );
  const request = __spreadProps(__spreadValues({}, filters), {
    startDate: getDateISOBasedInEndOfBusinessDay(
      filters.startDate || "",
      state
    ),
    endDate: getDateISOBasedInEndOfBusinessDay(filters.endDate || "", state),
    page,
    organizationUserId: userId
  });
  const url = apiConfig_default.management.getEmployeeDetailsShifts(
    organizationId,
    locationId,
    getEmployeeDetailsScreenRequestFormData(request, sorting)
  );
  try {
    const response = yield apiCall(
      "get" /* Get */,
      url,
      true,
      void 0,
      licenseId,
      () => null,
      dispatch,
      state
    );
    const newEmployees = append ? [...currentShifts, ...response.shifts] : response.shifts;
    return {
      success: true,
      totalPages: response.totalPages,
      total: response.total,
      currentPage: response.currentPage,
      shifts: newEmployees
    };
  } catch (e) {
    return errorObject;
  } finally {
    !append && !omitLoading && dispatch(setIsLoadingModal({ active: false, isMakingApiCall: false }));
  }
});
var fetchEmployeeDetailsSummaryCore = (organizationId, locationId, licenseId, filters, userId) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const errorObject = {
    success: false,
    employeeSummary: [],
    totalSales: 0,
    totalTipsEarned: 0,
    totalTipsPaid: 0,
    totalHoursWorked: 0
  };
  if (!filters.startDate || !filters.endDate) {
    return errorObject;
  }
  const request = __spreadProps(__spreadValues({}, filters), {
    startDate: getDateISOBasedInEndOfBusinessDay(
      filters.startDate || "",
      state
    ),
    endDate: getDateISOBasedInEndOfBusinessDay(filters.endDate || "", state),
    organizationUserId: userId
  });
  const url = apiConfig_default.management.getEmployeeDetailsSummary(
    organizationId,
    locationId,
    getEmployeeDetailsScreenRequestFormData(request)
  );
  try {
    const response = yield apiCall(
      "get" /* Get */,
      url,
      true,
      void 0,
      licenseId,
      () => null,
      dispatch,
      state
    );
    return __spreadValues({
      success: true
    }, response);
  } catch (e) {
    return errorObject;
  }
});
var genericEmployeeShiftCore = (organizationId, locationId, licenseId, shift, method) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const url = apiConfig_default.management.editEmployeeShift(
    organizationId,
    locationId
  );
  dispatch(
    setIsLoadingModal({
      active: true,
      isMakingApiCall: true
    })
  );
  try {
    yield apiCall(
      method,
      url,
      true,
      shift,
      licenseId,
      () => null,
      dispatch,
      state
    );
    return true;
  } catch (e) {
    return false;
  } finally {
    dispatch(
      setIsLoadingModal({
        active: false,
        isMakingApiCall: false
      })
    );
  }
});
var addEmployeeShiftCore = (organizationId, locationId, licenseId, shift) => (dispatch) => __async(void 0, null, function* () {
  return dispatch(
    genericEmployeeShiftCore(
      organizationId,
      locationId,
      licenseId,
      shift,
      "post" /* Post */
    )
  );
});
var editEmployeeShiftCore = (organizationId, locationId, licenseId, shift) => (dispatch) => __async(void 0, null, function* () {
  return dispatch(
    genericEmployeeShiftCore(
      organizationId,
      locationId,
      licenseId,
      shift,
      "put" /* Put */
    )
  );
});
var deleteEmployeeShiftCore = (organizationId, locationId, licenseId, shift) => (dispatch) => __async(void 0, null, function* () {
  return dispatch(
    genericEmployeeShiftCore(
      organizationId,
      locationId,
      licenseId,
      shift,
      "delete" /* Delete */
    )
  );
});

// src/state/register/giftCards/actions.ts
var actions_exports11 = {};
__export(actions_exports11, {
  getGiftCardSales: () => getGiftCardSales
});
var getGiftCardSales = (currentData = [], organizationId, locationId, licenseId, errorCodesDispatcher, page = 0, append = true, last4 = "", extraHeaders) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const url = apiConfig_default.register.giftCardSales(organizationId, locationId);
    let response = yield apiCall(
      "post" /* Post */,
      url,
      true,
      { page, last4: last4 ? last4 : void 0 },
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders
    );
    response = __spreadProps(__spreadValues({}, response), {
      giftCardInfo: response.giftCardInfo.map((giftCard, index) => __spreadProps(__spreadValues({}, giftCard), {
        id: index + 1
      }))
    });
    if (append) {
      return __spreadProps(__spreadValues({}, response), {
        giftCardInfo: [...currentData, ...response.giftCardInfo]
      });
    }
    return response;
  });
};

// src/state/register/printerCenter/actions.ts
var actions_exports12 = {};
__export(actions_exports12, {
  clearPrinterErrorsForPrintJobs: () => clearPrinterErrorsForPrintJobs,
  deletePrinterJobs: () => deletePrinterJobs,
  getPrintJobInfo: () => getPrintJobInfo,
  getPrinterJobs: () => getPrinterJobs,
  handleConfirmedPrintJobs: () => handleConfirmedPrintJobs,
  handlePausedPrinterAndPrintJobs: () => handlePausedPrinterAndPrintJobs,
  handleResumePrinterAndPrintJobs: () => handleResumePrinterAndPrintJobs,
  handleTransferredPrintJobs: () => handleTransferredPrintJobs,
  pauseResumePrinter: () => pauseResumePrinter,
  replaceBackupPrinter: () => replaceBackupPrinter,
  reprintPrinterJobs: () => reprintPrinterJobs,
  transferPrinterJobs: () => transferPrinterJobs
});
var getPrinterJobs = (printerId, organizationId, locationId, licenseId, errorCodesDispatcher) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const urlGetter = printerId ? apiConfig_default.register.getPrinterJobs : apiConfig_default.register.allPrinterJobs;
  const url = urlGetter(organizationId, locationId, printerId);
  try {
    const res = yield apiCall(
      "get" /* Get */,
      url,
      true,
      {},
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state
    );
    return res != null ? res : [];
  } catch (err) {
    return [];
  }
});
var replaceBackupPrinter = (printerId, newBackupPrinterId, organizationId, locationId, licenseId, errorCodesDispatcher) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const printers = printersSelector(state);
  const url = apiConfig_default.register.replaceBackUpPrinter(
    organizationId,
    locationId,
    printerId
  );
  const data = {
    backUpPrinterId: !newBackupPrinterId ? null : newBackupPrinterId
  };
  dispatch(
    setIsLoadingModal({
      active: true,
      message: i18n_config_default.t("navBar.common.printerCenter.backupPrinter.updating")
    })
  );
  yield apiCall(
    "put" /* Put */,
    url,
    true,
    data,
    licenseId,
    errorCodesDispatcher,
    dispatch,
    state
  ).then(() => {
    const newPrinters = produce(printers, (draft) => {
      draft[printerId].backupPrinterId = newBackupPrinterId;
    });
    dispatch(setPrinters(newPrinters));
    dispatch(
      showToast({
        type: "success",
        title: i18n_config_default.t(
          "navBar.common.printerCenter.backupPrinter.updateSuccess"
        )
      })
    );
    dispatch(
      setIsLoadingModal({
        active: false
      })
    );
  }).catch(() => {
    dispatch(
      setIsLoadingModal({
        active: false
      })
    );
  });
});
var pauseResumePrinter = (id, action, organizationId, locationId, licenseId, errorCodesDispatcher) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const url = apiConfig_default.register.pauseResumePrinter(
    organizationId,
    locationId,
    id,
    action
  );
  dispatch(
    setIsLoadingModal({
      active: true,
      message: i18n_config_default.t("navBar.common.printerCenter.printerStatus.updating")
    })
  );
  dispatch(setMessageId("updatingPrinterStatus"));
  yield apiCall(
    "put" /* Put */,
    url,
    true,
    {},
    licenseId,
    errorCodesDispatcher,
    dispatch,
    state
  ).catch(() => {
    dispatch(
      showToast({
        type: "error",
        title: i18n_config_default.t("navBar.common.printerCenter.printerStatus.error"),
        description: void 0
      })
    );
  }).finally(
    () => dispatch(
      setIsLoadingModal({
        active: false
      })
    )
  );
});
var deletePrinterJobs = (printjobsIds, onSuccess, onError, organizationId, locationId, licenseId, errorCodesDispatcher) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const deleteUrl = apiConfig_default.register.getPrinterJobsInfo(
    organizationId,
    locationId
  );
  dispatch(
    setIsLoadingModal({
      active: true,
      message: i18n_config_default.t("navBar.common.printerCenter.printJobs.deleting")
    })
  );
  yield apiCall(
    "delete" /* Delete */,
    deleteUrl,
    true,
    { printjobsIds },
    licenseId,
    errorCodesDispatcher,
    dispatch,
    state
  ).then(() => {
    showToast({
      title: i18n_config_default.t("navBar.common.printerCenter.printJobs.deleteSuccess"),
      type: "success"
    });
    onSuccess();
    dispatch(setIsLoadingModal({ active: false }));
  }).catch((err) => {
    console.error(err);
    showToast({
      title: i18n_config_default.t("navBar.common.printerCenter.printJobs.deleteError"),
      type: "error"
    });
    dispatch(setIsLoadingModal({ active: false }));
  });
  onError();
});
var reprintPrinterJobs = (data, onSuccess, onError, organizationId, locationId, licenseId, errorCodesDispatcher) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const deleteUrl = apiConfig_default.register.reprintPrinterJobsInfo(
    organizationId,
    locationId
  );
  dispatch(
    setIsLoadingModal({
      active: true,
      message: i18n_config_default.t("navBar.common.printerCenter.printJobs.reprinting")
    })
  );
  yield apiCall(
    "put" /* Put */,
    deleteUrl,
    true,
    data,
    licenseId,
    errorCodesDispatcher,
    dispatch,
    state
  ).then(() => {
    showToast({
      title: i18n_config_default.t("commonTexts.success"),
      description: i18n_config_default.t(
        "navBar.common.printerCenter.printJobs.reprintSuccess"
      ),
      type: "success"
    });
    onSuccess();
    dispatch(setIsLoadingModal({ active: false }));
  }).catch((err) => {
    console.error(err);
    showToast({
      title: i18n_config_default.t("commonTexts.error"),
      description: i18n_config_default.t("commonTexts.somethingWentWrong"),
      type: "error"
    });
    dispatch(setIsLoadingModal({ active: false }));
  });
  onError();
});
var transferPrinterJobs = (data, onSuccess, onError, organizationId, locationId, licenseId, errorCodesDispatcher) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const transferURL = apiConfig_default.register.transferPrinterJobsInfo(
    organizationId,
    locationId
  );
  dispatch(
    setIsLoadingModal({
      active: true,
      message: i18n_config_default.t("navBar.common.printerCenter.printJobs.transferring")
    })
  );
  yield apiCall(
    "put" /* Put */,
    transferURL,
    true,
    data,
    licenseId,
    errorCodesDispatcher,
    dispatch,
    state
  ).then(() => {
    showToast({
      title: i18n_config_default.t(
        "navBar.common.printerCenter.printJobs.transferSuccess"
      ),
      type: "success"
    });
    dispatch(
      setIsLoadingModal({
        active: false
      })
    );
    onSuccess();
  }).catch((err) => {
    console.error(err);
    showToast({
      title: i18n_config_default.t("navBar.common.printerCenter.printJobs.transferError"),
      type: "error"
    });
    dispatch(
      setIsLoadingModal({
        active: false
      })
    );
  });
  onError();
});
var clearPrinterErrorsForPrintJobs = (printerJobsIds) => (dispatch, getState) => {
  const state = getState();
  const updatedOrders = produce(state.register.orders, (draft) => {
    var _a;
    for (const order of Object.values(draft)) {
      if (!order.printerError)
        continue;
      let orderHasPrinterError = false;
      for (const ticketElement of Object.values(order.ticketElements)) {
        if (isEmpty9(ticketElement.printErrorMessage))
          continue;
        const printErrors = ticketElement.printErrorMessage;
        for (const printError in printErrors) {
          if (printerJobsIds.includes((_a = printErrors == null ? void 0 : printErrors[printError]) == null ? void 0 : _a.printJobId)) {
            printErrors[printError].isErrored = false;
            printErrors[printError].isCleared = true;
            printErrors[printError].sentTime = getNowUTCDate();
          }
        }
        if (Object.values(ticketElement.printErrorMessage).some(
          (printError) => printError.isErrored
        ))
          orderHasPrinterError = true;
      }
      order.printerError = orderHasPrinterError;
    }
  });
  return dispatch(setOrders(updatedOrders));
};
var handleTransferredPrintJobs = (payload) => (dispatch, getState) => {
  const state = getState();
  const printerJobsIds = payload.transferredPrinterJobs.map(
    (transferredPrintJob) => transferredPrintJob.printJobId
  );
  const orderIds = payload.transferredPrinterJobs.map(
    (transferredPrintJob) => transferredPrintJob.orderId
  );
  const updatedOrders = produce(state.register.orders, (draft) => {
    Object.values(draft).filter((order) => orderIds.includes(getEntityId(order))).forEach((order) => {
      var _a;
      let orderHasPrinterError = false;
      for (const ticketElement of Object.values(order.ticketElements)) {
        if (isEmpty9(ticketElement.printErrorMessage))
          continue;
        const printErrors = ticketElement.printErrorMessage;
        const printHistory = ticketElement.sentToPrepStationHistory;
        for (const printError in printErrors) {
          if (printerJobsIds.includes((_a = printErrors == null ? void 0 : printErrors[printError]) == null ? void 0 : _a.printJobId)) {
            printErrors[printError].isErrored = false;
            printErrors[printError].isCleared = true;
            printErrors[printError].sentTime = getNowUTCDate();
          }
        }
        if (Object.keys(printErrors).some(
          (printError) => printerJobsIds.includes(printError)
        )) {
          const lastPrepStationId = printHistory[printHistory.length - 1].prepStationId;
          printHistory.push({
            printJobId: generatePrintJobId(),
            printJobErrorId: null,
            sentTime: getNowUTCDate(),
            prepStationId: lastPrepStationId,
            printerId: payload.toPrinterId
          });
        }
        if (Object.values(ticketElement.printErrorMessage).some(
          (printError) => printError.isErrored
        ))
          orderHasPrinterError = true;
      }
      order.printerError = orderHasPrinterError;
    });
  });
  dispatch(setOrders(updatedOrders));
};
var handleResumePrinterAndPrintJobs = (_printerJobsIds) => () => {
  console.info(_printerJobsIds);
  return;
};
var handlePausedPrinterAndPrintJobs = (printerJobsIds) => (dispatch, getState) => {
  const state = getState();
  const updatedOrders = produce(state.register.orders, (draft) => {
    var _a;
    for (const order of Object.values(draft)) {
      let orderHasPrinterError = false;
      for (const ticketElement of Object.values(order.ticketElements)) {
        if (isEmpty9(ticketElement.printErrorMessage))
          continue;
        const printErrors = ticketElement.printErrorMessage;
        for (const printError in printErrors) {
          if (printerJobsIds.includes((_a = printErrors == null ? void 0 : printErrors[printError]) == null ? void 0 : _a.printJobId)) {
            if (printErrors[printError].isCleared) {
              printErrors[printError].isErrored = true;
              printErrors[printError].isCleared = false;
              printErrors[printError].clearedTime = void 0;
            }
          }
        }
        if (Object.values(ticketElement.printErrorMessage).some(
          (printError) => printError.isErrored
        ))
          orderHasPrinterError = true;
      }
      order.printerError = orderHasPrinterError;
    }
  });
  return dispatch(setOrders(updatedOrders));
};
var handleConfirmedPrintJobs = (printJobsWSR) => (dispatch, getState) => {
  const state = getState();
  const { orderId, printJobId } = printJobsWSR;
  if (!state.register.orders[orderId])
    return;
  selectIsDualPricingEnabled(state);
  const updatedOrder = produce(state.register.orders[orderId], (draft) => {
    if (!draft.printerError)
      return;
    let orderHasPrinterError = false;
    for (const ticketElement of Object.values(draft.ticketElements)) {
      if (isEmpty9(ticketElement.printErrorMessage))
        continue;
      const printErrors = ticketElement.printErrorMessage;
      if (printErrors[printJobId]) {
        printErrors[printJobId].isErrored = false;
        printErrors[printJobId].isCleared = true;
        printErrors[printJobId].sentTime = getNowUTCDate();
      }
      if (Object.values(ticketElement.printErrorMessage).some(
        (printError) => printError.isErrored && !printError.isCleared
      ))
        orderHasPrinterError = true;
    }
    draft.printerError = orderHasPrinterError;
  });
  return dispatch(updateOrderField(orderId, updatedOrder, true));
};
var getPrintJobInfo = (filterParams, currentData = [], organizationId, locationId, licenseId, errorCodesDispatcher, page = 0, append = true, extraHeaders) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const formData = formatParametersToGetPrintJob(filterParams);
    const pageData = `?page=${page}`;
    const url = apiConfig_default.register.getPrinterJobsInfo(
      organizationId,
      locationId,
      pageData,
      formData
    );
    const response = yield apiCall(
      "get" /* Get */,
      url,
      true,
      void 0,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders
    );
    if (append) {
      return __spreadProps(__spreadValues({}, response), {
        printjobs: [...currentData, ...response.printjobs]
      });
    }
    return response;
  });
};

// src/state/reports/actions.ts
var actions_exports13 = {};
__export(actions_exports13, {
  cancelReportsChangesOnPress: () => cancelReportsChangesOnPress,
  changeSelectedReportsMode: () => changeSelectedReportsMode,
  checkReportsForChangesAndNavigate: () => checkReportsForChangesAndNavigate,
  deleteReport: () => deleteReport,
  emailReport: () => emailReport,
  fetchReport: () => fetchReport,
  getLocationsToApplyReportsChanges: () => getLocationsToApplyReportsChanges,
  handleReportsChange: () => handleReportsChange,
  initializeReportsState: () => initializeReportsState,
  loadReportBucketChangeData: () => loadReportBucketChangeData,
  printEndOfShiftReport: () => printEndOfShiftReport,
  printInventoryOnHandReport: () => printInventoryOnHandReport,
  printReport: () => printReport,
  refreshCurrentReports: () => refreshCurrentReports,
  resetReportsChangeData: () => resetReportsChangeData,
  resetReportsFieldErrors: () => resetReportsFieldErrors,
  saveReportsChanges: () => saveReportsChanges,
  saveReportsChangesOnSavePress: () => saveReportsChangesOnSavePress,
  setCurrentReportURL: () => setCurrentReportURL,
  setIsReportPDFLodaing: () => setIsReportPDFLodaing,
  setIsReportSaving: () => setIsReportSaving,
  setReports: () => setReports,
  setReportsChangeData: () => setReportsChangeData,
  setReportsChangeDataValues: () => setReportsChangeDataValues,
  setReportsDiffObject: () => setReportsDiffObject,
  setReportsErrors: () => setReportsErrors,
  setReportsSelectedMode: () => setReportsSelectedMode,
  setSelectedReportsType: () => setSelectedReportsType,
  validateReportForm: () => validateReportForm
});
var getBaseReportInitialState = () => ({
  id: 0,
  isActive: true,
  name: "",
  isFavorited: false,
  period: "custom" /* CUSTOM */,
  startDate: "",
  endDate: "",
  categoryIds: null,
  subcategoryIds: null,
  // orderStatuses: null,
  orderTypes: null,
  reportingGroupIds: null,
  isSchedulingEnabled: false,
  fileType: "pdf" /* PDF */,
  scheduleStartDateTime: (/* @__PURE__ */ new Date()).toISOString(),
  repeatType: "daily" /* DAILY */,
  recipients: []
});
var getCustomReportsInitialState = () => __spreadProps(__spreadValues({}, getBaseReportInitialState()), {
  customReportId: 0,
  locationCustomReportId: 0,
  layout: {},
  customReportComponents: {},
  period: "yesterday" /* YESTERDAY */
});
var getItemComboSalesReportInitialState = () => __spreadProps(__spreadValues({}, getBaseReportInitialState()), {
  itemComboSalesReportId: 0,
  groupBy: "category" /* CATEGORY */,
  showModItemsSales: false
});
var getSalesOverviewReportInitialState = () => __spreadProps(__spreadValues({}, getBaseReportInitialState()), {
  salesOverviewReportId: 0,
  template: "default" /* DEFAULT */,
  showSalesByMenuType: false,
  showSalesByOrderType: false,
  showSalesByRole: false,
  showSalesByServiceArea: false
});
var getEndOfShiftReportInitialState = () => __spreadProps(__spreadValues({}, getBaseReportInitialState()), {
  endOfShiftReportId: 0,
  ownerIds: null,
  showSalesByMenuType: false,
  showSalesByOrderType: false,
  combineForAll: false,
  doNotPrintOrderHistory: false,
  isClockOut: true
});
var getCreditCardBatchReportInitialState = () => __spreadProps(__spreadValues({}, getBaseReportInitialState()), {
  creditCardBatchReportId: 0
});
var getEmployeeSalesAndTipsReportInitialState = () => __spreadProps(__spreadValues({}, getBaseReportInitialState()), {
  employeeSalesAndTipsReportId: 0,
  ownerIds: null
});
var getVoidReasonsReportInitialState = () => __spreadProps(__spreadValues({}, getBaseReportInitialState()), {
  voidReasonsReportId: 0
});
var getInventoryOnHandReportInitialState = () => __spreadProps(__spreadValues({}, getBaseReportInitialState()), {
  inventoryOnHandReportId: 0
});
var getCreditBalancesReportInitialState = () => __spreadProps(__spreadValues({}, getBaseReportInitialState()), {
  creditBalancesReportId: 0
});
var getReportsChangeDataInitialState = () => ({
  id: null,
  bucket: null,
  data: null,
  originalData: null,
  hasChanges: false,
  mode: "create" /* CREATE */,
  differences: [],
  errors: {},
  reportUrl: null,
  isReportPdfLoading: false,
  isReportSaving: false,
  isQuickReport: false
});
var getReportsStoreInitialState = () => ({
  customReports: {},
  itemComboSalesReports: {},
  salesOverviewReports: {},
  endOfShiftReports: {},
  creditCardBatchReports: {},
  employeeSalesAndTipsReports: {},
  voidReasonsReports: {},
  inventoryOnHandReports: {},
  creditBalancesReports: {}
});
var getReportsSelectedModeInitialState = () => ({
  id: 0,
  name: "",
  type: "master" /* MASTER */,
  currentReports: getReportsStoreInitialState()
});
var getReportsReducerInitialState = () => ({
  master: getReportsStoreInitialState(),
  location: getReportsStoreInitialState(),
  changeData: getReportsChangeDataInitialState(),
  selectedMode: getReportsSelectedModeInitialState(),
  versions: { ["master" /* MASTER */]: 0, ["location" /* LOCATION */]: 0 }
});
var reportsReducer = produce((state = getReportsReducerInitialState(), action) => {
  switch (action.type) {
    case WS_SET_REPORTS:
    case SET_REPORTS:
      return action.payload;
    case SET_REPORTS_CHANGE_DATA:
      state.changeData = action.payload;
      break;
    case RESET_REPORTS_CHANGE_DATA:
      state.changeData = getReportsChangeDataInitialState();
      break;
    case SET_REPORTS_CHANGE_DATA_VALUES:
      state.changeData.data = action.payload;
      state.changeData.hasChanges = reportHasChanges(state.changeData);
      break;
    case SET_REPORT_URL:
      state.changeData.reportUrl = action.payload;
      break;
    case SET_IS_REPORT_PDF_LOADING:
      state.changeData.isReportPdfLoading = action.payload;
      break;
    case SET_IS_REPORT_SAVING:
      state.changeData.isReportSaving = action.payload;
      break;
    case SET_REPORTS_DIFF_OBJECT:
      state.changeData.differences = action.payload;
      break;
    case SET_REPORTS_ERRORS:
      state.changeData.errors = action.payload;
      break;
    case SET_SELECTED_REPORTS_TYPE:
      state.selectedMode.type = action.payload;
      state.selectedMode.currentReports = state[action.payload];
      break;
    case SET_REPORTS_SELECTED_MODE:
      state.selectedMode = action.payload;
      break;
  }
  return state;
});
var reducer_default5 = reportsReducer;

// src/state/reports/actions.ts
var setReports = (payload, isWebSocket = false) => ({
  type: isWebSocket ? WS_SET_REPORTS : SET_REPORTS,
  payload
});
var setReportsChangeData = (payload) => ({
  type: SET_REPORTS_CHANGE_DATA,
  payload
});
var resetReportsChangeData = () => ({
  type: RESET_REPORTS_CHANGE_DATA
});
var setReportsChangeDataValues = (payload) => ({
  type: SET_REPORTS_CHANGE_DATA_VALUES,
  payload
});
var setReportsDiffObject = (payload) => ({
  type: SET_REPORTS_DIFF_OBJECT,
  payload
});
var getReportsDiffObject = (getState) => {
  const state = getState();
  const differences = selectReports(state).changeData.differences;
  return diffReportFactory(differences, state);
};
var setReportsErrors = (payload) => ({
  type: SET_REPORTS_ERRORS,
  payload
});
var setSelectedReportsType = (payload) => ({
  type: SET_SELECTED_REPORTS_TYPE,
  payload
});
var setReportsSelectedMode = (payload) => ({
  type: SET_REPORTS_SELECTED_MODE,
  payload
});
var setCurrentReportURL = (payload) => ({
  type: SET_REPORT_URL,
  payload
});
var setIsReportPDFLodaing = (payload) => ({
  type: SET_IS_REPORT_PDF_LOADING,
  payload
});
var setIsReportSaving = (payload) => ({
  type: SET_IS_REPORT_SAVING,
  payload
});
var refreshCurrentReports = () => (dispatch, getState) => {
  var _a;
  const state = getState();
  const reports = selectReports(state);
  dispatch(
    setReportsSelectedMode(__spreadProps(__spreadValues({}, reports.selectedMode || getReportsSelectedModeInitialState()), {
      currentReports: ((_a = reports.selectedMode) == null ? void 0 : _a.type) === "master" /* MASTER */ ? reports.master : reports.location
    }))
  );
};
var initializeReportsState = (initializationData, isWebSocket = false) => (dispatch, getState) => {
  const state = getState();
  const {
    changeData: currentChangeData,
    selectedMode,
    versions
  } = selectReports(state);
  const selectedModeType = selectedMode.type;
  const initialState = __spreadValues(__spreadProps(__spreadValues({}, getReportsReducerInitialState()), {
    changeData: currentChangeData,
    selectedMode
  }), initializationData);
  isWebSocket && dispatch(
    setShowRefreshToast({
      isActive: true,
      variant: "MENU" /* MENU */,
      title: i18n_config_default.t("menuScreen.refreshToast.title.reports")
    })
  );
  dispatch(setReports(initialState, isWebSocket));
  dispatch(refreshCurrentReports());
  if (versions[selectedModeType] !== initializationData.versions[selectedModeType] && !currentChangeData.hasChanges && currentChangeData.data) {
    dispatch(resetReportsChangeData());
  }
};
var validateReportForm = (bucket, data, canDiscard, onContinue) => (dispatch) => __async(void 0, null, function* () {
  const schema = getReportsValidationSchema(bucket);
  let reportFormErrors = {};
  try {
    yield schema.validate(data, { abortEarly: false });
  } catch (error) {
    reportFormErrors = getErrorMessages(error);
  }
  if (Object.keys(reportFormErrors).length > 0) {
    dispatch(setReportsErrors(reportFormErrors));
    dispatch(
      setShowConfirmationModal({
        title: "",
        active: true,
        type: canDiscard ? "validationDiscard" : "validation",
        btnSuccessText: i18n_config_default.t("commonButtons.ok"),
        onSuccess: () => {
          dispatch(resetReportsChangeData());
          onContinue && onContinue();
        }
      })
    );
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var postSaveReport = (postRequest2, id, bucket) => (dispatch) => {
  dispatch(postRequest2(id, bucket));
  dispatch(
    showToast({
      title: i18n_config_default.t("commonTexts.success"),
      // message: isCreating
      //   ? i18n.t('commonTexts.createdSuccessfully')
      //   : i18n.t('commonTexts.updatedSuccessfully'),
      type: "success"
    })
  );
};
var saveReportsChanges = (onRefresh, postRequest2, organizationId, currentLocationId, licenseId, errorCodesDispatcher, extraHeaders, retries) => (dispatch, getState) => __async(void 0, null, function* () {
  var _a, _b, _c, _d, _e, _f;
  const state = getState();
  const selectedLocations = state.settings.changeData.selectedLocations;
  const hasMultipleLocations = selectShouldRenderLocationDropdown(state);
  const {
    changeData,
    versions,
    selectedMode: { type: selectedModeType, id: selectedModeLocationId }
  } = selectReports(state);
  const { data, originalData, bucket, mode, id } = changeData;
  const abortReturn = { success: false, id: 0 };
  if (!data || !originalData || !bucket || !mode) {
    return abortReturn;
  }
  const isCreating = mode === "create" /* CREATE */;
  dispatch(setShowConfirmationModal(CONFIRMATION_MODAL_INITIAL_STATE));
  dispatch(
    setIsLoadingModal({
      active: true,
      message: isCreating ? i18n_config_default.t("commonTexts.creating") : i18n_config_default.t("commonTexts.updating"),
      isMakingApiCall: true
    })
  );
  dispatch(setIsReportSaving(true));
  const url = apiConfig_default.reports.getLocationReports(
    organizationId,
    currentLocationId
  );
  const time = (/* @__PURE__ */ new Date()).getTime();
  const hash = shajs3("sha256").update(`${time}-${bucket}-${JSON.stringify(data)}`).digest("hex");
  let diffLocationIds = [0, currentLocationId];
  if (hasMultipleLocations) {
    diffLocationIds = [...selectedLocations != null ? selectedLocations : []];
    if (selectedModeType === "master" /* MASTER */ && !diffLocationIds.includes(0)) {
      diffLocationIds.unshift(0);
    }
  }
  let newData = data;
  const diffObject = getReportsDiffObject(getState) || {
    filters: [],
    scheduling: []
  };
  if (bucket === "customReports") {
    newData = fixCustomReportsIds(data);
  }
  const request = {
    id: id || 0,
    selectedReport: reportBucketToEndpointType(bucket),
    locationId: selectedModeLocationId,
    diffLocationIds,
    diff: diffObject,
    data: newData,
    reportsVersion: versions[selectedModeType]
  };
  try {
    dispatch(setMessageId(hash));
    const response = yield apiCall(
      isCreating ? "post" /* Post */ : "put" /* Put */,
      url,
      true,
      request,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      getState(),
      extraHeaders,
      () => true
    );
    const newId = response.id;
    if (newId) {
      dispatch(initializeReportsState(response.reports));
      dispatch(refreshCurrentReports());
      dispatch(setIsLoadingModal({ active: false, isMakingApiCall: false }));
      dispatch(postSaveReport(postRequest2, newId, bucket));
      dispatch(setIsReportSaving(false));
      return { success: true, id: newId };
    }
    return abortReturn;
  } catch (e) {
    console.error(e);
    const error = e;
    if (((_c = (_b = (_a = error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.error) == null ? void 0 : _c.code) === 108 /* OUTDATED_REPORTS */) {
      dispatch(
        setIsLoadingModal({
          active: true,
          message: `${i18n_config_default.t("commonTexts.refreshingData")}...`,
          isMakingApiCall: true
        })
      );
      yield new Promise((resolve) => setTimeout(resolve, 1e3));
      const updatedSettings = (_f = (_e = (_d = error.response) == null ? void 0 : _d.data) == null ? void 0 : _e.error) == null ? void 0 : _f.data;
      dispatch(initializeReportsState(updatedSettings));
      onRefresh == null ? void 0 : onRefresh();
      if (!retries) {
        dispatch(
          setIsLoadingModal({ active: false, isMakingApiCall: false })
        );
        dispatch(
          setShowConfirmationModal({
            title: i18n_config_default.t(
              "menuScreen.refreshModal.edit.settings.title"
            ),
            description: i18n_config_default.t(
              "menuScreen.refreshModal.edit.settings.description"
            ),
            type: "refresh",
            btnSuccessText: i18n_config_default.t("menuScreen.refreshModal.successButton"),
            active: true,
            hideCancel: true,
            onSuccess: () => {
              dispatch(
                setShowConfirmationModal(CONFIRMATION_MODAL_INITIAL_STATE)
              );
            }
          })
        );
        return abortReturn;
      }
      yield new Promise((resolve) => setTimeout(resolve, 1e3));
      return yield dispatch(
        saveReportsChanges(
          onRefresh,
          postRequest2,
          organizationId,
          currentLocationId,
          licenseId,
          errorCodesDispatcher,
          extraHeaders,
          retries - 1
        )
      );
    } else {
      dispatch(setIsLoadingModal({ active: false, isMakingApiCall: false }));
      dispatch(setIsReportSaving(false));
      return abortReturn;
    }
  }
});
var getLocationsToApplyReportsChanges = (locationId) => (_, getState) => {
  const state = getState();
  const { selectedMode } = selectReports(state);
  const accessLocations = [locationId];
  const isMasterMode = selectedMode.type === "master" /* MASTER */;
  const locationSetId = new Set(accessLocations);
  const locationList = selectLocationListIds(state);
  return [
    ...!isMasterMode ? [0] : [],
    ...locationList.filter(
      (id) => locationSetId.has(id) && accessLocations.includes(id) && id !== selectedMode.id
    )
  ];
};
var checkReportsForChangesAndNavigate = (onContinue, onRefresh, postRequest2, organizationId, currentLocationId, licenseId, errorCodesDispatcher, extraHeaders, onContinueResetChangeData = true, isSavePressed = false, isQuickReportSave = false) => (dispatch, getState) => __async(void 0, null, function* () {
  var _a, _b;
  const state = getState();
  let changeData = (_a = selectReports(state)) == null ? void 0 : _a.changeData;
  if (!changeData.data || changeData.isQuickReport && !isQuickReportSave) {
    onContinue();
    return;
  }
  if (isQuickReportSave) {
    dispatch(reduceQuickReportChangeData());
    changeData = (_b = selectReports(state)) == null ? void 0 : _b.changeData;
  }
  if (!changeData.bucket) {
    return;
  }
  const isValid = yield dispatch(
    validateReportForm(changeData.bucket, changeData.data, true, onContinue)
  );
  if (!isValid)
    return;
  const showLocationSelectionModal = selectShouldRenderLocationDropdown(state);
  const handleSave = () => {
    dispatch(
      saveReportsChanges(
        onRefresh,
        postRequest2,
        organizationId,
        currentLocationId,
        licenseId,
        errorCodesDispatcher,
        extraHeaders,
        2
      )
    ).then(({ success }) => {
      if (success) {
        if (onContinueResetChangeData)
          dispatch(resetReportsChangeData());
        onContinue();
      }
    });
  };
  if (changeData.bucket && changeData.hasChanges) {
    const differences = diff(
      changeData.originalData,
      changeData.data
    );
    dispatch(setReportsDiffObject(differences));
    const onSuccess = () => {
      if (showLocationSelectionModal) {
        dispatch(
          setShowConfirmationModal({
            title: "",
            type: "locationReportsSelection" /* locationReportsSelection */,
            active: true,
            onSuccess: handleSave
          })
        );
      } else {
        handleSave();
      }
    };
    dispatch(
      setShowConfirmationModal({
        title: i18n_config_default.t("app.modals.diffModal.reviewChanges"),
        type: "reportsDiff" /* reportsDiff */,
        btnCancelText: isSavePressed ? "" : i18n_config_default.t("app.modals.discardChangesConfirmation.title"),
        btnSuccessText: showLocationSelectionModal ? "" : i18n_config_default.t("commonButtons.save"),
        description: showLocationSelectionModal ? `${i18n_config_default.t("app.modals.diffModal.youHaveUnsavedChanges", {
          bucket: i18n_config_default.t(
            `menuScreen.common.reports.${changeData.bucket}.singular`
          )
        })} ${i18n_config_default.t("app.modals.diffModal.descripTionForContinue")}` : `${i18n_config_default.t("app.modals.diffModal.youHaveUnsavedChanges", {
          bucket: i18n_config_default.t(
            `menuScreen.common.reports.${changeData.bucket}.singular`
          )
        })} ${i18n_config_default.t("app.modals.diffModal.descriptionForSave")}`,
        active: true,
        onSuccess,
        onCancel: () => {
          if (isSavePressed)
            return;
          if (onContinueResetChangeData) {
            dispatch(resetReportsChangeData());
          }
          onContinue();
        }
      })
    );
  } else {
    if (onContinueResetChangeData)
      dispatch(resetReportsChangeData());
    onContinue();
  }
});
var saveReportsChangesOnSavePress = (onRefresh, postRequest2, organizationId, currentLocationId, licenseId, errorCodesDispatcher, extraHeaders, isQuickReportSave = false) => (dispatch) => {
  dispatch(
    checkReportsForChangesAndNavigate(
      () => null,
      onRefresh,
      postRequest2,
      organizationId,
      currentLocationId,
      licenseId,
      errorCodesDispatcher,
      extraHeaders,
      true,
      true,
      isQuickReportSave
    )
  );
};
var cancelReportsChangesOnPress = (onNavigate) => (dispatch, getState) => {
  const state = getState();
  const { changeData } = selectReports(state);
  const onSuccess = () => {
    if (changeData.mode === "create" /* CREATE */) {
      dispatch(resetReportsChangeData());
      changeData.bucket && onNavigate(changeData.bucket);
      return;
    }
    dispatch(resetReportsChangeData());
  };
  dispatch(
    setShowConfirmationModal({
      title: i18n_config_default.t("app.modals.discardChangesConfirmation.title"),
      description: i18n_config_default.t(
        "app.modals.discardChangesConfirmation.description"
      ),
      active: true,
      type: "warning",
      btnCancelText: i18n_config_default.t("commonTexts.no"),
      btnSuccessText: i18n_config_default.t("commonTexts.yes"),
      onSuccess
    })
  );
};
var deleteReport = (id, bucket, organizationId, currentLocationId, licenseId, errorCodesDispatcher, extraHeaders) => (dispatch, getState) => __async(void 0, null, function* () {
  var _a, _b;
  const state = getState();
  const { versions, selectedMode } = selectReports(state);
  const report = (_b = (_a = selectedMode.currentReports) == null ? void 0 : _a[bucket]) == null ? void 0 : _b[id];
  if (!report)
    return;
  const url = apiConfig_default.reports.getLocationReports(
    organizationId,
    currentLocationId
  );
  dispatch(
    setIsLoadingModal({
      active: true,
      isMakingApiCall: true
    })
  );
  const request = {
    id,
    selectedReport: reportBucketToEndpointType(bucket),
    locationId: selectedMode.id,
    diffLocationIds: [0, currentLocationId],
    diff: { filters: [], scheduling: [] },
    data: report,
    reportsVersion: versions[selectedMode.type]
  };
  try {
    const response = yield apiCall(
      "delete" /* Delete */,
      url,
      true,
      request,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders
    );
    dispatch(initializeReportsState(response.reports));
    dispatch(refreshCurrentReports());
    dispatch(
      showToast({
        title: i18n_config_default.t("commonTexts.success"),
        type: "success"
      })
    );
    dispatch(setIsLoadingModal({ active: false, isMakingApiCall: false }));
    return Promise.resolve(response);
  } catch (e) {
    console.error(e);
    dispatch(setIsLoadingModal({ active: false, isMakingApiCall: false }));
    return Promise.reject(e);
  }
});
var reportNameFromBucket = {
  customReports: "custom",
  itemComboSalesReports: "itemsByCategory",
  salesOverviewReports: "sales",
  endOfShiftReports: "endOfShift",
  creditCardBatchReports: "creditCardBatch",
  employeeSalesAndTipsReports: "employeeSalesAndTips",
  voidReasonsReports: "voidReasons",
  inventoryOnHandReports: "inventoryOnHand",
  creditBalancesReports: "creditBalances"
};
var fetchReport = (onReport, orgUserId, organizationId, currentLocationId, licenseId, errorCodesDispatcher, responseType = "blob", reportData = null, reportBucket = null) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const { bucket: changeDataBucket, data: changeDataReport } = selectReports(
    state
  ).changeData;
  const report = reportData || changeDataReport;
  const bucket = reportBucket || changeDataBucket;
  if (!report || !bucket) {
    return false;
  }
  dispatch(setIsReportPDFLodaing(true));
  dispatch(setCurrentReportURL(null));
  const reportName = reportNameFromBucket[bucket];
  const url = apiConfig_default.reports.getReport(
    organizationId,
    currentLocationId,
    reportName
  );
  try {
    const response = yield apiCall(
      "post" /* Post */,
      url,
      true,
      report,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      {
        Accept: "application/pdf",
        "Org-UserId": orgUserId
      },
      () => true,
      void 0,
      responseType
    );
    if (response.data.size === 0) {
      console.error("The response is empty");
      dispatch(
        showToast({
          title: i18n_config_default.t("commonTexts.error"),
          // message: i18n.t('commonTexts.failedToFetchReport'),
          type: "error"
        })
      );
      return false;
    }
    const fileURL = yield onReport(response.data);
    dispatch(setIsReportPDFLodaing(false));
    dispatch(setCurrentReportURL(fileURL));
    return true;
  } catch (error) {
    console.error(error);
    dispatch(setIsReportPDFLodaing(false));
    dispatch(
      showToast({
        title: i18n_config_default.t("commonTexts.error"),
        // message: i18n.t('commonTexts.failedToFetchReport'),
        type: "error"
      })
    );
    return false;
  }
});
var resetReportsFieldErrors = (field) => (dispatch, getState) => {
  const state = getState();
  const errors = selectReports(state).changeData.errors;
  if (!errors || !errors[field])
    return;
  const newErrors = __spreadValues({}, errors);
  delete newErrors[field];
  dispatch(setReportsErrors(newErrors));
};
var changeSelectedReportsMode = (locationId, locationName) => (dispatch, getState) => {
  const getSettingsType = (id) => {
    switch (id) {
      case 0:
        return "master" /* MASTER */;
      default:
        return "location" /* LOCATION */;
    }
  };
  const settingsType = getSettingsType(locationId);
  const { location, master } = getState().reports;
  switch (settingsType) {
    case "master" /* MASTER */:
      dispatch(
        setReportsSelectedMode({
          type: "master" /* MASTER */,
          currentReports: master,
          id: 0,
          name: "Enterprise"
        })
      );
      dispatch(resetReportsChangeData());
      break;
    default:
      dispatch(
        setReportsSelectedMode({
          type: "location" /* LOCATION */,
          currentReports: location,
          id: locationId,
          name: locationName
        })
      );
      dispatch(resetReportsChangeData());
      break;
  }
};
var getReportBucketInitialData = (bucket, isQuickReport, endOfBusinessDay, businessTimeZone) => {
  let report = null;
  switch (bucket) {
    case "customReports":
      report = getCustomReportsInitialState();
      break;
    case "itemComboSalesReports":
      report = getItemComboSalesReportInitialState();
      break;
    case "salesOverviewReports":
      report = getSalesOverviewReportInitialState();
      break;
    case "endOfShiftReports":
      report = getEndOfShiftReportInitialState();
      break;
    case "creditCardBatchReports":
      report = getCreditCardBatchReportInitialState();
      break;
    case "employeeSalesAndTipsReports":
      report = getEmployeeSalesAndTipsReportInitialState();
      break;
    case "voidReasonsReports":
      report = getVoidReasonsReportInitialState();
      break;
    case "inventoryOnHandReports":
      report = getInventoryOnHandReportInitialState();
      break;
    case "creditBalancesReports":
      report = getCreditBalancesReportInitialState();
      break;
    default:
      return report;
  }
  const period = isQuickReport ? "specific_date" /* SPECIFIC_DATE */ : bucket === "customReports" ? "yesterday" /* YESTERDAY */ : "custom" /* CUSTOM */;
  report = __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, report), {
    period
  }), getReportDateTimesForPeriod(period, endOfBusinessDay, businessTimeZone)), {
    name: isQuickReport ? "Quick Report" : ""
  });
  return report;
};
var loadReportBucketChangeData = ({ id = 0, bucket, isQuickReport }) => (dispatch, getState) => {
  const state = getState();
  const mode = id ? "update" /* UPDATE */ : "create" /* CREATE */;
  const isCreation = mode === "create" /* CREATE */;
  let report = null;
  if (!isCreation)
    switch (bucket) {
      case "customReports":
        report = selectCustomReportById(state, id);
        break;
      case "itemComboSalesReports":
        report = selectItemComboSalesReportById(state, id);
        break;
      case "salesOverviewReports":
        report = selectSalesOverviewReportById(state, id);
        break;
      case "endOfShiftReports":
        report = selectEndOfShiftReportById(state, id);
        break;
      case "creditCardBatchReports":
        report = selectCreditCardBatchReportById(state, id);
        break;
      case "employeeSalesAndTipsReports":
        report = selectEmployeeSalesAndTipsReportById(state, id);
        break;
      case "voidReasonsReports":
        report = selectVoidReasonsReportById(state, id);
        break;
      case "inventoryOnHandReports":
        report = selectInventoryOnHandReportById(state, id);
        break;
      case "creditBalancesReports":
        report = selectCreditBalancesReportById(state, id);
        break;
      default:
        return;
    }
  const endOfBusinessDay = selectGeneralSettings(state).endOfBusinessDay;
  const businessTimeZone = selectCurrentTimeZone(state);
  if (isCreation || isQuickReport)
    report = getReportBucketInitialData(
      bucket,
      isQuickReport,
      endOfBusinessDay,
      businessTimeZone
    );
  if (!report)
    return;
  dispatch(
    setReportsChangeData(__spreadProps(__spreadValues({}, getReportsChangeDataInitialState()), {
      id,
      bucket,
      mode,
      data: cloneDeep16(report),
      originalData: cloneDeep16(report),
      isQuickReport,
      hasChanges: isQuickReport
    }))
  );
};
var handleReportsChange = (v) => (dispatch, getState) => {
  const state = getState();
  const oldData = state.reports.changeData.data;
  if (!oldData) {
    return;
  }
  const newValue = typeof v === "function" ? v(oldData) : v;
  dispatch(setReportsChangeDataValues(newValue));
};
var printEndOfShiftReport = (report, printerId, orgUserId, organizationId, currentLocationId, licenseId, errorCodesDispatcher) => (dispatch) => __async(void 0, null, function* () {
  return dispatch(
    printReport(
      report,
      "endOfShift",
      printerId,
      orgUserId,
      organizationId,
      currentLocationId,
      licenseId,
      errorCodesDispatcher
    )
  );
});
var printInventoryOnHandReport = (report, printerId, orgUserId, organizationId, currentLocationId, licenseId, errorCodesDispatcher) => (dispatch) => __async(void 0, null, function* () {
  return dispatch(
    printReport(
      report,
      "inventoryOnHand",
      printerId,
      orgUserId,
      organizationId,
      currentLocationId,
      licenseId,
      errorCodesDispatcher
    )
  );
});
var printReport = (report, reportBucket, printerId, orgUserId, organizationId, currentLocationId, licenseId, errorCodesDispatcher) => (dispatch, getState) => __async(void 0, null, function* () {
  var _a;
  if (!report)
    return;
  const url = apiConfig_default.reports.printReport(
    organizationId,
    currentLocationId,
    reportBucket
  );
  const data = __spreadProps(__spreadValues({
    printerId
  }, report), {
    id: void 0
  });
  delete data.id;
  try {
    yield apiCall(
      "post" /* Post */,
      url,
      true,
      data,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      getState(),
      {
        "Org-UserId": orgUserId
      },
      () => true,
      void 0
    );
    dispatch(
      showToast({
        title: i18n_config_default.t("commonTexts.success"),
        description: "Printed successfully",
        type: "success"
      })
    );
  } catch (error) {
    console.error((_a = error == null ? void 0 : error.toJSON) == null ? void 0 : _a.call(error));
    dispatch(
      showToast({
        title: i18n_config_default.t("commonTexts.error"),
        // message: i18n.t('commonTexts.failedToFetchReport'),
        type: "error"
      })
    );
  }
});
var emailReport = (orgUserIds, bucket, report, orgUserId, organizationId, currentLocationId, licenseId, errorCodesDispatcher) => (dispatch, getState) => __async(void 0, null, function* () {
  var _a;
  const state = getState();
  const url = apiConfig_default.reports.emailReport(
    organizationId,
    currentLocationId,
    reportNameFromBucket[bucket]
  );
  const data = {
    filters: __spreadProps(__spreadValues({}, report), { id: void 0 }),
    orgUserIds
  };
  delete data.filters.id;
  try {
    yield apiCall(
      "post" /* Post */,
      url,
      true,
      data,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      {
        "Org-UserId": orgUserId
      },
      () => true,
      void 0
    );
    dispatch(
      showToast({
        title: i18n_config_default.t("commonTexts.success"),
        description: "Email sent successfully",
        type: "success"
      })
    );
    return Promise.resolve();
  } catch (error) {
    console.error((_a = error == null ? void 0 : error.toJSON) == null ? void 0 : _a.call(error));
    dispatch(
      showToast({
        title: i18n_config_default.t("commonTexts.error"),
        // message: i18n.t('commonTexts.failedToFetchReport'),
        type: "error"
      })
    );
    return Promise.reject();
  }
});
var reduceQuickReportChangeData = () => (dispatch, getState) => {
  const state = getState();
  const previousChangeData = selectReports(state).changeData;
  const previousQuickReportData = previousChangeData == null ? void 0 : previousChangeData.data;
  const bucket = previousChangeData == null ? void 0 : previousChangeData.bucket;
  if (!previousQuickReportData || !bucket)
    return;
  const endOfBusinessDay = selectGeneralSettings(state).endOfBusinessDay;
  const businessTimeZone = selectCurrentTimeZone(state);
  const initialData = getReportBucketInitialData(
    bucket,
    true,
    endOfBusinessDay,
    businessTimeZone
  );
  const mappedQuickReportData = (
    // maps the fields that exist on the initial data to the quick report data
    Object.keys(initialData).reduce((acc, key) => {
      acc[key] = previousQuickReportData[key];
      return acc;
    }, {})
  );
  dispatch(handleReportsChange(mappedQuickReportData));
};
var getClearedNavigationObject = (isCurrentTicketElementCurrentMenuType, isCustomizerSubcategory, isOpenItem, menuOptions, clearComboData, hasAllSubcategory, clearQuantity) => {
  const navUpdate = {
    itemId: null,
    ticketElementId: null,
    skipInventoryCheck: false,
    isSeatSelectionActive: false,
    modifyingSentTicketElementId: null,
    modifierGroupId: null,
    prevModGroupTypeModGroupId: null,
    isAllModsEnabled: false,
    nestedModifierGroupId: null,
    modifierItemInstanceId: null
  };
  if (clearQuantity) {
    if (clearQuantity.quantity)
      navUpdate.quantity = null;
    if (clearQuantity.customQuantityInput)
      navUpdate.customQuantityInput = null;
  }
  if (clearComboData) {
    navUpdate.comboElementId = null;
    navUpdate.comboId = null;
  }
  if (isCustomizerSubcategory) {
    navUpdate.subcategoryId = hasAllSubcategory ? 0 : null;
  } else if (isOpenItem) {
    navUpdate.categoryId = null;
  }
  if (!isCurrentTicketElementCurrentMenuType || isOpenItem || menuOptions.isMenuTypeSimpleMode || menuOptions.isDefaultToHomeScreen) {
    navUpdate.subcategoryId = null;
    navUpdate.categoryId = null;
  }
  return navUpdate;
};
var navigateToOrderCore = (orderId, checkAndUpdateRecentOrders) => (dispatch, getState) => __async(void 0, null, function* () {
  var _a, _b;
  const state = getState();
  const tables = state.tableLayout.savedData.tables;
  const isCoursingEnabled = selectIsCoursingEnabled(state);
  try {
    const nextOrder = yield dispatch(getCurrentOrderInData(orderId));
    const menuTypeId = dispatch(getMenuTypeFromOrder(nextOrder));
    const currentTableNumber = (_b = (_a = tables[nextOrder.tableId]) == null ? void 0 : _a.tableNumber) != null ? _b : "";
    let seats = {};
    const isSeatingEnabled = selectIsSeatingModeEnabled(state);
    if (isSeatingEnabled) {
      const seatingMode = selectSeatingMode(state);
      if (seatingMode === "no_prompt" /* NO_PROMPT */ && nextOrder.tableId && nextOrder.tableId in tables && typeof nextOrder.numberOfSeatsOccupied === "number" && nextOrder.numberOfSeatsOccupied > 0) {
        seats = { 1: true };
      }
    }
    if (!isEqual(
      state.register.paymentNavigation,
      PAYMENT_NAVIGATION_INITIAL_STATE
    ))
      dispatch(
        updatePaymentNavigation(__spreadValues({}, PAYMENT_NAVIGATION_INITIAL_STATE))
      );
    dispatch(
      updateRegisterNavigationField({
        menuTypeId,
        orderId,
        quantity: null,
        itemId: null,
        ticketElementId: null,
        skipInventoryCheck: false,
        isSeatSelectionActive: false,
        comboId: null,
        comboElementId: null,
        courseNumber: null,
        modifyingSentTicketElementId: null,
        modifierGroupId: null,
        prevModGroupTypeModGroupId: null,
        isAllModsEnabled: false,
        categoryId: null,
        subcategoryId: null,
        activeItems: [],
        currentSeat: ALL_SEATS,
        seats,
        isPreviewMode: false,
        tableId: nextOrder.tableId,
        detailsOverlay: false,
        ticketMultiselectMode: null
      })
    );
    if (isCoursingEnabled)
      dispatch(checkForCoursesUpdate(nextOrder));
    if (checkAndUpdateRecentOrders) {
      if (isOrderClosedOrPaid(nextOrder.status))
        dispatch(
          actions_exports7.removeRecentOrderClosed({
            orderId
          })
        );
      else
        dispatch(
          updateUserRecentOrdersStation({
            orderId,
            orderNumber: nextOrder.orderNumber,
            tableNumber: currentTableNumber
          })
        );
    }
    return Promise.resolve();
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
});
var openOrderDetailsOverlayCore = (payload) => (dispatch) => {
  dispatch(
    updateRegisterNavigationField(__spreadProps(__spreadValues({}, payload), {
      detailsOverlay: true,
      activeItems: [],
      ticketMultiselectMode: null
    }))
  );
};
var changeRegisterNavigationCategory = (newCategoryId, isFirstRender) => (dispatch, getState) => {
  var _a;
  const state = getState();
  const isPreview = state.register.registerNavigation.isPreviewMode;
  const currentCategoryId = state.register.registerNavigation.categoryId;
  const currentMenuTypeId = state.register.registerNavigation.menuTypeId;
  const currentMenuType = state.menu.locationMenu.menuTypes[Number(currentMenuTypeId)];
  let subcategoryId = null;
  const currentMenuTypeHasHomeScreenItemsAndCombos = (currentMenuType == null ? void 0 : currentMenuType.homeScreenElements.length) > 0;
  if ((currentCategoryId === newCategoryId || isFirstRender) && (currentMenuTypeHasHomeScreenItemsAndCombos || isPreview)) {
    dispatch(
      updateRegisterNavigationField({
        categoryId: null,
        subcategoryId: null,
        itemId: null,
        comboElementId: null,
        comboId: null,
        ticketElementId: null,
        skipInventoryCheck: false,
        isSeatSelectionActive: false,
        modifyingSentTicketElementId: null,
        modifierGroupId: null,
        prevModGroupTypeModGroupId: null,
        isAllModsEnabled: false,
        modifierTag: null,
        quantity: null
      })
    );
    return;
  }
  const category = state.menu.locationMenu.categories[newCategoryId];
  const hasAllSubcategory = getHasAllSubcategory(
    category.subcategoryMenuTypeItemsIds,
    category.subcategoryMenuTypeCombosIds,
    currentMenuTypeId || 0
  );
  if (!hasAllSubcategory && getCategoryChildrenType(
    category.subcategoryMenuTypeItemsIds,
    category.subcategoryMenuTypeCombosIds
  ) === "subcategory" /* SUBCATEGORY */) {
    const subcategoriesIds = state.menu.locationMenu.categories[newCategoryId].subcategoryIds;
    const menuTypeItemIds = selectMenuTypeItemsSet(state);
    const menuTypeComboIds = selectMenuTypeCombosSet(state);
    const activeSubcategories = filterSubcategoriesWithItemAndComboIdSet(
      mapSubcategoryFromBucket(
        subcategoriesIds,
        state.menu.locationMenu.subcategories
      ),
      menuTypeItemIds,
      menuTypeComboIds,
      state.menu.locationMenu.items,
      state.menu.locationMenu.combos,
      state.register.registerNavigation.menuTypeId,
      currentCategoryId,
      state.menu.locationMenu.categories
    );
    const subcategory = activeSubcategories.filter(
      (_subcategory) => !_subcategory.customizer && _subcategory.subcategoryId
    )[0];
    subcategoryId = (_a = subcategory == null ? void 0 : subcategory.subcategoryId) != null ? _a : null;
  }
  const _activeItems = [...state.register.registerNavigation.activeItems];
  const filteredActiveItems = _activeItems.filter(
    (ticketElementId) => ticketElementId !== state.register.registerNavigation.ticketElementId
  );
  if (hasAllSubcategory) {
    subcategoryId = 0;
  }
  dispatch(
    updateRegisterNavigationField({
      categoryId: newCategoryId,
      subcategoryId,
      itemId: null,
      comboElementId: null,
      comboId: null,
      ticketElementId: null,
      skipInventoryCheck: false,
      isSeatSelectionActive: false,
      modifyingSentTicketElementId: null,
      modifierGroupId: null,
      prevModGroupTypeModGroupId: null,
      isAllModsEnabled: false,
      activeItems: [...filteredActiveItems],
      modifierTag: null,
      quantity: null
    })
  );
};
var closeOrderDetailsOverlay = () => (dispatch, getState) => {
  const state = getState();
  const registerNavigation = state.register.registerNavigation;
  const { menuTypeId: currentMenuTypeId } = registerNavigation;
  let selectedCategoryId = null;
  const buckets = Object.values(state.menu.previewElements);
  const noHomeItems = buckets.every(
    (bucket) => Object.keys(bucket).length === 0
  );
  const currentMenuType = state.menu.selectedMode.currentMenu.menuTypes[currentMenuTypeId || -1];
  if (currentMenuType && noHomeItems && !currentMenuType.categoryIds.includes(registerNavigation.categoryId || -1)) {
    const menuTypeSubcategoriesSorted = currentMenuType.categoryIds.map(
      (categoryId) => state.menu.selectedMode.currentMenu.categories[categoryId]
    ).sort((a, b) => a.sortPriority - b.sortPriority).filter((category) => category.active);
    selectedCategoryId = menuTypeSubcategoriesSorted[0].id;
    dispatch(changeRegisterNavigationCategory(selectedCategoryId));
  }
  dispatch(
    updateRegisterNavigationField({
      detailsOverlay: false,
      ticketMultiselectMode: null
    })
  );
};
var setIsPaymentModeActiveCoreThunk = (open = true, navProps) => (dispatch, getState) => {
  const state = getState();
  const printedChecksCount = selectCurrentOrderCheckCount(state);
  const orderId = selectCurrentOrderId(state);
  if (!orderId)
    return;
  const isPopOverActive = state.app.popover.isActive;
  if (isPopOverActive)
    dispatch(
      updatePopover({
        isActive: false,
        data: null,
        popoverId: "NONE" /* NONE */
      })
    );
  const navigation = {
    comboElementId: null,
    comboId: null,
    ticketElementId: null,
    itemId: null,
    modifierGroupId: null,
    activeItems: [],
    ticketMultiselectMode: null,
    detailsOverlay: false,
    isAllModsEnabled: false,
    nestedModifierGroupId: null,
    isSeatSelectionActive: false
  };
  dispatch(
    updateRegisterNavigationFieldWithCheck(
      state.register.registerNavigation,
      navigation
    )
  );
  dispatch(
    updatePaymentNavigation(__spreadValues({
      isPaymentModeActive: open,
      screen: printedChecksCount > 1 ? "CHECK_EDITOR" /* CHECK_EDITOR */ : "PAYMENT" /* PAYMENT */,
      option: "PAY" /* PAY */,
      method: "CREDIT_DEBIT" /* CREDIT_CARD */
    }, navProps))
  );
  dispatch(enterPaymentMode(null));
  if (open) {
    if (orderId in state.register.orders) {
      dispatch(rollUpOrderCheckElements(orderId));
    } else if (orderId in state.register.orderSearchResults.orders) {
      dispatch(rollUpOrderSearchCheckElements(orderId));
    }
  }
};
var updateRegisterNavigationFieldWithCheck = (registerNavigation, navigation) => (dispatch) => {
  const keysToCheck = Object.keys(navigation);
  const originalData = Object.fromEntries(
    Object.entries(registerNavigation).filter(
      ([key]) => keysToCheck.includes(key)
    )
  );
  if (!isEqual(originalData, navigation))
    dispatch(updateRegisterNavigationField(navigation));
};
var updateRegisterNavigationFieldWithCheckAndState = (navigation) => (dispatch, getState) => {
  const state = getState();
  dispatch(
    updateRegisterNavigationFieldWithCheck(
      state.register.registerNavigation,
      navigation
    )
  );
};
var closeMultiselectMode = () => (dispatch) => dispatch(
  updateRegisterNavigationField({
    activeItems: [],
    ticketMultiselectMode: null,
    detailsOverlay: false
  })
);
var clearModifierTag = (toggleAction, modifierTag) => (dispatch) => {
  toggleAction();
  if (modifierTag !== null)
    dispatch(
      updateRegisterNavigationField({
        modifierTag: null
      })
    );
};
var getAndResetGlobalQuantity = (resetTo = void 0) => (dispatch, getState) => {
  const state = getState();
  const { quantity, ticketElementId, comboElementId, modifierTag } = state.register.registerNavigation;
  const newQuantity = isUndefined(resetTo) ? ticketElementId || comboElementId ? null : 1 : resetTo;
  if (newQuantity === quantity && modifierTag === null)
    return quantity;
  dispatch(
    updateRegisterNavigationField({
      quantity: newQuantity,
      modifierTag: null
    })
  );
  return quantity;
};
var checkPaymentScreenAndNavigate = (screen) => (dispatch, getState) => {
  const state = getState();
  const currentPaymentScreen = state.register.paymentNavigation.screen;
  if (currentPaymentScreen !== screen) {
    dispatch(updatePaymentNavigation({ screen }));
  }
};

// src/state/register/orders/thunks/modifierItemsAndIngredients.ts
var getMaxSortPriorityInAllMods = () => (_, getState) => {
  const state = getState();
  return selectMaxSortPriorityInAllModsSelected(state);
};
var getMaxSortPriorityByModifierGroupId = (modifierGroupId) => (_, getState) => {
  const state = getState();
  const ticketElement = selectCurrentTicketElement(state);
  if (!ticketElement)
    return 0;
  return Object.values(
    ticketElement.modifierGroupsSelected[modifierGroupId].modifierItemsSelected
  ).reduce((maxSortPriority, modifierItemSelected) => {
    return modifierItemSelected.sortPriority > maxSortPriority ? modifierItemSelected.sortPriority : maxSortPriority;
  }, 0);
};
var toggleModifierItemSelectedThunk = (modifierGroupId, modifierItemId, globalData, onSuccess) => (dispatch, getState) => {
  let state = getState();
  const { modifierItems: menuModifierItems, items } = state.menu.locationMenu;
  const { registerNavigation, customizer } = state.register;
  const {
    orderId,
    ticketElementId: currentTicketElementId,
    modifierTag,
    currentSeat
  } = registerNavigation;
  const quantity = dispatch(getAndResetGlobalQuantity());
  const ticketElementId = globalData.ticketElementId || currentTicketElementId;
  if (orderId === null || !ticketElementId)
    return;
  let ticket = selectCurrentTicket(state);
  let ticketElement = ticket[ticketElementId];
  dispatch(
    validateTicketElementIsEnabled(ticketElementId, orderId, () => {
      var _a, _b, _c, _d, _e;
      ticket = selectCurrentTicket(state);
      ticketElement = ticket[ticketElementId];
      if (!ticketElement)
        return;
      const existOnAllModsObject = !!((_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[isOpenItemFn(ticketElement) ? 0 : ticketElement.menuTypeId].modifierGroups[modifierGroupId].modifierItems[modifierItemId]);
      if (!existOnAllModsObject) {
        const selectedMI = menuModifierItems[modifierItemId];
        if (ticketElement.itemObj) {
          const maxSortPriority = modifierGroupId === ALL_MODS_ID ? dispatch(getMaxSortPriorityInAllMods()) : 0;
          let newModifierItemInAllMods = null;
          if (modifierGroupId === ALL_MODS_ID) {
            newModifierItemInAllMods = modifierItemToTicketModifierItem(
              selectedMI,
              modifierGroupId,
              globalData.isGlobalModifierItem,
              state.menu.locationMenu.modifierGroups,
              state.menu.locationMenu.modifierItems,
              modifierGroupId === ALL_MODS_ID ? maxSortPriority + 1 : (_d = (_c = (_b = state.menu.locationMenu.modifierGroups[modifierGroupId]) == null ? void 0 : _b.modifierItems[modifierItemId]) == null ? void 0 : _c.sortPriority) != null ? _d : maxSortPriority + 1
            );
          } else {
            const baseMenuTypeVersion = items[ticketElement.itemId].menuTypeVersions[ticketElement.menuTypeId];
            const premadeMenuTypeVersionWithModifierGroups = preMakeMenuTypeVersionWithModifierGroups(
              ticketElement.itemId,
              __spreadProps(__spreadValues({}, baseMenuTypeVersion), {
                modifierGroups: {
                  [modifierGroupId]: __spreadProps(__spreadValues({}, baseMenuTypeVersion.modifierGroups[modifierGroupId]), {
                    modifierItems: {
                      [modifierItemId]: baseMenuTypeVersion.modifierGroups[modifierGroupId].modifierItems[modifierItemId]
                    }
                  })
                }
              }),
              state.menu,
              true
            );
            const newModifierItems = modifierItemToTicketElementModifierItemCore(
              premadeMenuTypeVersionWithModifierGroups.modifierGroups[modifierGroupId].modifierItems,
              false,
              state.menu.locationMenu.modifierGroups,
              state.menu.locationMenu.modifierItems,
              false,
              1,
              state.menu.locationMenu.modifierGroups[modifierGroupId]
            );
            newModifierItemInAllMods = cloneDeep(
              newModifierItems[modifierItemId]
            );
          }
          if (newModifierItemInAllMods)
            dispatch(
              addModifierItemToModifierGroupItemObj({
                orderId,
                ticketElementId,
                modifierGroupId,
                modifierItemId,
                modifierItemObj: newModifierItemInAllMods
              })
            );
        }
        state = getState();
        ticket = selectCurrentTicket(state);
        ticketElement = ticket[ticketElementId];
      }
      if (!ticketElement)
        return;
      const menuType = (_e = ticketElement.itemObj) == null ? void 0 : _e.menuTypeVersions[isOpenItemFn(ticketElement) ? 0 : ticketElement.menuTypeId];
      if (!menuType)
        return;
      const modifierGroup = menuType.modifierGroups[modifierGroupId];
      if (!modifierGroup)
        return;
      const modTags = selectLocationModifierTags(state);
      const modifierTagObject = modifierTag !== null && modTags[modifierTag] ? getSelectedModifierTag(modTags[modifierTag]) : null;
      if (!(ticketElement == null ? void 0 : ticketElement.itemObj))
        return;
      let operation = "NONE" /* NONE */;
      const modifierGroupSelected = ticketElement.modifierGroupsSelected[modifierGroupId];
      if (modifierGroupSelected) {
        const defaultModifiersSelected = getDefaultModifiersSelectedFromItem(ticketElement);
        const modifierItemSelected = modifierGroupSelected.modifierItemsSelected[modifierItemId];
        operation = getOperationByModifierTagAndModifierItem(
          modifierItemSelected,
          modifierTagObject,
          modifierGroup.quantityMode,
          quantity,
          modifierGroupSelected.customizerEnabled && ticketElement.customizerType !== "none" /* NONE */,
          customizer,
          defaultModifiersSelected[modifierGroupId]
        );
      } else {
        operation = getOperationByModifierTagOnly(
          modifierTagObject,
          quantity
        );
      }
      try {
        validateMaximumModifierGroupItemsQuantity(
          modifierGroup,
          ticketElement,
          modifierItemId,
          simplifyModifierOperationToQuantityEffect(operation),
          quantity
        );
        const isAllModRelated = modifierGroupSelected.global || modifierGroupId === ALL_MODS_ID;
        let maxSortPriority = void 0;
        if (isAllModRelated)
          maxSortPriority = dispatch(getMaxSortPriorityInAllMods()) + 1;
        else
          maxSortPriority = dispatch(getMaxSortPriorityByModifierGroupId(modifierGroupId)) + 1;
        validateSeatingMode(
          getState,
          (seatSplitRequired = false) => dispatch(
            clearModifierTag(() => {
              dispatch(
                toggleModifierItemSelected(
                  orderId,
                  ticketElementId,
                  modifierGroupId,
                  modifierItemId,
                  customizer,
                  modifierTagObject,
                  {
                    seatSplitRequired,
                    currentSeat,
                    isSeatingModeEnabled: selectIsCurrentOrderSeatingMode.lastResult()
                  },
                  quantity,
                  state,
                  operation,
                  maxSortPriority
                )
              );
              onSuccess && onSuccess();
            }, modifierTag)
          )
        );
      } catch (error) {
        dispatch(
          handleModifierGroupMaximumQuantityError(
            error.message,
            quantity,
            modifierGroup.maximumModifierItems
          )
        );
      }
    })
  );
};
var deleteModifierGroupItemSelected = (modifierGroupId, modifierItemId) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const { registerNavigation, customizer } = state.register;
    const currentOrderId = registerNavigation.orderId;
    const ticketElementId = registerNavigation.ticketElementId;
    const currentSeat = registerNavigation.currentSeat;
    validateSeatingMode(
      getState,
      (seatSplitRequired = false) => dispatch(
        deleteTicketModifierItemSelected(
          currentOrderId,
          ticketElementId,
          modifierGroupId,
          modifierItemId,
          customizer,
          {
            seatSplitRequired,
            currentSeat,
            isSeatingModeEnabled: selectIsCurrentOrderSeatingMode.lastResult()
          },
          state
        )
      )
    );
  });
};
var incrementModifierItemSelectedThunk = (modifierGroupId, modifierItemId) => (dispatch, getState) => {
  const state = getState();
  const { orderId, ticketElementId, currentSeat } = state.register.registerNavigation;
  const customizer = state.register.customizer;
  if (orderId === null || !ticketElementId)
    return;
  if (!dispatch(
    validateMaximumModifierItemQuantityCurrent(
      modifierItemId,
      "INCREMENT" /* INCREMENT */,
      1
    )
  ))
    return;
  let maxSortPriority = void 0;
  const ticketElement = selectCurrentTicketElement(state);
  if (ticketElement) {
    const modifierGroupSelected = ticketElement.modifierGroupsSelected[modifierGroupId];
    const isAllModRelated = modifierGroupSelected.global || modifierGroupId === ALL_MODS_ID;
    if (isAllModRelated)
      maxSortPriority = dispatch(getMaxSortPriorityInAllMods()) + 1;
    else
      maxSortPriority = dispatch(getMaxSortPriorityByModifierGroupId(modifierGroupId)) + 1;
  }
  validateSeatingMode(
    getState,
    (requireSplitItem = false) => dispatch(
      validateTicketElementIsEnabled(
        ticketElementId,
        orderId,
        () => dispatch(
          incrementModifierItemSelected(
            orderId,
            ticketElementId,
            modifierGroupId,
            modifierItemId,
            customizer,
            requireSplitItem,
            currentSeat,
            selectIsCurrentOrderSeatingMode.lastResult(),
            state,
            maxSortPriority
          )
        )
      )
    )
  );
};
var resetModifierGroupToConfigWhenSentCore = (isIngredientsActive) => (dispatch, getState) => {
  const state = getState();
  const { orderId, modifierGroupId, ticketElementId } = state.register.registerNavigation;
  if (orderId === null || !ticketElementId || isNil(modifierGroupId))
    return;
  const isSeatingModeEnabled = selectIsCurrentOrderSeatingMode.lastResult();
  dispatch(
    resetModifierGroupSelectedToConfigWhenSent(
      orderId,
      ticketElementId,
      modifierGroupId,
      isSeatingModeEnabled,
      isIngredientsActive
    )
  );
};
var resetModifierGroupSelectedCoreThunk = (isIngredientsActive) => (dispatch, getState) => {
  const state = getState();
  const { orderId, modifierGroupId, currentSeat, ticketElementId } = state.register.registerNavigation;
  if (orderId === null || !ticketElementId || isNil(modifierGroupId))
    return;
  const isSeatingModeEnabled = selectIsCurrentOrderSeatingMode.lastResult();
  validateSeatingMode(
    getState,
    (seatSplitRequired = false) => dispatch(
      resetModifierGroupSelected(
        orderId,
        ticketElementId,
        modifierGroupId,
        currentSeat,
        seatSplitRequired,
        isSeatingModeEnabled,
        isIngredientsActive,
        state
      )
    )
  );
};
var addOpenModAndToggleItThunk = (name, price) => (dispatch, getState) => {
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  const ticketElement = selectCurrentTicketElement(state);
  if (!orderId || !ticketElement)
    return;
  if (!ticketElement.itemObj)
    return;
  const openMod = {
    locationModifierItemId: null,
    locationModifierItemVersionId: null,
    name,
    posName: name,
    checkName: name,
    kdsName: name,
    modifierGroups: {},
    spacesBefore: 0,
    linesBefore: 0,
    modifierItemPricingVersionId: 0,
    defaultModifierItemPricingVersionId: 0,
    modifierItemId: 0,
    locationId: null,
    includedMasterPrice: price,
    additionalMasterPrice: price,
    applyPiecePricing: false,
    quarterPricePercent: 0,
    halfPricePercent: 0,
    customIncludedQuantityPricing: false,
    includedLightPrice: price,
    includedRegularPrice: price,
    includedExtraPrice: price,
    customAdditionalQuantityPricing: false,
    additionalLightPrice: price,
    additionalRegularPrice: price,
    additionalExtraPrice: price,
    defaultQuantitySelected: 0,
    isSelected: false,
    active: true,
    locationModifierItemPricingVersionId: null,
    locationModifierGroupPricingVersionId: null,
    sortPriority: 0,
    defaultAmountSelected: "regular" /* REGULAR */,
    is86ed: false,
    locationMgpvLocationMipvVersionId: 0,
    override: {},
    id: 0,
    maximumQuantity: 0,
    inheritedActive: true
  };
  const showAllMods = selectCurrentItemShowAllModsEnabled(state);
  const newItemObj = produce(ticketElement.itemObj, (draft) => {
    const menuTypeVersion = draft.menuTypeVersions[isOpenItemFn(ticketElement) ? 0 : ticketElement.menuTypeId];
    if (!showAllMods) {
      if (!menuTypeVersion.modifierGroups[0]) {
        const allModsModifierGroup = {
          posName: "",
          checkName: "",
          kdsName: "",
          priceCalcMode: "max",
          quantityMode: "x1,x2,x3",
          modifierItems: {},
          allowNoneSelection: false,
          hidePriceIfFree: false,
          activeCustomizerSectionSelector: false,
          customizerSlicing: "quarters" /* QUARTERS */,
          locationModifierGroupId: 0,
          locationModifierGroupVersionId: 0,
          showSearchBar: false,
          searchAllModifierItems: false,
          showModGroupTitleOnRegisterTicket: false,
          backgroundColor: null,
          textColor: null,
          enableModTags: false,
          enableQuantityBar: false,
          modifierGroupMenuTypeItemId: 0,
          locationId: null,
          locationModifierGroupItemsId: 0,
          modifierGroupItemsId: 0,
          modifierGroupId: 0,
          multiselect: false,
          active: false,
          sortPriority: 0,
          requiredModifierItems: 0,
          includedModifierItems: 0,
          maximumModifierItems: 0,
          defaultModifierGroupPricingVersionId: null,
          locationModifierGroupMenuTypeItemVersionId: 0,
          defaultSelectionPrice: 0,
          override: {
            active: false,
            advancedModifier: false,
            defaultModifierGroupPricingVersionId: false,
            includedModifierItems: false,
            requiredModifierItems: false,
            maximumModifierItems: false
          },
          global: false,
          isAllMod: false,
          isPremadeHeader: false,
          id: 0,
          inheritedActive: false
        };
        menuTypeVersion.modifierGroups[0] = allModsModifierGroup;
      }
    }
    menuTypeVersion.modifierGroups[0].modifierItems[0] = openMod;
  });
  dispatch(
    setCurrentTicketElementItemObj({
      orderId,
      ticketElementId: getTicketElementId(ticketElement),
      itemObj: newItemObj
    })
  );
  if (!showAllMods && !ticketElement.modifierGroupsSelected[0]) {
    dispatch(
      updateTicketElementField(
        {
          modifierGroupsSelected: __spreadProps(__spreadValues({}, ticketElement.modifierGroupsSelected), {
            0: {
              locationModifierGroupId: 0,
              locationModifierGroupVersionId: 0,
              customizerEnabled: false,
              global: true,
              isComplete: true,
              isNoneSelected: false,
              modifierGroupId: 0,
              modifierItemsSelected: {},
              quantityMode: "x1,x2,x3",
              quantityRequired: 0,
              totalPricePerItemUnit: 0,
              taxInclusiveTotalPricePerItemUnit: 0,
              modifierItemsWithNested: [],
              showSearchBar: true
            }
          })
        },
        orderId,
        getTicketElementId(ticketElement),
        selectIsSeatingModeEnabled(state)
      )
    );
  }
  dispatch(
    toggleModifierItemSelectedThunk(0, 0, {
      isGlobalModifierItem: true,
      ticketElementId: void 0
    })
  );
};
var clearOpenModThunk = () => (dispatch, getState) => {
  const orderId = selectCurrentOrderId(getState());
  const ticketElement = selectCurrentTicketElement(getState());
  if (!orderId || !ticketElement)
    return;
  if (!ticketElement.itemObj)
    return;
  dispatch(deleteModifierGroupItemSelected(0, 0));
  const newItemObj = produce(ticketElement.itemObj, (draft) => {
    delete draft.menuTypeVersions[isOpenItemFn(ticketElement) ? 0 : ticketElement.menuTypeId].modifierGroups[0].modifierItems[0];
  });
  dispatch(
    setCurrentTicketElementItemObj({
      orderId,
      ticketElementId: getTicketElementId(ticketElement),
      itemObj: newItemObj
    })
  );
};
var handleModifierGroupMaximumQuantityError = (errorCode, quantity, maximumModifierItems) => (dispatch) => {
  const maximumReached = i18n_config_default.t("validations.modifierItems.maximumReached", {
    maximumModifierItems
  });
  const wrongQuantity = i18n_config_default.t("validations.modifierItems.wrongQuantity", {
    quantity,
    maximumModifierItems
  });
  const descriptions = {
    maximumReached,
    wrongQuantity
  };
  dispatch(
    showToast({
      type: "warning",
      title: i18n_config_default.t("validations.modifierItems.maxModifiersErrorTitle"),
      description: descriptions[errorCode]
    })
  );
};
var validateMaximumModifierItemQuantityCurrent = (modifierItemId, operation, quantity) => (dispatch, getState) => {
  const state = getState();
  const modifierGroup = selectCurrentModifierGroup(state);
  if (!modifierGroup)
    return false;
  const ticketElement = selectCurrentTicketElement(state);
  if (!ticketElement)
    return false;
  try {
    return validateMaximumModifierGroupItemsQuantity(
      modifierGroup,
      ticketElement,
      modifierItemId,
      operation,
      quantity
    );
  } catch (error) {
    dispatch(
      handleModifierGroupMaximumQuantityError(
        error.message,
        quantity,
        modifierGroup.maximumModifierItems
      )
    );
  }
  return false;
};
var decrementModifierItemSelectedThunk = (modifierGroupId, modifierItemId) => (dispatch, getState) => {
  const state = getState();
  const {
    registerNavigation: {
      orderId,
      ticketElementId,
      modifierItemInstanceId,
      currentSeat
    },
    customizer
  } = state.register;
  if (orderId === null || !ticketElementId)
    return;
  let maxSortPriority = void 0;
  const ticketElement = selectCurrentTicketElement(state);
  if (ticketElement) {
    const modifierGroupSelected = ticketElement.modifierGroupsSelected[modifierGroupId];
    const isAllModRelated = modifierGroupSelected.global || modifierGroupId === ALL_MODS_ID;
    if (isAllModRelated)
      maxSortPriority = dispatch(getMaxSortPriorityInAllMods()) + 1;
    else
      maxSortPriority = dispatch(getMaxSortPriorityByModifierGroupId(modifierGroupId)) + 1;
  }
  validateSeatingMode(
    getState,
    (requireSplitItem = false) => dispatch(
      validateTicketElementIsEnabled(
        ticketElementId,
        orderId,
        () => dispatch(
          decrementModifierItemSelected(
            orderId,
            ticketElementId,
            modifierGroupId,
            modifierItemId,
            customizer,
            requireSplitItem,
            currentSeat,
            selectIsCurrentOrderSeatingMode.lastResult(),
            state,
            maxSortPriority
          )
        )
      )
    )
  );
  const modItemInstances = state.register.orders[orderId].ticketElements[ticketElementId].modifierGroupsSelected[modifierGroupId].modifierItemsSelected[modifierItemId].modifierItemInstances;
  if (Object.keys(modItemInstances).length === (modifierItemInstanceId || 0)) {
    dispatch(
      updateRegisterNavigationField({
        modifierItemInstanceId: (modifierItemInstanceId || 2) - 1
      })
    );
  }
};
var toggleNoneModifierItemsSelected = (modifierGroupId) => (dispatch, getState) => {
  const state = getState();
  const { orderId, ticketElementId, currentSeat } = state.register.registerNavigation;
  if (orderId === null || !ticketElementId)
    return;
  const currentTicketElement = selectCurrentTicketElement(state);
  const currentCustomizer = selectCustomizer(state);
  if (!currentTicketElement)
    return;
  const currentModifierGroupSelected = currentTicketElement.modifierGroupsSelected[modifierGroupId];
  if (currentModifierGroupSelected.customizerEnabled) {
    return validateSeatingMode(getState, (seatSplitRequired = false) => {
      dispatch(
        selectNoneNestedModifierItemSelected(
          {
            orderId,
            ticketElementId,
            modifierGroupId,
            customizer: currentCustomizer,
            globalState: state
          },
          {
            currentSeat,
            seatSplitRequired,
            isSeatingModeEnabled: selectIsCurrentOrderSeatingMode.lastResult()
          }
        )
      );
    });
  }
  validateSeatingMode(getState, (seatSplitRequired = false) => {
    dispatch(
      selectNoneModifierItems(
        orderId || 0,
        ticketElementId || 0,
        {
          currentSeat,
          seatSplitRequired,
          isSeatingModeEnabled: selectIsCurrentOrderSeatingMode.lastResult()
        },
        modifierGroupId,
        state
      )
    );
  });
};
var toggleNestedModifierItemSelectedThunk = (parentModifierGroupId, parentModifierItemId, modifierItemInstanceId, nestedModifierGroupId, nestedModifierItemId, onSuccess) => (dispatch, getState) => {
  var _a, _b, _c, _d, _e, _f;
  const state = getState();
  const { orderId, ticketElementId, modifierTag, currentSeat } = state.register.registerNavigation;
  const ticketElement = selectCurrentTicketElement(state);
  if (!ticketElement)
    return;
  const menuTypeId = !ticketElement.isOpenItem ? ticketElement.menuTypeId : 0;
  const parentModifierGroup = (_b = (_a = ticketElement == null ? void 0 : ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[menuTypeId]) == null ? void 0 : _b.modifierGroups[parentModifierGroupId || 0];
  const modifierGroup = (_f = (_e = (_d = (_c = ticketElement == null ? void 0 : ticketElement.itemObj) == null ? void 0 : _c.menuTypeVersions[menuTypeId]) == null ? void 0 : _d.modifierGroups[parentModifierGroupId || 0]) == null ? void 0 : _e.modifierItems[parentModifierItemId]) == null ? void 0 : _f.modifierGroups[nestedModifierGroupId || 0];
  if (orderId === null || !ticketElementId || !modifierGroup || !parentModifierGroup)
    return;
  const modTags = selectLocationModifierTags(state);
  const modifierTagObject = modifierTag !== null && modTags[modifierTag] ? getSelectedModifierTag(modTags[modifierTag]) : null;
  const modifierGroupSelected = ticketElement.modifierGroupsSelected[parentModifierGroupId].modifierItemsSelected[parentModifierItemId].modifierItemInstances[modifierItemInstanceId].nestedModifierGroupsSelected[nestedModifierGroupId];
  const modifierItemSelected = modifierGroupSelected.modifierItemsSelected[nestedModifierItemId];
  const operation = getOperationByModifierTagAndModifierItem(
    modifierItemSelected,
    modifierTagObject,
    modifierGroup.quantityMode,
    null,
    false,
    CUSTOMIZER_INITIAL_STATE,
    getDefaultModifierGroupsSelectedForNestedMod(
      ticketElement.itemObj,
      parentModifierGroupId,
      parentModifierItemId,
      nestedModifierGroupId
    )
  );
  try {
    validateMaximumNestedModifierItemQuantity(
      ticketElement,
      parentModifierGroup,
      parentModifierItemId,
      modifierItemInstanceId,
      nestedModifierGroupId,
      nestedModifierItemId,
      simplifyNestedModifierOperationToQuantityEffect(operation)
    );
    validateSeatingMode(
      getState,
      (seatSplitRequired = false) => dispatch(
        clearModifierTag(() => {
          dispatch(
            toggleNestedModifierItemSelected(
              orderId,
              ticketElementId,
              parentModifierGroupId || 0,
              parentModifierItemId,
              modifierItemInstanceId || 0,
              nestedModifierGroupId || 0,
              nestedModifierItemId,
              modifierTagObject,
              {
                currentSeat,
                seatSplitRequired,
                isSeatingModeEnabled: selectIsCurrentOrderSeatingMode.lastResult()
              },
              state,
              operation
            )
          );
          onSuccess();
        }, modifierTag)
      )
    );
  } catch (error) {
    dispatch(
      handleModifierGroupMaximumQuantityError(
        error.message,
        null,
        modifierGroup.maximumModifierItems
      )
    );
  }
};
var incrementNestedModifierItemSelectedThunk = (parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId, nestedModifierItemId) => (dispatch, getState) => {
  var _a, _b;
  const state = getState();
  const { orderId, ticketElementId, currentSeat } = state.register.registerNavigation;
  const ticketElement = selectCurrentTicketElement(state);
  if (orderId === null || !ticketElement || !ticketElementId)
    return;
  const menuTypeId = !ticketElement.isOpenItem ? ticketElement.menuTypeId : 0;
  const parentModifierGroup = (_b = (_a = ticketElement == null ? void 0 : ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[menuTypeId]) == null ? void 0 : _b.modifierGroups[parentModifierGroupId || 0];
  if (!parentModifierGroup)
    return;
  const modifierGroupQuantityMode = parentModifierGroup.modifierItems[parentModifierItemId].modifierGroups[nestedModifierGroupId].quantityMode;
  const nestedModifierGroup = parentModifierGroup.modifierItems[parentModifierItemId].modifierGroups[nestedModifierGroupId];
  const modifierItem = ticketElement.modifierGroupsSelected[parentModifierGroupId].modifierItemsSelected[parentModifierItemId].modifierItemInstances[parentModifierInstanceId].nestedModifierGroupsSelected[nestedModifierGroupId].modifierItemsSelected[nestedModifierItemId];
  try {
    validateMaximumNestedModifierItemQuantity(
      ticketElement,
      parentModifierGroup,
      parentModifierItemId,
      parentModifierInstanceId,
      nestedModifierGroupId,
      nestedModifierItemId,
      getOperationByQuantityModeAndModifierItem(
        modifierGroupQuantityMode,
        modifierItem
      )
    );
    validateSeatingMode(
      getState,
      (seatSplitRequired = false) => dispatch(
        incrementNestedModifierItemSelected(
          orderId,
          ticketElementId,
          parentModifierGroupId,
          parentModifierItemId,
          parentModifierInstanceId,
          nestedModifierGroupId,
          nestedModifierItemId,
          {
            currentSeat,
            seatSplitRequired,
            isSeatingModeEnabled: selectIsCurrentOrderSeatingMode.lastResult()
          }
        )
      )
    );
  } catch (error) {
    dispatch(
      handleModifierGroupMaximumQuantityError(
        error.message,
        null,
        nestedModifierGroup.maximumModifierItems
      )
    );
  }
};
var deleteNestedModifierGroupItemSelected = (parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId, nestedModifierItemId) => (dispatch, getState) => {
  const state = getState();
  const { orderId, ticketElementId } = state.register.registerNavigation;
  if (orderId === null || !ticketElementId)
    return;
  dispatch(
    deleteNestedModifierItemSelected(
      orderId,
      ticketElementId,
      parentModifierGroupId,
      parentModifierItemId,
      parentModifierInstanceId,
      nestedModifierGroupId,
      nestedModifierItemId,
      selectIsCurrentOrderSeatingMode.lastResult()
    )
  );
};
var decrementNestedModifierItemSelectedThunk = (parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId, nestedModifierItemId) => (dispatch, getState) => {
  const state = getState();
  const { orderId, ticketElementId, currentSeat } = state.register.registerNavigation;
  if (orderId === null || !ticketElementId)
    return;
  validateSeatingMode(
    getState,
    (seatSplitRequired = false) => dispatch(
      decrementNestedModifierItemSelected(
        orderId,
        ticketElementId,
        parentModifierGroupId,
        parentModifierItemId,
        parentModifierInstanceId,
        nestedModifierGroupId,
        nestedModifierItemId,
        {
          currentSeat,
          seatSplitRequired,
          isSeatingModeEnabled: selectIsCurrentOrderSeatingMode.lastResult()
        }
      )
    )
  );
};
var toggleNoneNestedModifierItemSelectedThunk = (parentModifierGroupId, parentModifierItemId, parentModifierInstanceId, nestedModifierGroupId) => (dispatch, getState) => {
  const state = getState();
  const { orderId, ticketElementId, currentSeat } = state.register.registerNavigation;
  if (orderId === null || !ticketElementId)
    return;
  validateSeatingMode(
    getState,
    (seatSplitRequired = false) => dispatch(
      toggleNoneNestedModifierItemSelected(
        orderId,
        ticketElementId,
        parentModifierGroupId,
        parentModifierItemId,
        parentModifierInstanceId,
        nestedModifierGroupId,
        {
          currentSeat,
          seatSplitRequired,
          isSeatingModeEnabled: selectIsCurrentOrderSeatingMode.lastResult()
        }
      )
    )
  );
};
var toggleItemIngredientThunk = (ingredientId) => (dispatch, getState) => {
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  const ticketElementId = selectCurrentTicketElementId(state);
  const isSeatingModeEnabled = selectIsCurrentOrderSeatingMode.lastResult();
  const currentSeat = selectCurrentSeatSelected(state);
  const modifierTagId = selectCurrentModifierTagId(state);
  const modTags = selectLocationModifierTags(state);
  const modifierTagObject = modifierTagId !== null && modTags[modifierTagId] ? getSelectedModifierTag(modTags[modifierTagId]) : null;
  if (orderId === null || !ticketElementId)
    return;
  validateSeatingMode(
    getState,
    (seatSplitRequired = false) => dispatch(
      clearModifierTag(
        () => dispatch(
          toggleItemIngredient({
            orderId,
            ticketElementId,
            ingredientId,
            seatSplitRequired,
            isSeatingModeEnabled,
            currentSeat,
            modifierTagObject
          })
        ),
        modifierTagId
      )
    )
  );
};
var incrementItemIngredientSizeThunk = (ingredientId) => (dispatch, getState) => {
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  const ticketElementId = selectCurrentTicketElementId(state);
  const isSeatingModeEnabled = selectIsCurrentOrderSeatingMode.lastResult();
  const currentSeat = selectCurrentSeatSelected(state);
  if (orderId === null || !ticketElementId)
    return;
  validateSeatingMode(
    getState,
    (seatSplitRequired = false) => dispatch(
      incrementItemIngredient({
        orderId,
        currentSeat,
        ingredientId,
        isSeatingModeEnabled,
        seatSplitRequired,
        ticketElementId
      })
    )
  );
};
var decrementItemIngredientThunk = (ingredientId) => (dispatch, getState) => {
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  const ticketElementId = selectCurrentTicketElementId(state);
  const isSeatingModeEnabled = selectIsCurrentOrderSeatingMode.lastResult();
  const currentSeat = selectCurrentSeatSelected(state);
  if (orderId === null || !ticketElementId)
    return;
  validateSeatingMode(
    getState,
    (seatSplitRequired = false) => dispatch(
      decrementItemIngredient({
        orderId,
        currentSeat,
        ingredientId,
        isSeatingModeEnabled,
        seatSplitRequired,
        ticketElementId
      })
    )
  );
};

// src/state/register/orders/thunks/payments.ts
var payments_exports = {};
__export(payments_exports, {
  addPaymentToCurrentCheckCoreThunk: () => addPaymentToCurrentCheckCoreThunk,
  handleBatchPaymentResponseThunk: () => handleBatchPaymentResponseThunk,
  movePaymentsCoreThunk: () => movePaymentsCoreThunk
});
var addPaymentToCurrentCheckCoreThunk = (payment, orderId) => (dispatch, getState) => {
  const state = getState();
  if (!orderId)
    return;
  const currentCheckId = payment.checkId;
  dispatch(addCheckPayment(orderId, currentCheckId, payment, state));
};
var movePaymentsCoreThunk = (orderId, paymentsChecksIds, checkToId) => (dispatch) => {
  if (orderId === null)
    return;
  const paymentsToCheckIdsMap = {};
  Object.values(paymentsChecksIds).forEach(({ paymentId, checkId }) => {
    paymentsToCheckIdsMap[paymentId] = checkId;
  });
  dispatch(movePayments(orderId, paymentsToCheckIdsMap, checkToId));
};
var handleBatchPaymentResponseThunk = (bodyResponse) => (dispatch, getState) => {
  const state = getState();
  const closedOrdersIds = [];
  const orderIds = bodyResponse.orderPayments.reduce((acc, payment) => {
    return acc.add(payment.orderId);
  }, /* @__PURE__ */ new Set());
  const orderStatuses = bodyResponse.orderPayments.reduce(
    (acc, payment) => {
      acc[payment.orderId] = payment.orderStatus;
      return acc;
    },
    {}
  );
  const orderPayments = bodyResponse.orderPayments.reduce(
    (acc, payment) => {
      if (!acc[payment.orderId])
        acc[payment.orderId] = [];
      acc[payment.orderId].push(payment);
      return acc;
    },
    {}
  );
  const updatedOrders = produce(state.register.orders, (draft) => {
    orderIds.forEach((orderId) => {
      const order = draft[orderId];
      if (!order)
        return;
      order.status = orderStatuses[orderId];
      if (isOrderClosedOrPaid(order.status)) {
        closedOrdersIds.push(orderId);
      }
      Object.values(order.checks).forEach((check) => {
        const thisOrderPayments = orderPayments[orderId];
        thisOrderPayments.forEach((payment) => {
          if (!check.payments[payment.paymentId])
            return;
          const checkPayment = check.payments[payment.paymentId];
          checkPayment.status = payment.paymentStatus;
          if (payment.paymentStatus === "batched" /* BATCHED */) {
            checkPayment.userConfirmedTip = true;
          }
          const batchedTimeUpdatesSet = new Set(
            Object.keys(payment.batchedTimes).map(Number)
          );
          Object.values(checkPayment.transactionHistory).forEach(
            (transaction) => {
              const transactionId = transaction.id;
              if (!batchedTimeUpdatesSet.has(transactionId))
                return;
              transaction.batchedTime = payment.batchedTimes[transactionId];
            }
          );
        });
      });
    });
  });
  const remoteOrders = state.register.orderSearchResults.orders;
  if (remoteOrders.length && remoteOrders.some((order) => order.id && orderIds.has(order.id))) {
    const updateOrderSearchResult = produce(
      state.register.orderSearchResults,
      (draft) => {
        draft.orders = draft.orders.map((order) => {
          if (order.id && orderIds.has(order.id)) {
            return __spreadProps(__spreadValues({}, order), {
              status: orderStatuses[order.id]
            });
          }
          return order;
        });
        const selectedMainOrder = draft.selectedMainOrder;
        const selectedMainOrderId = selectedMainOrder == null ? void 0 : selectedMainOrder.id;
        if (selectedMainOrder && selectedMainOrderId && orderIds.has(selectedMainOrderId)) {
          Object.values(selectedMainOrder.checks).forEach((check) => {
            const thisOrderPayments = orderPayments[selectedMainOrderId];
            thisOrderPayments.forEach((payment) => {
              if (!check.payments[payment.paymentId])
                return;
              const checkPayment = check.payments[payment.paymentId];
              checkPayment.status = payment.paymentStatus;
              if (payment.paymentStatus === "batched" /* BATCHED */) {
                checkPayment.userConfirmedTip = true;
              }
              const batchedTimeUpdatesSet = new Set(
                Object.keys(payment.batchedTimes).map(Number)
              );
              Object.values(checkPayment.transactionHistory).forEach(
                (transaction) => {
                  const transactionId = transaction.id;
                  if (!batchedTimeUpdatesSet.has(transactionId))
                    return;
                  transaction.batchedTime = payment.batchedTimes[transactionId];
                }
              );
            });
          });
        }
      }
    );
    dispatch(setOrderSearchResult(updateOrderSearchResult));
  }
  closedOrdersIds.forEach((closedOrderId) => {
    dispatch(
      removeRecentOrderClosed({
        orderId: closedOrderId
      })
    );
  });
  dispatch(setOrders(updatedOrders));
};

// src/state/register/actions.ts
var setToggleHotButtons = () => ({
  type: SET_TOGGLE_HOT_BUTTONS
});
var setShowHotButtons = (payload) => ({
  type: SET_SHOW_HOT_BUTTONS,
  payload: payload || {}
});
var setDrawers = (payload) => ({
  type: SET_DRAWERS,
  payload
});
var updateDrawer = (payload) => ({
  type: UPDATE_REGISTER_DRAWER,
  payload
});
var updatePaymentNavigation = (payload) => ({
  type: UPDATE_PAYMENT_NAVIGATION,
  payload
});
var enterPaymentMode = (payload) => ({
  type: ENTER_PAYMENT_MODE,
  payload
});
var setPaymentOption = (payload) => ({
  type: SET_PAYMENT_OPTION,
  payload
});
var setPaymentMethod = (payload) => ({
  type: SET_PAYMENT_METHOD,
  payload
});
var setCurrentStationCounter = (payload) => ({
  type: SET_STATION_COUNTER,
  payload
});
var setActiveTicketElement = (payload) => ({
  type: SET_ACTIVE_TICKET_ELEMENT,
  payload
});
var setOrderModal = (payload) => ({
  type: TOGGLE_ORDER_MODAL,
  payload
});
var setTicketElementsOpen = (payload) => ({
  type: SET_TICKET_ELEMENTS_OPEN,
  payload
});
var cleanNavigationAndRemoveActiveItem = (payload) => ({
  type: CLEAN_NAVIGATION_AND_REMOVE_ACTIVE_ITEM,
  payload
});
var toggleActiveItem = (payload) => ({
  type: ADD_REMOVE_ACTIVE_ITEMS,
  payload
});
var setRegisterNavigation = (payload) => ({
  type: SET_REGISTER_NAVIGATION,
  payload
});
var updateRegisterNavigationField = (payload) => {
  return {
    type: UPDATE_REGISTER_NAVIGATION_FIELD,
    payload
  };
};
var updateExitOrderCallStatus = (payload) => ({
  type: payload ? DISABLE_EXIT_ORDER_CALL : ENABLE_EXIT_ORDER_CALL,
  payload
});

// src/state/menu/actions.ts
var isMakingMenuUpdateRequest = false;
var controller = new AbortController();
var setMasterMenu = (payload, isWebSocket = false) => ({
  type: isWebSocket ? SET_MASTER_MENU_ON_STATE_WS : SET_MASTER_MENU_ON_STATE,
  payload
});
var setLocationMenu = (payload, isWebSocket = false) => ({
  type: isWebSocket ? SET_LOCATION_MENU_ON_STATE : SET_LOCATION_MENU_ON_STATE,
  payload
});
var setSelectedMenuMode = (payload, isWebSocket = false) => ({
  type: isWebSocket ? SET_SELECTED_MENU_MODE_WS : SET_SELECTED_MENU_MODE,
  payload
});
var setMenuVersions = (payload, isWebSocket = false) => ({
  type: isWebSocket ? SET_MENU_VERSIONS_WS : SET_MENU_VERSIONS,
  payload
});
var setRemoteLocationMenu = (payload, isWebSocket = false) => ({
  type: isWebSocket ? SET_REMOTE_LOCATION_MENU_ON_STATE_WS : SET_REMOTE_LOCATION_MENU_ON_STATE,
  payload
});
var setSelectedLocations = (payload) => ({
  type: SET_SELECTED_LOCATIONS,
  payload
});
var setMassUpdateSelectedLocations = (payload) => ({
  type: SET_MASS_UPDATE_SELECTED_LOCATIONS,
  payload
});
var setChangeData = (payload) => ({
  type: SET_CHANGE_DATA,
  payload
});
var setChangeMassUpdateData = (payload) => ({
  type: SET_CHANGE_MASS_UPDATE_DATA,
  payload
});
var setChangeFreshSheetData = (payload) => ({
  type: SET_CHANGE_FRESH_SHEET_DATA,
  payload
});
var updateChangeDataValues = (payload) => ({
  type: UPDATE_CHANGE_DATA_VALUES,
  payload
});
var updateChangeFreshSheetDataValues = (payload) => ({
  type: UPDATE_CHANGE_FRESH_SHEET_DATA_VALUES,
  payload
});
var updateChangeMassUpdateDataValues = (payload) => ({
  type: UPDATE_CHANGE_MASS_UPDATE_DATA_VALUES,
  payload
});
var resetChangeData = () => ({
  type: RESET_CHANGE_DATA
});
var resetChangeMassUpdateData = () => ({
  type: RESET_CHANGE_MASS_UPDATE_DATA
});
var resetChangeFreshSheetData = () => ({
  type: RESET_CHANGE_FRESH_SHEET_DATA
});
var resetMenuChanges = (payload) => ({
  type: RESET_MENU_CHANGES,
  payload
});
var resetMassUpdateMenuChanges = (payload) => ({
  type: RESET_MASS_UPDATE_MENU_CHANGES,
  payload
});
var setChangeDataValues = (data, sectionId = "all", isMassUpdate = false) => {
  if (isMassUpdate) {
    return {
      type: SET_CHANGE_MASS_UPDATE_DATA_VALUES,
      payload: { data, sectionId }
    };
  }
  return {
    type: SET_CHANGE_DATA_VALUES,
    payload: {
      data,
      sectionId
    }
  };
};
var setChangeFreshSheetDataValues = (data, sectionId = "all") => ({
  type: SET_CHANGE_FRESH_SHEET_DATA_VALUES,
  payload: { data, sectionId }
});
var setChangeDataModifierGroupsValues = (payload) => ({
  type: SET_CHANGE_DATA_MODIFIER_GROUPS_VALUES,
  payload
});
var setDifferences = (payload) => ({
  type: SET_DIFFERENCES,
  payload
});
var setDiffObject = (payload) => ({
  type: SET_DIFF_OBJECT,
  payload
});
var setBreadCrumbLocation = (payload) => ({
  type: SET_BREADCRUMB_LOCATION,
  payload
});
var setBreadCrumb = (payload) => ({
  type: SET_BREADCRUMB,
  payload
});
var setErrors = (payload) => ({
  type: SET_ERRORS,
  payload
});
var setMassUpdateErrors = (payload) => ({
  type: SET_MASS_UPDATE_ERRORS,
  payload
});
var setLastPreviewArrangement = (payload) => ({
  type: SET_LAST_PREVIEW_ARRANGEMENT,
  payload
});
var setPreviewElements = (payload) => ({
  type: SET_PREVIEW_ELEMENTS,
  payload
});
var updatePreviewElements = (payload) => ({
  type: UPDATE_PREVIEW_ELEMENTS,
  payload
});
var setMenuPreviewAction = (payload) => ({
  type: SET_MENU_PREVIEW_ACTION,
  payload
});
var setLocalItem86 = (itemId, set86) => ({
  type: SET_LOCAL_ITEM_86,
  payload: {
    itemId,
    set86
  }
});
var setLocalModifierItem86 = (modifierItemId, set86) => ({
  type: SET_LOCAL_MODIFIER_ITEM_86,
  payload: {
    modifierItemId,
    set86
  }
});
var setLocalIngredient86 = (ingredientId, set86) => ({
  type: SET_LOCAL_INGREDIENT_86,
  payload: {
    ingredientId,
    set86
  }
});
var resetLocalItemStock = (itemId) => ({
  type: RESET_LOCAL_ITEM_STOCK,
  payload: {
    itemId
  }
});
var updateLocalItemStock = (itemId, stock) => ({
  type: UPDATE_LOCAL_ITEM_STOCK,
  payload: {
    itemId,
    stock
  }
});
var updateLocalItemShowStockOnItemCard = (itemId, showQuantityOnItemCard) => ({
  type: UPDATE_LOCAL_ITEM_SHOW_STOCK_ON_ITEM_CARD,
  payload: {
    itemId,
    showQuantityOnItemCard
  }
});
var updateInventory = (payload, isWebSocket = true) => ({
  type: isWebSocket ? UPDATE_INVENTORY_WS : UPDATE_INVENTORY,
  payload
});
var updateEntityInventoryWS = (payload) => ({
  type: payload.entity === "modifierItem" /* MODIFIER_ITEM */ ? UPDATE_MODIFIER_ITEM_INVENTORY_WS : payload.entity === "ingredient" /* INGREDIENT */ ? UPDATE_INGREDIENT_INVENTORY_WS : UPDATE_INVENTORY_WS,
  payload: payload.data
});
var changeSelectedMode = (preSelectedMode, location, organizationId, licenseId, errorCodesDispatcher, extraHeaders, onContinue) => {
  return (dispatch, getState) => {
    const { masterMenu, locationMenu, versions } = getState().menu;
    let canNavigate = true;
    const menuType = preSelectedMode.overrideMenuType || preSelectedMode.menuType;
    switch (menuType) {
      case "masterMenu" /* MASTER_MENU */:
        canNavigate = dispatch(
          checkForItemInLocationAndContinue(
            location,
            masterMenu,
            () => dispatch(
              setSelectedMenuMode(__spreadProps(__spreadValues({}, preSelectedMode), {
                currentMenu: masterMenu,
                menuVersion: versions.master
              }))
            )
          )
        );
        break;
      case "locationMenu" /* LOCATION_MENU */:
        canNavigate = dispatch(
          checkForItemInLocationAndContinue(
            location,
            locationMenu,
            () => dispatch(
              setSelectedMenuMode(__spreadProps(__spreadValues({}, preSelectedMode), {
                currentMenu: locationMenu,
                menuVersion: versions.location
              }))
            )
          )
        );
        break;
      case "remoteLocationMenu" /* REMOTE_LOCATION_MENU */:
        dispatch(
          getRemoteLocationMenu(
            preSelectedMode,
            location,
            organizationId,
            licenseId,
            errorCodesDispatcher,
            extraHeaders,
            onContinue
          )
        );
        return canNavigate;
    }
    onContinue && onContinue();
    return canNavigate;
  };
};
var updateItem = (values, sectionId, menuTypeVersionId, modifierGroupId, modifierItemId) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    var _a;
    const state = getState();
    const data = state.menu.changeData.data;
    const massUpdateData = getState().menu.changeMassUpdateData.data;
    if (menuTypeVersionId) {
      if (modifierGroupId && modifierItemId && menuTypeVersionId) {
        let newData = {};
        if (massUpdateData) {
          newData = __spreadProps(__spreadValues({}, massUpdateData), {
            modifierGroups: __spreadProps(__spreadValues({}, massUpdateData.modifierGroups), {
              [modifierGroupId]: __spreadProps(__spreadValues({}, massUpdateData.modifierGroups[modifierGroupId]), {
                modifierItems: __spreadProps(__spreadValues({}, massUpdateData.modifierGroups[modifierGroupId].modifierItems), {
                  [modifierItemId]: __spreadValues(__spreadValues({}, massUpdateData.modifierGroups[modifierGroupId].modifierItems[modifierItemId]), values)
                })
              })
            })
          });
        } else {
          newData = __spreadProps(__spreadValues({}, data), {
            menuTypeVersions: __spreadProps(__spreadValues({}, data.menuTypeVersions), {
              [menuTypeVersionId]: __spreadProps(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId]), {
                modifierGroups: __spreadProps(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId].modifierGroups), {
                  [modifierGroupId]: __spreadProps(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId].modifierGroups[modifierGroupId]), {
                    modifierItems: __spreadProps(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId].modifierGroups[modifierGroupId].modifierItems), {
                      [modifierItemId]: __spreadValues(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId].modifierGroups[modifierGroupId].modifierItems[modifierItemId]), values)
                    })
                  })
                })
              })
            })
          });
        }
        dispatch(
          setChangeDataValues(
            newData,
            sectionId,
            !!massUpdateData
          )
        );
      } else if (modifierGroupId) {
        let newData = {};
        if (massUpdateData) {
          newData = __spreadProps(__spreadValues({}, massUpdateData), {
            modifierGroups: __spreadProps(__spreadValues({}, massUpdateData.modifierGroups), {
              [modifierGroupId]: __spreadValues(__spreadValues({}, massUpdateData.modifierGroups[modifierGroupId]), values)
            })
          });
        } else {
          newData = __spreadProps(__spreadValues({}, data), {
            menuTypeVersions: __spreadProps(__spreadValues({}, data.menuTypeVersions), {
              [menuTypeVersionId]: __spreadProps(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId]), {
                modifierGroups: __spreadProps(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId].modifierGroups), {
                  [modifierGroupId]: __spreadValues(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId].modifierGroups[modifierGroupId]), values)
                })
              })
            })
          });
          const modifierGroupData = data.menuTypeVersions[menuTypeVersionId].modifierGroups[modifierGroupId];
          if ("active" in values && values.active && !modifierGroupData.inheritedActive && !modifierGroupData.active) {
            newData.menuTypeVersions[menuTypeVersionId].modifierGroups[modifierGroupId].active = false;
            dispatch(
              showToast({
                type: "error",
                title: i18n_config_default.t("commonTexts.error"),
                description: i18n_config_default.t(
                  "menuScreen.itemDetails.modifierGroupsSection.activeModifierGroupError"
                )
              })
            );
          }
        }
        dispatch(
          setChangeDataValues(
            newData,
            sectionId,
            !!massUpdateData
          )
        );
      } else {
        const newData = __spreadProps(__spreadValues({}, data), {
          menuTypeVersions: __spreadProps(__spreadValues({}, data.menuTypeVersions), {
            [menuTypeVersionId]: __spreadProps(__spreadValues(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId]), values), {
              locationId: ((_a = data.menuTypeVersions[menuTypeVersionId]) == null ? void 0 : _a.locationId) || 0
            })
          })
        });
        if (!isEqual6(
          newData.menuTypeVersions[menuTypeVersionId].categoriesSubcategories,
          data.menuTypeVersions[menuTypeVersionId].categoriesSubcategories
        ) && !massUpdateData) {
          newData.menuTypeVersions = populateTaxes(
            newData,
            menuTypeVersionId,
            getState()
          );
        }
        dispatch(
          setChangeDataValues(
            newData,
            sectionId
          )
        );
      }
    } else {
      const selectedData = massUpdateData ? massUpdateData : data;
      const newData = __spreadValues(__spreadValues({}, selectedData), values);
      dispatch(
        setChangeDataValues(newData, sectionId, !!massUpdateData)
      );
    }
  });
};
function populateTaxes(currentItem, changedMenuTypeVersionId, state) {
  const { subcategories, categories, menuTypes } = state.menu.selectedMode.currentMenu;
  const clonedMenuTypeVersions = cloneDeep16(currentItem.menuTypeVersions);
  Object.entries(clonedMenuTypeVersions).forEach(
    ([menuTypeVersionId, menuTypeVersion]) => {
      var _a;
      if (Number(menuTypeVersionId) !== changedMenuTypeVersionId) {
        return;
      }
      const categoryInheritedTaxes = {};
      const subcategoryInheritedTaxes = {};
      Object.values((_a = menuTypeVersion.categoriesSubcategories) != null ? _a : {}).forEach(
        (catSubcat) => {
          if (catSubcat.subcategoryId) {
            for (const taxId of subcategories[catSubcat.subcategoryId].taxIds) {
              subcategoryInheritedTaxes[taxId] = {
                id: taxId,
                isActive: true
              };
            }
          }
          if (catSubcat.categoryId) {
            for (const taxId of categories[catSubcat.categoryId].taxIds) {
              categoryInheritedTaxes[taxId] = {
                id: taxId,
                isActive: true
              };
            }
          }
        }
      );
      const inheritedTaxes = {
        menuTypeInheritedTaxes: {},
        categoryInheritedTaxes,
        subcategoryInheritedTaxes
      };
      if (menuTypeVersionId in menuTypes) {
        for (const taxId of menuTypes[Number(menuTypeVersionId)].taxIds) {
          inheritedTaxes.menuTypeInheritedTaxes[taxId] = {
            id: taxId,
            isActive: true
          };
        }
      }
      clonedMenuTypeVersions[Number(menuTypeVersionId)].inheritedTaxes = inheritedTaxes;
    }
  );
  return clonedMenuTypeVersions;
}
var updateCombo = (values, sectionId, menuTypeVersionId, itemGroupId, itemOfItemGroupId) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    var _a;
    const state = getState();
    const data = state.menu.changeData.data;
    const massUpdateData = getState().menu.changeMassUpdateData.data;
    const itemGroups = selectItemGroups(state);
    if (!menuTypeVersionId) {
      const newData = __spreadValues(__spreadValues({}, data), values);
      dispatch(setChangeDataValues(newData, sectionId));
      return;
    }
    if (itemGroupId && itemOfItemGroupId) {
      const newData = __spreadProps(__spreadValues({}, data), {
        menuTypeVersions: __spreadProps(__spreadValues({}, data.menuTypeVersions), {
          [menuTypeVersionId]: __spreadProps(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId]), {
            itemGroups: __spreadProps(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId].itemGroups), {
              [itemGroupId]: __spreadProps(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId].itemGroups[itemGroupId]), {
                items: __spreadProps(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId].itemGroups[itemGroupId].items), {
                  [itemOfItemGroupId]: __spreadValues(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId].itemGroups[itemGroupId].items[itemOfItemGroupId]), values)
                })
              })
            })
          })
        })
      });
      dispatch(setChangeDataValues(newData, sectionId));
    } else if (itemGroupId) {
      const itemGroup = itemGroups[Number(itemGroupId)];
      const newData = __spreadProps(__spreadValues({}, data), {
        menuTypeVersions: __spreadProps(__spreadValues({}, data.menuTypeVersions), {
          [menuTypeVersionId]: __spreadProps(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId]), {
            itemGroups: __spreadProps(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId].itemGroups), {
              [itemGroupId]: __spreadValues(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId].itemGroups[itemGroupId]), values)
            })
          })
        })
      });
      if ("active" in values && values.active && !itemGroup.active && !data.menuTypeVersions[menuTypeVersionId].itemGroups[itemGroupId].active) {
        return dispatch(
          showToast({
            type: "error",
            title: i18n_config_default.t("commonTexts.error"),
            description: i18n_config_default.t(
              "menuScreen.comboDetails.itemGroups.activeItemGroupError"
            )
          })
        );
      }
      dispatch(setChangeDataValues(newData, sectionId));
    } else {
      const newData = __spreadProps(__spreadValues({}, data), {
        menuTypeVersions: __spreadProps(__spreadValues({}, data.menuTypeVersions), {
          [menuTypeVersionId]: __spreadProps(__spreadValues(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId]), values), {
            locationId: ((_a = data.menuTypeVersions[menuTypeVersionId]) == null ? void 0 : _a.locationId) || 0
          })
        })
      });
      if (!isEqual6(
        newData.menuTypeVersions[menuTypeVersionId].categoriesSubcategories,
        data.menuTypeVersions[menuTypeVersionId].categoriesSubcategories
      ) && !massUpdateData) {
        newData.menuTypeVersions = populateTaxes(
          newData,
          menuTypeVersionId,
          getState()
        );
      }
      dispatch(setChangeDataValues(newData, sectionId));
    }
  });
};
var updateSpecial = (values, sectionId, menuTypeVersionId) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    var _a;
    const data = getState().menu.changeData.data;
    if (!menuTypeVersionId) {
      const newData2 = __spreadValues(__spreadValues({}, data), values);
      dispatch(setChangeDataValues(newData2, sectionId));
      return;
    }
    const newData = __spreadProps(__spreadValues({}, data), {
      menuTypeVersions: __spreadProps(__spreadValues({}, data.menuTypeVersions), {
        [menuTypeVersionId]: __spreadProps(__spreadValues(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId]), values), {
          locationId: ((_a = data.menuTypeVersions[menuTypeVersionId]) == null ? void 0 : _a.locationId) || 0
        })
      })
    });
    dispatch(setChangeDataValues(newData, sectionId));
  });
};
var handleHideModifierGroup = (modifierGroupId, active, menuTypeVersionId, sectionId) => (dispatch, getState) => {
  dispatch(
    hideModifierGroup(menuTypeVersionId, modifierGroupId, sectionId, !active)
  );
  const state = getState();
  const data = selectCurrentItem(state);
  const formMode = selectMenuMode(state);
  if (active) {
    const clonedModifierGroups = formMode !== "mass_update" /* MASS_UPDATE */ ? cloneDeep16(
      data.menuTypeVersions[menuTypeVersionId].modifierGroups
    ) : cloneDeep16(
      state.menu.changeMassUpdateData.data.modifierGroups
    );
    dispatch(
      updateItem(
        {
          modifierGroups: clonedModifierGroups
        },
        sectionId,
        menuTypeVersionId
      )
    );
  }
};
var handleDeleteModifierGroup = (modifierGroupId, name, active, menuTypeVersionId, sectionId) => (dispatch, getState) => {
  const state = getState();
  const itemData = selectCurrentItem(state);
  const isMasterMode = selectIsMenuMasterMode(state);
  const formMode = selectMenuMode(state);
  const massUpdateDeleteModifier = () => {
    const newModifierGroups = __spreadValues({}, itemData.modifierGroups);
    delete newModifierGroups[modifierGroupId];
    dispatch(
      updateItem(
        {
          modifierGroups: newModifierGroups
        },
        sectionId
      )
    );
  };
  isMasterMode ? dispatch(
    setShowConfirmationModal({
      active: true,
      title: i18n_config_default.t(
        "menuScreen.itemDetails.modifierGroupsSection.modifierGroup"
      ),
      type: "delete",
      name,
      onSuccess: () => {
        if (formMode !== "mass_update" /* MASS_UPDATE */) {
          dispatch(
            deleteModifierGroupFromItem(
              menuTypeVersionId,
              modifierGroupId,
              sectionId
            )
          );
        } else {
          massUpdateDeleteModifier();
        }
      }
    })
  ) : formMode !== "mass_update" /* MASS_UPDATE */ ? dispatch(
    handleHideModifierGroup(
      modifierGroupId,
      active,
      menuTypeVersionId,
      sectionId
    )
  ) : massUpdateDeleteModifier();
};
var deleteModifierGroupFromItem = (menuTypeVersionId, modifierGroupId, sectionId) => (dispatch, getState) => {
  const state = getState();
  const data = state.menu.changeData.data;
  const massUpdateData = state.menu.changeMassUpdateData.data;
  const currData = massUpdateData ? massUpdateData : data;
  const menuTypeVersion = massUpdateData ? massUpdateData : data.menuTypeVersions[menuTypeVersionId];
  const modifierGroups = menuTypeVersion.modifierGroups;
  const newModifierGroups = cloneDeep16(modifierGroups);
  const defaultModifiersPrice = menuTypeVersion.defaultModifiersPrice;
  const defaultSelectionPrice = menuTypeVersion.modifierGroups[modifierGroupId].defaultSelectionPrice;
  delete newModifierGroups[modifierGroupId];
  const newDefaultModifiersPrice = menuTypeVersion.modifierGroups[modifierGroupId].active ? (defaultModifiersPrice - defaultSelectionPrice).toFixed(2) : defaultModifiersPrice;
  const oldAllModsBehavior = menuTypeVersion.allModsBehavior;
  const newAllModsBehavior = Object.keys(newModifierGroups).length === 0 && oldAllModsBehavior === "associated" /* ASSOCIATED */ ? "all" /* ALL */ : oldAllModsBehavior;
  if (massUpdateData) {
    const newData2 = __spreadProps(__spreadValues({}, currData), {
      defaultModifiersPrice: Number(newDefaultModifiersPrice) || 0,
      modifierGroups: newModifierGroups,
      allModsBehavior: newAllModsBehavior
    });
    dispatch(
      setChangeDataValues(
        newData2,
        sectionId,
        true
      )
    );
    return;
  }
  const newData = __spreadProps(__spreadValues({}, currData), {
    menuTypeVersions: __spreadProps(__spreadValues({}, currData.menuTypeVersions), {
      [menuTypeVersionId]: __spreadProps(__spreadValues({}, menuTypeVersion), {
        defaultModifiersPrice: Number(newDefaultModifiersPrice) || 0,
        modifierGroups: newModifierGroups,
        allModsBehavior: newAllModsBehavior
      })
    })
  });
  dispatch(
    setChangeDataValues(
      newData,
      sectionId
    )
  );
};
var deleteItemGroupFromCombo = (menuTypeVersionId, itemGroupId) => (dispatch, getState) => {
  const state = getState();
  const data = state.menu.changeData.data;
  const itemGroups = data.menuTypeVersions[menuTypeVersionId].itemGroups;
  const newItemGroups = cloneDeep16(itemGroups);
  const isMasterMode = selectIsMenuMasterMode(state);
  if (!isMasterMode) {
    const isActive = newItemGroups[itemGroupId].active;
    return dispatch(
      updateCombo(
        { active: !isActive },
        "itemGroups" /* ITEM_GROUPS */,
        menuTypeVersionId,
        itemGroupId
      )
    );
  }
  delete newItemGroups[itemGroupId];
  const sortedItemGroups = orderBy5(
    Object.entries(newItemGroups),
    (itemGroup) => itemGroup[1].sortPriority
  ).map(([key]) => Number(key));
  sortedItemGroups.forEach((key, index) => {
    newItemGroups[key].sortPriority = index + 1;
  });
  dispatch(
    updateCombo(
      { itemGroups: newItemGroups },
      "itemGroups" /* ITEM_GROUPS */,
      menuTypeVersionId
    )
  );
};
var handleDeleteModifierGroupFromModifierItem = (modifierGroupId, name, active, sectionId) => (dispatch, getState) => {
  const state = getState();
  const isMasterMode = selectIsMenuMasterMode(state);
  isMasterMode ? dispatch(
    setShowConfirmationModal({
      active: true,
      title: i18n_config_default.t(
        "menuScreen.itemDetails.modifierGroupsSection.modifierGroup"
      ),
      type: "delete",
      name,
      onSuccess: () => {
        dispatch(
          deleteModifierGroupFromModifierItem(modifierGroupId, sectionId)
        );
      }
    })
  ) : dispatch(
    handleHideModifierGroupFromModifierItem(
      modifierGroupId,
      active,
      sectionId
    )
  );
};
var handleHideModifierGroupFromModifierItem = (modifierGroupId, active, sectionId) => (dispatch, getState) => {
  dispatch(
    hideModifierGroupFromModifierItem(modifierGroupId, sectionId, !active)
  );
  const state = getState();
  const data = selectCurrentItem(state);
  if (active) {
    const clonedModifierGroups = cloneDeep16(
      data.modifierGroups
    );
    dispatch(
      updateModifierItem(
        {
          modifierGroups: clonedModifierGroups
        },
        sectionId
      )
    );
  }
};
var hideModifierGroupFromModifierItem = (modifierGroupId, sectionId, isSwitchActive) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const data = state.menu.changeData.data;
    const modifierGroup = selectModifierGroups(state)[modifierGroupId];
    if (isSwitchActive && !modifierGroup.active) {
      return dispatch(
        showToast({
          type: "error",
          title: i18n_config_default.t("commonTexts.error"),
          description: i18n_config_default.t(
            "menuScreen.modifierItemDetails.associations.modifierGroups.activeModifierGroupError"
          )
        })
      );
    }
    const defaultModifiersPrice = data.defaultModifiersPrice;
    const defaultSelectionPrice = data.modifierGroups[modifierGroupId].defaultSelectionPrice;
    let newDefaultModifiersPrice = 0;
    if (isSwitchActive) {
      newDefaultModifiersPrice = Number(
        (defaultModifiersPrice + defaultSelectionPrice).toFixed(2)
      );
    } else {
      newDefaultModifiersPrice = Number(
        (defaultModifiersPrice - defaultSelectionPrice).toFixed(2)
      );
    }
    let newData = {};
    newData = __spreadProps(__spreadValues({}, data), {
      defaultModifiersPrice: newDefaultModifiersPrice || 0,
      modifierGroups: __spreadProps(__spreadValues({}, data.modifierGroups), {
        [modifierGroupId]: __spreadProps(__spreadValues({}, data.modifierGroups[modifierGroupId]), {
          active: isSwitchActive
        })
      })
    });
    dispatch(
      setChangeDataValues(
        newData,
        sectionId
      )
    );
  });
};
var deleteModifierGroupFromModifierItem = (modifierGroupId, sectionId) => (dispatch, getState) => {
  const state = getState();
  const data = state.menu.changeData.data;
  const modifierGroups = data.modifierGroups;
  const newModifierGroups = cloneDeep16(modifierGroups);
  const defaultModifiersPrice = data.defaultModifiersPrice;
  const defaultSelectionPrice = data.modifierGroups[modifierGroupId].defaultSelectionPrice;
  delete newModifierGroups[modifierGroupId];
  const newDefaultModifiersPrice = data.modifierGroups[modifierGroupId].active ? (defaultModifiersPrice - defaultSelectionPrice).toFixed(2) : defaultModifiersPrice;
  const newData = __spreadProps(__spreadValues({}, data), {
    defaultModifiersPrice: Number(newDefaultModifiersPrice) || 0,
    modifierGroups: newModifierGroups
  });
  dispatch(setChangeDataValues(newData, sectionId));
};
var rearrangeModifierGroups = (modifierGroupId, sectionId, order, prevModifierGroupId, nextModifierGroupId, menuTypeVersionId) => (dispatch, getState) => {
  const state = getState();
  const changeMassUpdateData = state.menu.changeMassUpdateData.data;
  let modifierGroups = {};
  if (menuTypeVersionId)
    modifierGroups = state.menu.changeData.data.menuTypeVersions[menuTypeVersionId].modifierGroups;
  else {
    modifierGroups = changeMassUpdateData ? changeMassUpdateData.modifierGroups : state.menu.changeData.data.modifierGroups;
  }
  const newModifierGroups = cloneDeep16(modifierGroups);
  const oldSortPriority = newModifierGroups[modifierGroupId].sortPriority;
  if (order === 1) {
    const newSortPriority = newModifierGroups[nextModifierGroupId].sortPriority;
    newModifierGroups[modifierGroupId].sortPriority = newSortPriority;
    newModifierGroups[nextModifierGroupId].sortPriority = oldSortPriority;
  } else {
    const newSortPriority = newModifierGroups[prevModifierGroupId].sortPriority;
    newModifierGroups[modifierGroupId].sortPriority = newSortPriority;
    newModifierGroups[prevModifierGroupId].sortPriority = oldSortPriority;
  }
  if (menuTypeVersionId || changeMassUpdateData) {
    dispatch(
      updateItem(
        {
          modifierGroups: newModifierGroups
        },
        sectionId,
        menuTypeVersionId
      )
    );
  } else {
    dispatch(
      updateModifierItem(
        {
          modifierGroups: newModifierGroups
        },
        sectionId
      )
    );
  }
};
var rearrangeModifierGroupsToLastOrFirst = (modifierGroupId, sectionId, to, menuTypeVersionId, isPremade) => (dispatch, getState) => {
  const state = getState();
  const changeMassUpdateData = state.menu.changeMassUpdateData.data;
  const isToFirst = to === "first";
  let modifierGroups = {};
  if (menuTypeVersionId) {
    modifierGroups = state.menu.changeData.data.menuTypeVersions[menuTypeVersionId].modifierGroups;
  } else {
    modifierGroups = changeMassUpdateData ? changeMassUpdateData.modifierGroups : state.menu.changeData.data.modifierGroups;
  }
  const modifierGroupIdsWithoutChangedId = without(
    Object.keys(
      menuTypeVersionId ? pickBy(
        modifierGroups,
        (modifierGroup) => modifierGroup.isAllMod === (isPremade || false)
      ) : modifierGroups
    ),
    `${modifierGroupId}`
  );
  let newOrderedModifierGroups = orderBy5(
    Object.entries(pick2(modifierGroups, modifierGroupIdsWithoutChangedId)),
    (modifierGroup) => {
      var _a;
      return (_a = modifierGroup[1]) == null ? void 0 : _a.sortPriority;
    }
  );
  if (isToFirst) {
    newOrderedModifierGroups = [
      [`${modifierGroupId}`, modifierGroups[modifierGroupId]],
      ...newOrderedModifierGroups
    ];
  } else {
    newOrderedModifierGroups = [
      ...newOrderedModifierGroups,
      [`${modifierGroupId}`, modifierGroups[modifierGroupId]]
    ];
  }
  const newModifierGroups = cloneDeep16(modifierGroups);
  newOrderedModifierGroups.forEach(([mgId], index) => {
    newModifierGroups[Number(mgId)].sortPriority = index + 1;
  });
  if (menuTypeVersionId || changeMassUpdateData) {
    dispatch(
      updateItem(
        {
          modifierGroups: newModifierGroups
        },
        sectionId,
        menuTypeVersionId
      )
    );
  } else {
    dispatch(
      updateModifierItem(
        {
          modifierGroups: newModifierGroups
        },
        sectionId
      )
    );
  }
};
var rearrangeItemGroups = (itemGroupId, sectionId, order, prevItemGroupId, nextItemGroupId, menuTypeVersionId) => (dispatch, getState) => {
  const state = getState();
  let itemGroups = {};
  itemGroups = state.menu.changeData.data.menuTypeVersions[menuTypeVersionId].itemGroups;
  const newItemGroups = cloneDeep16(itemGroups);
  const oldSortPriority = newItemGroups[itemGroupId].sortPriority;
  if (order === 1) {
    const newSortPriority = newItemGroups[nextItemGroupId].sortPriority;
    newItemGroups[itemGroupId].sortPriority = newSortPriority;
    newItemGroups[nextItemGroupId].sortPriority = oldSortPriority;
  } else {
    const newSortPriority = newItemGroups[prevItemGroupId].sortPriority;
    newItemGroups[itemGroupId].sortPriority = newSortPriority;
    newItemGroups[prevItemGroupId].sortPriority = oldSortPriority;
  }
  dispatch(
    updateCombo(
      {
        itemGroups: newItemGroups
      },
      sectionId,
      menuTypeVersionId
    )
  );
};
var rearrangeItemGroupsToLastOrFirst = (itemGroupId, sectionId, to, menuTypeVersionId) => (dispatch, getState) => {
  const state = getState();
  const isToFirst = to === "first";
  const itemGroups = state.menu.changeData.data.menuTypeVersions[menuTypeVersionId].itemGroups;
  const modifierGroupIdsWithoutChangedId = without(
    Object.keys(itemGroups),
    `${itemGroupId}`
  );
  let newOrderedItemGroups = orderBy5(
    Object.entries(pick2(itemGroups, modifierGroupIdsWithoutChangedId)),
    (modifierGroup) => {
      var _a;
      return (_a = modifierGroup[1]) == null ? void 0 : _a.sortPriority;
    }
  );
  if (isToFirst) {
    newOrderedItemGroups = [
      [`${itemGroupId}`, itemGroups[itemGroupId]],
      ...newOrderedItemGroups
    ];
  } else {
    newOrderedItemGroups = [
      ...newOrderedItemGroups,
      [`${itemGroupId}`, itemGroups[itemGroupId]]
    ];
  }
  const newItemGroups = cloneDeep16(itemGroups);
  newOrderedItemGroups.forEach(([igId], index) => {
    newItemGroups[igId].sortPriority = index + 1;
  });
  dispatch(
    updateCombo(
      {
        itemGroups: newItemGroups
      },
      sectionId,
      menuTypeVersionId
    )
  );
};
var addNewItemGroup = (menuTypeVersionId) => (dispatch, getState) => {
  const state = getState();
  const itemGroups = state.menu.changeData.data.menuTypeVersions[menuTypeVersionId].itemGroups;
  const newItemGroups = cloneDeep16(itemGroups);
  const nextId = generateTabletGeneratedId();
  const nextSortPriority = (max3(
    Object.values(itemGroups).map((itemGroup) => itemGroup.sortPriority)
  ) || 0) + 1;
  newItemGroups[nextId] = __spreadProps(__spreadValues({}, COMBO_ITEM_GROUP_INITIAL_STATE), {
    sortPriority: nextSortPriority
  });
  dispatch(
    updateCombo(
      {
        itemGroups: newItemGroups
      },
      "itemGroups" /* ITEM_GROUPS */,
      menuTypeVersionId
    )
  );
};
var updateMenuType = (values) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const data = getState().menu.changeData.data;
    dispatch(
      setChangeDataValues(__spreadValues(__spreadValues({}, data), values))
    );
  });
};
var updateItemGroup = (values, sectionId, itemId) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const data = getState().menu.changeData.data;
    if (itemId) {
      return dispatch(
        setChangeDataValues(
          __spreadProps(__spreadValues({}, data), {
            items: __spreadProps(__spreadValues({}, data.items), {
              [itemId]: __spreadValues(__spreadValues({}, data.items[itemId]), values)
            })
          }),
          sectionId
        )
      );
    }
    dispatch(
      setChangeDataValues(
        __spreadValues(__spreadValues({}, data), values),
        sectionId
      )
    );
  });
};
var updateCategory = (values) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const data = getState().menu.changeData.data;
    dispatch(
      setChangeDataValues(__spreadValues(__spreadValues({}, data), values))
    );
  });
};
var updateSubcategory = (values) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const data = getState().menu.changeData.data;
    dispatch(
      setChangeDataValues(__spreadValues(__spreadValues({}, data), values))
    );
  });
};
var updateModifierItem = (values, sectionId, id) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const data = getState().menu.changeData.data;
    if (!isNil3(id)) {
      const newData = __spreadProps(__spreadValues({}, data), {
        modifierItemPricingVersions: __spreadProps(__spreadValues({}, data.modifierItemPricingVersions), {
          [id]: __spreadValues(__spreadValues({}, data.modifierItemPricingVersions[id]), values)
        })
      });
      dispatch(setChangeDataValues(newData, sectionId));
    } else {
      dispatch(
        setChangeDataValues(
          __spreadValues(__spreadValues({}, data), values),
          sectionId
        )
      );
    }
  });
};
var updateMenuBucket = (values, sectionId) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const data = getState().menu.changeData.data;
    dispatch(
      setChangeDataValues(
        __spreadValues(__spreadValues({}, data), values),
        sectionId
      )
    );
  });
};
var updateFreshSheet = (values, sectionId) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const data = getState().menu.changeFreshSheetData.data;
    dispatch(
      setChangeFreshSheetDataValues(
        __spreadValues(__spreadValues({}, data), values),
        sectionId
      )
    );
  });
};
var updateModifierItemModifierGroups = (values, sectionId, modifierGroupId, modifierItemId) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const data = getState().menu.changeData.data;
    if (modifierItemId) {
      const newData = __spreadProps(__spreadValues({}, data), {
        modifierGroups: __spreadProps(__spreadValues({}, data.modifierGroups), {
          [modifierGroupId]: __spreadProps(__spreadValues({}, data.modifierGroups[modifierGroupId]), {
            modifierItems: __spreadProps(__spreadValues({}, data.modifierGroups[modifierGroupId].modifierItems), {
              [modifierItemId]: __spreadValues(__spreadValues({}, data.modifierGroups[modifierGroupId].modifierItems[modifierItemId]), values)
            })
          })
        })
      });
      dispatch(setChangeDataValues(newData, sectionId));
    } else {
      const newData = __spreadProps(__spreadValues({}, data), {
        modifierGroups: __spreadProps(__spreadValues({}, data.modifierGroups), {
          [modifierGroupId]: __spreadValues(__spreadValues({}, data.modifierGroups[modifierGroupId]), values)
        })
      });
      dispatch(setChangeDataValues(newData, sectionId));
    }
  });
};
var updateModifierGroup = (values, sectionId, subsection, id) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const data = getState().menu.changeData.data;
    let newData;
    if (!id) {
      newData = __spreadValues(__spreadValues({}, data), values);
      dispatch(setChangeDataValues(newData, sectionId));
      return;
    }
    switch (subsection) {
      case "pricingVersion" /* PRICING_VERSION */:
        newData = __spreadProps(__spreadValues({}, data), {
          modifierGroupPricingVersions: __spreadProps(__spreadValues({}, data.modifierGroupPricingVersions), {
            [id]: __spreadValues(__spreadValues({}, data.modifierGroupPricingVersions[id]), values)
          })
        });
        break;
      case "modifierItem" /* MODIFIER_ITEM */:
        newData = __spreadProps(__spreadValues({}, data), {
          modifierItems: __spreadProps(__spreadValues({}, data.modifierItems), {
            [id]: __spreadValues(__spreadValues({}, data.modifierItems[id]), values)
          })
        });
        break;
      default:
        newData = __spreadValues(__spreadValues({}, data), values);
        break;
    }
    dispatch(setChangeDataValues(newData, sectionId));
  });
};
var addPricingVersionForModifierGroup = (pricingVersionId, name, onSuccess) => (dispatch, getState) => {
  const state = getState();
  const menuModifierGroupPricingVersions = state.menu.changeData.data.modifierGroupPricingVersions;
  const modifierGroupPricingVersions = state.menu.changeData.data.modifierGroupPricingVersions;
  const selectedPricingVersion = modifierGroupPricingVersions[pricingVersionId] || MODIFIER_GROUP_PRICING_VERSION_INITIAL_STATE;
  const newKey = Object.keys(menuModifierGroupPricingVersions).reduce(
    (acc, value) => Number(value) > Number(acc) ? Number(value) : Number(acc),
    0
  ) + 1;
  const newModifierGroupPricingVersions = __spreadProps(__spreadValues({}, modifierGroupPricingVersions), {
    [newKey]: __spreadProps(__spreadValues({}, selectedPricingVersion), {
      id: newKey,
      modifierGroupPricingVersionId: newKey,
      name
    })
  });
  dispatch(
    updateModifierGroup(
      {
        modifierGroupPricingVersions: newModifierGroupPricingVersions
      },
      "association" /* ASSOCIATION */,
      "all" /* ALL */
    )
  );
  onSuccess(Object.keys(newModifierGroupPricingVersions));
};
var addPricingVersionForModifierItem = (pricingVersionId, name, onSuccess) => (dispatch, getState) => {
  const state = getState();
  const menuModifierGroupPricingVersions = state.menu.changeData.data.modifierItemPricingVersions;
  const modifierItemPricingVersions = state.menu.changeData.data.modifierItemPricingVersions;
  const selectedPricingVersion = modifierItemPricingVersions[pricingVersionId] || MODIFIER_ITEM_PRICING_VERSION_INITIAL_STATE;
  const newKey = Object.keys(menuModifierGroupPricingVersions).reduce(
    (acc, value) => Number(value) > Number(acc) ? Number(value) : Number(acc),
    0
  ) + 1;
  const newModifierItemPricingVersions = __spreadProps(__spreadValues({}, modifierItemPricingVersions), {
    [newKey]: __spreadProps(__spreadValues({}, selectedPricingVersion), {
      id: newKey,
      modifierItemPricingVersionId: newKey,
      name
    })
  });
  dispatch(
    updateModifierItem(
      {
        modifierItemPricingVersions: newModifierItemPricingVersions
      },
      "pricing" /* PRICING */
    )
  );
  onSuccess(Object.keys(newModifierItemPricingVersions));
};
var removePricingVersionFromModifierGroup = (pricingVersionId, onSuccess) => (dispatch, getState) => {
  const state = getState();
  const modifierGroupPricingVersions = state.menu.changeData.data.modifierGroupPricingVersions;
  const newModifierGroupPricingVersions = cloneDeep16(
    modifierGroupPricingVersions
  );
  if (Object.values(modifierGroupPricingVersions).length > 1) {
    delete newModifierGroupPricingVersions[pricingVersionId];
    dispatch(
      updateModifierGroup(
        {
          modifierGroupPricingVersions: newModifierGroupPricingVersions
        },
        "association" /* ASSOCIATION */,
        "all" /* ALL */
      )
    );
    onSuccess(Object.keys(newModifierGroupPricingVersions));
  } else {
    dispatch(
      showToast({
        type: "error",
        title: "Cannot remove Pricing Version",
        description: "You need at least one Pricing Version added"
      })
    );
  }
};
var removePricingVersionFromModifierItem = (pricingVersionId, onSuccess) => (dispatch, getState) => {
  const state = getState();
  const modifierItemPricingVersions = state.menu.changeData.data.modifierItemPricingVersions;
  const newModifierItemPricingVersions = cloneDeep16(
    modifierItemPricingVersions
  );
  if (Object.values(newModifierItemPricingVersions).length > 1) {
    delete newModifierItemPricingVersions[pricingVersionId];
    dispatch(
      updateModifierItem(
        {
          modifierItemPricingVersions: newModifierItemPricingVersions
        },
        "pricing" /* PRICING */
      )
    );
    onSuccess(Object.keys(newModifierItemPricingVersions));
  } else {
    dispatch(
      showToast({
        type: "error",
        title: "Cannot remove Pricing Version",
        description: "You need at least one Pricing Version added"
      })
    );
  }
};
var removeModifierItemFromModifierGroup = (modifierItemId) => (dispatch, getState) => {
  const state = getState();
  const modifierGroupData = state.menu.changeData.data;
  const { modifierItems, includedModifierItems, requiredModifierItems } = modifierGroupData;
  const modifierGroupPricingVersions = state.menu.changeData.data.modifierGroupPricingVersions;
  const totalOfModifierItems = Object.values(modifierItems).length;
  const newModifierItems = cloneDeep16(modifierItems);
  const newModifierGroupPricingVersions = cloneDeep16(
    modifierGroupPricingVersions
  );
  delete newModifierItems[modifierItemId];
  const newFormattedModifierGroupPricingVersions = Object.fromEntries(
    Object.entries(newModifierGroupPricingVersions).map((value) => {
      const newModItemPricingVersions = value[1].modItemPricingVersions;
      delete newModItemPricingVersions[modifierItemId];
      return [
        value[0],
        __spreadProps(__spreadValues({}, value[1]), {
          modItemPricingVersions: newModItemPricingVersions
        })
      ];
    })
  );
  dispatch(
    updateModifierGroup(
      {
        modifierItems: newModifierItems,
        modifierGroupPricingVersions: newFormattedModifierGroupPricingVersions,
        includedModifierItems: includedModifierItems > 20 && totalOfModifierItems - 1 < includedModifierItems ? totalOfModifierItems - 1 : includedModifierItems,
        requiredModifierItems: requiredModifierItems > 20 && totalOfModifierItems - 1 < requiredModifierItems ? totalOfModifierItems - 1 : requiredModifierItems
      },
      "association" /* ASSOCIATION */,
      "all" /* ALL */
    )
  );
  dispatch(updateModifierGroup({}, "basic" /* BASIC */));
};
var removeItemFromItemGroup = (itemId) => (dispatch, getState) => {
  const state = getState();
  const items = state.menu.changeData.data.items;
  const newItems = cloneDeep16(items);
  delete newItems[itemId];
  const sortedItems = orderBy5(
    Object.entries(newItems),
    (item) => item[1].sortPriority
  ).map(([key]) => Number(key));
  sortedItems.forEach((key, index) => {
    newItems[key].sortPriority = index + 1;
  });
  dispatch(
    updateItemGroup(
      {
        items: newItems
      },
      "association" /* ASSOCIATION */
    )
  );
};
var associateModifierItemToModifierGroup = (modifierItemsSelected, modifierItems, sectionId) => (dispatch, getState) => {
  const currentMenu = getState().menu.selectedMode.currentMenu;
  const modifierGroupPricingVersions = getState().menu.changeData.data.modifierGroupPricingVersions;
  const newModifierGroupPricingVersions = cloneDeep16(
    modifierGroupPricingVersions
  );
  if (modifierItemsSelected && modifierItemsSelected.length > 0) {
    const sortPriority = Object.values(modifierItems).reduce(
      (acc, modifierItem) => {
        return acc > modifierItem.sortPriority ? acc : modifierItem.sortPriority;
      },
      0
    );
    const newModifierItems = modifierItemsSelected.reduce(
      (acc, modifierItemSelected, index) => {
        const modifierItem = currentMenu.modifierItems[Number(modifierItemSelected.id)];
        return __spreadProps(__spreadValues({}, acc), {
          [Number(modifierItemSelected.id)]: {
            id: modifierItem.id,
            createdAt: modifierItem.createdAt,
            updatedAt: modifierItem.updatedAt,
            deletedAt: modifierItem.deletedAt,
            modifierItemId: modifierItem.modifierItemId,
            posName: modifierItem.posName,
            kdsName: modifierItem.kdsName,
            checkName: modifierItem.checkName,
            description: modifierItem.description,
            defaultModifierItemPricingVersionId: modifierItem.defaultModifierItemPricingVersionId,
            onlineName: modifierItem.onlineName,
            modifierGroupModifierItemId: 0,
            isSelected: false,
            defaultQuantitySelected: 0,
            defaultAmountSelected: "regular",
            requiredModifierItems: 0,
            includedModifierItems: 0,
            sortPriority: sortPriority + index + 1,
            active: modifierItem.active,
            inheritedActive: modifierItem.active,
            locationModifierGroupModifierItemId: 0,
            defaultSelectionPrice: 0
          }
        });
      },
      {}
    );
    const newFormattedModifierGroupPricingVersions = modifierItemsSelected.reduce((acc, modifierItemSelected) => {
      const modifierItem = currentMenu.modifierItems[Number(modifierItemSelected.id)];
      const modifierGroupsPricingVersions = Object.values(acc).length > 0 ? acc : newModifierGroupPricingVersions;
      const newPricingVersionRelations = Object.fromEntries(
        Object.entries(modifierGroupsPricingVersions).map((value) => {
          return [
            value[0],
            __spreadProps(__spreadValues({}, Object(value[1])), {
              modItemPricingVersions: __spreadProps(__spreadValues({}, Object(value[1]).modItemPricingVersions), {
                [modifierItem.modifierItemId]: modifierItem.defaultModifierItemPricingVersionId
              })
            })
          ];
        })
      );
      return __spreadValues(__spreadValues({}, acc), newPricingVersionRelations);
    }, {});
    dispatch(
      updateModifierGroup(
        {
          modifierItems: __spreadValues(__spreadValues({}, modifierItems), newModifierItems),
          modifierGroupPricingVersions: newFormattedModifierGroupPricingVersions
        },
        sectionId,
        "all" /* ALL */
      )
    );
  }
};
var associateItemToItemGroup = (itemsSelected, items) => (dispatch) => {
  if (!itemsSelected || itemsSelected.length === 0) {
    return;
  }
  const newItems = cloneDeep16(items);
  itemsSelected.forEach((newItem) => {
    if (items[Number(newItem.id)]) {
      return;
    }
    const sortPriority = (max3(
      Object.values(newItems || {}).map((item) => item.sortPriority) || []
    ) || 0) + 1;
    newItems[Number(newItem.id)] = __spreadProps(__spreadValues({}, COMBO_ITEM_OF_ITEM_GROUP_INITIAL_STATE), {
      itemId: Number(newItem.id),
      sortPriority
    });
  });
  dispatch(
    updateItemGroup(
      {
        items: newItems
      },
      "association" /* ASSOCIATION */
    )
  );
};
var addBreadCrumbLocation = (location) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    if (location.action === "replace" /* REPLACE */) {
      const breadCrumb = getState().menu.breadCrumb;
      breadCrumb.pop();
      dispatch(setBreadCrumb([...breadCrumb, location]));
    } else if (location.action === "nav-main" /* NAV_MAIN */) {
      dispatch(setBreadCrumb([location]));
    } else if (location.action === "add" /* ADD */) {
      const newLocation = __spreadProps(__spreadValues({}, location), {
        text: `${i18n_config_default.t("commonTexts.adding")} ${location.text}`
      });
      dispatch(setBreadCrumbLocation(newLocation));
    } else if (location.action === "edit" /* EDIT */) {
      const newLocation = __spreadProps(__spreadValues({}, location), {
        text: `${i18n_config_default.t("commonTexts.editing")} ${location.text}`
      });
      dispatch(setBreadCrumbLocation(newLocation));
    } else if (location.action === "mass-update" /* MASS_UPDATE */) {
      const newLocation = __spreadProps(__spreadValues({}, location), {
        text: `${location.text}`
      });
      dispatch(setBreadCrumbLocation(newLocation));
    } else {
      dispatch(setBreadCrumbLocation(location));
    }
    location.onPress();
  });
};
var checkBreadCrumbLocation = (index, onRefresh, organizationId, currentLocationId, licenseId, errorCodesDispatcher, responsive, getBreadcrumbOnPressForId, extraHeaders, omitOnPress) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const breadCrumb = getState().menu.breadCrumb;
    const newBreadCrumb = breadCrumb.slice(0, index + 1);
    if (breadCrumb[index].action === "nav-main") {
      dispatch(
        checkForChangesAndNavigate(
          () => {
            dispatch(setBreadCrumb([breadCrumb[index]]));
            if (!omitOnPress)
              breadCrumb[index].onPress();
          },
          onRefresh,
          organizationId,
          currentLocationId,
          licenseId,
          errorCodesDispatcher,
          responsive,
          getBreadcrumbOnPressForId,
          extraHeaders
        )
      );
    } else {
      dispatch(
        checkForChangesAndNavigate(
          () => {
            dispatch(setBreadCrumb(newBreadCrumb));
            if (!omitOnPress)
              breadCrumb[index].onPress();
          },
          onRefresh,
          organizationId,
          currentLocationId,
          licenseId,
          errorCodesDispatcher,
          responsive,
          getBreadcrumbOnPressForId,
          extraHeaders
        )
      );
    }
  });
};
var breadCrumbPopNavigation = (onRefresh, organizationId, currentLocationId, licenseId, errorCodesDispatcher, responsive, getBreadcrumbOnPressForId, extraHeaders) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const breadCrumb = getState().menu.breadCrumb;
    dispatch(
      checkBreadCrumbLocation(
        breadCrumb.length - 2,
        onRefresh,
        organizationId,
        currentLocationId,
        licenseId,
        errorCodesDispatcher,
        responsive,
        getBreadcrumbOnPressForId,
        extraHeaders
      )
    );
  });
};
var setBreadCrumbStatusPath = (index, statusPath, isItem = false) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const breadCrumb = getState().menu.breadCrumb;
    if (breadCrumb.length >= index + 1) {
      const breadCrumbCopy = [...breadCrumb];
      const newBreadCrumb = breadCrumbCopy[index];
      newBreadCrumb.statusPath = statusPath;
      newBreadCrumb.isItem = isItem;
      breadCrumbCopy[index] = newBreadCrumb;
      dispatch(setBreadCrumb(breadCrumbCopy));
    }
  });
};
var setBreadCrumbIndexData = (index, data) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const breadCrumb = selectBreadCrumbs(getState());
    if (breadCrumb.length >= index + 1) {
      const breadCrumbCopy = cloneDeep16(breadCrumb);
      breadCrumbCopy[index] = __spreadValues(__spreadValues({}, breadCrumbCopy[index]), data);
      dispatch(setBreadCrumb(breadCrumbCopy));
    }
  });
};
var checkForForbiddenBucket = (onContinue) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const { bucketSelected, mode } = getState().menu.changeData;
    if (bucketSelected && BUCKET_FORBIDDEN_TO_CHANGE_LOCATION.includes(bucketSelected) && mode === "create" /* CREATE */) {
      return dispatch(showForbiddenChangeLocationToast());
    }
    onContinue && onContinue();
  });
};
var updateFreshSheetDifferences = () => {
  return (dispatch, getState) => {
    const state = getState();
    const { data, originalData } = state.menu.changeFreshSheetData;
    const differences = diff(originalData, data) || [];
    const hasChanges = differences && differences.length > 0;
    const finalDiffObject = hasChanges ? diffFreshSheetFactory(differences, state) : null;
    dispatch(
      updateChangeFreshSheetDataValues({
        differences,
        finalDiffObject: { items: finalDiffObject },
        hasChanges
      })
    );
    return hasChanges;
  };
};
var itemsMassUpdateDifferences = (onRefresh, organizationId, currentLocationId, licenseId, errorCodesDispatcher, responsive, extraHeaders, onContinue) => {
  return (dispatch, getState) => {
    const state = getState();
    const breadcrumbs = selectBreadCrumbs(state);
    const { data } = state.menu.changeMassUpdateData;
    const obj = getItemMassUpdateDataWithoutMasterProperties(
      data
    );
    const differences = getItemMassUpdateDifferences(data);
    const hasChanges = differences && differences.length > 0;
    if (!hasChanges) {
      dispatch(resetChangeMassUpdateData());
      onContinue && onContinue();
      return hasChanges;
    }
    dispatch(
      updateChangeMassUpdateDataValues({
        differences,
        finalDiffObject: diffItemsFactory(0, differences, obj, state, true)
      })
    );
    dispatch(
      setShowConfirmationModal({
        title: i18n_config_default.t("app.modals.diffModal.reviewChanges"),
        type: "diff",
        btnCancelText: i18n_config_default.t("app.modals.discardChangesConfirmation.title"),
        btnSuccessText: i18n_config_default.t("commonButtons.save"),
        description: `${i18n_config_default.t(
          "app.modals.infoConfirmationModal.unsavedChanges"
        )} ${i18n_config_default.t("app.modals.diffModal.descriptionForSave")}`,
        active: true,
        onCancel: () => {
          !onContinue && dispatch(resetMassUpdateMenuChanges(MASS_UPDATE_INITIAL_STATE));
          onContinue && dispatch(resetChangeMassUpdateData());
          onContinue && onContinue();
        },
        onSuccess: () => {
          const onSuccessFn = () => __async(void 0, null, function* () {
            var _a, _b;
            yield dispatch(
              itemMassUpdateEndpoint(
                onRefresh,
                organizationId,
                currentLocationId,
                licenseId,
                errorCodesDispatcher,
                responsive,
                extraHeaders,
                2
              )
            );
            dispatch(resetChangeMassUpdateData());
            (_b = (_a = breadcrumbs[0]).onPress) == null ? void 0 : _b.call(_a);
            dispatch(setBreadCrumb([breadcrumbs[0]]));
          });
          onSuccessFn();
        }
      })
    );
    return hasChanges;
  };
};
var setFreshSheetDataFromMenu = () => {
  return (dispatch, getState) => {
    const state = getState();
    const items = state.menu.selectedMode.currentMenu.items;
    const freshSheetData = {
      items: freshSheetItemsFactoryCore(items, state)
    };
    dispatch(
      setChangeFreshSheetData({
        data: cloneDeep16(freshSheetData),
        originalData: cloneDeep16(freshSheetData),
        finalDiffObject: null,
        hasChanges: false,
        differences: [],
        errors: {},
        sectionId: "all" /* ALL */
      })
    );
  };
};
var checkForFreshSheetChangesAndNavigate = (onContinue, organizationId, currentLocationId, licenseId, errorCodesDispatcher, responsive, extraHeaders, onContinueResetChangeData = true) => {
  return (dispatch) => __async(void 0, null, function* () {
    batch$1(() => {
      const hasChanges = dispatch(updateFreshSheetDifferences());
      if (!hasChanges) {
        onContinueResetChangeData && dispatch(resetChangeFreshSheetData());
        onContinue();
        return;
      }
      dispatch(
        setShowConfirmationModal({
          title: i18n_config_default.t("validations.unsavedChanges"),
          description: i18n_config_default.t(
            "menuScreen.freshSheetDetails.unsavedChangesModal.description"
          ),
          type: "warning",
          active: true,
          btnTerciaryText: i18n_config_default.t(
            "app.modals.discardChangesConfirmation.title"
          ),
          btnSuccessText: i18n_config_default.t("commonButtons.save"),
          onSuccess: () => __async(void 0, null, function* () {
            const success = yield dispatch(
              updateFreshSheetEndpoint(
                organizationId,
                currentLocationId,
                licenseId,
                errorCodesDispatcher,
                extraHeaders
              )
            );
            if (success) {
              if (onContinueResetChangeData)
                dispatch(resetChangeFreshSheetData());
              onContinue && onContinue();
            }
          }),
          onTerciaryButtonPress: () => {
            dispatch(resetChangeFreshSheetData());
            onContinue && onContinue();
          },
          height: responsive(400),
          size: responsive(800)
        })
      );
    });
  });
};
var checkForMassUpdateChangesAndNavigate = (onContinue, onRefresh, organizationId, currentLocationId, licenseId, errorCodesDispatcher, responsive, extraHeaders) => {
  return (dispatch) => __async(void 0, null, function* () {
    dispatch(
      itemsMassUpdateDifferences(
        onRefresh,
        organizationId,
        currentLocationId,
        licenseId,
        errorCodesDispatcher,
        responsive,
        extraHeaders,
        onContinue
      )
    );
  });
};
var updateFinalDiffObject = (differences) => {
  return (dispatch, getState) => {
    const state = getState();
    const { bucketSelected, id, data } = selectChangeData(state);
    if (bucketSelected === "items") {
      dispatch(
        updateChangeDataValues({
          differences,
          finalDiffObject: diffItemsFactory(
            id,
            differences,
            data,
            state
          )
        })
      );
    } else if (bucketSelected === "combos") {
      dispatch(
        updateChangeDataValues({
          differences,
          finalDiffObject: diffCombosFactory(differences, state)
        })
      );
    } else if (bucketSelected === "specials") {
      dispatch(
        updateChangeDataValues({
          differences,
          finalDiffObject: diffSpecialsFactory(differences, state)
        })
      );
    } else {
      dispatch(
        updateChangeDataValues({
          differences
        })
      );
    }
  };
};
var updateMassUpdateFinalDiffObject = (differences) => {
  return (dispatch, getState) => {
    const state = getState();
    const { bucketSelected, data } = selectChangeDataOrChangeMassUpdateData(state);
    if (bucketSelected === "items") {
      dispatch(
        updateChangeMassUpdateDataValues({
          differences,
          finalDiffObject: diffItemsFactory(
            0,
            differences,
            getItemMassUpdateDataWithoutMasterProperties(data),
            state,
            true
          )
        })
      );
    } else {
      dispatch(
        updateChangeMassUpdateDataValues({
          differences
        })
      );
    }
  };
};
var checkForChangesAndNavigate = (onContinue, onRefresh, organizationId, currentLocationId, licenseId, errorCodesDispatcher, responsive, getBreadcrumbOnPressForId, extraHeaders, onContinueResetChangeData = true, isSavePressed = false, mustCreateBeforeLeave) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const { bucketSelected, data, mode, hasChanges } = selectChangeData(state);
    const isCreation = mode === "create" /* CREATE */;
    const freshSheetData = state.menu.changeFreshSheetData.data;
    const massUpdateData = state.menu.changeMassUpdateData.data;
    if (freshSheetData) {
      return dispatch(
        checkForFreshSheetChangesAndNavigate(
          onContinue,
          organizationId,
          currentLocationId,
          licenseId,
          errorCodesDispatcher,
          responsive,
          extraHeaders,
          onContinueResetChangeData
        )
      );
    } else if (massUpdateData) {
      const isValid2 = yield dispatch(
        checkMassUpdateFormValidation(massUpdateData, true, onContinue)
      );
      if (!isValid2) {
        return;
      }
      return dispatch(
        checkForMassUpdateChangesAndNavigate(
          onContinue,
          onRefresh,
          organizationId,
          currentLocationId,
          licenseId,
          errorCodesDispatcher,
          responsive,
          extraHeaders
        )
      );
    }
    if (!data) {
      onContinue();
      return;
    }
    if (!bucketSelected) {
      return;
    }
    const fn = menuBucketValidationThunks(
      bucketSelected,
      data,
      true,
      onContinue
    );
    const isValid = yield dispatch(fn);
    if (!isValid) {
      return;
    }
    if (bucketSelected && (!mustCreateBeforeLeave || mustCreateBeforeLeave && !isCreation)) {
      let originData = selectOriginalMenuData(state);
      if (bucketSelected === "items") {
        originData = preMakeItemWithModifierGroups(originData, state.menu);
      }
      const onDiscard = () => {
        if (isSavePressed)
          return;
        if (onContinueResetChangeData)
          dispatch(resetChangeData());
        onContinue();
      };
      const save = () => {
        let differences = diff(originData, data);
        if (!differences) {
          const changeData = selectChangeData(state);
          dispatch(setChangeData(__spreadProps(__spreadValues({}, changeData), { hasChanges: false })));
          onContinueResetChangeData && !isSavePressed && dispatch(resetChangeData());
          onContinue();
          return;
        }
        differences = filterDifferencesByBucket(
          bucketSelected,
          differences,
          state.menu,
          state
        );
        if (differences.length === 0) {
          onContinueResetChangeData && dispatch(resetChangeData());
          onContinue();
          return;
        }
        batch$1(() => {
          dispatch(updateFinalDiffObject(differences));
          const showLocationSelectionModal = shouldShowLocationsModalOnSaveCore(
            differences,
            state,
            dispatch
          );
          dispatch(
            setShowConfirmationModal({
              title: i18n_config_default.t("app.modals.diffModal.reviewChanges"),
              type: "diff",
              btnCancelText: isSavePressed ? "" : i18n_config_default.t("app.modals.discardChangesConfirmation.title"),
              btnSuccessText: showLocationSelectionModal ? "" : i18n_config_default.t("commonButtons.save"),
              description: showLocationSelectionModal ? `${i18n_config_default.t("app.modals.diffModal.youHaveUnsavedChanges", {
                bucket: i18n_config_default.t(
                  `menuScreen.common.bucket.${bucketSelected}.singular`
                )
              })} ${i18n_config_default.t("app.modals.diffModal.descripTionForContinue")}` : `${i18n_config_default.t("app.modals.diffModal.youHaveUnsavedChanges", {
                bucket: i18n_config_default.t(
                  `menuScreen.common.bucket.${bucketSelected}.singular`
                )
              })} ${i18n_config_default.t("app.modals.diffModal.descriptionForSave")}`,
              active: true,
              onSuccess: () => {
                const onSuccessFn = () => __async(void 0, null, function* () {
                  const success = yield dispatch(
                    updateDataByBucket(
                      bucketSelected,
                      onRefresh,
                      organizationId,
                      currentLocationId,
                      licenseId,
                      errorCodesDispatcher,
                      responsive,
                      getBreadcrumbOnPressForId,
                      extraHeaders
                    )
                  );
                  if (!success) {
                    return;
                  }
                  onContinue();
                });
                if (showLocationSelectionModal) {
                  dispatch(
                    setShowConfirmationModal({
                      title: "",
                      type: "locationSelection",
                      active: true,
                      onSuccess: onSuccessFn
                    })
                  );
                } else {
                  onSuccessFn();
                }
              },
              onCancel: onDiscard
            })
          );
        });
      };
      if (bucketSelected === "items" && isCreation) {
        const itemName = data.name;
        const items = selectItems(state);
        const similarItemIds = getSimilarNameItemIds(items, itemName);
        const itemsCount = similarItemIds.length;
        if (itemsCount > 0) {
          return dispatch(
            setShowConfirmationModal({
              title: i18n_config_default.t("app.modals.similarItems.title", {
                count: itemsCount
              }),
              description: i18n_config_default.t("app.modals.similarItems.description", {
                count: itemsCount
              }),
              btnSuccessText: i18n_config_default.t("app.modals.similarItems.btnSuccessText"),
              onCancel: () => dispatch(
                setShowConfirmationModal(CONFIRMATION_MODAL_INITIAL_STATE)
              ),
              onSuccess: save,
              onTerciaryButtonPress: !isSavePressed ? () => {
                onDiscard();
                dispatch(
                  setShowConfirmationModal(
                    CONFIRMATION_MODAL_INITIAL_STATE
                  )
                );
              } : void 0,
              btnTerciaryText: isSavePressed ? "" : i18n_config_default.t("app.modals.discardChangesConfirmation.title"),
              type: "similarItems" /* similarItems */,
              active: true,
              items: menuItemTableFactoryCore(
                pickBy(items, (_, id) => similarItemIds.includes(Number(id))),
                selectCategories(state),
                selectSubcategories(state),
                selectMenuTypes(state),
                currentTaxesSettingsSelector(state),
                selectModifierGroups(state),
                currentPrepStationsSelector(state),
                selectReportingGroups(state)
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
              ).map((_a) => {
                var _b = _a, item = __objRest(_b, ["children"]);
                return __spreadProps(__spreadValues({}, item), { children: [] });
              })
            })
          );
        }
      }
      save();
    } else if (isCreation && mustCreateBeforeLeave) {
      dispatch(
        setShowConfirmationModal({
          title: i18n_config_default.t("menuScreen.common.preventLeaveModal.title"),
          description: i18n_config_default.t(
            `menuScreen.common.preventLeaveModal.${mustCreateBeforeLeave}`
          ),
          type: "warning",
          active: true,
          btnCancelText: i18n_config_default.t("app.modals.creationConfirmation.continue"),
          onSuccess: () => null,
          hideSuccess: true,
          height: responsive(300)
        })
      );
      return;
    } else if (!hasChanges) {
      if (onContinueResetChangeData)
        dispatch(resetChangeData());
      onContinue();
    }
  });
};
var updateDataByBucket = (bucketSelected, onRefresh, organizationId, currentLocationId, licenseId, errorCodesDispatcher, responsive, getBreadcrumbOnPressForId, extraHeaders) => (dispatch) => __async(void 0, null, function* () {
  dispatch(setShowConfirmationModal(CONFIRMATION_MODAL_INITIAL_STATE));
  return (yield dispatch(
    createBucketElement(
      onRefresh,
      organizationId,
      currentLocationId,
      licenseId,
      errorCodesDispatcher,
      responsive,
      getBreadcrumbOnPressForId,
      extraHeaders,
      void 0,
      void 0
    )
  )).success;
});
var filterDifferencesByBucket = (bucketSelected, differences, menuStore, state) => {
  var _a, _b, _c;
  const hasSomeItemIds = differences.some(
    (difference3) => difference3.path[0] === "itemIds"
  );
  const hasSomeComboIds = differences.some(
    (difference3) => difference3.path[0] === "comboIds"
  );
  const data = menuStore.changeData.data;
  const currentMenu = menuStore.selectedMode.currentMenu;
  const id = menuStore.changeData.id;
  const originalData = (_a = currentMenu[bucketSelected]) == null ? void 0 : _a[id];
  if (bucketSelected === "items") {
    differences = differences.filter((difference3) => {
      if (itemIgnoredFields.includes(difference3.path[difference3.path.length - 1]))
        return false;
      if (difference3.path.length === 7 && difference3.path[difference3.path.length - 1] === "sortPriority")
        return false;
      else
        return true;
    });
  } else if (bucketSelected === "specials") {
    const hasSomeLocationIds = differences.some(
      (difference3) => difference3.path[0] === "locationIds"
    );
    differences = differences.filter(
      (difference3) => difference3.path[0] !== "locationIds"
    );
    if (hasSomeLocationIds) {
      const specialLocationIds = currentMenu.specials[id].locationIds;
      const locationChanges = getLocationsChanges(
        hasSomeLocationIds,
        specialLocationIds,
        data.locationIds,
        state
      );
      if (locationChanges.length > 0) {
        differences.push({
          kind: "A",
          path: ["locationIds"]
        });
      }
    }
  } else if (bucketSelected === "menuTypes") {
    const hasSomeCategoryIds = differences.some(
      (difference3) => difference3.path[0] === "categoryIds"
    );
    const { itemsChanges, categoriesChanges, combosChanges } = getItemsCombosAndCategoriesChanges(
      hasSomeCategoryIds,
      hasSomeItemIds,
      hasSomeComboIds,
      state
    );
    differences = differences.filter(
      (difference3) => difference3.path[0] !== "itemIds" && difference3.path[0] !== "categoryIds" && difference3.path[0] !== "comboIds" && difference3.path[0] !== "itemMenuTypeTemplateIds" && difference3.path[0] !== "comboMenuTypeTemplateIds"
    );
    if (itemsChanges.length > 0) {
      differences.push({
        kind: "A",
        path: ["itemIds"]
      });
    }
    if (categoriesChanges.length > 0) {
      differences.push({
        kind: "A",
        path: ["categoryIds"]
      });
    }
    if (combosChanges.length > 0) {
      differences.push({
        kind: "A",
        path: ["comboIds"]
      });
    }
  } else if (bucketSelected === "categories") {
    const associationsChanges = getCategoryAssociationsChanges(state);
    const hasItemChanges = associationsChanges.items.length > 0;
    const hasComboChanges = associationsChanges.combos.length > 0;
    const hasSubcategoryItemChanges = associationsChanges.subcategories.some(
      (change) => change.field === "subcategoryMenuTypeItemsIds"
    );
    const hasSubcategoryComboChanges = associationsChanges.subcategories.some(
      (change) => change.field === "subcategoryMenuTypeCombosIds"
    );
    differences = differences.filter(
      (difference3) => difference3.path[0] !== "itemIds" && difference3.path[0] !== "comboIds" && difference3.path[0] !== "menuTypeItemIds" && difference3.path[0] !== "menuTypeComboIds" && difference3.path[0] !== "subcategoryMenuTypeItemsIds" && difference3.path[0] !== "subcategoryMenuTypeCombosIds"
    );
    if (hasItemChanges) {
      differences.push({
        kind: "A",
        path: ["itemIds"]
      });
    }
    if (hasComboChanges) {
      differences.push({
        kind: "A",
        path: ["comboIds"]
      });
    }
    if (hasSubcategoryItemChanges) {
      differences.push({
        kind: "A",
        path: ["subcategoryMenuTypeItemsIds"]
      });
    }
    if (hasSubcategoryComboChanges) {
      differences.push({
        kind: "A",
        path: ["subcategoryMenuTypeCombosIds"]
      });
    }
  } else if (bucketSelected === "subcategories") {
    const associationsChanges = getSubcategoryAssociationsChanges(
      state,
      "subcategories"
    );
    const hasItemChanges = associationsChanges.some(
      (change) => change.field === "itemIds"
    );
    const hasComboChanges = associationsChanges.some(
      (change) => change.field === "comboIds"
    );
    differences = differences.filter(
      (difference3) => difference3.path[0] !== "itemIds" && difference3.path[0] !== "comboIds" && difference3.path[0] !== "menuTypeItemIds" && difference3.path[0] !== "menuTypeComboIds"
    );
    if (hasItemChanges) {
      differences.push({
        kind: "A",
        path: ["itemIds"]
      });
    }
    if (hasComboChanges) {
      differences.push({
        kind: "A",
        path: ["comboIds"]
      });
    }
  } else if (bucketSelected === "modifierGroups") {
    differences = differences.filter((difference3) => {
      const field = difference3.path[difference3.path.length - 1];
      if (difference3.path.length === 3 && modifierGroupIgnoredModifierGroupModifierItemFields.includes(field)) {
        return false;
      }
      return !modifierGroupIgnoredModifierItemsOfModifierGroupFields.includes(
        field
      );
    });
  } else if (bucketSelected === "modifierItems") {
    const parentModifierGroupChanges = getArrayNumberChanges(
      (_b = originalData == null ? void 0 : originalData.parentModifierGroupIds) != null ? _b : [],
      (_c = data == null ? void 0 : data.parentModifierGroupIds) != null ? _c : []
    );
    differences = differences.filter((difference3) => {
      if (difference3.path[0] === "parentModifierGroupIds") {
        return false;
      }
      if (modifierItemIgnoredModifierGroupOfModifierItemFields.includes(
        difference3.path[difference3.path.length - 1]
      ))
        return false;
      if (difference3.path.length === 5 && (difference3.path[difference3.path.length - 1] === "defaultModifierGroupPricingVersionId" || difference3.path[difference3.path.length - 1] === "sortPriority"))
        return false;
      else
        return true;
    });
    if (parentModifierGroupChanges.length > 0) {
      differences.push({
        path: ["parentModifierGroupIds"],
        kind: "A"
      });
    }
  } else if (bucketSelected === "reportingGroups") {
    const diffObject = diffReportingGroupFactory(differences, state);
    if (!diffObject || Object.values(diffObject).every((_diff) => _diff.length === 0)) {
      differences = [];
    }
  }
  return differences;
};
var getLocationsToApply = () => (_, getState) => {
  const state = getState();
  const { changeData, changeMassUpdateData } = selectMenuState(state);
  const menuAccessLocations = selectLoggedInUserMenuAccessLocations(state);
  const isMasterMode = selectIsMenuMasterMode(state);
  const currentLocationId = selectSelectedModeId(state);
  const isMassUpdate = !!changeMassUpdateData.data;
  const bucketSelected = isMassUpdate ? changeMassUpdateData.bucketSelected : changeData.bucketSelected;
  const hasAccessToMasterMenu = selectHasLoggedInUserAccessToMasterMenu(state);
  if (!bucketSelected)
    return [];
  const locationSetId = new Set(menuAccessLocations);
  const locationList = selectLocationListIds(state);
  return [
    ...hasAccessToMasterMenu && !isMasterMode ? [0] : [],
    ...locationList.filter(
      (id) => locationSetId.has(id) && menuAccessLocations.includes(id) && id !== currentLocationId
    )
  ];
};
var menuBucketValidationThunks = (bucketName, data, canDiscard, onContinue) => {
  switch (bucketName) {
    case "items":
      return checkItemFormValidation(data, canDiscard, onContinue);
    case "menuTypes":
      return checkMenuTypeFormValidation(
        data,
        canDiscard,
        onContinue
      );
    case "subcategories":
      return checkSubcategoryFormValidation(
        data,
        canDiscard,
        onContinue
      );
    case "categories":
      return checkCategoryFormValidation(
        data,
        canDiscard,
        onContinue
      );
    case "modifierItems":
      return checkModifierItemFormValidation(
        data,
        canDiscard,
        onContinue
      );
    case "modifierGroups":
      return checkModifierGroupFormValidation(
        data,
        canDiscard,
        onContinue
      );
    case "discounts":
      return checkDiscountFormValidation(
        data,
        canDiscard,
        onContinue
      );
    case "ingredients":
      return checkIngredientFormValidation(
        data,
        canDiscard,
        onContinue
      );
    case "combos":
      return checkComboFormValidation(data, canDiscard, onContinue);
    case "specials":
      return checkSpecialFormValidation(
        data,
        canDiscard,
        onContinue
      );
    case "itemGroups":
      return checkItemGroupFormValidation(
        data,
        canDiscard,
        onContinue
      );
    case "reportingGroups":
      return checkReportingGroupFormValidation(
        data,
        canDiscard,
        onContinue
      );
    default:
      return checkBucketValidation();
  }
};
var checkBucketValidation = () => () => {
  return Promise.resolve(true);
};
var checkItemFormValidation = (data, canDiscard, onContinue) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const categories = selectMenu(state).categories;
  const items = selectMenu(state).items;
  const itemId = selectChangeDataId(state);
  let itemYupErrors = null;
  try {
    yield itemSchema(items, itemId).validate(data, {
      abortEarly: false,
      context: {
        categories
      }
    });
  } catch (error) {
    itemYupErrors = getErrorMessages(error);
  }
  const itemErrors = {};
  Object.entries(itemYupErrors || {}).forEach(([errorPath, error]) => {
    setWith(itemErrors, errorPath, error, Object);
  });
  if (Object.keys(itemErrors).length > 0) {
    dispatch(setErrors(itemErrors));
    dispatch(
      setShowConfirmationModal({
        title: "",
        active: true,
        type: canDiscard ? "validationDiscard" : "validation",
        btnSuccessText: i18n_config_default.t("commonButtons.ok"),
        onSuccess: () => {
          dispatch(resetChangeData());
          onContinue && onContinue();
        }
      })
    );
    return Promise.resolve(false);
  }
  dispatch(setErrors({}));
  return Promise.resolve(true);
});
var checkReportingGroupFormValidation = (data, canDiscard, onContinue) => (dispatch) => __async(void 0, null, function* () {
  let reportingGroupYupErrors = null;
  try {
    yield reportingGroupSchema.validate(data, {
      abortEarly: false
    });
  } catch (error) {
    reportingGroupYupErrors = getErrorMessages(error);
  }
  const reportingGroupErrors = {};
  Object.entries(reportingGroupYupErrors || {}).forEach(
    ([errorPath, error]) => {
      setWith(reportingGroupErrors, errorPath, error, Object);
    }
  );
  if (Object.keys(reportingGroupErrors).length > 0) {
    dispatch(setErrors(reportingGroupErrors));
    dispatch(
      setShowConfirmationModal({
        title: "",
        active: true,
        type: canDiscard ? "validationDiscard" : "validation",
        btnSuccessText: i18n_config_default.t("commonButtons.ok"),
        onSuccess: () => {
          dispatch(resetChangeData());
          onContinue && onContinue();
        }
      })
    );
    return Promise.resolve(false);
  }
  dispatch(setErrors({}));
  return Promise.resolve(true);
});
var checkMassUpdateFormValidation = (data, canDiscard, onContinue) => (dispatch) => __async(void 0, null, function* () {
  let itemErrors = null;
  try {
    yield massUpdateItemSchema.validate(data, {
      abortEarly: false
    });
  } catch (error) {
    itemErrors = getErrorMessages(error);
  }
  if (itemErrors && "suggestiveOrdering" in itemErrors && itemErrors.suggestiveOrdering === 'suggestiveOrdering must be a `boolean` type, but the final value was: `"\xABNo Changes\xBB"`.') {
    delete itemErrors.suggestiveOrdering;
  }
  if (Object.keys(itemErrors || {}).length > 0) {
    dispatch(setMassUpdateErrors(itemErrors || {}));
    dispatch(
      setShowConfirmationModal({
        title: "",
        active: true,
        type: canDiscard ? "validationDiscard" : "validation",
        btnSuccessText: i18n_config_default.t("commonButtons.ok"),
        onSuccess: () => {
          dispatch(resetChangeMassUpdateData());
          onContinue && onContinue();
        }
      })
    );
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var checkComboFormValidation = (data, canDiscard, onContinue) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const categories = selectMenu(state).categories;
  let comboYupErrors = null;
  try {
    yield comboSchema.validate(data, {
      abortEarly: false,
      context: {
        categories
      }
    });
  } catch (error) {
    comboYupErrors = getErrorMessages(error);
  }
  const comboErrors = {};
  Object.entries(comboYupErrors || {}).forEach(([errorPath, error]) => {
    setWith(comboErrors, errorPath, error, Object);
  });
  if (Object.keys(comboErrors).length > 0) {
    dispatch(setErrors(comboErrors));
    dispatch(
      setShowConfirmationModal({
        title: "",
        active: true,
        type: canDiscard ? "validationDiscard" : "validation",
        btnSuccessText: i18n_config_default.t("commonButtons.ok"),
        onSuccess: () => {
          dispatch(resetChangeData());
          onContinue && onContinue();
        }
      })
    );
    return Promise.resolve(false);
  }
  dispatch(setErrors({}));
  return Promise.resolve(true);
});
var checkSpecialFormValidation = (data, canDiscard, onContinue) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  let specialYupErrors = null;
  try {
    yield specialSchema(state).validate(data, {
      abortEarly: false
    });
  } catch (error) {
    specialYupErrors = getErrorMessages(error);
  }
  const specialErrors = {};
  Object.entries(specialYupErrors || {}).forEach(([errorPath, error]) => {
    setWith(specialErrors, errorPath, error, Object);
  });
  if (Object.keys(specialErrors).length > 0) {
    dispatch(setErrors(specialErrors));
    dispatch(
      setShowConfirmationModal({
        title: "",
        active: true,
        type: canDiscard ? "validationDiscard" : "validation",
        btnSuccessText: i18n_config_default.t("commonButtons.ok"),
        onSuccess: () => {
          dispatch(resetChangeData());
          onContinue && onContinue();
        }
      })
    );
    return Promise.resolve(false);
  }
  dispatch(setErrors({}));
  return Promise.resolve(true);
});
var checkItemGroupFormValidation = (data, canDiscard, onContinue) => (dispatch) => __async(void 0, null, function* () {
  let itemGroupYupErrors = null;
  try {
    yield itemGroupSchema.validate(data, {
      abortEarly: false
    });
  } catch (error) {
    itemGroupYupErrors = getErrorMessages(error);
  }
  const itemGroupErrors = {};
  Object.entries(itemGroupYupErrors || {}).forEach(([errorPath, error]) => {
    setWith(itemGroupErrors, errorPath, error, Object);
  });
  if (Object.keys(itemGroupErrors).length > 0) {
    dispatch(setErrors(itemGroupErrors));
    dispatch(
      setShowConfirmationModal({
        title: "",
        active: true,
        type: canDiscard ? "validationDiscard" : "validation",
        btnSuccessText: i18n_config_default.t("commonButtons.ok"),
        onSuccess: () => {
          dispatch(resetChangeData());
          onContinue && onContinue();
        }
      })
    );
    return Promise.resolve(false);
  }
  dispatch(setErrors({}));
  return Promise.resolve(true);
});
var checkMenuTypeFormValidation = (data, canDiscard, onContinue) => (dispatch) => __async(void 0, null, function* () {
  let menuTypeErrors = {};
  try {
    yield menuTypeSchema.validate(data, {
      abortEarly: false
    });
  } catch (error) {
    menuTypeErrors = getErrorMessages(error);
  }
  if (Object.keys(menuTypeErrors).length > 0) {
    dispatch(setErrors(menuTypeErrors));
    dispatch(
      setShowConfirmationModal({
        title: "",
        active: true,
        type: canDiscard ? "validationDiscard" : "validation",
        btnSuccessText: i18n_config_default.t("commonButtons.ok"),
        onSuccess: () => {
          dispatch(resetChangeData());
          onContinue && onContinue();
        }
      })
    );
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var checkSubcategoryFormValidation = (data, canDiscard, onContinue) => (dispatch) => __async(void 0, null, function* () {
  let subcategoryErrors = {};
  try {
    yield subcategorySchema.validate(data, {
      abortEarly: false
    });
  } catch (error) {
    subcategoryErrors = getErrorMessages(error);
  }
  if (Object.keys(subcategoryErrors).length > 0) {
    dispatch(setErrors(subcategoryErrors));
    dispatch(
      setShowConfirmationModal({
        title: "",
        active: true,
        type: canDiscard ? "validationDiscard" : "validation",
        btnSuccessText: i18n_config_default.t("commonButtons.ok"),
        onSuccess: () => {
          dispatch(resetChangeData());
          onContinue && onContinue();
        }
      })
    );
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var checkCategoryFormValidation = (data, canDiscard, onContinue) => (dispatch) => __async(void 0, null, function* () {
  let categoryErrors = {};
  try {
    yield categorySchema.validate(data, {
      abortEarly: false
    });
  } catch (error) {
    categoryErrors = getErrorMessages(error);
  }
  if (Object.keys(categoryErrors).length > 0) {
    dispatch(setErrors(categoryErrors));
    dispatch(
      setShowConfirmationModal({
        title: "",
        active: true,
        type: canDiscard ? "validationDiscard" : "validation",
        btnSuccessText: i18n_config_default.t("commonButtons.ok"),
        onSuccess: () => {
          dispatch(resetChangeData());
          onContinue && onContinue();
        }
      })
    );
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var checkModifierItemFormValidation = (data, canDiscard, onContinue) => (dispatch) => __async(void 0, null, function* () {
  let modifierItemErrors = {};
  try {
    yield modifierItemSchema.validate(data, {
      abortEarly: false
    });
  } catch (error) {
    modifierItemErrors = getErrorMessages(error);
  }
  if (Object.keys(modifierItemErrors).length > 0) {
    dispatch(setErrors(modifierItemErrors));
    dispatch(
      setShowConfirmationModal({
        title: "",
        active: true,
        type: canDiscard ? "validationDiscard" : "validation",
        btnSuccessText: i18n_config_default.t("commonButtons.ok"),
        onSuccess: () => {
          dispatch(resetChangeData());
          onContinue && onContinue();
        }
      })
    );
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var checkModifierGroupFormValidation = (data, canDiscard, onContinue) => (dispatch) => __async(void 0, null, function* () {
  let modifierGroupErrors = {};
  try {
    yield modifierGroupSchema.validate(data, {
      abortEarly: false
    });
  } catch (error) {
    modifierGroupErrors = getErrorMessages(error);
  }
  if (Object.keys(modifierGroupErrors).length > 0) {
    dispatch(setErrors(modifierGroupErrors));
    dispatch(
      setShowConfirmationModal({
        title: "",
        active: true,
        type: canDiscard ? "validationDiscard" : "validation",
        btnSuccessText: i18n_config_default.t("commonButtons.ok"),
        onSuccess: () => {
          dispatch(resetChangeData());
          onContinue && onContinue();
        }
      })
    );
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var checkDiscountFormValidation = (data, canDiscard, onContinue) => (dispatch) => __async(void 0, null, function* () {
  let discountErrors = {};
  try {
    yield discountSchema.validate(data, {
      abortEarly: false
    });
  } catch (error) {
    discountErrors = getErrorMessages(error);
  }
  if (Object.keys(discountErrors).length > 0) {
    dispatch(setErrors(discountErrors));
    dispatch(
      setShowConfirmationModal({
        title: "",
        active: true,
        type: canDiscard ? "validationDiscard" : "validation",
        btnSuccessText: i18n_config_default.t("commonButtons.ok"),
        onSuccess: () => {
          dispatch(resetChangeData());
          onContinue && onContinue();
        }
      })
    );
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var checkIngredientFormValidation = (data, canDiscard, onContinue) => (dispatch) => __async(void 0, null, function* () {
  let ingredientErrors = {};
  try {
    yield ingredientSchema.validate(data, {
      abortEarly: false
    });
  } catch (error) {
    ingredientErrors = getErrorMessages(error);
  }
  if (Object.keys(ingredientErrors).length > 0) {
    dispatch(setErrors(ingredientErrors));
    dispatch(
      setShowConfirmationModal({
        title: "",
        active: true,
        type: canDiscard ? "validationDiscard" : "validation",
        btnSuccessText: i18n_config_default.t("commonButtons.ok"),
        onSuccess: () => {
          dispatch(resetChangeData());
          onContinue && onContinue();
        }
      })
    );
    return Promise.resolve(false);
  }
  return Promise.resolve(true);
});
var getCurrentEditingElement = () => (_, getState) => {
  const state = getState();
  const { bucketSelected, id } = state.menu.changeData;
  return bucketSelected ? state.menu.selectedMode.currentMenu[bucketSelected][id] : null;
};
var getDataFromChangeData = () => (_, getState) => {
  const state = getState();
  if (state.menu.changeMassUpdateData.data)
    return state.menu.changeMassUpdateData.data;
  const { bucketSelected, data } = state.menu.changeData;
  return bucketSelected ? data : null;
};
var addNewMenuTypesToItem = (menuTypeIds, selectedMenuTypeVersionId, onSuccess, isCombo = false, categoryId = 0, subcategoryId = -1) => (dispatch, getState) => {
  var _a;
  const state = getState();
  const isCreation = selectIsMenuCreationMode(state);
  const items = selectItems(state);
  const menuTypes = selectMenuTypes(state);
  const currentMenuTypes = (_a = state.menu.changeData.data) == null ? void 0 : _a.menuTypeVersions;
  const menuTypeVersionData = cloneDeep16(
    selectedMenuTypeVersionId && currentMenuTypes ? currentMenuTypes[selectedMenuTypeVersionId] : isCombo ? COMBO_MENU_TYPE_VERSION_INITIAL_STATE : MENU_TYPE_VERSION_INITIAL_STATE
  );
  const menuTypeVersionTemp = {};
  menuTypeIds.map((menuTypeId) => {
    menuTypeVersionTemp[Number(menuTypeId.id)] = __spreadProps(__spreadValues({}, menuTypeVersionData), {
      menuTypeId: menuTypeId.id,
      categoriesSubcategories: categoryId ? {
        [isCreation ? 1 : generateTabletGeneratedId()]: {
          categoryId,
          subcategoryId: subcategoryId > -1 ? subcategoryId : null
        }
      } : menuTypeVersionData.categoriesSubcategories
    });
    if (isCombo) {
      const typedMenuTypeCombo = menuTypeVersionTemp[Number(menuTypeId.id)];
      Object.entries(typedMenuTypeCombo.itemGroups || {}).forEach(
        ([itemGroupId, itemGroup]) => {
          Object.keys(itemGroup.items || {}).forEach((itemId) => {
            if (!items[Number(itemId)].menuTypeVersions[Number(menuTypeId.id)]) {
              delete typedMenuTypeCombo.itemGroups[Number(itemGroupId)].items[Number(itemId)];
            }
          });
        }
      );
    }
  });
  const currentData = selectedMenuTypeVersionId ? currentMenuTypes : {};
  for (const id of Object.keys(menuTypeVersionTemp)) {
    const inheritedTaxes = {
      menuTypeInheritedTaxes: {},
      categoryInheritedTaxes: menuTypeVersionData.inheritedTaxes.categoryInheritedTaxes,
      subcategoryInheritedTaxes: menuTypeVersionData.inheritedTaxes.subcategoryInheritedTaxes
    };
    if (id in menuTypes) {
      for (const taxId of menuTypes[Number(id)].taxIds) {
        inheritedTaxes.menuTypeInheritedTaxes[taxId] = {
          id: taxId,
          isActive: true
        };
      }
    }
    menuTypeVersionTemp[Number(id)].inheritedTaxes = inheritedTaxes;
  }
  const newMenuTypeVersions = __spreadValues(__spreadValues({}, currentData), menuTypeVersionTemp);
  dispatch(
    updateItem(
      {
        menuTypeVersions: newMenuTypeVersions
      },
      "all" /* ALL */
    )
  );
  onSuccess();
};
var addNewMenuTypesToSpecial = (menuTypeIds, selectedMenuTypeVersionId, onSuccess) => (dispatch, getState) => {
  var _a;
  const state = getState();
  const currentMenuTypes = (_a = state.menu.changeData.data) == null ? void 0 : _a.menuTypeVersions;
  const items = selectItems(state);
  const combos = selectCombos(state);
  const menuTypeVersionData = cloneDeep16(
    selectedMenuTypeVersionId && currentMenuTypes ? currentMenuTypes[selectedMenuTypeVersionId] : SPECIAL_MENU_TYPE_VERSION_INITIAL_STATE
  );
  const filterFnItems = (itemId, menuTypeId) => {
    var _a2, _b;
    return Boolean((_b = (_a2 = items[itemId]) == null ? void 0 : _a2.menuTypeVersions) == null ? void 0 : _b[menuTypeId]);
  };
  const filterFnCombos = (comboId, menuTypeId) => {
    var _a2, _b;
    return Boolean((_b = (_a2 = combos[comboId]) == null ? void 0 : _a2.menuTypeVersions) == null ? void 0 : _b[menuTypeId]);
  };
  const menuTypeVersionTemp = {};
  menuTypeIds.map((menuTypeId) => {
    menuTypeVersionTemp[Number(menuTypeId.id)] = __spreadProps(__spreadValues({}, menuTypeVersionData), {
      active: true,
      buyItemIds: menuTypeVersionData.buyItemIds.filter(
        (itemId) => filterFnItems(itemId, menuTypeId.id)
      ),
      getItemIds: menuTypeVersionData.getItemIds.filter(
        (itemId) => filterFnItems(itemId, menuTypeId.id)
      ),
      buyComboIds: menuTypeVersionData.buyComboIds.filter(
        (comboId) => filterFnCombos(comboId, menuTypeId.id)
      ),
      getComboIds: menuTypeVersionData.getComboIds.filter(
        (comboId) => filterFnCombos(comboId, menuTypeId.id)
      ),
      menuTypeId: menuTypeId.id
    });
  });
  const currentData = selectedMenuTypeVersionId ? currentMenuTypes : {};
  dispatch(
    updateSpecial(
      {
        menuTypeVersions: __spreadValues(__spreadValues({}, currentData), menuTypeVersionTemp)
      },
      "all" /* ALL */
    )
  );
  onSuccess();
};
var removeMenuTypeFromItem = (menuTypeVersionIdToRemove, onSuccess) => (dispatch, getState) => {
  var _a;
  const state = getState();
  const newMenuTypeVersions = cloneDeep16(
    (_a = state.menu.changeData.data) == null ? void 0 : _a.menuTypeVersions
  );
  if (Object.values(newMenuTypeVersions).length > 1) {
    delete newMenuTypeVersions[menuTypeVersionIdToRemove];
    dispatch(
      updateItem(
        {
          menuTypeVersions: __spreadValues({}, newMenuTypeVersions)
        },
        "menuTypes" /* MENU_TYPES */
      )
    );
    onSuccess(Object.keys(newMenuTypeVersions));
  } else {
    showToast({
      type: "error",
      title: i18n_config_default.t("menuScreen.itemDetails.menuTypes.toastRemoveErrorTitle"),
      description: i18n_config_default.t(
        "menuScreen.itemDetails.menuTypes.toastRemoveErrorDescription"
      )
    });
  }
};
var ELEMENT_NOT_FOUND_MESSAGES2 = {
  items: "menuScreen.itemDetails.noElementFoundMessage",
  categories: "menuScreen.categoryDetails.noElementFoundMessage",
  subcategories: "menuScreen.subcategoryDetails.noElementFoundMessage",
  menuTypes: "menuScreen.menuTypeDetails.noElementFoundMessage",
  modifierGroups: "menuScreen.modifierGroupDetails.noElementFoundMessage",
  modifierItems: "menuScreen.modifierItemDetails.noElementFoundMessage",
  discounts: "menuScreen.discountDetails.noElementFoundMessage",
  combos: "menuScreen.comboDetails.noElementFoundMessage",
  hotButtons: "menuScreen.comboDetails.noElementFoundMessage",
  specials: "menuScreen.specialDetails.noElementFoundMessage",
  ingredients: "menuScreen.ingredientDetails.noElementFoundMessage",
  itemGroups: "menuScreen.itemGroupDetails.noElementFoundMessage",
  reportingGroups: "menuScreen.reportingGroupDetails.noElementFoundMessage"
};
var BUCKET_FORBIDDEN_TO_CHANGE_LOCATION = [
  "categories",
  "subcategories",
  "menuTypes",
  "modifierGroups",
  "modifierItems",
  "ingredients"
];
var showForbiddenChangeLocationToast = () => {
  return (dispatch, getState) => {
    const { bucketSelected } = getState().menu.changeData;
    if (!bucketSelected) {
      return;
    }
    dispatch(
      showToast({
        type: "error",
        title: i18n_config_default.t("menuScreen.common.forbiddenChangeLocation.title"),
        description: i18n_config_default.t(
          `menuScreen.common.forbiddenChangeLocation.description.${bucketSelected}`
        )
      })
    );
  };
};
var setDefaultFreshSheetData = () => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const freshSheetData = state.menu.changeFreshSheetData.data;
    if (freshSheetData) {
      dispatch(setFreshSheetDataFromMenu());
    }
  });
};
var setDefaultData = () => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const { bucketSelected, id, mode } = state.menu.changeData;
    const currentMenu = state.menu.selectedMode.currentMenu;
    const freshSheetData = state.menu.changeFreshSheetData.data;
    if (freshSheetData) {
      return dispatch(setDefaultFreshSheetData());
    }
    if (!bucketSelected) {
      return;
    }
    const isItem = currentMenu[bucketSelected][id];
    dispatch(
      setChangeData({
        bucketSelected,
        id,
        data: isItem || getMenuInitialState(bucketSelected),
        hasChanges: false,
        sectionId: "all" /* ALL */,
        mode,
        differences: [],
        finalDiffObject: null,
        errors: {},
        menuVersion: dispatch(getMenuVersion()) || 0,
        selectedLocations: []
      })
    );
  });
};
var checkForItemInLocationAndContinue = (location, currentMenu, onContinue) => {
  return (dispatch, getState) => {
    const { bucketSelected, id, mode } = getState().menu.changeData;
    if (bucketSelected) {
      const isItem = currentMenu[bucketSelected][id];
      if (isItem || mode === "create" /* CREATE */) {
        onContinue();
        dispatch(setDefaultData());
      } else {
        dispatch(
          showToast({
            type: "error",
            title: i18n_config_default.t("menuScreen.noElementToast.title"),
            description: i18n_config_default.t(ELEMENT_NOT_FOUND_MESSAGES2[bucketSelected], {
              location
            })
          })
        );
        return false;
      }
    } else {
      onContinue();
    }
    return true;
  };
};
var getRemoteLocationMenu = (preSelectedMode, location, organizationId, licenseId, errorCodesDispatcher, extraHeaders, onContinue) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const url = apiConfig_default.menu.getRemoteLocation(
      organizationId,
      preSelectedMode.id
    );
    try {
      const resp = yield apiCall(
        "get" /* Get */,
        url,
        true,
        void 0,
        licenseId,
        errorCodesDispatcher,
        dispatch,
        state,
        extraHeaders
      );
      dispatch(
        checkForItemInLocationAndContinue(location, resp.location, () => {
          dispatch(setRemoteLocationMenu(resp.location));
          dispatch(
            setMenuVersions(__spreadProps(__spreadValues({}, state.menu.versions), {
              remoteLocation: resp.version
            }))
          );
          dispatch(
            setSelectedMenuMode(__spreadProps(__spreadValues({}, preSelectedMode), {
              currentMenu: resp.location,
              name: location,
              menuVersion: resp.version
            }))
          );
          onContinue == null ? void 0 : onContinue();
        })
      );
    } catch (err) {
      console.error(err);
    }
  });
};
var getMasterMenu = (organizationId, licenseId, errorCodesDispatcher, extraHeaders, onContinue) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const url = apiConfig_default.menu.getRemoteLocation(organizationId, 0);
    try {
      const resp = yield apiCall(
        "get" /* Get */,
        url,
        true,
        void 0,
        licenseId,
        errorCodesDispatcher,
        dispatch,
        state,
        extraHeaders
      );
      dispatch(setMasterMenu(resp.location));
      dispatch(
        setMenuVersions(__spreadProps(__spreadValues({}, state.menu.versions), {
          master: resp.version
        }))
      );
      onContinue == null ? void 0 : onContinue();
    } catch (err) {
      console.error(err);
    }
  });
};
var getItemPriceListByIdAndMenuTypeId = (itemId, menuTypeId, locationIds, organizationId, currentLocationId, licenseId, licenseSettingsId, errorCodesDispatcher, extraHeaders, isCombo = false) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const url = apiConfig_default.menu.getItemPriceList(
    organizationId,
    currentLocationId,
    isCombo ? "combo" : "item",
    itemId,
    locationIds,
    menuTypeId
  );
  try {
    const response = yield apiCall(
      "get" /* Get */,
      url,
      true,
      void 0,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders
    );
    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject(error);
  }
});
var clearError = (path) => (dispatch, getState) => {
  const state = getState();
  const errors = cloneDeep16(state.menu.changeData.errors);
  unset(errors, path);
  dispatch(setErrors(errors));
};
var changePricingVersion = (modifierGroupId, modifierGroupPricingVersionId, sectionId, menuTypeVersionId) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const { modifierGroups, modifierItems } = getState().menu.selectedMode.currentMenu;
    const currentChangeMassUpdateItemData = getState().menu.changeMassUpdateData.data;
    const isMassUpdate = !!currentChangeMassUpdateItemData;
    if (menuTypeVersionId || isMassUpdate) {
      const currentItemData = getState().menu.changeData.data;
      const modItemPricingVersions = modifierGroups[modifierGroupId].modifierGroupPricingVersions[modifierGroupPricingVersionId].modItemPricingVersions;
      if (Object.values(modItemPricingVersions).length > 0) {
        const newModifierItemPricingVersion = Object.entries(
          modItemPricingVersions
        ).map(([key, value]) => {
          const modifierItem = modifierItems[Number(key)].modifierItemPricingVersions[value];
          return {
            itemId: key,
            includedMasterPrice: modifierItem.includedMasterPrice,
            additionalMasterPrice: modifierItem.additionalMasterPrice,
            includedLightPrice: modifierItem.includedLightPrice,
            includedRegularPrice: modifierItem.includedRegularPrice,
            includedExtraPrice: modifierItem.includedExtraPrice,
            additionalLightPrice: modifierItem.additionalLightPrice,
            additionalRegularPrice: modifierItem.additionalRegularPrice,
            additionalExtraPrice: modifierItem.additionalExtraPrice
          };
        });
        const newModifierItems = __spreadValues({}, (isMassUpdate ? currentChangeMassUpdateItemData : currentItemData.menuTypeVersions[menuTypeVersionId]).modifierGroups[modifierGroupId].modifierItems);
        newModifierItemPricingVersion.map((_a) => {
          var _b = _a, { itemId } = _b, pricingVersion = __objRest(_b, ["itemId"]);
          const modifierItemOldData = newModifierItems[Number(itemId)];
          const newPricingVersion = __spreadValues(__spreadValues({}, modifierItemOldData), pricingVersion);
          newModifierItems[Number(itemId)] = newPricingVersion;
        });
        dispatch(
          updateItem(
            {
              modifierItems: __spreadValues({}, newModifierItems),
              defaultModifierGroupPricingVersionId: modifierGroupPricingVersionId
            },
            sectionId,
            isMassUpdate ? 1 : menuTypeVersionId,
            modifierGroupId,
            void 0
          )
        );
      } else {
        dispatch(
          updateItem(
            {
              defaultModifierGroupPricingVersionId: modifierGroupPricingVersionId
            },
            sectionId,
            isMassUpdate ? 1 : menuTypeVersionId,
            modifierGroupId,
            void 0
          )
        );
      }
    } else {
      dispatch(
        updateModifierItemModifierGroups(
          {
            defaultModifierGroupPricingVersionId: modifierGroupPricingVersionId
          },
          sectionId,
          modifierGroupId
        )
      );
    }
  });
};
var updateModPrice = (modifierGroupId, sectionId, defaultSelectionPrice, menuTypeVersionId) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    if (menuTypeVersionId) {
      const data = cloneDeep16(getState().menu.changeData.data);
      data.menuTypeVersions[menuTypeVersionId].modifierGroups[modifierGroupId].defaultSelectionPrice = defaultSelectionPrice;
      const defaultModifiersPrice = Number(
        Object.values(data.menuTypeVersions[menuTypeVersionId].modifierGroups).reduce((acc, value) => {
          if (value.active)
            return acc + value.defaultSelectionPrice;
          else
            return acc;
        }, 0).toFixed(2)
      );
      const newData = produce(data, (draft) => {
        draft.menuTypeVersions[menuTypeVersionId].defaultModifiersPrice = defaultModifiersPrice || 0;
        draft.menuTypeVersions[menuTypeVersionId].modifierGroups[modifierGroupId].defaultSelectionPrice = defaultSelectionPrice;
      });
      dispatch(setChangeDataValues(newData, sectionId));
    } else {
      const changeMassUpdateData = cloneDeep16(
        getState().menu.changeMassUpdateData.data
      );
      const data = cloneDeep16(
        getState().menu.changeData.data || changeMassUpdateData
      );
      data.modifierGroups[modifierGroupId].defaultSelectionPrice = defaultSelectionPrice;
      const defaultModifiersPrice = Number(
        Object.values(data.modifierGroups).reduce((acc, value) => {
          if (value.active)
            return acc + value.defaultSelectionPrice;
          else
            return acc;
        }, 0).toFixed(2)
      );
      const newData = produce(data, (draft) => {
        draft.defaultModifiersPrice = defaultModifiersPrice || 0, draft.modifierGroups[modifierGroupId].defaultSelectionPrice = defaultSelectionPrice;
      });
      dispatch(setChangeDataValues(newData, sectionId, !!changeMassUpdateData));
    }
  });
};
var updateSelectionPriceForModifierItemsOfModifierGroup = (modifierItemId, sectionId, defaultSelectionPrice) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const data = getState().menu.changeData.data;
    data.modifierItems[modifierItemId].defaultSelectionPrice = defaultSelectionPrice;
    const newData = __spreadProps(__spreadValues({}, data), {
      modifierItems: __spreadProps(__spreadValues({}, data.modifierItems), {
        [modifierItemId]: __spreadProps(__spreadValues({}, data.modifierItems[modifierItemId]), {
          defaultSelectionPrice
        })
      })
    });
    dispatch(setChangeDataValues(newData, sectionId));
  });
};
var hideModifierGroup = (menuTypeVersionId, modifierGroupId, sectionId, isSwitchActive) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const data = state.menu.changeData.data;
    const modifierGroup = selectModifierGroups(state)[modifierGroupId];
    if (isSwitchActive && !modifierGroup.active) {
      return dispatch(
        showToast({
          type: "error",
          title: i18n_config_default.t("commonTexts.error"),
          description: i18n_config_default.t(
            "menuScreen.itemDetails.modifierGroupsSection.activeModifierGroupError"
          )
        })
      );
    }
    const massUpdateData = getState().menu.changeMassUpdateData.data;
    const currData = massUpdateData ? massUpdateData : data.menuTypeVersions[menuTypeVersionId];
    const defaultModifiersPrice = currData.defaultModifiersPrice;
    const defaultSelectionPrice = currData.modifierGroups[modifierGroupId].defaultSelectionPrice;
    let newDefaultModifiersPrice = 0;
    if (isSwitchActive) {
      newDefaultModifiersPrice = Number(
        (defaultModifiersPrice + defaultSelectionPrice).toFixed(2)
      );
    } else {
      newDefaultModifiersPrice = Number(
        (defaultModifiersPrice - defaultSelectionPrice).toFixed(2)
      );
    }
    let newData = {};
    if (massUpdateData) {
      newData = __spreadProps(__spreadValues({}, massUpdateData), {
        defaultModifiersPrice: newDefaultModifiersPrice || 0,
        modifierGroups: __spreadProps(__spreadValues({}, massUpdateData.modifierGroups), {
          [modifierGroupId]: __spreadProps(__spreadValues({}, massUpdateData.modifierGroups[modifierGroupId]), {
            active: isSwitchActive
          })
        })
      });
    } else {
      newData = __spreadProps(__spreadValues({}, data), {
        menuTypeVersions: __spreadProps(__spreadValues({}, data.menuTypeVersions), {
          [menuTypeVersionId]: __spreadProps(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId]), {
            defaultModifiersPrice: newDefaultModifiersPrice || 0,
            modifierGroups: __spreadProps(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId].modifierGroups), {
              [modifierGroupId]: __spreadProps(__spreadValues({}, data.menuTypeVersions[menuTypeVersionId].modifierGroups[modifierGroupId]), {
                active: isSwitchActive
              })
            })
          })
        })
      });
    }
    dispatch(
      setChangeDataValues(
        newData,
        sectionId,
        !!massUpdateData
      )
    );
  });
};
var CREATE_BUCKET_MESSAGES = {
  success: {
    items: "menuScreen.itemDetails.createNewElement.success",
    categories: "menuScreen.categoryDetails.createNewElement.success",
    subcategories: "menuScreen.subcategoryDetails.createNewElement.success",
    menuTypes: "menuScreen.menuTypeDetails.createNewElement.success",
    modifierGroups: "menuScreen.modifierGroupDetails.createNewElement.success",
    modifierItems: "menuScreen.modifierItemDetails.createNewElement.success",
    discounts: "menuScreen.discountDetails.createNewElement.success",
    combos: "menuScreen.comboDetails.createNewElement.success",
    hotButtons: "commonTexts.na",
    specials: "menuScreen.specialDetails.createNewElement.success",
    ingredients: "menuScreen.ingredientDetails.createNewElement.success",
    itemGroups: "menuScreen.itemGroupDetails.createNewElement.success",
    reportingGroups: "menuScreen.reportingGroupDetails.createNewElement.success"
  },
  error: {
    items: "menuScreen.itemDetails.createNewElement.error",
    categories: "menuScreen.categoryDetails.createNewElement.error",
    subcategories: "menuScreen.subcategoryDetails.createNewElement.error",
    menuTypes: "menuScreen.menuTypeDetails.createNewElement.error",
    modifierGroups: "menuScreen.modifierGroupDetails.createNewElement.error",
    modifierItems: "menuScreen.modifierItemDetails.createNewElement.error",
    discounts: "menuScreen.discountDetails.createNewElement.error",
    combos: "menuScreen.comboDetails.createNewElement.error",
    hotButtons: "commonTexts.na",
    specials: "menuScreen.specialDetails.createNewElement.error",
    ingredients: "menuScreen.ingredientDetails.createNewElement.error",
    itemGroups: "menuScreen.itemGroupDetails.createNewElement.error",
    reportingGroups: "menuScreen.reportingGroupDetails.createNewElement.error"
  },
  loading: {
    items: "menuScreen.itemDetails.createNewElement.loading",
    categories: "menuScreen.categoryDetails.createNewElement.loading",
    subcategories: "menuScreen.subcategoryDetails.createNewElement.loading",
    menuTypes: "menuScreen.menuTypeDetails.createNewElement.loading",
    modifierGroups: "menuScreen.modifierGroupDetails.createNewElement.loading",
    modifierItems: "menuScreen.modifierItemDetails.createNewElement.loading",
    discounts: "menuScreen.discountDetails.createNewElement.loading",
    combos: "menuScreen.comboDetails.createNewElement.loading",
    hotButtons: "commonTexts.na",
    specials: "menuScreen.specialDetails.createNewElement.loading",
    ingredients: "menuScreen.ingredientDetails.createNewElement.loading",
    itemGroups: "menuScreen.itemGroupDetails.createNewElement.loading",
    reportingGroups: "menuScreen.reportingGroupDetails.createNewElement.loading"
  }
};
var UPDATE_BUCKET_MESSAGES = {
  success: {
    items: "menuScreen.itemDetails.editElement.success",
    categories: "menuScreen.categoryDetails.editElement.success",
    subcategories: "menuScreen.subcategoryDetails.editElement.success",
    menuTypes: "menuScreen.menuTypeDetails.editElement.success",
    modifierGroups: "menuScreen.modifierGroupDetails.editElement.success",
    modifierItems: "menuScreen.modifierItemDetails.editElement.success",
    discounts: "menuScreen.discountDetails.editElement.success",
    combos: "menuScreen.comboDetails.editElement.success",
    hotButtons: "commonTexts.na",
    specials: "menuScreen.specialDetails.editElement.success",
    ingredients: "menuScreen.ingredientDetails.editElement.success",
    itemGroups: "menuScreen.itemGroupDetails.editElement.success",
    reportingGroups: "menuScreen.reportingGroupDetails.editElement.success"
  },
  error: {
    items: "menuScreen.itemDetails.editElement.error",
    categories: "menuScreen.categoryDetails.editElement.error",
    subcategories: "menuScreen.subcategoryDetails.editElement.error",
    menuTypes: "menuScreen.menuTypeDetails.editElement.error",
    modifierGroups: "menuScreen.modifierGroupDetails.editElement.error",
    modifierItems: "menuScreen.modifierItemDetails.editElement.error",
    discounts: "menuScreen.discountDetails.editElement.error",
    combos: "menuScreen.comboDetails.editElement.error",
    hotButtons: "commonTexts.na",
    specials: "menuScreen.specialDetails.editElement.error",
    ingredients: "menuScreen.ingredientDetails.editElement.error",
    itemGroups: "menuScreen.itemGroupDetails.editElement.error",
    reportingGroups: "menuScreen.reportingGroupDetails.editElement.error"
  },
  loading: {
    items: "menuScreen.itemDetails.editElement.loading",
    categories: "menuScreen.categoryDetails.editElement.loading",
    subcategories: "menuScreen.subcategoryDetails.editElement.loading",
    menuTypes: "menuScreen.menuTypeDetails.editElement.loading",
    modifierGroups: "menuScreen.modifierGroupDetails.editElement.loading",
    modifierItems: "menuScreen.modifierItemDetails.editElement.loading",
    discounts: "menuScreen.discountDetails.editElement.loading",
    combos: "menuScreen.comboDetails.editElement.loading",
    hotButtons: "commonTexts.na",
    specials: "menuScreen.specialDetails.editElement.loading",
    ingredients: "menuScreen.ingredientDetails.editElement.loading",
    itemGroups: "menuScreen.itemGroupDetails.editElement.loading",
    reportingGroups: "menuScreen.reportingGroupDetails.editElement.loading"
  }
};
var DELETE_BUCKET_MESSAGES = {
  success: {
    items: "menuScreen.itemDetails.deleteElement.success",
    categories: "menuScreen.categoryDetails.deleteElement.success",
    subcategories: "menuScreen.subcategoryDetails.deleteElement.success",
    menuTypes: "menuScreen.menuTypeDetails.deleteElement.success",
    modifierGroups: "menuScreen.modifierGroupDetails.deleteElement.success",
    modifierItems: "menuScreen.modifierItemDetails.deleteElement.success",
    discounts: "menuScreen.discountDetails.deleteElement.success",
    combos: "menuScreen.comboDetails.deleteElement.success",
    hotButtons: "commonTexts.na",
    specials: "menuScreen.specialDetails.deleteElement.success",
    ingredients: "menuScreen.ingredientDetails.deleteElement.success",
    itemGroups: "menuScreen.itemGroupDetails.deleteElement.success",
    reportingGroups: "menuScreen.reportingGroupDetails.deleteElement.success"
  },
  error: {
    items: "menuScreen.itemDetails.deleteElement.error",
    categories: "menuScreen.categoryDetails.deleteElement.error",
    subcategories: "menuScreen.subcategoryDetails.deleteElement.error",
    menuTypes: "menuScreen.menuTypeDetails.deleteElement.error",
    modifierGroups: "menuScreen.modifierGroupDetails.deleteElement.error",
    modifierItems: "menuScreen.modifierItemDetails.deleteElement.error",
    discounts: "menuScreen.discountDetails.deleteElement.error",
    combos: "menuScreen.comboDetails.deleteElement.error",
    hotButtons: "commonTexts.na",
    specials: "menuScreen.specialDetails.deleteElement.error",
    ingredients: "menuScreen.ingredientDetails.deleteElement.error",
    itemGroups: "menuScreen.itemGroupDetails.deleteElement.error",
    reportingGroups: "menuScreen.reportingGroupDetails.deleteElement.error"
  },
  loading: {
    items: "menuScreen.itemDetails.deleteElement.loading",
    categories: "menuScreen.categoryDetails.deleteElement.loading",
    subcategories: "menuScreen.subcategoryDetails.deleteElement.loading",
    menuTypes: "menuScreen.menuTypeDetails.deleteElement.loading",
    modifierGroups: "menuScreen.modifierGroupDetails.deleteElement.loading",
    modifierItems: "menuScreen.modifierItemDetails.deleteElement.loading",
    discounts: "menuScreen.discountDetails.deleteElement.loading",
    combos: "menuScreen.comboDetails.deleteElement.loading",
    hotButtons: "commonTexts.na",
    specials: "menuScreen.specialDetails.deleteElement.loading",
    ingredients: "menuScreen.ingredientDetails.deleteElement.loading",
    itemGroups: "menuScreen.itemGroupDetails.deleteElement.loading",
    reportingGroups: "menuScreen.reportingGroupDetails.deleteElement.loading"
  }
};
var UNASSOCIATE_BUCKET_MESSAGES = {
  success: {
    items: "menuScreen.itemDetails.unassociateElement.success",
    categories: "menuScreen.categoryDetails.unassociateElement.success",
    subcategories: "menuScreen.subcategoryDetails.unassociateElement.success",
    menuTypes: "menuScreen.menuTypeDetails.unassociateElement.success",
    modifierGroups: "menuScreen.modifierGroupDetails.unassociateElement.success",
    modifierItems: "menuScreen.modifierItemDetails.unassociateElement.success",
    discounts: "menuScreen.discountDetails.unassociateElement.success",
    combos: "menuScreen.comboDetails.unassociateElement.success",
    hotButtons: "commonTexts.na",
    specials: "menuScreen.specialDetails.unassociateElement.success",
    ingredients: "menuScreen.ingredientDetails.unassociateElement.success",
    itemGroups: "menuScreen.itemGroupDetails.unassociateElement.success",
    reportingGroups: "commonTexts.na"
  },
  error: {
    items: "menuScreen.itemDetails.unassociateElement.error",
    categories: "menuScreen.categoryDetails.unassociateElement.error",
    subcategories: "menuScreen.subcategoryDetails.unassociateElement.error",
    menuTypes: "menuScreen.menuTypeDetails.unassociateElement.error",
    modifierGroups: "menuScreen.modifierGroupDetails.unassociateElement.error",
    modifierItems: "menuScreen.modifierItemDetails.unassociateElement.error",
    discounts: "menuScreen.discountDetails.unassociateElement.error",
    combos: "menuScreen.comboDetails.unassociateElement.error",
    hotButtons: "commonTexts.na",
    specials: "menuScreen.specialDetails.unassociateElement.error",
    ingredients: "menuScreen.ingredientDetails.unassociateElement.error",
    itemGroups: "menuScreen.itemGroupDetails.unassociateElement.error",
    reportingGroups: "commonTexts.na"
  },
  loading: {
    items: "menuScreen.itemDetails.unassociateElement.loading",
    categories: "menuScreen.categoryDetails.unassociateElement.loading",
    subcategories: "menuScreen.subcategoryDetails.unassociateElement.loading",
    menuTypes: "menuScreen.menuTypeDetails.unassociateElement.loading",
    modifierGroups: "menuScreen.modifierGroupDetails.unassociateElement.loading",
    modifierItems: "menuScreen.modifierItemDetails.unassociateElement.loading",
    discounts: "menuScreen.discountDetails.unassociateElement.loading",
    combos: "menuScreen.comboDetails.unassociateElement.loading",
    hotButtons: "commonTexts.na",
    specials: "menuScreen.specialDetails.unassociateElement.loading",
    ingredients: "menuScreen.ingredientDetails.unassociateElement.loading",
    itemGroups: "menuScreen.itemGroupDetails.unassociateElement.loading",
    reportingGroups: "commonTexts.na"
  }
};
var getGenericData = (getState) => {
  const state = getState();
  const data = state.menu.changeData.data;
  return Promise.resolve(data);
};
var getDerivatedItemData = (getState) => __async(void 0, null, function* () {
  const state = getState();
  const item = cloneDeep16(state.menu.changeData.data);
  item.menuTypeVersions = propagateCategoriesToMenuTypes(item.menuTypeVersions);
  const images = Object.values(item.menuTypeVersions).map((mtv) => mtv.imageUrl);
  const derivatedImages = yield Promise.all(
    images.map(getURLStringOrBase64)
  );
  const secondaryImages = Object.values(item.menuTypeVersions).map(
    (mtv) => mtv.secondaryImageUrl
  );
  const derivatedSecondaryImages = yield Promise.all(
    secondaryImages.map(getURLStringOrBase64)
  );
  const derivatedMenuTypesV = Object.values(item.menuTypeVersions);
  for (let i = 0; i < derivatedMenuTypesV.length; i++)
    derivatedMenuTypesV[i].imageUrl = derivatedImages[i];
  for (let i = 0; i < derivatedMenuTypesV.length; i++)
    derivatedMenuTypesV[i].secondaryImageUrl = derivatedSecondaryImages[i];
  return __spreadProps(__spreadValues({}, item), {
    menuTypeVersions: derivatedMenuTypesV.reduce(
      (acc, mtv) => __spreadProps(__spreadValues({}, acc), { [mtv.menuTypeId]: mtv }),
      {}
    )
  });
});
var getDerivatedSubcategoryData = (getState) => __async(void 0, null, function* () {
  const state = getState();
  const subcategory = cloneDeep16(state.menu.changeData.data);
  const image = subcategory.imageUrl;
  const derivatedImage = yield getURLStringOrBase64(image);
  subcategory.imageUrl = derivatedImage;
  return subcategory;
});
var getFinalDiffObject = (getState) => {
  if (getState().menu.changeMassUpdateData.data) {
    return getState().menu.changeMassUpdateData.finalDiffObject;
  }
  return getState().menu.changeData.finalDiffObject;
};
var getMenuTypeVersionDiffObjectWithImages = (getState) => __async(void 0, null, function* () {
  const imageField = "imageUrl";
  const diffObject = cloneDeep16(getFinalDiffObject(getState));
  const imageChanges = diffObject.menuTypeVersions.filter(
    (menuTypeVersion) => menuTypeVersion.sections.basic.some((change) => change.field === imageField)
  );
  yield Promise.all(
    imageChanges.map((imageChange) => __async(void 0, null, function* () {
      const basicImageChange = imageChange.sections.basic.find(
        (change) => change.field === imageField
      );
      if (basicImageChange) {
        basicImageChange.value = yield getURLStringOrBase64(
          basicImageChange == null ? void 0 : basicImageChange.value
        );
      }
      return Promise.resolve(imageChange);
    }))
  );
  const secondaryImageChanges = diffObject.menuTypeVersions.filter(
    (menuTypeVersion) => menuTypeVersion.sections.basic.some(
      (change) => change.field === "secondaryImageUrl"
    )
  );
  yield Promise.all(
    secondaryImageChanges.map((imageChange) => __async(void 0, null, function* () {
      const secondaryImageChange = imageChange.sections.basic.find(
        (change) => change.field === "secondaryImageUrl"
      );
      if (secondaryImageChange) {
        secondaryImageChange.value = yield getURLStringOrBase64(
          secondaryImageChange == null ? void 0 : secondaryImageChange.value
        );
      }
      return Promise.resolve(imageChange);
    }))
  );
  return diffObject;
});
var getMenuTypeDiffObject = (getState) => {
  const state = getState();
  const { id, differences, data } = state.menu.changeData;
  const currentMenu = state.menu.selectedMode.currentMenu;
  return diffMenuTypesFactory(
    id,
    differences,
    currentMenu,
    data,
    state
  );
};
var getSubcategoryDiffObjectWithImages = (getState) => __async(void 0, null, function* () {
  const state = getState();
  const { id, differences, data } = state.menu.changeData;
  const subcategoryDiffObject = diffSubcategoriesFactory(
    id,
    differences,
    data,
    state
  );
  const imageField = "imageUrl";
  const imageChanges = subcategoryDiffObject == null ? void 0 : subcategoryDiffObject.basic.filter(
    (change) => change.field === imageField
  );
  if (imageChanges) {
    yield Promise.all(
      imageChanges.map((imageChange) => __async(void 0, null, function* () {
        imageChange.value = yield getURLStringOrBase64(
          imageChange == null ? void 0 : imageChange.value
        );
        return Promise.resolve(imageChange);
      }))
    );
  }
  return subcategoryDiffObject;
});
var getCategoryDiffObject = (getState) => {
  const state = getState();
  const { id, differences } = state.menu.changeData;
  return diffCategoriesFactory(id, differences, state);
};
var getModifierItemDiffObject = (getState) => {
  const state = getState();
  const { id, differences, data } = state.menu.changeData;
  return diffModifierItemsFactory(
    id,
    differences,
    data,
    state
  );
};
var getModifieGroupDiffObject = (getState) => {
  const state = getState();
  const { id, differences, data } = state.menu.changeData;
  return diffModifierGroupsFactory(
    id,
    differences,
    data,
    state
  );
};
var getDiscountDiffObject = (getState) => {
  const state = getState();
  const { id, differences, data } = state.menu.changeData;
  return diffDiscountFactory(id, differences, data, state);
};
var getIngredientDiffObject = (getState) => {
  const state = getState();
  const differences = selectChangeDataDifferences(state);
  return diffIngredientsFactory(differences, state);
};
var getItemGroupDiffObject = (getState) => {
  const state = getState();
  const differences = selectChangeDataDifferences(state);
  return diffItemGroupsFactory(differences, state);
};
var getReportingGroupDiffObject = (getState) => {
  const state = getState();
  const differences = selectChangeDataDifferences(state);
  return diffReportingGroupFactory(differences, state);
};
var CREATE_BUCKET_GETTERS = {
  items: getDerivatedItemData,
  categories: (getState) => getGenericData(getState),
  menuTypes: (getState) => getGenericData(getState),
  subcategories: getDerivatedSubcategoryData,
  modifierGroups: (getState) => getGenericData(getState),
  modifierItems: (getState) => getGenericData(getState),
  discounts: (getState) => getGenericData(getState),
  combos: getDerivatedItemData,
  hotButtons: (getState) => getGenericData(getState),
  specials: (getState) => getGenericData(getState),
  ingredients: (getState) => getGenericData(getState),
  itemGroups: (getState) => getGenericData(getState),
  reportingGroups: (getState) => getGenericData(getState)
};
var DIFF_OBJECT_GETTER2 = {
  items: getMenuTypeVersionDiffObjectWithImages,
  categories: getCategoryDiffObject,
  menuTypes: getMenuTypeDiffObject,
  subcategories: getSubcategoryDiffObjectWithImages,
  modifierGroups: getModifieGroupDiffObject,
  modifierItems: getModifierItemDiffObject,
  discounts: getDiscountDiffObject,
  //TODO: Create combos diff object getter
  combos: getMenuTypeVersionDiffObjectWithImages,
  hotButtons: () => null,
  specials: getFinalDiffObject,
  ingredients: getIngredientDiffObject,
  itemGroups: getItemGroupDiffObject,
  reportingGroups: getReportingGroupDiffObject
};
var updateMenuChangeData = (getBreadcrumbOnPressForId) => (dispatch, getState) => {
  const state = getState();
  const { bucketSelected, id, mode } = selectChangeData(state);
  const currentMenu = selectMenu(state);
  if (!bucketSelected) {
    return;
  }
  const isCreation = mode === "create" /* CREATE */;
  const newData = currentMenu[bucketSelected][id];
  dispatch(
    updateChangeDataValues({
      data: newData,
      hasChanges: false,
      sectionId: "all" /* ALL */,
      mode: isCreation ? "update" /* UPDATE */ : mode,
      menuVersion: dispatch(getMenuVersion()) || 0
    })
  );
  if (isCreation) {
    const breadCrumbLength = selectBreadCrumbsLength(state);
    dispatch(
      setBreadCrumbIndexData(breadCrumbLength - 1, {
        action: "nav" /* NAV */,
        text: newData.name,
        onPress: getBreadcrumbOnPressForId(newData.id)
      })
    );
    dispatch({
      type: POST_REQUEST_MENU,
      payload: {
        item: {
          text: newData.name,
          id: newData.id
        },
        bucketSelected,
        isDeleting: false
      }
    });
  }
};
var postRequest = (organizationId, currentLocationId, licenseId, errorCodesDispatcher, responsive, isDeleting, getBreadcrumbOnPressForId, extraHeaders) => (dispatch, getState) => {
  const state = getState();
  const { bucketSelected: bucket } = state.menu.changeData;
  const { bucketSelected: massUpdateBucket } = state.menu.changeMassUpdateData;
  const bucketSelected = massUpdateBucket ? massUpdateBucket : bucket;
  if (bucketSelected === null || state.menu.changeData.data === null && state.menu.changeMassUpdateData.data === null)
    return;
  batch$1(() => {
    if (isDeleting) {
      dispatch(resetChangeData());
      dispatch(resetChangeMassUpdateData());
      dispatch(
        breadCrumbPopNavigation(
          () => null,
          organizationId,
          currentLocationId,
          licenseId,
          errorCodesDispatcher,
          responsive,
          () => () => null,
          extraHeaders
        )
      );
    }
    dispatch(
      updateMenuChangeData(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getBreadcrumbOnPressForId || ((_) => () => null)
      )
    );
    dispatch(setIsLoadingModal({ active: false, isMakingApiCall: false }));
    dispatch(setMessageId(""));
  });
};
var postCreateElement2 = (organizationId, currentLocationId, licenseId, errorCodesDispatcher, responsive, getBreadcrumbOnPressForId, extraHeaders, mode) => (dispatch, getState) => {
  const state = getState();
  const { bucketSelected: changeDataBucketSelected, mode: stateMode } = state.menu.changeData;
  const { bucketSelected: massUpdateBucketSelected } = state.menu.changeMassUpdateData;
  const bucketSelected = massUpdateBucketSelected ? massUpdateBucketSelected : changeDataBucketSelected;
  if (bucketSelected === null || state.menu.changeData.data === null && state.menu.changeMassUpdateData.data === null)
    return;
  const isCreating = (mode || stateMode) === "create" /* CREATE */;
  dispatch(
    postRequest(
      organizationId,
      currentLocationId,
      licenseId,
      errorCodesDispatcher,
      responsive,
      false,
      getBreadcrumbOnPressForId,
      extraHeaders
    )
  );
  if (isCreating) {
    dispatch(
      showToast({
        title: i18n_config_default.t("commonTexts.success"),
        description: bucketSelected ? i18n_config_default.t(
          isCreating ? CREATE_BUCKET_MESSAGES.success[bucketSelected] : UPDATE_BUCKET_MESSAGES.success[bucketSelected]
        ) : "Successfully sent new Element",
        type: "success"
      })
    );
  } else {
    dispatch(
      showToast({
        type: "success",
        title: i18n_config_default.t("menuScreen.common.changesSaved.title"),
        description: i18n_config_default.t("menuScreen.common.changesSaved.description")
      })
    );
  }
};
var postDeleteElement = (organizationId, currentLocationId, licenseId, errorCodesDispatcher, responsive, extraHeaders) => (dispatch, getState) => {
  const state = getState();
  const { bucketSelected } = state.menu.changeData;
  const menuType = selectActualMenuType(state);
  const isMasterMode = menuType === "masterMenu" /* MASTER_MENU */;
  dispatch(
    postRequest(
      organizationId,
      currentLocationId,
      licenseId,
      errorCodesDispatcher,
      responsive,
      true,
      () => () => null,
      extraHeaders
    )
  );
  dispatch(
    showToast({
      title: i18n_config_default.t("commonTexts.success"),
      description: bucketSelected ? i18n_config_default.t(
        isMasterMode ? DELETE_BUCKET_MESSAGES.success[bucketSelected] : UNASSOCIATE_BUCKET_MESSAGES.success[bucketSelected]
      ) : "Successfully deleted Element",
      type: "success"
    })
  );
};
var postDeleteItems = (organizationId, currentLocationId, licenseId, errorCodesDispatcher, responsive, extraHeaders) => (dispatch, getState) => {
  const state = getState();
  const bucketSelected = "items";
  const isMasterMode = state.menu.selectedMode.menuType === "masterMenu" /* MASTER_MENU */;
  dispatch(resetChangeData());
  dispatch(resetChangeMassUpdateData());
  dispatch(
    breadCrumbPopNavigation(
      () => null,
      organizationId,
      currentLocationId,
      licenseId,
      errorCodesDispatcher,
      responsive,
      () => () => null,
      extraHeaders
    )
  );
  dispatch(
    updateMenuChangeData(
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      (_) => () => null
    )
  );
  dispatch(setIsLoadingModal({ active: false, isMakingApiCall: false }));
  dispatch(setMessageId(""));
  dispatch(
    showToast({
      title: i18n_config_default.t("commonTexts.success"),
      description: i18n_config_default.t(
        isMasterMode ? DELETE_BUCKET_MESSAGES.success[bucketSelected] : UNASSOCIATE_BUCKET_MESSAGES.success[bucketSelected]
      ) ,
      type: "success"
    })
  );
};
var setMenusOnState = (payload, isWebSocket = false, {
  skipMaster,
  skipLocation
} = {}) => (dispatch, getState) => {
  const state = getState();
  const selectedMode = state.menu.selectedMode;
  const {
    master: masterVersion,
    location: locationVersion,
    remoteLocation: remoteVersion
  } = state.menu.versions;
  batch$1(() => {
    payload.master && !skipMaster && dispatch(setMasterMenu(payload.master, isWebSocket));
    payload.location && !skipLocation && dispatch(setLocationMenu(payload.location, isWebSocket));
    dispatch(
      setMenuVersions(
        {
          master: skipMaster ? masterVersion : payload.versions.master || masterVersion,
          location: payload.versions.location || locationVersion,
          remoteLocation: payload.versions.remoteLocation || remoteVersion
        },
        isWebSocket
      )
    );
    if (payload.remote) {
      dispatch(setRemoteLocationMenu(payload.remote, isWebSocket));
      dispatch(
        setSelectedMenuMode(
          __spreadProps(__spreadValues({}, selectedMode), {
            currentMenu: payload.remote
          }),
          isWebSocket
        )
      );
    }
  });
};
var updateMenuOnSocket = (payload, organizationId, currentLocationId, licenseId, errorCodesDispatcher, extraHeaders, skipMaster = false) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const { bucketSelected } = selectChangeData(state);
  let hasToUpdate = false;
  const menuVersions = selectMenuVersions(state);
  const { active: isLoading, isMakingApiCall } = selectIsLoadingModal(state);
  const menuType = selectCurrentMenuType(state);
  const oldMenuVersion = dispatch(getMenuVersion());
  const newMenuVersion = dispatch(getNewMenuVersion(payload));
  const isRemoteLocationMode = selectIsMenuRemoteLocationMode(state);
  if (isLoading && isMakingApiCall) {
    return;
  }
  if (isMakingMenuUpdateRequest) {
    controller.abort();
  }
  isMakingMenuUpdateRequest = true;
  const url = apiConfig_default.menu.getRemoteLocationCache(
    organizationId,
    currentLocationId
  );
  const urlMaster = apiConfig_default.menu.getRemoteLocationCache(
    organizationId,
    0
  );
  if ((payload.location || menuVersions.location) === menuVersions.location && (payload.master || menuVersions.master) === menuVersions.master) {
    return;
  }
  try {
    let newLocationMenu = null;
    let newMasterMenu = null;
    if ((payload.location || menuVersions.location) !== menuVersions.location) {
      hasToUpdate = true;
      newLocationMenu = yield apiCall(
        "get" /* Get */,
        url,
        true,
        {},
        licenseId,
        errorCodesDispatcher,
        dispatch,
        state,
        extraHeaders,
        (errorResponse) => {
          var _a, _b, _c;
          return ((_c = (_b = (_a = errorResponse.response) == null ? void 0 : _a.data) == null ? void 0 : _b.error) == null ? void 0 : _c.code) !== 5 /* OUTDATED_MENU */;
        },
        controller
      );
    }
    if (!skipMaster && (payload.master || menuVersions.master) !== menuVersions.master) {
      hasToUpdate = true;
      newMasterMenu = yield apiCall(
        "get" /* Get */,
        urlMaster,
        true,
        {},
        licenseId,
        errorCodesDispatcher,
        dispatch,
        state,
        extraHeaders,
        (errorResponse) => {
          var _a, _b, _c;
          return ((_c = (_b = (_a = errorResponse.response) == null ? void 0 : _a.data) == null ? void 0 : _b.error) == null ? void 0 : _c.code) !== 5 /* OUTDATED_MENU */;
        },
        controller
      );
    }
    isMakingMenuUpdateRequest = false;
    hasToUpdate && dispatch(
      setMenusOnState(
        {
          location: newLocationMenu ? newLocationMenu.menu : {},
          master: newMasterMenu ? newMasterMenu.menu : {},
          remote: null,
          versions: {
            master: newMasterMenu ? newMasterMenu.version : menuVersions.master,
            location: newLocationMenu ? newLocationMenu.version : menuVersions.location,
            remoteLocation: null
          }
        },
        true,
        {
          skipMaster: skipMaster && newMasterMenu === null,
          skipLocation: newLocationMenu === null
        }
      )
    );
    if (oldMenuVersion !== newMenuVersion && !isRemoteLocationMode) {
      if (!bucketSelected && menuType !== "remoteLocationMenu" /* REMOTE_LOCATION_MENU */) {
        dispatch(updateCurrentMenu(false));
      }
      dispatch(
        setShowRefreshToast({
          isActive: true,
          variant: "MENU" /* MENU */,
          title: i18n_config_default.t("menuScreen.refreshToast.title.menu")
        })
      );
    }
  } catch (e) {
    console.error(e);
  }
});
var updateCurrentMenu = (hideRefresh = true) => (dispatch, getState) => {
  const state = getState();
  const selectedMode = state.menu.selectedMode;
  const { masterMenu, locationMenu, remoteLocationMenu, versions } = state.menu;
  const refreshToast = state.app.refreshToast;
  let currentMenu;
  let menuVersion;
  const menuType = selectActualMenuType(state);
  switch (menuType) {
    case "masterMenu" /* MASTER_MENU */:
      currentMenu = masterMenu;
      menuVersion = versions.master;
      break;
    case "locationMenu" /* LOCATION_MENU */:
      currentMenu = locationMenu;
      menuVersion = versions.location;
      break;
    case "remoteLocationMenu" /* REMOTE_LOCATION_MENU */:
      currentMenu = remoteLocationMenu;
      menuVersion = versions.remoteLocation || 0;
      break;
  }
  dispatch(
    setSelectedMenuMode(__spreadProps(__spreadValues({}, selectedMode), {
      menuVersion,
      currentMenu
    }))
  );
  if (refreshToast.isActive && hideRefresh) {
    dispatch(hideRefreshToast());
  }
};
var getNewMenuVersion = (payload) => (_, getState) => {
  const state = getState();
  const menuType = selectActualMenuType(state);
  switch (menuType) {
    case "masterMenu" /* MASTER_MENU */:
      return (payload == null ? void 0 : payload.master) || null;
    case "locationMenu" /* LOCATION_MENU */:
      return (payload == null ? void 0 : payload.location) || null;
    default:
      return null;
  }
};
var getMenuVersion = () => (_, getState) => {
  const state = getState();
  return getMenuVersionState(state);
};
var updateFreshSheetEndpoint = (organizationId, currentLocationId, licenseId, errorCodesDispatcher, extraHeaders) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const finalDiffObject = state.menu.changeFreshSheetData.finalDiffObject;
  const selectedMode = state.menu.selectedMode;
  const loggedInUser = state.loggedInUser;
  const loggedInOrganizationUserId = loggedInUser.organizationUserId;
  const roleId = loggedInUser.loggedInRole.id;
  const menuType = selectActualMenuType(state);
  dispatch(
    setIsLoadingModal({
      active: true,
      message: i18n_config_default.t("menuScreen.freshSheetDetails.updating")
    })
  );
  const diffObject = finalDiffObject;
  const url = apiConfig_default.menu.updateFreshSheet(
    organizationId,
    currentLocationId
  );
  const locationId = selectedMode.id;
  const dataRequest = {
    locationId,
    roleId,
    organizationUserId: loggedInOrganizationUserId,
    diff: diffObject.items
  };
  try {
    const response = yield apiCall(
      "put" /* Put */,
      url,
      true,
      dataRequest,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders,
      (errorResponse) => {
        var _a, _b, _c;
        return ((_c = (_b = (_a = errorResponse.response) == null ? void 0 : _a.data) == null ? void 0 : _b.error) == null ? void 0 : _c.code) !== 5 /* OUTDATED_MENU */;
      }
    );
    batch$1(() => {
      dispatch(setMenusOnState(response));
      if (menuType !== "remoteLocationMenu" /* REMOTE_LOCATION_MENU */) {
        dispatch(updateCurrentMenu());
      }
      dispatch(setFreshSheetDataFromMenu());
    });
    dispatch(
      showToast({
        type: "success",
        title: i18n_config_default.t("menuScreen.common.changesSaved.title"),
        description: i18n_config_default.t("menuScreen.common.changesSaved.description")
      })
    );
    return true;
  } catch (e) {
    console.error(e);
    return false;
  } finally {
    dispatch(setIsLoadingModal({ active: false }));
  }
});
var itemMassUpdateEndpoint = (onRefresh, organizationId, currentLocationId, licenseId, errorCodesDispatcher, responsive, extraHeaders, retries) => (dispatch, getState) => __async(void 0, null, function* () {
  var _a, _b, _c, _d, _e;
  const state = getState();
  const {
    selectionCriteria,
    bucketIds,
    selectedLocations,
    menuVersion,
    bucketSelected
  } = state.menu.changeMassUpdateData;
  const selectedMode = state.menu.selectedMode;
  const loggedInUser = state.loggedInUser;
  const loggedInOrganizationUserId = loggedInUser.organizationUserId;
  const roleId = loggedInUser.loggedInRole.id;
  dispatch(setShowConfirmationModal(CONFIRMATION_MODAL_INITIAL_STATE));
  dispatch(
    setIsLoadingModal({
      active: true,
      message: i18n_config_default.t("menuScreen.massUpdate.updating")
    })
  );
  const diffObj = yield getMenuTypeVersionDiffObjectWithImages(getState);
  const sections = diffObj.menuTypeVersions[0].sections;
  const masterChanges = diffObj.masterChanges;
  const data = {
    masterChanges,
    sections
  };
  const url = apiConfig_default.menu.itemMassUpdate(
    organizationId,
    currentLocationId
  );
  const locationId = selectedMode.id;
  const dataRequest = {
    locationId,
    roleId,
    organizationUserId: loggedInOrganizationUserId,
    diff: data,
    selectionCriteria,
    bucketIds,
    bucketSelected,
    diffLocationIds: selectedLocations,
    menuVersion
  };
  try {
    const response = yield apiCall(
      "put" /* Put */,
      url,
      true,
      dataRequest,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders,
      (errorResponse) => {
        var _a2, _b2, _c2;
        return ((_c2 = (_b2 = (_a2 = errorResponse.response) == null ? void 0 : _a2.data) == null ? void 0 : _b2.error) == null ? void 0 : _c2.code) !== 5 /* OUTDATED_MENU */;
      }
    );
    batch$1(() => {
      dispatch(setMenusOnState(response));
      dispatch(updateCurrentMenu());
      dispatch(
        postCreateElement2(
          organizationId,
          currentLocationId,
          licenseId,
          errorCodesDispatcher,
          responsive,
          () => () => null,
          extraHeaders,
          "mass_update" /* MASS_UPDATE */
        )
      );
    });
    return true;
  } catch (e) {
    const error = e;
    if (((_c = (_b = (_a = error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.error) == null ? void 0 : _c.code) === 5 /* OUTDATED_MENU */) {
      dispatch(
        setIsLoadingModal({
          active: true,
          message: `${i18n_config_default.t("menuScreen.massUpdate.updating")}. ${i18n_config_default.t("commonTexts.refreshingData")}...`,
          isMakingApiCall: true
        })
      );
      yield new Promise((resolve) => setTimeout(resolve, 1e3));
      dispatch(setMenusOnState((_e = (_d = error.response.data) == null ? void 0 : _d.error) == null ? void 0 : _e.data));
      onRefresh && onRefresh();
      if (!retries) {
        dispatch(
          setIsLoadingModal({ active: false, isMakingApiCall: false })
        );
        dispatch(
          setShowConfirmationModal({
            title: i18n_config_default.t(
              "menuScreen.refreshModal.edit.bucketMessages.items.massUpdateTitle"
            ),
            description: i18n_config_default.t(
              "menuScreen.refreshModal.edit.bucketMessages.items.description"
            ),
            type: "refresh",
            btnSuccessText: i18n_config_default.t("menuScreen.refreshModal.successButton"),
            hideCancel: true,
            active: true,
            onSuccess: () => {
              dispatch(
                setShowConfirmationModal(CONFIRMATION_MODAL_INITIAL_STATE)
              );
            }
          })
        );
        return false;
      }
      yield new Promise((resolve) => setTimeout(resolve, 2e3));
      return yield dispatch(
        itemMassUpdateEndpoint(
          onRefresh,
          organizationId,
          currentLocationId,
          licenseId,
          errorCodesDispatcher,
          responsive,
          extraHeaders,
          retries - 1
        )
      );
    } else {
      return false;
    }
  } finally {
    dispatch(setIsLoadingModal({ active: false, isMakingApiCall: false }));
  }
});
var createBucketElement = (onRefresh, organizationId, currentLocationId, licenseId, errorCodesDispatcher, responsive, getBreadcrumbOnPressForId, extraHeaders, request, mode) => (dispatch, getState) => __async(void 0, null, function* () {
  var _a, _b, _c, _d, _e;
  const state = getState();
  const hasMultipleLocations = selectShouldRenderLocationDropdown(state);
  const differences = selectChangeDataDifferences(state);
  const {
    bucketSelected = request == null ? void 0 : request.bucketSelected,
    menuVersion,
    mode: stateMode,
    selectedLocations,
    id
  } = state.menu.changeData;
  const selectedMode = state.menu.selectedMode;
  const loggedInUser = state.loggedInUser;
  const loggedInOrganizationUserId = loggedInUser.organizationUserId;
  const roleId = loggedInUser.loggedInRole.id;
  if (!bucketSelected || state.menu.changeData.data === null && !(request == null ? void 0 : request.data))
    return { success: false, id: 0 };
  const isCreating = (mode || stateMode) === "create" /* CREATE */;
  dispatch(
    setIsLoadingModal({
      active: true,
      message: i18n_config_default.t(
        isCreating ? CREATE_BUCKET_MESSAGES.loading[bucketSelected] : UPDATE_BUCKET_MESSAGES.loading[bucketSelected]
      ),
      isMakingApiCall: true
    })
  );
  if (!differences.length && !isCreating) {
    dispatch(
      postCreateElement2(
        organizationId,
        currentLocationId,
        licenseId,
        errorCodesDispatcher,
        responsive,
        getBreadcrumbOnPressForId,
        extraHeaders,
        mode || stateMode
      )
    );
    return { success: true, id };
  }
  let data = {};
  if (typeof CREATE_BUCKET_GETTERS[bucketSelected] === "function" && !request) {
    data = yield CREATE_BUCKET_GETTERS[bucketSelected](getState);
  }
  const url = apiConfig_default.menu.editOrCreateBucketElement(
    organizationId,
    currentLocationId
  );
  const time = (/* @__PURE__ */ new Date()).getTime();
  const hash = shajs3("sha256").update(`${time}-${bucketSelected}-${JSON.stringify(data)}`).digest("hex");
  const locationId = selectedMode.id;
  const diffLocationIds = !hasMultipleLocations && selectedLocations.length === 0 ? [0, currentLocationId] : selectedLocations;
  const dataRequest = request ? __spreadProps(__spreadValues({}, request), {
    hash,
    locationId,
    menuVersion,
    diffLocationIds,
    roleId,
    organizationUserId: loggedInOrganizationUserId
  }) : {
    bucketSelected,
    id,
    hash,
    data,
    locationId,
    menuVersion,
    diffLocationIds,
    roleId,
    organizationUserId: loggedInOrganizationUserId,
    diff: isCreating ? {} : typeof DIFF_OBJECT_GETTER2[bucketSelected] === "function" ? yield DIFF_OBJECT_GETTER2[bucketSelected](getState) : {}
  };
  try {
    dispatch(setMessageId(hash));
    const response = yield apiCall(
      isCreating ? "post" /* Post */ : "put" /* Put */,
      url,
      true,
      dataRequest,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders,
      (errorResponse) => {
        var _a2, _b2, _c2;
        return ((_c2 = (_b2 = (_a2 = errorResponse.response) == null ? void 0 : _a2.data) == null ? void 0 : _b2.error) == null ? void 0 : _c2.code) !== 5 /* OUTDATED_MENU */;
      }
    );
    batch$1(() => {
      dispatch(setMenusOnState(response.menu));
      dispatch(updateCurrentMenu());
      isCreating && dispatch(updateChangeDataValues({ id: response.id }));
      dispatch(
        postCreateElement2(
          organizationId,
          currentLocationId,
          licenseId,
          errorCodesDispatcher,
          responsive,
          getBreadcrumbOnPressForId,
          extraHeaders,
          mode || stateMode
        )
      );
    });
    return { success: true, id: response.id };
  } catch (e) {
    const error = e;
    if (((_c = (_b = (_a = error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.error) == null ? void 0 : _c.code) === 5 /* OUTDATED_MENU */) {
      dispatch(
        setIsLoadingModal({
          active: true,
          message: `${i18n_config_default.t(
            `menuScreen.refreshModal.${isCreating ? "create" : "edit"}.bucketMessages.${bucketSelected}.title`
          )}. ${i18n_config_default.t("commonTexts.refreshingData")}...`,
          isMakingApiCall: true
        })
      );
      yield new Promise((resolve) => setTimeout(resolve, 1e3));
      dispatch(setMenusOnState((_e = (_d = error.response.data) == null ? void 0 : _d.error) == null ? void 0 : _e.data));
      onRefresh && onRefresh();
      yield new Promise((resolve) => setTimeout(resolve, 2e3));
      return yield dispatch(
        createBucketElement(
          onRefresh,
          organizationId,
          currentLocationId,
          licenseId,
          errorCodesDispatcher,
          responsive,
          getBreadcrumbOnPressForId,
          extraHeaders,
          request,
          mode
        )
      );
    } else {
      dispatch(setIsLoadingModal({ active: false, isMakingApiCall: false }));
      return { success: false, id: 0 };
    }
  }
});
var deleteBucketElement = (organizationId, currentLocationId, licenseId, errorCodesDispatcher, responsive, extraHeaders) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const hasMultipleLocations = selectShouldRenderLocationDropdown(state);
  const { bucketSelected, menuVersion, id, selectedLocations } = state.menu.changeData;
  const selectedMode = state.menu.selectedMode;
  if (bucketSelected === null || state.menu.changeData.data === null)
    return false;
  const menuType = selectActualMenuType(state);
  const isMasterMode = selectCurrentMenuType(state) === "masterMenu" /* MASTER_MENU */;
  const loggedInUser = state.loggedInUser;
  const loggedInOrganizationUserId = loggedInUser.organizationUserId;
  const roleId = loggedInUser.loggedInRole.id;
  dispatch(
    setIsLoadingModal({
      active: true,
      message: i18n_config_default.t(
        isMasterMode ? DELETE_BUCKET_MESSAGES.loading[bucketSelected] : UNASSOCIATE_BUCKET_MESSAGES.loading[bucketSelected]
      ),
      isMakingApiCall: true
    })
  );
  const url = apiConfig_default.menu.editOrCreateBucketElement(
    organizationId,
    currentLocationId
  );
  const time = (/* @__PURE__ */ new Date()).getTime();
  const hash = shajs3("sha256").update(`${time}-${bucketSelected}`).digest("hex");
  const diffLocationIds = !hasMultipleLocations && selectedLocations.length === 0 ? [0, currentLocationId] : selectedLocations;
  const dataRequest = {
    bucketSelected,
    organizationUserId: loggedInOrganizationUserId,
    roleId,
    id,
    hash,
    data: {},
    locationId: selectedMode.id,
    menuVersion,
    diffLocationIds,
    diff: {}
  };
  try {
    dispatch(setMessageId(hash));
    const response = yield apiCall(
      "delete" /* Delete */,
      url,
      true,
      dataRequest,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders
    );
    dispatch(setMenusOnState(response.menu));
    dispatch(
      postDeleteElement(
        organizationId,
        currentLocationId,
        licenseId,
        errorCodesDispatcher,
        responsive,
        extraHeaders
      )
    );
    if (menuType !== "remoteLocationMenu" /* REMOTE_LOCATION_MENU */) {
      dispatch(updateCurrentMenu());
    }
    return true;
  } catch (e) {
    console.error(e);
    dispatch(setIsLoadingModal({ active: false, isMakingApiCall: false }));
    return false;
  }
});
var deleteBucketItems = (itemsIds, organizationId, currentLocationId, licenseId, errorCodesDispatcher, responsive, extraHeaders) => (dispatch, getState) => __async(void 0, null, function* () {
  if (!itemsIds || itemsIds.length < 1)
    return false;
  const state = getState();
  const bucketSelected = "items";
  const selectedMode = state.menu.selectedMode;
  const loggedInUser = state.loggedInUser;
  const { selectedLocations } = state.menu.changeData;
  const hasMultipleLocations = selectShouldRenderLocationDropdown(state);
  const loggedInOrganizationUserId = loggedInUser.organizationUserId;
  const roleId = loggedInUser.loggedInRole.id;
  dispatch(
    setIsLoadingModal({
      active: true,
      message: i18n_config_default.t("menuScreen.itemDetails.deleteElement.massLoading"),
      isMakingApiCall: true
    })
  );
  const url = apiConfig_default.menu.editOrCreateBucketElement(
    organizationId,
    currentLocationId
  );
  const time = (/* @__PURE__ */ new Date()).getTime();
  const hash = shajs3("sha256").update(`${time}-${bucketSelected}`).digest("hex");
  const diffLocationIds = !hasMultipleLocations && selectedLocations.length === 0 ? [0, currentLocationId] : selectedLocations;
  const dataRequest = {
    bucketSelected,
    organizationUserId: loggedInOrganizationUserId,
    roleId,
    ids: itemsIds,
    hash,
    data: {},
    locationId: selectedMode.id,
    menuVersion: null,
    diffLocationIds,
    diff: {}
  };
  try {
    dispatch(setMessageId(hash));
    const response = yield apiCall(
      "delete" /* Delete */,
      url,
      true,
      dataRequest,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders
    );
    dispatch(setMenusOnState(response.menu));
    dispatch(
      postDeleteItems(
        organizationId,
        currentLocationId,
        licenseId,
        errorCodesDispatcher,
        responsive,
        extraHeaders
      )
    );
    if (selectedMode.menuType !== "remoteLocationMenu" /* REMOTE_LOCATION_MENU */) {
      dispatch(updateCurrentMenu());
    }
    return true;
  } catch (e) {
    console.error(e);
    dispatch(setIsLoadingModal({ active: false, isMakingApiCall: false }));
    return false;
  }
});
var saveChangesOnSavePress = (onRefresh, organizationId, currentLocationId, licenseId, errorCodesDispatcher, responsive, getBreadcrumbOnPressForId, extraHeaders) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const { bucketSelected, data } = selectChangeData(state);
    const isFreshSheet = Boolean(selectCurrentFreshSheet(state));
    const changeMassUpdateData = state.menu.changeMassUpdateData.data;
    if (isFreshSheet) {
      const hasChanges = dispatch(updateFreshSheetDifferences());
      return hasChanges && dispatch(
        updateFreshSheetEndpoint(
          organizationId,
          currentLocationId,
          licenseId,
          errorCodesDispatcher,
          extraHeaders
        )
      );
    }
    if (changeMassUpdateData) {
      dispatch(checkMassUpdateFormValidation(changeMassUpdateData, false));
      dispatch(
        itemsMassUpdateDifferences(
          onRefresh,
          organizationId,
          currentLocationId,
          licenseId,
          errorCodesDispatcher,
          responsive,
          extraHeaders
        )
      );
      return;
    }
    if (bucketSelected === null || data === null)
      return;
    try {
      const fn = menuBucketValidationThunks(bucketSelected, data, false);
      const isValid = yield dispatch(fn);
      if (isValid) {
        dispatch(
          checkForChangesAndNavigate(
            () => null,
            onRefresh,
            organizationId,
            currentLocationId,
            licenseId,
            errorCodesDispatcher,
            responsive,
            getBreadcrumbOnPressForId,
            extraHeaders,
            true,
            true
          )
        );
      }
    } catch (error) {
      console.error(error);
    }
  });
};
var resetFreshSheetToOriginal = () => {
  return (dispatch, getState) => {
    const state = getState();
    const originalData = state.menu.changeFreshSheetData.originalData;
    dispatch(
      updateChangeFreshSheetDataValues({
        data: originalData,
        hasChanges: false
      })
    );
  };
};
var cancelFreshSheetChangesOnCancelPress = () => {
  return (dispatch) => {
    const onSuccess = () => {
      dispatch(resetFreshSheetToOriginal());
    };
    dispatch(
      setShowConfirmationModal({
        title: i18n_config_default.t("app.modals.discardChangesConfirmation.title"),
        description: i18n_config_default.t(
          "app.modals.discardChangesConfirmation.description"
        ),
        active: true,
        type: "warning",
        btnCancelText: i18n_config_default.t("commonTexts.no"),
        btnSuccessText: i18n_config_default.t("commonTexts.yes"),
        onSuccess
      })
    );
  };
};
var cancelChangesOnCancelPress = (onNavigate, organizationId, currentLocationId, licenseId, errorCodesDispatcher, responsive, extraHeaders, omitBreadcrumbPopOnCreateMode) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const { bucketSelected, mode, id } = getState().menu.changeData;
    const currentEditingElement = bucketSelected ? state.menu.selectedMode.currentMenu[bucketSelected][id] : null;
    const freshSheetData = state.menu.changeFreshSheetData.data;
    const isMassUpdate = Boolean(state.menu.changeMassUpdateData.data);
    if (freshSheetData) {
      return dispatch(cancelFreshSheetChangesOnCancelPress());
    }
    const bucket = isMassUpdate ? state.menu.changeMassUpdateData.bucketSelected : bucketSelected;
    const onSuccess = bucket ? mode === "update" /* UPDATE */ || isMassUpdate ? () => {
      isMassUpdate ? dispatch(resetMassUpdateMenuChanges(MASS_UPDATE_INITIAL_STATE)) : dispatch(resetMenuChanges(currentEditingElement));
    } : () => {
      dispatch(resetChangeData());
      if (omitBreadcrumbPopOnCreateMode) {
        onNavigate(bucket);
      } else {
        dispatch(
          breadCrumbPopNavigation(
            () => null,
            organizationId,
            currentLocationId,
            licenseId,
            errorCodesDispatcher,
            responsive,
            () => () => null,
            extraHeaders
          )
        );
      }
    } : () => {
      onNavigate("menuTypes");
      dispatch(resetChangeData());
    };
    dispatch(
      setShowConfirmationModal({
        title: i18n_config_default.t("app.modals.discardChangesConfirmation.title"),
        description: i18n_config_default.t(
          "app.modals.discardChangesConfirmation.description"
        ),
        active: true,
        type: "warning",
        btnCancelText: i18n_config_default.t("commonTexts.no"),
        btnSuccessText: i18n_config_default.t("commonTexts.yes"),
        onSuccess
      })
    );
  });
};
var getModifierItemsCurrentItem = (modifierGroupId, menuTypeVersionId) => (_, getState) => {
  const state = getState();
  if (menuTypeVersionId) {
    return state.menu.changeData.data.menuTypeVersions[menuTypeVersionId].modifierGroups[modifierGroupId].modifierItems;
  } else {
    return state.menu.changeData.data.modifierGroups[modifierGroupId].modifierItems;
  }
};
var getCurrentModifierGroup = (modifierGroupId, menuTypeVersionId) => (_, getState) => {
  const state = getState();
  if (menuTypeVersionId) {
    return state.menu.changeData.data.menuTypeVersions[menuTypeVersionId].modifierGroups[modifierGroupId];
  } else {
    return state.menu.changeData.data.modifierGroups[modifierGroupId];
  }
};
var updateLastModifierItemsOrder = (lastModifierItemsOrder) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const modifierItems = getState().menu.changeData.data.modifierItems;
    const newModifierItemsOrder = cloneDeep16(modifierItems);
    let isOneSortPriorityDifferent = false;
    if (Object.values(lastModifierItemsOrder).length > 0) {
      Object.entries(lastModifierItemsOrder).sort((a, b) => a[1].sortPriority - b[1].sortPriority).map(([modifierItemId, modifierItem]) => {
        newModifierItemsOrder[Number(modifierItemId)].sortPriority = modifierItem.sortPriority;
        if (modifierItems[Number(modifierItemId)].sortPriority !== modifierItem.sortPriority) {
          isOneSortPriorityDifferent = true;
        }
      });
      if (isOneSortPriorityDifferent)
        dispatch(
          updateModifierGroup(
            { modifierItems: newModifierItemsOrder },
            "association" /* ASSOCIATION */,
            "modifierItem" /* MODIFIER_ITEM */
          )
        );
    }
  });
};
var updateLastItemsOfItemGroupOrder = (lastItemsOfItemGroupOrder) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const items = getState().menu.changeData.data.items;
    const newItemsOrder = cloneDeep16(items);
    let isOneSortPriorityDifferent = false;
    if (Object.values(lastItemsOfItemGroupOrder).length > 0) {
      Object.entries(lastItemsOfItemGroupOrder).sort((a, b) => a[1].sortPriority - b[1].sortPriority).map(([itemId, item]) => {
        newItemsOrder[Number(itemId)].sortPriority = item.sortPriority;
        if (items[Number(itemId)].sortPriority !== item.sortPriority) {
          isOneSortPriorityDifferent = true;
        }
      });
      if (isOneSortPriorityDifferent)
        dispatch(
          updateItemGroup({ items: newItemsOrder }, "association" /* ASSOCIATION */)
        );
    }
  });
};
var setLastPreviewOrder = (lastPreviewOrder, bucket, pageIndex) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    var _a;
    const state = getState();
    const menuMode = selectActualMenuType(state);
    const lastHotButtons = state.menu.lastRearrangePreview.hotButtons;
    const { itemId: selectedItemId, menuTypeId: selectedMenuTypeId } = state.register.registerNavigation;
    const currentCombo = selectCurrentComboElement(state);
    const selectedCombo = (_a = currentCombo == null ? void 0 : currentCombo.comboObj) == null ? void 0 : _a.menuTypeVersions[currentCombo.menuTypeId];
    if (menuMode && Object.values(lastPreviewOrder).length > 0) {
      let values = [];
      let isOneSortPriorityDifferent = false;
      if (bucket === "hotButtons" && pageIndex !== void 0) {
        const newHotButtons = lastHotButtons;
        Object.entries(lastPreviewOrder).map(([elementId, element]) => {
          const currentElementIndex = lastHotButtons[pageIndex].findIndex(
            (hotButton) => hotButton.id.toString() === elementId.toString()
          );
          const currentElement = lastHotButtons[pageIndex].find(
            (hotButton) => hotButton.id.toString() === elementId.toString()
          );
          if (currentElementIndex === -1 || !currentElement)
            return;
          newHotButtons[pageIndex][currentElementIndex] = __spreadProps(__spreadValues({}, currentElement), {
            position: element.sortPriority
          });
        });
        return dispatch(setLastPreviewArrangement({ [bucket]: newHotButtons }));
      } else if (bucket === "modifierGroups" && selectedItemId && selectedMenuTypeId) {
        const selectedItemVersion = state.menu.selectedMode.currentMenu.items[selectedItemId].menuTypeVersions[selectedMenuTypeId];
        values = Object.entries(lastPreviewOrder).reduce(
          (acc, [elementId, element]) => {
            if (bucket === "modifierGroups" && selectedItemVersion.modifierGroups[Number(elementId)].sortPriority === element.sortPriority)
              return acc;
            isOneSortPriorityDifferent = true;
            return [
              ...acc,
              {
                id: Number(elementId),
                sortPriority: element.sortPriority,
                menuTypeItemId: selectedItemVersion.menuTypeItemId
              }
            ];
          },
          []
        );
      } else if (bucket === "itemGroups" && selectedCombo && selectedMenuTypeId) {
        const selectedComboVersion = state.menu.selectedMode.currentMenu.combos[currentCombo.comboId].menuTypeVersions[selectedMenuTypeId];
        values = Object.entries(lastPreviewOrder).reduce(
          (acc, [elementId, element]) => {
            if (selectedComboVersion.itemGroups[Number(elementId)].sortPriority === element.sortPriority) {
              return acc;
            }
            isOneSortPriorityDifferent = true;
            return [
              ...acc,
              {
                id: Number(elementId),
                sortPriority: element.sortPriority,
                menuTypeComboId: selectedComboVersion.menuTypeComboId
              }
            ];
          },
          []
        );
      } else if (bucket === "comboItems" && currentCombo && selectedMenuTypeId) {
        const itemGroupId = Object.entries(lastPreviewOrder)[0][1].type;
        if (itemGroupId) {
          const currentItemGroup = state.menu.selectedMode.currentMenu.combos[currentCombo.comboId].menuTypeVersions[selectedMenuTypeId].itemGroups[itemGroupId];
          values = Object.entries(lastPreviewOrder).reduce(
            (acc, [elementId, element]) => {
              if (currentItemGroup.items[Number(elementId)].sortPriority === element.sortPriority) {
                return acc;
              }
              isOneSortPriorityDifferent = true;
              return [
                ...acc,
                {
                  id: Number(elementId),
                  sortPriority: element.sortPriority,
                  locationMenuTypeComboGroupId: currentItemGroup.locationMenuTypeComboGroupId
                }
              ];
            },
            []
          );
        }
      } else {
        const menuElements = state.menu.selectedMode.currentMenu[bucket];
        const modifierElements = state.settings.selectedMode.currentSettings.register.modifierTags;
        const elements = bucket === "modifierTags" ? modifierElements : menuElements;
        values = Object.entries(lastPreviewOrder).reduce(
          (acc, [elementId, element]) => {
            if (elementId === "0")
              return acc;
            if (elements[Number(elementId)].sortPriority !== element.sortPriority) {
              isOneSortPriorityDifferent = true;
            }
            if (!isOneSortPriorityDifferent)
              return acc;
            return [
              ...acc,
              {
                id: isNaN(elementId) ? elementId : Number(elementId),
                sortPriority: element.sortPriority
              }
            ];
          },
          []
        );
      }
      if (isOneSortPriorityDifferent) {
        dispatch(setLastPreviewArrangement({ [bucket]: values }));
      } else
        dispatch(setLastPreviewArrangement({ [bucket]: [] }));
    }
  });
};
var resetLastPreviewOrder = (stationNumber, isMerge, organizationId) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    var _a;
    const state = getState();
    const { items, menuTypes, modifierItems, categories, subcategories } = state.menu.selectedMode.currentMenu;
    const menuTypeId = state.register.registerNavigation.menuTypeId;
    const hotButtons = ((_a = state.menu.selectedMode.currentMenu.menuTypes[menuTypeId]) == null ? void 0 : _a.hotButtons) || {};
    let toResetArragementFields = {
      categories: [],
      subcategories: [],
      items: [],
      combos: [],
      menuTypes: [],
      general: [],
      modifierItems: []
    };
    if (isMerge && organizationId) {
      const newHotButtons = getNewHotButtonsCore(state, organizationId);
      const hotButtonsAreEqual = isEqual6(hotButtons, newHotButtons);
      if (!hotButtonsAreEqual) {
        const prevHotButtonsByPosition = Object.values(hotButtons).reduce(
          (acc, hotButton) => {
            acc[hotButton.position] = hotButton;
            return acc;
          },
          {}
        );
        Object.values(newHotButtons).forEach((hotButton) => {
          if (!(hotButton.position in prevHotButtonsByPosition)) {
            hotButtons[hotButton.id] = hotButton;
          } else if (!isEqual6(prevHotButtonsByPosition[hotButton.position], hotButton)) {
            const prevHotButton = prevHotButtonsByPosition[hotButton.position];
            delete hotButtons[prevHotButton.id];
            hotButtons[hotButton.id] = hotButton;
          }
        });
      }
      const prevHomeScreenElements = state.menu.selectedMode.currentMenu.menuTypes[menuTypeId].homeScreenElements;
      const newHomeScreenElements = state.menu.previewElements;
      const homeElementsByBucket = getHomeElementsByBucket(
        prevHomeScreenElements
      );
      if (!isEqual6(newHomeScreenElements, homeElementsByBucket)) {
        toResetArragementFields = {};
      }
    }
    const openItems = selectOpenItemTypes(state);
    dispatch(
      setLastPreviewArrangement(__spreadProps(__spreadValues({
        itemGroups: [],
        comboItems: [],
        modifierTags: [],
        modifierGroups: []
      }, toResetArragementFields), {
        hotButtons: hotButtonsFactoryCore(
          hotButtons,
          items,
          modifierItems,
          menuTypes,
          categories,
          subcategories,
          openItems,
          stationNumber
        )
      }))
    );
  });
};
var updateLastPreviewOrder = (organizationId, stationNumber, licenseId, licenseSettingsId, errorCodesDispatcher, extraHeaders, propagateHotButtonsMenuTypeIds = []) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const state = getState();
    const lastRearrangePreview = state.menu.lastRearrangePreview;
    const currentMenuTypeId = state.register.registerNavigation.menuTypeId;
    const { id: locationId, menuVersion } = state.menu.selectedMode;
    const itemId = state.register.registerNavigation.itemId;
    const settingsVersion = state.settings.selectedMode.settingsVersion;
    const currentCategoryId = state.register.registerNavigation.categoryId;
    const previewElements = selectPreviewElements(state);
    const currentMenuTypes = state.menu.selectedMode.currentMenu.menuTypes;
    const currentMenuType = currentMenuTypes[currentMenuTypeId];
    const oldHomeElements = currentMenuType.homeScreenElements;
    const {
      organizationUserId,
      loggedInRole: { id: roleId }
    } = state.loggedInUser;
    const rearrangeUrl = apiConfig_default.menu.reArrangePreview(
      organizationId,
      locationId
    );
    const newHotButtons = getNewHotButtonsCore(state, organizationId);
    const body = {
      isHomeScreen: !currentCategoryId,
      organizationUserId,
      roleId,
      locationId,
      menuVersion,
      settingsVersion,
      menuTypeId: currentMenuTypeId,
      homeScreenElements: [],
      itemsAndCombosSpaces: {
        items: {},
        combos: {}
      },
      categories: lastRearrangePreview.categories,
      subcategories: lastRearrangePreview.subcategories,
      items: [],
      combos: [],
      itemGroups: lastRearrangePreview.itemGroups,
      comboItems: lastRearrangePreview.comboItems,
      modifierTags: lastRearrangePreview.modifierTags,
      modifierGroups: lastRearrangePreview.modifierGroups,
      hotButtons: newHotButtons,
      propagateHotButtonsMenuTypeIds
    };
    Object.values(previewElements.items).forEach((element) => {
      body.items.push({
        id: element.id,
        sortPriority: element.index
      });
      body.itemsAndCombosSpaces.items[element.id] = element.spaces;
    });
    Object.values(previewElements.combos).forEach((element) => {
      body.combos.push({
        id: element.id,
        sortPriority: element.index
      });
      body.itemsAndCombosSpaces.combos[element.id] = element.spaces;
    });
    if (!currentCategoryId) {
      const homeElements = [];
      oldHomeElements.forEach((element) => {
        if (!(element.id in previewElements[bucketTypeMap[element.type]])) {
          homeElements.push(__spreadProps(__spreadValues({}, element), {
            sortPriority: null
          }));
        }
      });
      Object.values(previewElements).forEach(
        (bucket) => {
          Object.values(bucket).forEach((element) => {
            homeElements.push({
              id: typeof element.elementId === "string" ? null : element.elementId,
              bucketId: element.id,
              sortPriority: element.index,
              type: element.type === "menuType" ? "menu" : element.type,
              backgroundColor: element.backgroundColor,
              textColor: element.textColor,
              spacesBefore: element.spaces
            });
          });
        }
      );
      homeElements.sort((a, b) => a.sortPriority - b.sortPriority);
      body.homeScreenElements = homeElements;
      body.items = [];
      body.combos = [];
      body.itemsAndCombosSpaces = {
        items: {},
        combos: {}
      };
    }
    batch$1(() => __async(void 0, null, function* () {
      dispatch(
        setIsLoadingModal({
          active: true,
          message: i18n_config_default.t("menuScreen.refreshModal.edit.preview.savingChanges")
        })
      );
      yield apiCall(
        "put" /* Put */,
        rearrangeUrl,
        true,
        body,
        licenseId,
        errorCodesDispatcher,
        dispatch,
        state,
        extraHeaders
      ).then((response) => {
        dispatch(setMenusOnState(response.menu));
        dispatch(setSettingsOnState(response.settings, licenseSettingsId));
        dispatch(updateCurrentMenu());
        dispatch(updateCurrentSettings());
        if (lastRearrangePreview.modifierGroups.length > 0 && itemId)
          dispatch(selectRegisterItemThunk(itemId, licenseId || 0));
        if (lastRearrangePreview.itemGroups.length > 0 || lastRearrangePreview.comboItems.length > 0)
          dispatch(updateComboObjectPreviewThunk());
        dispatch(
          showToast({
            title: i18n_config_default.t("commonTexts.success"),
            description: i18n_config_default.t(
              "menuScreen.refreshModal.edit.preview.menuUpdated"
            ),
            type: "success"
          })
        );
        dispatch(
          updateRegisterNavigationField({ isPreviewEditEnabled: false })
        );
        dispatch(resetLastPreviewOrder(stationNumber));
      }).catch((err) => {
        const error = err.response.data.error;
        if (error.code === 5 /* OUTDATED_MENU */ || error.code === 17 /* OUTDATED_SETTINGS */ || error.code === 18 /* OUTDATED_MENU_AND_SETTINGS */) {
          const errorData = {
            key: "",
            update: () => null,
            onSuccess: () => null
          };
          switch (error.code) {
            case 5 /* OUTDATED_MENU */:
              errorData.key = "outdatedMenu";
              errorData.update = () => dispatch(setMenusOnState(error.data));
              errorData.onSuccess = () => dispatch(updateCurrentMenu());
              break;
            case 17 /* OUTDATED_SETTINGS */:
              errorData.key = "outdatedSettings";
              errorData.update = () => {
                dispatch(
                  setSettingsOnState(
                    error.data,
                    licenseSettingsId
                  )
                );
              };
              errorData.onSuccess = () => dispatch(updateCurrentSettings());
              break;
            case 18 /* OUTDATED_MENU_AND_SETTINGS */:
              errorData.key = "outdatedMenuAndSettings";
              errorData.update = () => {
                const data = error.data;
                dispatch(setMenusOnState(data.menu));
                dispatch(
                  setSettingsOnState(data.settings, licenseSettingsId)
                );
              };
              errorData.onSuccess = () => {
                dispatch(updateCurrentMenu());
                dispatch(updateCurrentSettings());
              };
              break;
          }
          errorData.update();
          dispatch(
            setShowConfirmationModal({
              title: i18n_config_default.t(
                `menuScreen.refreshModal.edit.preview.refresh.${errorData.key}.title`
              ),
              description: i18n_config_default.t(
                `menuScreen.refreshModal.edit.preview.refresh.${errorData.key}.description`
              ),
              type: "refresh",
              btnSuccessText: i18n_config_default.t("menuScreen.refreshModal.successButton"),
              active: true,
              onSuccess: () => {
                errorData.onSuccess();
                dispatch(
                  resetLastPreviewOrder(stationNumber, true, organizationId)
                );
                dispatch(
                  setShowConfirmationModal(CONFIRMATION_MODAL_INITIAL_STATE)
                );
              },
              onCancel: () => {
                dispatch(
                  setShowConfirmationModal(CONFIRMATION_MODAL_INITIAL_STATE)
                );
              }
            })
          );
        }
      });
      dispatch(setIsLoadingModal({ active: false }));
    }));
  });
};
var checkForPreviewChanges = (section, onContinue, organizationId, stationNumber, licenseId, licenseSettingsId, errorCodesDispatcher, extraHeaders) => {
  return (dispatch, getState) => {
    const lastRearrangePreview = getState().menu.lastRearrangePreview;
    if (section === "categories" && lastRearrangePreview.subcategories.length === 0 && lastRearrangePreview.items.length === 0 && lastRearrangePreview.modifierTags.length === 0 && lastRearrangePreview.modifierGroups.length === 0 && lastRearrangePreview.itemGroups.length === 0 && lastRearrangePreview.comboItems.length === 0) {
      return onContinue();
    } else if (section === "subcategories" && lastRearrangePreview.items.length === 0 && lastRearrangePreview.combos.length === 0) {
      return onContinue();
    } else if (section === "items" && lastRearrangePreview.subcategories.length === 0 && lastRearrangePreview.items.length === 0 && lastRearrangePreview.combos.length === 0) {
      return onContinue();
    } else if (section === "modifierGroups" && lastRearrangePreview.modifierGroups.length === 0) {
      return onContinue();
    } else if (section === "itemGroups" && lastRearrangePreview.comboItems.length === 0) {
      return onContinue();
    } else if (section === "comboItems" && lastRearrangePreview.comboItems.length === 0) {
      return onContinue();
    }
    dispatch(
      setShowConfirmationModal({
        title: i18n_config_default.t(
          "app.modals.infoConfirmationModal.unsavedChanges"
        ),
        description: `
${i18n_config_default.t(
          "app.modals.infoConfirmationModal.unsavedChangesMessage"
        )}`,
        active: true,
        type: "info",
        btnCancelText: i18n_config_default.t("commonButtons.dontSaveChanges"),
        btnSuccessText: i18n_config_default.t("commonButtons.saveChanges"),
        onSuccess: () => {
          dispatch(
            updateLastPreviewOrder(
              organizationId,
              stationNumber,
              licenseId,
              licenseSettingsId,
              errorCodesDispatcher,
              extraHeaders
            )
          );
          dispatch(
            updateRegisterNavigationField({ isPreviewEditEnabled: false })
          );
          onContinue();
        },
        onCancel: () => {
          if (section === "categories") {
            dispatch(
              setLastPreviewArrangement({
                items: [],
                subcategories: [],
                modifierTags: [],
                modifierGroups: [],
                combos: [],
                itemGroups: []
              })
            );
            dispatch(
              updateRegisterNavigationField({ isPreviewEditEnabled: false })
            );
          } else if (section === "subcategories") {
            dispatch(setLastPreviewArrangement({ items: [], combos: [] }));
          } else if (section === "modifierGroups") {
            dispatch(setLastPreviewArrangement({ modifierGroups: [] }));
          } else if (section === "itemGroups") {
            dispatch(setLastPreviewArrangement({ comboItems: [] }));
          } else if (section === "comboItems") {
            dispatch(setLastPreviewArrangement({ comboItems: [] }));
          } else {
            dispatch(resetLastPreviewOrder(stationNumber));
          }
          onContinue();
        }
      })
    );
  };
};
var assignItemsToLocation = (ids, bucket, organizationId, currentLocationId, licenseId, errorCodesDispatcher, extraHeaders, locationId) => (dispatch, getState) => __async(void 0, null, function* () {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const state = getState();
  const selectedMode = state.menu.selectedMode;
  const url = apiConfig_default.menu.associateBucketToLocation(
    organizationId,
    currentLocationId,
    bucket
  );
  const loggedInUser = state.loggedInUser;
  const loggedInOrganizationUserId = loggedInUser.organizationUserId;
  const roleId = loggedInUser.loggedInRole.id;
  const dataRequest = {
    organizationUserId: loggedInOrganizationUserId,
    roleId,
    ids,
    locationId: locationId || selectedMode.id
  };
  dispatch(
    setIsLoadingModal({
      active: true,
      message: i18n_config_default.t(`app.modals.loadingAdd.${bucket}`)
    })
  );
  try {
    const response = yield apiCall(
      "put" /* Put */,
      url,
      true,
      dataRequest,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders
    );
    dispatch(setMenusOnState(response.menu));
    dispatch(updateCurrentMenu());
  } catch (e) {
    console.error(e);
    const error = e;
    Object.keys(((_d = (_c = (_b = (_a = error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.error) == null ? void 0 : _c.data) == null ? void 0 : _d.errors) || {}).length > 0 && Object.values(((_h = (_g = (_f = (_e = error.response) == null ? void 0 : _e.data) == null ? void 0 : _f.error) == null ? void 0 : _g.data) == null ? void 0 : _h.errors) || {}).forEach(
      (errorElement, index) => {
        setTimeout(() => {
          dispatch(
            showToast({
              type: "error",
              title: errorElement.type,
              description: errorElement.message
            })
          );
        }, index * 3e3);
      }
    );
  } finally {
    dispatch(setIsLoadingModal({ active: false }));
  }
});
var updateItemPrices = () => (dispatch, getState) => {
  const state = getState();
  const data = state.menu.changeData.data;
  const { id: itemId, hasChanges } = state.menu.changeData;
  const newData = state.menu.selectedMode.currentMenu.items[itemId];
  if (!newData) {
    return;
  }
  const menuTypeVersions = cloneDeep16(data.menuTypeVersions);
  Object.keys(menuTypeVersions).forEach((menuTypeVersionId) => {
    const menuTypeVersionIdNumber = Number(menuTypeVersionId);
    if (newData.menuTypeVersions[menuTypeVersionIdNumber]) {
      menuTypeVersions[menuTypeVersionIdNumber].itemPrice = newData.menuTypeVersions[menuTypeVersionIdNumber].itemPrice;
      menuTypeVersions[menuTypeVersionIdNumber].onlinePrice = newData.menuTypeVersions[menuTypeVersionIdNumber].onlinePrice;
      menuTypeVersions[menuTypeVersionIdNumber].deliveryPrice = newData.menuTypeVersions[menuTypeVersionIdNumber].deliveryPrice;
    }
  });
  dispatch(updateItem({ menuTypeVersions }, "pricing" /* PRICING */));
  if (!hasChanges) {
    dispatch(
      setChangeData(__spreadProps(__spreadValues({}, getState().menu.changeData), { hasChanges: false }))
    );
  }
};
var updateComboPrices = () => (dispatch, getState) => {
  const state = getState();
  const data = state.menu.changeData.data;
  const { id: comboId, hasChanges } = state.menu.changeData;
  const newData = state.menu.selectedMode.currentMenu.combos[comboId];
  if (!newData) {
    return;
  }
  const menuTypeVersions = cloneDeep16(data.menuTypeVersions);
  Object.keys(menuTypeVersions).forEach((menuTypeVersionId) => {
    const menuTypeVersionIdNumber = Number(menuTypeVersionId);
    if (newData.menuTypeVersions[menuTypeVersionIdNumber]) {
      menuTypeVersions[menuTypeVersionIdNumber].comboBasePrice = newData.menuTypeVersions[menuTypeVersionIdNumber].comboBasePrice;
      menuTypeVersions[menuTypeVersionIdNumber].onlinePrice = newData.menuTypeVersions[menuTypeVersionIdNumber].onlinePrice;
      menuTypeVersions[menuTypeVersionIdNumber].deliveryPrice = newData.menuTypeVersions[menuTypeVersionIdNumber].deliveryPrice;
    }
  });
  dispatch(updateCombo({ menuTypeVersions }, "pricing" /* PRICING */));
  if (!hasChanges) {
    dispatch(
      setChangeData(__spreadProps(__spreadValues({}, getState().menu.changeData), { hasChanges: false }))
    );
  }
};
var massPriceUpdate = (request, organizationId, currentLocationId, licenseId, errorCodesDispatcher, extraHeaders, isCombo = false) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const itemId = state.menu.changeData.id;
  const url = apiConfig_default.menu.massPriceUpdate(
    organizationId,
    currentLocationId,
    isCombo ? "combo" : "item",
    itemId
  );
  const loggedInUser = state.loggedInUser;
  const loggedInOrganizationUserId = loggedInUser.organizationUserId;
  const roleId = loggedInUser.loggedInRole.id;
  dispatch(
    setIsLoadingModal({
      active: true,
      message: i18n_config_default.t(
        `menuScreen.${isCombo ? "comboDetails" : "itemDetails"}.editElement.loading`
      )
    })
  );
  try {
    const response = yield apiCall(
      "put" /* Put */,
      url,
      true,
      __spreadProps(__spreadValues({}, request), { roleId, organizationUserId: loggedInOrganizationUserId }),
      licenseId,
      errorCodesDispatcher,
      dispatch,
      state,
      extraHeaders
    );
    dispatch(setMenusOnState(response.menu));
    if (isCombo) {
      dispatch(updateComboPrices());
    } else {
      dispatch(updateItemPrices());
    }
  } catch (e) {
    console.error(e);
  } finally {
    dispatch(setIsLoadingModal({ active: false }));
  }
});
var addHotButtonsPage = (stationNumber) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const hotButtonsData = state.menu.lastRearrangePreview.hotButtons;
  const totalHotButtons = hotButtonsData.flat(1).length;
  const emptyButtons = Array.from(Array(10)).map((_, index) => {
    const newPosition = totalHotButtons + index + 1;
    return __spreadProps(__spreadValues({}, EMPTY_HOT_BUTTON), {
      id: `${addLeadingZero(stationNumber)}${newPosition}-${Date.now()}`,
      position: newPosition
    });
  });
  dispatch(
    setLastPreviewArrangement({
      ["hotButtons"]: [...hotButtonsData, emptyButtons]
    })
  );
});
var associateHotButton = (selectedButton, hotButtonId, pageIndex) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const hotButtons = selectLastRearrangePreviewHotButtons(state);
  const items = selectItems(state);
  const menuTypes = selectMenuTypes(state);
  const categories = selectCategories(state);
  const subcategories = selectSubcategories(state);
  const modifierItems = selectModifierItems(state);
  const openItems = selectOpenItemTypes(state);
  const newHotButtons = [...hotButtons];
  const currentHotButtonIndex = newHotButtons[pageIndex].findIndex(
    (hotButton) => hotButton.id === hotButtonId
  );
  if (currentHotButtonIndex === -1)
    return;
  newHotButtons[pageIndex][currentHotButtonIndex] = __spreadProps(__spreadValues({}, newHotButtons[pageIndex][currentHotButtonIndex]), {
    backgroundColor: selectedButton.backgroundColor ? selectedButton.backgroundColor : "",
    textColor: selectedButton.textColor,
    title: i18n_config_default.t(
      getHotButtonTitle(
        selectedButton,
        items,
        modifierItems,
        menuTypes,
        categories,
        subcategories,
        openItems
      )
    ),
    originalTitle: getHotButtonTitle(
      selectedButton,
      items,
      modifierItems,
      menuTypes,
      categories,
      subcategories,
      openItems
    ),
    bucketId: selectedButton.bucketId,
    type: selectedButton.type,
    isEmpty: false,
    wasDeleted: false
  });
  dispatch(setLastPreviewArrangement({ ["hotButtons"]: newHotButtons }));
});
var removeHotButton = (hotButtonId, pageIndex) => (dispatch, getState) => __async(void 0, null, function* () {
  const hotButtons = getState().menu.lastRearrangePreview.hotButtons;
  const newHotButtons = [...hotButtons];
  const currentHotButtonIndex = newHotButtons[pageIndex].findIndex(
    (hotButton) => hotButton.id === hotButtonId
  );
  const currentHotButton = newHotButtons[pageIndex].find(
    (hotButton) => hotButton.id === hotButtonId
  );
  if (currentHotButton && currentHotButtonIndex !== -1) {
    newHotButtons[pageIndex][currentHotButtonIndex] = __spreadProps(__spreadValues({}, currentHotButton), {
      isEmpty: true,
      backgroundColor: "",
      textColor: "",
      bucketId: null,
      type: "none" /* NONE */,
      title: "",
      originalTitle: "",
      wasDeleted: true
    });
    dispatch(setLastPreviewArrangement({ ["hotButtons"]: newHotButtons }));
  }
});
var activatePreviewEditing = (stationNumber) => (dispatch, getState) => __async(void 0, null, function* () {
  var _a;
  const state = getState();
  const menuTypeId = state.register.registerNavigation.menuTypeId;
  const hotButtons = ((_a = state.menu.selectedMode.currentMenu.menuTypes[menuTypeId]) == null ? void 0 : _a.hotButtons) || {};
  if (Object.keys(hotButtons).length === 0) {
    dispatch(addHotButtonsPage(stationNumber));
  }
  dispatch(updateRegisterNavigationField({ isPreviewEditEnabled: true }));
});
var sortHotButtonsPage = (sortOption, pageIndex, onSort) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const lastRearrangeHotButtons = state.menu.lastRearrangePreview.hotButtons;
  const formattedHotButtons = lastRearrangeHotButtons[pageIndex];
  const addedHotButtons = formattedHotButtons.filter(
    (hotButton) => !hotButton.isEmpty
  );
  const emptyHotButtons = formattedHotButtons.filter(
    (hotButton) => hotButton.isEmpty
  );
  let filteredHotButtons = [];
  let newHotButtons = [];
  if (sortOption !== null) {
    filteredHotButtons = filter(
      addedHotButtons,
      {},
      sortOption,
      onSort
    );
    newHotButtons = generatePositions(
      [...filteredHotButtons, ...emptyHotButtons],
      pageIndex
    );
  } else {
    filteredHotButtons = filter(
      formattedHotButtons,
      {},
      sortOption,
      onSort
    );
    newHotButtons = generatePositions(filteredHotButtons, pageIndex);
  }
  const newRearrangeHotButtons = [...lastRearrangeHotButtons];
  newRearrangeHotButtons[pageIndex] = newHotButtons;
  dispatch(
    setLastPreviewArrangement({ ["hotButtons"]: newRearrangeHotButtons })
  );
});
var setItem68Thunk = (itemId, organizationId, currentLocationId, licenseId, errorCodesDispatcher, extraHeaders) => (dispatch, getState) => __async(void 0, null, function* () {
  var _a, _b, _c;
  const state = getState();
  const { isPreviewMode: isPreviewMode2, menuTypeId } = state.register.registerNavigation;
  if (isPreviewMode2 || !menuTypeId)
    return;
  const isCurrently86 = (_c = (_b = (_a = state.menu.locationMenu.items[itemId]) == null ? void 0 : _a.menuTypeVersions) == null ? void 0 : _b[menuTypeId]) == null ? void 0 : _c.is86ed;
  updateEntity86(
    state,
    "item" /* ITEM */,
    itemId,
    isCurrently86,
    () => dispatch(setLocalItem86(itemId, !isCurrently86)),
    dispatch,
    organizationId,
    currentLocationId,
    licenseId,
    errorCodesDispatcher,
    extraHeaders
  );
});
var show86ModifierItemOrIngredientModal = (entity, entityId, organizationId, currentLocationId, licenseId, errorCodesDispatcher, extraHeaders) => (dispatch, getState) => __async(void 0, null, function* () {
  var _a, _b;
  const state = getState();
  const { isPreviewMode: isPreviewMode2, menuTypeId } = state.register.registerNavigation;
  if (isPreviewMode2 || !menuTypeId)
    return;
  const isCurrently86 = entity === "modifierItem" /* MODIFIER_ITEM */ ? (_a = state.menu.locationMenu.modifierItems[entityId].is86ed) != null ? _a : false : entity === "ingredient" /* INGREDIENT */ ? (_b = state.menu.locationMenu.ingredients[entityId].is86ed) != null ? _b : false : false;
  const localUpdateAction = entity === "modifierItem" /* MODIFIER_ITEM */ ? setLocalModifierItem86(entityId, !isCurrently86) : setLocalIngredient86(entityId, !isCurrently86);
  const entityName = i18n_config_default.t(
    `register.detailsArea.modals.entity86ed.entity.${entity}`
  );
  dispatch(
    setShowConfirmationModal({
      active: true,
      title: i18n_config_default.t(
        isCurrently86 ? "register.detailsArea.modals.entity86ed.remove86Title" : "register.detailsArea.modals.entity86ed.confirmationTitle",
        { entity: entityName }
      ),
      type: "orange",
      runCancelOnClickOutside: true,
      description: i18n_config_default.t(
        isCurrently86 ? "register.detailsArea.modals.entity86ed.remove86Description" : "register.detailsArea.modals.entity86ed.confirmationDescription",
        { entity: entityName }
      ),
      btnSuccessText: isCurrently86 ? i18n_config_default.t("register.detailsArea.modals.entity86ed.remove86") : "86 " + entityName,
      onSuccess: () => {
        updateEntity86(
          state,
          entity,
          entityId,
          isCurrently86,
          () => dispatch(localUpdateAction),
          dispatch,
          organizationId,
          currentLocationId,
          licenseId,
          errorCodesDispatcher,
          extraHeaders
        );
      }
    })
  );
});
var showModifierItem86ConfirmationModal = (entity, entityId, onSuccess) => (dispatch) => {
  const entityName = i18n_config_default.t(
    `register.detailsArea.modals.entity86ed.entity.${entity}`
  );
  const article = i18n_config_default.t(
    `register.detailsArea.modals.entity86ed.article.${entity}`
  );
  dispatch(
    setShowConfirmationModal({
      active: true,
      title: i18n_config_default.t("register.detailsArea.modals.entity86ed.title", {
        entity: entityName
      }),
      type: "orange",
      runCancelOnClickOutside: true,
      description: `${i18n_config_default.t(
        "register.detailsArea.modals.entity86ed.description",
        {
          entity: entityName,
          article
        }
      )}
${i18n_config_default.t(
        "register.detailsArea.modals.entity86ed.continueMessage"
      )}`,
      btnSuccessText: i18n_config_default.t(
        "register.detailsArea.modals.entity86ed.orderAnyway"
      ),
      onSuccess
    })
  );
};
var updateEntity86 = (state, entity, entityId, isCurrently86, localUpdateCallback, dispatch, organizationId, currentLocationId, licenseId, errorCodesDispatcher, extraHeaders) => __async(void 0, null, function* () {
  const url = apiConfig_default.menu.entity86(
    organizationId,
    currentLocationId,
    entity
  );
  const loggedInUser = state.loggedInUser;
  const roleId = loggedInUser.loggedInRole.roleId;
  const time = (/* @__PURE__ */ new Date()).getTime();
  const responsePromise = apiCall(
    "put" /* Put */,
    url,
    true,
    {
      organizationUserId: loggedInUser.organizationUserId,
      roleId,
      locationId: currentLocationId,
      entity: "item" /* ITEM */,
      entityId,
      is86ed: !isCurrently86,
      hash: shajs3("sha256").update(`${time}-items`).digest("hex")
    },
    licenseId,
    errorCodesDispatcher,
    dispatch,
    state,
    extraHeaders
  );
  localUpdateCallback();
  try {
    yield responsePromise;
  } catch (error) {
    console.error("error while getting new menu", error);
  }
});
var updateItemInventory = (entityId, values, organizationId, currentLocationId, licenseId, errorCodesDispatcher, extraHeaders) => (dispatch, getState) => __async(void 0, null, function* () {
  const state = getState();
  const url = apiConfig_default.menu.entity86(
    organizationId,
    currentLocationId,
    "item" /* ITEM */
  );
  const loggedInUser = state.loggedInUser;
  const roleId = loggedInUser.loggedInRole.roleId;
  const time = (/* @__PURE__ */ new Date()).getTime();
  const payload = __spreadProps(__spreadValues({
    organizationUserId: loggedInUser.organizationUserId,
    roleId,
    locationId: currentLocationId,
    entity: "item" /* ITEM */,
    entityId
  }, values), {
    hash: shajs3("sha256").update(`${time}-items`).digest("hex")
  });
  const hasMultipleLocations = selectShouldRenderLocationDropdown(state);
  if (!hasMultipleLocations) {
    payload.locationIds = [0, currentLocationId];
  }
  const responsePromise = apiCall(
    "put" /* Put */,
    url,
    true,
    payload,
    licenseId,
    errorCodesDispatcher,
    dispatch,
    state,
    extraHeaders
  );
  const localInventoryUpdate = __spreadValues({}, values);
  if (values.stockQuantity) {
    localInventoryUpdate.currentAmount = values.stockQuantity;
  }
  dispatch(
    updateInventory(
      {
        [entityId]: localInventoryUpdate
      },
      false
    )
  );
  try {
    yield responsePromise;
  } catch (error) {
    console.error("error while getting new menu", error);
  }
});
var itemMassUpdateConfirmation = (itemsCount, massUpdateData, onSubmit, onNavigate, updateChangeData) => {
  return (dispatch, getState) => __async(void 0, null, function* () {
    const changeMassUpdateData = getState().menu.changeMassUpdateData;
    const onSuccess = updateChangeData ? () => {
      dispatch(
        setChangeMassUpdateData(__spreadProps(__spreadValues({}, changeMassUpdateData), {
          data: __spreadProps(__spreadValues({}, changeMassUpdateData.data), {
            modifierGroups: {},
            removeModifierGroups: [],
            locationIds: [],
            removeLocationIds: []
          }),
          bucketIds: massUpdateData.itemsIds,
          selectionCriteria: {
            categoryIds: massUpdateData.categoryIds,
            subcategoryIds: massUpdateData.subcategoryIds,
            menuTypeIds: massUpdateData.menuTypesIds
          }
        }))
      );
      onSubmit();
    } : () => {
      dispatch(
        addBreadCrumbLocation({
          action: "mass-update" /* MASS_UPDATE */,
          text: "Mass Update",
          onPress: () => onNavigate()
        })
      );
      onSubmit();
    };
    onSuccess();
  });
};

// src/state/app/actions.ts
var setNetworkStatus = (payload) => ({
  type: SET_NETWORK_STATUS,
  payload
});
var setIsWSActive = (payload) => ({
  type: SET_IS_WS_ACTIVE,
  payload
});
var resetGlobalState = () => ({
  type: RESET_GLOBAL_STATE
});
var handleConnectivityChange = (payload) => {
  return (dispatch) => __async(void 0, null, function* () {
    if (payload.isInternetReachable) {
      dispatch(setNetworkStatus("online" /* ONLINE */));
    } else {
      dispatch(setNetworkStatus("offline" /* OFFLINE */));
    }
  });
};
var setToken = (payload) => ({
  type: SET_TOKEN,
  payload
});
var setShowToast = (payload) => ({
  type: SET_SHOW_TOAST,
  payload
});
var setLockScreenBanner = (payload) => ({
  type: SET_LOCK_SCREEN_BANNER,
  payload
});
var setShowRefreshToast = (payload) => ({
  type: SET_SHOW_REFRESH_TOAST,
  payload
});
var setShowSettingsRefreshToast = (payload) => ({
  type: SET_SHOW_SETTINGS_REFRESH_TOAST,
  payload
});
var hideRefreshToast = () => ({
  type: SET_HIDE_REFRESH_TOAST
});
var setIsLoadingModal = (payload) => ({
  type: SET_IS_LOADING_MODAL,
  payload
});
var removeToastElement = (payload) => ({
  type: REMOVE_TOAST_ELEMENT,
  payload
});
var showToast = (payload) => {
  return (dispatch) => __async(void 0, null, function* () {
    dispatch(hideToast());
    const newPayload = __spreadProps(__spreadValues({}, payload), {
      timeout: payload.timeout || 0
    });
    setTimeout(() => {
      dispatch(setShowToast(newPayload));
    }, 50);
  });
};
var showLockScreenBanner = (payload) => (dispatch, getState) => {
  dispatch(clearLockScreenBanner());
  const newPayload = __spreadProps(__spreadValues({}, payload), {
    timeout: payload.timeout || 0
  });
  if (!newPayload.lockScreenDetails) {
    newPayload.lockScreenDetails = getToastStamp(getState());
  }
  return dispatch(setLockScreenBanner(newPayload));
};
var hideToast = () => ({
  type: SET_HIDE_TOAST
});
var clearLockScreenBanner = () => ({
  type: CLEAR_LOCK_SCREEN_BANNER
});
var setSelectedNetwork = (payload) => ({
  type: SET_SELECTED_NETWORK,
  payload
});
var setPullingData = (payload) => ({
  type: SET_PULLING_DATA,
  payload
});
var setIsLoading = (payload) => ({
  type: SET_IS_LOADING,
  payload
});
var setIsLoadingMore = (payload) => ({
  type: SET_IS_LOADING_MORE,
  payload
});
var setMessageId = (payload) => ({
  type: SET_MESSAGE_ID,
  payload
});
var setShowConfirmationModal = (payload) => ({
  type: SET_SHOW_CONFORMATION_MODAL,
  payload
});
var updateKeyboard = (payload) => ({
  type: UPDATE_KEYBOARD,
  payload
});
var setLatestPaymentInformation = (payload) => ({
  type: SET_LATEST_PAYMENT_INFORMATION,
  payload
});
var updatePopover = (payload) => ({
  type: UPDATE_POPOVER,
  payload
});
var setIsClockInSuggestionModalOpen = (payload) => ({
  type: SET_IS_CLOCK_IN_SUGGESTION_MODAL_OPEN,
  payload
});
var updateLicensesAndDevices = (activeTabletId, licenseId, activationDate) => (dispatch, getState) => {
  const state = getState();
  const settingsType = selectActualSettingsType(state);
  const settings = settingsType === "location" /* LOCATION_SETTINGS */ ? state.settings.location : state.settings.remoteLocation;
  const licenses = settings.licenses;
  const devices = settings.devices;
  const updatedLicense = __spreadProps(__spreadValues({}, licenses[licenseId]), {
    deviceId: activeTabletId,
    activationDate,
    status: activeTabletId ? "active" : "inactive"
  });
  const updatedTablet = __spreadProps(__spreadValues({}, devices.tablets[activeTabletId]), {
    license: __spreadValues({}, updatedLicense),
    licenseId
  });
  let replacedDevice = null;
  for (const tablet of Object.values(devices.tablets)) {
    if (tablet.license.id === licenseId && tablet.id !== activeTabletId) {
      replacedDevice = __spreadProps(__spreadValues({}, devices.tablets[tablet.id]), {
        license: LICENSE_INITIAL_STATE,
        licenseId: 0
      });
      break;
    }
  }
  const tablets = __spreadValues({}, devices.tablets);
  if (activeTabletId && replacedDevice) {
    tablets[replacedDevice.id] = replacedDevice;
    tablets[activeTabletId] = updatedTablet;
  } else if (activeTabletId === null && replacedDevice) {
    tablets[replacedDevice.id] = replacedDevice;
  } else if (activeTabletId) {
    tablets[activeTabletId] = updatedTablet;
  }
  const updatedSettings = __spreadProps(__spreadValues({}, settings), {
    licenses: __spreadProps(__spreadValues({}, settings.licenses), {
      [licenseId]: __spreadValues({}, updatedLicense)
    }),
    devices: __spreadProps(__spreadValues({}, devices), {
      tablets: __spreadValues(__spreadValues({}, devices.tablets), tablets)
    })
  });
  if (settingsType === "location" /* LOCATION_SETTINGS */)
    dispatch(setLocationSettings(updatedSettings, true));
  else
    dispatch(setRemoteLocationSettings(updatedSettings, true));
  dispatch(updateCurrentSettings());
};
var setMasterLocation = (organizationId, licenseId, errorCodesDispatcher, extraHeaders, onContinue) => (dispatch) => __async(void 0, null, function* () {
  dispatch(
    changeSelectedSettingsMode(
      {
        settingsType: "master" /* MASTER_SETTINGS */,
        id: 0,
        name: "Enterprise"
      },
      organizationId,
      licenseId,
      errorCodesDispatcher,
      extraHeaders,
      onContinue
    )
  );
  dispatch(setDefaultData());
  dispatch(setDefaultSettingsData());
});
var removeMasterData = () => ({
  type: REMOVE_MASTER_DATA
});
var addPrintingErrorsToOrder = (payload, isWS = false) => ({
  type: isWS ? KITCHEN_PRINTING_ERROR_WS : KITCHEN_PRINTING_ERROR,
  payload
});
var setInitializeAppOnLockScreen = (payload) => ({
  type: INITIALIZE_APP_ON_LOCK_SCREEN,
  payload
});
var sendCustomErrorToBackendLog = (customErrorLogBody, organizationId, locationId, licenseId, errorCodesDispatcher) => (dispatch, getState) => __async(void 0, null, function* () {
  const url = apiConfig_default.errorLog(organizationId, locationId);
  try {
    yield apiCall(
      "post" /* Post */,
      url,
      true,
      customErrorLogBody,
      licenseId,
      errorCodesDispatcher,
      dispatch,
      getState(),
      void 0,
      () => false
    );
  } catch (error) {
    console.error(error);
  }
});

// src/state/register/actionHelpers.ts
var getOrderAdditionalData = (getState) => {
  const state = getState();
  const createdById = state.loggedInUser.organizationUserId;
  const createdAt = getNowUTCDate();
  return {
    createdById,
    ownerId: createdById,
    lastUpdatedById: createdById,
    createdAt,
    updatedAt: createdAt
  };
};
var checkElementExist = (elementId, isCombo, onContinue, getState) => {
  const state = getState();
  const order = selectCurrentOrderObj(state);
  if (isCombo && order.combos[elementId])
    return onContinue();
  if (!isCombo && order.ticketElements[elementId])
    return onContinue();
};
var getValidationForCurrentOrder = (getState) => {
  const state = getState();
  const currentOrder = selectCurrentOrderObj(state);
  if (!currentOrder)
    return Promise.resolve(false);
  const isPopUpOnHoldConfirmationEnabled = selectShowPopUpOnNavigateIfItemsOnTicketNotSentToKitchen(state);
  if (!isPopUpOnHoldConfirmationEnabled)
    return Promise.resolve(false);
  if (!currentOrder.hasUnsentItems)
    return Promise.resolve(false);
  return Promise.reject();
};
var validateSeatingMode = (getState, onSuccess, ticketElement) => {
  const state = getState();
  const isSeatingModeEnabled = selectIsCurrentOrderSeatingMode(state);
  if (!isSeatingModeEnabled)
    return onSuccess();
  const isTicketSeatingBarEnabled = selectIsTicketSeatBarSettingEnabled(state);
  if (!isTicketSeatingBarEnabled)
    return onSuccess();
  const currentSeatSelected = selectCurrentSeatSelected(state);
  if (currentSeatSelected === ALL_SEATS)
    return onSuccess();
  const currentTicketElement = ticketElement ? ticketElement : selectCurrentTicketElement(state);
  if (!currentTicketElement)
    throw new Error("No Ticket Element Selected");
  const isUniqueSeatElement = Object.keys(currentTicketElement.seating).length === 1 && currentTicketElement.seating[currentSeatSelected];
  if (isUniqueSeatElement)
    return onSuccess();
  onSuccess(true);
};
var validateTicketElementIsEnabled = (ticketElementId, orderId, onSuccess, skipValidation) => (dispatch, getState) => {
  var _a;
  const state = getState();
  const order = state.register.orders[orderId];
  const element = (_a = order.ticketElements[ticketElementId]) != null ? _a : order.combos[ticketElementId];
  if (!(element == null ? void 0 : element.isInClosedCheck) || skipValidation)
    return onSuccess();
  if (Object.keys(order.checks).length === 1) {
    dispatch(openCheck(orderId, order.defaultCheckId));
    return onSuccess();
  }
  dispatch(
    setShowConfirmationModal({
      title: i18n_config_default.t(
        "register.modals.ticketElementInClosedChecks.title"
      ),
      description: i18n_config_default.t(
        "register.modals.ticketElementInClosedChecks.description"
      ),
      active: true,
      type: "warning",
      btnCancelText: i18n_config_default.t("commonButtons.cancel"),
      btnSuccessText: i18n_config_default.t(
        "register.modals.ticketElementInClosedChecks.btnSuccessText"
      ),
      onSuccess: () => {
        const closedChecks = getTicketElementClosedChecks(
          order,
          ticketElementId
        );
        closedChecks.forEach((closedCheck) => {
          dispatch(openCheck(orderId, closedCheck));
        });
        return onSuccess();
      }
    })
  );
};
var validateGeneralSeatingMode = (getState, onSuccess) => {
  const state = getState();
  const isSeatingModeEnabled = selectIsCurrentOrderSeatingMode(state);
  if (!isSeatingModeEnabled)
    return onSuccess(false);
  const isTicketSeatingBarEnabled = selectIsTicketSeatBarSettingEnabled(state);
  if (!isTicketSeatingBarEnabled)
    return onSuccess(false);
  const currentSeatSelected = selectCurrentSeatSelected(state);
  if (currentSeatSelected === ALL_SEATS)
    return onSuccess(false);
  return onSuccess(true);
};
var validateElementIsAppliedToSpecial = (elementId, type) => (dispatch, getState) => {
  const state = getState();
  const orderId = selectCurrentOrderId(state);
  if (orderId === null)
    return;
  const [triggerItems, triggerCombos] = selectCurrentSpecialsTriggerElementIds(state);
  const [rewardedItems, rewardedCombos] = selectCurrentSpecialsRewardedElementIds(state);
  let existInSpecialsSummary = false;
  if (type === "item") {
    existInSpecialsSummary = triggerItems.has(elementId) || rewardedItems.has(elementId);
  } else {
    existInSpecialsSummary = triggerCombos.has(elementId) || rewardedCombos.has(elementId);
  }
  if (!existInSpecialsSummary)
    return;
  const order = selectCurrentOrderObj(state);
  const specialsToReset = getSpecialsToReset(order, elementId, type);
  const specialsIndexesToReset = specialsToReset.map(({ index }) => index);
  if (specialsIndexesToReset.length === 0)
    return;
  dispatch(
    resetTicketSpecials({
      orderId,
      elementId,
      type,
      specialsIndexesToReset
    })
  );
};
var checkAndSetTicketElementActiveCore = ({
  registerNavigation,
  elementId,
  isCustomizer = false
}) => (dispatch, getState) => {
  var _a, _b, _c;
  const state = getState();
  const isVAOFocused = state.register.registerNavigation.VAOData.isVAOFocused;
  const currentOrder = selectCurrentOrderObj(state);
  const currentComboElement = registerNavigation.comboElementId ? currentOrder.combos[registerNavigation.comboElementId] : null;
  let comboFirstTicketElementId = null;
  if (currentComboElement) {
    comboFirstTicketElementId = (_a = registerNavigation.ticketElementId) != null ? _a : null;
  }
  const { categoryId, subcategoryId } = state.register.registerNavigation;
  let skipCategoryNavigation = false;
  if (isCustomizer) {
    skipCategoryNavigation = false;
  } else if (categoryId === null && subcategoryId === null) {
    skipCategoryNavigation = true;
  } else if (registerNavigation.categoryId) {
    if (!state.menu.locationMenu.categories[registerNavigation.categoryId].active) {
      skipCategoryNavigation = true;
    } else if (registerNavigation.subcategoryId) {
      if (!state.menu.locationMenu.subcategories[registerNavigation.subcategoryId].active)
        registerNavigation.subcategoryId = null;
    }
  }
  if (skipCategoryNavigation) {
    registerNavigation.categoryId = null;
    registerNavigation.subcategoryId = null;
  }
  if (isVAOFocused) {
    return;
  }
  const currentTicketElement = (_b = currentOrder.ticketElements[elementId || 0]) != null ? _b : currentOrder.ticketElements[comboFirstTicketElementId || 0];
  if (!currentTicketElement)
    return;
  const isOpenItem = isOpenItemFn(currentTicketElement);
  let navigateToAllMods = false;
  if (isOpenItem)
    navigateToAllMods = true;
  else {
    const currentMenuTypeItem = Object.values(
      ((_c = currentTicketElement == null ? void 0 : currentTicketElement.itemObj) == null ? void 0 : _c.menuTypeVersions) || {}
    )[0];
    const itemHasNormalModifierGroups = Object.values(
      currentMenuTypeItem.modifierGroups || {}
    ).some(
      (modifierGroup) => !modifierGroup.isAllMod && modifierGroup.modifierGroupId !== ALL_MODS_ID
    );
    const modifierGroupsIds = Object.keys(
      currentMenuTypeItem.modifierGroups || {}
    ).map(Number);
    navigateToAllMods = !itemHasNormalModifierGroups || modifierGroupsIds.length === 1 && modifierGroupsIds[0] === ALL_MODS_ID;
  }
  if (navigateToAllMods) {
    registerNavigation.modifierGroupId = ALL_MODS_ID;
    registerNavigation.isAllModsEnabled = true;
  }
  const isCurrentSubcategoryCustomizer = isOpenItem ? false : currentTicketElement.customizerType === "subcategory" /* SUBCATEGORY */;
  if (isCurrentSubcategoryCustomizer) {
    registerNavigation.isAllModsEnabled = false;
    const modifierGroupsSelected = Object.values(
      currentTicketElement.modifierGroupsSelected
    );
    if (!modifierGroupsSelected.length) {
      registerNavigation.modifierGroupId = null;
    } else {
      const firstModifierGroupId = modifierGroupsSelected[0].modifierGroupId;
      registerNavigation.modifierGroupId = firstModifierGroupId;
    }
  }
  dispatch(setActiveTicketElement({ registerNavigation, elementId }));
};
var checkForCoursesUpdate = (order) => (dispatch, getState) => {
  var _a;
  const isOrderOpen = getIsOrderOpen(order.status);
  if (!isOrderOpen)
    return;
  const state = getState();
  const orderCourses = (_a = cloneDeep(order.courseTimes)) != null ? _a : {};
  const currentLocationCourses = state.settings.location.register.courses;
  const currentLocationKeys = Object.keys(currentLocationCourses);
  const currentOrderKeys = Object.keys(orderCourses);
  const deletedKeys = currentOrderKeys.filter(
    (key) => orderCourses[Number(key)].type === "predefined" /* PREDEFINED */
  ).filter((key) => !currentLocationKeys.includes(key));
  if (deletedKeys.length > 0)
    deletedKeys.map((keyString) => Number(keyString)).forEach((key) => {
      orderCourses[key].isActive = false;
    });
  const isCoursingEnabled = selectIsCoursingEnabled(state);
  if (!isCoursingEnabled)
    return;
  const coursingMode = selectCoursingModeActive(state);
  if (coursingMode === "predefined" /* PREDEFINED */)
    Object.values(currentLocationCourses).forEach((course) => {
      const oldCourse = orderCourses[course.courseId];
      if (oldCourse) {
        oldCourse.courseName = course.posName;
        oldCourse.isActive = course.active;
        oldCourse.sortPriority = course.sortPriority;
        oldCourse.courseId = course.courseId;
        oldCourse.triggerTime = course.triggerTime;
        orderCourses[course.courseId] = oldCourse;
      } else {
        const newCourse = {
          timeTriggered: null,
          timeSentToKitchen: null,
          courseName: course.posName,
          isActive: course.active,
          courseId: course.courseId,
          sortPriority: course.sortPriority,
          triggerTime: course.triggerTime,
          type: "predefined" /* PREDEFINED */
        };
        orderCourses[course.courseId] = newCourse;
      }
    });
  else {
    const onTheFlyCourses = Object.values(orderCourses).filter(
      (course) => course.type === "on_the_fly" /* ON_THE_FLY */
    );
    if (onTheFlyCourses.length === 0)
      orderCourses[1] = getCourseTimeOnTheFly(1);
  }
  const hasChanges = diff(orderCourses, order.courseTimes);
  if (hasChanges)
    dispatch(
      updateOrderField(
        order.id || order.tabletGeneratedId,
        { courseTimes: orderCourses },
        true
      )
    );
};
var checkOrderPermissions = (onContinue) => (dispatch, getState) => {
  const canCreateOrders = getUserRegisterPermissionCore(
    "createOrders" /* createOrders */,
    getState()
  );
  if (canCreateOrders) {
    return onContinue();
  }
  dispatch(
    setShowConfirmationModal({
      active: true,
      type: "permissionDenied",
      onCancel: () => null,
      onSuccess: () => onContinue(),
      title: ["createOrders" /* createOrders */]
    })
  );
};
var generateCourseTimesObject = (state) => {
  const coursingMode = selectCoursingModeActive(state);
  const courses = selectLocationCourses(state);
  const auxObject = {};
  if (coursingMode === "predefined" /* PREDEFINED */)
    Object.values(courses).forEach((course) => {
      auxObject[course.courseId] = {
        timeSentToKitchen: null,
        timeTriggered: null,
        courseId: course.courseId,
        courseName: course.posName,
        isActive: course.active,
        sortPriority: course.sortPriority,
        triggerTime: course.triggerTime,
        type: "predefined" /* PREDEFINED */
      };
    });
  else
    auxObject[1] = getCourseTimeOnTheFly(1);
  return auxObject;
};
var ALL_MODS_ID = 0;
var generateTicketElementId = generateTabletGeneratedId;
var generateTimestampId = generateTabletGeneratedId;
var getNextTabletGeneratedId = generateTabletGeneratedId;
var generateNTimestampIds = (n) => {
  return Array.from({ length: n }, () => generateTimestampId());
};
var getTicketSize = (ticket) => {
  return Object.keys(ticket).length;
};
var closeComboElement = (order, comboElementId) => {
  const comboElement = order.combos[comboElementId];
  if (!comboElement)
    return;
  comboElement.isInClosedCheck = true;
  Object.values(comboElement.itemGroupsSelected).forEach((itemGroup) => {
    if (order.ticketElements[itemGroup.ticketElementId]) {
      order.ticketElements[itemGroup.ticketElementId].isInClosedCheck = true;
    }
  });
};
var openComboElement = (order, comboElementId) => {
  const comboElement = order.combos[comboElementId];
  if (!comboElement)
    return;
  comboElement.isInClosedCheck = false;
  Object.values(comboElement.itemGroupsSelected).forEach((itemGroup) => {
    if (order.ticketElements[itemGroup.ticketElementId]) {
      order.ticketElements[itemGroup.ticketElementId].isInClosedCheck = false;
    }
  });
};
var isTicketElementVoided = (ticketElement) => ticketElement.isVoided;
var isTicketElementComplete = (ticketElement) => !!(ticketElement == null ? void 0 : ticketElement.isComplete) && !!(ticketElement == null ? void 0 : ticketElement.quantity);
var TicketElementNotInClosedCheck = (ticketElement) => !(ticketElement == null ? void 0 : ticketElement.isInClosedCheck);
var selectSectionsCompletedIds = (ticketElement) => {
  return [
    ...Object.entries((ticketElement == null ? void 0 : ticketElement.modifierGroupsSelected) || {}).reduce((acc, [modifierGroupId, modifierGroup]) => {
      if (modifierGroup.isComplete)
        acc.add(Number(modifierGroupId));
      return acc;
    }, /* @__PURE__ */ new Set()).values()
  ];
};
var duplicateRegisterItem = (ticket, oldTicketElementId, newTicketElementId, seatSplitRequired, currentSeat, isSeatingEnabled, nextCourseNumber, isReorder) => {
  var _a, _b;
  const newTicketElement = cloneDeep(
    ticket[oldTicketElementId]
  );
  newTicketElement.printErrorMessage = {};
  newTicketElement.sentToPrepStationHistory = [];
  newTicketElement.onTheFlyCourseNumber = ticket[oldTicketElementId].isCurrentMenuTypeCourseDisabled ? null : nextCourseNumber != null ? nextCourseNumber : ticket[oldTicketElementId].onTheFlyCourseNumber;
  newTicketElement.roundNumber = void 0;
  newTicketElement.tabletGeneratedId = newTicketElementId;
  newTicketElement.id = 0;
  newTicketElement.ticketElementToCheckElementsId = newTicketElementId;
  newTicketElement.instanceIds = [];
  newTicketElement.isInClosedCheck = false;
  newTicketElement.configWhenSent = null;
  if (seatSplitRequired) {
    newTicketElement.quantity = ticket[oldTicketElementId].seating[currentSeat];
    newTicketElement.seating = {
      [currentSeat]: ticket[oldTicketElementId].seating[currentSeat]
    };
  }
  if (isReorder) {
    Object.values((_a = ticket[oldTicketElementId].specials) != null ? _a : {}).forEach(
      (special) => {
        special.instances.forEach((instance, index) => {
          var _a2;
          const itemElementIdIndex = ticket[oldTicketElementId].instanceIds.indexOf(instance);
          const newTicketElementInstance = ((_a2 = newTicketElement == null ? void 0 : newTicketElement.specials) != null ? _a2 : {})[special.id || special.tabletGeneratedId].instances;
          if (newTicketElementInstance.length) {
            newTicketElementInstance.splice(
              index,
              1,
              newTicketElement.instanceIds[itemElementIdIndex]
            );
          }
        });
      }
    );
  }
  newTicketElement.timeAdded = getNowUTCDate();
  if (!isReorder && isSeatingEnabled) {
    newTicketElement.quantity = 0;
    newTicketElement.seating = {};
    newTicketElement.isShared = null;
  }
  if (!isReorder && isSeatingEnabled && Object.values(((_b = newTicketElement.itemObj) == null ? void 0 : _b.menuTypeVersions) || {})[0].defaultNoSeat) {
    newTicketElement.seating[NO_SEAT_ID] = 1;
    newTicketElement.quantity = 1;
  }
  if (isReorder || newTicketElement.timeSentToKitchen !== NULLISH_DATE || newTicketElement.timeTriggered !== NULLISH_DATE) {
    newTicketElement.timeSentToKitchen = NULLISH_DATE;
    newTicketElement.timeTriggered = NULLISH_DATE;
    newTicketElement.isVoided = false;
    ticket[newTicketElementId] = newTicketElement;
    return;
  }
  ticket[newTicketElementId] = newTicketElement;
};
var reOrderCheckElements = (order, newElementId, isReorder, isCombo) => {
  let seatIndex = 0;
  const seats = isCombo ? order.combos[newElementId].seating : order.ticketElements[newElementId].seating;
  const seatDistribution = Object.keys(seats).map((seatId) => {
    const parsedSeatId = Number(seatId);
    return {
      seatId: parsedSeatId,
      amount: seats[parsedSeatId]
    };
  });
  const instanceIds = isCombo ? order.combos[newElementId].instanceIds : order.ticketElements[newElementId].instanceIds;
  instanceIds.forEach((itemId, index) => {
    if (isCombo) {
      addComboToChecks(
        order,
        newElementId,
        itemId,
        !isEmpty(seatDistribution) && isReorder ? {
          [seatDistribution[seatIndex].seatId]: seatDistribution[seatIndex].amount
        } : {}
      );
    } else {
      addTicketElementToChecks(
        order,
        newElementId,
        itemId,
        !isEmpty(seatDistribution) && isReorder ? {
          [seatDistribution[seatIndex].seatId]: seatDistribution[seatIndex].amount
        } : {}
      );
    }
    if (!isEmpty(seatDistribution) && isReorder && index + 1 === seatDistribution[seatIndex].amount) {
      seatIndex++;
    }
  });
};
var selectRegisterItem2 = (ticket, ticketElementId, itemId, globalState, dualPricingSettings, overrides = {}) => {
  var _a;
  const {
    menuTypeId: currentMenuTypeId,
    orderId,
    subcategoryId
  } = globalState.register.registerNavigation;
  const defaultPrepStationId = globalState.settings.location.prepStations.defaultPrepStationId;
  if (orderId === null || !currentMenuTypeId && !overrides.menuTypeId)
    return;
  const currentOrder = selectCurrentOrderObj(globalState);
  const menuTypeId = overrides.menuTypeId || currentMenuTypeId;
  const isCurrentMenuTypeCourseDisabled = globalState.menu.locationMenu.menuTypes[Number(menuTypeId)].coursingType !== "coursing" /* COURSING */;
  const isCustomizerSubcategory = subcategoryId ? globalState.menu.locationMenu.subcategories[subcategoryId].customizer : false;
  const itemCopy = getItemCopy(
    globalState,
    itemId,
    menuTypeId,
    overrides.price,
    overrides.defaultNoSeat,
    isCustomizerSubcategory
  );
  let ticketElement = ticket[ticketElementId];
  const hotButtonsModifierItemId = globalState.register.registerNavigation.modifierItemHotButtonSelectedId;
  if (hotButtonsModifierItemId && itemCopy)
    toggleHotButtonModifierItemInModifierGroup(
      itemCopy,
      menuTypeId,
      hotButtonsModifierItemId,
      { isSelected: true, defaultQuantitySelected: 1 }
    );
  const modifierInitialization = initializeModifierGroupsSelected_default(
    itemCopy,
    selectSpecialModTagsMetaData(globalState)
  );
  if (hotButtonsModifierItemId && itemCopy)
    toggleHotButtonModifierItemInModifierGroup(
      itemCopy,
      menuTypeId,
      hotButtonsModifierItemId,
      { isSelected: false, defaultQuantitySelected: 0 }
    );
  const isItemTaxExempt = itemCopy == null ? void 0 : itemCopy.menuTypeVersions[menuTypeId].taxExempt;
  if (!ticketElement) {
    ticketElement = createNewTicketElement(
      orderId,
      ticketElementId,
      currentOrder.type,
      globalState,
      itemCopy,
      overrides.special,
      dualPricingSettings,
      currentOrder.noTaxInclusive,
      menuTypeId
    );
    if (isItemTaxExempt) {
      ticketElement.taxExempt = true;
    }
    if (overrides.noPrinterLocation) {
      ticketElement.noPrinterLocation = true;
      ticketElement.prepStations = [];
    }
    Object.assign(ticketElement, modifierInitialization);
    ticket[ticketElementId] = ticketElement;
    updateWithGlobalQuantities(ticketElement, globalState);
    ticketElement.isTakeout = currentOrder.type === "to_go" /* TO_GO */;
    checkIfTicketElementIsTaxExempt(ticketElement, globalState);
    calcTotalItemWithAlternativePrice(ticketElement, {
      orderType: currentOrder.type,
      taxExempt: currentOrder.taxExempt,
      noTaxInclusive: currentOrder.noTaxInclusive,
      orderIsLockedPrice: currentOrder.isLockedPrice
    });
  } else {
    ticketElement = updateTicketElement(
      orderId,
      ticketElement,
      itemCopy,
      globalState,
      overrides.special,
      currentOrder.type
    );
    if (isItemTaxExempt) {
      ticketElement.taxExempt = true;
    }
    checkIfTicketElementIsTaxExempt(ticketElement, globalState);
    Object.assign(ticketElement, modifierInitialization);
    if (itemCopy == null ? void 0 : itemCopy.menuTypeVersions[menuTypeId].taxInclusive) {
      const taxesProportion = Object.values(ticketElement.taxDetails).reduce(
        (acc, tax) => acc + tax.percentage,
        0
      );
      applyTaxProportionToModifierItemsSelected(
        taxesProportion,
        ticketElement.taxInclusiveSelectedModifiersPricePerItemUnit,
        ticketElement.modifierGroupsSelected
      );
    }
  }
  const coursingMode = selectCoursingModeActive(globalState);
  ticketElement.courseId = coursingMode === "on_the_fly" /* ON_THE_FLY */ ? null : assignCourseId(ticketElement, globalState);
  ticketElement.onTheFlyCourseNumber = coursingMode === "predefined" /* PREDEFINED */ ? null : currentOrder.type === "to_go" /* TO_GO */ ? null : selectCurrentCourseNumber(globalState);
  const itemMenuTypeVersion = (_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[ticketElement.menuTypeId];
  if (defaultPrepStationId && itemCopy && itemMenuTypeVersion && isEmpty(itemMenuTypeVersion.prepStationIds)) {
    itemMenuTypeVersion.prepStationIds = [defaultPrepStationId];
  }
  if (overrides.prepStationId)
    ticketElement.prepStationOverrideId = overrides.prepStationId;
  ticketElement.isCurrentMenuTypeCourseDisabled = isCurrentMenuTypeCourseDisabled;
  Object.assign(
    ticketElement,
    initializeIngredientsSelected(ticketElement.itemObj)
  );
  let areAllModifiersComplete = true;
  Object.values(ticketElement.modifierGroupsSelected || {}).forEach((mg) => {
    areAllModifiersComplete && (areAllModifiersComplete = mg.isComplete);
  });
  ticketElement.isModifiersSelectionComplete = areAllModifiersComplete;
  ticketElement.isComplete = areAllModifiersComplete && !!ticketElement.quantity && !!ticketElement.itemObj;
};
var disableTicketElementsInClosedChecks = (globalState, order, payment) => {
  const checkId = payment.checkId;
  const check = Object.values(order.checks).find(
    (_check) => _check.id === checkId
  );
  if (!check || !order.ticketElements)
    return;
  if (check.status !== "closed" /* CLOSED */)
    return;
  const relatedCheckElementsCount = {};
  const mappedElements = {};
  Object.values(check.checkElements).forEach((checkElement) => {
    if (checkElement.splitWays > 1 && mappedElements[checkElement.instanceId])
      return;
    if (relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId]) {
      relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId].count += 1;
      relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId].rolledUpElements.push({
        itemId: checkElement.instanceId,
        checkElementId: getCheckElementId(checkElement),
        checkId
      });
    } else {
      relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId] = {
        count: 1,
        rolledUpElements: [
          {
            itemId: checkElement.instanceId,
            checkElementId: getCheckElementId(checkElement),
            checkId
          }
        ]
      };
      mappedElements[checkElement.instanceId] = true;
    }
  });
  Object.values(check.checkElements).forEach((checkElement) => {
    var _a, _b, _c, _d;
    if (checkElement.comboElementId) {
      const currentComboElement = order.combos[checkElement.comboElementId];
      if (!currentComboElement)
        return;
      const currentComboElementId = getTicketElementId(currentComboElement);
      const oldTicketToCheckElements = order.ticketElementToCheckElements[checkElement.ticketElementToCheckElementsId];
      if (!currentComboElementId || !oldTicketToCheckElements)
        return;
      if (!((_b = (_a = relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId]) == null ? void 0 : _a.rolledUpElements) == null ? void 0 : _b.length))
        return;
      const isSeatingEnabled = selectIsCurrentOrderSeatingMode.lastResult();
      Object.values(order.combos).forEach((comboElement) => {
        if (comboElement.isInClosedCheck && comboElement.tabletGeneratedId !== currentComboElement.tabletGeneratedId && combosAreEqual(
          order.ticketElements,
          comboElement,
          currentComboElement
        )) {
          comboElement.quantity += relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId].count;
          currentComboElement.quantity -= relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId].count;
          relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId].rolledUpElements.forEach((element) => {
            comboElement.instanceIds.push(element.itemId);
            order.checks[checkId].checkElements[element.checkElementId].comboElementId = getTicketElementId(comboElement);
            order.ticketElementToCheckElements[comboElement.comboElementToCheckElementsId].push(
              createTicketElementToCheckElementObject({
                checkId: element.checkId,
                checkElementId: element.checkElementId,
                instanceId: element.itemId
              })
            );
            if (isSeatingEnabled) {
              Object.keys(checkElement.seats).forEach((seatId) => {
                if (comboElement.seating[Number(seatId)]) {
                  comboElement.seating[Number(seatId)] += 1;
                } else {
                  comboElement.seating[Number(seatId)] = 1;
                }
              });
            }
          });
          if (currentComboElement.quantity === 0) {
            removeComboElement(order, currentComboElementId);
          }
          return;
        }
      });
      if (!order.combos[currentComboElementId])
        return;
      if (currentComboElement.quantity === relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId].count) {
        closeComboElement(order, currentComboElementId);
        return;
      }
      const checkElementQuantity = relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId].count;
      currentComboElement.quantity -= checkElementQuantity;
      calcTotalComboWithAlternativePrice(currentComboElement, {
        taxExempt: order.taxExempt,
        orderType: order.type,
        noTaxInclusive: order.noTaxInclusive,
        orderIsLockedPrice: order.isLockedPrice
      });
      const newComboElementId = generateTabletGeneratedId();
      validateSeatingMode(
        () => globalState,
        () => {
          duplicateRegisterCombo(
            order.combos,
            order.ticketElements,
            currentComboElementId,
            newComboElementId,
            isSeatingEnabled
          );
          const newComboElement = order.combos[newComboElementId];
          newComboElement.instanceIds = [];
          newComboElement.isInClosedCheck = true;
          newComboElement.quantity = checkElementQuantity;
          newComboElement.comboElementToCheckElementsId = newComboElementId;
          const newTicketToCheckElementsId = newComboElementId;
          if (!order.ticketElementToCheckElements[newTicketToCheckElementsId]) {
            order.ticketElementToCheckElements[newTicketToCheckElementsId] = [];
          }
          relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId].rolledUpElements.map((element) => {
            newComboElement.instanceIds.push(element.itemId);
            Array(checkElement.splitWays).fill(null).forEach(() => {
              const connection = oldTicketToCheckElements.find(
                (_checkElement) => _checkElement.instanceId === element.itemId
              );
              if (!connection)
                return;
              oldTicketToCheckElements.splice(
                oldTicketToCheckElements.findIndex(
                  (_checkElement) => _checkElement.instanceId === element.itemId
                ),
                1
              );
              currentComboElement.instanceIds.splice(
                currentComboElement.instanceIds.findIndex(
                  (_itemId) => _itemId === element.itemId
                ),
                1
              );
              order.ticketElementToCheckElements[newTicketToCheckElementsId].push(
                createTicketElementToCheckElementObject({
                  checkId: connection.checkId,
                  checkElementId: connection.checkElementId,
                  instanceId: element.itemId
                })
              );
              order.checks[connection.checkId].checkElements[connection.checkElementId].comboElementId = newComboElementId;
              order.checks[connection.checkId].checkElements[connection.checkElementId].ticketElementToCheckElementsId = newTicketToCheckElementsId;
            });
          });
          if (isSeatingEnabled) {
            Object.keys(checkElement.seats).forEach((seatId) => {
              const seatIdNumber = Number(seatId);
              if (!isNumber(seatIdNumber))
                return;
              currentComboElement.seating[seatIdNumber] -= 1;
              if (currentComboElement.seating[seatIdNumber] < 1) {
                delete currentComboElement.seating[seatIdNumber];
              }
              newComboElement.seating[seatIdNumber] = checkElementQuantity;
            });
          }
          delete relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId];
        }
      );
    } else {
      const currentTicketElement = Object.values(order.ticketElements).find(
        (ticketElement) => ticketElement.tabletGeneratedId === checkElement.ticketElementId || ticketElement.id === checkElement.ticketElementId
      );
      if (!currentTicketElement)
        return;
      const currentTicketElementId = getTicketElementId(currentTicketElement);
      const oldTicketToCheckElements = order.ticketElementToCheckElements[checkElement.ticketElementToCheckElementsId];
      if (!currentTicketElement || !oldTicketToCheckElements)
        return;
      const isSeatingEnabled = selectIsCurrentOrderSeatingMode.lastResult();
      if (!((_d = (_c = relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId]) == null ? void 0 : _c.rolledUpElements) == null ? void 0 : _d.length))
        return;
      Object.values(order.ticketElements).forEach((ticketElement) => {
        if (ticketElement.isInClosedCheck && ticketElement.tabletGeneratedId !== currentTicketElement.tabletGeneratedId && ticketElementsAreEqual(
          ticketElement,
          currentTicketElement
        )) {
          ticketElement.quantity += relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId].count;
          currentTicketElement.quantity -= relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId].count;
          relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId].rolledUpElements.forEach((element) => {
            ticketElement.instanceIds.push(element.itemId);
            order.checks[checkId].checkElements[element.checkElementId].ticketElementId = getTicketElementId(ticketElement);
            order.ticketElementToCheckElements[ticketElement.ticketElementToCheckElementsId].push(
              createTicketElementToCheckElementObject({
                checkId: element.checkId,
                checkElementId: element.checkElementId,
                instanceId: element.itemId
              })
            );
            if (isSeatingEnabled) {
              Object.keys(checkElement.seats).forEach((seatId) => {
                if (ticketElement.seating[Number(seatId)]) {
                  ticketElement.seating[Number(seatId)] += 1;
                } else {
                  ticketElement.seating[Number(seatId)] = 1;
                }
              });
            }
          });
          if (currentTicketElement.quantity === 0) {
            delete order.ticketElements[currentTicketElementId];
            delete order.ticketElementToCheckElements[checkElement.ticketElementToCheckElementsId];
          }
          return;
        }
      });
      if (!order.ticketElements[currentTicketElementId])
        return;
      if (currentTicketElement.quantity === relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId].count) {
        currentTicketElement.isInClosedCheck = true;
        return;
      }
      const checkElementQuantity = relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId].count;
      currentTicketElement.quantity -= checkElementQuantity;
      calcTotalItemWithAlternativePrice(currentTicketElement, {
        orderType: order.type,
        taxExempt: order.taxExempt,
        noTaxInclusive: order.noTaxInclusive,
        orderIsLockedPrice: order.isLockedPrice
      });
      const newTicketElementId = generateTabletGeneratedId();
      const { currentSeat } = globalState.register.registerNavigation;
      validateSeatingMode(
        () => globalState,
        (requireSplitItem = false) => {
          duplicateRegisterItem(
            order.ticketElements,
            currentTicketElementId,
            newTicketElementId,
            requireSplitItem,
            currentSeat,
            isSeatingEnabled
          );
          const newTicketElement = order.ticketElements[newTicketElementId];
          newTicketElement.instanceIds = [];
          newTicketElement.isInClosedCheck = true;
          newTicketElement.quantity = checkElementQuantity;
          newTicketElement.ticketElementToCheckElementsId = newTicketElementId;
          const newTicketToCheckElementsId = newTicketElementId;
          if (!order.ticketElementToCheckElements[newTicketToCheckElementsId]) {
            order.ticketElementToCheckElements[newTicketToCheckElementsId] = [];
          }
          relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId].rolledUpElements.map((element) => {
            newTicketElement.instanceIds.push(element.itemId);
            Array(checkElement.splitWays).fill(null).forEach(() => {
              const connection = oldTicketToCheckElements.find(
                (_checkElement) => _checkElement.instanceId === element.itemId
              );
              if (!connection)
                return;
              oldTicketToCheckElements.splice(
                oldTicketToCheckElements.findIndex(
                  (_checkElement) => _checkElement.instanceId === element.itemId
                ),
                1
              );
              currentTicketElement.instanceIds.splice(
                currentTicketElement.instanceIds.findIndex(
                  (_itemId) => _itemId === element.itemId
                ),
                1
              );
              order.ticketElementToCheckElements[newTicketToCheckElementsId].push(
                createTicketElementToCheckElementObject({
                  checkId: connection.checkId,
                  checkElementId: connection.checkElementId,
                  instanceId: element.itemId
                })
              );
              order.checks[connection.checkId].checkElements[connection.checkElementId].ticketElementId = newTicketElementId;
              order.checks[connection.checkId].checkElements[connection.checkElementId].ticketElementToCheckElementsId = newTicketToCheckElementsId;
            });
          });
          if (isSeatingEnabled) {
            Object.keys(checkElement.seats).forEach((seatId) => {
              const seatIdNumber = Number(seatId);
              if (!isNumber(seatIdNumber))
                return;
              currentTicketElement.seating[seatIdNumber] -= 1;
              if (currentTicketElement.seating[seatIdNumber] < 1) {
                delete currentTicketElement.seating[seatIdNumber];
              }
              newTicketElement.seating[seatIdNumber] = checkElementQuantity;
            });
          }
          delete relatedCheckElementsCount[checkElement.ticketElementToCheckElementsId];
        }
      );
    }
  });
};
var reEnableTicketElementsInClosedChecks = (order, checkId) => {
  const check = order.checks[checkId];
  if (!check)
    return;
  const reOpenedCheckElements = Object.values(check.checkElements);
  reOpenedCheckElements.forEach((checkElement) => {
    var _a;
    if (checkElement.comboElementId) {
      openComboElement(order, checkElement.comboElementId);
    } else {
      if (checkElement.ticketElementId && ((_a = order.ticketElements[checkElement.ticketElementId]) == null ? void 0 : _a.isInClosedCheck)) {
        order.ticketElements[checkElement.ticketElementId].isInClosedCheck = false;
      }
    }
  });
};
var getTicketElementClosedChecks = (order, ticketElementId) => {
  const closedChecks = [];
  Object.values(order.checks).forEach((orderCheck) => {
    if (checkStatusAllowsEditing(orderCheck.status))
      return;
    Object.values(orderCheck.checkElements).forEach((orderCheckElement) => {
      if ((orderCheckElement == null ? void 0 : orderCheckElement.comboElementId) === ticketElementId) {
        closedChecks.push(getCheckId(orderCheck));
      } else if ((orderCheckElement == null ? void 0 : orderCheckElement.ticketElementId) === ticketElementId) {
        closedChecks.push(getCheckId(orderCheck));
      }
    });
  });
  return closedChecks;
};
var getTicketElementChecks = (order, ticketElementId) => {
  const closedChecks = [];
  Object.values(order.checks).forEach((orderCheck) => {
    if (orderCheck.status === "closed" /* CLOSED */ || orderCheck.status === "voided" /* VOIDED */)
      return;
    Object.values(orderCheck.checkElements).forEach((orderCheckElement) => {
      var _a, _b;
      if (orderCheckElement.comboElementId && Object.keys(orderCheckElement.comboItemNames).includes(
        ticketElementId.toString()
      )) {
        closedChecks.push((_a = orderCheck.id) != null ? _a : orderCheck.tabletGeneratedId);
      } else if (orderCheckElement.ticketElementId === ticketElementId) {
        closedChecks.push((_b = orderCheck.id) != null ? _b : orderCheck.tabletGeneratedId);
      }
    });
  });
  return closedChecks;
};
var getItemCopy = (globalState, itemId, menuTypeId, priceOverride, defaultNoSeatOverride, isCustomizerSubcategory) => {
  const item = globalState.menu.locationMenu.items[itemId];
  let _menuTypeId = menuTypeId;
  const {
    ticketElementId: currentTicketElementId,
    orderId,
    subcategoryId,
    categoryId
  } = globalState.register.registerNavigation;
  if (currentTicketElementId) {
    const currentOrderId = orderId || 0;
    const currentOrder = globalState.register.orders[currentOrderId];
    const currentTicketElement = currentOrder.ticketElements[currentTicketElementId];
    if (currentTicketElement)
      _menuTypeId = currentTicketElement.menuTypeId;
  }
  const isShowAllModsEnabledInItem = item == null ? void 0 : item.menuTypeVersions[_menuTypeId].showAllMods;
  const showAllModsBehavior = item == null ? void 0 : item.menuTypeVersions[_menuTypeId].allModsBehavior;
  const allModIds = item == null ? void 0 : item.menuTypeVersions[_menuTypeId].allModIds;
  if (!item)
    return null;
  const currentTaxIds = getTaxesToApplyFromItemObj(
    item,
    _menuTypeId
  );
  const taxesSnapshot = getSnapshotFromItemTaxes(globalState, currentTaxIds);
  const premadeMenuTypeVersionWithModifierGroups = preMakeMenuTypeVersionWithModifierGroups(
    item.itemId,
    item.menuTypeVersions[_menuTypeId],
    globalState.menu,
    true
  );
  const newModifierGroups = recursiveModifierMapperCore(
    premadeMenuTypeVersionWithModifierGroups.modifierGroups,
    globalState.menu.locationMenu.modifierGroups,
    globalState.menu.locationMenu.modifierItems,
    true,
    0
  );
  const newModifierGroupIds = Object.keys(newModifierGroups).map(Number);
  const newTicketItem = __spreadProps(__spreadValues({}, item), {
    menuTypeVersions: {
      [_menuTypeId]: __spreadProps(__spreadValues({}, item.menuTypeVersions[_menuTypeId]), {
        ingredients: Object.entries(
          item.menuTypeVersions[_menuTypeId].ingredients
        ).filter(([, ingredient]) => ingredient.active).reduce(
          (acc, [key, ingredient]) => __spreadProps(__spreadValues({}, acc), { [key]: ingredient }),
          {}
        ),
        modifierGroups: newModifierGroups,
        allModIds: allModIds.filter((id) => newModifierGroupIds.includes(id)),
        categoriesSubcategories: isCustomizerSubcategory ? {
          [_menuTypeId]: {
            categoryId,
            subcategoryId
          }
        } : item.menuTypeVersions[_menuTypeId].categoriesSubcategories
        // TODO: Check if we need this data on the ticket element
      })
    },
    taxesSource: taxesSnapshot
  });
  const hotButtonsModifierItemId = globalState.register.registerNavigation.modifierItemHotButtonSelectedId;
  let allModsModifierItems = {};
  switch (showAllModsBehavior) {
    case "premade" /* PREMADE */:
      if (hotButtonsModifierItemId) {
        {
          const hotButtonIsOnModGroups = Object.values(
            premadeMenuTypeVersionWithModifierGroups.modifierGroups
          ).filter((modifierGroup) => !modifierGroup.isAllMod).find(
            (modifierGroup) => Object.keys(modifierGroup.modifierItems).includes(
              String(hotButtonsModifierItemId)
            )
          );
          if (!hotButtonIsOnModGroups) {
            const hotButtonIsOnPremadeGroups = Object.values(
              premadeMenuTypeVersionWithModifierGroups.modifierGroups
            ).filter((modifierGroup) => modifierGroup.isAllMod).find(
              (modifierGroup) => Object.keys(modifierGroup.modifierItems).includes(
                String(hotButtonsModifierItemId)
              )
            );
            if (hotButtonIsOnPremadeGroups) {
              const menuModifierItem = globalState.menu.locationMenu.modifierItems[hotButtonsModifierItemId];
              const ticketItemModifierGroupModifierItem = modifierItemToTicketModifierItem(
                menuModifierItem,
                hotButtonIsOnPremadeGroups.modifierGroupId,
                true,
                globalState.menu.locationMenu.modifierGroups,
                globalState.menu.locationMenu.modifierItems,
                0
              );
              newModifierGroups[hotButtonIsOnPremadeGroups.modifierGroupId].modifierItems[hotButtonsModifierItemId] = ticketItemModifierGroupModifierItem;
            }
          } else {
            if (!newModifierGroups[hotButtonIsOnModGroups.modifierGroupId].modifierItems[hotButtonsModifierItemId]) {
              const menuModifierItem = globalState.menu.locationMenu.modifierItems[hotButtonsModifierItemId];
              const ticketItemModifierGroupModifierItem = modifierItemToTicketModifierItem(
                menuModifierItem,
                ALL_MODS_ID,
                true,
                globalState.menu.locationMenu.modifierGroups,
                globalState.menu.locationMenu.modifierItems,
                0
              );
              newModifierGroups[hotButtonIsOnModGroups.modifierGroupId].modifierItems[hotButtonsModifierItemId] = ticketItemModifierGroupModifierItem;
            }
          }
        }
      }
      break;
    case "all" /* ALL */: {
      if (hotButtonsModifierItemId) {
        const modifierGroupWithHotButtonModItem = Object.values(
          premadeMenuTypeVersionWithModifierGroups.modifierGroups
        ).find(
          (modifierGroup) => Object.keys(modifierGroup.modifierItems).includes(
            String(hotButtonsModifierItemId)
          )
        );
        if (!modifierGroupWithHotButtonModItem) {
          const menuModifierItem = globalState.menu.locationMenu.modifierItems[hotButtonsModifierItemId];
          const ticketItemModifierGroupModifierItem = modifierItemToTicketModifierItem(
            menuModifierItem,
            ALL_MODS_ID,
            true,
            globalState.menu.locationMenu.modifierGroups,
            globalState.menu.locationMenu.modifierItems,
            0
          );
          allModsModifierItems = {
            [hotButtonsModifierItemId]: ticketItemModifierGroupModifierItem
          };
        } else {
          if (!newModifierGroups[modifierGroupWithHotButtonModItem.modifierGroupId].modifierItems[hotButtonsModifierItemId]) {
            const menuModifierItem = globalState.menu.locationMenu.modifierItems[hotButtonsModifierItemId];
            const ticketItemModifierGroupModifierItem = modifierItemToTicketModifierItem(
              menuModifierItem,
              ALL_MODS_ID,
              true,
              globalState.menu.locationMenu.modifierGroups,
              globalState.menu.locationMenu.modifierItems,
              0
            );
            newModifierGroups[modifierGroupWithHotButtonModItem.modifierGroupId].modifierItems[hotButtonsModifierItemId] = ticketItemModifierGroupModifierItem;
          }
        }
      }
      break;
    }
    case "associated" /* ASSOCIATED */:
    default: {
      if (hotButtonsModifierItemId) {
        {
          const hotButtonIsOnModGroups = Object.values(
            premadeMenuTypeVersionWithModifierGroups.modifierGroups
          ).filter((modifierGroup) => !modifierGroup.isAllMod).find(
            (modifierGroup) => Object.keys(modifierGroup.modifierItems).includes(
              String(hotButtonsModifierItemId)
            )
          );
          if (hotButtonIsOnModGroups) {
            if (!newModifierGroups[hotButtonIsOnModGroups.modifierGroupId].modifierItems[hotButtonsModifierItemId]) {
              const menuModifierItem = globalState.menu.locationMenu.modifierItems[hotButtonsModifierItemId];
              const ticketItemModifierGroupModifierItem = modifierItemToTicketModifierItem(
                menuModifierItem,
                hotButtonIsOnModGroups.modifierGroupId,
                true,
                globalState.menu.locationMenu.modifierGroups,
                globalState.menu.locationMenu.modifierItems,
                0
              );
              newModifierGroups[hotButtonIsOnModGroups.modifierGroupId].modifierItems[hotButtonsModifierItemId] = ticketItemModifierGroupModifierItem;
            }
          }
        }
      }
      break;
    }
  }
  if (isShowAllModsEnabledInItem) {
    newTicketItem.menuTypeVersions[_menuTypeId].modifierGroups[ALL_MODS_ID] = __spreadProps(__spreadValues({}, ALL_MODIFIERS_MODIFIER_GROUP()), {
      id: ALL_MODS_ID,
      modifierGroupId: ALL_MODS_ID,
      modifierItems: allModsModifierItems,
      requiredModifierItems: 0,
      sortPriority: Infinity
    });
  }
  if (isNumber(priceOverride)) {
    newTicketItem.menuTypeVersions[_menuTypeId].itemPrice = priceOverride;
  }
  if (defaultNoSeatOverride) {
    newTicketItem.menuTypeVersions[_menuTypeId].defaultNoSeat = true;
  }
  if (isEmpty(newTicketItem.menuTypeVersions[_menuTypeId].modifierGroups) && newTicketItem.menuTypeVersions[_menuTypeId].showAllMods) {
    newTicketItem.menuTypeVersions[_menuTypeId].modifierGroups = {
      [0]: ALL_MODIFIERS_MODIFIER_GROUP()
    };
  }
  return newTicketItem;
};
var getAssociatedModifierItems = (ticketElement) => {
  const associatedModifierItems = {};
  const currentItemModifierGroups = Object.values(
    ticketElement.menuTypeVersions
  )[0].modifierGroups;
  if (!currentItemModifierGroups)
    return { associatedModifierItems, addedModifierItemsIds: [] };
  const addedModifierItemsIds = [];
  Object.values(currentItemModifierGroups).filter((_modifierGroup) => _modifierGroup.active).sort(
    (modifierGroupA, modifierGroupB) => modifierGroupA.sortPriority - modifierGroupB.sortPriority
  ).forEach((_modifierGroup) => {
    const validModifierItems = Object.values(
      (_modifierGroup == null ? void 0 : _modifierGroup.modifierItems) || {}
    ).filter(
      (modifierItem) => !addedModifierItemsIds.includes(modifierItem.modifierItemId)
    ).filter((modifierItem) => modifierItem.active).sort(
      (modifierItemA, modifierItemB) => modifierItemA.sortPriority - modifierItemB.sortPriority
    ).map((modifierItem) => {
      addedModifierItemsIds.push(modifierItem.modifierItemId);
      return __spreadValues({}, modifierItem);
    });
    validModifierItems.forEach((validModifierItem) => {
      associatedModifierItems[validModifierItem.modifierItemId] = __spreadProps(__spreadValues({}, validModifierItem), {
        premadeModifierGroupSortPriority: _modifierGroup.sortPriority
      });
    });
  });
  return { associatedModifierItems, addedModifierItemsIds };
};
var getPreMadeModifierItems = (ticketElement) => {
  const preMadeModifierGroupsIds = Object.values(
    ticketElement.menuTypeVersions
  )[0].allModIds;
  const associatedModifierItems = {};
  const currentItemModifierGroups = Object.values(
    ticketElement.menuTypeVersions
  )[0].modifierGroups;
  if (!currentItemModifierGroups)
    return associatedModifierItems;
  const preMadeModifierGroups = preMadeModifierGroupsIds.map(
    (preMadeModifierGroupId) => currentItemModifierGroups[Number(preMadeModifierGroupId)]
  ).filter((_modifierGroup) => _modifierGroup.active).sort(
    (modifierGroupA, modifierGroupB) => modifierGroupA.sortPriority - modifierGroupB.sortPriority
  );
  if (!preMadeModifierGroups.length)
    return associatedModifierItems;
  const addedModifierItemsIds = [];
  Object.values(preMadeModifierGroups).forEach((_modifierGroup) => {
    const validModifierItems = Object.values(
      (_modifierGroup == null ? void 0 : _modifierGroup.modifierItems) || {}
    ).filter(
      (modifierItem) => !addedModifierItemsIds.includes(modifierItem.modifierItemId)
    ).sort(
      (modifierItemA, modifierItemB) => modifierItemA.sortPriority - modifierItemB.sortPriority
    ).filter((modifierItem) => modifierItem.active).map((modifierItem) => {
      addedModifierItemsIds.push(modifierItem.modifierItemId);
      return __spreadValues({}, modifierItem);
    });
    validModifierItems.forEach((validModifierItem) => {
      associatedModifierItems[validModifierItem.modifierItemId] = __spreadValues({}, validModifierItem);
    });
  });
  return associatedModifierItems;
};
var assignCourseId = (ticketElement, globalState) => {
  var _a;
  const isCoursingEnabled = selectIsCoursingEnabled(globalState);
  if (!isCoursingEnabled)
    return null;
  const menuTypeId = isOpenItemFn(ticketElement) ? 0 : ticketElement.menuTypeId;
  const itemCopy = ticketElement.itemObj;
  const defaultCourseId = itemCopy == null ? void 0 : itemCopy.menuTypeVersions[menuTypeId].courseId;
  if (isNil(defaultCourseId))
    return null;
  const isCourseActive = (_a = globalState.settings.selectedMode.currentSettings.register.courses[defaultCourseId]) == null ? void 0 : _a.active;
  return isCourseActive ? defaultCourseId : null;
};
var getBasePrice = (menuTypeVersion, isToGo) => {
  var _a, _b;
  const isPromptForPriceItem = menuTypeVersion.promptForPrice;
  let baseItemPrice = (_a = menuTypeVersion.itemPrice) != null ? _a : 0;
  if (isPromptForPriceItem)
    return baseItemPrice;
  if (isToGo)
    baseItemPrice = (_b = menuTypeVersion.toGoPrice) != null ? _b : 0;
  return baseItemPrice;
};
var getAlternativeListBasePrice = (baseItemPrice, dualPricingSettings) => {
  const { listPrice, cardCashPrice } = dualPricingSettings;
  if (listPrice === "card" /* CARD */) {
    return baseItemPrice * (1 - cardCashPrice / 100);
  }
  return baseItemPrice * (1 + cardCashPrice / 100);
};
var getItemPriceData = (baseItemPrice, modifierItemsPrice, quantity, special, taxesSource, taxIds, orderType, itemVolumeData) => {
  let totalSpecialsAmount = 0;
  let specials = {};
  if (special) {
    totalSpecialsAmount = getAppliedDiscountAmount(
      special.discountType,
      special.discountAmount,
      baseItemPrice * quantity,
      quantity,
      special.thresholdAmount
    );
    const tabletGeneratedId = generateTimestampId();
    specials = {
      [tabletGeneratedId]: __spreadProps(__spreadValues({}, getSpecialAppliedValue(special)), {
        appliedSpecialAmount: totalSpecialsAmount,
        tabletGeneratedId
      })
    };
  }
  const taxReduceFunction = getTaxesReduceFunction(
    taxesSource,
    orderType,
    orderType === "to_go" /* TO_GO */,
    baseItemPrice,
    quantity,
    itemVolumeData
  );
  const basePriceTaxes = taxIds.reduce(
    taxReduceFunction,
    getInitialTaxDetailsObject()
  );
  const modTaxReduceFunction = getTaxesReduceFunction(
    taxesSource,
    orderType,
    orderType === "to_go" /* TO_GO */,
    modifierItemsPrice,
    quantity,
    null,
    true
  );
  const modPriceTaxes = taxIds.reduce(
    modTaxReduceFunction,
    getInitialTaxDetailsObject()
  );
  const taxResultObj = mergeTaxesObjects(basePriceTaxes, modPriceTaxes);
  return {
    totalSpecialsAmount,
    specials,
    taxResultObj
  };
};
var createNewTicketElement = (orderId, ticketElementId, orderType, globalState, newTicketItem, special, dualPricingSettings, noTaxInclusive, defaultMenuTypeId) => {
  var _a, _b, _c, _d;
  const menuTypeId = defaultMenuTypeId || globalState.register.registerNavigation.menuTypeId || 0;
  const menuTypeInMenu = selectMenuTypes(globalState)[menuTypeId];
  const loggedInOrganizationUserId = globalState.loggedInUser.organizationUserId || 0;
  const isToGo = orderType === "to_go" /* TO_GO */;
  let baseItemPrice = newTicketItem ? getBasePrice(newTicketItem.menuTypeVersions[menuTypeId], isToGo) : 0;
  const selectedModifiersPricePerItemUnit = (_a = newTicketItem == null ? void 0 : newTicketItem.menuTypeVersions[menuTypeId].defaultModifiersPrice) != null ? _a : 0;
  const taxesSource = (_b = newTicketItem == null ? void 0 : newTicketItem.taxesSource) != null ? _b : {};
  const taxIds = getTaxesToApplyFromItemObj(newTicketItem, menuTypeId);
  const isTaxInclusive = noTaxInclusive ? false : (_c = newTicketItem == null ? void 0 : newTicketItem.menuTypeVersions[menuTypeId].taxInclusive) != null ? _c : false;
  const quantity = (_d = globalState.register.registerNavigation.quantity) != null ? _d : 1;
  let taxInclusiveSelectedModifiersPricePerItemUnit = 0;
  if (isTaxInclusive) {
    baseItemPrice = getBasePriceFromTaxInclusive(
      taxesSource,
      orderType,
      baseItemPrice,
      taxIds,
      isToGo,
      newTicketItem ? getItemVolumeData(newTicketItem, menuTypeId) : null,
      quantity
    );
    taxInclusiveSelectedModifiersPricePerItemUnit = getModsPriceForTaxInclusive(
      taxesSource,
      orderType,
      selectedModifiersPricePerItemUnit,
      taxIds,
      isToGo,
      quantity
    );
  }
  const { totalSpecialsAmount, specials, taxResultObj } = getItemPriceData(
    baseItemPrice,
    isTaxInclusive ? taxInclusiveSelectedModifiersPricePerItemUnit : selectedModifiersPricePerItemUnit,
    quantity,
    special,
    taxesSource,
    taxIds,
    orderType,
    newTicketItem ? getItemVolumeData(newTicketItem, menuTypeId) : null
  );
  let alternativePriceData = null;
  if (dualPricingSettings.dualPricing) {
    const alternativeBaseItemPrice = getAlternativeListBasePrice(
      baseItemPrice,
      dualPricingSettings
    );
    const alternativeModifiersPrice = getAlternativeListBasePrice(
      isTaxInclusive ? taxInclusiveSelectedModifiersPricePerItemUnit : selectedModifiersPricePerItemUnit,
      dualPricingSettings
    );
    const {
      specials: _specials,
      totalSpecialsAmount: _totalSpecialsAmount,
      taxResultObj: _taxResultObj
    } = getItemPriceData(
      alternativeBaseItemPrice,
      alternativeModifiersPrice,
      quantity,
      special,
      taxesSource,
      taxIds,
      orderType,
      newTicketItem ? getItemVolumeData(newTicketItem, menuTypeId) : null
    );
    alternativePriceData = {
      baseItemPrice: alternativeBaseItemPrice,
      selectedModifiersPricePerItemUnit: alternativeModifiersPrice,
      specials: _specials,
      discounts: {},
      taxDetails: _taxResultObj.details,
      taxInclusiveSelectedModifiersPricePerItemUnit,
      totalDiscountAmount: 0,
      totalPricePerItemUnit: alternativeBaseItemPrice + alternativeModifiersPrice,
      totalPriceWithDiscountsSpecialsNotTaxes: alternativeBaseItemPrice + alternativeModifiersPrice - _totalSpecialsAmount,
      totalSpecialsAmount: _totalSpecialsAmount,
      totalTax: roundToMoneyDecimals(_taxResultObj.taxTotal),
      totalSpecialsBOGOAmount: 0
    };
  }
  const newTicketElement = __spreadProps(__spreadValues({}, TICKET_ELEMENT_INITIAL_STATE), {
    id: void 0,
    tabletGeneratedId: `${ticketElementId}`,
    timeAdded: getNowUTCDate(),
    timeTriggered: NULLISH_DATE,
    timeSentToKitchen: NULLISH_DATE,
    versionId: 1,
    itemObj: newTicketItem,
    customizerType: (newTicketItem == null ? void 0 : newTicketItem.menuTypeVersions[menuTypeId].customizer) ? "item" /* ITEM */ : newTicketItem ? "none" /* NONE */ : "subcategory" /* SUBCATEGORY */,
    orderId: typeof orderId === "string" ? null : orderId,
    itemId: (newTicketItem == null ? void 0 : newTicketItem.itemId) || null,
    locationMenuTypeItemId: (newTicketItem == null ? void 0 : newTicketItem.menuTypeVersions[menuTypeId].locationMenuTypeItemId) || null,
    locationMenuTypeItemVersionId: (newTicketItem == null ? void 0 : newTicketItem.menuTypeVersions[menuTypeId].locationMenuTypeItemVersionId) || null,
    baseItemPrice,
    taxInclusiveSelectedModifiersPricePerItemUnit,
    selectedModifiersPricePerItemUnit,
    totalSpecialsAmount,
    totalPriceWithDiscountsSpecialsNotTaxes: baseItemPrice + selectedModifiersPricePerItemUnit - totalSpecialsAmount,
    totalPricePerItemUnit: baseItemPrice + selectedModifiersPricePerItemUnit,
    isTriggeringManuallyDisabled: false,
    createdById: loggedInOrganizationUserId,
    lastUpdatedById: loggedInOrganizationUserId,
    menuTypeId,
    specials,
    totalTax: roundToMoneyDecimals(taxResultObj.taxTotal),
    taxDetails: taxResultObj.details,
    isTakeout: isToGo,
    noPrinterLocation: false,
    isTaxInclusive,
    menuTypeInfo: {
      id: menuTypeInMenu.id,
      name: menuTypeInMenu.name,
      posName: menuTypeInMenu.posName,
      disableCoursing: menuTypeInMenu.coursingType !== "coursing" /* COURSING */
    },
    alternativePriceData
  });
  delete newTicketElement.id;
  return newTicketElement;
};
var updateTicketElement = (orderId, ticketElement, newTicketItem, globalState, special, orderType) => {
  var _a, _b, _c, _d, _e;
  if (!newTicketItem)
    return ticketElement;
  const menuTypeId = Number(Object.keys(newTicketItem == null ? void 0 : newTicketItem.menuTypeVersions)[0]);
  const loggedInOrganizationUserId = globalState.loggedInUser.organizationUserId || 0;
  ticketElement.itemObj = newTicketItem;
  ticketElement.selectedModifiersPricePerItemUnit = newTicketItem.menuTypeVersions[menuTypeId].defaultModifiersPrice;
  ticketElement.itemId = newTicketItem.itemId;
  ticketElement.locationMenuTypeItemId = newTicketItem.menuTypeVersions[menuTypeId].locationMenuTypeItemId;
  ticketElement.locationMenuTypeItemVersionId = newTicketItem.menuTypeVersions[menuTypeId].locationMenuTypeItemVersionId;
  ticketElement.lastUpdatedById = loggedInOrganizationUserId;
  ticketElement.baseItemPrice = newTicketItem ? getBasePrice(
    newTicketItem.menuTypeVersions[menuTypeId],
    globalState.register.orders[orderId].type === "to_go" /* TO_GO */
  ) : 0;
  ticketElement.selectedModifiersPricePerItemUnit = (_a = newTicketItem == null ? void 0 : newTicketItem.menuTypeVersions[menuTypeId].defaultModifiersPrice) != null ? _a : 0;
  let totalSpecialAmount = 0;
  let specials = {};
  if (special) {
    const quantity = (_b = globalState.register.registerNavigation.quantity) != null ? _b : 1;
    totalSpecialAmount = getAppliedDiscountAmount(
      special.discountType,
      special.discountAmount,
      ticketElement.baseItemPrice * quantity,
      quantity,
      special.thresholdAmount
    );
    const tabletGeneratedId = generateTimestampId();
    specials = {
      [tabletGeneratedId]: __spreadProps(__spreadValues({}, getSpecialAppliedValue(special)), {
        appliedSpecialAmount: totalSpecialAmount,
        tabletGeneratedId
      })
    };
  }
  ticketElement.specials = specials;
  const taxesSource = (_c = newTicketItem == null ? void 0 : newTicketItem.taxesSource) != null ? _c : {};
  const taxIds = getTaxesToApplyFromItemObj(newTicketItem, menuTypeId);
  const taxReduceFunction = getTaxesReduceFunction(
    taxesSource,
    orderType,
    orderType === "to_go" /* TO_GO */,
    ticketElement.baseItemPrice + ticketElement.selectedModifiersPricePerItemUnit - totalSpecialAmount,
    (_e = (_d = ticketElement.quantity) != null ? _d : globalState.register.registerNavigation.quantity) != null ? _e : 1,
    getTicketItemVolumeData(ticketElement)
  );
  const { taxTotal, details } = taxIds.reduce(
    taxReduceFunction,
    getInitialTaxDetailsObject()
  );
  ticketElement.totalTax = roundToMoneyDecimals(taxTotal);
  ticketElement.taxDetails = details;
  return ticketElement;
};
var updateWithGlobalQuantities = (ticketElement, globalState) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const isSeatingModeEnabled = selectIsCurrentOrderSeatingMode(globalState);
  if (!isSeatingModeEnabled) {
    ticketElement.quantity = (_a = globalState.register.registerNavigation.quantity) != null ? _a : 1;
    ticketElement.seating = { [NO_SEAT_ID]: ticketElement.quantity };
    return;
  }
  const isShared = selectCurrentSeatSharedBarStatus(globalState);
  const selectedSeats = Object.keys(
    globalState.register.registerNavigation.seats
  );
  const isSeatingModeNoPrompt = selectSeatingMode(globalState) === "no_prompt" /* NO_PROMPT */;
  const currentOrderType = selectCurrentOrderType(globalState);
  const isToGoOrder = currentOrderType === "to_go" /* TO_GO */;
  const isAttachNoSeatToGoOrder = selectAttachNoSeatToToGo(globalState);
  const isToGoAndNoSeat = isToGoOrder && isAttachNoSeatToGoOrder;
  const defaultNoSeat = isToGoAndNoSeat ? true : isComboElement(ticketElement) ? (_b = ticketElement.comboObj) == null ? void 0 : _b.menuTypeVersions[ticketElement.menuTypeId].defaultNoSeat : isOpenItemFn(ticketElement) ? false : (_c = ticketElement.itemObj) == null ? void 0 : _c.menuTypeVersions[ticketElement.menuTypeId].defaultNoSeat;
  if (selectedSeats.length === 0 && !defaultNoSeat && !isSeatingModeNoPrompt) {
    ticketElement.seating = {};
    ticketElement.quantity = 0;
    return;
  } else if (selectedSeats.length === 0 && defaultNoSeat) {
    ticketElement.quantity = (_d = globalState.register.registerNavigation.quantity) != null ? _d : 1;
    ticketElement.seating = {
      [NO_SEAT_ID]: (_e = globalState.register.registerNavigation.quantity) != null ? _e : 1
    };
    return;
  }
  const count = selectedSeats.length;
  const shareAmount = isShared ? ((_f = globalState.register.registerNavigation.quantity) != null ? _f : 1) / count : 1;
  ticketElement.seating = Object.entries(
    globalState.register.registerNavigation.seats
  ).reduce((acc, [seatId]) => {
    var _a2;
    return __spreadProps(__spreadValues({}, acc), {
      [seatId]: isShared ? shareAmount : (_a2 = globalState.register.registerNavigation.quantity) != null ? _a2 : 1
    });
  }, {});
  ticketElement.isShared = isShared;
  ticketElement.quantity = isShared ? (_g = globalState.register.registerNavigation.quantity) != null ? _g : 1 : Object.values(ticketElement.seating).reduce(
    (acc, seatQuantity) => acc + seatQuantity,
    0
  );
};
var updateCompletedSections = (ticketElement, isSeatingEnabled, modifierGroupId = 0, modifierItemId = 0, isNested = false, modifierInstanceId = 0, nestedModifierGroupId = 0) => {
  const modGroup = ticketElement.modifierGroupsSelected[modifierGroupId];
  const modItem = modGroup == null ? void 0 : modGroup.modifierItemsSelected[modifierItemId];
  if (isNested) {
    const modInstance = modItem == null ? void 0 : modItem.modifierItemInstances[modifierInstanceId];
    const nestedModGroup = modInstance == null ? void 0 : modInstance.nestedModifierGroupsSelected[nestedModifierGroupId];
    if (!nestedModGroup)
      return;
    nestedModGroup.isComplete = nestedModGroup.isNoneSelected || nestedModGroup.quantityRequired <= getModifierItemsSelectedQty(nestedModGroup);
    modInstance.isComplete = Object.values(
      modInstance.nestedModifierGroupsSelected
    ).every((_nestedModGroup) => _nestedModGroup.isComplete);
  }
  if (modifierItemId && modItem) {
    modItem.isComplete = Object.values(modItem.modifierItemInstances).every(
      (_modifierItemInstance) => _modifierItemInstance.isComplete
    );
  }
  if (modGroup) {
    modGroup.isComplete = modGroup.isNoneSelected || modGroup.quantityRequired <= getModifierItemsSelectedQty(modGroup) && modGroup.modifierItemsWithNested.every(
      (_modifierItemId) => {
        var _a;
        return (_a = modGroup.modifierItemsSelected[_modifierItemId]) == null ? void 0 : _a.isComplete;
      }
    );
  }
  ticketElement.isModifiersSelectionComplete = (isNotOpenItemFn(ticketElement) ? !!ticketElement.itemObj : true) && Object.values(ticketElement.modifierGroupsSelected).every(
    (_modGroup) => _modGroup.isComplete
  );
  const isComplete = ticketElement.isModifiersSelectionComplete && isTicketElementQuantityComplete(ticketElement, isSeatingEnabled);
  ticketElement.isComplete = isComplete;
};
var isTicketElementQuantityComplete = (ticketElement, isSeatingEnabled) => {
  var _a;
  const qtyWhenSent = (_a = ticketElement.configWhenSent) == null ? void 0 : _a.quantity;
  if (qtyWhenSent && ticketElement.quantity !== qtyWhenSent)
    return false;
  if (isSeatingEnabled) {
    return !!ticketElement.quantity && !isEmpty(ticketElement.seating);
  }
  return !!ticketElement.quantity;
};
var adjustTicketElemItemElementIds = (order, ticketElement, quantityDelta, seat) => {
  const createdCheckElementsIds = [];
  if (quantityDelta > 0) {
    Array(quantityDelta).fill(null).forEach(() => {
      const instanceId = generateTabletGeneratedId();
      const currentTicketElementId = getTicketElementId(ticketElement);
      const newCheckElement = addTicketElementToChecks(
        order,
        currentTicketElementId,
        instanceId
      );
      if (!newCheckElement)
        return;
      const previousElementId = ticketElement.instanceIds[0];
      const existingCheckElementConnection = order.ticketElementToCheckElements[ticketElement.ticketElementToCheckElementsId].find(
        ({ instanceId: _itemElementId }) => _itemElementId === previousElementId
      );
      if (!existingCheckElementConnection)
        return;
      const existingCheckElement = order.checks[existingCheckElementConnection.checkId].checkElements[existingCheckElementConnection == null ? void 0 : existingCheckElementConnection.checkElementId];
      if (!existingCheckElement)
        return;
      ticketElement.instanceIds.push(instanceId);
      const newCheckElementId = getCheckElementId(newCheckElement);
      updateCheckElementOld(
        order,
        order.checks[order.defaultCheckId],
        order.checks[order.defaultCheckId].checkElements[newCheckElementId],
        {
          name: existingCheckElement.name,
          itemCount: 0,
          discount: existingCheckElement.discount,
          specialAmount: existingCheckElement.specialAmount,
          eachPrice: existingCheckElement.eachPrice,
          price: existingCheckElement.eachPrice,
          quantity: 0,
          tax: existingCheckElement.tax,
          seats: seat && isInteger(seat) ? { [seat]: 0 } : {},
          isShared: false
        }
      );
      createdCheckElementsIds.push(newCheckElementId);
    });
  } else {
    const ticketElementToCheckElementsId = ticketElement.ticketElementToCheckElementsId;
    if (!seat) {
      Array(Math.abs(quantityDelta)).fill(null).forEach(() => {
        const instanceId = ticketElement.instanceIds.pop();
        const connections2 = order.ticketElementToCheckElements[ticketElementToCheckElementsId].filter(
          ({ instanceId: _itemElementId }) => _itemElementId === instanceId
        );
        connections2.forEach(({ checkId, checkElementId }) => {
          const checkElement = order.checks[checkId].checkElements[checkElementId];
          const check = order.checks[checkId];
          if (!check || !checkElement)
            return;
          deleteCheckElementAndUpdateCheckOld(order, check, checkElement);
          order.ticketElementToCheckElements[ticketElementToCheckElementsId].splice(
            order.ticketElementToCheckElements[ticketElementToCheckElementsId].findIndex(
              ({ checkElementId: _checkElementId }) => _checkElementId === checkElementId
            ),
            1
          );
        });
      });
      return createdCheckElementsIds;
    }
    const elementIdsToRemove = [];
    const connections = cloneDeep(
      order.ticketElementToCheckElements[ticketElementToCheckElementsId]
    );
    connections.forEach(({ checkId, checkElementId, instanceId }) => {
      if (elementIdsToRemove.length === Math.abs(quantityDelta) && !elementIdsToRemove.includes(instanceId))
        return;
      const checkElement = order.checks[checkId].checkElements[checkElementId];
      const check = order.checks[checkId];
      if (!check || !checkElement)
        return;
      if (checkElement.seats[seat]) {
        deleteCheckElementAndUpdateCheckOld(order, check, checkElement);
        order.ticketElementToCheckElements[ticketElementToCheckElementsId].splice(
          order.ticketElementToCheckElements[ticketElementToCheckElementsId].findIndex(
            ({
              checkId: _checkId,
              checkElementId: _checkElementId,
              instanceId: _itemElementId
            }) => _checkId === checkId && _checkElementId === checkElementId && _itemElementId === instanceId
          ),
          1
        );
        if (!elementIdsToRemove.includes(instanceId)) {
          ticketElement.instanceIds.splice(
            ticketElement.instanceIds.findIndex(
              (_itemElementId) => _itemElementId === instanceId
            ),
            1
          );
          elementIdsToRemove.push(instanceId);
        }
      }
    });
  }
  return createdCheckElementsIds;
};
var adjustComboElemItemElementIds = (order, comboElement, quantityDelta, seat) => {
  const createdCheckElementsIds = [];
  if (quantityDelta > 0) {
    Array(quantityDelta).fill(null).forEach(() => {
      const instanceId = generateTabletGeneratedId();
      const currentTicketElementId = getTicketElementId(comboElement);
      const newCheckElement = addComboToChecks(
        order,
        currentTicketElementId,
        instanceId
      );
      if (!newCheckElement)
        return;
      const previousElementId = comboElement.instanceIds[0];
      const existingCheckElementConnection = order.ticketElementToCheckElements[comboElement.comboElementToCheckElementsId].find(
        ({ instanceId: _itemElementId }) => _itemElementId === previousElementId
      );
      if (!existingCheckElementConnection)
        return;
      const existingCheckElement = order.checks[existingCheckElementConnection.checkId].checkElements[existingCheckElementConnection == null ? void 0 : existingCheckElementConnection.checkElementId];
      if (!existingCheckElement)
        return;
      comboElement.instanceIds.push(instanceId);
      const newCheckElementId = getCheckElementId(newCheckElement);
      updateCheckElementOld(
        order,
        order.checks[order.defaultCheckId],
        order.checks[order.defaultCheckId].checkElements[newCheckElementId],
        {
          name: existingCheckElement.name,
          itemCount: existingCheckElement.itemCount,
          discount: existingCheckElement.discount,
          specialAmount: existingCheckElement.specialAmount,
          eachPrice: existingCheckElement.eachPrice,
          price: existingCheckElement.price,
          quantity: existingCheckElement.quantity,
          tax: existingCheckElement.tax,
          seats: seat ? { [seat]: 0 } : {},
          isShared: false
        }
      );
      createdCheckElementsIds.push(newCheckElementId);
    });
  } else {
    const ticketElementToCheckElementsId = comboElement.comboElementToCheckElementsId;
    if (!seat) {
      Array(Math.abs(quantityDelta)).fill(null).forEach(() => {
        const instanceId = comboElement.instanceIds.pop();
        const connections2 = order.ticketElementToCheckElements[ticketElementToCheckElementsId].filter(
          ({ instanceId: _itemElementId }) => _itemElementId === instanceId
        );
        connections2.forEach(({ checkId, checkElementId }) => {
          const checkElement = order.checks[checkId].checkElements[checkElementId];
          const check = order.checks[checkId];
          if (!check || !checkElement)
            return;
          deleteCheckElementAndUpdateCheckOld(order, check, checkElement);
          order.ticketElementToCheckElements[ticketElementToCheckElementsId].splice(
            order.ticketElementToCheckElements[ticketElementToCheckElementsId].findIndex(
              ({ checkElementId: _checkElementId }) => _checkElementId === checkElementId
            ),
            1
          );
        });
      });
      return createdCheckElementsIds;
    }
    const elementIdsToRemove = [];
    const connections = cloneDeep(
      order.ticketElementToCheckElements[ticketElementToCheckElementsId]
    );
    connections.forEach(({ checkId, checkElementId, instanceId }) => {
      if (elementIdsToRemove.length === Math.abs(quantityDelta) && !elementIdsToRemove.includes(instanceId))
        return;
      const checkElement = order.checks[checkId].checkElements[checkElementId];
      const check = order.checks[checkId];
      if (!check || !checkElement)
        return;
      if (checkElement.seats[seat]) {
        deleteCheckElementAndUpdateCheckOld(order, check, checkElement);
        order.ticketElementToCheckElements[ticketElementToCheckElementsId].splice(
          order.ticketElementToCheckElements[ticketElementToCheckElementsId].findIndex(
            ({
              checkId: _checkId,
              checkElementId: _checkElementId,
              instanceId: _itemElementId
            }) => _checkId === checkId && _checkElementId === checkElementId && _itemElementId === instanceId
          ),
          1
        );
        if (!elementIdsToRemove.includes(instanceId)) {
          comboElement.instanceIds.splice(
            comboElement.instanceIds.findIndex(
              (_itemElementId) => _itemElementId === instanceId
            ),
            1
          );
          elementIdsToRemove.push(instanceId);
        }
      }
    });
  }
  return createdCheckElementsIds;
};
var updateSharedQuantities = (ticketElement) => {
  if (!ticketElement.isShared)
    return;
  const activeSeats = Object.entries(ticketElement.seating).filter(
    ([, quantity]) => quantity && quantity > 0
  );
  const shareAmount = (ticketElement.quantity || 0) / activeSeats.length;
  ticketElement.seating = activeSeats.reduce(
    (acc, [seatId]) => __spreadProps(__spreadValues({}, acc), {
      [seatId]: shareAmount
    }),
    {}
  );
};
var calcTotalSelectedModifiersPrice = (ticketElement) => {
  ticketElement.selectedModifiersPricePerItemUnit = Object.values(
    ticketElement.modifierGroupsSelected
  ).reduce(
    (total, modifierGroupSelected) => total + modifierGroupSelected.totalPricePerItemUnit,
    0
  );
};
var getAndSplitTicketElement = (order, ticketElementId, requireSplit, currentSeat) => {
  var _a;
  if (!requireSplit || ((_a = order.ticketElements[ticketElementId]) == null ? void 0 : _a.isShared)) {
    return order.ticketElements[ticketElementId];
  }
  const seatKey = currentSeat === FOR_TABLE_SEAT_ID ? 0 : currentSeat;
  const ticketElementClone = cloneDeep(order.ticketElements[ticketElementId]);
  ticketElementClone.id = void 0;
  const clonedTicketElementKey = generateTimestampId();
  ticketElementClone.tabletGeneratedId = clonedTicketElementKey;
  const { remainingItemIds, removedItemIds } = removeItemElementIdsFromTicketElement(
    ticketElementClone.instanceIds,
    ticketElementClone.seating,
    seatKey
  );
  ticketElementClone.instanceIds = remainingItemIds;
  ticketElementClone.quantity = ticketElementClone.quantity - ticketElementClone.seating[seatKey];
  delete ticketElementClone.seating[seatKey];
  const ticketElement = order.ticketElements[ticketElementId];
  ticketElement.quantity = ticketElement.seating[seatKey];
  ticketElement.seating = {
    [seatKey]: ticketElement.seating[seatKey]
  };
  ticketElement.instanceIds = removedItemIds;
  order.ticketElements[clonedTicketElementKey] = ticketElementClone;
  handleAutoSplitBySelectedSeat(order, ticketElementId, remainingItemIds);
  generateCheckElementsForElement(order, clonedTicketElementKey, false);
  updateCheckElementForTicketElement(order, clonedTicketElementKey);
  return ticketElement;
};
var removeItemElementIdsFromTicketElement = (originalItemIds, seats, seatKey) => {
  const keySeatMap = Object.entries(seats).map(([seatId, quantity]) => new Array(quantity).fill(seatId)).flat().map(Number);
  const tuples = zip(keySeatMap, originalItemIds);
  const remainingItemIds = tuples.filter(([seatId]) => seatId !== seatKey).map(([, itemId]) => itemId);
  const removedItemIds = tuples.filter(([seatId]) => seatId === seatKey).map(([, itemId]) => itemId);
  return { remainingItemIds, removedItemIds };
};
var ungroupTicketElementByQtyReducer = (ticket, ticketElementId, quantity, newTicketElementId, currentOrderSpecialsObject, orderType, taxExempt, orderIsLockedPrice, noTaxInclusive) => {
  var _a;
  const currentTicketElement = ticket[ticketElementId];
  const originalQuantity = currentTicketElement.quantity;
  const originalItemElementIds = [...currentTicketElement.instanceIds];
  if (!currentTicketElement || (originalQuantity || 0) - quantity < 1) {
    return;
  }
  const originalConfigWhenSent = (currentTicketElement == null ? void 0 : currentTicketElement.configWhenSent) ? __spreadValues({}, currentTicketElement.configWhenSent) : null;
  duplicateRegisterItem(
    ticket,
    ticketElementId,
    newTicketElementId,
    false,
    0,
    false,
    (_a = currentTicketElement.onTheFlyCourseNumber) != null ? _a : void 0
  );
  const newTicketElement = ticket[newTicketElementId];
  newTicketElement.quantity = (originalQuantity || 0) - quantity;
  newTicketElement.instanceIds = currentTicketElement.instanceIds.slice(
    0,
    newTicketElement.quantity
  );
  currentTicketElement.instanceIds = currentTicketElement.instanceIds.slice(
    newTicketElement.quantity
  );
  currentTicketElement.quantity = quantity;
  if (originalConfigWhenSent) {
    const currentTicketElementNewConfigWhenSent = __spreadValues({}, originalConfigWhenSent);
    const newTicketElementNewConfigWhenSent = __spreadValues({}, originalConfigWhenSent);
    currentTicketElementNewConfigWhenSent.quantity = currentTicketElement.quantity;
    currentTicketElementNewConfigWhenSent.seating = __spreadValues({}, currentTicketElementNewConfigWhenSent.seating);
    currentTicketElement.configWhenSent = currentTicketElementNewConfigWhenSent;
    newTicketElementNewConfigWhenSent.quantity = newTicketElement.quantity;
    newTicketElementNewConfigWhenSent.seating = __spreadValues({}, newTicketElementNewConfigWhenSent.seating);
    newTicketElement.configWhenSent = newTicketElementNewConfigWhenSent;
    newTicketElement.timeSentToKitchen = currentTicketElement.timeSentToKitchen;
    newTicketElement.timeTriggered = currentTicketElement.timeTriggered;
  }
  if (!selectIsCurrentOrderSeatingMode.lastResult()) {
    newTicketElement.seating = { [NO_SEAT_ID]: newTicketElement.quantity };
    currentTicketElement.seating = {
      [NO_SEAT_ID]: currentTicketElement.quantity
    };
  }
  const notAnOpenItem = isNotOpenItemFn(currentTicketElement);
  const bogoSpecial = notAnOpenItem ? Object.values(currentTicketElement.specials).find(
    (special) => special.specialApplyTo === "bogo" /* BOGO */
  ) : null;
  if (bogoSpecial) {
    updateCurrentOrderSpecialsWithItems(
      {
        id: ticketElementId,
        qty: originalQuantity,
        instanceIds: originalItemElementIds
      },
      [
        {
          id: ticketElementId,
          qty: quantity,
          instanceIds: currentTicketElement.instanceIds
        },
        {
          id: newTicketElementId,
          qty: newTicketElement.quantity,
          instanceIds: newTicketElement.instanceIds
        }
      ],
      currentOrderSpecialsObject
    );
    updateTicketElementWithInstancesCount(
      currentTicketElement,
      ticketElementId,
      bogoSpecial,
      currentOrderSpecialsObject,
      orderType,
      taxExempt,
      orderIsLockedPrice,
      noTaxInclusive
    );
    updateTicketElementWithInstancesCount(
      newTicketElement,
      newTicketElementId,
      bogoSpecial,
      currentOrderSpecialsObject,
      orderType,
      taxExempt,
      orderIsLockedPrice,
      noTaxInclusive
    );
  }
};
var ungroupTicketElementBySeatsReducer = (ticket, ticketElementsSeatMap) => {
  const ticketElement_0_id = ticketElementsSeatMap[0].ticketElementId;
  const originalTicketElement = ticket[ticketElement_0_id];
  const originalItemElementIds = originalTicketElement.instanceIds;
  const originalConfigWhenSent = (originalTicketElement == null ? void 0 : originalTicketElement.configWhenSent) ? __spreadValues({}, originalTicketElement.configWhenSent) : null;
  const originalTimeSentToKitchen = originalTicketElement.timeSentToKitchen;
  const originalTimeTriggered = originalTicketElement.timeTriggered;
  ticketElementsSeatMap.forEach(
    ({ ticketElementId, seatId, quantity }, index) => {
      var _a;
      if (!ticketElementId || !quantity)
        return;
      if (index !== 0 && typeof ticketElementId === "string") {
        duplicateRegisterItem(
          ticket,
          ticketElement_0_id,
          ticketElementId,
          false,
          seatId,
          true,
          (_a = originalTicketElement.onTheFlyCourseNumber) != null ? _a : void 0
        );
      }
      const ticketElement = ticket[ticketElementId];
      ticketElement.instanceIds = [];
      ticketElement.seating = {
        [seatId]: quantity
      };
      if (originalConfigWhenSent) {
        const newConfigWhenSent = __spreadProps(__spreadValues({}, originalConfigWhenSent), {
          seating: __spreadValues({}, originalConfigWhenSent.seating),
          quantity
        });
        ticketElement.configWhenSent = newConfigWhenSent;
        ticketElement.timeSentToKitchen = originalTimeSentToKitchen;
        ticketElement.timeTriggered = originalTimeTriggered;
      }
      ticketElement.quantity = quantity;
    }
  );
  originalTicketElement.instanceIds = originalItemElementIds;
  return {
    originalTicketElementId: ticketElement_0_id,
    newTicketElementIds: ticketElementsSeatMap.map(({ ticketElementId }) => ticketElementId).filter((ticketElementId) => ticketElementId !== ticketElement_0_id)
  };
};
var updateElementAfterSplitBySeats = (ticket, ticketElementsSeatMap, originalItemElementIds, currentOrderSpecialsObject, orderType, taxExempt, orderIsLockedPrice, noTaxInclusive) => {
  const ticketElement_0_id = ticketElementsSeatMap[ticketElementsSeatMap.length - 1].ticketElementId;
  const originalTicketElement = ticket[ticketElement_0_id];
  const originalQuantity = ticket[ticketElement_0_id].quantity;
  const bogoSpecial = isNotOpenItemFn(originalTicketElement) ? Object.values(originalTicketElement.specials).find(
    (special) => special.specialApplyTo === "bogo" /* BOGO */
  ) : void 0;
  if (bogoSpecial) {
    const originalItem = {
      id: ticketElement_0_id,
      qty: originalQuantity,
      instanceIds: originalItemElementIds
    };
    const newItems = ticketElementsSeatMap.map((seatObject) => ({
      id: seatObject.ticketElementId,
      qty: seatObject.quantity,
      instanceIds: ticket[seatObject.ticketElementId].instanceIds
    }));
    updateCurrentOrderSpecialsWithItems(
      originalItem,
      newItems,
      currentOrderSpecialsObject
    );
    ticketElementsSeatMap.forEach(({ ticketElementId }) => {
      updateTicketElementWithInstancesCount(
        ticket[ticketElementId],
        ticketElementId,
        bogoSpecial,
        currentOrderSpecialsObject,
        orderType,
        taxExempt,
        orderIsLockedPrice,
        noTaxInclusive
      );
    });
  }
};
var ungroupTicketElementBySingleSeatReducer = (ticket, ticketElementId, newTicketElementId, seatId, quantity, currentOrderSpecialsObject, orderType, taxExempt, orderIsLockedPrice, noTaxInclusive) => {
  var _a;
  const currentTicketElement = ticket[ticketElementId];
  const currentSeatQty = currentTicketElement.seating[seatId];
  const originalItemElementIds = [...currentTicketElement.instanceIds];
  if (!currentTicketElement || !currentSeatQty || currentSeatQty - quantity < 1) {
    return;
  }
  const originalConfigWhenSent = (currentTicketElement == null ? void 0 : currentTicketElement.configWhenSent) ? __spreadValues({}, currentTicketElement.configWhenSent) : null;
  duplicateRegisterItem(
    ticket,
    ticketElementId,
    newTicketElementId,
    false,
    seatId,
    true,
    (_a = currentTicketElement.onTheFlyCourseNumber) != null ? _a : void 0
  );
  const newTicketElement = ticket[newTicketElementId];
  newTicketElement.instanceIds = currentTicketElement.instanceIds.slice(
    0,
    quantity
  );
  newTicketElement.instanceIds = currentTicketElement.instanceIds.slice(quantity);
  currentTicketElement.instanceIds = currentTicketElement.instanceIds.slice(
    0,
    quantity
  );
  newTicketElement.quantity = (currentTicketElement.quantity || 0) - quantity;
  newTicketElement.seating = __spreadProps(__spreadValues({}, currentTicketElement.seating), {
    [seatId]: (currentTicketElement.quantity || 0) - quantity
  });
  currentTicketElement.quantity = quantity;
  currentTicketElement.seating = { [seatId]: quantity };
  if (originalConfigWhenSent) {
    const currentTicketElementNewConfigWhenSent = __spreadValues({}, originalConfigWhenSent);
    const newTicketElementNewConfigWhenSent = __spreadValues({}, originalConfigWhenSent);
    currentTicketElementNewConfigWhenSent.quantity = currentTicketElement.quantity;
    currentTicketElementNewConfigWhenSent.seating = __spreadValues({}, currentTicketElementNewConfigWhenSent.seating);
    currentTicketElement.configWhenSent = currentTicketElementNewConfigWhenSent;
    newTicketElementNewConfigWhenSent.quantity = newTicketElement.quantity;
    newTicketElementNewConfigWhenSent.seating = __spreadValues({}, newTicketElementNewConfigWhenSent.seating);
    newTicketElement.configWhenSent = newTicketElementNewConfigWhenSent;
    newTicketElement.timeSentToKitchen = currentTicketElement.timeSentToKitchen;
    newTicketElement.timeTriggered = currentTicketElement.timeTriggered;
  }
  const bogoSpecial = isNotOpenItemFn(currentTicketElement) ? Object.values(currentTicketElement.specials).find(
    (special) => special.specialApplyTo === "bogo" /* BOGO */
  ) : void 0;
  if (bogoSpecial) {
    updateCurrentOrderSpecialsWithItems(
      {
        id: ticketElementId,
        qty: currentSeatQty,
        instanceIds: originalItemElementIds
      },
      [
        {
          id: ticketElementId,
          qty: quantity,
          instanceIds: currentTicketElement.instanceIds
        },
        {
          id: newTicketElementId,
          qty: newTicketElement.quantity,
          instanceIds: newTicketElement.instanceIds
        }
      ],
      currentOrderSpecialsObject
    );
    updateTicketElementWithInstancesCount(
      currentTicketElement,
      ticketElementId,
      bogoSpecial,
      currentOrderSpecialsObject,
      orderType,
      taxExempt,
      orderIsLockedPrice,
      noTaxInclusive
    );
    updateTicketElementWithInstancesCount(
      newTicketElement,
      newTicketElementId,
      bogoSpecial,
      currentOrderSpecialsObject,
      orderType,
      taxExempt,
      orderIsLockedPrice,
      noTaxInclusive
    );
  }
};
var getTicketElementKitchenSnapshot = (ticketElement) => {
  return {
    isCopied: true,
    quantity: ticketElement.quantity,
    seating: cloneDeep(ticketElement.seating),
    isShared: ticketElement.isShared,
    instructions: ticketElement.instructions,
    modifierGroupsSelected: cloneDeep(ticketElement.modifierGroupsSelected),
    ingredientsSelected: ticketElement.ingredientsSelected ? cloneDeep(ticketElement.ingredientsSelected) : void 0
  };
};
var copySentTicketElementConfig = (ticketElement) => {
  if (!ticketElement || !ticketElement.modifierGroupsSelected) {
    return;
  }
  if (ticketElement.configWhenSent)
    ticketElement.oldModifications = cloneDeep(ticketElement.configWhenSent);
  ticketElement.configWhenSent = getTicketElementKitchenSnapshot(ticketElement);
};
var getTicketElementModifications = (ticketElement) => {
  const currentState = getTicketElementKitchenSnapshot(ticketElement);
  const diff11 = deepDiff6(currentState, ticketElement.configWhenSent);
  return diff11;
};
var getTicketElementModifierGroupHasModifications = (ticketElement) => {
  var _a, _b;
  const currentState = getTicketElementKitchenSnapshot(ticketElement);
  const diff11 = deepDiff6(
    currentState.modifierGroupsSelected,
    (_a = ticketElement.configWhenSent) == null ? void 0 : _a.modifierGroupsSelected
  );
  const seatDiff = deepDiff6(
    currentState.seating,
    (_b = ticketElement.configWhenSent) == null ? void 0 : _b.seating
  );
  return diff11 !== void 0 || seatDiff !== void 0;
};
var resetModifierGroupSelectedToConfigWhenSent2 = (ticketElement, modifierGroupId) => {
  var _a, _b;
  if (!ticketElement || !((_b = (_a = ticketElement == null ? void 0 : ticketElement.configWhenSent) == null ? void 0 : _a.modifierGroupsSelected) == null ? void 0 : _b[modifierGroupId])) {
    return;
  }
  ticketElement.modifierGroupsSelected[modifierGroupId] = cloneDeep(
    ticketElement.configWhenSent.modifierGroupsSelected[modifierGroupId]
  );
};
var resetIngredientsSelectedToConfigWhenSent = (ticketElement) => {
  var _a;
  if (!ticketElement || !((_a = ticketElement.configWhenSent) == null ? void 0 : _a.ingredientsSelected)) {
    return;
  }
  ticketElement.ingredientsSelected = cloneDeep(
    ticketElement.configWhenSent.ingredientsSelected
  );
};
var rollUpTicketElements2 = (ticket, rollUpIds, currentSpecials, specialOrderSource, orderType, taxExempt, orderIsLockedPrice, noTaxInclusive) => rollUpIds.forEach(
  ({ uniqueId, redundantIds, resultingQuantity, resultingSeats }) => {
    const resultingTicketElement = ticket[uniqueId];
    resultingTicketElement.quantity = resultingQuantity;
    resultingTicketElement.seating = resultingSeats;
    resultingTicketElement.updatedAt = getNowUTCDate();
    const oldItemElementIds = [...resultingTicketElement.instanceIds];
    redundantIds.forEach((redundantId) => {
      var _a, _b, _c;
      resultingTicketElement.instanceIds = [
        ...resultingTicketElement.instanceIds,
        ...ticket[redundantId].instanceIds
      ];
      if (resultingTicketElement.configWhenSent && ((_a = resultingTicketElement.configWhenSent) == null ? void 0 : _a.quantity))
        resultingTicketElement.configWhenSent.quantity += (_c = (_b = ticket[redundantId].configWhenSent) == null ? void 0 : _b.quantity) != null ? _c : 0;
    });
    fixSpecialTicketIds(
      resultingTicketElement,
      redundantIds,
      ticket,
      uniqueId,
      oldItemElementIds,
      currentSpecials,
      specialOrderSource,
      orderType,
      taxExempt,
      orderIsLockedPrice,
      noTaxInclusive
    );
    redundantIds.forEach((redundantId) => {
      delete ticket[redundantId];
    });
  }
);
var fixSpecialTicketIds = (resultingTicketElement, redundantIds, ticket, uniqueId, oldItemElementIds, currentSpecials, specialOrderSource, orderType, taxExempt, orderIsLockedPrice, noTaxInclusive) => {
  var _a;
  const hasSpecials = (resultingTicketElement.isOpenItem ? 0 : Object.values((_a = resultingTicketElement.specials) != null ? _a : {}).length) + redundantIds.reduce(
    (specialsCount, redundantId) => {
      var _a2;
      return specialsCount + (ticket[redundantId].isOpenItem ? 0 : Object.values((_a2 = ticket[redundantId].specials) != null ? _a2 : {}).length);
    },
    0
  );
  if (!hasSpecials)
    return;
  const resultingInstances = resultingTicketElement.instanceIds.map(
    (instanceId, index) => ({
      elementId: uniqueId,
      instance: index + 1,
      instanceId
    })
  );
  let oldInstances = [...oldItemElementIds].map((instance) => instance);
  redundantIds.forEach((redundantElementId) => {
    const redundantElementInstances = ticket[redundantElementId].instanceIds.map((instance) => instance);
    oldInstances = [...oldInstances, ...redundantElementInstances];
  });
  const dictionaryKeys = {};
  const dictionaryEntries = zip(oldInstances, resultingInstances);
  dictionaryEntries.forEach(([oldKeyInstance, newKeyInstance]) => {
    if (oldKeyInstance && newKeyInstance)
      dictionaryKeys[oldKeyInstance] = newKeyInstance;
  });
  updateCurrentOrderSpecialObjectWithDictionary(
    dictionaryKeys,
    currentSpecials
  );
  const specialsWithItemsToUpdate = new Set(
    Object.values(currentSpecials).filter(
      (special) => special.validation.get.elements.some(
        (element) => element.ticketElementId && (element.ticketElementId === uniqueId || redundantIds.includes(element.ticketElementId))
      )
    ).map(
      (special) => special.validation.get.elements.map((element) => element.ticketElementId)
    ).flat().filter((value) => value !== null)
  );
  specialsWithItemsToUpdate.forEach((ticketElementId) => {
    const specialBound = getSpecialBoundToItem(
      currentSpecials,
      ticketElementId,
      null
    );
    if (specialBound) {
      const ticketElement = ticket[ticketElementId];
      const bogoSpecial = Object.values(ticketElement.specials).find(
        (special) => special.specialId === specialBound.specialId
      );
      const appliedSpecialAmount = getItemBOGOAppliedAmount(
        specialOrderSource[specialBound.specialId].discountSpecialObj,
        ticketElement
      );
      const { instances, count } = countItemInstances(
        currentSpecials,
        specialBound.specialId,
        ticketElementId
      );
      if (bogoSpecial) {
        ticketElement.specials[bogoSpecial.id || bogoSpecial.tabletGeneratedId].instances = instances;
        ticketElement.specials[bogoSpecial.id || bogoSpecial.tabletGeneratedId].appliedSpecialAmount = appliedSpecialAmount * count;
      } else {
        const tabletGeneratedId = generateTicketElementId();
        ticketElement.specials[tabletGeneratedId] = __spreadProps(__spreadValues({}, getSpecialAppliedValue(
          specialOrderSource[specialBound.specialId].discountSpecialObj
        )), {
          tabletGeneratedId,
          appliedSpecialAmount: appliedSpecialAmount * count,
          instances
        });
      }
    }
    calcTotalItemWithAlternativePrice(ticket[ticketElementId], {
      orderType,
      taxExempt,
      noTaxInclusive,
      orderIsLockedPrice
    });
  });
};
var convertOldTicketElementIntoTheNewest = (oldTicketElement, newTicketElement, isSeatingEnabled) => {
  newTicketElement.configWhenSent = oldTicketElement.configWhenSent ? cloneDeep(oldTicketElement.configWhenSent) : null;
  newTicketElement.isVoided = oldTicketElement.isVoided;
  newTicketElement.isInClosedCheck = false;
  oldTicketElement.timeAdded = (/* @__PURE__ */ new Date()).toISOString();
  oldTicketElement.timeSentToKitchen = NULLISH_DATE;
  oldTicketElement.timeTriggered = NULLISH_DATE;
  oldTicketElement.configWhenSent = null;
  oldTicketElement.isVoided = false;
  if (isSeatingEnabled) {
    newTicketElement.quantity = oldTicketElement.quantity;
    newTicketElement.seating = __spreadValues({}, oldTicketElement.seating);
    oldTicketElement.quantity = 0;
    oldTicketElement.seating = {};
  }
};
var getTicketItemVolumeData = (ticketElement) => {
  if (ticketElement.isOpenItem || !ticketElement.itemObj)
    return null;
  const menuTypeId = ticketElement.menuTypeId;
  return getItemVolumeData(ticketElement.itemObj, menuTypeId);
};
var getItemVolumeData = (itemObj, menuTypeId) => {
  const menuTypeVersion = itemObj == null ? void 0 : itemObj.menuTypeVersions[menuTypeId];
  const volume = menuTypeVersion == null ? void 0 : menuTypeVersion.volume;
  const volumeUnit = menuTypeVersion == null ? void 0 : menuTypeVersion.unit;
  if (typeof volume === "undefined" || typeof volumeUnit === "undefined")
    return null;
  return {
    volume,
    unit: volumeUnit
  };
};
var updateTicketElementInstanceIds = (ticketElement, prevQuantity) => {
  if (ticketElement.quantity > prevQuantity) {
    const newInstanceIds = Array.from(
      new Array(ticketElement.quantity - prevQuantity),
      () => generateInstanceId()
    );
    ticketElement.instanceIds = [
      ...ticketElement.instanceIds,
      ...newInstanceIds
    ];
  } else if (ticketElement.quantity < prevQuantity) {
    ticketElement.instanceIds = take(
      ticketElement.instanceIds,
      ticketElement.quantity
    );
  }
};
var updateComboElementInstanceIds = (comboElement, prevQuantity) => {
  if (comboElement.quantity > prevQuantity) {
    const newInstanceIds = Array.from(
      new Array(comboElement.quantity - prevQuantity),
      () => generateInstanceId()
    );
    comboElement.instanceIds = [...comboElement.instanceIds, ...newInstanceIds];
  } else if (comboElement.quantity < prevQuantity) {
    comboElement.instanceIds = take(
      comboElement.instanceIds,
      comboElement.quantity
    );
  }
};
var handleQuantityChange = (ticketElement) => {
  if (ticketElement.isOnHold) {
    ticketElement.hasBeenHeld = ticketElement.quantity;
  }
};

// src/helpers/register/reducerHelpers/comboElement.ts
var isTicketElementNotAssociatedWithCombo = (ticketElement) => isOpenItemFn(ticketElement) || !ticketElement.comboElementId;
var isComboElementNotTriggered = (element, ticket) => Object.values(element.itemGroupsSelected).filter(
  (itemGroupSelected) => itemGroupSelected.ticketElementId
).every(
  (itemGroupSelected) => notTicketElementTriggered(
    ticket[itemGroupSelected.ticketElementId]
  )
);
var isTicketElementAssociatedWithCombo = (ticketElement) => isNotOpenItemFn(ticketElement) && !!ticketElement.comboElementId;
var selectRegisterCombo2 = (order, comboElementId, comboId, globalState, dualPricingSettings, overrides = {}) => {
  var _a;
  const {
    menuTypeId: currentMenuTypeId,
    orderId,
    quantity
  } = globalState.register.registerNavigation;
  const seating = globalState.settings.selectedMode.currentSettings.register.seating;
  const menuTypeId = (_a = overrides.menuTypeId) != null ? _a : currentMenuTypeId;
  const isCurrentMenuTypeCourseDisabled = globalState.menu.locationMenu.menuTypes[Number(menuTypeId)].coursingType !== "coursing" /* COURSING */;
  if (orderId === null || !menuTypeId)
    return;
  const currentOrder = selectCurrentOrderObj(globalState);
  const comboClone = cloneDeep(globalState.menu.locationMenu.combos[comboId]);
  const menuTypeComboClone = cloneDeep(
    globalState.menu.locationMenu.combos[comboId].menuTypeVersions[menuTypeId]
  );
  const newComboElement = createNewComboElement(
    orderId,
    comboElementId,
    comboClone,
    menuTypeId,
    menuTypeComboClone,
    globalState.loggedInUser.organizationUserId,
    globalState,
    overrides.special,
    currentOrder.type,
    dualPricingSettings
  );
  if (!seating) {
    newComboElement.instanceIds = Array(quantity != null ? quantity : 1).fill(null).map(() => generateTabletGeneratedId());
  }
  newComboElement.comboElementToCheckElementsId = comboElementId;
  newComboElement.itemGroupsSelected = Object.values(
    menuTypeComboClone.itemGroups
  ).map(expandItemGroupsByQuantity).flat().reduce(
    (itemGroupsSelected, itemGroupSelected) => __spreadProps(__spreadValues({}, itemGroupsSelected), {
      [`${itemGroupSelected.itemGroupId}-${itemGroupSelected.instanceId}`]: itemGroupSelected
    }),
    {}
  );
  newComboElement.isCurrentMenuTypeCourseDisabled = isCurrentMenuTypeCourseDisabled;
  const coursingMode = selectCoursingModeActive(globalState);
  newComboElement.onTheFlyCourseNumber = coursingMode === "predefined" /* PREDEFINED */ ? null : currentOrder.type === "to_go" /* TO_GO */ ? null : isCurrentMenuTypeCourseDisabled ? null : selectCurrentCourseNumber(globalState);
  updateWithGlobalQuantities(newComboElement, globalState);
  newComboElement.totalPriceWithDiscountsSpecialsNotTaxes = newComboElement.totalPriceWithDiscountsSpecialsNotTaxes * newComboElement.quantity;
  newComboElement.isComplete = !!newComboElement.quantity && !!newComboElement.comboObj && Object.values(newComboElement.itemGroupsSelected).every(
    (itemGroupSelected) => itemGroupSelected.isComplete
  );
  if (!order.combos)
    order.combos = {};
  order.combos[comboElementId] = newComboElement;
};
var expandItemGroupsByQuantity = (itemGroup) => {
  var _a;
  const isRequired = itemGroup.required;
  const comboItemGroupSelected = {
    itemGroupId: itemGroup.itemGroupId,
    itemId: null,
    isComplete: !isRequired,
    ticketElementId: null,
    isRequired,
    additionalPrice: 0,
    additionalModifiersPrice: 0
  };
  return Array((_a = itemGroup.quantity) != null ? _a : 1).fill(null).map((_, index) => __spreadProps(__spreadValues({}, cloneDeep(comboItemGroupSelected)), {
    instanceId: index + 1
  }));
};
var getComboPriceData = (comboBasePrice, quantity, special, taxesSource, taxIds, orderType) => {
  let totalSpecialsAmount = 0;
  let specials = {};
  if (special) {
    totalSpecialsAmount = getAppliedDiscountAmount(
      special.discountType,
      special.discountAmount,
      comboBasePrice * quantity,
      quantity,
      special.thresholdAmount
    );
    const tabletGeneratedId = generateTimestampId();
    specials = {
      [tabletGeneratedId]: __spreadProps(__spreadValues({}, getSpecialAppliedValue(special)), {
        appliedSpecialAmount: totalSpecialsAmount,
        tabletGeneratedId
      })
    };
  }
  const taxReduceFunction = getTaxesReduceFunction(
    taxesSource,
    orderType,
    orderType === "to_go" /* TO_GO */,
    comboBasePrice - totalSpecialsAmount,
    quantity,
    null
  );
  const taxResultObj = taxIds.reduce(
    taxReduceFunction,
    getInitialTaxDetailsObject()
  );
  return {
    specials,
    totalSpecialsAmount,
    taxResultObj
  };
};
var createNewComboElement = (orderId, comboElementId, comboClone, menuTypeId, menuTypeComboClone, loggedInOrganizationUserId, globalState, special, orderType, dualPricingSettings) => {
  var _a;
  const taxIds = getTaxesToApplyFromComboObj(comboClone, menuTypeId);
  const taxesSource = getSnapshotFromItemTaxes(globalState, taxIds);
  const isTaxInclusive = comboClone.menuTypeVersions[menuTypeId].taxInclusive;
  const quantity = (_a = globalState.register.registerNavigation.quantity) != null ? _a : 1;
  const isToGo = orderType === "to_go" /* TO_GO */;
  const originalComboBasePrice = getComboBasePrice(menuTypeComboClone, isToGo);
  let comboBasePrice = getComboBasePrice(menuTypeComboClone, isToGo);
  if (isTaxInclusive) {
    comboBasePrice = getBasePriceFromTaxInclusive(
      taxesSource,
      orderType,
      comboBasePrice,
      taxIds,
      isToGo,
      null,
      quantity
    );
  }
  const {
    taxResultObj: taxResultObjPartial,
    specials,
    totalSpecialsAmount
  } = getComboPriceData(
    comboBasePrice,
    quantity,
    special,
    taxesSource,
    taxIds,
    orderType
  );
  let taxResultObj = taxResultObjPartial;
  if (isTaxInclusive) {
    const priceDiff = roundToMoneyDecimals(
      originalComboBasePrice - (comboBasePrice + taxResultObjPartial.taxTotal)
    );
    if (Math.abs(priceDiff) > 0)
      taxResultObj = distributePenniesBetweenTaxes(
        priceDiff,
        taxResultObjPartial,
        taxesSource
      );
  }
  let alternativePriceData = null;
  if (dualPricingSettings.dualPricing) {
    const alternativeBaseItemPrice = getAlternativeListBasePrice(
      comboBasePrice,
      dualPricingSettings
    );
    const {
      specials: _specials,
      totalSpecialsAmount: _totalSpecialsAmount,
      taxResultObj: _taxResultObj
    } = getComboPriceData(
      alternativeBaseItemPrice,
      quantity,
      special,
      taxesSource,
      taxIds,
      orderType
    );
    alternativePriceData = {
      comboBasePrice: alternativeBaseItemPrice,
      totalAdditionalPriceAmount: 0,
      taxInclusiveAdditionalPrice: 0,
      specials: _specials,
      discounts: {},
      taxDetails: _taxResultObj.details,
      totalDiscountAmount: 0,
      totalPricePerItemUnit: alternativeBaseItemPrice,
      totalPriceWithDiscountsSpecialsNotTaxes: alternativeBaseItemPrice - _totalSpecialsAmount,
      totalSpecialsAmount: _totalSpecialsAmount,
      totalTax: roundToMoneyDecimals(_taxResultObj.taxTotal),
      totalSpecialsBOGOAmount: 0
    };
  }
  const newTicketElement = __spreadProps(__spreadValues({}, COMBO_ELEMENT_INITIAL_STATE), {
    createdById: loggedInOrganizationUserId,
    lastUpdatedById: loggedInOrganizationUserId,
    tabletGeneratedId: comboElementId,
    timeAdded: getNowUTCDate(),
    versionId: 1,
    comboObj: __spreadProps(__spreadValues({}, comboClone), {
      taxesSource,
      menuTypeVersions: { [menuTypeId]: menuTypeComboClone }
    }),
    orderId,
    comboId: comboClone.comboId,
    comboBasePrice,
    totalPricePerItemUnit: comboBasePrice,
    totalSpecialsAmount,
    totalPriceWithDiscountsSpecialsNotTaxes: comboBasePrice - totalSpecialsAmount,
    menuTypeId,
    specials,
    totalTax: roundToMoneyDecimals(taxResultObj.taxTotal),
    taxDetails: taxResultObj.details,
    isTakeout: isToGo,
    locationMenuTypeComboId: menuTypeComboClone.locationMenuTypeComboId,
    locationMenuTypeComboVersionId: menuTypeComboClone.locationMenuTypeComboVersionId,
    // ticketElementToCheckElementsId: generateTabletGeneratedId(),
    alternativePriceData
  });
  return newTicketElement;
};
var updateComboElement = (order, comboElementId, comboId, globalState) => {
  const menuTypeId = globalState.register.registerNavigation.menuTypeId;
  if (!menuTypeId)
    return order;
  const comboClone = cloneDeep(globalState.menu.locationMenu.combos[comboId]);
  const menuTypeComboClone = cloneDeep(
    globalState.menu.locationMenu.combos[comboId].menuTypeVersions[menuTypeId]
  );
  const currentTaxIds = getTaxesToApplyFromComboObj(comboClone, menuTypeId);
  const taxesSnapshot = getSnapshotFromItemTaxes(globalState, currentTaxIds);
  order.combos[comboElementId].comboObj = __spreadProps(__spreadValues({}, comboClone), {
    taxesSource: taxesSnapshot,
    menuTypeVersions: { [menuTypeId]: menuTypeComboClone }
  });
  return order;
};
var removeComboElement = (order, comboElementId) => {
  var _a;
  const comboElement = order.combos[comboElementId];
  Object.values(comboElement.itemGroupsSelected).forEach((itemGroupSelected) => {
    if (itemGroupSelected.ticketElementId !== null) {
      delete order.ticketElements[itemGroupSelected.ticketElementId];
    }
  });
  delete order.ticketElementToCheckElements[(_a = comboElement.comboElementToCheckElementsId) != null ? _a : ""];
  delete order.combos[comboElementId];
};
var removePreviousElement = (ticket, itemGroupSelected) => {
  if (itemGroupSelected.ticketElementId !== null)
    delete ticket[itemGroupSelected.ticketElementId];
  itemGroupSelected.ticketElementId = null;
  itemGroupSelected.itemId = null;
  itemGroupSelected.isComplete = !itemGroupSelected.isRequired;
  itemGroupSelected.additionalPrice = 0;
};
var duplicateRegisterCombo = (combos, ticket, oldComboElementId, newComboElementId, isSeatingEnabled, isReorder, nextCourseNumber) => {
  const newCombo = cloneDeep(combos[oldComboElementId]);
  newCombo.tabletGeneratedId = newComboElementId;
  newCombo.id = void 0;
  newCombo.comboElementToCheckElementsId = newComboElementId;
  newCombo.ticketElementToCheckElementsId = newComboElementId;
  newCombo.isInClosedCheck = false;
  newCombo.instanceIds = Array(
    isReorder ? combos[oldComboElementId].quantity : isSeatingEnabled ? 1 : combos[oldComboElementId].quantity
  ).fill(null).map(() => generateTabletGeneratedId());
  const itemGroupsWithItemSelected = Object.values(
    newCombo.itemGroupsSelected
  ).filter(
    (itemGroupSelected) => itemGroupSelected.ticketElementId
  );
  itemGroupsWithItemSelected.forEach(
    (itemGroupSelected) => {
      const newTicketElementId = generateTimestampId();
      const newComboItemSelected = cloneDeep(
        ticket[itemGroupSelected.ticketElementId]
      );
      newComboItemSelected.id = void 0;
      newComboItemSelected.tabletGeneratedId = newTicketElementId;
      newComboItemSelected.comboElementId = newComboElementId;
      newComboItemSelected.timeAdded = getNowUTCDate();
      newComboItemSelected.timeSentToKitchen = NULLISH_DATE;
      newComboItemSelected.timeTriggered = NULLISH_DATE;
      newComboItemSelected.roundNumber = void 0;
      newComboItemSelected.isInClosedCheck = false;
      newComboItemSelected.isVoided = false;
      newComboItemSelected.sentToPrepStationHistory = [];
      newComboItemSelected.printErrorMessage = {};
      newComboItemSelected.isModifiedAfterSent = false;
      newComboItemSelected.configWhenSent = null;
      if (newComboItemSelected.isCurrentMenuTypeCourseDisabled)
        newComboItemSelected.onTheFlyCourseNumber = null;
      else if (nextCourseNumber) {
        newComboItemSelected.onTheFlyCourseNumber = nextCourseNumber;
      }
      ticket[newTicketElementId] = newComboItemSelected;
      newCombo.itemGroupsSelected[`${itemGroupSelected.itemGroupId}-${itemGroupSelected.instanceId}`].ticketElementId = newTicketElementId;
    }
  );
  newCombo.specials = __spreadValues({}, combos[oldComboElementId].specials);
  combos[newComboElementId] = newCombo;
};
var convertOldComboElementIntoTheNewest = (oldTicketElement, newTicketElement, ticket, isSeatingEnabled, isReorder) => {
  var _a;
  newTicketElement.quantity = oldTicketElement.quantity;
  newTicketElement.seating = __spreadValues({}, oldTicketElement.seating);
  if (isSeatingEnabled && !isReorder) {
    newTicketElement.quantity = 0;
    newTicketElement.seating = {};
    newTicketElement.isShared = null;
  }
  applySeatAndQuantityToItems(newTicketElement, ticket);
  newTicketElement.timeAdded = (/* @__PURE__ */ new Date()).toISOString();
  newTicketElement.isInClosedCheck = false;
  Object.values((_a = oldTicketElement.specials) != null ? _a : {}).forEach((special) => {
    special.instances.forEach((instance, index) => {
      var _a2;
      const itemElementIdIndex = oldTicketElement.instanceIds.indexOf(instance);
      const newComboElementInstance = ((_a2 = newTicketElement == null ? void 0 : newTicketElement.specials) != null ? _a2 : {})[special.id || special.tabletGeneratedId].instances;
      if (newComboElementInstance.length) {
        newComboElementInstance.splice(
          index,
          1,
          newTicketElement.instanceIds[itemElementIdIndex]
        );
      }
    });
  });
};
var updateTicketAndComboCompleteQuantity = (comboElement, ticket, isSeatingEnabled) => {
  Object.values(comboElement.itemGroupsSelected).forEach((itemGroupSelected) => {
    if (itemGroupSelected.ticketElementId) {
      const ticketElementId = itemGroupSelected.ticketElementId;
      ticket[ticketElementId].isModifiersSelectionComplete = Object.values(
        ticket[ticketElementId].modifierGroupsSelected
      ).every((modifierGroupSelected) => modifierGroupSelected.isComplete);
      ticket[ticketElementId].isComplete = ticket[ticketElementId].isModifiersSelectionComplete && isTicketElementQuantityComplete(
        ticket[ticketElementId],
        isSeatingEnabled
      );
      comboElement.itemGroupsSelected[`${itemGroupSelected.itemGroupId}-${itemGroupSelected.instanceId}`].isComplete = ticket[ticketElementId].isModifiersSelectionComplete;
    }
  });
};
var setIsComboComplete = (comboElement, isSeatingModeEnabled) => {
  comboElement.isComplete = Object.values(comboElement.itemGroupsSelected).every(
    (itemGroup) => itemGroup.isComplete || !itemGroup.isRequired && !itemGroup.ticketElementId
  ) && !!comboElement.quantity && (!isSeatingModeEnabled || !!Object.keys(comboElement.seating || {}).length);
};
var showComboOrSpreadIntoItems = (comboElement) => {
  const itemGroupsSelected = Object.values(
    comboElement.itemGroupsSelected
  ).filter(
    (itemGroupSelected) => !!itemGroupSelected.item
  );
  if (itemGroupsSelected.length === 0)
    return comboElement;
  const baseType = itemGroupsSelected[0].item.isTakeout;
  const baseCourse = itemGroupsSelected[0].item.courseId;
  const areAllTakeOutOrDineIn = itemGroupsSelected.every(
    (itemGroupSelected) => baseType === itemGroupSelected.item.isTakeout
  );
  const areAllNotTriggered = itemGroupsSelected.every(
    (itemGroupSelected) => !isTicketElementTriggered(itemGroupSelected.item)
  );
  const areAllTriggered = itemGroupsSelected.every(
    (itemGroupSelected) => isTicketElementTriggered(itemGroupSelected.item)
  );
  if (areAllTakeOutOrDineIn && (areAllNotTriggered || areAllTriggered) && itemGroupsSelected.every(
    (itemGroup) => itemGroup.item.courseId === baseCourse
  ))
    return comboElement;
  return Object.values(itemGroupsSelected).map(
    (itemGroupSelected) => itemGroupSelected.item
  );
};
var showComboOrSpreadIntoItemsCoursingOnTheFly = (comboElement) => {
  const itemGroupsSelected = Object.values(
    comboElement.itemGroupsSelected
  ).filter(
    (itemGroupSelected) => !!itemGroupSelected.item
  );
  if (itemGroupsSelected.length === 0)
    return comboElement;
  const baseTakeOut = itemGroupsSelected[0].item.isTakeout;
  const areAllTakeOut = itemGroupsSelected.every(
    (itemGroupSelected) => baseTakeOut === itemGroupSelected.item.isTakeout
  );
  const baseCourse = itemGroupsSelected[0].item.onTheFlyCourseNumber;
  const areAllInSameCourse = itemGroupsSelected.every(
    (itemGroupSelected) => baseCourse === itemGroupSelected.item.onTheFlyCourseNumber
  );
  const areAllNotTriggered = itemGroupsSelected.every(
    (itemGroupSelected) => !isTicketElementTriggered(itemGroupSelected.item)
  );
  const areAllTriggered = itemGroupsSelected.every(
    (itemGroupSelected) => isTicketElementTriggered(itemGroupSelected.item)
  );
  if (areAllTakeOut && areAllInSameCourse && (areAllNotTriggered || areAllTriggered))
    return comboElement;
  return Object.values(itemGroupsSelected).map(
    (itemGroupSelected) => itemGroupSelected.item
  );
};
var spreadComboIntoItem = (comboElement) => {
  const itemGroupsSelected = Object.values(
    comboElement.itemGroupsSelected
  ).filter(
    (itemGroupSelected) => !!itemGroupSelected.item
  );
  return itemGroupsSelected.map(
    (itemGroupSelected) => itemGroupSelected.item
  );
};
var isComboElementCompleted = (comboElement) => {
  return comboElement.isComplete && Object.values(comboElement.itemGroupsSelected).every(
    (itemGroupSelected) => itemGroupSelected.item === null && !itemGroupSelected.isRequired || itemGroupSelected.item !== null && isTicketElementComplete(itemGroupSelected.item)
  );
};
var isComboElementCompletedAndItsItems = (comboElement, ticket) => {
  return comboElement.isComplete && Object.values(comboElement.itemGroupsSelected).every(
    (itemGroupSelected) => itemGroupSelected.ticketElementId === null && !itemGroupSelected.isRequired || itemGroupSelected.ticketElementId !== null && isTicketElementComplete(ticket[itemGroupSelected.ticketElementId])
  );
};
var getReadyItems = (comboElement) => Object.values(comboElement.itemGroupsSelected).filter(filterReadyItems);
var getItemGroupsWithSelection = (comboElement) => Object.values(comboElement.itemGroupsSelected).filter(
  (itemGroupSelected) => !!itemGroupSelected.itemId && !!itemGroupSelected.ticketElementId
);
var getNotNullItemGroups = (comboElement) => Object.values(comboElement.itemGroupsSelected).filter(filterNotNullItem);
var filterReadyItems = (itemGroupSelected) => !!itemGroupSelected.item;
var filterNotNullItem = (itemGroupSelected) => !!itemGroupSelected.ticketElementId;
var isComboElement = (element) => {
  if (!element)
    return false;
  return "comboObj" in element;
};
var isComboOrTicketElementTriggered = (element) => {
  if (isComboElement(element)) {
    const elementsReady = getReadyItems(element).map(
      (itemGroupSelected) => itemGroupSelected.item
    );
    if (elementsReady.length > 0)
      return elementsReady.every(isTicketElementTriggered);
    return false;
  }
  return isTicketElementTriggered(element);
};
var isComboOrTicketElementOnHold = (element) => {
  if (!element)
    return false;
  if (isComboElement(element)) {
    const elementsReady = getReadyItems(element).map(
      (itemGroupSelected) => itemGroupSelected.item
    );
    if (elementsReady.length > 0)
      return elementsReady.some((comboElement) => comboElement.isOnHold);
    return false;
  }
  return element.isOnHold;
};
var getComboOrTicketElementSentTimes = (element) => {
  if (isComboElement(element)) {
    const elementsReady = getReadyItems(element).map(
      (itemGroupSelected) => itemGroupSelected.item
    );
    let timeSentToKitchen = "";
    let timeTriggered = "";
    if (elementsReady.length > 0)
      for (const _element of elementsReady) {
        if (_element.timeSentToKitchen !== "") {
          timeSentToKitchen = _element.timeSentToKitchen;
          timeTriggered = _element.timeTriggered;
          break;
        }
      }
    return { timeSentToKitchen, timeTriggered };
  }
  return {
    timeSentToKitchen: element.timeSentToKitchen,
    timeTriggered: element.timeTriggered
  };
};
var isComboOrTicketElementTriggeredFromOrderData = (element, order) => {
  if (isComboElement(element)) {
    const elementsReady = Object.values(element.itemGroupsSelected).filter((itemGroupSelected) => !!itemGroupSelected.ticketElementId).map((itemGroupSelected) => itemGroupSelected.ticketElementId);
    if (elementsReady.length > 0)
      return elementsReady.every(
        (ticketElementId) => isTicketElementTriggered(order.ticketElements[ticketElementId])
      );
    return false;
  }
  return isTicketElementTriggered(element);
};
var isComboOrTicketElementToGo = (element) => {
  var _a;
  if (!isComboElement(element))
    return isElementToGo(element);
  const elementsReady = getReadyItems(element).map(
    (itemGroupSelected) => itemGroupSelected.item
  );
  if (elementsReady.length > 0)
    return elementsReady.every(isElementToGo);
  return (_a = element.isTakeout) != null ? _a : false;
};
var getComboOrTicketElementCourseId = (element) => {
  var _a;
  if (!isComboElement(element))
    return element.courseId;
  const elementsReady = getReadyItems(element).map(
    (itemGroupSelected) => itemGroupSelected.item
  );
  const [comboItem] = elementsReady;
  return (_a = comboItem == null ? void 0 : comboItem.courseId) != null ? _a : null;
};
var getComboOrTicketElementOnTheFlyCourseNumber = (element) => {
  var _a;
  if (!isComboElement(element))
    return element.onTheFlyCourseNumber;
  const elementsReady = getReadyItems(element).map(
    (itemGroupSelected) => itemGroupSelected.item
  );
  const [comboItem] = elementsReady;
  return (_a = comboItem == null ? void 0 : comboItem.onTheFlyCourseNumber) != null ? _a : element.onTheFlyCourseNumber;
};
var isElementToGo = (element) => element.isTakeout;
var getItemIdsToSend = (elements) => {
  return elements.filter((element) => {
    if (isComboElement(element))
      return true;
    return !element.isOnHold;
  }).map((element) => {
    if (!isComboElement(element))
      return getTicketElementId(element);
    return getReadyItems(element).filter(
      (itemGroupSelected) => !itemGroupSelected.item.isOnHold
    ).map((itemGroupSelected) => itemGroupSelected.item).map(getTicketElementId);
  }).flat();
};
var updateComboItemGroup = (ticketElement, combos, isSeatingModeEnabled) => {
  if (isOpenItemFn(ticketElement) || !ticketElement.comboElementId)
    return;
  const comboElement = combos[ticketElement.comboElementId];
  const itemGroupId = ticketElement.comboItemGroupId;
  if (!itemGroupId)
    return;
  const itemGroup = comboElement.itemGroupsSelected[`${itemGroupId}-${ticketElement.comboItemGroupInstance}`];
  if (!itemGroup)
    return;
  combos[ticketElement.comboElementId].itemGroupsSelected[`${itemGroupId}-${ticketElement.comboItemGroupInstance}`].isComplete = ticketElement.isModifiersSelectionComplete;
  setIsComboComplete(
    combos[ticketElement.comboElementId],
    isSeatingModeEnabled
  );
};
var incrementComboSeatQuantity = (comboElement, ticket, seatId) => {
  incrementSeatQuantity(comboElement, seatId);
  Object.values(comboElement.itemGroupsSelected).filter(
    (itemGroupSelected) => itemGroupSelected.ticketElementId
  ).forEach((itemGroupSelected) => {
    checkForSentItems(ticket, itemGroupSelected.ticketElementId);
    incrementSeatQuantity(
      ticket[itemGroupSelected.ticketElementId],
      seatId
    );
  });
};
var decrementComboSeatQuantity = (comboElement, ticket, seatId) => {
  decrementSeatQuantity(comboElement, seatId);
  Object.values(comboElement.itemGroupsSelected).filter(
    (itemGroupSelected) => itemGroupSelected.ticketElementId
  ).forEach((itemGroupSelected) => {
    checkForSentItems(ticket, itemGroupSelected.ticketElementId);
    decrementSeatQuantity(
      ticket[itemGroupSelected.ticketElementId],
      seatId
    );
  });
};
var toggleComboSeatQuantity = (comboElement, ticket, seatId, quantity) => {
  const toggleCase = toggleSeatQuantity(comboElement, seatId, quantity);
  Object.values(comboElement.itemGroupsSelected).filter(
    (itemGroupSelected) => itemGroupSelected.ticketElementId
  ).forEach((itemGroupSelected) => {
    checkForSentItems(ticket, itemGroupSelected.ticketElementId);
    toggleSeatQuantity(
      ticket[itemGroupSelected.ticketElementId],
      seatId,
      quantity
    );
  });
  return toggleCase;
};
var setComboSeatQuantity = (comboElement, ticket, seatId, quantity) => {
  setSeatQuantity(comboElement, seatId, quantity);
  Object.values(comboElement.itemGroupsSelected).filter(
    (itemGroupSelected) => itemGroupSelected.ticketElementId
  ).forEach((itemGroupSelected) => {
    setSeatQuantity(
      ticket[itemGroupSelected.ticketElementId],
      seatId,
      quantity
    );
  });
};
var shareComboElement = (order, comboElement, ticket, isSeatingModeEnabled, shareCase, splitType) => {
  deleteNoSeatKey(comboElement);
  const originalQuantity = comboElement.quantity;
  let quantity = comboElement.quantity;
  if (shareCase === "share" || comboElement.quantity === 0) {
    comboElement.quantity = 1;
    quantity = 1;
  }
  shareTicketElement(comboElement, splitType);
  if (quantity < originalQuantity) {
    adjustComboElemItemElementIds(
      order,
      comboElement,
      quantity - originalQuantity
    );
  }
  setSeatValuesOnShareToggle(comboElement, true, isSeatingModeEnabled);
  setIsComboComplete(comboElement, isSeatingModeEnabled);
  updateCheckElementForComboElement(order, getTicketElementId(comboElement));
  Object.values(comboElement.itemGroupsSelected).filter(
    (itemGroupSelected) => itemGroupSelected.ticketElementId
  ).forEach((itemGroupSelected) => {
    shareTicketElement(
      ticket[itemGroupSelected.ticketElementId],
      splitType
    );
    setSeatValuesOnShareToggle(
      ticket[itemGroupSelected.ticketElementId],
      true,
      isSeatingModeEnabled
    );
  });
};
var unShareComboElement = (comboElement, ticket, isSeatingModeEnabled, isForTableEnabled) => {
  setSeatValuesOnShareToggle(comboElement, false, isSeatingModeEnabled);
  unShareTicketElement(comboElement, isForTableEnabled);
  Object.values(comboElement.itemGroupsSelected).filter(
    (itemGroupSelected) => itemGroupSelected.ticketElementId
  ).forEach((itemGroupSelected) => {
    unShareTicketElement(
      ticket[itemGroupSelected.ticketElementId],
      isForTableEnabled
    );
    setSeatValuesOnShareToggle(
      ticket[itemGroupSelected.ticketElementId],
      false,
      isSeatingModeEnabled
    );
  });
};
var toggleComboElementSeatShared = (comboElement, ticket, isSeatingModeEnabled, seatId) => {
  toggleSeat(comboElement, seatId);
  setSeatValuesOnShareToggle(comboElement, true, isSeatingModeEnabled);
  Object.values(comboElement.itemGroupsSelected).filter(
    (itemGroupSelected) => itemGroupSelected.ticketElementId
  ).forEach((itemGroupSelected) => {
    toggleSeat(ticket[itemGroupSelected.ticketElementId], seatId);
    setSeatValuesOnShareToggle(
      ticket[itemGroupSelected.ticketElementId],
      true,
      isSeatingModeEnabled
    );
  });
};
var setComboElementQuantity = (comboElement, ticket, quantity, isSeatingModeEnabled) => {
  comboElement.quantity = quantity;
  if (!comboElement.isShared)
    comboElement.seating = { [NO_SEAT_ID]: quantity };
  updateSharedQuantities(comboElement);
  Object.values(comboElement.itemGroupsSelected).filter(
    (itemGroupSelected) => itemGroupSelected.ticketElementId
  ).forEach((itemGroupSelected) => {
    checkForSentItems(ticket, itemGroupSelected.ticketElementId);
    ticket[itemGroupSelected.ticketElementId].quantity = quantity;
    ticket[itemGroupSelected.ticketElementId].seating = {
      [NO_SEAT_ID]: quantity
    };
    updateSharedQuantities(
      ticket[itemGroupSelected.ticketElementId]
    );
    updateCompletedSections(
      ticket[itemGroupSelected.ticketElementId],
      isSeatingModeEnabled
    );
  });
};
var checkForSentItems = (ticket, ticketElementId) => {
  if (isTicketElementTriggered(ticket[ticketElementId]))
    copySentTicketElementConfig(ticket[ticketElementId]);
};
var setComboBasePrice = (comboElement, overridePrice) => {
  comboElement.overridePricePerItemUnit = overridePrice;
  comboElement.isPriceOverride = true;
  calcTotalComboPrice(comboElement);
};
var revertComboPrice = (comboElement) => {
  comboElement.overridePricePerItemUnit = 0;
  comboElement.isPriceOverride = false;
  calcTotalComboPrice(comboElement);
};
var calcTotalAdditionalPrice = (comboElement) => {
  comboElement.totalAdditionalPriceAmount = Object.values(
    comboElement.itemGroupsSelected
  ).reduce(
    (totalAdditional, itemGroup) => {
      var _a, _b;
      return totalAdditional + ((_a = itemGroup.additionalPrice) != null ? _a : 0) + ((_b = itemGroup.additionalModifiersPrice) != null ? _b : 0);
    },
    0
  );
};
var isComboElementIdInSeatPage = (combos, comboElementId, currentSeat, activeItems) => {
  if (currentSeat === ALL_SEATS)
    return { comboElementId, activeItems };
  const seatKeys = currentSeat === FOR_TABLE_SEAT_ID ? 0 : currentSeat;
  return comboElementId === null ? { comboElementId: null, activeItems: [] } : Object.values(combos).filter(
    (comboElement) => Object.keys(comboElement.seating).map((seatKey) => Number(seatKey)).includes(seatKeys)
  ).some(
    (comboElement) => comboElementId === getTicketElementId(comboElement)
  ) ? { comboElementId, activeItems: [comboElementId] } : { comboElementId: null, activeItems: [] };
};
var clearCombos = (order, clearableComboIds) => {
  var _a;
  Object.values((_a = order.combos) != null ? _a : {}).forEach((comboElement) => {
    if (comboElement.isInClosedCheck)
      return;
    const comboElementId = getTicketElementId(comboElement);
    if (clearableComboIds.includes(comboElementId))
      removeComboElement(order, comboElementId);
  });
};
var ungroupComboElementByQty = (combos, ticket, comboElementId, quantity, newTicketElementId) => {
  const currentCombo = combos[comboElementId];
  if (!currentCombo)
    return;
  if (!currentCombo.isComplete || currentCombo.quantity - quantity < 1)
    return;
  duplicateRegisterCombo(
    combos,
    ticket,
    comboElementId,
    newTicketElementId,
    false
  );
  const newComboElement = combos[newTicketElementId];
  newComboElement.quantity = currentCombo.quantity - quantity;
  newComboElement.instanceIds = currentCombo.instanceIds.slice(
    0,
    newComboElement.quantity
  );
  currentCombo.instanceIds = currentCombo.instanceIds.slice(
    newComboElement.quantity
  );
  currentCombo.quantity = quantity;
  applySeatAndQuantityToItems(currentCombo, ticket);
  applySeatAndQuantityToItems(newComboElement, ticket);
};
var applySeatAndQuantityToItems = (comboElement, ticket) => {
  Object.values(comboElement.itemGroupsSelected).forEach(
    (itemGroupSelected) => {
      if (itemGroupSelected.ticketElementId === null)
        return;
      ticket[itemGroupSelected.ticketElementId].quantity = comboElement.quantity;
      ticket[itemGroupSelected.ticketElementId].seating = comboElement.seating;
    }
  );
};
var updateWithComboValues = (comboElement, ticketElement, itemGroupId, instanceId) => {
  ticketElement.comboElementId = getEntityIdOrTabletGeneratedId(comboElement);
  ticketElement.comboItemGroupId = itemGroupId;
  ticketElement.comboItemGroupInstance = instanceId;
  ticketElement.quantity = comboElement.quantity;
  ticketElement.seating = __spreadValues({}, comboElement.seating);
  ticketElement.isShared = comboElement.isShared;
};
var ungroupComboElementBySeats = (combos, ticket, comboElementsSeatMap) => {
  const originalComboId = comboElementsSeatMap[0].ticketElementId;
  const originalComboElement = combos[originalComboId];
  const originalItemElementIds = originalComboElement.instanceIds;
  comboElementsSeatMap.forEach(
    ({ ticketElementId: comboElementId, seatId, quantity }, index) => {
      if (!comboElementId || !quantity)
        return;
      if (index !== 0 && typeof comboElementId === "string") {
        duplicateRegisterCombo(
          combos,
          ticket,
          originalComboId,
          comboElementId,
          true
        );
      }
      const comboElement = combos[comboElementId];
      comboElement.instanceIds = [];
      comboElement.seating = {
        [seatId]: quantity
      };
      comboElement.quantity = quantity;
      applySeatAndQuantityToItems(comboElement, ticket);
    }
  );
  originalComboElement.instanceIds = originalItemElementIds;
  return {
    originalTicketElementId: originalComboId,
    newTicketElementIds: comboElementsSeatMap.map(({ ticketElementId }) => ticketElementId).filter((ticketElementId) => ticketElementId !== originalComboId)
  };
};
var ungroupComboElementBySingleSeat = (combos, ticket, comboElementId, newComboElementId, seatId, quantity) => {
  const currentComboElement = combos[comboElementId];
  const currentSeatQty = currentComboElement.seating[seatId];
  if (!currentComboElement || !currentSeatQty || currentSeatQty - quantity < 1) {
    return;
  }
  duplicateRegisterCombo(
    combos,
    ticket,
    comboElementId,
    newComboElementId,
    true
  );
  const newComboElement = combos[newComboElementId];
  newComboElement.instanceIds = currentComboElement.instanceIds.slice(
    0,
    quantity
  );
  newComboElement.instanceIds = currentComboElement.instanceIds.slice(quantity);
  currentComboElement.instanceIds = currentComboElement.instanceIds.slice(
    0,
    quantity
  );
  newComboElement.quantity = (currentComboElement.quantity || 0) - quantity;
  newComboElement.seating = __spreadProps(__spreadValues({}, currentComboElement.seating), {
    [seatId]: (currentComboElement.quantity || 0) - quantity
  });
  currentComboElement.quantity = quantity;
  currentComboElement.seating = { [seatId]: quantity };
  applySeatAndQuantityToItems(currentComboElement, ticket);
  applySeatAndQuantityToItems(newComboElement, ticket);
};
var updateItemGroupSelected = (comboElement, itemGroupId, itemGroupInstance, itemGroupSelected) => {
  comboElement.itemGroupsSelected[`${itemGroupId}-${itemGroupInstance}`] = itemGroupSelected;
};
var rollUpComboElements = (order, rollUpIds, currentSpecials, orderSpecialsSource) => rollUpIds.forEach(
  ({ uniqueId, redundantIds, resultingQuantity, resultingSeats }) => {
    var _a;
    const resultingComboElement = order.combos[uniqueId];
    const oldComboElementIds = order.combos[uniqueId].instanceIds;
    resultingComboElement.quantity = resultingQuantity;
    resultingComboElement.seating = resultingSeats;
    resultingComboElement.updatedAt = getNowUTCDate();
    applySeatAndQuantityToItems(resultingComboElement, order.ticketElements);
    redundantIds.forEach((redundantId) => {
      resultingComboElement.instanceIds = [
        ...resultingComboElement.instanceIds,
        ...order.combos[redundantId].instanceIds
      ];
    });
    const hasSpecials = Object.values((_a = resultingComboElement.specials) != null ? _a : {}).length + redundantIds.reduce(
      (specialsCount, redundantId) => {
        var _a2;
        return specialsCount + Object.values((_a2 = order.combos[redundantId].specials) != null ? _a2 : {}).length;
      },
      0
    );
    if (hasSpecials) {
      const resultingInstances = resultingComboElement.instanceIds.map(
        (instanceId, index) => ({
          elementId: uniqueId,
          instance: index + 1,
          instanceId
        })
      );
      let oldInstances = [...oldComboElementIds].map(
        (instance) => `${uniqueId}-${instance}`
      );
      redundantIds.forEach((redundantElementId) => {
        const redundantElementInstances = order.combos[redundantElementId].instanceIds.map((instance) => `${redundantElementId}-${instance}`);
        oldInstances = [...oldInstances, ...redundantElementInstances];
      });
      const dictionaryKeys = {};
      const dictionaryEntries = zip(oldInstances, resultingInstances);
      dictionaryEntries.forEach(([oldKeyInstance, newKeyInstance]) => {
        if (oldKeyInstance && newKeyInstance)
          dictionaryKeys[oldKeyInstance] = newKeyInstance;
      });
      updateCurrentOrderSpecialObjectWithDictionary(
        dictionaryKeys,
        currentSpecials
      );
      const specialBound = getSpecialBoundToItem(
        currentSpecials,
        null,
        uniqueId
      );
      if (specialBound) {
        const bogoSpecial = Object.values(
          order.combos[uniqueId].specials
        ).find((special) => special.specialId === specialBound.specialId);
        const appliedSpecialAmount = getComboBOGOAppliedAmount(
          orderSpecialsSource[specialBound.specialId].discountSpecialObj,
          order.combos[uniqueId]
        );
        const { instances, count } = countComboInstances(
          currentSpecials,
          specialBound.specialId,
          uniqueId
        );
        if (bogoSpecial) {
          order.combos[uniqueId].specials[bogoSpecial.id || bogoSpecial.tabletGeneratedId].instances = instances;
          order.combos[uniqueId].specials[bogoSpecial.id || bogoSpecial.tabletGeneratedId].appliedSpecialAmount = appliedSpecialAmount * count;
        } else {
          const tabletGeneratedId = generateTicketElementId();
          order.combos[uniqueId].specials[tabletGeneratedId] = __spreadProps(__spreadValues({}, getSpecialAppliedValue(
            orderSpecialsSource[specialBound.specialId].discountSpecialObj
          )), {
            tabletGeneratedId,
            appliedSpecialAmount: appliedSpecialAmount * count,
            instances
          });
        }
      }
    }
    redundantIds.forEach((redundantId) => {
      const itemGroupsSelected = order.combos[redundantId].itemGroupsSelected;
      Object.values(itemGroupsSelected).forEach(
        (itemGroupSelected) => {
          if (itemGroupSelected.ticketElementId === null)
            return;
          delete order.ticketElements[itemGroupSelected.ticketElementId];
        }
      );
      delete order.combos[redundantId];
    });
    calcTotalComboPrice(order.combos[uniqueId]);
    updateCheckElementForComboElement(order, uniqueId);
  }
);
var isComboVoided = (itemGroupsSelected, ticket, skipPendingItemsCheck = false) => {
  const itemGroupList = Object.values(itemGroupsSelected);
  const hasPendingItems = itemGroupList.find(
    (itemGroupSelected) => itemGroupSelected.isRequired && !itemGroupSelected.ticketElementId
  );
  if (!skipPendingItemsCheck && hasPendingItems)
    return false;
  return itemGroupList.filter(filterNotNullItem).reduce(
    (acc, itemGroupSelected) => acc && ticket[itemGroupSelected.ticketElementId].isVoided,
    true
  );
};
var getComboBasePrice = (menuTypeVersion, isToGo) => {
  var _a, _b;
  let baseItemPrice = (_a = menuTypeVersion.comboBasePrice) != null ? _a : 0;
  if (isToGo)
    baseItemPrice = (_b = menuTypeVersion.toGoPrice) != null ? _b : 0;
  return baseItemPrice;
};
var isComboElementTaxInclusive = (comboElement) => {
  var _a, _b;
  return (_b = (_a = comboElement.comboObj) == null ? void 0 : _a.menuTypeVersions[comboElement.menuTypeId].taxInclusive) != null ? _b : false;
};
var updateComboIsTakeoutStatus = (comboElement, ticket) => {
  const comboItemsSelected = Object.values(
    comboElement.itemGroupsSelected
  ).filter(
    (itemGroupSelected) => !!itemGroupSelected.ticketElementId
  );
  if (comboItemsSelected.length === 0)
    return;
  const isComboTakeout = comboItemsSelected.every(
    (itemGroupSelected) => ticket[itemGroupSelected.ticketElementId].isTakeout
  );
  comboElement.isTakeout = isComboTakeout;
};
var expandItemGroupsFunction = (itemGroup) => {
  var _a;
  const isRequired = itemGroup.required;
  return Array((_a = itemGroup.quantity) != null ? _a : 1).fill(null).map((_, index) => __spreadProps(__spreadValues({}, cloneDeep(itemGroup)), {
    isRequired,
    instanceId: index + 1
  }));
};
var updateItemGroupAdditionalPrice = (ticketElement, comboElement) => {
  var _a, _b;
  if (!ticketElement.comboItemGroupId || !ticketElement.comboItemGroupInstance)
    return;
  const extraModifiersPrice = ticketElement.selectedModifiersPricePerItemUnit - ((_b = (_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[isNotOpenItemFn(ticketElement) ? ticketElement.menuTypeId : 0].defaultModifiersPrice) != null ? _b : 0);
  comboElement.itemGroupsSelected[`${ticketElement.comboItemGroupId}-${ticketElement.comboItemGroupInstance}`].additionalModifiersPrice = Math.max(extraModifiersPrice, 0);
  calcTotalAdditionalPrice(comboElement);
  calcTotalComboPrice(comboElement);
};

// src/helpers/register/reducerHelpers/orders.ts
var clearUnsentTicketElements = (ticket, clearableComboIds, ignoredTicketElementIds) => {
  const ignoredTicketElementIdsSet = new Set(ignoredTicketElementIds);
  Object.values(ticket).forEach((ticketElement) => {
    if (ticketElement.isInClosedCheck)
      return;
    const _ticketElementId = getTicketElementId(ticketElement);
    if (ignoredTicketElementIdsSet.has(_ticketElementId))
      return;
    if (isNotOpenItemFn(ticketElement) && ticketElement.comboElementId && !clearableComboIds.includes(ticketElement.comboElementId))
      return;
    const timeTriggered = ticket[_ticketElementId].timeTriggered;
    if (timeTriggered === NULLISH_DATE) {
      delete ticket[_ticketElementId];
    }
  });
};
var clearUnsentTicketElementsAndSplit = (order, ticketElementIds, ignoredTicketElementIds, currentSeat, checkForSplit) => {
  Object.values(order.ticketElements).filter(isTicketElementNotAssociatedWithCombo).filter(
    (ticketElement) => ticketElementIds.includes(getTicketElementId(ticketElement)) && !ignoredTicketElementIds.includes(getTicketElementId(ticketElement))
  ).filter(notTicketElementTriggered).forEach((item) => {
    var _a;
    if (item.isInClosedCheck)
      return;
    let requireSplit = checkForSplit;
    if (checkForSplit) {
      const isUniqueSeatElement = Object.keys(order.ticketElements[getTicketElementId(item)].seating).length === 1 && order.ticketElements[getTicketElementId(item)].seating[currentSeat];
      requireSplit = !isUniqueSeatElement;
    }
    if (!requireSplit)
      delete order.ticketElements[getTicketElementId(item)];
    else {
      const ticketElement = order.ticketElements[getTicketElementId(item)];
      const seatKey = currentSeat === FOR_TABLE_SEAT_ID ? 0 : currentSeat;
      const clearedQty = ticketElement.seating[seatKey];
      ticketElement.quantity = ((_a = ticketElement.quantity) != null ? _a : 1) - clearedQty;
      delete ticketElement.seating[seatKey];
    }
  });
};
var getCourseTimeOnTheFly = (courseId) => {
  return {
    timeTriggered: null,
    timeSentToKitchen: null,
    courseId,
    courseName: `${courseId}`,
    isActive: true,
    sortPriority: courseId,
    triggerTime: courseId,
    type: "on_the_fly" /* ON_THE_FLY */
  };
};
var getOrderHasUnsentItems = (order) => {
  if (!order.ticketElements)
    return false;
  return Object.values(order.ticketElements).some(
    (item) => !isTicketElementSent(item) && !item.isOnHold
  );
};
var getOrderHasToShowItemsNotSentIndicator = (order) => {
  if (!order.ticketElements)
    return false;
  return order.hasUnsentItems || Object.values(order.ticketElements).some((item) => item.isOnHold);
};
var isOrderClosed = (order) => {
  return order.status === "closed-batch pending" /* CLOSED_BATCH_PENDING */ || order.status === "closed-complete" /* CLOSED_COMPLETE */ || order.status === "failed" /* FAILED */ || order.status === "tip-pending" /* TIP_PENDING */ || order.status === "other-voided" /* OTHER_VOIDED */;
};

// src/helpers/register/reducerHelpers/serviceCharges.ts
var getOrderApplicableServiceCharges = (order, orderServiceCharges, orderTaxes) => {
  const serviceCharges = orderServiceCharges != null ? orderServiceCharges : selectPaymentsServiceCharges.lastResult();
  if (!serviceCharges)
    return {
      serviceChargeDetails: {},
      serviceChargeTotal: 0,
      serviceChargeTaxTotal: 0,
      serviceChargeTaxesSource: {}
    };
  const selectedIds = new Set(
    order.serviceChargeSelection ? order.serviceChargeSelection.selectedIds : []
  );
  const unselectedIds = new Set(
    order.serviceChargeSelection ? order.serviceChargeSelection.unselectedIds : []
  );
  const taxes = orderTaxes != null ? orderTaxes : selectCurrentTaxesSettingsSelector.lastResult();
  const serviceChargeDetails = {};
  const serviceChargeTaxesSource = {};
  Object.values(serviceCharges).forEach((serviceCharge) => {
    if (selectedIds.has(Number(serviceCharge.id)) || serviceCharge.active && ((order == null ? void 0 : order.numberOfSeatsOccupied) || 0) >= serviceCharge.minGuests && serviceCharge.orderTypes.includes(order.type) && !unselectedIds.has(Number(serviceCharge.id)) && serviceCharge.autoApply) {
      serviceCharge.taxIds.forEach((taxId) => {
        if (!(taxId in serviceChargeTaxesSource) && taxId in taxes) {
          const newTax = __spreadValues({}, taxes[taxId]);
          delete newTax.createdAt;
          delete newTax.updatedAt;
          delete newTax.deletedAt;
          serviceChargeTaxesSource[taxId] = newTax;
        }
      });
    }
  });
  Object.entries(serviceCharges).forEach(([serviceChargeId, serviceCharge]) => {
    var _a, _b, _c, _d;
    if (selectedIds.has(Number(serviceCharge.id)) || serviceCharge.active && ((order == null ? void 0 : order.numberOfSeatsOccupied) || 0) >= serviceCharge.minGuests && serviceCharge.orderTypes.includes(order.type) && !unselectedIds.has(Number(serviceCharge.id)) && serviceCharge.autoApply) {
      const charge = roundToMoneyDecimals(
        serviceCharge.chargeType === "fixed" /* FIXED */ || serviceCharge.chargeType === "custom_dollar" /* CUSTOM_DOLLAR */ ? serviceCharge.chargeType === "custom_dollar" /* CUSTOM_DOLLAR */ ? ((_b = (_a = order.serviceChargeSelection) == null ? void 0 : _a.customIds) == null ? void 0 : _b[serviceChargeId]) || 0 : serviceCharge.charge : (serviceCharge.discount === "post discount" /* POST_DISCOUNT */ ? order.total : order.subtotal) * (serviceCharge.chargeType === "custom_percent" /* CUSTOM_PERCENT */ ? ((_d = (_c = order.serviceChargeSelection) == null ? void 0 : _c.customIds) == null ? void 0 : _d[serviceChargeId]) || 0 : serviceCharge.charge) / 100
      );
      let taxResultObj = getInitialTaxDetailsObject();
      const taxReduceFunction = getTaxesReduceFunction(
        serviceChargeTaxesSource,
        order.type,
        order.type === "to_go" /* TO_GO */,
        charge,
        1,
        null
      );
      taxResultObj = serviceCharge.taxIds.reduce(
        taxReduceFunction,
        taxResultObj
      );
      serviceChargeDetails[Number(serviceChargeId)] = __spreadProps(__spreadValues({}, serviceCharge), {
        taxAmount: taxResultObj.taxTotal,
        taxDetails: taxResultObj.details,
        appliedServiceCharge: charge
      });
    }
  });
  let serviceChargeTotal = 0;
  let serviceChargeTaxTotal = 0;
  Object.values(serviceChargeDetails).forEach((serviceCharge) => {
    serviceChargeTotal += serviceCharge.appliedServiceCharge;
    serviceChargeTaxTotal += serviceCharge.taxAmount;
  });
  return {
    serviceChargeDetails,
    serviceChargeTotal: roundToMoneyDecimals(serviceChargeTotal),
    serviceChargeTaxTotal: roundToMoneyDecimals(serviceChargeTaxTotal),
    serviceChargeTaxesSource
  };
};

// src/helpers/register/reducerHelpers/totalCalculation.ts
var roundToMoneyDecimals = (value) => {
  return parseFloat(
    (Math.round(parseFloat(value.toFixed(3)) * 100) / 100).toFixed(2)
  );
};
var calcTicketElementTaxInclusivePrice = (ticketElement, orderType) => {
  var _a, _b, _c, _d, _e;
  const taxIds = getTaxesToApplyFromItemObj(
    ticketElement.itemObj,
    ticketElement.menuTypeId
  );
  ticketElement.baseItemPrice = getBasePriceFromTaxInclusive(
    (_b = (_a = ticketElement.itemObj) == null ? void 0 : _a.taxesSource) != null ? _b : {},
    orderType,
    ticketElement.isPriceOverride ? ticketElement.overridePricePerItemUnit : ticketElement.itemObj ? getBasePrice(
      ticketElement.itemObj.menuTypeVersions[ticketElement.menuTypeId],
      ticketElement.isTakeout
    ) : (_c = ticketElement.baseItemPrice) != null ? _c : 0,
    taxIds,
    ticketElement.isTakeout,
    getTicketItemVolumeData(ticketElement),
    ticketElement.quantity || 1
  );
  ticketElement.taxInclusiveSelectedModifiersPricePerItemUnit = getModsPriceForTaxInclusive(
    (_e = (_d = ticketElement.itemObj) == null ? void 0 : _d.taxesSource) != null ? _e : {},
    orderType,
    ticketElement.isPriceOverride ? 0 : ticketElement.selectedModifiersPricePerItemUnit,
    taxIds,
    ticketElement.isTakeout,
    ticketElement.quantity || 1
  );
  return ticketElement;
};
var calcTicketElementAlternativeTaxInclusivePrice = (ticketElement, dualPricingSettings) => {
  ticketElement.alternativePriceData.baseItemPrice = getAlternativeListBasePrice(
    ticketElement.baseItemPrice,
    dualPricingSettings
  );
  ticketElement.alternativePriceData.selectedModifiersPricePerItemUnit = getAlternativeListBasePrice(
    ticketElement.selectedModifiersPricePerItemUnit,
    dualPricingSettings
  );
  if (ticketElement.isTaxInclusive) {
    ticketElement.alternativePriceData.taxInclusiveSelectedModifiersPricePerItemUnit = getAlternativeListBasePrice(
      ticketElement.taxInclusiveSelectedModifiersPricePerItemUnit,
      dualPricingSettings
    );
  }
  return ticketElement;
};
var calcTicketComboAlternativeTaxInclusivePrice = (ticketElement, dualPricingSettings) => {
  ticketElement.alternativePriceData.comboBasePrice = getAlternativeListBasePrice(
    ticketElement.comboBasePrice,
    dualPricingSettings
  );
  if (ticketElement.isTaxInclusive) {
    ticketElement.alternativePriceData.taxInclusiveAdditionalPrice = getAlternativeListBasePrice(
      ticketElement.taxInclusiveAdditionalPrice,
      dualPricingSettings
    );
  } else {
    ticketElement.alternativePriceData.totalAdditionalPriceAmount = getAlternativeListBasePrice(
      ticketElement.totalAdditionalPriceAmount,
      dualPricingSettings
    );
  }
  return ticketElement;
};
var calcTicketElementSpecialAmounts = (ticketElement, calcSpecial) => {
  if (calcSpecial)
    ticketElement.specials = calcSpecialAmountApplied(
      ticketElement.specials,
      ticketElement.quantity,
      getItemPriceForSpecialsFlow(ticketElement)
    );
  ticketElement.totalSpecialsAmount = getTotalSpecialAmount(
    ticketElement.specials
  );
  ticketElement.totalSpecialsBOGOAmount = getTotalBogoSpecialAmount(
    ticketElement.specials
  );
  return ticketElement;
};
var calcTicketElementAlternativeSpecialAmounts = (ticketElement, calcSpecial) => {
  if (calcSpecial) {
    ticketElement.alternativePriceData.specials = cloneDeep(
      ticketElement.specials
    );
    ticketElement.alternativePriceData.specials = calcSpecialAmountApplied(
      ticketElement.alternativePriceData.specials,
      ticketElement.quantity,
      getAlternativePriceForSpecialsFlow(ticketElement)
    );
  }
  ticketElement.alternativePriceData.totalSpecialsAmount = getTotalSpecialAmount(ticketElement.alternativePriceData.specials);
  ticketElement.alternativePriceData.totalSpecialsBOGOAmount = getTotalBogoSpecialAmount(ticketElement.alternativePriceData.specials);
  return ticketElement;
};
var calcTicketElementDiscountAmounts = (ticketElement, calcDiscount) => {
  if (calcDiscount)
    ticketElement.discounts = calcDiscountAmountAppliedToItem(
      ticketElement.discounts,
      ticketElement.quantity,
      getItemPriceWithSpecials(ticketElement)
    );
  ticketElement.totalDiscountAmount = getTotalDiscountAmount(
    ticketElement.discounts
  );
  return ticketElement;
};
var calcTicketElementAlternativeDiscountAmounts = (ticketElement, calcDiscount) => {
  if (calcDiscount) {
    ticketElement.alternativePriceData.discounts = cloneDeep(
      ticketElement.discounts
    );
    ticketElement.alternativePriceData.discounts = calcDiscountAmountAppliedToItem(
      ticketElement.alternativePriceData.discounts,
      ticketElement.quantity,
      getAlternativeItemPriceWithSpecials(ticketElement)
    );
  }
  ticketElement.alternativePriceData.totalDiscountAmount = getTotalDiscountAmount(ticketElement.alternativePriceData.discounts);
  return ticketElement;
};
var calcTicketComboDiscountAmounts = (comboElement, calcDiscount) => {
  if (calcDiscount)
    comboElement.discounts = calcDiscountAmountAppliedToItem(
      comboElement.discounts,
      comboElement.quantity,
      getComboPriceWithSpecials(comboElement)
    );
  comboElement.totalDiscountAmount = getTotalDiscountAmount(
    comboElement.discounts
  );
};
var calcTicketComboAlternativeDiscountAmounts = (comboElement, calcDiscount) => {
  if (calcDiscount)
    comboElement.alternativePriceData.discounts = calcDiscountAmountAppliedToItem(
      comboElement.alternativePriceData.discounts,
      comboElement.quantity,
      getAlternativeComboPriceWithSpecials(comboElement)
    );
  comboElement.alternativePriceData.totalDiscountAmount = getTotalDiscountAmount(comboElement.alternativePriceData.discounts);
};
var calcOpenItemTaxes = (ticketElement, basePrice, modPriceAmount, orderType, taxesSource, totalDiscountsAmountBeforeTaxes, taxResultObj, modTaxObj) => {
  var _a, _b;
  const currentTaxIds = (_b = (_a = ticketElement.itemObj) == null ? void 0 : _a.taxIds) != null ? _b : [];
  let discountsApplied = totalDiscountsAmountBeforeTaxes;
  let discountsAppliedToTheItem = 0;
  if (totalDiscountsAmountBeforeTaxes > basePrice) {
    discountsAppliedToTheItem = basePrice;
    discountsApplied -= basePrice;
  } else {
    discountsAppliedToTheItem = totalDiscountsAmountBeforeTaxes;
    discountsApplied = 0;
  }
  const baseItemPrice = basePrice * ticketElement.quantity - discountsAppliedToTheItem;
  const taxReduceFunction = getTaxesReduceFunction(
    taxesSource,
    orderType,
    ticketElement.isTakeout,
    baseItemPrice,
    ticketElement.quantity,
    getTicketItemVolumeData(ticketElement)
  );
  const modTaxReduceFunction = getTaxesReduceFunction(
    taxesSource,
    orderType,
    ticketElement.isTakeout,
    modPriceAmount * ticketElement.quantity - discountsApplied,
    ticketElement.quantity,
    null,
    true
  );
  taxResultObj = currentTaxIds.reduce(taxReduceFunction, taxResultObj);
  modTaxObj = currentTaxIds.reduce(modTaxReduceFunction, modTaxObj);
  return {
    taxResultObj,
    modTaxObj
  };
};
var getTicketElementBasePriceOnly = (ticketElement) => {
  return ticketElement.isTaxInclusive ? ticketElement.baseItemPrice : ticketElement.isPriceOverride ? ticketElement.overridePricePerItemUnit : ticketElement.baseItemPrice;
};
var getTicketComboBasePriceOnly = (ticketElement) => {
  return ticketElement.isTaxInclusive ? ticketElement.comboBasePrice : ticketElement.isPriceOverride ? ticketElement.overridePricePerItemUnit : ticketElement.comboBasePrice;
};
var getTicketSpecialsAppliedAmount = (ticketElement) => {
  return ticketElement.totalSpecialsBOGOAmount + ticketElement.totalSpecialsAmount;
};
var getTicketElementAlternativeBasePriceOnly = (ticketElement) => {
  return ticketElement.isTaxInclusive ? ticketElement.alternativePriceData.baseItemPrice : ticketElement.isPriceOverride ? ticketElement.overridePricePerItemUnit : ticketElement.alternativePriceData.baseItemPrice;
};
var getTicketComboAlternativeBasePriceOnly = (ticketElement) => {
  return ticketElement.isTaxInclusive ? ticketElement.alternativePriceData.comboBasePrice : ticketElement.isPriceOverride ? ticketElement.overridePricePerItemUnit : ticketElement.alternativePriceData.comboBasePrice;
};
var getTicketAlternativeSpecialsAppliedAmount = (ticketElement) => {
  return ticketElement.alternativePriceData.totalSpecialsBOGOAmount + ticketElement.alternativePriceData.totalSpecialsAmount;
};
var calcTicketElementTaxes = (ticketElement, orderType, taxesSource, totalDiscountsAmountBeforeTaxes, taxResultObj, modTaxObj, basePriceValue, specialsTotalValue) => {
  const currentTaxIds = getTaxesToApplyFromItemObj(
    ticketElement.itemObj,
    ticketElement.menuTypeId
  );
  let discountsApplied = totalDiscountsAmountBeforeTaxes;
  let discountsAppliedToTheItem = 0;
  const basePrice = basePriceValue;
  if (totalDiscountsAmountBeforeTaxes > basePrice) {
    discountsAppliedToTheItem = basePrice;
    discountsApplied -= basePrice;
  } else {
    discountsAppliedToTheItem = totalDiscountsAmountBeforeTaxes;
    discountsApplied = 0;
  }
  const baseItemPrice = basePrice * ticketElement.quantity - (specialsTotalValue + discountsAppliedToTheItem);
  const taxReduceFunction = getTaxesReduceFunction(
    taxesSource,
    orderType,
    ticketElement.isTakeout,
    baseItemPrice,
    ticketElement.quantity,
    getTicketItemVolumeData(ticketElement)
  );
  const modPriceField = ticketElement.isTaxInclusive ? "taxInclusiveSelectedModifiersPricePerItemUnit" : "selectedModifiersPricePerItemUnit";
  const modPriceAmount = ticketElement.isPriceOverride ? 0 : ticketElement[modPriceField];
  const modTaxReduceFunction = getTaxesReduceFunction(
    taxesSource,
    orderType,
    ticketElement.isTakeout,
    modPriceAmount * ticketElement.quantity - discountsApplied,
    ticketElement.quantity,
    null,
    true
  );
  taxResultObj = currentTaxIds.reduce(taxReduceFunction, taxResultObj);
  modTaxObj = currentTaxIds.reduce(modTaxReduceFunction, modTaxObj);
  return {
    taxResultObj,
    modTaxObj
  };
};
var calcTicketComboTaxes = (comboElement, orderType, taxesSource, totalDiscountsAmountBeforeTaxes, taxResultObj, modTaxObj, basePriceValue, specialsTotalValue) => {
  const currentTaxIds = getTaxesToApplyFromComboObj(
    comboElement.comboObj,
    comboElement.menuTypeId
  );
  let discountsApplied = totalDiscountsAmountBeforeTaxes;
  let discountsAppliedToTheCombo = 0;
  const basePrice = basePriceValue;
  if (totalDiscountsAmountBeforeTaxes > basePrice) {
    discountsAppliedToTheCombo = basePrice;
    discountsApplied -= basePrice;
  } else {
    discountsAppliedToTheCombo = totalDiscountsAmountBeforeTaxes;
    discountsApplied = 0;
  }
  const baseItemPrice = basePrice * comboElement.quantity - (specialsTotalValue + discountsAppliedToTheCombo);
  const taxReduceFunction = getTaxesReduceFunction(
    taxesSource,
    orderType,
    comboElement.isTakeout,
    baseItemPrice,
    comboElement.quantity,
    null
  );
  const additionalPriceAmount = comboElement.isPriceOverride ? 0 : comboElement.isTaxInclusive ? comboElement.taxInclusiveAdditionalPrice : comboElement.totalAdditionalPriceAmount;
  const additionalPriceReduceFunction = getTaxesReduceFunction(
    taxesSource,
    orderType,
    comboElement.isTakeout,
    additionalPriceAmount * comboElement.quantity - discountsApplied,
    comboElement.quantity,
    null,
    true
  );
  taxResultObj = currentTaxIds.reduce(taxReduceFunction, taxResultObj);
  modTaxObj = currentTaxIds.reduce(additionalPriceReduceFunction, modTaxObj);
  return {
    taxResultObj,
    modTaxObj
  };
};
var mergeItemAndModTaxes = (taxResultObj, modTaxObj) => {
  return Object.keys(modTaxObj.details).length > Object.keys(taxResultObj.details).length ? mergeTaxesObjects(modTaxObj, taxResultObj) : mergeTaxesObjects(taxResultObj, modTaxObj);
};
var applyTaxToModsAndFixPennies = (ticketElement, taxResultObj) => {
  var _a, _b;
  let taxInclusivePrice = (ticketElement.baseItemPrice + ticketElement.taxInclusiveSelectedModifiersPricePerItemUnit) * ticketElement.quantity + taxResultObj.taxTotal;
  if (Object.keys(ticketElement.specials).length > 0) {
    taxInclusivePrice -= ticketElement.totalSpecialsAmount;
    taxInclusivePrice -= ticketElement.totalSpecialsBOGOAmount;
  }
  if (Object.keys(ticketElement.discounts).length > 0) {
    taxInclusivePrice -= ticketElement.totalDiscountAmount;
  }
  const finalPriceWithDiscountsIsGreaterThanZero = Number(taxInclusivePrice.toFixed(4)) > 0;
  if (finalPriceWithDiscountsIsGreaterThanZero) {
    const originalPriceWithDiscounts = calcDiscountAmountAppliedToOriginalItem(ticketElement);
    const priceDiff = roundToMoneyDecimals(
      originalPriceWithDiscounts - taxInclusivePrice
    );
    if (Math.abs(priceDiff) > 0)
      taxResultObj = distributePenniesBetweenTaxes(
        priceDiff,
        taxResultObj,
        (_b = (_a = ticketElement.itemObj) == null ? void 0 : _a.taxesSource) != null ? _b : {}
      );
  }
  const taxesProportion = Object.values(ticketElement.taxDetails).reduce(
    (acc, tax) => acc + tax.percentage,
    0
  );
  applyTaxProportionToModifierItemsSelected(
    taxesProportion,
    ticketElement.taxInclusiveSelectedModifiersPricePerItemUnit,
    ticketElement.modifierGroupsSelected
  );
  return taxResultObj;
};
var calcElementSpecialsAndDiscounts = (singlePrice, currentPrice, quantity, specials, discounts) => {
  const applySpecialReducer = getSpecialsCalculatorReducer(quantity);
  const applyBogoSpecialReducer = getBogoSpecialCalculatorReducer();
  const applyDiscountsReducer = getDiscountCalculatorReducer(quantity);
  const bogoSpecialsAmount = Object.values(specials != null ? specials : {}).filter((special) => special.specialApplyTo === "bogo" /* BOGO */).sort(sortAppliedSpecialsFunction).reduce(applyBogoSpecialReducer, {
    appliedSpecials: [],
    itemPrice: singlePrice
  }).appliedSpecials.reduce(getTotalSpecialAmountReducer, 0);
  const normalSpecialsAmount = Object.values(specials != null ? specials : {}).filter((special) => special.specialApplyTo !== "bogo" /* BOGO */).sort(sortAppliedSpecialsFunction).reduce(applySpecialReducer, {
    appliedSpecials: [],
    itemPrice: currentPrice
  }).appliedSpecials.reduce(getTotalSpecialAmountReducer, 0);
  const specialsAppliedPrice = currentPrice - bogoSpecialsAmount - normalSpecialsAmount;
  const totalDiscountApplied = Object.values(discounts).sort(sortDiscountsFunction).reduce(applyDiscountsReducer, {
    appliedDiscounts: [],
    itemPrice: specialsAppliedPrice
  }).appliedDiscounts.reduce(getTotalDiscountAmountReducer, 0);
  return specialsAppliedPrice - totalDiscountApplied;
};
var calcDiscountAmountAppliedToOriginalItem = (ticketElement) => {
  var _a, _b;
  const isTaxInclusive = isTicketElementTaxInclusive(ticketElement);
  const menuItemBasePrice = ticketElement.isPriceOverride && isTaxInclusive ? ticketElement.baseItemPrice : ticketElement.itemObj ? getBasePrice(
    ticketElement.itemObj.menuTypeVersions[ticketElement.menuTypeId],
    ticketElement.isTakeout
  ) : (_a = ticketElement.baseItemPrice) != null ? _a : 0;
  const defaultModifiersPrice = ticketElement.isPriceOverride && isTaxInclusive ? 0 : ticketElement.selectedModifiersPricePerItemUnit;
  const originalItemBasePrice = menuItemBasePrice + defaultModifiersPrice;
  const singleItemPrice = ticketElement.isPriceOverride ? ticketElement.overridePricePerItemUnit : originalItemBasePrice;
  const currentItemPrice = singleItemPrice * ticketElement.quantity;
  return calcElementSpecialsAndDiscounts(
    singleItemPrice,
    currentItemPrice,
    ticketElement.quantity,
    (_b = ticketElement.specials) != null ? _b : {},
    ticketElement.discounts
  );
};
var calcDiscountAmountAppliedToOriginalCombo = (comboElement) => {
  var _a;
  const isTaxInclusive = isComboElementTaxInclusive(comboElement);
  const menuComboBasePrice = comboElement.isPriceOverride && isTaxInclusive ? comboElement.comboBasePrice : comboElement.comboObj ? getComboBasePrice(
    comboElement.comboObj.menuTypeVersions[comboElement.menuTypeId],
    comboElement.isTakeout
  ) : (_a = comboElement.comboBasePrice) != null ? _a : 0;
  const defaultAdditionalPrice = comboElement.isPriceOverride && isTaxInclusive ? 0 : comboElement.totalAdditionalPriceAmount;
  const originalComboBasePrice = menuComboBasePrice + defaultAdditionalPrice;
  const singleComboPrice = comboElement.isPriceOverride ? comboElement.overridePricePerItemUnit : originalComboBasePrice;
  const currentComboPrice = singleComboPrice * comboElement.quantity;
  return calcElementSpecialsAndDiscounts(
    singleComboPrice,
    currentComboPrice,
    comboElement.quantity,
    comboElement.specials,
    comboElement.discounts
  );
};
var calcTotalItemPrice = (ticketElement, options) => {
  var _a, _b;
  const {
    calcDiscount = true,
    calcSpecial = true,
    orderType = "dine in" /* DINE_IN */,
    taxExempt = false
  } = options;
  const taxesSource = (_b = (_a = ticketElement.itemObj) == null ? void 0 : _a.taxesSource) != null ? _b : {};
  let taxResultObj = getInitialTaxDetailsObject();
  if (ticketElement.isOpenItem) {
    calcTicketElementDiscountAmounts(ticketElement, calcDiscount);
    const totalDiscountsAmountBeforeTaxes = ticketElement.totalDiscountAmount;
    const finalTaxObject = calcOpenItemTaxes(
      ticketElement,
      ticketElement.isPriceOverride ? ticketElement.overridePricePerItemUnit : ticketElement.baseItemPrice,
      ticketElement.isPriceOverride ? 0 : ticketElement.selectedModifiersPricePerItemUnit,
      orderType,
      taxesSource,
      totalDiscountsAmountBeforeTaxes,
      taxResultObj,
      getInitialTaxDetailsObject()
    );
    taxResultObj = mergeItemAndModTaxes(
      finalTaxObject.taxResultObj,
      finalTaxObject.modTaxObj
    );
  } else {
    if (ticketElement.isTaxInclusive)
      calcTicketElementTaxInclusivePrice(ticketElement, orderType);
    calcTicketElementSpecialAmounts(ticketElement, calcSpecial);
    calcTicketElementDiscountAmounts(ticketElement, calcDiscount);
    const totalDiscountsAmountBeforeTaxes = ticketElement.totalDiscountAmount;
    const finalTaxObject = calcTicketElementTaxes(
      ticketElement,
      orderType,
      taxesSource,
      totalDiscountsAmountBeforeTaxes,
      taxResultObj,
      getInitialTaxDetailsObject(),
      getTicketElementBasePriceOnly(ticketElement),
      getTicketSpecialsAppliedAmount(ticketElement)
    );
    taxResultObj = mergeItemAndModTaxes(
      finalTaxObject.taxResultObj,
      finalTaxObject.modTaxObj
    );
    if (ticketElement.isTaxInclusive) {
      taxResultObj = applyTaxToModsAndFixPennies(ticketElement, taxResultObj);
    }
  }
  ticketElement.totalTax = roundToMoneyDecimals(taxResultObj.taxTotal);
  ticketElement.taxDetails = taxResultObj.details;
  if (taxExempt || ticketElement.taxExempt) {
    ticketElement.totalTax = 0;
    ticketElement.taxDetails = {};
  }
  const { totalPricePerItemUnit, totalPriceWithDiscountsSpecialsNotTaxes } = getTotalDiscountedItemPrice(ticketElement);
  ticketElement.totalPricePerItemUnit = roundToMoneyDecimals(
    totalPricePerItemUnit
  );
  ticketElement.totalPriceWithDiscountsSpecialsNotTaxes = roundToMoneyDecimals(
    totalPriceWithDiscountsSpecialsNotTaxes
  );
};
var calcTotalItemAlternativePrice = (ticketElement, options, dualPricingSettings) => {
  var _a, _b;
  const {
    calcDiscount = true,
    calcSpecial = true,
    orderType = "dine in" /* DINE_IN */,
    taxExempt = false
  } = options;
  calcTicketElementAlternativeTaxInclusivePrice(
    ticketElement,
    dualPricingSettings
  );
  const taxesSource = (_b = (_a = ticketElement.itemObj) == null ? void 0 : _a.taxesSource) != null ? _b : {};
  let taxResultObj = getInitialTaxDetailsObject();
  if (ticketElement.isOpenItem) {
    calcTicketElementAlternativeDiscountAmounts(ticketElement, calcDiscount);
    const totalDiscountsAmountBeforeTaxes = ticketElement.totalDiscountAmount;
    const finalTaxObject = calcOpenItemTaxes(
      ticketElement,
      ticketElement.isPriceOverride ? ticketElement.overridePricePerItemUnit : ticketElement.alternativePriceData.baseItemPrice,
      ticketElement.isPriceOverride ? 0 : ticketElement.alternativePriceData.selectedModifiersPricePerItemUnit,
      orderType,
      taxesSource,
      totalDiscountsAmountBeforeTaxes,
      taxResultObj,
      getInitialTaxDetailsObject()
    );
    taxResultObj = mergeItemAndModTaxes(
      finalTaxObject.taxResultObj,
      finalTaxObject.modTaxObj
    );
  } else {
    if (ticketElement.isTaxInclusive)
      calcTicketElementAlternativeTaxInclusivePrice(
        ticketElement,
        dualPricingSettings
      );
    calcTicketElementAlternativeSpecialAmounts(ticketElement, calcSpecial);
    calcTicketElementAlternativeDiscountAmounts(ticketElement, calcDiscount);
    const totalDiscountsAmountBeforeTaxes = ticketElement.alternativePriceData.totalDiscountAmount;
    const finalTaxObject = calcTicketElementTaxes(
      ticketElement,
      orderType,
      taxesSource,
      totalDiscountsAmountBeforeTaxes,
      taxResultObj,
      getInitialTaxDetailsObject(),
      getTicketElementAlternativeBasePriceOnly(ticketElement),
      getTicketAlternativeSpecialsAppliedAmount(ticketElement)
    );
    taxResultObj = mergeItemAndModTaxes(
      finalTaxObject.taxResultObj,
      finalTaxObject.modTaxObj
    );
  }
  ticketElement.alternativePriceData.totalTax = roundToMoneyDecimals(
    taxResultObj.taxTotal
  );
  ticketElement.alternativePriceData.taxDetails = taxResultObj.details;
  if (taxExempt || ticketElement.taxExempt) {
    ticketElement.alternativePriceData.totalTax = 0;
    ticketElement.alternativePriceData.taxDetails = {};
  }
  const { totalPricePerItemUnit, totalPriceWithDiscountsSpecialsNotTaxes } = getTotalDiscountedAlternativeItemPrice(ticketElement);
  ticketElement.alternativePriceData.totalPricePerItemUnit = roundToMoneyDecimals(totalPricePerItemUnit);
  ticketElement.alternativePriceData.totalPriceWithDiscountsSpecialsNotTaxes = roundToMoneyDecimals(totalPriceWithDiscountsSpecialsNotTaxes);
};
var calcTotalItemWithAlternativePrice = (ticketElement, options) => {
  ticketElement.isTaxInclusive = options.noTaxInclusive ? false : isTicketElementTaxInclusive(ticketElement) && !options.taxExempt;
  const isDualPricingEnabled = selectIsDualPricingEnabled.lastResult();
  calcTotalItemPrice(ticketElement, options);
  if (!isDualPricingEnabled.dualPricing)
    return;
  if (options.orderIsLockedPrice) {
    copyItemTotalPriceToAlternativeData(
      ticketElement
    );
  } else
    calcTotalItemAlternativePrice(
      ticketElement,
      __spreadProps(__spreadValues({}, options), { calcDiscount: true, calcSpecial: true }),
      selectIsDualPricingEnabled.lastResult()
    );
};
var copyItemTotalPriceToAlternativeData = (ticketElement) => {
  if (ticketElement.isOpenItem) {
    const {
      baseItemPrice,
      discounts,
      selectedModifiersPricePerItemUnit,
      specials,
      taxDetails,
      taxInclusiveSelectedModifiersPricePerItemUnit,
      totalDiscountAmount,
      totalPricePerItemUnit,
      totalPriceWithDiscountsSpecialsNotTaxes,
      totalTax
    } = ticketElement;
    const alternativePriceData = {
      baseItemPrice,
      discounts,
      selectedModifiersPricePerItemUnit,
      specials,
      taxDetails,
      taxInclusiveSelectedModifiersPricePerItemUnit,
      totalDiscountAmount,
      totalPricePerItemUnit,
      totalPriceWithDiscountsSpecialsNotTaxes,
      totalTax
    };
    ticketElement.alternativePriceData = alternativePriceData;
  } else {
    const {
      baseItemPrice,
      discounts,
      selectedModifiersPricePerItemUnit,
      specials,
      taxDetails,
      taxInclusiveSelectedModifiersPricePerItemUnit,
      totalDiscountAmount,
      totalPricePerItemUnit,
      totalPriceWithDiscountsSpecialsNotTaxes,
      totalSpecialsAmount,
      totalSpecialsBOGOAmount,
      totalTax
    } = ticketElement;
    const alternativePriceData = {
      baseItemPrice,
      discounts,
      selectedModifiersPricePerItemUnit,
      specials,
      taxDetails,
      taxInclusiveSelectedModifiersPricePerItemUnit,
      totalDiscountAmount,
      totalPricePerItemUnit,
      totalPriceWithDiscountsSpecialsNotTaxes,
      totalSpecialsAmount,
      totalSpecialsBOGOAmount,
      totalTax
    };
    ticketElement.alternativePriceData = alternativePriceData;
  }
};
var calcTotalComboWithAlternativePrice = (comboElement, options) => {
  comboElement.isTaxInclusive = options.noTaxInclusive ? false : isComboElementTaxInclusive(comboElement) && !options.taxExempt;
  const isDualPricingEnabled = selectIsDualPricingEnabled.lastResult();
  calcTotalComboPrice(comboElement, options);
  if (!isDualPricingEnabled.dualPricing)
    return;
  calcTotalAlternativeComboPrice(
    comboElement,
    options,
    selectIsDualPricingEnabled.lastResult()
  );
};
var calcTotalComboPrice = (comboElement, options) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const {
    calcDiscount = true,
    calcSpecial = true,
    orderType = "dine in" /* DINE_IN */,
    taxExempt = false
  } = options != null ? options : {};
  const taxesSource = (_b = (_a = comboElement.comboObj) == null ? void 0 : _a.taxesSource) != null ? _b : {};
  let priceTaxObj = getInitialTaxDetailsObject();
  if (comboElement.isTaxInclusive) {
    const taxIds = getTaxesToApplyFromComboObj(
      comboElement.comboObj,
      comboElement.menuTypeId
    );
    comboElement.comboBasePrice = getBasePriceFromTaxInclusive(
      (_d = (_c = comboElement.comboObj) == null ? void 0 : _c.taxesSource) != null ? _d : {},
      orderType,
      comboElement.isPriceOverride ? comboElement.overridePricePerItemUnit : comboElement.comboObj ? getComboBasePrice(
        comboElement.comboObj.menuTypeVersions[comboElement.menuTypeId],
        comboElement.isTakeout
      ) : (_e = comboElement.comboBasePrice) != null ? _e : 0,
      taxIds,
      comboElement.isTakeout,
      null,
      comboElement.quantity
    );
    comboElement.taxInclusiveAdditionalPrice = getModsPriceForTaxInclusive(
      (_g = (_f = comboElement.comboObj) == null ? void 0 : _f.taxesSource) != null ? _g : {},
      orderType,
      comboElement.isPriceOverride ? 0 : comboElement.totalAdditionalPriceAmount,
      taxIds,
      comboElement.isTakeout,
      comboElement.quantity
    );
  }
  calcTicketElementSpecialAmounts(comboElement, calcSpecial);
  calcTicketComboDiscountAmounts(comboElement, calcDiscount);
  const taxObj = calcTicketComboTaxes(
    comboElement,
    orderType,
    taxesSource,
    comboElement.totalDiscountAmount,
    priceTaxObj,
    getInitialTaxDetailsObject(),
    getTicketComboBasePriceOnly(comboElement),
    getTicketSpecialsAppliedAmount(comboElement)
  );
  priceTaxObj = mergeItemAndModTaxes(taxObj.taxResultObj, taxObj.modTaxObj);
  if (comboElement.isTaxInclusive) {
    const hasSpecials = comboElement.totalSpecialsAmount > 0;
    if (!hasSpecials) {
      let taxInclusivePrice = (comboElement.comboBasePrice + comboElement.taxInclusiveAdditionalPrice) * comboElement.quantity + priceTaxObj.taxTotal;
      if (comboElement.totalDiscountAmount > 0) {
        taxInclusivePrice -= comboElement.totalDiscountAmount;
      }
      const finalPriceWithDiscountsIsGreaterThanZero = Number(taxInclusivePrice.toFixed(4)) > 0;
      if (finalPriceWithDiscountsIsGreaterThanZero) {
        const originalPriceWithDiscounts = calcDiscountAmountAppliedToOriginalCombo(comboElement);
        const priceDiff = roundToMoneyDecimals(
          originalPriceWithDiscounts - taxInclusivePrice
        );
        if (Math.abs(priceDiff) > 0)
          priceTaxObj = distributePenniesBetweenTaxes(
            priceDiff,
            priceTaxObj,
            (_i = (_h = comboElement.comboObj) == null ? void 0 : _h.taxesSource) != null ? _i : {}
          );
      }
    }
  }
  comboElement.totalTax = priceTaxObj.taxTotal;
  comboElement.taxDetails = priceTaxObj.details;
  if (taxExempt) {
    comboElement.totalTax = 0;
    comboElement.taxDetails = {};
  }
  const { totalPricePerItemUnit, totalPriceWithDiscountsSpecialsNotTaxes } = getTotalDiscountedComboPrice(comboElement);
  comboElement.totalPriceWithDiscountsSpecialsNotTaxes = roundToMoneyDecimals(
    totalPriceWithDiscountsSpecialsNotTaxes
  );
  comboElement.totalPricePerItemUnit = roundToMoneyDecimals(
    totalPricePerItemUnit
  );
};
var calcTotalAlternativeComboPrice = (comboElement, options, dualPricingSettings) => {
  var _a, _b, _c, _d;
  const {
    calcDiscount = true,
    calcSpecial = true,
    orderType = "dine in" /* DINE_IN */,
    taxExempt = false
  } = options != null ? options : {};
  calcTicketComboAlternativeTaxInclusivePrice(
    comboElement,
    dualPricingSettings
  );
  const taxesSource = (_b = (_a = comboElement.comboObj) == null ? void 0 : _a.taxesSource) != null ? _b : {};
  let priceTaxObj = getInitialTaxDetailsObject();
  calcTicketElementAlternativeSpecialAmounts(comboElement, calcSpecial);
  calcTicketComboAlternativeDiscountAmounts(comboElement, calcDiscount);
  const taxObj = calcTicketComboTaxes(
    comboElement,
    orderType,
    taxesSource,
    comboElement.alternativePriceData.totalDiscountAmount,
    priceTaxObj,
    getInitialTaxDetailsObject(),
    getTicketComboAlternativeBasePriceOnly(comboElement),
    getTicketAlternativeSpecialsAppliedAmount(comboElement)
  );
  priceTaxObj = mergeItemAndModTaxes(taxObj.taxResultObj, taxObj.modTaxObj);
  if (comboElement.isTaxInclusive) {
    const hasSpecials = comboElement.alternativePriceData.totalSpecialsAmount > 0;
    if (!hasSpecials) {
      let taxInclusivePrice = (comboElement.alternativePriceData.comboBasePrice + comboElement.alternativePriceData.taxInclusiveAdditionalPrice) * comboElement.quantity + priceTaxObj.taxTotal;
      if (comboElement.alternativePriceData.totalDiscountAmount > 0) {
        taxInclusivePrice -= comboElement.alternativePriceData.totalDiscountAmount;
      }
      const finalPriceWithDiscountsIsGreaterThanZero = Number(taxInclusivePrice.toFixed(4)) > 0;
      if (finalPriceWithDiscountsIsGreaterThanZero) {
        const originalPriceWithDiscounts = calcDiscountAmountAppliedToOriginalCombo(comboElement);
        const priceDiff = roundToMoneyDecimals(
          originalPriceWithDiscounts - taxInclusivePrice
        );
        if (Math.abs(priceDiff) > 0)
          priceTaxObj = distributePenniesBetweenTaxes(
            priceDiff,
            priceTaxObj,
            (_d = (_c = comboElement.comboObj) == null ? void 0 : _c.taxesSource) != null ? _d : {}
          );
      }
    }
  }
  comboElement.alternativePriceData.totalTax = priceTaxObj.taxTotal;
  comboElement.alternativePriceData.taxDetails = priceTaxObj.details;
  if (taxExempt) {
    comboElement.alternativePriceData.totalTax = 0;
    comboElement.alternativePriceData.taxDetails = {};
  }
  const { totalPricePerItemUnit, totalPriceWithDiscountsSpecialsNotTaxes } = getTotalDiscountedAlternativeComboPrice(comboElement);
  comboElement.alternativePriceData.totalPriceWithDiscountsSpecialsNotTaxes = roundToMoneyDecimals(totalPriceWithDiscountsSpecialsNotTaxes);
  comboElement.alternativePriceData.totalPricePerItemUnit = roundToMoneyDecimals(totalPricePerItemUnit);
};
var filterTicketElementsForSubtotal = (ticketElements) => {
  return Object.values(ticketElements).filter(
    (ticketItem) => {
      var _a;
      return isOpenItemFn(ticketItem) || !((_a = ticketItem.itemObj) == null ? void 0 : _a.menuTypeVersions[ticketItem.menuTypeId].excludeFromDiscounts);
    }
  ).filter(isTicketElementNotAssociatedWithCombo).filter((ticketElement) => !ticketElement.isVoided);
};
var getItemPriceWithSpecials = (ticketElement) => {
  const notAnOpenItem = isNotOpenItemFn(ticketElement);
  const isTaxInclusive = isTicketElementTaxInclusive(ticketElement);
  return (ticketElement.isPriceOverride ? ticketElement.overridePricePerItemUnit : ticketElement.baseItemPrice + (isTaxInclusive ? ticketElement.taxInclusiveSelectedModifiersPricePerItemUnit : ticketElement.selectedModifiersPricePerItemUnit)) * ticketElement.quantity - (notAnOpenItem ? ticketElement.totalSpecialsBOGOAmount + ticketElement.totalSpecialsAmount : 0);
};
var getAlternativeItemPriceWithSpecials = (ticketElement) => {
  const notAnOpenItem = !ticketElement.isOpenItem;
  const isTaxInclusive = isTicketElementTaxInclusive(ticketElement);
  return (ticketElement.isPriceOverride ? ticketElement.overridePricePerItemUnit : ticketElement.alternativePriceData.baseItemPrice + (isTaxInclusive ? ticketElement.alternativePriceData.taxInclusiveSelectedModifiersPricePerItemUnit : ticketElement.alternativePriceData.selectedModifiersPricePerItemUnit)) * ticketElement.quantity - (notAnOpenItem ? ticketElement.alternativePriceData.totalSpecialsBOGOAmount + ticketElement.alternativePriceData.totalSpecialsAmount : 0);
};
var getComboPriceWithSpecials = (comboElement) => {
  const isItemTaxInclusive = isComboElementTaxInclusive(comboElement);
  return (comboElement.isPriceOverride ? comboElement.overridePricePerItemUnit : comboElement.comboBasePrice + (isItemTaxInclusive ? comboElement.taxInclusiveAdditionalPrice : comboElement.totalAdditionalPriceAmount)) * comboElement.quantity - comboElement.totalSpecialsBOGOAmount - comboElement.totalSpecialsAmount;
};
var getAlternativeComboPriceWithSpecials = (comboElement) => {
  const isItemTaxInclusive = isComboElementTaxInclusive(comboElement);
  return (comboElement.isPriceOverride ? comboElement.overridePricePerItemUnit : comboElement.alternativePriceData.comboBasePrice + (isItemTaxInclusive ? comboElement.alternativePriceData.taxInclusiveAdditionalPrice : comboElement.alternativePriceData.totalAdditionalPriceAmount)) * comboElement.quantity - comboElement.alternativePriceData.totalSpecialsBOGOAmount - comboElement.alternativePriceData.totalSpecialsAmount;
};
var getItemPriceWithModsPerUnit = (ticketElement) => {
  const isTaxInclusive = isTicketElementTaxInclusive(ticketElement);
  return ticketElement.isPriceOverride ? ticketElement.isTaxInclusive ? ticketElement.baseItemPrice : ticketElement.overridePricePerItemUnit : ticketElement.baseItemPrice + (isTaxInclusive ? ticketElement.taxInclusiveSelectedModifiersPricePerItemUnit : ticketElement.selectedModifiersPricePerItemUnit);
};
var getAlternativeItemPriceWithModsPerUnit = (ticketElement) => {
  const isTaxInclusive = isTicketElementTaxInclusive(ticketElement);
  return ticketElement.isPriceOverride ? ticketElement.isTaxInclusive ? ticketElement.alternativePriceData.baseItemPrice : ticketElement.overridePricePerItemUnit : ticketElement.alternativePriceData.baseItemPrice + (isTaxInclusive ? ticketElement.alternativePriceData.taxInclusiveSelectedModifiersPricePerItemUnit : ticketElement.alternativePriceData.selectedModifiersPricePerItemUnit);
};
var getTotalDiscountedItemPrice = (ticketElement) => {
  const totalPricePerItemUnit = getItemPriceWithModsPerUnit(ticketElement);
  const totalPriceWithDiscountsSpecialsNotTaxes = totalPricePerItemUnit * ticketElement.quantity - (ticketElement.isOpenItem ? 0 : ticketElement.totalSpecialsAmount + ticketElement.totalSpecialsBOGOAmount) - ticketElement.totalDiscountAmount;
  return {
    totalPricePerItemUnit,
    totalPriceWithDiscountsSpecialsNotTaxes
  };
};
var getTotalDiscountedComboPrice = (comboElement) => {
  const totalPricePerItemUnit = (comboElement.isPriceOverride ? comboElement.isTaxInclusive ? comboElement.comboBasePrice : comboElement.overridePricePerItemUnit : comboElement.comboBasePrice) + (comboElement.isTaxInclusive ? comboElement.taxInclusiveAdditionalPrice : comboElement.totalAdditionalPriceAmount);
  const totalPriceWithDiscountsSpecialsNotTaxes = totalPricePerItemUnit * comboElement.quantity - comboElement.totalSpecialsAmount - comboElement.totalSpecialsBOGOAmount - comboElement.totalDiscountAmount;
  return {
    totalPricePerItemUnit,
    totalPriceWithDiscountsSpecialsNotTaxes
  };
};
var getTotalDiscountedAlternativeItemPrice = (ticketElement) => {
  const totalPricePerItemUnit = getAlternativeItemPriceWithModsPerUnit(ticketElement);
  const totalPriceWithDiscountsSpecialsNotTaxes = totalPricePerItemUnit * ticketElement.quantity - (ticketElement.isOpenItem ? 0 : ticketElement.alternativePriceData.totalSpecialsAmount + ticketElement.alternativePriceData.totalSpecialsBOGOAmount) - ticketElement.alternativePriceData.totalDiscountAmount;
  return {
    totalPricePerItemUnit,
    totalPriceWithDiscountsSpecialsNotTaxes
  };
};
var getTotalDiscountedAlternativeComboPrice = (comboElement) => {
  const totalPricePerItemUnit = (comboElement.isPriceOverride ? comboElement.isTaxInclusive ? comboElement.alternativePriceData.comboBasePrice : comboElement.overridePricePerItemUnit : comboElement.alternativePriceData.comboBasePrice) + (comboElement.isTaxInclusive ? comboElement.alternativePriceData.taxInclusiveAdditionalPrice : comboElement.alternativePriceData.totalAdditionalPriceAmount);
  const totalPriceWithDiscountsSpecialsNotTaxes = totalPricePerItemUnit * comboElement.quantity - comboElement.alternativePriceData.totalSpecialsAmount - comboElement.alternativePriceData.totalSpecialsBOGOAmount - comboElement.alternativePriceData.totalDiscountAmount;
  return {
    totalPricePerItemUnit,
    totalPriceWithDiscountsSpecialsNotTaxes
  };
};
var getItemElementPrice = (ticketItem) => {
  const { totalPriceWithDiscountsSpecialsNotTaxes } = getTotalDiscountedItemPrice(ticketItem);
  return totalPriceWithDiscountsSpecialsNotTaxes;
};
var getItemElementAlternativePrice = (ticketItem) => {
  if (!ticketItem.alternativePriceData)
    return getItemElementPrice(ticketItem);
  const isTaxInclusive = isTicketElementTaxInclusive(ticketItem);
  const itemTotalPrice = (ticketItem.isPriceOverride ? ticketItem.overridePricePerItemUnit : ticketItem.alternativePriceData.baseItemPrice + (isTaxInclusive ? ticketItem.alternativePriceData.taxInclusiveSelectedModifiersPricePerItemUnit : ticketItem.alternativePriceData.selectedModifiersPricePerItemUnit)) * ticketItem.quantity;
  return itemTotalPrice - ticketItem.alternativePriceData.totalDiscountAmount - (ticketItem.isOpenItem ? 0 : ticketItem.alternativePriceData.totalSpecialsAmount + ticketItem.alternativePriceData.totalSpecialsBOGOAmount);
};
var filterCombosForSubtotal = (combos) => {
  return Object.values(combos).filter((comboItem) => !comboItem.isVoided);
};
var getComboElementPrice = (comboItem) => {
  const isTaxInclusive = isComboElementTaxInclusive(comboItem);
  const comboTotalPrice = (comboItem.isPriceOverride ? comboItem.overridePricePerItemUnit : comboItem.comboBasePrice + (isTaxInclusive ? comboItem.taxInclusiveAdditionalPrice : comboItem.totalAdditionalPriceAmount)) * comboItem.quantity;
  return comboTotalPrice - comboItem.totalSpecialsAmount - comboItem.totalSpecialsBOGOAmount - comboItem.totalDiscountAmount;
};
var getComboElementAlternativePrice = (comboItem) => {
  if (!comboItem.alternativePriceData)
    return getComboElementPrice(comboItem);
  const isTaxInclusive = isComboElementTaxInclusive(comboItem);
  const comboTotalPrice = (comboItem.isPriceOverride ? comboItem.overridePricePerItemUnit : comboItem.alternativePriceData.comboBasePrice + (isTaxInclusive ? comboItem.alternativePriceData.taxInclusiveAdditionalPrice : comboItem.alternativePriceData.totalAdditionalPriceAmount)) * comboItem.quantity;
  return comboTotalPrice - comboItem.alternativePriceData.totalSpecialsAmount - comboItem.alternativePriceData.totalSpecialsBOGOAmount - comboItem.alternativePriceData.totalDiscountAmount;
};
var calcOrderMainSubtotal = (order) => calcOrderSubtotal(order, getItemElementPrice, getComboElementPrice);
var calcOrderAlternativeSubtotal = (order) => calcOrderSubtotal(
  order,
  getItemElementAlternativePrice,
  getComboElementAlternativePrice
);
var calcOrderSubtotal = (order, getItemPriceFunction, getComboPriceFunction) => {
  const itemsTotal = filterTicketElementsForSubtotal(order.ticketElements).map(getItemPriceFunction).reduce((acc, price) => acc + price, 0);
  return filterCombosForSubtotal(order.combos).map(getComboPriceFunction).reduce((acc, comboPrice) => acc + comboPrice, itemsTotal);
};
var getOrderDiscounts = (order) => order.orderDiscounts;
var getOrderAlternativeDiscounts = (order) => order.alternativePriceData.orderDiscounts;
var getOrderAlternativeSpecials = (order) => order.alternativePriceData.orderSpecials;
var getOrderSpecials = (order) => order.orderSpecials;
var calcOrderTotals = (order, withUpdatedServiceCharges) => {
  var _a, _b, _c, _d, _e;
  const taxExempt = order.taxExempt;
  const itemsSummary = Object.values((_a = order.ticketElements) != null ? _a : {}).filter((ticketElement) => !ticketElement.isOnHold).reduce(
    (acc, ticketElement) => {
      const {
        quantity,
        totalPricePerItemUnit,
        totalDiscountAmount,
        totalTax: tax,
        isVoided
      } = ticketElement;
      if (!quantity || isVoided)
        return acc;
      const notAnOpenItem = isNotOpenItemFn(ticketElement);
      const isCombo = notAnOpenItem && !!ticketElement.comboElementId;
      const itemQuantity = quantity != null ? quantity : 1;
      const itemCount = acc.itemCount + itemQuantity;
      if (isCombo)
        return __spreadProps(__spreadValues({}, acc), {
          itemCount
        });
      const subtotal = acc.subtotal + totalPricePerItemUnit * itemQuantity;
      const discount = acc.discount + (notAnOpenItem ? ticketElement.totalSpecialsAmount + ticketElement.totalSpecialsBOGOAmount : 0) + totalDiscountAmount;
      const taxTotal = acc.taxTotal + tax;
      return __spreadProps(__spreadValues({}, acc), {
        discount,
        itemCount,
        subtotal,
        taxTotal
      });
    },
    {
      itemCount: 0,
      subtotal: 0,
      discount: 0,
      taxTotal: 0
    }
  );
  const combosSummary = Object.values((_b = order.combos) != null ? _b : {}).reduce(
    (acc, {
      quantity,
      totalPricePerItemUnit,
      isVoided,
      totalSpecialsBOGOAmount,
      totalSpecialsAmount,
      totalDiscountAmount,
      totalTax: tax
    }) => {
      if (!quantity || isVoided)
        return acc;
      const subtotal = acc.subtotal + totalPricePerItemUnit * quantity;
      const discount = acc.discount + totalSpecialsAmount + totalSpecialsBOGOAmount + totalDiscountAmount;
      const taxTotal = acc.taxTotal + tax;
      return __spreadProps(__spreadValues({}, acc), {
        discount,
        subtotal,
        taxTotal
      });
    },
    {
      subtotal: 0,
      discount: 0,
      taxTotal: 0
    }
  );
  checkAndUpdateOrderSpecials(order, calcOrderMainSubtotal);
  const orderSpecial = getTotalSpecialAmount((_c = order.orderSpecials) != null ? _c : {});
  order.totalDiscountsAndSpecials = itemsSummary.discount + combosSummary.discount + orderSpecial;
  order.subtotal = roundToMoneyDecimals(
    itemsSummary.subtotal + combosSummary.subtotal
  );
  order.itemCount = itemsSummary.itemCount;
  order.tax = itemsSummary.taxTotal + combosSummary.taxTotal;
  const totalService = order.subtotal + order.tax;
  order.total = Math.max(
    0,
    roundToMoneyDecimals(totalService - order.totalDiscountsAndSpecials)
  );
  const {
    serviceChargeTotal,
    serviceChargeTaxTotal,
    serviceChargeTaxesSource,
    serviceChargeDetails
  } = getOrderApplicableServiceCharges(
    __spreadProps(__spreadValues({}, order), {
      subtotal: order.subtotal,
      total: order.subtotal - order.totalDiscountsAndSpecials
    }),
    withUpdatedServiceCharges ? void 0 : (order == null ? void 0 : order.serviceChargeDetails) || {},
    withUpdatedServiceCharges ? void 0 : (order == null ? void 0 : order.serviceChargeTaxesSource) || {}
  );
  order.tax += taxExempt ? 0 : serviceChargeTaxTotal;
  order.serviceChargeTaxTotal = serviceChargeTaxTotal;
  order.serviceChargeTotal = serviceChargeTotal;
  order.orderDiscounts = checkAndUpdateOrderDiscounts(
    order,
    getOrderDiscounts,
    getOrderSpecials,
    calcOrderMainSubtotal
  );
  const orderDiscount = getTotalDiscountAmount((_d = order.orderDiscounts) != null ? _d : {});
  order.totalDiscountsAndSpecials += orderDiscount;
  order.total += roundToMoneyDecimals(
    serviceChargeTotal + serviceChargeTaxTotal
  );
  order.total = roundToMoneyDecimals(order.total - orderDiscount);
  order.serviceChargeTaxesSource = serviceChargeTaxesSource;
  order.serviceChargeDetails = serviceChargeDetails;
  const allPayments = getValidPayments((_e = order.checks) != null ? _e : {});
  const { totalPayments, totalTip } = getTotalPaidAmountAndTotalTip(allPayments);
  order.balanceDue = roundToMoneyDecimals(order.total - totalPayments);
  order.tip = roundToMoneyDecimals(totalTip);
  order.hasUnsentItems = getOrderHasUnsentItems(order);
};
var getTotalPaidAmountAndTotalTip = (payments) => {
  return payments.reduce(
    (acc, { baseAmount, total, tip, paymentMethod }) => ({
      totalPayments: acc.totalPayments + (paymentMethod === "cash" /* CASH */ ? total : baseAmount),
      totalTip: acc.totalTip + tip
    }),
    { totalPayments: 0, totalTip: 0 }
  );
};
var getValidPayments = (checks) => {
  return Object.values(checks).reduce((validPayments, check) => {
    var _a;
    return [
      ...validPayments,
      ...Object.values((_a = check.payments) != null ? _a : {}).filter(
        (payment) => isPaymentValid(payment.status)
      )
    ];
  }, []);
};
var calcAlternativeOrderTotal = (order, withUpdatedServiceCharges) => {
  var _a, _b, _c, _d, _e;
  if (!order.alternativePriceData)
    return calcOrderTotals(order, withUpdatedServiceCharges);
  const itemsSummary = Object.values((_a = order.ticketElements) != null ? _a : {}).filter(
    (ticketElement) => !ticketElement.isOnHold && !ticketElement.isVoided && ticketElement.quantity && !(isNotOpenItemFn(ticketElement) && !!ticketElement.comboElementId) && ticketElement.alternativePriceData
  ).reduce(
    (acc, ticketElement) => {
      const alternativePriceData = ticketElement.alternativePriceData;
      const { quantity } = ticketElement;
      const itemQuantity = quantity;
      const subtotal = acc.subtotal + alternativePriceData.totalPricePerItemUnit * itemQuantity;
      const discount = acc.discount + (ticketElement.isOpenItem ? 0 : alternativePriceData.totalSpecialsAmount + alternativePriceData.totalSpecialsBOGOAmount) + alternativePriceData.totalDiscountAmount;
      const taxTotal = acc.taxTotal + alternativePriceData.totalTax;
      return __spreadProps(__spreadValues({}, acc), { discount, taxTotal, subtotal });
    },
    { subtotal: 0, discount: 0, taxTotal: 0 }
  );
  const combosSummary = Object.values((_b = order.combos) != null ? _b : {}).filter(
    (comboElement) => !comboElement.isVoided && comboElement.quantity && comboElement.alternativePriceData
  ).reduce(
    (acc, comboElement) => {
      const alternativePriceData = comboElement.alternativePriceData;
      const subtotal = acc.subtotal + alternativePriceData.totalPricePerItemUnit * comboElement.quantity;
      const discount = acc.discount + alternativePriceData.totalSpecialsAmount + alternativePriceData.totalSpecialsBOGOAmount + alternativePriceData.totalDiscountAmount;
      const taxTotal = acc.taxTotal + alternativePriceData.totalTax;
      return {
        discount,
        subtotal,
        taxTotal
      };
    },
    {
      subtotal: 0,
      discount: 0,
      taxTotal: 0
    }
  );
  order.alternativePriceData.orderSpecials = cloneDeep(order.orderSpecials);
  checkAndUpdateOrderSpecials(order, calcOrderAlternativeSubtotal);
  const orderSpecial = getTotalSpecialAmount(
    (_c = order.alternativePriceData.orderSpecials) != null ? _c : {}
  );
  const totalDiscountsAndSpecials = itemsSummary.discount + combosSummary.discount + orderSpecial;
  order.alternativePriceData.subtotal = roundToMoneyDecimals(
    itemsSummary.subtotal + combosSummary.subtotal
  );
  order.alternativePriceData.tax = itemsSummary.taxTotal + combosSummary.taxTotal;
  const totalService = order.alternativePriceData.subtotal + order.alternativePriceData.tax;
  order.alternativePriceData.total = Math.max(
    0,
    roundToMoneyDecimals(totalService - totalDiscountsAndSpecials)
  );
  const { serviceChargeTotal, serviceChargeTaxTotal } = getOrderApplicableServiceCharges(
    __spreadProps(__spreadValues({}, order), {
      subtotal: order.alternativePriceData.subtotal,
      total: order.alternativePriceData.subtotal - totalDiscountsAndSpecials
    }),
    withUpdatedServiceCharges ? void 0 : (order == null ? void 0 : order.serviceChargeDetails) || {},
    withUpdatedServiceCharges ? void 0 : (order == null ? void 0 : order.serviceChargeTaxesSource) || {}
  );
  order.alternativePriceData.tax += serviceChargeTaxTotal;
  order.alternativePriceData.serviceChargeTaxTotal = serviceChargeTaxTotal;
  order.alternativePriceData.serviceChargeTotal = serviceChargeTotal;
  order.alternativePriceData.orderDiscounts = cloneDeep(order.orderDiscounts);
  order.alternativePriceData.orderDiscounts = checkAndUpdateOrderDiscounts(
    order,
    getOrderAlternativeDiscounts,
    getOrderAlternativeSpecials,
    calcOrderAlternativeSubtotal
  );
  const orderDiscount = getTotalDiscountAmount(
    (_d = order.alternativePriceData.orderDiscounts) != null ? _d : {}
  );
  order.alternativePriceData.totalDiscountsAndSpecials = orderDiscount + totalDiscountsAndSpecials;
  order.alternativePriceData.total += roundToMoneyDecimals(
    serviceChargeTotal + serviceChargeTaxTotal
  );
  order.alternativePriceData.total = roundToMoneyDecimals(
    order.alternativePriceData.total - orderDiscount
  );
  const allPayments = getValidPayments((_e = order.checks) != null ? _e : {});
  const { totalPayments, totalTip } = getTotalPaidAmountAndTotalTip(allPayments);
  order.alternativePriceData.balanceDue = roundToMoneyDecimals(
    order.alternativePriceData.total - totalPayments
  );
  order.alternativePriceData.tip = roundToMoneyDecimals(totalTip);
};
var calcOrderTotalsWithAlternativePrice = (order, withUpdatedServiceCharges) => {
  const isDualPricingEnabled = selectIsDualPricingEnabled.lastResult();
  calcOrderTotals(order, withUpdatedServiceCharges);
  if (!isDualPricingEnabled || !isDualPricingEnabled.dualPricing)
    return;
  if (order.isLockedPrice)
    copyOrderPriceDataToAlternative(order);
  else
    calcAlternativeOrderTotal(order, withUpdatedServiceCharges);
};
var copyOrderPriceDataToAlternative = (order) => {
  const {
    balanceDue,
    orderDiscounts,
    orderSpecials,
    serviceChargeTaxTotal,
    serviceChargeTotal,
    subtotal,
    tax,
    tip,
    total,
    totalDiscountsAndSpecials
  } = order;
  const alternativePriceData = {
    balanceDue,
    orderDiscounts,
    orderSpecials,
    serviceChargeTaxTotal,
    serviceChargeTotal,
    subtotal,
    tax,
    tip,
    total,
    totalDiscountsAndSpecials
  };
  order.alternativePriceData = alternativePriceData;
};

// src/helpers/register/reducerHelpers/taxes.ts
var getTaxesReduceFunction = (taxesSettings, orderType, isTakeout, basePrice, quantity, itemVolumeData, isModPrice = false) => (taxResult, taxId) => {
  var _a;
  const tax = taxesSettings[taxId];
  if (!tax)
    return taxResult;
  const taxType = tax.taxType;
  const taxData = (_a = tax.typeData) != null ? _a : {
    interval: 0,
    rate: 0,
    unit: null
  };
  if (isTakeout && (!tax.orderTypes.includes("to_go" /* TO_GO */) || !tax.orderTypes.includes("delivery" /* DELIVERY */)) || !isTakeout && !tax.orderTypes.includes("dine in" /* DINE_IN */))
    return taxResult;
  if (basePrice === 0)
    return taxResult;
  if (isModPrice && tax.taxType !== "percent" /* PERCENT */)
    return taxResult;
  switch (taxType) {
    case "percent" /* PERCENT */: {
      const taxAmount = roundToMoneyDecimals(
        basePrice * (taxData.rate / 100)
      );
      return {
        taxTotal: taxAmount + taxResult.taxTotal,
        details: addTaxAmountResultById(
          taxResult.details,
          taxId,
          taxAmount,
          taxData.rate
        )
      };
    }
    case "fixed" /* FIXED */:
      return {
        taxTotal: taxResult.taxTotal + taxData.rate * quantity,
        details: addTaxAmountResultById(
          taxResult.details,
          taxId,
          taxData.rate
        )
      };
    case "table" /* TABLE */: {
      if (!tax.tableTypeData)
        return taxResult;
      const taxApplied = roundToMoneyDecimals(
        applyTaxTable(basePrice, tax.tableTypeData)
      );
      return {
        taxTotal: taxResult.taxTotal + taxApplied,
        details: addTaxAmountResultById(taxResult.details, taxId, taxApplied)
      };
    }
    case "volume" /* VOLUMETRIC */: {
      if (!tax.typeData || !itemVolumeData)
        return taxResult;
      const taxAmount = roundToMoneyDecimals(
        getVolumetricTaxApplied(tax.typeData, itemVolumeData, quantity)
      );
      return {
        taxTotal: taxAmount + taxResult.taxTotal,
        details: addTaxAmountResultById(taxResult.details, taxId, taxAmount)
      };
    }
    default:
      return taxResult;
  }
};
var applyTaxTable = (baseItemPrice, taxData) => {
  const taxTableIterator = getTaxTableIterator(taxData);
  let amountApplied = baseItemPrice;
  let taxAmount = 0;
  while (amountApplied) {
    const taxTableItem = taxTableIterator.next();
    if (taxTableItem.done)
      break;
    const { from, tax, to } = taxTableItem.value;
    const diff11 = to - from;
    const amountToApply = Math.min(amountApplied, diff11);
    amountApplied -= amountToApply;
    taxAmount += tax;
  }
  return taxAmount;
};
function* getTaxTableIterator(taxTable) {
  const taxTableList = Object.values(taxTable);
  if (!taxTableList.length)
    return;
  const repeatedRows = taxTableList.filter((row) => row.repeat);
  let currentList = taxTableList;
  let i = 0;
  while (true) {
    if (!currentList[i]) {
      break;
    } else {
      yield currentList[i];
    }
    i++;
    if (i === currentList.length) {
      currentList = repeatedRows;
      i = 0;
    }
  }
}
var addTaxAmountResultById = (details, taxId, taxAmount, percentage = 0) => {
  var _a;
  const taxDetail = (_a = details[taxId]) != null ? _a : { totalAmount: 0, taxId };
  return __spreadProps(__spreadValues({}, details), {
    [taxId]: __spreadProps(__spreadValues({}, taxDetail), {
      totalAmount: taxDetail.totalAmount + taxAmount,
      percentage
    })
  });
};
var getBasePriceFromTaxInclusive = (taxesSettings, orderType, basePrice, taxIds, isTakeout, itemVolumeData, quantity) => {
  let fixedAmount = 0;
  let percentageTotal = 0;
  let tableTaxTotal = 0;
  let volumetricTaxTotal = 0;
  if (basePrice === 0)
    return 0;
  taxIds.forEach((taxId) => {
    var _a, _b, _c, _d;
    const tax = taxesSettings[taxId];
    if (!tax.orderTypes.includes(orderType))
      return;
    if (orderType === "dine in" /* DINE_IN */ && isTakeout)
      return;
    if (orderType === "to_go" /* TO_GO */ && !isTakeout)
      return;
    switch (tax.taxType) {
      case "fixed" /* FIXED */:
        fixedAmount += (_b = (_a = taxesSettings[taxId].typeData) == null ? void 0 : _a.rate) != null ? _b : 0;
        break;
      case "percent" /* PERCENT */:
        percentageTotal += (_d = (_c = taxesSettings[taxId].typeData) == null ? void 0 : _c.rate) != null ? _d : 0;
        break;
      case "table" /* TABLE */:
        tableTaxTotal += tax.tableTypeData ? applyTaxTable(basePrice, tax.tableTypeData) : 0;
        break;
      case "volume" /* VOLUMETRIC */:
        volumetricTaxTotal += tax.typeData && itemVolumeData ? roundToMoneyDecimals(
          getVolumetricTaxApplied(tax.typeData, itemVolumeData, 1)
        ) : 0;
        break;
    }
  });
  const priceWithoutFixedTaxes = (basePrice - fixedAmount - tableTaxTotal - volumetricTaxTotal) * quantity;
  const priceWithoutPercentageTaxes = percentageTotal ? priceWithoutFixedTaxes / (1 + percentageTotal / 100) : priceWithoutFixedTaxes;
  const inclusiveTaxPrice = Math.trunc(priceWithoutPercentageTaxes / quantity * 100) / 100;
  return inclusiveTaxPrice;
};
var getModsPriceForTaxInclusive = (taxesSettings, orderType, modsPrice, taxIds, isTakeout, quantity) => {
  if (!modsPrice)
    return 0;
  let percentageTotal = 0;
  taxIds.forEach((taxId) => {
    var _a, _b;
    const tax = taxesSettings[taxId];
    if (!tax.orderTypes.includes(orderType))
      return;
    if (orderType === "dine in" /* DINE_IN */ && isTakeout)
      return;
    if (orderType === "to_go" /* TO_GO */ && !isTakeout)
      return;
    switch (tax.taxType) {
      case "percent" /* PERCENT */:
        percentageTotal += (_b = (_a = taxesSettings[taxId].typeData) == null ? void 0 : _a.rate) != null ? _b : 0;
        break;
    }
  });
  const priceWithoutFixedTaxes = modsPrice * quantity;
  const priceWithoutPercentageTaxes = percentageTotal ? priceWithoutFixedTaxes / (1 + percentageTotal / 100) : priceWithoutFixedTaxes;
  const inclusiveTaxPrice = Math.trunc(priceWithoutPercentageTaxes / quantity * 100) / 100;
  return inclusiveTaxPrice;
};
var getEmptyTaxesObject = () => ({
  menuTypeInheritedTaxes: {},
  categoryInheritedTaxes: {},
  subcategoryInheritedTaxes: {}
});
var getInitialTaxDetailsObject = () => ({
  taxTotal: 0,
  details: {}
});
var getTaxesToApplyFromItemObj = (itemObj, menuTypeId) => {
  var _a, _b;
  return combineInheritedAndSelectedTaxes(
    (_a = itemObj == null ? void 0 : itemObj.menuTypeVersions[menuTypeId].inheritedTaxes) != null ? _a : getEmptyTaxesObject(),
    (_b = itemObj == null ? void 0 : itemObj.menuTypeVersions[menuTypeId].taxIds) != null ? _b : []
  );
};
var getTaxesToApplyFromOpenItemObj = (openItemObj) => {
  var _a;
  return (_a = openItemObj == null ? void 0 : openItemObj.taxIds) != null ? _a : [];
};
var getTaxesToApplyFromComboObj = (comboObj, menuTypeId) => {
  var _a, _b;
  return combineInheritedAndSelectedTaxes(
    (_a = comboObj == null ? void 0 : comboObj.menuTypeVersions[menuTypeId].inheritedTaxes) != null ? _a : getEmptyTaxesObject(),
    (_b = comboObj == null ? void 0 : comboObj.menuTypeVersions[menuTypeId].taxIds) != null ? _b : []
  );
};
var isTicketElementTaxInclusive = (ticketElement) => {
  var _a, _b, _c;
  return ticketElement.isOpenItem ? false : (_c = (_b = (_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[ticketElement.menuTypeId]) == null ? void 0 : _b.taxInclusive) != null ? _c : false;
};
var combineInheritedAndSelectedTaxes = (inheritedTaxes, toxIds) => {
  const inheritedTaxesResult = [
    "menuTypeInheritedTaxes",
    "categoryInheritedTaxes",
    "subcategoryInheritedTaxes"
  ].reduce((acc, key) => {
    const taxes = inheritedTaxes[key];
    const taxesToApply = Object.entries(taxes).filter(([, tax]) => tax.isActive).map(([taxId]) => Number(taxId));
    return [...acc, ...taxesToApply];
  }, []);
  return [...inheritedTaxesResult, ...toxIds];
};
var getSnapshotFromItemTaxes = (store, taxIds) => {
  return taxIds.reduce((acc, taxId) => {
    const copyOfTax = cloneDeep(store.settings.location.taxes[taxId]);
    delete copyOfTax.deletedAt;
    delete copyOfTax.createdAt;
    delete copyOfTax.updatedAt;
    return __spreadProps(__spreadValues({}, acc), { [taxId]: copyOfTax });
  }, {});
};
var checkForOrderTypeChanges = (payload, order) => {
  if (!order)
    return;
  const newOrderType = payload.type;
  const oldOrderType = order.type;
  if (!newOrderType || newOrderType === oldOrderType)
    return;
  Object.values(order.ticketElements).forEach((ticketElement) => {
    calcTotalItemWithAlternativePrice(ticketElement, {
      calcSpecial: true,
      calcDiscount: true,
      orderType: order.type,
      orderIsLockedPrice: order.isLockedPrice,
      taxExempt: order.taxExempt,
      noTaxInclusive: order.noTaxInclusive
    });
  });
  Object.values(order.combos).forEach((combo) => {
    calcTotalComboWithAlternativePrice(combo, {
      calcSpecial: true,
      calcDiscount: true,
      orderType: order.type,
      taxExempt: order.taxExempt,
      noTaxInclusive: order.noTaxInclusive,
      orderIsLockedPrice: order.isLockedPrice
    });
  });
  calcOrderTotalsWithAlternativePrice(order);
};
var distributePenniesBetweenTaxes = (pennies, taxes, taxesSource) => {
  var _a, _b, _c, _d;
  const percentageTaxes = Object.entries(taxes.details).filter(([, tax]) => taxesSource[tax.taxId].taxType === "percent" /* PERCENT */).map(([taxId]) => Number(taxId));
  if (!percentageTaxes.length)
    return {
      taxTotal: roundToMoneyDecimals(taxes.taxTotal + pennies),
      details: taxes.details
    };
  const originTaxesCount = percentageTaxes.length;
  if (originTaxesCount === 1)
    return {
      taxTotal: roundToMoneyDecimals(taxes.taxTotal + pennies),
      details: __spreadProps(__spreadValues({}, taxes.details), {
        [percentageTaxes[0]]: {
          taxId: percentageTaxes[0],
          percentage: (_b = (_a = taxesSource[percentageTaxes[0]].typeData) == null ? void 0 : _a.rate) != null ? _b : 0,
          totalAmount: roundToMoneyDecimals(
            pennies + taxes.details[percentageTaxes[0]].totalAmount
          )
        }
      })
    };
  const round = Math.floor(pennies * 100 / originTaxesCount) / 100;
  let remainingPennies = pennies * 100 - round * 100 * originTaxesCount;
  if (round > 0)
    for (let i2 = 0; i2 < percentageTaxes.length; i2++) {
      taxes.details[percentageTaxes[i2]].totalAmount += round;
    }
  let i = 0;
  while (remainingPennies > 0) {
    taxes.details[percentageTaxes[i]].totalAmount += 0.01;
    taxes.details[percentageTaxes[i]].percentage = (_d = (_c = taxesSource[percentageTaxes[i]].typeData) == null ? void 0 : _c.rate) != null ? _d : 0;
    remainingPennies -= 1;
    i = (i + 1) % originTaxesCount;
  }
  taxes.taxTotal = roundToMoneyDecimals(taxes.taxTotal + pennies);
  return taxes;
};
var mergeTaxesObjects = (itemTaxObject, modsTaxObject) => {
  const mergedTaxDetails = Object.entries(itemTaxObject.details).reduce(
    (acc, [taxId, tax]) => {
      const modTax = modsTaxObject.details[Number(taxId)];
      if (!modTax)
        return __spreadProps(__spreadValues({}, acc), { [taxId]: tax });
      return __spreadProps(__spreadValues({}, acc), {
        [taxId]: __spreadProps(__spreadValues({}, tax), {
          taxId: tax.taxId,
          totalAmount: roundToMoneyDecimals(
            tax.totalAmount + modTax.totalAmount
          )
        })
      });
    },
    {}
  );
  const mergedTaxTotal = itemTaxObject.taxTotal + modsTaxObject.taxTotal;
  return { taxTotal: mergedTaxTotal, details: mergedTaxDetails };
};
var applyTaxProportionToModifierItemsSelected = (proportion, taxInclusivePrice, modifierGroupsSelected) => {
  let taxModifierItemsPriceSummary = 0;
  Object.values(modifierGroupsSelected).forEach((modifierGroup) => {
    modifierGroup.taxInclusiveTotalPricePerItemUnit = roundToMoneyDecimals(
      modifierGroup.totalPricePerItemUnit / (1 + proportion / 100)
    );
    taxModifierItemsPriceSummary += modifierGroup.taxInclusiveTotalPricePerItemUnit;
  });
  const modGroupsPennyDifference = taxInclusivePrice - taxModifierItemsPriceSummary;
  if (Math.abs(modGroupsPennyDifference) > 0) {
    distributePenniesBetweenModifierGroups(
      modGroupsPennyDifference,
      modifierGroupsSelected
    );
  }
  Object.values(modifierGroupsSelected).filter((modifierGroup) => modifierGroup.totalPricePerItemUnit).forEach((modifierGroup) => {
    let calculated = 0;
    Object.values(modifierGroup.modifierItemsSelected).forEach(
      (modifierItem) => {
        modifierItem.taxInclusiveTotalPricePerItemUnit = roundToMoneyDecimals(
          modifierItem.totalPricePerItemUnit / (1 + proportion / 100)
        );
        calculated += modifierItem.taxInclusiveTotalPricePerItemUnit;
      }
    );
    const modItemsPennyDifference = modifierGroup.taxInclusiveTotalPricePerItemUnit - calculated;
    if (Math.abs(modItemsPennyDifference) > 0) {
      distributePenniesBetweenModifierItems(
        modItemsPennyDifference,
        modifierGroup.modifierItemsSelected
      );
    }
    Object.values(modifierGroup.modifierItemsSelected).forEach(
      (modifierItem) => {
        Object.values(modifierItem.modifierItemInstances).forEach(
          (modifierItemInstance) => {
            modifierItemInstance.taxInclusivePrice = roundToMoneyDecimals(
              modifierItemInstance.price / (1 + proportion / 100)
            );
          }
        );
        let instanceCalculated = 0;
        Object.values(modifierItem.modifierItemInstances).forEach(
          (modifierItemInstance) => {
            instanceCalculated += modifierItemInstance.taxInclusivePrice;
          }
        );
        const modItemInstancesPennyDifference = modifierItem.taxInclusiveTotalPricePerItemUnit - instanceCalculated;
        if (Math.abs(modItemInstancesPennyDifference) > 0) {
          distributePenniesBetweenInstances(
            modItemsPennyDifference,
            modifierItem.modifierItemInstances
          );
        }
        Object.values(modifierItem.modifierItemInstances).forEach(
          (modifierItemInstance) => {
            Object.values(
              modifierItemInstance.nestedModifierGroupsSelected
            ).forEach((nestedModGroup) => {
              nestedModGroup.taxInclusiveTotalPricePerItemUnit = roundToMoneyDecimals(
                nestedModGroup.totalPricePerItemUnit / (1 + proportion / 100)
              );
              let nestedCalculated = 0;
              Object.values(nestedModGroup.modifierItemsSelected).forEach(
                (nestedModItem) => {
                  nestedModItem.taxInclusiveTotalPricePerItemUnit = roundToMoneyDecimals(
                    nestedModItem.totalPricePerItemUnit / (1 + proportion / 100)
                  );
                  nestedCalculated += nestedModItem.taxInclusiveTotalPricePerItemUnit;
                }
              );
              const nestedModItemsPennyDifference = nestedModGroup.taxInclusiveTotalPricePerItemUnit - nestedCalculated;
              if (Math.abs(nestedModItemsPennyDifference) > 0) {
                distributePenniesBetweenModifierItems(
                  nestedModItemsPennyDifference,
                  nestedModGroup.modifierItemsSelected
                );
              }
              Object.values(nestedModGroup.modifierItemsSelected).forEach(
                (nestedModItem) => {
                  Object.values(nestedModItem.modifierItemInstances).forEach(
                    (nestedModItemInstance) => {
                      nestedModItemInstance.taxInclusivePrice = roundToMoneyDecimals(
                        nestedModItemInstance.price / (1 + proportion / 100)
                      );
                    }
                  );
                  let nestedInstanceCalculated = 0;
                  Object.values(nestedModItem.modifierItemInstances).forEach(
                    (nestedModItemInstance) => {
                      nestedInstanceCalculated += nestedModItemInstance.taxInclusivePrice;
                    }
                  );
                  const nestedModItemInstancesPennyDifference = nestedModItem.taxInclusiveTotalPricePerItemUnit - nestedInstanceCalculated;
                  if (Math.abs(nestedModItemInstancesPennyDifference) > 0) {
                    distributePenniesBetweenInstances(
                      nestedModItemInstancesPennyDifference,
                      nestedModItem.modifierItemInstances
                    );
                  }
                }
              );
            });
          }
        );
      }
    );
  });
};
var distributePenniesBetweenModifierGroups = (pennies, modifierGroupsSelected) => {
  const filteredModifierGroups = Object.values(modifierGroupsSelected).filter(
    (modifierGroup) => modifierGroup.totalPricePerItemUnit
  );
  const modifierGroupsCount = filteredModifierGroups.length;
  const modifierGroupsKeys = filteredModifierGroups.map(
    (modifierGroup) => modifierGroup.modifierGroupId
  );
  switch (modifierGroupsCount) {
    case 0:
      break;
    case 1:
      modifierGroupsSelected[modifierGroupsKeys[0]].taxInclusiveTotalPricePerItemUnit += pennies;
      break;
    default: {
      const round = Math.floor(pennies * 100 / modifierGroupsCount) / 100;
      let remainingPennies = pennies * 100 - round * 100 * modifierGroupsCount;
      let i = 0;
      while (remainingPennies > 0) {
        modifierGroupsSelected[modifierGroupsKeys[i]].taxInclusiveTotalPricePerItemUnit += 0.01;
        remainingPennies -= 1;
        i = (i + 1) % modifierGroupsCount;
      }
    }
  }
};
var distributePenniesBetweenModifierItems = (pennies, modifierItemsSelected) => {
  const filteredModifierItems = Object.values(modifierItemsSelected).filter(
    (modifierItem) => modifierItem.totalPricePerItemUnit
  );
  const modifierItemsCount = filteredModifierItems.length;
  const modifierItemsKeys = filteredModifierItems.map(
    (modifierItem) => modifierItem.modifierItemId
  );
  switch (modifierItemsCount) {
    case 0:
      break;
    case 1:
      modifierItemsSelected[modifierItemsKeys[0]].taxInclusiveTotalPricePerItemUnit += pennies;
      break;
    default: {
      const round = Math.floor(pennies * 100 / modifierItemsCount) / 100;
      let remainingPennies = pennies * 100 - round * 100 * modifierItemsCount;
      let i = 0;
      while (remainingPennies > 0) {
        modifierItemsSelected[modifierItemsKeys[i]].taxInclusiveTotalPricePerItemUnit += 0.01;
        remainingPennies -= 1;
        i = (i + 1) % modifierItemsCount;
      }
    }
  }
};
var distributePenniesBetweenInstances = (pennies, modifierItemInstances) => {
  const filteredModifierItemInstances = Object.values(
    modifierItemInstances
  ).filter((modifierItemInstance) => modifierItemInstance.price);
  const modifierItemInstancesCount = filteredModifierItemInstances.length;
  const modifierItemInstancesKeys = filteredModifierItemInstances.map(
    (modifierItemInstance) => modifierItemInstance.modifierItemInstanceId
  );
  switch (modifierItemInstancesCount) {
    case 0:
      break;
    case 1:
      modifierItemInstances[modifierItemInstancesKeys[0]].taxInclusivePrice += pennies;
      break;
    default: {
      const round = Math.floor(pennies * 100 / modifierItemInstancesCount) / 100;
      let remainingPennies = pennies * 100 - round * 100 * modifierItemInstancesCount;
      let i = 0;
      while (remainingPennies > 0) {
        modifierItemInstances[modifierItemInstancesKeys[i]].taxInclusivePrice += 0.01;
        remainingPennies -= 1;
        i = (i + 1) % modifierItemInstancesCount;
      }
    }
  }
};
var updateTicketElementsWithTaxExempt = (_order) => {
  if (!_order)
    return;
  const taxExempt = _order.taxExempt;
  const noTaxInclusive = _order.noTaxInclusive;
  Object.values(_order.ticketElements).forEach((ticketElement) => {
    const isTaxInclusive = isTicketElementTaxInclusive(ticketElement);
    if (isTaxInclusive && (taxExempt || noTaxInclusive || ticketElement.taxExempt)) {
      const itemObj = ticketElement.itemObj;
      ticketElement.baseItemPrice = itemObj.menuTypeVersions[ticketElement.isOpenItem ? 0 : ticketElement.menuTypeId].itemPrice;
      ticketElement.taxInclusiveSelectedModifiersPricePerItemUnit = ticketElement.selectedModifiersPricePerItemUnit;
    }
    calcTotalItemWithAlternativePrice(ticketElement, {
      orderType: _order.type,
      taxExempt,
      orderIsLockedPrice: _order.isLockedPrice,
      noTaxInclusive
    });
    updateCheckElementForTicketElement(_order, getEntityId(ticketElement));
  });
  Object.values(_order.combos).forEach((combo) => {
    const isTaxInclusive = isComboElementTaxInclusive(combo);
    if (isTaxInclusive && (taxExempt || noTaxInclusive)) {
      const comboObj = combo.comboObj;
      combo.comboBasePrice = comboObj.menuTypeVersions[combo.menuTypeId].comboBasePrice;
      combo.taxInclusiveAdditionalPrice = combo.totalAdditionalPriceAmount;
    }
    calcTotalComboWithAlternativePrice(combo, {
      orderType: _order.type,
      taxExempt,
      noTaxInclusive,
      orderIsLockedPrice: _order.isLockedPrice
    });
    updateCheckElementForComboElement(_order, getEntityId(combo));
  });
  calcOrderTotalsWithAlternativePrice(_order);
};

// src/helpers/register/reducerHelpers/openItems.ts
var TICKET_OPEN_ITEM_TYPE_ID = 0;
var isOpenItemFn = (ticketElement) => ticketElement == null ? void 0 : ticketElement.isOpenItem;
var isNotOpenItemFn = (ticketElement) => !isOpenItemFn(ticketElement);
var addNewOpenItem = (ticket, _a, dualPricingSettings) => {
  var _b = _a, {
    globalState
  } = _b, openItemData = __objRest(_b, [
    "globalState"
  ]);
  const currentOrder = selectCurrentOrderObj(globalState);
  const ticketElement = createNewOpenItem(
    openItemData,
    globalState,
    currentOrder.type,
    dualPricingSettings
  );
  ticket[openItemData.tabletGeneratedId] = ticketElement;
  updateWithGlobalQuantities(ticketElement, globalState);
  const coursingMode = selectCoursingModeActive(globalState);
  ticketElement.courseId = coursingMode === "on_the_fly" /* ON_THE_FLY */ ? null : assignCourseId(ticketElement, globalState);
  ticketElement.onTheFlyCourseNumber = coursingMode === "predefined" /* PREDEFINED */ ? null : currentOrder.type === "to_go" /* TO_GO */ ? null : selectCurrentCourseNumber(globalState);
  ticketElement.isTakeout = currentOrder.type === "to_go" /* TO_GO */;
  Object.assign(
    ticketElement,
    initializeModifierGroupsSelected_default(
      ticketElement.itemObj,
      selectSpecialModTagsMetaData(globalState)
    )
  );
  calcTotalItemWithAlternativePrice(ticketElement, {
    orderType: currentOrder.type,
    orderIsLockedPrice: currentOrder.isLockedPrice,
    taxExempt: currentOrder.taxExempt,
    noTaxInclusive: currentOrder.noTaxInclusive
  });
  ticketElement.isComplete = !!ticketElement.quantity && !!ticketElement.itemObj;
};
var isTicketItemFn = (ticketElement) => !ticketElement.isOpenItem;
var getOpenItemCopy = (posName, openItemTypeId, globalState) => {
  const openItemBase = globalState.settings.location.register.openItemTypes[openItemTypeId];
  const newTicketItem = __spreadProps(__spreadValues({}, openItemBase), {
    menuTypeVersions: {
      [0]: __spreadProps(__spreadValues({}, MENU_TYPE_VERSION_INITIAL_STATE), {
        showAllMods: true,
        posName,
        checkName: posName,
        kdsName: posName,
        modifierGroups: {
          [ALL_MODS_ID]: __spreadProps(__spreadValues({}, ALL_MODIFIERS_MODIFIER_GROUP()), {
            id: ALL_MODS_ID,
            modifierGroupId: ALL_MODS_ID,
            modifierItems: {},
            requiredModifierItems: 0,
            sortPriority: 0
          })
        }
      })
    },
    taxesSource: getSnapshotFromItemTaxes(globalState, openItemBase.taxIds)
  });
  return newTicketItem;
};
var createNewOpenItem = (payload, globalState, orderType, dualPricingSettings) => {
  var _b, _c, _d, _e, _f;
  const loggedInOrganizationUserId = globalState.loggedInUser.organizationUserId;
  const _a = payload, { posName, openItemTypeId, baseItemPrice } = _a, rest = __objRest(_a, ["posName", "openItemTypeId", "baseItemPrice"]);
  const menuTypeInMenu = selectMenuTypes(globalState)[payload.menuTypeId];
  const menuTypeInfo = menuTypeInMenu ? {
    id: menuTypeInMenu.id,
    name: menuTypeInMenu.name,
    posName: menuTypeInMenu.posName,
    disableCoursing: menuTypeInMenu.coursingType !== "coursing" /* COURSING */
  } : null;
  const isCurrentMenuTypeCourseDisabled = menuTypeInMenu ? menuTypeInMenu.coursingType !== "coursing" /* COURSING */ : false;
  const ticketOpenItem = __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, OPEN_ITEM_INITIAL_STATE), {
    itemObj: getOpenItemCopy(posName, openItemTypeId, globalState),
    timeAdded: getNowUTCDate(),
    timeTriggered: NULLISH_DATE,
    timeSentToKitchen: NULLISH_DATE,
    createdById: loggedInOrganizationUserId,
    lastUpdatedById: loggedInOrganizationUserId,
    versionId: 1,
    baseItemPrice,
    totalDiscountedPrice: payload.baseItemPrice,
    totalPrice: payload.baseItemPrice,
    totalPricePerItemUnit: payload.baseItemPrice,
    openItemTypeId,
    ticketElementToCheckElementsId: rest.tabletGeneratedId,
    menuTypeInfo,
    isCurrentMenuTypeCourseDisabled
  }), rest), {
    orderId: null
  });
  const taxesSource = (_c = (_b = ticketOpenItem.itemObj) == null ? void 0 : _b.taxesSource) != null ? _c : {};
  const taxIds = (_d = ticketOpenItem.itemObj.taxIds) != null ? _d : [];
  const taxReduceFunction = getTaxesReduceFunction(
    taxesSource,
    orderType,
    orderType === "to_go" /* TO_GO */,
    baseItemPrice,
    (_e = globalState.register.registerNavigation.quantity) != null ? _e : 1,
    null
  );
  const { taxTotal, details } = taxIds.reduce(
    taxReduceFunction,
    getInitialTaxDetailsObject()
  );
  ticketOpenItem.totalTax = taxTotal;
  ticketOpenItem.taxDetails = details;
  let alternativePriceData = null;
  if (dualPricingSettings.dualPricing) {
    const alternativeBaseItemPrice = getAlternativeListBasePrice(
      payload.baseItemPrice,
      dualPricingSettings
    );
    const alternativeTaxReduceFunction = getTaxesReduceFunction(
      taxesSource,
      orderType,
      orderType === "to_go" /* TO_GO */,
      alternativeBaseItemPrice,
      (_f = globalState.register.registerNavigation.quantity) != null ? _f : 1,
      null
    );
    const taxResult = taxIds.reduce(
      alternativeTaxReduceFunction,
      getInitialTaxDetailsObject()
    );
    alternativePriceData = {
      baseItemPrice: alternativeBaseItemPrice,
      discounts: {},
      selectedModifiersPricePerItemUnit: 0,
      taxInclusiveSelectedModifiersPricePerItemUnit: 0,
      totalPriceWithDiscountsSpecialsNotTaxes: alternativeBaseItemPrice,
      specials: null,
      taxDetails: taxResult.details,
      totalDiscountAmount: 0,
      totalPricePerItemUnit: alternativeBaseItemPrice,
      totalTax: taxResult.taxTotal
    };
  }
  ticketOpenItem.alternativePriceData = alternativePriceData;
  delete ticketOpenItem.id;
  return ticketOpenItem;
};
var OPEN_ITEM_INITIAL_STATE = {
  isOpenItem: true,
  openItemTypeId: 0,
  orderId: 0,
  tabletGeneratedId: "",
  versionId: 0,
  quantity: 0,
  isComplete: false,
  isModifiersSelectionComplete: true,
  seating: {},
  isVoided: false,
  isShared: null,
  timeAdded: "",
  createdById: null,
  lastUpdatedById: null,
  isPriceOverride: false,
  instanceIds: [],
  overridePricePerItemUnit: 0,
  discounts: {},
  totalDiscountAmount: 0,
  totalPriceWithDiscountsSpecialsNotTaxes: 0,
  totalPricePerItemUnit: 0,
  totalTax: 0,
  taxDetails: {},
  isModifiedAfterSent: false,
  isInClosedCheck: false,
  modifierGroupsSelected: {},
  courseId: null,
  isTakeout: false,
  onTheFlyCourseNumber: null,
  timeTriggered: "",
  timeSentToKitchen: "",
  instructions: "",
  isTriggeringManuallyDisabled: false,
  baseItemPrice: 0,
  isOnHold: false,
  hasBeenHeld: null,
  selectedModifiersPricePerItemUnit: 0,
  taxInclusiveSelectedModifiersPricePerItemUnit: 0,
  configWhenSent: null,
  prepStations: [],
  prepStationOverrideId: null,
  prepStationOverride: null,
  printErrorMessage: {},
  ticketElementToCheckElementsId: null,
  itemObj: null,
  suggestedItemId: null,
  customizerType: "none" /* NONE */,
  itemId: null,
  comboElementId: null,
  ingredientsSelected: null,
  locationMenuTypeItemId: null,
  locationMenuTypeItemVersionId: null,
  menuTypeId: null,
  specials: null,
  sentToPrepStationHistory: [],
  isCurrentMenuTypeCourseDisabled: false,
  noPrinterLocation: false,
  menuTypeInfo: null,
  voidedReasonId: null,
  alternativePriceData: null,
  isTaxInclusive: false,
  taxExempt: false
};

// src/helpers/register/openMod.ts
var hasOpenModAdded = (ticketElement) => {
  if (!ticketElement)
    return false;
  if (!ticketElement.itemObj)
    return false;
  const menuTypeVersion = ticketElement.itemObj.menuTypeVersions[isOpenItemFn(ticketElement) ? 0 : ticketElement.menuTypeId];
  if (!menuTypeVersion.modifierGroups[0])
    return false;
  return !!menuTypeVersion.modifierGroups[0].modifierItems[0];
};
var selectIsPaymentModeActive = (state) => state.register.paymentNavigation.isPaymentModeActive;
var selectIsPayThroughTablet = (state) => state.register.paymentNavigation.payThroughTablet;
var isCheckEditorActive = (state) => state.register.paymentNavigation.screen === "CHECK_EDITOR" /* CHECK_EDITOR */;
var isPaymentScreenActive = (state) => state.register.paymentNavigation.screen === "PAYMENT" /* PAYMENT */;
var selectIsItemsToggled = (state) => state.register.paymentNavigation.isItemsToggled;
var selectPaymentOption = (state) => state.register.paymentNavigation.option;
var selectPaymentMethod = (state) => state.register.paymentNavigation.method;
var selectPaymentNavigationCheckId = (state) => state.register.paymentNavigation.checkId;
var selectPaymentNavigationRefundAction = (state) => state.register.paymentNavigation.refundAction;
var selectPaymentMethodList = createSelector(
  selectCustomTenders,
  selectPaymentOption,
  (customTenders, paymentOption) => {
    var _a, _b;
    const paymentOptionMethods = (_b = (_a = PAYMENT_OPTIONS.find((option) => option.optionId === paymentOption)) == null ? void 0 : _a.paymentMethods) != null ? _b : [];
    if (paymentOption === "PAY" /* PAY */) {
      const customMethods = [...Object.values(customTenders).flat()];
      customMethods.sort((a, b) => a.sortPriority - b.sortPriority);
      return [...paymentOptionMethods, ...customMethods];
    }
    return paymentOptionMethods;
  }
);

// src/state/selectors/register/registerSelectors.ts
var createShallowEqualSelector = createSelectorCreator(
  defaultMemoize,
  shallowEqual
);
var selectOrderSearchResults = (state) => state.register.orderSearchResults;
var selectOrderSearchResultsOrders = (state) => state.register.orderSearchResults.orders;
var selectSelectedOrderSearchResult = (state) => state.register.orderSearchResults.selectedMainOrder;
var selectBarCodeOrderSearchResult = (state) => state.register.orderSearchResults.barCodeOrder;
var selectDrawers = (state) => state.register.drawers;
var selectOrders = (state) => state.register.orders;
var selectCurrentMenuTypeRegister = createSelector(
  selectCurrentMenuTypeId,
  selectCurrentMenuTypes,
  (menuTypeId, menuTypes) => {
    if (!menuTypeId)
      return null;
    return menuTypes[menuTypeId];
  }
);
var selectIsCurrentMenuTypeCoursingEnabled = createSelector(
  selectCurrentMenuTypeRegister,
  (menuType) => (menuType == null ? void 0 : menuType.coursingType) === "coursing" /* COURSING */
);
var selectVAOData = createSelector(
  selectVAOSelectedOrders,
  selectVAOIsMultiselect,
  selectIsVAOFocused,
  selectVAOFilter,
  selectVAOSelectedCheckId,
  (selectedOrders, isMultiselect, isVAOFocused, filter2, selectedCheckId) => ({
    selectedOrders,
    isMultiselect,
    isVAOFocused,
    filter: filter2,
    selectedCheckId
  })
);
var selectCurrentHotButtonModifierItemPosName = createSelector(
  selectModifierItemHotButtonId,
  selectModifierItems,
  (modifierItemId, menuModifierItems) => {
    var _a;
    return ((_a = menuModifierItems[Number(modifierItemId)]) == null ? void 0 : _a.posName) || "";
  }
);
var selectCurrentOrderId = createSelector(
  selectVAOData,
  selectCurrentMenuTypeId,
  (state) => state.register.registerNavigation.orderId,
  (VAOData, currentMenuTypeId, orderId) => orderId !== null ? orderId : !currentMenuTypeId ? VAOData.selectedOrders[0] || null : null
);
var selectOmitCheckAndPaymentChecksToCloseOrder = (state) => state.register.registerNavigation.omitChecksAndPaymentsCheckToCloseOrder;
var selectCurrentOrderObj = createSelector(
  selectCurrentOrderId,
  selectOrders,
  selectSelectedOrderSearchResult,
  (orderId, orders, remoteOrder) => {
    if (orderId === null)
      return produce(ORDER_INITIAL_STATE, (draft) => {
        calcOrderTotals(draft, true);
      });
    if (orders[orderId])
      return orders[orderId];
    if (remoteOrder && String(remoteOrder.id) === String(orderId))
      return remoteOrder;
    return produce(ORDER_INITIAL_STATE, (draft) => {
      calcOrderTotals(draft, true);
    });
  }
);
var selectCurrentCombos = createSelector(
  selectCurrentOrderObj,
  (order) => {
    var _a;
    return (_a = order.combos) != null ? _a : {};
  }
);
var selectCurrentComboElement = createSelector(
  selectCurrentCombos,
  selectCurrentComboElementId,
  (combos, comboElementId) => comboElementId ? combos[comboElementId] : null
);
var selectCurrentOrderType = createSelector(
  selectCurrentOrderObj,
  (order) => order.type
);
var selectCurrentOrderDiscounts = createSelector(
  selectCurrentOrderObj,
  (order) => {
    var _a;
    return (_a = order.orderDiscounts) != null ? _a : {};
  }
);
var selectCurrentOrderTotalDiscountAmount = createSelector(
  selectCurrentOrderDiscounts,
  getTotalDiscountAmount
);
var selectCurrentOrderSpecials = createSelector(
  selectCurrentOrderObj,
  (order) => {
    var _a;
    return (_a = order.orderSpecials) != null ? _a : {};
  }
);
var selectCurrentOrderTotalServiceChargeAmount = createSelector(
  selectCurrentOrderObj,
  (order) => {
    var _a;
    return (_a = order.serviceChargeTotal) != null ? _a : 0;
  }
);
var selectCurrentOrderServiceCharges = createSelector(
  selectCurrentOrderObj,
  (order) => {
    var _a;
    return (_a = order.serviceChargeDetails) != null ? _a : {};
  }
);
var selectCurrentOrderServiceChargeSelection = createSelector(
  selectCurrentOrderObj,
  (order) => {
    var _a;
    return (_a = order.serviceChargeSelection) != null ? _a : null;
  }
);
var selectCurrentOrderTableId = createSelector(
  selectCurrentOrderObj,
  (order) => order.tableId
);
var selectCurrentOrderSplitMode = createSelector(
  selectCurrentOrderObj,
  (order) => order.splitMode
);
var selectCurrentOrderNumberOfChecks = createSelector(
  selectCurrentOrderObj,
  (order) => Object.keys(order.checks).length - 1
);
var selectCurrentOrderStatus = createSelector(
  selectCurrentOrderObj,
  (order) => order.status
);
var selectCurrentOrderNumber = createSelector(
  selectCurrentOrderObj,
  (order) => order.orderNumber
);
var selectCurrentOrderCreatedDate = createSelector(
  selectCurrentOrderObj,
  (order) => order.createdAt
);
var selectCurrentOrderOwnerId = createSelector(
  selectCurrentOrderObj,
  (order) => order.ownerId
);
var selectCurrentOrderIsNotBeenEdited = createSelector(
  selectCurrentOrderObj,
  (order) => order.licenseEditingId === null
);
var selectCurrentTicket = createSelector(
  selectCurrentOrderObj,
  (order) => order.ticketElements
);
var selectCurrentOrderSubtotal = createSelector(
  selectCurrentOrderObj,
  (order) => order.subtotal
);
var selectCurrentOrderBalanceDue = createSelector(
  selectCurrentOrderObj,
  (order) => order.balanceDue
);
var selectOrderSeatOnePosition = createSelector(
  selectCurrentOrderObj,
  (order) => order.seatOnePosition
);
var selectCurrentLicenseEditing = createSelector(
  selectCurrentOrderObj,
  (order) => order.licenseEditingId
);
var selectCurrentOrderPayments = createSelector(
  selectCurrentOrderObj,
  (order) => Object.values(order.checks).map((check) => Object.values(check.payments)).flat()
);
var selectIsOrderTypeToGo = createSelector(
  selectCurrentOrderObj,
  (order) => (order == null ? void 0 : order.type) === "to_go" /* TO_GO */
);
var selectCurrentCombosWithItems = createSelector(
  selectCurrentTicket,
  selectCurrentCombos,
  zipCombosWithItems
);
var selectCurrentTicketSize = createSelector(
  selectCurrentTicket,
  getTicketSize
);
var selectCurrentTicketBySeat = createShallowEqualSelector(
  selectCurrentTicket,
  selectCurrentSeatSelected,
  filterTicketElementsBySeat
);
var selectCurrentCombosBySeat = createShallowEqualSelector(
  selectCurrentCombosWithItems,
  selectCurrentSeatSelected,
  filterCombosBySeatSelected
);
var selectCurrentTicketElementsNotTriggeredQty = createSelector(
  selectCurrentTicketBySeat,
  (ticketElements) => ticketElements.filter(
    (ticketElement) => notTicketElementTriggered(ticketElement)
  ).length
);
var selectCurrentComboItemsReadyToSend = createSelector(
  selectCurrentCombosBySeat,
  (comboElements) => comboElements.filter((comboElement) => comboElement.isComplete).map(spreadComboIntoItem).flat().filter(
    (ticketElement) => !ticketElement.timeTriggered || notTicketElementTriggered(ticketElement)
  )
);
var selectCurrentTicketIsEmpty = createSelector(
  selectCurrentTicketBySeat,
  (ticketElements) => ticketElements.length === 0
);
var selectCurrentSeatTotalAmount = createSelector(
  selectCurrentTicketBySeat,
  calcTotalAmountPerSeat
);
var selectCurrentComboItemsNotTriggeredQty = createSelector(
  selectCurrentCombosBySeat,
  (comboElements) => comboElements.map(spreadComboIntoItem).flat().filter(
    (ticketElement) => !ticketElement.timeTriggered || notTicketElementTriggered(ticketElement)
  ).length
);
var selectCurrentOrder = createSelector(
  selectCurrentOrderId,
  selectOrders,
  (orderId, orders) => {
    if (!orderId)
      return null;
    return orders[orderId];
  }
);
var selectIsCurrentOrderSeatingMode = createSelector(
  selectIsSeatingModeEnabled,
  selectCurrentOrder,
  selectRegisterNavigationTableId,
  (isSeatingModeEnabled, order, currentTableId) => {
    if (!order)
      return currentTableId ? isSeatingModeEnabled : false;
    return isSeatingModeEnabled && order.tableId !== null && order.numberOfSeatsOccupied !== null;
  }
);
var selectCurrentTicketElementsReadyToSend = createSelector(
  selectCurrentTicketBySeat,
  (ticketElements) => ticketElements.filter(
    (ticketElement) => notTicketElementTriggered(ticketElement) && isTicketElementComplete(ticketElement)
  )
);
var selectCurrentTicketElement = createSelector(
  selectCurrentTicket,
  selectCurrentTicketElementId,
  (ticket, ticketElementId) => {
    var _a;
    if (!ticketElementId)
      return null;
    return (_a = ticket[ticketElementId]) != null ? _a : null;
  }
);
var selectCurrentTicketElementIsNotNull = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => ticketElement !== null
);
var selectCurrentTicketElementMenuTypeId = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => ticketElement == null ? void 0 : ticketElement.menuTypeId
);
var selectCurrentTicketElementExitDetailsOnReqModsCompletion = createSelector(selectCurrentTicketElement, (ticketElement) => {
  var _a, _b;
  if (!ticketElement)
    return false;
  return (_b = Object.values(((_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions) || {})[0]) == null ? void 0 : _b.exitItemDetailsOnRequiredModCompletion;
});
var selectIsCurrentTicketElementSubcategoryCustomizer = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => {
    if (!ticketElement || ticketElement.isOpenItem)
      return false;
    return ticketElement.customizerType === "subcategory" /* SUBCATEGORY */;
  }
);
var selectIsCurrentTicketElementItemCustomizer = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => {
    if (!ticketElement || ticketElement.isOpenItem)
      return false;
    return ticketElement.customizerType === "item" /* ITEM */;
  }
);
var selectCurrentActiveSpecials = createSelector(
  selectCurrentMenuTypeId,
  (state) => selectSpecials(state),
  (state) => selectCurrentTimeZone(state),
  selectSpecialsCounterValue,
  getSpecialsFromMenuType
);
var selectCurrentActiveBOGOSpecials = createSelector(
  selectCurrentActiveSpecials,
  getBogoSpecialsFromActiveSpecialsObject
);
var selectCurrentOrderSpecialsSource = createSelector(
  selectCurrentOrderObj,
  (order) => {
    var _a;
    return (_a = order.bogoSpecialsObj) != null ? _a : {};
  }
);
var selectCurrentBOGOSpecialsBuyItemIds = createSelector(
  selectCurrentOrderSpecialsSource,
  getCurrentBOGOSpecialsBuyItemIds
);
var selectCurrentBOGOSpecialsGetItemIds = createSelector(
  selectCurrentOrderSpecialsSource,
  getCurrentBOGOSpecialsGetItemIds
);
var selectCurrentOrderBOGOSpecials = createSelector(
  selectCurrentOrderObj,
  (order) => {
    var _a;
    return (_a = order.bogoSpecialsSelected) != null ? _a : [];
  }
);
var selectCurrentSpecialsTriggerElementInstances = createSelector(
  selectCurrentOrderBOGOSpecials,
  getCurrentSpecialsTriggerElementInstances
);
var selectCurrentSpecialsRewardedElementInstances = createSelector(
  selectCurrentOrderBOGOSpecials,
  getCurrentSpecialsRewardedElementInstances
);
var selectCurrentActiveItemSpecials = createSelector(
  selectCurrentActiveSpecials,
  getItemSpecialsFromActiveSpecialsObject
);
var selectCurrentSpecialsTriggerElementIds = createSelector(
  selectCurrentOrderBOGOSpecials,
  getCurrentSpecialsTriggerElementIds
);
var selectCurrentSpecialsRewardedElementIds = createSelector(
  selectCurrentOrderBOGOSpecials,
  getCurrentSpecialsRewardedElementIds
);
var selectTicketElementById = createSelector(
  selectCurrentOrderObj,
  (_, ticketElementId) => ticketElementId,
  (order, ticketElementId) => {
    const ticketElement = order == null ? void 0 : order.ticketElements[ticketElementId];
    return ticketElement;
  }
);
var selectIsSimpleModeEnabled = createSelector(
  selectCurrentMenuTypeId,
  selectCurrentMenuTypes,
  (currentMenuTypeId, menuTypes) => {
    var _a, _b;
    if (!currentMenuTypeId)
      return false;
    return (_b = (_a = menuTypes[currentMenuTypeId]) == null ? void 0 : _a.enableSimpleMode) != null ? _b : false;
  }
);
var selectComboDisplayName = createSelector(
  selectCurrentMenuTypeId,
  selectCurrentMenuTypes,
  (currentMenuTypeId, menuTypes) => {
    var _a;
    if (!currentMenuTypeId)
      return "Combo";
    return ((_a = menuTypes[currentMenuTypeId]) == null ? void 0 : _a.comboDisplayName) || "Combo";
  }
);
var selectCurrentCourseNumber = createSelector(
  selectCoursingModeActive,
  selectCurrentCourseNumberSelected,
  (coursingMode, courseNumberSelected) => {
    if (coursingMode === "predefined" /* PREDEFINED */)
      return null;
    if (courseNumberSelected)
      return courseNumberSelected;
    return null;
  }
);
var selectSpecialModTagsMetaData = createSelector(
  modifierTagsSelector,
  specialModifierTagsFactory
);
var selectIsNOModifierTagSelected = createSelector(
  selectLocationModifierTags,
  selectCurrentModifierTagId,
  (tags, tagId) => {
    if (!tagId)
      return false;
    return tags[tagId].isSpecial && tags[tagId].name === "NO";
  }
);
var selectTagList = createSelector(
  selectCurrentMenuTypeId,
  selectLocationModifierTags,
  (menuTypeId, tags) => {
    return Object.values(tags).filter(
      (tag) => menuTypeId === null ? true : tag.menuTypeIds === null ? true : tag.menuTypeIds.includes(menuTypeId)
    ).filter((tag) => tag.active).sort((a, b) => a.sortPriority - b.sortPriority);
  }
);
var selectCurrentOrderClosedCheckIds = createSelector(
  selectCurrentOrder,
  (order) => {
    if (!order)
      return [];
    return Object.values(order.checks).filter((check) => !checkStatusAllowsEditing(check.status)).map(getCheckId);
  }
);
var selectUnassignedCheckHasValidPayments = createSelector(
  selectCurrentOrder,
  (order) => {
    if (!order)
      return false;
    const unassignedCheck = order.checks[order.defaultCheckId];
    return Object.values(unassignedCheck.payments).some(
      (payment) => isPaymentValid(payment.status)
    );
  }
);
var selectCurrentOrderTicketElementToCheckElements = createSelector(
  selectCurrentOrder,
  (order) => {
    if (!order)
      return {};
    return order.ticketElementToCheckElements;
  }
);
var selectOrderTicketElementSeats = createSelector(
  selectCurrentTicket,
  (ticketElements) => Object.values(ticketElements).map((ticketElement) => ticketElement.seating).reduce((acc, seating) => __spreadValues(__spreadValues({}, acc), seating), {})
);
var selectOrderComboElementSeats = createSelector(
  selectCurrentCombos,
  (combos) => Object.values(combos).map((comboElement) => comboElement.seating).reduce((acc, seating) => __spreadValues(__spreadValues({}, acc), seating), {})
);
var selectOrderNumberOfSeatsServed = createSelector(
  selectOrderTicketElementSeats,
  selectOrderComboElementSeats,
  (ticketElementSeats, comboElementSeats) => {
    const seats = __spreadValues(__spreadValues({}, ticketElementSeats), comboElementSeats);
    return Object.values(seats).filter((seat) => !!seat).length;
  }
);
var selectCurrentTicketElementItemObject = createSelector(
  selectCurrentTicketElement,
  (currentTicketElement) => currentTicketElement == null ? void 0 : currentTicketElement.itemObj
);
var selectCurrentTicketElementIsShared = createSelector(
  selectCurrentTicketElement,
  (currentTicketElement) => currentTicketElement == null ? void 0 : currentTicketElement.isShared
);
var selectCurrentTicketElementQuantity = createSelector(
  selectCurrentTicketElement,
  (currentTicketElement) => currentTicketElement == null ? void 0 : currentTicketElement.quantity
);
var selectCurrentTicketElementCustomizerShape = createSelector(
  selectCurrentTicketElementItemObject,
  (currentTicketElementItemObj) => {
    var _a;
    return ((_a = Object.values((currentTicketElementItemObj == null ? void 0 : currentTicketElementItemObj.menuTypeVersions) || {})[0]) == null ? void 0 : _a.customizerShape) || "round" /* ROUND */;
  }
);
var selectCurrentItemShowIngredients = createSelector(
  selectCurrentTicketElementItemObject,
  (itemObject) => {
    var _a;
    return Object.values(
      ((_a = Object.values((itemObject == null ? void 0 : itemObject.menuTypeVersions) || {})[0]) == null ? void 0 : _a.ingredients) || {}
    ).filter((ingredient) => ingredient.active).length > 0;
  }
);
var selectCurrentItemAllModIds = createSelector(
  selectCurrentTicketElementItemObject,
  (itemObject) => {
    var _a;
    return ((_a = Object.values((itemObject == null ? void 0 : itemObject.menuTypeVersions) || {})[0]) == null ? void 0 : _a.allModIds) || [];
  }
);
var selectCurrentItemShowAllModsBehavior = createSelector(
  selectCurrentTicketElementItemObject,
  (itemObject) => {
    var _a;
    return (_a = Object.values((itemObject == null ? void 0 : itemObject.menuTypeVersions) || {})[0]) == null ? void 0 : _a.allModsBehavior;
  }
);
var selectCurrentItemShowAllModsEnabled = createSelector(
  selectCurrentTicketElementItemObject,
  (itemObject) => {
    var _a;
    return (_a = Object.values((itemObject == null ? void 0 : itemObject.menuTypeVersions) || {})[0]) == null ? void 0 : _a.showAllMods;
  }
);
var selectCurrentItemShowAllModsAlphabetizeButtonsEnabled = createSelector(
  selectCurrentTicketElementItemObject,
  (itemObject) => {
    var _a;
    return (_a = Object.values((itemObject == null ? void 0 : itemObject.menuTypeVersions) || {})[0]) == null ? void 0 : _a.showAllModsAlphabetizeButtons;
  }
);
var selectCurrentItemShowAllModsHalfSizeButtonsEnabled = createSelector(
  selectCurrentTicketElementItemObject,
  (itemObject) => {
    var _a;
    return (_a = Object.values((itemObject == null ? void 0 : itemObject.menuTypeVersions) || {})[0]) == null ? void 0 : _a.showAllModsHalfSizeButtons;
  }
);
var selectCurrentTicketElementPrepStations = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => {
    return [
      ...(ticketElement == null ? void 0 : ticketElement.prepStations) || [],
      ...(ticketElement == null ? void 0 : ticketElement.prepStationOverride) ? [ticketElement == null ? void 0 : ticketElement.prepStationOverride] : []
    ];
  }
);
var selectCurrentTicketElementSeating = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => {
    if (!ticketElement)
      return {};
    return ticketElement.seating;
  }
);
var selectCurrentComboHasSeatSelected = createSelector(
  selectIsCurrentOrderSeatingMode,
  selectCurrentComboElement,
  (isCurrentOrderSeatingEnabled, comboElement) => isCurrentOrderSeatingEnabled ? comboElement ? Object.values(comboElement.seating).length > 0 : false : true
);
var selectCurrentTicketElementCustomizerType = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => ticketElement == null ? void 0 : ticketElement.customizerType
);
var selectCurrentTicketElementCourseId = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => {
    var _a;
    return (_a = ticketElement == null ? void 0 : ticketElement.courseId) != null ? _a : null;
  }
);
var selectCurrentTicketElementOnTheFlyCourseNumber = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => {
    var _a;
    return (_a = ticketElement == null ? void 0 : ticketElement.onTheFlyCourseNumber) != null ? _a : null;
  }
);
var selectCurrentTicketElementIsFromDisabledCoursingMenu = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => ticketElement == null ? void 0 : ticketElement.isCurrentMenuTypeCourseDisabled
);
var selectCurrentTicketElementIsTakeout = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => {
    var _a;
    return (_a = ticketElement == null ? void 0 : ticketElement.isTakeout) != null ? _a : false;
  }
);
var selectCurrentTicketElementIsClosedCheck = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => {
    var _a;
    return (_a = ticketElement == null ? void 0 : ticketElement.isInClosedCheck) != null ? _a : false;
  }
);
var selectCurrentComboElementIsInClosedCheck = createSelector(
  selectCurrentComboElement,
  (comboElement) => {
    var _a;
    return (_a = comboElement == null ? void 0 : comboElement.isInClosedCheck) != null ? _a : false;
  }
);
var selectCurrentTicketElementModifierGroups = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => {
    var _a, _b;
    if (!(ticketElement == null ? void 0 : ticketElement.itemObj))
      return [];
    const modifierGroups = (_b = (_a = ticketElement.itemObj.menuTypeVersions[ticketElement.isOpenItem ? 0 : ticketElement.menuTypeId || 0]) == null ? void 0 : _a.modifierGroups) != null ? _b : {};
    return Object.values(modifierGroups).filter((mg) => mg.active).sort((a, b) => a.sortPriority - b.sortPriority);
  }
);
var selectCurrentTicketElementNormalMods = createSelector(
  selectCurrentTicketElementModifierGroups,
  (modifierGroups) => modifierGroups.filter((mg) => !mg.isAllMod)
);
var selectCurrentTicketNormalModsSelectedAreComplete = createSelector(
  selectCurrentTicketElementNormalMods,
  selectCurrentTicketElement,
  (modifierGroups, ticketElement) => modifierGroups.every(
    (mg) => {
      var _a;
      return !!((_a = ticketElement == null ? void 0 : ticketElement.modifierGroupsSelected[mg.modifierGroupId]) == null ? void 0 : _a.isComplete);
    }
  ) || false
);
var selectCurrentTicketElementHasNormalMods = createSelector(
  selectCurrentTicketElementNormalMods,
  selectCurrentTicketElement,
  (modifierGroups, ticketElement) => modifierGroups.length > 0 || ((ticketElement == null ? void 0 : ticketElement.isOpenItem) ? false : (ticketElement == null ? void 0 : ticketElement.customizerType) === "subcategory" /* SUBCATEGORY */)
);
var selectCurrentTicketItemIngredients = createSelector(
  selectCurrentTicketElementItemObject,
  (itemObject) => {
    var _a;
    return Object.values(
      ((_a = Object.values((itemObject == null ? void 0 : itemObject.menuTypeVersions) || {})[0]) == null ? void 0 : _a.ingredients) || {}
    );
  }
);
var selectIsCurrentTicketElementShowIngredients = createSelector(
  selectCurrentTicketElementItemObject,
  (itemObject) => {
    const menuTypeVersion = Object.values(
      (itemObject == null ? void 0 : itemObject.menuTypeVersions) || {}
    )[0];
    if (!menuTypeVersion)
      return false;
    return Object.values(menuTypeVersion.ingredients || {}).length > 0 && menuTypeVersion.showIngredients;
  }
);
var selectCurrentTicketElementHasMods = createSelector(
  selectCurrentTicketElement,
  selectCurrentTicketElementModifierGroups,
  (ticketElement, modifierGroups) => !isEmpty(modifierGroups) || (ticketElement == null ? void 0 : ticketElement.isOpenItem) ? false : (ticketElement == null ? void 0 : ticketElement.customizerType) === "subcategory" /* SUBCATEGORY */
);
var selectCurrentTicketElementHasOpenModAdded = createSelector(
  selectCurrentTicketElement,
  hasOpenModAdded
);
var selectFilteredCurrentTicketElementModifierGroups = createSelector(
  selectCurrentTicketElementModifierGroups,
  selectIsAllModsEnabled,
  (modifierGroups, isAllModsEnabled) => {
    return modifierGroups.filter(
      (mg) => isAllModsEnabled ? mg.isAllMod : !mg.isAllMod
    );
  }
);
var selectCurrentTicketElementAllowShare = createSelector(
  selectCurrentTicketElement,
  selectCurrentComboElement,
  (ticketElement, currentComboElement) => {
    var _a, _b;
    if (currentComboElement) {
      return Object.values(
        ((_a = currentComboElement.comboObj) == null ? void 0 : _a.menuTypeVersions) || {}
      )[0].allowSharing;
    } else if (ticketElement)
      return ticketElement.customizerType === "subcategory" /* SUBCATEGORY */ ? false : Object.values(((_b = ticketElement == null ? void 0 : ticketElement.itemObj) == null ? void 0 : _b.menuTypeVersions) || {})[0].allowSharing;
    return false;
  }
);
var selectCurrentOrderCourseTimesObject = createSelector(
  selectCurrentOrderObj,
  (order) => order.courseTimes
);
var selectCurrentOrderCourseTimes = createSelector(
  selectCurrentOrderCourseTimesObject,
  selectCoursingModeActive,
  (courseTimes, coursingMode) => Object.values(courseTimes).filter((course) => course.type === coursingMode).reduce(
    (courseAcc, course) => course.isActive ? __spreadProps(__spreadValues({}, courseAcc), {
      [course.courseId]: course
    }) : courseAcc,
    {}
  )
);
var selectCurrentTicketElementHasItem = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => !!(ticketElement == null ? void 0 : ticketElement.itemObj)
);
var selectCurrentComboName = createSelector(
  selectCurrentComboElement,
  (combo) => {
    var _a, _b;
    const menuTypeId = Object.keys(((_a = combo == null ? void 0 : combo.comboObj) == null ? void 0 : _a.menuTypeVersions) || {})[0];
    return (_b = combo == null ? void 0 : combo.comboObj) == null ? void 0 : _b.menuTypeVersions[Number(menuTypeId)].posName;
  }
);
var selectCurrentTicketElementComboId = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => {
    var _a;
    return (ticketElement == null ? void 0 : ticketElement.isOpenItem) ? null : (_a = ticketElement == null ? void 0 : ticketElement.comboElementId) != null ? _a : null;
  }
);
var selectTriggeringManuallyDisabled = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => ticketElement == null ? void 0 : ticketElement.isTriggeringManuallyDisabled
);
var selectCurrentElementItemObj = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => {
    if (!ticketElement)
      return null;
    return ticketElement.itemObj;
  }
);
var selectCurrentElementMenuTypeVersion = createSelector(
  selectCurrentTicketElement,
  selectCurrentElementItemObj,
  (ticketElement, itemObj) => {
    if (!ticketElement || !itemObj)
      return null;
    return itemObj.menuTypeVersions[ticketElement.isOpenItem ? 0 : ticketElement.menuTypeId];
  }
);
var selectCurrentModifierGroup = createSelector(
  selectCurrentElementMenuTypeVersion,
  selectCurrentModifierGroupId,
  (menuTypeVersionObj, modifierGroupId) => {
    if (!menuTypeVersionObj || isNil(modifierGroupId))
      return null;
    return menuTypeVersionObj.modifierGroups[modifierGroupId];
  }
);
var selectOrderSeatTags = createSelector(
  selectCurrentOrderObj,
  (order) => {
    var _a;
    return (_a = order == null ? void 0 : order.seatTags) != null ? _a : {};
  }
);
var selectCurrentElementCustomizerType = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => {
    if (!ticketElement || ticketElement.isOpenItem)
      return "none" /* NONE */;
    return ticketElement.customizerType;
  }
);
var selectCurrentElementTimeTriggered = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => {
    if (!ticketElement)
      return NULLISH_DATE;
    return ticketElement.timeTriggered;
  }
);
var selectIsCustomizerScreenByTicketElement = createSelector(
  selectCurrentElementCustomizerType,
  (customizerType) => customizerType !== "none" /* NONE */
);
var selectCurrentElementInstructions = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => !ticketElement ? null : ticketElement.instructions
);
var selectCurrentElementCreatedById = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => !ticketElement ? null : ticketElement.createdById
);
var selectCurrentElementTimeSentToKitchen = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => ticketElement == null ? void 0 : ticketElement.timeSentToKitchen
);
var selectCurrentElementConfigWhenSent = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => !ticketElement ? null : ticketElement.configWhenSent
);
var selectIsCurrentElementQtyWhenSentComplete = createSelector(
  selectCurrentTicketElementQuantity,
  selectCurrentElementConfigWhenSent,
  (quantity, configWhenSent) => !configWhenSent || quantity === configWhenSent.quantity
);
var selectCurrentElementIsOnHold = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => isComboOrTicketElementOnHold(
    ticketElement
  )
);
var selectSectionsCompletedSet = createSelector(
  selectCurrentTicketElement,
  selectSectionsCompletedIds
);
var selectIsCurrentTicketElementComplete = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => !ticketElement ? true : ticketElement.isOnHold ? true : isTicketElementComplete(ticketElement)
);
var selectIsCurrentComboElementComplete = createSelector(
  selectCurrentComboElement,
  (combo) => {
    var _a;
    return (_a = combo == null ? void 0 : combo.isComplete) != null ? _a : false;
  }
);
var selectIsCurrentElementComplete = createSelector(
  selectCurrentComboElementId,
  selectIsCurrentComboElementComplete,
  selectIsCurrentTicketElementComplete,
  (comboElementId, isComboComplete, isTicketItemComplete) => comboElementId ? isComboComplete : isTicketItemComplete
);
var selectTicketItemMenuTypeId = createSelector(
  selectCurrentElementItemObj,
  (itemObj) => Object.keys((itemObj == null ? void 0 : itemObj.menuTypeVersions) || {})[0]
);
var selectLowestPriceInActiveItems = createSelector(
  selectCurrentActiveItems,
  selectCurrentTicket,
  selectCurrentCombos,
  (activeItems, items, combos) => {
    if (activeItems.length === 0)
      return 0;
    const activeElements = activeItems.reduce(
      (acc, elementId) => {
        if (items[elementId]) {
          return [...acc, items[elementId]];
        } else if (combos[elementId]) {
          return [...acc, combos[elementId]];
        }
        return acc;
      },
      []
    );
    const [firstItem] = activeElements;
    if (!firstItem)
      return 0;
    const initialValue = "comboId" in firstItem ? firstItem.comboBasePrice + firstItem.totalAdditionalPriceAmount : firstItem.baseItemPrice + firstItem.selectedModifiersPricePerItemUnit;
    return activeElements.reduce((lowest, item) => {
      const elementPrice = "comboId" in item ? item.comboBasePrice + item.totalAdditionalPriceAmount : item.baseItemPrice + item.selectedModifiersPricePerItemUnit;
      return lowest < elementPrice ? lowest : elementPrice;
    }, initialValue);
  }
);
var selectShowTicketElementModifierGroupSearchBar = createSelector(
  selectCurrentElementMenuTypeVersion,
  selectCurrentModifierGroupId,
  (itemObj, modifierGroupId) => {
    var _a;
    if (!itemObj)
      return false;
    const modifierGroup = (_a = itemObj.modifierGroups) == null ? void 0 : _a[modifierGroupId || 0];
    if (!modifierGroup)
      return false;
    return modifierGroup.showSearchBar;
  }
);
var EMPTY_MODS_SELECTED = {};
var selectSelectedModifierGroups = createSelector(
  selectCurrentTicketElement,
  (currentTicketElement) => {
    var _a;
    return (_a = currentTicketElement == null ? void 0 : currentTicketElement.modifierGroupsSelected) != null ? _a : EMPTY_MODS_SELECTED;
  }
);
var selectSelectedIngredients = createSelector(
  selectCurrentTicketElement,
  (currentTicketElement) => {
    return currentTicketElement ? currentTicketElement.ingredientsSelected : null;
  }
);
var selectTicketElementsReadyForKitchen = createSelector(
  selectCurrentOrder,
  (currentOrder) => {
    return Object.values((currentOrder == null ? void 0 : currentOrder.ticketElements) || {}).filter(
      (ticketElement) => (!ticketElement.timeTriggered.length || notTicketElementTriggered(ticketElement)) && isTicketElementComplete(ticketElement)
    );
  }
);
var selectIsCurrentTicketElementCurrentMenuType = createSelector(
  selectCurrentTicketElement,
  selectCurrentMenuTypeId,
  (ticketElement, menuTypeId) => {
    return (ticketElement == null ? void 0 : ticketElement.isOpenItem) ? false : (ticketElement == null ? void 0 : ticketElement.menuTypeId) === menuTypeId;
  }
);
var selectCurrentOrderHasDineInAndTakeOut = createSelector(
  selectCurrentOrder,
  (currentOrder) => {
    const hasTakeOutTicketElements = Object.values(
      (currentOrder == null ? void 0 : currentOrder.ticketElements) || {}
    ).some((ticketElement) => ticketElement.isTakeout);
    return hasTakeOutTicketElements && Object.values((currentOrder == null ? void 0 : currentOrder.ticketElements) || {}).some(
      (ticketElement) => !ticketElement.isTakeout
    );
  }
);
var selectIsCurrentTicketElementToGo = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => {
    var _a;
    return (_a = ticketElement == null ? void 0 : ticketElement.isTakeout) != null ? _a : false;
  }
);
var selectIsCurrentTicketElementVoid = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => ticketElement == null ? void 0 : ticketElement.isVoided
);
var selectCurrentOrderDefaultCheckId = createSelector(
  selectCurrentOrderObj,
  (order) => order.defaultCheckId
);
var selectDefaultCheckElementsIds = createSelector(
  selectCurrentOrderObj,
  selectCurrentOrderDefaultCheckId,
  (currentOrder, defaultCheckId) => {
    var _a, _b;
    return Object.keys((_b = (_a = currentOrder.checks[defaultCheckId]) == null ? void 0 : _a.checkElements) != null ? _b : {});
  }
);
var selectCurrentOrderChecks = createSelector(
  selectCurrentOrderObj,
  (order) => {
    const checks = Object.values(order.checks || {});
    const { nonVoidChecks, voidChecks } = checks.reduce(
      (acc, check) => {
        if (isCheckVoided(check)) {
          acc.voidChecks.push(check);
        } else {
          acc.nonVoidChecks.push(check);
        }
        return acc;
      },
      { nonVoidChecks: [], voidChecks: [] }
    );
    return nonVoidChecks.sort((a, b) => a.number - b.number).concat(voidChecks.sort((a, b) => a.number - b.number));
  }
);
var selectCurrentOrderActiveChecks = createSelector(
  selectCurrentOrderChecks,
  (checks) => checks.filter((check) => !isCheckVoided(check))
);
var selectCurrentOrderHasAvailableChecks = createSelector(
  selectCurrentOrder,
  (order) => {
    const hasAvailableChecks = Object.values((order == null ? void 0 : order.checks) || {}).some(
      (check) => checkStatusAllowsEditing(check.status) && getCheckId(check) !== (order == null ? void 0 : order.defaultCheckId)
    );
    return hasAvailableChecks;
  }
);
var selectCurrentBaseCheck = createSelector(
  selectCurrentOrderObj,
  selectCurrentOrderDefaultCheckId,
  (orderObj, defaultCheckId) => orderObj.checks[defaultCheckId]
);
var selectCurrentBaseCheckBalanceDue = createSelector(
  selectCurrentBaseCheck,
  (check) => (check == null ? void 0 : check.balanceDue) || 0
);
var selectCurrentBaseCheckTotal = createSelector(
  selectCurrentBaseCheck,
  (check) => (check == null ? void 0 : check.total) || 0
);
var selectCurrentBaseCheckTip = createSelector(
  selectCurrentBaseCheck,
  (check) => (check == null ? void 0 : check.tip) || 0
);
var selectCurrentOrderChecksCount = createSelector(
  selectCurrentOrderObj,
  (order) => Object.keys(order.checks || {}).length
);
var selectCurrentOrderCheckCount = createSelector(
  selectCurrentOrderChecks,
  (splitChecks) => splitChecks.length || 0
);
var selectCurrentOrderCheckPaymentsCount = createSelector(
  selectCurrentOrderObj,
  getCheckPaymentsCount
);
var selectCurrentOrderTicketIdsNoOnHold = createSelector(
  selectCurrentOrderObj,
  (order) => {
    return Object.values(order.ticketElements).filter((ticketElement) => !(ticketElement == null ? void 0 : ticketElement.isOnHold)).map((ticketElements) => {
      return {
        id: getTicketElementId(ticketElements),
        tabletGeneratedId: ticketElements.tabletGeneratedId
      };
    });
  }
);
var selectCurrentOrderComboIdsNoOnHold = createSelector(
  selectCurrentOrderObj,
  (order) => {
    return Object.values(order.combos).filter(
      (comboElement) => !Object.values(comboElement.itemGroupsSelected).some(
        (itemGroup) => {
          var _a;
          return (_a = order.ticketElements[Number(itemGroup.ticketElementId)]) == null ? void 0 : _a.isOnHold;
        }
      )
    ).map((combo) => {
      return {
        id: getTicketElementId(combo),
        tabletGeneratedId: combo.tabletGeneratedId
      };
    });
  }
);
var selectCurrentTicketItemIds = createShallowEqualSelector(
  selectCurrentTicket,
  (ticket) => {
    const itemIds = Array.from(
      new Set(
        Object.values(ticket).filter((ticketElement) => !ticketElement.comboElementId).map((ticketElement) => ticketElement.itemId).filter((itemId) => itemId !== null)
      )
    );
    return itemIds;
  }
);
var selectCurrentTicketComboIds = createShallowEqualSelector(
  selectCurrentCombos,
  (combos) => {
    const comboIds = Array.from(
      new Set(Object.values(combos).map((combo) => combo.comboId))
    );
    return comboIds;
  }
);
var selectIsOrderClosed = createSelector(
  selectCurrentOrderObj,
  (order) => order.status !== "open-initiated" /* OPEN_INITIATED */ && order.status !== "open-ordered" /* OPEN_ORDERED */ && order.status !== "tip-pending" /* TIP_PENDING */
);
var selectCurrentCheckId = createSelector(
  selectPaymentNavigationCheckId,
  selectCurrentOrderActiveChecks,
  selectCurrentOrderDefaultCheckId,
  (checkId, activeChecks, defaultCheckId) => {
    if (checkId)
      return checkId;
    if (activeChecks.length > 1)
      return getCheckId(activeChecks[1]);
    return defaultCheckId;
  }
);
var selectIsCurrentCheckDefault = createSelector(
  selectCurrentCheckId,
  selectCurrentOrderDefaultCheckId,
  (checkId, defaultCheckId) => checkId === defaultCheckId
);
var selectCurrentCheck = createSelector(
  selectCurrentOrderObj,
  selectCurrentCheckId,
  (orderObj, checkId) => orderObj.checks[checkId]
);
var selectOrderOrCurrentCheck = createSelector(
  isCheckEditorActive,
  selectCurrentOrderDefaultCheckId,
  selectCurrentOrderObj,
  selectCurrentCheckId,
  (checkEditorActive, defaultId, orderObj, checkId) => {
    var _a;
    return checkEditorActive || defaultId === checkId ? orderObj : (_a = orderObj.checks[checkId]) != null ? _a : {};
  }
);
var selectCurrentCheckElements = createSelector(
  selectCurrentCheck,
  (check) => {
    var _a;
    return (_a = check == null ? void 0 : check.displayCheckElements) != null ? _a : {};
  }
);
var selectCurrentCheckElementEntries = createSelector(
  selectCurrentCheckElements,
  (checkElements) => [...Object.values(checkElements)]
);
var selectCurrentCheckBalanceDue = createSelector(
  selectCurrentOrderDefaultCheckId,
  selectCurrentOrderObj,
  selectCurrentCheckId,
  (defaultId, orderObj, checkId) => {
    if (!checkId || !orderObj || !orderObj.checks[checkId])
      return 0;
    return defaultId === checkId ? orderObj.balanceDue : orderObj.checks[checkId].balanceDue;
  }
);
var selectCurrentCheckTotal = createSelector(
  selectCurrentOrderDefaultCheckId,
  selectCurrentOrderObj,
  selectCurrentCheckId,
  (defaultId, orderObj, checkId) => {
    if (!checkId || !orderObj || !orderObj.checks[checkId])
      return 0;
    return defaultId === checkId ? orderObj.total : orderObj.checks[checkId].total;
  }
);
var selectCurrentCheckName = createSelector(
  selectCurrentCheck,
  (check) => (check == null ? void 0 : check.name) || ""
);
var selectCurrentCheckNumber = createSelector(
  selectCurrentCheck,
  (check) => (check == null ? void 0 : check.number) || 0
);
var selectCurrentNavCheckIds = createSelector(
  selectCurrentOrderActiveChecks,
  selectCurrentCheckId,
  (splitChecks, checkId) => {
    if (!checkId || !splitChecks.length)
      return {
        prevCheckId: null,
        nextCheckId: null
      };
    const currentCheckIdIndex = splitChecks.findIndex(
      (check) => getCheckId(check) === checkId
    );
    const prevCheckIndex = (currentCheckIdIndex - 1 + splitChecks.length) % splitChecks.length;
    const nextCheckIndex = (currentCheckIdIndex + 1) % splitChecks.length;
    let prevCheckId = getCheckId(
      splitChecks[prevCheckIndex]
    );
    let nextCheckId = getCheckId(
      splitChecks[nextCheckIndex]
    );
    if (prevCheckId === checkId)
      prevCheckId = null;
    if (nextCheckId === checkId)
      nextCheckId = null;
    return {
      prevCheckId,
      nextCheckId
    };
  }
);
var selectCurrentCheckPayments = createSelector(
  selectCurrentCheck,
  (check) => {
    var _a;
    return Object.values((_a = check == null ? void 0 : check.payments) != null ? _a : {});
  }
);
var selectMaxSortPriorityInAllModsSelected = createSelector(
  selectCurrentTicketElement,
  (ticketElement) => {
    if (!ticketElement)
      return 0;
    return Object.values(ticketElement.modifierGroupsSelected).filter(
      (modifierGroup) => modifierGroup.global || modifierGroup.modifierGroupId === ALL_MODS_ID
    ).map(
      (modifierGroupSelected) => Object.values(modifierGroupSelected.modifierItemsSelected).map(
        (modifierItem) => modifierItem.sortPriority
      )
    ).flat().reduce((max4, current) => current > max4 ? current : max4, 0);
  }
);
var selectPromptForItemPriceName = createSelector(
  selectCurrentMenuTypeId,
  selectRegisterNavigationPromptForPriceItemId,
  selectItems,
  (menuTypeId, promptForPriceItemId, items) => {
    var _a, _b, _c;
    if (!menuTypeId || !promptForPriceItemId)
      return "";
    return ((_c = (_b = (_a = items[promptForPriceItemId]) == null ? void 0 : _a.menuTypeVersions) == null ? void 0 : _b[menuTypeId]) == null ? void 0 : _c.posName) || "";
  }
);
var selectIsCurrentMenuTypeSelectedActive = createSelector(
  selectCurrentMenuTypeId,
  selectLocationMenuTypeBucket,
  (menuTypeId, menuTypes) => {
    var _a, _b;
    return (_b = (_a = menuTypes[menuTypeId || 0]) == null ? void 0 : _a.active) != null ? _b : false;
  }
);
var selectBarCodeOrderFromOrders = createSelector(
  selectBarCodeOrderSearchResult,
  selectOrders,
  (barCodeOrder, orders) => barCodeOrder ? orders[barCodeOrder.id || -1] || null : null
);
var selectDefaultServiceAreaOptionAndMode = createSelector(
  selectDefaultServiceAreaOption,
  selectIsCateringAvailable,
  selectIsDeliveryAvailable,
  selectIsToGoAvailable,
  (_defaultServiceAreaOption, isCateringAvailable, isDeliveryAvailable, isToGoAvailable) => {
    let defaultServiceAreaOption = _defaultServiceAreaOption;
    if (defaultServiceAreaOption === "catering" /* CATERING */ && !isCateringAvailable || defaultServiceAreaOption === "to_go" /* TO_GO */ && !isToGoAvailable || defaultServiceAreaOption === "delivery" /* DELIVERY */ && !isDeliveryAvailable) {
      defaultServiceAreaOption = null;
    }
    let isInTabMode = false;
    if (defaultServiceAreaOption) {
      isInTabMode = true;
    }
    return {
      defaultServiceAreaOption,
      isInTabMode
    };
  }
);

// src/state/selectors/tableLayoutSelectors.ts
var tableLayoutSelectors_exports = {};
__export(tableLayoutSelectors_exports, {
  makeSelectIsDragAndDropEnabled: () => makeSelectIsDragAndDropEnabled,
  makeSelectIsDragAndDropEnabledOnMergedTables: () => makeSelectIsDragAndDropEnabledOnMergedTables,
  makeSelectRecentOrderRelatedTableAndOrderName: () => makeSelectRecentOrderRelatedTableAndOrderName,
  selectIsDragAndDropActionEnabled: () => selectIsDragAndDropActionEnabled,
  selectOrderType: () => selectOrderType,
  selectRevenueCenters: () => selectRevenueCenters,
  selectSelectedAction: () => selectSelectedAction,
  selectSelectedElement: () => selectSelectedElement,
  selectSelectedServiceArea: () => selectSelectedServiceArea,
  selectSelectedServiceAreas: () => selectSelectedServiceAreas,
  selectSelectedTables: () => selectSelectedTables,
  selectServiceAreaLayouts: () => selectServiceAreaLayouts,
  selectServiceAreas: () => selectServiceAreas,
  selectShowTableBorderForLoggedInUsersOrders: () => selectShowTableBorderForLoggedInUsersOrders,
  selectTables: () => selectTables,
  selectUsersData: () => selectUsersData
});
var selectSelectedAction = (state) => state.tableLayout.selectedAction;
var selectSelectedTables = (state) => state.tableLayout.selectedTables;
var selectTables = (state) => state.tableLayout.savedData.tables;
var selectServiceAreas = (state) => state.tableLayout.savedData.serviceAreas;
var selectServiceAreaLayouts = (state) => state.tableLayout.savedData.serviceAreaLayouts;
var selectSelectedServiceAreas = (state) => state.tableLayout.currentEditData.serviceAreas;
var selectOrderType = (state) => state.tableLayout.currentEditLayout.selectedOrderType;
var selectSelectedServiceArea = (state) => state.tableLayout.currentEditLayout.selectedServiceArea;
var selectSelectedElement = (state) => state.tableLayout.currentEditLayout.selectedElement;
var selectRevenueCenters = (state) => state.tableLayout.savedData.revenueCenters;
var selectIsDragAndDropActionEnabled = createSelector(
  selectSelectedAction,
  (selectedAction) => selectedAction === "dragDrop" /* DRAG_DROP */
);
var selectShowTableBorderForLoggedInUsersOrders = (state) => state.settings.selectedMode.currentSettings.register.showTableBorderForLoggedInUsersOrders;
var selectUsersData = createSelector(
  (state) => state.settings.selectedMode.currentSettings.users,
  (users) => Object.entries(users).reduce((acc, [key, user]) => {
    var _a, _b;
    if (key !== "undefined")
      return [
        ...acc,
        {
          label: `${(_a = user == null ? void 0 : user.user) == null ? void 0 : _a.firstName} ${(_b = user == null ? void 0 : user.user) == null ? void 0 : _b.lastName}`,
          value: user == null ? void 0 : user.organizationUserId
        }
      ];
    return acc;
  }, [])
);
var makeSelectIsDragAndDropEnabled = () => {
  const selectIsDragAndDropEnabled = createSelector(
    [
      selectSelectedAction,
      selectSelectedTables,
      (state, tableId) => tableId
    ],
    (selectedAction, selectedTables, tableId) => {
      return selectedTables.length > 0 && selectedAction === "dragDrop" /* DRAG_DROP */ && selectedTables[0].tableId === tableId;
    }
  );
  return selectIsDragAndDropEnabled;
};
var makeSelectIsDragAndDropEnabledOnMergedTables = () => {
  const selectIsDragAndDropEnabled = createSelector(
    [selectSelectedAction, selectSelectedTables, (state, element) => element],
    (selectedAction, selectedTables, element) => {
      return selectedTables.length > 0 && selectedTables[0].mergedTableId ? selectedAction === "dragDrop" /* DRAG_DROP */ && selectedTables[0].mergedTableId === element.mergedTableId && selectedTables[0].tableId !== element.tableId : false;
    }
  );
  return selectIsDragAndDropEnabled;
};
var makeSelectRecentOrderRelatedTableAndOrderName = () => {
  return createSelector(
    [selectTables, selectOrders, (state, orderId) => orderId],
    (tables, orders, orderId) => {
      const currentTable = Object.values(tables).find(
        (table) => table.orderId === orderId
      );
      const currentOrder = orders[orderId];
      return {
        table: currentTable ? currentTable : null,
        orderName: currentOrder ? currentOrder.name : ""
      };
    }
  );
};
var customersLocationReducer = produce((state = CUSTOMERS_INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_LOCATION_CUSTOMERS:
    case SET_LOCATION_CUSTOMERS_WS:
      return action.payload;
    default:
      return state;
  }
});
var reducers_default3 = customersLocationReducer;
var settingsMasterReducer = produce((state = CUSTOMERS_INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_MASTER_CUSTOMERS:
    case SET_MASTER_CUSTOMERS_WS:
      return action.payload;
    default:
      return state;
  }
});
var reducers_default4 = settingsMasterReducer;
var customersRemoteLocationReducer = produce((state = CUSTOMERS_INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_REMOTE_LOCATION_CUSTOMERS:
    case SET_REMOTE_LOCATION_CUSTOMERS_WS:
      return action.payload;
    default:
      return state;
  }
});
var reducers_default5 = customersRemoteLocationReducer;
var settingsSelectedModeReducer = produce((state = CUSTOMER_SELECTED_MODE_INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_SELECTED_CUSTOMERS_MODE:
    case SET_SELECTED_CUSTOMERS_MODE_WS:
      return action.payload;
    default:
      return state;
  }
});
var reducers_default6 = settingsSelectedModeReducer;

// src/state/customers/reducers.ts
var reducers_default7 = combineReducers({
  selectedMode: reducers_default6,
  changeData: reducer_default$2,
  versions: reducers_default,
  master: reducers_default4,
  location: reducers_default3,
  remoteLocation: reducers_default5
});
var preProcessOrders = (orders) => {
  return Object.entries(orders).reduce(
    (acc, [i, order]) => {
      const numberKey = Number(i);
      acc[numberKey] = preProcessOrder(order);
      return acc;
    },
    {}
  );
};
var applyOpenModId = (ticketAcc, [j, ticketElement]) => {
  const requiresFormatting = hasOpenModAdded(ticketElement);
  let ticketBody = ticketElement;
  if (requiresFormatting) {
    ticketBody = produce(ticketElement, (ticketDraft) => {
      const modifierGroupsSelected = ticketBody.modifierGroupsSelected;
      if (modifierGroupsSelected[0]) {
        const { modifierItemsSelected } = modifierGroupsSelected[0];
        if (modifierItemsSelected[0])
          ticketDraft.modifierGroupsSelected[0].modifierItemsSelected[0].modifierItemId = 0;
      }
    });
  }
  ticketAcc[j] = __spreadValues({}, ticketBody);
  return ticketAcc;
};
var preProcessOrder = (order) => {
  const _order = __spreadValues({}, order);
  const ticketBody = Object.entries(order.ticketElements).reduce(
    applyOpenModId,
    {}
  );
  return __spreadProps(__spreadValues({}, _order), { ticketElements: ticketBody });
};
var orders_default = preProcessOrders;

// src/helpers/apiMock.ts
var getOrderById = (orderId) => new Promise(
  (res) => setTimeout(
    () => res(__spreadProps(__spreadValues({}, ORDER_INITIAL_STATE), { id: orderId })),
    10
  )
);
var getDiffFieldsByBucket = (bucket) => {
  const baseArrayValueFields = [
    "categoryIds",
    "subcategoryIds",
    // 'orderStatuses',
    "orderTypes",
    "reportingGroupIds"
  ];
  const baseNonArrayValueFields = [
    "isActive",
    "name",
    "isFavorited",
    "period",
    "startDate",
    "endDate"
  ];
  const baseArraySchedulingFields = [
    "recipients"
  ];
  const baseNonArraySchedulingFields = [
    "isSchedulingEnabled",
    "fileType",
    "scheduleStartDateTime",
    "repeatType"
  ];
  const getReturnObject = (arrayFilterFields, nonArrayFilterFields) => ({
    arrayFilterFields,
    nonArrayFilterFields,
    arrayFilterFieldsSet: new Set(arrayFilterFields),
    nonArrayFilterFieldsSet: new Set(nonArrayFilterFields),
    arraySchedulingFields: baseArraySchedulingFields,
    nonArraySchedulingFields: baseNonArraySchedulingFields,
    arraySchedulingFieldsSet: new Set(baseArraySchedulingFields),
    nonArraySchedulingFieldsSet: new Set(baseNonArraySchedulingFields)
  });
  switch (bucket) {
    case "customReports": {
      const employeeSalesAndTipsReportArrayValueFields = ["ownerIds"];
      return getReturnObject(
        employeeSalesAndTipsReportArrayValueFields,
        baseNonArrayValueFields
      );
    }
    case "itemComboSalesReports": {
      const itemComboSalesReportNonArrayValueFields = [...baseNonArrayValueFields, "groupBy", "showModItemsSales"];
      return getReturnObject(
        baseArrayValueFields,
        itemComboSalesReportNonArrayValueFields
      );
    }
    case "employeeSalesAndTipsReports": {
      const employeeSalesAndTipsReportArrayValueFields = ["ownerIds"];
      return getReturnObject(
        employeeSalesAndTipsReportArrayValueFields,
        baseNonArrayValueFields
      );
    }
    case "salesOverviewReports": {
      const salesOverviewReportNonArrayValueFields = [
        ...baseNonArrayValueFields,
        "showSalesByMenuType",
        "showSalesByOrderType",
        "showSalesByRole",
        "showSalesByServiceArea"
      ];
      return getReturnObject(
        baseArrayValueFields,
        salesOverviewReportNonArrayValueFields
      );
    }
    case "endOfShiftReports": {
      const endOfShiftReportArrayValueFields = [
        ...baseArrayValueFields,
        "ownerIds"
      ];
      const endOfShiftReportNonArrayValueFields = [
        ...baseNonArrayValueFields,
        "showSalesByMenuType",
        "showSalesByOrderType",
        "combineForAll",
        "doNotPrintOrderHistory"
      ];
      return getReturnObject(
        endOfShiftReportArrayValueFields,
        endOfShiftReportNonArrayValueFields
      );
    }
    case "voidReasonsReports":
    case "creditCardBatchReports": {
      const batchReportArrayValueFields = [];
      return getReturnObject(
        batchReportArrayValueFields,
        baseNonArrayValueFields
      );
    }
    case "inventoryOnHandReports": {
      const inventoryReportArrayValueFields = [];
      const inventoryReportNonArrayValueFields = ["isActive", "name", "isFavorited"];
      return getReturnObject(
        inventoryReportArrayValueFields,
        inventoryReportNonArrayValueFields
      );
    }
  }
  return getReturnObject(baseArrayValueFields, baseNonArrayValueFields);
};
var getArrayValueChanges = (fields, data, originalData) => {
  const changes = [];
  const getChangeCreator = (action) => (id) => {
    return { action, value: id };
  };
  fields.forEach((field) => {
    const fieldChange = {
      field,
      label: field,
      value: []
    };
    const originalArray = originalData[field];
    const newArray = data[field];
    let addedIds = [];
    let removedIds = [];
    if (originalArray && newArray) {
      addedIds = difference(newArray, originalArray);
      removedIds = difference(originalArray, newArray);
    } else if (originalArray) {
      fieldChange.value = null;
      changes.push(fieldChange);
      return;
    } else if (newArray) {
      addedIds = newArray;
    }
    fieldChange.value = [
      ...addedIds.map(getChangeCreator("add")),
      ...removedIds.map(getChangeCreator("remove"))
    ];
    if (fieldChange.value.length > 0) {
      changes.push(fieldChange);
    }
  });
  return changes;
};
var getDiffTranslation = (change) => {
  switch (change.field) {
    case "groupBy":
      change.textValue = i18n_config_default.t(
        `reports.fields.groupByOptions.${change.value}`
      );
      break;
    case "period":
      change.textValue = i18n_config_default.t(
        `reports.fields.periodOptions.${change.value}`
      );
      break;
    case "fileType":
      change.textValue = i18n_config_default.t(
        `reports.fields.fileTypeOptions.${change.value}`
      );
      break;
    case "repeatType":
      change.textValue = i18n_config_default.t(
        `reports.fields.repeatTypeOptions.${change.value}`
      );
      break;
  }
  return change;
};
var diffCreateReportFactory = (data, bucket) => {
  const diffObject = {
    filters: [],
    scheduling: []
  };
  const {
    arrayFilterFields,
    nonArrayFilterFields,
    arraySchedulingFields,
    nonArraySchedulingFields
  } = getDiffFieldsByBucket(bucket);
  const appendChange = (diffBucket) => (field) => {
    const value = data[field];
    if (!Array.isArray(value))
      return diffObject[diffBucket].push(
        getDiffTranslation({
          field,
          label: i18n_config_default.t(`reports.fields.${field}`),
          value
        })
      );
    const values = value.map((id) => ({
      action: "add",
      value: id
    }));
    diffObject[diffBucket].push({
      field,
      label: i18n_config_default.t(`reports.fields.${field}`),
      value: values
    });
  };
  const isCustomPeriod = data.period === "custom" /* CUSTOM */;
  const isSpecificDate = data.period === "specific_date" /* SPECIFIC_DATE */;
  nonArrayFilterFields.filter(
    (field) => {
      if (field === "startDate") {
        return isCustomPeriod || isSpecificDate;
      }
      if (field === "endDate") {
        return isCustomPeriod;
      }
      return true;
    }
  ).forEach(appendChange("filters"));
  arrayFilterFields.forEach(appendChange("filters"));
  if (data.isSchedulingEnabled) {
    arraySchedulingFields.forEach(appendChange("scheduling"));
    nonArraySchedulingFields.forEach(appendChange("scheduling"));
  }
  return diffObject;
};
var diffReportFactory = (diffArray, state) => {
  const { data, originalData, bucket, mode } = state.reports.changeData;
  if (!data || !originalData || !bucket)
    return null;
  if (mode === "create" /* CREATE */) {
    return diffCreateReportFactory(data, bucket);
  }
  const reportsDiffObject = {
    filters: [],
    scheduling: []
  };
  const isCustomPeriod = data.period === "custom" /* CUSTOM */;
  const isSpecificDate = data.period === "specific_date" /* SPECIFIC_DATE */;
  const {
    arrayFilterFields,
    nonArrayFilterFieldsSet,
    arraySchedulingFields,
    nonArraySchedulingFieldsSet
  } = getDiffFieldsByBucket(bucket);
  diffArray.forEach(
    (diff11) => filterDiffFunction(
      diff11,
      ({ field, newDiff }) => {
        const isFilterNonArrayField = nonArrayFilterFieldsSet.has(field);
        const isSchedulingNonArrayField = nonArraySchedulingFieldsSet.has(field);
        if (!isFilterNonArrayField && !isSchedulingNonArrayField) {
          return;
        }
        if (isFilterNonArrayField && (field === "startDate" && !isCustomPeriod && !isSpecificDate || field === "endDate" && !isCustomPeriod)) {
          return;
        }
        const changeArray = isFilterNonArrayField ? reportsDiffObject.filters : reportsDiffObject.scheduling;
        changeArray.push(getDiffTranslation(newDiff));
      },
      (field) => i18n_config_default.t(`reports.fields.${field}`)
    )
  );
  const arrayFilterChanges = getArrayValueChanges(
    arrayFilterFields,
    data,
    originalData
  );
  if (arrayFilterChanges.length > 0) {
    reportsDiffObject.filters.push(
      ...arrayFilterChanges.map(getDiffTranslation)
    );
  }
  const arraySchedulingChanges = getArrayValueChanges(
    arraySchedulingFields,
    data,
    originalData
  );
  if (arraySchedulingChanges.length > 0) {
    reportsDiffObject.scheduling.push(
      ...arraySchedulingChanges.map(getDiffTranslation)
    );
  }
  return reportsDiffObject;
};
var getDiffReportFactoryLabeledFilterValues = (diffArray, state) => {
  const diffObject = diffReportFactory(diffArray, state);
  if (!diffObject)
    return null;
  const labelArrayValues = (field) => {
    return (diff11) => {
      var _a, _b, _c, _d, _e;
      const menuBucket = field === "categoryIds" ? "categories" : field === "subcategoryIds" ? "subcategories" : field === "reportingGroupIds" ? "reportingGroups" : null;
      switch (field) {
        case "orderTypes":
          return __spreadProps(__spreadValues({}, diff11), {
            value: i18n_config_default.t(
              `reports.fields.orderTypeOptions.${diff11.value}`
            )
          });
        case "recipients":
        case "ownerIds": {
          const user = (_b = (_a = state.settings.selectedMode.currentSettings) == null ? void 0 : _a.users[diff11.value]) == null ? void 0 : _b.user;
          const fullName = user ? `${user.firstName} ${user.lastName}` : `Owner ${diff11.value} NOT FOUND`;
          return __spreadProps(__spreadValues({}, diff11), {
            value: fullName
          });
        }
      }
      if (!menuBucket) {
        return diff11;
      }
      return __spreadProps(__spreadValues({}, diff11), {
        value: (_e = (_d = (_c = state.menu.selectedMode.currentMenu) == null ? void 0 : _c[menuBucket][diff11.value]) == null ? void 0 : _d.name) != null ? _e : `${menuBucket} ${diff11.value} NOT FOUND`
      });
    };
  };
  const newFiltersChanges = diffObject.filters.map((diff11) => {
    if (diff11.field === "categoryIds" || diff11.field === "subcategoryIds" || diff11.field === "reportingGroupIds" || // diff.field === 'orderStatuses' ||
    diff11.field === "orderTypes" || diff11.field === "ownerIds") {
      return __spreadProps(__spreadValues({}, diff11), {
        value: Array.isArray(diff11.value) ? diff11.value.map(labelArrayValues(diff11.field)) : i18n_config_default.t("commonTexts.all"),
        label: i18n_config_default.t(`reports.fields.${diff11.field}`)
      });
    }
    if (diff11.field === "startDate" || diff11.field === "endDate") {
      const timeZone = selectCurrentTimeZone(state);
      const dateTimeString = DateTime.fromISO(diff11.value, {
        zone: "utc"
      }).setZone(timeZone).toLocaleString(DateTime.DATETIME_MED);
      return __spreadProps(__spreadValues({}, diff11), {
        value: dateTimeString,
        label: i18n_config_default.t(`reports.fields.${diff11.field}`)
      });
    }
    return __spreadValues({}, diff11);
  });
  const newSchedulingChanges = diffObject.scheduling.map((diff11) => {
    if (diff11.field === "recipients") {
      return __spreadProps(__spreadValues({}, diff11), {
        value: Array.isArray(diff11.value) ? diff11.value.map(labelArrayValues(diff11.field)) : i18n_config_default.t("commonTexts.all"),
        label: i18n_config_default.t(`reports.fields.${diff11.field}`)
      });
    }
    if (diff11.field === "scheduleStartDateTime") {
      const timeZone = selectCurrentTimeZone(state);
      const dateTimeString = DateTime.fromISO(diff11.value, {
        zone: "utc"
      }).setZone(timeZone).toLocaleString(DateTime.DATETIME_MED);
      return __spreadProps(__spreadValues({}, diff11), {
        value: dateTimeString,
        label: i18n_config_default.t(`reports.fields.${diff11.field}`)
      });
    }
    return __spreadValues({}, diff11);
  });
  return {
    filters: newFiltersChanges,
    scheduling: newSchedulingChanges
  };
};

// src/helpers/menu/buckets/modifierItems.ts
var calculateModifierItemPricesMenu = (modifierItems, includedModifierItems, quantityMode, priceCalcMode) => {
  const filteredList = Object.values(modifierItems).filter(
    (modifierItem) => modifierItem.isSelected && modifierItem.inheritedActive
  ).filter((modifierItem) => modifierItem.defaultQuantitySelected !== 0).map(({ modifierItemId, defaultQuantitySelected, name }) => ({
    id: modifierItemId,
    count: quantityMode === "x1,x2,x3" /* NUMBER */ ? defaultQuantitySelected != null ? defaultQuantitySelected : 0 : 1,
    name,
    isDefault: true
  }));
  const selectedModifierItemElements = {
    modifierItems: filteredList.reduce(
      (accObj, mi) => __spreadProps(__spreadValues({}, accObj), { [mi.id]: mi }),
      {}
    ),
    count: filteredList.reduce(
      (totalCount, modifierItem) => totalCount + modifierItem.count,
      0
    )
  };
  return calculateModifierItemPrices(
    modifierItems,
    includedModifierItems,
    quantityMode,
    priceCalcMode,
    selectedModifierItemElements
  );
};
var calculateModifierItemPricesRegister = (modifierItems, selectedModifierItems, includedModifierItems, quantityMode, priceCalcMode) => {
  const filteredList = Object.values(selectedModifierItems).filter((modifierItem) => modifierItem.quantitySelected !== 0).map(({ modifierItemId, quantitySelected }) => ({
    id: modifierItemId,
    count: quantityMode === "x1,x2,x3" /* NUMBER */ ? quantitySelected != null ? quantitySelected : 0 : 1,
    name: modifierItems[modifierItemId].name,
    isDefault: selectedModifierItems[modifierItemId].isDefaultModifier
  }));
  const selectedModifierItemElements = {
    modifierItems: filteredList.reduce(
      (accObj, mi) => __spreadProps(__spreadValues({}, accObj), { [mi.id]: mi }),
      {}
    ),
    count: filteredList.reduce(
      (totalCount, modifierItem) => totalCount + modifierItem.count,
      0
    )
  };
  return calculateModifierItemPrices(
    modifierItems,
    includedModifierItems,
    quantityMode,
    priceCalcMode,
    selectedModifierItemElements
  );
};
var calculateModifierItemPrices = (modifierItems, includedModifierItems, quantityMode, priceCalcMode, selectedModifierItemElements) => {
  const {
    includedModifierItems: includedModifierItemsCount,
    additionalModifierItems: additionalModifierItemsCount
  } = modifierItemsPriceAlgorithm(
    quantityMode,
    priceCalcMode,
    includedModifierItems,
    selectedModifierItemElements.count,
    selectedModifierItemElements.modifierItems,
    modifierItems
  );
  const totalPrice = calculateTotalPrice(
    quantityMode,
    includedModifierItemsCount,
    additionalModifierItemsCount,
    modifierItems
  );
  return {
    includedModifierItemsCount,
    additionalModifierItemsCount,
    totalPrice
  };
};

// src/helpers/register/orderCreation/modifierGroups.ts
var getDefaultModifierGroupSelected = (modifierGroups) => {
  var _a, _b;
  const validModifierGroups = Object.values(modifierGroups || {}).filter(
    (modifierGroup) => !modifierGroup.isAllMod && modifierGroup.modifierGroupId !== ALL_MODS_ID
  ).sort((a, b) => a.sortPriority - b.sortPriority);
  return (_b = (_a = validModifierGroups[0]) == null ? void 0 : _a.modifierGroupId) != null ? _b : null;
};

// src/helpers/register/reducerHelpers/itemElement.ts
var isItemElement = (element) => {
  return !isComboElement(element) && !isOpenItemFn(element);
};
var isItemElementPromptForPrice = (element) => {
  var _a;
  if (!isItemElement(element)) {
    return false;
  }
  const itemObj = element.itemObj;
  return Boolean((_a = itemObj == null ? void 0 : itemObj.menuTypeVersions[element.menuTypeId]) == null ? void 0 : _a.promptForPrice);
};
var ModItemToggleOperations = /* @__PURE__ */ ((ModItemToggleOperations2) => {
  ModItemToggleOperations2["DELETE"] = "DELETE";
  ModItemToggleOperations2["INCREMENT"] = "INCREMENT";
  ModItemToggleOperations2["INCREMENT_SIZE"] = "INCREMENT_SIZE";
  ModItemToggleOperations2["SET_QUANTITY"] = "SET_QUANTITY";
  ModItemToggleOperations2["SELECT_NO"] = "SELECT_NO";
  ModItemToggleOperations2["DESELECT_NO"] = "DESELECT_NO";
  ModItemToggleOperations2["SELECT_LITE"] = "SELECT_LITE";
  ModItemToggleOperations2["SELECT_EXTRA"] = "SELECT_EXTRA";
  ModItemToggleOperations2["SELECT_ON_SIDE"] = "SELECT_ON_SIDE";
  ModItemToggleOperations2["NONE"] = "NONE";
  return ModItemToggleOperations2;
})(ModItemToggleOperations || {});
var MODIFIER_TAG_NAME_TO_OPERATION = {
  [NO_MODIFIER_TAG_POS_NAME]: "SELECT_NO" /* SELECT_NO */,
  [LITE_MODIFIER_TAG_POS_NAME]: "SELECT_LITE" /* SELECT_LITE */,
  [EXTRA_MODIFIER_TAG_POS_NAME]: "SELECT_EXTRA" /* SELECT_EXTRA */,
  [ON_SIDE_MODIFIER_TAG_POS_NAME]: "SELECT_ON_SIDE" /* SELECT_ON_SIDE */
};
var SPECIAL_TAG_NAME_TO_QUANTITY_SIZE = {
  [LITE_MODIFIER_TAG_POS_NAME]: "light" /* LIGHT */,
  [EXTRA_MODIFIER_TAG_POS_NAME]: "extra" /* EXTRA */
};
var SPECIAL_TAGS_WITHOUT_STRING = [
  LITE_MODIFIER_TAG_POS_NAME,
  EXTRA_MODIFIER_TAG_POS_NAME
];
var SPECIAL_TAGS_WITH_TOGGLE = [
  NO_MODIFIER_TAG_POS_NAME,
  LITE_MODIFIER_TAG_POS_NAME,
  EXTRA_MODIFIER_TAG_POS_NAME,
  ON_SIDE_MODIFIER_TAG_POS_NAME
];
var incrementModifierItemSelected2 = (ticketElement, modifierGroupId, modifierItemId, modifierTagSizes, customizer, globalState, sortPriority) => {
  var _a, _b, _c, _d, _e;
  const isOpenItem = isOpenItemFn(ticketElement);
  const menuTypeId = isOpenItem ? 0 : ticketElement.menuTypeId;
  const modifierGroupSelected = ticketElement.modifierGroupsSelected[modifierGroupId];
  let modifierItemSelected = modifierGroupSelected == null ? void 0 : modifierGroupSelected.modifierItemsSelected[modifierItemId];
  let modifierGroup = (_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[menuTypeId].modifierGroups[modifierGroupId];
  let modifierItem = modifierGroup == null ? void 0 : modifierGroup.modifierItems[modifierItemId];
  if (!modifierItem && ticketElement.itemObj && globalState) {
    const newModifierItem = modifierItemToTicketModifierItem(
      globalState.menu.locationMenu.modifierItems[modifierItemId],
      modifierGroupId,
      (_b = modifierGroup == null ? void 0 : modifierGroup.isAllMod) != null ? _b : false,
      globalState.menu.locationMenu.modifierGroups,
      globalState.menu.locationMenu.modifierItems,
      sortPriority ? sortPriority : modifierItem ? modifierItem == null ? void 0 : modifierItem.sortPriority : 0
    );
    ticketElement.itemObj.menuTypeVersions[menuTypeId].modifierGroups[modifierGroupId].modifierItems[modifierItemId] = newModifierItem;
    modifierGroup = (_c = ticketElement.itemObj) == null ? void 0 : _c.menuTypeVersions[menuTypeId].modifierGroups[modifierGroupId];
    modifierItem = modifierGroup == null ? void 0 : modifierGroup.modifierItems[modifierItemId];
  }
  if (!modifierItem || !modifierGroupSelected)
    return;
  if (!modifierItemSelected) {
    addNewModifierItemSelected(
      modifierItem,
      modifierGroupSelected,
      modifierTagSizes,
      customizer,
      sortPriority
    );
    modifierItemSelected = modifierGroupSelected.modifierItemsSelected[modifierItemId];
  } else {
    if (modifierGroupSelected.quantityMode === "x1,x2,x3" /* NUMBER */ && !modifierItemSelected.isOverrideType) {
      modifierItemSelected.quantitySelected++;
      const modifierInstance = __spreadProps(__spreadValues({}, GET_MODIFIER_ITEM_INSTANCE_INITIAL_STATE()), {
        modifierItemInstanceId: modifierItemSelected.quantitySelected,
        amountSelected: modifierItem.defaultAmountSelected,
        customizerSectors: __spreadValues({}, customizer)
      });
      if (!isEmpty(modifierItem.modifierGroups)) {
        const nestedModifierGroupsSelected = mapNestedModGroups(
          modifierItem.modifierGroups,
          modifierTagSizes
        );
        modifierInstance.nestedModifierGroupsSelected = nestedModifierGroupsSelected;
      }
      modifierInstance.isComplete = initializeIsInstanceComplete(
        modifierInstance.nestedModifierGroupsSelected
      );
      modifierItemSelected.modifierItemInstances[modifierItemSelected.quantitySelected] = modifierInstance;
      modifierItemSelected.isComplete = Object.values(
        modifierItemSelected.modifierItemInstances
      ).every((instance) => instance.isComplete);
    } else if (!isOpenItem && ticketElement.customizerType !== "none" /* NONE */ && (modifierGroup == null ? void 0 : modifierGroup.activeCustomizerSectionSelector)) {
      handleCustomizerModifierItemIncrement(
        modifierItem,
        modifierItemSelected,
        modifierTagSizes,
        customizer
      );
    } else {
      modifierItemSelected.amountSelected = nextQuantityAmount(
        modifierItemSelected.amountSelected
      );
      modifierItemSelected.modifierSizeTag = modifierTagSizes[modifierItemSelected.amountSelected];
      modifierItemSelected.modifierItemInstances[1].amountSelected = nextQuantityAmount(
        modifierItemSelected.modifierItemInstances[1].amountSelected
      );
    }
    if (sortPriority)
      modifierItemSelected.sortPriority = sortPriority;
    modifierItemSelected.isComplete = Object.values(
      modifierItemSelected.modifierItemInstances
    ).every((instance) => instance.isComplete);
  }
  if (!isEmpty(modifierItem.modifierGroups)) {
    if (!((_d = modifierGroupSelected.modifierItemsWithNested) == null ? void 0 : _d.includes(modifierItemId)))
      modifierGroupSelected.modifierItemsWithNested = [
        ...(_e = modifierGroupSelected.modifierItemsWithNested) != null ? _e : [],
        modifierItemId
      ];
    Object.entries(modifierItemSelected.modifierItemInstances).forEach(
      ([, instance]) => {
        if (isEmpty(instance.nestedModifierGroupsSelected)) {
          instance.nestedModifierGroupsSelected = {};
          Object.entries((modifierItem == null ? void 0 : modifierItem.modifierGroups) || {}).forEach(
            ([nestedModifierGroupId, nestedModifierGroup]) => {
              const newNestedModifierGroupSelected = {
                isComplete: nestedModifierGroup.requiredModifierItems === 0,
                isNoneSelected: false,
                quantityRequired: nestedModifierGroup.requiredModifierItems,
                modifierGroupId: Number(nestedModifierGroupId),
                quantityMode: nestedModifierGroup.quantityMode,
                modifierItemsWithNested: [],
                modifierItemsSelected: {},
                totalPricePerItemUnit: 0,
                taxInclusiveTotalPricePerItemUnit: 0,
                customizerEnabled: false,
                locationModifierGroupId: nestedModifierGroup.locationModifierGroupId,
                locationModifierGroupVersionId: nestedModifierGroup.locationModifierGroupVersionId,
                showSearchBar: nestedModifierGroup.showSearchBar,
                global: nestedModifierGroup.global
              };
              instance.nestedModifierGroupsSelected[Number(nestedModifierGroupId)] = newNestedModifierGroupSelected;
            }
          );
        }
      }
    );
  }
};
var setModifierItemSelected = (ticketElement, modifierGroupId, baseModifierItem, modifierTagSizes) => {
  var _a;
  const modifierGroupSelected = ticketElement.modifierGroupsSelected[modifierGroupId];
  const modifierGroup = (_a = ticketElement.itemObj) == null ? void 0 : _a.menuTypeVersions[isOpenItemFn(ticketElement) ? 0 : ticketElement.menuTypeId].modifierGroups[modifierGroupId];
  const modifierItem = modifierGroup == null ? void 0 : modifierGroup.modifierItems[baseModifierItem.modifierItemId];
  if (!modifierItem || !modifierGroupSelected)
    return;
  addNewModifierItemSelected(
    modifierItem,
    modifierGroupSelected,
    modifierTagSizes,
    CUSTOMIZER_INITIAL_STATE
  );
  const modifierItemSelected = modifierGroupSelected.modifierItemsSelected[baseModifierItem.modifierItemId];
  Object.assign(modifierItemSelected, baseModifierItem);
  modifierItemSelected.isComplete = Object.values(
    modifierItemSelected.modifierItemInstances
  ).every((instance) => instance.isComplete);
};
var addNewModifierItemSelected = (modifierItem, modifierGroupSelected, modifierTagSizes, customizer, sortPriority) => {
  const modifierInstance = __spreadProps(__spreadValues({}, GET_MODIFIER_ITEM_INSTANCE_INITIAL_STATE()), {
    modifierItemInstanceId: 1,
    amountSelected: modifierItem.defaultAmountSelected || "regular" /* REGULAR */,
    customizerSectors: __spreadValues({}, customizer)
  });
  if (!isEmpty(modifierItem.modifierGroups)) {
    const nestedModifierGroupsSelected = mapNestedModGroups(
      modifierItem.modifierGroups,
      modifierTagSizes
    );
    modifierInstance.nestedModifierGroupsSelected = nestedModifierGroupsSelected;
  }
  modifierInstance.isComplete = initializeIsInstanceComplete(
    modifierInstance.nestedModifierGroupsSelected
  );
  modifierGroupSelected.isNoneSelected = false;
  modifierGroupSelected.modifierItemsSelected[modifierItem.modifierItemId] = __spreadProps(__spreadValues({}, GET_MODIFIER_ITEM_SELECTED_INITIAL_STATE()), {
    isComplete: modifierInstance.isComplete,
    modifierItemId: modifierItem.modifierItemId,
    sortPriority: sortPriority != null ? sortPriority : modifierItem.sortPriority,
    amountSelected: modifierItem.defaultAmountSelected || "regular" /* REGULAR */,
    modifierSizeTag: modifierGroupSelected.quantityMode === "Lt,Reg,Ext" /* SIZE */ ? modifierTagSizes[modifierItem.defaultAmountSelected || "regular" /* REGULAR */] : null,
    quantitySelected: 1,
    locationModifierItemId: modifierItem.locationModifierItemId,
    locationModifierItemVersionId: modifierItem.locationModifierItemVersionId,
    modifierItemInstances: {
      1: modifierInstance
    }
  });
};
var handleCustomizerModifierItemIncrement = (modifierItem, modifierItemSelected, modifierTagSizes, customizer) => {
  var _a, _b;
  const matchingInstanceId = (_a = Object.entries(
    modifierItemSelected.modifierItemInstances
  ).find(
    ([, instance]) => isEqual(instance.customizerSectors, customizer)
  )) == null ? void 0 : _a[0];
  const matchingInstance = modifierItemSelected.modifierItemInstances[Number(matchingInstanceId)];
  if (matchingInstance) {
    matchingInstance.amountSelected = nextQuantityAmount(
      matchingInstance.amountSelected
    );
    const instanceWithSameAmountEntry = Object.entries(
      modifierItemSelected.modifierItemInstances
    ).find(([, instance]) => {
      if (isEqual(instance, matchingInstance))
        return false;
      return instance.amountSelected === matchingInstance.amountSelected;
    });
    if (instanceWithSameAmountEntry) {
      const [instanceWithSameAmountId, instanceWithSameAmount] = instanceWithSameAmountEntry;
      Object.entries(instanceWithSameAmount.customizerSectors).forEach(
        ([sectorKey, sectorValue]) => {
          if (sectorValue) {
            matchingInstance.customizerSectors[sectorKey] = true;
          }
        }
      );
      delete modifierItemSelected.modifierItemInstances[Number(instanceWithSameAmountId)];
    }
  } else {
    const currentAmountSelected = Object.values(
      modifierItemSelected.modifierItemInstances
    ).reduce(
      (acc, instance) => {
        if (isCustomizerSuperSet(instance.customizerSectors, customizer)) {
          return instance.amountSelected;
        }
        return acc;
      },
      void 0
    );
    const nextAmountSelected = currentAmountSelected ? nextQuantityAmount(currentAmountSelected) : modifierItem.defaultAmountSelected;
    const instanceToMergeWithStringId = (_b = Object.entries(
      modifierItemSelected.modifierItemInstances
    ).find(
      ([, instance]) => instance.amountSelected === nextAmountSelected
    )) == null ? void 0 : _b[0];
    const instanceToMergeWith = modifierItemSelected.modifierItemInstances[Number(instanceToMergeWithStringId)];
    Object.entries(modifierItemSelected.modifierItemInstances).forEach(
      ([instanceKey, instance]) => {
        if (instanceKey === instanceToMergeWithStringId)
          return;
        Object.keys(instance.customizerSectors).forEach((sector) => {
          if (customizer[sector]) {
            modifierItemSelected.modifierItemInstances[Number(instanceKey)].customizerSectors[sector] = false;
          }
        });
      }
    );
    if (instanceToMergeWith) {
      Object.entries(customizer).forEach(([sectorKey, sectorValue]) => {
        if (sectorValue) {
          instanceToMergeWith.customizerSectors[sectorKey] = true;
        }
      });
    } else {
      const newInstanceId = Object.keys(modifierItemSelected.modifierItemInstances).reduce(
        (acc, curr) => Math.max(acc, Number(curr)),
        0
      ) + 1;
      let nestedModifierGroups = {};
      let nestedModsPrice = 0;
      if (!isEmpty(modifierItem.modifierGroups)) {
        nestedModifierGroups = mapNestedModGroups(
          modifierItem.modifierGroups,
          modifierTagSizes
        );
        nestedModsPrice = Object.values(nestedModifierGroups).reduce(
          (acc, modGroup) => acc + modGroup.totalPricePerItemUnit,
          0
        );
      }
      modifierItemSelected.modifierItemInstances[newInstanceId] = __spreadProps(__spreadValues({}, GET_MODIFIER_ITEM_INSTANCE_INITIAL_STATE()), {
        amountSelected: nextAmountSelected,
        customizerSectors: __spreadValues({}, customizer),
        price: nestedModsPrice,
        isComplete: initializeIsInstanceComplete(nestedModifierGroups)
      });
    }
    Object.entries(modifierItemSelected.modifierItemInstances).forEach(
      ([instanceKey, instance]) => {
        if (Object.values(instance.customizerSectors).every((v) => !v)) {
          delete modifierItemSelected.modifierItemInstances[Number(instanceKey)];
        }
      }
    );
  }
  const newAmount = Object.values(
    modifierItemSelected.modifierItemInstances
  ).reduce(
    (acc, instance) => getMaxSize(acc, instance.amountSelected),
    "light" /* LIGHT */
  );
  modifierItemSelected.amountSelected = newAmount;
};
var initializeIsInstanceComplete = (nestedModifierGroups) => {
  return isEmpty(nestedModifierGroups) || Object.values(nestedModifierGroups).every(
    (nestedModifierGroup) => nestedModifierGroup.isComplete
  );
};
var deleteModifierItemSelected = (ticketElement, modifierGroupId, modifierItemId, customizer) => {
  const currentModifierGroupSelected = ticketElement.modifierGroupsSelected[modifierGroupId];
  if (currentModifierGroupSelected.modifierItemsWithNested.includes(
    modifierItemId
  )) {
    currentModifierGroupSelected.modifierItemsWithNested = currentModifierGroupSelected.modifierItemsWithNested.filter(
      (id) => id !== modifierItemId
    );
  }
  if (currentModifierGroupSelected.customizerEnabled) {
    const newModifierItemSelected = currentModifierGroupSelected.modifierItemsSelected[modifierItemId];
    const matchingInstanceEntry = Object.entries(
      (newModifierItemSelected == null ? void 0 : newModifierItemSelected.modifierItemInstances) || {}
    ).find(([, instance]) => isEqual(instance.customizerSectors, customizer));
    if (matchingInstanceEntry) {
      delete newModifierItemSelected.modifierItemInstances[Number(matchingInstanceEntry[0])];
      newModifierItemSelected.quantitySelected -= 1;
    } else {
      for (const [instanceId, instance] of Object.entries(
        newModifierItemSelected.modifierItemInstances
      )) {
        for (const customizerSection in customizer) {
          if (customizer[customizerSection]) {
            instance.customizerSectors[customizerSection] = false;
          }
        }
        if (Object.values(instance.customizerSectors).every((value) => !value)) {
          delete newModifierItemSelected.modifierItemInstances[Number(instanceId)];
          newModifierItemSelected.quantitySelected -= 1;
        }
      }
    }
    if (isEmpty(newModifierItemSelected.modifierItemInstances)) {
      delete currentModifierGroupSelected.modifierItemsSelected[modifierItemId];
    }
  } else {
    delete currentModifierGroupSelected.modifierItemsSelected[modifierItemId];
  }
};
var setModifierItemSelectedQuantity = (ticketElement, modifierGroupId, modifierItemId, globalQuantity, modifierTagSizes, globalState, sortPriority) => {
  var _a, _b, _c;
  const prevQuantity = (_c = (_b = (_a = ticketElement.modifierGroupsSelected[modifierGroupId]) == null ? void 0 : _a.modifierItemsSelected[modifierItemId]) == null ? void 0 : _b.quantitySelected) != null ? _c : 0;
  const diff11 = globalQuantity - prevQuantity;
  if (diff11 > 0) {
    for (let i = 0; i < diff11; i++) {
      incrementModifierItemSelected2(
        ticketElement,
        modifierGroupId,
        modifierItemId,
        modifierTagSizes,
        CUSTOMIZER_INITIAL_STATE,
        globalState,
        sortPriority
      );
    }
    singleSelectDeleteOtherModifiers(
      ticketElement,
      modifierGroupId,
      modifierItemId,
      CUSTOMIZER_INITIAL_STATE
    );
  } else {
    for (let i = 0; i < -diff11; i++) {
      decrementModifierItemSelected2(
        ticketElement,
        modifierGroupId,
        modifierItemId,
        modifierTagSizes,
        CUSTOMIZER_INITIAL_STATE
      );
    }
  }
};

// src/helpers/register/reducerHelpers/payments.ts
var SERVICE_CHARGE_SORT_VALUES = {
  ["custom_dollar" /* CUSTOM_DOLLAR */]: 1,
  ["custom_percent" /* CUSTOM_PERCENT */]: 2,
  ["fixed" /* FIXED */]: 3,
  ["percent" /* PERCENT */]: 4
};
var SERVICE_CHARGE_DISCOUNT_SORT_VALUES = {
  ["pre discount" /* PRE_DISCOUNT */]: 1,
  ["post discount" /* POST_DISCOUNT */]: 2
};
var sortServiceChargesFunction = (dA, dB) => dA.chargeType === dB.chargeType ? dA.discount === dB.discount ? (dA.charge - dB.charge) * -1 : SERVICE_CHARGE_DISCOUNT_SORT_VALUES[dA.discount] - SERVICE_CHARGE_DISCOUNT_SORT_VALUES[dB.discount] : SERVICE_CHARGE_SORT_VALUES[dA.chargeType] - SERVICE_CHARGE_SORT_VALUES[dB.chargeType];
var compareDiscounts = (discountA, discountB) => {
  return discountA.discountId === discountB.discountId && discountA.type === discountB.type && discountA.value === discountB.value && discountA.appliedDiscountAmount === discountB.appliedDiscountAmount && discountA.additionalInfo === discountB.additionalInfo && discountA.discountReasonId === discountB.discountReasonId && discountA.discountReasonId === discountB.discountReasonId;
};
var ticketElementsAreEqual = (ticketElementA, ticketElementB) => {
  var _a, _b, _c, _d;
  const isSameItemId = ticketElementA.itemId === ticketElementB.itemId;
  if (!isSameItemId)
    return false;
  const isSameMenuTypeId = ticketElementA.menuTypeId === ticketElementB.menuTypeId;
  if (!isSameMenuTypeId)
    return false;
  const areSameCourse = ticketElementA.courseId === ticketElementB.courseId && ticketElementA.isTakeout === ticketElementB.isTakeout;
  if (!areSameCourse)
    return false;
  const areSameCourseNumber = ticketElementA.onTheFlyCourseNumber === ticketElementB.onTheFlyCourseNumber && ticketElementA.isTakeout === ticketElementB.isTakeout;
  if (!areSameCourseNumber)
    return false;
  const areSamePrepStation = ticketElementA.prepStationOverrideId === ticketElementB.prepStationOverrideId;
  if (!areSamePrepStation)
    return false;
  const areBothNotShared = ticketElementA.isShared === null && ticketElementB.isShared === null;
  if (!areBothNotShared)
    return false;
  const areBothPriceOverridden = ticketElementA.isPriceOverride === ticketElementB.isPriceOverride;
  if (!areBothPriceOverridden)
    return false;
  if (areBothPriceOverridden && ticketElementA.isPriceOverride) {
    const areBothSamePrice = ticketElementA.overridePricePerItemUnit === ticketElementB.overridePricePerItemUnit;
    if (!areBothSamePrice)
      return false;
  }
  if ((((_b = (_a = ticketElementA.itemObj) == null ? void 0 : _a.menuTypeVersions[ticketElementA.menuTypeId]) == null ? void 0 : _b.promptForPrice) || ((_d = (_c = ticketElementB.itemObj) == null ? void 0 : _c.menuTypeVersions[ticketElementA.menuTypeId]) == null ? void 0 : _d.promptForPrice)) && ticketElementA.baseItemPrice !== ticketElementB.baseItemPrice) {
    return false;
  }
  const areSameInstructions = ticketElementA.instructions === ticketElementB.instructions;
  if (!areSameInstructions)
    return false;
  const ticketElementAKeysArray = Object.keys(
    ticketElementA.modifierGroupsSelected
  );
  const ticketElementBKeysArray = Object.keys(
    ticketElementB.modifierGroupsSelected
  );
  const haveSameModsQuantity = ticketElementAKeysArray.length === ticketElementBKeysArray.length;
  if (!haveSameModsQuantity)
    return false;
  const areSameModifiersGroupsKeys = ticketElementAKeysArray.every(
    (ticketElementAKey) => ticketElementBKeysArray.includes(ticketElementAKey)
  );
  if (!areSameModifiersGroupsKeys)
    return false;
  let areSameModifierItems = true;
  const ticketElementModifierGroupsSelected = Object.values(
    ticketElementA.modifierGroupsSelected
  );
  for (let index = 0; index < ticketElementModifierGroupsSelected.length; index++) {
    const currentModifierGroupSelectedTicketElementA = ticketElementModifierGroupsSelected[index];
    const modifierItemKeysTicketElementA = Object.keys(
      currentModifierGroupSelectedTicketElementA.modifierItemsSelected
    );
    const modifierItemKeysTicketElementB = Object.keys(
      ticketElementB.modifierGroupsSelected[currentModifierGroupSelectedTicketElementA.modifierGroupId].modifierItemsSelected
    );
    if (modifierItemKeysTicketElementA.length !== modifierItemKeysTicketElementB.length) {
      areSameModifierItems = false;
      break;
    }
    const areSameModItemsInModGroup = modifierItemKeysTicketElementA.every(
      (modifierItemKeyTicketElementA) => modifierItemKeysTicketElementB.includes(modifierItemKeyTicketElementA)
    );
    if (!areSameModItemsInModGroup) {
      areSameModifierItems = false;
      break;
    }
    const modifierItemsSelected = Object.values(
      currentModifierGroupSelectedTicketElementA.modifierItemsSelected
    );
    for (let currentModifierItemIndex = 0; currentModifierItemIndex < modifierItemsSelected.length; currentModifierItemIndex++) {
      const currentModifierItemTicketElementA = modifierItemsSelected[currentModifierItemIndex];
      const currentModifierItemTicketElementB = ticketElementB.modifierGroupsSelected[currentModifierGroupSelectedTicketElementA.modifierGroupId].modifierItemsSelected[currentModifierItemTicketElementA.modifierItemId];
      const modifierItemTagTicketElementA = currentModifierItemTicketElementA.modifierTag;
      const modifierItemQuantityTicketElementA = currentModifierItemTicketElementA.quantitySelected;
      const modifierItemAmountTicketElementA = currentModifierItemTicketElementA.amountSelected;
      const modifierItemTagTicketElementB = currentModifierItemTicketElementB.modifierTag;
      const modifierItemQuantityTicketElementB = currentModifierItemTicketElementB.quantitySelected;
      const modifierItemAmountTicketElementB = currentModifierItemTicketElementB.amountSelected;
      if (!isEqual8(
        modifierItemTagTicketElementA,
        modifierItemTagTicketElementB
      ) || modifierItemQuantityTicketElementA !== modifierItemQuantityTicketElementB || modifierItemAmountTicketElementA !== modifierItemAmountTicketElementB) {
        areSameModifierItems = false;
        break;
      }
      const diff11 = deepDiff6(
        currentModifierItemTicketElementA.modifierItemInstances,
        currentModifierItemTicketElementB.modifierItemInstances
      );
      if (diff11)
        areSameModifierItems = false;
    }
  }
  if (!areSameModifierItems)
    return false;
  const ticketElementAIngredientsSelected = Object.keys(
    ticketElementA.ingredientsSelected
  );
  const ticketElementBIngredientsSelected = Object.keys(
    ticketElementB.ingredientsSelected
  );
  if (ticketElementAIngredientsSelected.length !== ticketElementBIngredientsSelected.length)
    return false;
  let areSameIngredients = true;
  areSameIngredients = ticketElementAIngredientsSelected.every(
    (ingredientKeyTicketElementA) => ticketElementBIngredientsSelected.includes(ingredientKeyTicketElementA)
  );
  if (!areSameIngredients)
    return false;
  const ticketElementIngredientsSelected = Object.values(
    ticketElementA.ingredientsSelected
  );
  for (let index = 0; index < ticketElementIngredientsSelected.length; index++) {
    const ingredientSelectedTicketElementA = ticketElementIngredientsSelected[index];
    const ingredientSelectedTicketElementB = ticketElementB.ingredientsSelected[ingredientSelectedTicketElementA.ingredientId];
    const ingredientAAmountSelected = ingredientSelectedTicketElementA.selectedAmount;
    const ingredientBAmountSelected = ingredientSelectedTicketElementB.selectedAmount;
    if (ingredientAAmountSelected !== ingredientBAmountSelected) {
      areSameIngredients = false;
      break;
    }
    if (!isEqual8(
      ingredientSelectedTicketElementA.modifierTag,
      ingredientSelectedTicketElementB.modifierTag
    )) {
      areSameIngredients = false;
      break;
    }
  }
  if (!areSameIngredients)
    return false;
  const specialsKeysTicketElementA = Object.values(
    ticketElementA.specials
  ).filter((special) => special.specialApplyTo !== "bogo" /* BOGO */);
  const specialsKeysTicketElementB = Object.values(
    ticketElementB.specials
  ).filter((special) => special.specialApplyTo !== "bogo" /* BOGO */);
  const hasSameSpecialQuantity = specialsKeysTicketElementA.length === specialsKeysTicketElementB.length;
  if (!hasSameSpecialQuantity)
    return 0;
  const discountKeysTicketElementA = Object.keys(ticketElementA.discounts);
  const discountKeysTicketElementB = Object.keys(ticketElementB.discounts);
  const hasSameDiscountQuantity = discountKeysTicketElementA.length === discountKeysTicketElementB.length;
  if (!hasSameDiscountQuantity)
    return 0;
  const discountArrayTicketElementA = Object.values(ticketElementA.discounts);
  const discountArrayTicketElementB = Object.values(ticketElementB.discounts);
  discountArrayTicketElementA.forEach((ticketElementADiscount) => {
    const isDiscountInTicketElementBDiscountArray = discountArrayTicketElementB.find(
      (ticketElementBDiscount) => compareDiscounts(ticketElementADiscount, ticketElementBDiscount)
    );
    if (!isDiscountInTicketElementBDiscountArray) {
      areSameModifierItems = false;
    }
  });
  return areSameModifierItems;
};
var mergeSeats = (seatA, seatB) => {
  const mergedSeats = __spreadValues({}, seatA);
  Object.entries(seatB).map(([key, value]) => [Number(key), value]).forEach(([key, value]) => {
    if (key in mergedSeats)
      mergedSeats[key] = mergedSeats[key] + value;
    else
      mergedSeats[key] = value;
  });
  return mergedSeats;
};
var combosAreEqual = (ticket, ticketElementA, ticketElementB) => {
  const areBothNotShared = ticketElementA.isShared === null && ticketElementB.isShared === null;
  if (!areBothNotShared)
    return false;
  const itemGroupsSelectedElementA = Object.values(
    ticketElementA.itemGroupsSelected
  );
  const itemGroupsSelectedElementB = ticketElementB.itemGroupsSelected;
  if (itemGroupsSelectedElementA.filter((itemGroup) => itemGroup.ticketElementId).length !== Object.values(itemGroupsSelectedElementB).filter(
    (itemGroup) => itemGroup.ticketElementId
  ).length)
    return false;
  const haveSameItemsSelected = itemGroupsSelectedElementA.every(
    (itemGroupSelectedElementA) => {
      var _a, _b, _c, _d, _e;
      const itemGroupItemSelectedElementA = (_b = ticket[(_a = itemGroupSelectedElementA.ticketElementId) != null ? _a : ""]) != null ? _b : null;
      const itemGroupItemSelectedElementB = (_e = ticket[(_d = (_c = itemGroupsSelectedElementB[itemGroupSelectedElementA.itemGroupId]) == null ? void 0 : _c.ticketElementId) != null ? _d : ""]) != null ? _e : null;
      const bothDoNotHaveItemSelected = itemGroupItemSelectedElementA === null && itemGroupItemSelectedElementB === null;
      if (bothDoNotHaveItemSelected)
        return true;
      if (itemGroupItemSelectedElementA === null || itemGroupItemSelectedElementB === null)
        return false;
      const areTicketsElementsEqual = ticketElementsAreEqual(
        itemGroupItemSelectedElementA,
        itemGroupItemSelectedElementB
      );
      return areTicketsElementsEqual;
    }
  );
  if (!haveSameItemsSelected)
    return false;
  const specialsKeysTicketElementA = Object.values(
    ticketElementA.specials
  ).filter((special) => special.specialApplyTo !== "bogo" /* BOGO */);
  const specialsKeysTicketElementB = Object.values(
    ticketElementB.specials
  ).filter((special) => special.specialApplyTo !== "bogo" /* BOGO */);
  const hasSameSpecialQuantity = specialsKeysTicketElementA.length === specialsKeysTicketElementB.length;
  if (!hasSameSpecialQuantity)
    return 0;
  const discountKeysTicketElementA = Object.keys(ticketElementA.discounts);
  const discountKeysTicketElementB = Object.keys(ticketElementB.discounts);
  const hasSameDiscountQuantity = discountKeysTicketElementA.length === discountKeysTicketElementB.length;
  if (!hasSameDiscountQuantity)
    return 0;
  const discountArrayTicketElementA = Object.values(ticketElementA.discounts);
  const discountArrayTicketElementB = Object.values(ticketElementB.discounts);
  let areSameDiscounts = true;
  discountArrayTicketElementA.forEach((ticketElementADiscount) => {
    const isDiscountInTicketElementBDiscountArray = discountArrayTicketElementB.find(
      (ticketElementBDiscount) => compareDiscounts(ticketElementADiscount, ticketElementBDiscount)
    );
    if (!isDiscountInTicketElementBDiscountArray) {
      areSameDiscounts = false;
    }
  });
  return areSameDiscounts;
};
function checkForRollUp(ticket, combos, onTicketRollUp, onCombosRollUp, skipSentItems = false) {
  const ticketResult = __spreadValues({}, ticket);
  const [completeTicketItems, completeTicketComboElements] = Object.values(
    ticket
  ).filter(isTicketElementComplete).filter(isNotOpenItemFn).filter((ticketElement) => !ticketElement.isOnHold).reduce(
    (acc, ticketElement) => {
      if (ticketElement.comboElementId) {
        acc[1].push(ticketElement);
      } else {
        acc[0].push(ticketElement);
      }
      return acc;
    },
    [[], []]
  );
  const nonDisabledTicketItems = completeTicketItems.filter(
    TicketElementNotInClosedCheck
  );
  const notSentTicketElements = skipSentItems ? nonDisabledTicketItems : nonDisabledTicketItems.filter(notTicketElementTriggered);
  const nonDisabledComboElements = completeTicketComboElements.filter(
    TicketElementNotInClosedCheck
  );
  const notSentComboElementIds = Array.from(
    new Set(
      nonDisabledComboElements.filter(notTicketElementTriggered).map((ticketElement) => `${ticketElement.comboElementId}`)
    )
  );
  const countIdsReducerFn = (acc, id) => {
    if (acc[id])
      return __spreadProps(__spreadValues({}, acc), { [id]: acc[id] + 1 });
    return __spreadProps(__spreadValues({}, acc), { [id]: 1 });
  };
  const comboElementIdsToRollUpCheck = [
    ...new Set(notSentComboElementIds).values()
  ].filter((comboElementId) => {
    const comboElement = combos[comboElementId];
    if (!comboElement)
      return false;
    if (!comboElement.isComplete)
      return false;
    if (comboElement.isInClosedCheck)
      return false;
    if (!isComboElementNotTriggered(comboElement, ticket))
      return false;
    return true;
  });
  const comboIdsCounter = comboElementIdsToRollUpCheck.map((comboElementId) => combos[comboElementId].comboId).reduce(countIdsReducerFn, {});
  const repeatedCombos = Object.entries(comboIdsCounter).filter(
    ([, count]) => count > 1
  );
  const itemIdsCounter = notSentTicketElements.map((ticketElement) => ticketElement.itemId).reduce(countIdsReducerFn, {});
  const repeatedItems = Object.entries(itemIdsCounter).filter(
    ([, count]) => count > 1
  );
  if (repeatedItems.length === 0 && repeatedCombos.length === 0)
    return 0;
  const rollUpTicketElementIds = [];
  repeatedItems.forEach(([key]) => {
    var _a, _b;
    const sameItemIdElements = notSentTicketElements.filter(
      (ticketItem) => ticketItem.itemId === Number(key)
    );
    const queue = [...sameItemIdElements];
    let endMarkerId;
    let pivot;
    let pivotRollUp;
    while (queue.length) {
      const current = queue.shift();
      const ticketElementId = getTicketElementId(current);
      if (endMarkerId === ticketElementId) {
        if (pivotRollUp == null ? void 0 : pivotRollUp.redundantIds.length) {
          rollUpTicketElementIds.push(pivotRollUp);
        }
        if (queue.length > 0)
          queue.push(current);
        endMarkerId = void 0;
        pivot = void 0;
        pivotRollUp = void 0;
        continue;
      }
      if (!(pivot && pivotRollUp)) {
        pivot = current;
        pivotRollUp = {
          uniqueId: ticketElementId,
          redundantIds: [],
          resultingQuantity: (_a = current.quantity) != null ? _a : 0,
          resultingSeats: current.seating
        };
        continue;
      }
      if (!ticketElementsAreEqual(pivot, current)) {
        queue.push(current);
        if (!endMarkerId)
          endMarkerId = ticketElementId;
        continue;
      }
      pivotRollUp.redundantIds.push(getTicketElementId(current));
      pivotRollUp.resultingQuantity += (_b = current.quantity) != null ? _b : 0;
      pivotRollUp.resultingSeats = mergeSeats(
        pivotRollUp.resultingSeats,
        current.seating
      );
    }
    if (pivotRollUp == null ? void 0 : pivotRollUp.redundantIds.length) {
      rollUpTicketElementIds.push(pivotRollUp);
    }
  });
  rollUpTicketElementIds.length && onTicketRollUp(rollUpTicketElementIds);
  const notSentComboElements = comboElementIdsToRollUpCheck.map(
    (comboElementId) => {
      const comboElement = combos[comboElementId];
      const itemGroupsSelectedWithTicketItem = Object.values(
        comboElement.itemGroupsSelected
      ).map((itemGroupSelected) => __spreadProps(__spreadValues({}, itemGroupSelected), {
        item: itemGroupSelected.ticketElementId ? ticket[itemGroupSelected.ticketElementId] : null
      })).reduce(
        (acc, itemGroupSelected) => __spreadProps(__spreadValues({}, acc), {
          [itemGroupSelected.itemGroupId]: itemGroupSelected
        }),
        {}
      );
      return __spreadProps(__spreadValues({}, comboElement), {
        itemGroupsSelected: itemGroupsSelectedWithTicketItem
      });
    }
  );
  const rollUpComboElementIds = [];
  repeatedCombos.forEach(([key]) => {
    var _a, _b;
    const sameItemIdElements = notSentComboElements.filter(
      (comboItem) => comboItem.comboId === Number(key)
    );
    const queue = [...sameItemIdElements];
    let endMarkerId;
    let pivot;
    let pivotRollUp;
    while (queue.length) {
      const current = queue.shift();
      const comboElementId = getTicketElementId(current);
      if (endMarkerId === comboElementId) {
        if (pivotRollUp == null ? void 0 : pivotRollUp.redundantIds.length) {
          rollUpComboElementIds.push(pivotRollUp);
        }
        endMarkerId = void 0;
        pivot = void 0;
        pivotRollUp = void 0;
        continue;
      }
      if (!(pivot && pivotRollUp)) {
        pivot = current;
        pivotRollUp = {
          uniqueId: comboElementId,
          redundantIds: [],
          resultingQuantity: (_a = current.quantity) != null ? _a : 0,
          resultingSeats: current.seating
        };
        continue;
      }
      if (!combosAreEqual(ticket, pivot, current)) {
        queue.push(current);
        if (!endMarkerId)
          endMarkerId = comboElementId;
        continue;
      }
      pivotRollUp.redundantIds.push(getTicketElementId(current));
      pivotRollUp.resultingQuantity += (_b = current.quantity) != null ? _b : 0;
      pivotRollUp.resultingSeats = mergeSeats(
        pivotRollUp.resultingSeats,
        current.seating
      );
    }
    if (pivotRollUp == null ? void 0 : pivotRollUp.redundantIds.length) {
      rollUpComboElementIds.push(pivotRollUp);
    }
  });
  rollUpComboElementIds.length && onCombosRollUp(rollUpComboElementIds);
  return Object.values(ticketResult).length;
}
function preventRollUpOriginalItem(ticketElementIds, ticketElementId) {
  return ticketElementIds.map((resume) => {
    if (resume.uniqueId === ticketElementId)
      return resume;
    if (resume.redundantIds.includes(ticketElementId))
      return __spreadProps(__spreadValues({}, resume), {
        uniqueId: ticketElementId,
        redundantIds: [
          ...resume.redundantIds.filter((id) => id !== ticketElementId),
          resume.uniqueId
        ]
      });
    return resume;
  });
}

// src/helpers/socket.ts
var createSocket = (authToken, orgId, locationId) => {
  const headers = {
    Authorization: `Bearer ${authToken}`
  };
  const socket = new WebSocket(
    `${baseUrl}/s/organization/${orgId}/location/${locationId}/ws`,
    null,
    { headers }
  );
  return socket;
};

// src/hooks/useOrderStatusName.ts
var MAIN_STATUS_ROUTE = "viewAllOrdersScreen.modals.filter.orderStatusNames";
var SUB_STATUS_ROUTE = "viewAllOrdersScreen.modals.filter.orderSubstatusNames";
var getOrderStatusName = (status, onlySubStatus = false) => {
  switch (status) {
    case "open-initiated" /* OPEN_INITIATED */:
      if (onlySubStatus)
        return i18n_config_default.t(`${SUB_STATUS_ROUTE}.${"initiated" /* INITIATED */}`);
      return `${i18n_config_default.t(
        `${MAIN_STATUS_ROUTE}.${"open" /* OPEN */}`
      )}-${i18n_config_default.t(`${SUB_STATUS_ROUTE}.${"initiated" /* INITIATED */}`)}`;
    case "open-ordered" /* OPEN_ORDERED */:
      if (onlySubStatus)
        return i18n_config_default.t(`${SUB_STATUS_ROUTE}.${"ordered" /* ORDERED */}`);
      return `${i18n_config_default.t(
        `${MAIN_STATUS_ROUTE}.${"open" /* OPEN */}`
      )}-${i18n_config_default.t(`${SUB_STATUS_ROUTE}.${"ordered" /* ORDERED */}`)}`;
    case "tip-pending" /* TIP_PENDING */:
      return i18n_config_default.t(`${MAIN_STATUS_ROUTE}.${"tip-pending" /* TIP_PENDING */}`);
    case "failed" /* FAILED */:
      return i18n_config_default.t(`${MAIN_STATUS_ROUTE}.${"failed" /* FAILED */}`);
    case "closed-batch pending" /* CLOSED_BATCH_PENDING */:
      if (onlySubStatus)
        return i18n_config_default.t(`${SUB_STATUS_ROUTE}.${"batchPending" /* BATCH_PENDING */}`);
      return `${i18n_config_default.t(
        `${MAIN_STATUS_ROUTE}.${"closed" /* CLOSED */}`
      )}-${i18n_config_default.t(`${SUB_STATUS_ROUTE}.${"batchPending" /* BATCH_PENDING */}`)}`;
    case "closed-complete" /* CLOSED_COMPLETE */:
      return `${i18n_config_default.t(`${MAIN_STATUS_ROUTE}.${"closed" /* CLOSED */}`)}`;
    case "other-ready for pickup" /* OTHER_READY_FOR_PICKUP */:
      if (onlySubStatus)
        return i18n_config_default.t(`${SUB_STATUS_ROUTE}.${"readyForPickup" /* READY_FOR_PICKUP */}`);
      return `${i18n_config_default.t(
        `${MAIN_STATUS_ROUTE}.${"other" /* OTHER */}`
      )}-${i18n_config_default.t(`${SUB_STATUS_ROUTE}.${"readyForPickup" /* READY_FOR_PICKUP */}`)}`;
    case "other-on the way" /* OTHER_ON_THE_WAY */:
      if (onlySubStatus)
        return i18n_config_default.t(`${SUB_STATUS_ROUTE}.${"onTheWay" /* ON_THE_WAY */}`);
      return `${i18n_config_default.t(
        `${MAIN_STATUS_ROUTE}.${"other" /* OTHER */}`
      )}-${i18n_config_default.t(`${SUB_STATUS_ROUTE}.${"onTheWay" /* ON_THE_WAY */}`)}`;
    case "other-voided" /* OTHER_VOIDED */:
      if (onlySubStatus)
        return i18n_config_default.t(`${SUB_STATUS_ROUTE}.${"voided" /* VOIDED */}`);
      return `${i18n_config_default.t(
        `${MAIN_STATUS_ROUTE}.${"other" /* OTHER */}`
      )}-${i18n_config_default.t(`${SUB_STATUS_ROUTE}.${"voided" /* VOIDED */}`)}`;
    default:
      return i18n_config_default.t(`${SUB_STATUS_ROUTE}.${"onTheWay" /* ON_THE_WAY */}`);
  }
};
var useOrderStatusName = (status, onlySubStatus = false) => {
  return getOrderStatusName(status, onlySubStatus);
};

// src/helpers/factories/orderStatusOptionsFactory.ts
var orderStatusToIndex = Object.values(OrderStatus).reduce(
  (acc, value) => {
    acc.index += 1;
    acc.values[value] = acc.index;
    return acc;
  },
  {
    index: 0,
    values: {}
  }
).values;
var indexToOrderStatus = Object.values(OrderStatus).reduce(
  (acc, value) => {
    acc.index += 1;
    acc.values[acc.index] = value;
    return acc;
  },
  { index: 0, values: {} }
).values;
var orderStatusOptionsArray = Object.values(OrderStatus).reduce(
  (acc, value) => {
    acc.index += 1;
    acc.values.push({
      label: getOrderStatusName(value),
      value: acc.index
    });
    return acc;
  },
  { index: 0, values: [] }
).values;
var useFormError = (name) => {
  const { clearError: clearError2 } = bindActionCreators(actions_exports16, useDispatch());
  const { t: t2 } = useTranslation();
  const selector = useMemo(
    () => createSelector(selectCurrentErrors, (data) => {
      const errorObj = get(data, name) || "";
      const [bucket2, error2] = errorObj.includes("-") ? errorObj.split("-") : ["Item", errorObj];
      return [bucket2, error2];
    }),
    [name]
  );
  const clear = useCallback(() => clearError2(name), [name, clearError2]);
  const [bucket, error] = useSelector(selector);
  return error ? { error: t2(`validations.${error}`, { bucket }), clear } : null;
};
var useFormError_default = useFormError;
var useMenuDetailsForm = (bucketName) => {
  const currentElementChangeData = useSelector(
    (state) => selectDataByBucketName(state, bucketName)
  );
  const {
    updateItem: updateItem2,
    updateMenuType: updateMenuType2,
    updateCategory: updateCategory2,
    updateSubcategory: updateSubcategory2,
    updateModifierGroup: updateModifierGroup2,
    updateModifierItem: updateModifierItem2,
    updateMenuBucket: updateMenuBucket2,
    updateItemGroup: updateItemGroup2,
    updateCombo: updateCombo2
  } = bindActionCreators(actions_exports16, useDispatch());
  const setValues = {
    menuTypes: updateMenuType2,
    categories: updateCategory2,
    subcategories: updateSubcategory2,
    items: updateItem2,
    modifierGroups: updateModifierGroup2,
    modifierItems: updateModifierItem2,
    discounts: updateMenuBucket2,
    combos: updateCombo2,
    itemGroups: updateItemGroup2,
    hotButtons: () => null,
    specials: () => null,
    ingredients: () => null,
    reportingGroups: updateMenuBucket2
  };
  const getValue = (keyString) => {
    if (keyString)
      return get$1(currentElementChangeData, keyString);
    return currentElementChangeData;
  };
  return {
    getValue,
    setValue: setValues[bucketName]
  };
};
var useMenuDetailsForm_default = useMenuDetailsForm;
var useModifierItemPriceCalc = (modifierItems, includedModifierItems, quantityMode, priceCalcMode) => {
  const selectedModifierItemElements = React.useMemo(() => {
    return getModifierItemPriceObject(modifierItems, quantityMode);
  }, [modifierItems, quantityMode]);
  const { additionalModifierItemsCount, includedModifierItemsCount } = React.useMemo(() => {
    const {
      includedModifierItems: _includedModifierItems,
      additionalModifierItems
    } = modifierItemsPriceAlgorithm(
      quantityMode,
      priceCalcMode,
      includedModifierItems,
      selectedModifierItemElements.count,
      selectedModifierItemElements.modifierItems,
      modifierItems
    );
    return {
      includedModifierItemsCount: _includedModifierItems,
      additionalModifierItemsCount: additionalModifierItems
    };
  }, [
    selectedModifierItemElements,
    includedModifierItems,
    quantityMode,
    priceCalcMode
  ]);
  const totalPriceMemo = React.useMemo(
    () => calculateTotalPrice(
      quantityMode,
      includedModifierItemsCount,
      additionalModifierItemsCount,
      modifierItems
    ),
    [
      additionalModifierItemsCount,
      includedModifierItemsCount,
      modifierItems,
      quantityMode
    ]
  );
  const totalDifferenceObj = React.useMemo(
    () => simulateAlgorithm(
      totalPriceMemo,
      selectedModifierItemElements,
      includedModifierItems,
      quantityMode,
      priceCalcMode,
      modifierItems
    ),
    [
      totalPriceMemo,
      selectedModifierItemElements,
      includedModifierItems,
      quantityMode,
      priceCalcMode,
      modifierItems
    ]
  );
  return {
    selectedModifierItemElements,
    includedModifierItemsCount,
    additionalModifierItemsCount,
    totalPrice: totalPriceMemo,
    totalDifferenceObj
  };
};
var getSettingsInitialState2 = (settingsSelected) => {
  switch (settingsSelected) {
    case "roles": {
      return ROLE_INITIAL_STATE;
    }
    case "users": {
      return USER_INITIAL_STATE;
    }
    case "licenseSettings": {
      return LICENSE_SETTINGS_INITIAL_STATE;
    }
  }
};
var useRefreshCustomer = (dispatch) => {
  const { setCustomersChangeData: setCustomersChangeData2 } = bindActionCreators(
    actions_exports,
    dispatch
  );
  const { showToast: showToast2, hideRefreshToast: hideRefreshToast2, setShowConfirmationModal: setShowConfirmationModal2 } = bindActionCreators(actions_exports14, dispatch);
  const getCustomerMergeData = (state) => {
    const newCurrentCustomers = getCurrentCustomersCore(state);
    const { data, originalData, id } = selectCustomerChangeData(state);
    const currentCustomers = selectCustomers(state);
    if (!data) {
      return {};
    }
    const originData = originalData || currentCustomers[id];
    const newData = cloneDeep16(newCurrentCustomers.customers[id]);
    return getMergedData({ newData, originData, data });
  };
  const getData = (state) => {
    return getCustomerMergeData(state);
  };
  const onRefresh = (state) => {
    const { errors, id, mode, hasChanges, finalDiffObject, data } = selectCustomerChangeData(state);
    const { type, active } = selectConfirmationModal(state);
    if (!data) {
      dispatch(hideRefreshToast2());
      return;
    }
    const isCreation = mode === "create" /* CREATE */;
    const currentCustomers = getCurrentCustomersCore(state);
    const originData = cloneDeep16(currentCustomers.customers[id]);
    if (!originData) {
      showToast2({
        type: "error",
        title: i18n_config_default.t("toasts.customerRemoved.title"),
        description: i18n_config_default.t("toasts.customerRemoved.description")
      });
      return;
    }
    const newData = getData(state);
    const newDifferences = isCreation ? [] : diff(originData, newData) || [];
    const newHasChanges = isCreation ? hasChanges : newDifferences.length > 0;
    setCustomersChangeData2({
      data: newData,
      id,
      mode,
      originalData: originData,
      hasChanges: newHasChanges,
      sectionId: "all" /* ALL */,
      differences: newDifferences,
      finalDiffObject,
      errors,
      customersVersion: getCustomersVersionCore(state) || 0,
      selectedLocations: []
    });
    if (active && type === "settingsDiff" && !newHasChanges) {
      setShowConfirmationModal2(CONFIRMATION_MODAL_INITIAL_STATE);
    }
    hideRefreshToast2();
    dispatch(updateCurrentCustomers());
  };
  return onRefresh;
};
var useRefreshCustomer_default = useRefreshCustomer;
var useRefreshMenu = (dispatch, getState) => {
  const {
    setChangeData: setChangeData2,
    updateFinalDiffObject: updateFinalDiffObject2,
    updateChangeMassUpdateDataValues: updateChangeMassUpdateDataValues2,
    updateMassUpdateFinalDiffObject: updateMassUpdateFinalDiffObject2
  } = bindActionCreators(actions_exports16, dispatch);
  const { hideRefreshToast: hideRefreshToast2, setShowConfirmationModal: setShowConfirmationModal2 } = bindActionCreators(
    actions_exports14,
    dispatch
  );
  const getNewBucketId = (bucket, bucketId) => {
    const currentMenu = getCurrentMenu();
    return currentMenu[bucket][bucketId] ? bucketId : 0;
  };
  const getFilteredBucketIds = (bucket, bucketIds) => {
    const currentMenu = getCurrentMenu();
    const currentBucketIds = Object.keys(currentMenu[bucket]);
    return bucketIds.filter((id) => currentBucketIds.includes(`${id}`));
  };
  const getFilteredSettingsIds = (settings, settingsIds) => {
    const currentSettings = getCurrentSettings().settings;
    const currentSettingsIds = Object.keys(
      settings === "prepStations" ? currentSettings.prepStations.prepStations : currentSettings[settings]
    );
    return settingsIds.filter((id) => currentSettingsIds.includes(`${id}`));
  };
  const getNewModifierItems = (modifierItemsObject, modifierGroupId) => {
    const currentMenu = getCurrentMenu();
    const currentModifierGroup = currentMenu.modifierGroups[modifierGroupId];
    if (!currentModifierGroup) {
      return {};
    }
    const currentEditingModifierItems = Object.keys(modifierItemsObject);
    const currentModifierItems = Object.keys(
      currentModifierGroup.modifierItems
    );
    const newModifierGroupIds = getLeftJoin(
      currentEditingModifierItems,
      currentModifierItems
    ).map((el) => Number(el));
    return newModifierGroupIds.length > 0 ? pick2(modifierItemsObject, newModifierGroupIds) : {};
  };
  const getNewModifierPricingVersion = (id, pricingVersionId, bucket) => {
    const currentMenu = getCurrentMenu();
    const modifierObject = currentMenu[bucket];
    const modifier = modifierObject[id];
    if (!modifier) {
      return 0;
    }
    if (bucket === "modifierGroups" && modifier.modifierGroupPricingVersions[pricingVersionId] || bucket === "modifierItems" && modifier.modifierItemPricingVersions[pricingVersionId]) {
      return pricingVersionId;
    }
    const pricingVersionArray = Object.keys(
      bucket === "modifierGroups" ? modifier.modifierGroupPricingVersions : modifier.modifierItemPricingVersions
    );
    return pricingVersionArray.length > 0 ? Number(pricingVersionArray[0]) : 0;
  };
  const getNewModifierGroups = (modifierGroupsObject) => {
    const currentMenu = getCurrentMenu();
    const currentEditingModifierGroups = Object.keys(modifierGroupsObject);
    const currentModifierGroup = Object.keys(currentMenu.modifierGroups);
    const newModifierGroupIds = getLeftJoin(
      currentEditingModifierGroups,
      currentModifierGroup
    ).map((el) => Number(el));
    return newModifierGroupIds.length > 0 ? __spreadValues({}, mapValues3(
      pick2(modifierGroupsObject, newModifierGroupIds),
      (modifierGroup, modifierGroupId) => __spreadProps(__spreadValues({}, modifierGroup), {
        defaultModifierGroupPricingVersionId: getNewModifierPricingVersion(
          Number(modifierGroupId) || 0,
          modifierGroup.defaultModifierGroupPricingVersionId || 0,
          "modifierGroups"
        ),
        modifierItems: getNewModifierItems(
          modifierGroup.modifierItems,
          Number(modifierGroupId) || 0
        )
      })
    )) : {};
  };
  const getNewIngredients = (ingredientsObject) => {
    const currentMenu = getCurrentMenu();
    const currentEditingIngredients = Object.keys(ingredientsObject);
    const currentIngredients = Object.keys(currentMenu.modifierGroups);
    const newIngredientIds = getLeftJoin(
      currentEditingIngredients,
      currentIngredients
    ).map((el) => Number(el));
    return newIngredientIds.length > 0 ? pick2(ingredientsObject, newIngredientIds) : {};
  };
  const getNewCategoriesSubcategories = (categoriesSubcategories, removeEmptyCategory = false) => {
    const newCategoriesAndSubcategoriesIds = Object.entries(
      categoriesSubcategories != null ? categoriesSubcategories : {}
    ).reduce((acc, [key, { categoryId, subcategoryId }]) => {
      const newCategoryId = getNewBucketId("categories", categoryId || 0) || null;
      const newSubcategoryId = getNewBucketId("subcategories", subcategoryId || 0) || null;
      if (removeEmptyCategory && !newCategoryId)
        return acc;
      return __spreadProps(__spreadValues({}, acc), {
        [key]: {
          categoryId: newCategoryId,
          subcategoryId: newSubcategoryId
        }
      });
    }, {});
    return newCategoriesAndSubcategoriesIds;
  };
  const getNewMenuTypeVersions = (menuTypeVersionsObj) => {
    const currentMenu = getCurrentMenu();
    const currentEditingMenuTypes = Object.keys(menuTypeVersionsObj);
    const currentMenuTypes = Object.keys(currentMenu.menuTypes);
    const newMenuTypeVersionIds = getLeftJoin(
      currentEditingMenuTypes,
      currentMenuTypes
    ).map((el) => Number(el));
    return newMenuTypeVersionIds.length > 0 ? __spreadValues({}, mapValues3(
      pick2(menuTypeVersionsObj, newMenuTypeVersionIds),
      (menuTypeVersion) => {
        const newCategoriesAndSubcategoriesIds = getNewCategoriesSubcategories(
          menuTypeVersion.categoriesSubcategories
        );
        return __spreadProps(__spreadValues({}, menuTypeVersion), {
          ingredients: getNewIngredients(menuTypeVersion.ingredients),
          categoriesSubcategories: newCategoriesAndSubcategoriesIds,
          modifierGroups: getNewModifierGroups(menuTypeVersion.modifierGroups)
        });
      }
    )) : {
      "0": MENU_TYPE_VERSION_INITIAL_STATE
    };
  };
  const getMenuMergeData = () => {
    const newCurrentMenu = getCurrentMenu();
    const state = getState();
    const currentMenu = state.menu.selectedMode.currentMenu;
    const { data, mode, id, bucketSelected } = state.menu.changeData;
    const isCreation = mode === "create" /* CREATE */;
    const isItemBucket = bucketSelected === "items";
    if (!bucketSelected || !data) {
      return {};
    }
    if (isCreation) {
      return data;
    }
    let originData = currentMenu[bucketSelected][id];
    let newData = cloneDeep16(newCurrentMenu[bucketSelected][id]);
    if (isItemBucket) {
      originData = preMakeItemWithModifierGroups(
        originData,
        state.menu
      );
      newData = preMakeItemWithModifierGroups(newData, state.menu);
    }
    return getMergedData({ newData, originData, data });
  };
  const getItemData = () => {
    const state = getState();
    const { bucketSelected } = state.menu.changeData;
    if (!bucketSelected) {
      return null;
    }
    const currentData = getMenuMergeData();
    const newData = __spreadProps(__spreadValues({}, currentData), {
      menuTypeVersions: getNewMenuTypeVersions(currentData.menuTypeVersions)
    });
    return newData;
  };
  const getItemMassUpdateData = () => {
    const bucketSelected = selectBucketSelected(getState());
    if (!bucketSelected) {
      return null;
    }
    const currentData = selectCurrentItem(getState());
    const newData = __spreadProps(__spreadValues({}, currentData), {
      categoriesSubcategories: getNewCategoriesSubcategories(
        currentData.categoriesSubcategories,
        true
      ),
      removeCategoriesSubcategories: getNewCategoriesSubcategories(
        currentData.removeCategoriesSubcategories,
        true
      ),
      modifierGroups: getNewModifierGroups(currentData.modifierGroups),
      ingredients: getNewIngredients(currentData.ingredients),
      removeModifierGroups: getFilteredBucketIds(
        "modifierGroups",
        currentData.removeModifierGroups.map(Number)
      ).map((id) => `${id}`),
      removeTaxIds: getFilteredSettingsIds("taxes", currentData.removeTaxIds),
      taxIds: getFilteredSettingsIds("taxes", currentData.taxIds),
      prepStationIds: getFilteredSettingsIds(
        "prepStations",
        currentData.prepStationIds
      ),
      removePrepStationIds: getFilteredSettingsIds(
        "prepStations",
        currentData.removePrepStationIds
      ),
      allModIds: getFilteredBucketIds("modifierGroups", currentData.allModIds)
    });
    return newData;
  };
  const getNewComboItemGroups = (itemGroupsObject) => {
    const currentMenu = getCurrentMenu();
    const currentItemIds = Object.keys(currentMenu.items).map(
      (itemId) => Number(itemId)
    );
    const currentEditingItemGroupIds = Object.keys(itemGroupsObject);
    const currentItemGroupIds = Object.keys(currentMenu.itemGroups);
    const newItemGroupIds = getLeftJoin(
      currentEditingItemGroupIds,
      currentItemGroupIds
    ).map((el) => Number(el));
    return currentEditingItemGroupIds.length > 0 ? __spreadValues({}, mapValues3(pick2(itemGroupsObject, newItemGroupIds), (itemGroup) => __spreadProps(__spreadValues({}, itemGroup), {
      items: pick2(itemGroup.items, currentItemIds)
    }))) : {};
  };
  const getNewComboMenuTypeVersions = (menuTypeVersionsObj) => {
    const currentMenu = getCurrentMenu();
    const currentEditingMenuTypes = Object.keys(menuTypeVersionsObj);
    const currentMenuTypes = Object.keys(currentMenu.menuTypes);
    const newMenuTypeVersionIds = getLeftJoin(
      currentEditingMenuTypes,
      currentMenuTypes
    ).map((el) => Number(el));
    return newMenuTypeVersionIds.length > 0 ? __spreadValues({}, mapValues3(
      pick2(menuTypeVersionsObj, newMenuTypeVersionIds),
      (menuTypeVersion) => {
        var _a;
        const newCategoriesAndSubcategoriesIds = Object.entries(
          (_a = menuTypeVersion.categoriesSubcategories) != null ? _a : {}
        ).reduce((acc, [key, { categoryId, subcategoryId }]) => {
          const newCategoryId = getNewBucketId("categories", categoryId || 0) || null;
          const newSubcategoryId = getNewBucketId("subcategories", subcategoryId || 0) || null;
          return __spreadProps(__spreadValues({}, acc), {
            [key]: {
              categoryId: newCategoryId,
              subcategoryId: newSubcategoryId
            }
          });
        }, {});
        return __spreadProps(__spreadValues({}, menuTypeVersion), {
          itemGroups: getNewComboItemGroups(menuTypeVersion.itemGroups),
          categoriesSubcategories: newCategoriesAndSubcategoriesIds
        });
      }
    )) : {
      "0": COMBO_MENU_TYPE_VERSION_INITIAL_STATE
    };
  };
  const getComboData = () => {
    const { bucketSelected } = getState().menu.changeData;
    if (!bucketSelected) {
      return null;
    }
    const currentData = getMenuMergeData();
    const newData = __spreadProps(__spreadValues({}, currentData), {
      menuTypeVersions: getNewComboMenuTypeVersions(
        currentData.menuTypeVersions
      )
    });
    return newData;
  };
  const getNewSpecialMenuTypeVersions = (menuTypeVersionsObj) => {
    const currentMenu = getCurrentMenu();
    const currentEditingMenuTypes = Object.keys(menuTypeVersionsObj);
    const currentMenuTypes = Object.keys(currentMenu.menuTypes);
    const newMenuTypeVersionIds = getLeftJoin(
      currentEditingMenuTypes,
      currentMenuTypes
    ).map((el) => Number(el));
    return newMenuTypeVersionIds.length > 0 ? __spreadValues({}, mapValues3(
      pick2(menuTypeVersionsObj, newMenuTypeVersionIds),
      (menuTypeVersion) => __spreadProps(__spreadValues({}, menuTypeVersion), {
        buyItemIds: getFilteredBucketIds(
          "items",
          menuTypeVersion.buyItemIds
        ),
        getItemIds: getFilteredBucketIds(
          "items",
          menuTypeVersion.getItemIds
        )
      })
    )) : {
      "0": SPECIAL_MENU_TYPE_VERSION_INITIAL_STATE
    };
  };
  const getSpecialData = () => {
    const { bucketSelected } = getState().menu.changeData;
    if (!bucketSelected) {
      return null;
    }
    const currentData = getMenuMergeData();
    const newData = __spreadProps(__spreadValues({}, currentData), {
      menuTypeVersions: getNewSpecialMenuTypeVersions(
        currentData.menuTypeVersions
      )
    });
    return newData;
  };
  const getSubcategoryData = () => {
    const { bucketSelected } = getState().menu.changeData;
    if (!bucketSelected) {
      return null;
    }
    const currentData = getMenuMergeData();
    const newCategoryId = getNewBucketId(
      "categories",
      currentData.categoryId || 0
    );
    const newData = __spreadProps(__spreadValues({}, currentData), {
      categoryId: newCategoryId,
      itemIds: getFilteredBucketIds("items", currentData.itemIds)
    });
    return newData;
  };
  const getCategorySubcategoryMenuTypeItemIds = (subcategoryMenuTypeElementIds, bucket) => {
    const subcategories = [
      0,
      ...getFilteredBucketIds(
        "subcategories",
        Object.keys(subcategoryMenuTypeElementIds || {}).map((id) => Number(id))
      )
    ];
    const newSubcategoryElementIds = pick2(
      subcategoryMenuTypeElementIds,
      subcategories
    );
    const allMenuTypes = /* @__PURE__ */ new Set();
    const allElements = /* @__PURE__ */ new Set();
    Object.values(newSubcategoryElementIds).forEach((menuTypeVersionItemIds) => {
      Object.entries(menuTypeVersionItemIds).forEach(
        ([menuTypeVersionId, elementIds]) => {
          allMenuTypes.add(Number(menuTypeVersionId));
          elementIds.forEach(allElements.add, allElements);
        }
      );
    });
    const menuTypes = getFilteredBucketIds(
      "menuTypes",
      Array.from(allMenuTypes)
    );
    const elements = getFilteredBucketIds(bucket, Array.from(allElements));
    Object.keys(newSubcategoryElementIds).forEach((subcategoryId) => {
      const newSubcategoryMenuTypeElementIds = pick2(
        newSubcategoryElementIds[Number(subcategoryId)],
        menuTypes
      );
      newSubcategoryElementIds[Number(subcategoryId)] = newSubcategoryMenuTypeElementIds;
      Object.keys(newSubcategoryMenuTypeElementIds).forEach((menuTypeId) => {
        const newElements = newSubcategoryElementIds[Number(subcategoryId)][Number(menuTypeId)].filter((elementId) => elements.includes(elementId));
        newSubcategoryElementIds[Number(subcategoryId)][Number(menuTypeId)] = newElements;
      });
    });
    return newSubcategoryElementIds;
  };
  const getCategoryData = () => {
    const { bucketSelected } = getState().menu.changeData;
    if (!bucketSelected) {
      return null;
    }
    const currentData = getMenuMergeData();
    const newData = __spreadProps(__spreadValues({}, currentData), {
      menuTypeIds: getFilteredBucketIds("menuTypes", currentData.menuTypeIds),
      itemIds: getFilteredBucketIds("items", currentData.itemIds),
      subcategoryIds: getFilteredBucketIds(
        "subcategories",
        currentData.subcategoryIds
      ),
      subcategoryMenuTypeItemsIds: getCategorySubcategoryMenuTypeItemIds(
        currentData.subcategoryMenuTypeItemsIds,
        "items"
      ),
      subcategoryMenuTypeCombosIds: getCategorySubcategoryMenuTypeItemIds(
        currentData.subcategoryMenuTypeCombosIds,
        "combos"
      )
    });
    return newData;
  };
  const getModifierItemData = () => {
    const { bucketSelected } = getState().menu.changeData;
    if (!bucketSelected) {
      return null;
    }
    const currentData = getMenuMergeData();
    const newData = __spreadProps(__spreadValues({}, currentData), {
      modifierGroups: getNewModifierGroups(
        currentData.modifierGroups
      )
    });
    return newData;
  };
  const getNewModifierGroupPricingVersions = (pricingVersionsObject, newModifierItems) => {
    return mapValues3(pricingVersionsObject, (pricingVersion) => {
      return __spreadProps(__spreadValues({}, pricingVersion), {
        modItemPricingVersions: mapValues3(
          pick2(pricingVersion.modItemPricingVersions, newModifierItems),
          (pricingVersionId, modifierItemId) => getNewModifierPricingVersion(
            Number(modifierItemId) || 0,
            pricingVersionId || 0,
            "modifierItems"
          )
        )
      });
    });
  };
  const getModifierGroupData = () => {
    const { bucketSelected } = getState().menu.changeData;
    if (!bucketSelected) {
      return null;
    }
    const currentData = getMenuMergeData();
    const newModifierItems = getFilteredBucketIds(
      "modifierItems",
      Object.keys(currentData.modifierItems).map((id) => Number(id))
    );
    const newData = __spreadProps(__spreadValues({}, currentData), {
      modifierItems: pick2(currentData.modifierItems, newModifierItems),
      modifierGroupPricingVersions: getNewModifierGroupPricingVersions(
        currentData.modifierGroupPricingVersions,
        newModifierItems
      )
    });
    return newData;
  };
  const getMenuTypeItemMenuTypeTemplateIds = (itemMenuTypeTemplateIds, bucket) => {
    const currentMenu = getCurrentMenu();
    return pickBy(
      itemMenuTypeTemplateIds,
      (menuTypeId, itemId) => currentMenu[bucket][Number(itemId)] && currentMenu.menuTypes[menuTypeId]
    );
  };
  const getMenuTypeData = () => {
    const { bucketSelected } = getState().menu.changeData;
    if (!bucketSelected) {
      return null;
    }
    const currentData = getMenuMergeData();
    const newItemsMenuTypeTemplateIds = getMenuTypeItemMenuTypeTemplateIds(
      currentData.itemMenuTypeTemplateIds,
      "items"
    );
    const newCombosMenuTypeTemplateIds = getMenuTypeItemMenuTypeTemplateIds(
      currentData.comboMenuTypeTemplateIds,
      "combos"
    );
    const deletedItemIds = difference(
      Object.keys(currentData.itemMenuTypeTemplateIds),
      Object.keys(newItemsMenuTypeTemplateIds)
    );
    const deletedComboIds = difference(
      Object.keys(currentData.comboMenuTypeTemplateIds),
      Object.keys(newCombosMenuTypeTemplateIds)
    );
    const newItemIds = getFilteredBucketIds(
      "items",
      currentData.itemIds
    ).filter((itemId) => !deletedItemIds.includes(`${itemId}`));
    const newComboIds = getFilteredBucketIds(
      "combos",
      currentData.comboIds
    ).filter((comboId) => !deletedComboIds.includes(`${comboId}`));
    const newData = __spreadProps(__spreadValues({}, currentData), {
      itemIds: newItemIds,
      comboIds: newComboIds,
      categoryIds: getFilteredBucketIds("categories", currentData.categoryIds),
      itemMenuTypeTemplateIds: newItemsMenuTypeTemplateIds,
      comboMenuTypeTemplateIds: newCombosMenuTypeTemplateIds
    });
    return newData;
  };
  const getIngredientData = () => {
    const { bucketSelected } = getState().menu.changeData;
    if (!bucketSelected) {
      return null;
    }
    const currentData = getMenuMergeData();
    const newItemIds = getFilteredBucketIds("items", currentData.itemIds);
    const newData = __spreadProps(__spreadValues({}, currentData), {
      itemIds: getFilteredBucketIds("items", currentData.itemIds),
      itemMenuTypeIds: pick2(currentData.itemMenuTypeIds, newItemIds)
    });
    return newData;
  };
  const getReportingGroupData = () => {
    const { bucketSelected } = getState().menu.changeData;
    if (!bucketSelected) {
      return null;
    }
    const currentData = getMenuMergeData();
    const newData = __spreadProps(__spreadValues({}, currentData), {
      itemIds: getFilteredBucketIds("items", currentData.itemIds),
      comboIds: getFilteredBucketIds("combos", currentData.comboIds)
    });
    return newData;
  };
  const getItemGroupData = () => {
    const { bucketSelected } = getState().menu.changeData;
    if (!bucketSelected) {
      return null;
    }
    const currentMenu = getCurrentMenu();
    const currentData = getMenuMergeData();
    const currentEditingItemIds = Object.keys(currentData.items);
    const currentItems = Object.keys(currentMenu.items);
    const newItemIds = getLeftJoin(currentEditingItemIds, currentItems).map(
      (el) => Number(el)
    );
    const newItems = newItemIds.length > 0 ? pick2(currentData.items, newItemIds) : {};
    const newData = __spreadProps(__spreadValues({}, currentData), {
      items: newItems,
      parentComboIds: getFilteredBucketIds(
        "combos",
        currentData.parentComboIds
      )
    });
    return newData;
  };
  const getDiscountData = () => {
    const { bucketSelected } = getState().menu.changeData;
    if (!bucketSelected) {
      return null;
    }
    const newData = getMenuMergeData();
    return newData;
  };
  const getData = () => {
    const { bucketSelected } = getState().menu.changeData;
    switch (bucketSelected) {
      case "items":
        return getItemData();
      case "subcategories":
        return getSubcategoryData();
      case "categories":
        return getCategoryData();
      case "menuTypes":
        return getMenuTypeData();
      case "modifierItems":
        return getModifierItemData();
      case "modifierGroups":
        return getModifierGroupData();
      case "combos":
        return getComboData();
      case "specials":
        return getSpecialData();
      case "ingredients":
        return getIngredientData();
      case "reportingGroups":
        return getReportingGroupData();
      case "itemGroups":
        return getItemGroupData();
      case "discounts":
        return getDiscountData();
      default:
        return getItemData();
    }
  };
  const getMassUpdateData = () => {
    const bucketSelected = selectBucketSelected(getState());
    switch (bucketSelected) {
      case "items":
        return getItemMassUpdateData();
      default:
        return getItemMassUpdateData();
    }
  };
  const getCurrentMenu = () => {
    const state = getState();
    return getCurrentMenuCore(state);
  };
  const getCurrentSettings = () => {
    return getCurrentSettingsCore(getState());
  };
  const onRefresh = () => {
    const state = getState();
    const { errors, hasChanges, finalDiffObject } = selectChangeDataOrChangeMassUpdateData(state);
    const { id, mode } = selectChangeData(state);
    const bucketSelected = selectBucketSelected(state);
    const isMassUpdate = selectIsMassUpdate(state);
    const { type, active } = selectConfirmationModal(state);
    const menuType = selectCurrentMenuType(state);
    if (!bucketSelected) {
      dispatch(hideRefreshToast2());
      return;
    }
    const currentMenu = getCurrentMenu();
    const isItemBucket = bucketSelected === "items";
    const isCreation = mode === "create" /* CREATE */;
    let newData = getData();
    let originData = currentMenu[bucketSelected][id];
    if (isItemBucket && !isMassUpdate) {
      newData = preMakeItemWithModifierGroups(newData, state.menu);
      originData = preMakeItemWithModifierGroups(
        originData,
        state.menu
      );
    }
    let newDifferences = isCreation ? [] : diff(originData, newData) || [];
    let newHasChanges = isCreation ? hasChanges : newDifferences.length > 0;
    if (isMassUpdate) {
      const { bucketIds, selectionCriteria } = state.menu.changeMassUpdateData;
      const newMassUpdateData = getMassUpdateData();
      newDifferences = getItemMassUpdateDifferences(
        newMassUpdateData
      );
      newHasChanges = newDifferences.length > 0;
      updateChangeMassUpdateDataValues2({
        data: newMassUpdateData,
        bucketIds: getFilteredBucketIds(bucketSelected, bucketIds),
        selectionCriteria: selectionCriteria ? {
          menuTypeIds: getFilteredBucketIds(
            "menuTypes",
            selectionCriteria.menuTypeIds
          ),
          categoryIds: selectionCriteria.categoryIds ? getFilteredBucketIds(
            "categories",
            selectionCriteria.categoryIds
          ) : null,
          subcategoryIds: selectionCriteria.subcategoryIds ? getFilteredBucketIds(
            "subcategories",
            selectionCriteria.subcategoryIds
          ) : null
        } : selectionCriteria,
        hasChanges: newHasChanges,
        sectionId: "all" /* ALL */,
        differences: newDifferences,
        errors,
        menuVersion: dispatch(
          getMenuVersion()
        ) || 0
      });
      updateMassUpdateFinalDiffObject2(newDifferences);
    } else {
      setChangeData2({
        bucketSelected,
        id,
        data: newData,
        hasChanges: newHasChanges,
        sectionId: "all" /* ALL */,
        mode,
        differences: newDifferences,
        finalDiffObject,
        errors,
        menuVersion: dispatch(
          getMenuVersion()
        ) || 0,
        selectedLocations: []
      });
      updateFinalDiffObject2(newDifferences);
    }
    if (active && type === "diff" && !newHasChanges) {
      setShowConfirmationModal2(CONFIRMATION_MODAL_INITIAL_STATE);
    }
    hideRefreshToast2();
    if (menuType !== "remoteLocationMenu" /* REMOTE_LOCATION_MENU */) {
      dispatch(updateCurrentMenu());
    }
  };
  return onRefresh;
};
var useRefreshMenu_default = useRefreshMenu;
var getSettingsInitialState3 = (settingsSelected) => {
  switch (settingsSelected) {
    case "roles": {
      return ROLE_INITIAL_STATE;
    }
    case "users": {
      return USER_INITIAL_STATE;
    }
    case "licenseSettings": {
      return LICENSE_SETTINGS_INITIAL_STATE;
    }
  }
};
var useRefreshSettings = (dispatch, onBreadcrumbPress) => {
  const { setSettingsChangeData: setSettingsChangeData2 } = bindActionCreators(
    actions_exports$1,
    dispatch
  );
  const { addSettingsBreadCrumbLocation: addSettingsBreadCrumbLocation2 } = bindActionCreators(
    actions_exports6,
    dispatch
  );
  const { showToast: showToast2, hideRefreshToast: hideRefreshToast2, setShowConfirmationModal: setShowConfirmationModal2 } = bindActionCreators(actions_exports14, dispatch);
  const getSettingsMergeData = (state) => {
    const newCurrentSettings = getCurrentSettingsCore(state);
    const { data, settingsSelected, originalData, id } = selectSettingsChangeData(state);
    const hasMultipleLocations = selectShouldRenderLocationDropdown(state);
    const currentSettings = settingsSelected === "printerRules" && !hasMultipleLocations ? selectLocationSettings(state) : selectCurrentSettings(state);
    if (!settingsSelected || !data) {
      return {};
    }
    const originData = originalData || (id ? currentSettings[settingsSelected][id] : currentSettings[settingsSelected]);
    let newData = cloneDeep16(
      id ? newCurrentSettings.settings[settingsSelected][id] : newCurrentSettings.settings[settingsSelected]
    );
    if ((settingsSelected === "licenseSettings" || settingsSelected === "roles") && id === 0) {
      newData = data;
    }
    return getMergedData({ newData, originData, data });
  };
  const getRegisterData = (state) => {
    const settingsSelected = selectSettingsSelected(state);
    if (!settingsSelected) {
      return null;
    }
    return getSettingsMergeData(state);
  };
  const getGeneralData = (state) => {
    const settingsSelected = selectSettingsSelected(state);
    if (!settingsSelected) {
      return null;
    }
    return getSettingsMergeData(state);
  };
  const getRegisterTicketData = (state) => {
    const settingsSelected = selectSettingsSelected(state);
    if (!settingsSelected) {
      return null;
    }
    return getSettingsMergeData(state);
  };
  const getKitchenTicketData = (state) => {
    const settingsSelected = selectSettingsSelected(state);
    if (!settingsSelected) {
      return null;
    }
    return getSettingsMergeData(state);
  };
  const getRolesTicketData = (state) => {
    const settingsSelected = selectSettingsSelected(state);
    if (!settingsSelected) {
      return null;
    }
    return getSettingsMergeData(state);
  };
  const getUsersData = (state) => {
    const locations = Object.values(state.locations).map((locationGroup) => locationGroup.locations).flat().map((location) => location.id);
    const roles = Object.values(
      state.settings.selectedMode.currentSettings.roles
    ).map((role) => role.id);
    const settingsSelected = selectSettingsSelected(state);
    if (!settingsSelected) {
      return null;
    }
    const currentData = getSettingsMergeData(state);
    if (!currentData) {
      return currentData;
    }
    const newLocationsWithRoleIds = {};
    currentData.locationsWithRoleIds && Object.keys(currentData.locationsWithRoleIds).filter((id) => locations.includes(Number(id))).forEach((id) => {
      newLocationsWithRoleIds[id] = currentData.locationsWithRoleIds[id].filter((roleId) => roles.includes(roleId));
    });
    const newData = __spreadProps(__spreadValues({}, currentData), {
      locationIds: currentData.locationIds.filter((id) => locations.includes(id)),
      roleIds: currentData.roleIds.filter((id) => roles.includes(id)),
      locationsWithRoleIds: newLocationsWithRoleIds
    });
    return newData;
  };
  const getPrepStationsData = (state) => {
    var _a, _b, _c, _d;
    const printers = (_d = (_c = (_b = (_a = state.settings) == null ? void 0 : _a.selectedMode) == null ? void 0 : _b.currentSettings) == null ? void 0 : _c.devices) == null ? void 0 : _d.printers;
    const printerIds = printers ? Object.values(printers).map((role) => role.id) : [];
    const currentData = getSettingsMergeData(state);
    const newData = __spreadProps(__spreadValues({}, currentData), {
      prepStations: mapValues3(
        currentData.prepStations,
        (prepStation) => __spreadProps(__spreadValues({}, prepStation), {
          printerIds: prepStation.printerIds.filter(
            (id) => printerIds.includes(id)
          )
        })
      )
    });
    return newData;
  };
  const getPrinterRulesData = (state) => {
    const settingsSelected = selectSettingsSelected(state);
    if (!settingsSelected) {
      return null;
    }
    return getSettingsMergeData(state);
  };
  const getLicenseSettingsData = (state) => {
    const settingsSelected = selectSettingsSelected(state);
    if (!settingsSelected) {
      return null;
    }
    return getSettingsMergeData(state);
  };
  const getData = (state) => {
    const settingsSelected = selectSettingsSelected(state);
    switch (settingsSelected) {
      case "register":
        return getRegisterData(state);
      case "general":
        return getGeneralData(state);
      case "registerTicket":
        return getRegisterTicketData(state);
      case "kitchenTicket":
        return getKitchenTicketData(state);
      case "roles":
        return getRolesTicketData(state);
      case "users":
        return getUsersData(state);
      case "prepStations":
        return getPrepStationsData(state);
      case "printerRules":
        return getPrinterRulesData(state);
      case "licenseSettings":
        return getLicenseSettingsData(state);
      default:
        return getRegisterData(state);
    }
  };
  const onRefresh = (state) => {
    const {
      originalData,
      settingsSelected,
      errors,
      id,
      mode,
      hasChanges,
      finalDiffObject
    } = selectSettingsChangeData(state);
    const { type, active } = selectConfirmationModal(state);
    const settingsType = selectSettingsType(state);
    if (!settingsSelected) {
      dispatch(hideRefreshToast2());
      return;
    }
    const isPrinterRules = settingsSelected === "printerRules";
    const hasMultipleLocations = selectShouldRenderLocationDropdown(state);
    const isCreation = mode === "create" /* CREATE */;
    const currentSettings = getCurrentSettingsCore(state);
    let originData = cloneDeep16(
      id ? currentSettings.settings[settingsSelected][id] : currentSettings.settings[settingsSelected]
    );
    if (!originData) {
      showToast2({
        type: "error",
        title: i18n_config_default.t("toasts.settingRemoved.title"),
        description: i18n_config_default.t("toasts.settingRemoved.description")
      });
      addSettingsBreadCrumbLocation2({
        action: "nav-main" /* NAV_MAIN */,
        text: "",
        onPress: () => onBreadcrumbPress
      });
      return;
    }
    const newData = getData(state);
    if ((settingsSelected === "licenseSettings" || settingsSelected === "roles") && id === 0) {
      originData = originalData;
    }
    if (settingsSelected === "users") {
      const userOriginData = __spreadProps(__spreadValues({}, originData), { locationsWithRoleIds: {} });
      originData = userOriginData;
    }
    const newDifferences = isCreation ? [] : diff(originData, newData) || [];
    const newHasChanges = isCreation ? hasChanges : newDifferences.length > 0;
    setSettingsChangeData2({
      settingsSelected,
      data: newData,
      id,
      mode,
      originalData: originData,
      hasChanges: newHasChanges,
      sectionId: "all" /* ALL */,
      differences: newDifferences,
      finalDiffObject,
      errors,
      settingsVersion: isPrinterRules && !hasMultipleLocations ? getCurrentSettingsCore(state, "location" /* LOCATION_SETTINGS */).version : getSettingsVersionCore(state) || 0,
      selectedLocations: []
    });
    if (active && type === "settingsDiff" && !newHasChanges) {
      setShowConfirmationModal2(CONFIRMATION_MODAL_INITIAL_STATE);
    }
    hideRefreshToast2();
    if (settingsType !== "remoteLocation" /* REMOTE_LOCATION_SETTINGS */) {
      dispatch(updateCurrentSettings());
    }
  };
  return onRefresh;
};
var useRefreshSettings_default = useRefreshSettings;

// src/helpers/toastStamp.ts
var getToastStamp = (state) => {
  const orderObj = selectCurrentOrderObj(state);
  const tables = selectTables(state);
  const restaurantMode = selectRestaurantMode(state);
  let returnUndefined = true;
  const lockScreenDetails = {
    userName: "",
    orderName: ""
  };
  const userName = state.loggedInUser.posName;
  if (userName) {
    lockScreenDetails.userName = userName;
    returnUndefined = false;
  }
  if (orderObj == null ? void 0 : orderObj.name) {
    lockScreenDetails.orderName = orderObj.name;
  } else if (restaurantMode === "tsr" /* TSR */ && (orderObj == null ? void 0 : orderObj.tableId) && tables[orderObj.tableId]) {
    lockScreenDetails.orderName = `${i18n_config_default.t("commonTexts.table")} #${tables[orderObj.tableId].tableNumber}`;
  } else {
    lockScreenDetails.orderName = `#${orderObj == null ? void 0 : orderObj.orderNumber}`;
  }
  if (lockScreenDetails.orderName)
    returnUndefined = false;
  if (returnUndefined)
    return void 0;
  return lockScreenDetails;
};
var useLoadReportsChangeData = (id, bucket, isQuickReport = false) => {
  const dispatch = useDispatch();
  const loadReportBucketChangeData2 = bindActionCreators(
    actions_exports13.loadReportBucketChangeData,
    dispatch
  );
  const resetReportsChangeData2 = bindActionCreators(
    actions_exports13.resetReportsChangeData,
    dispatch
  );
  const report = useSelector(
    (state) => state.reports.changeData.data
  );
  const isSet = useSelector(
    (state) => state.reports.changeData.id === id
  );
  const isReportSaving = useSelector(
    (state) => state.reports.changeData.isReportSaving
  );
  const reportFilled = useSelector(
    (state) => {
      var _a;
      return ((_a = state.reports.selectedMode.currentReports[bucket][id]) == null ? void 0 : _a.id) === id;
    }
  );
  useEffect(() => {
    if (!isSet && !isReportSaving) {
      loadReportBucketChangeData2({ id, bucket, isQuickReport });
    }
  }, [id, bucket, isSet, reportFilled, isReportSaving]);
  useEffect(() => {
    return () => {
      resetReportsChangeData2();
    };
  }, [id]);
  return report;
};
var useLoadReportsChangeData_default = useLoadReportsChangeData;
var SECTION_ID = "webHomeScreen" /* WEB_HOME_SCREEN */;
var getMemoizedRoleData = makeSelectSettingsData(SECTION_ID);
var useDashboardsSection = () => {
  const { updateGenericSettings: setValue } = bindActionCreators(
    actions_exports5,
    useDispatch()
  );
  const { data } = useSelector(getMemoizedRoleData);
  const cardDashboardsList = useSelector(selectDashboardCardsList);
  const [isEditMode, setEditMode] = useState(false);
  const [openAddExistingDashboard, setOpenAddExistingDashboard] = useState(false);
  const roleDashboards = useMemo(
    () => cardDashboardsList.filter(
      (role) => (data.dashboardIds || []).includes(role.id)
    ),
    [cardDashboardsList, data.dashboardIds]
  );
  const dashboardStringIds = useMemo(
    () => (data.dashboardIds || []).map(String),
    [data.dashboardIds]
  );
  const handleOnAssociate = (selectedDashboards) => {
    const newDashboardIds = [
      ...data.dashboardIds || [],
      ...selectedDashboards.map((role) => Number(role.id))
    ];
    setValue(
      {
        dashboardIds: newDashboardIds,
        defaultDashboardId: data.defaultDashboardId ? data.defaultDashboardId : newDashboardIds[0]
      },
      SECTION_ID
    );
    setOpenAddExistingDashboard(false);
  };
  const handleOnDisassociate = (id) => {
    const newDashboardIds = without(data.dashboardIds || [], id);
    const newDefaultDashboardId = newDashboardIds.length > 0 ? newDashboardIds[0] : null;
    setValue(
      {
        dashboardIds: without(data.dashboardIds, id),
        defaultDashboardId: data.defaultDashboardId === id ? newDefaultDashboardId : data.defaultDashboardId
      },
      SECTION_ID
    );
  };
  const handleDefaultDashboardSelection = (id) => {
    setValue(
      {
        defaultDashboardId: id
      },
      SECTION_ID
    );
  };
  return {
    isEditMode,
    setEditMode,
    openAddExistingDashboard,
    setOpenAddExistingDashboard,
    handleDefaultDashboardSelection,
    handleOnDisassociate,
    handleOnAssociate,
    dashboardStringIds,
    roleDashboards,
    defaultDashboardId: data.defaultDashboardId
  };
};
var SHADE_ADJUSTMENT = 130;
var getOrderStatusColor = (status, displayMode, lightTheme, darkTheme) => {
  const theme = displayMode === "dark" /* DARK */ ? darkTheme : lightTheme;
  const otherColor = displayMode === "dark" /* DARK */ ? theme.colors.cardGrey : theme.colors.lighterGrey;
  const openColor = lightTheme.colors.semanticGreen;
  const orderedColor = lightTheme.colors.darkerYellow;
  const paidColor = lightTheme.colors.semanticBlue;
  const closedColor = lightTheme.colors.semanticRed;
  const failedColor = lightTheme.colors.semanticOrange;
  switch (status) {
    case "open-initiated" /* OPEN_INITIATED */:
      return {
        bg: openColor,
        bgSecondary: adjustShade(openColor, SHADE_ADJUSTMENT),
        border: openColor,
        text: "textWhite",
        textSecondary: "textBlack"
      };
    case "open-ordered" /* OPEN_ORDERED */:
      return {
        bg: orderedColor,
        bgSecondary: adjustShade(orderedColor, SHADE_ADJUSTMENT),
        border: orderedColor,
        text: "textWhite",
        textSecondary: "textBlack"
      };
    case "failed" /* FAILED */:
      return {
        bg: failedColor,
        bgSecondary: adjustShade(failedColor, SHADE_ADJUSTMENT),
        border: failedColor,
        text: "textWhite",
        textSecondary: "textBlack"
      };
    case "closed-batch pending" /* CLOSED_BATCH_PENDING */:
    case "closed-complete" /* CLOSED_COMPLETE */:
      return {
        bg: closedColor,
        bgSecondary: adjustShade(closedColor, SHADE_ADJUSTMENT),
        border: closedColor,
        text: "textWhite",
        textSecondary: "textBlack"
      };
    case "tip-pending" /* TIP_PENDING */:
      return {
        bg: paidColor,
        bgSecondary: adjustShade(paidColor, SHADE_ADJUSTMENT),
        border: paidColor,
        text: "textWhite",
        textSecondary: "textBlack"
      };
    default:
      return {
        bg: otherColor,
        bgSecondary: adjustShade(otherColor, SHADE_ADJUSTMENT),
        border: otherColor,
        text: "black",
        textSecondary: "textBlack"
      };
  }
};
var useOrderStatusColor = (status, lightTheme, darkTheme) => {
  const displayMode = useSelector(selectDisplayMode);
  return getOrderStatusColor(status, displayMode, lightTheme, darkTheme);
};
var getSelectedModifierTag = ({
  modifierTagId,
  tagPosition,
  checkName,
  name,
  isSpecial
}) => {
  return {
    name,
    modifierTagId,
    tagPosition,
    checkName,
    isSpecial
  };
};
var applyModTagString = (modifierTagList = [], itemPosName) => {
  if (isEmpty(modifierTagList))
    return itemPosName;
  return modifierTagList.reduce(
    (acc, modifierTag) => modifierTag.tagPosition === "before" /* BEFORE */ ? `${modifierTag.checkName} ${acc}` : `${acc} ${modifierTag.checkName}`,
    itemPosName
  );
};
var applySizeModTagString = (modifierTag, itemPosName) => {
  if (modifierTag === null)
    return itemPosName;
  return (modifierTag == null ? void 0 : modifierTag.tagPosition) === "before" /* BEFORE */ ? `${modifierTag.checkName} ${itemPosName}` : `${itemPosName} ${modifierTag == null ? void 0 : modifierTag.checkName}`;
};
var hasNoModifierTag = (modifierTagList = []) => (modifierTagList != null ? modifierTagList : []).some(
  (modifierTag) => modifierTag.name === NO_MODIFIER_TAG.posName && modifierTag.isSpecial
);
var hasOnSideApplied = (modifierTagList = []) => (modifierTagList != null ? modifierTagList : []).some(
  (modifierTag) => modifierTag.name === ON_SIDE_MODIFIER_TAG_POS_NAME && modifierTag.isSpecial
);
var hasModifierTag = (modifierTagList = [], targetModifierTag) => (modifierTagList != null ? modifierTagList : []).some(
  (modifierTag) => modifierTag.modifierTagId === targetModifierTag.modifierTagId
);
var removeModifierTag = (modifierTagList = [], targetModifierTag) => modifierTagList.filter(
  (modifierTag) => modifierTag.modifierTagId !== targetModifierTag.modifierTagId
);

export { ALL_MODIFIERS_MODIFIER_GROUP, ALL_MODS_ID, CHECK_ELEMENT_INITIAL_STATE, CHECK_INITIAL_STATE, COMBO_ELEMENT_INITIAL_STATE, COMBO_ITEM_GROUP_SELECTED_INITIAL_STATE, CUSTOMERS_INITIAL_STATE, CUSTOMER_ADDRESS_INITIAL_STATE, CUSTOMER_INITIAL_STATE, CUSTOMER_ORDER_INITIAL_STATE, CUSTOMER_SELECTED_MODE_INITIAL_STATE, ComboAssociationsSectionFieldLabels, ComboBasicSectionFieldLabels, ComboInventorySectionFieldLabels, ComboItemGroupsFieldLabels, ComboItemsOfItemGroupFieldLabels, ComboMasterFieldLabels, ComboMoreInformationFieldLabels, ComboPricingFieldLabels, ComboRegisterSectionFieldLabels, CustomerAddressInfoSectionFieldLabels, CustomerBasicSectionFieldLabels, CustomerCardsInfoSectionFieldLabels, DEFAULT_ALTERNATIVE_PRICE_DATA, DISCOUNT_SORT_VALUES, DISCOUNT_TAXES_SORT_VALUES, DISPLAY_CHECK_ELEMENT_INITIAL_STATE, DRAWER_MANAGEMENT_NAVIGATION_INITIAL_STATE, DiscountBasicSectionFieldLabels, DiscountDiscountScheme, DiscountMasterFieldLabels, DiscountMoreInformationFieldLabels, GET_MODIFIER_ITEM_INSTANCE_INITIAL_STATE, GET_MODIFIER_ITEM_SELECTED_INITIAL_STATE, GET_MODIFIER_NO_MOD_TAG_APPLIED_STATE, GET_ORDER_INITIAL_STATE, ITEM_DISCOUNT_INITIAL_STATE, ItemAssociationsSectionFieldLabels, ItemBasicSectionFieldLabels, ItemDimensionsFieldLabels, ItemGuestCheckDisplayLabels, ItemIngredientsExtraLabels, ItemIngredientsFields, ItemInventoryLabels, ItemLinkedModifierItemsFields, ItemModifierGroupLabels, ItemModifierGroupsExtraLabels, ItemModifierItemLabels, ItemMoreInformationFieldLabels, ItemPrepStationsChangesLabels, ItemPricingFieldLabels, ItemRegisterSectionFieldLabels, ItemSuggestiveOrderingLabels, ItemTaxFields, ItemTaxLabels, MENU_INITIAL_STATE, MENU_MODULE_INITIAL_STATE, MENU_VERSIONS_INITIAL_STATE, MODIFIER_TAG_NAME_TO_OPERATION, MasterFieldLabels, ModItemToggleOperations, ModifierGroupBasicSectionFieldLabels, ModifierGroupMasterFieldLabels, ModifierGroupModifierGroupPricingVersionsLabels, ModifierGroupModifierItemsFieldsLabels, ModifierGroupPricingVersionFieldsLabels, ModifierGroupRegisterDisplayFieldLabels, ModifierGroupSectionStatus, ModifierItemBasicSectionFieldLabels, ModifierItemInventorySectionFieldLabels, ModifierItemMasterFieldLabels, ModifierItemModifierGroupLabels, ModifierItemModifierItemLabels, ModifierItemPricingVersionFields, OPEN_ITEM_INITIAL_STATE, ORDER_INITIAL_STATE, ORDER_SEARCH_RESULTS_INITIAL_STATE, PAYMENT_NAVIGATION_INITIAL_STATE, REFUND_ACTION_INITIAL_STATE, REGISTER_NAVIGATION_INITIAL_STATE, ReturnTypes, SERVICE_CHARGE_DISCOUNT_SORT_VALUES, SERVICE_CHARGE_SORT_VALUES, SPECIAL_TAGS_WITHOUT_STRING, SPECIAL_TAGS_WITH_TOGGLE, SPECIAL_TAG_NAME_TO_QUANTITY_SIZE, SPECIAL_TYPES_SORT_VALUES, SPECIAL_VALIDATION_OBJECT_INITIAL_STATE, SpecialAvailabilityFields, SpecialBasicSectionFieldLabels, SpecialGetItemsFieldLabels, SpecialMasterFieldLabels, SpecialMoreInformationFieldLabels, SpecialsSchemeFieldLabels, TICKET_ELEMENT_INITIAL_STATE, TICKET_OPEN_ITEM_TYPE_ID, TOGGLE_SEATS_CASES, TicketElementNotInClosedCheck, actionHelpers_exports, actions_exports3 as actions_exports, actions_exports12 as actions_exports10, actions_exports13 as actions_exports11, actions_exports17 as actions_exports12, actions_exports16 as actions_exports13, actions_exports14, actions_exports4 as actions_exports2, actions_exports5 as actions_exports3, actions_exports6 as actions_exports4, actions_exports7 as actions_exports5, actions_exports8 as actions_exports6, actions_exports9 as actions_exports7, actions_exports10 as actions_exports8, actions_exports11 as actions_exports9, activatePreviewEditing, addBreadCrumbLocation, addCategoriesSubcategoriesPropertiesAndOverWriteIfExist, addCheckElementsInDefaultCheckToOrder, addCheckPayment2 as addCheckPayment, addCheckPaymentCoreThunk, addComboToChecks, addDiscountToActiveItemsCore, addDiscountToActiveOrder, addElement, addEmployeeShiftCore, addHotButtonsPage, addInheritedTaxesPropertiesAndOverWriteIfExist, addNewItemGroup, addNewMenuTypesToItem, addNewMenuTypesToSpecial, addNewModifierItemSelected, addNewOpenItem, addOpenModAndToggleItThunk, addPaymentToCurrentCheckCoreThunk, addPricingVersionForModifierGroup, addPricingVersionForModifierItem, addPrintingErrorsToOrder, addPropertiesAndOverWriteIfExist, addServiceArea, addSettingsBreadCrumbLocation, addTaxesPropertiesAndOverWriteIfExist, addTicketElementToChecks, addressInfoRowMapping, addressInfoTableFactory, adjustCheckDataForTicketElement, adjustCheckDataForToggleSeats, adjustChecksStatus, adjustComboElemItemElementIds, adjustIsInClosedCheckForTicketElements, adjustRedundantCheckElementsAndTicketElementToCheckElements, adjustTicketElemItemElementIds, apiCall, applyChangesToMenuTypes, applyComboChangesToMenuTypes, applyDiscountToCombos, applyDiscountToItems, applyModTagString, applyModifierTag, applySeatAndQuantityToItems, applySizeModTagString, applySpecialChangesToMenuTypes, applySpecialModTag, applySpecialModTagNested, applySpecialsToNewItems, applySpecialsToTicketAndCombos, applyTaxProportionToModifierItemsSelected, areCustomersMasterModeSelector, assignCourseId, assignItemsToLocation, associateHotButton, associateItemToItemGroup, associateLicenseLocation, associateModifierItemToModifierGroup, associateUsersToLocation, autoAssignCheckElements, autoSplitChecks, autoTransferPaymentsBasedOnCheckBalanceDue, baseUrl, breadCrumbPopNavigation, breakInBreakOut, calcAlternativeOrderTotal, calcDiscountAmountAppliedToItem, calcNextMenuType, calcOrderAlternativeSubtotal, calcOrderMainSubtotal, calcOrderSpecials, calcOrderTotals, calcOrderTotalsWithAlternativePrice, calcSpecialAmountApplied, calcTotalAdditionalPrice, calcTotalAlternativeComboPrice, calcTotalAmountPerSeat, calcTotalComboPrice, calcTotalComboWithAlternativePrice, calcTotalItemAlternativePrice, calcTotalItemPrice, calcTotalItemWithAlternativePrice, calcTotalSelectedModifiersPrice, calculateModifierItemPricesMenu, calculateModifierItemPricesRegister, calculateTotalPrice, cancelChangesOnCancelPress, cancelComboElementThunk, cancelCustomerChangesOnCancelPress, cancelFreshSheetChangesOnCancelPress, cancelReportsChangesOnPress, cancelSettingsChangesOnCancelPress, cancelTableLayoutChanges, carryOverModifiersSelected2 as carryOverModifiersSelected, changePricingVersion, changeRegisterNavigationCategory, changeSelectedMode, changeSelectedReportsMode, changeSelectedSettingsMode, changeServiceArea, checkAndDisplayCheckElementsRollUp, checkAndSetTicketElementActiveCore, checkAndUpdateOrderDiscounts, checkAndUpdateOrderSpecials, checkBreadCrumbLocation, checkBucketValidation, checkCanBeDeleted, checkCategoryFormValidation, checkComboFormValidation, checkCustomerValidation, checkDiscountFormValidation, checkElementExist, checkForChangesAndNavigate, checkForCoursesUpdate, checkForCustomerChangesAndNavigate, checkForForbiddenBucket, checkForFreshSheetChangesAndNavigate, checkForItemInLocationAndContinue, checkForLayoutChanges, checkForMassUpdateChangesAndNavigate, checkForOrderTypeChanges, checkForPreviewChanges, checkForRollUp, checkForSettingsChangesAndNavigate, checkForValueInLocationAndContinue, checkGeneralSettingsFormValidation, checkIfTicketElementIsTaxExempt, checkIngredientFormValidation, checkItemFormValidation, checkItemGroupFormValidation, checkKitchenTicketSettingsFormValidation, checkLicenseSettingsFormValidation, checkMassUpdateFormValidation, checkMenuTypeFormValidation, checkModifierGroupFormValidation, checkModifierItemFormValidation, checkOnlineSettingsFormValidation, checkOrderPermissions, checkPaymentScreenAndNavigate, checkPaymentsValidation, checkPrepStationsFormValidation, checkPrinterRulesValidation, checkRegisterModeFormValidation, checkReportingGroupFormValidation, checkReportsForChangesAndNavigate, checkRolesFormValidation, checkSettingsBreadCrumbLocation, checkSettingsValidation, checkSpecialFormValidation, checkStatusAllowsEditing, checkSubcategoryFormValidation, checkTaxesValidation, checkUsersFormValidation, checks_exports, cleanDisplayCheckElements2 as cleanDisplayCheckElements, cleanDisplayCheckElementsThunk, cleanNavigationAndRemoveActiveItem, clearCheckElementsForUnSentElements, clearComboSpecial, clearCombos, clearError, clearItemSpecial, clearLockScreenBanner, clearModifierTag, clearOpenModThunk, clearOrderSpecialObjects, clearPrinterErrorsForPrintJobs, clearUnsentTicketElements, clearUnsentTicketElementsAndSplit, clearUser, clockInClockOut, closeCheck2 as closeCheck, closeCheckThunk, closeMultiselectMode, closeOrderDetailsOverlay, combosAreEqual, combos_exports, convertOldComboElementIntoTheNewest, convertOldTicketElementIntoTheNewest, copySentTicketElementConfig, countComboInstances, countItemInstances, createBucketElement, createCategorySubcategoryMultiAddDiff, createCheck2 as createCheck, createCheckCoreThunk, createCheckDataAndUpdateCheckForTicketElement, createCheckDataForTicketElement, createCheckElement, createCustomersErrorSelector, createCustomersSectionSelector, createDisplayCheckElement, createDisplayCheckElementsThunk, createEmployeeAction, createOrderCore, createRegisterTicketPreviewData, createSocket, createTicketElementToCheckElementObject, createTicketElementToCheckElements, createValidationObject, customerValidationThunk, customersSelectors_exports, deactivateLicense, deactivateLicenseFromDevice, decrementComboSeatQuantity, decrementItemIngredientThunk, decrementModifierItemSelected2 as decrementModifierItemSelected, decrementModifierItemSelectedThunk, decrementNestedModifierItemSelected2 as decrementNestedModifierItemSelected, decrementNestedModifierItemSelectedThunk, decrementSeatQuantity, decrementTicketElementIngredientSize, deleteBucketElement, deleteBucketItems, deleteCheckCoreThunk, deleteCheckElementAndUpdateCheck, deleteCheckElementAndUpdateCheckOld, deleteCheckElementsFromCheck, deleteComboElementFromOrder, deleteDisplayCheckElementFromCheck, deleteEditableCheck2 as deleteEditableCheck, deleteElementFromLayout, deleteEmployeeShiftCore, deleteEmptyChecks, deleteItemGroupFromCombo, deleteModifierGroupFromItem, deleteModifierGroupFromModifierItem, deleteModifierGroupItemSelected, deleteModifierItemSelected, deleteNestedModifierGroupItemSelected, deleteNestedModifierItemSelected2 as deleteNestedModifierItemSelected, deleteNoSeatKey, deletePrepStation, deletePrinterJobs, deleteReport, deleteSeatQuantity, deleteSettingsElement, deleteTicketElementCheckElementsFromChecks, deleteTicketElementFromChecksData, deleteTicketElementToCheckElements, diffCombosFactory, diffCustomerFactory, diffDiscountFactory, diffItemsFactory, diffModifierGroupsFactory, diffModifierItemsFactory, diffOnlineSettingsFactory, diffRegisterModeFactory, diffReportFactory, diffSpecialsFactory, disableTicketElementsInClosedChecks, discardTableLayoutChanges, discountsAndSpecials_exports, distributeAmountToElementsBasedOnCheckTotals, distributeAndUpdatePriceDataToCheckElements, distributePenniesBetweenInstances, distributePenniesBetweenModifierGroups, distributePenniesBetweenModifierItems, distributePenniesBetweenTaxes, distributeValuesForTicketElementToCheckElements, dumpDefaultCheck2 as dumpDefaultCheck, dumpDefaultCheckThunk, duplicateElement, duplicateRegisterCombo, duplicateRegisterItem, editCustomer, editEmployeeShiftCore, editOrder, editSettingsElement, emailReport, enterPaymentMode, exitFromOrderCore, exitOrderReducer, expandItemGroupsByQuantity, expandItemGroupsFunction, fetchCustomers, fetchEmployeeDetailsShiftsCore, fetchEmployeeDetailsSummaryCore, fetchEmployeesCore, fetchReport, fetchSingleCustomer, filterCombosBySeatSelected, filterTicketElementsBySeat, findDisplayCheckElementId, findElementByIdAndType, fixModifierTag, fixModifierTagForNestedMod, formatCategorySubcategoryDiffValue, formatItemNewTaxes, generateCategoriesAndSubcategoriesChanges, generateCheckElementId, generateCheckElementsForElement, generateCheckElementsForTicketElementInstances, generateCheckId, generateCourseTimesObject, generateDisplayCheckElementId, generateDisplayCheckElements, generateInstanceId, generateMassUpdateReportingGroupsChanges, generateNTimestampIds, generateNewCheckNumber, generateSingleCheck, generateTaxesChanges, generateTicketElementId, generateTimestampId, genericEmployeeShiftCore, getAdditionalAmountPrice, getAlternativeListBasePrice, getAlternativePriceForSpecialsFlow, getAndResetGlobalQuantity, getAndSplitTicketElement, getAppliedDiscountAmount, getAssociatedModifierItems, getBasePrice, getBasePriceFromTaxInclusive, getBaseReportInitialState, getBogoSpecialCalculatorReducer, getBogoSpecialsFromActiveSpecialsObject, getCheckElementId, getCheckId, getCheckIdByCheckElementId, getCheckPaymentsCount, getChecksIdsForTicketElement, getClearedNavigationObject, getClosedChecksForSeatId, getComboBOGOAppliedAmount, getComboBasePrice, getComboElementItemNames, getComboNames, getComboOrTicketElementCourseId, getComboOrTicketElementOnTheFlyCourseNumber, getComboOrTicketElementSentTimes, getCourseTimeOnTheFly, getCreditBalancesReportInitialState, getCreditCardBatchReportInitialState, getCurrentBOGOSpecialsBuyItemIds, getCurrentBOGOSpecialsGetItemIds, getCurrentCustomersCore, getCurrentEditingElement, getCurrentModifierGroup, getCurrentOrderInData, getCurrentSpecialsRewardedElementIds, getCurrentSpecialsRewardedElementInstances, getCurrentSpecialsTriggerElementIds, getCurrentSpecialsTriggerElementInstances, getCustomReportsInitialState, getCustomerAddressRowData, getCustomersVersionCore, getCustomersVersionWithStateCore, getDataForMenuReducer, getDataFromChangeData, getDefaultIngredientsSelected, getDefaultModifierGroupSelected, getDefaultModifierGroupsSelectedForNestedMod, getDefaultModifiersSelectedFromItem, getDefaultModsByModifierGroup, getDiffReportFactoryLabeledFilterValues, getDiscountCalculatorReducer, getDiscountCount, getElementsAffectedBySpecial, getEmployeeSalesAndTipsReportInitialState, getEmptyTaxesObject, getEndOfShiftReportInitialState, getExclusiveDiscountsCount, getExtendedTableAndShowOrderModal, getExtendedTableFactory, getExtendedTableThunk, getGiftCardSales, getIncludedAmountPrice, getInitialTaxDetailsObject, getInstances, getInventoryOnHandReportInitialState, getIsOrderOpen, getItemBOGOAppliedAmount, getItemComboSalesReportInitialState, getItemGroupsWithSelection, getItemIdsToSend, getItemMassUpdateDataWithoutMasterProperties, getItemMassUpdateDifferences, getItemNameOrNames, getItemPriceForSpecialsFlow, getItemPriceListByIdAndMenuTypeId, getItemSpecialsFromActiveSpecialsObject, getItemVolumeData, getLocationsChanges, getLocationsToApply, getLocationsToApplyReportsChanges, getMasterMenu, getMasterSettings, getMaxSize, getMaxSortPriorityByModifierGroupId, getMaxSortPriorityInAllMods, getMenuAccessLocations, getMenuTypeFromOrder, getMenuVersion, getMinSize, getModifierItemButtonStatus, getModifierItemButtonStatusByData, getModifierItemHasChangesFunction, getModifierItemPriceCalc, getModifierItemPriceObject, getModifierItemsCurrentItem, getModifierItemsNextPrice, getModifierItemsSelectedQty, getModsPriceForTaxInclusive, getNestedModifierItemHasChangesFunction, getNewCustomerEmptyAddress, getNewCustomersVersionCore, getNewFilteredItemsOfItemGroup, getNewSpecialFilteredItemsOfItemGroup, getNextItemGroupId, getNextTabletGeneratedId, getNotNullItemGroups, getOperationByModifierTagAndModifierItem, getOperationByModifierTagOnly, getOperationByQuantityModeAndModifierItem, getOrderAdditionalData, getOrderApplicableServiceCharges, getOrderById, getOrderHasToShowItemsNotSentIndicator, getOrderHasUnsentItems, getOrderStatusColor, getOrderStatusName, getOverrideMenuType, getPayButtonContent, getPaymentMethod, getPaymentsId, getPreMadeModifierItems, getPrepStationChanges, getPrintJobInfo, getPrinterJobs, getReadyItems, getReducedOrderObject, getRemoteLocationMenu, getRemoteLocationSettings, getReportsChangeDataInitialState, getReportsReducerInitialState, getReportsSelectedModeInitialState, getReportsStoreInitialState, getSalesOverviewReportInitialState, getSeatName, getSelectedIngredientFromMenuIngredient, getSelectedModifierTag, getSettingsAccessLocations, getSettingsInitialState2 as getSettingsInitialState, getSettingsInitialState3 as getSettingsInitialState2, getSettingsLocationsToApply, getSnapshotFromItemTaxes, getSpecialAppliedValue, getSpecialBoundToItem, getSpecialNextItemGroupId, getSpecialsActiveNow, getSpecialsCalculatorReducer, getSpecialsFromMenuType, getSpecialsToApply, getSpecialsToReset, getTaxesReduceFunction, getTaxesToApplyFromComboObj, getTaxesToApplyFromItemObj, getTaxesToApplyFromOpenItemObj, getTicketElementChecks, getTicketElementClosedChecks, getTicketElementModifications, getTicketElementModifierGroupHasModifications, getTicketItemVolumeData, getTicketSize, getToSkipCheckElementIds, getToastStamp, getTotalBogoSpecialAmount, getTotalDiscountAmount, getTotalDiscountAmountReducer, getTotalSpecialAmount, getTotalSpecialAmountReducer, getValidationForCurrentOrder, getVoidReasonsReportInitialState, getVolumetricTaxApplied, handleAutoSplitBySelectedSeat, handleBatchPaymentResponseThunk, handleConfirmedPrintJobs, handleConnectivityChange, handleDecrementModifierItem, handleDeleteModifierGroup, handleDeleteModifierGroupFromModifierItem, handleElementUngroupBySeat, handleHideModifierGroup, handleHideModifierGroupFromModifierItem, handleIncrementModifierItemQuantity, handleModifierGroupMaximumQuantityError, handlePausedPrinterAndPrintJobs, handleQuantityChange, handleReportsChange, handleResumePrinterAndPrintJobs, handleSetDefaultSelected, handleTransferredPrintJobs, hasModifierTag, hasNoModifierTag, hasOnSideApplied, hasOpenModAdded, hideModifierGroup, hideModifierGroupFromModifierItem, hideRefreshToast, hideToast, hotButtonsReducer, ignoredQuantitySizeFields, incrementComboSeatQuantity, incrementItemIngredientSizeThunk, incrementModifierItemSelected2 as incrementModifierItemSelected, incrementModifierItemSelectedThunk, incrementNestedModifierItemSelected2 as incrementNestedModifierItemSelected, incrementNestedModifierItemSelectedThunk, incrementSeatQuantity, incrementTicketElementIngredientSize, indexToOrderStatus, initializeIngredientsSelected, initializeIsInstanceComplete, initializeLayout, initializeModifierGroupsSelected, initializeModifierGroupsSelected_default, initializeReportsState, initializeTablesLayout, isCheckEditorActive, isCheckVoided, isComboElement, isComboElementCompleted, isComboElementCompletedAndItsItems, isComboElementIdInSeatPage, isComboElementNotTriggered, isComboElementTaxInclusive, isComboOrTicketElementOnHold, isComboOrTicketElementToGo, isComboOrTicketElementTriggered, isComboOrTicketElementTriggeredFromOrderData, isComboVoided, isItemElement, isItemElementPromptForPrice, isNotOpenItemFn, isOpenItemFn, isOrderClosed, isOrderClosedOrPaid, isOrderClosedOrVoided, isOrderNotAvailableToEnter, isOrderStatusClosed, isPaymentScreenActive, isPaymentValid, isTicketElementAssociatedWithCombo, isTicketElementComplete, isTicketElementIdInSeatPage, isTicketElementNotAssociatedWithCombo, isTicketElementQuantityComplete, isTicketElementTaxInclusive, isTicketElementVoided, isTicketItemFn, itemIgnoredFields, itemIgnoredModifierItemsFields, itemIgnoredQuantityNumberFields, itemIgnoredQuantityOffFields, itemIgnoredQuantitySizeFields, itemMassUpdateConfirmation, itemMassUpdateEndpoint, loadReportBucketChangeData, makeComboFromItemThunk, makeSelectCustomersData, makeSelectIsDragAndDropEnabled, makeSelectIsDragAndDropEnabledOnMergedTables, makeSelectRecentOrderRelatedTableAndOrderName, mapElementIdToInstanceKey, mapElementIdToInstanceObject, mapNestedModGroups, massPriceUpdate, menuBucketValidationThunks, menuReducerHasChanges, mergeChecks2 as mergeChecks, mergeChecksCoreThunk, mergeComboWithItemsFunctionGenerator, mergeElementInstances, mergeTaxesObjects, modifierGroupIgnoredModifierGroupModifierItemFields, modifierGroupIgnoredModifierGroupPricingVersionFields, modifierGroupIgnoredModifierItemsOfModifierGroupFields, modifierItemIgnoredModifierGroupOfModifierItemFields, modifierItemIgnoredModifierItemPricingVersion, modifierItemIgnoredModifierItemsFields, modifierItemToTicketModifierItem, modifierItemToTicketModifierItemIntoItemObj, modifierItemsAndIngredients_exports, modifierItemsPriceAlgorithm, moveCheckElements2 as moveCheckElements, movePaymentsCoreThunk, navigateToOrderCore, navigation_exports, nextQuantityAmount, openCheck2 as openCheck, openCheckThunk, openOrderDetailsOverlayCore, orderModalReducer, orderSearchResultsReducer, orderStatusOptionsArray, orderStatusToIndex, ordersReducer, orders_default, overrideCheckElementFields, pauseResumePrinter, paymentNavigationReducer, paymentsCustomTendersSchema, payments_exports, preMakeItemWithModifierGroups, preMakeMenuTypeVersionWithModifierGroups, preProcessOrder, prevQuantityAmount, preventRollUpOriginalItem, printEndOfShiftReport, printInventoryOnHandReport, printReport, printTestKitchenTicket, propagateCategoriesToMenuTypes, pullKitchenTicketPrepStationSettings, pushKitchenTicketPrepStationsSettings, reEnableTicketElementsInClosedChecks, reOrderCheckElements, rearrangeItemGroups, rearrangeItemGroupsToLastOrFirst, rearrangeModifierGroups, rearrangeModifierGroupsToLastOrFirst, redoLastElementChange, reduceToDiscountsObject, reduceToSpecialsObject, reducer_default4 as reducer_default, reducer_default5 as reducer_default2, reducers_default2 as reducers_default, reducers_default3 as reducers_default2, reducers_default4 as reducers_default3, reducers_default5 as reducers_default4, reducers_default6 as reducers_default5, reducers_default7 as reducers_default6, refreshCurrentReports, registerNavigationReducer, registerSelectors_exports, registerTicketSettings_dummy_default, reinitializeModifierGroupSelected_default, removeAllItemDiscounts, removeCheckDataForTicketElement, removeCheckElementFromDisplayCheckElement, removeComboDiscountByIdOrTabletGeneratedId, removeComboElement, removeComboElementCoreThunk, removeComboOrItemDiscountThunk, removeHotButton, removeInvalidCheckElements, removeItemDiscountByIdOrTabletGeneratedId, removeItemFromItemGroup, removeMasterData, removeMenuTypeFromItem, removeModifierItemFromModifierGroup, removeModifierTag, removeOrderDiscountByIdOrTabletGeneratedId, removeOrderDiscountThunk, removePreviousElement, removePricingVersionFromModifierGroup, removePricingVersionFromModifierItem, removePrinters, removeRecentOrderClosed, removeServiceAreAndResetState, removeServiceArea, removeTicketComboItemThunk, removeTicketElementAndCheckData, removeToastElement, renameCheck, replaceBackupPrinter, replaceKeyWithInstanceDictionary, replaceSessionOrderThunk, replaceUserRecentOrderStation, reprintPrinterJobs, resendUserInvite, resetAllEditableChecksCoreThunk, resetAllModsModifierGroupsSelected, resetChangeData, resetChangeFreshSheetData, resetChangeMassUpdateData, resetChecksData, resetCurrentEditData, resetDisplayCheckElements, resetFreshSheetToOriginal, resetGlobalState, resetIngredientsSelected, resetIngredientsSelectedToConfigWhenSent, resetLastPreviewOrder, resetLocalItemStock, resetMassUpdateMenuChanges, resetMenuChanges, resetModifierGroupSelected2 as resetModifierGroupSelected, resetModifierGroupSelectedCoreThunk, resetModifierGroupSelectedToConfigWhenSent2 as resetModifierGroupSelectedToConfigWhenSent, resetModifierGroupToConfigWhenSentCore, resetRegisterTicketSettingsData, resetReportsChangeData, resetReportsFieldErrors, resetSpecialsOnRemovedInstances, revertComboPrice, rollUpCheckElementsNew, rollUpComboElements, rollUpDisplayCheckElementOfDifferentInstances, rollUpDisplayCheckElements, rollUpTicketElements2 as rollUpTicketElements, rollUpTicketInCurrentOrder, roundToCentesimal, roundToMoneyDecimals, saveAllChanges, saveChangesOnSavePress, saveCustomerChangesOnSavePress, saveReportsChanges, saveReportsChangesOnSavePress, saveSettingsChangesOnSavePress, selectActualCustomersVersion, selectBarCodeOrderFromOrders, selectBarCodeOrderSearchResult, selectComboDisplayName, selectCurrentActiveBOGOSpecials, selectCurrentActiveItemSpecials, selectCurrentActiveSpecials, selectCurrentBOGOSpecialsBuyItemIds, selectCurrentBOGOSpecialsGetItemIds, selectCurrentBaseCheck, selectCurrentBaseCheckBalanceDue, selectCurrentBaseCheckTip, selectCurrentBaseCheckTotal, selectCurrentCheck, selectCurrentCheckBalanceDue, selectCurrentCheckElementEntries, selectCurrentCheckId, selectCurrentCheckName, selectCurrentCheckNumber, selectCurrentCheckPayments, selectCurrentCheckTotal, selectCurrentComboElement, selectCurrentComboElementIsInClosedCheck, selectCurrentComboHasSeatSelected, selectCurrentComboItemsNotTriggeredQty, selectCurrentComboItemsReadyToSend, selectCurrentComboName, selectCurrentCombos, selectCurrentCombosBySeat, selectCurrentCourseNumber, selectCurrentCustomer, selectCurrentCustomerOriginalData, selectCurrentCustomersSectionId, selectCurrentElementConfigWhenSent, selectCurrentElementCreatedById, selectCurrentElementCustomizerType, selectCurrentElementInstructions, selectCurrentElementIsOnHold, selectCurrentElementItemObj, selectCurrentElementMenuTypeVersion, selectCurrentElementTimeSentToKitchen, selectCurrentElementTimeTriggered, selectCurrentHotButtonModifierItemPosName, selectCurrentItemAllModIds, selectCurrentItemShowAllModsAlphabetizeButtonsEnabled, selectCurrentItemShowAllModsBehavior, selectCurrentItemShowAllModsEnabled, selectCurrentItemShowAllModsHalfSizeButtonsEnabled, selectCurrentItemShowIngredients, selectCurrentLicenseEditing, selectCurrentMenuTypeRegister, selectCurrentModifierGroup, selectCurrentNavCheckIds, selectCurrentOrder, selectCurrentOrderActiveChecks, selectCurrentOrderBOGOSpecials, selectCurrentOrderBalanceDue, selectCurrentOrderCheckCount, selectCurrentOrderCheckPaymentsCount, selectCurrentOrderChecks, selectCurrentOrderChecksCount, selectCurrentOrderClosedCheckIds, selectCurrentOrderComboIdsNoOnHold, selectCurrentOrderCourseTimes, selectCurrentOrderCourseTimesObject, selectCurrentOrderCreatedDate, selectCurrentOrderDefaultCheckId, selectCurrentOrderDiscounts, selectCurrentOrderHasAvailableChecks, selectCurrentOrderHasDineInAndTakeOut, selectCurrentOrderId, selectCurrentOrderIsNotBeenEdited, selectCurrentOrderNumber, selectCurrentOrderNumberOfChecks, selectCurrentOrderObj, selectCurrentOrderOwnerId, selectCurrentOrderPayments, selectCurrentOrderServiceChargeSelection, selectCurrentOrderServiceCharges, selectCurrentOrderSpecials, selectCurrentOrderSpecialsSource, selectCurrentOrderSplitMode, selectCurrentOrderStatus, selectCurrentOrderSubtotal, selectCurrentOrderTableId, selectCurrentOrderTicketElementToCheckElements, selectCurrentOrderTicketIdsNoOnHold, selectCurrentOrderTotalDiscountAmount, selectCurrentOrderTotalServiceChargeAmount, selectCurrentOrderType, selectCurrentSeatTotalAmount, selectCurrentSpecialsRewardedElementIds, selectCurrentSpecialsRewardedElementInstances, selectCurrentSpecialsTriggerElementIds, selectCurrentSpecialsTriggerElementInstances, selectCurrentTicket, selectCurrentTicketBySeat, selectCurrentTicketComboIds, selectCurrentTicketElement, selectCurrentTicketElementAllowShare, selectCurrentTicketElementComboId, selectCurrentTicketElementCourseId, selectCurrentTicketElementCustomizerShape, selectCurrentTicketElementCustomizerType, selectCurrentTicketElementExitDetailsOnReqModsCompletion, selectCurrentTicketElementHasItem, selectCurrentTicketElementHasMods, selectCurrentTicketElementHasNormalMods, selectCurrentTicketElementHasOpenModAdded, selectCurrentTicketElementIsClosedCheck, selectCurrentTicketElementIsFromDisabledCoursingMenu, selectCurrentTicketElementIsNotNull, selectCurrentTicketElementIsShared, selectCurrentTicketElementIsTakeout, selectCurrentTicketElementItemObject, selectCurrentTicketElementMenuTypeId, selectCurrentTicketElementModifierGroups, selectCurrentTicketElementNormalMods, selectCurrentTicketElementOnTheFlyCourseNumber, selectCurrentTicketElementPrepStations, selectCurrentTicketElementQuantity, selectCurrentTicketElementSeating, selectCurrentTicketElementsNotTriggeredQty, selectCurrentTicketElementsReadyToSend, selectCurrentTicketIsEmpty, selectCurrentTicketItemIds, selectCurrentTicketItemIngredients, selectCurrentTicketNormalModsSelectedAreComplete, selectCurrentTicketSize, selectCustomerChangeData, selectCustomerDifferences, selectCustomerFinalDiffObject, selectCustomers, selectCustomersDataAndSectionId, selectCustomersErrors, selectCustomersLocationVersion, selectCustomersMasterVersion, selectCustomersRemoteLocationVersion, selectCustomersSelectedMode, selectCustomersType, selectCustomersVersions, selectDefaultCheckElementsIds, selectDefaultServiceAreaOptionAndMode, selectDrawers, selectElement, selectFilteredCurrentTicketElementModifierGroups, selectIsCurrentCheckDefault, selectIsCurrentComboElementComplete, selectIsCurrentElementComplete, selectIsCurrentElementQtyWhenSentComplete, selectIsCurrentMenuTypeCoursingEnabled, selectIsCurrentMenuTypeSelectedActive, selectIsCurrentOrderSeatingMode, selectIsCurrentTicketElementComplete, selectIsCurrentTicketElementCurrentMenuType, selectIsCurrentTicketElementItemCustomizer, selectIsCurrentTicketElementShowIngredients, selectIsCurrentTicketElementSubcategoryCustomizer, selectIsCurrentTicketElementToGo, selectIsCurrentTicketElementVoid, selectIsCustomerSet, selectIsCustomizerScreenByTicketElement, selectIsDragAndDropActionEnabled, selectIsItemsToggled, selectIsNOModifierTagSelected, selectIsOrderClosed, selectIsOrderTypeToGo, selectIsPayThroughTablet, selectIsPaymentModeActive, selectIsSimpleModeEnabled, selectLocationCustomers, selectLowestPriceInActiveItems, selectMasterCustomers, selectMaxSortPriorityInAllModsSelected, selectNoModifierItem, selectNoneModifierItems2 as selectNoneModifierItems, selectNoneModifierItemsCustomizer, selectOmitCheckAndPaymentChecksToCloseOrder, selectOrderComboElementSeats, selectOrderNumberOfSeatsServed, selectOrderOrCurrentCheck, selectOrderSearchResults, selectOrderSearchResultsOrders, selectOrderSeatOnePosition, selectOrderSeatTags, selectOrderTicketElementSeats, selectOrderType, selectOrders, selectPaymentMethod, selectPaymentMethodList, selectPaymentNavigationCheckId, selectPaymentNavigationRefundAction, selectPaymentOption, selectPromptForItemPriceName, selectRegisterCombo2 as selectRegisterCombo, selectRegisterComboItemThunk, selectRegisterComboThunk, selectRegisterItem2 as selectRegisterItem, selectRegisterItemThunk, selectRemoteLocationCustomers, selectRevenueCenters, selectSectionsCompletedIds, selectSectionsCompletedSet, selectSelectedAction, selectSelectedElement, selectSelectedIngredients, selectSelectedModifierGroups, selectSelectedOrderSearchResult, selectSelectedServiceArea, selectSelectedServiceAreas, selectSelectedTables, selectServiceAreaLayouts, selectServiceAreas, selectShowTableBorderForLoggedInUsersOrders, selectShowTicketElementModifierGroupSearchBar, selectSpecialModTagsMetaData, selectTables, selectTagList, selectTicketElementById, selectTicketElementsReadyForKitchen, selectTicketItemMenuTypeId, selectTriggeringManuallyDisabled, selectUnassignedCheckHasValidPayments, selectUsersData, selectVAOData, sendCustomErrorToBackendLog, separateDiscountsByTaxesType, setActiveTicketElement, setBreadCrumb, setBreadCrumbIndexData, setBreadCrumbLocation, setBreadCrumbStatusPath, setChangeData, setChangeDataModifierGroupsValues, setChangeDataValues, setChangeFreshSheetData, setChangeFreshSheetDataValues, setChangeMassUpdateData, setChecksStatus, setComboBasePrice, setComboElementQuantity, setComboSeatQuantity, setCurrentEditData, setCurrentReportURL, setCurrentStationCounter, setCustomersOnState, setDashboards, setDefaultData, setDefaultFreshSheetData, setDefaultSettingsData, setDiffObject, setDifferences, setDiscountToOrder, setDrawers, setErrors, setFreshSheetDataFromMenu, setInitialLoggedInUser, setInitializeAppOnLockScreen, setIsBottomSheetOpen, setIsClockInSuggestionModalOpen, setIsComboComplete, setIsLoading, setIsLoadingModal, setIsLoadingMore, setIsPaymentModeActiveCoreThunk, setIsReportPDFLodaing, setIsReportSaving, setIsWSActive, setItem68Thunk, setLastLayoutChangeToCurrentEditData, setLastPreviewArrangement, setLastPreviewOrder, setLastRedoChanges, setLastServiceAreasOrder, setLastUndoChanges, setLatestPaymentInformation, setLocalIngredient86, setLocalItem86, setLocalModifierItem86, setLocationMenu, setLocationSelectedSettingsMode, setLocationSettings, setLockScreenBanner, setLoggedInRoleOnState, setLoggedInUser, setMassUpdateErrors, setMassUpdateSelectedLocations, setMasterLocation, setMasterMenu, setMenuPreviewAction, setMenuVersions, setMessageId, setModifierItemSelected, setModifierItemSelectedQuantity, setNetworkStatus, setNewServiceArea, setOrderModal, setPaymentMethod, setPaymentOption, setPreviewElements, setPrinterStatusWs, setPrinters, setPullingData, setRegisterNavigation, setRegisterSettings, setRegisterTicketSettings, setRemoteLocationMenu, setRemovedPrinters, setReports, setReportsChangeData, setReportsChangeDataValues, setReportsDiffObject, setReportsErrors, setReportsSelectedMode, setRoleDashboards, setSeatQuantity, setSeatValuesOnShareToggle, setSelectedElement, setSelectedLayout, setSelectedLocations, setSelectedMenuMode, setSelectedNetwork, setSelectedReportsType, setSelectedTables, setServiceArea, setSettingsBreadCrumb, setSettingsBreadCrumbLocation, setSettingsBreadCrumbStatusPath, setSettingsOnState, setShowConfirmationModal, setShowHotButtons, setShowRefreshToast, setShowSettingsRefreshToast, setShowToast, setSingleSeatQuantity, setTableLayoutData, setTicketElementsOpen, setToggleHotButtons, setToken, setToolSettings, setUpBogoSpecial, setUpCurrentOrderActiveSpecials, setUsers, setUsersAndUpdateLoggedInUser, settingsValidationThunks, shareComboElement, shareTicketElement, shouldShowLocationsModalOnSaveCore, show86ModifierItemOrIngredientModal, showComboOrSpreadIntoItems, showComboOrSpreadIntoItemsCoursingOnTheFly, showElementNotFoundInLocationToast, showForbiddenChangeLocationToast, showLockScreenBanner, showModifierItem86ConfirmationModal, showToast, simplifyModifierOperationToQuantityEffect, simplifyNestedModifierOperationToQuantityEffect, simulateAlgorithm, singleSelectDeleteOtherModifiers, singleSelectDeleteOtherNestedModifiers, sortAppliedSpecialsFunction, sortDiscountsFunction, sortHotButtonsPage, sortServiceChargesFunction, sortSpecialsFunction, specialModifierTagsFactory, specialsCounterReducer, splitCheckElementBySeat, splitCheckElementBySeatReducerHelper, splitCheckElementEvenlyIntoAllEditableChecks, splitCheckElementIntoChecksEvenly, splitCheckElementNWaysCoreThunk, splitCheckElementToAllNonDefaultAvailableChecks, splitCheckElementsBySeat, splitCheckElementsNWays, splitDefaultCheckByCustomCoreThunk, splitDefaultCheckBySeat, splitDefaultCheckBySeatsCoreThunk, splitDefaultCheckInNWays, splitDefaultCheckIntoExistingChecksThunk, splitDefaultCheckIntoNNewChecksCoreThunk, splitDefaultCheckToExistingChecks, splitPaymentForCheck, spreadComboIntoItem, stationCounterReducer, suggestOrdering, tableLayoutSelectors_exports, tablelayout_exports, thunks_exports, ticketElementsAreEqual, tipsDeliveryFieldLabels, tipsPickupFieldLabels, toggleActiveItem, toggleComboElementSeatShared, toggleComboSeatQuantity, toggleHotButtonModifierItemInModifierGroup, toggleItemIngredientThunk, toggleModifierItemSelected2 as toggleModifierItemSelected, toggleModifierItemSelectedThunk, toggleMultiselectModeCore, toggleNestedModifierItemSelected2 as toggleNestedModifierItemSelected, toggleNestedModifierItemSelectedThunk, toggleNoneModifierItemsSelected, toggleNoneNestedModifierItemSelectedThunk, toggleNoneNestedModifierItemsSelected, toggleSeat, toggleSeatQuantity, toggleTicketElementIngredient, transferCheckElements, transferPayment, transferPayments, transferPrinterJobs, transformResultToSpecialValidation, unGroupDisplayCheckElements, unShareComboElement, unShareTicketElement, unSplitCheckElementHelper, undoLastElementChange, ungroupCheckElementsThunk, ungroupComboElementByQty, ungroupComboElementBySeats, ungroupComboElementBySingleSeat, ungroupTicketElementByQtyReducer, ungroupTicketElementBySeatsReducer, ungroupTicketElementBySingleSeatReducer, unsplitCheckElementsCoreThunk, updateAllModifiersPrices, updateCategory, updateChangeDataValues, updateChangeFreshSheetDataValues, updateChangeMassUpdateDataValues, updateCheckElement, updateCheckElementDiscount, updateCheckElementDisplayFraction, updateCheckElementEachPrice, updateCheckElementForComboElement, updateCheckElementForTicketElement, updateCheckElementIsShared, updateCheckElementItemCount, updateCheckElementItemId, updateCheckElementName, updateCheckElementOld, updateCheckElementPrice, updateCheckElementSeats, updateCheckElementSpecial, updateCheckElementTax, updateCheckElementsSeats, updateCheckOrderDiscountsThunk, updateChecksServiceChargeDistribution, updateChecksTotals, updateCombo, updateComboCheckElements, updateComboDiscountObjectByIdOrTabletGeneratedId, updateComboElement, updateComboElementInstanceIds, updateComboIsTakeoutStatus, updateComboItemGroup, updateComboObjectPreviewThunk, updateCompletedSections, updateCurrentCustomers, updateCurrentMenu, updateCurrentOrderChecksData, updateCurrentOrderSpecialObjectWithDictionary, updateCurrentOrderSpecialsWithItems, updateCurrentSettings, updateCustomer, updateCustomerChangeData, updateCustomerFinalDiffObject, updateDisplayCheckElementDisplayFraction, updateDisplayCheckElementTotalQty, updateDrawer, updateElementAfterSplitBySeats, updateElementAndSaveLastChange, updateEnterOrderAndRecentOrders, updateEntityInventoryWS, updateExitOrderCallStatus, updateExitOrderLicenseId, updateFinalDiffObject, updateFreshSheet, updateFreshSheetEndpoint, updateGenericSettings, updateInventory, updateItem, updateItemCheckElements, updateItemDiscountObjectByIdOrTabletGeneratedId, updateItemGroup, updateItemGroupAdditionalPrice, updateItemGroupSelected, updateItemInventory, updateKeyboard, updateKitchenTicketSettings, updateLastItemsOfItemGroupOrder, updateLastModifierItemsOrder, updateLastPreviewOrder, updateLicensesAndDevices, updateLocalItemShowStockOnItemCard, updateLocalItemStock, updateLoggedInUserRecentOrders, updateMassUpdateFinalDiffObject, updateMasterCheckOrderDiscounts, updateMenuBucket, updateMenuChangeData, updateMenuItemInventory, updateMenuOnSocket, updateMenuType, updateModPrice, updateModifierGroup, updateModifierItem, updateModifierItemModifierGroups, updateModifierPrice, updateOrderDiscountObjectByIdOrTabletGeneratedId, updateOrderDiscountThunk, updateOrderField, updatePayment, updatePaymentNavigation, updatePopover, updatePreviewElements, updateRecentOrders, updateRegisterNavigationField, updateRegisterNavigationFieldWithCheck, updateRegisterNavigationFieldWithCheckAndState, updateRegisterTicketSettings, updateSelectionPriceForModifierItemsOfModifierGroup, updateServiceArea, updateServiceAreaDetails, updateServiceAreas, updateSettingsChangeData, updateSettingsFinalDiffObject, updateSettingsOnSocket, updateSharedQuantities, updateSingleTableLayoutStatus, updateSpecial, updateSubcategory, updateTableLayoutOrders, updateTableLayoutStore, updateTables, updateTablesStatusAndOrderId, updateTicketAndComboCompleteQuantity, updateTicketElementChecksTotals, updateTicketElementDiscountThunk, updateTicketElementInstanceIds, updateTicketElementWithInstancesCount, updateTicketElementsWithTaxExempt, updateUserRecentOrders, updateUserRecentOrdersStation, updateUsersTimeSummary, updateWithComboValues, updateWithGlobalQuantities, useDashboardsSection, useFormError_default, useLoadReportsChangeData_default, useMenuDetailsForm_default, useModifierItemPriceCalc, useOrderStatusColor, useOrderStatusName, useRefreshCustomer_default, useRefreshMenu_default, useRefreshSettings_default, validateCurrentOrderTabletGeneratedId, validateCustomerChangesOnSavePress, validateElementIsAppliedToSpecial, validateGeneralSeatingMode, validateKitchenSettingsData, validateMaximumModifierGroupItemsQuantity, validateMaximumModifierItemQuantityCurrent, validateMaximumNestedModifierItemQuantity, validatePayments, validateReportForm, validateSeatingMode, validateTicketElementIsEnabled, voidAllChecks2 as voidAllChecks, voidAllChecksCoreThunk, voidCheck, voidCheckItemElement, voidPayment, zipCombosWithItems };
